//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



/** Classe base astratta di tutte le risposte API */
export abstract class ApiResponse implements IApiResponse {
    /** Codice facoltativo che identifica il tipo di risposta */
    code?: string | null;
    /** ID univoco della richiesta alla quale viene fornita la risposta */
    requestID?: string | null;
    /** Timestamp UTC della risposta */
    timestamp?: number;
    /** ID univoco della risposta */
    uniqueID?: string;

    constructor(data?: IApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.requestID = _data["requestID"] !== undefined ? _data["requestID"] : <any>null;
            this.timestamp = _data["timestamp"] !== undefined ? _data["timestamp"] : <any>null;
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : <any>null;
        }
    }

    static fromJS(data: any): ApiResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["requestID"] = this.requestID !== undefined ? this.requestID : <any>null;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : <any>null;
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : <any>null;
        return data;
    }
}

/** Classe base astratta di tutte le risposte API */
export interface IApiResponse {
    /** Codice facoltativo che identifica il tipo di risposta */
    code?: string | null;
    /** ID univoco della richiesta alla quale viene fornita la risposta */
    requestID?: string | null;
    /** Timestamp UTC della risposta */
    timestamp?: number;
    /** ID univoco della risposta */
    uniqueID?: string;
}

/** Classe base delle risposte positive API */
export class OkApiResponse extends ApiResponse implements IOkApiResponse {
    /** Risultato dell'elaborazione. Vale sempre "OK"  */
    result?: EOkResponseType;

    constructor(data?: IOkApiResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : <any>null;
        }
    }

    static fromJS(data: any): OkApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OkApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe base delle risposte positive API */
export interface IOkApiResponse extends IApiResponse {
    /** Risultato dell'elaborazione. Vale sempre "OK"  */
    result?: EOkResponseType;
}

export class AccordoReadResponse extends OkApiResponse implements IAccordoReadResponse {
    accordo?: Accordo | null;

    constructor(data?: IAccordoReadResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordo = _data["accordo"] ? Accordo.fromJS(_data["accordo"]) : <any>null;
        }
    }

    static fromJS(data: any): AccordoReadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoReadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordo"] = this.accordo ? this.accordo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAccordoReadResponse extends IOkApiResponse {
    accordo?: Accordo | null;
}

export class Accordo implements IAccordo {
    accordoID?: number;
    operatore?: EOperatore | null;
    contattoID?: number | null;
    pagamentoID?: number | null;
    tipo?: ETipoAccordo;
    nome!: string;
    memo?: string | null;
    dal?: string | null;
    al?: string | null;
    tipoEmissioneVoucher?: ETipoEmissioneVoucher | null;
    notaPiePaginaVoucher?: string | null;
    valutaID?: number | null;
    contabilizzazione?: EContabilizzazione | null;
    centroDiCosto?: ECentroDiCosto | null;
    deregolamentato?: boolean;
    fornitore?: EFornitore | null;
    host2Host?: boolean | null;
    prenotazioneAutomatica?: boolean;
    commissioniBiglietteriaDeregolamentate?: boolean;
    prezziLordi?: boolean | null;
    contattoSupportoID?: number | null;
    reservationsFrom?: string | null;
    margine?: number | null;
    conversioneCosti?: number | null;
    conversionePrezzi?: number | null;
    margineNetto?: number | null;
    conversionePrezziNetto?: number | null;
    marginePacchetto?: number | null;
    conversionePrezziPacchetto?: number | null;
    codiceContabile?: number | null;
    deleted?: string | null;

    constructor(data?: IAccordo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.tipoEmissioneVoucher = _data["tipoEmissioneVoucher"] !== undefined ? _data["tipoEmissioneVoucher"] : <any>null;
            this.notaPiePaginaVoucher = _data["notaPiePaginaVoucher"] !== undefined ? _data["notaPiePaginaVoucher"] : <any>null;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : <any>null;
            this.contabilizzazione = _data["contabilizzazione"] !== undefined ? _data["contabilizzazione"] : <any>null;
            this.centroDiCosto = _data["centroDiCosto"] !== undefined ? _data["centroDiCosto"] : <any>null;
            this.deregolamentato = _data["deregolamentato"] !== undefined ? _data["deregolamentato"] : <any>null;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            this.host2Host = _data["host2Host"] !== undefined ? _data["host2Host"] : <any>null;
            this.prenotazioneAutomatica = _data["prenotazioneAutomatica"] !== undefined ? _data["prenotazioneAutomatica"] : <any>null;
            this.commissioniBiglietteriaDeregolamentate = _data["commissioniBiglietteriaDeregolamentate"] !== undefined ? _data["commissioniBiglietteriaDeregolamentate"] : <any>null;
            this.prezziLordi = _data["prezziLordi"] !== undefined ? _data["prezziLordi"] : <any>null;
            this.contattoSupportoID = _data["contattoSupportoID"] !== undefined ? _data["contattoSupportoID"] : <any>null;
            this.reservationsFrom = _data["reservationsFrom"] !== undefined ? _data["reservationsFrom"] : <any>null;
            this.margine = _data["margine"] !== undefined ? _data["margine"] : <any>null;
            this.conversioneCosti = _data["conversioneCosti"] !== undefined ? _data["conversioneCosti"] : <any>null;
            this.conversionePrezzi = _data["conversionePrezzi"] !== undefined ? _data["conversionePrezzi"] : <any>null;
            this.margineNetto = _data["margineNetto"] !== undefined ? _data["margineNetto"] : <any>null;
            this.conversionePrezziNetto = _data["conversionePrezziNetto"] !== undefined ? _data["conversionePrezziNetto"] : <any>null;
            this.marginePacchetto = _data["marginePacchetto"] !== undefined ? _data["marginePacchetto"] : <any>null;
            this.conversionePrezziPacchetto = _data["conversionePrezziPacchetto"] !== undefined ? _data["conversionePrezziPacchetto"] : <any>null;
            this.codiceContabile = _data["codiceContabile"] !== undefined ? _data["codiceContabile"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
        }
    }

    static fromJS(data: any): Accordo {
        data = typeof data === 'object' ? data : {};
        let result = new Accordo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["memo"] = this.memo !== undefined ? this.memo : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["tipoEmissioneVoucher"] = this.tipoEmissioneVoucher !== undefined ? this.tipoEmissioneVoucher : <any>null;
        data["notaPiePaginaVoucher"] = this.notaPiePaginaVoucher !== undefined ? this.notaPiePaginaVoucher : <any>null;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : <any>null;
        data["contabilizzazione"] = this.contabilizzazione !== undefined ? this.contabilizzazione : <any>null;
        data["centroDiCosto"] = this.centroDiCosto !== undefined ? this.centroDiCosto : <any>null;
        data["deregolamentato"] = this.deregolamentato !== undefined ? this.deregolamentato : <any>null;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        data["host2Host"] = this.host2Host !== undefined ? this.host2Host : <any>null;
        data["prenotazioneAutomatica"] = this.prenotazioneAutomatica !== undefined ? this.prenotazioneAutomatica : <any>null;
        data["commissioniBiglietteriaDeregolamentate"] = this.commissioniBiglietteriaDeregolamentate !== undefined ? this.commissioniBiglietteriaDeregolamentate : <any>null;
        data["prezziLordi"] = this.prezziLordi !== undefined ? this.prezziLordi : <any>null;
        data["contattoSupportoID"] = this.contattoSupportoID !== undefined ? this.contattoSupportoID : <any>null;
        data["reservationsFrom"] = this.reservationsFrom !== undefined ? this.reservationsFrom : <any>null;
        data["margine"] = this.margine !== undefined ? this.margine : <any>null;
        data["conversioneCosti"] = this.conversioneCosti !== undefined ? this.conversioneCosti : <any>null;
        data["conversionePrezzi"] = this.conversionePrezzi !== undefined ? this.conversionePrezzi : <any>null;
        data["margineNetto"] = this.margineNetto !== undefined ? this.margineNetto : <any>null;
        data["conversionePrezziNetto"] = this.conversionePrezziNetto !== undefined ? this.conversionePrezziNetto : <any>null;
        data["marginePacchetto"] = this.marginePacchetto !== undefined ? this.marginePacchetto : <any>null;
        data["conversionePrezziPacchetto"] = this.conversionePrezziPacchetto !== undefined ? this.conversionePrezziPacchetto : <any>null;
        data["codiceContabile"] = this.codiceContabile !== undefined ? this.codiceContabile : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        return data;
    }
}

export interface IAccordo {
    accordoID?: number;
    operatore?: EOperatore | null;
    contattoID?: number | null;
    pagamentoID?: number | null;
    tipo?: ETipoAccordo;
    nome: string;
    memo?: string | null;
    dal?: string | null;
    al?: string | null;
    tipoEmissioneVoucher?: ETipoEmissioneVoucher | null;
    notaPiePaginaVoucher?: string | null;
    valutaID?: number | null;
    contabilizzazione?: EContabilizzazione | null;
    centroDiCosto?: ECentroDiCosto | null;
    deregolamentato?: boolean;
    fornitore?: EFornitore | null;
    host2Host?: boolean | null;
    prenotazioneAutomatica?: boolean;
    commissioniBiglietteriaDeregolamentate?: boolean;
    prezziLordi?: boolean | null;
    contattoSupportoID?: number | null;
    reservationsFrom?: string | null;
    margine?: number | null;
    conversioneCosti?: number | null;
    conversionePrezzi?: number | null;
    margineNetto?: number | null;
    conversionePrezziNetto?: number | null;
    marginePacchetto?: number | null;
    conversionePrezziPacchetto?: number | null;
    codiceContabile?: number | null;
    deleted?: string | null;
}

export enum EOperatore {
    Indefinito = "Indefinito",
    Naar = "Naar",
    NaarFrance = "NaarFrance",
    NaarGermany = "NaarGermany",
    Aviomar = "Aviomar",
    NaarBenelux = "NaarBenelux",
    Salaun = "Salaun",
}

export enum ETipoAccordo {
    Fornitori = "Fornitori",
    Agenzie = "Agenzie",
    Biglietteria = "Biglietteria",
    Scaduto = "Scaduto",
}

export enum ETipoEmissioneVoucher {
    Nessuna = "Nessuna",
    UnVoucherAServizio = "UnVoucherAServizio",
    UnVoucherAOfferta = "UnVoucherAOfferta",
    VoucherFornitore = "VoucherFornitore",
}

export enum EContabilizzazione {
    ExtraCee = "ExtraCee",
    Cee = "Cee",
    Italia = "Italia",
}

export enum ECentroDiCosto {
    Naar = "Naar",
    Aliviaggi = "Aliviaggi",
    DriveOut = "DriveOut",
    Anyway = "Anyway",
    Aviomar = "Aviomar",
}

export enum EFornitore {
    NONE = "NONE",
    NAAR_INTERNO = "NAAR_INTERNO",
    GTA = "GTA",
    KOBRA = "KOBRA",
    TOURICO = "TOURICO",
    ATI = "ATI",
    PANORAMA = "PANORAMA",
    CLICKONLINE = "CLICKONLINE",
    JONVIEW = "JONVIEW",
    NAAR_INTERNO_NUOVO = "NAAR_INTERNO_NUOVO",
    HOTELBEDS = "HOTELBEDS",
    JACTRAVEL = "JACTRAVEL",
    TRAVCO = "TRAVCO",
    BONOTEL = "BONOTEL",
    AMADEUS = "AMADEUS",
    TEAM_AMERICA = "TEAM_AMERICA",
    YOUTRAVEL = "YOUTRAVEL",
    AVIOMAR = "AVIOMAR",
    GALILEO = "GALILEO",
    PANPACIFIC = "PANPACIFIC",
    DELTANET = "DELTANET",
    ARABIAN = "ARABIAN",
    EUROTOURS = "EUROTOURS",
    EXPEDIA = "EXPEDIA",
    TRAVELFUSION = "TRAVELFUSION",
    KUONI = "KUONI",
    TIRRENIA = "TIRRENIA",
    ALLIED = "ALLIED",
    INTRA = "INTRA",
    ITALCAMEL = "ITALCAMEL",
    MONDIAL = "MONDIAL",
    UNILINE = "UNILINE",
    WELCOMEBEDS = "WELCOMEBEDS",
    RESTEL = "RESTEL",
    ATI_2012 = "ATI_2012",
    MIKITRAVEL_OLD = "MIKITRAVEL_OLD",
    MARK = "MARK",
    EUROTUR = "EUROTUR",
    CTN = "CTN",
    RMHTOURS = "RMHTOURS",
    OPENTOURS = "OPENTOURS",
    TRANSHOTEL = "TRANSHOTEL",
    TEAM_AMERICA_2013 = "TEAM_AMERICA_2013",
    TEKURA = "TEKURA",
    AOT = "AOT",
    TRAVALCO = "TRAVALCO",
    WTS = "WTS",
    ASIAN = "ASIAN",
    VOLATOUR = "VOLATOUR",
    JTB = "JTB",
    GOWEST_OLD = "GOWEST_OLD",
    TOURMAPPERS = "TOURMAPPERS",
    TOURICO_2014 = "TOURICO_2014",
    TEAM_AMERICA_2014 = "TEAM_AMERICA_2014",
    EAN = "EAN",
    GLOBAL = "GLOBAL",
    VISION = "VISION",
    ROSIE = "ROSIE",
    MECA = "MECA",
    MARK_2016 = "MARK_2016",
    CONDOR = "CONDOR",
    SANDALS = "SANDALS",
    RTS = "RTS",
    A4Y = "A4Y",
    DUMMY = "DUMMY",
    AIC = "AIC",
    TRAVALCO_2018 = "TRAVALCO_2018",
    OLYMPIA = "OLYMPIA",
    HOTELSTON = "HOTELSTON",
    ALLIEDTPRO = "ALLIEDTPRO",
    PACIFIC_DNZ = "PACIFIC_DNZ",
    CREOLE = "CREOLE",
    WTS_2018 = "WTS_2018",
    PACIFIC_DAU = "PACIFIC_DAU",
    ALAMO = "ALAMO",
    WHL = "WHL",
    MSC = "MSC",
    PRICELINE = "PRICELINE",
    TOURMAPPERS_2018 = "TOURMAPPERS_2018",
    MISTER_ROOM = "MISTER_ROOM",
    RIU = "RIU",
    WTS_NAMIBIA = "WTS_NAMIBIA",
    W2M = "W2M",
    MAGIC_TRAVELS = "MAGIC_TRAVELS",
    BOOK_ME = "BOOK_ME",
    CLUBMED = "CLUBMED",
    MAGIC_TRAVELS_2022 = "MAGIC_TRAVELS_2022",
    NTA = "NTA",
    HASHNAP = "HASHNAP",
    WEBBEDS = "WEBBEDS",
    HOTEL_TRADER = "HOTEL_TRADER",
    MIKITRAVEL = "MIKITRAVEL",
    G2_TRAVEL = "G2_TRAVEL",
    NUITEE = "NUITEE",
    GOWEST_2024 = "GOWEST_2024",
    RATE_HAWK = "RATE_HAWK",
    WEBBEDS_2024 = "WEBBEDS_2024",
    GO_WAY = "GO_WAY",
    GO_GLOBAL = "GO_GLOBAL",
    DIDA_TRAVEL = "DIDA_TRAVEL",
    HYPER_GUEST = "HYPER_GUEST",
    G2_TRAVEL_2024 = "G2_TRAVEL_2024",
    MIKITRAVEL_2024 = "MIKITRAVEL_2024",
    JUMBONLINE = "JUMBONLINE",
    NORDBEDS = "NORDBEDS",
    TBO = "TBO",
    AMADEUS_NDC = "AMADEUS_NDC",
    DIDA_TRAVEL_2025 = "DIDA_TRAVEL_2025",
    EXPEDIA_RAPID = "EXPEDIA_RAPID",
    DOTW = "DOTW",
}

export enum EOkResponseType {
    OK = "OK",
}

/** Classe base delle risposte di errore */
export class ErrorResponse extends ApiResponse implements IErrorResponse {
    /** Risultato dell'elaborazione. Vale sempre "ERROR"  */
    result?: EErrorResponseType;
    /** Descrizione testuale dell'errore */
    error?: string | null;
    /** Valori custom associati all'errore */
    values?: { [key: string]: any; } | null;

    constructor(data?: IErrorResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : <any>null;
            this.error = _data["error"] !== undefined ? _data["error"] : <any>null;
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key] !== undefined ? _data["values"][key] : <any>null;
                }
            }
            else {
                this.values = <any>null;
            }
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : <any>null;
        data["error"] = this.error !== undefined ? this.error : <any>null;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = this.values[key] !== undefined ? this.values[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

/** Classe base delle risposte di errore */
export interface IErrorResponse extends IApiResponse {
    /** Risultato dell'elaborazione. Vale sempre "ERROR"  */
    result?: EErrorResponseType;
    /** Descrizione testuale dell'errore */
    error?: string | null;
    /** Valori custom associati all'errore */
    values?: { [key: string]: any; } | null;
}

export enum EErrorResponseType {
    ERROR = "ERROR",
}

export class ModelValidationFailedResponse extends ErrorResponse implements IModelValidationFailedResponse {
    errors?: string[] | null;

    constructor(data?: IModelValidationFailedResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = <any>null;
            }
        }
    }

    static fromJS(data: any): ModelValidationFailedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ModelValidationFailedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IModelValidationFailedResponse extends IErrorResponse {
    errors?: string[] | null;
}

/** Classe base di tutte le richieste API */
export class ApiRequest implements IApiRequest {
    /** ID univoco facoltativo della richiesta */
    uniqueID?: string | null;

    constructor(data?: IApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : <any>null;
        }
    }

    static fromJS(data: any): ApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : <any>null;
        return data;
    }
}

/** Classe base di tutte le richieste API */
export interface IApiRequest {
    /** ID univoco facoltativo della richiesta */
    uniqueID?: string | null;
}

export class AccordoReadRequest extends ApiRequest implements IAccordoReadRequest {
    accordoID?: number;

    constructor(data?: IAccordoReadRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
        }
    }

    static fromJS(data: any): AccordoReadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoReadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAccordoReadRequest extends IApiRequest {
    accordoID?: number;
}

export class AccordoWriteRequest extends ApiRequest implements IAccordoWriteRequest {
    accordo?: Accordo | null;

    constructor(data?: IAccordoWriteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordo = _data["accordo"] ? Accordo.fromJS(_data["accordo"]) : <any>null;
        }
    }

    static fromJS(data: any): AccordoWriteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoWriteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordo"] = this.accordo ? this.accordo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAccordoWriteRequest extends IApiRequest {
    accordo?: Accordo | null;
}

export class AccordoDeleteRequest extends ApiRequest implements IAccordoDeleteRequest {
    /** Id dell'accordo da eliminare */
    accordoID?: number;

    constructor(data?: IAccordoDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
        }
    }

    static fromJS(data: any): AccordoDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAccordoDeleteRequest extends IApiRequest {
    /** Id dell'accordo da eliminare */
    accordoID?: number;
}

export class RestoreAccordoRequest extends ApiRequest implements IRestoreAccordoRequest {
    /** Id dell'accordo da eliminare */
    accordoID?: number;

    constructor(data?: IRestoreAccordoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
        }
    }

    static fromJS(data: any): RestoreAccordoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreAccordoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreAccordoRequest extends IApiRequest {
    /** Id dell'accordo da eliminare */
    accordoID?: number;
}

export class AccordiDeleteMultiRequest extends ApiRequest implements IAccordiDeleteMultiRequest {
    /** Lista degli id degli accordi da eliminare */
    accordiIds?: number[] | null;

    constructor(data?: IAccordiDeleteMultiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["accordiIds"])) {
                this.accordiIds = [] as any;
                for (let item of _data["accordiIds"])
                    this.accordiIds!.push(item);
            }
            else {
                this.accordiIds = <any>null;
            }
        }
    }

    static fromJS(data: any): AccordiDeleteMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccordiDeleteMultiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accordiIds)) {
            data["accordiIds"] = [];
            for (let item of this.accordiIds)
                data["accordiIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAccordiDeleteMultiRequest extends IApiRequest {
    /** Lista degli id degli accordi da eliminare */
    accordiIds?: number[] | null;
}

export class NrTableResponseOfContraenteRow extends OkApiResponse implements INrTableResponseOfContraenteRow {
    /** Array delle righe della pagina richiesta */
    rows?: ContraenteRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfContraenteRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContraenteRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfContraenteRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfContraenteRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfContraenteRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ContraenteRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ContraenteRow implements IContraenteRow {
    /** Id riga accordo/contraente */
    id?: number;
    /** Id del contatto contraente */
    contattoID?: number;
    /** Nome visualizzato del contatto */
    contatto?: string | null;
    /** Operatore di riferimento */
    operatore?: EOperatore;
    /** Id del pricing */
    pricing?: string | null;
    /** True se i viaggi netti sono abilitati */
    viaggiNetti?: boolean | null;
    /** Il Markup dei viaggi netti */
    markup_vn?: number | null;
    /** Il Markup dei teds */
    markup_teds?: number | null;
    /** Data di validità */
    data?: string | null;

    constructor(data?: IContraenteRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.pricing = _data["pricing"] !== undefined ? _data["pricing"] : <any>null;
            this.viaggiNetti = _data["viaggiNetti"] !== undefined ? _data["viaggiNetti"] : <any>null;
            this.markup_vn = _data["markup_vn"] !== undefined ? _data["markup_vn"] : <any>null;
            this.markup_teds = _data["markup_teds"] !== undefined ? _data["markup_teds"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static fromJS(data: any): ContraenteRow {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["contatto"] = this.contatto !== undefined ? this.contatto : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["pricing"] = this.pricing !== undefined ? this.pricing : <any>null;
        data["viaggiNetti"] = this.viaggiNetti !== undefined ? this.viaggiNetti : <any>null;
        data["markup_vn"] = this.markup_vn !== undefined ? this.markup_vn : <any>null;
        data["markup_teds"] = this.markup_teds !== undefined ? this.markup_teds : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        return data;
    }
}

export interface IContraenteRow {
    /** Id riga accordo/contraente */
    id?: number;
    /** Id del contatto contraente */
    contattoID?: number;
    /** Nome visualizzato del contatto */
    contatto?: string | null;
    /** Operatore di riferimento */
    operatore?: EOperatore;
    /** Id del pricing */
    pricing?: string | null;
    /** True se i viaggi netti sono abilitati */
    viaggiNetti?: boolean | null;
    /** Il Markup dei viaggi netti */
    markup_vn?: number | null;
    /** Il Markup dei teds */
    markup_teds?: number | null;
    /** Data di validità */
    data?: string | null;
}

/** Riferimento ad un file esportato */
export class ExportFileResponse extends OkApiResponse implements IExportFileResponse {
    /** Parametro da passare a /export/get se TempFileID è nullo */
    file?: string | null;
    /** ID del file temporaneo da passare a /export/get/temp e che prevale su File quando valorizzato */
    tempFileID?: number | null;

    constructor(data?: IExportFileResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.file = _data["file"] !== undefined ? _data["file"] : <any>null;
            this.tempFileID = _data["tempFileID"] !== undefined ? _data["tempFileID"] : <any>null;
        }
    }

    static fromJS(data: any): ExportFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExportFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file !== undefined ? this.file : <any>null;
        data["tempFileID"] = this.tempFileID !== undefined ? this.tempFileID : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Riferimento ad un file esportato */
export interface IExportFileResponse extends IOkApiResponse {
    /** Parametro da passare a /export/get se TempFileID è nullo */
    file?: string | null;
    /** ID del file temporaneo da passare a /export/get/temp e che prevale su File quando valorizzato */
    tempFileID?: number | null;
}

export class LocalizedRequest extends ApiRequest implements ILocalizedRequest {
    /** Lingua richiesta */
    lingua!: ELingua;

    constructor(data?: ILocalizedRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
        }
    }

    static fromJS(data: any): LocalizedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ILocalizedRequest extends IApiRequest {
    /** Lingua richiesta */
    lingua: ELingua;
}

/** Base per richieste paginate */
export class NrTableRequest extends LocalizedRequest implements INrTableRequest {
    /** Numero della pagina 1 based */
    page?: number;
    /** Dimensione della pagina */
    pageSize?: number;
    /** Nome della colonna su cui effettuare l'ordinamento (facoltativo) */
    sortColumn?: string | null;
    /** Direzione dell'ordinamento (facoltativo): asc / desc / '' */
    sortDirection?: string | null;
    /** Se true esporta il file Excel invece di generare la tabella */
    export?: boolean;
    exportEntityName?: string | null;
    exportFieldsNames?: { [key: string]: string; } | null;
    fieldsDecoders?: { [key: string]: { [key: string]: string; }; } | null;

    constructor(data?: INrTableRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.sortColumn = _data["sortColumn"] !== undefined ? _data["sortColumn"] : <any>null;
            this.sortDirection = _data["sortDirection"] !== undefined ? _data["sortDirection"] : <any>null;
            this.export = _data["export"] !== undefined ? _data["export"] : <any>null;
            this.exportEntityName = _data["exportEntityName"] !== undefined ? _data["exportEntityName"] : <any>null;
            if (_data["exportFieldsNames"]) {
                this.exportFieldsNames = {} as any;
                for (let key in _data["exportFieldsNames"]) {
                    if (_data["exportFieldsNames"].hasOwnProperty(key))
                        (<any>this.exportFieldsNames)![key] = _data["exportFieldsNames"][key] !== undefined ? _data["exportFieldsNames"][key] : <any>null;
                }
            }
            else {
                this.exportFieldsNames = <any>null;
            }
            if (_data["fieldsDecoders"]) {
                this.fieldsDecoders = {} as any;
                for (let key in _data["fieldsDecoders"]) {
                    if (_data["fieldsDecoders"].hasOwnProperty(key))
                        (<any>this.fieldsDecoders)![key] = _data["fieldsDecoders"][key] !== undefined ? _data["fieldsDecoders"][key] : {};
                }
            }
            else {
                this.fieldsDecoders = <any>null;
            }
        }
    }

    static fromJS(data: any): NrTableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["sortColumn"] = this.sortColumn !== undefined ? this.sortColumn : <any>null;
        data["sortDirection"] = this.sortDirection !== undefined ? this.sortDirection : <any>null;
        data["export"] = this.export !== undefined ? this.export : <any>null;
        data["exportEntityName"] = this.exportEntityName !== undefined ? this.exportEntityName : <any>null;
        if (this.exportFieldsNames) {
            data["exportFieldsNames"] = {};
            for (let key in this.exportFieldsNames) {
                if (this.exportFieldsNames.hasOwnProperty(key))
                    (<any>data["exportFieldsNames"])[key] = this.exportFieldsNames[key] !== undefined ? this.exportFieldsNames[key] : <any>null;
            }
        }
        if (this.fieldsDecoders) {
            data["fieldsDecoders"] = {};
            for (let key in this.fieldsDecoders) {
                if (this.fieldsDecoders.hasOwnProperty(key))
                    (<any>data["fieldsDecoders"])[key] = this.fieldsDecoders[key] !== undefined ? this.fieldsDecoders[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

/** Base per richieste paginate */
export interface INrTableRequest extends ILocalizedRequest {
    /** Numero della pagina 1 based */
    page?: number;
    /** Dimensione della pagina */
    pageSize?: number;
    /** Nome della colonna su cui effettuare l'ordinamento (facoltativo) */
    sortColumn?: string | null;
    /** Direzione dell'ordinamento (facoltativo): asc / desc / '' */
    sortDirection?: string | null;
    /** Se true esporta il file Excel invece di generare la tabella */
    export?: boolean;
    exportEntityName?: string | null;
    exportFieldsNames?: { [key: string]: string; } | null;
    fieldsDecoders?: { [key: string]: { [key: string]: string; }; } | null;
}

export class ContraentiSearchRequest extends NrTableRequest implements IContraentiSearchRequest {
    /** Id dell'accordo del quale visualizzare i contraenti */
    accordoId?: number;

    constructor(data?: IContraentiSearchRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoId = _data["accordoId"] !== undefined ? _data["accordoId"] : <any>null;
        }
    }

    static fromJS(data: any): ContraentiSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContraentiSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoId"] = this.accordoId !== undefined ? this.accordoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IContraentiSearchRequest extends INrTableRequest {
    /** Id dell'accordo del quale visualizzare i contraenti */
    accordoId?: number;
}

export enum ELingua {
    Italiano = "Italiano",
    English = "English",
    Francais = "Francais",
    Deutsch = "Deutsch",
    Dutch = "Dutch",
    Spanish = "Spanish",
    Portuguese = "Portuguese",
    Debug = "Debug",
}

export class ContraenteReadResponse extends OkApiResponse implements IContraenteReadResponse {
    accordoContatto?: AccordoContatto | null;

    constructor(data?: IContraenteReadResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : <any>null;
        }
    }

    static fromJS(data: any): ContraenteReadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteReadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IContraenteReadResponse extends IOkApiResponse {
    accordoContatto?: AccordoContatto | null;
}

export class AccordoContatto implements IAccordoContatto {
    id?: number;
    operatore?: EOperatore;
    contattoID?: number;
    accordoID?: number;
    pagamentoID?: number | null;
    pagamentoBiglietteriaID?: number | null;
    percentualeAcconto?: number | null;
    percentualeAccontoNozze?: number | null;
    credito?: number | null;
    corrente?: number | null;
    data?: string | null;
    bancaID?: number | null;
    noAnticipoBiglietti?: boolean;
    noAnticipoQuote?: boolean;
    commissioniBiglietteriaDeregolamentate?: boolean;
    pricingID?: number | null;
    viaggiNetti?: boolean | null;
    markup_vn?: number | null;
    markup_teds?: number | null;
    enable_teds?: boolean;

    constructor(data?: IAccordoContatto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : <any>null;
            this.pagamentoBiglietteriaID = _data["pagamentoBiglietteriaID"] !== undefined ? _data["pagamentoBiglietteriaID"] : <any>null;
            this.percentualeAcconto = _data["percentualeAcconto"] !== undefined ? _data["percentualeAcconto"] : <any>null;
            this.percentualeAccontoNozze = _data["percentualeAccontoNozze"] !== undefined ? _data["percentualeAccontoNozze"] : <any>null;
            this.credito = _data["credito"] !== undefined ? _data["credito"] : <any>null;
            this.corrente = _data["corrente"] !== undefined ? _data["corrente"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : <any>null;
            this.noAnticipoBiglietti = _data["noAnticipoBiglietti"] !== undefined ? _data["noAnticipoBiglietti"] : <any>null;
            this.noAnticipoQuote = _data["noAnticipoQuote"] !== undefined ? _data["noAnticipoQuote"] : <any>null;
            this.commissioniBiglietteriaDeregolamentate = _data["commissioniBiglietteriaDeregolamentate"] !== undefined ? _data["commissioniBiglietteriaDeregolamentate"] : <any>null;
            this.pricingID = _data["pricingID"] !== undefined ? _data["pricingID"] : <any>null;
            this.viaggiNetti = _data["viaggiNetti"] !== undefined ? _data["viaggiNetti"] : <any>null;
            this.markup_vn = _data["markup_vn"] !== undefined ? _data["markup_vn"] : <any>null;
            this.markup_teds = _data["markup_teds"] !== undefined ? _data["markup_teds"] : <any>null;
            this.enable_teds = _data["enable_teds"] !== undefined ? _data["enable_teds"] : <any>null;
        }
    }

    static fromJS(data: any): AccordoContatto {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoContatto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : <any>null;
        data["pagamentoBiglietteriaID"] = this.pagamentoBiglietteriaID !== undefined ? this.pagamentoBiglietteriaID : <any>null;
        data["percentualeAcconto"] = this.percentualeAcconto !== undefined ? this.percentualeAcconto : <any>null;
        data["percentualeAccontoNozze"] = this.percentualeAccontoNozze !== undefined ? this.percentualeAccontoNozze : <any>null;
        data["credito"] = this.credito !== undefined ? this.credito : <any>null;
        data["corrente"] = this.corrente !== undefined ? this.corrente : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : <any>null;
        data["noAnticipoBiglietti"] = this.noAnticipoBiglietti !== undefined ? this.noAnticipoBiglietti : <any>null;
        data["noAnticipoQuote"] = this.noAnticipoQuote !== undefined ? this.noAnticipoQuote : <any>null;
        data["commissioniBiglietteriaDeregolamentate"] = this.commissioniBiglietteriaDeregolamentate !== undefined ? this.commissioniBiglietteriaDeregolamentate : <any>null;
        data["pricingID"] = this.pricingID !== undefined ? this.pricingID : <any>null;
        data["viaggiNetti"] = this.viaggiNetti !== undefined ? this.viaggiNetti : <any>null;
        data["markup_vn"] = this.markup_vn !== undefined ? this.markup_vn : <any>null;
        data["markup_teds"] = this.markup_teds !== undefined ? this.markup_teds : <any>null;
        data["enable_teds"] = this.enable_teds !== undefined ? this.enable_teds : <any>null;
        return data;
    }
}

export interface IAccordoContatto {
    id?: number;
    operatore?: EOperatore;
    contattoID?: number;
    accordoID?: number;
    pagamentoID?: number | null;
    pagamentoBiglietteriaID?: number | null;
    percentualeAcconto?: number | null;
    percentualeAccontoNozze?: number | null;
    credito?: number | null;
    corrente?: number | null;
    data?: string | null;
    bancaID?: number | null;
    noAnticipoBiglietti?: boolean;
    noAnticipoQuote?: boolean;
    commissioniBiglietteriaDeregolamentate?: boolean;
    pricingID?: number | null;
    viaggiNetti?: boolean | null;
    markup_vn?: number | null;
    markup_teds?: number | null;
    enable_teds?: boolean;
}

export class ContraenteReadRequest extends ApiRequest implements IContraenteReadRequest {
    accordoID?: number;
    accordoContattoID?: number;

    constructor(data?: IContraenteReadRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.accordoContattoID = _data["accordoContattoID"] !== undefined ? _data["accordoContattoID"] : <any>null;
        }
    }

    static fromJS(data: any): ContraenteReadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteReadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["accordoContattoID"] = this.accordoContattoID !== undefined ? this.accordoContattoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IContraenteReadRequest extends IApiRequest {
    accordoID?: number;
    accordoContattoID?: number;
}

export class ContraenteWriteResponse extends OkApiResponse implements IContraenteWriteResponse {
    accordoContatto?: AccordoContatto | null;

    constructor(data?: IContraenteWriteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : <any>null;
        }
    }

    static fromJS(data: any): ContraenteWriteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteWriteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IContraenteWriteResponse extends IOkApiResponse {
    accordoContatto?: AccordoContatto | null;
}

export class ContraenteWriteRequest extends ApiRequest implements IContraenteWriteRequest {
    accordoID?: number;
    accordoContatto?: AccordoContatto | null;

    constructor(data?: IContraenteWriteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : <any>null;
        }
    }

    static fromJS(data: any): ContraenteWriteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteWriteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IContraenteWriteRequest extends IApiRequest {
    accordoID?: number;
    accordoContatto?: AccordoContatto | null;
}

export class ContraenteDeleteRequest extends ApiRequest implements IContraenteDeleteRequest {
    accordoID?: number;
    accordoContattoID?: number;

    constructor(data?: IContraenteDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.accordoContattoID = _data["accordoContattoID"] !== undefined ? _data["accordoContattoID"] : <any>null;
        }
    }

    static fromJS(data: any): ContraenteDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["accordoContattoID"] = this.accordoContattoID !== undefined ? this.accordoContattoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IContraenteDeleteRequest extends IApiRequest {
    accordoID?: number;
    accordoContattoID?: number;
}

export class ContraenteDeleteMultiRequest extends ApiRequest implements IContraenteDeleteMultiRequest {
    accordoID?: number;
    accordiContattiIDs?: number[] | null;

    constructor(data?: IContraenteDeleteMultiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            if (Array.isArray(_data["accordiContattiIDs"])) {
                this.accordiContattiIDs = [] as any;
                for (let item of _data["accordiContattiIDs"])
                    this.accordiContattiIDs!.push(item);
            }
            else {
                this.accordiContattiIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): ContraenteDeleteMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContraenteDeleteMultiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        if (Array.isArray(this.accordiContattiIDs)) {
            data["accordiContattiIDs"] = [];
            for (let item of this.accordiContattiIDs)
                data["accordiContattiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IContraenteDeleteMultiRequest extends IApiRequest {
    accordoID?: number;
    accordiContattiIDs?: number[] | null;
}

export class NrTableResponseOfDatoAggiuntivoRow extends OkApiResponse implements INrTableResponseOfDatoAggiuntivoRow {
    /** Array delle righe della pagina richiesta */
    rows?: DatoAggiuntivoRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfDatoAggiuntivoRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DatoAggiuntivoRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfDatoAggiuntivoRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfDatoAggiuntivoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfDatoAggiuntivoRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: DatoAggiuntivoRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class DatoAggiuntivoRow implements IDatoAggiuntivoRow {
    id?: number;
    iban?: string | null;
    swift?: string | null;
    banca?: string | null;

    constructor(data?: IDatoAggiuntivoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.iban = _data["iban"] !== undefined ? _data["iban"] : <any>null;
            this.swift = _data["swift"] !== undefined ? _data["swift"] : <any>null;
            this.banca = _data["banca"] !== undefined ? _data["banca"] : <any>null;
        }
    }

    static fromJS(data: any): DatoAggiuntivoRow {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["iban"] = this.iban !== undefined ? this.iban : <any>null;
        data["swift"] = this.swift !== undefined ? this.swift : <any>null;
        data["banca"] = this.banca !== undefined ? this.banca : <any>null;
        return data;
    }
}

export interface IDatoAggiuntivoRow {
    id?: number;
    iban?: string | null;
    swift?: string | null;
    banca?: string | null;
}

export class DatiAggiuntiviSearchRequest extends NrTableRequest implements IDatiAggiuntiviSearchRequest {
    accordoId?: number;

    constructor(data?: IDatiAggiuntiviSearchRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoId = _data["accordoId"] !== undefined ? _data["accordoId"] : <any>null;
        }
    }

    static fromJS(data: any): DatiAggiuntiviSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DatiAggiuntiviSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoId"] = this.accordoId !== undefined ? this.accordoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDatiAggiuntiviSearchRequest extends INrTableRequest {
    accordoId?: number;
}

export class DatoAggiuntivoReadResponse extends OkApiResponse implements IDatoAggiuntivoReadResponse {
    accordoDatoAggiuntivo?: AccordoDatoAggiuntivo | null;

    constructor(data?: IDatoAggiuntivoReadResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoDatoAggiuntivo = _data["accordoDatoAggiuntivo"] ? AccordoDatoAggiuntivo.fromJS(_data["accordoDatoAggiuntivo"]) : <any>null;
        }
    }

    static fromJS(data: any): DatoAggiuntivoReadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoReadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoDatoAggiuntivo"] = this.accordoDatoAggiuntivo ? this.accordoDatoAggiuntivo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDatoAggiuntivoReadResponse extends IOkApiResponse {
    accordoDatoAggiuntivo?: AccordoDatoAggiuntivo | null;
}

export class AccordoDatoAggiuntivo implements IAccordoDatoAggiuntivo {
    datoAggiuntivoID?: number;
    accordoID?: number;
    iban?: string | null;
    swift?: string | null;
    fax?: string | null;
    email?: string | null;
    banca?: string | null;

    constructor(data?: IAccordoDatoAggiuntivo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datoAggiuntivoID = _data["datoAggiuntivoID"] !== undefined ? _data["datoAggiuntivoID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.iban = _data["iban"] !== undefined ? _data["iban"] : <any>null;
            this.swift = _data["swift"] !== undefined ? _data["swift"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.banca = _data["banca"] !== undefined ? _data["banca"] : <any>null;
        }
    }

    static fromJS(data: any): AccordoDatoAggiuntivo {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoDatoAggiuntivo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datoAggiuntivoID"] = this.datoAggiuntivoID !== undefined ? this.datoAggiuntivoID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["iban"] = this.iban !== undefined ? this.iban : <any>null;
        data["swift"] = this.swift !== undefined ? this.swift : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["banca"] = this.banca !== undefined ? this.banca : <any>null;
        return data;
    }
}

export interface IAccordoDatoAggiuntivo {
    datoAggiuntivoID?: number;
    accordoID?: number;
    iban?: string | null;
    swift?: string | null;
    fax?: string | null;
    email?: string | null;
    banca?: string | null;
}

export class DatoAggiuntivoReadRequest extends ApiRequest implements IDatoAggiuntivoReadRequest {
    accordoID?: number;
    accordoDatoAggiuntivoID?: number;

    constructor(data?: IDatoAggiuntivoReadRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.accordoDatoAggiuntivoID = _data["accordoDatoAggiuntivoID"] !== undefined ? _data["accordoDatoAggiuntivoID"] : <any>null;
        }
    }

    static fromJS(data: any): DatoAggiuntivoReadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoReadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["accordoDatoAggiuntivoID"] = this.accordoDatoAggiuntivoID !== undefined ? this.accordoDatoAggiuntivoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDatoAggiuntivoReadRequest extends IApiRequest {
    accordoID?: number;
    accordoDatoAggiuntivoID?: number;
}

export class DatoAggiuntivoWriteResponse extends OkApiResponse implements IDatoAggiuntivoWriteResponse {
    accordoDatoAggiuntivo?: AccordoDatoAggiuntivo | null;

    constructor(data?: IDatoAggiuntivoWriteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoDatoAggiuntivo = _data["accordoDatoAggiuntivo"] ? AccordoDatoAggiuntivo.fromJS(_data["accordoDatoAggiuntivo"]) : <any>null;
        }
    }

    static fromJS(data: any): DatoAggiuntivoWriteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoWriteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoDatoAggiuntivo"] = this.accordoDatoAggiuntivo ? this.accordoDatoAggiuntivo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDatoAggiuntivoWriteResponse extends IOkApiResponse {
    accordoDatoAggiuntivo?: AccordoDatoAggiuntivo | null;
}

export class DatoAggiuntivoWriteRequest extends ApiRequest implements IDatoAggiuntivoWriteRequest {
    accordoID?: number;
    accordoDatoAggiuntivo?: AccordoDatoAggiuntivo | null;

    constructor(data?: IDatoAggiuntivoWriteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.accordoDatoAggiuntivo = _data["accordoDatoAggiuntivo"] ? AccordoDatoAggiuntivo.fromJS(_data["accordoDatoAggiuntivo"]) : <any>null;
        }
    }

    static fromJS(data: any): DatoAggiuntivoWriteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoWriteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["accordoDatoAggiuntivo"] = this.accordoDatoAggiuntivo ? this.accordoDatoAggiuntivo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDatoAggiuntivoWriteRequest extends IApiRequest {
    accordoID?: number;
    accordoDatoAggiuntivo?: AccordoDatoAggiuntivo | null;
}

export class DatoAggiuntivoDeleteRequest extends ApiRequest implements IDatoAggiuntivoDeleteRequest {
    accordoID?: number;
    accordoDatoAggiuntivoID?: number;

    constructor(data?: IDatoAggiuntivoDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.accordoDatoAggiuntivoID = _data["accordoDatoAggiuntivoID"] !== undefined ? _data["accordoDatoAggiuntivoID"] : <any>null;
        }
    }

    static fromJS(data: any): DatoAggiuntivoDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["accordoDatoAggiuntivoID"] = this.accordoDatoAggiuntivoID !== undefined ? this.accordoDatoAggiuntivoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDatoAggiuntivoDeleteRequest extends IApiRequest {
    accordoID?: number;
    accordoDatoAggiuntivoID?: number;
}

export class DatoAggiuntivoDeleteMultiRequest extends ApiRequest implements IDatoAggiuntivoDeleteMultiRequest {
    accordoID?: number;
    accordiContattiIDs?: number[] | null;

    constructor(data?: IDatoAggiuntivoDeleteMultiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            if (Array.isArray(_data["accordiContattiIDs"])) {
                this.accordiContattiIDs = [] as any;
                for (let item of _data["accordiContattiIDs"])
                    this.accordiContattiIDs!.push(item);
            }
            else {
                this.accordiContattiIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): DatoAggiuntivoDeleteMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoDeleteMultiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        if (Array.isArray(this.accordiContattiIDs)) {
            data["accordiContattiIDs"] = [];
            for (let item of this.accordiContattiIDs)
                data["accordiContattiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDatoAggiuntivoDeleteMultiRequest extends IApiRequest {
    accordoID?: number;
    accordiContattiIDs?: number[] | null;
}

export class NrTableResponseOfTabellaCostiCommissioniRow extends OkApiResponse implements INrTableResponseOfTabellaCostiCommissioniRow {
    /** Array delle righe della pagina richiesta */
    rows?: TabellaCostiCommissioniRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTabellaCostiCommissioniRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TabellaCostiCommissioniRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfTabellaCostiCommissioniRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTabellaCostiCommissioniRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTabellaCostiCommissioniRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TabellaCostiCommissioniRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TabellaCostiCommissioniRow implements ITabellaCostiCommissioniRow {
    id?: number;
    nome?: string | null;
    dal?: string | null;
    al?: string | null;
    commissionePercentuale?: number;
    commissionePercentualeWeb?: number;

    constructor(data?: ITabellaCostiCommissioniRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.commissionePercentuale = _data["commissionePercentuale"] !== undefined ? _data["commissionePercentuale"] : <any>null;
            this.commissionePercentualeWeb = _data["commissionePercentualeWeb"] !== undefined ? _data["commissionePercentualeWeb"] : <any>null;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniRow {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["commissionePercentuale"] = this.commissionePercentuale !== undefined ? this.commissionePercentuale : <any>null;
        data["commissionePercentualeWeb"] = this.commissionePercentualeWeb !== undefined ? this.commissionePercentualeWeb : <any>null;
        return data;
    }
}

export interface ITabellaCostiCommissioniRow {
    id?: number;
    nome?: string | null;
    dal?: string | null;
    al?: string | null;
    commissionePercentuale?: number;
    commissionePercentualeWeb?: number;
}

export class TabelleCostiCommissioniSearchRequest extends NrTableRequest implements ITabelleCostiCommissioniSearchRequest {
    accordoId?: number;

    constructor(data?: ITabelleCostiCommissioniSearchRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoId = _data["accordoId"] !== undefined ? _data["accordoId"] : <any>null;
        }
    }

    static fromJS(data: any): TabelleCostiCommissioniSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TabelleCostiCommissioniSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoId"] = this.accordoId !== undefined ? this.accordoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITabelleCostiCommissioniSearchRequest extends INrTableRequest {
    accordoId?: number;
}

export class TabelleCostiCommissioniListResponse extends OkApiResponse implements ITabelleCostiCommissioniListResponse {
    tabelle?: TabellaCostiCommissioniList[] | null;

    constructor(data?: ITabelleCostiCommissioniListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tabelle"])) {
                this.tabelle = [] as any;
                for (let item of _data["tabelle"])
                    this.tabelle!.push(TabellaCostiCommissioniList.fromJS(item));
            }
            else {
                this.tabelle = <any>null;
            }
        }
    }

    static fromJS(data: any): TabelleCostiCommissioniListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TabelleCostiCommissioniListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tabelle)) {
            data["tabelle"] = [];
            for (let item of this.tabelle)
                data["tabelle"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITabelleCostiCommissioniListResponse extends IOkApiResponse {
    tabelle?: TabellaCostiCommissioniList[] | null;
}

export class TabellaCostiCommissioniList implements ITabellaCostiCommissioniList {
    tabella?: TabellaCostiCommissioni | null;
    nome?: string | null;
    codiceValuta?: string | null;

    constructor(data?: ITabellaCostiCommissioniList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabella = _data["tabella"] ? TabellaCostiCommissioni.fromJS(_data["tabella"]) : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : <any>null;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniList {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabella"] = this.tabella ? this.tabella.toJSON() : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : <any>null;
        return data;
    }
}

export interface ITabellaCostiCommissioniList {
    tabella?: TabellaCostiCommissioni | null;
    nome?: string | null;
    codiceValuta?: string | null;
}

export class TabellaCostiCommissioni implements ITabellaCostiCommissioni {
    tabellaCostiCommissioniID?: number;
    accordoID?: number;
    nome!: string;
    nomeOriginale?: string | null;
    descrizioneWeb?: string | null;
    dal?: string;
    al?: string;
    tipo?: ETipoTabellaCostiCommissioni | null;
    tipoCommissione?: ETipoCommissione | null;
    prenotaEntro?: string | null;
    prenotaDopo?: string | null;
    prenotaEntroGiorni?: number | null;
    regolaInserimentoID?: number | null;
    commissionePercentuale?: number;
    commissionePercentualeWeb?: number;
    commissionePercentualePacchetti?: number | null;
    permutaBambini?: boolean | null;
    nonRimborsabile?: boolean;
    pagaSubito?: boolean;
    nozze?: boolean;
    fisso?: boolean;
    codiceAviomar?: number | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    ordine?: number | null;

    constructor(data?: ITabellaCostiCommissioni) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabellaCostiCommissioniID = _data["tabellaCostiCommissioniID"] !== undefined ? _data["tabellaCostiCommissioniID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeOriginale = _data["nomeOriginale"] !== undefined ? _data["nomeOriginale"] : <any>null;
            this.descrizioneWeb = _data["descrizioneWeb"] !== undefined ? _data["descrizioneWeb"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.tipoCommissione = _data["tipoCommissione"] !== undefined ? _data["tipoCommissione"] : <any>null;
            this.prenotaEntro = _data["prenotaEntro"] !== undefined ? _data["prenotaEntro"] : <any>null;
            this.prenotaDopo = _data["prenotaDopo"] !== undefined ? _data["prenotaDopo"] : <any>null;
            this.prenotaEntroGiorni = _data["prenotaEntroGiorni"] !== undefined ? _data["prenotaEntroGiorni"] : <any>null;
            this.regolaInserimentoID = _data["regolaInserimentoID"] !== undefined ? _data["regolaInserimentoID"] : <any>null;
            this.commissionePercentuale = _data["commissionePercentuale"] !== undefined ? _data["commissionePercentuale"] : <any>null;
            this.commissionePercentualeWeb = _data["commissionePercentualeWeb"] !== undefined ? _data["commissionePercentualeWeb"] : <any>null;
            this.commissionePercentualePacchetti = _data["commissionePercentualePacchetti"] !== undefined ? _data["commissionePercentualePacchetti"] : <any>null;
            this.permutaBambini = _data["permutaBambini"] !== undefined ? _data["permutaBambini"] : <any>null;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : <any>null;
            this.pagaSubito = _data["pagaSubito"] !== undefined ? _data["pagaSubito"] : <any>null;
            this.nozze = _data["nozze"] !== undefined ? _data["nozze"] : <any>null;
            this.fisso = _data["fisso"] !== undefined ? _data["fisso"] : <any>null;
            this.codiceAviomar = _data["codiceAviomar"] !== undefined ? _data["codiceAviomar"] : <any>null;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : <any>null;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : <any>null;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioni {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioni();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabellaCostiCommissioniID"] = this.tabellaCostiCommissioniID !== undefined ? this.tabellaCostiCommissioniID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeOriginale"] = this.nomeOriginale !== undefined ? this.nomeOriginale : <any>null;
        data["descrizioneWeb"] = this.descrizioneWeb !== undefined ? this.descrizioneWeb : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["tipoCommissione"] = this.tipoCommissione !== undefined ? this.tipoCommissione : <any>null;
        data["prenotaEntro"] = this.prenotaEntro !== undefined ? this.prenotaEntro : <any>null;
        data["prenotaDopo"] = this.prenotaDopo !== undefined ? this.prenotaDopo : <any>null;
        data["prenotaEntroGiorni"] = this.prenotaEntroGiorni !== undefined ? this.prenotaEntroGiorni : <any>null;
        data["regolaInserimentoID"] = this.regolaInserimentoID !== undefined ? this.regolaInserimentoID : <any>null;
        data["commissionePercentuale"] = this.commissionePercentuale !== undefined ? this.commissionePercentuale : <any>null;
        data["commissionePercentualeWeb"] = this.commissionePercentualeWeb !== undefined ? this.commissionePercentualeWeb : <any>null;
        data["commissionePercentualePacchetti"] = this.commissionePercentualePacchetti !== undefined ? this.commissionePercentualePacchetti : <any>null;
        data["permutaBambini"] = this.permutaBambini !== undefined ? this.permutaBambini : <any>null;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : <any>null;
        data["pagaSubito"] = this.pagaSubito !== undefined ? this.pagaSubito : <any>null;
        data["nozze"] = this.nozze !== undefined ? this.nozze : <any>null;
        data["fisso"] = this.fisso !== undefined ? this.fisso : <any>null;
        data["codiceAviomar"] = this.codiceAviomar !== undefined ? this.codiceAviomar : <any>null;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : <any>null;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : <any>null;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        return data;
    }
}

export interface ITabellaCostiCommissioni {
    tabellaCostiCommissioniID?: number;
    accordoID?: number;
    nome: string;
    nomeOriginale?: string | null;
    descrizioneWeb?: string | null;
    dal?: string;
    al?: string;
    tipo?: ETipoTabellaCostiCommissioni | null;
    tipoCommissione?: ETipoCommissione | null;
    prenotaEntro?: string | null;
    prenotaDopo?: string | null;
    prenotaEntroGiorni?: number | null;
    regolaInserimentoID?: number | null;
    commissionePercentuale?: number;
    commissionePercentualeWeb?: number;
    commissionePercentualePacchetti?: number | null;
    permutaBambini?: boolean | null;
    nonRimborsabile?: boolean;
    pagaSubito?: boolean;
    nozze?: boolean;
    fisso?: boolean;
    codiceAviomar?: number | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    ordine?: number | null;
}

export enum ETipoTabellaCostiCommissioni {
    Standard = "Standard",
    LastMinute = "LastMinute",
    PrenotaPrima = "PrenotaPrima",
}

export enum ETipoCommissione {
    ContrattiAlNetto = "ContrattiAlNetto",
    SuLordo = "SuLordo",
    SuImponibile = "SuImponibile",
    ScontoCommerciale = "ScontoCommerciale",
}

export class SiteRequest extends LocalizedRequest implements ISiteRequest {
    siteID?: number;

    constructor(data?: ISiteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.siteID = _data["siteID"] !== undefined ? _data["siteID"] : <any>null;
        }
    }

    static fromJS(data: any): SiteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SiteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteID"] = this.siteID !== undefined ? this.siteID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISiteRequest extends ILocalizedRequest {
    siteID?: number;
}

export class TabelleCostiCommissioniListRequest extends SiteRequest implements ITabelleCostiCommissioniListRequest {
    accordoID?: number;

    constructor(data?: ITabelleCostiCommissioniListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
        }
    }

    static fromJS(data: any): TabelleCostiCommissioniListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TabelleCostiCommissioniListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITabelleCostiCommissioniListRequest extends ISiteRequest {
    accordoID?: number;
}

export class TabellaCostiCommissioniReadResponse extends OkApiResponse implements ITabellaCostiCommissioniReadResponse {
    tabellaCostiCommissioni?: TabellaCostiCommissioni | null;

    constructor(data?: ITabellaCostiCommissioniReadResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] ? TabellaCostiCommissioni.fromJS(_data["tabellaCostiCommissioni"]) : <any>null;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniReadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniReadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni ? this.tabellaCostiCommissioni.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITabellaCostiCommissioniReadResponse extends IOkApiResponse {
    tabellaCostiCommissioni?: TabellaCostiCommissioni | null;
}

export class TabellaCostiCommissioniReadRequest extends ApiRequest implements ITabellaCostiCommissioniReadRequest {
    accordoID?: number;
    tabellaCostiCommissioniID?: number;

    constructor(data?: ITabellaCostiCommissioniReadRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.tabellaCostiCommissioniID = _data["tabellaCostiCommissioniID"] !== undefined ? _data["tabellaCostiCommissioniID"] : <any>null;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniReadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniReadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["tabellaCostiCommissioniID"] = this.tabellaCostiCommissioniID !== undefined ? this.tabellaCostiCommissioniID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITabellaCostiCommissioniReadRequest extends IApiRequest {
    accordoID?: number;
    tabellaCostiCommissioniID?: number;
}

export class TabellaCostiCommissioniWriteResponse extends OkApiResponse implements ITabellaCostiCommissioniWriteResponse {
    tabellaCostiCommissioni?: TabellaCostiCommissioni | null;

    constructor(data?: ITabellaCostiCommissioniWriteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] ? TabellaCostiCommissioni.fromJS(_data["tabellaCostiCommissioni"]) : <any>null;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniWriteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniWriteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni ? this.tabellaCostiCommissioni.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITabellaCostiCommissioniWriteResponse extends IOkApiResponse {
    tabellaCostiCommissioni?: TabellaCostiCommissioni | null;
}

export class TabellaCostiCommissioniWriteRequest extends ApiRequest implements ITabellaCostiCommissioniWriteRequest {
    accordoID?: number;
    tabellaCostiCommissioni?: TabellaCostiCommissioni | null;

    constructor(data?: ITabellaCostiCommissioniWriteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] ? TabellaCostiCommissioni.fromJS(_data["tabellaCostiCommissioni"]) : <any>null;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniWriteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniWriteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni ? this.tabellaCostiCommissioni.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITabellaCostiCommissioniWriteRequest extends IApiRequest {
    accordoID?: number;
    tabellaCostiCommissioni?: TabellaCostiCommissioni | null;
}

export class TabellaCostiCommissioniDeleteRequest extends ApiRequest implements ITabellaCostiCommissioniDeleteRequest {
    accordoID?: number;
    tabellaCostiCommissioniID?: number;

    constructor(data?: ITabellaCostiCommissioniDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.tabellaCostiCommissioniID = _data["tabellaCostiCommissioniID"] !== undefined ? _data["tabellaCostiCommissioniID"] : <any>null;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["tabellaCostiCommissioniID"] = this.tabellaCostiCommissioniID !== undefined ? this.tabellaCostiCommissioniID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITabellaCostiCommissioniDeleteRequest extends IApiRequest {
    accordoID?: number;
    tabellaCostiCommissioniID?: number;
}

export class TabellaCostiCommissioniDeleteMultiRequest extends ApiRequest implements ITabellaCostiCommissioniDeleteMultiRequest {
    accordoID?: number;
    tabelleCostiCommissioniIDs?: number[] | null;

    constructor(data?: ITabellaCostiCommissioniDeleteMultiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            if (Array.isArray(_data["tabelleCostiCommissioniIDs"])) {
                this.tabelleCostiCommissioniIDs = [] as any;
                for (let item of _data["tabelleCostiCommissioniIDs"])
                    this.tabelleCostiCommissioniIDs!.push(item);
            }
            else {
                this.tabelleCostiCommissioniIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniDeleteMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniDeleteMultiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        if (Array.isArray(this.tabelleCostiCommissioniIDs)) {
            data["tabelleCostiCommissioniIDs"] = [];
            for (let item of this.tabelleCostiCommissioniIDs)
                data["tabelleCostiCommissioniIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITabellaCostiCommissioniDeleteMultiRequest extends IApiRequest {
    accordoID?: number;
    tabelleCostiCommissioniIDs?: number[] | null;
}

export class NrTableResponseOfAccordoRow extends OkApiResponse implements INrTableResponseOfAccordoRow {
    /** Array delle righe della pagina richiesta */
    rows?: AccordoRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAccordoRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AccordoRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfAccordoRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAccordoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAccordoRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AccordoRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

/** Vista di riga per l'elenco accordi */
export class AccordoRow implements IAccordoRow {
    /** ID dell'accordo */
    id?: number;
    /** Nome dell'accordo */
    nome?: string | null;
    /** Operatore al quale si applica l'accordo */
    operatore?: EOperatore | null;
    /** Nome visualizzato del contatto dell'accordo */
    contatto?: string | null;
    /** Nome del luogo del contatto dell'accordo */
    luogo?: string | null;
    /** Se true il luogo è eliminato */
    luogoEliminato?: boolean;
    /** Codice mnemonico dell'accordo */
    memo?: string | null;
    /** Data di validità "dal" */
    dal?: string | null;
    /** Data di validità "al" */
    al?: string | null;
    deleted?: string | null;

    constructor(data?: IAccordoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.luogoEliminato = _data["luogoEliminato"] !== undefined ? _data["luogoEliminato"] : <any>null;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
        }
    }

    static fromJS(data: any): AccordoRow {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["contatto"] = this.contatto !== undefined ? this.contatto : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["luogoEliminato"] = this.luogoEliminato !== undefined ? this.luogoEliminato : <any>null;
        data["memo"] = this.memo !== undefined ? this.memo : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        return data;
    }
}

/** Vista di riga per l'elenco accordi */
export interface IAccordoRow {
    /** ID dell'accordo */
    id?: number;
    /** Nome dell'accordo */
    nome?: string | null;
    /** Operatore al quale si applica l'accordo */
    operatore?: EOperatore | null;
    /** Nome visualizzato del contatto dell'accordo */
    contatto?: string | null;
    /** Nome del luogo del contatto dell'accordo */
    luogo?: string | null;
    /** Se true il luogo è eliminato */
    luogoEliminato?: boolean;
    /** Codice mnemonico dell'accordo */
    memo?: string | null;
    /** Data di validità "dal" */
    dal?: string | null;
    /** Data di validità "al" */
    al?: string | null;
    deleted?: string | null;
}

/** Filtri per la ricerca paginata degli accordi */
export class AccordiSearchRequest extends NrTableRequest implements IAccordiSearchRequest {
    /** Nome da ricercare, o parte. Case insensitive */
    nome?: string | null;
    /** Tipo di accordo, obbligatorio */
    tipo?: ETipoAccordo;
    /** Id del contatto. Facoltativo */
    contattoId?: number | null;
    /** Filtro sul tipo di scadenza */
    filtroScadenza?: EFiltroScadenzaAccordi;
    operatore?: EOperatore | null;
    /** Show also deleted items */
    showValid?: boolean | null;

    constructor(data?: IAccordiSearchRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
            this.filtroScadenza = _data["filtroScadenza"] !== undefined ? _data["filtroScadenza"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.showValid = _data["showValid"] !== undefined ? _data["showValid"] : <any>null;
        }
    }

    static fromJS(data: any): AccordiSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccordiSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        data["filtroScadenza"] = this.filtroScadenza !== undefined ? this.filtroScadenza : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["showValid"] = this.showValid !== undefined ? this.showValid : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Filtri per la ricerca paginata degli accordi */
export interface IAccordiSearchRequest extends INrTableRequest {
    /** Nome da ricercare, o parte. Case insensitive */
    nome?: string | null;
    /** Tipo di accordo, obbligatorio */
    tipo?: ETipoAccordo;
    /** Id del contatto. Facoltativo */
    contattoId?: number | null;
    /** Filtro sul tipo di scadenza */
    filtroScadenza?: EFiltroScadenzaAccordi;
    operatore?: EOperatore | null;
    /** Show also deleted items */
    showValid?: boolean | null;
}

/** Modalità del filtro scadenza per gli accordi */
export enum EFiltroScadenzaAccordi {
    Qualsiasi = "Qualsiasi",
    Scaduti = "Scaduti",
    NonScaduti = "NonScaduti",
    ValidiAdesso = "ValidiAdesso",
    ValidiInFuturo = "ValidiInFuturo",
}

export class GetCurrenciesExportRequest extends LocalizedRequest implements IGetCurrenciesExportRequest {
    exportEntityName?: string | null;
    exportFieldsNames?: { [key: string]: string; } | null;
    fieldsDecoders?: { [key: string]: { [key: string]: string; }; } | null;

    constructor(data?: IGetCurrenciesExportRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.exportEntityName = _data["exportEntityName"] !== undefined ? _data["exportEntityName"] : <any>null;
            if (_data["exportFieldsNames"]) {
                this.exportFieldsNames = {} as any;
                for (let key in _data["exportFieldsNames"]) {
                    if (_data["exportFieldsNames"].hasOwnProperty(key))
                        (<any>this.exportFieldsNames)![key] = _data["exportFieldsNames"][key] !== undefined ? _data["exportFieldsNames"][key] : <any>null;
                }
            }
            else {
                this.exportFieldsNames = <any>null;
            }
            if (_data["fieldsDecoders"]) {
                this.fieldsDecoders = {} as any;
                for (let key in _data["fieldsDecoders"]) {
                    if (_data["fieldsDecoders"].hasOwnProperty(key))
                        (<any>this.fieldsDecoders)![key] = _data["fieldsDecoders"][key] !== undefined ? _data["fieldsDecoders"][key] : {};
                }
            }
            else {
                this.fieldsDecoders = <any>null;
            }
        }
    }

    static fromJS(data: any): GetCurrenciesExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrenciesExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportEntityName"] = this.exportEntityName !== undefined ? this.exportEntityName : <any>null;
        if (this.exportFieldsNames) {
            data["exportFieldsNames"] = {};
            for (let key in this.exportFieldsNames) {
                if (this.exportFieldsNames.hasOwnProperty(key))
                    (<any>data["exportFieldsNames"])[key] = this.exportFieldsNames[key] !== undefined ? this.exportFieldsNames[key] : <any>null;
            }
        }
        if (this.fieldsDecoders) {
            data["fieldsDecoders"] = {};
            for (let key in this.fieldsDecoders) {
                if (this.fieldsDecoders.hasOwnProperty(key))
                    (<any>data["fieldsDecoders"])[key] = this.fieldsDecoders[key] !== undefined ? this.fieldsDecoders[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCurrenciesExportRequest extends ILocalizedRequest {
    exportEntityName?: string | null;
    exportFieldsNames?: { [key: string]: string; } | null;
    fieldsDecoders?: { [key: string]: { [key: string]: string; }; } | null;
}

export class GetCurrenciesListResponse extends OkApiResponse implements IGetCurrenciesListResponse {
    /** Elenco delle valute e relativi cambi */
    currencies?: CurrencyRow[];

    constructor(data?: IGetCurrenciesListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["currencies"])) {
                this.currencies = [] as any;
                for (let item of _data["currencies"])
                    this.currencies!.push(CurrencyRow.fromJS(item));
            }
            else {
                this.currencies = <any>null;
            }
        }
    }

    static fromJS(data: any): GetCurrenciesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrenciesListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.currencies)) {
            data["currencies"] = [];
            for (let item of this.currencies)
                data["currencies"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCurrenciesListResponse extends IOkApiResponse {
    /** Elenco delle valute e relativi cambi */
    currencies?: CurrencyRow[];
}

export class CurrencyRow implements ICurrencyRow {
    /** ID della valuta */
    id?: number;
    /** Codice a 3 lettere della valuta */
    code?: string;
    /** Nome della valuta */
    name?: string;
    /** Valore di cambio corrente */
    valoreCorrente?: number | null;
    /** Valore di cambio applicato alle offerte corrente */
    valoreApplicato?: number | null;
    /** Ultimo aggiornamento del valore */
    lastUpdate?: string | null;

    constructor(data?: ICurrencyRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.valoreCorrente = _data["valoreCorrente"] !== undefined ? _data["valoreCorrente"] : <any>null;
            this.valoreApplicato = _data["valoreApplicato"] !== undefined ? _data["valoreApplicato"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
        }
    }

    static fromJS(data: any): CurrencyRow {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["valoreCorrente"] = this.valoreCorrente !== undefined ? this.valoreCorrente : <any>null;
        data["valoreApplicato"] = this.valoreApplicato !== undefined ? this.valoreApplicato : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        return data;
    }
}

export interface ICurrencyRow {
    /** ID della valuta */
    id?: number;
    /** Codice a 3 lettere della valuta */
    code?: string;
    /** Nome della valuta */
    name?: string;
    /** Valore di cambio corrente */
    valoreCorrente?: number | null;
    /** Valore di cambio applicato alle offerte corrente */
    valoreApplicato?: number | null;
    /** Ultimo aggiornamento del valore */
    lastUpdate?: string | null;
}

export class NrTableResponseOfValutaValore extends OkApiResponse implements INrTableResponseOfValutaValore {
    /** Array delle righe della pagina richiesta */
    rows?: ValutaValore[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfValutaValore) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ValutaValore.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfValutaValore {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfValutaValore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfValutaValore extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ValutaValore[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetCurrencyHistoryResponse extends NrTableResponseOfValutaValore implements IGetCurrencyHistoryResponse {

    constructor(data?: IGetCurrencyHistoryResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetCurrencyHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrencyHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetCurrencyHistoryResponse extends INrTableResponseOfValutaValore {
}

export class ValutaValore implements IValutaValore {
    valutaValoreID?: number;
    valutaID?: number;
    data?: string;
    valoreCorrente?: number;
    valore?: number;
    valoreApplicato?: number;
    attiva?: boolean | null;
    operatoreID?: number | null;

    constructor(data?: IValutaValore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valutaValoreID = _data["valutaValoreID"] !== undefined ? _data["valutaValoreID"] : <any>null;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.valoreCorrente = _data["valoreCorrente"] !== undefined ? _data["valoreCorrente"] : <any>null;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : <any>null;
            this.valoreApplicato = _data["valoreApplicato"] !== undefined ? _data["valoreApplicato"] : <any>null;
            this.attiva = _data["attiva"] !== undefined ? _data["attiva"] : <any>null;
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : <any>null;
        }
    }

    static fromJS(data: any): ValutaValore {
        data = typeof data === 'object' ? data : {};
        let result = new ValutaValore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valutaValoreID"] = this.valutaValoreID !== undefined ? this.valutaValoreID : <any>null;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["valoreCorrente"] = this.valoreCorrente !== undefined ? this.valoreCorrente : <any>null;
        data["valore"] = this.valore !== undefined ? this.valore : <any>null;
        data["valoreApplicato"] = this.valoreApplicato !== undefined ? this.valoreApplicato : <any>null;
        data["attiva"] = this.attiva !== undefined ? this.attiva : <any>null;
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : <any>null;
        return data;
    }
}

export interface IValutaValore {
    valutaValoreID?: number;
    valutaID?: number;
    data?: string;
    valoreCorrente?: number;
    valore?: number;
    valoreApplicato?: number;
    attiva?: boolean | null;
    operatoreID?: number | null;
}

export class GetCurrencyHistoryRequest extends NrTableRequest implements IGetCurrencyHistoryRequest {
    /** ID della valuta di cui caricare lo storico */
    valutaID?: number;

    constructor(data?: IGetCurrencyHistoryRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : <any>null;
        }
    }

    static fromJS(data: any): GetCurrencyHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrencyHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCurrencyHistoryRequest extends INrTableRequest {
    /** ID della valuta di cui caricare lo storico */
    valutaID?: number;
}

export class CurrencyRateInsertResponse extends OkApiResponse implements ICurrencyRateInsertResponse {
    /** Singola riga aggiornata */
    valutaAggiornata?: CurrencyRow;

    constructor(data?: ICurrencyRateInsertResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valutaAggiornata = _data["valutaAggiornata"] ? CurrencyRow.fromJS(_data["valutaAggiornata"]) : <any>null;
        }
    }

    static fromJS(data: any): CurrencyRateInsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyRateInsertResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valutaAggiornata"] = this.valutaAggiornata ? this.valutaAggiornata.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICurrencyRateInsertResponse extends IOkApiResponse {
    /** Singola riga aggiornata */
    valutaAggiornata?: CurrencyRow;
}

export class CurrencyRateInsertRequest extends LocalizedRequest implements ICurrencyRateInsertRequest {
    /** ID della valuta alla quale aggiungere un nuovo cambio */
    valutaID?: number;
    /** Nuovo valore corrente */
    valoreCorrente?: number;
    /** Nuovo valore applicato */
    valoreApplicato?: number;

    constructor(data?: ICurrencyRateInsertRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : <any>null;
            this.valoreCorrente = _data["valoreCorrente"] !== undefined ? _data["valoreCorrente"] : <any>null;
            this.valoreApplicato = _data["valoreApplicato"] !== undefined ? _data["valoreApplicato"] : <any>null;
        }
    }

    static fromJS(data: any): CurrencyRateInsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyRateInsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : <any>null;
        data["valoreCorrente"] = this.valoreCorrente !== undefined ? this.valoreCorrente : <any>null;
        data["valoreApplicato"] = this.valoreApplicato !== undefined ? this.valoreApplicato : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICurrencyRateInsertRequest extends ILocalizedRequest {
    /** ID della valuta alla quale aggiungere un nuovo cambio */
    valutaID?: number;
    /** Nuovo valore corrente */
    valoreCorrente?: number;
    /** Nuovo valore applicato */
    valoreApplicato?: number;
}

export class GetNewExchangeRatesResponse extends OkApiResponse implements IGetNewExchangeRatesResponse {
    /** Elenco dei cambi */
    cambi?: ValutaValore[];

    constructor(data?: IGetNewExchangeRatesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["cambi"])) {
                this.cambi = [] as any;
                for (let item of _data["cambi"])
                    this.cambi!.push(ValutaValore.fromJS(item));
            }
            else {
                this.cambi = <any>null;
            }
        }
    }

    static fromJS(data: any): GetNewExchangeRatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewExchangeRatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cambi)) {
            data["cambi"] = [];
            for (let item of this.cambi)
                data["cambi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetNewExchangeRatesResponse extends IOkApiResponse {
    /** Elenco dei cambi */
    cambi?: ValutaValore[];
}

export class ImportTicketsDeleteResponse extends OkApiResponse implements IImportTicketsDeleteResponse {

    constructor(data?: IImportTicketsDeleteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ImportTicketsDeleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsDeleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsDeleteResponse extends IOkApiResponse {
}

export class ImportTicketsDeleteRequest extends ApiRequest implements IImportTicketsDeleteRequest {
    id?: number;

    constructor(data?: IImportTicketsDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): ImportTicketsDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsDeleteRequest extends IApiRequest {
    id?: number;
}

export class ImportTicketsGetResponse extends OkApiResponse implements IImportTicketsGetResponse {
    id?: number;
    dataBolla?: string | null;
    numeroBolla?: string | null;
    vettore?: string | null;
    codiceV?: string | null;
    pax?: string | null;
    serie?: string | null;
    tkt?: string | null;
    routing?: string | null;
    classe?: string | null;
    nazInt?: string | null;
    partenza?: string | null;
    c_Costo?: number | null;
    commessa?: string | null;
    tariffaApplicata?: number | null;
    tax?: number | null;
    totale?: number | null;
    tariffaOrdinaria?: number | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    note?: string | null;
    partenzaPratica?: string | null;

    constructor(data?: IImportTicketsGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dataBolla = _data["dataBolla"] !== undefined ? _data["dataBolla"] : <any>null;
            this.numeroBolla = _data["numeroBolla"] !== undefined ? _data["numeroBolla"] : <any>null;
            this.vettore = _data["vettore"] !== undefined ? _data["vettore"] : <any>null;
            this.codiceV = _data["codiceV"] !== undefined ? _data["codiceV"] : <any>null;
            this.pax = _data["pax"] !== undefined ? _data["pax"] : <any>null;
            this.serie = _data["serie"] !== undefined ? _data["serie"] : <any>null;
            this.tkt = _data["tkt"] !== undefined ? _data["tkt"] : <any>null;
            this.routing = _data["routing"] !== undefined ? _data["routing"] : <any>null;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : <any>null;
            this.nazInt = _data["nazInt"] !== undefined ? _data["nazInt"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.c_Costo = _data["c_Costo"] !== undefined ? _data["c_Costo"] : <any>null;
            this.commessa = _data["commessa"] !== undefined ? _data["commessa"] : <any>null;
            this.tariffaApplicata = _data["tariffaApplicata"] !== undefined ? _data["tariffaApplicata"] : <any>null;
            this.tax = _data["tax"] !== undefined ? _data["tax"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.tariffaOrdinaria = _data["tariffaOrdinaria"] !== undefined ? _data["tariffaOrdinaria"] : <any>null;
            this.f_Pag = _data["f_Pag"] !== undefined ? _data["f_Pag"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.iva = _data["iva"] !== undefined ? _data["iva"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.partenzaPratica = _data["partenzaPratica"] !== undefined ? _data["partenzaPratica"] : <any>null;
        }
    }

    static fromJS(data: any): ImportTicketsGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dataBolla"] = this.dataBolla !== undefined ? this.dataBolla : <any>null;
        data["numeroBolla"] = this.numeroBolla !== undefined ? this.numeroBolla : <any>null;
        data["vettore"] = this.vettore !== undefined ? this.vettore : <any>null;
        data["codiceV"] = this.codiceV !== undefined ? this.codiceV : <any>null;
        data["pax"] = this.pax !== undefined ? this.pax : <any>null;
        data["serie"] = this.serie !== undefined ? this.serie : <any>null;
        data["tkt"] = this.tkt !== undefined ? this.tkt : <any>null;
        data["routing"] = this.routing !== undefined ? this.routing : <any>null;
        data["classe"] = this.classe !== undefined ? this.classe : <any>null;
        data["nazInt"] = this.nazInt !== undefined ? this.nazInt : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["c_Costo"] = this.c_Costo !== undefined ? this.c_Costo : <any>null;
        data["commessa"] = this.commessa !== undefined ? this.commessa : <any>null;
        data["tariffaApplicata"] = this.tariffaApplicata !== undefined ? this.tariffaApplicata : <any>null;
        data["tax"] = this.tax !== undefined ? this.tax : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["tariffaOrdinaria"] = this.tariffaOrdinaria !== undefined ? this.tariffaOrdinaria : <any>null;
        data["f_Pag"] = this.f_Pag !== undefined ? this.f_Pag : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["iva"] = this.iva !== undefined ? this.iva : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["partenzaPratica"] = this.partenzaPratica !== undefined ? this.partenzaPratica : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsGetResponse extends IOkApiResponse {
    id?: number;
    dataBolla?: string | null;
    numeroBolla?: string | null;
    vettore?: string | null;
    codiceV?: string | null;
    pax?: string | null;
    serie?: string | null;
    tkt?: string | null;
    routing?: string | null;
    classe?: string | null;
    nazInt?: string | null;
    partenza?: string | null;
    c_Costo?: number | null;
    commessa?: string | null;
    tariffaApplicata?: number | null;
    tax?: number | null;
    totale?: number | null;
    tariffaOrdinaria?: number | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    note?: string | null;
    partenzaPratica?: string | null;
}

export class ImportTicketsGetRequest extends ApiRequest implements IImportTicketsGetRequest {
    id!: number;

    constructor(data?: IImportTicketsGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): ImportTicketsGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsGetRequest extends IApiRequest {
    id: number;
}

export class NrTableResponseOfTicketsRows extends OkApiResponse implements INrTableResponseOfTicketsRows {
    /** Array delle righe della pagina richiesta */
    rows?: TicketsRows[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTicketsRows) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TicketsRows.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfTicketsRows {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTicketsRows();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTicketsRows extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TicketsRows[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ListTicketsResponse extends NrTableResponseOfTicketsRows implements IListTicketsResponse {

    constructor(data?: IListTicketsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ListTicketsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListTicketsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListTicketsResponse extends INrTableResponseOfTicketsRows {
}

export class TicketsRows implements ITicketsRows {
    id?: number;
    dataBolla?: string | null;
    numeroBolla?: string | null;
    vettore?: string | null;
    codiceV?: string | null;
    pax?: string | null;
    serie?: string | null;
    tkt?: string | null;
    routing?: string | null;
    classe?: string | null;
    nazInt?: string | null;
    partenza?: string | null;
    c_Costo?: number | null;
    commessa?: string | null;
    tariffaApplicata?: number | null;
    tax?: number | null;
    totale?: number | null;
    tariffaOrdinaria?: number | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    note?: string | null;
    partenzaPratica?: string | null;
    ticketType?: ETicketsType;

    constructor(data?: ITicketsRows) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dataBolla = _data["dataBolla"] !== undefined ? _data["dataBolla"] : <any>null;
            this.numeroBolla = _data["numeroBolla"] !== undefined ? _data["numeroBolla"] : <any>null;
            this.vettore = _data["vettore"] !== undefined ? _data["vettore"] : <any>null;
            this.codiceV = _data["codiceV"] !== undefined ? _data["codiceV"] : <any>null;
            this.pax = _data["pax"] !== undefined ? _data["pax"] : <any>null;
            this.serie = _data["serie"] !== undefined ? _data["serie"] : <any>null;
            this.tkt = _data["tkt"] !== undefined ? _data["tkt"] : <any>null;
            this.routing = _data["routing"] !== undefined ? _data["routing"] : <any>null;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : <any>null;
            this.nazInt = _data["nazInt"] !== undefined ? _data["nazInt"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.c_Costo = _data["c_Costo"] !== undefined ? _data["c_Costo"] : <any>null;
            this.commessa = _data["commessa"] !== undefined ? _data["commessa"] : <any>null;
            this.tariffaApplicata = _data["tariffaApplicata"] !== undefined ? _data["tariffaApplicata"] : <any>null;
            this.tax = _data["tax"] !== undefined ? _data["tax"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.tariffaOrdinaria = _data["tariffaOrdinaria"] !== undefined ? _data["tariffaOrdinaria"] : <any>null;
            this.f_Pag = _data["f_Pag"] !== undefined ? _data["f_Pag"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.iva = _data["iva"] !== undefined ? _data["iva"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.partenzaPratica = _data["partenzaPratica"] !== undefined ? _data["partenzaPratica"] : <any>null;
            this.ticketType = _data["ticketType"] !== undefined ? _data["ticketType"] : <any>null;
        }
    }

    static fromJS(data: any): TicketsRows {
        data = typeof data === 'object' ? data : {};
        let result = new TicketsRows();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dataBolla"] = this.dataBolla !== undefined ? this.dataBolla : <any>null;
        data["numeroBolla"] = this.numeroBolla !== undefined ? this.numeroBolla : <any>null;
        data["vettore"] = this.vettore !== undefined ? this.vettore : <any>null;
        data["codiceV"] = this.codiceV !== undefined ? this.codiceV : <any>null;
        data["pax"] = this.pax !== undefined ? this.pax : <any>null;
        data["serie"] = this.serie !== undefined ? this.serie : <any>null;
        data["tkt"] = this.tkt !== undefined ? this.tkt : <any>null;
        data["routing"] = this.routing !== undefined ? this.routing : <any>null;
        data["classe"] = this.classe !== undefined ? this.classe : <any>null;
        data["nazInt"] = this.nazInt !== undefined ? this.nazInt : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["c_Costo"] = this.c_Costo !== undefined ? this.c_Costo : <any>null;
        data["commessa"] = this.commessa !== undefined ? this.commessa : <any>null;
        data["tariffaApplicata"] = this.tariffaApplicata !== undefined ? this.tariffaApplicata : <any>null;
        data["tax"] = this.tax !== undefined ? this.tax : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["tariffaOrdinaria"] = this.tariffaOrdinaria !== undefined ? this.tariffaOrdinaria : <any>null;
        data["f_Pag"] = this.f_Pag !== undefined ? this.f_Pag : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["iva"] = this.iva !== undefined ? this.iva : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["partenzaPratica"] = this.partenzaPratica !== undefined ? this.partenzaPratica : <any>null;
        data["ticketType"] = this.ticketType !== undefined ? this.ticketType : <any>null;
        return data;
    }
}

export interface ITicketsRows {
    id?: number;
    dataBolla?: string | null;
    numeroBolla?: string | null;
    vettore?: string | null;
    codiceV?: string | null;
    pax?: string | null;
    serie?: string | null;
    tkt?: string | null;
    routing?: string | null;
    classe?: string | null;
    nazInt?: string | null;
    partenza?: string | null;
    c_Costo?: number | null;
    commessa?: string | null;
    tariffaApplicata?: number | null;
    tax?: number | null;
    totale?: number | null;
    tariffaOrdinaria?: number | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    note?: string | null;
    partenzaPratica?: string | null;
    ticketType?: ETicketsType;
}

export enum ETicketsType {
    Meridiano = "Meridiano",
    Amadeus = "Amadeus",
}

export class ListTicketsRequest extends NrTableRequest implements IListTicketsRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
    emessoDal?: string | null;
    emessoAl?: string | null;
    pax?: string | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    tkt?: string | null;
    ticketType?: ETicketsType | null;

    constructor(data?: IListTicketsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.emessoDal = _data["emessoDal"] !== undefined ? _data["emessoDal"] : <any>null;
            this.emessoAl = _data["emessoAl"] !== undefined ? _data["emessoAl"] : <any>null;
            this.pax = _data["pax"] !== undefined ? _data["pax"] : <any>null;
            this.f_Pag = _data["f_Pag"] !== undefined ? _data["f_Pag"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.iva = _data["iva"] !== undefined ? _data["iva"] : <any>null;
            this.tkt = _data["tkt"] !== undefined ? _data["tkt"] : <any>null;
            this.ticketType = _data["ticketType"] !== undefined ? _data["ticketType"] : <any>null;
        }
    }

    static fromJS(data: any): ListTicketsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListTicketsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["emessoDal"] = this.emessoDal !== undefined ? this.emessoDal : <any>null;
        data["emessoAl"] = this.emessoAl !== undefined ? this.emessoAl : <any>null;
        data["pax"] = this.pax !== undefined ? this.pax : <any>null;
        data["f_Pag"] = this.f_Pag !== undefined ? this.f_Pag : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["iva"] = this.iva !== undefined ? this.iva : <any>null;
        data["tkt"] = this.tkt !== undefined ? this.tkt : <any>null;
        data["ticketType"] = this.ticketType !== undefined ? this.ticketType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IListTicketsRequest extends INrTableRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
    emessoDal?: string | null;
    emessoAl?: string | null;
    pax?: string | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    tkt?: string | null;
    ticketType?: ETicketsType | null;
}

export class ImportTicketsUpdateResponse extends OkApiResponse implements IImportTicketsUpdateResponse {

    constructor(data?: IImportTicketsUpdateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ImportTicketsUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsUpdateResponse extends IOkApiResponse {
}

export class ImportTicketsUpdateRequest extends ImportTicketsGetRequest implements IImportTicketsUpdateRequest {
    importTickets?: ImportTicket | null;

    constructor(data?: IImportTicketsUpdateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.importTickets = _data["importTickets"] ? ImportTicket.fromJS(_data["importTickets"]) : <any>null;
        }
    }

    static fromJS(data: any): ImportTicketsUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importTickets"] = this.importTickets ? this.importTickets.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsUpdateRequest extends IImportTicketsGetRequest {
    importTickets?: ImportTicket | null;
}

export class ImportTicket implements IImportTicket {
    id?: number;
    dataBolla?: string | null;
    numeroBolla?: string | null;
    vettore?: string | null;
    codiceV?: string | null;
    pax?: string | null;
    serie?: string | null;
    tkt?: string | null;
    routing?: string | null;
    classe?: string | null;
    nazInt?: string | null;
    partenza?: string | null;
    c_Costo?: number | null;
    commessa?: string | null;
    tariffaApplicata?: number | null;
    tax?: number | null;
    totale?: number | null;
    tariffaOrdinaria?: number | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    note?: string | null;
    partenzaPratica?: string | null;
    ticketType?: ETicketsType;
    searchTerms?: string;

    constructor(data?: IImportTicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dataBolla = _data["dataBolla"] !== undefined ? _data["dataBolla"] : <any>null;
            this.numeroBolla = _data["numeroBolla"] !== undefined ? _data["numeroBolla"] : <any>null;
            this.vettore = _data["vettore"] !== undefined ? _data["vettore"] : <any>null;
            this.codiceV = _data["codiceV"] !== undefined ? _data["codiceV"] : <any>null;
            this.pax = _data["pax"] !== undefined ? _data["pax"] : <any>null;
            this.serie = _data["serie"] !== undefined ? _data["serie"] : <any>null;
            this.tkt = _data["tkt"] !== undefined ? _data["tkt"] : <any>null;
            this.routing = _data["routing"] !== undefined ? _data["routing"] : <any>null;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : <any>null;
            this.nazInt = _data["nazInt"] !== undefined ? _data["nazInt"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.c_Costo = _data["c_Costo"] !== undefined ? _data["c_Costo"] : <any>null;
            this.commessa = _data["commessa"] !== undefined ? _data["commessa"] : <any>null;
            this.tariffaApplicata = _data["tariffaApplicata"] !== undefined ? _data["tariffaApplicata"] : <any>null;
            this.tax = _data["tax"] !== undefined ? _data["tax"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.tariffaOrdinaria = _data["tariffaOrdinaria"] !== undefined ? _data["tariffaOrdinaria"] : <any>null;
            this.f_Pag = _data["f_Pag"] !== undefined ? _data["f_Pag"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.iva = _data["iva"] !== undefined ? _data["iva"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.partenzaPratica = _data["partenzaPratica"] !== undefined ? _data["partenzaPratica"] : <any>null;
            this.ticketType = _data["ticketType"] !== undefined ? _data["ticketType"] : <any>null;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : <any>null;
        }
    }

    static fromJS(data: any): ImportTicket {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dataBolla"] = this.dataBolla !== undefined ? this.dataBolla : <any>null;
        data["numeroBolla"] = this.numeroBolla !== undefined ? this.numeroBolla : <any>null;
        data["vettore"] = this.vettore !== undefined ? this.vettore : <any>null;
        data["codiceV"] = this.codiceV !== undefined ? this.codiceV : <any>null;
        data["pax"] = this.pax !== undefined ? this.pax : <any>null;
        data["serie"] = this.serie !== undefined ? this.serie : <any>null;
        data["tkt"] = this.tkt !== undefined ? this.tkt : <any>null;
        data["routing"] = this.routing !== undefined ? this.routing : <any>null;
        data["classe"] = this.classe !== undefined ? this.classe : <any>null;
        data["nazInt"] = this.nazInt !== undefined ? this.nazInt : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["c_Costo"] = this.c_Costo !== undefined ? this.c_Costo : <any>null;
        data["commessa"] = this.commessa !== undefined ? this.commessa : <any>null;
        data["tariffaApplicata"] = this.tariffaApplicata !== undefined ? this.tariffaApplicata : <any>null;
        data["tax"] = this.tax !== undefined ? this.tax : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["tariffaOrdinaria"] = this.tariffaOrdinaria !== undefined ? this.tariffaOrdinaria : <any>null;
        data["f_Pag"] = this.f_Pag !== undefined ? this.f_Pag : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["iva"] = this.iva !== undefined ? this.iva : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["partenzaPratica"] = this.partenzaPratica !== undefined ? this.partenzaPratica : <any>null;
        data["ticketType"] = this.ticketType !== undefined ? this.ticketType : <any>null;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : <any>null;
        return data;
    }
}

export interface IImportTicket {
    id?: number;
    dataBolla?: string | null;
    numeroBolla?: string | null;
    vettore?: string | null;
    codiceV?: string | null;
    pax?: string | null;
    serie?: string | null;
    tkt?: string | null;
    routing?: string | null;
    classe?: string | null;
    nazInt?: string | null;
    partenza?: string | null;
    c_Costo?: number | null;
    commessa?: string | null;
    tariffaApplicata?: number | null;
    tax?: number | null;
    totale?: number | null;
    tariffaOrdinaria?: number | null;
    f_Pag?: string | null;
    offertaID?: number | null;
    iva?: string | null;
    note?: string | null;
    partenzaPratica?: string | null;
    ticketType?: ETicketsType;
    searchTerms?: string;
}

export class ImportTicketsUploadResponse extends OkApiResponse implements IImportTicketsUploadResponse {

    constructor(data?: IImportTicketsUploadResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ImportTicketsUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTicketsUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IImportTicketsUploadResponse extends IOkApiResponse {
}

export class IncomingDeleteRequest extends ApiRequest implements IIncomingDeleteRequest {
    offertaID?: number;
    incassoID?: number;

    constructor(data?: IIncomingDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.incassoID = _data["incassoID"] !== undefined ? _data["incassoID"] : <any>null;
        }
    }

    static fromJS(data: any): IncomingDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["incassoID"] = this.incassoID !== undefined ? this.incassoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingDeleteRequest extends IApiRequest {
    offertaID?: number;
    incassoID?: number;
}

export class IncomingGetResponse extends OkApiResponse implements IIncomingGetResponse {
    /** Entità dell'incasso */
    incasso?: OffertaIncasso;

    constructor(data?: IIncomingGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incasso = _data["incasso"] ? OffertaIncasso.fromJS(_data["incasso"]) : <any>null;
        }
    }

    static fromJS(data: any): IncomingGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incasso"] = this.incasso ? this.incasso.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingGetResponse extends IOkApiResponse {
    /** Entità dell'incasso */
    incasso?: OffertaIncasso;
}

export class OffertaIncasso implements IOffertaIncasso {
    incassoID?: number;
    offertaID?: number;
    importo?: number | null;
    dataPagamento?: string | null;
    dataScadenza?: string | null;
    dataCessione?: string | null;
    tipoPagamentoIncasso?: ETipoPagamentoIncasso | null;
    tipoPagamento?: number | null;
    tipoOperazioneIncasso?: ETipoOperazioneIncasso | null;
    tipoOperazione?: number | null;
    offertaDatoID?: number | null;
    descrizione?: string | null;
    tipoTicketBiglietteria?: ETipoTicketBiglietteria | null;
    tipoBiglietteria?: number | null;
    tipoPrepagamentoIncasso?: ETipoAcconto | null;
    tipoPrepagamento?: number | null;
    banca?: number | null;
    causale?: string | null;
    contattoID?: number;
    operatoreID?: number | null;
    estrattoContoID?: number | null;
    dareAvere?: EDareAvere | null;
    flussoID?: number | null;

    constructor(data?: IOffertaIncasso) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incassoID = _data["incassoID"] !== undefined ? _data["incassoID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
            this.dataPagamento = _data["dataPagamento"] !== undefined ? _data["dataPagamento"] : <any>null;
            this.dataScadenza = _data["dataScadenza"] !== undefined ? _data["dataScadenza"] : <any>null;
            this.dataCessione = _data["dataCessione"] !== undefined ? _data["dataCessione"] : <any>null;
            this.tipoPagamentoIncasso = _data["tipoPagamentoIncasso"] !== undefined ? _data["tipoPagamentoIncasso"] : <any>null;
            this.tipoPagamento = _data["tipoPagamento"] !== undefined ? _data["tipoPagamento"] : <any>null;
            this.tipoOperazioneIncasso = _data["tipoOperazioneIncasso"] !== undefined ? _data["tipoOperazioneIncasso"] : <any>null;
            this.tipoOperazione = _data["tipoOperazione"] !== undefined ? _data["tipoOperazione"] : <any>null;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.tipoTicketBiglietteria = _data["tipoTicketBiglietteria"] !== undefined ? _data["tipoTicketBiglietteria"] : <any>null;
            this.tipoBiglietteria = _data["tipoBiglietteria"] !== undefined ? _data["tipoBiglietteria"] : <any>null;
            this.tipoPrepagamentoIncasso = _data["tipoPrepagamentoIncasso"] !== undefined ? _data["tipoPrepagamentoIncasso"] : <any>null;
            this.tipoPrepagamento = _data["tipoPrepagamento"] !== undefined ? _data["tipoPrepagamento"] : <any>null;
            this.banca = _data["banca"] !== undefined ? _data["banca"] : <any>null;
            this.causale = _data["causale"] !== undefined ? _data["causale"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : <any>null;
            this.estrattoContoID = _data["estrattoContoID"] !== undefined ? _data["estrattoContoID"] : <any>null;
            this.dareAvere = _data["dareAvere"] !== undefined ? _data["dareAvere"] : <any>null;
            this.flussoID = _data["flussoID"] !== undefined ? _data["flussoID"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaIncasso {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaIncasso();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incassoID"] = this.incassoID !== undefined ? this.incassoID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        data["dataPagamento"] = this.dataPagamento !== undefined ? this.dataPagamento : <any>null;
        data["dataScadenza"] = this.dataScadenza !== undefined ? this.dataScadenza : <any>null;
        data["dataCessione"] = this.dataCessione !== undefined ? this.dataCessione : <any>null;
        data["tipoPagamentoIncasso"] = this.tipoPagamentoIncasso !== undefined ? this.tipoPagamentoIncasso : <any>null;
        data["tipoPagamento"] = this.tipoPagamento !== undefined ? this.tipoPagamento : <any>null;
        data["tipoOperazioneIncasso"] = this.tipoOperazioneIncasso !== undefined ? this.tipoOperazioneIncasso : <any>null;
        data["tipoOperazione"] = this.tipoOperazione !== undefined ? this.tipoOperazione : <any>null;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["tipoTicketBiglietteria"] = this.tipoTicketBiglietteria !== undefined ? this.tipoTicketBiglietteria : <any>null;
        data["tipoBiglietteria"] = this.tipoBiglietteria !== undefined ? this.tipoBiglietteria : <any>null;
        data["tipoPrepagamentoIncasso"] = this.tipoPrepagamentoIncasso !== undefined ? this.tipoPrepagamentoIncasso : <any>null;
        data["tipoPrepagamento"] = this.tipoPrepagamento !== undefined ? this.tipoPrepagamento : <any>null;
        data["banca"] = this.banca !== undefined ? this.banca : <any>null;
        data["causale"] = this.causale !== undefined ? this.causale : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : <any>null;
        data["estrattoContoID"] = this.estrattoContoID !== undefined ? this.estrattoContoID : <any>null;
        data["dareAvere"] = this.dareAvere !== undefined ? this.dareAvere : <any>null;
        data["flussoID"] = this.flussoID !== undefined ? this.flussoID : <any>null;
        return data;
    }
}

export interface IOffertaIncasso {
    incassoID?: number;
    offertaID?: number;
    importo?: number | null;
    dataPagamento?: string | null;
    dataScadenza?: string | null;
    dataCessione?: string | null;
    tipoPagamentoIncasso?: ETipoPagamentoIncasso | null;
    tipoPagamento?: number | null;
    tipoOperazioneIncasso?: ETipoOperazioneIncasso | null;
    tipoOperazione?: number | null;
    offertaDatoID?: number | null;
    descrizione?: string | null;
    tipoTicketBiglietteria?: ETipoTicketBiglietteria | null;
    tipoBiglietteria?: number | null;
    tipoPrepagamentoIncasso?: ETipoAcconto | null;
    tipoPrepagamento?: number | null;
    banca?: number | null;
    causale?: string | null;
    contattoID?: number;
    operatoreID?: number | null;
    estrattoContoID?: number | null;
    dareAvere?: EDareAvere | null;
    flussoID?: number | null;
}

export enum ETipoPagamentoIncasso {
    Bonifico = "Bonifico",
    Factoring = "Factoring",
    TravelFactoring = "TravelFactoring",
    RID = "RID",
    POS = "POS",
    PAYPAL = "PAYPAL",
    Assegno = "Assegno",
    Contanti = "Contanti",
    Compensazione = "Compensazione",
}

export enum ETipoOperazioneIncasso {
    Acconto = "Acconto",
    Saldo = "Saldo",
    Cessione = "Cessione",
}

export enum ETipoTicketBiglietteria {
    Tutto = "Tutto",
    IP = "IP",
    TO = "TO",
}

export enum ETipoAcconto {
    Acconto = "Acconto",
    Hotel = "Hotel",
    Tour = "Tour",
    TariffaIP = "TariffaIP",
    TariffaTO = "TariffaTO",
    AltriVoli = "AltriVoli",
}

export enum EDareAvere {
    Avere = "Avere",
    Dare = "Dare",
    Previsione = "Previsione",
}

export class IncomingGetRequest extends ApiRequest implements IIncomingGetRequest {
    /** ID dell'incasso da caricare */
    incassoID?: number;

    constructor(data?: IIncomingGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incassoID = _data["incassoID"] !== undefined ? _data["incassoID"] : <any>null;
        }
    }

    static fromJS(data: any): IncomingGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incassoID"] = this.incassoID !== undefined ? this.incassoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingGetRequest extends IApiRequest {
    /** ID dell'incasso da caricare */
    incassoID?: number;
}

export class IncomingsBatchResponse extends OkApiResponse implements IIncomingsBatchResponse {
    count?: number;
    taskID?: number;

    constructor(data?: IIncomingsBatchResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.taskID = _data["taskID"] !== undefined ? _data["taskID"] : <any>null;
        }
    }

    static fromJS(data: any): IncomingsBatchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsBatchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["taskID"] = this.taskID !== undefined ? this.taskID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsBatchResponse extends IOkApiResponse {
    count?: number;
    taskID?: number;
}

export class IncomingsListRequest extends LocalizedRequest implements IIncomingsListRequest {
    /** Filtro su offerta singola. NOTA: Invalida tutti gli altri filtri */
    offertaID?: number | null;
    /** Modalità della gestione incassi */
    modalita?: EModalitaIncassi;
    /** Filtro Dare/Avere */
    modalitaDareAvere?: EModalitaDareAvere;
    /** Filtro sull'operatore della pratica */
    operatore?: EOperatore | null;
    /** ID del contatto agenzia associato alle righe */
    contattoAgenziaID?: number | null;
    /** Filtro sulla partita IVA del contatto agenzia */
    partitaIVA?: string | null;
    /** Filtro sulla data di partenza "dal" incluso */
    partenzaDal?: string | null;
    /** Filtro sulla data di partenza "al" incluso */
    partenzaAl?: string | null;
    /** Filtro sulla data di scadenza "dal" incluso */
    scadenzaDal?: string | null;
    /** Filtro sulla data di scadenza "al" incluso */
    scadenzaAl?: string | null;
    /** ID della modalità di pagamento (riferita all'offerta) */
    modalitaPagamentoID?: number | null;
    /** ID della banca (come stringa) */
    bancaID?: number | null;
    /** ID del promotore dell'agenzia */
    contattoPromotoreID?: number | null;

    constructor(data?: IIncomingsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.modalita = _data["modalita"] !== undefined ? _data["modalita"] : <any>null;
            this.modalitaDareAvere = _data["modalitaDareAvere"] !== undefined ? _data["modalitaDareAvere"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : <any>null;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : <any>null;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
            this.scadenzaDal = _data["scadenzaDal"] !== undefined ? _data["scadenzaDal"] : <any>null;
            this.scadenzaAl = _data["scadenzaAl"] !== undefined ? _data["scadenzaAl"] : <any>null;
            this.modalitaPagamentoID = _data["modalitaPagamentoID"] !== undefined ? _data["modalitaPagamentoID"] : <any>null;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : <any>null;
            this.contattoPromotoreID = _data["contattoPromotoreID"] !== undefined ? _data["contattoPromotoreID"] : <any>null;
        }
    }

    static fromJS(data: any): IncomingsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["modalita"] = this.modalita !== undefined ? this.modalita : <any>null;
        data["modalitaDareAvere"] = this.modalitaDareAvere !== undefined ? this.modalitaDareAvere : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : <any>null;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : <any>null;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        data["scadenzaDal"] = this.scadenzaDal !== undefined ? this.scadenzaDal : <any>null;
        data["scadenzaAl"] = this.scadenzaAl !== undefined ? this.scadenzaAl : <any>null;
        data["modalitaPagamentoID"] = this.modalitaPagamentoID !== undefined ? this.modalitaPagamentoID : <any>null;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : <any>null;
        data["contattoPromotoreID"] = this.contattoPromotoreID !== undefined ? this.contattoPromotoreID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsListRequest extends ILocalizedRequest {
    /** Filtro su offerta singola. NOTA: Invalida tutti gli altri filtri */
    offertaID?: number | null;
    /** Modalità della gestione incassi */
    modalita?: EModalitaIncassi;
    /** Filtro Dare/Avere */
    modalitaDareAvere?: EModalitaDareAvere;
    /** Filtro sull'operatore della pratica */
    operatore?: EOperatore | null;
    /** ID del contatto agenzia associato alle righe */
    contattoAgenziaID?: number | null;
    /** Filtro sulla partita IVA del contatto agenzia */
    partitaIVA?: string | null;
    /** Filtro sulla data di partenza "dal" incluso */
    partenzaDal?: string | null;
    /** Filtro sulla data di partenza "al" incluso */
    partenzaAl?: string | null;
    /** Filtro sulla data di scadenza "dal" incluso */
    scadenzaDal?: string | null;
    /** Filtro sulla data di scadenza "al" incluso */
    scadenzaAl?: string | null;
    /** ID della modalità di pagamento (riferita all'offerta) */
    modalitaPagamentoID?: number | null;
    /** ID della banca (come stringa) */
    bancaID?: number | null;
    /** ID del promotore dell'agenzia */
    contattoPromotoreID?: number | null;
}

export class IncomingsBatchRequest extends IncomingsListRequest implements IIncomingsBatchRequest {
    /** Se true non crea il task ma fa solo i conteggi */
    preview?: boolean;
    /** Se true esegue il ricalcolo accorpato */
    grouped?: boolean;

    constructor(data?: IIncomingsBatchRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.preview = _data["preview"] !== undefined ? _data["preview"] : <any>null;
            this.grouped = _data["grouped"] !== undefined ? _data["grouped"] : <any>null;
        }
    }

    static fromJS(data: any): IncomingsBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preview"] = this.preview !== undefined ? this.preview : <any>null;
        data["grouped"] = this.grouped !== undefined ? this.grouped : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsBatchRequest extends IIncomingsListRequest {
    /** Se true non crea il task ma fa solo i conteggi */
    preview?: boolean;
    /** Se true esegue il ricalcolo accorpato */
    grouped?: boolean;
}

export enum EModalitaIncassi {
    Scadenziario = "Scadenziario",
    DareAvere = "DareAvere",
}

export enum EModalitaDareAvere {
    Tutto = "Tutto",
    Dare = "Dare",
    Avere = "Avere",
}

export class IncomingsBatchQueryResponse extends OkApiResponse implements IIncomingsBatchQueryResponse {
    hasWork?: boolean;
    done?: number;
    total?: number;

    constructor(data?: IIncomingsBatchQueryResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasWork = _data["hasWork"] !== undefined ? _data["hasWork"] : <any>null;
            this.done = _data["done"] !== undefined ? _data["done"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): IncomingsBatchQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsBatchQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasWork"] = this.hasWork !== undefined ? this.hasWork : <any>null;
        data["done"] = this.done !== undefined ? this.done : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsBatchQueryResponse extends IOkApiResponse {
    hasWork?: boolean;
    done?: number;
    total?: number;
}

export class IncomingsChangeRequest extends ApiRequest implements IIncomingsChangeRequest {
    incassiIDs?: number[];
    pagamentoIncassoID?: number | null;
    bancaID?: number | null;
    data?: string | null;

    constructor(data?: IIncomingsChangeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["incassiIDs"])) {
                this.incassiIDs = [] as any;
                for (let item of _data["incassiIDs"])
                    this.incassiIDs!.push(item);
            }
            else {
                this.incassiIDs = <any>null;
            }
            this.pagamentoIncassoID = _data["pagamentoIncassoID"] !== undefined ? _data["pagamentoIncassoID"] : <any>null;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static fromJS(data: any): IncomingsChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incassiIDs)) {
            data["incassiIDs"] = [];
            for (let item of this.incassiIDs)
                data["incassiIDs"].push(item);
        }
        data["pagamentoIncassoID"] = this.pagamentoIncassoID !== undefined ? this.pagamentoIncassoID : <any>null;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsChangeRequest extends IApiRequest {
    incassiIDs?: number[];
    pagamentoIncassoID?: number | null;
    bancaID?: number | null;
    data?: string | null;
}

export class IncomingsCreateRequest extends ApiRequest implements IIncomingsCreateRequest {
    offertaID?: number;
    grouped?: boolean;

    constructor(data?: IIncomingsCreateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.grouped = _data["grouped"] !== undefined ? _data["grouped"] : <any>null;
        }
    }

    static fromJS(data: any): IncomingsCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["grouped"] = this.grouped !== undefined ? this.grouped : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsCreateRequest extends IApiRequest {
    offertaID?: number;
    grouped?: boolean;
}

export class IncomingsDeleteRequest extends ApiRequest implements IIncomingsDeleteRequest {
    incassiIDs?: number[];

    constructor(data?: IIncomingsDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["incassiIDs"])) {
                this.incassiIDs = [] as any;
                for (let item of _data["incassiIDs"])
                    this.incassiIDs!.push(item);
            }
            else {
                this.incassiIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): IncomingsDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incassiIDs)) {
            data["incassiIDs"] = [];
            for (let item of this.incassiIDs)
                data["incassiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsDeleteRequest extends IApiRequest {
    incassiIDs?: number[];
}

export class IncomingsListResponse extends OkApiResponse implements IIncomingsListResponse {
    /** Lista delle righe */
    rows?: IncomingListRow[];
    /** Numero di righe massimo estratto */
    maxRows?: number;
    /** Numero di righe totali che corrispondono al criterio */
    totalRows?: number;
    /** Modalità della lista (se chiedo un'offerta specifica potrebbe essere diversa da quella del filtro) */
    modalita?: EModalitaIncassi;
    /** Toale dare, incluse non visualizzate */
    totaleDare?: number;
    /** Totale avere, incluse non visualizzate */
    totaleAvere?: number;
    /** Totale avere incluse le non visualizzate, con data inferiore ad oggi ed importo non coperto dal totale dare */
    totaleAvereScaduto?: number;
    /** Totale sbilancio, incluse non visualizzate */
    totaleSbilancio?: number;
    /** Se true ci sono altri record che rispettano il criterio ma non sono visualizzati */
    hasMore?: boolean;

    constructor(data?: IIncomingsListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(IncomingListRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.maxRows = _data["maxRows"] !== undefined ? _data["maxRows"] : <any>null;
            this.totalRows = _data["totalRows"] !== undefined ? _data["totalRows"] : <any>null;
            this.modalita = _data["modalita"] !== undefined ? _data["modalita"] : <any>null;
            this.totaleDare = _data["totaleDare"] !== undefined ? _data["totaleDare"] : <any>null;
            this.totaleAvere = _data["totaleAvere"] !== undefined ? _data["totaleAvere"] : <any>null;
            this.totaleAvereScaduto = _data["totaleAvereScaduto"] !== undefined ? _data["totaleAvereScaduto"] : <any>null;
            this.totaleSbilancio = _data["totaleSbilancio"] !== undefined ? _data["totaleSbilancio"] : <any>null;
            this.hasMore = _data["hasMore"] !== undefined ? _data["hasMore"] : <any>null;
        }
    }

    static fromJS(data: any): IncomingsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["maxRows"] = this.maxRows !== undefined ? this.maxRows : <any>null;
        data["totalRows"] = this.totalRows !== undefined ? this.totalRows : <any>null;
        data["modalita"] = this.modalita !== undefined ? this.modalita : <any>null;
        data["totaleDare"] = this.totaleDare !== undefined ? this.totaleDare : <any>null;
        data["totaleAvere"] = this.totaleAvere !== undefined ? this.totaleAvere : <any>null;
        data["totaleAvereScaduto"] = this.totaleAvereScaduto !== undefined ? this.totaleAvereScaduto : <any>null;
        data["totaleSbilancio"] = this.totaleSbilancio !== undefined ? this.totaleSbilancio : <any>null;
        data["hasMore"] = this.hasMore !== undefined ? this.hasMore : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingsListResponse extends IOkApiResponse {
    /** Lista delle righe */
    rows?: IncomingListRow[];
    /** Numero di righe massimo estratto */
    maxRows?: number;
    /** Numero di righe totali che corrispondono al criterio */
    totalRows?: number;
    /** Modalità della lista (se chiedo un'offerta specifica potrebbe essere diversa da quella del filtro) */
    modalita?: EModalitaIncassi;
    /** Toale dare, incluse non visualizzate */
    totaleDare?: number;
    /** Totale avere, incluse non visualizzate */
    totaleAvere?: number;
    /** Totale avere incluse le non visualizzate, con data inferiore ad oggi ed importo non coperto dal totale dare */
    totaleAvereScaduto?: number;
    /** Totale sbilancio, incluse non visualizzate */
    totaleSbilancio?: number;
    /** Se true ci sono altri record che rispettano il criterio ma non sono visualizzati */
    hasMore?: boolean;
}

export class IncomingListRow implements IIncomingListRow {
    id?: number;
    offertaID?: number;
    descrizioneOfferta?: string | null;
    partenza?: string;
    offertaDatoID?: number | null;
    data?: string;
    importo?: number;
    descrizioneIncasso?: string | null;
    dareAvere?: EDareAvere | null;
    contattoID?: number;
    nomeContatto?: string | null;
    contattoNetworkID?: number | null;
    nomeContattoNetwork?: string | null;
    dataIncasso?: string | null;
    dataCessione?: string | null;
    pagamentoOffertaID?: number | null;
    nomePagamentoOfferta?: string | null;
    bancaID?: number | null;
    nomeBanca?: string | null;
    tipoOperazione?: ETipoOperazioneIncasso | null;
    tipoPagamento?: ETipoPagamentoIncasso | null;
    tipoTicketBiglietteria?: ETipoTicketBiglietteria | null;
    tipoPrepagamento?: ETipoAcconto | null;
    contattoPromotoreID?: number | null;
    nomeContattoPromotore?: string | null;
    incasso?: OffertaIncasso | null;

    constructor(data?: IIncomingListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.descrizioneOfferta = _data["descrizioneOfferta"] !== undefined ? _data["descrizioneOfferta"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
            this.descrizioneIncasso = _data["descrizioneIncasso"] !== undefined ? _data["descrizioneIncasso"] : <any>null;
            this.dareAvere = _data["dareAvere"] !== undefined ? _data["dareAvere"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.nomeContatto = _data["nomeContatto"] !== undefined ? _data["nomeContatto"] : <any>null;
            this.contattoNetworkID = _data["contattoNetworkID"] !== undefined ? _data["contattoNetworkID"] : <any>null;
            this.nomeContattoNetwork = _data["nomeContattoNetwork"] !== undefined ? _data["nomeContattoNetwork"] : <any>null;
            this.dataIncasso = _data["dataIncasso"] !== undefined ? _data["dataIncasso"] : <any>null;
            this.dataCessione = _data["dataCessione"] !== undefined ? _data["dataCessione"] : <any>null;
            this.pagamentoOffertaID = _data["pagamentoOffertaID"] !== undefined ? _data["pagamentoOffertaID"] : <any>null;
            this.nomePagamentoOfferta = _data["nomePagamentoOfferta"] !== undefined ? _data["nomePagamentoOfferta"] : <any>null;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : <any>null;
            this.nomeBanca = _data["nomeBanca"] !== undefined ? _data["nomeBanca"] : <any>null;
            this.tipoOperazione = _data["tipoOperazione"] !== undefined ? _data["tipoOperazione"] : <any>null;
            this.tipoPagamento = _data["tipoPagamento"] !== undefined ? _data["tipoPagamento"] : <any>null;
            this.tipoTicketBiglietteria = _data["tipoTicketBiglietteria"] !== undefined ? _data["tipoTicketBiglietteria"] : <any>null;
            this.tipoPrepagamento = _data["tipoPrepagamento"] !== undefined ? _data["tipoPrepagamento"] : <any>null;
            this.contattoPromotoreID = _data["contattoPromotoreID"] !== undefined ? _data["contattoPromotoreID"] : <any>null;
            this.nomeContattoPromotore = _data["nomeContattoPromotore"] !== undefined ? _data["nomeContattoPromotore"] : <any>null;
            this.incasso = _data["incasso"] ? OffertaIncasso.fromJS(_data["incasso"]) : <any>null;
        }
    }

    static fromJS(data: any): IncomingListRow {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["descrizioneOfferta"] = this.descrizioneOfferta !== undefined ? this.descrizioneOfferta : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        data["descrizioneIncasso"] = this.descrizioneIncasso !== undefined ? this.descrizioneIncasso : <any>null;
        data["dareAvere"] = this.dareAvere !== undefined ? this.dareAvere : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["nomeContatto"] = this.nomeContatto !== undefined ? this.nomeContatto : <any>null;
        data["contattoNetworkID"] = this.contattoNetworkID !== undefined ? this.contattoNetworkID : <any>null;
        data["nomeContattoNetwork"] = this.nomeContattoNetwork !== undefined ? this.nomeContattoNetwork : <any>null;
        data["dataIncasso"] = this.dataIncasso !== undefined ? this.dataIncasso : <any>null;
        data["dataCessione"] = this.dataCessione !== undefined ? this.dataCessione : <any>null;
        data["pagamentoOffertaID"] = this.pagamentoOffertaID !== undefined ? this.pagamentoOffertaID : <any>null;
        data["nomePagamentoOfferta"] = this.nomePagamentoOfferta !== undefined ? this.nomePagamentoOfferta : <any>null;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : <any>null;
        data["nomeBanca"] = this.nomeBanca !== undefined ? this.nomeBanca : <any>null;
        data["tipoOperazione"] = this.tipoOperazione !== undefined ? this.tipoOperazione : <any>null;
        data["tipoPagamento"] = this.tipoPagamento !== undefined ? this.tipoPagamento : <any>null;
        data["tipoTicketBiglietteria"] = this.tipoTicketBiglietteria !== undefined ? this.tipoTicketBiglietteria : <any>null;
        data["tipoPrepagamento"] = this.tipoPrepagamento !== undefined ? this.tipoPrepagamento : <any>null;
        data["contattoPromotoreID"] = this.contattoPromotoreID !== undefined ? this.contattoPromotoreID : <any>null;
        data["nomeContattoPromotore"] = this.nomeContattoPromotore !== undefined ? this.nomeContattoPromotore : <any>null;
        data["incasso"] = this.incasso ? this.incasso.toJSON() : <any>null;
        return data;
    }
}

export interface IIncomingListRow {
    id?: number;
    offertaID?: number;
    descrizioneOfferta?: string | null;
    partenza?: string;
    offertaDatoID?: number | null;
    data?: string;
    importo?: number;
    descrizioneIncasso?: string | null;
    dareAvere?: EDareAvere | null;
    contattoID?: number;
    nomeContatto?: string | null;
    contattoNetworkID?: number | null;
    nomeContattoNetwork?: string | null;
    dataIncasso?: string | null;
    dataCessione?: string | null;
    pagamentoOffertaID?: number | null;
    nomePagamentoOfferta?: string | null;
    bancaID?: number | null;
    nomeBanca?: string | null;
    tipoOperazione?: ETipoOperazioneIncasso | null;
    tipoPagamento?: ETipoPagamentoIncasso | null;
    tipoTicketBiglietteria?: ETipoTicketBiglietteria | null;
    tipoPrepagamento?: ETipoAcconto | null;
    contattoPromotoreID?: number | null;
    nomeContattoPromotore?: string | null;
    incasso?: OffertaIncasso | null;
}

export class IncomingUpsertResponse extends OkApiResponse implements IIncomingUpsertResponse {
    incasso?: OffertaIncasso;

    constructor(data?: IIncomingUpsertResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incasso = _data["incasso"] ? OffertaIncasso.fromJS(_data["incasso"]) : <any>null;
        }
    }

    static fromJS(data: any): IncomingUpsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingUpsertResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incasso"] = this.incasso ? this.incasso.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingUpsertResponse extends IOkApiResponse {
    incasso?: OffertaIncasso;
}

export class IncomingUpsertRequest extends ApiRequest implements IIncomingUpsertRequest {
    incasso?: OffertaIncasso;

    constructor(data?: IIncomingUpsertRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incasso = _data["incasso"] ? OffertaIncasso.fromJS(_data["incasso"]) : <any>null;
        }
    }

    static fromJS(data: any): IncomingUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incasso"] = this.incasso ? this.incasso.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIncomingUpsertRequest extends IApiRequest {
    incasso?: OffertaIncasso;
}

export class NrTableResponseOfBillableTrip extends OkApiResponse implements INrTableResponseOfBillableTrip {
    /** Array delle righe della pagina richiesta */
    rows?: BillableTrip[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfBillableTrip) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(BillableTrip.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfBillableTrip {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfBillableTrip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfBillableTrip extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: BillableTrip[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class BillableTripsListResponse extends NrTableResponseOfBillableTrip implements IBillableTripsListResponse {

    constructor(data?: IBillableTripsListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): BillableTripsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BillableTripsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBillableTripsListResponse extends INrTableResponseOfBillableTrip {
}

/** Classe che rappresenta una singola riga di viaggio fatturabile */
export class BillableTrip implements IBillableTrip {
    /** ID dell'offerta */
    offertaID?: number;
    /** ID dell'offerta / agenzia */
    offertaAgenziaID?: number;
    /** Nome del network, se l'agenzia appartiene ad un network */
    network?: string | null;
    /** ID del contatto agenzia */
    contattoAgenziaID?: number | null;
    /** Nome dell'agenzia */
    agenzia?: string | null;
    /** Data di partenza dell'offerta */
    partenza?: string;
    /** Nome del viaggio */
    descrizione?: string | null;
    /** Totale netto dell'offerta */
    totale?: number;
    /** Totale commissioni sull'offerta */
    totaleCommissione?: number;
    /** Viaggio al netto */
    alNetto?: boolean;
    /** Data di cancellazione */
    dataCancellazione?: string | null;
    /** True se la fattura è stata emessa */
    fatturaEmessa?: boolean;
    /** True se l'autofattura è stata emessa */
    autofatturaEmessa?: boolean;

    constructor(data?: IBillableTrip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.offertaAgenziaID = _data["offertaAgenziaID"] !== undefined ? _data["offertaAgenziaID"] : <any>null;
            this.network = _data["network"] !== undefined ? _data["network"] : <any>null;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : <any>null;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.totaleCommissione = _data["totaleCommissione"] !== undefined ? _data["totaleCommissione"] : <any>null;
            this.alNetto = _data["alNetto"] !== undefined ? _data["alNetto"] : <any>null;
            this.dataCancellazione = _data["dataCancellazione"] !== undefined ? _data["dataCancellazione"] : <any>null;
            this.fatturaEmessa = _data["fatturaEmessa"] !== undefined ? _data["fatturaEmessa"] : <any>null;
            this.autofatturaEmessa = _data["autofatturaEmessa"] !== undefined ? _data["autofatturaEmessa"] : <any>null;
        }
    }

    static fromJS(data: any): BillableTrip {
        data = typeof data === 'object' ? data : {};
        let result = new BillableTrip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["offertaAgenziaID"] = this.offertaAgenziaID !== undefined ? this.offertaAgenziaID : <any>null;
        data["network"] = this.network !== undefined ? this.network : <any>null;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : <any>null;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["totaleCommissione"] = this.totaleCommissione !== undefined ? this.totaleCommissione : <any>null;
        data["alNetto"] = this.alNetto !== undefined ? this.alNetto : <any>null;
        data["dataCancellazione"] = this.dataCancellazione !== undefined ? this.dataCancellazione : <any>null;
        data["fatturaEmessa"] = this.fatturaEmessa !== undefined ? this.fatturaEmessa : <any>null;
        data["autofatturaEmessa"] = this.autofatturaEmessa !== undefined ? this.autofatturaEmessa : <any>null;
        return data;
    }
}

/** Classe che rappresenta una singola riga di viaggio fatturabile */
export interface IBillableTrip {
    /** ID dell'offerta */
    offertaID?: number;
    /** ID dell'offerta / agenzia */
    offertaAgenziaID?: number;
    /** Nome del network, se l'agenzia appartiene ad un network */
    network?: string | null;
    /** ID del contatto agenzia */
    contattoAgenziaID?: number | null;
    /** Nome dell'agenzia */
    agenzia?: string | null;
    /** Data di partenza dell'offerta */
    partenza?: string;
    /** Nome del viaggio */
    descrizione?: string | null;
    /** Totale netto dell'offerta */
    totale?: number;
    /** Totale commissioni sull'offerta */
    totaleCommissione?: number;
    /** Viaggio al netto */
    alNetto?: boolean;
    /** Data di cancellazione */
    dataCancellazione?: string | null;
    /** True se la fattura è stata emessa */
    fatturaEmessa?: boolean;
    /** True se l'autofattura è stata emessa */
    autofatturaEmessa?: boolean;
}

export class BillableTripsListRequest extends NrTableRequest implements IBillableTripsListRequest {
    /** Filtro per operatore obbligatorio */
    operatore?: EOperatore;
    /** ID di una singola offerta, prevale sugli altri filtri */
    offertaID?: number | null;
    /** ID del contatto agenzia associato alle offerte */
    contattoAgenziaID?: number | null;
    /** Partita IVA dell'agenzia */
    partitaIVA?: string | null;
    /** Data di partenza, DAL */
    partenzaDal?: string | null;
    /** Data di partenza, AL */
    partenzaAl?: string | null;
    /** ID della modalità di pagamento (dallo status pratiche) */
    tipoPagamentoID?: number | null;
    /** Solo offerte al netto */
    soloNetto?: boolean;
    /** Solo offerte cancellate */
    soloCancellate?: boolean;

    constructor(data?: IBillableTripsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : <any>null;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : <any>null;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
            this.tipoPagamentoID = _data["tipoPagamentoID"] !== undefined ? _data["tipoPagamentoID"] : <any>null;
            this.soloNetto = _data["soloNetto"] !== undefined ? _data["soloNetto"] : <any>null;
            this.soloCancellate = _data["soloCancellate"] !== undefined ? _data["soloCancellate"] : <any>null;
        }
    }

    static fromJS(data: any): BillableTripsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BillableTripsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : <any>null;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : <any>null;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        data["tipoPagamentoID"] = this.tipoPagamentoID !== undefined ? this.tipoPagamentoID : <any>null;
        data["soloNetto"] = this.soloNetto !== undefined ? this.soloNetto : <any>null;
        data["soloCancellate"] = this.soloCancellate !== undefined ? this.soloCancellate : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBillableTripsListRequest extends INrTableRequest {
    /** Filtro per operatore obbligatorio */
    operatore?: EOperatore;
    /** ID di una singola offerta, prevale sugli altri filtri */
    offertaID?: number | null;
    /** ID del contatto agenzia associato alle offerte */
    contattoAgenziaID?: number | null;
    /** Partita IVA dell'agenzia */
    partitaIVA?: string | null;
    /** Data di partenza, DAL */
    partenzaDal?: string | null;
    /** Data di partenza, AL */
    partenzaAl?: string | null;
    /** ID della modalità di pagamento (dallo status pratiche) */
    tipoPagamentoID?: number | null;
    /** Solo offerte al netto */
    soloNetto?: boolean;
    /** Solo offerte cancellate */
    soloCancellate?: boolean;
}

export class GetNextDocumentNumberResponse extends OkApiResponse implements IGetNextDocumentNumberResponse {
    /** Next "free" document number */
    nextDocumentNumber?: number;
    /** Document date. Today if not supplied by DocDate */
    docDate?: string;

    constructor(data?: IGetNextDocumentNumberResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nextDocumentNumber = _data["nextDocumentNumber"] !== undefined ? _data["nextDocumentNumber"] : <any>null;
            this.docDate = _data["docDate"] !== undefined ? _data["docDate"] : <any>null;
        }
    }

    static fromJS(data: any): GetNextDocumentNumberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNextDocumentNumberResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextDocumentNumber"] = this.nextDocumentNumber !== undefined ? this.nextDocumentNumber : <any>null;
        data["docDate"] = this.docDate !== undefined ? this.docDate : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetNextDocumentNumberResponse extends IOkApiResponse {
    /** Next "free" document number */
    nextDocumentNumber?: number;
    /** Document date. Today if not supplied by DocDate */
    docDate?: string;
}

export class GetNextDocumentNumberRequest extends ApiRequest implements IGetNextDocumentNumberRequest {
    /** Document type to retrive. Document numbers are "per type" */
    documentType?: ETipoDocumento;
    /** Tour operator */
    operator?: EOperatore;
    /** Document date */
    docDate?: string | null;

    constructor(data?: IGetNextDocumentNumberRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
            this.docDate = _data["docDate"] !== undefined ? _data["docDate"] : <any>null;
        }
    }

    static fromJS(data: any): GetNextDocumentNumberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetNextDocumentNumberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        data["docDate"] = this.docDate !== undefined ? this.docDate : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetNextDocumentNumberRequest extends IApiRequest {
    /** Document type to retrive. Document numbers are "per type" */
    documentType?: ETipoDocumento;
    /** Tour operator */
    operator?: EOperatore;
    /** Document date */
    docDate?: string | null;
}

export enum ETipoDocumento {
    Generico = "Generico",
    NotaCredito = "NotaCredito",
    Fattura = "Fattura",
    EstrattoConto = "EstrattoConto",
    Autofattura = "Autofattura",
    RapportoContabile = "RapportoContabile",
    Offerta = "Offerta",
    Conferma = "Conferma",
    Prenotazione = "Prenotazione",
    Voucher = "Voucher",
    ProgrammaViaggio = "ProgrammaViaggio",
    PreventivoCliente = "PreventivoCliente",
    Miniguida = "Miniguida",
    Corrispondenza = "Corrispondenza",
    EstrattoContoConfermaServizi = "EstrattoContoConfermaServizi",
    NotaCreditoOrdinaria = "NotaCreditoOrdinaria",
    FatturaOrdinaria = "FatturaOrdinaria",
    RiepilogoPrenotazioni = "RiepilogoPrenotazioni",
    RiepilogoPrenotazioniAccordo = "RiepilogoPrenotazioniAccordo",
    RiepilogoPrenotazioniNU = "RiepilogoPrenotazioniNU",
    StornoAutofattura = "StornoAutofattura",
    FatturaAcquisto = "FatturaAcquisto",
    NotaCreditoAcquisto = "NotaCreditoAcquisto",
    FatturaAcquistoOrdinaria = "FatturaAcquistoOrdinaria",
    NotaCreditoAcquistoOrdinaria = "NotaCreditoAcquistoOrdinaria",
    RispostaPrenotazione = "RispostaPrenotazione",
    PrenotazioneH2H = "PrenotazioneH2H",
    DocumentiDiViaggio = "DocumentiDiViaggio",
    MultiDocumento = "MultiDocumento",
    MailPrenotazioneClienteFinale = "MailPrenotazioneClienteFinale",
    Biglietteria = "Biglietteria",
    Assicurazioni = "Assicurazioni",
    MailConfermaClienteFinale = "MailConfermaClienteFinale",
    RispostaPerAdv = "RispostaPerAdv",
    DocumentoContabile = "DocumentoContabile",
    PreventivoClienteTraducibile = "PreventivoClienteTraducibile",
    ProgrammaViaggioTraducibile = "ProgrammaViaggioTraducibile",
    DocumentoCondiviso = "DocumentoCondiviso",
    AutofatturaBis = "AutofatturaBis",
    NotaDiDebito = "NotaDiDebito",
    NotaDiDebitoOrdinaria = "NotaDiDebitoOrdinaria",
    VoucherTuristico = "VoucherTuristico",
    PreventivoClientePlus = "PreventivoClientePlus",
    ConfermaCliente = "ConfermaCliente",
    ConfermaProvvisoriaAgenzia = "ConfermaProvvisoriaAgenzia",
    EstrattoContoPenale = "EstrattoContoPenale",
    ProgrammaViaggio2022 = "ProgrammaViaggio2022",
    ProgrammaViaggio2023 = "ProgrammaViaggio2023",
    Kanban = "Kanban",
}

export class InvoiceDeleteRequest extends ApiRequest implements IInvoiceDeleteRequest {
    /** ID del documento da eliminare */
    documentoID?: number;

    constructor(data?: IInvoiceDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceDeleteRequest extends IApiRequest {
    /** ID del documento da eliminare */
    documentoID?: number;
}

export class InvoiceGetResponse extends OkApiResponse implements IInvoiceGetResponse {
    /** Dati, testata e righe del documento */
    listRow?: InvoicesListRow | null;

    constructor(data?: IInvoiceGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.listRow = _data["listRow"] ? InvoicesListRow.fromJS(_data["listRow"]) : <any>null;
        }
    }

    static fromJS(data: any): InvoiceGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listRow"] = this.listRow ? this.listRow.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceGetResponse extends IOkApiResponse {
    /** Dati, testata e righe del documento */
    listRow?: InvoicesListRow | null;
}

export class InvoicesListRowBase implements IInvoicesListRowBase {
    /** ID del documento */
    id?: number;
    /** Tipo di documento */
    tipoDocumento?: ETipoDocumento;
    /** Numero del documento */
    numeroDocumento?: number;
    /** Data del documento */
    dataDocumento?: string;
    /** ID del contatto associato */
    contattoID?: number | null;
    /** Ragione sociale del contatto associato */
    contatto?: string | null;
    /** Descrizione testuale del cliente */
    cliente?: string | null;
    /** Data partenza viaggio */
    partenza?: string | null;
    /** Importo del documento */
    importo?: number;
    /** Iva totale del documento */
    totaleIva?: number;

    constructor(data?: IInvoicesListRowBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : <any>null;
            this.numeroDocumento = _data["numeroDocumento"] !== undefined ? _data["numeroDocumento"] : <any>null;
            this.dataDocumento = _data["dataDocumento"] !== undefined ? _data["dataDocumento"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : <any>null;
            this.cliente = _data["cliente"] !== undefined ? _data["cliente"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
            this.totaleIva = _data["totaleIva"] !== undefined ? _data["totaleIva"] : <any>null;
        }
    }

    static fromJS(data: any): InvoicesListRowBase {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesListRowBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : <any>null;
        data["numeroDocumento"] = this.numeroDocumento !== undefined ? this.numeroDocumento : <any>null;
        data["dataDocumento"] = this.dataDocumento !== undefined ? this.dataDocumento : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["contatto"] = this.contatto !== undefined ? this.contatto : <any>null;
        data["cliente"] = this.cliente !== undefined ? this.cliente : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        data["totaleIva"] = this.totaleIva !== undefined ? this.totaleIva : <any>null;
        return data;
    }
}

export interface IInvoicesListRowBase {
    /** ID del documento */
    id?: number;
    /** Tipo di documento */
    tipoDocumento?: ETipoDocumento;
    /** Numero del documento */
    numeroDocumento?: number;
    /** Data del documento */
    dataDocumento?: string;
    /** ID del contatto associato */
    contattoID?: number | null;
    /** Ragione sociale del contatto associato */
    contatto?: string | null;
    /** Descrizione testuale del cliente */
    cliente?: string | null;
    /** Data partenza viaggio */
    partenza?: string | null;
    /** Importo del documento */
    importo?: number;
    /** Iva totale del documento */
    totaleIva?: number;
}

export class InvoicesListRow extends InvoicesListRowBase implements IInvoicesListRow {
    /** Entità del documento */
    documento?: DocumentoContabileTestata;
    /** Righe della fattura */
    righe?: InvoicesListRowDetail[];

    constructor(data?: IInvoicesListRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documento = _data["documento"] ? DocumentoContabileTestata.fromJS(_data["documento"]) : <any>null;
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(InvoicesListRowDetail.fromJS(item));
            }
            else {
                this.righe = <any>null;
            }
        }
    }

    static fromJS(data: any): InvoicesListRow {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documento"] = this.documento ? this.documento.toJSON() : <any>null;
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicesListRow extends IInvoicesListRowBase {
    /** Entità del documento */
    documento?: DocumentoContabileTestata;
    /** Righe della fattura */
    righe?: InvoicesListRowDetail[];
}

export class DocumentoContabileTestata implements IDocumentoContabileTestata {
    documentoID?: number;
    tipoDocumentoID?: number;
    tipoDocumento?: ETipoDocumento;
    alfanum?: string | null;
    num_doc?: number | null;
    dataDocumento?: string;
    cliente?: string | null;
    indirizzo?: string | null;
    piva?: string | null;
    descrizione?: string | null;
    dataPartenza?: string | null;
    pagamentoID?: number | null;
    totale_doc?: number | null;
    stampato?: boolean;
    contabilizzato?: boolean;
    note?: string | null;
    nota_credito?: boolean;
    riferimento_id?: number | null;
    contattoID?: number | null;
    cliente_age?: boolean;
    causale?: string | null;
    codfisc?: string | null;
    resultSentMail?: string | null;
    operatore?: EOperatore;
    idsede?: number | null;
    statoSDI?: EStatoSDI | null;
    documentoParentID?: number | null;
    ragioneSociale?: string | null;
    nome?: string | null;
    cognome?: string | null;
    indirizzoFatt?: string | null;
    numeroCivico?: string | null;
    cap?: string | null;
    comune?: string | null;
    provincia?: string | null;
    nazione?: string | null;

    constructor(data?: IDocumentoContabileTestata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
            this.tipoDocumentoID = _data["tipoDocumentoID"] !== undefined ? _data["tipoDocumentoID"] : <any>null;
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : <any>null;
            this.alfanum = _data["alfanum"] !== undefined ? _data["alfanum"] : <any>null;
            this.num_doc = _data["num_doc"] !== undefined ? _data["num_doc"] : <any>null;
            this.dataDocumento = _data["dataDocumento"] !== undefined ? _data["dataDocumento"] : <any>null;
            this.cliente = _data["cliente"] !== undefined ? _data["cliente"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.piva = _data["piva"] !== undefined ? _data["piva"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.dataPartenza = _data["dataPartenza"] !== undefined ? _data["dataPartenza"] : <any>null;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : <any>null;
            this.totale_doc = _data["totale_doc"] !== undefined ? _data["totale_doc"] : <any>null;
            this.stampato = _data["stampato"] !== undefined ? _data["stampato"] : <any>null;
            this.contabilizzato = _data["contabilizzato"] !== undefined ? _data["contabilizzato"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.nota_credito = _data["nota_credito"] !== undefined ? _data["nota_credito"] : <any>null;
            this.riferimento_id = _data["riferimento_id"] !== undefined ? _data["riferimento_id"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.cliente_age = _data["cliente_age"] !== undefined ? _data["cliente_age"] : <any>null;
            this.causale = _data["causale"] !== undefined ? _data["causale"] : <any>null;
            this.codfisc = _data["codfisc"] !== undefined ? _data["codfisc"] : <any>null;
            this.resultSentMail = _data["resultSentMail"] !== undefined ? _data["resultSentMail"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.idsede = _data["idsede"] !== undefined ? _data["idsede"] : <any>null;
            this.statoSDI = _data["statoSDI"] !== undefined ? _data["statoSDI"] : <any>null;
            this.documentoParentID = _data["documentoParentID"] !== undefined ? _data["documentoParentID"] : <any>null;
            this.ragioneSociale = _data["ragioneSociale"] !== undefined ? _data["ragioneSociale"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.indirizzoFatt = _data["indirizzoFatt"] !== undefined ? _data["indirizzoFatt"] : <any>null;
            this.numeroCivico = _data["numeroCivico"] !== undefined ? _data["numeroCivico"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.comune = _data["comune"] !== undefined ? _data["comune"] : <any>null;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : <any>null;
            this.nazione = _data["nazione"] !== undefined ? _data["nazione"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentoContabileTestata {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoContabileTestata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        data["tipoDocumentoID"] = this.tipoDocumentoID !== undefined ? this.tipoDocumentoID : <any>null;
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : <any>null;
        data["alfanum"] = this.alfanum !== undefined ? this.alfanum : <any>null;
        data["num_doc"] = this.num_doc !== undefined ? this.num_doc : <any>null;
        data["dataDocumento"] = this.dataDocumento !== undefined ? this.dataDocumento : <any>null;
        data["cliente"] = this.cliente !== undefined ? this.cliente : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["piva"] = this.piva !== undefined ? this.piva : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["dataPartenza"] = this.dataPartenza !== undefined ? this.dataPartenza : <any>null;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : <any>null;
        data["totale_doc"] = this.totale_doc !== undefined ? this.totale_doc : <any>null;
        data["stampato"] = this.stampato !== undefined ? this.stampato : <any>null;
        data["contabilizzato"] = this.contabilizzato !== undefined ? this.contabilizzato : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["nota_credito"] = this.nota_credito !== undefined ? this.nota_credito : <any>null;
        data["riferimento_id"] = this.riferimento_id !== undefined ? this.riferimento_id : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["cliente_age"] = this.cliente_age !== undefined ? this.cliente_age : <any>null;
        data["causale"] = this.causale !== undefined ? this.causale : <any>null;
        data["codfisc"] = this.codfisc !== undefined ? this.codfisc : <any>null;
        data["resultSentMail"] = this.resultSentMail !== undefined ? this.resultSentMail : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["idsede"] = this.idsede !== undefined ? this.idsede : <any>null;
        data["statoSDI"] = this.statoSDI !== undefined ? this.statoSDI : <any>null;
        data["documentoParentID"] = this.documentoParentID !== undefined ? this.documentoParentID : <any>null;
        data["ragioneSociale"] = this.ragioneSociale !== undefined ? this.ragioneSociale : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["indirizzoFatt"] = this.indirizzoFatt !== undefined ? this.indirizzoFatt : <any>null;
        data["numeroCivico"] = this.numeroCivico !== undefined ? this.numeroCivico : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["comune"] = this.comune !== undefined ? this.comune : <any>null;
        data["provincia"] = this.provincia !== undefined ? this.provincia : <any>null;
        data["nazione"] = this.nazione !== undefined ? this.nazione : <any>null;
        return data;
    }
}

export interface IDocumentoContabileTestata {
    documentoID?: number;
    tipoDocumentoID?: number;
    tipoDocumento?: ETipoDocumento;
    alfanum?: string | null;
    num_doc?: number | null;
    dataDocumento?: string;
    cliente?: string | null;
    indirizzo?: string | null;
    piva?: string | null;
    descrizione?: string | null;
    dataPartenza?: string | null;
    pagamentoID?: number | null;
    totale_doc?: number | null;
    stampato?: boolean;
    contabilizzato?: boolean;
    note?: string | null;
    nota_credito?: boolean;
    riferimento_id?: number | null;
    contattoID?: number | null;
    cliente_age?: boolean;
    causale?: string | null;
    codfisc?: string | null;
    resultSentMail?: string | null;
    operatore?: EOperatore;
    idsede?: number | null;
    statoSDI?: EStatoSDI | null;
    documentoParentID?: number | null;
    ragioneSociale?: string | null;
    nome?: string | null;
    cognome?: string | null;
    indirizzoFatt?: string | null;
    numeroCivico?: string | null;
    cap?: string | null;
    comune?: string | null;
    provincia?: string | null;
    nazione?: string | null;
}

export enum EStatoSDI {
    Nessuno = "Nessuno",
    Pronto = "Pronto",
    Inviato = "Inviato",
    RifiutatoVAR = "RifiutatoVAR",
    Accettato = "Accettato",
    RifiutatoSDI = "RifiutatoSDI",
}

export class InvoicesListRowDetail implements IInvoicesListRowDetail {
    /** ID della riga */
    id?: number;
    /** Descrizione della riga */
    descrizione?: string | null;
    /** Importo della riga */
    importo?: number;
    /** Se true è un importo CEE */
    isCee?: boolean;
    /** Entità della riga */
    riga?: DocumentoContabileRiga;

    constructor(data?: IInvoicesListRowDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
            this.isCee = _data["isCee"] !== undefined ? _data["isCee"] : <any>null;
            this.riga = _data["riga"] ? DocumentoContabileRiga.fromJS(_data["riga"]) : <any>null;
        }
    }

    static fromJS(data: any): InvoicesListRowDetail {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesListRowDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        data["isCee"] = this.isCee !== undefined ? this.isCee : <any>null;
        data["riga"] = this.riga ? this.riga.toJSON() : <any>null;
        return data;
    }
}

export interface IInvoicesListRowDetail {
    /** ID della riga */
    id?: number;
    /** Descrizione della riga */
    descrizione?: string | null;
    /** Importo della riga */
    importo?: number;
    /** Se true è un importo CEE */
    isCee?: boolean;
    /** Entità della riga */
    riga?: DocumentoContabileRiga;
}

export class DocumentoContabileRiga implements IDocumentoContabileRiga {
    idriga?: number;
    idsede?: number;
    iddocumento?: number;
    idoffagenzia?: number | null;
    descrizione?: string | null;
    importo?: number | null;
    iva?: number | null;
    codiva?: string | null;
    natura?: NaturaType | null;

    constructor(data?: IDocumentoContabileRiga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idriga = _data["idriga"] !== undefined ? _data["idriga"] : <any>null;
            this.idsede = _data["idsede"] !== undefined ? _data["idsede"] : <any>null;
            this.iddocumento = _data["iddocumento"] !== undefined ? _data["iddocumento"] : <any>null;
            this.idoffagenzia = _data["idoffagenzia"] !== undefined ? _data["idoffagenzia"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
            this.iva = _data["iva"] !== undefined ? _data["iva"] : <any>null;
            this.codiva = _data["codiva"] !== undefined ? _data["codiva"] : <any>null;
            this.natura = _data["natura"] !== undefined ? _data["natura"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentoContabileRiga {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoContabileRiga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idriga"] = this.idriga !== undefined ? this.idriga : <any>null;
        data["idsede"] = this.idsede !== undefined ? this.idsede : <any>null;
        data["iddocumento"] = this.iddocumento !== undefined ? this.iddocumento : <any>null;
        data["idoffagenzia"] = this.idoffagenzia !== undefined ? this.idoffagenzia : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        data["iva"] = this.iva !== undefined ? this.iva : <any>null;
        data["codiva"] = this.codiva !== undefined ? this.codiva : <any>null;
        data["natura"] = this.natura !== undefined ? this.natura : <any>null;
        return data;
    }
}

export interface IDocumentoContabileRiga {
    idriga?: number;
    idsede?: number;
    iddocumento?: number;
    idoffagenzia?: number | null;
    descrizione?: string | null;
    importo?: number | null;
    iva?: number | null;
    codiva?: string | null;
    natura?: NaturaType | null;
}

export enum NaturaType {
    N1 = "N1",
    N2 = "N2",
    N3 = "N3",
    N4 = "N4",
    N5 = "N5",
    N6 = "N6",
    N7 = "N7",
}

export class InvoiceGetRequest extends ApiRequest implements IInvoiceGetRequest {
    /** ID del documento da richiedere */
    documentoID?: number;

    constructor(data?: IInvoiceGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceGetRequest extends IApiRequest {
    /** ID del documento da richiedere */
    documentoID?: number;
}

export class InvoicesCreateResponse extends OkApiResponse implements IInvoicesCreateResponse {
    docs?: InvoicesListRow[] | null;

    constructor(data?: IInvoicesCreateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["docs"])) {
                this.docs = [] as any;
                for (let item of _data["docs"])
                    this.docs!.push(InvoicesListRow.fromJS(item));
            }
            else {
                this.docs = <any>null;
            }
        }
    }

    static fromJS(data: any): InvoicesCreateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesCreateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.docs)) {
            data["docs"] = [];
            for (let item of this.docs)
                data["docs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicesCreateResponse extends IOkApiResponse {
    docs?: InvoicesListRow[] | null;
}

export class InvoicesCreateRequest extends ApiRequest implements IInvoicesCreateRequest {
    tipoDocumento?: ETipoDocumento;
    dataEmissione?: string;
    offerte?: DatiDocumentoContabile[] | null;

    constructor(data?: IInvoicesCreateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : <any>null;
            this.dataEmissione = _data["dataEmissione"] !== undefined ? _data["dataEmissione"] : <any>null;
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(DatiDocumentoContabile.fromJS(item));
            }
            else {
                this.offerte = <any>null;
            }
        }
    }

    static fromJS(data: any): InvoicesCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : <any>null;
        data["dataEmissione"] = this.dataEmissione !== undefined ? this.dataEmissione : <any>null;
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicesCreateRequest extends IApiRequest {
    tipoDocumento?: ETipoDocumento;
    dataEmissione?: string;
    offerte?: DatiDocumentoContabile[] | null;
}

export class DatiDocumentoContabile implements IDatiDocumentoContabile {
    offertaID?: number;
    contattoAgenziaID?: number;
    offertaAgenziaID?: number;
    alNetto?: boolean;

    constructor(data?: IDatiDocumentoContabile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : <any>null;
            this.offertaAgenziaID = _data["offertaAgenziaID"] !== undefined ? _data["offertaAgenziaID"] : <any>null;
            this.alNetto = _data["alNetto"] !== undefined ? _data["alNetto"] : <any>null;
        }
    }

    static fromJS(data: any): DatiDocumentoContabile {
        data = typeof data === 'object' ? data : {};
        let result = new DatiDocumentoContabile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : <any>null;
        data["offertaAgenziaID"] = this.offertaAgenziaID !== undefined ? this.offertaAgenziaID : <any>null;
        data["alNetto"] = this.alNetto !== undefined ? this.alNetto : <any>null;
        return data;
    }
}

export interface IDatiDocumentoContabile {
    offertaID?: number;
    contattoAgenziaID?: number;
    offertaAgenziaID?: number;
    alNetto?: boolean;
}

export class NrTableResponseOfInvoicesListRow extends OkApiResponse implements INrTableResponseOfInvoicesListRow {
    /** Array delle righe della pagina richiesta */
    rows?: InvoicesListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfInvoicesListRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(InvoicesListRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfInvoicesListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfInvoicesListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfInvoicesListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: InvoicesListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class InvoicesListResponse extends NrTableResponseOfInvoicesListRow implements IInvoicesListResponse {

    constructor(data?: IInvoicesListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): InvoicesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicesListResponse extends INrTableResponseOfInvoicesListRow {
}

export class InvoicesListRequest extends NrTableRequest implements IInvoicesListRequest {
    /** ID del contatto (agenzia) */
    contattoID?: number | null;
    /** Operatore del documento */
    operatore?: EOperatore | null;
    /** Partita IVA associata al documento */
    partitaIVA?: string | null;
    /** Inizio range data del documento */
    dataDocumentoFrom?: string | null;
    /** Fine range data del documento */
    dataDocumentoTo?: string | null;
    /** Intestazione (come testo) */
    intestazione?: string | null;
    /** Tipo di documento */
    tipoDocumento?: ETipoDocumento | null;
    /** ID del tipo di pagamento */
    tipoPagamentoID?: number | null;
    /** Numero di documento */
    numeroDocumento?: number | null;
    /** Anno di emissione del documento */
    annoDocumento?: number | null;
    /** Trip id */
    tripId?: number | null;

    constructor(data?: IInvoicesListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : <any>null;
            this.dataDocumentoFrom = _data["dataDocumentoFrom"] !== undefined ? _data["dataDocumentoFrom"] : <any>null;
            this.dataDocumentoTo = _data["dataDocumentoTo"] !== undefined ? _data["dataDocumentoTo"] : <any>null;
            this.intestazione = _data["intestazione"] !== undefined ? _data["intestazione"] : <any>null;
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : <any>null;
            this.tipoPagamentoID = _data["tipoPagamentoID"] !== undefined ? _data["tipoPagamentoID"] : <any>null;
            this.numeroDocumento = _data["numeroDocumento"] !== undefined ? _data["numeroDocumento"] : <any>null;
            this.annoDocumento = _data["annoDocumento"] !== undefined ? _data["annoDocumento"] : <any>null;
            this.tripId = _data["tripId"] !== undefined ? _data["tripId"] : <any>null;
        }
    }

    static fromJS(data: any): InvoicesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : <any>null;
        data["dataDocumentoFrom"] = this.dataDocumentoFrom !== undefined ? this.dataDocumentoFrom : <any>null;
        data["dataDocumentoTo"] = this.dataDocumentoTo !== undefined ? this.dataDocumentoTo : <any>null;
        data["intestazione"] = this.intestazione !== undefined ? this.intestazione : <any>null;
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : <any>null;
        data["tipoPagamentoID"] = this.tipoPagamentoID !== undefined ? this.tipoPagamentoID : <any>null;
        data["numeroDocumento"] = this.numeroDocumento !== undefined ? this.numeroDocumento : <any>null;
        data["annoDocumento"] = this.annoDocumento !== undefined ? this.annoDocumento : <any>null;
        data["tripId"] = this.tripId !== undefined ? this.tripId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicesListRequest extends INrTableRequest {
    /** ID del contatto (agenzia) */
    contattoID?: number | null;
    /** Operatore del documento */
    operatore?: EOperatore | null;
    /** Partita IVA associata al documento */
    partitaIVA?: string | null;
    /** Inizio range data del documento */
    dataDocumentoFrom?: string | null;
    /** Fine range data del documento */
    dataDocumentoTo?: string | null;
    /** Intestazione (come testo) */
    intestazione?: string | null;
    /** Tipo di documento */
    tipoDocumento?: ETipoDocumento | null;
    /** ID del tipo di pagamento */
    tipoPagamentoID?: number | null;
    /** Numero di documento */
    numeroDocumento?: number | null;
    /** Anno di emissione del documento */
    annoDocumento?: number | null;
    /** Trip id */
    tripId?: number | null;
}

export class InvoiceUpsertResponse extends OkApiResponse implements IInvoiceUpsertResponse {
    /** Documento creato o aggiornato */
    documento?: DocumentoContabileTestata;
    /** Righe create o aggiornate */
    righe?: DocumentoContabileRiga[] | null;

    constructor(data?: IInvoiceUpsertResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documento = _data["documento"] ? DocumentoContabileTestata.fromJS(_data["documento"]) : <any>null;
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(DocumentoContabileRiga.fromJS(item));
            }
            else {
                this.righe = <any>null;
            }
        }
    }

    static fromJS(data: any): InvoiceUpsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceUpsertResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documento"] = this.documento ? this.documento.toJSON() : <any>null;
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceUpsertResponse extends IOkApiResponse {
    /** Documento creato o aggiornato */
    documento?: DocumentoContabileTestata;
    /** Righe create o aggiornate */
    righe?: DocumentoContabileRiga[] | null;
}

export class InvoiceUpsertRequest extends ApiRequest implements IInvoiceUpsertRequest {
    /** Testata del documento */
    documento!: DocumentoContabileTestata;
    /** Righe del documento. Se mancanti in un update le righe restano invariate */
    righe?: DocumentoContabileRiga[] | null;

    constructor(data?: IInvoiceUpsertRequest) {
        super(data);
        if (!data) {
            this.documento = new DocumentoContabileTestata();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documento = _data["documento"] ? DocumentoContabileTestata.fromJS(_data["documento"]) : new DocumentoContabileTestata();
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(DocumentoContabileRiga.fromJS(item));
            }
            else {
                this.righe = <any>null;
            }
        }
    }

    static fromJS(data: any): InvoiceUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documento"] = this.documento ? this.documento.toJSON() : <any>null;
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceUpsertRequest extends IApiRequest {
    /** Testata del documento */
    documento: DocumentoContabileTestata;
    /** Righe del documento. Se mancanti in un update le righe restano invariate */
    righe?: DocumentoContabileRiga[] | null;
}

export class PaymentDeleteRequest extends ApiRequest implements IPaymentDeleteRequest {
    /** ID del pagamento da eliminare */
    pagamentoID?: number;

    constructor(data?: IPaymentDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentDeleteRequest extends IApiRequest {
    /** ID del pagamento da eliminare */
    pagamentoID?: number;
}

export class PaymentGetResponse extends OkApiResponse implements IPaymentGetResponse {
    /** Entità del pagamenti */
    pagamento?: Pagamento;
    /** Codice della valuta del pagamento */
    valuta?: string | null;
    /** Nome del contatto */
    contatto?: string | null;
    /** Nome della banca */
    banca?: string | null;
    /** Offerte associate al pagamento, ordinate per partenza e ID */
    offerte?: PaymentTripRow[] | null;
    /** Totale dei "Pagare" delle offerte */
    totalePagare?: number;

    constructor(data?: IPaymentGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pagamento = _data["pagamento"] ? Pagamento.fromJS(_data["pagamento"]) : <any>null;
            this.valuta = _data["valuta"] !== undefined ? _data["valuta"] : <any>null;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : <any>null;
            this.banca = _data["banca"] !== undefined ? _data["banca"] : <any>null;
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(PaymentTripRow.fromJS(item));
            }
            else {
                this.offerte = <any>null;
            }
            this.totalePagare = _data["totalePagare"] !== undefined ? _data["totalePagare"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagamento"] = this.pagamento ? this.pagamento.toJSON() : <any>null;
        data["valuta"] = this.valuta !== undefined ? this.valuta : <any>null;
        data["contatto"] = this.contatto !== undefined ? this.contatto : <any>null;
        data["banca"] = this.banca !== undefined ? this.banca : <any>null;
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item.toJSON());
        }
        data["totalePagare"] = this.totalePagare !== undefined ? this.totalePagare : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentGetResponse extends IOkApiResponse {
    /** Entità del pagamenti */
    pagamento?: Pagamento;
    /** Codice della valuta del pagamento */
    valuta?: string | null;
    /** Nome del contatto */
    contatto?: string | null;
    /** Nome della banca */
    banca?: string | null;
    /** Offerte associate al pagamento, ordinate per partenza e ID */
    offerte?: PaymentTripRow[] | null;
    /** Totale dei "Pagare" delle offerte */
    totalePagare?: number;
}

export class Pagamento implements IPagamento {
    id?: number;
    contattoID?: number;
    offertaID?: number | null;
    data?: string | null;
    commissioniBancarie?: number | null;
    valutaID?: number;
    cambio?: number | null;
    tipoOperazioneID?: number | null;
    navBanca?: string | null;
    navCausale?: string | null;
    operatoreID?: EOperatore | null;
    note?: string | null;
    datiBancaFor?: string | null;
    importo?: number | null;

    constructor(data?: IPagamento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.commissioniBancarie = _data["commissioniBancarie"] !== undefined ? _data["commissioniBancarie"] : <any>null;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : <any>null;
            this.cambio = _data["cambio"] !== undefined ? _data["cambio"] : <any>null;
            this.tipoOperazioneID = _data["tipoOperazioneID"] !== undefined ? _data["tipoOperazioneID"] : <any>null;
            this.navBanca = _data["navBanca"] !== undefined ? _data["navBanca"] : <any>null;
            this.navCausale = _data["navCausale"] !== undefined ? _data["navCausale"] : <any>null;
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.datiBancaFor = _data["datiBancaFor"] !== undefined ? _data["datiBancaFor"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
        }
    }

    static fromJS(data: any): Pagamento {
        data = typeof data === 'object' ? data : {};
        let result = new Pagamento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["commissioniBancarie"] = this.commissioniBancarie !== undefined ? this.commissioniBancarie : <any>null;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : <any>null;
        data["cambio"] = this.cambio !== undefined ? this.cambio : <any>null;
        data["tipoOperazioneID"] = this.tipoOperazioneID !== undefined ? this.tipoOperazioneID : <any>null;
        data["navBanca"] = this.navBanca !== undefined ? this.navBanca : <any>null;
        data["navCausale"] = this.navCausale !== undefined ? this.navCausale : <any>null;
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["datiBancaFor"] = this.datiBancaFor !== undefined ? this.datiBancaFor : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        return data;
    }
}

export interface IPagamento {
    id?: number;
    contattoID?: number;
    offertaID?: number | null;
    data?: string | null;
    commissioniBancarie?: number | null;
    valutaID?: number;
    cambio?: number | null;
    tipoOperazioneID?: number | null;
    navBanca?: string | null;
    navCausale?: string | null;
    operatoreID?: EOperatore | null;
    note?: string | null;
    datiBancaFor?: string | null;
    importo?: number | null;
}

export class PaymentTripRow implements IPaymentTripRow {
    /** ID dell'offerta */
    offertaID?: number;
    /** Operatore dell'offerta */
    operatore?: EOperatore;
    /** Data di partenza */
    partenza?: string;
    /** Data di conferma */
    conferma?: string | null;
    /** Se true c'è cancellazione conferma */
    cancellataADV?: boolean;
    /** Se true è cancellata TO */
    cancellataTO?: boolean;
    /** Importo da pagare in valuta */
    pagare?: number;
    /** Tipo di contabilizzazione */
    contabilizzazione?: EContabilizzazione | null;
    /** Nomi abbreviati dei clienti */
    clienti?: string;
    /** Nome dell'utente di conferma */
    utenteConferma?: string | null;
    /** Indirizzo email dell'utente di conferma */
    emailUtenteConferma?: string | null;
    /** Codice booking se presente */
    bookingRef?: string | null;

    constructor(data?: IPaymentTripRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : <any>null;
            this.cancellataADV = _data["cancellataADV"] !== undefined ? _data["cancellataADV"] : <any>null;
            this.cancellataTO = _data["cancellataTO"] !== undefined ? _data["cancellataTO"] : <any>null;
            this.pagare = _data["pagare"] !== undefined ? _data["pagare"] : <any>null;
            this.contabilizzazione = _data["contabilizzazione"] !== undefined ? _data["contabilizzazione"] : <any>null;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : <any>null;
            this.utenteConferma = _data["utenteConferma"] !== undefined ? _data["utenteConferma"] : <any>null;
            this.emailUtenteConferma = _data["emailUtenteConferma"] !== undefined ? _data["emailUtenteConferma"] : <any>null;
            this.bookingRef = _data["bookingRef"] !== undefined ? _data["bookingRef"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentTripRow {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTripRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["conferma"] = this.conferma !== undefined ? this.conferma : <any>null;
        data["cancellataADV"] = this.cancellataADV !== undefined ? this.cancellataADV : <any>null;
        data["cancellataTO"] = this.cancellataTO !== undefined ? this.cancellataTO : <any>null;
        data["pagare"] = this.pagare !== undefined ? this.pagare : <any>null;
        data["contabilizzazione"] = this.contabilizzazione !== undefined ? this.contabilizzazione : <any>null;
        data["clienti"] = this.clienti !== undefined ? this.clienti : <any>null;
        data["utenteConferma"] = this.utenteConferma !== undefined ? this.utenteConferma : <any>null;
        data["emailUtenteConferma"] = this.emailUtenteConferma !== undefined ? this.emailUtenteConferma : <any>null;
        data["bookingRef"] = this.bookingRef !== undefined ? this.bookingRef : <any>null;
        return data;
    }
}

export interface IPaymentTripRow {
    /** ID dell'offerta */
    offertaID?: number;
    /** Operatore dell'offerta */
    operatore?: EOperatore;
    /** Data di partenza */
    partenza?: string;
    /** Data di conferma */
    conferma?: string | null;
    /** Se true c'è cancellazione conferma */
    cancellataADV?: boolean;
    /** Se true è cancellata TO */
    cancellataTO?: boolean;
    /** Importo da pagare in valuta */
    pagare?: number;
    /** Tipo di contabilizzazione */
    contabilizzazione?: EContabilizzazione | null;
    /** Nomi abbreviati dei clienti */
    clienti?: string;
    /** Nome dell'utente di conferma */
    utenteConferma?: string | null;
    /** Indirizzo email dell'utente di conferma */
    emailUtenteConferma?: string | null;
    /** Codice booking se presente */
    bookingRef?: string | null;
}

export class PaymentGetRequest extends LocalizedRequest implements IPaymentGetRequest {
    /** ID del pagamento da caricare */
    pagamentoID?: number;
    /** Se true include le righe di pagamento sulle offerte */
    includiRighe?: boolean;

    constructor(data?: IPaymentGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : <any>null;
            this.includiRighe = _data["includiRighe"] !== undefined ? _data["includiRighe"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : <any>null;
        data["includiRighe"] = this.includiRighe !== undefined ? this.includiRighe : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentGetRequest extends ILocalizedRequest {
    /** ID del pagamento da caricare */
    pagamentoID?: number;
    /** Se true include le righe di pagamento sulle offerte */
    includiRighe?: boolean;
}

export class PaymentsAssignRequest extends ApiRequest implements IPaymentsAssignRequest {
    /** Lista dei pagamenti da impostare */
    pagamenti!: ServicePayment[];

    constructor(data?: IPaymentsAssignRequest) {
        super(data);
        if (!data) {
            this.pagamenti = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pagamenti"])) {
                this.pagamenti = [] as any;
                for (let item of _data["pagamenti"])
                    this.pagamenti!.push(ServicePayment.fromJS(item));
            }
            else {
                this.pagamenti = <any>null;
            }
        }
    }

    static fromJS(data: any): PaymentsAssignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentsAssignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pagamenti)) {
            data["pagamenti"] = [];
            for (let item of this.pagamenti)
                data["pagamenti"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentsAssignRequest extends IApiRequest {
    /** Lista dei pagamenti da impostare */
    pagamenti: ServicePayment[];
}

export class ServicePayment implements IServicePayment {
    offertaID?: number;
    offertaDatoID?: number;
    pagamentoID?: number | null;
    importo?: number;

    constructor(data?: IServicePayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
        }
    }

    static fromJS(data: any): ServicePayment {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        return data;
    }
}

export interface IServicePayment {
    offertaID?: number;
    offertaDatoID?: number;
    pagamentoID?: number | null;
    importo?: number;
}

export class NrTableResponseOfPaymentRow extends OkApiResponse implements INrTableResponseOfPaymentRow {
    /** Array delle righe della pagina richiesta */
    rows?: PaymentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPaymentRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PaymentRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfPaymentRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPaymentRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPaymentRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PaymentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetPaymentsListResponse extends NrTableResponseOfPaymentRow implements IGetPaymentsListResponse {
    /** Totali divisi per moneta */
    currenciesTotals?: PaymentCurrencyTotal[];
    /** Totale Euro */
    euroTotal?: number;

    constructor(data?: IGetPaymentsListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["currenciesTotals"])) {
                this.currenciesTotals = [] as any;
                for (let item of _data["currenciesTotals"])
                    this.currenciesTotals!.push(PaymentCurrencyTotal.fromJS(item));
            }
            else {
                this.currenciesTotals = <any>null;
            }
            this.euroTotal = _data["euroTotal"] !== undefined ? _data["euroTotal"] : <any>null;
        }
    }

    static fromJS(data: any): GetPaymentsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.currenciesTotals)) {
            data["currenciesTotals"] = [];
            for (let item of this.currenciesTotals)
                data["currenciesTotals"].push(item.toJSON());
        }
        data["euroTotal"] = this.euroTotal !== undefined ? this.euroTotal : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPaymentsListResponse extends INrTableResponseOfPaymentRow {
    /** Totali divisi per moneta */
    currenciesTotals?: PaymentCurrencyTotal[];
    /** Totale Euro */
    euroTotal?: number;
}

export class PaymentCurrencyTotal implements IPaymentCurrencyTotal {
    /** Codice della valuta */
    codiceValuta?: string | null;
    /** Importo totale in valuta */
    importoValuta?: number;
    /** Importo totale in Euro */
    importoEuro?: number;
    /** Totale dei "Pagato" in riga delle offerte */
    importoCosti?: number;

    constructor(data?: IPaymentCurrencyTotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : <any>null;
            this.importoValuta = _data["importoValuta"] !== undefined ? _data["importoValuta"] : <any>null;
            this.importoEuro = _data["importoEuro"] !== undefined ? _data["importoEuro"] : <any>null;
            this.importoCosti = _data["importoCosti"] !== undefined ? _data["importoCosti"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentCurrencyTotal {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentCurrencyTotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : <any>null;
        data["importoValuta"] = this.importoValuta !== undefined ? this.importoValuta : <any>null;
        data["importoEuro"] = this.importoEuro !== undefined ? this.importoEuro : <any>null;
        data["importoCosti"] = this.importoCosti !== undefined ? this.importoCosti : <any>null;
        return data;
    }
}

export interface IPaymentCurrencyTotal {
    /** Codice della valuta */
    codiceValuta?: string | null;
    /** Importo totale in valuta */
    importoValuta?: number;
    /** Importo totale in Euro */
    importoEuro?: number;
    /** Totale dei "Pagato" in riga delle offerte */
    importoCosti?: number;
}

/** Vista dell'export Excel */
export class PaymentExportRow implements IPaymentExportRow {
    /** ID del pagamento */
    id?: number;
    /** Operatore del pagamento */
    operatore?: EOperatore | null;
    /** ID del contatto fornitore */
    contattoID?: number | null;
    /** Nome / Ragione sociale del fornitore */
    contattoFornitore?: string | null;
    /** Data di effettuazione del pagamento */
    dataEffettuazione?: string | null;
    /** Codice 3 lettere della valuta */
    codiceValuta?: string | null;
    /** Cambio della valuta al momento del pagamento */
    cambioValuta?: number | null;
    /** ID della banca d'appoggio */
    bancaID?: number | null;
    /** Nome della banca */
    banca?: string | null;
    /** Importo in valuta del pagamento */
    importoValuta?: number | null;
    /** Importo in Euro */
    importoEuro?: number | null;
    /** Totale dei "Pagato" in riga delle offerte */
    totaleCosti?: number | null;

    constructor(data?: IPaymentExportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.contattoFornitore = _data["contattoFornitore"] !== undefined ? _data["contattoFornitore"] : <any>null;
            this.dataEffettuazione = _data["dataEffettuazione"] !== undefined ? _data["dataEffettuazione"] : <any>null;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : <any>null;
            this.cambioValuta = _data["cambioValuta"] !== undefined ? _data["cambioValuta"] : <any>null;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : <any>null;
            this.banca = _data["banca"] !== undefined ? _data["banca"] : <any>null;
            this.importoValuta = _data["importoValuta"] !== undefined ? _data["importoValuta"] : <any>null;
            this.importoEuro = _data["importoEuro"] !== undefined ? _data["importoEuro"] : <any>null;
            this.totaleCosti = _data["totaleCosti"] !== undefined ? _data["totaleCosti"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentExportRow {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentExportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["contattoFornitore"] = this.contattoFornitore !== undefined ? this.contattoFornitore : <any>null;
        data["dataEffettuazione"] = this.dataEffettuazione !== undefined ? this.dataEffettuazione : <any>null;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : <any>null;
        data["cambioValuta"] = this.cambioValuta !== undefined ? this.cambioValuta : <any>null;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : <any>null;
        data["banca"] = this.banca !== undefined ? this.banca : <any>null;
        data["importoValuta"] = this.importoValuta !== undefined ? this.importoValuta : <any>null;
        data["importoEuro"] = this.importoEuro !== undefined ? this.importoEuro : <any>null;
        data["totaleCosti"] = this.totaleCosti !== undefined ? this.totaleCosti : <any>null;
        return data;
    }
}

/** Vista dell'export Excel */
export interface IPaymentExportRow {
    /** ID del pagamento */
    id?: number;
    /** Operatore del pagamento */
    operatore?: EOperatore | null;
    /** ID del contatto fornitore */
    contattoID?: number | null;
    /** Nome / Ragione sociale del fornitore */
    contattoFornitore?: string | null;
    /** Data di effettuazione del pagamento */
    dataEffettuazione?: string | null;
    /** Codice 3 lettere della valuta */
    codiceValuta?: string | null;
    /** Cambio della valuta al momento del pagamento */
    cambioValuta?: number | null;
    /** ID della banca d'appoggio */
    bancaID?: number | null;
    /** Nome della banca */
    banca?: string | null;
    /** Importo in valuta del pagamento */
    importoValuta?: number | null;
    /** Importo in Euro */
    importoEuro?: number | null;
    /** Totale dei "Pagato" in riga delle offerte */
    totaleCosti?: number | null;
}

/** View della singola riga di pagamento (Export + ID vari) */
export class PaymentRow extends PaymentExportRow implements IPaymentRow {
    /** ID del contatto fornitore */
    contattoFornitoreID?: number;
    /** ID della valuta */
    valutaID?: number;
    /** Entità del pagamento */
    pagamento?: Pagamento;

    constructor(data?: IPaymentRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoFornitoreID = _data["contattoFornitoreID"] !== undefined ? _data["contattoFornitoreID"] : <any>null;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : <any>null;
            this.pagamento = _data["pagamento"] ? Pagamento.fromJS(_data["pagamento"]) : <any>null;
        }
    }

    static fromJS(data: any): PaymentRow {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoFornitoreID"] = this.contattoFornitoreID !== undefined ? this.contattoFornitoreID : <any>null;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : <any>null;
        data["pagamento"] = this.pagamento ? this.pagamento.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** View della singola riga di pagamento (Export + ID vari) */
export interface IPaymentRow extends IPaymentExportRow {
    /** ID del contatto fornitore */
    contattoFornitoreID?: number;
    /** ID della valuta */
    valutaID?: number;
    /** Entità del pagamento */
    pagamento?: Pagamento;
}

export class GetPaymentsListRequest extends NrTableRequest implements IGetPaymentsListRequest {
    /** Filtro per operatore */
    operatore?: EOperatore | null;
    /** ID del contatto fornitore associato al pagamento */
    contattoFornitoreID?: number | null;
    /** ID offerta singola */
    offertaID?: number | null;
    /** Pagamento singolo */
    pagamentoID?: number | null;
    /** ID della banca */
    bancaID?: number | null;
    /** Data iniziale */
    dataDal?: string | null;
    /** Data finale */
    dataAl?: string | null;

    constructor(data?: IGetPaymentsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.contattoFornitoreID = _data["contattoFornitoreID"] !== undefined ? _data["contattoFornitoreID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : <any>null;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : <any>null;
            this.dataDal = _data["dataDal"] !== undefined ? _data["dataDal"] : <any>null;
            this.dataAl = _data["dataAl"] !== undefined ? _data["dataAl"] : <any>null;
        }
    }

    static fromJS(data: any): GetPaymentsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["contattoFornitoreID"] = this.contattoFornitoreID !== undefined ? this.contattoFornitoreID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : <any>null;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : <any>null;
        data["dataDal"] = this.dataDal !== undefined ? this.dataDal : <any>null;
        data["dataAl"] = this.dataAl !== undefined ? this.dataAl : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPaymentsListRequest extends INrTableRequest {
    /** Filtro per operatore */
    operatore?: EOperatore | null;
    /** ID del contatto fornitore associato al pagamento */
    contattoFornitoreID?: number | null;
    /** ID offerta singola */
    offertaID?: number | null;
    /** Pagamento singolo */
    pagamentoID?: number | null;
    /** ID della banca */
    bancaID?: number | null;
    /** Data iniziale */
    dataDal?: string | null;
    /** Data finale */
    dataAl?: string | null;
}

export class PaymentUpsertResponse extends OkApiResponse implements IPaymentUpsertResponse {
    /** Entità del pagamento dopo il salvataggio */
    pagamento?: Pagamento;

    constructor(data?: IPaymentUpsertResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pagamento = _data["pagamento"] ? Pagamento.fromJS(_data["pagamento"]) : <any>null;
        }
    }

    static fromJS(data: any): PaymentUpsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentUpsertResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagamento"] = this.pagamento ? this.pagamento.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentUpsertResponse extends IOkApiResponse {
    /** Entità del pagamento dopo il salvataggio */
    pagamento?: Pagamento;
}

export class PaymentUpsertRequest extends ApiRequest implements IPaymentUpsertRequest {
    /** Entità del pagamento */
    pagamento!: Pagamento;

    constructor(data?: IPaymentUpsertRequest) {
        super(data);
        if (!data) {
            this.pagamento = new Pagamento();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pagamento = _data["pagamento"] ? Pagamento.fromJS(_data["pagamento"]) : new Pagamento();
        }
    }

    static fromJS(data: any): PaymentUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagamento"] = this.pagamento ? this.pagamento.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentUpsertRequest extends IApiRequest {
    /** Entità del pagamento */
    pagamento: Pagamento;
}

export class ServicesToPayListResponse extends OkApiResponse implements IServicesToPayListResponse {
    /** Lista dei servizi da pagare */
    rows?: ServiceToPayRow[];

    constructor(data?: IServicesToPayListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ServiceToPayRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): ServicesToPayListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServicesToPayListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServicesToPayListResponse extends IOkApiResponse {
    /** Lista dei servizi da pagare */
    rows?: ServiceToPayRow[];
}

export class ServiceToPayExportRow implements IServiceToPayExportRow {
    /** ID dell'offerta */
    offertaID?: number;
    /** Operatore dell'offerta */
    operatore?: EOperatore;
    /** Se true è annullata TO */
    annullataTO?: boolean;
    /** Se true è annullata ADV */
    annullataADV?: boolean;
    /** Nome del contatto dell'accordo */
    contattoAccordo?: string | null;
    /** Data di partenza */
    partenza?: string;
    /** Clienti (dall'abbinamento) */
    clienti?: string | null;
    /** Paese (dal luogo della tappa) */
    paese?: string | null;
    /** Luogo della tappa */
    luogo?: string | null;
    /** Descrizione servizio in riga */
    servizio?: string | null;
    /** Prezzo totale */
    prezzo?: number;
    /** Codice della valuta */
    valuta?: string | null;
    /** Addebito in valuta */
    addebito?: number;
    /** Costo progressivo per offerta */
    costoProgressivoOfferta?: number;
    /** Importo già pagato */
    pagato?: number;
    /** Importo da pagare */
    pagare?: number;
    /** ID del pagamento associato */
    pagamentoID?: number | null;
    /** Verificato */
    verificato?: boolean;
    /** Tipo di contabilizzazione */
    contabilizzazione?: EContabilizzazione;
    /** Codice della conferma del fornitore */
    bookingRef?: string | null;

    constructor(data?: IServiceToPayExportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.annullataTO = _data["annullataTO"] !== undefined ? _data["annullataTO"] : <any>null;
            this.annullataADV = _data["annullataADV"] !== undefined ? _data["annullataADV"] : <any>null;
            this.contattoAccordo = _data["contattoAccordo"] !== undefined ? _data["contattoAccordo"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.valuta = _data["valuta"] !== undefined ? _data["valuta"] : <any>null;
            this.addebito = _data["addebito"] !== undefined ? _data["addebito"] : <any>null;
            this.costoProgressivoOfferta = _data["costoProgressivoOfferta"] !== undefined ? _data["costoProgressivoOfferta"] : <any>null;
            this.pagato = _data["pagato"] !== undefined ? _data["pagato"] : <any>null;
            this.pagare = _data["pagare"] !== undefined ? _data["pagare"] : <any>null;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : <any>null;
            this.verificato = _data["verificato"] !== undefined ? _data["verificato"] : <any>null;
            this.contabilizzazione = _data["contabilizzazione"] !== undefined ? _data["contabilizzazione"] : <any>null;
            this.bookingRef = _data["bookingRef"] !== undefined ? _data["bookingRef"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceToPayExportRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceToPayExportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["annullataTO"] = this.annullataTO !== undefined ? this.annullataTO : <any>null;
        data["annullataADV"] = this.annullataADV !== undefined ? this.annullataADV : <any>null;
        data["contattoAccordo"] = this.contattoAccordo !== undefined ? this.contattoAccordo : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["clienti"] = this.clienti !== undefined ? this.clienti : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["valuta"] = this.valuta !== undefined ? this.valuta : <any>null;
        data["addebito"] = this.addebito !== undefined ? this.addebito : <any>null;
        data["costoProgressivoOfferta"] = this.costoProgressivoOfferta !== undefined ? this.costoProgressivoOfferta : <any>null;
        data["pagato"] = this.pagato !== undefined ? this.pagato : <any>null;
        data["pagare"] = this.pagare !== undefined ? this.pagare : <any>null;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : <any>null;
        data["verificato"] = this.verificato !== undefined ? this.verificato : <any>null;
        data["contabilizzazione"] = this.contabilizzazione !== undefined ? this.contabilizzazione : <any>null;
        data["bookingRef"] = this.bookingRef !== undefined ? this.bookingRef : <any>null;
        return data;
    }
}

export interface IServiceToPayExportRow {
    /** ID dell'offerta */
    offertaID?: number;
    /** Operatore dell'offerta */
    operatore?: EOperatore;
    /** Se true è annullata TO */
    annullataTO?: boolean;
    /** Se true è annullata ADV */
    annullataADV?: boolean;
    /** Nome del contatto dell'accordo */
    contattoAccordo?: string | null;
    /** Data di partenza */
    partenza?: string;
    /** Clienti (dall'abbinamento) */
    clienti?: string | null;
    /** Paese (dal luogo della tappa) */
    paese?: string | null;
    /** Luogo della tappa */
    luogo?: string | null;
    /** Descrizione servizio in riga */
    servizio?: string | null;
    /** Prezzo totale */
    prezzo?: number;
    /** Codice della valuta */
    valuta?: string | null;
    /** Addebito in valuta */
    addebito?: number;
    /** Costo progressivo per offerta */
    costoProgressivoOfferta?: number;
    /** Importo già pagato */
    pagato?: number;
    /** Importo da pagare */
    pagare?: number;
    /** ID del pagamento associato */
    pagamentoID?: number | null;
    /** Verificato */
    verificato?: boolean;
    /** Tipo di contabilizzazione */
    contabilizzazione?: EContabilizzazione;
    /** Codice della conferma del fornitore */
    bookingRef?: string | null;
}

export class ServiceToPayRow extends ServiceToPayExportRow implements IServiceToPayRow {
    /** ID della riga */
    offertaDatoID?: number;
    /** Contatto indicato nell'accordo */
    contattoAccordoID?: number | null;
    /** Check di corrispondenza contatto fornitore */
    supplierCheck?: ESupplierCheck;
    /** Valuta del pagamento già assegnato */
    valutaPagamento?: string | null;
    /** Check sull'ID pagamento associato */
    check?: EPaymentCheck;
    /** Se true è una riga "dispari" (per guidare la colorazione raggruppata per ID offerta */
    odd?: boolean;
    /** Span della riga per visualizzare correttamente la tabella */
    rowSpan?: number;

    constructor(data?: IServiceToPayRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.contattoAccordoID = _data["contattoAccordoID"] !== undefined ? _data["contattoAccordoID"] : <any>null;
            this.supplierCheck = _data["supplierCheck"] !== undefined ? _data["supplierCheck"] : <any>null;
            this.valutaPagamento = _data["valutaPagamento"] !== undefined ? _data["valutaPagamento"] : <any>null;
            this.check = _data["check"] !== undefined ? _data["check"] : <any>null;
            this.odd = _data["odd"] !== undefined ? _data["odd"] : <any>null;
            this.rowSpan = _data["rowSpan"] !== undefined ? _data["rowSpan"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceToPayRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceToPayRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["contattoAccordoID"] = this.contattoAccordoID !== undefined ? this.contattoAccordoID : <any>null;
        data["supplierCheck"] = this.supplierCheck !== undefined ? this.supplierCheck : <any>null;
        data["valutaPagamento"] = this.valutaPagamento !== undefined ? this.valutaPagamento : <any>null;
        data["check"] = this.check !== undefined ? this.check : <any>null;
        data["odd"] = this.odd !== undefined ? this.odd : <any>null;
        data["rowSpan"] = this.rowSpan !== undefined ? this.rowSpan : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceToPayRow extends IServiceToPayExportRow {
    /** ID della riga */
    offertaDatoID?: number;
    /** Contatto indicato nell'accordo */
    contattoAccordoID?: number | null;
    /** Check di corrispondenza contatto fornitore */
    supplierCheck?: ESupplierCheck;
    /** Valuta del pagamento già assegnato */
    valutaPagamento?: string | null;
    /** Check sull'ID pagamento associato */
    check?: EPaymentCheck;
    /** Se true è una riga "dispari" (per guidare la colorazione raggruppata per ID offerta */
    odd?: boolean;
    /** Span della riga per visualizzare correttamente la tabella */
    rowSpan?: number;
}

export enum ESupplierCheck {
    Missing = "Missing",
    Ok = "Ok",
    Mismatch = "Mismatch",
}

export enum EPaymentCheck {
    None = "None",
    Exists = "Exists",
    Missing = "Missing",
    Checking = "Checking",
}

export class ServicesToPayListRequest extends LocalizedRequest implements IServicesToPayListRequest {
    /** ID dell'operatore */
    operatore?: EOperatore | null;
    /** ID del contatto fornitore (da cercare sull'accordo) */
    contattoID?: number | null;
    /** ID dell'accordo */
    accordoID?: number | null;
    /** Data di partenza Dal */
    partenzaDal!: string;
    /** Data di partenza Al */
    partenzaAl!: string;
    /** ID di un'offerta */
    offertaID?: number | null;
    /** Se true è richiesta l'esportazione Excel */
    export?: boolean;
    /** Nome o parte del nome di un pax */
    nomePax?: string | null;
    /** Data inizio servizio "Dal" */
    inizioServizioDal?: string | null;
    /** Data inizio servizio "Al" */
    inizioServizioAl?: string | null;

    constructor(data?: IServicesToPayListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.export = _data["export"] !== undefined ? _data["export"] : <any>null;
            this.nomePax = _data["nomePax"] !== undefined ? _data["nomePax"] : <any>null;
            this.inizioServizioDal = _data["inizioServizioDal"] !== undefined ? _data["inizioServizioDal"] : <any>null;
            this.inizioServizioAl = _data["inizioServizioAl"] !== undefined ? _data["inizioServizioAl"] : <any>null;
        }
    }

    static fromJS(data: any): ServicesToPayListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServicesToPayListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["export"] = this.export !== undefined ? this.export : <any>null;
        data["nomePax"] = this.nomePax !== undefined ? this.nomePax : <any>null;
        data["inizioServizioDal"] = this.inizioServizioDal !== undefined ? this.inizioServizioDal : <any>null;
        data["inizioServizioAl"] = this.inizioServizioAl !== undefined ? this.inizioServizioAl : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IServicesToPayListRequest extends ILocalizedRequest {
    /** ID dell'operatore */
    operatore?: EOperatore | null;
    /** ID del contatto fornitore (da cercare sull'accordo) */
    contattoID?: number | null;
    /** ID dell'accordo */
    accordoID?: number | null;
    /** Data di partenza Dal */
    partenzaDal: string;
    /** Data di partenza Al */
    partenzaAl: string;
    /** ID di un'offerta */
    offertaID?: number | null;
    /** Se true è richiesta l'esportazione Excel */
    export?: boolean;
    /** Nome o parte del nome di un pax */
    nomePax?: string | null;
    /** Data inizio servizio "Dal" */
    inizioServizioDal?: string | null;
    /** Data inizio servizio "Al" */
    inizioServizioAl?: string | null;
}

export class CreateTravelfactoringResponse extends OkApiResponse implements ICreateTravelfactoringResponse {
    /** Flusso creato. Se null non c'erano righe da aggiungere */
    flusso?: Travelfactoring_Flusso | null;

    constructor(data?: ICreateTravelfactoringResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.flusso = _data["flusso"] ? Travelfactoring_Flusso.fromJS(_data["flusso"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateTravelfactoringResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTravelfactoringResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flusso"] = this.flusso ? this.flusso.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateTravelfactoringResponse extends IOkApiResponse {
    /** Flusso creato. Se null non c'erano righe da aggiungere */
    flusso?: Travelfactoring_Flusso | null;
}

export class Travelfactoring_Flusso implements ITravelfactoring_Flusso {
    id?: number;
    creato?: string;
    inviato?: string | null;

    constructor(data?: ITravelfactoring_Flusso) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.creato = _data["creato"] !== undefined ? _data["creato"] : <any>null;
            this.inviato = _data["inviato"] !== undefined ? _data["inviato"] : <any>null;
        }
    }

    static fromJS(data: any): Travelfactoring_Flusso {
        data = typeof data === 'object' ? data : {};
        let result = new Travelfactoring_Flusso();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["creato"] = this.creato !== undefined ? this.creato : <any>null;
        data["inviato"] = this.inviato !== undefined ? this.inviato : <any>null;
        return data;
    }
}

export interface ITravelfactoring_Flusso {
    id?: number;
    creato?: string;
    inviato?: string | null;
}

export class TravelfactoringGetRequest extends ApiRequest implements ITravelfactoringGetRequest {
    flussoID?: number;

    constructor(data?: ITravelfactoringGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.flussoID = _data["flussoID"] !== undefined ? _data["flussoID"] : <any>null;
        }
    }

    static fromJS(data: any): TravelfactoringGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TravelfactoringGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flussoID"] = this.flussoID !== undefined ? this.flussoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITravelfactoringGetRequest extends IApiRequest {
    flussoID?: number;
}

export class ExportTravelfactoringResponse extends OkApiResponse implements IExportTravelfactoringResponse {
    fileName?: string;
    fileContent?: string;

    constructor(data?: IExportTravelfactoringResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.fileContent = _data["fileContent"] !== undefined ? _data["fileContent"] : <any>null;
        }
    }

    static fromJS(data: any): ExportTravelfactoringResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExportTravelfactoringResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileContent"] = this.fileContent !== undefined ? this.fileContent : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IExportTravelfactoringResponse extends IOkApiResponse {
    fileName?: string;
    fileContent?: string;
}

export class TravelfactoringGetResponse extends OkApiResponse implements ITravelfactoringGetResponse {
    righe?: Travelfactoring_Riga[];

    constructor(data?: ITravelfactoringGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(Travelfactoring_Riga.fromJS(item));
            }
            else {
                this.righe = <any>null;
            }
        }
    }

    static fromJS(data: any): TravelfactoringGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TravelfactoringGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITravelfactoringGetResponse extends IOkApiResponse {
    righe?: Travelfactoring_Riga[];
}

export class Travelfactoring_Riga implements ITravelfactoring_Riga {
    id?: number;
    flussoID?: number;
    agenziaID?: number;
    offertaID?: number | null;
    pratica!: string;
    partenza?: string;
    scadenza?: string;
    operazione?: EOperazioneFactoring;
    importo?: number;
    passeggero?: string | null;

    constructor(data?: ITravelfactoring_Riga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.flussoID = _data["flussoID"] !== undefined ? _data["flussoID"] : <any>null;
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.pratica = _data["pratica"] !== undefined ? _data["pratica"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.scadenza = _data["scadenza"] !== undefined ? _data["scadenza"] : <any>null;
            this.operazione = _data["operazione"] !== undefined ? _data["operazione"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
            this.passeggero = _data["passeggero"] !== undefined ? _data["passeggero"] : <any>null;
        }
    }

    static fromJS(data: any): Travelfactoring_Riga {
        data = typeof data === 'object' ? data : {};
        let result = new Travelfactoring_Riga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["flussoID"] = this.flussoID !== undefined ? this.flussoID : <any>null;
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["pratica"] = this.pratica !== undefined ? this.pratica : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["scadenza"] = this.scadenza !== undefined ? this.scadenza : <any>null;
        data["operazione"] = this.operazione !== undefined ? this.operazione : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        data["passeggero"] = this.passeggero !== undefined ? this.passeggero : <any>null;
        return data;
    }
}

export interface ITravelfactoring_Riga {
    id?: number;
    flussoID?: number;
    agenziaID?: number;
    offertaID?: number | null;
    pratica: string;
    partenza?: string;
    scadenza?: string;
    operazione?: EOperazioneFactoring;
    importo?: number;
    passeggero?: string | null;
}

export enum EOperazioneFactoring {
    PrimaCessione = "PrimaCessione",
    Integrazione = "Integrazione",
    StornoParziale = "StornoParziale",
    AccreditoTotale = "AccreditoTotale",
    Rinuncia = "Rinuncia",
    AccreditoAutofattura = "AccreditoAutofattura",
}

export class NrTableResponseOfTravelfactoringFlussoView extends OkApiResponse implements INrTableResponseOfTravelfactoringFlussoView {
    /** Array delle righe della pagina richiesta */
    rows?: TravelfactoringFlussoView[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTravelfactoringFlussoView) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TravelfactoringFlussoView.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfTravelfactoringFlussoView {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTravelfactoringFlussoView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTravelfactoringFlussoView extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TravelfactoringFlussoView[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TravelfactoringListResponse extends NrTableResponseOfTravelfactoringFlussoView implements ITravelfactoringListResponse {

    constructor(data?: ITravelfactoringListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TravelfactoringListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TravelfactoringListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITravelfactoringListResponse extends INrTableResponseOfTravelfactoringFlussoView {
}

export class TravelfactoringFlussoView implements ITravelfactoringFlussoView {
    id?: number;
    creato?: string;
    inviato?: string | null;
    righe?: number;
    importo?: number;

    constructor(data?: ITravelfactoringFlussoView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.creato = _data["creato"] !== undefined ? _data["creato"] : <any>null;
            this.inviato = _data["inviato"] !== undefined ? _data["inviato"] : <any>null;
            this.righe = _data["righe"] !== undefined ? _data["righe"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
        }
    }

    static fromJS(data: any): TravelfactoringFlussoView {
        data = typeof data === 'object' ? data : {};
        let result = new TravelfactoringFlussoView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["creato"] = this.creato !== undefined ? this.creato : <any>null;
        data["inviato"] = this.inviato !== undefined ? this.inviato : <any>null;
        data["righe"] = this.righe !== undefined ? this.righe : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        return data;
    }
}

export interface ITravelfactoringFlussoView {
    id?: number;
    creato?: string;
    inviato?: string | null;
    righe?: number;
    importo?: number;
}

export class TravelfactoringListRequest extends NrTableRequest implements ITravelfactoringListRequest {
    dal?: string | null;
    al?: string | null;

    constructor(data?: ITravelfactoringListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
        }
    }

    static fromJS(data: any): TravelfactoringListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TravelfactoringListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITravelfactoringListRequest extends INrTableRequest {
    dal?: string | null;
    al?: string | null;
}

export class UpdateTravelfactoringRequest extends TravelfactoringGetRequest implements IUpdateTravelfactoringRequest {
    righe?: Travelfactoring_Riga[];

    constructor(data?: IUpdateTravelfactoringRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(Travelfactoring_Riga.fromJS(item));
            }
            else {
                this.righe = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateTravelfactoringRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTravelfactoringRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTravelfactoringRequest extends ITravelfactoringGetRequest {
    righe?: Travelfactoring_Riga[];
}

export class NrTableResponseOfActivityLogsRow extends OkApiResponse implements INrTableResponseOfActivityLogsRow {
    /** Array delle righe della pagina richiesta */
    rows?: ActivityLogsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfActivityLogsRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ActivityLogsRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfActivityLogsRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfActivityLogsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfActivityLogsRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ActivityLogsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TripActivityLogItem implements ITripActivityLogItem {
    transactionID?: string;
    ip?: string | null;
    context?: EActivityContext;
    userID?: number | null;
    tripID?: number | null;
    date?: string;
    operations?: ActivityLogOperation[];

    constructor(data?: ITripActivityLogItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionID = _data["transactionID"] !== undefined ? _data["transactionID"] : <any>null;
            this.ip = _data["ip"] !== undefined ? _data["ip"] : <any>null;
            this.context = _data["context"] !== undefined ? _data["context"] : <any>null;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : <any>null;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(ActivityLogOperation.fromJS(item));
            }
            else {
                this.operations = <any>null;
            }
        }
    }

    static fromJS(data: any): TripActivityLogItem {
        data = typeof data === 'object' ? data : {};
        let result = new TripActivityLogItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionID"] = this.transactionID !== undefined ? this.transactionID : <any>null;
        data["ip"] = this.ip !== undefined ? this.ip : <any>null;
        data["context"] = this.context !== undefined ? this.context : <any>null;
        data["userID"] = this.userID !== undefined ? this.userID : <any>null;
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripActivityLogItem {
    transactionID?: string;
    ip?: string | null;
    context?: EActivityContext;
    userID?: number | null;
    tripID?: number | null;
    date?: string;
    operations?: ActivityLogOperation[];
}

export class SqlTripActivityLogItem extends TripActivityLogItem implements ISqlTripActivityLogItem {
    id?: number;

    constructor(data?: ISqlTripActivityLogItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): SqlTripActivityLogItem {
        data = typeof data === 'object' ? data : {};
        let result = new SqlTripActivityLogItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISqlTripActivityLogItem extends ITripActivityLogItem {
    id?: number;
}

export class ActivityLogsRow extends SqlTripActivityLogItem implements IActivityLogsRow {
    /** OperationsItems but re-declared without JsonIgnore */
    items?: SqlActivityLogOperation[] | null;
    userName?: string | null;

    constructor(data?: IActivityLogsRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SqlActivityLogOperation.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityLogsRow {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IActivityLogsRow extends ISqlTripActivityLogItem {
    /** OperationsItems but re-declared without JsonIgnore */
    items?: SqlActivityLogOperation[] | null;
    userName?: string | null;
}

export class ActivityLogOperation implements IActivityLogOperation {
    operationNr?: number;
    methodType?: string;
    operation?: EDataOperation;
    message?: string | null;
    methodName?: string;
    masterRecordID?: number | null;
    masterTable?: string | null;
    table?: string | null;
    date?: string;
    recordID?: number | null;
    rawDataJObject?: any | null;

    constructor(data?: IActivityLogOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationNr = _data["operationNr"] !== undefined ? _data["operationNr"] : <any>null;
            this.methodType = _data["methodType"] !== undefined ? _data["methodType"] : <any>null;
            this.operation = _data["operation"] !== undefined ? _data["operation"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.methodName = _data["methodName"] !== undefined ? _data["methodName"] : <any>null;
            this.masterRecordID = _data["masterRecordID"] !== undefined ? _data["masterRecordID"] : <any>null;
            this.masterTable = _data["masterTable"] !== undefined ? _data["masterTable"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.recordID = _data["recordID"] !== undefined ? _data["recordID"] : <any>null;
            this.rawDataJObject = _data["rawDataJObject"] !== undefined ? _data["rawDataJObject"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityLogOperation {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogOperation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationNr"] = this.operationNr !== undefined ? this.operationNr : <any>null;
        data["methodType"] = this.methodType !== undefined ? this.methodType : <any>null;
        data["operation"] = this.operation !== undefined ? this.operation : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["methodName"] = this.methodName !== undefined ? this.methodName : <any>null;
        data["masterRecordID"] = this.masterRecordID !== undefined ? this.masterRecordID : <any>null;
        data["masterTable"] = this.masterTable !== undefined ? this.masterTable : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["recordID"] = this.recordID !== undefined ? this.recordID : <any>null;
        data["rawDataJObject"] = this.rawDataJObject !== undefined ? this.rawDataJObject : <any>null;
        return data;
    }
}

export interface IActivityLogOperation {
    operationNr?: number;
    methodType?: string;
    operation?: EDataOperation;
    message?: string | null;
    methodName?: string;
    masterRecordID?: number | null;
    masterTable?: string | null;
    table?: string | null;
    date?: string;
    recordID?: number | null;
    rawDataJObject?: any | null;
}

export class SqlActivityLogOperation extends ActivityLogOperation implements ISqlActivityLogOperation {
    id?: number;
    logItemID?: number;

    constructor(data?: ISqlActivityLogOperation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.logItemID = _data["logItemID"] !== undefined ? _data["logItemID"] : <any>null;
        }
    }

    static fromJS(data: any): SqlActivityLogOperation {
        data = typeof data === 'object' ? data : {};
        let result = new SqlActivityLogOperation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["logItemID"] = this.logItemID !== undefined ? this.logItemID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISqlActivityLogOperation extends IActivityLogOperation {
    id?: number;
    logItemID?: number;
}

export enum EDataOperation {
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
    Select = "Select",
    Restore = "Restore",
}

export enum EActivityContext {
    WEB = "WEB",
    INTRANET = "INTRANET",
    B2B = "B2B",
    B2C = "B2C",
    AGENT = "AGENT",
    AUTOFILL = "AUTOFILL",
    MOBILE = "MOBILE",
}

export class ActivityLogsListRequest extends NrTableRequest implements IActivityLogsListRequest {
    userID?: number | null;
    date?: string | null;
    context?: EActivityContext | null;

    constructor(data?: IActivityLogsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userID = _data["userID"] !== undefined ? _data["userID"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.context = _data["context"] !== undefined ? _data["context"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityLogsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID !== undefined ? this.userID : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["context"] = this.context !== undefined ? this.context : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IActivityLogsListRequest extends INrTableRequest {
    userID?: number | null;
    date?: string | null;
    context?: EActivityContext | null;
}

export class AdditionalDataGetResponse extends OkApiResponse implements IAdditionalDataGetResponse {
    additionalData?: DatoAggiuntivo | null;

    constructor(data?: IAdditionalDataGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalData = _data["additionalData"] ? DatoAggiuntivo.fromJS(_data["additionalData"]) : <any>null;
        }
    }

    static fromJS(data: any): AdditionalDataGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataGetResponse extends IOkApiResponse {
    additionalData?: DatoAggiuntivo | null;
}

export class DatoAggiuntivo implements IDatoAggiuntivo {
    id?: number;
    tipoDatiID?: number;
    traduzioni?: AdditionalDataTranslation[] | null;
    codice?: string | null;
    nome?: string | null;
    nome_en?: string | null;
    ordine?: number | null;
    mostraDescrizione?: boolean;
    priorita?: number | null;
    luogoID?: number | null;
    tipoServizioID?: number | null;
    variabili?: number | null;
    temporizzato?: boolean;
    gif?: number | null;
    gifName?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;

    constructor(data?: IDatoAggiuntivo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tipoDatiID = _data["tipoDatiID"] !== undefined ? _data["tipoDatiID"] : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(AdditionalDataTranslation.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.mostraDescrizione = _data["mostraDescrizione"] !== undefined ? _data["mostraDescrizione"] : <any>null;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.tipoServizioID = _data["tipoServizioID"] !== undefined ? _data["tipoServizioID"] : <any>null;
            this.variabili = _data["variabili"] !== undefined ? _data["variabili"] : <any>null;
            this.temporizzato = _data["temporizzato"] !== undefined ? _data["temporizzato"] : <any>null;
            this.gif = _data["gif"] !== undefined ? _data["gif"] : <any>null;
            this.gifName = _data["gifName"] !== undefined ? _data["gifName"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
        }
    }

    static fromJS(data: any): DatoAggiuntivo {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tipoDatiID"] = this.tipoDatiID !== undefined ? this.tipoDatiID : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["mostraDescrizione"] = this.mostraDescrizione !== undefined ? this.mostraDescrizione : <any>null;
        data["priorita"] = this.priorita !== undefined ? this.priorita : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["tipoServizioID"] = this.tipoServizioID !== undefined ? this.tipoServizioID : <any>null;
        data["variabili"] = this.variabili !== undefined ? this.variabili : <any>null;
        data["temporizzato"] = this.temporizzato !== undefined ? this.temporizzato : <any>null;
        data["gif"] = this.gif !== undefined ? this.gif : <any>null;
        data["gifName"] = this.gifName !== undefined ? this.gifName : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        return data;
    }
}

export interface IDatoAggiuntivo {
    id?: number;
    tipoDatiID?: number;
    traduzioni?: AdditionalDataTranslation[] | null;
    codice?: string | null;
    nome?: string | null;
    nome_en?: string | null;
    ordine?: number | null;
    mostraDescrizione?: boolean;
    priorita?: number | null;
    luogoID?: number | null;
    tipoServizioID?: number | null;
    variabili?: number | null;
    temporizzato?: boolean;
    gif?: number | null;
    gifName?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
}

export class WebTranslation implements IWebTranslation {
    id?: number;
    table!: string;
    entityID!: number;
    lang!: ELingua;
    culture?: string | null;
    translation!: string;
    lastUpdate?: string | null;
    confirmed?: boolean | null;
    deleted?: string | null;

    constructor(data?: IWebTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
            this.entityID = _data["entityID"] !== undefined ? _data["entityID"] : <any>null;
            this.lang = _data["lang"] !== undefined ? _data["lang"] : <any>null;
            this.culture = _data["culture"] !== undefined ? _data["culture"] : <any>null;
            this.translation = _data["translation"] !== undefined ? _data["translation"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
        }
    }

    static fromJS(data: any): WebTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new WebTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        data["entityID"] = this.entityID !== undefined ? this.entityID : <any>null;
        data["lang"] = this.lang !== undefined ? this.lang : <any>null;
        data["culture"] = this.culture !== undefined ? this.culture : <any>null;
        data["translation"] = this.translation !== undefined ? this.translation : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        return data;
    }
}

export interface IWebTranslation {
    id?: number;
    table: string;
    entityID: number;
    lang: ELingua;
    culture?: string | null;
    translation: string;
    lastUpdate?: string | null;
    confirmed?: boolean | null;
    deleted?: string | null;
}

export class AdditionalDataTranslation extends WebTranslation implements IAdditionalDataTranslation {

    constructor(data?: IAdditionalDataTranslation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdditionalDataTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataTranslation extends IWebTranslation {
}

export class AdditionalDataGetRequest extends ApiRequest implements IAdditionalDataGetRequest {
    additionalDataID!: number;

    constructor(data?: IAdditionalDataGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalDataID = _data["additionalDataID"] !== undefined ? _data["additionalDataID"] : <any>null;
        }
    }

    static fromJS(data: any): AdditionalDataGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalDataID"] = this.additionalDataID !== undefined ? this.additionalDataID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataGetRequest extends IApiRequest {
    additionalDataID: number;
}

export class AdditionalDataUpdateRequest extends AdditionalDataGetRequest implements IAdditionalDataUpdateRequest {
    additionalData!: DatoAggiuntivo;

    constructor(data?: IAdditionalDataUpdateRequest) {
        super(data);
        if (!data) {
            this.additionalData = new DatoAggiuntivo();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalData = _data["additionalData"] ? DatoAggiuntivo.fromJS(_data["additionalData"]) : new DatoAggiuntivo();
        }
    }

    static fromJS(data: any): AdditionalDataUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataUpdateRequest extends IAdditionalDataGetRequest {
    additionalData: DatoAggiuntivo;
}

export class AdditionalDataDeleteRequest extends AdditionalDataGetRequest implements IAdditionalDataDeleteRequest {

    constructor(data?: IAdditionalDataDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdditionalDataDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataDeleteRequest extends IAdditionalDataGetRequest {
}

export class NrTableResponseOfAdditionalDataRow extends OkApiResponse implements INrTableResponseOfAdditionalDataRow {
    /** Array delle righe della pagina richiesta */
    rows?: AdditionalDataRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAdditionalDataRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AdditionalDataRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfAdditionalDataRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAdditionalDataRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAdditionalDataRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AdditionalDataRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class AdditionalDataListResponse extends NrTableResponseOfAdditionalDataRow implements IAdditionalDataListResponse {

    constructor(data?: IAdditionalDataListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdditionalDataListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataListResponse extends INrTableResponseOfAdditionalDataRow {
}

export class AdditionalDataRow implements IAdditionalDataRow {
    id?: number;
    type?: string;
    name?: string | null;
    place?: string;
    serviceType?: string;
    order?: number | null;
    priority?: number | null;
    additionalData?: DatoAggiuntivo | null;

    constructor(data?: IAdditionalDataRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.place = _data["place"] !== undefined ? _data["place"] : <any>null;
            this.serviceType = _data["serviceType"] !== undefined ? _data["serviceType"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.additionalData = _data["additionalData"] ? DatoAggiuntivo.fromJS(_data["additionalData"]) : <any>null;
        }
    }

    static fromJS(data: any): AdditionalDataRow {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["place"] = this.place !== undefined ? this.place : <any>null;
        data["serviceType"] = this.serviceType !== undefined ? this.serviceType : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>null;
        return data;
    }
}

export interface IAdditionalDataRow {
    id?: number;
    type?: string;
    name?: string | null;
    place?: string;
    serviceType?: string;
    order?: number | null;
    priority?: number | null;
    additionalData?: DatoAggiuntivo | null;
}

export class AdditionalDataListRequest extends NrTableRequest implements IAdditionalDataListRequest {
    term?: string | null;
    typeID?: number | null;
    placeID?: number | null;

    constructor(data?: IAdditionalDataListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : <any>null;
            this.placeID = _data["placeID"] !== undefined ? _data["placeID"] : <any>null;
        }
    }

    static fromJS(data: any): AdditionalDataListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["typeID"] = this.typeID !== undefined ? this.typeID : <any>null;
        data["placeID"] = this.placeID !== undefined ? this.placeID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataListRequest extends INrTableRequest {
    term?: string | null;
    typeID?: number | null;
    placeID?: number | null;
}

export class AdditionalDataUpdateResponse extends AdditionalDataGetResponse implements IAdditionalDataUpdateResponse {

    constructor(data?: IAdditionalDataUpdateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdditionalDataUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataUpdateResponse extends IAdditionalDataGetResponse {
}

export class AdditionalsDataTypesGetRequest extends ApiRequest implements IAdditionalsDataTypesGetRequest {
    id!: number;

    constructor(data?: IAdditionalsDataTypesGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AdditionalsDataTypesGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalsDataTypesGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalsDataTypesGetRequest extends IApiRequest {
    id: number;
}

export class AdditionalsDataTypesUpdateRequest extends AdditionalsDataTypesGetRequest implements IAdditionalsDataTypesUpdateRequest {
    additionalDataType!: DatoAggiuntivoTipo;

    constructor(data?: IAdditionalsDataTypesUpdateRequest) {
        super(data);
        if (!data) {
            this.additionalDataType = new DatoAggiuntivoTipo();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalDataType = _data["additionalDataType"] ? DatoAggiuntivoTipo.fromJS(_data["additionalDataType"]) : new DatoAggiuntivoTipo();
        }
    }

    static fromJS(data: any): AdditionalsDataTypesUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalsDataTypesUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalDataType"] = this.additionalDataType ? this.additionalDataType.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalsDataTypesUpdateRequest extends IAdditionalsDataTypesGetRequest {
    additionalDataType: DatoAggiuntivoTipo;
}

export class DatoAggiuntivoTipo implements IDatoAggiuntivoTipo {
    id?: number;
    tipoDatiID?: number;
    traduzioni?: AdditionalDataTypeTranslation[] | null;
    tipoServizio?: ETipoServizio | null;
    nome!: string;
    ordine?: number | null;
    usaPerRicerca?: boolean;
    codice?: string | null;
    standard?: boolean;
    nome_en?: string | null;
    mostra_descr?: number | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;

    constructor(data?: IDatoAggiuntivoTipo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tipoDatiID = _data["tipoDatiID"] !== undefined ? _data["tipoDatiID"] : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(AdditionalDataTypeTranslation.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.usaPerRicerca = _data["usaPerRicerca"] !== undefined ? _data["usaPerRicerca"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.standard = _data["standard"] !== undefined ? _data["standard"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.mostra_descr = _data["mostra_descr"] !== undefined ? _data["mostra_descr"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
        }
    }

    static fromJS(data: any): DatoAggiuntivoTipo {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoTipo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tipoDatiID"] = this.tipoDatiID !== undefined ? this.tipoDatiID : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["usaPerRicerca"] = this.usaPerRicerca !== undefined ? this.usaPerRicerca : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["standard"] = this.standard !== undefined ? this.standard : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["mostra_descr"] = this.mostra_descr !== undefined ? this.mostra_descr : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        return data;
    }
}

export interface IDatoAggiuntivoTipo {
    id?: number;
    tipoDatiID?: number;
    traduzioni?: AdditionalDataTypeTranslation[] | null;
    tipoServizio?: ETipoServizio | null;
    nome: string;
    ordine?: number | null;
    usaPerRicerca?: boolean;
    codice?: string | null;
    standard?: boolean;
    nome_en?: string | null;
    mostra_descr?: number | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
}

export class AdditionalDataTypeTranslation extends WebTranslation implements IAdditionalDataTypeTranslation {

    constructor(data?: IAdditionalDataTypeTranslation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdditionalDataTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataTypeTranslation extends IWebTranslation {
}

export enum ETipoServizio {
    TrasferimentiEVisite = "TrasferimentiEVisite",
    NoleggiAuto = "NoleggiAuto",
    SelfDrive = "SelfDrive",
    TourECrociere = "TourECrociere",
    Hotel = "Hotel",
    KitViaggio = "KitViaggio",
    Pacchetti = "Pacchetti",
    Voli = "Voli",
    KitViaggioOLD = "KitViaggioOLD",
    ItinerariConsigliati = "ItinerariConsigliati",
    PacchettiDinamici = "PacchettiDinamici",
    PacchettiCatalogo = "PacchettiCatalogo",
}

export class AdditionalsDataTypesDeleteResponse extends OkApiResponse implements IAdditionalsDataTypesDeleteResponse {

    constructor(data?: IAdditionalsDataTypesDeleteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdditionalsDataTypesDeleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalsDataTypesDeleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalsDataTypesDeleteResponse extends IOkApiResponse {
}

export class AdditionalsDataTypesDeleteRequest extends AdditionalsDataTypesGetRequest implements IAdditionalsDataTypesDeleteRequest {

    constructor(data?: IAdditionalsDataTypesDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdditionalsDataTypesDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalsDataTypesDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalsDataTypesDeleteRequest extends IAdditionalsDataTypesGetRequest {
}

export class AdditionalsDataTypesGetResponse extends OkApiResponse implements IAdditionalsDataTypesGetResponse {
    additionalDataType?: DatoAggiuntivoTipo | null;

    constructor(data?: IAdditionalsDataTypesGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.additionalDataType = _data["additionalDataType"] ? DatoAggiuntivoTipo.fromJS(_data["additionalDataType"]) : <any>null;
        }
    }

    static fromJS(data: any): AdditionalsDataTypesGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalsDataTypesGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalDataType"] = this.additionalDataType ? this.additionalDataType.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalsDataTypesGetResponse extends IOkApiResponse {
    additionalDataType?: DatoAggiuntivoTipo | null;
}

export class NrTableResponseOfAdditionalDataTypeRow extends OkApiResponse implements INrTableResponseOfAdditionalDataTypeRow {
    /** Array delle righe della pagina richiesta */
    rows?: AdditionalDataTypeRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAdditionalDataTypeRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AdditionalDataTypeRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfAdditionalDataTypeRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAdditionalDataTypeRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAdditionalDataTypeRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AdditionalDataTypeRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class AdditionalDataTypeListResponse extends NrTableResponseOfAdditionalDataTypeRow implements IAdditionalDataTypeListResponse {

    constructor(data?: IAdditionalDataTypeListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdditionalDataTypeListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataTypeListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalDataTypeListResponse extends INrTableResponseOfAdditionalDataTypeRow {
}

export class AdditionalDataTypeRow implements IAdditionalDataTypeRow {
    id?: number;
    order?: number | null;
    type?: string | null;
    ricerca?: boolean;
    standard?: boolean;
    mostra_desc?: number | null;
    name?: string;
    name_en?: string | null;
    name_ep?: string | null;
    name_fr?: string | null;
    name_de?: string | null;
    name_es?: string | null;
    serviceType?: ETipoServizio | null;

    constructor(data?: IAdditionalDataTypeRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.ricerca = _data["ricerca"] !== undefined ? _data["ricerca"] : <any>null;
            this.standard = _data["standard"] !== undefined ? _data["standard"] : <any>null;
            this.mostra_desc = _data["mostra_desc"] !== undefined ? _data["mostra_desc"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.name_en = _data["name_en"] !== undefined ? _data["name_en"] : <any>null;
            this.name_ep = _data["name_ep"] !== undefined ? _data["name_ep"] : <any>null;
            this.name_fr = _data["name_fr"] !== undefined ? _data["name_fr"] : <any>null;
            this.name_de = _data["name_de"] !== undefined ? _data["name_de"] : <any>null;
            this.name_es = _data["name_es"] !== undefined ? _data["name_es"] : <any>null;
            this.serviceType = _data["serviceType"] !== undefined ? _data["serviceType"] : <any>null;
        }
    }

    static fromJS(data: any): AdditionalDataTypeRow {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDataTypeRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["ricerca"] = this.ricerca !== undefined ? this.ricerca : <any>null;
        data["standard"] = this.standard !== undefined ? this.standard : <any>null;
        data["mostra_desc"] = this.mostra_desc !== undefined ? this.mostra_desc : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["name_en"] = this.name_en !== undefined ? this.name_en : <any>null;
        data["name_ep"] = this.name_ep !== undefined ? this.name_ep : <any>null;
        data["name_fr"] = this.name_fr !== undefined ? this.name_fr : <any>null;
        data["name_de"] = this.name_de !== undefined ? this.name_de : <any>null;
        data["name_es"] = this.name_es !== undefined ? this.name_es : <any>null;
        data["serviceType"] = this.serviceType !== undefined ? this.serviceType : <any>null;
        return data;
    }
}

export interface IAdditionalDataTypeRow {
    id?: number;
    order?: number | null;
    type?: string | null;
    ricerca?: boolean;
    standard?: boolean;
    mostra_desc?: number | null;
    name?: string;
    name_en?: string | null;
    name_ep?: string | null;
    name_fr?: string | null;
    name_de?: string | null;
    name_es?: string | null;
    serviceType?: ETipoServizio | null;
}

export class AdditionalsDataTypesListRequest extends NrTableRequest implements IAdditionalsDataTypesListRequest {
    term?: string | null;
    serviceID?: number | null;

    constructor(data?: IAdditionalsDataTypesListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : <any>null;
        }
    }

    static fromJS(data: any): AdditionalsDataTypesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalsDataTypesListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalsDataTypesListRequest extends INrTableRequest {
    term?: string | null;
    serviceID?: number | null;
}

export class NrTableResponseOfEmailForwarderLogRow extends OkApiResponse implements INrTableResponseOfEmailForwarderLogRow {
    /** Array delle righe della pagina richiesta */
    rows?: EmailForwarderLogRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfEmailForwarderLogRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EmailForwarderLogRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfEmailForwarderLogRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfEmailForwarderLogRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfEmailForwarderLogRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: EmailForwarderLogRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetEmailForwarderLogResponse extends NrTableResponseOfEmailForwarderLogRow implements IGetEmailForwarderLogResponse {

    constructor(data?: IGetEmailForwarderLogResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetEmailForwarderLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailForwarderLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetEmailForwarderLogResponse extends INrTableResponseOfEmailForwarderLogRow {
}

export class EmailForwarderLogRow implements IEmailForwarderLogRow {
    id?: number;
    contactID?: number | null;
    forwardedDate?: string | null;
    senderEmail?: string | null;
    forwardedToEmail?: string | null;
    statusID?: EEmailForwardedStatus | null;
    mailSubject?: string | null;
    reservationNumber?: string | null;
    offertaID?: number | null;

    constructor(data?: IEmailForwarderLogRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : <any>null;
            this.forwardedDate = _data["forwardedDate"] !== undefined ? _data["forwardedDate"] : <any>null;
            this.senderEmail = _data["senderEmail"] !== undefined ? _data["senderEmail"] : <any>null;
            this.forwardedToEmail = _data["forwardedToEmail"] !== undefined ? _data["forwardedToEmail"] : <any>null;
            this.statusID = _data["statusID"] !== undefined ? _data["statusID"] : <any>null;
            this.mailSubject = _data["mailSubject"] !== undefined ? _data["mailSubject"] : <any>null;
            this.reservationNumber = _data["reservationNumber"] !== undefined ? _data["reservationNumber"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
        }
    }

    static fromJS(data: any): EmailForwarderLogRow {
        data = typeof data === 'object' ? data : {};
        let result = new EmailForwarderLogRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["contactID"] = this.contactID !== undefined ? this.contactID : <any>null;
        data["forwardedDate"] = this.forwardedDate !== undefined ? this.forwardedDate : <any>null;
        data["senderEmail"] = this.senderEmail !== undefined ? this.senderEmail : <any>null;
        data["forwardedToEmail"] = this.forwardedToEmail !== undefined ? this.forwardedToEmail : <any>null;
        data["statusID"] = this.statusID !== undefined ? this.statusID : <any>null;
        data["mailSubject"] = this.mailSubject !== undefined ? this.mailSubject : <any>null;
        data["reservationNumber"] = this.reservationNumber !== undefined ? this.reservationNumber : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        return data;
    }
}

export interface IEmailForwarderLogRow {
    id?: number;
    contactID?: number | null;
    forwardedDate?: string | null;
    senderEmail?: string | null;
    forwardedToEmail?: string | null;
    statusID?: EEmailForwardedStatus | null;
    mailSubject?: string | null;
    reservationNumber?: string | null;
    offertaID?: number | null;
}

export enum EEmailForwardedStatus {
    Ok = "Ok",
    Error = "Error",
    NotForwarded = "NotForwarded",
}

export class GetEmailForwarderLogRequest extends NrTableRequest implements IGetEmailForwarderLogRequest {
    startDate?: string | null;
    endDate?: string | null;
    toEmail?: string | null;
    fromEmail?: string | null;
    subject?: string | null;
    status?: EEmailForwardedStatus | null;
    contactID?: number | null;
    reservationNumber?: string | null;
    offertaID?: number | null;
    externalOnly?: boolean;

    constructor(data?: IGetEmailForwarderLogRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : <any>null;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : <any>null;
            this.toEmail = _data["toEmail"] !== undefined ? _data["toEmail"] : <any>null;
            this.fromEmail = _data["fromEmail"] !== undefined ? _data["fromEmail"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : <any>null;
            this.reservationNumber = _data["reservationNumber"] !== undefined ? _data["reservationNumber"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.externalOnly = _data["externalOnly"] !== undefined ? _data["externalOnly"] : <any>null;
        }
    }

    static fromJS(data: any): GetEmailForwarderLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailForwarderLogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : <any>null;
        data["toEmail"] = this.toEmail !== undefined ? this.toEmail : <any>null;
        data["fromEmail"] = this.fromEmail !== undefined ? this.fromEmail : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["contactID"] = this.contactID !== undefined ? this.contactID : <any>null;
        data["reservationNumber"] = this.reservationNumber !== undefined ? this.reservationNumber : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["externalOnly"] = this.externalOnly !== undefined ? this.externalOnly : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetEmailForwarderLogRequest extends INrTableRequest {
    startDate?: string | null;
    endDate?: string | null;
    toEmail?: string | null;
    fromEmail?: string | null;
    subject?: string | null;
    status?: EEmailForwardedStatus | null;
    contactID?: number | null;
    reservationNumber?: string | null;
    offertaID?: number | null;
    externalOnly?: boolean;
}

export class AdvancePaymentGetRequest extends LocalizedRequest implements IAdvancePaymentGetRequest {
    /** ID dell'entità da recuperare */
    id?: number;

    constructor(data?: IAdvancePaymentGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AdvancePaymentGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdvancePaymentGetRequest extends ILocalizedRequest {
    /** ID dell'entità da recuperare */
    id?: number;
}

export class AdvancePaymentDeletePreviewResponse extends OkApiResponse implements IAdvancePaymentDeletePreviewResponse {
    /** Se true è possibile procedere all'eliminazione */
    okToDelete?: boolean;
    /** Numero di righe di dati offerte che hanno l'ID che si sta per cancellare */
    affectedCount?: number;

    constructor(data?: IAdvancePaymentDeletePreviewResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.okToDelete = _data["okToDelete"] !== undefined ? _data["okToDelete"] : <any>null;
            this.affectedCount = _data["affectedCount"] !== undefined ? _data["affectedCount"] : <any>null;
        }
    }

    static fromJS(data: any): AdvancePaymentDeletePreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentDeletePreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["okToDelete"] = this.okToDelete !== undefined ? this.okToDelete : <any>null;
        data["affectedCount"] = this.affectedCount !== undefined ? this.affectedCount : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdvancePaymentDeletePreviewResponse extends IOkApiResponse {
    /** Se true è possibile procedere all'eliminazione */
    okToDelete?: boolean;
    /** Numero di righe di dati offerte che hanno l'ID che si sta per cancellare */
    affectedCount?: number;
}

export class AdvancePaymentGetResponse extends OkApiResponse implements IAdvancePaymentGetResponse {
    /** Entità letta */
    servizioAnticipoFornitore?: ServizioAnticipoFornitore;

    constructor(data?: IAdvancePaymentGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAnticipoFornitore = _data["servizioAnticipoFornitore"] ? ServizioAnticipoFornitore.fromJS(_data["servizioAnticipoFornitore"]) : <any>null;
        }
    }

    static fromJS(data: any): AdvancePaymentGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAnticipoFornitore"] = this.servizioAnticipoFornitore ? this.servizioAnticipoFornitore.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdvancePaymentGetResponse extends IOkApiResponse {
    /** Entità letta */
    servizioAnticipoFornitore?: ServizioAnticipoFornitore;
}

export class ServizioAnticipoFornitore implements IServizioAnticipoFornitore {
    id?: number;
    nome!: string;
    servizioID?: number | null;
    accordoID?: number | null;
    luogoID?: number | null;
    tipoServizio?: ETipoServizio | null;
    dal?: string | null;
    al?: string | null;
    ordine?: number;
    note?: string | null;
    tipoAnticipo?: ETipoAnticipoFornitore;
    valore?: number;
    moltiplicaPerPax?: boolean;
    valutaID?: number | null;
    entroGiorni?: number | null;
    entroGiorniDaInizioServizio?: boolean;

    constructor(data?: IServizioAnticipoFornitore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.tipoAnticipo = _data["tipoAnticipo"] !== undefined ? _data["tipoAnticipo"] : <any>null;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : <any>null;
            this.moltiplicaPerPax = _data["moltiplicaPerPax"] !== undefined ? _data["moltiplicaPerPax"] : <any>null;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : <any>null;
            this.entroGiorni = _data["entroGiorni"] !== undefined ? _data["entroGiorni"] : <any>null;
            this.entroGiorniDaInizioServizio = _data["entroGiorniDaInizioServizio"] !== undefined ? _data["entroGiorniDaInizioServizio"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioAnticipoFornitore {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAnticipoFornitore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["tipoAnticipo"] = this.tipoAnticipo !== undefined ? this.tipoAnticipo : <any>null;
        data["valore"] = this.valore !== undefined ? this.valore : <any>null;
        data["moltiplicaPerPax"] = this.moltiplicaPerPax !== undefined ? this.moltiplicaPerPax : <any>null;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : <any>null;
        data["entroGiorni"] = this.entroGiorni !== undefined ? this.entroGiorni : <any>null;
        data["entroGiorniDaInizioServizio"] = this.entroGiorniDaInizioServizio !== undefined ? this.entroGiorniDaInizioServizio : <any>null;
        return data;
    }
}

export interface IServizioAnticipoFornitore {
    id?: number;
    nome: string;
    servizioID?: number | null;
    accordoID?: number | null;
    luogoID?: number | null;
    tipoServizio?: ETipoServizio | null;
    dal?: string | null;
    al?: string | null;
    ordine?: number;
    note?: string | null;
    tipoAnticipo?: ETipoAnticipoFornitore;
    valore?: number;
    moltiplicaPerPax?: boolean;
    valutaID?: number | null;
    entroGiorni?: number | null;
    entroGiorniDaInizioServizio?: boolean;
}

export enum ETipoAnticipoFornitore {
    ImportoFisso = "ImportoFisso",
    Percentuale = "Percentuale",
    Notti = "Notti",
}

export class NrTableResponseOfAdvancePaymentRow extends OkApiResponse implements INrTableResponseOfAdvancePaymentRow {
    /** Array delle righe della pagina richiesta */
    rows?: AdvancePaymentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAdvancePaymentRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AdvancePaymentRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfAdvancePaymentRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAdvancePaymentRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAdvancePaymentRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AdvancePaymentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class AdvancePaymentsList extends NrTableResponseOfAdvancePaymentRow implements IAdvancePaymentsList {

    constructor(data?: IAdvancePaymentsList) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AdvancePaymentsList {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAdvancePaymentsList extends INrTableResponseOfAdvancePaymentRow {
}

export class AdvancePaymentRow implements IAdvancePaymentRow {
    /** ID dell'entità */
    id?: number;
    /** Entità */
    servizioAnticipoFornitore?: ServizioAnticipoFornitore;
    /** Nome in lingua del servizio (se c'è) */
    servizio?: string | null;
    /** True se il servizio è obsoleto */
    servizioObsoleto?: boolean;
    /** True se il servizio è eliminato */
    servizioEliminato?: boolean;
    /** Nome dell'accordo (se c'è) */
    accordo?: string | null;
    /** Nome in lingua del luogo (se c'è) */
    luogo?: string | null;
    luogoEliminato?: boolean;

    constructor(data?: IAdvancePaymentRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioAnticipoFornitore = _data["servizioAnticipoFornitore"] ? ServizioAnticipoFornitore.fromJS(_data["servizioAnticipoFornitore"]) : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.servizioObsoleto = _data["servizioObsoleto"] !== undefined ? _data["servizioObsoleto"] : <any>null;
            this.servizioEliminato = _data["servizioEliminato"] !== undefined ? _data["servizioEliminato"] : <any>null;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.luogoEliminato = _data["luogoEliminato"] !== undefined ? _data["luogoEliminato"] : <any>null;
        }
    }

    static fromJS(data: any): AdvancePaymentRow {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioAnticipoFornitore"] = this.servizioAnticipoFornitore ? this.servizioAnticipoFornitore.toJSON() : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["servizioObsoleto"] = this.servizioObsoleto !== undefined ? this.servizioObsoleto : <any>null;
        data["servizioEliminato"] = this.servizioEliminato !== undefined ? this.servizioEliminato : <any>null;
        data["accordo"] = this.accordo !== undefined ? this.accordo : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["luogoEliminato"] = this.luogoEliminato !== undefined ? this.luogoEliminato : <any>null;
        return data;
    }
}

export interface IAdvancePaymentRow {
    /** ID dell'entità */
    id?: number;
    /** Entità */
    servizioAnticipoFornitore?: ServizioAnticipoFornitore;
    /** Nome in lingua del servizio (se c'è) */
    servizio?: string | null;
    /** True se il servizio è obsoleto */
    servizioObsoleto?: boolean;
    /** True se il servizio è eliminato */
    servizioEliminato?: boolean;
    /** Nome dell'accordo (se c'è) */
    accordo?: string | null;
    /** Nome in lingua del luogo (se c'è) */
    luogo?: string | null;
    luogoEliminato?: boolean;
}

export class AdvancePaymentsListRequest extends NrTableRequest implements IAdvancePaymentsListRequest {
    /** Testo da cercare nelle note */
    term?: string | null;
    /** Accordo associato */
    accordoID?: number | null;
    /** Solo non associati ad accordo */
    noAccordo?: boolean;
    /** Tipo di servizio associato */
    tipoServizio?: ETipoServizio | null;
    /** Sono non associati a tipo servizio */
    noTipoServizio?: boolean;
    /** Servizio associato */
    servizioID?: number | null;
    /** Solo non associati a servizio */
    noServizio?: boolean;
    /** Luogo associato */
    luogoID?: number | null;
    /** Solo non associati a luogo */
    noLuogo?: boolean;

    constructor(data?: IAdvancePaymentsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.noAccordo = _data["noAccordo"] !== undefined ? _data["noAccordo"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.noTipoServizio = _data["noTipoServizio"] !== undefined ? _data["noTipoServizio"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.noServizio = _data["noServizio"] !== undefined ? _data["noServizio"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.noLuogo = _data["noLuogo"] !== undefined ? _data["noLuogo"] : <any>null;
        }
    }

    static fromJS(data: any): AdvancePaymentsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["noAccordo"] = this.noAccordo !== undefined ? this.noAccordo : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["noTipoServizio"] = this.noTipoServizio !== undefined ? this.noTipoServizio : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["noServizio"] = this.noServizio !== undefined ? this.noServizio : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["noLuogo"] = this.noLuogo !== undefined ? this.noLuogo : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdvancePaymentsListRequest extends INrTableRequest {
    /** Testo da cercare nelle note */
    term?: string | null;
    /** Accordo associato */
    accordoID?: number | null;
    /** Solo non associati ad accordo */
    noAccordo?: boolean;
    /** Tipo di servizio associato */
    tipoServizio?: ETipoServizio | null;
    /** Sono non associati a tipo servizio */
    noTipoServizio?: boolean;
    /** Servizio associato */
    servizioID?: number | null;
    /** Solo non associati a servizio */
    noServizio?: boolean;
    /** Luogo associato */
    luogoID?: number | null;
    /** Solo non associati a luogo */
    noLuogo?: boolean;
}

export class AdvancePaymentUpsertRequest extends LocalizedRequest implements IAdvancePaymentUpsertRequest {
    /** Entità da persistere (nuova o modificata) */
    servizioAnticipoFornitore?: ServizioAnticipoFornitoreBase;

    constructor(data?: IAdvancePaymentUpsertRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAnticipoFornitore = _data["servizioAnticipoFornitore"] ? ServizioAnticipoFornitoreBase.fromJS(_data["servizioAnticipoFornitore"]) : <any>null;
        }
    }

    static fromJS(data: any): AdvancePaymentUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAnticipoFornitore"] = this.servizioAnticipoFornitore ? this.servizioAnticipoFornitore.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdvancePaymentUpsertRequest extends ILocalizedRequest {
    /** Entità da persistere (nuova o modificata) */
    servizioAnticipoFornitore?: ServizioAnticipoFornitoreBase;
}

export abstract class ServizioAnticipoFornitoreBase implements IServizioAnticipoFornitoreBase {
    id?: number;
    nome?: string;
    servizioID?: number | null;
    accordoID?: number | null;
    luogoID?: number | null;
    tipoServizio?: ETipoServizio | null;
    dal?: string | null;
    al?: string | null;
    ordine?: number;
    note?: string | null;
    tipoAnticipo?: ETipoAnticipoFornitore;
    valore?: number;
    moltiplicaPerPax?: boolean;
    valutaID?: number | null;
    entroGiorni?: number | null;
    entroGiorniDaInizioServizio?: boolean;

    constructor(data?: IServizioAnticipoFornitoreBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.tipoAnticipo = _data["tipoAnticipo"] !== undefined ? _data["tipoAnticipo"] : <any>null;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : <any>null;
            this.moltiplicaPerPax = _data["moltiplicaPerPax"] !== undefined ? _data["moltiplicaPerPax"] : <any>null;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : <any>null;
            this.entroGiorni = _data["entroGiorni"] !== undefined ? _data["entroGiorni"] : <any>null;
            this.entroGiorniDaInizioServizio = _data["entroGiorniDaInizioServizio"] !== undefined ? _data["entroGiorniDaInizioServizio"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioAnticipoFornitoreBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioAnticipoFornitoreBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["tipoAnticipo"] = this.tipoAnticipo !== undefined ? this.tipoAnticipo : <any>null;
        data["valore"] = this.valore !== undefined ? this.valore : <any>null;
        data["moltiplicaPerPax"] = this.moltiplicaPerPax !== undefined ? this.moltiplicaPerPax : <any>null;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : <any>null;
        data["entroGiorni"] = this.entroGiorni !== undefined ? this.entroGiorni : <any>null;
        data["entroGiorniDaInizioServizio"] = this.entroGiorniDaInizioServizio !== undefined ? this.entroGiorniDaInizioServizio : <any>null;
        return data;
    }
}

export interface IServizioAnticipoFornitoreBase {
    id?: number;
    nome?: string;
    servizioID?: number | null;
    accordoID?: number | null;
    luogoID?: number | null;
    tipoServizio?: ETipoServizio | null;
    dal?: string | null;
    al?: string | null;
    ordine?: number;
    note?: string | null;
    tipoAnticipo?: ETipoAnticipoFornitore;
    valore?: number;
    moltiplicaPerPax?: boolean;
    valutaID?: number | null;
    entroGiorni?: number | null;
    entroGiorniDaInizioServizio?: boolean;
}

export class HelpContentGetResponse extends OkApiResponse implements IHelpContentGetResponse {
    videos?: YouTubeVideo[] | null;
    nextPageToken?: string | null;
    prevPageToken?: string | null;

    constructor(data?: IHelpContentGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(YouTubeVideo.fromJS(item));
            }
            else {
                this.videos = <any>null;
            }
            this.nextPageToken = _data["nextPageToken"] !== undefined ? _data["nextPageToken"] : <any>null;
            this.prevPageToken = _data["prevPageToken"] !== undefined ? _data["prevPageToken"] : <any>null;
        }
    }

    static fromJS(data: any): HelpContentGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HelpContentGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        data["nextPageToken"] = this.nextPageToken !== undefined ? this.nextPageToken : <any>null;
        data["prevPageToken"] = this.prevPageToken !== undefined ? this.prevPageToken : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IHelpContentGetResponse extends IOkApiResponse {
    videos?: YouTubeVideo[] | null;
    nextPageToken?: string | null;
    prevPageToken?: string | null;
}

export class YouTubeVideo implements IYouTubeVideo {
    id?: string | null;
    publishedAt?: string;
    player?: string | null;
    title?: string | null;
    tags?: string[] | null;
    thumbnails?: YouTubeThumbnails | null;

    constructor(data?: IYouTubeVideo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.publishedAt = _data["publishedAt"] !== undefined ? _data["publishedAt"] : <any>null;
            this.player = _data["player"] !== undefined ? _data["player"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            else {
                this.tags = <any>null;
            }
            this.thumbnails = _data["thumbnails"] ? YouTubeThumbnails.fromJS(_data["thumbnails"]) : <any>null;
        }
    }

    static fromJS(data: any): YouTubeVideo {
        data = typeof data === 'object' ? data : {};
        let result = new YouTubeVideo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["publishedAt"] = this.publishedAt !== undefined ? this.publishedAt : <any>null;
        data["player"] = this.player !== undefined ? this.player : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["thumbnails"] = this.thumbnails ? this.thumbnails.toJSON() : <any>null;
        return data;
    }
}

export interface IYouTubeVideo {
    id?: string | null;
    publishedAt?: string;
    player?: string | null;
    title?: string | null;
    tags?: string[] | null;
    thumbnails?: YouTubeThumbnails | null;
}

export class YouTubeThumbnails implements IYouTubeThumbnails {
    default?: YouTubeThumbnail | null;
    medium?: YouTubeThumbnail | null;
    high?: YouTubeThumbnail | null;
    standard?: YouTubeThumbnail | null;
    maxres?: YouTubeThumbnail | null;

    constructor(data?: IYouTubeThumbnails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.default = _data["default"] ? YouTubeThumbnail.fromJS(_data["default"]) : <any>null;
            this.medium = _data["medium"] ? YouTubeThumbnail.fromJS(_data["medium"]) : <any>null;
            this.high = _data["high"] ? YouTubeThumbnail.fromJS(_data["high"]) : <any>null;
            this.standard = _data["standard"] ? YouTubeThumbnail.fromJS(_data["standard"]) : <any>null;
            this.maxres = _data["maxres"] ? YouTubeThumbnail.fromJS(_data["maxres"]) : <any>null;
        }
    }

    static fromJS(data: any): YouTubeThumbnails {
        data = typeof data === 'object' ? data : {};
        let result = new YouTubeThumbnails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["default"] = this.default ? this.default.toJSON() : <any>null;
        data["medium"] = this.medium ? this.medium.toJSON() : <any>null;
        data["high"] = this.high ? this.high.toJSON() : <any>null;
        data["standard"] = this.standard ? this.standard.toJSON() : <any>null;
        data["maxres"] = this.maxres ? this.maxres.toJSON() : <any>null;
        return data;
    }
}

export interface IYouTubeThumbnails {
    default?: YouTubeThumbnail | null;
    medium?: YouTubeThumbnail | null;
    high?: YouTubeThumbnail | null;
    standard?: YouTubeThumbnail | null;
    maxres?: YouTubeThumbnail | null;
}

export class YouTubeThumbnail implements IYouTubeThumbnail {
    url?: string | null;
    width?: number;
    height?: number;

    constructor(data?: IYouTubeThumbnail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
        }
    }

    static fromJS(data: any): YouTubeThumbnail {
        data = typeof data === 'object' ? data : {};
        let result = new YouTubeThumbnail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        return data;
    }
}

export interface IYouTubeThumbnail {
    url?: string | null;
    width?: number;
    height?: number;
}

export class HelpContentGetRequest extends ApiRequest implements IHelpContentGetRequest {
    pageSize?: number;
    pageToken?: string | null;

    constructor(data?: IHelpContentGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.pageToken = _data["pageToken"] !== undefined ? _data["pageToken"] : <any>null;
        }
    }

    static fromJS(data: any): HelpContentGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HelpContentGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["pageToken"] = this.pageToken !== undefined ? this.pageToken : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IHelpContentGetRequest extends IApiRequest {
    pageSize?: number;
    pageToken?: string | null;
}

export class NaarAIChatRequestResponse extends OkApiResponse implements INaarAIChatRequestResponse {
    message?: string;

    constructor(data?: INaarAIChatRequestResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): NaarAIChatRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIChatRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAIChatRequestResponse extends IOkApiResponse {
    message?: string;
}

export class NaarAIChatRequestRequest extends LocalizedRequest implements INaarAIChatRequestRequest {
    message?: string;
    newChat?: boolean;

    constructor(data?: INaarAIChatRequestRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.newChat = _data["newChat"] !== undefined ? _data["newChat"] : <any>null;
        }
    }

    static fromJS(data: any): NaarAIChatRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIChatRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["newChat"] = this.newChat !== undefined ? this.newChat : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAIChatRequestRequest extends ILocalizedRequest {
    message?: string;
    newChat?: boolean;
}

export class NaarAIGenerateHotelDescriptionResponse extends OkApiResponse implements INaarAIGenerateHotelDescriptionResponse {
    testi?: TestoCompleto[] | null;

    constructor(data?: INaarAIGenerateHotelDescriptionResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["testi"])) {
                this.testi = [] as any;
                for (let item of _data["testi"])
                    this.testi!.push(TestoCompleto.fromJS(item));
            }
            else {
                this.testi = <any>null;
            }
        }
    }

    static fromJS(data: any): NaarAIGenerateHotelDescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIGenerateHotelDescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.testi)) {
            data["testi"] = [];
            for (let item of this.testi)
                data["testi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface INaarAIGenerateHotelDescriptionResponse extends IOkApiResponse {
    testi?: TestoCompleto[] | null;
}

export class TestoCompleto implements ITestoCompleto {
    testoID?: number;
    lingua?: ELingua;
    tipoTesto?: ETipoTesto;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    giorno?: number;
    ordine?: number;
    tradottoAutomaticamente?: boolean;
    generatoAI?: boolean;
    allegati?: TestoCompletoAllegato[] | null;

    constructor(data?: ITestoCompleto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.testoID = _data["testoID"] !== undefined ? _data["testoID"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.tipoTesto = _data["tipoTesto"] !== undefined ? _data["tipoTesto"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.tradottoAutomaticamente = _data["tradottoAutomaticamente"] !== undefined ? _data["tradottoAutomaticamente"] : <any>null;
            this.generatoAI = _data["generatoAI"] !== undefined ? _data["generatoAI"] : <any>null;
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(TestoCompletoAllegato.fromJS(item));
            }
            else {
                this.allegati = <any>null;
            }
        }
    }

    static fromJS(data: any): TestoCompleto {
        data = typeof data === 'object' ? data : {};
        let result = new TestoCompleto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testoID"] = this.testoID !== undefined ? this.testoID : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["tipoTesto"] = this.tipoTesto !== undefined ? this.tipoTesto : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["sunto"] = this.sunto !== undefined ? this.sunto : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["tradottoAutomaticamente"] = this.tradottoAutomaticamente !== undefined ? this.tradottoAutomaticamente : <any>null;
        data["generatoAI"] = this.generatoAI !== undefined ? this.generatoAI : <any>null;
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITestoCompleto {
    testoID?: number;
    lingua?: ELingua;
    tipoTesto?: ETipoTesto;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    giorno?: number;
    ordine?: number;
    tradottoAutomaticamente?: boolean;
    generatoAI?: boolean;
    allegati?: TestoCompletoAllegato[] | null;
}

export enum ETipoTesto {
    Articolo = "Articolo",
    ArticoloTraducibile = "ArticoloTraducibile",
    TestoFornitore = "TestoFornitore",
}

export class TestoCompletoAllegato implements ITestoCompletoAllegato {
    id?: number;
    nome?: string | null;

    constructor(data?: ITestoCompletoAllegato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
        }
    }

    static fromJS(data: any): TestoCompletoAllegato {
        data = typeof data === 'object' ? data : {};
        let result = new TestoCompletoAllegato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        return data;
    }
}

export interface ITestoCompletoAllegato {
    id?: number;
    nome?: string | null;
}

export class NaarAIGenerateHotelDescriptionRequest extends LocalizedRequest implements INaarAIGenerateHotelDescriptionRequest {
    servizioID?: number;

    constructor(data?: INaarAIGenerateHotelDescriptionRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
        }
    }

    static fromJS(data: any): NaarAIGenerateHotelDescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIGenerateHotelDescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAIGenerateHotelDescriptionRequest extends ILocalizedRequest {
    servizioID?: number;
}

export class NaarAITimeZoneGapResponse extends OkApiResponse implements INaarAITimeZoneGapResponse {
    timeZoneOne?: string | null;
    timeZoneTwo?: string | null;
    timeFromGreenwichOne?: string | null;
    timeFromGreenwichTwo?: string | null;
    gap?: number;

    constructor(data?: INaarAITimeZoneGapResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.timeZoneOne = _data["timeZoneOne"] !== undefined ? _data["timeZoneOne"] : <any>null;
            this.timeZoneTwo = _data["timeZoneTwo"] !== undefined ? _data["timeZoneTwo"] : <any>null;
            this.timeFromGreenwichOne = _data["timeFromGreenwichOne"] !== undefined ? _data["timeFromGreenwichOne"] : <any>null;
            this.timeFromGreenwichTwo = _data["timeFromGreenwichTwo"] !== undefined ? _data["timeFromGreenwichTwo"] : <any>null;
            this.gap = _data["gap"] !== undefined ? _data["gap"] : <any>null;
        }
    }

    static fromJS(data: any): NaarAITimeZoneGapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITimeZoneGapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneOne"] = this.timeZoneOne !== undefined ? this.timeZoneOne : <any>null;
        data["timeZoneTwo"] = this.timeZoneTwo !== undefined ? this.timeZoneTwo : <any>null;
        data["timeFromGreenwichOne"] = this.timeFromGreenwichOne !== undefined ? this.timeFromGreenwichOne : <any>null;
        data["timeFromGreenwichTwo"] = this.timeFromGreenwichTwo !== undefined ? this.timeFromGreenwichTwo : <any>null;
        data["gap"] = this.gap !== undefined ? this.gap : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITimeZoneGapResponse extends IOkApiResponse {
    timeZoneOne?: string | null;
    timeZoneTwo?: string | null;
    timeFromGreenwichOne?: string | null;
    timeFromGreenwichTwo?: string | null;
    gap?: number;
}

export class NaarAITimeZoneGapRequest extends ApiRequest implements INaarAITimeZoneGapRequest {
    placeFromID!: number;
    placeToID!: number;

    constructor(data?: INaarAITimeZoneGapRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.placeFromID = _data["placeFromID"] !== undefined ? _data["placeFromID"] : <any>null;
            this.placeToID = _data["placeToID"] !== undefined ? _data["placeToID"] : <any>null;
        }
    }

    static fromJS(data: any): NaarAITimeZoneGapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITimeZoneGapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeFromID"] = this.placeFromID !== undefined ? this.placeFromID : <any>null;
        data["placeToID"] = this.placeToID !== undefined ? this.placeToID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITimeZoneGapRequest extends IApiRequest {
    placeFromID: number;
    placeToID: number;
}

export class NaarAIQueryDBResponse extends OkApiResponse implements INaarAIQueryDBResponse {
    sqlQuery?: string | null;
    resultData?: StatisticTable | null;

    constructor(data?: INaarAIQueryDBResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sqlQuery = _data["sqlQuery"] !== undefined ? _data["sqlQuery"] : <any>null;
            this.resultData = _data["resultData"] ? StatisticTable.fromJS(_data["resultData"]) : <any>null;
        }
    }

    static fromJS(data: any): NaarAIQueryDBResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIQueryDBResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sqlQuery"] = this.sqlQuery !== undefined ? this.sqlQuery : <any>null;
        data["resultData"] = this.resultData ? this.resultData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAIQueryDBResponse extends IOkApiResponse {
    sqlQuery?: string | null;
    resultData?: StatisticTable | null;
}

export class StatisticTable implements IStatisticTable {
    columns?: StatisticTableColumn[];
    rows?: { [key: string]: any; }[];
    rowCount?: number;

    constructor(data?: IStatisticTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(StatisticTableColumn.fromJS(item));
            }
            else {
                this.columns = <any>null;
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            else {
                this.rows = <any>null;
            }
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : <any>null;
        }
    }

    static fromJS(data: any): StatisticTable {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : <any>null;
        return data;
    }
}

export interface IStatisticTable {
    columns?: StatisticTableColumn[];
    rows?: { [key: string]: any; }[];
    rowCount?: number;
}

export class StatisticTableColumn implements IStatisticTableColumn {
    name?: string;
    format?: string;
    text?: string;
    alignment?: string;

    constructor(data?: IStatisticTableColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.format = _data["format"] !== undefined ? _data["format"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.alignment = _data["alignment"] !== undefined ? _data["alignment"] : <any>null;
        }
    }

    static fromJS(data: any): StatisticTableColumn {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticTableColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["format"] = this.format !== undefined ? this.format : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["alignment"] = this.alignment !== undefined ? this.alignment : <any>null;
        return data;
    }
}

export interface IStatisticTableColumn {
    name?: string;
    format?: string;
    text?: string;
    alignment?: string;
}

export class NaarAIQueryDBRequest extends LocalizedRequest implements INaarAIQueryDBRequest {
    contextTableName?: string | null;
    query?: string | null;

    constructor(data?: INaarAIQueryDBRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contextTableName = _data["contextTableName"] !== undefined ? _data["contextTableName"] : <any>null;
            this.query = _data["query"] !== undefined ? _data["query"] : <any>null;
        }
    }

    static fromJS(data: any): NaarAIQueryDBRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIQueryDBRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contextTableName"] = this.contextTableName !== undefined ? this.contextTableName : <any>null;
        data["query"] = this.query !== undefined ? this.query : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAIQueryDBRequest extends ILocalizedRequest {
    contextTableName?: string | null;
    query?: string | null;
}

export class NaarAISummarizeTextResponse extends OkApiResponse implements INaarAISummarizeTextResponse {
    summarizedText?: string | null;

    constructor(data?: INaarAISummarizeTextResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summarizedText = _data["summarizedText"] !== undefined ? _data["summarizedText"] : <any>null;
        }
    }

    static fromJS(data: any): NaarAISummarizeTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAISummarizeTextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summarizedText"] = this.summarizedText !== undefined ? this.summarizedText : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAISummarizeTextResponse extends IOkApiResponse {
    summarizedText?: string | null;
}

export class NaarAISummarizeTextRequest extends LocalizedRequest implements INaarAISummarizeTextRequest {
    text?: string | null;

    constructor(data?: INaarAISummarizeTextRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): NaarAISummarizeTextRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAISummarizeTextRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAISummarizeTextRequest extends ILocalizedRequest {
    text?: string | null;
}

export class NaarAITuningGetRequest extends ApiRequest implements INaarAITuningGetRequest {
    id?: number;

    constructor(data?: INaarAITuningGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): NaarAITuningGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningGetRequest extends IApiRequest {
    id?: number;
}

export class NaarAITuningDeleteRequest extends NaarAITuningGetRequest implements INaarAITuningDeleteRequest {

    constructor(data?: INaarAITuningDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): NaarAITuningDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningDeleteRequest extends INaarAITuningGetRequest {
}

export class NaarAITuningGetResponse extends OkApiResponse implements INaarAITuningGetResponse {
    tuning?: NaarAIRequestTuning | null;

    constructor(data?: INaarAITuningGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tuning = _data["tuning"] ? NaarAIRequestTuning.fromJS(_data["tuning"]) : <any>null;
        }
    }

    static fromJS(data: any): NaarAITuningGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tuning"] = this.tuning ? this.tuning.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningGetResponse extends IOkApiResponse {
    tuning?: NaarAIRequestTuning | null;
}

export class NaarAIRequestTuning implements INaarAIRequestTuning {
    id!: number;
    name!: string;
    model!: string;
    message!: string;
    params?: { [key: string]: NaarAIRequestTuningParam; } | null;
    assistantMessage?: string | null;
    assistantParams?: { [key: string]: NaarAIRequestTuningParam; } | null;

    constructor(data?: INaarAIRequestTuning) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            if (_data["params"]) {
                this.params = {} as any;
                for (let key in _data["params"]) {
                    if (_data["params"].hasOwnProperty(key))
                        (<any>this.params)![key] = _data["params"][key] ? NaarAIRequestTuningParam.fromJS(_data["params"][key]) : new NaarAIRequestTuningParam();
                }
            }
            else {
                this.params = <any>null;
            }
            this.assistantMessage = _data["assistantMessage"] !== undefined ? _data["assistantMessage"] : <any>null;
            if (_data["assistantParams"]) {
                this.assistantParams = {} as any;
                for (let key in _data["assistantParams"]) {
                    if (_data["assistantParams"].hasOwnProperty(key))
                        (<any>this.assistantParams)![key] = _data["assistantParams"][key] ? NaarAIRequestTuningParam.fromJS(_data["assistantParams"][key]) : new NaarAIRequestTuningParam();
                }
            }
            else {
                this.assistantParams = <any>null;
            }
        }
    }

    static fromJS(data: any): NaarAIRequestTuning {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIRequestTuning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        if (this.params) {
            data["params"] = {};
            for (let key in this.params) {
                if (this.params.hasOwnProperty(key))
                    (<any>data["params"])[key] = this.params[key] ? this.params[key].toJSON() : <any>null;
            }
        }
        data["assistantMessage"] = this.assistantMessage !== undefined ? this.assistantMessage : <any>null;
        if (this.assistantParams) {
            data["assistantParams"] = {};
            for (let key in this.assistantParams) {
                if (this.assistantParams.hasOwnProperty(key))
                    (<any>data["assistantParams"])[key] = this.assistantParams[key] ? this.assistantParams[key].toJSON() : <any>null;
            }
        }
        return data;
    }
}

export interface INaarAIRequestTuning {
    id: number;
    name: string;
    model: string;
    message: string;
    params?: { [key: string]: NaarAIRequestTuningParam; } | null;
    assistantMessage?: string | null;
    assistantParams?: { [key: string]: NaarAIRequestTuningParam; } | null;
}

export class NaarAIRequestTuningParam implements INaarAIRequestTuningParam {
    type?: string;
    labelId?: string | null;

    constructor(data?: INaarAIRequestTuningParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.labelId = _data["labelId"] !== undefined ? _data["labelId"] : <any>null;
        }
    }

    static fromJS(data: any): NaarAIRequestTuningParam {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAIRequestTuningParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["labelId"] = this.labelId !== undefined ? this.labelId : <any>null;
        return data;
    }
}

export interface INaarAIRequestTuningParam {
    type?: string;
    labelId?: string | null;
}

export class NrTableResponseOfNaarAIRequestTuning extends OkApiResponse implements INrTableResponseOfNaarAIRequestTuning {
    /** Array delle righe della pagina richiesta */
    rows?: NaarAIRequestTuning[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfNaarAIRequestTuning) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(NaarAIRequestTuning.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfNaarAIRequestTuning {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfNaarAIRequestTuning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfNaarAIRequestTuning extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: NaarAIRequestTuning[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class NaarAITuningListRequest extends NrTableRequest implements INaarAITuningListRequest {
    name?: string | null;
    model?: string | null;

    constructor(data?: INaarAITuningListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
        }
    }

    static fromJS(data: any): NaarAITuningListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningListRequest extends INrTableRequest {
    name?: string | null;
    model?: string | null;
}

export class NaarAITuningTestResponse extends OkApiResponse implements INaarAITuningTestResponse {
    response?: string | null;

    constructor(data?: INaarAITuningTestResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] !== undefined ? _data["response"] : <any>null;
        }
    }

    static fromJS(data: any): NaarAITuningTestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningTestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response !== undefined ? this.response : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningTestResponse extends IOkApiResponse {
    response?: string | null;
}

export class NaarAITuningTestRequest extends ApiRequest implements INaarAITuningTestRequest {
    tuning?: NaarAIRequestTuning | null;
    userMessage?: string | null;
    parameters?: { [key: string]: string; } | null;

    constructor(data?: INaarAITuningTestRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tuning = _data["tuning"] ? NaarAIRequestTuning.fromJS(_data["tuning"]) : <any>null;
            this.userMessage = _data["userMessage"] !== undefined ? _data["userMessage"] : <any>null;
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key] !== undefined ? _data["parameters"][key] : <any>null;
                }
            }
            else {
                this.parameters = <any>null;
            }
        }
    }

    static fromJS(data: any): NaarAITuningTestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningTestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tuning"] = this.tuning ? this.tuning.toJSON() : <any>null;
        data["userMessage"] = this.userMessage !== undefined ? this.userMessage : <any>null;
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = this.parameters[key] !== undefined ? this.parameters[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningTestRequest extends IApiRequest {
    tuning?: NaarAIRequestTuning | null;
    userMessage?: string | null;
    parameters?: { [key: string]: string; } | null;
}

export class NaarAITuningUpsertRequest extends ApiRequest implements INaarAITuningUpsertRequest {
    tuning?: NaarAIRequestTuning | null;

    constructor(data?: INaarAITuningUpsertRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tuning = _data["tuning"] ? NaarAIRequestTuning.fromJS(_data["tuning"]) : <any>null;
        }
    }

    static fromJS(data: any): NaarAITuningUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarAITuningUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tuning"] = this.tuning ? this.tuning.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarAITuningUpsertRequest extends IApiRequest {
    tuning?: NaarAIRequestTuning | null;
}

export class AirlineGetResponse extends OkApiResponse implements IAirlineGetResponse {
    airline?: CompagniaAerea;

    constructor(data?: IAirlineGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airline = _data["airline"] ? CompagniaAerea.fromJS(_data["airline"]) : <any>null;
        }
    }

    static fromJS(data: any): AirlineGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airline"] = this.airline ? this.airline.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAirlineGetResponse extends IOkApiResponse {
    airline?: CompagniaAerea;
}

export class CompagniaAerea implements ICompagniaAerea {
    id?: number;
    codice!: string;
    nome!: string;
    idCpf?: number | null;
    rank?: number | null;
    commissione?: number | null;
    commNazionali?: number | null;
    codiceBSP?: string | null;
    icao?: string | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    searchTerms?: string | null;

    constructor(data?: ICompagniaAerea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.idCpf = _data["idCpf"] !== undefined ? _data["idCpf"] : <any>null;
            this.rank = _data["rank"] !== undefined ? _data["rank"] : <any>null;
            this.commissione = _data["commissione"] !== undefined ? _data["commissione"] : <any>null;
            this.commNazionali = _data["commNazionali"] !== undefined ? _data["commNazionali"] : <any>null;
            this.codiceBSP = _data["codiceBSP"] !== undefined ? _data["codiceBSP"] : <any>null;
            this.icao = _data["icao"] !== undefined ? _data["icao"] : <any>null;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
            this.deletedAt = _data["deletedAt"] !== undefined ? _data["deletedAt"] : <any>null;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : <any>null;
        }
    }

    static fromJS(data: any): CompagniaAerea {
        data = typeof data === 'object' ? data : {};
        let result = new CompagniaAerea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["idCpf"] = this.idCpf !== undefined ? this.idCpf : <any>null;
        data["rank"] = this.rank !== undefined ? this.rank : <any>null;
        data["commissione"] = this.commissione !== undefined ? this.commissione : <any>null;
        data["commNazionali"] = this.commNazionali !== undefined ? this.commNazionali : <any>null;
        data["codiceBSP"] = this.codiceBSP !== undefined ? this.codiceBSP : <any>null;
        data["icao"] = this.icao !== undefined ? this.icao : <any>null;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        data["deletedAt"] = this.deletedAt !== undefined ? this.deletedAt : <any>null;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : <any>null;
        return data;
    }
}

export interface ICompagniaAerea {
    id?: number;
    codice: string;
    nome: string;
    idCpf?: number | null;
    rank?: number | null;
    commissione?: number | null;
    commNazionali?: number | null;
    codiceBSP?: string | null;
    icao?: string | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    searchTerms?: string | null;
}

export class AirlineGetRequest extends LocalizedRequest implements IAirlineGetRequest {
    airlineID?: number;

    constructor(data?: IAirlineGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airlineID = _data["airlineID"] !== undefined ? _data["airlineID"] : <any>null;
        }
    }

    static fromJS(data: any): AirlineGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineID"] = this.airlineID !== undefined ? this.airlineID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAirlineGetRequest extends ILocalizedRequest {
    airlineID?: number;
}

export class AirlineUpdateRequest extends AirlineGetRequest implements IAirlineUpdateRequest {
    airline?: CompagniaAerea | null;

    constructor(data?: IAirlineUpdateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airline = _data["airline"] ? CompagniaAerea.fromJS(_data["airline"]) : <any>null;
        }
    }

    static fromJS(data: any): AirlineUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airline"] = this.airline ? this.airline.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAirlineUpdateRequest extends IAirlineGetRequest {
    airline?: CompagniaAerea | null;
}

export class AirlineDeleteRequest extends ApiRequest implements IAirlineDeleteRequest {
    airlineID?: number;

    constructor(data?: IAirlineDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airlineID = _data["airlineID"] !== undefined ? _data["airlineID"] : <any>null;
        }
    }

    static fromJS(data: any): AirlineDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineID"] = this.airlineID !== undefined ? this.airlineID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAirlineDeleteRequest extends IApiRequest {
    airlineID?: number;
}

export class NrTableResponseOfAirlineRow extends OkApiResponse implements INrTableResponseOfAirlineRow {
    /** Array delle righe della pagina richiesta */
    rows?: AirlineRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAirlineRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AirlineRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfAirlineRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAirlineRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAirlineRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AirlineRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class AirlinesListResponse extends NrTableResponseOfAirlineRow implements IAirlinesListResponse {

    constructor(data?: IAirlinesListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AirlinesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AirlinesListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAirlinesListResponse extends INrTableResponseOfAirlineRow {
}

export class AirlineRow implements IAirlineRow {
    id?: number;
    name?: string;
    code?: string;
    rank?: string;
    airline?: CompagniaAerea | null;

    constructor(data?: IAirlineRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.rank = _data["rank"] !== undefined ? _data["rank"] : <any>null;
            this.airline = _data["airline"] ? CompagniaAerea.fromJS(_data["airline"]) : <any>null;
        }
    }

    static fromJS(data: any): AirlineRow {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["rank"] = this.rank !== undefined ? this.rank : <any>null;
        data["airline"] = this.airline ? this.airline.toJSON() : <any>null;
        return data;
    }
}

export interface IAirlineRow {
    id?: number;
    name?: string;
    code?: string;
    rank?: string;
    airline?: CompagniaAerea | null;
}

export class AirlinesListRequest extends NrTableRequest implements IAirlinesListRequest {
    code?: string | null;
    name?: string | null;

    constructor(data?: IAirlinesListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): AirlinesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirlinesListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAirlinesListRequest extends INrTableRequest {
    code?: string | null;
    name?: string | null;
}

export class AirportGetResponse extends OkApiResponse implements IAirportGetResponse {
    airport?: Aeroporto;

    constructor(data?: IAirportGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airport = _data["airport"] ? Aeroporto.fromJS(_data["airport"]) : <any>null;
        }
    }

    static fromJS(data: any): AirportGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AirportGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airport"] = this.airport ? this.airport.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAirportGetResponse extends IOkApiResponse {
    airport?: Aeroporto;
}

export class Aeroporto implements IAeroporto {
    id?: number;
    codice?: string | null;
    codiceArea?: string | null;
    nome?: string | null;
    airport?: string | null;
    paese?: string | null;
    nomeItaliano?: string | null;
    tipo?: number | null;
    luogoID?: number | null;
    latitudine?: number | null;
    longitudine?: number | null;
    mainAirport?: boolean | null;
    gmt?: number | null;
    domesticCheckin?: number | null;
    internationalCheckin?: number | null;
    frenchName?: string | null;
    germanName?: string | null;
    spanishName?: string | null;
    dutchName?: string | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    isAreaCode?: boolean;

    constructor(data?: IAeroporto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.codiceArea = _data["codiceArea"] !== undefined ? _data["codiceArea"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.airport = _data["airport"] !== undefined ? _data["airport"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
            this.nomeItaliano = _data["nomeItaliano"] !== undefined ? _data["nomeItaliano"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : <any>null;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : <any>null;
            this.mainAirport = _data["mainAirport"] !== undefined ? _data["mainAirport"] : <any>null;
            this.gmt = _data["gmt"] !== undefined ? _data["gmt"] : <any>null;
            this.domesticCheckin = _data["domesticCheckin"] !== undefined ? _data["domesticCheckin"] : <any>null;
            this.internationalCheckin = _data["internationalCheckin"] !== undefined ? _data["internationalCheckin"] : <any>null;
            this.frenchName = _data["frenchName"] !== undefined ? _data["frenchName"] : <any>null;
            this.germanName = _data["germanName"] !== undefined ? _data["germanName"] : <any>null;
            this.spanishName = _data["spanishName"] !== undefined ? _data["spanishName"] : <any>null;
            this.dutchName = _data["dutchName"] !== undefined ? _data["dutchName"] : <any>null;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
            this.deletedAt = _data["deletedAt"] !== undefined ? _data["deletedAt"] : <any>null;
            this.isAreaCode = _data["isAreaCode"] !== undefined ? _data["isAreaCode"] : <any>null;
        }
    }

    static fromJS(data: any): Aeroporto {
        data = typeof data === 'object' ? data : {};
        let result = new Aeroporto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["codiceArea"] = this.codiceArea !== undefined ? this.codiceArea : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["airport"] = this.airport !== undefined ? this.airport : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        data["nomeItaliano"] = this.nomeItaliano !== undefined ? this.nomeItaliano : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : <any>null;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : <any>null;
        data["mainAirport"] = this.mainAirport !== undefined ? this.mainAirport : <any>null;
        data["gmt"] = this.gmt !== undefined ? this.gmt : <any>null;
        data["domesticCheckin"] = this.domesticCheckin !== undefined ? this.domesticCheckin : <any>null;
        data["internationalCheckin"] = this.internationalCheckin !== undefined ? this.internationalCheckin : <any>null;
        data["frenchName"] = this.frenchName !== undefined ? this.frenchName : <any>null;
        data["germanName"] = this.germanName !== undefined ? this.germanName : <any>null;
        data["spanishName"] = this.spanishName !== undefined ? this.spanishName : <any>null;
        data["dutchName"] = this.dutchName !== undefined ? this.dutchName : <any>null;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        data["deletedAt"] = this.deletedAt !== undefined ? this.deletedAt : <any>null;
        data["isAreaCode"] = this.isAreaCode !== undefined ? this.isAreaCode : <any>null;
        return data;
    }
}

export interface IAeroporto {
    id?: number;
    codice?: string | null;
    codiceArea?: string | null;
    nome?: string | null;
    airport?: string | null;
    paese?: string | null;
    nomeItaliano?: string | null;
    tipo?: number | null;
    luogoID?: number | null;
    latitudine?: number | null;
    longitudine?: number | null;
    mainAirport?: boolean | null;
    gmt?: number | null;
    domesticCheckin?: number | null;
    internationalCheckin?: number | null;
    frenchName?: string | null;
    germanName?: string | null;
    spanishName?: string | null;
    dutchName?: string | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    isAreaCode?: boolean;
}

export class AirportGetRequest extends LocalizedRequest implements IAirportGetRequest {
    airportID?: number;

    constructor(data?: IAirportGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airportID = _data["airportID"] !== undefined ? _data["airportID"] : <any>null;
        }
    }

    static fromJS(data: any): AirportGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirportGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airportID"] = this.airportID !== undefined ? this.airportID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAirportGetRequest extends ILocalizedRequest {
    airportID?: number;
}

export class AirportUpdateRequest extends AirportGetRequest implements IAirportUpdateRequest {
    airport?: Aeroporto | null;

    constructor(data?: IAirportUpdateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airport = _data["airport"] ? Aeroporto.fromJS(_data["airport"]) : <any>null;
        }
    }

    static fromJS(data: any): AirportUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirportUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airport"] = this.airport ? this.airport.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAirportUpdateRequest extends IAirportGetRequest {
    airport?: Aeroporto | null;
}

export class AirportDeleteRequest extends ApiRequest implements IAirportDeleteRequest {
    airportID?: number;

    constructor(data?: IAirportDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airportID = _data["airportID"] !== undefined ? _data["airportID"] : <any>null;
        }
    }

    static fromJS(data: any): AirportDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirportDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airportID"] = this.airportID !== undefined ? this.airportID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAirportDeleteRequest extends IApiRequest {
    airportID?: number;
}

export class NrTableResponseOfAirportRow extends OkApiResponse implements INrTableResponseOfAirportRow {
    /** Array delle righe della pagina richiesta */
    rows?: AirportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAirportRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AirportRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfAirportRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAirportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAirportRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AirportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class AirportsListResponse extends NrTableResponseOfAirportRow implements IAirportsListResponse {

    constructor(data?: IAirportsListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AirportsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AirportsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAirportsListResponse extends INrTableResponseOfAirportRow {
}

export class AirportRow implements IAirportRow {
    id?: number;
    name?: string;
    iataCode?: string;
    country?: string | null;
    airport?: Aeroporto | null;

    constructor(data?: IAirportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.iataCode = _data["iataCode"] !== undefined ? _data["iataCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.airport = _data["airport"] ? Aeroporto.fromJS(_data["airport"]) : <any>null;
        }
    }

    static fromJS(data: any): AirportRow {
        data = typeof data === 'object' ? data : {};
        let result = new AirportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["iataCode"] = this.iataCode !== undefined ? this.iataCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["airport"] = this.airport ? this.airport.toJSON() : <any>null;
        return data;
    }
}

export interface IAirportRow {
    id?: number;
    name?: string;
    iataCode?: string;
    country?: string | null;
    airport?: Aeroporto | null;
}

export class AirportsListRequest extends NrTableRequest implements IAirportsListRequest {
    iataCode?: string | null;
    name?: string | null;
    luogoId?: number | null;
    country?: string | null;

    constructor(data?: IAirportsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.iataCode = _data["iataCode"] !== undefined ? _data["iataCode"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
        }
    }

    static fromJS(data: any): AirportsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AirportsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iataCode"] = this.iataCode !== undefined ? this.iataCode : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAirportsListRequest extends INrTableRequest {
    iataCode?: string | null;
    name?: string | null;
    luogoId?: number | null;
    country?: string | null;
}

export class AddAttachmentResponse extends OkApiResponse implements IAddAttachmentResponse {
    allegato?: ArticoloAllegato;

    constructor(data?: IAddAttachmentResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.allegato = _data["allegato"] ? ArticoloAllegato.fromJS(_data["allegato"]) : <any>null;
        }
    }

    static fromJS(data: any): AddAttachmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddAttachmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allegato"] = this.allegato ? this.allegato.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddAttachmentResponse extends IOkApiResponse {
    allegato?: ArticoloAllegato;
}

export class ArticoloAllegato implements IArticoloAllegato {
    /** Entità dell'allegato */
    allegato?: ArticoloAttachment;
    /** Dimensione in byte, se il file esiste */
    dimensione?: number | null;
    /** True se il file esiste ed è accessibile */
    esiste?: boolean;

    constructor(data?: IArticoloAllegato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allegato = _data["allegato"] ? ArticoloAttachment.fromJS(_data["allegato"]) : <any>null;
            this.dimensione = _data["dimensione"] !== undefined ? _data["dimensione"] : <any>null;
            this.esiste = _data["esiste"] !== undefined ? _data["esiste"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloAllegato {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloAllegato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allegato"] = this.allegato ? this.allegato.toJSON() : <any>null;
        data["dimensione"] = this.dimensione !== undefined ? this.dimensione : <any>null;
        data["esiste"] = this.esiste !== undefined ? this.esiste : <any>null;
        return data;
    }
}

export interface IArticoloAllegato {
    /** Entità dell'allegato */
    allegato?: ArticoloAttachment;
    /** Dimensione in byte, se il file esiste */
    dimensione?: number | null;
    /** True se il file esiste ed è accessibile */
    esiste?: boolean;
}

export class ArticoloAttachment implements IArticoloAttachment {
    articoloAttachmentID?: number;
    articoloID?: number;
    filename?: string | null;
    originalFilename?: string | null;
    descrizione?: string | null;

    constructor(data?: IArticoloAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articoloAttachmentID = _data["articoloAttachmentID"] !== undefined ? _data["articoloAttachmentID"] : <any>null;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
            this.filename = _data["filename"] !== undefined ? _data["filename"] : <any>null;
            this.originalFilename = _data["originalFilename"] !== undefined ? _data["originalFilename"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloAttachmentID"] = this.articoloAttachmentID !== undefined ? this.articoloAttachmentID : <any>null;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        data["filename"] = this.filename !== undefined ? this.filename : <any>null;
        data["originalFilename"] = this.originalFilename !== undefined ? this.originalFilename : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        return data;
    }
}

export interface IArticoloAttachment {
    articoloAttachmentID?: number;
    articoloID?: number;
    filename?: string | null;
    originalFilename?: string | null;
    descrizione?: string | null;
}

export class ArticoloGetResponse extends OkApiResponse implements IArticoloGetResponse {
    /** Entità dell'articolo */
    articolo?: Articolo;
    /** Elenco dei testi nelle varie lingue */
    testi?: ArticoloTestoLingua[];
    /** Elenco degli allegati */
    allegati?: ArticoloAllegato[];
    /** Riferimenti agli articoli padre, in ordine dal più prossimo alla radice */
    padri?: ArticoloRiferimento[];
    /** Riferimenti agli articoli figlio */
    figli?: ArticoloRiferimento[];
    /** True se sono presenti riferimenti circolari */
    riferimentiCircolari?: boolean;
    /** Eventuale link associato */
    link?: ArticoloLink | null;
    /** Testo per la UI */
    testo?: TripTextHtml;

    constructor(data?: IArticoloGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articolo = _data["articolo"] ? Articolo.fromJS(_data["articolo"]) : <any>null;
            if (Array.isArray(_data["testi"])) {
                this.testi = [] as any;
                for (let item of _data["testi"])
                    this.testi!.push(ArticoloTestoLingua.fromJS(item));
            }
            else {
                this.testi = <any>null;
            }
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(ArticoloAllegato.fromJS(item));
            }
            else {
                this.allegati = <any>null;
            }
            if (Array.isArray(_data["padri"])) {
                this.padri = [] as any;
                for (let item of _data["padri"])
                    this.padri!.push(ArticoloRiferimento.fromJS(item));
            }
            else {
                this.padri = <any>null;
            }
            if (Array.isArray(_data["figli"])) {
                this.figli = [] as any;
                for (let item of _data["figli"])
                    this.figli!.push(ArticoloRiferimento.fromJS(item));
            }
            else {
                this.figli = <any>null;
            }
            this.riferimentiCircolari = _data["riferimentiCircolari"] !== undefined ? _data["riferimentiCircolari"] : <any>null;
            this.link = _data["link"] ? ArticoloLink.fromJS(_data["link"]) : <any>null;
            this.testo = _data["testo"] ? TripTextHtml.fromJS(_data["testo"]) : <any>null;
        }
    }

    static fromJS(data: any): ArticoloGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articolo"] = this.articolo ? this.articolo.toJSON() : <any>null;
        if (Array.isArray(this.testi)) {
            data["testi"] = [];
            for (let item of this.testi)
                data["testi"].push(item.toJSON());
        }
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item.toJSON());
        }
        if (Array.isArray(this.padri)) {
            data["padri"] = [];
            for (let item of this.padri)
                data["padri"].push(item.toJSON());
        }
        if (Array.isArray(this.figli)) {
            data["figli"] = [];
            for (let item of this.figli)
                data["figli"].push(item.toJSON());
        }
        data["riferimentiCircolari"] = this.riferimentiCircolari !== undefined ? this.riferimentiCircolari : <any>null;
        data["link"] = this.link ? this.link.toJSON() : <any>null;
        data["testo"] = this.testo ? this.testo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloGetResponse extends IOkApiResponse {
    /** Entità dell'articolo */
    articolo?: Articolo;
    /** Elenco dei testi nelle varie lingue */
    testi?: ArticoloTestoLingua[];
    /** Elenco degli allegati */
    allegati?: ArticoloAllegato[];
    /** Riferimenti agli articoli padre, in ordine dal più prossimo alla radice */
    padri?: ArticoloRiferimento[];
    /** Riferimenti agli articoli figlio */
    figli?: ArticoloRiferimento[];
    /** True se sono presenti riferimenti circolari */
    riferimentiCircolari?: boolean;
    /** Eventuale link associato */
    link?: ArticoloLink | null;
    /** Testo per la UI */
    testo?: TripTextHtml;
}

export class Articolo implements IArticolo {
    id?: number;
    linguaID?: ELingua;
    accordoID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
    articoloPadreID?: number | null;
    linkPadre?: boolean;
    articoloTestataID?: number | null;
    categoria?: ECategoriaArticolo | null;
    titolo?: string | null;
    sunto?: string | null;
    ordine1?: number | null;
    ordine2?: number | null;
    pubblicaWeb?: boolean;
    pubblicaCatalogo?: boolean;
    pubblicaOfferta?: boolean;
    pubblicaProgramma?: boolean;
    pubblicaPreventivo?: boolean;
    pubblicaMiniguida?: boolean;
    pubblicaVoucher?: boolean;
    pubblicaEstrattoConto?: boolean;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    priority?: number | null;
    ultimoAggiornamento?: string | null;
    tipoServizio?: ETipoServizio | null;
    pageLinkID?: number | null;
    faIcon?: string | null;
    rawEdit?: boolean;
    showAsLink?: boolean;
    compagniaID?: number | null;
    operatore?: EOperatore | null;
    eliminato?: string | null;
    generatoAI?: boolean;

    constructor(data?: IArticolo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.linguaID = _data["linguaID"] !== undefined ? _data["linguaID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.articoloPadreID = _data["articoloPadreID"] !== undefined ? _data["articoloPadreID"] : <any>null;
            this.linkPadre = _data["linkPadre"] !== undefined ? _data["linkPadre"] : <any>null;
            this.articoloTestataID = _data["articoloTestataID"] !== undefined ? _data["articoloTestataID"] : <any>null;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : <any>null;
            this.ordine1 = _data["ordine1"] !== undefined ? _data["ordine1"] : <any>null;
            this.ordine2 = _data["ordine2"] !== undefined ? _data["ordine2"] : <any>null;
            this.pubblicaWeb = _data["pubblicaWeb"] !== undefined ? _data["pubblicaWeb"] : <any>null;
            this.pubblicaCatalogo = _data["pubblicaCatalogo"] !== undefined ? _data["pubblicaCatalogo"] : <any>null;
            this.pubblicaOfferta = _data["pubblicaOfferta"] !== undefined ? _data["pubblicaOfferta"] : <any>null;
            this.pubblicaProgramma = _data["pubblicaProgramma"] !== undefined ? _data["pubblicaProgramma"] : <any>null;
            this.pubblicaPreventivo = _data["pubblicaPreventivo"] !== undefined ? _data["pubblicaPreventivo"] : <any>null;
            this.pubblicaMiniguida = _data["pubblicaMiniguida"] !== undefined ? _data["pubblicaMiniguida"] : <any>null;
            this.pubblicaVoucher = _data["pubblicaVoucher"] !== undefined ? _data["pubblicaVoucher"] : <any>null;
            this.pubblicaEstrattoConto = _data["pubblicaEstrattoConto"] !== undefined ? _data["pubblicaEstrattoConto"] : <any>null;
            this.pubblicaDal = _data["pubblicaDal"] !== undefined ? _data["pubblicaDal"] : <any>null;
            this.pubblicaAl = _data["pubblicaAl"] !== undefined ? _data["pubblicaAl"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.pageLinkID = _data["pageLinkID"] !== undefined ? _data["pageLinkID"] : <any>null;
            this.faIcon = _data["faIcon"] !== undefined ? _data["faIcon"] : <any>null;
            this.rawEdit = _data["rawEdit"] !== undefined ? _data["rawEdit"] : <any>null;
            this.showAsLink = _data["showAsLink"] !== undefined ? _data["showAsLink"] : <any>null;
            this.compagniaID = _data["compagniaID"] !== undefined ? _data["compagniaID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : <any>null;
            this.generatoAI = _data["generatoAI"] !== undefined ? _data["generatoAI"] : <any>null;
        }
    }

    static fromJS(data: any): Articolo {
        data = typeof data === 'object' ? data : {};
        let result = new Articolo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["linguaID"] = this.linguaID !== undefined ? this.linguaID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["articoloPadreID"] = this.articoloPadreID !== undefined ? this.articoloPadreID : <any>null;
        data["linkPadre"] = this.linkPadre !== undefined ? this.linkPadre : <any>null;
        data["articoloTestataID"] = this.articoloTestataID !== undefined ? this.articoloTestataID : <any>null;
        data["categoria"] = this.categoria !== undefined ? this.categoria : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["sunto"] = this.sunto !== undefined ? this.sunto : <any>null;
        data["ordine1"] = this.ordine1 !== undefined ? this.ordine1 : <any>null;
        data["ordine2"] = this.ordine2 !== undefined ? this.ordine2 : <any>null;
        data["pubblicaWeb"] = this.pubblicaWeb !== undefined ? this.pubblicaWeb : <any>null;
        data["pubblicaCatalogo"] = this.pubblicaCatalogo !== undefined ? this.pubblicaCatalogo : <any>null;
        data["pubblicaOfferta"] = this.pubblicaOfferta !== undefined ? this.pubblicaOfferta : <any>null;
        data["pubblicaProgramma"] = this.pubblicaProgramma !== undefined ? this.pubblicaProgramma : <any>null;
        data["pubblicaPreventivo"] = this.pubblicaPreventivo !== undefined ? this.pubblicaPreventivo : <any>null;
        data["pubblicaMiniguida"] = this.pubblicaMiniguida !== undefined ? this.pubblicaMiniguida : <any>null;
        data["pubblicaVoucher"] = this.pubblicaVoucher !== undefined ? this.pubblicaVoucher : <any>null;
        data["pubblicaEstrattoConto"] = this.pubblicaEstrattoConto !== undefined ? this.pubblicaEstrattoConto : <any>null;
        data["pubblicaDal"] = this.pubblicaDal !== undefined ? this.pubblicaDal : <any>null;
        data["pubblicaAl"] = this.pubblicaAl !== undefined ? this.pubblicaAl : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["pageLinkID"] = this.pageLinkID !== undefined ? this.pageLinkID : <any>null;
        data["faIcon"] = this.faIcon !== undefined ? this.faIcon : <any>null;
        data["rawEdit"] = this.rawEdit !== undefined ? this.rawEdit : <any>null;
        data["showAsLink"] = this.showAsLink !== undefined ? this.showAsLink : <any>null;
        data["compagniaID"] = this.compagniaID !== undefined ? this.compagniaID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : <any>null;
        data["generatoAI"] = this.generatoAI !== undefined ? this.generatoAI : <any>null;
        return data;
    }
}

export interface IArticolo {
    id?: number;
    linguaID?: ELingua;
    accordoID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
    articoloPadreID?: number | null;
    linkPadre?: boolean;
    articoloTestataID?: number | null;
    categoria?: ECategoriaArticolo | null;
    titolo?: string | null;
    sunto?: string | null;
    ordine1?: number | null;
    ordine2?: number | null;
    pubblicaWeb?: boolean;
    pubblicaCatalogo?: boolean;
    pubblicaOfferta?: boolean;
    pubblicaProgramma?: boolean;
    pubblicaPreventivo?: boolean;
    pubblicaMiniguida?: boolean;
    pubblicaVoucher?: boolean;
    pubblicaEstrattoConto?: boolean;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    priority?: number | null;
    ultimoAggiornamento?: string | null;
    tipoServizio?: ETipoServizio | null;
    pageLinkID?: number | null;
    faIcon?: string | null;
    rawEdit?: boolean;
    showAsLink?: boolean;
    compagniaID?: number | null;
    operatore?: EOperatore | null;
    eliminato?: string | null;
    generatoAI?: boolean;
}

export enum ECategoriaArticolo {
    Produzione = "Produzione",
    PreProduzione = "PreProduzione",
    Miniguida = "Miniguida",
    Offerte = "Offerte",
    ElementiArticoli = "ElementiArticoli",
    TestiCatalogo = "TestiCatalogo",
    TestiStampe = "TestiStampe",
    Obsoleto = "Obsoleto",
}

export class ArticoloTestoLingua implements IArticoloTestoLingua {
    articoloID?: number;
    lingua?: ELingua;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    confermato?: boolean;
    ultimoAggiornamento?: string | null;

    constructor(data?: IArticoloTestoLingua) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.confermato = _data["confermato"] !== undefined ? _data["confermato"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloTestoLingua {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTestoLingua();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["sunto"] = this.sunto !== undefined ? this.sunto : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["confermato"] = this.confermato !== undefined ? this.confermato : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        return data;
    }
}

export interface IArticoloTestoLingua {
    articoloID?: number;
    lingua?: ELingua;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    confermato?: boolean;
    ultimoAggiornamento?: string | null;
}

export class ArticoloRiferimento implements IArticoloRiferimento {
    /** ID dell'articolo puntato */
    id?: number;
    /** Titolo dell'articolo (se c'è) */
    titolo?: string | null;
    /** Servizio associato (se c'è) */
    servizio?: string | null;

    constructor(data?: IArticoloRiferimento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloRiferimento {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloRiferimento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        return data;
    }
}

export interface IArticoloRiferimento {
    /** ID dell'articolo puntato */
    id?: number;
    /** Titolo dell'articolo (se c'è) */
    titolo?: string | null;
    /** Servizio associato (se c'è) */
    servizio?: string | null;
}

export class ArticoloLink implements IArticoloLink {
    id?: number;
    nome?: string | null;
    luogo?: string | null;
    posizione?: EPosizioneLink;

    constructor(data?: IArticoloLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.posizione = _data["posizione"] !== undefined ? _data["posizione"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloLink {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["posizione"] = this.posizione !== undefined ? this.posizione : <any>null;
        return data;
    }
}

export interface IArticoloLink {
    id?: number;
    nome?: string | null;
    luogo?: string | null;
    posizione?: EPosizioneLink;
}

export enum EPosizioneLink {
    Default = "Default",
    MenuNavigazione = "MenuNavigazione",
    BannerTop = "BannerTop",
    BannerBottom = "BannerBottom",
    BannerLeft = "BannerLeft",
    BannerRight = "BannerRight",
    MenuSecondario = "MenuSecondario",
    BoxNews = "BoxNews",
    FooterLinks = "FooterLinks",
}

/** Contentiore generico dei testi */
export class TripTextHtml implements ITripTextHtml {
    /** Sorgente del testo */
    source?: ETripTextHtmlSource;
    /** ID riferimento, usato secondo i contesti */
    refID?: number;
    /** Hash ad uso interno */
    hash?: string;
    /** Titolo facoltativo */
    titolo?: string | null;
    /** Testo HTML */
    testo?: string;
    /** Se true in un documento deve apparire come URL. In questo caso il titolo deve esserci */
    usaUrlInDocumenti?: boolean;
    /** Url da utilizzare */
    url?: string | null;
    luogoID?: number;
    ordine?: number;

    constructor(data?: ITripTextHtml) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"] !== undefined ? _data["source"] : <any>null;
            this.refID = _data["refID"] !== undefined ? _data["refID"] : <any>null;
            this.hash = _data["hash"] !== undefined ? _data["hash"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.usaUrlInDocumenti = _data["usaUrlInDocumenti"] !== undefined ? _data["usaUrlInDocumenti"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
        }
    }

    static fromJS(data: any): TripTextHtml {
        data = typeof data === 'object' ? data : {};
        let result = new TripTextHtml();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source !== undefined ? this.source : <any>null;
        data["refID"] = this.refID !== undefined ? this.refID : <any>null;
        data["hash"] = this.hash !== undefined ? this.hash : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["usaUrlInDocumenti"] = this.usaUrlInDocumenti !== undefined ? this.usaUrlInDocumenti : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        return data;
    }
}

/** Contentiore generico dei testi */
export interface ITripTextHtml {
    /** Sorgente del testo */
    source?: ETripTextHtmlSource;
    /** ID riferimento, usato secondo i contesti */
    refID?: number;
    /** Hash ad uso interno */
    hash?: string;
    /** Titolo facoltativo */
    titolo?: string | null;
    /** Testo HTML */
    testo?: string;
    /** Se true in un documento deve apparire come URL. In questo caso il titolo deve esserci */
    usaUrlInDocumenti?: boolean;
    /** Url da utilizzare */
    url?: string | null;
    luogoID?: number;
    ordine?: number;
}

/** Sorgente del testo, ad uso interno */
export enum ETripTextHtmlSource {
    Articolo = "Articolo",
    NotaOfferta = "NotaOfferta",
    DatiAggiuntiviServizio = "DatiAggiuntiviServizio",
    PenaleH2H = "PenaleH2H",
    Custom = "Custom",
}

export class ArticoloGetRequest extends LocalizedRequest implements IArticoloGetRequest {
    articoloID?: number;

    constructor(data?: IArticoloGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloGetRequest extends ILocalizedRequest {
    articoloID?: number;
}

export class UpdateArticoloRequest extends ArticoloGetRequest implements IUpdateArticoloRequest {
    articolo?: Articolo | null;
    testoPrincipale?: ArticoloTestoLingua | null;
    traduzioni?: ArticoloTestoLingua[] | null;
    allegati?: ArticoloAttachment[] | null;

    constructor(data?: IUpdateArticoloRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articolo = _data["articolo"] ? Articolo.fromJS(_data["articolo"]) : <any>null;
            this.testoPrincipale = _data["testoPrincipale"] ? ArticoloTestoLingua.fromJS(_data["testoPrincipale"]) : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(ArticoloTestoLingua.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(ArticoloAttachment.fromJS(item));
            }
            else {
                this.allegati = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateArticoloRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticoloRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articolo"] = this.articolo ? this.articolo.toJSON() : <any>null;
        data["testoPrincipale"] = this.testoPrincipale ? this.testoPrincipale.toJSON() : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateArticoloRequest extends IArticoloGetRequest {
    articolo?: Articolo | null;
    testoPrincipale?: ArticoloTestoLingua | null;
    traduzioni?: ArticoloTestoLingua[] | null;
    allegati?: ArticoloAttachment[] | null;
}

export class ArticoloDeleteRequest extends ApiRequest implements IArticoloDeleteRequest {
    articoloID?: number;

    constructor(data?: IArticoloDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloDeleteRequest extends IApiRequest {
    articoloID?: number;
}

export class NrTableResponseOfArticoloFraseListRow extends OkApiResponse implements INrTableResponseOfArticoloFraseListRow {
    /** Array delle righe della pagina richiesta */
    rows?: ArticoloFraseListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfArticoloFraseListRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ArticoloFraseListRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfArticoloFraseListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfArticoloFraseListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfArticoloFraseListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ArticoloFraseListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetArticoliFraseListResponse extends NrTableResponseOfArticoloFraseListRow implements IGetArticoliFraseListResponse {

    constructor(data?: IGetArticoliFraseListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetArticoliFraseListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticoliFraseListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetArticoliFraseListResponse extends INrTableResponseOfArticoloFraseListRow {
}

export class ArticoloFraseListRow implements IArticoloFraseListRow {
    id?: number;
    title?: string;

    constructor(data?: IArticoloFraseListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloFraseListRow {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloFraseListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data;
    }
}

export interface IArticoloFraseListRow {
    id?: number;
    title?: string;
}

export class GetArticoliFraseListRequest extends NrTableRequest implements IGetArticoliFraseListRequest {
    phraseID?: number;

    constructor(data?: IGetArticoliFraseListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phraseID = _data["phraseID"] !== undefined ? _data["phraseID"] : <any>null;
        }
    }

    static fromJS(data: any): GetArticoliFraseListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticoliFraseListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phraseID"] = this.phraseID !== undefined ? this.phraseID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetArticoliFraseListRequest extends INrTableRequest {
    phraseID?: number;
}

export class ArticoloGetPublishedResponse extends OkApiResponse implements IArticoloGetPublishedResponse {
    id?: number;
    titolo?: string | null;
    testo?: string | null;
    allegati?: ArticoloAllegato[] | null;

    constructor(data?: IArticoloGetPublishedResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(ArticoloAllegato.fromJS(item));
            }
            else {
                this.allegati = <any>null;
            }
        }
    }

    static fromJS(data: any): ArticoloGetPublishedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloGetPublishedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloGetPublishedResponse extends IOkApiResponse {
    id?: number;
    titolo?: string | null;
    testo?: string | null;
    allegati?: ArticoloAllegato[] | null;
}

export class ArticoloGetPublishedRequest extends SiteRequest implements IArticoloGetPublishedRequest {
    articoloID?: number;

    constructor(data?: IArticoloGetPublishedRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloGetPublishedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloGetPublishedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloGetPublishedRequest extends ISiteRequest {
    articoloID?: number;
}

export class GetAllSectionsResponse extends OkApiResponse implements IGetAllSectionsResponse {
    sezioni?: SectionsRow[];

    constructor(data?: IGetAllSectionsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sezioni"])) {
                this.sezioni = [] as any;
                for (let item of _data["sezioni"])
                    this.sezioni!.push(SectionsRow.fromJS(item));
            }
            else {
                this.sezioni = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAllSectionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSectionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sezioni)) {
            data["sezioni"] = [];
            for (let item of this.sezioni)
                data["sezioni"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAllSectionsResponse extends IOkApiResponse {
    sezioni?: SectionsRow[];
}

export class SectionsRow implements ISectionsRow {
    id?: number;
    nome?: string;
    codice?: string;
    visibilita?: EVisibilitaSezione;
    tipoServizio?: ETipoServizioFlags;

    constructor(data?: ISectionsRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
        }
    }

    static fromJS(data: any): SectionsRow {
        data = typeof data === 'object' ? data : {};
        let result = new SectionsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        return data;
    }
}

export interface ISectionsRow {
    id?: number;
    nome?: string;
    codice?: string;
    visibilita?: EVisibilitaSezione;
    tipoServizio?: ETipoServizioFlags;
}

export enum EVisibilitaSezione {
    Nessuno = "Nessuno",
    Articoli = "Articoli",
    PreventivoCliente = "PreventivoCliente",
    ProgrammaDiViaggio = "ProgrammaDiViaggio",
}

export enum ETipoServizioFlags {
    Nessuno = "Nessuno",
    Hotel = "Hotel",
    Tour = "Tour",
    Crociere = "Crociere",
    SelfDrive = "SelfDrive",
    Trasferimenti = "Trasferimenti",
    Visite = "Visite",
    Noleggi = "Noleggi",
    Pacchetti = "Pacchetti",
}

export class GetArticoloTextResponse extends OkApiResponse implements IGetArticoloTextResponse {
    id?: number;
    testo?: TripTextHtml;

    constructor(data?: IGetArticoloTextResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.testo = _data["testo"] ? TripTextHtml.fromJS(_data["testo"]) : <any>null;
        }
    }

    static fromJS(data: any): GetArticoloTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticoloTextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["testo"] = this.testo ? this.testo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetArticoloTextResponse extends IOkApiResponse {
    id?: number;
    testo?: TripTextHtml;
}

export class NrTableResponseOfArticoloListRow extends OkApiResponse implements INrTableResponseOfArticoloListRow {
    /** Array delle righe della pagina richiesta */
    rows?: ArticoloListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfArticoloListRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ArticoloListRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfArticoloListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfArticoloListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfArticoloListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ArticoloListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ArticoloListRow implements IArticoloListRow {
    articoloID?: number;
    categoria?: ECategoriaArticolo;
    luogo?: string | null;
    luogoEliminato?: boolean;
    servizio?: string | null;
    servizioObsoleto?: boolean;
    servizioEliminato?: boolean;
    accordo?: string | null;
    compagniaAerea?: string | null;
    ultimoAggiornamento?: string | null;
    titolo?: string | null;
    titoloOriginale?: string | null;
    giorno?: number;
    ordine?: number;
    ordineStr?: string;
    link?: string | null;
    luogoLink?: string | null;
    intestazione?: string | null;
    operatore?: EOperatore | null;
    deleted?: string | null;

    constructor(data?: IArticoloListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.luogoEliminato = _data["luogoEliminato"] !== undefined ? _data["luogoEliminato"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.servizioObsoleto = _data["servizioObsoleto"] !== undefined ? _data["servizioObsoleto"] : <any>null;
            this.servizioEliminato = _data["servizioEliminato"] !== undefined ? _data["servizioEliminato"] : <any>null;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : <any>null;
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.titoloOriginale = _data["titoloOriginale"] !== undefined ? _data["titoloOriginale"] : <any>null;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.ordineStr = _data["ordineStr"] !== undefined ? _data["ordineStr"] : <any>null;
            this.link = _data["link"] !== undefined ? _data["link"] : <any>null;
            this.luogoLink = _data["luogoLink"] !== undefined ? _data["luogoLink"] : <any>null;
            this.intestazione = _data["intestazione"] !== undefined ? _data["intestazione"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloListRow {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        data["categoria"] = this.categoria !== undefined ? this.categoria : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["luogoEliminato"] = this.luogoEliminato !== undefined ? this.luogoEliminato : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["servizioObsoleto"] = this.servizioObsoleto !== undefined ? this.servizioObsoleto : <any>null;
        data["servizioEliminato"] = this.servizioEliminato !== undefined ? this.servizioEliminato : <any>null;
        data["accordo"] = this.accordo !== undefined ? this.accordo : <any>null;
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["titoloOriginale"] = this.titoloOriginale !== undefined ? this.titoloOriginale : <any>null;
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["ordineStr"] = this.ordineStr !== undefined ? this.ordineStr : <any>null;
        data["link"] = this.link !== undefined ? this.link : <any>null;
        data["luogoLink"] = this.luogoLink !== undefined ? this.luogoLink : <any>null;
        data["intestazione"] = this.intestazione !== undefined ? this.intestazione : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        return data;
    }
}

export interface IArticoloListRow {
    articoloID?: number;
    categoria?: ECategoriaArticolo;
    luogo?: string | null;
    luogoEliminato?: boolean;
    servizio?: string | null;
    servizioObsoleto?: boolean;
    servizioEliminato?: boolean;
    accordo?: string | null;
    compagniaAerea?: string | null;
    ultimoAggiornamento?: string | null;
    titolo?: string | null;
    titoloOriginale?: string | null;
    giorno?: number;
    ordine?: number;
    ordineStr?: string;
    link?: string | null;
    luogoLink?: string | null;
    intestazione?: string | null;
    operatore?: EOperatore | null;
    deleted?: string | null;
}

export class ArticoliListRequest extends NrTableRequest implements IArticoliListRequest {
    tipoRicercaArticolo?: ETipoRicercaArticolo;
    tipoDocumento?: ETipoDocumento | null;
    articoliIdEsclusi?: number[] | null;
    servizioID?: number | null;
    noServizio?: boolean;
    categoria?: ECategoriaArticolo | null;
    testataID?: number | null;
    luogoID?: number | null;
    noLuogo?: boolean;
    accordoID?: number | null;
    noAccordo?: boolean;
    compagniaID?: number | null;
    noCompagnia?: boolean;
    noLink?: boolean;
    titolo?: string | null;
    testo?: string | null;
    linguaArticolo?: ELingua | null;
    nomiCategorie?: { [key in keyof typeof ECategoriaArticolo]?: string; } | null;
    operatore?: EOperatore | null;
    pubblicaWeb?: boolean;
    pubblicaCatalogo?: boolean;
    pubblicaOfferta?: boolean;
    pubblicaProgramma?: boolean;
    pubblicaPreventivo?: boolean;
    pubblicaMiniguida?: boolean;
    pubblicaVoucher?: boolean;
    pubblicaEstrattoConto?: boolean;
    showDeleted?: boolean | null;
    showActiveOnly?: boolean | null;

    constructor(data?: IArticoliListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoRicercaArticolo = _data["tipoRicercaArticolo"] !== undefined ? _data["tipoRicercaArticolo"] : <any>null;
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : <any>null;
            if (Array.isArray(_data["articoliIdEsclusi"])) {
                this.articoliIdEsclusi = [] as any;
                for (let item of _data["articoliIdEsclusi"])
                    this.articoliIdEsclusi!.push(item);
            }
            else {
                this.articoliIdEsclusi = <any>null;
            }
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.noServizio = _data["noServizio"] !== undefined ? _data["noServizio"] : <any>null;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : <any>null;
            this.testataID = _data["testataID"] !== undefined ? _data["testataID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.noLuogo = _data["noLuogo"] !== undefined ? _data["noLuogo"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.noAccordo = _data["noAccordo"] !== undefined ? _data["noAccordo"] : <any>null;
            this.compagniaID = _data["compagniaID"] !== undefined ? _data["compagniaID"] : <any>null;
            this.noCompagnia = _data["noCompagnia"] !== undefined ? _data["noCompagnia"] : <any>null;
            this.noLink = _data["noLink"] !== undefined ? _data["noLink"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.linguaArticolo = _data["linguaArticolo"] !== undefined ? _data["linguaArticolo"] : <any>null;
            if (_data["nomiCategorie"]) {
                this.nomiCategorie = {} as any;
                for (let key in _data["nomiCategorie"]) {
                    if (_data["nomiCategorie"].hasOwnProperty(key))
                        (<any>this.nomiCategorie)![key] = _data["nomiCategorie"][key] !== undefined ? _data["nomiCategorie"][key] : <any>null;
                }
            }
            else {
                this.nomiCategorie = <any>null;
            }
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.pubblicaWeb = _data["pubblicaWeb"] !== undefined ? _data["pubblicaWeb"] : <any>null;
            this.pubblicaCatalogo = _data["pubblicaCatalogo"] !== undefined ? _data["pubblicaCatalogo"] : <any>null;
            this.pubblicaOfferta = _data["pubblicaOfferta"] !== undefined ? _data["pubblicaOfferta"] : <any>null;
            this.pubblicaProgramma = _data["pubblicaProgramma"] !== undefined ? _data["pubblicaProgramma"] : <any>null;
            this.pubblicaPreventivo = _data["pubblicaPreventivo"] !== undefined ? _data["pubblicaPreventivo"] : <any>null;
            this.pubblicaMiniguida = _data["pubblicaMiniguida"] !== undefined ? _data["pubblicaMiniguida"] : <any>null;
            this.pubblicaVoucher = _data["pubblicaVoucher"] !== undefined ? _data["pubblicaVoucher"] : <any>null;
            this.pubblicaEstrattoConto = _data["pubblicaEstrattoConto"] !== undefined ? _data["pubblicaEstrattoConto"] : <any>null;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : <any>null;
            this.showActiveOnly = _data["showActiveOnly"] !== undefined ? _data["showActiveOnly"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoliListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoliListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoRicercaArticolo"] = this.tipoRicercaArticolo !== undefined ? this.tipoRicercaArticolo : <any>null;
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : <any>null;
        if (Array.isArray(this.articoliIdEsclusi)) {
            data["articoliIdEsclusi"] = [];
            for (let item of this.articoliIdEsclusi)
                data["articoliIdEsclusi"].push(item);
        }
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["noServizio"] = this.noServizio !== undefined ? this.noServizio : <any>null;
        data["categoria"] = this.categoria !== undefined ? this.categoria : <any>null;
        data["testataID"] = this.testataID !== undefined ? this.testataID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["noLuogo"] = this.noLuogo !== undefined ? this.noLuogo : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["noAccordo"] = this.noAccordo !== undefined ? this.noAccordo : <any>null;
        data["compagniaID"] = this.compagniaID !== undefined ? this.compagniaID : <any>null;
        data["noCompagnia"] = this.noCompagnia !== undefined ? this.noCompagnia : <any>null;
        data["noLink"] = this.noLink !== undefined ? this.noLink : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["linguaArticolo"] = this.linguaArticolo !== undefined ? this.linguaArticolo : <any>null;
        if (this.nomiCategorie) {
            data["nomiCategorie"] = {};
            for (let key in this.nomiCategorie) {
                if (this.nomiCategorie.hasOwnProperty(key))
                    (<any>data["nomiCategorie"])[key] = this.nomiCategorie[key] !== undefined ? this.nomiCategorie[key] : <any>null;
            }
        }
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["pubblicaWeb"] = this.pubblicaWeb !== undefined ? this.pubblicaWeb : <any>null;
        data["pubblicaCatalogo"] = this.pubblicaCatalogo !== undefined ? this.pubblicaCatalogo : <any>null;
        data["pubblicaOfferta"] = this.pubblicaOfferta !== undefined ? this.pubblicaOfferta : <any>null;
        data["pubblicaProgramma"] = this.pubblicaProgramma !== undefined ? this.pubblicaProgramma : <any>null;
        data["pubblicaPreventivo"] = this.pubblicaPreventivo !== undefined ? this.pubblicaPreventivo : <any>null;
        data["pubblicaMiniguida"] = this.pubblicaMiniguida !== undefined ? this.pubblicaMiniguida : <any>null;
        data["pubblicaVoucher"] = this.pubblicaVoucher !== undefined ? this.pubblicaVoucher : <any>null;
        data["pubblicaEstrattoConto"] = this.pubblicaEstrattoConto !== undefined ? this.pubblicaEstrattoConto : <any>null;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : <any>null;
        data["showActiveOnly"] = this.showActiveOnly !== undefined ? this.showActiveOnly : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoliListRequest extends INrTableRequest {
    tipoRicercaArticolo?: ETipoRicercaArticolo;
    tipoDocumento?: ETipoDocumento | null;
    articoliIdEsclusi?: number[] | null;
    servizioID?: number | null;
    noServizio?: boolean;
    categoria?: ECategoriaArticolo | null;
    testataID?: number | null;
    luogoID?: number | null;
    noLuogo?: boolean;
    accordoID?: number | null;
    noAccordo?: boolean;
    compagniaID?: number | null;
    noCompagnia?: boolean;
    noLink?: boolean;
    titolo?: string | null;
    testo?: string | null;
    linguaArticolo?: ELingua | null;
    nomiCategorie?: { [key in keyof typeof ECategoriaArticolo]?: string; } | null;
    operatore?: EOperatore | null;
    pubblicaWeb?: boolean;
    pubblicaCatalogo?: boolean;
    pubblicaOfferta?: boolean;
    pubblicaProgramma?: boolean;
    pubblicaPreventivo?: boolean;
    pubblicaMiniguida?: boolean;
    pubblicaVoucher?: boolean;
    pubblicaEstrattoConto?: boolean;
    showDeleted?: boolean | null;
    showActiveOnly?: boolean | null;
}

export enum ETipoRicercaArticolo {
    Standard = "Standard",
    NoteDocumento = "NoteDocumento",
    NoteCompagniaAerea = "NoteCompagniaAerea",
    NoteServizio = "NoteServizio",
}

export class ArticoloRestoreRequest extends ApiRequest implements IArticoloRestoreRequest {
    articoloID?: number;

    constructor(data?: IArticoloRestoreRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloRestoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloRestoreRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloRestoreRequest extends IApiRequest {
    articoloID?: number;
}

export class SetArticoliOrderRequest extends ApiRequest implements ISetArticoliOrderRequest {
    sortedIds?: number[] | null;

    constructor(data?: ISetArticoliOrderRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortedIds"])) {
                this.sortedIds = [] as any;
                for (let item of _data["sortedIds"])
                    this.sortedIds!.push(item);
            }
            else {
                this.sortedIds = <any>null;
            }
        }
    }

    static fromJS(data: any): SetArticoliOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetArticoliOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortedIds)) {
            data["sortedIds"] = [];
            for (let item of this.sortedIds)
                data["sortedIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetArticoliOrderRequest extends IApiRequest {
    sortedIds?: number[] | null;
}

export class SetLinkRequest extends ArticoloGetRequest implements ISetLinkRequest {
    pageLinkID?: number | null;

    constructor(data?: ISetLinkRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageLinkID = _data["pageLinkID"] !== undefined ? _data["pageLinkID"] : <any>null;
        }
    }

    static fromJS(data: any): SetLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageLinkID"] = this.pageLinkID !== undefined ? this.pageLinkID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetLinkRequest extends IArticoloGetRequest {
    pageLinkID?: number | null;
}

export class TranslateArticoloResponse extends OkApiResponse implements ITranslateArticoloResponse {
    testoTradotto?: ArticoloTestoLingua | null;

    constructor(data?: ITranslateArticoloResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testoTradotto = _data["testoTradotto"] ? ArticoloTestoLingua.fromJS(_data["testoTradotto"]) : <any>null;
        }
    }

    static fromJS(data: any): TranslateArticoloResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateArticoloResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testoTradotto"] = this.testoTradotto ? this.testoTradotto.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslateArticoloResponse extends IOkApiResponse {
    testoTradotto?: ArticoloTestoLingua | null;
}

export class TranslateArticoloRequest extends ApiRequest implements ITranslateArticoloRequest {
    testo?: ArticoloTestoLingua | null;
    linguaDestinazione?: ELingua;

    constructor(data?: ITranslateArticoloRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testo = _data["testo"] ? ArticoloTestoLingua.fromJS(_data["testo"]) : <any>null;
            this.linguaDestinazione = _data["linguaDestinazione"] !== undefined ? _data["linguaDestinazione"] : <any>null;
        }
    }

    static fromJS(data: any): TranslateArticoloRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateArticoloRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testo"] = this.testo ? this.testo.toJSON() : <any>null;
        data["linguaDestinazione"] = this.linguaDestinazione !== undefined ? this.linguaDestinazione : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslateArticoloRequest extends IApiRequest {
    testo?: ArticoloTestoLingua | null;
    linguaDestinazione?: ELingua;
}

export class UpdateAttachmentResponse extends AddAttachmentResponse implements IUpdateAttachmentResponse {

    constructor(data?: IUpdateAttachmentResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateAttachmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttachmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAttachmentResponse extends IAddAttachmentResponse {
}

export class ArticoliTemplateGetResponse extends OkApiResponse implements IArticoliTemplateGetResponse {
    articoloTemplate?: ArticoloTemplate;
    nomeTipoServizio?: string;

    constructor(data?: IArticoliTemplateGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloTemplate = _data["articoloTemplate"] ? ArticoloTemplate.fromJS(_data["articoloTemplate"]) : <any>null;
            this.nomeTipoServizio = _data["nomeTipoServizio"] !== undefined ? _data["nomeTipoServizio"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoliTemplateGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoliTemplateGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloTemplate"] = this.articoloTemplate ? this.articoloTemplate.toJSON() : <any>null;
        data["nomeTipoServizio"] = this.nomeTipoServizio !== undefined ? this.nomeTipoServizio : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoliTemplateGetResponse extends IOkApiResponse {
    articoloTemplate?: ArticoloTemplate;
    nomeTipoServizio?: string;
}

export class ArticoloTemplate implements IArticoloTemplate {
    id?: number;
    nome!: string;
    servizioTipoID?: number | null;
    createdAt?: string;
    updatedAt?: string | null;
    deletedAt?: string | null;

    constructor(data?: IArticoloTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.servizioTipoID = _data["servizioTipoID"] !== undefined ? _data["servizioTipoID"] : <any>null;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
            this.deletedAt = _data["deletedAt"] !== undefined ? _data["deletedAt"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["servizioTipoID"] = this.servizioTipoID !== undefined ? this.servizioTipoID : <any>null;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        data["deletedAt"] = this.deletedAt !== undefined ? this.deletedAt : <any>null;
        return data;
    }
}

export interface IArticoloTemplate {
    id?: number;
    nome: string;
    servizioTipoID?: number | null;
    createdAt?: string;
    updatedAt?: string | null;
    deletedAt?: string | null;
}

export class ArticoliTemplateGetRequest extends LocalizedRequest implements IArticoliTemplateGetRequest {
    templateID!: number;

    constructor(data?: IArticoliTemplateGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.templateID = _data["templateID"] !== undefined ? _data["templateID"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoliTemplateGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoliTemplateGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateID"] = this.templateID !== undefined ? this.templateID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoliTemplateGetRequest extends ILocalizedRequest {
    templateID: number;
}

export class UpdateArticoliTemplateRequest extends ArticoliTemplateGetRequest implements IUpdateArticoliTemplateRequest {
    articolotemplate?: ArticoloTemplate | null;

    constructor(data?: IUpdateArticoliTemplateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articolotemplate = _data["articolotemplate"] ? ArticoloTemplate.fromJS(_data["articolotemplate"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateArticoliTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticoliTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articolotemplate"] = this.articolotemplate ? this.articolotemplate.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateArticoliTemplateRequest extends IArticoliTemplateGetRequest {
    articolotemplate?: ArticoloTemplate | null;
}

export class ArticoloTemplateDeleteRequest extends ApiRequest implements IArticoloTemplateDeleteRequest {
    templateID?: number;

    constructor(data?: IArticoloTemplateDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.templateID = _data["templateID"] !== undefined ? _data["templateID"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloTemplateDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTemplateDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateID"] = this.templateID !== undefined ? this.templateID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IArticoloTemplateDeleteRequest extends IApiRequest {
    templateID?: number;
}

export class GetAllTemplatesResponse extends OkApiResponse implements IGetAllTemplatesResponse {
    template?: TemplatesRow[];

    constructor(data?: IGetAllTemplatesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["template"])) {
                this.template = [] as any;
                for (let item of _data["template"])
                    this.template!.push(TemplatesRow.fromJS(item));
            }
            else {
                this.template = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAllTemplatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTemplatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.template)) {
            data["template"] = [];
            for (let item of this.template)
                data["template"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAllTemplatesResponse extends IOkApiResponse {
    template?: TemplatesRow[];
}

export class TemplatesRow implements ITemplatesRow {
    id?: number;
    nome?: string;
    tipoServizio?: string;
    tipoServizioID?: number | null;

    constructor(data?: ITemplatesRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.tipoServizioID = _data["tipoServizioID"] !== undefined ? _data["tipoServizioID"] : <any>null;
        }
    }

    static fromJS(data: any): TemplatesRow {
        data = typeof data === 'object' ? data : {};
        let result = new TemplatesRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["tipoServizioID"] = this.tipoServizioID !== undefined ? this.tipoServizioID : <any>null;
        return data;
    }
}

export interface ITemplatesRow {
    id?: number;
    nome?: string;
    tipoServizio?: string;
    tipoServizioID?: number | null;
}

export class GetTemplatesRequest extends LocalizedRequest implements IGetTemplatesRequest {
    servizioID?: number | null;

    constructor(data?: IGetTemplatesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
        }
    }

    static fromJS(data: any): GetTemplatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTemplatesRequest extends ILocalizedRequest {
    servizioID?: number | null;
}

export class NrTableResponseOfTemplatesRow extends OkApiResponse implements INrTableResponseOfTemplatesRow {
    /** Array delle righe della pagina richiesta */
    rows?: TemplatesRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTemplatesRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TemplatesRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfTemplatesRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTemplatesRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTemplatesRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TemplatesRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ListTemplatesResponse extends NrTableResponseOfTemplatesRow implements IListTemplatesResponse {

    constructor(data?: IListTemplatesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ListTemplatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListTemplatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListTemplatesResponse extends INrTableResponseOfTemplatesRow {
}

export class ListTemplatesRequest extends NrTableRequest implements IListTemplatesRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;

    constructor(data?: IListTemplatesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
        }
    }

    static fromJS(data: any): ListTemplatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListTemplatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IListTemplatesRequest extends INrTableRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
}

export class TypeSericesGetResponse extends OkApiResponse implements ITypeSericesGetResponse {
    serviceTypeList?: ServizioTipo[];

    constructor(data?: ITypeSericesGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["serviceTypeList"])) {
                this.serviceTypeList = [] as any;
                for (let item of _data["serviceTypeList"])
                    this.serviceTypeList!.push(ServizioTipo.fromJS(item));
            }
            else {
                this.serviceTypeList = <any>null;
            }
        }
    }

    static fromJS(data: any): TypeSericesGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TypeSericesGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceTypeList)) {
            data["serviceTypeList"] = [];
            for (let item of this.serviceTypeList)
                data["serviceTypeList"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITypeSericesGetResponse extends IOkApiResponse {
    serviceTypeList?: ServizioTipo[];
}

export class ServizioTipo implements IServizioTipo {
    id?: number;
    tipo?: ETipoServizio;
    traduzioni?: ServiceTypeTranslation[] | null;
    ordine?: number | null;
    nome?: string | null;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
    serviziTipologieStandard?: ServizioTipologiaStandard[] | null;

    constructor(data?: IServizioTipo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(ServiceTypeTranslation.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
            if (Array.isArray(_data["serviziTipologieStandard"])) {
                this.serviziTipologieStandard = [] as any;
                for (let item of _data["serviziTipologieStandard"])
                    this.serviziTipologieStandard!.push(ServizioTipologiaStandard.fromJS(item));
            }
            else {
                this.serviziTipologieStandard = <any>null;
            }
        }
    }

    static fromJS(data: any): ServizioTipo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioTipo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        if (Array.isArray(this.serviziTipologieStandard)) {
            data["serviziTipologieStandard"] = [];
            for (let item of this.serviziTipologieStandard)
                data["serviziTipologieStandard"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServizioTipo {
    id?: number;
    tipo?: ETipoServizio;
    traduzioni?: ServiceTypeTranslation[] | null;
    ordine?: number | null;
    nome?: string | null;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
    serviziTipologieStandard?: ServizioTipologiaStandard[] | null;
}

export class ServiceTypeTranslation extends WebTranslation implements IServiceTypeTranslation {

    constructor(data?: IServiceTypeTranslation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ServiceTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IServiceTypeTranslation extends IWebTranslation {
}

export class ServizioTipologiaStandard implements IServizioTipologiaStandard {
    id?: number;
    eTipoServizio?: ETipoServizio;
    nome?: string | null;
    nomeInglese?: string | null;
    aggiornato?: string | null;
    eliminato?: string | null;
    traduzioni?: ServiceDefinitionStandardTranslation[] | null;
    paramNames?: TipologiaStandardParam[] | null;

    constructor(data?: IServizioTipologiaStandard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.eTipoServizio = _data["eTipoServizio"] !== undefined ? _data["eTipoServizio"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : <any>null;
            this.aggiornato = _data["aggiornato"] !== undefined ? _data["aggiornato"] : <any>null;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(ServiceDefinitionStandardTranslation.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            if (Array.isArray(_data["paramNames"])) {
                this.paramNames = [] as any;
                for (let item of _data["paramNames"])
                    this.paramNames!.push(TipologiaStandardParam.fromJS(item));
            }
            else {
                this.paramNames = <any>null;
            }
        }
    }

    static fromJS(data: any): ServizioTipologiaStandard {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioTipologiaStandard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["eTipoServizio"] = this.eTipoServizio !== undefined ? this.eTipoServizio : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : <any>null;
        data["aggiornato"] = this.aggiornato !== undefined ? this.aggiornato : <any>null;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        if (Array.isArray(this.paramNames)) {
            data["paramNames"] = [];
            for (let item of this.paramNames)
                data["paramNames"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServizioTipologiaStandard {
    id?: number;
    eTipoServizio?: ETipoServizio;
    nome?: string | null;
    nomeInglese?: string | null;
    aggiornato?: string | null;
    eliminato?: string | null;
    traduzioni?: ServiceDefinitionStandardTranslation[] | null;
    paramNames?: TipologiaStandardParam[] | null;
}

export class ServiceDefinitionStandardTranslation extends WebTranslation implements IServiceDefinitionStandardTranslation {

    constructor(data?: IServiceDefinitionStandardTranslation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ServiceDefinitionStandardTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDefinitionStandardTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IServiceDefinitionStandardTranslation extends IWebTranslation {
}

export class TipologiaStandardParam implements ITipologiaStandardParam {
    name?: string | null;
    languages?: ELingua[] | null;
    isSpecial?: boolean;

    constructor(data?: ITipologiaStandardParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            else {
                this.languages = <any>null;
            }
            this.isSpecial = _data["isSpecial"] !== undefined ? _data["isSpecial"] : <any>null;
        }
    }

    static fromJS(data: any): TipologiaStandardParam {
        data = typeof data === 'object' ? data : {};
        let result = new TipologiaStandardParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["isSpecial"] = this.isSpecial !== undefined ? this.isSpecial : <any>null;
        return data;
    }
}

export interface ITipologiaStandardParam {
    name?: string | null;
    languages?: ELingua[] | null;
    isSpecial?: boolean;
}

export class TypeSericesGetRequest extends LocalizedRequest implements ITypeSericesGetRequest {
    servicetypeID?: number;

    constructor(data?: ITypeSericesGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servicetypeID = _data["servicetypeID"] !== undefined ? _data["servicetypeID"] : <any>null;
        }
    }

    static fromJS(data: any): TypeSericesGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TypeSericesGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servicetypeID"] = this.servicetypeID !== undefined ? this.servicetypeID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITypeSericesGetRequest extends ILocalizedRequest {
    servicetypeID?: number;
}

export class CloneArticoloTraducibileResponse extends OkApiResponse implements ICloneArticoloTraducibileResponse {
    testoId?: number | null;

    constructor(data?: ICloneArticoloTraducibileResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testoId = _data["testoId"] !== undefined ? _data["testoId"] : <any>null;
        }
    }

    static fromJS(data: any): CloneArticoloTraducibileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CloneArticoloTraducibileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testoId"] = this.testoId !== undefined ? this.testoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICloneArticoloTraducibileResponse extends IOkApiResponse {
    testoId?: number | null;
}

export class TextsGetRequest extends LocalizedRequest implements ITextsGetRequest {
    testoID?: number;

    constructor(data?: ITextsGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testoID = _data["testoID"] !== undefined ? _data["testoID"] : <any>null;
        }
    }

    static fromJS(data: any): TextsGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextsGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testoID"] = this.testoID !== undefined ? this.testoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITextsGetRequest extends ILocalizedRequest {
    testoID?: number;
}

export class CloneTextsRequest extends TextsGetRequest implements ICloneTextsRequest {

    constructor(data?: ICloneTextsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CloneTextsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloneTextsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICloneTextsRequest extends ITextsGetRequest {
}

export class TextsGetResponse extends OkApiResponse implements ITextsGetResponse {
    service?: Servizio | null;
    articoloTraducibile?: ArticoloTraducibile;
    sections?: TranslateArticleSection[] | null;
    services?: IdValore[] | null;
    locations?: IdValore[] | null;

    constructor(data?: ITextsGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.service = _data["service"] ? Servizio.fromJS(_data["service"]) : <any>null;
            this.articoloTraducibile = _data["articoloTraducibile"] ? ArticoloTraducibile.fromJS(_data["articoloTraducibile"]) : <any>null;
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(TranslateArticleSection.fromJS(item));
            }
            else {
                this.sections = <any>null;
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(IdValore.fromJS(item));
            }
            else {
                this.services = <any>null;
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(IdValore.fromJS(item));
            }
            else {
                this.locations = <any>null;
            }
        }
    }

    static fromJS(data: any): TextsGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextsGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service ? this.service.toJSON() : <any>null;
        data["articoloTraducibile"] = this.articoloTraducibile ? this.articoloTraducibile.toJSON() : <any>null;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITextsGetResponse extends IOkApiResponse {
    service?: Servizio | null;
    articoloTraducibile?: ArticoloTraducibile;
    sections?: TranslateArticleSection[] | null;
    services?: IdValore[] | null;
    locations?: IdValore[] | null;
}

export abstract class ServizioBase implements IServizioBase {
    servizioID?: number;
    luogoID?: number;
    tipo?: ETipoServizio;
    markup?: number | null;
    penaleID?: number | null;
    giorniPenale?: number | null;
    parametroPenale?: number | null;

    constructor(data?: IServizioBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.markup = _data["markup"] !== undefined ? _data["markup"] : <any>null;
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : <any>null;
            this.giorniPenale = _data["giorniPenale"] !== undefined ? _data["giorniPenale"] : <any>null;
            this.parametroPenale = _data["parametroPenale"] !== undefined ? _data["parametroPenale"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["markup"] = this.markup !== undefined ? this.markup : <any>null;
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : <any>null;
        data["giorniPenale"] = this.giorniPenale !== undefined ? this.giorniPenale : <any>null;
        data["parametroPenale"] = this.parametroPenale !== undefined ? this.parametroPenale : <any>null;
        return data;
    }
}

export interface IServizioBase {
    servizioID?: number;
    luogoID?: number;
    tipo?: ETipoServizio;
    markup?: number | null;
    penaleID?: number | null;
    giorniPenale?: number | null;
    parametroPenale?: number | null;
}

export class Servizio extends ServizioBase implements IServizio {
    traduzioni?: ServiceTranslation[] | null;
    pubblicazioni?: ServicePublish[] | null;
    contattoFornitoreID?: number | null;
    deleted?: string | null;
    nome!: string;
    nomeInglese?: string | null;
    nomeOriginale?: string | null;
    popolarita?: number | null;
    ordine?: number | null;
    pubblicazione1?: EStatoPubblicazioneServizio | null;
    pubblicazione2?: EStatoPubblicazioneServizio | null;
    pubblicazione3?: EStatoPubblicazioneServizio | null;
    note?: string | null;
    status?: EStatoUtilizzoServizio | null;
    preferito?: boolean;
    codice?: string | null;
    giataID?: number | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;

    constructor(data?: IServizio) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(ServiceTranslation.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            if (Array.isArray(_data["pubblicazioni"])) {
                this.pubblicazioni = [] as any;
                for (let item of _data["pubblicazioni"])
                    this.pubblicazioni!.push(ServicePublish.fromJS(item));
            }
            else {
                this.pubblicazioni = <any>null;
            }
            this.contattoFornitoreID = _data["contattoFornitoreID"] !== undefined ? _data["contattoFornitoreID"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : <any>null;
            this.nomeOriginale = _data["nomeOriginale"] !== undefined ? _data["nomeOriginale"] : <any>null;
            this.popolarita = _data["popolarita"] !== undefined ? _data["popolarita"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.pubblicazione1 = _data["pubblicazione1"] !== undefined ? _data["pubblicazione1"] : <any>null;
            this.pubblicazione2 = _data["pubblicazione2"] !== undefined ? _data["pubblicazione2"] : <any>null;
            this.pubblicazione3 = _data["pubblicazione3"] !== undefined ? _data["pubblicazione3"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.preferito = _data["preferito"] !== undefined ? _data["preferito"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
        }
    }

    static fromJS(data: any): Servizio {
        data = typeof data === 'object' ? data : {};
        let result = new Servizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        if (Array.isArray(this.pubblicazioni)) {
            data["pubblicazioni"] = [];
            for (let item of this.pubblicazioni)
                data["pubblicazioni"].push(item.toJSON());
        }
        data["contattoFornitoreID"] = this.contattoFornitoreID !== undefined ? this.contattoFornitoreID : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : <any>null;
        data["nomeOriginale"] = this.nomeOriginale !== undefined ? this.nomeOriginale : <any>null;
        data["popolarita"] = this.popolarita !== undefined ? this.popolarita : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["pubblicazione1"] = this.pubblicazione1 !== undefined ? this.pubblicazione1 : <any>null;
        data["pubblicazione2"] = this.pubblicazione2 !== undefined ? this.pubblicazione2 : <any>null;
        data["pubblicazione3"] = this.pubblicazione3 !== undefined ? this.pubblicazione3 : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["preferito"] = this.preferito !== undefined ? this.preferito : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["giataID"] = this.giataID !== undefined ? this.giataID : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IServizio extends IServizioBase {
    traduzioni?: ServiceTranslation[] | null;
    pubblicazioni?: ServicePublish[] | null;
    contattoFornitoreID?: number | null;
    deleted?: string | null;
    nome: string;
    nomeInglese?: string | null;
    nomeOriginale?: string | null;
    popolarita?: number | null;
    ordine?: number | null;
    pubblicazione1?: EStatoPubblicazioneServizio | null;
    pubblicazione2?: EStatoPubblicazioneServizio | null;
    pubblicazione3?: EStatoPubblicazioneServizio | null;
    note?: string | null;
    status?: EStatoUtilizzoServizio | null;
    preferito?: boolean;
    codice?: string | null;
    giataID?: number | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
}

export class ServiceTranslation extends WebTranslation implements IServiceTranslation {

    constructor(data?: IServiceTranslation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ServiceTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IServiceTranslation extends IWebTranslation {
}

export class WebsitePublish implements IWebsitePublish {
    id?: number;
    websiteID!: number;
    table!: string;
    entityID!: number;
    publish?: number;
    publishFrom?: string | null;
    publishTo?: string | null;
    markupOverride?: number | null;

    constructor(data?: IWebsitePublish) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.websiteID = _data["websiteID"] !== undefined ? _data["websiteID"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
            this.entityID = _data["entityID"] !== undefined ? _data["entityID"] : <any>null;
            this.publish = _data["publish"] !== undefined ? _data["publish"] : <any>null;
            this.publishFrom = _data["publishFrom"] !== undefined ? _data["publishFrom"] : <any>null;
            this.publishTo = _data["publishTo"] !== undefined ? _data["publishTo"] : <any>null;
            this.markupOverride = _data["markupOverride"] !== undefined ? _data["markupOverride"] : <any>null;
        }
    }

    static fromJS(data: any): WebsitePublish {
        data = typeof data === 'object' ? data : {};
        let result = new WebsitePublish();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["websiteID"] = this.websiteID !== undefined ? this.websiteID : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        data["entityID"] = this.entityID !== undefined ? this.entityID : <any>null;
        data["publish"] = this.publish !== undefined ? this.publish : <any>null;
        data["publishFrom"] = this.publishFrom !== undefined ? this.publishFrom : <any>null;
        data["publishTo"] = this.publishTo !== undefined ? this.publishTo : <any>null;
        data["markupOverride"] = this.markupOverride !== undefined ? this.markupOverride : <any>null;
        return data;
    }
}

export interface IWebsitePublish {
    id?: number;
    websiteID: number;
    table: string;
    entityID: number;
    publish?: number;
    publishFrom?: string | null;
    publishTo?: string | null;
    markupOverride?: number | null;
}

export class ServicePublish extends WebsitePublish implements IServicePublish {
    statoPubblicazione?: EStatoPubblicazioneServizio;

    constructor(data?: IServicePublish) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statoPubblicazione = _data["statoPubblicazione"] !== undefined ? _data["statoPubblicazione"] : <any>null;
        }
    }

    static fromJS(data: any): ServicePublish {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePublish();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statoPubblicazione"] = this.statoPubblicazione !== undefined ? this.statoPubblicazione : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IServicePublish extends IWebsitePublish {
    statoPubblicazione?: EStatoPubblicazioneServizio;
}

export enum EStatoPubblicazioneServizio {
    NonPubblicare = "NonPubblicare",
    PubblicaWeb = "PubblicaWeb",
    PubblicaIntranet = "PubblicaIntranet",
    PubblicaWebPreferito = "PubblicaWebPreferito",
    VisibilePubblicamente = "VisibilePubblicamente",
    InLavorazione = "InLavorazione",
}

export enum EStatoUtilizzoServizio {
    Attivo = "Attivo",
    Occasionale = "Occasionale",
    InLavorazione = "InLavorazione",
    Obsoleto = "Obsoleto",
}

export class ArticoloTraducibile implements IArticoloTraducibile {
    id?: number;
    templateID?: number | null;
    titoloInterno?: string | null;
    entita?: EArticoloEntita;
    recordID?: number;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    visibilita?: EArticoloVisibilita;
    status?: EStatoArticolo;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    sortOrder?: number;

    constructor(data?: IArticoloTraducibile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.templateID = _data["templateID"] !== undefined ? _data["templateID"] : <any>null;
            this.titoloInterno = _data["titoloInterno"] !== undefined ? _data["titoloInterno"] : <any>null;
            this.entita = _data["entita"] !== undefined ? _data["entita"] : <any>null;
            this.recordID = _data["recordID"] !== undefined ? _data["recordID"] : <any>null;
            this.pubblicaDal = _data["pubblicaDal"] !== undefined ? _data["pubblicaDal"] : <any>null;
            this.pubblicaAl = _data["pubblicaAl"] !== undefined ? _data["pubblicaAl"] : <any>null;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
            this.deletedAt = _data["deletedAt"] !== undefined ? _data["deletedAt"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloTraducibile {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTraducibile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["templateID"] = this.templateID !== undefined ? this.templateID : <any>null;
        data["titoloInterno"] = this.titoloInterno !== undefined ? this.titoloInterno : <any>null;
        data["entita"] = this.entita !== undefined ? this.entita : <any>null;
        data["recordID"] = this.recordID !== undefined ? this.recordID : <any>null;
        data["pubblicaDal"] = this.pubblicaDal !== undefined ? this.pubblicaDal : <any>null;
        data["pubblicaAl"] = this.pubblicaAl !== undefined ? this.pubblicaAl : <any>null;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        data["deletedAt"] = this.deletedAt !== undefined ? this.deletedAt : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        return data;
    }
}

export interface IArticoloTraducibile {
    id?: number;
    templateID?: number | null;
    titoloInterno?: string | null;
    entita?: EArticoloEntita;
    recordID?: number;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    visibilita?: EArticoloVisibilita;
    status?: EStatoArticolo;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    sortOrder?: number;
}

export enum EArticoloEntita {
    Luogo = "Luogo",
    Servizio = "Servizio",
    Tipologia = "Tipologia",
    Itinerario = "Itinerario",
    WebsiteTree = "WebsiteTree",
}

export enum EArticoloVisibilita {
    Nessuna = "Nessuna",
    Web = "Web",
    Offerta = "Offerta",
    Preventivo = "Preventivo",
    ProgrammaDiViaggio = "ProgrammaDiViaggio",
    Voucher = "Voucher",
    EstrattoConto = "EstrattoConto",
    Template = "Template",
}

export enum EStatoArticolo {
    Bozza = "Bozza",
    Pronto = "Pronto",
    Pubblicato = "Pubblicato",
    PubblicatoIntranet = "PubblicatoIntranet",
}

export class TranslateArticleSection implements ITranslateArticleSection {
    id?: number;
    name?: string;
    itinerary?: string | null;
    phrases?: ArticlePhrase[] | null;
    days?: TranslateArticleSectionDay[] | null;

    constructor(data?: ITranslateArticleSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.itinerary = _data["itinerary"] !== undefined ? _data["itinerary"] : <any>null;
            if (Array.isArray(_data["phrases"])) {
                this.phrases = [] as any;
                for (let item of _data["phrases"])
                    this.phrases!.push(ArticlePhrase.fromJS(item));
            }
            else {
                this.phrases = <any>null;
            }
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(TranslateArticleSectionDay.fromJS(item));
            }
            else {
                this.days = <any>null;
            }
        }
    }

    static fromJS(data: any): TranslateArticleSection {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateArticleSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["itinerary"] = this.itinerary !== undefined ? this.itinerary : <any>null;
        if (Array.isArray(this.phrases)) {
            data["phrases"] = [];
            for (let item of this.phrases)
                data["phrases"].push(item.toJSON());
        }
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITranslateArticleSection {
    id?: number;
    name?: string;
    itinerary?: string | null;
    phrases?: ArticlePhrase[] | null;
    days?: TranslateArticleSectionDay[] | null;
}

export class ArticoloFrase implements IArticoloFrase {
    id?: number;
    articoloID?: number;
    fraseID?: number | null;
    frase?: Frase | null;
    terminatore?: EFraseTerminatore;
    articoloTestoID?: number | null;
    sezioneID?: number;
    ordine?: number;
    giorno?: number | null;
    parametri?: string | null;
    visibilita?: EFraseVisibilita;

    constructor(data?: IArticoloFrase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : <any>null;
            this.frase = _data["frase"] ? Frase.fromJS(_data["frase"]) : <any>null;
            this.terminatore = _data["terminatore"] !== undefined ? _data["terminatore"] : <any>null;
            this.articoloTestoID = _data["articoloTestoID"] !== undefined ? _data["articoloTestoID"] : <any>null;
            this.sezioneID = _data["sezioneID"] !== undefined ? _data["sezioneID"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.parametri = _data["parametri"] !== undefined ? _data["parametri"] : <any>null;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloFrase {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloFrase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : <any>null;
        data["frase"] = this.frase ? this.frase.toJSON() : <any>null;
        data["terminatore"] = this.terminatore !== undefined ? this.terminatore : <any>null;
        data["articoloTestoID"] = this.articoloTestoID !== undefined ? this.articoloTestoID : <any>null;
        data["sezioneID"] = this.sezioneID !== undefined ? this.sezioneID : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["parametri"] = this.parametri !== undefined ? this.parametri : <any>null;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : <any>null;
        return data;
    }
}

export interface IArticoloFrase {
    id?: number;
    articoloID?: number;
    fraseID?: number | null;
    frase?: Frase | null;
    terminatore?: EFraseTerminatore;
    articoloTestoID?: number | null;
    sezioneID?: number;
    ordine?: number;
    giorno?: number | null;
    parametri?: string | null;
    visibilita?: EFraseVisibilita;
}

export class ArticlePhrase extends ArticoloFrase implements IArticlePhrase {
    variables?: { [key: string]: VariabileValore; } | null;

    constructor(data?: IArticlePhrase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["variables"]) {
                this.variables = {} as any;
                for (let key in _data["variables"]) {
                    if (_data["variables"].hasOwnProperty(key))
                        (<any>this.variables)![key] = _data["variables"][key] ? VariabileValore.fromJS(_data["variables"][key]) : new VariabileValore();
                }
            }
            else {
                this.variables = <any>null;
            }
        }
    }

    static fromJS(data: any): ArticlePhrase {
        data = typeof data === 'object' ? data : {};
        let result = new ArticlePhrase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.variables) {
            data["variables"] = {};
            for (let key in this.variables) {
                if (this.variables.hasOwnProperty(key))
                    (<any>data["variables"])[key] = this.variables[key] ? this.variables[key].toJSON() : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IArticlePhrase extends IArticoloFrase {
    variables?: { [key: string]: VariabileValore; } | null;
}

export class VariabileValore implements IVariabileValore {
    default?: string | null;
    valore?: string | null;

    constructor(data?: IVariabileValore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.default = _data["default"] !== undefined ? _data["default"] : <any>null;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : <any>null;
        }
    }

    static fromJS(data: any): VariabileValore {
        data = typeof data === 'object' ? data : {};
        let result = new VariabileValore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["default"] = this.default !== undefined ? this.default : <any>null;
        data["valore"] = this.valore !== undefined ? this.valore : <any>null;
        return data;
    }
}

export interface IVariabileValore {
    default?: string | null;
    valore?: string | null;
}

export class Frase implements IFrase {
    id!: number;
    traduzioni?: FraseTraduzione[] | null;
    sezioneID?: number | null;
    luogoID?: number | null;
    luogoDestID?: number | null;
    servizioID?: number | null;
    contattoID?: number | null;
    documentoID?: number | null;
    titoloInterno?: string | null;
    testoITA!: string;
    testoENG?: string | null;
    testoEstesoITA?: string | null;
    testoEstesoENG?: string | null;
    default!: boolean;
    usaFIT!: boolean;
    defaultFIT!: boolean;
    sistema!: boolean;
    codice?: string | null;
    sortOrder?: number | null;
    visibilita!: EFraseVisibilita;
    pasti!: EFrasiPasti;
    createdAt!: string;
    updatedAt!: string;
    deletedAt?: string | null;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    confermato?: boolean | null;
    createdAtENG?: string | null;
    updatedAtENG?: string | null;
    deletedAtENG?: string | null;
    confermatoENG?: boolean | null;

    constructor(data?: IFrase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(FraseTraduzione.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            this.sezioneID = _data["sezioneID"] !== undefined ? _data["sezioneID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogoDestID = _data["luogoDestID"] !== undefined ? _data["luogoDestID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
            this.titoloInterno = _data["titoloInterno"] !== undefined ? _data["titoloInterno"] : <any>null;
            this.testoITA = _data["testoITA"] !== undefined ? _data["testoITA"] : <any>null;
            this.testoENG = _data["testoENG"] !== undefined ? _data["testoENG"] : <any>null;
            this.testoEstesoITA = _data["testoEstesoITA"] !== undefined ? _data["testoEstesoITA"] : <any>null;
            this.testoEstesoENG = _data["testoEstesoENG"] !== undefined ? _data["testoEstesoENG"] : <any>null;
            this.default = _data["default"] !== undefined ? _data["default"] : <any>null;
            this.usaFIT = _data["usaFIT"] !== undefined ? _data["usaFIT"] : <any>null;
            this.defaultFIT = _data["defaultFIT"] !== undefined ? _data["defaultFIT"] : <any>null;
            this.sistema = _data["sistema"] !== undefined ? _data["sistema"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : <any>null;
            this.pasti = _data["pasti"] !== undefined ? _data["pasti"] : <any>null;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
            this.deletedAt = _data["deletedAt"] !== undefined ? _data["deletedAt"] : <any>null;
            this.pubblicaDal = _data["pubblicaDal"] !== undefined ? _data["pubblicaDal"] : <any>null;
            this.pubblicaAl = _data["pubblicaAl"] !== undefined ? _data["pubblicaAl"] : <any>null;
            this.confermato = _data["confermato"] !== undefined ? _data["confermato"] : <any>null;
            this.createdAtENG = _data["createdAtENG"] !== undefined ? _data["createdAtENG"] : <any>null;
            this.updatedAtENG = _data["updatedAtENG"] !== undefined ? _data["updatedAtENG"] : <any>null;
            this.deletedAtENG = _data["deletedAtENG"] !== undefined ? _data["deletedAtENG"] : <any>null;
            this.confermatoENG = _data["confermatoENG"] !== undefined ? _data["confermatoENG"] : <any>null;
        }
    }

    static fromJS(data: any): Frase {
        data = typeof data === 'object' ? data : {};
        let result = new Frase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        data["sezioneID"] = this.sezioneID !== undefined ? this.sezioneID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogoDestID"] = this.luogoDestID !== undefined ? this.luogoDestID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        data["titoloInterno"] = this.titoloInterno !== undefined ? this.titoloInterno : <any>null;
        data["testoITA"] = this.testoITA !== undefined ? this.testoITA : <any>null;
        data["testoENG"] = this.testoENG !== undefined ? this.testoENG : <any>null;
        data["testoEstesoITA"] = this.testoEstesoITA !== undefined ? this.testoEstesoITA : <any>null;
        data["testoEstesoENG"] = this.testoEstesoENG !== undefined ? this.testoEstesoENG : <any>null;
        data["default"] = this.default !== undefined ? this.default : <any>null;
        data["usaFIT"] = this.usaFIT !== undefined ? this.usaFIT : <any>null;
        data["defaultFIT"] = this.defaultFIT !== undefined ? this.defaultFIT : <any>null;
        data["sistema"] = this.sistema !== undefined ? this.sistema : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : <any>null;
        data["pasti"] = this.pasti !== undefined ? this.pasti : <any>null;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        data["deletedAt"] = this.deletedAt !== undefined ? this.deletedAt : <any>null;
        data["pubblicaDal"] = this.pubblicaDal !== undefined ? this.pubblicaDal : <any>null;
        data["pubblicaAl"] = this.pubblicaAl !== undefined ? this.pubblicaAl : <any>null;
        data["confermato"] = this.confermato !== undefined ? this.confermato : <any>null;
        data["createdAtENG"] = this.createdAtENG !== undefined ? this.createdAtENG : <any>null;
        data["updatedAtENG"] = this.updatedAtENG !== undefined ? this.updatedAtENG : <any>null;
        data["deletedAtENG"] = this.deletedAtENG !== undefined ? this.deletedAtENG : <any>null;
        data["confermatoENG"] = this.confermatoENG !== undefined ? this.confermatoENG : <any>null;
        return data;
    }
}

export interface IFrase {
    id: number;
    traduzioni?: FraseTraduzione[] | null;
    sezioneID?: number | null;
    luogoID?: number | null;
    luogoDestID?: number | null;
    servizioID?: number | null;
    contattoID?: number | null;
    documentoID?: number | null;
    titoloInterno?: string | null;
    testoITA: string;
    testoENG?: string | null;
    testoEstesoITA?: string | null;
    testoEstesoENG?: string | null;
    default: boolean;
    usaFIT: boolean;
    defaultFIT: boolean;
    sistema: boolean;
    codice?: string | null;
    sortOrder?: number | null;
    visibilita: EFraseVisibilita;
    pasti: EFrasiPasti;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    confermato?: boolean | null;
    createdAtENG?: string | null;
    updatedAtENG?: string | null;
    deletedAtENG?: string | null;
    confermatoENG?: boolean | null;
}

export class FraseTraduzione implements IFraseTraduzione {
    id?: number;
    fraseID?: number;
    lingua?: ELingua;
    testo?: string | null;
    confermata?: boolean;
    creazione?: string | null;
    ultimoAggiornamento?: string | null;

    constructor(data?: IFraseTraduzione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.confermata = _data["confermata"] !== undefined ? _data["confermata"] : <any>null;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
        }
    }

    static fromJS(data: any): FraseTraduzione {
        data = typeof data === 'object' ? data : {};
        let result = new FraseTraduzione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["confermata"] = this.confermata !== undefined ? this.confermata : <any>null;
        data["creazione"] = this.creazione !== undefined ? this.creazione : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        return data;
    }
}

export interface IFraseTraduzione {
    id?: number;
    fraseID?: number;
    lingua?: ELingua;
    testo?: string | null;
    confermata?: boolean;
    creazione?: string | null;
    ultimoAggiornamento?: string | null;
}

export enum EFraseVisibilita {
    Tutto = "Tutto",
    ProgrammaDiViaggio = "ProgrammaDiViaggio",
    Web = "Web",
    PreventivoCliente = "PreventivoCliente",
}

export enum EFrasiPasti {
    Nessuno = "Nessuno",
    Colazione = "Colazione",
    PranzoAlSacco = "PranzoAlSacco",
    Pranzo = "Pranzo",
    Cena = "Cena",
}

export enum EFraseTerminatore {
    Nessuno = "Nessuno",
    ACapo = "ACapo",
    Punto = "Punto",
    PuntoACapo = "PuntoACapo",
    Virgola = "Virgola",
    PuntoEVirgola = "PuntoEVirgola",
    Duepunti = "Duepunti",
    Trattino = "Trattino",
    PuntoEVirgolaACapo = "PuntoEVirgolaACapo",
    DoppioACapo = "DoppioACapo",
    PuntoEDoppioACapo = "PuntoEDoppioACapo",
    SegueMaiuscolo = "SegueMaiuscolo",
    ACapoESegueMaiuscolo = "ACapoESegueMaiuscolo",
    Separatore = "Separatore",
}

export class TranslateArticleSectionDay implements ITranslateArticleSectionDay {
    day?: number;
    dayName?: string;
    place?: string | null;
    serviceID?: number | null;
    duration?: number | null;
    phrases?: ArticlePhrase[];

    constructor(data?: ITranslateArticleSectionDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"] !== undefined ? _data["day"] : <any>null;
            this.dayName = _data["dayName"] !== undefined ? _data["dayName"] : <any>null;
            this.place = _data["place"] !== undefined ? _data["place"] : <any>null;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : <any>null;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : <any>null;
            if (Array.isArray(_data["phrases"])) {
                this.phrases = [] as any;
                for (let item of _data["phrases"])
                    this.phrases!.push(ArticlePhrase.fromJS(item));
            }
            else {
                this.phrases = <any>null;
            }
        }
    }

    static fromJS(data: any): TranslateArticleSectionDay {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateArticleSectionDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day !== undefined ? this.day : <any>null;
        data["dayName"] = this.dayName !== undefined ? this.dayName : <any>null;
        data["place"] = this.place !== undefined ? this.place : <any>null;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : <any>null;
        data["duration"] = this.duration !== undefined ? this.duration : <any>null;
        if (Array.isArray(this.phrases)) {
            data["phrases"] = [];
            for (let item of this.phrases)
                data["phrases"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITranslateArticleSectionDay {
    day?: number;
    dayName?: string;
    place?: string | null;
    serviceID?: number | null;
    duration?: number | null;
    phrases?: ArticlePhrase[];
}

export class IdValore implements IIdValore {
    id?: number;
    valore?: string;

    constructor(data?: IIdValore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : <any>null;
        }
    }

    static fromJS(data: any): IdValore {
        data = typeof data === 'object' ? data : {};
        let result = new IdValore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["valore"] = this.valore !== undefined ? this.valore : <any>null;
        return data;
    }
}

export interface IIdValore {
    id?: number;
    valore?: string;
}

export class UpdateTextsRequest extends TextsGetRequest implements IUpdateTextsRequest {
    articoloTraducibile?: ArticoloTraducibile | null;
    sections?: TranslateArticleSection[] | null;

    constructor(data?: IUpdateTextsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloTraducibile = _data["articoloTraducibile"] ? ArticoloTraducibile.fromJS(_data["articoloTraducibile"]) : <any>null;
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(TranslateArticleSection.fromJS(item));
            }
            else {
                this.sections = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateTextsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTextsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloTraducibile"] = this.articoloTraducibile ? this.articoloTraducibile.toJSON() : <any>null;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTextsRequest extends ITextsGetRequest {
    articoloTraducibile?: ArticoloTraducibile | null;
    sections?: TranslateArticleSection[] | null;
}

export class TextDeleteRequest extends ApiRequest implements ITextDeleteRequest {
    testoID?: number;

    constructor(data?: ITextDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testoID = _data["testoID"] !== undefined ? _data["testoID"] : <any>null;
        }
    }

    static fromJS(data: any): TextDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testoID"] = this.testoID !== undefined ? this.testoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITextDeleteRequest extends IApiRequest {
    testoID?: number;
}

export class TextsGetFrasiDefaultResponse extends OkApiResponse implements ITextsGetFrasiDefaultResponse {
    section?: TranslateArticleSection;

    constructor(data?: ITextsGetFrasiDefaultResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.section = _data["section"] ? TranslateArticleSection.fromJS(_data["section"]) : <any>null;
        }
    }

    static fromJS(data: any): TextsGetFrasiDefaultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextsGetFrasiDefaultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["section"] = this.section ? this.section.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITextsGetFrasiDefaultResponse extends IOkApiResponse {
    section?: TranslateArticleSection;
}

export class TextsGetFrasiDefaultRequest extends LocalizedRequest implements ITextsGetFrasiDefaultRequest {
    sezioneID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;

    constructor(data?: ITextsGetFrasiDefaultRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sezioneID = _data["sezioneID"] !== undefined ? _data["sezioneID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
        }
    }

    static fromJS(data: any): TextsGetFrasiDefaultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextsGetFrasiDefaultRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sezioneID"] = this.sezioneID !== undefined ? this.sezioneID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITextsGetFrasiDefaultRequest extends ILocalizedRequest {
    sezioneID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
}

export class TextsGetItinerarioResponse extends OkApiResponse implements ITextsGetItinerarioResponse {
    section?: TranslateArticleSection;

    constructor(data?: ITextsGetItinerarioResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.section = _data["section"] ? TranslateArticleSection.fromJS(_data["section"]) : <any>null;
        }
    }

    static fromJS(data: any): TextsGetItinerarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextsGetItinerarioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["section"] = this.section ? this.section.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITextsGetItinerarioResponse extends IOkApiResponse {
    section?: TranslateArticleSection;
}

export class TextsGetItinerarioRequest extends LocalizedRequest implements ITextsGetItinerarioRequest {
    servizioID?: number | null;

    constructor(data?: ITextsGetItinerarioRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
        }
    }

    static fromJS(data: any): TextsGetItinerarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextsGetItinerarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITextsGetItinerarioRequest extends ILocalizedRequest {
    servizioID?: number | null;
}

export class TextGetArticlePhraseResponse extends OkApiResponse implements ITextGetArticlePhraseResponse {
    articlePhrase?: ArticlePhrase;

    constructor(data?: ITextGetArticlePhraseResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articlePhrase = _data["articlePhrase"] ? ArticlePhrase.fromJS(_data["articlePhrase"]) : <any>null;
        }
    }

    static fromJS(data: any): TextGetArticlePhraseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextGetArticlePhraseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articlePhrase"] = this.articlePhrase ? this.articlePhrase.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITextGetArticlePhraseResponse extends IOkApiResponse {
    articlePhrase?: ArticlePhrase;
}

export class TextGetArticlePhraseRequest extends LocalizedRequest implements ITextGetArticlePhraseRequest {
    phraseID?: number;

    constructor(data?: ITextGetArticlePhraseRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phraseID = _data["phraseID"] !== undefined ? _data["phraseID"] : <any>null;
        }
    }

    static fromJS(data: any): TextGetArticlePhraseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextGetArticlePhraseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phraseID"] = this.phraseID !== undefined ? this.phraseID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITextGetArticlePhraseRequest extends ILocalizedRequest {
    phraseID?: number;
}

export class NrTableResponseOfTextsRow extends OkApiResponse implements INrTableResponseOfTextsRow {
    /** Array delle righe della pagina richiesta */
    rows?: TextsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTextsRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TextsRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfTextsRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTextsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTextsRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TextsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ListTextsResponse extends NrTableResponseOfTextsRow implements IListTextsResponse {

    constructor(data?: IListTextsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ListTextsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListTextsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListTextsResponse extends INrTableResponseOfTextsRow {
}

export class TextsRow implements ITextsRow {
    id?: number;
    title?: string | null;
    luogo?: string | null;
    servizio?: string | null;
    contatto?: string | null;
    paese?: string | null;
    tipoServizio?: ETipoServizioFlags | null;
    status?: EStatoArticolo | null;

    constructor(data?: ITextsRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): TextsRow {
        data = typeof data === 'object' ? data : {};
        let result = new TextsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["contatto"] = this.contatto !== undefined ? this.contatto : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface ITextsRow {
    id?: number;
    title?: string | null;
    luogo?: string | null;
    servizio?: string | null;
    contatto?: string | null;
    paese?: string | null;
    tipoServizio?: ETipoServizioFlags | null;
    status?: EStatoArticolo | null;
}

export class ListTextsRequest extends NrTableRequest implements IListTextsRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
    /** Se true cerca solo frasi non associate a luogo */
    noLuogo?: boolean;
    /** Se true cerca solo frasi non associate a servizio */
    noServizio?: boolean;
    /** Se true cerca solo frasi non associate a contatto */
    noContatto?: boolean;
    /** Filtro sugli ID luogo. Se presente la frase deve appartenere ad uno di questi luoghi */
    luoghiIds?: number[] | null;
    /** Filtro sugli ID servizio. Se presente la frase deve appartenere ad uno di questi servizi */
    serviziIds?: number[] | null;
    /** Filtro sugli ID contatto. Se presente la frase deve appartenere ad uno di questi contatti */
    contattiIds?: number[] | null;
    paeseID?: number | null;
    status?: EStatoArticolo | null;
    tipoServizio?: ETipoServizioFlags | null;

    constructor(data?: IListTextsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.noLuogo = _data["noLuogo"] !== undefined ? _data["noLuogo"] : <any>null;
            this.noServizio = _data["noServizio"] !== undefined ? _data["noServizio"] : <any>null;
            this.noContatto = _data["noContatto"] !== undefined ? _data["noContatto"] : <any>null;
            if (Array.isArray(_data["luoghiIds"])) {
                this.luoghiIds = [] as any;
                for (let item of _data["luoghiIds"])
                    this.luoghiIds!.push(item);
            }
            else {
                this.luoghiIds = <any>null;
            }
            if (Array.isArray(_data["serviziIds"])) {
                this.serviziIds = [] as any;
                for (let item of _data["serviziIds"])
                    this.serviziIds!.push(item);
            }
            else {
                this.serviziIds = <any>null;
            }
            if (Array.isArray(_data["contattiIds"])) {
                this.contattiIds = [] as any;
                for (let item of _data["contattiIds"])
                    this.contattiIds!.push(item);
            }
            else {
                this.contattiIds = <any>null;
            }
            this.paeseID = _data["paeseID"] !== undefined ? _data["paeseID"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
        }
    }

    static fromJS(data: any): ListTextsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListTextsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["noLuogo"] = this.noLuogo !== undefined ? this.noLuogo : <any>null;
        data["noServizio"] = this.noServizio !== undefined ? this.noServizio : <any>null;
        data["noContatto"] = this.noContatto !== undefined ? this.noContatto : <any>null;
        if (Array.isArray(this.luoghiIds)) {
            data["luoghiIds"] = [];
            for (let item of this.luoghiIds)
                data["luoghiIds"].push(item);
        }
        if (Array.isArray(this.serviziIds)) {
            data["serviziIds"] = [];
            for (let item of this.serviziIds)
                data["serviziIds"].push(item);
        }
        if (Array.isArray(this.contattiIds)) {
            data["contattiIds"] = [];
            for (let item of this.contattiIds)
                data["contattiIds"].push(item);
        }
        data["paeseID"] = this.paeseID !== undefined ? this.paeseID : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IListTextsRequest extends INrTableRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
    /** Se true cerca solo frasi non associate a luogo */
    noLuogo?: boolean;
    /** Se true cerca solo frasi non associate a servizio */
    noServizio?: boolean;
    /** Se true cerca solo frasi non associate a contatto */
    noContatto?: boolean;
    /** Filtro sugli ID luogo. Se presente la frase deve appartenere ad uno di questi luoghi */
    luoghiIds?: number[] | null;
    /** Filtro sugli ID servizio. Se presente la frase deve appartenere ad uno di questi servizi */
    serviziIds?: number[] | null;
    /** Filtro sugli ID contatto. Se presente la frase deve appartenere ad uno di questi contatti */
    contattiIds?: number[] | null;
    paeseID?: number | null;
    status?: EStatoArticolo | null;
    tipoServizio?: ETipoServizioFlags | null;
}

/** Dati dell'utente */
export class UserDataResponse extends OkApiResponse implements IUserDataResponse {
    /** ID in chiaro */
    id?: number;
    /** User email */
    email?: string | null;
    /** ID criptato per operazioni in SSO */
    ssoToken?: string;
    /** Nome */
    nome?: string | null;
    /** Cognome */
    cognome?: string | null;
    /** Tipo di utente */
    tipo?: ETipoUtente;
    /** Elenco complessivo dei suoi permessi */
    permessi?: string[];
    /** Can Book Flight -> diverso dai permessi!!! e su userinfo */
    canBookFlights?: boolean;
    /** Può prenotare? */
    canBook?: boolean;
    /** Opzioni del frontend */
    opzioniUI?: OpzioniUI;
    /** Dati dell'agenzia dell'utente, se ne ha una */
    agencyData?: AgencyData | null;
    /** Dati di debug con le impostazioni del server */
    debugData?: DebugData;
    operator?: EOperatore;
    mustChangePassword?: boolean;
    resetPasswordCode?: string | null;

    constructor(data?: IUserDataResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.ssoToken = _data["ssoToken"] !== undefined ? _data["ssoToken"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            if (Array.isArray(_data["permessi"])) {
                this.permessi = [] as any;
                for (let item of _data["permessi"])
                    this.permessi!.push(item);
            }
            else {
                this.permessi = <any>null;
            }
            this.canBookFlights = _data["canBookFlights"] !== undefined ? _data["canBookFlights"] : <any>null;
            this.canBook = _data["canBook"] !== undefined ? _data["canBook"] : <any>null;
            this.opzioniUI = _data["opzioniUI"] ? OpzioniUI.fromJS(_data["opzioniUI"]) : <any>null;
            this.agencyData = _data["agencyData"] ? AgencyData.fromJS(_data["agencyData"]) : <any>null;
            this.debugData = _data["debugData"] ? DebugData.fromJS(_data["debugData"]) : <any>null;
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
            this.mustChangePassword = _data["mustChangePassword"] !== undefined ? _data["mustChangePassword"] : <any>null;
            this.resetPasswordCode = _data["resetPasswordCode"] !== undefined ? _data["resetPasswordCode"] : <any>null;
        }
    }

    static fromJS(data: any): UserDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["ssoToken"] = this.ssoToken !== undefined ? this.ssoToken : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        if (Array.isArray(this.permessi)) {
            data["permessi"] = [];
            for (let item of this.permessi)
                data["permessi"].push(item);
        }
        data["canBookFlights"] = this.canBookFlights !== undefined ? this.canBookFlights : <any>null;
        data["canBook"] = this.canBook !== undefined ? this.canBook : <any>null;
        data["opzioniUI"] = this.opzioniUI ? this.opzioniUI.toJSON() : <any>null;
        data["agencyData"] = this.agencyData ? this.agencyData.toJSON() : <any>null;
        data["debugData"] = this.debugData ? this.debugData.toJSON() : <any>null;
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        data["mustChangePassword"] = this.mustChangePassword !== undefined ? this.mustChangePassword : <any>null;
        data["resetPasswordCode"] = this.resetPasswordCode !== undefined ? this.resetPasswordCode : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Dati dell'utente */
export interface IUserDataResponse extends IOkApiResponse {
    /** ID in chiaro */
    id?: number;
    /** User email */
    email?: string | null;
    /** ID criptato per operazioni in SSO */
    ssoToken?: string;
    /** Nome */
    nome?: string | null;
    /** Cognome */
    cognome?: string | null;
    /** Tipo di utente */
    tipo?: ETipoUtente;
    /** Elenco complessivo dei suoi permessi */
    permessi?: string[];
    /** Can Book Flight -> diverso dai permessi!!! e su userinfo */
    canBookFlights?: boolean;
    /** Può prenotare? */
    canBook?: boolean;
    /** Opzioni del frontend */
    opzioniUI?: OpzioniUI;
    /** Dati dell'agenzia dell'utente, se ne ha una */
    agencyData?: AgencyData | null;
    /** Dati di debug con le impostazioni del server */
    debugData?: DebugData;
    operator?: EOperatore;
    mustChangePassword?: boolean;
    resetPasswordCode?: string | null;
}

export enum ETipoUtente {
    Privato = "Privato",
    Agenzia = "Agenzia",
    Intranet = "Intranet",
    TestCertificazioni = "TestCertificazioni",
}

/** Classe con le opzioni di frontend dell'utene */
export class OpzioniUI implements IOpzioniUI {
    /** Nome del tema del sito (usato dal sito vecchio) */
    theme?: string | null;
    /** Nome del tema Nebular della intranet */
    intranetTheme?: string | null;
    /** Lingua preferita */
    lang?: string | null;
    presaVisionePrivacy?: string | null;

    constructor(data?: IOpzioniUI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"] !== undefined ? _data["theme"] : <any>null;
            this.intranetTheme = _data["intranetTheme"] !== undefined ? _data["intranetTheme"] : <any>null;
            this.lang = _data["lang"] !== undefined ? _data["lang"] : <any>null;
            this.presaVisionePrivacy = _data["presaVisionePrivacy"] !== undefined ? _data["presaVisionePrivacy"] : <any>null;
        }
    }

    static fromJS(data: any): OpzioniUI {
        data = typeof data === 'object' ? data : {};
        let result = new OpzioniUI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme !== undefined ? this.theme : <any>null;
        data["intranetTheme"] = this.intranetTheme !== undefined ? this.intranetTheme : <any>null;
        data["lang"] = this.lang !== undefined ? this.lang : <any>null;
        data["presaVisionePrivacy"] = this.presaVisionePrivacy !== undefined ? this.presaVisionePrivacy : <any>null;
        return data;
    }
}

/** Classe con le opzioni di frontend dell'utene */
export interface IOpzioniUI {
    /** Nome del tema del sito (usato dal sito vecchio) */
    theme?: string | null;
    /** Nome del tema Nebular della intranet */
    intranetTheme?: string | null;
    /** Lingua preferita */
    lang?: string | null;
    presaVisionePrivacy?: string | null;
}

/** Dati dell'agenzia dell'utente */
export class AgencyData implements IAgencyData {
    /** ID del contatto agenzia */
    agencyID?: number;
    /** Nome visualizzato del contatto */
    agencyName?: string;
    /** Url del logo dell'agenzia, se ce l'ha */
    agencyLogoUrl?: string | null;

    constructor(data?: IAgencyData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyID = _data["agencyID"] !== undefined ? _data["agencyID"] : <any>null;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : <any>null;
            this.agencyLogoUrl = _data["agencyLogoUrl"] !== undefined ? _data["agencyLogoUrl"] : <any>null;
        }
    }

    static fromJS(data: any): AgencyData {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyID"] = this.agencyID !== undefined ? this.agencyID : <any>null;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : <any>null;
        data["agencyLogoUrl"] = this.agencyLogoUrl !== undefined ? this.agencyLogoUrl : <any>null;
        return data;
    }
}

/** Dati dell'agenzia dell'utente */
export interface IAgencyData {
    /** ID del contatto agenzia */
    agencyID?: number;
    /** Nome visualizzato del contatto */
    agencyName?: string;
    /** Url del logo dell'agenzia, se ce l'ha */
    agencyLogoUrl?: string | null;
}

export class DebugData implements IDebugData {
    /** Se true il server è compilato in debug */
    isDebug?: boolean;
    /** IP/Nome del server del database Naar7 */
    naarDatabaseServer?: string | null;
    /** Nome del database Naar7 */
    naarDatabaseName?: string | null;
    /** IP/Nome del server del database NaarHH */
    hhDatabaseServer?: string | null;
    /** Nome del database NaarHH */
    hhDatabaseName?: string | null;
    /** IP/Nome del server del database NaarDocs */
    docsDatabaseServer?: string | null;
    /** Nome del database NaarDocs */
    docsDatabaseName?: string | null;
    /** Coda delle richieste al pricer */
    pricerQueueName?: string | null;
    /** Coda delle richiestea all'agent */
    agentQueueName?: string | null;

    constructor(data?: IDebugData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDebug = _data["isDebug"] !== undefined ? _data["isDebug"] : <any>null;
            this.naarDatabaseServer = _data["naarDatabaseServer"] !== undefined ? _data["naarDatabaseServer"] : <any>null;
            this.naarDatabaseName = _data["naarDatabaseName"] !== undefined ? _data["naarDatabaseName"] : <any>null;
            this.hhDatabaseServer = _data["hhDatabaseServer"] !== undefined ? _data["hhDatabaseServer"] : <any>null;
            this.hhDatabaseName = _data["hhDatabaseName"] !== undefined ? _data["hhDatabaseName"] : <any>null;
            this.docsDatabaseServer = _data["docsDatabaseServer"] !== undefined ? _data["docsDatabaseServer"] : <any>null;
            this.docsDatabaseName = _data["docsDatabaseName"] !== undefined ? _data["docsDatabaseName"] : <any>null;
            this.pricerQueueName = _data["pricerQueueName"] !== undefined ? _data["pricerQueueName"] : <any>null;
            this.agentQueueName = _data["agentQueueName"] !== undefined ? _data["agentQueueName"] : <any>null;
        }
    }

    static fromJS(data: any): DebugData {
        data = typeof data === 'object' ? data : {};
        let result = new DebugData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDebug"] = this.isDebug !== undefined ? this.isDebug : <any>null;
        data["naarDatabaseServer"] = this.naarDatabaseServer !== undefined ? this.naarDatabaseServer : <any>null;
        data["naarDatabaseName"] = this.naarDatabaseName !== undefined ? this.naarDatabaseName : <any>null;
        data["hhDatabaseServer"] = this.hhDatabaseServer !== undefined ? this.hhDatabaseServer : <any>null;
        data["hhDatabaseName"] = this.hhDatabaseName !== undefined ? this.hhDatabaseName : <any>null;
        data["docsDatabaseServer"] = this.docsDatabaseServer !== undefined ? this.docsDatabaseServer : <any>null;
        data["docsDatabaseName"] = this.docsDatabaseName !== undefined ? this.docsDatabaseName : <any>null;
        data["pricerQueueName"] = this.pricerQueueName !== undefined ? this.pricerQueueName : <any>null;
        data["agentQueueName"] = this.agentQueueName !== undefined ? this.agentQueueName : <any>null;
        return data;
    }
}

export interface IDebugData {
    /** Se true il server è compilato in debug */
    isDebug?: boolean;
    /** IP/Nome del server del database Naar7 */
    naarDatabaseServer?: string | null;
    /** Nome del database Naar7 */
    naarDatabaseName?: string | null;
    /** IP/Nome del server del database NaarHH */
    hhDatabaseServer?: string | null;
    /** Nome del database NaarHH */
    hhDatabaseName?: string | null;
    /** IP/Nome del server del database NaarDocs */
    docsDatabaseServer?: string | null;
    /** Nome del database NaarDocs */
    docsDatabaseName?: string | null;
    /** Coda delle richieste al pricer */
    pricerQueueName?: string | null;
    /** Coda delle richiestea all'agent */
    agentQueueName?: string | null;
}

export class CheckCrossLoginResponse extends OkApiResponse implements ICheckCrossLoginResponse {
    /** Nome visualizzato dell'utente che ha chiesto il token e che dovrà autenticarsi */
    requestUserDiplayName?: string | null;
    /** Nome visualzzato dell'utente target */
    targetUserDisplayName?: string | null;

    constructor(data?: ICheckCrossLoginResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestUserDiplayName = _data["requestUserDiplayName"] !== undefined ? _data["requestUserDiplayName"] : <any>null;
            this.targetUserDisplayName = _data["targetUserDisplayName"] !== undefined ? _data["targetUserDisplayName"] : <any>null;
        }
    }

    static fromJS(data: any): CheckCrossLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckCrossLoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestUserDiplayName"] = this.requestUserDiplayName !== undefined ? this.requestUserDiplayName : <any>null;
        data["targetUserDisplayName"] = this.targetUserDisplayName !== undefined ? this.targetUserDisplayName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICheckCrossLoginResponse extends IOkApiResponse {
    /** Nome visualizzato dell'utente che ha chiesto il token e che dovrà autenticarsi */
    requestUserDiplayName?: string | null;
    /** Nome visualzzato dell'utente target */
    targetUserDisplayName?: string | null;
}

export class CheckCrossLoginRequest extends ApiRequest implements ICheckCrossLoginRequest {
    /** Codice univoco monouso da testare */
    codice?: string;

    constructor(data?: ICheckCrossLoginRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
        }
    }

    static fromJS(data: any): CheckCrossLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckCrossLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICheckCrossLoginRequest extends IApiRequest {
    /** Codice univoco monouso da testare */
    codice?: string;
}

/** Form di login */
export class LoginRequest extends ApiRequest implements ILoginRequest {
    /** Nome utente */
    username!: string;
    /** Password */
    password!: string;
    /** Eventuale codice di cross login per impersonare un altro utente */
    crossLoginCode?: string | null;

    constructor(data?: ILoginRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.crossLoginCode = _data["crossLoginCode"] !== undefined ? _data["crossLoginCode"] : <any>null;
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["crossLoginCode"] = this.crossLoginCode !== undefined ? this.crossLoginCode : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Form di login */
export interface ILoginRequest extends IApiRequest {
    /** Nome utente */
    username: string;
    /** Password */
    password: string;
    /** Eventuale codice di cross login per impersonare un altro utente */
    crossLoginCode?: string | null;
}

export class LoginViaEmailRequest extends ApiRequest implements ILoginViaEmailRequest {
    /** Nome utente */
    username!: string;
    /** Codice per accesso temporaneo */
    emailLoginCode!: string;

    constructor(data?: ILoginViaEmailRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.emailLoginCode = _data["emailLoginCode"] !== undefined ? _data["emailLoginCode"] : <any>null;
        }
    }

    static fromJS(data: any): LoginViaEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginViaEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["emailLoginCode"] = this.emailLoginCode !== undefined ? this.emailLoginCode : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ILoginViaEmailRequest extends IApiRequest {
    /** Nome utente */
    username: string;
    /** Codice per accesso temporaneo */
    emailLoginCode: string;
}

/** Risposta al salvataggio delle opzioni utente */
export class SaveUserOptionsResponse extends OkApiResponse implements ISaveUserOptionsResponse {
    /** Oggetto utente aggiornato */
    user?: Utente;
    /** Opzioni utente aggiorntate */
    uiOptions?: any;

    constructor(data?: ISaveUserOptionsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? Utente.fromJS(_data["user"]) : <any>null;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : <any>null;
        }
    }

    static fromJS(data: any): SaveUserOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Risposta al salvataggio delle opzioni utente */
export interface ISaveUserOptionsResponse extends IOkApiResponse {
    /** Oggetto utente aggiornato */
    user?: Utente;
    /** Opzioni utente aggiorntate */
    uiOptions?: any;
}

export class Utente implements IUtente {
    id?: number;
    contattoAgenziaID?: number | null;
    contattoUtenteID?: number | null;
    tipoUtente?: ETipoUtente | null;
    registrationDate?: string;
    email?: string | null;
    nome?: string | null;
    cognome?: string | null;
    passwordInChiaro?: string | null;
    passwordCifrata?: string | null;
    abilitato?: boolean;
    deleted?: string | null;
    operatoreID?: number | null;
    operatore?: EOperatore | null;
    abilitazioneCrs?: number | null;
    telefono?: string | null;
    teamID?: string | null;
    npr?: boolean;
    uiOptions?: string | null;
    fuorisede?: boolean;
    emailFuorisede?: string | null;
    categoriaContattoID?: number | null;
    utentePadreID?: number | null;
    basecampRefreshToken?: string | null;
    ultimoAccesso?: string | null;
    ultimoAggiornamentoPassword?: string | null;
    fastLoginEnabled?: boolean | null;
    fastLogingEnabledDate?: string | null;
    fastLoginTokenValidityDays?: number | null;
    fastLoginToken?: string | null;
    emailLoginEnabled?: boolean | null;

    constructor(data?: IUtente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : <any>null;
            this.contattoUtenteID = _data["contattoUtenteID"] !== undefined ? _data["contattoUtenteID"] : <any>null;
            this.tipoUtente = _data["tipoUtente"] !== undefined ? _data["tipoUtente"] : <any>null;
            this.registrationDate = _data["registrationDate"] !== undefined ? _data["registrationDate"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.passwordInChiaro = _data["passwordInChiaro"] !== undefined ? _data["passwordInChiaro"] : <any>null;
            this.passwordCifrata = _data["passwordCifrata"] !== undefined ? _data["passwordCifrata"] : <any>null;
            this.abilitato = _data["abilitato"] !== undefined ? _data["abilitato"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.abilitazioneCrs = _data["abilitazioneCrs"] !== undefined ? _data["abilitazioneCrs"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : <any>null;
            this.npr = _data["npr"] !== undefined ? _data["npr"] : <any>null;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : <any>null;
            this.fuorisede = _data["fuorisede"] !== undefined ? _data["fuorisede"] : <any>null;
            this.emailFuorisede = _data["emailFuorisede"] !== undefined ? _data["emailFuorisede"] : <any>null;
            this.categoriaContattoID = _data["categoriaContattoID"] !== undefined ? _data["categoriaContattoID"] : <any>null;
            this.utentePadreID = _data["utentePadreID"] !== undefined ? _data["utentePadreID"] : <any>null;
            this.basecampRefreshToken = _data["basecampRefreshToken"] !== undefined ? _data["basecampRefreshToken"] : <any>null;
            this.ultimoAccesso = _data["ultimoAccesso"] !== undefined ? _data["ultimoAccesso"] : <any>null;
            this.ultimoAggiornamentoPassword = _data["ultimoAggiornamentoPassword"] !== undefined ? _data["ultimoAggiornamentoPassword"] : <any>null;
            this.fastLoginEnabled = _data["fastLoginEnabled"] !== undefined ? _data["fastLoginEnabled"] : <any>null;
            this.fastLogingEnabledDate = _data["fastLogingEnabledDate"] !== undefined ? _data["fastLogingEnabledDate"] : <any>null;
            this.fastLoginTokenValidityDays = _data["fastLoginTokenValidityDays"] !== undefined ? _data["fastLoginTokenValidityDays"] : <any>null;
            this.fastLoginToken = _data["fastLoginToken"] !== undefined ? _data["fastLoginToken"] : <any>null;
            this.emailLoginEnabled = _data["emailLoginEnabled"] !== undefined ? _data["emailLoginEnabled"] : <any>null;
        }
    }

    static fromJS(data: any): Utente {
        data = typeof data === 'object' ? data : {};
        let result = new Utente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : <any>null;
        data["contattoUtenteID"] = this.contattoUtenteID !== undefined ? this.contattoUtenteID : <any>null;
        data["tipoUtente"] = this.tipoUtente !== undefined ? this.tipoUtente : <any>null;
        data["registrationDate"] = this.registrationDate !== undefined ? this.registrationDate : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["passwordInChiaro"] = this.passwordInChiaro !== undefined ? this.passwordInChiaro : <any>null;
        data["passwordCifrata"] = this.passwordCifrata !== undefined ? this.passwordCifrata : <any>null;
        data["abilitato"] = this.abilitato !== undefined ? this.abilitato : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["abilitazioneCrs"] = this.abilitazioneCrs !== undefined ? this.abilitazioneCrs : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["teamID"] = this.teamID !== undefined ? this.teamID : <any>null;
        data["npr"] = this.npr !== undefined ? this.npr : <any>null;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : <any>null;
        data["fuorisede"] = this.fuorisede !== undefined ? this.fuorisede : <any>null;
        data["emailFuorisede"] = this.emailFuorisede !== undefined ? this.emailFuorisede : <any>null;
        data["categoriaContattoID"] = this.categoriaContattoID !== undefined ? this.categoriaContattoID : <any>null;
        data["utentePadreID"] = this.utentePadreID !== undefined ? this.utentePadreID : <any>null;
        data["basecampRefreshToken"] = this.basecampRefreshToken !== undefined ? this.basecampRefreshToken : <any>null;
        data["ultimoAccesso"] = this.ultimoAccesso !== undefined ? this.ultimoAccesso : <any>null;
        data["ultimoAggiornamentoPassword"] = this.ultimoAggiornamentoPassword !== undefined ? this.ultimoAggiornamentoPassword : <any>null;
        data["fastLoginEnabled"] = this.fastLoginEnabled !== undefined ? this.fastLoginEnabled : <any>null;
        data["fastLogingEnabledDate"] = this.fastLogingEnabledDate !== undefined ? this.fastLogingEnabledDate : <any>null;
        data["fastLoginTokenValidityDays"] = this.fastLoginTokenValidityDays !== undefined ? this.fastLoginTokenValidityDays : <any>null;
        data["fastLoginToken"] = this.fastLoginToken !== undefined ? this.fastLoginToken : <any>null;
        data["emailLoginEnabled"] = this.emailLoginEnabled !== undefined ? this.emailLoginEnabled : <any>null;
        return data;
    }
}

export interface IUtente {
    id?: number;
    contattoAgenziaID?: number | null;
    contattoUtenteID?: number | null;
    tipoUtente?: ETipoUtente | null;
    registrationDate?: string;
    email?: string | null;
    nome?: string | null;
    cognome?: string | null;
    passwordInChiaro?: string | null;
    passwordCifrata?: string | null;
    abilitato?: boolean;
    deleted?: string | null;
    operatoreID?: number | null;
    operatore?: EOperatore | null;
    abilitazioneCrs?: number | null;
    telefono?: string | null;
    teamID?: string | null;
    npr?: boolean;
    uiOptions?: string | null;
    fuorisede?: boolean;
    emailFuorisede?: string | null;
    categoriaContattoID?: number | null;
    utentePadreID?: number | null;
    basecampRefreshToken?: string | null;
    ultimoAccesso?: string | null;
    ultimoAggiornamentoPassword?: string | null;
    fastLoginEnabled?: boolean | null;
    fastLogingEnabledDate?: string | null;
    fastLoginTokenValidityDays?: number | null;
    fastLoginToken?: string | null;
    emailLoginEnabled?: boolean | null;
}

/** Richiesta di salvataggio delle opzioni utente */
export class SaveUserOptionsRequest extends ApiRequest implements ISaveUserOptionsRequest {
    /** Dati dell'utente */
    user?: Utente;
    /** Opzioni di frontend */
    uiOptions?: any;

    constructor(data?: ISaveUserOptionsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? Utente.fromJS(_data["user"]) : <any>null;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : <any>null;
        }
    }

    static fromJS(data: any): SaveUserOptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserOptionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Richiesta di salvataggio delle opzioni utente */
export interface ISaveUserOptionsRequest extends IApiRequest {
    /** Dati dell'utente */
    user?: Utente;
    /** Opzioni di frontend */
    uiOptions?: any;
}

export class SendLoginViaEmailResponse extends OkApiResponse implements ISendLoginViaEmailResponse {

    constructor(data?: ISendLoginViaEmailResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SendLoginViaEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendLoginViaEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISendLoginViaEmailResponse extends IOkApiResponse {
}

export class SendLoginViaEmailRequest extends LocalizedRequest implements ISendLoginViaEmailRequest {
    emailAddress?: string | null;

    constructor(data?: ISendLoginViaEmailRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
        }
    }

    static fromJS(data: any): SendLoginViaEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendLoginViaEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISendLoginViaEmailRequest extends ILocalizedRequest {
    emailAddress?: string | null;
}

export class AutocompleteValueResponse extends OkApiResponse implements IAutocompleteValueResponse {
    value?: AutocompleteValue | null;

    constructor(data?: IAutocompleteValueResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? AutocompleteValue.fromJS(_data["value"]) : <any>null;
        }
    }

    static fromJS(data: any): AutocompleteValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AutocompleteValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAutocompleteValueResponse extends IOkApiResponse {
    value?: AutocompleteValue | null;
}

export class AutocompleteValue implements IAutocompleteValue {
    id?: string | null;
    label?: string | null;
    value?: string | null;
    qualifier?: string | null;
    extraInt?: number | null;
    extraString?: string | null;
    extraString2?: string | null;
    extraDecimal?: number | null;
    extraBool?: boolean;
    inactive?: boolean;
    deleted?: boolean;

    constructor(data?: IAutocompleteValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.qualifier = _data["qualifier"] !== undefined ? _data["qualifier"] : <any>null;
            this.extraInt = _data["extraInt"] !== undefined ? _data["extraInt"] : <any>null;
            this.extraString = _data["extraString"] !== undefined ? _data["extraString"] : <any>null;
            this.extraString2 = _data["extraString2"] !== undefined ? _data["extraString2"] : <any>null;
            this.extraDecimal = _data["extraDecimal"] !== undefined ? _data["extraDecimal"] : <any>null;
            this.extraBool = _data["extraBool"] !== undefined ? _data["extraBool"] : <any>null;
            this.inactive = _data["inactive"] !== undefined ? _data["inactive"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
        }
    }

    static fromJS(data: any): AutocompleteValue {
        data = typeof data === 'object' ? data : {};
        let result = new AutocompleteValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["qualifier"] = this.qualifier !== undefined ? this.qualifier : <any>null;
        data["extraInt"] = this.extraInt !== undefined ? this.extraInt : <any>null;
        data["extraString"] = this.extraString !== undefined ? this.extraString : <any>null;
        data["extraString2"] = this.extraString2 !== undefined ? this.extraString2 : <any>null;
        data["extraDecimal"] = this.extraDecimal !== undefined ? this.extraDecimal : <any>null;
        data["extraBool"] = this.extraBool !== undefined ? this.extraBool : <any>null;
        data["inactive"] = this.inactive !== undefined ? this.inactive : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        return data;
    }
}

export interface IAutocompleteValue {
    id?: string | null;
    label?: string | null;
    value?: string | null;
    qualifier?: string | null;
    extraInt?: number | null;
    extraString?: string | null;
    extraString2?: string | null;
    extraDecimal?: number | null;
    extraBool?: boolean;
    inactive?: boolean;
    deleted?: boolean;
}

export class AutocompleteRequest extends SiteRequest implements IAutocompleteRequest {
    tableName?: string | null;
    term?: string | null;
    limit?: number | null;
    pageNr?: number | null;
    fieldName?: string | null;
    nameFormat?: string | null;
    foreingKeyValue?: string | null;
    id?: string | null;

    constructor(data?: IAutocompleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"] !== undefined ? _data["tableName"] : <any>null;
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.pageNr = _data["pageNr"] !== undefined ? _data["pageNr"] : <any>null;
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : <any>null;
            this.nameFormat = _data["nameFormat"] !== undefined ? _data["nameFormat"] : <any>null;
            this.foreingKeyValue = _data["foreingKeyValue"] !== undefined ? _data["foreingKeyValue"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AutocompleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AutocompleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName !== undefined ? this.tableName : <any>null;
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["pageNr"] = this.pageNr !== undefined ? this.pageNr : <any>null;
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : <any>null;
        data["nameFormat"] = this.nameFormat !== undefined ? this.nameFormat : <any>null;
        data["foreingKeyValue"] = this.foreingKeyValue !== undefined ? this.foreingKeyValue : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAutocompleteRequest extends ISiteRequest {
    tableName?: string | null;
    term?: string | null;
    limit?: number | null;
    pageNr?: number | null;
    fieldName?: string | null;
    nameFormat?: string | null;
    foreingKeyValue?: string | null;
    id?: string | null;
}

export class AutocompleteSearchResponse extends OkApiResponse implements IAutocompleteSearchResponse {
    values?: AutocompleteValue[] | null;
    hasMore?: boolean;

    constructor(data?: IAutocompleteSearchResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(AutocompleteValue.fromJS(item));
            }
            else {
                this.values = <any>null;
            }
            this.hasMore = _data["hasMore"] !== undefined ? _data["hasMore"] : <any>null;
        }
    }

    static fromJS(data: any): AutocompleteSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AutocompleteSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["hasMore"] = this.hasMore !== undefined ? this.hasMore : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAutocompleteSearchResponse extends IOkApiResponse {
    values?: AutocompleteValue[] | null;
    hasMore?: boolean;
}

export class GetB2cArticleResponse extends OkApiResponse implements IGetB2cArticleResponse {
    article?: B2cArticle | null;

    constructor(data?: IGetB2cArticleResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.article = _data["article"] ? B2cArticle.fromJS(_data["article"]) : <any>null;
        }
    }

    static fromJS(data: any): GetB2cArticleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetB2cArticleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["article"] = this.article ? this.article.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetB2cArticleResponse extends IOkApiResponse {
    article?: B2cArticle | null;
}

export class B2cArticle implements IB2cArticle {
    articleId?: number;
    title?: string | null;
    text?: string | null;
    luogoId?: number;
    numberOfImages?: number;

    constructor(data?: IB2cArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : <any>null;
            this.numberOfImages = _data["numberOfImages"] !== undefined ? _data["numberOfImages"] : <any>null;
        }
    }

    static fromJS(data: any): B2cArticle {
        data = typeof data === 'object' ? data : {};
        let result = new B2cArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : <any>null;
        data["numberOfImages"] = this.numberOfImages !== undefined ? this.numberOfImages : <any>null;
        return data;
    }
}

export interface IB2cArticle {
    articleId?: number;
    title?: string | null;
    text?: string | null;
    luogoId?: number;
    numberOfImages?: number;
}

export class GetB2cArticleRequest extends SiteRequest implements IGetB2cArticleRequest {
    articleID?: number;
    parseToken?: boolean;

    constructor(data?: IGetB2cArticleRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articleID = _data["articleID"] !== undefined ? _data["articleID"] : <any>null;
            this.parseToken = _data["parseToken"] !== undefined ? _data["parseToken"] : <any>null;
        }
    }

    static fromJS(data: any): GetB2cArticleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetB2cArticleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleID"] = this.articleID !== undefined ? this.articleID : <any>null;
        data["parseToken"] = this.parseToken !== undefined ? this.parseToken : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetB2cArticleRequest extends ISiteRequest {
    articleID?: number;
    parseToken?: boolean;
}

export class NrTableResponseOfAgenciesListRow extends OkApiResponse implements INrTableResponseOfAgenciesListRow {
    /** Array delle righe della pagina richiesta */
    rows?: AgenciesListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAgenciesListRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AgenciesListRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfAgenciesListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAgenciesListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAgenciesListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AgenciesListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class AgenciesListRow implements IAgenciesListRow {
    contactID?: number;
    nome?: string | null;
    indirizzo?: string | null;
    cap?: string | null;
    telefono?: string | null;
    prov?: string | null;
    luogo?: string | null;

    constructor(data?: IAgenciesListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.prov = _data["prov"] !== undefined ? _data["prov"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
        }
    }

    static fromJS(data: any): AgenciesListRow {
        data = typeof data === 'object' ? data : {};
        let result = new AgenciesListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactID"] = this.contactID !== undefined ? this.contactID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["prov"] = this.prov !== undefined ? this.prov : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        return data;
    }
}

export interface IAgenciesListRow {
    contactID?: number;
    nome?: string | null;
    indirizzo?: string | null;
    cap?: string | null;
    telefono?: string | null;
    prov?: string | null;
    luogo?: string | null;
}

export class AgenciesListRequest extends NrTableRequest implements IAgenciesListRequest {
    cap?: number | null;
    prov?: string | null;
    citta?: string | null;
    position?: string | null;
    raggio?: number | null;

    constructor(data?: IAgenciesListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.prov = _data["prov"] !== undefined ? _data["prov"] : <any>null;
            this.citta = _data["citta"] !== undefined ? _data["citta"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.raggio = _data["raggio"] !== undefined ? _data["raggio"] : <any>null;
        }
    }

    static fromJS(data: any): AgenciesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgenciesListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["prov"] = this.prov !== undefined ? this.prov : <any>null;
        data["citta"] = this.citta !== undefined ? this.citta : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["raggio"] = this.raggio !== undefined ? this.raggio : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAgenciesListRequest extends INrTableRequest {
    cap?: number | null;
    prov?: string | null;
    citta?: string | null;
    position?: string | null;
    raggio?: number | null;
}

export class GetDestinationResponse extends OkApiResponse implements IGetDestinationResponse {
    destination?: DestinationInfo | null;

    constructor(data?: IGetDestinationResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.destination = _data["destination"] ? DestinationInfo.fromJS(_data["destination"]) : <any>null;
        }
    }

    static fromJS(data: any): GetDestinationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDestinationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destination"] = this.destination ? this.destination.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetDestinationResponse extends IOkApiResponse {
    destination?: DestinationInfo | null;
}

/** Intestazione di una destinazione;    nome, Abstract (Descrizione), Immagine di copertina */
export class Destination implements IDestination {
    lingua?: ELingua;
    luogoID?: number;
    coverImageUrl?: string | null;
    nome?: string | null;
    nomeAbbreviato?: string | null;
    abstract?: string | null;
    gaColor?: string | null;
    gaBgColor?: string | null;
    gaIcon?: string | null;
    ordine?: number;

    constructor(data?: IDestination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.coverImageUrl = _data["coverImageUrl"] !== undefined ? _data["coverImageUrl"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeAbbreviato = _data["nomeAbbreviato"] !== undefined ? _data["nomeAbbreviato"] : <any>null;
            this.abstract = _data["abstract"] !== undefined ? _data["abstract"] : <any>null;
            this.gaColor = _data["gaColor"] !== undefined ? _data["gaColor"] : <any>null;
            this.gaBgColor = _data["gaBgColor"] !== undefined ? _data["gaBgColor"] : <any>null;
            this.gaIcon = _data["gaIcon"] !== undefined ? _data["gaIcon"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
        }
    }

    static fromJS(data: any): Destination {
        data = typeof data === 'object' ? data : {};
        let result = new Destination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["coverImageUrl"] = this.coverImageUrl !== undefined ? this.coverImageUrl : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeAbbreviato"] = this.nomeAbbreviato !== undefined ? this.nomeAbbreviato : <any>null;
        data["abstract"] = this.abstract !== undefined ? this.abstract : <any>null;
        data["gaColor"] = this.gaColor !== undefined ? this.gaColor : <any>null;
        data["gaBgColor"] = this.gaBgColor !== undefined ? this.gaBgColor : <any>null;
        data["gaIcon"] = this.gaIcon !== undefined ? this.gaIcon : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        return data;
    }
}

/** Intestazione di una destinazione;    nome, Abstract (Descrizione), Immagine di copertina */
export interface IDestination {
    lingua?: ELingua;
    luogoID?: number;
    coverImageUrl?: string | null;
    nome?: string | null;
    nomeAbbreviato?: string | null;
    abstract?: string | null;
    gaColor?: string | null;
    gaBgColor?: string | null;
    gaIcon?: string | null;
    ordine?: number;
}

/** Versione completa di una Destinazione    tutti i viaggi ad essa legati */
export class DestinationInfo extends Destination implements IDestinationInfo {
    elencoViaggi?: TripHead[] | null;
    elencoImmagini?: ImageSeed[] | null;

    constructor(data?: IDestinationInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["elencoViaggi"])) {
                this.elencoViaggi = [] as any;
                for (let item of _data["elencoViaggi"])
                    this.elencoViaggi!.push(TripHead.fromJS(item));
            }
            else {
                this.elencoViaggi = <any>null;
            }
            if (Array.isArray(_data["elencoImmagini"])) {
                this.elencoImmagini = [] as any;
                for (let item of _data["elencoImmagini"])
                    this.elencoImmagini!.push(ImageSeed.fromJS(item));
            }
            else {
                this.elencoImmagini = <any>null;
            }
        }
    }

    static fromJS(data: any): DestinationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DestinationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elencoViaggi)) {
            data["elencoViaggi"] = [];
            for (let item of this.elencoViaggi)
                data["elencoViaggi"].push(item.toJSON());
        }
        if (Array.isArray(this.elencoImmagini)) {
            data["elencoImmagini"] = [];
            for (let item of this.elencoImmagini)
                data["elencoImmagini"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

/** Versione completa di una Destinazione    tutti i viaggi ad essa legati */
export interface IDestinationInfo extends IDestination {
    elencoViaggi?: TripHead[] | null;
    elencoImmagini?: ImageSeed[] | null;
}

/** È l'intestazione di un viaggio;    Nome, Luogo, Descrizione sommaria (Abstract), immagine di copertina */
export class TripHead implements ITripHead {
    tripID?: number;
    nome?: string | null;
    luogo?: string | null;
    descr?: string | null;
    cover?: string | null;
    lingua?: ELingua;
    durata?: ServiceDuration | null;
    ideas?: number[] | null;
    destinations?: number[] | null;
    map?: TripMap | null;

    constructor(data?: ITripHead) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.descr = _data["descr"] !== undefined ? _data["descr"] : <any>null;
            this.cover = _data["cover"] !== undefined ? _data["cover"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.durata = _data["durata"] ? ServiceDuration.fromJS(_data["durata"]) : <any>null;
            if (Array.isArray(_data["ideas"])) {
                this.ideas = [] as any;
                for (let item of _data["ideas"])
                    this.ideas!.push(item);
            }
            else {
                this.ideas = <any>null;
            }
            if (Array.isArray(_data["destinations"])) {
                this.destinations = [] as any;
                for (let item of _data["destinations"])
                    this.destinations!.push(item);
            }
            else {
                this.destinations = <any>null;
            }
            this.map = _data["map"] ? TripMap.fromJS(_data["map"]) : <any>null;
        }
    }

    static fromJS(data: any): TripHead {
        data = typeof data === 'object' ? data : {};
        let result = new TripHead();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["descr"] = this.descr !== undefined ? this.descr : <any>null;
        data["cover"] = this.cover !== undefined ? this.cover : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["durata"] = this.durata ? this.durata.toJSON() : <any>null;
        if (Array.isArray(this.ideas)) {
            data["ideas"] = [];
            for (let item of this.ideas)
                data["ideas"].push(item);
        }
        if (Array.isArray(this.destinations)) {
            data["destinations"] = [];
            for (let item of this.destinations)
                data["destinations"].push(item);
        }
        data["map"] = this.map ? this.map.toJSON() : <any>null;
        return data;
    }
}

/** È l'intestazione di un viaggio;    Nome, Luogo, Descrizione sommaria (Abstract), immagine di copertina */
export interface ITripHead {
    tripID?: number;
    nome?: string | null;
    luogo?: string | null;
    descr?: string | null;
    cover?: string | null;
    lingua?: ELingua;
    durata?: ServiceDuration | null;
    ideas?: number[] | null;
    destinations?: number[] | null;
    map?: TripMap | null;
}

export class ServiceDuration implements IServiceDuration {
    giorni?: number;
    notti?: number;

    constructor(data?: IServiceDuration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceDuration {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorni"] = this.giorni !== undefined ? this.giorni : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        return data;
    }
}

export interface IServiceDuration {
    giorni?: number;
    notti?: number;
}

export class TripMap implements ITripMap {
    lat?: number;
    long?: number;
    zoom?: number;

    constructor(data?: ITripMap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.long = _data["long"] !== undefined ? _data["long"] : <any>null;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : <any>null;
        }
    }

    static fromJS(data: any): TripMap {
        data = typeof data === 'object' ? data : {};
        let result = new TripMap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["long"] = this.long !== undefined ? this.long : <any>null;
        data["zoom"] = this.zoom !== undefined ? this.zoom : <any>null;
        return data;
    }
}

export interface ITripMap {
    lat?: number;
    long?: number;
    zoom?: number;
}

export class ImageSeed implements IImageSeed {
    id?: number;
    url?: string;
    caption?: string;

    constructor(data?: IImageSeed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.caption = _data["caption"] !== undefined ? _data["caption"] : <any>null;
        }
    }

    static fromJS(data: any): ImageSeed {
        data = typeof data === 'object' ? data : {};
        let result = new ImageSeed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        return data;
    }
}

export interface IImageSeed {
    id?: number;
    url?: string;
    caption?: string;
}

export class GetDestinationRequest extends SiteRequest implements IGetDestinationRequest {
    destinationID?: number;

    constructor(data?: IGetDestinationRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.destinationID = _data["destinationID"] !== undefined ? _data["destinationID"] : <any>null;
        }
    }

    static fromJS(data: any): GetDestinationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDestinationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationID"] = this.destinationID !== undefined ? this.destinationID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetDestinationRequest extends ISiteRequest {
    destinationID?: number;
}

export class GetDestinationsResponse extends OkApiResponse implements IGetDestinationsResponse {
    destinazioni?: Destination[] | null;

    constructor(data?: IGetDestinationsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["destinazioni"])) {
                this.destinazioni = [] as any;
                for (let item of _data["destinazioni"])
                    this.destinazioni!.push(Destination.fromJS(item));
            }
            else {
                this.destinazioni = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDestinationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDestinationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.destinazioni)) {
            data["destinazioni"] = [];
            for (let item of this.destinazioni)
                data["destinazioni"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDestinationsResponse extends IOkApiResponse {
    destinazioni?: Destination[] | null;
}

export class GetOpenDestinationsResponse extends OkApiResponse implements IGetOpenDestinationsResponse {
    destinazioni?: OpenDestination[] | null;

    constructor(data?: IGetOpenDestinationsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["destinazioni"])) {
                this.destinazioni = [] as any;
                for (let item of _data["destinazioni"])
                    this.destinazioni!.push(OpenDestination.fromJS(item));
            }
            else {
                this.destinazioni = <any>null;
            }
        }
    }

    static fromJS(data: any): GetOpenDestinationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOpenDestinationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.destinazioni)) {
            data["destinazioni"] = [];
            for (let item of this.destinazioni)
                data["destinazioni"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetOpenDestinationsResponse extends IOkApiResponse {
    destinazioni?: OpenDestination[] | null;
}

export class OpenDestination implements IOpenDestination {
    articles?: OpenDestinationArticle[] | null;
    destinazione?: Destination | null;
    order?: number;

    constructor(data?: IOpenDestination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["articles"])) {
                this.articles = [] as any;
                for (let item of _data["articles"])
                    this.articles!.push(OpenDestinationArticle.fromJS(item));
            }
            else {
                this.articles = <any>null;
            }
            this.destinazione = _data["destinazione"] ? Destination.fromJS(_data["destinazione"]) : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): OpenDestination {
        data = typeof data === 'object' ? data : {};
        let result = new OpenDestination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.articles)) {
            data["articles"] = [];
            for (let item of this.articles)
                data["articles"].push(item.toJSON());
        }
        data["destinazione"] = this.destinazione ? this.destinazione.toJSON() : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        return data;
    }
}

export interface IOpenDestination {
    articles?: OpenDestinationArticle[] | null;
    destinazione?: Destination | null;
    order?: number;
}

export class OpenDestinationArticle implements IOpenDestinationArticle {
    id?: number;
    title?: string | null;
    text?: string | null;
    updateAt?: string | null;
    order?: number;
    allegati?: ArticoloAllegato[] | null;

    constructor(data?: IOpenDestinationArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.updateAt = _data["updateAt"] !== undefined ? _data["updateAt"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(ArticoloAllegato.fromJS(item));
            }
            else {
                this.allegati = <any>null;
            }
        }
    }

    static fromJS(data: any): OpenDestinationArticle {
        data = typeof data === 'object' ? data : {};
        let result = new OpenDestinationArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["updateAt"] = this.updateAt !== undefined ? this.updateAt : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOpenDestinationArticle {
    id?: number;
    title?: string | null;
    text?: string | null;
    updateAt?: string | null;
    order?: number;
    allegati?: ArticoloAllegato[] | null;
}

export class GetIdeasResponse extends OkApiResponse implements IGetIdeasResponse {
    idee?: Idea[] | null;

    constructor(data?: IGetIdeasResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["idee"])) {
                this.idee = [] as any;
                for (let item of _data["idee"])
                    this.idee!.push(Idea.fromJS(item));
            }
            else {
                this.idee = <any>null;
            }
        }
    }

    static fromJS(data: any): GetIdeasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIdeasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.idee)) {
            data["idee"] = [];
            for (let item of this.idee)
                data["idee"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetIdeasResponse extends IOkApiResponse {
    idee?: Idea[] | null;
}

/** Descrittore dell'Idea di viaggio */
export class Idea implements IIdea {
    ideaID?: number;
    nome?: string | null;
    gliphIdx?: number | null;
    gliphName?: string | null;
    gliphColor?: string | null;
    variabili?: number | null;
    luogoID?: number | null;
    coverImageUrl?: string | null;
    abstract?: string | null;
    ordine?: number;

    constructor(data?: IIdea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ideaID = _data["ideaID"] !== undefined ? _data["ideaID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.gliphIdx = _data["gliphIdx"] !== undefined ? _data["gliphIdx"] : <any>null;
            this.gliphName = _data["gliphName"] !== undefined ? _data["gliphName"] : <any>null;
            this.gliphColor = _data["gliphColor"] !== undefined ? _data["gliphColor"] : <any>null;
            this.variabili = _data["variabili"] !== undefined ? _data["variabili"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.coverImageUrl = _data["coverImageUrl"] !== undefined ? _data["coverImageUrl"] : <any>null;
            this.abstract = _data["abstract"] !== undefined ? _data["abstract"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
        }
    }

    static fromJS(data: any): Idea {
        data = typeof data === 'object' ? data : {};
        let result = new Idea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ideaID"] = this.ideaID !== undefined ? this.ideaID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["gliphIdx"] = this.gliphIdx !== undefined ? this.gliphIdx : <any>null;
        data["gliphName"] = this.gliphName !== undefined ? this.gliphName : <any>null;
        data["gliphColor"] = this.gliphColor !== undefined ? this.gliphColor : <any>null;
        data["variabili"] = this.variabili !== undefined ? this.variabili : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["coverImageUrl"] = this.coverImageUrl !== undefined ? this.coverImageUrl : <any>null;
        data["abstract"] = this.abstract !== undefined ? this.abstract : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        return data;
    }
}

/** Descrittore dell'Idea di viaggio */
export interface IIdea {
    ideaID?: number;
    nome?: string | null;
    gliphIdx?: number | null;
    gliphName?: string | null;
    gliphColor?: string | null;
    variabili?: number | null;
    luogoID?: number | null;
    coverImageUrl?: string | null;
    abstract?: string | null;
    ordine?: number;
}

export class GetIdeaResponse extends OkApiResponse implements IGetIdeaResponse {
    idea?: IdeaInfo | null;

    constructor(data?: IGetIdeaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idea = _data["idea"] ? IdeaInfo.fromJS(_data["idea"]) : <any>null;
        }
    }

    static fromJS(data: any): GetIdeaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIdeaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idea"] = this.idea ? this.idea.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetIdeaResponse extends IOkApiResponse {
    idea?: IdeaInfo | null;
}

/** Estendo la classe integrando la lista dei viaggi e la lista dei testi */
export class IdeaInfo extends Idea implements IIdeaInfo {
    elencoViaggi?: TripHead[] | null;
    elencoTesti?: string[] | null;

    constructor(data?: IIdeaInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["elencoViaggi"])) {
                this.elencoViaggi = [] as any;
                for (let item of _data["elencoViaggi"])
                    this.elencoViaggi!.push(TripHead.fromJS(item));
            }
            else {
                this.elencoViaggi = <any>null;
            }
            if (Array.isArray(_data["elencoTesti"])) {
                this.elencoTesti = [] as any;
                for (let item of _data["elencoTesti"])
                    this.elencoTesti!.push(item);
            }
            else {
                this.elencoTesti = <any>null;
            }
        }
    }

    static fromJS(data: any): IdeaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new IdeaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elencoViaggi)) {
            data["elencoViaggi"] = [];
            for (let item of this.elencoViaggi)
                data["elencoViaggi"].push(item.toJSON());
        }
        if (Array.isArray(this.elencoTesti)) {
            data["elencoTesti"] = [];
            for (let item of this.elencoTesti)
                data["elencoTesti"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Estendo la classe integrando la lista dei viaggi e la lista dei testi */
export interface IIdeaInfo extends IIdea {
    elencoViaggi?: TripHead[] | null;
    elencoTesti?: string[] | null;
}

export class GetIdeaRequest extends SiteRequest implements IGetIdeaRequest {
    ideaID?: number;

    constructor(data?: IGetIdeaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ideaID = _data["ideaID"] !== undefined ? _data["ideaID"] : <any>null;
        }
    }

    static fromJS(data: any): GetIdeaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetIdeaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ideaID"] = this.ideaID !== undefined ? this.ideaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetIdeaRequest extends ISiteRequest {
    ideaID?: number;
}

export class GetB2cImageUrlResponse extends OkApiResponse implements IGetB2cImageUrlResponse {
    image?: string | null;

    constructor(data?: IGetB2cImageUrlResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
        }
    }

    static fromJS(data: any): GetB2cImageUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetB2cImageUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image !== undefined ? this.image : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetB2cImageUrlResponse extends IOkApiResponse {
    image?: string | null;
}

export class GetB2cImageUrlRequest extends SiteRequest implements IGetB2cImageUrlRequest {
    imageID?: number;

    constructor(data?: IGetB2cImageUrlRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageID = _data["imageID"] !== undefined ? _data["imageID"] : <any>null;
        }
    }

    static fromJS(data: any): GetB2cImageUrlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetB2cImageUrlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageID"] = this.imageID !== undefined ? this.imageID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetB2cImageUrlRequest extends ISiteRequest {
    imageID?: number;
}

export class GetMenuDataResponse extends OkApiResponse implements IGetMenuDataResponse {
    menuData?: MenuData[] | null;

    constructor(data?: IGetMenuDataResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["menuData"])) {
                this.menuData = [] as any;
                for (let item of _data["menuData"])
                    this.menuData!.push(MenuData.fromJS(item));
            }
            else {
                this.menuData = <any>null;
            }
        }
    }

    static fromJS(data: any): GetMenuDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMenuDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.menuData)) {
            data["menuData"] = [];
            for (let item of this.menuData)
                data["menuData"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMenuDataResponse extends IOkApiResponse {
    menuData?: MenuData[] | null;
}

export class MenuData implements IMenuData {
    nome?: string | null;
    idPagelink?: number;
    url?: string | null;
    icon?: string | null;
    idLuogo?: number;

    constructor(data?: IMenuData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.idPagelink = _data["idPagelink"] !== undefined ? _data["idPagelink"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.icon = _data["icon"] !== undefined ? _data["icon"] : <any>null;
            this.idLuogo = _data["idLuogo"] !== undefined ? _data["idLuogo"] : <any>null;
        }
    }

    static fromJS(data: any): MenuData {
        data = typeof data === 'object' ? data : {};
        let result = new MenuData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["idPagelink"] = this.idPagelink !== undefined ? this.idPagelink : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["icon"] = this.icon !== undefined ? this.icon : <any>null;
        data["idLuogo"] = this.idLuogo !== undefined ? this.idLuogo : <any>null;
        return data;
    }
}

export interface IMenuData {
    nome?: string | null;
    idPagelink?: number;
    url?: string | null;
    icon?: string | null;
    idLuogo?: number;
}

export class GetPageDataResponse extends OkApiResponse implements IGetPageDataResponse {
    pageData?: PageData | null;

    constructor(data?: IGetPageDataResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageData = _data["pageData"] ? PageData.fromJS(_data["pageData"]) : <any>null;
        }
    }

    static fromJS(data: any): GetPageDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageData"] = this.pageData ? this.pageData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPageDataResponse extends IOkApiResponse {
    pageData?: PageData | null;
}

/** Acquisizione dei testi relativi ad una pagina */
export class PageData implements IPageData {
    id?: number;
    nome?: string | null;
    tipo?: ETipoLink;
    elencoDati?: PageDataGeneric[] | null;

    constructor(data?: IPageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            if (Array.isArray(_data["elencoDati"])) {
                this.elencoDati = [] as any;
                for (let item of _data["elencoDati"])
                    this.elencoDati!.push(PageDataGeneric.fromJS(item));
            }
            else {
                this.elencoDati = <any>null;
            }
        }
    }

    static fromJS(data: any): PageData {
        data = typeof data === 'object' ? data : {};
        let result = new PageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        if (Array.isArray(this.elencoDati)) {
            data["elencoDati"] = [];
            for (let item of this.elencoDati)
                data["elencoDati"].push(item.toJSON());
        }
        return data;
    }
}

/** Acquisizione dei testi relativi ad una pagina */
export interface IPageData {
    id?: number;
    nome?: string | null;
    tipo?: ETipoLink;
    elencoDati?: PageDataGeneric[] | null;
}

export enum ETipoLink {
    Url = "Url",
    RouterLink = "RouterLink",
    Contenitore = "Contenitore",
}

export class PageDataGeneric implements IPageDataGeneric {
    id?: number;
    entityId?: number;
    entityType?: ETipoEntita;
    name?: string | null;
    content?: string | null;
    group?: number;
    order?: number;
    style?: number;

    constructor(data?: IPageDataGeneric) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.entityId = _data["entityId"] !== undefined ? _data["entityId"] : <any>null;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.group = _data["group"] !== undefined ? _data["group"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.style = _data["style"] !== undefined ? _data["style"] : <any>null;
        }
    }

    static fromJS(data: any): PageDataGeneric {
        data = typeof data === 'object' ? data : {};
        let result = new PageDataGeneric();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["entityId"] = this.entityId !== undefined ? this.entityId : <any>null;
        data["entityType"] = this.entityType !== undefined ? this.entityType : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["group"] = this.group !== undefined ? this.group : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["style"] = this.style !== undefined ? this.style : <any>null;
        return data;
    }
}

export interface IPageDataGeneric {
    id?: number;
    entityId?: number;
    entityType?: ETipoEntita;
    name?: string | null;
    content?: string | null;
    group?: number;
    order?: number;
    style?: number;
}

export enum ETipoEntita {
    Articolo = "Articolo",
}

export class GetPageDataRequest extends SiteRequest implements IGetPageDataRequest {
    pageDataID?: number;

    constructor(data?: IGetPageDataRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageDataID = _data["pageDataID"] !== undefined ? _data["pageDataID"] : <any>null;
        }
    }

    static fromJS(data: any): GetPageDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageDataID"] = this.pageDataID !== undefined ? this.pageDataID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPageDataRequest extends ISiteRequest {
    pageDataID?: number;
}

export class GetPageFooterResponse extends OkApiResponse implements IGetPageFooterResponse {
    footerData?: PageData | null;
    contactInfo?: PageContact | null;

    constructor(data?: IGetPageFooterResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.footerData = _data["footerData"] ? PageData.fromJS(_data["footerData"]) : <any>null;
            this.contactInfo = _data["contactInfo"] ? PageContact.fromJS(_data["contactInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): GetPageFooterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageFooterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["footerData"] = this.footerData ? this.footerData.toJSON() : <any>null;
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPageFooterResponse extends IOkApiResponse {
    footerData?: PageData | null;
    contactInfo?: PageContact | null;
}

export class Contatto implements IContatto {
    contattoID?: number;
    contattoTipo?: ETipoContatto;
    luogoID?: number | null;
    nome?: string | null;
    cognome?: string | null;
    indirizzo?: string | null;
    civico?: string | null;
    cap?: string | null;
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;
    note?: string | null;
    noFee?: boolean;
    categoriaContattoID?: number | null;
    titolo?: ETitolo;
    mansioneID?: number | null;
    abilitatoBookingVoli?: boolean;
    markupAdv?: number | null;
    indirizzoFatturazione?: string | null;
    luogoFatturazioneID?: number | null;
    capFatturazione?: string | null;
    civicoFatturazione?: string | null;
    eliminato?: boolean;
    lingua?: number | null;

    constructor(data?: IContatto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.contattoTipo = _data["contattoTipo"] !== undefined ? _data["contattoTipo"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.civico = _data["civico"] !== undefined ? _data["civico"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.noFee = _data["noFee"] !== undefined ? _data["noFee"] : <any>null;
            this.categoriaContattoID = _data["categoriaContattoID"] !== undefined ? _data["categoriaContattoID"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.mansioneID = _data["mansioneID"] !== undefined ? _data["mansioneID"] : <any>null;
            this.abilitatoBookingVoli = _data["abilitatoBookingVoli"] !== undefined ? _data["abilitatoBookingVoli"] : <any>null;
            this.markupAdv = _data["markupAdv"] !== undefined ? _data["markupAdv"] : <any>null;
            this.indirizzoFatturazione = _data["indirizzoFatturazione"] !== undefined ? _data["indirizzoFatturazione"] : <any>null;
            this.luogoFatturazioneID = _data["luogoFatturazioneID"] !== undefined ? _data["luogoFatturazioneID"] : <any>null;
            this.capFatturazione = _data["capFatturazione"] !== undefined ? _data["capFatturazione"] : <any>null;
            this.civicoFatturazione = _data["civicoFatturazione"] !== undefined ? _data["civicoFatturazione"] : <any>null;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
        }
    }

    static fromJS(data: any): Contatto {
        data = typeof data === 'object' ? data : {};
        let result = new Contatto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["contattoTipo"] = this.contattoTipo !== undefined ? this.contattoTipo : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["civico"] = this.civico !== undefined ? this.civico : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["noFee"] = this.noFee !== undefined ? this.noFee : <any>null;
        data["categoriaContattoID"] = this.categoriaContattoID !== undefined ? this.categoriaContattoID : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["mansioneID"] = this.mansioneID !== undefined ? this.mansioneID : <any>null;
        data["abilitatoBookingVoli"] = this.abilitatoBookingVoli !== undefined ? this.abilitatoBookingVoli : <any>null;
        data["markupAdv"] = this.markupAdv !== undefined ? this.markupAdv : <any>null;
        data["indirizzoFatturazione"] = this.indirizzoFatturazione !== undefined ? this.indirizzoFatturazione : <any>null;
        data["luogoFatturazioneID"] = this.luogoFatturazioneID !== undefined ? this.luogoFatturazioneID : <any>null;
        data["capFatturazione"] = this.capFatturazione !== undefined ? this.capFatturazione : <any>null;
        data["civicoFatturazione"] = this.civicoFatturazione !== undefined ? this.civicoFatturazione : <any>null;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        return data;
    }
}

export interface IContatto {
    contattoID?: number;
    contattoTipo?: ETipoContatto;
    luogoID?: number | null;
    nome?: string | null;
    cognome?: string | null;
    indirizzo?: string | null;
    civico?: string | null;
    cap?: string | null;
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;
    note?: string | null;
    noFee?: boolean;
    categoriaContattoID?: number | null;
    titolo?: ETitolo;
    mansioneID?: number | null;
    abilitatoBookingVoli?: boolean;
    markupAdv?: number | null;
    indirizzoFatturazione?: string | null;
    luogoFatturazioneID?: number | null;
    capFatturazione?: string | null;
    civicoFatturazione?: string | null;
    eliminato?: boolean;
    lingua?: number | null;
}

export class PageContact extends Contatto implements IPageContact {
    citta?: string | null;
    paese?: string | null;

    constructor(data?: IPageContact) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.citta = _data["citta"] !== undefined ? _data["citta"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
        }
    }

    static fromJS(data: any): PageContact {
        data = typeof data === 'object' ? data : {};
        let result = new PageContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["citta"] = this.citta !== undefined ? this.citta : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPageContact extends IContatto {
    citta?: string | null;
    paese?: string | null;
}

export enum ETipoContatto {
    Fornitore = "Fornitore",
    Addetto = "Addetto",
    Agenzia = "Agenzia",
    UfficioFornitore = "UfficioFornitore",
    Produttore = "Produttore",
    TourOperator = "TourOperator",
    GruppiAgenzie = "GruppiAgenzie",
    ContrattiAgenti = "ContrattiAgenti",
    Hotel = "Hotel",
    Corrieri = "Corrieri",
    CompagnieAeree = "CompagnieAeree",
    FornitoreIndiretto = "FornitoreIndiretto",
    Giornali = "Giornali",
    ClienteDiretto = "ClienteDiretto",
    Appartamenti = "Appartamenti",
    AgenzieChiuse = "AgenzieChiuse",
    SottogruppiAgenzie = "SottogruppiAgenzie",
    FornitoreContabilita = "FornitoreContabilita",
    PuntoPickup = "PuntoPickup",
    ClienteContabilita = "ClienteContabilita",
}

export enum ETitolo {
    Signor = "Signor",
    Signora = "Signora",
    Bambina = "Bambina",
    Bambino = "Bambino",
    Dottor = "Dottor",
    Dottssa = "Dottssa",
    Sconosciuto = "Sconosciuto",
    Srl = "Srl",
    SpA = "SpA",
    Sas = "Sas",
    Snc = "Snc",
}

export class GetPageFooterRequest extends SiteRequest implements IGetPageFooterRequest {
    pageDataID?: number;

    constructor(data?: IGetPageFooterRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageDataID = _data["pageDataID"] !== undefined ? _data["pageDataID"] : <any>null;
        }
    }

    static fromJS(data: any): GetPageFooterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageFooterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageDataID"] = this.pageDataID !== undefined ? this.pageDataID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPageFooterRequest extends ISiteRequest {
    pageDataID?: number;
}

export class GetPagesResponse extends OkApiResponse implements IGetPagesResponse {
    pages?: PageLinkDetails[];
    footer?: PageLinkDetails | null;
    secondMenu?: PageLinkDetails[] | null;

    constructor(data?: IGetPagesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(PageLinkDetails.fromJS(item));
            }
            else {
                this.pages = <any>null;
            }
            this.footer = _data["footer"] ? PageLinkDetails.fromJS(_data["footer"]) : <any>null;
            if (Array.isArray(_data["secondMenu"])) {
                this.secondMenu = [] as any;
                for (let item of _data["secondMenu"])
                    this.secondMenu!.push(PageLinkDetails.fromJS(item));
            }
            else {
                this.secondMenu = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        data["footer"] = this.footer ? this.footer.toJSON() : <any>null;
        if (Array.isArray(this.secondMenu)) {
            data["secondMenu"] = [];
            for (let item of this.secondMenu)
                data["secondMenu"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPagesResponse extends IOkApiResponse {
    pages?: PageLinkDetails[];
    footer?: PageLinkDetails | null;
    secondMenu?: PageLinkDetails[] | null;
}

export class PageLink implements IPageLink {
    id?: number;
    luogoID?: number | null;
    servizioID?: number | null;
    ordine?: number;
    operatore?: EOperatore | null;
    tipo?: ETipoLink;
    posizione?: EPosizioneLink;
    memo?: string | null;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    url?: string | null;
    nome!: string;
    nome_fr?: string | null;
    nome_en?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    faIcon?: string | null;
    deleted?: string | null;

    constructor(data?: IPageLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.posizione = _data["posizione"] !== undefined ? _data["posizione"] : <any>null;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : <any>null;
            this.pubblicaDal = _data["pubblicaDal"] !== undefined ? _data["pubblicaDal"] : <any>null;
            this.pubblicaAl = _data["pubblicaAl"] !== undefined ? _data["pubblicaAl"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : <any>null;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : <any>null;
            this.faIcon = _data["faIcon"] !== undefined ? _data["faIcon"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
        }
    }

    static fromJS(data: any): PageLink {
        data = typeof data === 'object' ? data : {};
        let result = new PageLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["posizione"] = this.posizione !== undefined ? this.posizione : <any>null;
        data["memo"] = this.memo !== undefined ? this.memo : <any>null;
        data["pubblicaDal"] = this.pubblicaDal !== undefined ? this.pubblicaDal : <any>null;
        data["pubblicaAl"] = this.pubblicaAl !== undefined ? this.pubblicaAl : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : <any>null;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : <any>null;
        data["faIcon"] = this.faIcon !== undefined ? this.faIcon : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        return data;
    }
}

export interface IPageLink {
    id?: number;
    luogoID?: number | null;
    servizioID?: number | null;
    ordine?: number;
    operatore?: EOperatore | null;
    tipo?: ETipoLink;
    posizione?: EPosizioneLink;
    memo?: string | null;
    pubblicaDal?: string | null;
    pubblicaAl?: string | null;
    url?: string | null;
    nome: string;
    nome_fr?: string | null;
    nome_en?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    faIcon?: string | null;
    deleted?: string | null;
}

export class PageLinkDetails extends PageLink implements IPageLinkDetails {
    contents?: PageLinkContent[] | null;

    constructor(data?: IPageLinkDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(PageLinkContent.fromJS(item));
            }
            else {
                this.contents = <any>null;
            }
        }
    }

    static fromJS(data: any): PageLinkDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPageLinkDetails extends IPageLink {
    contents?: PageLinkContent[] | null;
}

export class PageLinkContent implements IPageLinkContent {
    id?: number;
    pageLinkID?: number;
    entityType?: ETipoEntita;
    entityID?: number;
    sortOrder?: number;
    faIcon?: string | null;
    deleted?: string | null;

    constructor(data?: IPageLinkContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.pageLinkID = _data["pageLinkID"] !== undefined ? _data["pageLinkID"] : <any>null;
            this.entityType = _data["entityType"] !== undefined ? _data["entityType"] : <any>null;
            this.entityID = _data["entityID"] !== undefined ? _data["entityID"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.faIcon = _data["faIcon"] !== undefined ? _data["faIcon"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
        }
    }

    static fromJS(data: any): PageLinkContent {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["pageLinkID"] = this.pageLinkID !== undefined ? this.pageLinkID : <any>null;
        data["entityType"] = this.entityType !== undefined ? this.entityType : <any>null;
        data["entityID"] = this.entityID !== undefined ? this.entityID : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["faIcon"] = this.faIcon !== undefined ? this.faIcon : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        return data;
    }
}

export interface IPageLinkContent {
    id?: number;
    pageLinkID?: number;
    entityType?: ETipoEntita;
    entityID?: number;
    sortOrder?: number;
    faIcon?: string | null;
    deleted?: string | null;
}

export class GetPagesRequest extends LocalizedRequest implements IGetPagesRequest {
    operator!: EOperatore;

    constructor(data?: IGetPagesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
        }
    }

    static fromJS(data: any): GetPagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPagesRequest extends ILocalizedRequest {
    operator: EOperatore;
}

export class GetTripResponse extends OkApiResponse implements IGetTripResponse {
    trip?: TripInfo | null;

    constructor(data?: IGetTripResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trip = _data["trip"] ? TripInfo.fromJS(_data["trip"]) : <any>null;
        }
    }

    static fromJS(data: any): GetTripResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trip"] = this.trip ? this.trip.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripResponse extends IOkApiResponse {
    trip?: TripInfo | null;
}

/** Versione completa di un viaggio    Articoli, Immagini, Partenze e Itinerario */
export class TripInfo extends TripHead implements ITripInfo {
    articoli?: TripArticle[] | null;
    articoliTraducibili?: TripArticle[] | null;
    immagini?: TripImage[] | null;
    partenze?: TripDeparture[] | null;
    itinerario?: TripItinerary | null;
    tipoServizio?: ETipoServizio;
    popolarita?: number | null;
    attributi?: ServiceAttribute[] | null;
    allegati?: TripAttachment[] | null;

    constructor(data?: ITripInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["articoli"])) {
                this.articoli = [] as any;
                for (let item of _data["articoli"])
                    this.articoli!.push(TripArticle.fromJS(item));
            }
            else {
                this.articoli = <any>null;
            }
            if (Array.isArray(_data["articoliTraducibili"])) {
                this.articoliTraducibili = [] as any;
                for (let item of _data["articoliTraducibili"])
                    this.articoliTraducibili!.push(TripArticle.fromJS(item));
            }
            else {
                this.articoliTraducibili = <any>null;
            }
            if (Array.isArray(_data["immagini"])) {
                this.immagini = [] as any;
                for (let item of _data["immagini"])
                    this.immagini!.push(TripImage.fromJS(item));
            }
            else {
                this.immagini = <any>null;
            }
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(TripDeparture.fromJS(item));
            }
            else {
                this.partenze = <any>null;
            }
            this.itinerario = _data["itinerario"] ? TripItinerary.fromJS(_data["itinerario"]) : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.popolarita = _data["popolarita"] !== undefined ? _data["popolarita"] : <any>null;
            if (Array.isArray(_data["attributi"])) {
                this.attributi = [] as any;
                for (let item of _data["attributi"])
                    this.attributi!.push(ServiceAttribute.fromJS(item));
            }
            else {
                this.attributi = <any>null;
            }
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(TripAttachment.fromJS(item));
            }
            else {
                this.allegati = <any>null;
            }
        }
    }

    static fromJS(data: any): TripInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TripInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.articoli)) {
            data["articoli"] = [];
            for (let item of this.articoli)
                data["articoli"].push(item.toJSON());
        }
        if (Array.isArray(this.articoliTraducibili)) {
            data["articoliTraducibili"] = [];
            for (let item of this.articoliTraducibili)
                data["articoliTraducibili"].push(item.toJSON());
        }
        if (Array.isArray(this.immagini)) {
            data["immagini"] = [];
            for (let item of this.immagini)
                data["immagini"].push(item.toJSON());
        }
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item.toJSON());
        }
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["popolarita"] = this.popolarita !== undefined ? this.popolarita : <any>null;
        if (Array.isArray(this.attributi)) {
            data["attributi"] = [];
            for (let item of this.attributi)
                data["attributi"].push(item.toJSON());
        }
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

/** Versione completa di un viaggio    Articoli, Immagini, Partenze e Itinerario */
export interface ITripInfo extends ITripHead {
    articoli?: TripArticle[] | null;
    articoliTraducibili?: TripArticle[] | null;
    immagini?: TripImage[] | null;
    partenze?: TripDeparture[] | null;
    itinerario?: TripItinerary | null;
    tipoServizio?: ETipoServizio;
    popolarita?: number | null;
    attributi?: ServiceAttribute[] | null;
    allegati?: TripAttachment[] | null;
}

export class TripArticle implements ITripArticle {
    titolo?: string | null;
    testo?: string | null;

    constructor(data?: ITripArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
        }
    }

    static fromJS(data: any): TripArticle {
        data = typeof data === 'object' ? data : {};
        let result = new TripArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        return data;
    }
}

export interface ITripArticle {
    titolo?: string | null;
    testo?: string | null;
}

export class TripImage implements ITripImage {
    titolo?: string | null;
    url?: string | null;

    constructor(data?: ITripImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): TripImage {
        data = typeof data === 'object' ? data : {};
        let result = new TripImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

export interface ITripImage {
    titolo?: string | null;
    url?: string | null;
}

export class TripDeparture implements ITripDeparture {
    dataFirst?: string;
    anno?: number;
    parts?: TripDeparturePart[] | null;

    constructor(data?: ITripDeparture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataFirst = _data["dataFirst"] !== undefined ? _data["dataFirst"] : <any>null;
            this.anno = _data["anno"] !== undefined ? _data["anno"] : <any>null;
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(TripDeparturePart.fromJS(item));
            }
            else {
                this.parts = <any>null;
            }
        }
    }

    static fromJS(data: any): TripDeparture {
        data = typeof data === 'object' ? data : {};
        let result = new TripDeparture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataFirst"] = this.dataFirst !== undefined ? this.dataFirst : <any>null;
        data["anno"] = this.anno !== undefined ? this.anno : <any>null;
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripDeparture {
    dataFirst?: string;
    anno?: number;
    parts?: TripDeparturePart[] | null;
}

export class TripDeparturePart implements ITripDeparturePart {
    mese?: number;
    giorni?: number[] | null;

    constructor(data?: ITripDeparturePart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mese = _data["mese"] !== undefined ? _data["mese"] : <any>null;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(item);
            }
            else {
                this.giorni = <any>null;
            }
        }
    }

    static fromJS(data: any): TripDeparturePart {
        data = typeof data === 'object' ? data : {};
        let result = new TripDeparturePart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mese"] = this.mese !== undefined ? this.mese : <any>null;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item);
        }
        return data;
    }
}

export interface ITripDeparturePart {
    mese?: number;
    giorni?: number[] | null;
}

export class TripItinerary implements ITripItinerary {
    nome?: string | null;
    giorni?: number;
    notti?: number;
    days?: TripItineraryDay[] | null;

    constructor(data?: ITripItinerary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(TripItineraryDay.fromJS(item));
            }
            else {
                this.days = <any>null;
            }
        }
    }

    static fromJS(data: any): TripItinerary {
        data = typeof data === 'object' ? data : {};
        let result = new TripItinerary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["giorni"] = this.giorni !== undefined ? this.giorni : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripItinerary {
    nome?: string | null;
    giorni?: number;
    notti?: number;
    days?: TripItineraryDay[] | null;
}

export class TripItineraryDay implements ITripItineraryDay {
    giorno?: number;
    ordine?: number;
    luogo?: string | null;
    durata?: number;
    hotel?: string | null;
    immagine?: TripImage | null;
    lat?: number;
    lon?: number;
    tipoTrasporto?: ETipoTrasporto | null;

    constructor(data?: ITripItineraryDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : <any>null;
            this.hotel = _data["hotel"] !== undefined ? _data["hotel"] : <any>null;
            this.immagine = _data["immagine"] ? TripImage.fromJS(_data["immagine"]) : <any>null;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lon = _data["lon"] !== undefined ? _data["lon"] : <any>null;
            this.tipoTrasporto = _data["tipoTrasporto"] !== undefined ? _data["tipoTrasporto"] : <any>null;
        }
    }

    static fromJS(data: any): TripItineraryDay {
        data = typeof data === 'object' ? data : {};
        let result = new TripItineraryDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["durata"] = this.durata !== undefined ? this.durata : <any>null;
        data["hotel"] = this.hotel !== undefined ? this.hotel : <any>null;
        data["immagine"] = this.immagine ? this.immagine.toJSON() : <any>null;
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lon"] = this.lon !== undefined ? this.lon : <any>null;
        data["tipoTrasporto"] = this.tipoTrasporto !== undefined ? this.tipoTrasporto : <any>null;
        return data;
    }
}

export interface ITripItineraryDay {
    giorno?: number;
    ordine?: number;
    luogo?: string | null;
    durata?: number;
    hotel?: string | null;
    immagine?: TripImage | null;
    lat?: number;
    lon?: number;
    tipoTrasporto?: ETipoTrasporto | null;
}

export enum ETipoTrasporto {
    Aereo = "Aereo",
    Auto = "Auto",
    Traghetto = "Traghetto",
    Indefinito = "Indefinito",
    Treno = "Treno",
    Pullman = "Pullman",
}

export class ServiceAttribute implements IServiceAttribute {
    tipoID?: number;
    nomeTipo?: string | null;
    valori?: string[] | null;

    constructor(data?: IServiceAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoID = _data["tipoID"] !== undefined ? _data["tipoID"] : <any>null;
            this.nomeTipo = _data["nomeTipo"] !== undefined ? _data["nomeTipo"] : <any>null;
            if (Array.isArray(_data["valori"])) {
                this.valori = [] as any;
                for (let item of _data["valori"])
                    this.valori!.push(item);
            }
            else {
                this.valori = <any>null;
            }
        }
    }

    static fromJS(data: any): ServiceAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoID"] = this.tipoID !== undefined ? this.tipoID : <any>null;
        data["nomeTipo"] = this.nomeTipo !== undefined ? this.nomeTipo : <any>null;
        if (Array.isArray(this.valori)) {
            data["valori"] = [];
            for (let item of this.valori)
                data["valori"].push(item);
        }
        return data;
    }
}

export interface IServiceAttribute {
    tipoID?: number;
    nomeTipo?: string | null;
    valori?: string[] | null;
}

export class TripAttachment implements ITripAttachment {
    fileUrl?: string | null;
    fileExt?: string | null;
    descr?: string | null;

    constructor(data?: ITripAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUrl = _data["fileUrl"] !== undefined ? _data["fileUrl"] : <any>null;
            this.fileExt = _data["fileExt"] !== undefined ? _data["fileExt"] : <any>null;
            this.descr = _data["descr"] !== undefined ? _data["descr"] : <any>null;
        }
    }

    static fromJS(data: any): TripAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new TripAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : <any>null;
        data["fileExt"] = this.fileExt !== undefined ? this.fileExt : <any>null;
        data["descr"] = this.descr !== undefined ? this.descr : <any>null;
        return data;
    }
}

export interface ITripAttachment {
    fileUrl?: string | null;
    fileExt?: string | null;
    descr?: string | null;
}

export class GetTripRequest extends SiteRequest implements IGetTripRequest {
    tripID?: number;

    constructor(data?: IGetTripRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
        }
    }

    static fromJS(data: any): GetTripRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripRequest extends ISiteRequest {
    tripID?: number;
}

export class SetInfosRequest extends SiteRequest implements ISetInfosRequest {
    cognome?: string | null;
    nome?: string | null;
    email?: string | null;
    viaggioDiNozze?: string | null;
    budget?: string | null;
    note?: string | null;
    selectedADV?: TinySelectedAdv | null;
    interestedTrip?: TinyTripOfInterest[] | null;
    sentOn?: string | null;
    destinazioni?: string[] | null;
    selectedTrip?: string | null;

    constructor(data?: ISetInfosRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.viaggioDiNozze = _data["viaggioDiNozze"] !== undefined ? _data["viaggioDiNozze"] : <any>null;
            this.budget = _data["budget"] !== undefined ? _data["budget"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.selectedADV = _data["selectedADV"] ? TinySelectedAdv.fromJS(_data["selectedADV"]) : <any>null;
            if (Array.isArray(_data["interestedTrip"])) {
                this.interestedTrip = [] as any;
                for (let item of _data["interestedTrip"])
                    this.interestedTrip!.push(TinyTripOfInterest.fromJS(item));
            }
            else {
                this.interestedTrip = <any>null;
            }
            this.sentOn = _data["sentOn"] !== undefined ? _data["sentOn"] : <any>null;
            if (Array.isArray(_data["destinazioni"])) {
                this.destinazioni = [] as any;
                for (let item of _data["destinazioni"])
                    this.destinazioni!.push(item);
            }
            else {
                this.destinazioni = <any>null;
            }
            this.selectedTrip = _data["selectedTrip"] !== undefined ? _data["selectedTrip"] : <any>null;
        }
    }

    static fromJS(data: any): SetInfosRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetInfosRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["viaggioDiNozze"] = this.viaggioDiNozze !== undefined ? this.viaggioDiNozze : <any>null;
        data["budget"] = this.budget !== undefined ? this.budget : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["selectedADV"] = this.selectedADV ? this.selectedADV.toJSON() : <any>null;
        if (Array.isArray(this.interestedTrip)) {
            data["interestedTrip"] = [];
            for (let item of this.interestedTrip)
                data["interestedTrip"].push(item.toJSON());
        }
        data["sentOn"] = this.sentOn !== undefined ? this.sentOn : <any>null;
        if (Array.isArray(this.destinazioni)) {
            data["destinazioni"] = [];
            for (let item of this.destinazioni)
                data["destinazioni"].push(item);
        }
        data["selectedTrip"] = this.selectedTrip !== undefined ? this.selectedTrip : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetInfosRequest extends ISiteRequest {
    cognome?: string | null;
    nome?: string | null;
    email?: string | null;
    viaggioDiNozze?: string | null;
    budget?: string | null;
    note?: string | null;
    selectedADV?: TinySelectedAdv | null;
    interestedTrip?: TinyTripOfInterest[] | null;
    sentOn?: string | null;
    destinazioni?: string[] | null;
    selectedTrip?: string | null;
}

export class TinySelectedAdv implements ITinySelectedAdv {
    contactID?: string | null;
    nome?: string | null;
    telefono?: string | null;
    indirizzo?: string | null;

    constructor(data?: ITinySelectedAdv) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactID = _data["contactID"] !== undefined ? _data["contactID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
        }
    }

    static fromJS(data: any): TinySelectedAdv {
        data = typeof data === 'object' ? data : {};
        let result = new TinySelectedAdv();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactID"] = this.contactID !== undefined ? this.contactID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        return data;
    }
}

export interface ITinySelectedAdv {
    contactID?: string | null;
    nome?: string | null;
    telefono?: string | null;
    indirizzo?: string | null;
}

export class TinyTripOfInterest implements ITinyTripOfInterest {
    id?: string | null;
    nome?: string | null;
    durata?: string | null;

    constructor(data?: ITinyTripOfInterest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : <any>null;
        }
    }

    static fromJS(data: any): TinyTripOfInterest {
        data = typeof data === 'object' ? data : {};
        let result = new TinyTripOfInterest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["durata"] = this.durata !== undefined ? this.durata : <any>null;
        return data;
    }
}

export interface ITinyTripOfInterest {
    id?: string | null;
    nome?: string | null;
    durata?: string | null;
}

export class BasecampAuthorizeRequest extends ApiRequest implements IBasecampAuthorizeRequest {
    /** Il codice di autorizzazione ottenuto da Basecamp */
    code!: string;

    constructor(data?: IBasecampAuthorizeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): BasecampAuthorizeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BasecampAuthorizeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBasecampAuthorizeRequest extends IApiRequest {
    /** Il codice di autorizzazione ottenuto da Basecamp */
    code: string;
}

export class NrTableResponseOfBasecampMessageData extends OkApiResponse implements INrTableResponseOfBasecampMessageData {
    /** Array delle righe della pagina richiesta */
    rows?: BasecampMessageData[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfBasecampMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(BasecampMessageData.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfBasecampMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfBasecampMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfBasecampMessageData extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: BasecampMessageData[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class BasecampMessageData implements IBasecampMessageData {
    id?: number;
    avatarUrl?: string | null;
    appUrl?: string | null;
    title?: string | null;
    creatorName?: string | null;
    createdAt?: string;

    constructor(data?: IBasecampMessageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.avatarUrl = _data["avatarUrl"] !== undefined ? _data["avatarUrl"] : <any>null;
            this.appUrl = _data["appUrl"] !== undefined ? _data["appUrl"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.creatorName = _data["creatorName"] !== undefined ? _data["creatorName"] : <any>null;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : <any>null;
        }
    }

    static fromJS(data: any): BasecampMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new BasecampMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["avatarUrl"] = this.avatarUrl !== undefined ? this.avatarUrl : <any>null;
        data["appUrl"] = this.appUrl !== undefined ? this.appUrl : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["creatorName"] = this.creatorName !== undefined ? this.creatorName : <any>null;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : <any>null;
        return data;
    }
}

export interface IBasecampMessageData {
    id?: number;
    avatarUrl?: string | null;
    appUrl?: string | null;
    title?: string | null;
    creatorName?: string | null;
    createdAt?: string;
}

export class BasecampGetMessagesRequest extends NrTableRequest implements IBasecampGetMessagesRequest {
    projectId?: number;
    dockId?: number;

    constructor(data?: IBasecampGetMessagesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.dockId = _data["dockId"] !== undefined ? _data["dockId"] : <any>null;
        }
    }

    static fromJS(data: any): BasecampGetMessagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BasecampGetMessagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["dockId"] = this.dockId !== undefined ? this.dockId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBasecampGetMessagesRequest extends INrTableRequest {
    projectId?: number;
    dockId?: number;
}

export class BasecampGetProjectsResponse extends OkApiResponse implements IBasecampGetProjectsResponse {
    projects?: BasecampProjectData[] | null;

    constructor(data?: IBasecampGetProjectsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(BasecampProjectData.fromJS(item));
            }
            else {
                this.projects = <any>null;
            }
        }
    }

    static fromJS(data: any): BasecampGetProjectsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BasecampGetProjectsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBasecampGetProjectsResponse extends IOkApiResponse {
    projects?: BasecampProjectData[] | null;
}

export class BasecampProjectData implements IBasecampProjectData {
    projectName?: string | null;
    projectId?: number;
    dockId?: number;
    appUrl?: string | null;

    constructor(data?: IBasecampProjectData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : <any>null;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.dockId = _data["dockId"] !== undefined ? _data["dockId"] : <any>null;
            this.appUrl = _data["appUrl"] !== undefined ? _data["appUrl"] : <any>null;
        }
    }

    static fromJS(data: any): BasecampProjectData {
        data = typeof data === 'object' ? data : {};
        let result = new BasecampProjectData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName !== undefined ? this.projectName : <any>null;
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["dockId"] = this.dockId !== undefined ? this.dockId : <any>null;
        data["appUrl"] = this.appUrl !== undefined ? this.appUrl : <any>null;
        return data;
    }
}

export interface IBasecampProjectData {
    projectName?: string | null;
    projectId?: number;
    dockId?: number;
    appUrl?: string | null;
}

export class GetTrattamentiResponse extends OkApiResponse implements IGetTrattamentiResponse {
    trattamenti?: TrattamentoTradotto[] | null;

    constructor(data?: IGetTrattamentiResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["trattamenti"])) {
                this.trattamenti = [] as any;
                for (let item of _data["trattamenti"])
                    this.trattamenti!.push(TrattamentoTradotto.fromJS(item));
            }
            else {
                this.trattamenti = <any>null;
            }
        }
    }

    static fromJS(data: any): GetTrattamentiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrattamentiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trattamenti)) {
            data["trattamenti"] = [];
            for (let item of this.trattamenti)
                data["trattamenti"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTrattamentiResponse extends IOkApiResponse {
    trattamenti?: TrattamentoTradotto[] | null;
}

export class TrattamentoTradotto implements ITrattamentoTradotto {
    trattamento?: Trattamento | null;
    nome?: string | null;

    constructor(data?: ITrattamentoTradotto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trattamento = _data["trattamento"] ? Trattamento.fromJS(_data["trattamento"]) : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
        }
    }

    static fromJS(data: any): TrattamentoTradotto {
        data = typeof data === 'object' ? data : {};
        let result = new TrattamentoTradotto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trattamento"] = this.trattamento ? this.trattamento.toJSON() : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        return data;
    }
}

export interface ITrattamentoTradotto {
    trattamento?: Trattamento | null;
    nome?: string | null;
}

export class Trattamento implements ITrattamento {
    id?: number;
    traduzioni?: TreatmentTranslation[] | null;
    nome?: string | null;
    nome_en?: string | null;
    nomeVoucher?: string | null;
    ordine?: number;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;

    constructor(data?: ITrattamento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(TreatmentTranslation.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.nomeVoucher = _data["nomeVoucher"] !== undefined ? _data["nomeVoucher"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
        }
    }

    static fromJS(data: any): Trattamento {
        data = typeof data === 'object' ? data : {};
        let result = new Trattamento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["nomeVoucher"] = this.nomeVoucher !== undefined ? this.nomeVoucher : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        return data;
    }
}

export interface ITrattamento {
    id?: number;
    traduzioni?: TreatmentTranslation[] | null;
    nome?: string | null;
    nome_en?: string | null;
    nomeVoucher?: string | null;
    ordine?: number;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
}

export class TreatmentTranslation extends WebTranslation implements ITreatmentTranslation {

    constructor(data?: ITreatmentTranslation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TreatmentTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITreatmentTranslation extends IWebTranslation {
}

export class GetFornitoriResponse extends OkApiResponse implements IGetFornitoriResponse {
    fornitori?: Fornitore[] | null;

    constructor(data?: IGetFornitoriResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["fornitori"])) {
                this.fornitori = [] as any;
                for (let item of _data["fornitori"])
                    this.fornitori!.push(Fornitore.fromJS(item));
            }
            else {
                this.fornitori = <any>null;
            }
        }
    }

    static fromJS(data: any): GetFornitoriResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFornitoriResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fornitori)) {
            data["fornitori"] = [];
            for (let item of this.fornitori)
                data["fornitori"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetFornitoriResponse extends IOkApiResponse {
    fornitori?: Fornitore[] | null;
}

export class Fornitore implements IFornitore {
    id?: number;
    codice?: EFornitore;
    nome?: string | null;
    attivo?: boolean;
    ricercaHotel?: boolean;
    bookingHotel?: boolean;
    ricercaVoli?: boolean;
    bookingVoli?: boolean;
    ricercaVisite?: boolean;
    bookingVisite?: boolean;
    ricercaNoleggi?: boolean;
    bookingNoleggi?: boolean;
    accordoObbligatorio?: boolean;

    constructor(data?: IFornitore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.attivo = _data["attivo"] !== undefined ? _data["attivo"] : <any>null;
            this.ricercaHotel = _data["ricercaHotel"] !== undefined ? _data["ricercaHotel"] : <any>null;
            this.bookingHotel = _data["bookingHotel"] !== undefined ? _data["bookingHotel"] : <any>null;
            this.ricercaVoli = _data["ricercaVoli"] !== undefined ? _data["ricercaVoli"] : <any>null;
            this.bookingVoli = _data["bookingVoli"] !== undefined ? _data["bookingVoli"] : <any>null;
            this.ricercaVisite = _data["ricercaVisite"] !== undefined ? _data["ricercaVisite"] : <any>null;
            this.bookingVisite = _data["bookingVisite"] !== undefined ? _data["bookingVisite"] : <any>null;
            this.ricercaNoleggi = _data["ricercaNoleggi"] !== undefined ? _data["ricercaNoleggi"] : <any>null;
            this.bookingNoleggi = _data["bookingNoleggi"] !== undefined ? _data["bookingNoleggi"] : <any>null;
            this.accordoObbligatorio = _data["accordoObbligatorio"] !== undefined ? _data["accordoObbligatorio"] : <any>null;
        }
    }

    static fromJS(data: any): Fornitore {
        data = typeof data === 'object' ? data : {};
        let result = new Fornitore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["attivo"] = this.attivo !== undefined ? this.attivo : <any>null;
        data["ricercaHotel"] = this.ricercaHotel !== undefined ? this.ricercaHotel : <any>null;
        data["bookingHotel"] = this.bookingHotel !== undefined ? this.bookingHotel : <any>null;
        data["ricercaVoli"] = this.ricercaVoli !== undefined ? this.ricercaVoli : <any>null;
        data["bookingVoli"] = this.bookingVoli !== undefined ? this.bookingVoli : <any>null;
        data["ricercaVisite"] = this.ricercaVisite !== undefined ? this.ricercaVisite : <any>null;
        data["bookingVisite"] = this.bookingVisite !== undefined ? this.bookingVisite : <any>null;
        data["ricercaNoleggi"] = this.ricercaNoleggi !== undefined ? this.ricercaNoleggi : <any>null;
        data["bookingNoleggi"] = this.bookingNoleggi !== undefined ? this.bookingNoleggi : <any>null;
        data["accordoObbligatorio"] = this.accordoObbligatorio !== undefined ? this.accordoObbligatorio : <any>null;
        return data;
    }
}

export interface IFornitore {
    id?: number;
    codice?: EFornitore;
    nome?: string | null;
    attivo?: boolean;
    ricercaHotel?: boolean;
    bookingHotel?: boolean;
    ricercaVoli?: boolean;
    bookingVoli?: boolean;
    ricercaVisite?: boolean;
    bookingVisite?: boolean;
    ricercaNoleggi?: boolean;
    bookingNoleggi?: boolean;
    accordoObbligatorio?: boolean;
}

export class GetPagamentiDocumentoContabileResponse extends OkApiResponse implements IGetPagamentiDocumentoContabileResponse {
    modalitaPagamento?: ModalitaPagamento[] | null;

    constructor(data?: IGetPagamentiDocumentoContabileResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["modalitaPagamento"])) {
                this.modalitaPagamento = [] as any;
                for (let item of _data["modalitaPagamento"])
                    this.modalitaPagamento!.push(ModalitaPagamento.fromJS(item));
            }
            else {
                this.modalitaPagamento = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPagamentiDocumentoContabileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPagamentiDocumentoContabileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.modalitaPagamento)) {
            data["modalitaPagamento"] = [];
            for (let item of this.modalitaPagamento)
                data["modalitaPagamento"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPagamentiDocumentoContabileResponse extends IOkApiResponse {
    modalitaPagamento?: ModalitaPagamento[] | null;
}

export class ModalitaPagamento implements IModalitaPagamento {
    id?: number;
    nome?: string | null;

    constructor(data?: IModalitaPagamento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
        }
    }

    static fromJS(data: any): ModalitaPagamento {
        data = typeof data === 'object' ? data : {};
        let result = new ModalitaPagamento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        return data;
    }
}

export interface IModalitaPagamento {
    id?: number;
    nome?: string | null;
}

export class GetBancheResponse extends OkApiResponse implements IGetBancheResponse {
    banche?: Banca[] | null;

    constructor(data?: IGetBancheResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["banche"])) {
                this.banche = [] as any;
                for (let item of _data["banche"])
                    this.banche!.push(Banca.fromJS(item));
            }
            else {
                this.banche = <any>null;
            }
        }
    }

    static fromJS(data: any): GetBancheResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBancheResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.banche)) {
            data["banche"] = [];
            for (let item of this.banche)
                data["banche"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetBancheResponse extends IOkApiResponse {
    banche?: Banca[] | null;
}

export class Banca implements IBanca {
    id?: number;
    nome?: string | null;
    iban?: string | null;

    constructor(data?: IBanca) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.iban = _data["iban"] !== undefined ? _data["iban"] : <any>null;
        }
    }

    static fromJS(data: any): Banca {
        data = typeof data === 'object' ? data : {};
        let result = new Banca();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["iban"] = this.iban !== undefined ? this.iban : <any>null;
        return data;
    }
}

export interface IBanca {
    id?: number;
    nome?: string | null;
    iban?: string | null;
}

export class GetSystemEmailsResponse extends OkApiResponse implements IGetSystemEmailsResponse {
    emails?: SystemEmailRow[] | null;

    constructor(data?: IGetSystemEmailsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(SystemEmailRow.fromJS(item));
            }
            else {
                this.emails = <any>null;
            }
        }
    }

    static fromJS(data: any): GetSystemEmailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemEmailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetSystemEmailsResponse extends IOkApiResponse {
    emails?: SystemEmailRow[] | null;
}

export class SystemEmailRow implements ISystemEmailRow {
    id?: number;
    code?: string | null;
    hasDynamicBody?: boolean;
    hasDynamicRecipient?: boolean;
    isHtmlBody?: boolean;
    name?: string | null;
    texts?: SystemEmailTextRow[] | null;

    constructor(data?: ISystemEmailRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.hasDynamicBody = _data["hasDynamicBody"] !== undefined ? _data["hasDynamicBody"] : <any>null;
            this.hasDynamicRecipient = _data["hasDynamicRecipient"] !== undefined ? _data["hasDynamicRecipient"] : <any>null;
            this.isHtmlBody = _data["isHtmlBody"] !== undefined ? _data["isHtmlBody"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["texts"])) {
                this.texts = [] as any;
                for (let item of _data["texts"])
                    this.texts!.push(SystemEmailTextRow.fromJS(item));
            }
            else {
                this.texts = <any>null;
            }
        }
    }

    static fromJS(data: any): SystemEmailRow {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["hasDynamicBody"] = this.hasDynamicBody !== undefined ? this.hasDynamicBody : <any>null;
        data["hasDynamicRecipient"] = this.hasDynamicRecipient !== undefined ? this.hasDynamicRecipient : <any>null;
        data["isHtmlBody"] = this.isHtmlBody !== undefined ? this.isHtmlBody : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.texts)) {
            data["texts"] = [];
            for (let item of this.texts)
                data["texts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISystemEmailRow {
    id?: number;
    code?: string | null;
    hasDynamicBody?: boolean;
    hasDynamicRecipient?: boolean;
    isHtmlBody?: boolean;
    name?: string | null;
    texts?: SystemEmailTextRow[] | null;
}

export class SystemEmailTextRow implements ISystemEmailTextRow {
    id?: number;
    body?: string | null;
    language?: ELingua;
    senderAddress?: string | null;
    senderName?: string | null;
    subject?: string | null;
    addresses?: SystemEmailAddress[] | null;

    constructor(data?: ISystemEmailTextRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.body = _data["body"] !== undefined ? _data["body"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.senderAddress = _data["senderAddress"] !== undefined ? _data["senderAddress"] : <any>null;
            this.senderName = _data["senderName"] !== undefined ? _data["senderName"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(SystemEmailAddress.fromJS(item));
            }
            else {
                this.addresses = <any>null;
            }
        }
    }

    static fromJS(data: any): SystemEmailTextRow {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailTextRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["body"] = this.body !== undefined ? this.body : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["senderAddress"] = this.senderAddress !== undefined ? this.senderAddress : <any>null;
        data["senderName"] = this.senderName !== undefined ? this.senderName : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISystemEmailTextRow {
    id?: number;
    body?: string | null;
    language?: ELingua;
    senderAddress?: string | null;
    senderName?: string | null;
    subject?: string | null;
    addresses?: SystemEmailAddress[] | null;
}

export class SystemEmailAddress implements ISystemEmailAddress {
    id?: number;
    emailTextID?: number;
    addressType?: EEmailAddressType;
    name?: string | null;
    address!: string;

    constructor(data?: ISystemEmailAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.emailTextID = _data["emailTextID"] !== undefined ? _data["emailTextID"] : <any>null;
            this.addressType = _data["addressType"] !== undefined ? _data["addressType"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
        }
    }

    static fromJS(data: any): SystemEmailAddress {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["emailTextID"] = this.emailTextID !== undefined ? this.emailTextID : <any>null;
        data["addressType"] = this.addressType !== undefined ? this.addressType : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        return data;
    }
}

export interface ISystemEmailAddress {
    id?: number;
    emailTextID?: number;
    addressType?: EEmailAddressType;
    name?: string | null;
    address: string;
}

export enum EEmailAddressType {
    To = "To",
    Cc = "Cc",
    Bcc = "Bcc",
}

export class GetCompagnieAereeResponse extends OkApiResponse implements IGetCompagnieAereeResponse {
    compagnie?: CompagniaAerea[] | null;

    constructor(data?: IGetCompagnieAereeResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["compagnie"])) {
                this.compagnie = [] as any;
                for (let item of _data["compagnie"])
                    this.compagnie!.push(CompagniaAerea.fromJS(item));
            }
            else {
                this.compagnie = <any>null;
            }
        }
    }

    static fromJS(data: any): GetCompagnieAereeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompagnieAereeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.compagnie)) {
            data["compagnie"] = [];
            for (let item of this.compagnie)
                data["compagnie"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCompagnieAereeResponse extends IOkApiResponse {
    compagnie?: CompagniaAerea[] | null;
}

export class GetAeroportiResponse extends OkApiResponse implements IGetAeroportiResponse {
    aeroporti?: Aeroporto[] | null;

    constructor(data?: IGetAeroportiResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["aeroporti"])) {
                this.aeroporti = [] as any;
                for (let item of _data["aeroporti"])
                    this.aeroporti!.push(Aeroporto.fromJS(item));
            }
            else {
                this.aeroporti = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAeroportiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAeroportiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.aeroporti)) {
            data["aeroporti"] = [];
            for (let item of this.aeroporti)
                data["aeroporti"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAeroportiResponse extends IOkApiResponse {
    aeroporti?: Aeroporto[] | null;
}

export class GetStatiVoloResponse extends OkApiResponse implements IGetStatiVoloResponse {
    stati?: StatoVolo[] | null;

    constructor(data?: IGetStatiVoloResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["stati"])) {
                this.stati = [] as any;
                for (let item of _data["stati"])
                    this.stati!.push(StatoVolo.fromJS(item));
            }
            else {
                this.stati = <any>null;
            }
        }
    }

    static fromJS(data: any): GetStatiVoloResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatiVoloResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stati)) {
            data["stati"] = [];
            for (let item of this.stati)
                data["stati"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetStatiVoloResponse extends IOkApiResponse {
    stati?: StatoVolo[] | null;
}

export class StatoVolo implements IStatoVolo {
    statoID?: number;
    codice?: string;
    nome!: string;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
    ok?: boolean;

    constructor(data?: IStatoVolo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statoID = _data["statoID"] !== undefined ? _data["statoID"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
            this.ok = _data["ok"] !== undefined ? _data["ok"] : <any>null;
        }
    }

    static fromJS(data: any): StatoVolo {
        data = typeof data === 'object' ? data : {};
        let result = new StatoVolo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statoID"] = this.statoID !== undefined ? this.statoID : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        data["ok"] = this.ok !== undefined ? this.ok : <any>null;
        return data;
    }
}

export interface IStatoVolo {
    statoID?: number;
    codice?: string;
    nome: string;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
    ok?: boolean;
}

export class GetImmaginiPubblicitarieResponse extends OkApiResponse implements IGetImmaginiPubblicitarieResponse {
    immagini?: ImmaginePubblicitaria[] | null;

    constructor(data?: IGetImmaginiPubblicitarieResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["immagini"])) {
                this.immagini = [] as any;
                for (let item of _data["immagini"])
                    this.immagini!.push(ImmaginePubblicitaria.fromJS(item));
            }
            else {
                this.immagini = <any>null;
            }
        }
    }

    static fromJS(data: any): GetImmaginiPubblicitarieResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImmaginiPubblicitarieResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.immagini)) {
            data["immagini"] = [];
            for (let item of this.immagini)
                data["immagini"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetImmaginiPubblicitarieResponse extends IOkApiResponse {
    immagini?: ImmaginePubblicitaria[] | null;
}

export class ImmaginePubblicitaria implements IImmaginePubblicitaria {
    url?: string | null;
    titolo?: string | null;
    testo?: string | null;

    constructor(data?: IImmaginePubblicitaria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
        }
    }

    static fromJS(data: any): ImmaginePubblicitaria {
        data = typeof data === 'object' ? data : {};
        let result = new ImmaginePubblicitaria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        return data;
    }
}

export interface IImmaginePubblicitaria {
    url?: string | null;
    titolo?: string | null;
    testo?: string | null;
}

export class GetLuoghiTopResponse extends OkApiResponse implements IGetLuoghiTopResponse {
    luoghiTop?: LuogoTop[] | null;

    constructor(data?: IGetLuoghiTopResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["luoghiTop"])) {
                this.luoghiTop = [] as any;
                for (let item of _data["luoghiTop"])
                    this.luoghiTop!.push(LuogoTop.fromJS(item));
            }
            else {
                this.luoghiTop = <any>null;
            }
        }
    }

    static fromJS(data: any): GetLuoghiTopResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuoghiTopResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.luoghiTop)) {
            data["luoghiTop"] = [];
            for (let item of this.luoghiTop)
                data["luoghiTop"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetLuoghiTopResponse extends IOkApiResponse {
    luoghiTop?: LuogoTop[] | null;
}

export class LuogoTop implements ILuogoTop {
    id?: number;
    nome?: string | null;
    latitudine?: number;
    longitudine?: number;
    popolarita?: number;

    constructor(data?: ILuogoTop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : <any>null;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : <any>null;
            this.popolarita = _data["popolarita"] !== undefined ? _data["popolarita"] : <any>null;
        }
    }

    static fromJS(data: any): LuogoTop {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoTop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : <any>null;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : <any>null;
        data["popolarita"] = this.popolarita !== undefined ? this.popolarita : <any>null;
        return data;
    }
}

export interface ILuogoTop {
    id?: number;
    nome?: string | null;
    latitudine?: number;
    longitudine?: number;
    popolarita?: number;
}

export class GetArticleHeadsResponse extends OkApiResponse implements IGetArticleHeadsResponse {
    intestazioni?: ArticoloTestataRow[];

    constructor(data?: IGetArticleHeadsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["intestazioni"])) {
                this.intestazioni = [] as any;
                for (let item of _data["intestazioni"])
                    this.intestazioni!.push(ArticoloTestataRow.fromJS(item));
            }
            else {
                this.intestazioni = <any>null;
            }
        }
    }

    static fromJS(data: any): GetArticleHeadsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleHeadsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.intestazioni)) {
            data["intestazioni"] = [];
            for (let item of this.intestazioni)
                data["intestazioni"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetArticleHeadsResponse extends IOkApiResponse {
    intestazioni?: ArticoloTestataRow[];
}

/** Rappresenta sul frontent una testa articolo con id e nome tradotto */
export class ArticoloTestataRow implements IArticoloTestataRow {
    /** ID dell'intestazione articolo */
    articoloTestataID?: number;
    /** Nome nella lingua richiesta */
    nome?: string;

    constructor(data?: IArticoloTestataRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articoloTestataID = _data["articoloTestataID"] !== undefined ? _data["articoloTestataID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloTestataRow {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTestataRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloTestataID"] = this.articoloTestataID !== undefined ? this.articoloTestataID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        return data;
    }
}

/** Rappresenta sul frontent una testa articolo con id e nome tradotto */
export interface IArticoloTestataRow {
    /** ID dell'intestazione articolo */
    articoloTestataID?: number;
    /** Nome nella lingua richiesta */
    nome?: string;
}

export class GetContactCategoriesResponse extends OkApiResponse implements IGetContactCategoriesResponse {
    /** Lista delle categorie contatto */
    categories?: ContactCategory[];

    constructor(data?: IGetContactCategoriesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(ContactCategory.fromJS(item));
            }
            else {
                this.categories = <any>null;
            }
        }
    }

    static fromJS(data: any): GetContactCategoriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactCategoriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetContactCategoriesResponse extends IOkApiResponse {
    /** Lista delle categorie contatto */
    categories?: ContactCategory[];
}

export class ContactCategory implements IContactCategory {
    /** ID della categoria */
    id?: number;
    /** Nome della categoria */
    name?: string;

    constructor(data?: IContactCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ContactCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ContactCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IContactCategory {
    /** ID della categoria */
    id?: number;
    /** Nome della categoria */
    name?: string;
}

export class GetContattoTipiDatoResponse extends OkApiResponse implements IGetContattoTipiDatoResponse {
    contattoTipiDato?: ContattoTipoDatoRow[] | null;

    constructor(data?: IGetContattoTipiDatoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contattoTipiDato"])) {
                this.contattoTipiDato = [] as any;
                for (let item of _data["contattoTipiDato"])
                    this.contattoTipiDato!.push(ContattoTipoDatoRow.fromJS(item));
            }
            else {
                this.contattoTipiDato = <any>null;
            }
        }
    }

    static fromJS(data: any): GetContattoTipiDatoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContattoTipiDatoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contattoTipiDato)) {
            data["contattoTipiDato"] = [];
            for (let item of this.contattoTipiDato)
                data["contattoTipiDato"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetContattoTipiDatoResponse extends IOkApiResponse {
    contattoTipiDato?: ContattoTipoDatoRow[] | null;
}

export class ContattoTipoDatoRow implements IContattoTipoDatoRow {
    id?: number;
    nome?: string | null;

    constructor(data?: IContattoTipoDatoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
        }
    }

    static fromJS(data: any): ContattoTipoDatoRow {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoTipoDatoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        return data;
    }
}

export interface IContattoTipoDatoRow {
    id?: number;
    nome?: string | null;
}

export class GetDatiAggiuntiviServiziResponse extends OkApiResponse implements IGetDatiAggiuntiviServiziResponse {
    tipiDatoAggiuntivo?: DatoAggiuntivoTipoRow[];

    constructor(data?: IGetDatiAggiuntiviServiziResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tipiDatoAggiuntivo"])) {
                this.tipiDatoAggiuntivo = [] as any;
                for (let item of _data["tipiDatoAggiuntivo"])
                    this.tipiDatoAggiuntivo!.push(DatoAggiuntivoTipoRow.fromJS(item));
            }
            else {
                this.tipiDatoAggiuntivo = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDatiAggiuntiviServiziResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatiAggiuntiviServiziResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipiDatoAggiuntivo)) {
            data["tipiDatoAggiuntivo"] = [];
            for (let item of this.tipiDatoAggiuntivo)
                data["tipiDatoAggiuntivo"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDatiAggiuntiviServiziResponse extends IOkApiResponse {
    tipiDatoAggiuntivo?: DatoAggiuntivoTipoRow[];
}

export class DatoAggiuntivoTipoRow implements IDatoAggiuntivoTipoRow {
    /** ID del tipo di dato */
    id?: number;
    /** Se valorizzato il tipo di dato va ristretto al tipo servizio */
    tipoServizio?: ETipoServizio | null;
    /** Nome localizzato del tipo di dato aggiuntivo */
    nome?: string;
    dati?: DatoAggiuntivoServizioRow[];

    constructor(data?: IDatoAggiuntivoTipoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            if (Array.isArray(_data["dati"])) {
                this.dati = [] as any;
                for (let item of _data["dati"])
                    this.dati!.push(DatoAggiuntivoServizioRow.fromJS(item));
            }
            else {
                this.dati = <any>null;
            }
        }
    }

    static fromJS(data: any): DatoAggiuntivoTipoRow {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoTipoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        if (Array.isArray(this.dati)) {
            data["dati"] = [];
            for (let item of this.dati)
                data["dati"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDatoAggiuntivoTipoRow {
    /** ID del tipo di dato */
    id?: number;
    /** Se valorizzato il tipo di dato va ristretto al tipo servizio */
    tipoServizio?: ETipoServizio | null;
    /** Nome localizzato del tipo di dato aggiuntivo */
    nome?: string;
    dati?: DatoAggiuntivoServizioRow[];
}

export class DatoAggiuntivoServizioRow implements IDatoAggiuntivoServizioRow {
    /** ID del dato */
    id?: number;
    /** Nome localizzato */
    nome?: string;
    /** Se usato vale solo nel luogo indicato */
    luogoID?: number | null;
    /** Se usato vale solo per il tipo di servizio indicato */
    tipoServizio?: ETipoServizio | null;
    /** Se true l'attributo accetta una variabile stringa */
    variabili?: boolean;
    /** Se true l'attributo è limitabile nel tempo */
    temporizzato?: boolean;

    constructor(data?: IDatoAggiuntivoServizioRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.variabili = _data["variabili"] !== undefined ? _data["variabili"] : <any>null;
            this.temporizzato = _data["temporizzato"] !== undefined ? _data["temporizzato"] : <any>null;
        }
    }

    static fromJS(data: any): DatoAggiuntivoServizioRow {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoServizioRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["variabili"] = this.variabili !== undefined ? this.variabili : <any>null;
        data["temporizzato"] = this.temporizzato !== undefined ? this.temporizzato : <any>null;
        return data;
    }
}

export interface IDatoAggiuntivoServizioRow {
    /** ID del dato */
    id?: number;
    /** Nome localizzato */
    nome?: string;
    /** Se usato vale solo nel luogo indicato */
    luogoID?: number | null;
    /** Se usato vale solo per il tipo di servizio indicato */
    tipoServizio?: ETipoServizio | null;
    /** Se true l'attributo accetta una variabile stringa */
    variabili?: boolean;
    /** Se true l'attributo è limitabile nel tempo */
    temporizzato?: boolean;
}

export class GetDocumentTypesResponse extends OkApiResponse implements IGetDocumentTypesResponse {
    documentTypes?: { [key in keyof typeof ETipoDocumento]?: DocumentType; };

    constructor(data?: IGetDocumentTypesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["documentTypes"]) {
                this.documentTypes = {} as any;
                for (let key in _data["documentTypes"]) {
                    if (_data["documentTypes"].hasOwnProperty(key))
                        (<any>this.documentTypes)![key] = _data["documentTypes"][key] ? DocumentType.fromJS(_data["documentTypes"][key]) : new DocumentType();
                }
            }
            else {
                this.documentTypes = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDocumentTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.documentTypes) {
            data["documentTypes"] = {};
            for (let key in this.documentTypes) {
                if (this.documentTypes.hasOwnProperty(key))
                    (<any>data["documentTypes"])[key] = this.documentTypes[key] ? this.documentTypes[key].toJSON() : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDocumentTypesResponse extends IOkApiResponse {
    documentTypes?: { [key in keyof typeof ETipoDocumento]?: DocumentType; };
}

export class DocumentType implements IDocumentType {
    /** Tipo */
    tipoDocumento?: ETipoDocumento;
    /** True se è un documento a frasi da creare con CreateDocumentoFrasi */
    usaFrasi?: boolean;
    /** True se consente di fare la preview */
    consentePreview?: boolean;
    /** Se true il documento è ancora sul NaarPrintServer */
    usaNps?: boolean;

    constructor(data?: IDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : <any>null;
            this.usaFrasi = _data["usaFrasi"] !== undefined ? _data["usaFrasi"] : <any>null;
            this.consentePreview = _data["consentePreview"] !== undefined ? _data["consentePreview"] : <any>null;
            this.usaNps = _data["usaNps"] !== undefined ? _data["usaNps"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : <any>null;
        data["usaFrasi"] = this.usaFrasi !== undefined ? this.usaFrasi : <any>null;
        data["consentePreview"] = this.consentePreview !== undefined ? this.consentePreview : <any>null;
        data["usaNps"] = this.usaNps !== undefined ? this.usaNps : <any>null;
        return data;
    }
}

export interface IDocumentType {
    /** Tipo */
    tipoDocumento?: ETipoDocumento;
    /** True se è un documento a frasi da creare con CreateDocumentoFrasi */
    usaFrasi?: boolean;
    /** True se consente di fare la preview */
    consentePreview?: boolean;
    /** Se true il documento è ancora sul NaarPrintServer */
    usaNps?: boolean;
}

export class GetExtraDocumentsResponse extends OkApiResponse implements IGetExtraDocumentsResponse {
    extraDocuments?: ExtraDocument[] | null;
    groups?: string[] | null;

    constructor(data?: IGetExtraDocumentsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["extraDocuments"])) {
                this.extraDocuments = [] as any;
                for (let item of _data["extraDocuments"])
                    this.extraDocuments!.push(ExtraDocument.fromJS(item));
            }
            else {
                this.extraDocuments = <any>null;
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
            else {
                this.groups = <any>null;
            }
        }
    }

    static fromJS(data: any): GetExtraDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetExtraDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.extraDocuments)) {
            data["extraDocuments"] = [];
            for (let item of this.extraDocuments)
                data["extraDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetExtraDocumentsResponse extends IOkApiResponse {
    extraDocuments?: ExtraDocument[] | null;
    groups?: string[] | null;
}

export class ExtraDocument implements IExtraDocument {
    id?: number;
    nome?: string | null;
    ordine?: number;
    pagine?: number;
    gruppo?: string | null;
    default?: boolean;
    luogoID?: number | null;
    tipoDocID?: number;

    constructor(data?: IExtraDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.pagine = _data["pagine"] !== undefined ? _data["pagine"] : <any>null;
            this.gruppo = _data["gruppo"] !== undefined ? _data["gruppo"] : <any>null;
            this.default = _data["default"] !== undefined ? _data["default"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.tipoDocID = _data["tipoDocID"] !== undefined ? _data["tipoDocID"] : <any>null;
        }
    }

    static fromJS(data: any): ExtraDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["pagine"] = this.pagine !== undefined ? this.pagine : <any>null;
        data["gruppo"] = this.gruppo !== undefined ? this.gruppo : <any>null;
        data["default"] = this.default !== undefined ? this.default : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["tipoDocID"] = this.tipoDocID !== undefined ? this.tipoDocID : <any>null;
        return data;
    }
}

export interface IExtraDocument {
    id?: number;
    nome?: string | null;
    ordine?: number;
    pagine?: number;
    gruppo?: string | null;
    default?: boolean;
    luogoID?: number | null;
    tipoDocID?: number;
}

export class GetMiniguideResponse extends OkApiResponse implements IGetMiniguideResponse {
    miniguide?: MiniguidaHeader[];

    constructor(data?: IGetMiniguideResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["miniguide"])) {
                this.miniguide = [] as any;
                for (let item of _data["miniguide"])
                    this.miniguide!.push(MiniguidaHeader.fromJS(item));
            }
            else {
                this.miniguide = <any>null;
            }
        }
    }

    static fromJS(data: any): GetMiniguideResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMiniguideResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.miniguide)) {
            data["miniguide"] = [];
            for (let item of this.miniguide)
                data["miniguide"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMiniguideResponse extends IOkApiResponse {
    miniguide?: MiniguidaHeader[];
}

export class MiniguidaHeader implements IMiniguidaHeader {
    id?: number;
    luogoID?: number;
    titolo?: string | null;
    ordine?: number;
    lingua?: ELingua;
    selected?: boolean;
    paeseID?: number;
    paese?: string | null;

    constructor(data?: IMiniguidaHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
            this.paeseID = _data["paeseID"] !== undefined ? _data["paeseID"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
        }
    }

    static fromJS(data: any): MiniguidaHeader {
        data = typeof data === 'object' ? data : {};
        let result = new MiniguidaHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        data["paeseID"] = this.paeseID !== undefined ? this.paeseID : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        return data;
    }
}

export interface IMiniguidaHeader {
    id?: number;
    luogoID?: number;
    titolo?: string | null;
    ordine?: number;
    lingua?: ELingua;
    selected?: boolean;
    paeseID?: number;
    paese?: string | null;
}

export class MiniguideRequest extends LocalizedRequest implements IMiniguideRequest {
    /** ID dell'offerta da cui estrarre i luoghi */
    offertaId!: number;

    constructor(data?: IMiniguideRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaId = _data["offertaId"] !== undefined ? _data["offertaId"] : <any>null;
        }
    }

    static fromJS(data: any): MiniguideRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MiniguideRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaId"] = this.offertaId !== undefined ? this.offertaId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMiniguideRequest extends ILocalizedRequest {
    /** ID dell'offerta da cui estrarre i luoghi */
    offertaId: number;
}

export class GetOperatorsResponse extends OkApiResponse implements IGetOperatorsResponse {
    /** Lista degli operatori */
    operators?: OperatorData[];

    constructor(data?: IGetOperatorsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["operators"])) {
                this.operators = [] as any;
                for (let item of _data["operators"])
                    this.operators!.push(OperatorData.fromJS(item));
            }
            else {
                this.operators = <any>null;
            }
        }
    }

    static fromJS(data: any): GetOperatorsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOperatorsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operators)) {
            data["operators"] = [];
            for (let item of this.operators)
                data["operators"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetOperatorsResponse extends IOkApiResponse {
    /** Lista degli operatori */
    operators?: OperatorData[];
}

export class OperatorData implements IOperatorData {
    /** ID dell'operatore */
    id?: number;
    /** Nome dell'operatore */
    name?: string;
    /** Enum dell'operatore */
    operatore?: EOperatore;
    /** Lingue supportate dall'operatore */
    lingue?: ELingua[];
    /** Lingua di default */
    linguaDiDefault?: ELingua;
    /** Se l'operatore è visibile */
    visible?: boolean;
    advHomeConf?: ActionBoxConfig[] | null;

    constructor(data?: IOperatorData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            if (Array.isArray(_data["lingue"])) {
                this.lingue = [] as any;
                for (let item of _data["lingue"])
                    this.lingue!.push(item);
            }
            else {
                this.lingue = <any>null;
            }
            this.linguaDiDefault = _data["linguaDiDefault"] !== undefined ? _data["linguaDiDefault"] : <any>null;
            this.visible = _data["visible"] !== undefined ? _data["visible"] : <any>null;
            if (Array.isArray(_data["advHomeConf"])) {
                this.advHomeConf = [] as any;
                for (let item of _data["advHomeConf"])
                    this.advHomeConf!.push(ActionBoxConfig.fromJS(item));
            }
            else {
                this.advHomeConf = <any>null;
            }
        }
    }

    static fromJS(data: any): OperatorData {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        if (Array.isArray(this.lingue)) {
            data["lingue"] = [];
            for (let item of this.lingue)
                data["lingue"].push(item);
        }
        data["linguaDiDefault"] = this.linguaDiDefault !== undefined ? this.linguaDiDefault : <any>null;
        data["visible"] = this.visible !== undefined ? this.visible : <any>null;
        if (Array.isArray(this.advHomeConf)) {
            data["advHomeConf"] = [];
            for (let item of this.advHomeConf)
                data["advHomeConf"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOperatorData {
    /** ID dell'operatore */
    id?: number;
    /** Nome dell'operatore */
    name?: string;
    /** Enum dell'operatore */
    operatore?: EOperatore;
    /** Lingue supportate dall'operatore */
    lingue?: ELingua[];
    /** Lingua di default */
    linguaDiDefault?: ELingua;
    /** Se l'operatore è visibile */
    visible?: boolean;
    advHomeConf?: ActionBoxConfig[] | null;
}

export class ActionBoxConfig implements IActionBoxConfig {
    type?: EActionBoxType;
    orientation?: EActionBoxOrientation;
    showImage?: boolean;

    constructor(data?: IActionBoxConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.orientation = _data["orientation"] !== undefined ? _data["orientation"] : <any>null;
            this.showImage = _data["showImage"] !== undefined ? _data["showImage"] : <any>null;
        }
    }

    static fromJS(data: any): ActionBoxConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ActionBoxConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["orientation"] = this.orientation !== undefined ? this.orientation : <any>null;
        data["showImage"] = this.showImage !== undefined ? this.showImage : <any>null;
        return data;
    }
}

export interface IActionBoxConfig {
    type?: EActionBoxType;
    orientation?: EActionBoxOrientation;
    showImage?: boolean;
}

export enum EActionBoxType {
    CreaInLiberta = "CreaInLiberta",
    FlyBeach = "FlyBeach",
    FlyCity = "FlyCity",
    FlyCruise = "FlyCruise",
    FlyTour = "FlyTour",
    ItinConsigliati = "ItinConsigliati",
    RicercaViaggi = "RicercaViaggi",
    RichiestaPreventivo = "RichiestaPreventivo",
    Separator = "Separator",
    TourGuidati = "TourGuidati",
}

export enum EActionBoxOrientation {
    Vertical = "Vertical",
    Horizontal = "Horizontal",
    VerticalTiny = "VerticalTiny",
    HorizontalTiny = "HorizontalTiny",
}

export class GetOrdersTagsResponse extends OkApiResponse implements IGetOrdersTagsResponse {
    tags?: OrderTagData[] | null;

    constructor(data?: IGetOrdersTagsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(OrderTagData.fromJS(item));
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): GetOrdersTagsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrdersTagsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetOrdersTagsResponse extends IOkApiResponse {
    tags?: OrderTagData[] | null;
}

/** Rappresentazione di un Tag offerta, per uso lista generica/visualizzazione */
export class OrderTagData implements IOrderTagData {
    /** ID del tag */
    id?: number;
    /** Nome visualizzato del tag */
    tag?: string | null;
    /** JSON Opzioni UI */
    uiOptions?: string | null;

    constructor(data?: IOrderTagData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : <any>null;
        }
    }

    static fromJS(data: any): OrderTagData {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTagData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : <any>null;
        return data;
    }
}

/** Rappresentazione di un Tag offerta, per uso lista generica/visualizzazione */
export interface IOrderTagData {
    /** ID del tag */
    id?: number;
    /** Nome visualizzato del tag */
    tag?: string | null;
    /** JSON Opzioni UI */
    uiOptions?: string | null;
}

export class GetPageLinksResponse extends OkApiResponse implements IGetPageLinksResponse {
    menuLinks?: SitePageLink[] | null;
    bannerLinks?: SitePageLink[] | null;
    newsLinks?: SitePageLink[] | null;

    constructor(data?: IGetPageLinksResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["menuLinks"])) {
                this.menuLinks = [] as any;
                for (let item of _data["menuLinks"])
                    this.menuLinks!.push(SitePageLink.fromJS(item));
            }
            else {
                this.menuLinks = <any>null;
            }
            if (Array.isArray(_data["bannerLinks"])) {
                this.bannerLinks = [] as any;
                for (let item of _data["bannerLinks"])
                    this.bannerLinks!.push(SitePageLink.fromJS(item));
            }
            else {
                this.bannerLinks = <any>null;
            }
            if (Array.isArray(_data["newsLinks"])) {
                this.newsLinks = [] as any;
                for (let item of _data["newsLinks"])
                    this.newsLinks!.push(SitePageLink.fromJS(item));
            }
            else {
                this.newsLinks = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPageLinksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageLinksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.menuLinks)) {
            data["menuLinks"] = [];
            for (let item of this.menuLinks)
                data["menuLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.bannerLinks)) {
            data["bannerLinks"] = [];
            for (let item of this.bannerLinks)
                data["bannerLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.newsLinks)) {
            data["newsLinks"] = [];
            for (let item of this.newsLinks)
                data["newsLinks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPageLinksResponse extends IOkApiResponse {
    menuLinks?: SitePageLink[] | null;
    bannerLinks?: SitePageLink[] | null;
    newsLinks?: SitePageLink[] | null;
}

export class SitePageLink implements ISitePageLink {
    nome?: string | null;
    tipo?: ETipoLink;
    url?: string | null;
    routerLink?: any[] | null;
    icona?: string | null;
    articoli?: PageArticle[] | null;
    collapseFlag?: boolean;

    constructor(data?: ISitePageLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            if (Array.isArray(_data["routerLink"])) {
                this.routerLink = [] as any;
                for (let item of _data["routerLink"])
                    this.routerLink!.push(item);
            }
            else {
                this.routerLink = <any>null;
            }
            this.icona = _data["icona"] !== undefined ? _data["icona"] : <any>null;
            if (Array.isArray(_data["articoli"])) {
                this.articoli = [] as any;
                for (let item of _data["articoli"])
                    this.articoli!.push(PageArticle.fromJS(item));
            }
            else {
                this.articoli = <any>null;
            }
            this.collapseFlag = _data["collapseFlag"] !== undefined ? _data["collapseFlag"] : <any>null;
        }
    }

    static fromJS(data: any): SitePageLink {
        data = typeof data === 'object' ? data : {};
        let result = new SitePageLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        if (Array.isArray(this.routerLink)) {
            data["routerLink"] = [];
            for (let item of this.routerLink)
                data["routerLink"].push(item);
        }
        data["icona"] = this.icona !== undefined ? this.icona : <any>null;
        if (Array.isArray(this.articoli)) {
            data["articoli"] = [];
            for (let item of this.articoli)
                data["articoli"].push(item.toJSON());
        }
        data["collapseFlag"] = this.collapseFlag !== undefined ? this.collapseFlag : <any>null;
        return data;
    }
}

export interface ISitePageLink {
    nome?: string | null;
    tipo?: ETipoLink;
    url?: string | null;
    routerLink?: any[] | null;
    icona?: string | null;
    articoli?: PageArticle[] | null;
    collapseFlag?: boolean;
}

export class PageArticle implements IPageArticle {
    id?: number;
    titolo?: string | null;
    icona?: string | null;

    constructor(data?: IPageArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.icona = _data["icona"] !== undefined ? _data["icona"] : <any>null;
        }
    }

    static fromJS(data: any): PageArticle {
        data = typeof data === 'object' ? data : {};
        let result = new PageArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["icona"] = this.icona !== undefined ? this.icona : <any>null;
        return data;
    }
}

export interface IPageArticle {
    id?: number;
    titolo?: string | null;
    icona?: string | null;
}

export class GetPageLinksRequest extends SiteRequest implements IGetPageLinksRequest {
    luogoPaginaID?: number;

    constructor(data?: IGetPageLinksRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoPaginaID = _data["luogoPaginaID"] !== undefined ? _data["luogoPaginaID"] : <any>null;
        }
    }

    static fromJS(data: any): GetPageLinksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageLinksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoPaginaID"] = this.luogoPaginaID !== undefined ? this.luogoPaginaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPageLinksRequest extends ISiteRequest {
    luogoPaginaID?: number;
}

export class GetPermissionsResponse extends OkApiResponse implements IGetPermissionsResponse {
    /** Categorie di permessi (e relativi permessi) */
    categories?: PermissionCategoryData[];
    /** Elenco "flat" dei permessi */
    permissions?: PermissionData[];

    constructor(data?: IGetPermissionsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(PermissionCategoryData.fromJS(item));
            }
            else {
                this.categories = <any>null;
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionData.fromJS(item));
            }
            else {
                this.permissions = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPermissionsResponse extends IOkApiResponse {
    /** Categorie di permessi (e relativi permessi) */
    categories?: PermissionCategoryData[];
    /** Elenco "flat" dei permessi */
    permissions?: PermissionData[];
}

export class PermissionCategoryData implements IPermissionCategoryData {
    /** ID della categoria */
    id?: number;
    /** Nome della categoria */
    name?: string;
    /** Lista dei permessi di questa categoria */
    permissions?: PermissionData[];

    constructor(data?: IPermissionCategoryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionData.fromJS(item));
            }
            else {
                this.permissions = <any>null;
            }
        }
    }

    static fromJS(data: any): PermissionCategoryData {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionCategoryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissionCategoryData {
    /** ID della categoria */
    id?: number;
    /** Nome della categoria */
    name?: string;
    /** Lista dei permessi di questa categoria */
    permissions?: PermissionData[];
}

export class PermissionData implements IPermissionData {
    /** ID del permesso */
    id?: number;
    /** Codice alfanumerico del permesso */
    code?: string;
    /** Descrizione del permesso */
    description?: string;

    constructor(data?: IPermissionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): PermissionData {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface IPermissionData {
    /** ID del permesso */
    id?: number;
    /** Codice alfanumerico del permesso */
    code?: string;
    /** Descrizione del permesso */
    description?: string;
}

export class GetPhraseTagsResponse extends OkApiResponse implements IGetPhraseTagsResponse {
    tags?: TagView[];

    constructor(data?: IGetPhraseTagsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagView.fromJS(item));
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPhraseTagsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPhraseTagsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPhraseTagsResponse extends IOkApiResponse {
    tags?: TagView[];
}

export class TagView implements ITagView {
    id?: number;
    /** Nome localizzato del tag */
    tag?: string;
    /** True se è un tag di sistema */
    isSystem?: boolean;
    /** Codice del tag */
    code?: string | null;
    /** Opzioni UI (colore e sfondo) */
    uiOptions?: string | null;
    /** Numero di frasi associate */
    usageCount?: number;

    constructor(data?: ITagView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.isSystem = _data["isSystem"] !== undefined ? _data["isSystem"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : <any>null;
            this.usageCount = _data["usageCount"] !== undefined ? _data["usageCount"] : <any>null;
        }
    }

    static fromJS(data: any): TagView {
        data = typeof data === 'object' ? data : {};
        let result = new TagView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["isSystem"] = this.isSystem !== undefined ? this.isSystem : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : <any>null;
        data["usageCount"] = this.usageCount !== undefined ? this.usageCount : <any>null;
        return data;
    }
}

export interface ITagView {
    id?: number;
    /** Nome localizzato del tag */
    tag?: string;
    /** True se è un tag di sistema */
    isSystem?: boolean;
    /** Codice del tag */
    code?: string | null;
    /** Opzioni UI (colore e sfondo) */
    uiOptions?: string | null;
    /** Numero di frasi associate */
    usageCount?: number;
}

export class GetPoliciesListResponse extends OkApiResponse implements IGetPoliciesListResponse {
    penali?: PenaleRow[] | null;

    constructor(data?: IGetPoliciesListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["penali"])) {
                this.penali = [] as any;
                for (let item of _data["penali"])
                    this.penali!.push(PenaleRow.fromJS(item));
            }
            else {
                this.penali = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPoliciesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPoliciesListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.penali)) {
            data["penali"] = [];
            for (let item of this.penali)
                data["penali"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPoliciesListResponse extends IOkApiResponse {
    penali?: PenaleRow[] | null;
}

export class PenaleRow implements IPenaleRow {
    id?: number;
    nome?: string | null;
    cfgDataLimite?: EConfigurazioneParametro;
    cfgImporto?: EConfigurazioneParametro;
    utilizzabileSuRegolaVendita?: boolean;

    constructor(data?: IPenaleRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cfgDataLimite = _data["cfgDataLimite"] !== undefined ? _data["cfgDataLimite"] : <any>null;
            this.cfgImporto = _data["cfgImporto"] !== undefined ? _data["cfgImporto"] : <any>null;
            this.utilizzabileSuRegolaVendita = _data["utilizzabileSuRegolaVendita"] !== undefined ? _data["utilizzabileSuRegolaVendita"] : <any>null;
        }
    }

    static fromJS(data: any): PenaleRow {
        data = typeof data === 'object' ? data : {};
        let result = new PenaleRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cfgDataLimite"] = this.cfgDataLimite !== undefined ? this.cfgDataLimite : <any>null;
        data["cfgImporto"] = this.cfgImporto !== undefined ? this.cfgImporto : <any>null;
        data["utilizzabileSuRegolaVendita"] = this.utilizzabileSuRegolaVendita !== undefined ? this.utilizzabileSuRegolaVendita : <any>null;
        return data;
    }
}

export interface IPenaleRow {
    id?: number;
    nome?: string | null;
    cfgDataLimite?: EConfigurazioneParametro;
    cfgImporto?: EConfigurazioneParametro;
    utilizzabileSuRegolaVendita?: boolean;
}

export enum EConfigurazioneParametro {
    NonUsato = "NonUsato",
    SolaLettura = "SolaLettura",
    Modificabile = "Modificabile",
}

export class GetPricingResponse extends OkApiResponse implements IGetPricingResponse {
    pricings?: PricingItem[];

    constructor(data?: IGetPricingResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pricings"])) {
                this.pricings = [] as any;
                for (let item of _data["pricings"])
                    this.pricings!.push(PricingItem.fromJS(item));
            }
            else {
                this.pricings = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPricingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pricings)) {
            data["pricings"] = [];
            for (let item of this.pricings)
                data["pricings"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPricingResponse extends IOkApiResponse {
    pricings?: PricingItem[];
}

export class PricingItem implements IPricingItem {
    pricing?: Pricing;
    tourOperator?: string;

    constructor(data?: IPricingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricing = _data["pricing"] ? Pricing.fromJS(_data["pricing"]) : <any>null;
            this.tourOperator = _data["tourOperator"] !== undefined ? _data["tourOperator"] : <any>null;
        }
    }

    static fromJS(data: any): PricingItem {
        data = typeof data === 'object' ? data : {};
        let result = new PricingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricing"] = this.pricing ? this.pricing.toJSON() : <any>null;
        data["tourOperator"] = this.tourOperator !== undefined ? this.tourOperator : <any>null;
        return data;
    }
}

export interface IPricingItem {
    pricing?: Pricing;
    tourOperator?: string;
}

export class Pricing implements IPricing {
    id?: number;
    name!: string;
    operator?: EOperatore;

    constructor(data?: IPricing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
        }
    }

    static fromJS(data: any): Pricing {
        data = typeof data === 'object' ? data : {};
        let result = new Pricing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        return data;
    }
}

export interface IPricing {
    id?: number;
    name: string;
    operator?: EOperatore;
}

export class GetRolesResponse extends OkApiResponse implements IGetRolesResponse {
    /** Lista degli ruoli */
    roles?: RoleData[] | null;

    constructor(data?: IGetRolesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleData.fromJS(item));
            }
            else {
                this.roles = <any>null;
            }
        }
    }

    static fromJS(data: any): GetRolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetRolesResponse extends IOkApiResponse {
    /** Lista degli ruoli */
    roles?: RoleData[] | null;
}

export class RoleData implements IRoleData {
    /** ID del ruolo */
    id?: number;
    /** Nome del ruolo */
    name?: string | null;

    constructor(data?: IRoleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): RoleData {
        data = typeof data === 'object' ? data : {};
        let result = new RoleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IRoleData {
    /** ID del ruolo */
    id?: number;
    /** Nome del ruolo */
    name?: string | null;
}

export class GetServicesOffersTypesResponse extends OkApiResponse implements IGetServicesOffersTypesResponse {
    offersTypes?: ServiceOfferTypeRow[];

    constructor(data?: IGetServicesOffersTypesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["offersTypes"])) {
                this.offersTypes = [] as any;
                for (let item of _data["offersTypes"])
                    this.offersTypes!.push(ServiceOfferTypeRow.fromJS(item));
            }
            else {
                this.offersTypes = <any>null;
            }
        }
    }

    static fromJS(data: any): GetServicesOffersTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServicesOffersTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.offersTypes)) {
            data["offersTypes"] = [];
            for (let item of this.offersTypes)
                data["offersTypes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetServicesOffersTypesResponse extends IOkApiResponse {
    offersTypes?: ServiceOfferTypeRow[];
}

export class ServiceOfferTypeRow implements IServiceOfferTypeRow {
    id?: number;
    name?: string;

    constructor(data?: IServiceOfferTypeRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceOfferTypeRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOfferTypeRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IServiceOfferTypeRow {
    id?: number;
    name?: string;
}

export class GetSistemazioniResponse extends OkApiResponse implements IGetSistemazioniResponse {
    sistemazioni?: SistemazioneListRow[] | null;

    constructor(data?: IGetSistemazioniResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sistemazioni"])) {
                this.sistemazioni = [] as any;
                for (let item of _data["sistemazioni"])
                    this.sistemazioni!.push(SistemazioneListRow.fromJS(item));
            }
            else {
                this.sistemazioni = <any>null;
            }
        }
    }

    static fromJS(data: any): GetSistemazioniResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSistemazioniResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sistemazioni)) {
            data["sistemazioni"] = [];
            for (let item of this.sistemazioni)
                data["sistemazioni"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetSistemazioniResponse extends IOkApiResponse {
    sistemazioni?: SistemazioneListRow[] | null;
}

export class SistemazioneListRow implements ISistemazioneListRow {
    /** ID del bedding */
    sistemazioneID?: number;
    /** Nome localizzato */
    nome?: string | null;

    constructor(data?: ISistemazioneListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sistemazioneID = _data["sistemazioneID"] !== undefined ? _data["sistemazioneID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
        }
    }

    static fromJS(data: any): SistemazioneListRow {
        data = typeof data === 'object' ? data : {};
        let result = new SistemazioneListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sistemazioneID"] = this.sistemazioneID !== undefined ? this.sistemazioneID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        return data;
    }
}

export interface ISistemazioneListRow {
    /** ID del bedding */
    sistemazioneID?: number;
    /** Nome localizzato */
    nome?: string | null;
}

export class GetTeamsResponse extends OkApiResponse implements IGetTeamsResponse {
    /** Lista dei team */
    teams?: TeamData[];

    constructor(data?: IGetTeamsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamData.fromJS(item));
            }
            else {
                this.teams = <any>null;
            }
        }
    }

    static fromJS(data: any): GetTeamsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTeamsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTeamsResponse extends IOkApiResponse {
    /** Lista dei team */
    teams?: TeamData[];
}

export class TeamData implements ITeamData {
    /** ID del team */
    id?: string;
    /** ID numerico del team */
    teamID?: number;
    /** Nome del team */
    name?: string;
    /** Visibilità del team */
    visibilita?: EVisibilitaTeam;
    operatore?: EOperatore;

    constructor(data?: ITeamData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
        }
    }

    static fromJS(data: any): TeamData {
        data = typeof data === 'object' ? data : {};
        let result = new TeamData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["teamID"] = this.teamID !== undefined ? this.teamID : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        return data;
    }
}

export interface ITeamData {
    /** ID del team */
    id?: string;
    /** ID numerico del team */
    teamID?: number;
    /** Nome del team */
    name?: string;
    /** Visibilità del team */
    visibilita?: EVisibilitaTeam;
    operatore?: EOperatore;
}

export enum EVisibilitaTeam {
    NonVisibile = "NonVisibile",
    Privato = "Privato",
    Pubblico = "Pubblico",
    Obsoleto = "Obsoleto",
}

export class GetTipologiaStandardResponse extends OkApiResponse implements IGetTipologiaStandardResponse {
    tipologieStandard?: ServizioTipologiaStandard[] | null;

    constructor(data?: IGetTipologiaStandardResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tipologieStandard"])) {
                this.tipologieStandard = [] as any;
                for (let item of _data["tipologieStandard"])
                    this.tipologieStandard!.push(ServizioTipologiaStandard.fromJS(item));
            }
            else {
                this.tipologieStandard = <any>null;
            }
        }
    }

    static fromJS(data: any): GetTipologiaStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipologiaStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipologieStandard)) {
            data["tipologieStandard"] = [];
            for (let item of this.tipologieStandard)
                data["tipologieStandard"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTipologiaStandardResponse extends IOkApiResponse {
    tipologieStandard?: ServizioTipologiaStandard[] | null;
}

export class GetValuteResponse extends OkApiResponse implements IGetValuteResponse {
    valute?: ValutaCorrente[];

    constructor(data?: IGetValuteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["valute"])) {
                this.valute = [] as any;
                for (let item of _data["valute"])
                    this.valute!.push(ValutaCorrente.fromJS(item));
            }
            else {
                this.valute = <any>null;
            }
        }
    }

    static fromJS(data: any): GetValuteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetValuteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.valute)) {
            data["valute"] = [];
            for (let item of this.valute)
                data["valute"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetValuteResponse extends IOkApiResponse {
    valute?: ValutaCorrente[];
}

export class ValutaCorrente implements IValutaCorrente {
    /** ID della valuta */
    id?: number;
    /** Nome visualizzato */
    nome?: string;
    /** Codice a tre lettere della valuta */
    codice?: string;
    /** Cambio applicato nelle offerte */
    cambio?: number | null;
    /** Cambio reale da usare nei pagamenti */
    cambioReale?: number | null;

    constructor(data?: IValutaCorrente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.cambio = _data["cambio"] !== undefined ? _data["cambio"] : <any>null;
            this.cambioReale = _data["cambioReale"] !== undefined ? _data["cambioReale"] : <any>null;
        }
    }

    static fromJS(data: any): ValutaCorrente {
        data = typeof data === 'object' ? data : {};
        let result = new ValutaCorrente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["cambio"] = this.cambio !== undefined ? this.cambio : <any>null;
        data["cambioReale"] = this.cambioReale !== undefined ? this.cambioReale : <any>null;
        return data;
    }
}

export interface IValutaCorrente {
    /** ID della valuta */
    id?: number;
    /** Nome visualizzato */
    nome?: string;
    /** Codice a tre lettere della valuta */
    codice?: string;
    /** Cambio applicato nelle offerte */
    cambio?: number | null;
    /** Cambio reale da usare nei pagamenti */
    cambioReale?: number | null;
}

export class NrTableResponseOfEmissioneRow extends OkApiResponse implements INrTableResponseOfEmissioneRow {
    /** Array delle righe della pagina richiesta */
    rows?: EmissioneRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfEmissioneRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EmissioneRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfEmissioneRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfEmissioneRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfEmissioneRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: EmissioneRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class EmissioneRow implements IEmissioneRow {
    offertaID?: number;
    offertaDatoID?: number;
    partenza?: string;
    contattoAgenziaID?: number;
    operatore?: EOperatore;
    agenzia?: string | null;
    pagamento?: string | null;
    descrizione?: string | null;
    pnr?: string | null;
    pagaSubito?: boolean;
    dataPagamento?: string | null;
    dataPresaInCarico?: string | null;
    dataRichiesta?: string;
    dataEmissione?: string | null;
    okContabilita?: boolean;
    emesso?: boolean;
    utenteConferma?: string | null;

    constructor(data?: IEmissioneRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : <any>null;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : <any>null;
            this.pagaSubito = _data["pagaSubito"] !== undefined ? _data["pagaSubito"] : <any>null;
            this.dataPagamento = _data["dataPagamento"] !== undefined ? _data["dataPagamento"] : <any>null;
            this.dataPresaInCarico = _data["dataPresaInCarico"] !== undefined ? _data["dataPresaInCarico"] : <any>null;
            this.dataRichiesta = _data["dataRichiesta"] !== undefined ? _data["dataRichiesta"] : <any>null;
            this.dataEmissione = _data["dataEmissione"] !== undefined ? _data["dataEmissione"] : <any>null;
            this.okContabilita = _data["okContabilita"] !== undefined ? _data["okContabilita"] : <any>null;
            this.emesso = _data["emesso"] !== undefined ? _data["emesso"] : <any>null;
            this.utenteConferma = _data["utenteConferma"] !== undefined ? _data["utenteConferma"] : <any>null;
        }
    }

    static fromJS(data: any): EmissioneRow {
        data = typeof data === 'object' ? data : {};
        let result = new EmissioneRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : <any>null;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["pnr"] = this.pnr !== undefined ? this.pnr : <any>null;
        data["pagaSubito"] = this.pagaSubito !== undefined ? this.pagaSubito : <any>null;
        data["dataPagamento"] = this.dataPagamento !== undefined ? this.dataPagamento : <any>null;
        data["dataPresaInCarico"] = this.dataPresaInCarico !== undefined ? this.dataPresaInCarico : <any>null;
        data["dataRichiesta"] = this.dataRichiesta !== undefined ? this.dataRichiesta : <any>null;
        data["dataEmissione"] = this.dataEmissione !== undefined ? this.dataEmissione : <any>null;
        data["okContabilita"] = this.okContabilita !== undefined ? this.okContabilita : <any>null;
        data["emesso"] = this.emesso !== undefined ? this.emesso : <any>null;
        data["utenteConferma"] = this.utenteConferma !== undefined ? this.utenteConferma : <any>null;
        return data;
    }
}

export interface IEmissioneRow {
    offertaID?: number;
    offertaDatoID?: number;
    partenza?: string;
    contattoAgenziaID?: number;
    operatore?: EOperatore;
    agenzia?: string | null;
    pagamento?: string | null;
    descrizione?: string | null;
    pnr?: string | null;
    pagaSubito?: boolean;
    dataPagamento?: string | null;
    dataPresaInCarico?: string | null;
    dataRichiesta?: string;
    dataEmissione?: string | null;
    okContabilita?: boolean;
    emesso?: boolean;
    utenteConferma?: string | null;
}

export class GetEmissioniRequest extends NrTableRequest implements IGetEmissioniRequest {
    offertaID?: number | null;
    utenteConfermaID?: number | null;
    tipoLista?: ETipoListaEmissioni;
    contattoAgenziaID?: number | null;
    pagamentoID?: number | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    scadenzaEmissioneDal?: string | null;
    scadenzaEmissioneAl?: string | null;
    scadenzaPagamentoDal?: string | null;
    scadenzaPagamentoAl?: string | null;
    operatore?: EOperatore | null;

    constructor(data?: IGetEmissioniRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.utenteConfermaID = _data["utenteConfermaID"] !== undefined ? _data["utenteConfermaID"] : <any>null;
            this.tipoLista = _data["tipoLista"] !== undefined ? _data["tipoLista"] : <any>null;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : <any>null;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : <any>null;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
            this.scadenzaEmissioneDal = _data["scadenzaEmissioneDal"] !== undefined ? _data["scadenzaEmissioneDal"] : <any>null;
            this.scadenzaEmissioneAl = _data["scadenzaEmissioneAl"] !== undefined ? _data["scadenzaEmissioneAl"] : <any>null;
            this.scadenzaPagamentoDal = _data["scadenzaPagamentoDal"] !== undefined ? _data["scadenzaPagamentoDal"] : <any>null;
            this.scadenzaPagamentoAl = _data["scadenzaPagamentoAl"] !== undefined ? _data["scadenzaPagamentoAl"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
        }
    }

    static fromJS(data: any): GetEmissioniRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmissioniRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["utenteConfermaID"] = this.utenteConfermaID !== undefined ? this.utenteConfermaID : <any>null;
        data["tipoLista"] = this.tipoLista !== undefined ? this.tipoLista : <any>null;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : <any>null;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : <any>null;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        data["scadenzaEmissioneDal"] = this.scadenzaEmissioneDal !== undefined ? this.scadenzaEmissioneDal : <any>null;
        data["scadenzaEmissioneAl"] = this.scadenzaEmissioneAl !== undefined ? this.scadenzaEmissioneAl : <any>null;
        data["scadenzaPagamentoDal"] = this.scadenzaPagamentoDal !== undefined ? this.scadenzaPagamentoDal : <any>null;
        data["scadenzaPagamentoAl"] = this.scadenzaPagamentoAl !== undefined ? this.scadenzaPagamentoAl : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetEmissioniRequest extends INrTableRequest {
    offertaID?: number | null;
    utenteConfermaID?: number | null;
    tipoLista?: ETipoListaEmissioni;
    contattoAgenziaID?: number | null;
    pagamentoID?: number | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    scadenzaEmissioneDal?: string | null;
    scadenzaEmissioneAl?: string | null;
    scadenzaPagamentoDal?: string | null;
    scadenzaPagamentoAl?: string | null;
    operatore?: EOperatore | null;
}

export enum ETipoListaEmissioni {
    Tutti = "Tutti",
    DaAutorizzare = "DaAutorizzare",
    DaEmettere = "DaEmettere",
    Emessi = "Emessi",
    NonPresiInCarico = "NonPresiInCarico",
    PresiInCarico = "PresiInCarico",
}

export class SetOkContabilitaRequest extends ApiRequest implements ISetOkContabilitaRequest {
    righe?: OffertaRiga[] | null;

    constructor(data?: ISetOkContabilitaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(OffertaRiga.fromJS(item));
            }
            else {
                this.righe = <any>null;
            }
        }
    }

    static fromJS(data: any): SetOkContabilitaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetOkContabilitaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetOkContabilitaRequest extends IApiRequest {
    righe?: OffertaRiga[] | null;
}

export class OffertaRiga implements IOffertaRiga {
    offertaID?: number;
    rigaID?: number;

    constructor(data?: IOffertaRiga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaRiga {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaRiga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : <any>null;
        return data;
    }
}

export interface IOffertaRiga {
    offertaID?: number;
    rigaID?: number;
}

export class SetPresaInCaricoRequest extends ApiRequest implements ISetPresaInCaricoRequest {
    righe?: OffertaRiga[] | null;

    constructor(data?: ISetPresaInCaricoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(OffertaRiga.fromJS(item));
            }
            else {
                this.righe = <any>null;
            }
        }
    }

    static fromJS(data: any): SetPresaInCaricoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetPresaInCaricoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetPresaInCaricoRequest extends IApiRequest {
    righe?: OffertaRiga[] | null;
}

export class LinkEditResponse extends OkApiResponse implements ILinkEditResponse {
    link?: PageLink | null;

    constructor(data?: ILinkEditResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.link = _data["link"] ? PageLink.fromJS(_data["link"]) : <any>null;
        }
    }

    static fromJS(data: any): LinkEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link ? this.link.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ILinkEditResponse extends IOkApiResponse {
    link?: PageLink | null;
}

export class AddLinkContentRequest extends LocalizedRequest implements IAddLinkContentRequest {
    linkID?: number;
    tipoEntita?: ETipoEntita;
    entitaID?: number;

    constructor(data?: IAddLinkContentRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkID = _data["linkID"] !== undefined ? _data["linkID"] : <any>null;
            this.tipoEntita = _data["tipoEntita"] !== undefined ? _data["tipoEntita"] : <any>null;
            this.entitaID = _data["entitaID"] !== undefined ? _data["entitaID"] : <any>null;
        }
    }

    static fromJS(data: any): AddLinkContentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddLinkContentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkID"] = this.linkID !== undefined ? this.linkID : <any>null;
        data["tipoEntita"] = this.tipoEntita !== undefined ? this.tipoEntita : <any>null;
        data["entitaID"] = this.entitaID !== undefined ? this.entitaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddLinkContentRequest extends ILocalizedRequest {
    linkID?: number;
    tipoEntita?: ETipoEntita;
    entitaID?: number;
}

export class LinkEditRequest extends ApiRequest implements ILinkEditRequest {
    link?: PageLink | null;

    constructor(data?: ILinkEditRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.link = _data["link"] ? PageLink.fromJS(_data["link"]) : <any>null;
        }
    }

    static fromJS(data: any): LinkEditRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkEditRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link ? this.link.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ILinkEditRequest extends IApiRequest {
    link?: PageLink | null;
}

export class EditLinkContentRequest extends LocalizedRequest implements IEditLinkContentRequest {
    contenuto?: PageLinkContent | null;

    constructor(data?: IEditLinkContentRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contenuto = _data["contenuto"] ? PageLinkContent.fromJS(_data["contenuto"]) : <any>null;
        }
    }

    static fromJS(data: any): EditLinkContentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditLinkContentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contenuto"] = this.contenuto ? this.contenuto.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEditLinkContentRequest extends ILocalizedRequest {
    contenuto?: PageLinkContent | null;
}

export class DeleteLinkContentRequest extends LocalizedRequest implements IDeleteLinkContentRequest {
    linkID?: number;
    linkContentID?: number;

    constructor(data?: IDeleteLinkContentRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkID = _data["linkID"] !== undefined ? _data["linkID"] : <any>null;
            this.linkContentID = _data["linkContentID"] !== undefined ? _data["linkContentID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteLinkContentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLinkContentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkID"] = this.linkID !== undefined ? this.linkID : <any>null;
        data["linkContentID"] = this.linkContentID !== undefined ? this.linkContentID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteLinkContentRequest extends ILocalizedRequest {
    linkID?: number;
    linkContentID?: number;
}

export class GetCmsPagesResponse extends OkApiResponse implements IGetCmsPagesResponse {
    pages?: CmsPage[] | null;

    constructor(data?: IGetCmsPagesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(CmsPage.fromJS(item));
            }
            else {
                this.pages = <any>null;
            }
        }
    }

    static fromJS(data: any): GetCmsPagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCmsPagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCmsPagesResponse extends IOkApiResponse {
    pages?: CmsPage[] | null;
}

export class CmsPage implements ICmsPage {
    id?: number;
    nome?: string | null;
    sezioni?: { [key in keyof typeof EPosizioneLink]?: CmsPageSection; } | null;

    constructor(data?: ICmsPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            if (_data["sezioni"]) {
                this.sezioni = {} as any;
                for (let key in _data["sezioni"]) {
                    if (_data["sezioni"].hasOwnProperty(key))
                        (<any>this.sezioni)![key] = _data["sezioni"][key] ? CmsPageSection.fromJS(_data["sezioni"][key]) : new CmsPageSection();
                }
            }
            else {
                this.sezioni = <any>null;
            }
        }
    }

    static fromJS(data: any): CmsPage {
        data = typeof data === 'object' ? data : {};
        let result = new CmsPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        if (this.sezioni) {
            data["sezioni"] = {};
            for (let key in this.sezioni) {
                if (this.sezioni.hasOwnProperty(key))
                    (<any>data["sezioni"])[key] = this.sezioni[key] ? this.sezioni[key].toJSON() : <any>null;
            }
        }
        return data;
    }
}

export interface ICmsPage {
    id?: number;
    nome?: string | null;
    sezioni?: { [key in keyof typeof EPosizioneLink]?: CmsPageSection; } | null;
}

export class CmsPageSection implements ICmsPageSection {
    nome?: string | null;
    help?: string | null;
    links?: CmsPageLink[] | null;
    linkConsentiti?: ETipoLink[] | null;
    contenutiConsentiti?: ETipoEntita[] | null;

    constructor(data?: ICmsPageSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.help = _data["help"] !== undefined ? _data["help"] : <any>null;
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(CmsPageLink.fromJS(item));
            }
            else {
                this.links = <any>null;
            }
            if (Array.isArray(_data["linkConsentiti"])) {
                this.linkConsentiti = [] as any;
                for (let item of _data["linkConsentiti"])
                    this.linkConsentiti!.push(item);
            }
            else {
                this.linkConsentiti = <any>null;
            }
            if (Array.isArray(_data["contenutiConsentiti"])) {
                this.contenutiConsentiti = [] as any;
                for (let item of _data["contenutiConsentiti"])
                    this.contenutiConsentiti!.push(item);
            }
            else {
                this.contenutiConsentiti = <any>null;
            }
        }
    }

    static fromJS(data: any): CmsPageSection {
        data = typeof data === 'object' ? data : {};
        let result = new CmsPageSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["help"] = this.help !== undefined ? this.help : <any>null;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        if (Array.isArray(this.linkConsentiti)) {
            data["linkConsentiti"] = [];
            for (let item of this.linkConsentiti)
                data["linkConsentiti"].push(item);
        }
        if (Array.isArray(this.contenutiConsentiti)) {
            data["contenutiConsentiti"] = [];
            for (let item of this.contenutiConsentiti)
                data["contenutiConsentiti"].push(item);
        }
        return data;
    }
}

export interface ICmsPageSection {
    nome?: string | null;
    help?: string | null;
    links?: CmsPageLink[] | null;
    linkConsentiti?: ETipoLink[] | null;
    contenutiConsentiti?: ETipoEntita[] | null;
}

export class CmsPageLink implements ICmsPageLink {
    id?: number;
    nome?: string | null;
    ordine?: number;
    tipo?: ETipoLink;
    url?: string | null;
    icona?: string | null;
    link?: PageLink | null;
    contenuti?: CmsPageContent[] | null;

    constructor(data?: ICmsPageLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.icona = _data["icona"] !== undefined ? _data["icona"] : <any>null;
            this.link = _data["link"] ? PageLink.fromJS(_data["link"]) : <any>null;
            if (Array.isArray(_data["contenuti"])) {
                this.contenuti = [] as any;
                for (let item of _data["contenuti"])
                    this.contenuti!.push(CmsPageContent.fromJS(item));
            }
            else {
                this.contenuti = <any>null;
            }
        }
    }

    static fromJS(data: any): CmsPageLink {
        data = typeof data === 'object' ? data : {};
        let result = new CmsPageLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["icona"] = this.icona !== undefined ? this.icona : <any>null;
        data["link"] = this.link ? this.link.toJSON() : <any>null;
        if (Array.isArray(this.contenuti)) {
            data["contenuti"] = [];
            for (let item of this.contenuti)
                data["contenuti"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICmsPageLink {
    id?: number;
    nome?: string | null;
    ordine?: number;
    tipo?: ETipoLink;
    url?: string | null;
    icona?: string | null;
    link?: PageLink | null;
    contenuti?: CmsPageContent[] | null;
}

export class CmsPageContent implements ICmsPageContent {
    id?: number;
    contenuto?: PageLinkContent | null;
    title?: string | null;
    visibile?: boolean;
    missing?: boolean;

    constructor(data?: ICmsPageContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.contenuto = _data["contenuto"] ? PageLinkContent.fromJS(_data["contenuto"]) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.visibile = _data["visibile"] !== undefined ? _data["visibile"] : <any>null;
            this.missing = _data["missing"] !== undefined ? _data["missing"] : <any>null;
        }
    }

    static fromJS(data: any): CmsPageContent {
        data = typeof data === 'object' ? data : {};
        let result = new CmsPageContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["contenuto"] = this.contenuto ? this.contenuto.toJSON() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["visibile"] = this.visibile !== undefined ? this.visibile : <any>null;
        data["missing"] = this.missing !== undefined ? this.missing : <any>null;
        return data;
    }
}

export interface ICmsPageContent {
    id?: number;
    contenuto?: PageLinkContent | null;
    title?: string | null;
    visibile?: boolean;
    missing?: boolean;
}

export class PageContentResponse extends OkApiResponse implements IPageContentResponse {
    content?: PageLinkContent | null;

    constructor(data?: IPageContentResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] ? PageLinkContent.fromJS(_data["content"]) : <any>null;
        }
    }

    static fromJS(data: any): PageContentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PageContentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPageContentResponse extends IOkApiResponse {
    content?: PageLinkContent | null;
}

export class PageContentRequest extends LocalizedRequest implements IPageContentRequest {
    id?: number;

    constructor(data?: IPageContentRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): PageContentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PageContentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPageContentRequest extends ILocalizedRequest {
    id?: number;
}

export class NrTableResponseOfPageContentRow extends OkApiResponse implements INrTableResponseOfPageContentRow {
    /** Array delle righe della pagina richiesta */
    rows?: PageContentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPageContentRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PageContentRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfPageContentRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPageContentRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPageContentRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PageContentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class PageContentListResponse extends NrTableResponseOfPageContentRow implements IPageContentListResponse {

    constructor(data?: IPageContentListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PageContentListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PageContentListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPageContentListResponse extends INrTableResponseOfPageContentRow {
}

export class PageContentRow implements IPageContentRow {
    pageContentName?: string | null;
    pageContent?: PageLinkContent | null;

    constructor(data?: IPageContentRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageContentName = _data["pageContentName"] !== undefined ? _data["pageContentName"] : <any>null;
            this.pageContent = _data["pageContent"] ? PageLinkContent.fromJS(_data["pageContent"]) : <any>null;
        }
    }

    static fromJS(data: any): PageContentRow {
        data = typeof data === 'object' ? data : {};
        let result = new PageContentRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageContentName"] = this.pageContentName !== undefined ? this.pageContentName : <any>null;
        data["pageContent"] = this.pageContent ? this.pageContent.toJSON() : <any>null;
        return data;
    }
}

export interface IPageContentRow {
    pageContentName?: string | null;
    pageContent?: PageLinkContent | null;
}

export class PageContentListRequest extends NrTableRequest implements IPageContentListRequest {
    pagelinkId?: number;
    showDeleted?: boolean;

    constructor(data?: IPageContentListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pagelinkId = _data["pagelinkId"] !== undefined ? _data["pagelinkId"] : <any>null;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): PageContentListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PageContentListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagelinkId"] = this.pagelinkId !== undefined ? this.pagelinkId : <any>null;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPageContentListRequest extends INrTableRequest {
    pagelinkId?: number;
    showDeleted?: boolean;
}

export class PageLinkResponse extends OkApiResponse implements IPageLinkResponse {
    link?: PageLink | null;

    constructor(data?: IPageLinkResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.link = _data["link"] ? PageLink.fromJS(_data["link"]) : <any>null;
        }
    }

    static fromJS(data: any): PageLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link ? this.link.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPageLinkResponse extends IOkApiResponse {
    link?: PageLink | null;
}

export class PageLinkRequest extends LocalizedRequest implements IPageLinkRequest {
    id?: number;

    constructor(data?: IPageLinkRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): PageLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPageLinkRequest extends ILocalizedRequest {
    id?: number;
}

export class NrTableResponseOfPageLinkRow extends OkApiResponse implements INrTableResponseOfPageLinkRow {
    /** Array delle righe della pagina richiesta */
    rows?: PageLinkRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPageLinkRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PageLinkRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfPageLinkRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPageLinkRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPageLinkRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PageLinkRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class PageLinkListResponse extends NrTableResponseOfPageLinkRow implements IPageLinkListResponse {

    constructor(data?: IPageLinkListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PageLinkListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPageLinkListResponse extends INrTableResponseOfPageLinkRow {
}

export class PageLinkRow implements IPageLinkRow {
    pageLink?: PageLink | null;

    constructor(data?: IPageLinkRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageLink = _data["pageLink"] ? PageLink.fromJS(_data["pageLink"]) : <any>null;
        }
    }

    static fromJS(data: any): PageLinkRow {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageLink"] = this.pageLink ? this.pageLink.toJSON() : <any>null;
        return data;
    }
}

export interface IPageLinkRow {
    pageLink?: PageLink | null;
}

export class PageLinkListRequest extends NrTableRequest implements IPageLinkListRequest {
    operator?: EOperatore | null;
    position?: EPosizioneLink | null;
    type?: ETipoLink | null;
    name?: string | null;
    showDeleted?: boolean | null;

    constructor(data?: IPageLinkListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): PageLinkListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPageLinkListRequest extends INrTableRequest {
    operator?: EOperatore | null;
    position?: EPosizioneLink | null;
    type?: ETipoLink | null;
    name?: string | null;
    showDeleted?: boolean | null;
}

export class GetSiteBannersResponse extends OkApiResponse implements IGetSiteBannersResponse {
    banners?: Banner[] | null;

    constructor(data?: IGetSiteBannersResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["banners"])) {
                this.banners = [] as any;
                for (let item of _data["banners"])
                    this.banners!.push(Banner.fromJS(item));
            }
            else {
                this.banners = <any>null;
            }
        }
    }

    static fromJS(data: any): GetSiteBannersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteBannersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetSiteBannersResponse extends IOkApiResponse {
    banners?: Banner[] | null;
}

export class Banner implements IBanner {
    id?: number;
    imgUrl?: string | null;
    title?: string | null;
    sunto?: string | null;
    destCode?: string | null;
    offViaggio?: boolean;
    destination?: Destination | null;
    bannerType?: EBannerType;
    ordine?: number;
    attachment?: string | null;
    attachmentId?: number;
    attachmentFileType?: string | null;

    constructor(data?: IBanner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.imgUrl = _data["imgUrl"] !== undefined ? _data["imgUrl"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : <any>null;
            this.destCode = _data["destCode"] !== undefined ? _data["destCode"] : <any>null;
            this.offViaggio = _data["offViaggio"] !== undefined ? _data["offViaggio"] : <any>null;
            this.destination = _data["destination"] ? Destination.fromJS(_data["destination"]) : <any>null;
            this.bannerType = _data["bannerType"] !== undefined ? _data["bannerType"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.attachment = _data["attachment"] !== undefined ? _data["attachment"] : <any>null;
            this.attachmentId = _data["attachmentId"] !== undefined ? _data["attachmentId"] : <any>null;
            this.attachmentFileType = _data["attachmentFileType"] !== undefined ? _data["attachmentFileType"] : <any>null;
        }
    }

    static fromJS(data: any): Banner {
        data = typeof data === 'object' ? data : {};
        let result = new Banner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["imgUrl"] = this.imgUrl !== undefined ? this.imgUrl : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["sunto"] = this.sunto !== undefined ? this.sunto : <any>null;
        data["destCode"] = this.destCode !== undefined ? this.destCode : <any>null;
        data["offViaggio"] = this.offViaggio !== undefined ? this.offViaggio : <any>null;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>null;
        data["bannerType"] = this.bannerType !== undefined ? this.bannerType : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["attachment"] = this.attachment !== undefined ? this.attachment : <any>null;
        data["attachmentId"] = this.attachmentId !== undefined ? this.attachmentId : <any>null;
        data["attachmentFileType"] = this.attachmentFileType !== undefined ? this.attachmentFileType : <any>null;
        return data;
    }
}

export interface IBanner {
    id?: number;
    imgUrl?: string | null;
    title?: string | null;
    sunto?: string | null;
    destCode?: string | null;
    offViaggio?: boolean;
    destination?: Destination | null;
    bannerType?: EBannerType;
    ordine?: number;
    attachment?: string | null;
    attachmentId?: number;
    attachmentFileType?: string | null;
}

export enum EBannerType {
    Offerta = "offerta",
    Banner = "banner",
}

export class GetSiteBannersRequest extends SiteRequest implements IGetSiteBannersRequest {
    addCoBranded?: boolean;

    constructor(data?: IGetSiteBannersRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.addCoBranded = _data["addCoBranded"] !== undefined ? _data["addCoBranded"] : <any>null;
        }
    }

    static fromJS(data: any): GetSiteBannersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteBannersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addCoBranded"] = this.addCoBranded !== undefined ? this.addCoBranded : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSiteBannersRequest extends ISiteRequest {
    addCoBranded?: boolean;
}

export class GetSiteBannerSXResponse extends OkApiResponse implements IGetSiteBannerSXResponse {
    bannerSX?: BannerSX[] | null;

    constructor(data?: IGetSiteBannerSXResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["bannerSX"])) {
                this.bannerSX = [] as any;
                for (let item of _data["bannerSX"])
                    this.bannerSX!.push(BannerSX.fromJS(item));
            }
            else {
                this.bannerSX = <any>null;
            }
        }
    }

    static fromJS(data: any): GetSiteBannerSXResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteBannerSXResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bannerSX)) {
            data["bannerSX"] = [];
            for (let item of this.bannerSX)
                data["bannerSX"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetSiteBannerSXResponse extends IOkApiResponse {
    bannerSX?: BannerSX[] | null;
}

export class BannerSX implements IBannerSX {
    id?: number;
    title?: string | null;
    content?: string | null;
    grp?: number;

    constructor(data?: IBannerSX) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.grp = _data["grp"] !== undefined ? _data["grp"] : <any>null;
        }
    }

    static fromJS(data: any): BannerSX {
        data = typeof data === 'object' ? data : {};
        let result = new BannerSX();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["grp"] = this.grp !== undefined ? this.grp : <any>null;
        return data;
    }
}

export interface IBannerSX {
    id?: number;
    title?: string | null;
    content?: string | null;
    grp?: number;
}

export class GetSiteBannerSXRequest extends SiteRequest implements IGetSiteBannerSXRequest {

    constructor(data?: IGetSiteBannerSXRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetSiteBannerSXRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteBannerSXRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetSiteBannerSXRequest extends ISiteRequest {
}

export class GetSiteNewsResponse extends OkApiResponse implements IGetSiteNewsResponse {
    news?: NewsArticle[] | null;

    constructor(data?: IGetSiteNewsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["news"])) {
                this.news = [] as any;
                for (let item of _data["news"])
                    this.news!.push(NewsArticle.fromJS(item));
            }
            else {
                this.news = <any>null;
            }
        }
    }

    static fromJS(data: any): GetSiteNewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteNewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.news)) {
            data["news"] = [];
            for (let item of this.news)
                data["news"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetSiteNewsResponse extends IOkApiResponse {
    news?: NewsArticle[] | null;
}

export class NewsArticle implements INewsArticle {
    id?: number;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    testoShort?: string | null;
    tipoNews?: ENewsType;
    updated?: string | null;
    allegati?: ArticoloAllegato[] | null;

    constructor(data?: INewsArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.testoShort = _data["testoShort"] !== undefined ? _data["testoShort"] : <any>null;
            this.tipoNews = _data["tipoNews"] !== undefined ? _data["tipoNews"] : <any>null;
            this.updated = _data["updated"] !== undefined ? _data["updated"] : <any>null;
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(ArticoloAllegato.fromJS(item));
            }
            else {
                this.allegati = <any>null;
            }
        }
    }

    static fromJS(data: any): NewsArticle {
        data = typeof data === 'object' ? data : {};
        let result = new NewsArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["sunto"] = this.sunto !== undefined ? this.sunto : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["testoShort"] = this.testoShort !== undefined ? this.testoShort : <any>null;
        data["tipoNews"] = this.tipoNews !== undefined ? this.tipoNews : <any>null;
        data["updated"] = this.updated !== undefined ? this.updated : <any>null;
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewsArticle {
    id?: number;
    titolo?: string | null;
    sunto?: string | null;
    testo?: string | null;
    testoShort?: string | null;
    tipoNews?: ENewsType;
    updated?: string | null;
    allegati?: ArticoloAllegato[] | null;
}

export enum ENewsType {
    Approfondimenti = "approfondimenti",
    UltimeNotizie = "ultimeNotizie",
    InPrimoPiano = "inPrimoPiano",
}

export class GetSiteNewsRequest extends SiteRequest implements IGetSiteNewsRequest {

    constructor(data?: IGetSiteNewsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetSiteNewsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteNewsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetSiteNewsRequest extends ISiteRequest {
}

export class ContentEditRequest extends ApiRequest implements IContentEditRequest {
    content?: PageLinkContent | null;

    constructor(data?: IContentEditRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] ? PageLinkContent.fromJS(_data["content"]) : <any>null;
        }
    }

    static fromJS(data: any): ContentEditRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContentEditRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IContentEditRequest extends IApiRequest {
    content?: PageLinkContent | null;
}

export class SetLinkContentsOrderRequest extends LocalizedRequest implements ISetLinkContentsOrderRequest {
    linkID?: number;
    sortedIds?: number[] | null;

    constructor(data?: ISetLinkContentsOrderRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkID = _data["linkID"] !== undefined ? _data["linkID"] : <any>null;
            if (Array.isArray(_data["sortedIds"])) {
                this.sortedIds = [] as any;
                for (let item of _data["sortedIds"])
                    this.sortedIds!.push(item);
            }
            else {
                this.sortedIds = <any>null;
            }
        }
    }

    static fromJS(data: any): SetLinkContentsOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetLinkContentsOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkID"] = this.linkID !== undefined ? this.linkID : <any>null;
        if (Array.isArray(this.sortedIds)) {
            data["sortedIds"] = [];
            for (let item of this.sortedIds)
                data["sortedIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetLinkContentsOrderRequest extends ILocalizedRequest {
    linkID?: number;
    sortedIds?: number[] | null;
}

export class SetLinksOrderRequest extends ApiRequest implements ISetLinksOrderRequest {
    sortedIds?: number[] | null;

    constructor(data?: ISetLinksOrderRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortedIds"])) {
                this.sortedIds = [] as any;
                for (let item of _data["sortedIds"])
                    this.sortedIds!.push(item);
            }
            else {
                this.sortedIds = <any>null;
            }
        }
    }

    static fromJS(data: any): SetLinksOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetLinksOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortedIds)) {
            data["sortedIds"] = [];
            for (let item of this.sortedIds)
                data["sortedIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetLinksOrderRequest extends IApiRequest {
    sortedIds?: number[] | null;
}

export class ContactsGetAgencyGroupsResponse extends OkApiResponse implements IContactsGetAgencyGroupsResponse {
    agencyGroups?: AgencyGroup[];

    constructor(data?: IContactsGetAgencyGroupsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["agencyGroups"])) {
                this.agencyGroups = [] as any;
                for (let item of _data["agencyGroups"])
                    this.agencyGroups!.push(AgencyGroup.fromJS(item));
            }
            else {
                this.agencyGroups = <any>null;
            }
        }
    }

    static fromJS(data: any): ContactsGetAgencyGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsGetAgencyGroupsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agencyGroups)) {
            data["agencyGroups"] = [];
            for (let item of this.agencyGroups)
                data["agencyGroups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IContactsGetAgencyGroupsResponse extends IOkApiResponse {
    agencyGroups?: AgencyGroup[];
}

export class AgencyGroup implements IAgencyGroup {
    id?: number;
    name?: string;

    constructor(data?: IAgencyGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): AgencyGroup {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IAgencyGroup {
    id?: number;
    name?: string;
}

export class ContactsGetAgencyGroupsRequest extends ApiRequest implements IContactsGetAgencyGroupsRequest {

    constructor(data?: IContactsGetAgencyGroupsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ContactsGetAgencyGroupsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsGetAgencyGroupsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IContactsGetAgencyGroupsRequest extends IApiRequest {
}

export class GetContattoResponse extends OkApiResponse implements IGetContattoResponse {
    contatto?: ContactListRow;
    mappa?: Mappa;
    logo?: LogoInfo;

    constructor(data?: IGetContattoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contatto = _data["contatto"] ? ContactListRow.fromJS(_data["contatto"]) : <any>null;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : <any>null;
            this.logo = _data["logo"] ? LogoInfo.fromJS(_data["logo"]) : <any>null;
        }
    }

    static fromJS(data: any): GetContattoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContattoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contatto"] = this.contatto ? this.contatto.toJSON() : <any>null;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : <any>null;
        data["logo"] = this.logo ? this.logo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetContattoResponse extends IOkApiResponse {
    contatto?: ContactListRow;
    mappa?: Mappa;
    logo?: LogoInfo;
}

/** Classe che rappresenta una singola riga dell'elenco contatti */
export class ContactListRow implements IContactListRow {
    /** ID del contatto */
    id?: number;
    /** Nome proprio per le persone oppure nome colloquiale per agenzie e società */
    nome?: string | null;
    /** Cognome per le persone fisiche oppure ragione sociale per agenzie e società */
    cognome?: string | null;
    /** Nome del luogo associato al contatto */
    luogo?: string | null;
    /** True se il luogo associato è stato eliminato */
    luogoEliminato?: boolean;
    /** Nome del luogo associato al contatto */
    luogoID?: number | null;
    /** Nome della regione del luogo associato al contatto */
    regione?: string | null;
    /** Nome del paese del luogo associato al contatto */
    paese?: string | null;
    /** CAP dell'indirizzo del contatto  */
    cap?: string | null;
    /** Indirizzo del contatto, incluso il numero civico */
    indirizzo?: string | null;
    /** Numero di telefono del contatto */
    telefono?: string | null;
    /** Partita IVA del contatto */
    partitaIVA?: string | null;
    /** Indirizzo email del contatto */
    email?: string | null;
    /** Nome visualizzato del contatto promotore */
    promotore?: string | null;
    /** Nome della categoria per le agenzie */
    categoria?: string | null;
    /** Nome visualizzato del contatto network per le agenzie */
    network?: string | null;
    /** Nome dell'accordo */
    accordoCommerciale?: string | null;
    /** Nome del metodo di pagamento dei servizi a terra */
    pagamentoServiziTerra?: string | null;
    /** Nome del metodo di pagamento dei servizi volo (biglietteria) */
    pagamentoServiziVolo?: string | null;
    /** True se i dati di un contatto hotel sono completi */
    datiHotelOk?: boolean;
    /** True se il contatto hotel ha la mappa */
    mappaOk?: boolean;
    /** True se il contatto hotel ha almeno un servizio associato */
    haServizi?: boolean;
    lingua?: number | null;
    contatto?: Contatto;

    constructor(data?: IContactListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.luogoEliminato = _data["luogoEliminato"] !== undefined ? _data["luogoEliminato"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.promotore = _data["promotore"] !== undefined ? _data["promotore"] : <any>null;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : <any>null;
            this.network = _data["network"] !== undefined ? _data["network"] : <any>null;
            this.accordoCommerciale = _data["accordoCommerciale"] !== undefined ? _data["accordoCommerciale"] : <any>null;
            this.pagamentoServiziTerra = _data["pagamentoServiziTerra"] !== undefined ? _data["pagamentoServiziTerra"] : <any>null;
            this.pagamentoServiziVolo = _data["pagamentoServiziVolo"] !== undefined ? _data["pagamentoServiziVolo"] : <any>null;
            this.datiHotelOk = _data["datiHotelOk"] !== undefined ? _data["datiHotelOk"] : <any>null;
            this.mappaOk = _data["mappaOk"] !== undefined ? _data["mappaOk"] : <any>null;
            this.haServizi = _data["haServizi"] !== undefined ? _data["haServizi"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.contatto = _data["contatto"] ? Contatto.fromJS(_data["contatto"]) : <any>null;
        }
    }

    static fromJS(data: any): ContactListRow {
        data = typeof data === 'object' ? data : {};
        let result = new ContactListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["luogoEliminato"] = this.luogoEliminato !== undefined ? this.luogoEliminato : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["regione"] = this.regione !== undefined ? this.regione : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["promotore"] = this.promotore !== undefined ? this.promotore : <any>null;
        data["categoria"] = this.categoria !== undefined ? this.categoria : <any>null;
        data["network"] = this.network !== undefined ? this.network : <any>null;
        data["accordoCommerciale"] = this.accordoCommerciale !== undefined ? this.accordoCommerciale : <any>null;
        data["pagamentoServiziTerra"] = this.pagamentoServiziTerra !== undefined ? this.pagamentoServiziTerra : <any>null;
        data["pagamentoServiziVolo"] = this.pagamentoServiziVolo !== undefined ? this.pagamentoServiziVolo : <any>null;
        data["datiHotelOk"] = this.datiHotelOk !== undefined ? this.datiHotelOk : <any>null;
        data["mappaOk"] = this.mappaOk !== undefined ? this.mappaOk : <any>null;
        data["haServizi"] = this.haServizi !== undefined ? this.haServizi : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["contatto"] = this.contatto ? this.contatto.toJSON() : <any>null;
        return data;
    }
}

/** Classe che rappresenta una singola riga dell'elenco contatti */
export interface IContactListRow {
    /** ID del contatto */
    id?: number;
    /** Nome proprio per le persone oppure nome colloquiale per agenzie e società */
    nome?: string | null;
    /** Cognome per le persone fisiche oppure ragione sociale per agenzie e società */
    cognome?: string | null;
    /** Nome del luogo associato al contatto */
    luogo?: string | null;
    /** True se il luogo associato è stato eliminato */
    luogoEliminato?: boolean;
    /** Nome del luogo associato al contatto */
    luogoID?: number | null;
    /** Nome della regione del luogo associato al contatto */
    regione?: string | null;
    /** Nome del paese del luogo associato al contatto */
    paese?: string | null;
    /** CAP dell'indirizzo del contatto  */
    cap?: string | null;
    /** Indirizzo del contatto, incluso il numero civico */
    indirizzo?: string | null;
    /** Numero di telefono del contatto */
    telefono?: string | null;
    /** Partita IVA del contatto */
    partitaIVA?: string | null;
    /** Indirizzo email del contatto */
    email?: string | null;
    /** Nome visualizzato del contatto promotore */
    promotore?: string | null;
    /** Nome della categoria per le agenzie */
    categoria?: string | null;
    /** Nome visualizzato del contatto network per le agenzie */
    network?: string | null;
    /** Nome dell'accordo */
    accordoCommerciale?: string | null;
    /** Nome del metodo di pagamento dei servizi a terra */
    pagamentoServiziTerra?: string | null;
    /** Nome del metodo di pagamento dei servizi volo (biglietteria) */
    pagamentoServiziVolo?: string | null;
    /** True se i dati di un contatto hotel sono completi */
    datiHotelOk?: boolean;
    /** True se il contatto hotel ha la mappa */
    mappaOk?: boolean;
    /** True se il contatto hotel ha almeno un servizio associato */
    haServizi?: boolean;
    lingua?: number | null;
    contatto?: Contatto;
}

export class Mappa implements IMappa {
    mappaID?: number;
    tabella!: string;
    entitaID?: number;
    latitudine?: number | null;
    longitudine?: number | null;
    provider?: number | null;
    zoom?: number | null;
    layout?: number | null;

    constructor(data?: IMappa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mappaID = _data["mappaID"] !== undefined ? _data["mappaID"] : <any>null;
            this.tabella = _data["tabella"] !== undefined ? _data["tabella"] : <any>null;
            this.entitaID = _data["entitaID"] !== undefined ? _data["entitaID"] : <any>null;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : <any>null;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : <any>null;
            this.provider = _data["provider"] !== undefined ? _data["provider"] : <any>null;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : <any>null;
            this.layout = _data["layout"] !== undefined ? _data["layout"] : <any>null;
        }
    }

    static fromJS(data: any): Mappa {
        data = typeof data === 'object' ? data : {};
        let result = new Mappa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappaID"] = this.mappaID !== undefined ? this.mappaID : <any>null;
        data["tabella"] = this.tabella !== undefined ? this.tabella : <any>null;
        data["entitaID"] = this.entitaID !== undefined ? this.entitaID : <any>null;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : <any>null;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : <any>null;
        data["provider"] = this.provider !== undefined ? this.provider : <any>null;
        data["zoom"] = this.zoom !== undefined ? this.zoom : <any>null;
        data["layout"] = this.layout !== undefined ? this.layout : <any>null;
        return data;
    }
}

export interface IMappa {
    mappaID?: number;
    tabella: string;
    entitaID?: number;
    latitudine?: number | null;
    longitudine?: number | null;
    provider?: number | null;
    zoom?: number | null;
    layout?: number | null;
}

export class LogoInfo implements ILogoInfo {
    id?: number;
    logo?: ContattoLogo;
    exists?: boolean;
    filePath?: string | null;
    url?: string | null;
    base64?: string;

    constructor(data?: ILogoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.logo = _data["logo"] ? ContattoLogo.fromJS(_data["logo"]) : <any>null;
            this.exists = _data["exists"] !== undefined ? _data["exists"] : <any>null;
            this.filePath = _data["filePath"] !== undefined ? _data["filePath"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.base64 = _data["base64"] !== undefined ? _data["base64"] : <any>null;
        }
    }

    static fromJS(data: any): LogoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LogoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["logo"] = this.logo ? this.logo.toJSON() : <any>null;
        data["exists"] = this.exists !== undefined ? this.exists : <any>null;
        data["filePath"] = this.filePath !== undefined ? this.filePath : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["base64"] = this.base64 !== undefined ? this.base64 : <any>null;
        return data;
    }
}

export interface ILogoInfo {
    id?: number;
    logo?: ContattoLogo;
    exists?: boolean;
    filePath?: string | null;
    url?: string | null;
    base64?: string;
}

export class ContattoLogo implements IContattoLogo {
    contattoLogoID?: number;
    contattoID?: number;
    stampaSuOfferta?: boolean;
    stampaSuPreventivo?: boolean;
    stampaSuProgramma?: boolean;
    stampaSuConferma?: boolean | null;
    caricato?: string;
    nome?: string | null;
    nomeOriginale?: string | null;

    constructor(data?: IContattoLogo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoLogoID = _data["contattoLogoID"] !== undefined ? _data["contattoLogoID"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.stampaSuOfferta = _data["stampaSuOfferta"] !== undefined ? _data["stampaSuOfferta"] : <any>null;
            this.stampaSuPreventivo = _data["stampaSuPreventivo"] !== undefined ? _data["stampaSuPreventivo"] : <any>null;
            this.stampaSuProgramma = _data["stampaSuProgramma"] !== undefined ? _data["stampaSuProgramma"] : <any>null;
            this.stampaSuConferma = _data["stampaSuConferma"] !== undefined ? _data["stampaSuConferma"] : <any>null;
            this.caricato = _data["caricato"] !== undefined ? _data["caricato"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeOriginale = _data["nomeOriginale"] !== undefined ? _data["nomeOriginale"] : <any>null;
        }
    }

    static fromJS(data: any): ContattoLogo {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoLogo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoLogoID"] = this.contattoLogoID !== undefined ? this.contattoLogoID : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["stampaSuOfferta"] = this.stampaSuOfferta !== undefined ? this.stampaSuOfferta : <any>null;
        data["stampaSuPreventivo"] = this.stampaSuPreventivo !== undefined ? this.stampaSuPreventivo : <any>null;
        data["stampaSuProgramma"] = this.stampaSuProgramma !== undefined ? this.stampaSuProgramma : <any>null;
        data["stampaSuConferma"] = this.stampaSuConferma !== undefined ? this.stampaSuConferma : <any>null;
        data["caricato"] = this.caricato !== undefined ? this.caricato : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeOriginale"] = this.nomeOriginale !== undefined ? this.nomeOriginale : <any>null;
        return data;
    }
}

export interface IContattoLogo {
    contattoLogoID?: number;
    contattoID?: number;
    stampaSuOfferta?: boolean;
    stampaSuPreventivo?: boolean;
    stampaSuProgramma?: boolean;
    stampaSuConferma?: boolean | null;
    caricato?: string;
    nome?: string | null;
    nomeOriginale?: string | null;
}

export class UpsertContattoRequest extends LocalizedRequest implements IUpsertContattoRequest {
    contatto?: Contatto | null;
    logo?: LogoUpsert | null;

    constructor(data?: IUpsertContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contatto = _data["contatto"] ? Contatto.fromJS(_data["contatto"]) : <any>null;
            this.logo = _data["logo"] ? LogoUpsert.fromJS(_data["logo"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contatto"] = this.contatto ? this.contatto.toJSON() : <any>null;
        data["logo"] = this.logo ? this.logo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertContattoRequest extends ILocalizedRequest {
    contatto?: Contatto | null;
    logo?: LogoUpsert | null;
}

export class LogoUpsert implements ILogoUpsert {
    logoDataBase64?: string | null;
    contentType?: string | null;
    fileName?: string | null;

    constructor(data?: ILogoUpsert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoDataBase64 = _data["logoDataBase64"] !== undefined ? _data["logoDataBase64"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): LogoUpsert {
        data = typeof data === 'object' ? data : {};
        let result = new LogoUpsert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoDataBase64"] = this.logoDataBase64 !== undefined ? this.logoDataBase64 : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data;
    }
}

export interface ILogoUpsert {
    logoDataBase64?: string | null;
    contentType?: string | null;
    fileName?: string | null;
}

export class CreateUtenteAgenziaResponse extends OkApiResponse implements ICreateUtenteAgenziaResponse {
    /** Entità creata */
    utente?: UtenteRow;

    constructor(data?: ICreateUtenteAgenziaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.utente = _data["utente"] ? UtenteRow.fromJS(_data["utente"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateUtenteAgenziaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUtenteAgenziaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utente"] = this.utente ? this.utente.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateUtenteAgenziaResponse extends IOkApiResponse {
    /** Entità creata */
    utente?: UtenteRow;
}

export class UtenteRow implements IUtenteRow {
    id?: number;
    nome?: string;
    email?: string | null;
    tipoUtente?: ETipoUtente;
    otherInfo?: Utente | null;
    isSecondaryUser?: boolean;

    constructor(data?: IUtenteRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.tipoUtente = _data["tipoUtente"] !== undefined ? _data["tipoUtente"] : <any>null;
            this.otherInfo = _data["otherInfo"] ? Utente.fromJS(_data["otherInfo"]) : <any>null;
            this.isSecondaryUser = _data["isSecondaryUser"] !== undefined ? _data["isSecondaryUser"] : <any>null;
        }
    }

    static fromJS(data: any): UtenteRow {
        data = typeof data === 'object' ? data : {};
        let result = new UtenteRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["tipoUtente"] = this.tipoUtente !== undefined ? this.tipoUtente : <any>null;
        data["otherInfo"] = this.otherInfo ? this.otherInfo.toJSON() : <any>null;
        data["isSecondaryUser"] = this.isSecondaryUser !== undefined ? this.isSecondaryUser : <any>null;
        return data;
    }
}

export interface IUtenteRow {
    id?: number;
    nome?: string;
    email?: string | null;
    tipoUtente?: ETipoUtente;
    otherInfo?: Utente | null;
    isSecondaryUser?: boolean;
}

export class CreateUtenteAgenziaRequest extends SiteRequest implements ICreateUtenteAgenziaRequest {
    /** Indirizzo email dell'utente */
    email!: string;
    /** Nome proprio */
    nome!: string;
    /** Cognome, facoltativo */
    cognome?: string | null;
    /** Numero di telefono dell'utente, facoltativo */
    telefono?: string | null;

    constructor(data?: ICreateUtenteAgenziaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
        }
    }

    static fromJS(data: any): CreateUtenteAgenziaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUtenteAgenziaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateUtenteAgenziaRequest extends ISiteRequest {
    /** Indirizzo email dell'utente */
    email: string;
    /** Nome proprio */
    nome: string;
    /** Cognome, facoltativo */
    cognome?: string | null;
    /** Numero di telefono dell'utente, facoltativo */
    telefono?: string | null;
}

export class DeleteContattoRequest extends LocalizedRequest implements IDeleteContattoRequest {
    contattoId?: number;

    constructor(data?: IDeleteContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class DeleteAccordoContattoRequest extends LocalizedRequest implements IDeleteAccordoContattoRequest {
    contattoID?: number;
    accordoContattoID?: number;

    constructor(data?: IDeleteAccordoContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.accordoContattoID = _data["accordoContattoID"] !== undefined ? _data["accordoContattoID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteAccordoContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAccordoContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["accordoContattoID"] = this.accordoContattoID !== undefined ? this.accordoContattoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IDeleteAccordoContattoRequest extends ILocalizedRequest {
    contattoID?: number;
    accordoContattoID?: number;
}

export class DeleteMappaContattoRequest extends LocalizedRequest implements IDeleteMappaContattoRequest {
    contattoId?: number;

    constructor(data?: IDeleteMappaContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteMappaContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMappaContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMappaContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetContattoRequest extends LocalizedRequest implements IGetContattoRequest {
    contattoId?: number;

    constructor(data?: IGetContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
        }
    }

    static fromJS(data: any): GetContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetAccordiAggiuntiviResoponse extends OkApiResponse implements IGetAccordiAggiuntiviResoponse {
    rows?: AccordoAggiuntivoRow[] | null;

    constructor(data?: IGetAccordiAggiuntiviResoponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AccordoAggiuntivoRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAccordiAggiuntiviResoponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccordiAggiuntiviResoponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAccordiAggiuntiviResoponse extends IOkApiResponse {
    rows?: AccordoAggiuntivoRow[] | null;
}

export class AccordoAggiuntivoRow implements IAccordoAggiuntivoRow {
    id?: number;
    accordoID?: number;
    nome?: string | null;
    dal?: string | null;
    al?: string | null;
    operatore?: EOperatore;
    accordoContatto?: AccordoContatto | null;

    constructor(data?: IAccordoAggiuntivoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : <any>null;
        }
    }

    static fromJS(data: any): AccordoAggiuntivoRow {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoAggiuntivoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : <any>null;
        return data;
    }
}

export interface IAccordoAggiuntivoRow {
    id?: number;
    accordoID?: number;
    nome?: string | null;
    dal?: string | null;
    al?: string | null;
    operatore?: EOperatore;
    accordoContatto?: AccordoContatto | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetAccordiAggiuntiviRequest extends LocalizedRequest implements IGetAccordiAggiuntiviRequest {
    contattoId?: number;

    constructor(data?: IGetAccordiAggiuntiviRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
        }
    }

    static fromJS(data: any): GetAccordiAggiuntiviRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccordiAggiuntiviRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetAccordiAggiuntiviRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetAccordiDirettiResponse extends OkApiResponse implements IGetAccordiDirettiResponse {
    rows?: AccordoDirettoRow[] | null;

    constructor(data?: IGetAccordiDirettiResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AccordoDirettoRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAccordiDirettiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccordiDirettiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAccordiDirettiResponse extends IOkApiResponse {
    rows?: AccordoDirettoRow[] | null;
}

export class AccordoDirettoRow implements IAccordoDirettoRow {
    id?: number;
    nome?: string | null;
    dal?: string | null;
    al?: string | null;

    constructor(data?: IAccordoDirettoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
        }
    }

    static fromJS(data: any): AccordoDirettoRow {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoDirettoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        return data;
    }
}

export interface IAccordoDirettoRow {
    id?: number;
    nome?: string | null;
    dal?: string | null;
    al?: string | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetAccordiDirettiRequest extends LocalizedRequest implements IGetAccordiDirettiRequest {
    contattoId?: number;

    constructor(data?: IGetAccordiDirettiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
        }
    }

    static fromJS(data: any): GetAccordiDirettiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccordiDirettiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetAccordiDirettiRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetCategorieContattoResoponse extends OkApiResponse implements IGetCategorieContattoResoponse {
    rows?: CategoriaContatto[] | null;

    constructor(data?: IGetCategorieContattoResoponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CategoriaContatto.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): GetCategorieContattoResoponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategorieContattoResoponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCategorieContattoResoponse extends IOkApiResponse {
    rows?: CategoriaContatto[] | null;
}

export class CategoriaContatto implements ICategoriaContatto {
    categoriaContattoID?: number;
    memo?: string | null;
    nome?: string | null;
    operatore?: EOperatore | null;

    constructor(data?: ICategoriaContatto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoriaContattoID = _data["categoriaContattoID"] !== undefined ? _data["categoriaContattoID"] : <any>null;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
        }
    }

    static fromJS(data: any): CategoriaContatto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoriaContatto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoriaContattoID"] = this.categoriaContattoID !== undefined ? this.categoriaContattoID : <any>null;
        data["memo"] = this.memo !== undefined ? this.memo : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        return data;
    }
}

export interface ICategoriaContatto {
    categoriaContattoID?: number;
    memo?: string | null;
    nome?: string | null;
    operatore?: EOperatore | null;
}

export class GetDatiAggiuntiviContattoResponse extends OkApiResponse implements IGetDatiAggiuntiviContattoResponse {
    rows?: ContattoDato[] | null;

    constructor(data?: IGetDatiAggiuntiviContattoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContattoDato.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDatiAggiuntiviContattoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatiAggiuntiviContattoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDatiAggiuntiviContattoResponse extends IOkApiResponse {
    rows?: ContattoDato[] | null;
}

export class ContattoDato implements IContattoDato {
    contattoDatoID?: number;
    contattoID?: number;
    tipoDatoID?: number;
    tipoDato?: ETipoDatoContatto;
    testo?: string | null;

    constructor(data?: IContattoDato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoDatoID = _data["contattoDatoID"] !== undefined ? _data["contattoDatoID"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.tipoDatoID = _data["tipoDatoID"] !== undefined ? _data["tipoDatoID"] : <any>null;
            this.tipoDato = _data["tipoDato"] !== undefined ? _data["tipoDato"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
        }
    }

    static fromJS(data: any): ContattoDato {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoDato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoDatoID"] = this.contattoDatoID !== undefined ? this.contattoDatoID : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["tipoDatoID"] = this.tipoDatoID !== undefined ? this.tipoDatoID : <any>null;
        data["tipoDato"] = this.tipoDato !== undefined ? this.tipoDato : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        return data;
    }
}

export interface IContattoDato {
    contattoDatoID?: number;
    contattoID?: number;
    tipoDatoID?: number;
    tipoDato?: ETipoDatoContatto;
    testo?: string | null;
}

export enum ETipoDatoContatto {
    NonDefinito = "NonDefinito",
    PosizioneAgenzia = "PosizioneAgenzia",
    Responsabile = "Responsabile",
    Regione = "Regione",
    PartitaIVA = "PartitaIVA",
    CodiceFiscale = "CodiceFiscale",
    CodiceAdHoc = "CodiceAdHoc",
    NoteOfferta = "NoteOfferta",
    ProvinciaAgenzie = "ProvinciaAgenzie",
    CodAviomar = "CodAviomar",
    CodiceIATA = "CodiceIATA",
    PCC = "PCC",
    PasswordTicketStats = "PasswordTicketStats",
    NotaCommercialeAgenzia = "NotaCommercialeAgenzia",
    Sesso = "Sesso",
    Provincia = "Provincia",
    Citta = "Citta",
    AccessoBetaTest = "AccessoBetaTest",
    SsoToken = "SsoToken",
    ContrattoAgenzia = "ContrattoAgenzia",
    CodicePrioritaTelefonica = "CodicePrioritaTelefonica",
    CodiceUnivocoAgenziaFE = "CodiceUnivocoAgenziaFE",
    IndirizzoPecAgenziaFE = "IndirizzoPecAgenziaFE",
    IndirizzoPEC = "IndirizzoPEC",
    FEsenzaPECneCodice = "FEsenzaPECneCodice",
    SitoWeb = "SitoWeb",
    UrlLogo = "UrlLogo",
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetDatiAggiuntiviContattoRequest extends LocalizedRequest implements IGetDatiAggiuntiviContattoRequest {
    contattoId?: number;

    constructor(data?: IGetDatiAggiuntiviContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
        }
    }

    static fromJS(data: any): GetDatiAggiuntiviContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatiAggiuntiviContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetDatiAggiuntiviContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetMansioniResoponse extends OkApiResponse implements IGetMansioniResoponse {
    rows?: Mansione[] | null;

    constructor(data?: IGetMansioniResoponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Mansione.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): GetMansioniResoponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMansioniResoponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetMansioniResoponse extends IOkApiResponse {
    rows?: Mansione[] | null;
}

export class Mansione implements IMansione {
    id?: number;
    nome!: string;
    descrizione?: string | null;

    constructor(data?: IMansione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
        }
    }

    static fromJS(data: any): Mansione {
        data = typeof data === 'object' ? data : {};
        let result = new Mansione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        return data;
    }
}

export interface IMansione {
    id?: number;
    nome: string;
    descrizione?: string | null;
}

export class GetProfileResponse extends OkApiResponse implements IGetProfileResponse {
    /** Dati generici */
    profileData?: ProfileData;
    /** Dati del logo */
    logoData?: LogoData | null;
    /** Dati di fatturazione */
    invoiceData?: ProfileInvoiceData;

    constructor(data?: IGetProfileResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.profileData = _data["profileData"] ? ProfileData.fromJS(_data["profileData"]) : <any>null;
            this.logoData = _data["logoData"] ? LogoData.fromJS(_data["logoData"]) : <any>null;
            this.invoiceData = _data["invoiceData"] ? ProfileInvoiceData.fromJS(_data["invoiceData"]) : <any>null;
        }
    }

    static fromJS(data: any): GetProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileData"] = this.profileData ? this.profileData.toJSON() : <any>null;
        data["logoData"] = this.logoData ? this.logoData.toJSON() : <any>null;
        data["invoiceData"] = this.invoiceData ? this.invoiceData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetProfileResponse extends IOkApiResponse {
    /** Dati generici */
    profileData?: ProfileData;
    /** Dati del logo */
    logoData?: LogoData | null;
    /** Dati di fatturazione */
    invoiceData?: ProfileInvoiceData;
}

/** Dati generici di profilo di un'agenzia */
export class ProfileData implements IProfileData {
    /** Nome colloquiale dell'agenzia */
    nome?: string | null;
    /** Indirizzo generico, senza il civico */
    indirizzo?: string | null;
    /** Codice avviamento postale o assimilabile */
    cap?: string | null;
    /** Numero civico */
    civico?: string | null;
    /** ID del luogo */
    luogoID?: number | null;
    /** Città, prelevata dal luogo */
    citta?: string | null;
    /** Indirizzo email generico */
    email?: string | null;
    /** Numero di telefono */
    telefono?: string | null;
    /** Numero di fax. Ma chi cavolo usa ancora il fax? */
    fax?: string | null;

    constructor(data?: IProfileData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.civico = _data["civico"] !== undefined ? _data["civico"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.citta = _data["citta"] !== undefined ? _data["citta"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
        }
    }

    static fromJS(data: any): ProfileData {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["civico"] = this.civico !== undefined ? this.civico : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["citta"] = this.citta !== undefined ? this.citta : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        return data;
    }
}

/** Dati generici di profilo di un'agenzia */
export interface IProfileData {
    /** Nome colloquiale dell'agenzia */
    nome?: string | null;
    /** Indirizzo generico, senza il civico */
    indirizzo?: string | null;
    /** Codice avviamento postale o assimilabile */
    cap?: string | null;
    /** Numero civico */
    civico?: string | null;
    /** ID del luogo */
    luogoID?: number | null;
    /** Città, prelevata dal luogo */
    citta?: string | null;
    /** Indirizzo email generico */
    email?: string | null;
    /** Numero di telefono */
    telefono?: string | null;
    /** Numero di fax. Ma chi cavolo usa ancora il fax? */
    fax?: string | null;
}

/** Dati del logo, predisposti per loghi multipli */
export class LogoData implements ILogoData {
    /** Url assoluta del logo attuale */
    logoURL?: string;
    /** Questo logo viene usato sulle offerte */
    stampaSuOfferta?: boolean;
    /** Questo logo viene usato sui preventivi */
    stampaSuPreventivo?: boolean;
    /** Questo logo viene usato sul programma di viaggio */
    stampaSuProgramma?: boolean;
    /** Questo logo viene usato sulle conferme */
    stampaSuConferma?: boolean;

    constructor(data?: ILogoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoURL = _data["logoURL"] !== undefined ? _data["logoURL"] : <any>null;
            this.stampaSuOfferta = _data["stampaSuOfferta"] !== undefined ? _data["stampaSuOfferta"] : <any>null;
            this.stampaSuPreventivo = _data["stampaSuPreventivo"] !== undefined ? _data["stampaSuPreventivo"] : <any>null;
            this.stampaSuProgramma = _data["stampaSuProgramma"] !== undefined ? _data["stampaSuProgramma"] : <any>null;
            this.stampaSuConferma = _data["stampaSuConferma"] !== undefined ? _data["stampaSuConferma"] : <any>null;
        }
    }

    static fromJS(data: any): LogoData {
        data = typeof data === 'object' ? data : {};
        let result = new LogoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoURL"] = this.logoURL !== undefined ? this.logoURL : <any>null;
        data["stampaSuOfferta"] = this.stampaSuOfferta !== undefined ? this.stampaSuOfferta : <any>null;
        data["stampaSuPreventivo"] = this.stampaSuPreventivo !== undefined ? this.stampaSuPreventivo : <any>null;
        data["stampaSuProgramma"] = this.stampaSuProgramma !== undefined ? this.stampaSuProgramma : <any>null;
        data["stampaSuConferma"] = this.stampaSuConferma !== undefined ? this.stampaSuConferma : <any>null;
        return data;
    }
}

/** Dati del logo, predisposti per loghi multipli */
export interface ILogoData {
    /** Url assoluta del logo attuale */
    logoURL?: string;
    /** Questo logo viene usato sulle offerte */
    stampaSuOfferta?: boolean;
    /** Questo logo viene usato sui preventivi */
    stampaSuPreventivo?: boolean;
    /** Questo logo viene usato sul programma di viaggio */
    stampaSuProgramma?: boolean;
    /** Questo logo viene usato sulle conferme */
    stampaSuConferma?: boolean;
}

/** Dati specifici di fatturazione di un'agenzia */
export class ProfileInvoiceData implements IProfileInvoiceData {
    /** Ragione sociale completa dell'agenzia */
    ragioneSociale?: string | null;
    /** Prefisso della partita IVA in base al luogo di fatturazione */
    prefissoPartitaIVA?: string | null;
    /** Partita IVA */
    partitaIVA?: string | null;
    /** Indirizzo di fatturazione, senza il civico */
    indirizzo?: string | null;
    /** Codice avviamento postale o assimilabile */
    cap?: string | null;
    /** Numero civico */
    civico?: string | null;
    /** ID del luogo */
    luogoID?: number | null;
    /** Città, prelevata dal luogo */
    citta?: string | null;
    /** Casella PEC per fatturazione elettronica, solo per partite iva IT
Alternativo al codice univoco */
    pecFatturazioneElettronica?: string | null;
    /** Codice univoco per fatturazione elettronica, solo per partite iva IT
Alternativo alla PEC */
    codiceUnivocoFatturazioneElettronica?: string | null;

    constructor(data?: IProfileInvoiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ragioneSociale = _data["ragioneSociale"] !== undefined ? _data["ragioneSociale"] : <any>null;
            this.prefissoPartitaIVA = _data["prefissoPartitaIVA"] !== undefined ? _data["prefissoPartitaIVA"] : <any>null;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.civico = _data["civico"] !== undefined ? _data["civico"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.citta = _data["citta"] !== undefined ? _data["citta"] : <any>null;
            this.pecFatturazioneElettronica = _data["pecFatturazioneElettronica"] !== undefined ? _data["pecFatturazioneElettronica"] : <any>null;
            this.codiceUnivocoFatturazioneElettronica = _data["codiceUnivocoFatturazioneElettronica"] !== undefined ? _data["codiceUnivocoFatturazioneElettronica"] : <any>null;
        }
    }

    static fromJS(data: any): ProfileInvoiceData {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileInvoiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ragioneSociale"] = this.ragioneSociale !== undefined ? this.ragioneSociale : <any>null;
        data["prefissoPartitaIVA"] = this.prefissoPartitaIVA !== undefined ? this.prefissoPartitaIVA : <any>null;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["civico"] = this.civico !== undefined ? this.civico : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["citta"] = this.citta !== undefined ? this.citta : <any>null;
        data["pecFatturazioneElettronica"] = this.pecFatturazioneElettronica !== undefined ? this.pecFatturazioneElettronica : <any>null;
        data["codiceUnivocoFatturazioneElettronica"] = this.codiceUnivocoFatturazioneElettronica !== undefined ? this.codiceUnivocoFatturazioneElettronica : <any>null;
        return data;
    }
}

/** Dati specifici di fatturazione di un'agenzia */
export interface IProfileInvoiceData {
    /** Ragione sociale completa dell'agenzia */
    ragioneSociale?: string | null;
    /** Prefisso della partita IVA in base al luogo di fatturazione */
    prefissoPartitaIVA?: string | null;
    /** Partita IVA */
    partitaIVA?: string | null;
    /** Indirizzo di fatturazione, senza il civico */
    indirizzo?: string | null;
    /** Codice avviamento postale o assimilabile */
    cap?: string | null;
    /** Numero civico */
    civico?: string | null;
    /** ID del luogo */
    luogoID?: number | null;
    /** Città, prelevata dal luogo */
    citta?: string | null;
    /** Casella PEC per fatturazione elettronica, solo per partite iva IT
Alternativo al codice univoco */
    pecFatturazioneElettronica?: string | null;
    /** Codice univoco per fatturazione elettronica, solo per partite iva IT
Alternativo alla PEC */
    codiceUnivocoFatturazioneElettronica?: string | null;
}

export class GetRecapitiContattoResponse extends OkApiResponse implements IGetRecapitiContattoResponse {
    rows?: ContattoRecapito[] | null;

    constructor(data?: IGetRecapitiContattoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContattoRecapito.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): GetRecapitiContattoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecapitiContattoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetRecapitiContattoResponse extends IOkApiResponse {
    rows?: ContattoRecapito[] | null;
}

export class ContattoRecapito implements IContattoRecapito {
    recapitoID?: number;
    contattoID?: number;
    mezzoprenID?: EMezzoPrenotazione;
    recapito?: string | null;
    principale?: number | null;
    ordine?: number | null;
    attivo?: boolean;
    note?: string | null;

    constructor(data?: IContattoRecapito) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recapitoID = _data["recapitoID"] !== undefined ? _data["recapitoID"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.mezzoprenID = _data["mezzoprenID"] !== undefined ? _data["mezzoprenID"] : <any>null;
            this.recapito = _data["recapito"] !== undefined ? _data["recapito"] : <any>null;
            this.principale = _data["principale"] !== undefined ? _data["principale"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.attivo = _data["attivo"] !== undefined ? _data["attivo"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): ContattoRecapito {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoRecapito();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recapitoID"] = this.recapitoID !== undefined ? this.recapitoID : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["mezzoprenID"] = this.mezzoprenID !== undefined ? this.mezzoprenID : <any>null;
        data["recapito"] = this.recapito !== undefined ? this.recapito : <any>null;
        data["principale"] = this.principale !== undefined ? this.principale : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["attivo"] = this.attivo !== undefined ? this.attivo : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        return data;
    }
}

export interface IContattoRecapito {
    recapitoID?: number;
    contattoID?: number;
    mezzoprenID?: EMezzoPrenotazione;
    recapito?: string | null;
    principale?: number | null;
    ordine?: number | null;
    attivo?: boolean;
    note?: string | null;
}

export enum EMezzoPrenotazione {
    FaxPrenotazioni = "FaxPrenotazioni",
    Telefono = "Telefono",
    TerminaleAereo = "TerminaleAereo",
    Cellulare = "Cellulare",
    EmailPrenotazioni = "EmailPrenotazioni",
    EmailPromozioni = "EmailPromozioni",
    InvioDocContabili = "InvioDocContabili",
    BigliettiAerei = "BigliettiAerei",
    FaxPromozioni = "FaxPromozioni",
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetRecapitiContattoRequest extends LocalizedRequest implements IGetRecapitiContattoRequest {
    contattoId?: number;

    constructor(data?: IGetRecapitiContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
        }
    }

    static fromJS(data: any): GetRecapitiContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecapitiContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetRecapitiContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetRelazioniContattoResponse extends OkApiResponse implements IGetRelazioniContattoResponse {
    rows?: ContattoRelazione[] | null;

    constructor(data?: IGetRelazioniContattoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContattoRelazione.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): GetRelazioniContattoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRelazioniContattoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetRelazioniContattoResponse extends IOkApiResponse {
    rows?: ContattoRelazione[] | null;
}

export class ContattoRelazione implements IContattoRelazione {
    relazioneID?: number;
    contattoID?: number;
    contattoPadreID?: number;
    tipoRelazione?: ETipoRelazioneContatto;
    nome?: string | null;

    constructor(data?: IContattoRelazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relazioneID = _data["relazioneID"] !== undefined ? _data["relazioneID"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.contattoPadreID = _data["contattoPadreID"] !== undefined ? _data["contattoPadreID"] : <any>null;
            this.tipoRelazione = _data["tipoRelazione"] !== undefined ? _data["tipoRelazione"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
        }
    }

    static fromJS(data: any): ContattoRelazione {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoRelazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relazioneID"] = this.relazioneID !== undefined ? this.relazioneID : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["contattoPadreID"] = this.contattoPadreID !== undefined ? this.contattoPadreID : <any>null;
        data["tipoRelazione"] = this.tipoRelazione !== undefined ? this.tipoRelazione : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        return data;
    }
}

export interface IContattoRelazione {
    relazioneID?: number;
    contattoID?: number;
    contattoPadreID?: number;
    tipoRelazione?: ETipoRelazioneContatto;
    nome?: string | null;
}

export enum ETipoRelazioneContatto {
    UfficioDi = "UfficioDi",
    DipendenteDi = "DipendenteDi",
    CompetaA = "CompetaA",
    MembroDelGruppo = "MembroDelGruppo",
    MembroDelSottogruppo = "MembroDelSottogruppo",
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetRelazioniContattoRequest extends LocalizedRequest implements IGetRelazioniContattoRequest {
    contattoId?: number;

    constructor(data?: IGetRelazioniContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
        }
    }

    static fromJS(data: any): GetRelazioniContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRelazioniContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetRelazioniContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class GetUtentiListResponse extends OkApiResponse implements IGetUtentiListResponse {
    utenti?: UtenteRow[];

    constructor(data?: IGetUtentiListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["utenti"])) {
                this.utenti = [] as any;
                for (let item of _data["utenti"])
                    this.utenti!.push(UtenteRow.fromJS(item));
            }
            else {
                this.utenti = <any>null;
            }
        }
    }

    static fromJS(data: any): GetUtentiListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUtentiListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.utenti)) {
            data["utenti"] = [];
            for (let item of this.utenti)
                data["utenti"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetUtentiListResponse extends IOkApiResponse {
    utenti?: UtenteRow[];
}

export class GetUtentiListRequest extends ApiRequest implements IGetUtentiListRequest {
    contattoID?: number;

    constructor(data?: IGetUtentiListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
        }
    }

    static fromJS(data: any): GetUtentiListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUtentiListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetUtentiListRequest extends IApiRequest {
    contattoID?: number;
}

export class GetUtentiSecondariListRequest extends GetUtentiListRequest implements IGetUtentiSecondariListRequest {
    utenteID?: number;

    constructor(data?: IGetUtentiSecondariListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.utenteID = _data["utenteID"] !== undefined ? _data["utenteID"] : <any>null;
        }
    }

    static fromJS(data: any): GetUtentiSecondariListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUtentiSecondariListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utenteID"] = this.utenteID !== undefined ? this.utenteID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetUtentiSecondariListRequest extends IGetUtentiListRequest {
    utenteID?: number;
}

export class NrTableResponseOfContactListRow extends OkApiResponse implements INrTableResponseOfContactListRow {
    /** Array delle righe della pagina richiesta */
    rows?: ContactListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfContactListRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContactListRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfContactListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfContactListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfContactListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ContactListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

/** Classe che rappresenta la risposta ad una richiesta di elenco contatti */
export class ContactsListResponse extends NrTableResponseOfContactListRow implements IContactsListResponse {

    constructor(data?: IContactsListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ContactsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta la risposta ad una richiesta di elenco contatti */
export interface IContactsListResponse extends INrTableResponseOfContactListRow {
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class ContactsListRequest extends NrTableRequest implements IContactsListRequest {
    /** Ragione sociale, email, ID, ecc... da cercare */
    term?: string | null;
    /** Tipo di contatto */
    tipo?: ETipoContatto | null;
    /** ID del luogo associato al contatto */
    luogoCittaID?: number | null;
    /** ID del luogo paese associato al luogo del contatto */
    luogoPaeseID?: number | null;
    /** ID del luogo regione associato al luogo del contatto */
    luogoRegioneID?: number | null;
    /** Partita IVA del contatto */
    partitaIVA?: string | null;
    /** Sigla della provincia */
    provincia?: string | null;
    /** Filter contatscts based on validity (delted or not) */
    showValid?: boolean | null;

    constructor(data?: IContactsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.luogoCittaID = _data["luogoCittaID"] !== undefined ? _data["luogoCittaID"] : <any>null;
            this.luogoPaeseID = _data["luogoPaeseID"] !== undefined ? _data["luogoPaeseID"] : <any>null;
            this.luogoRegioneID = _data["luogoRegioneID"] !== undefined ? _data["luogoRegioneID"] : <any>null;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : <any>null;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : <any>null;
            this.showValid = _data["showValid"] !== undefined ? _data["showValid"] : <any>null;
        }
    }

    static fromJS(data: any): ContactsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["luogoCittaID"] = this.luogoCittaID !== undefined ? this.luogoCittaID : <any>null;
        data["luogoPaeseID"] = this.luogoPaeseID !== undefined ? this.luogoPaeseID : <any>null;
        data["luogoRegioneID"] = this.luogoRegioneID !== undefined ? this.luogoRegioneID : <any>null;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : <any>null;
        data["provincia"] = this.provincia !== undefined ? this.provincia : <any>null;
        data["showValid"] = this.showValid !== undefined ? this.showValid : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IContactsListRequest extends INrTableRequest {
    /** Ragione sociale, email, ID, ecc... da cercare */
    term?: string | null;
    /** Tipo di contatto */
    tipo?: ETipoContatto | null;
    /** ID del luogo associato al contatto */
    luogoCittaID?: number | null;
    /** ID del luogo paese associato al luogo del contatto */
    luogoPaeseID?: number | null;
    /** ID del luogo regione associato al luogo del contatto */
    luogoRegioneID?: number | null;
    /** Partita IVA del contatto */
    partitaIVA?: string | null;
    /** Sigla della provincia */
    provincia?: string | null;
    /** Filter contatscts based on validity (delted or not) */
    showValid?: boolean | null;
}

export class RestoreContattoRequest extends LocalizedRequest implements IRestoreContattoRequest {
    contattoId?: number;

    constructor(data?: IRestoreContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
        }
    }

    static fromJS(data: any): RestoreContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreContattoRequest extends ILocalizedRequest {
    contattoId?: number;
}

export class SaveAccordoContattoResponse extends OkApiResponse implements ISaveAccordoContattoResponse {
    accordoContatto?: AccordoContatto | null;

    constructor(data?: ISaveAccordoContattoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : <any>null;
        }
    }

    static fromJS(data: any): SaveAccordoContattoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAccordoContattoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISaveAccordoContattoResponse extends IOkApiResponse {
    accordoContatto?: AccordoContatto | null;
}

export class SaveAccordoContattoRequest extends ApiRequest implements ISaveAccordoContattoRequest {
    accordoContatto?: AccordoContatto | null;

    constructor(data?: ISaveAccordoContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : <any>null;
        }
    }

    static fromJS(data: any): SaveAccordoContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAccordoContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISaveAccordoContattoRequest extends IApiRequest {
    accordoContatto?: AccordoContatto | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class SetDatiAggiuntiviContattoRequest extends LocalizedRequest implements ISetDatiAggiuntiviContattoRequest {
    contattoId?: number;
    dati?: ContattoDato[] | null;

    constructor(data?: ISetDatiAggiuntiviContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
            if (Array.isArray(_data["dati"])) {
                this.dati = [] as any;
                for (let item of _data["dati"])
                    this.dati!.push(ContattoDato.fromJS(item));
            }
            else {
                this.dati = <any>null;
            }
        }
    }

    static fromJS(data: any): SetDatiAggiuntiviContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetDatiAggiuntiviContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        if (Array.isArray(this.dati)) {
            data["dati"] = [];
            for (let item of this.dati)
                data["dati"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface ISetDatiAggiuntiviContattoRequest extends ILocalizedRequest {
    contattoId?: number;
    dati?: ContattoDato[] | null;
}

export class SetMappaContattoResponse extends OkApiResponse implements ISetMappaContattoResponse {
    mappa?: Mappa | null;

    constructor(data?: ISetMappaContattoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : <any>null;
        }
    }

    static fromJS(data: any): SetMappaContattoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappaContattoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappa"] = this.mappa ? this.mappa.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappaContattoResponse extends IOkApiResponse {
    mappa?: Mappa | null;
}

export class SetMappaContattoRequest extends LocalizedRequest implements ISetMappaContattoRequest {
    contattoId?: number;
    mappa?: Mappa | null;

    constructor(data?: ISetMappaContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : <any>null;
        }
    }

    static fromJS(data: any): SetMappaContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappaContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappaContattoRequest extends ILocalizedRequest {
    contattoId?: number;
    mappa?: Mappa | null;
}

export class SetRecapitiContattoRequest extends LocalizedRequest implements ISetRecapitiContattoRequest {
    contattoId?: number;
    dati?: ContattoRecapito[] | null;

    constructor(data?: ISetRecapitiContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
            if (Array.isArray(_data["dati"])) {
                this.dati = [] as any;
                for (let item of _data["dati"])
                    this.dati!.push(ContattoRecapito.fromJS(item));
            }
            else {
                this.dati = <any>null;
            }
        }
    }

    static fromJS(data: any): SetRecapitiContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRecapitiContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        if (Array.isArray(this.dati)) {
            data["dati"] = [];
            for (let item of this.dati)
                data["dati"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetRecapitiContattoRequest extends ILocalizedRequest {
    contattoId?: number;
    dati?: ContattoRecapito[] | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class SetRelazioniContattoRequest extends LocalizedRequest implements ISetRelazioniContattoRequest {
    contattoID?: number;
    relazioni?: ContattoRelazione[] | null;

    constructor(data?: ISetRelazioniContattoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            if (Array.isArray(_data["relazioni"])) {
                this.relazioni = [] as any;
                for (let item of _data["relazioni"])
                    this.relazioni!.push(ContattoRelazione.fromJS(item));
            }
            else {
                this.relazioni = <any>null;
            }
        }
    }

    static fromJS(data: any): SetRelazioniContattoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRelazioniContattoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        if (Array.isArray(this.relazioni)) {
            data["relazioni"] = [];
            for (let item of this.relazioni)
                data["relazioni"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface ISetRelazioniContattoRequest extends ILocalizedRequest {
    contattoID?: number;
    relazioni?: ContattoRelazione[] | null;
}

export class UpdateAgencyDataRequest extends LocalizedRequest implements IUpdateAgencyDataRequest {
    profileData!: ProfileData;

    constructor(data?: IUpdateAgencyDataRequest) {
        super(data);
        if (!data) {
            this.profileData = new ProfileData();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.profileData = _data["profileData"] ? ProfileData.fromJS(_data["profileData"]) : new ProfileData();
        }
    }

    static fromJS(data: any): UpdateAgencyDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgencyDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileData"] = this.profileData ? this.profileData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAgencyDataRequest extends ILocalizedRequest {
    profileData: ProfileData;
}

export class UpdateAgencyInvoiceDataRequest extends LocalizedRequest implements IUpdateAgencyInvoiceDataRequest {
    profileInvoiceData!: ProfileInvoiceData;

    constructor(data?: IUpdateAgencyInvoiceDataRequest) {
        super(data);
        if (!data) {
            this.profileInvoiceData = new ProfileInvoiceData();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.profileInvoiceData = _data["profileInvoiceData"] ? ProfileInvoiceData.fromJS(_data["profileInvoiceData"]) : new ProfileInvoiceData();
        }
    }

    static fromJS(data: any): UpdateAgencyInvoiceDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgencyInvoiceDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileInvoiceData"] = this.profileInvoiceData ? this.profileInvoiceData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAgencyInvoiceDataRequest extends ILocalizedRequest {
    profileInvoiceData: ProfileInvoiceData;
}

export class UpdateLogoRequest extends LocalizedRequest implements IUpdateLogoRequest {
    logo?: LogoUpsert | null;

    constructor(data?: IUpdateLogoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logo = _data["logo"] ? LogoUpsert.fromJS(_data["logo"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateLogoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLogoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo ? this.logo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateLogoRequest extends ILocalizedRequest {
    logo?: LogoUpsert | null;
}

export class UpdateUtenteAgenziaResponse extends OkApiResponse implements IUpdateUtenteAgenziaResponse {
    /** Entità modificata */
    utente?: UtenteRow;

    constructor(data?: IUpdateUtenteAgenziaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.utente = _data["utente"] ? UtenteRow.fromJS(_data["utente"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateUtenteAgenziaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUtenteAgenziaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utente"] = this.utente ? this.utente.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateUtenteAgenziaResponse extends IOkApiResponse {
    /** Entità modificata */
    utente?: UtenteRow;
}

export class UpdateUtenteAgenziaRequest extends SiteRequest implements IUpdateUtenteAgenziaRequest {
    /** ID dell'utente da modificare */
    id!: number;
    /** Indirizzo email dell'utente */
    email!: string;
    /** Nome proprio */
    nome!: string;
    /** Cognome, facoltativo */
    cognome?: string | null;
    /** Numero di telefono dell'utente, facoltativo */
    telefono?: string | null;
    /** Flag di abilitazione */
    abilitato?: boolean;

    constructor(data?: IUpdateUtenteAgenziaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.abilitato = _data["abilitato"] !== undefined ? _data["abilitato"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateUtenteAgenziaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUtenteAgenziaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["abilitato"] = this.abilitato !== undefined ? this.abilitato : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateUtenteAgenziaRequest extends ISiteRequest {
    /** ID dell'utente da modificare */
    id: number;
    /** Indirizzo email dell'utente */
    email: string;
    /** Nome proprio */
    nome: string;
    /** Cognome, facoltativo */
    cognome?: string | null;
    /** Numero di telefono dell'utente, facoltativo */
    telefono?: string | null;
    /** Flag di abilitazione */
    abilitato?: boolean;
}

export class UpsertUtenteSecondarioResponse extends CreateUtenteAgenziaResponse implements IUpsertUtenteSecondarioResponse {

    constructor(data?: IUpsertUtenteSecondarioResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertUtenteSecondarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUtenteSecondarioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertUtenteSecondarioResponse extends ICreateUtenteAgenziaResponse {
}

export class UpsertUtenteSecondarioRequest extends CreateUtenteAgenziaRequest implements IUpsertUtenteSecondarioRequest {
    utenteID?: number;

    constructor(data?: IUpsertUtenteSecondarioRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.utenteID = _data["utenteID"] !== undefined ? _data["utenteID"] : <any>null;
        }
    }

    static fromJS(data: any): UpsertUtenteSecondarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUtenteSecondarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utenteID"] = this.utenteID !== undefined ? this.utenteID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertUtenteSecondarioRequest extends ICreateUtenteAgenziaRequest {
    utenteID?: number;
}

export class GetDashboardNewsResponse extends OkApiResponse implements IGetDashboardNewsResponse {
    news?: NewsRow[] | null;

    constructor(data?: IGetDashboardNewsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["news"])) {
                this.news = [] as any;
                for (let item of _data["news"])
                    this.news!.push(NewsRow.fromJS(item));
            }
            else {
                this.news = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDashboardNewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardNewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.news)) {
            data["news"] = [];
            for (let item of this.news)
                data["news"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDashboardNewsResponse extends IOkApiResponse {
    news?: NewsRow[] | null;
}

export class NewsRow implements INewsRow {
    id?: number;
    titoloIT?: string | null;
    titoloEN?: string | null;
    testoIT?: string | null;
    testoEN?: string | null;
    allegati?: NewsAttachment[] | null;
    ultimoAggiornamento?: string | null;

    constructor(data?: INewsRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.titoloIT = _data["titoloIT"] !== undefined ? _data["titoloIT"] : <any>null;
            this.titoloEN = _data["titoloEN"] !== undefined ? _data["titoloEN"] : <any>null;
            this.testoIT = _data["testoIT"] !== undefined ? _data["testoIT"] : <any>null;
            this.testoEN = _data["testoEN"] !== undefined ? _data["testoEN"] : <any>null;
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(NewsAttachment.fromJS(item));
            }
            else {
                this.allegati = <any>null;
            }
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
        }
    }

    static fromJS(data: any): NewsRow {
        data = typeof data === 'object' ? data : {};
        let result = new NewsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["titoloIT"] = this.titoloIT !== undefined ? this.titoloIT : <any>null;
        data["titoloEN"] = this.titoloEN !== undefined ? this.titoloEN : <any>null;
        data["testoIT"] = this.testoIT !== undefined ? this.testoIT : <any>null;
        data["testoEN"] = this.testoEN !== undefined ? this.testoEN : <any>null;
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item.toJSON());
        }
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        return data;
    }
}

export interface INewsRow {
    id?: number;
    titoloIT?: string | null;
    titoloEN?: string | null;
    testoIT?: string | null;
    testoEN?: string | null;
    allegati?: NewsAttachment[] | null;
    ultimoAggiornamento?: string | null;
}

export class NewsAttachment implements INewsAttachment {
    id?: number;
    descrizione?: string | null;
    fileName?: string | null;

    constructor(data?: INewsAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): NewsAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new NewsAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data;
    }
}

export interface INewsAttachment {
    id?: number;
    descrizione?: string | null;
    fileName?: string | null;
}

export class DashboardGetConfigResponse extends OkApiResponse implements IDashboardGetConfigResponse {
    userConfig?: IntranetUsersDashboardConfig[] | null;

    constructor(data?: IDashboardGetConfigResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["userConfig"])) {
                this.userConfig = [] as any;
                for (let item of _data["userConfig"])
                    this.userConfig!.push(IntranetUsersDashboardConfig.fromJS(item));
            }
            else {
                this.userConfig = <any>null;
            }
        }
    }

    static fromJS(data: any): DashboardGetConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardGetConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userConfig)) {
            data["userConfig"] = [];
            for (let item of this.userConfig)
                data["userConfig"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDashboardGetConfigResponse extends IOkApiResponse {
    userConfig?: IntranetUsersDashboardConfig[] | null;
}

export class IntranetUsersDashboardConfig implements IIntranetUsersDashboardConfig {
    id?: number;
    userID?: number;
    type?: EDashboardWidgetType;
    row?: number;
    rowSpan?: number;
    col?: number;
    colSpan?: number;
    title?: string | null;
    jsonOptions?: string | null;

    constructor(data?: IIntranetUsersDashboardConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.row = _data["row"] !== undefined ? _data["row"] : <any>null;
            this.rowSpan = _data["rowSpan"] !== undefined ? _data["rowSpan"] : <any>null;
            this.col = _data["col"] !== undefined ? _data["col"] : <any>null;
            this.colSpan = _data["colSpan"] !== undefined ? _data["colSpan"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.jsonOptions = _data["jsonOptions"] !== undefined ? _data["jsonOptions"] : <any>null;
        }
    }

    static fromJS(data: any): IntranetUsersDashboardConfig {
        data = typeof data === 'object' ? data : {};
        let result = new IntranetUsersDashboardConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userID"] = this.userID !== undefined ? this.userID : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["row"] = this.row !== undefined ? this.row : <any>null;
        data["rowSpan"] = this.rowSpan !== undefined ? this.rowSpan : <any>null;
        data["col"] = this.col !== undefined ? this.col : <any>null;
        data["colSpan"] = this.colSpan !== undefined ? this.colSpan : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["jsonOptions"] = this.jsonOptions !== undefined ? this.jsonOptions : <any>null;
        return data;
    }
}

export interface IIntranetUsersDashboardConfig {
    id?: number;
    userID?: number;
    type?: EDashboardWidgetType;
    row?: number;
    rowSpan?: number;
    col?: number;
    colSpan?: number;
    title?: string | null;
    jsonOptions?: string | null;
}

export enum EDashboardWidgetType {
    Statistic = "Statistic",
    Admin = "Admin",
    Basecamp = "Basecamp",
    Translation = "Translation",
    News = "News",
}

export class SetUserConfigRequest extends ApiRequest implements ISetUserConfigRequest {
    userConfig?: IntranetUsersDashboardConfig[] | null;

    constructor(data?: ISetUserConfigRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["userConfig"])) {
                this.userConfig = [] as any;
                for (let item of _data["userConfig"])
                    this.userConfig!.push(IntranetUsersDashboardConfig.fromJS(item));
            }
            else {
                this.userConfig = <any>null;
            }
        }
    }

    static fromJS(data: any): SetUserConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userConfig)) {
            data["userConfig"] = [];
            for (let item of this.userConfig)
                data["userConfig"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetUserConfigRequest extends IApiRequest {
    userConfig?: IntranetUsersDashboardConfig[] | null;
}

export class PhraseGetResponse extends OkApiResponse implements IPhraseGetResponse {
    frase?: Frase;
    tagsIds?: number[];

    constructor(data?: IPhraseGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.frase = _data["frase"] ? Frase.fromJS(_data["frase"]) : <any>null;
            if (Array.isArray(_data["tagsIds"])) {
                this.tagsIds = [] as any;
                for (let item of _data["tagsIds"])
                    this.tagsIds!.push(item);
            }
            else {
                this.tagsIds = <any>null;
            }
        }
    }

    static fromJS(data: any): PhraseGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PhraseGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frase"] = this.frase ? this.frase.toJSON() : <any>null;
        if (Array.isArray(this.tagsIds)) {
            data["tagsIds"] = [];
            for (let item of this.tagsIds)
                data["tagsIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPhraseGetResponse extends IOkApiResponse {
    frase?: Frase;
    tagsIds?: number[];
}

export class PhraseGetRequest extends LocalizedRequest implements IPhraseGetRequest {
    fraseID?: number;

    constructor(data?: IPhraseGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : <any>null;
        }
    }

    static fromJS(data: any): PhraseGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PhraseGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPhraseGetRequest extends ILocalizedRequest {
    fraseID?: number;
}

export class UpdatePhraseRequest extends PhraseGetRequest implements IUpdatePhraseRequest {
    frase?: Frase | null;
    tagsIds?: number[] | null;

    constructor(data?: IUpdatePhraseRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.frase = _data["frase"] ? Frase.fromJS(_data["frase"]) : <any>null;
            if (Array.isArray(_data["tagsIds"])) {
                this.tagsIds = [] as any;
                for (let item of _data["tagsIds"])
                    this.tagsIds!.push(item);
            }
            else {
                this.tagsIds = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdatePhraseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhraseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frase"] = this.frase ? this.frase.toJSON() : <any>null;
        if (Array.isArray(this.tagsIds)) {
            data["tagsIds"] = [];
            for (let item of this.tagsIds)
                data["tagsIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePhraseRequest extends IPhraseGetRequest {
    frase?: Frase | null;
    tagsIds?: number[] | null;
}

export class PhraseDeleteRequest extends ApiRequest implements IPhraseDeleteRequest {
    fraseID?: number;

    constructor(data?: IPhraseDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : <any>null;
        }
    }

    static fromJS(data: any): PhraseDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PhraseDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPhraseDeleteRequest extends IApiRequest {
    fraseID?: number;
}

export class NrTableResponseOfPhraseRow extends OkApiResponse implements INrTableResponseOfPhraseRow {
    /** Array delle righe della pagina richiesta */
    rows?: PhraseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPhraseRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PhraseRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfPhraseRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPhraseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPhraseRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PhraseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ListPhrasesResponse extends NrTableResponseOfPhraseRow implements IListPhrasesResponse {

    constructor(data?: IListPhrasesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ListPhrasesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListPhrasesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListPhrasesResponse extends INrTableResponseOfPhraseRow {
}

export class PhraseRow implements IPhraseRow {
    text?: string;
    title?: string | null;
    frase?: Frase;
    luogo?: string | null;
    paese?: string | null;
    luogoDestinazione?: string | null;
    servizio?: string | null;
    sezione?: string | null;
    contatto?: string | null;
    deleted?: boolean;
    tagsIds?: number[];

    constructor(data?: IPhraseRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.frase = _data["frase"] ? Frase.fromJS(_data["frase"]) : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
            this.luogoDestinazione = _data["luogoDestinazione"] !== undefined ? _data["luogoDestinazione"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.sezione = _data["sezione"] !== undefined ? _data["sezione"] : <any>null;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
            if (Array.isArray(_data["tagsIds"])) {
                this.tagsIds = [] as any;
                for (let item of _data["tagsIds"])
                    this.tagsIds!.push(item);
            }
            else {
                this.tagsIds = <any>null;
            }
        }
    }

    static fromJS(data: any): PhraseRow {
        data = typeof data === 'object' ? data : {};
        let result = new PhraseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["frase"] = this.frase ? this.frase.toJSON() : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        data["luogoDestinazione"] = this.luogoDestinazione !== undefined ? this.luogoDestinazione : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["sezione"] = this.sezione !== undefined ? this.sezione : <any>null;
        data["contatto"] = this.contatto !== undefined ? this.contatto : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        if (Array.isArray(this.tagsIds)) {
            data["tagsIds"] = [];
            for (let item of this.tagsIds)
                data["tagsIds"].push(item);
        }
        return data;
    }
}

export interface IPhraseRow {
    text?: string;
    title?: string | null;
    frase?: Frase;
    luogo?: string | null;
    paese?: string | null;
    luogoDestinazione?: string | null;
    servizio?: string | null;
    sezione?: string | null;
    contatto?: string | null;
    deleted?: boolean;
    tagsIds?: number[];
}

export class ListPhrasesRequest extends NrTableRequest implements IListPhrasesRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
    /** Se true cerca solo frasi non associate a luogo */
    noLuogo?: boolean;
    /** Se true cerca solo frasi non associate a servizio */
    noServizio?: boolean;
    /** Se true cerca solo frasi non associate a contatto */
    noContatto?: boolean;
    /** Se presente cerca solo frasi che hanno almeno uno dei tag con l'id della lista */
    tagIds?: number[] | null;
    /** Modalità di filtraggio degli ID dei tag */
    tagsIdsFilter?: EListPhrasesCollectionFilter;
    /** Filtro sugli ID luogo. Se presente la frase deve appartenere ad uno di questi luoghi */
    luoghiIds?: number[] | null;
    /** Filtroo sugli ID paese; */
    paesiIds?: number[] | null;
    /** Filtro sugli ID servizio. Se presente la frase deve appartenere ad uno di questi servizi */
    serviziIds?: number[] | null;
    /** Filtro sugli ID contatto. Se presente la frase deve appartenere ad uno di questi contatti */
    contattiIds?: number[] | null;
    /** Filtro sull'ID della sezione. Se presente la frase deve appartenere a questa sezione */
    sezioneID?: number | null;
    /** Filters by not deleted when true or only deleted items when false */
    showDeleted?: boolean;
    tipoServizioID?: string | null;

    constructor(data?: IListPhrasesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.noLuogo = _data["noLuogo"] !== undefined ? _data["noLuogo"] : <any>null;
            this.noServizio = _data["noServizio"] !== undefined ? _data["noServizio"] : <any>null;
            this.noContatto = _data["noContatto"] !== undefined ? _data["noContatto"] : <any>null;
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            else {
                this.tagIds = <any>null;
            }
            this.tagsIdsFilter = _data["tagsIdsFilter"] !== undefined ? _data["tagsIdsFilter"] : <any>null;
            if (Array.isArray(_data["luoghiIds"])) {
                this.luoghiIds = [] as any;
                for (let item of _data["luoghiIds"])
                    this.luoghiIds!.push(item);
            }
            else {
                this.luoghiIds = <any>null;
            }
            if (Array.isArray(_data["paesiIds"])) {
                this.paesiIds = [] as any;
                for (let item of _data["paesiIds"])
                    this.paesiIds!.push(item);
            }
            else {
                this.paesiIds = <any>null;
            }
            if (Array.isArray(_data["serviziIds"])) {
                this.serviziIds = [] as any;
                for (let item of _data["serviziIds"])
                    this.serviziIds!.push(item);
            }
            else {
                this.serviziIds = <any>null;
            }
            if (Array.isArray(_data["contattiIds"])) {
                this.contattiIds = [] as any;
                for (let item of _data["contattiIds"])
                    this.contattiIds!.push(item);
            }
            else {
                this.contattiIds = <any>null;
            }
            this.sezioneID = _data["sezioneID"] !== undefined ? _data["sezioneID"] : <any>null;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : <any>null;
            this.tipoServizioID = _data["tipoServizioID"] !== undefined ? _data["tipoServizioID"] : <any>null;
        }
    }

    static fromJS(data: any): ListPhrasesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListPhrasesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["noLuogo"] = this.noLuogo !== undefined ? this.noLuogo : <any>null;
        data["noServizio"] = this.noServizio !== undefined ? this.noServizio : <any>null;
        data["noContatto"] = this.noContatto !== undefined ? this.noContatto : <any>null;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["tagsIdsFilter"] = this.tagsIdsFilter !== undefined ? this.tagsIdsFilter : <any>null;
        if (Array.isArray(this.luoghiIds)) {
            data["luoghiIds"] = [];
            for (let item of this.luoghiIds)
                data["luoghiIds"].push(item);
        }
        if (Array.isArray(this.paesiIds)) {
            data["paesiIds"] = [];
            for (let item of this.paesiIds)
                data["paesiIds"].push(item);
        }
        if (Array.isArray(this.serviziIds)) {
            data["serviziIds"] = [];
            for (let item of this.serviziIds)
                data["serviziIds"].push(item);
        }
        if (Array.isArray(this.contattiIds)) {
            data["contattiIds"] = [];
            for (let item of this.contattiIds)
                data["contattiIds"].push(item);
        }
        data["sezioneID"] = this.sezioneID !== undefined ? this.sezioneID : <any>null;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : <any>null;
        data["tipoServizioID"] = this.tipoServizioID !== undefined ? this.tipoServizioID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IListPhrasesRequest extends INrTableRequest {
    /** Termine di ricerca: ID, titolo, parti di testo */
    term?: string | null;
    /** Se true cerca solo frasi non associate a luogo */
    noLuogo?: boolean;
    /** Se true cerca solo frasi non associate a servizio */
    noServizio?: boolean;
    /** Se true cerca solo frasi non associate a contatto */
    noContatto?: boolean;
    /** Se presente cerca solo frasi che hanno almeno uno dei tag con l'id della lista */
    tagIds?: number[] | null;
    /** Modalità di filtraggio degli ID dei tag */
    tagsIdsFilter?: EListPhrasesCollectionFilter;
    /** Filtro sugli ID luogo. Se presente la frase deve appartenere ad uno di questi luoghi */
    luoghiIds?: number[] | null;
    /** Filtroo sugli ID paese; */
    paesiIds?: number[] | null;
    /** Filtro sugli ID servizio. Se presente la frase deve appartenere ad uno di questi servizi */
    serviziIds?: number[] | null;
    /** Filtro sugli ID contatto. Se presente la frase deve appartenere ad uno di questi contatti */
    contattiIds?: number[] | null;
    /** Filtro sull'ID della sezione. Se presente la frase deve appartenere a questa sezione */
    sezioneID?: number | null;
    /** Filters by not deleted when true or only deleted items when false */
    showDeleted?: boolean;
    tipoServizioID?: string | null;
}

export enum EListPhrasesCollectionFilter {
    All = "All",
    Any = "Any",
}

export class TranslatePhrasesResponse extends OkApiResponse implements ITranslatePhrasesResponse {
    testoTradotto?: FraseTestoLingua | null;

    constructor(data?: ITranslatePhrasesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testoTradotto = _data["testoTradotto"] ? FraseTestoLingua.fromJS(_data["testoTradotto"]) : <any>null;
        }
    }

    static fromJS(data: any): TranslatePhrasesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslatePhrasesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testoTradotto"] = this.testoTradotto ? this.testoTradotto.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslatePhrasesResponse extends IOkApiResponse {
    testoTradotto?: FraseTestoLingua | null;
}

export class FraseTestoLingua implements IFraseTestoLingua {
    fraseID?: number;
    lingua?: ELingua;
    titolo?: string | null;
    testo?: string | null;
    confermato?: boolean;

    constructor(data?: IFraseTestoLingua) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.confermato = _data["confermato"] !== undefined ? _data["confermato"] : <any>null;
        }
    }

    static fromJS(data: any): FraseTestoLingua {
        data = typeof data === 'object' ? data : {};
        let result = new FraseTestoLingua();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["confermato"] = this.confermato !== undefined ? this.confermato : <any>null;
        return data;
    }
}

export interface IFraseTestoLingua {
    fraseID?: number;
    lingua?: ELingua;
    titolo?: string | null;
    testo?: string | null;
    confermato?: boolean;
}

export class TranslatePhrasesRequest extends ApiRequest implements ITranslatePhrasesRequest {
    testo?: FraseTestoLingua | null;
    linguaDestinazione?: ELingua;

    constructor(data?: ITranslatePhrasesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testo = _data["testo"] ? FraseTestoLingua.fromJS(_data["testo"]) : <any>null;
            this.linguaDestinazione = _data["linguaDestinazione"] !== undefined ? _data["linguaDestinazione"] : <any>null;
        }
    }

    static fromJS(data: any): TranslatePhrasesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslatePhrasesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testo"] = this.testo ? this.testo.toJSON() : <any>null;
        data["linguaDestinazione"] = this.linguaDestinazione !== undefined ? this.linguaDestinazione : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslatePhrasesRequest extends IApiRequest {
    testo?: FraseTestoLingua | null;
    linguaDestinazione?: ELingua;
}

export class PhraseRestoreRequest extends ApiRequest implements IPhraseRestoreRequest {
    fraseID?: number;

    constructor(data?: IPhraseRestoreRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : <any>null;
        }
    }

    static fromJS(data: any): PhraseRestoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PhraseRestoreRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPhraseRestoreRequest extends IApiRequest {
    fraseID?: number;
}

export class ConvertPdfMultiResponse extends OkApiResponse implements IConvertPdfMultiResponse {
    outputTempID?: number;

    constructor(data?: IConvertPdfMultiResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.outputTempID = _data["outputTempID"] !== undefined ? _data["outputTempID"] : <any>null;
        }
    }

    static fromJS(data: any): ConvertPdfMultiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertPdfMultiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outputTempID"] = this.outputTempID !== undefined ? this.outputTempID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IConvertPdfMultiResponse extends IOkApiResponse {
    outputTempID?: number;
}

export class ConvertPdfMultiRequest extends ApiRequest implements IConvertPdfMultiRequest {
    documentiIDs?: number[];
    format?: string;

    constructor(data?: IConvertPdfMultiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["documentiIDs"])) {
                this.documentiIDs = [] as any;
                for (let item of _data["documentiIDs"])
                    this.documentiIDs!.push(item);
            }
            else {
                this.documentiIDs = <any>null;
            }
            this.format = _data["format"] !== undefined ? _data["format"] : <any>null;
        }
    }

    static fromJS(data: any): ConvertPdfMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertPdfMultiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentiIDs)) {
            data["documentiIDs"] = [];
            for (let item of this.documentiIDs)
                data["documentiIDs"].push(item);
        }
        data["format"] = this.format !== undefined ? this.format : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IConvertPdfMultiRequest extends IApiRequest {
    documentiIDs?: number[];
    format?: string;
}

export class TripGetResponse extends OkApiResponse implements ITripGetResponse {
    id?: number;
    header?: TripHeader;
    contattoAgenziaID?: number | null;
    agency?: TripAgency | null;
    status?: TripStatus | null;
    economics?: TripEconomics | null;
    cancelCosts?: TripCancelCosts;
    paxes?: TripPaxes;
    confermata?: boolean;
    annullata?: boolean;
    warningGlobali?: WarningOfferta[];
    confermabile?: boolean;
    warningVoli?: WarningOfferta[];
    voliPrenotabili?: boolean;
    noteAgenzia?: string[] | null;
    flights?: TripFlights;
    steps?: TripStep[];
    accontoTotale?: number;
    compensatoTotale?: number;
    dataPrimoAcconto?: string | null;
    agreementsCosts?: TripAgreementCost[] | null;
    agreementsByRoomCosts?: TripAgreementCost[] | null;
    invoices?: TripInvoicesListRow[] | null;
    note?: TripNote[] | null;
    abilitaCopiaAgenzia?: boolean;
    /** Se true consente l'inserimento di quote di apertura con impostazione "manuale" che non vengono eliminate in automatico se il viaggio è a tappa singola */
    consentiQuoteManuali?: boolean;
    /** Tutti i servizi accessori non volo, non booking fee e non assicurazione */
    accessories?: TripStep | null;
    /** Assicurazioni per conto loro */
    insurances?: TripStep | null;
    documenti?: TripDocument[] | null;
    corrispondenzaAgenzia?: TripDocument[] | null;
    corrispondenzaFornitori?: TripDocument[] | null;
    documentiViaggio?: TripDocument[] | null;
    vouchers?: TripVoucher[] | null;
    emails?: TripEmail[] | null;
    isNew?: boolean;
    newTripData?: Offerta | null;
    documentiAllegabili?: TripAttachedDocCategory[] | null;
    documentiAgenzia?: TripAgencyDocuments;
    assicurazioni?: EServizioAutomatico[];
    voucherTuristicoID?: number | null;
    /** Percentuale attuale dei diritti di agenzia. Null se non presenti */
    percentualeDirittiAgenzia?: number | null;
    /** True se è possibile attivare il pulsante di sblocco */
    sbloccabile?: boolean;
    /** ID univoci di tutti i luoghi (città, regione, paese) toccati */
    luoghiIds?: number[];
    paxConnectID?: string | null;
    midocoID?: string | null;
    bosysID?: string | null;
    /** Se true è possibile generare l'estratto conto. */
    consentiEstrattoConto?: boolean;

    constructor(data?: ITripGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.header = _data["header"] ? TripHeader.fromJS(_data["header"]) : <any>null;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : <any>null;
            this.agency = _data["agency"] ? TripAgency.fromJS(_data["agency"]) : <any>null;
            this.status = _data["status"] ? TripStatus.fromJS(_data["status"]) : <any>null;
            this.economics = _data["economics"] ? TripEconomics.fromJS(_data["economics"]) : <any>null;
            this.cancelCosts = _data["cancelCosts"] ? TripCancelCosts.fromJS(_data["cancelCosts"]) : <any>null;
            this.paxes = _data["paxes"] ? TripPaxes.fromJS(_data["paxes"]) : <any>null;
            this.confermata = _data["confermata"] !== undefined ? _data["confermata"] : <any>null;
            this.annullata = _data["annullata"] !== undefined ? _data["annullata"] : <any>null;
            if (Array.isArray(_data["warningGlobali"])) {
                this.warningGlobali = [] as any;
                for (let item of _data["warningGlobali"])
                    this.warningGlobali!.push(WarningOfferta.fromJS(item));
            }
            else {
                this.warningGlobali = <any>null;
            }
            this.confermabile = _data["confermabile"] !== undefined ? _data["confermabile"] : <any>null;
            if (Array.isArray(_data["warningVoli"])) {
                this.warningVoli = [] as any;
                for (let item of _data["warningVoli"])
                    this.warningVoli!.push(WarningOfferta.fromJS(item));
            }
            else {
                this.warningVoli = <any>null;
            }
            this.voliPrenotabili = _data["voliPrenotabili"] !== undefined ? _data["voliPrenotabili"] : <any>null;
            if (Array.isArray(_data["noteAgenzia"])) {
                this.noteAgenzia = [] as any;
                for (let item of _data["noteAgenzia"])
                    this.noteAgenzia!.push(item);
            }
            else {
                this.noteAgenzia = <any>null;
            }
            this.flights = _data["flights"] ? TripFlights.fromJS(_data["flights"]) : <any>null;
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(TripStep.fromJS(item));
            }
            else {
                this.steps = <any>null;
            }
            this.accontoTotale = _data["accontoTotale"] !== undefined ? _data["accontoTotale"] : <any>null;
            this.compensatoTotale = _data["compensatoTotale"] !== undefined ? _data["compensatoTotale"] : <any>null;
            this.dataPrimoAcconto = _data["dataPrimoAcconto"] !== undefined ? _data["dataPrimoAcconto"] : <any>null;
            if (Array.isArray(_data["agreementsCosts"])) {
                this.agreementsCosts = [] as any;
                for (let item of _data["agreementsCosts"])
                    this.agreementsCosts!.push(TripAgreementCost.fromJS(item));
            }
            else {
                this.agreementsCosts = <any>null;
            }
            if (Array.isArray(_data["agreementsByRoomCosts"])) {
                this.agreementsByRoomCosts = [] as any;
                for (let item of _data["agreementsByRoomCosts"])
                    this.agreementsByRoomCosts!.push(TripAgreementCost.fromJS(item));
            }
            else {
                this.agreementsByRoomCosts = <any>null;
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(TripInvoicesListRow.fromJS(item));
            }
            else {
                this.invoices = <any>null;
            }
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(TripNote.fromJS(item));
            }
            else {
                this.note = <any>null;
            }
            this.abilitaCopiaAgenzia = _data["abilitaCopiaAgenzia"] !== undefined ? _data["abilitaCopiaAgenzia"] : <any>null;
            this.consentiQuoteManuali = _data["consentiQuoteManuali"] !== undefined ? _data["consentiQuoteManuali"] : <any>null;
            this.accessories = _data["accessories"] ? TripStep.fromJS(_data["accessories"]) : <any>null;
            this.insurances = _data["insurances"] ? TripStep.fromJS(_data["insurances"]) : <any>null;
            if (Array.isArray(_data["documenti"])) {
                this.documenti = [] as any;
                for (let item of _data["documenti"])
                    this.documenti!.push(TripDocument.fromJS(item));
            }
            else {
                this.documenti = <any>null;
            }
            if (Array.isArray(_data["corrispondenzaAgenzia"])) {
                this.corrispondenzaAgenzia = [] as any;
                for (let item of _data["corrispondenzaAgenzia"])
                    this.corrispondenzaAgenzia!.push(TripDocument.fromJS(item));
            }
            else {
                this.corrispondenzaAgenzia = <any>null;
            }
            if (Array.isArray(_data["corrispondenzaFornitori"])) {
                this.corrispondenzaFornitori = [] as any;
                for (let item of _data["corrispondenzaFornitori"])
                    this.corrispondenzaFornitori!.push(TripDocument.fromJS(item));
            }
            else {
                this.corrispondenzaFornitori = <any>null;
            }
            if (Array.isArray(_data["documentiViaggio"])) {
                this.documentiViaggio = [] as any;
                for (let item of _data["documentiViaggio"])
                    this.documentiViaggio!.push(TripDocument.fromJS(item));
            }
            else {
                this.documentiViaggio = <any>null;
            }
            if (Array.isArray(_data["vouchers"])) {
                this.vouchers = [] as any;
                for (let item of _data["vouchers"])
                    this.vouchers!.push(TripVoucher.fromJS(item));
            }
            else {
                this.vouchers = <any>null;
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(TripEmail.fromJS(item));
            }
            else {
                this.emails = <any>null;
            }
            this.isNew = _data["isNew"] !== undefined ? _data["isNew"] : <any>null;
            this.newTripData = _data["newTripData"] ? Offerta.fromJS(_data["newTripData"]) : <any>null;
            if (Array.isArray(_data["documentiAllegabili"])) {
                this.documentiAllegabili = [] as any;
                for (let item of _data["documentiAllegabili"])
                    this.documentiAllegabili!.push(TripAttachedDocCategory.fromJS(item));
            }
            else {
                this.documentiAllegabili = <any>null;
            }
            this.documentiAgenzia = _data["documentiAgenzia"] ? TripAgencyDocuments.fromJS(_data["documentiAgenzia"]) : <any>null;
            if (Array.isArray(_data["assicurazioni"])) {
                this.assicurazioni = [] as any;
                for (let item of _data["assicurazioni"])
                    this.assicurazioni!.push(item);
            }
            else {
                this.assicurazioni = <any>null;
            }
            this.voucherTuristicoID = _data["voucherTuristicoID"] !== undefined ? _data["voucherTuristicoID"] : <any>null;
            this.percentualeDirittiAgenzia = _data["percentualeDirittiAgenzia"] !== undefined ? _data["percentualeDirittiAgenzia"] : <any>null;
            this.sbloccabile = _data["sbloccabile"] !== undefined ? _data["sbloccabile"] : <any>null;
            if (Array.isArray(_data["luoghiIds"])) {
                this.luoghiIds = [] as any;
                for (let item of _data["luoghiIds"])
                    this.luoghiIds!.push(item);
            }
            else {
                this.luoghiIds = <any>null;
            }
            this.paxConnectID = _data["paxConnectID"] !== undefined ? _data["paxConnectID"] : <any>null;
            this.midocoID = _data["midocoID"] !== undefined ? _data["midocoID"] : <any>null;
            this.bosysID = _data["bosysID"] !== undefined ? _data["bosysID"] : <any>null;
            this.consentiEstrattoConto = _data["consentiEstrattoConto"] !== undefined ? _data["consentiEstrattoConto"] : <any>null;
        }
    }

    static fromJS(data: any): TripGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TripGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["header"] = this.header ? this.header.toJSON() : <any>null;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : <any>null;
        data["agency"] = this.agency ? this.agency.toJSON() : <any>null;
        data["status"] = this.status ? this.status.toJSON() : <any>null;
        data["economics"] = this.economics ? this.economics.toJSON() : <any>null;
        data["cancelCosts"] = this.cancelCosts ? this.cancelCosts.toJSON() : <any>null;
        data["paxes"] = this.paxes ? this.paxes.toJSON() : <any>null;
        data["confermata"] = this.confermata !== undefined ? this.confermata : <any>null;
        data["annullata"] = this.annullata !== undefined ? this.annullata : <any>null;
        if (Array.isArray(this.warningGlobali)) {
            data["warningGlobali"] = [];
            for (let item of this.warningGlobali)
                data["warningGlobali"].push(item.toJSON());
        }
        data["confermabile"] = this.confermabile !== undefined ? this.confermabile : <any>null;
        if (Array.isArray(this.warningVoli)) {
            data["warningVoli"] = [];
            for (let item of this.warningVoli)
                data["warningVoli"].push(item.toJSON());
        }
        data["voliPrenotabili"] = this.voliPrenotabili !== undefined ? this.voliPrenotabili : <any>null;
        if (Array.isArray(this.noteAgenzia)) {
            data["noteAgenzia"] = [];
            for (let item of this.noteAgenzia)
                data["noteAgenzia"].push(item);
        }
        data["flights"] = this.flights ? this.flights.toJSON() : <any>null;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        data["accontoTotale"] = this.accontoTotale !== undefined ? this.accontoTotale : <any>null;
        data["compensatoTotale"] = this.compensatoTotale !== undefined ? this.compensatoTotale : <any>null;
        data["dataPrimoAcconto"] = this.dataPrimoAcconto !== undefined ? this.dataPrimoAcconto : <any>null;
        if (Array.isArray(this.agreementsCosts)) {
            data["agreementsCosts"] = [];
            for (let item of this.agreementsCosts)
                data["agreementsCosts"].push(item.toJSON());
        }
        if (Array.isArray(this.agreementsByRoomCosts)) {
            data["agreementsByRoomCosts"] = [];
            for (let item of this.agreementsByRoomCosts)
                data["agreementsByRoomCosts"].push(item.toJSON());
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item.toJSON());
        }
        data["abilitaCopiaAgenzia"] = this.abilitaCopiaAgenzia !== undefined ? this.abilitaCopiaAgenzia : <any>null;
        data["consentiQuoteManuali"] = this.consentiQuoteManuali !== undefined ? this.consentiQuoteManuali : <any>null;
        data["accessories"] = this.accessories ? this.accessories.toJSON() : <any>null;
        data["insurances"] = this.insurances ? this.insurances.toJSON() : <any>null;
        if (Array.isArray(this.documenti)) {
            data["documenti"] = [];
            for (let item of this.documenti)
                data["documenti"].push(item.toJSON());
        }
        if (Array.isArray(this.corrispondenzaAgenzia)) {
            data["corrispondenzaAgenzia"] = [];
            for (let item of this.corrispondenzaAgenzia)
                data["corrispondenzaAgenzia"].push(item.toJSON());
        }
        if (Array.isArray(this.corrispondenzaFornitori)) {
            data["corrispondenzaFornitori"] = [];
            for (let item of this.corrispondenzaFornitori)
                data["corrispondenzaFornitori"].push(item.toJSON());
        }
        if (Array.isArray(this.documentiViaggio)) {
            data["documentiViaggio"] = [];
            for (let item of this.documentiViaggio)
                data["documentiViaggio"].push(item.toJSON());
        }
        if (Array.isArray(this.vouchers)) {
            data["vouchers"] = [];
            for (let item of this.vouchers)
                data["vouchers"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        data["isNew"] = this.isNew !== undefined ? this.isNew : <any>null;
        data["newTripData"] = this.newTripData ? this.newTripData.toJSON() : <any>null;
        if (Array.isArray(this.documentiAllegabili)) {
            data["documentiAllegabili"] = [];
            for (let item of this.documentiAllegabili)
                data["documentiAllegabili"].push(item.toJSON());
        }
        data["documentiAgenzia"] = this.documentiAgenzia ? this.documentiAgenzia.toJSON() : <any>null;
        if (Array.isArray(this.assicurazioni)) {
            data["assicurazioni"] = [];
            for (let item of this.assicurazioni)
                data["assicurazioni"].push(item);
        }
        data["voucherTuristicoID"] = this.voucherTuristicoID !== undefined ? this.voucherTuristicoID : <any>null;
        data["percentualeDirittiAgenzia"] = this.percentualeDirittiAgenzia !== undefined ? this.percentualeDirittiAgenzia : <any>null;
        data["sbloccabile"] = this.sbloccabile !== undefined ? this.sbloccabile : <any>null;
        if (Array.isArray(this.luoghiIds)) {
            data["luoghiIds"] = [];
            for (let item of this.luoghiIds)
                data["luoghiIds"].push(item);
        }
        data["paxConnectID"] = this.paxConnectID !== undefined ? this.paxConnectID : <any>null;
        data["midocoID"] = this.midocoID !== undefined ? this.midocoID : <any>null;
        data["bosysID"] = this.bosysID !== undefined ? this.bosysID : <any>null;
        data["consentiEstrattoConto"] = this.consentiEstrattoConto !== undefined ? this.consentiEstrattoConto : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITripGetResponse extends IOkApiResponse {
    id?: number;
    header?: TripHeader;
    contattoAgenziaID?: number | null;
    agency?: TripAgency | null;
    status?: TripStatus | null;
    economics?: TripEconomics | null;
    cancelCosts?: TripCancelCosts;
    paxes?: TripPaxes;
    confermata?: boolean;
    annullata?: boolean;
    warningGlobali?: WarningOfferta[];
    confermabile?: boolean;
    warningVoli?: WarningOfferta[];
    voliPrenotabili?: boolean;
    noteAgenzia?: string[] | null;
    flights?: TripFlights;
    steps?: TripStep[];
    accontoTotale?: number;
    compensatoTotale?: number;
    dataPrimoAcconto?: string | null;
    agreementsCosts?: TripAgreementCost[] | null;
    agreementsByRoomCosts?: TripAgreementCost[] | null;
    invoices?: TripInvoicesListRow[] | null;
    note?: TripNote[] | null;
    abilitaCopiaAgenzia?: boolean;
    /** Se true consente l'inserimento di quote di apertura con impostazione "manuale" che non vengono eliminate in automatico se il viaggio è a tappa singola */
    consentiQuoteManuali?: boolean;
    /** Tutti i servizi accessori non volo, non booking fee e non assicurazione */
    accessories?: TripStep | null;
    /** Assicurazioni per conto loro */
    insurances?: TripStep | null;
    documenti?: TripDocument[] | null;
    corrispondenzaAgenzia?: TripDocument[] | null;
    corrispondenzaFornitori?: TripDocument[] | null;
    documentiViaggio?: TripDocument[] | null;
    vouchers?: TripVoucher[] | null;
    emails?: TripEmail[] | null;
    isNew?: boolean;
    newTripData?: Offerta | null;
    documentiAllegabili?: TripAttachedDocCategory[] | null;
    documentiAgenzia?: TripAgencyDocuments;
    assicurazioni?: EServizioAutomatico[];
    voucherTuristicoID?: number | null;
    /** Percentuale attuale dei diritti di agenzia. Null se non presenti */
    percentualeDirittiAgenzia?: number | null;
    /** True se è possibile attivare il pulsante di sblocco */
    sbloccabile?: boolean;
    /** ID univoci di tutti i luoghi (città, regione, paese) toccati */
    luoghiIds?: number[];
    paxConnectID?: string | null;
    midocoID?: string | null;
    bosysID?: string | null;
    /** Se true è possibile generare l'estratto conto. */
    consentiEstrattoConto?: boolean;
}

export class TripHeader implements ITripHeader {
    id?: number;
    descrizione?: string | null;
    /** Titolo interno */
    titoloViaggio?: string | null;
    /** Titolo da usare nei documenti */
    titoloDocumenti?: string | null;
    note?: string | null;
    partenza?: string;
    termine?: string;
    giorni?: number;
    notti?: number;
    numeroPax?: number;
    numeroTappe?: number;
    nozze?: boolean;
    tipo?: ETipoViaggio;
    statoUtente?: EStatoOffertaUtente;
    modalitaQuote?: EModalitaQuote;
    dataCancellazioneTO?: string | null;
    offerta?: Offerta;
    /** Flag che indica che la stampa dell'offerta non richiede verifica prezzi */
    prezziAggiornati?: boolean;
    totale?: number | null;
    destinazione?: string | null;
    totaleCommissioni?: number | null;
    totaleNetto?: number | null;
    /** Solo intranet */
    utenteCreatore?: string | null;
    anticipiFornitoreAggiornati?: boolean;
    /** Lingua del viaggio */
    lingua?: ELingua;

    constructor(data?: ITripHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.titoloViaggio = _data["titoloViaggio"] !== undefined ? _data["titoloViaggio"] : <any>null;
            this.titoloDocumenti = _data["titoloDocumenti"] !== undefined ? _data["titoloDocumenti"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.termine = _data["termine"] !== undefined ? _data["termine"] : <any>null;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            this.numeroPax = _data["numeroPax"] !== undefined ? _data["numeroPax"] : <any>null;
            this.numeroTappe = _data["numeroTappe"] !== undefined ? _data["numeroTappe"] : <any>null;
            this.nozze = _data["nozze"] !== undefined ? _data["nozze"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.statoUtente = _data["statoUtente"] !== undefined ? _data["statoUtente"] : <any>null;
            this.modalitaQuote = _data["modalitaQuote"] !== undefined ? _data["modalitaQuote"] : <any>null;
            this.dataCancellazioneTO = _data["dataCancellazioneTO"] !== undefined ? _data["dataCancellazioneTO"] : <any>null;
            this.offerta = _data["offerta"] ? Offerta.fromJS(_data["offerta"]) : <any>null;
            this.prezziAggiornati = _data["prezziAggiornati"] !== undefined ? _data["prezziAggiornati"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : <any>null;
            this.totaleCommissioni = _data["totaleCommissioni"] !== undefined ? _data["totaleCommissioni"] : <any>null;
            this.totaleNetto = _data["totaleNetto"] !== undefined ? _data["totaleNetto"] : <any>null;
            this.utenteCreatore = _data["utenteCreatore"] !== undefined ? _data["utenteCreatore"] : <any>null;
            this.anticipiFornitoreAggiornati = _data["anticipiFornitoreAggiornati"] !== undefined ? _data["anticipiFornitoreAggiornati"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
        }
    }

    static fromJS(data: any): TripHeader {
        data = typeof data === 'object' ? data : {};
        let result = new TripHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["titoloViaggio"] = this.titoloViaggio !== undefined ? this.titoloViaggio : <any>null;
        data["titoloDocumenti"] = this.titoloDocumenti !== undefined ? this.titoloDocumenti : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["termine"] = this.termine !== undefined ? this.termine : <any>null;
        data["giorni"] = this.giorni !== undefined ? this.giorni : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        data["numeroPax"] = this.numeroPax !== undefined ? this.numeroPax : <any>null;
        data["numeroTappe"] = this.numeroTappe !== undefined ? this.numeroTappe : <any>null;
        data["nozze"] = this.nozze !== undefined ? this.nozze : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["statoUtente"] = this.statoUtente !== undefined ? this.statoUtente : <any>null;
        data["modalitaQuote"] = this.modalitaQuote !== undefined ? this.modalitaQuote : <any>null;
        data["dataCancellazioneTO"] = this.dataCancellazioneTO !== undefined ? this.dataCancellazioneTO : <any>null;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        data["prezziAggiornati"] = this.prezziAggiornati !== undefined ? this.prezziAggiornati : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : <any>null;
        data["totaleCommissioni"] = this.totaleCommissioni !== undefined ? this.totaleCommissioni : <any>null;
        data["totaleNetto"] = this.totaleNetto !== undefined ? this.totaleNetto : <any>null;
        data["utenteCreatore"] = this.utenteCreatore !== undefined ? this.utenteCreatore : <any>null;
        data["anticipiFornitoreAggiornati"] = this.anticipiFornitoreAggiornati !== undefined ? this.anticipiFornitoreAggiornati : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        return data;
    }
}

export interface ITripHeader {
    id?: number;
    descrizione?: string | null;
    /** Titolo interno */
    titoloViaggio?: string | null;
    /** Titolo da usare nei documenti */
    titoloDocumenti?: string | null;
    note?: string | null;
    partenza?: string;
    termine?: string;
    giorni?: number;
    notti?: number;
    numeroPax?: number;
    numeroTappe?: number;
    nozze?: boolean;
    tipo?: ETipoViaggio;
    statoUtente?: EStatoOffertaUtente;
    modalitaQuote?: EModalitaQuote;
    dataCancellazioneTO?: string | null;
    offerta?: Offerta;
    /** Flag che indica che la stampa dell'offerta non richiede verifica prezzi */
    prezziAggiornati?: boolean;
    totale?: number | null;
    destinazione?: string | null;
    totaleCommissioni?: number | null;
    totaleNetto?: number | null;
    /** Solo intranet */
    utenteCreatore?: string | null;
    anticipiFornitoreAggiornati?: boolean;
    /** Lingua del viaggio */
    lingua?: ELingua;
}

export enum ETipoViaggio {
    Indefinito = "Indefinito",
    Vip = "Vip",
    Gruppo = "Gruppo",
    Tci = "Tci",
    Adv = "Adv",
    EasyTop = "EasyTop",
    Pacchetto = "Pacchetto",
}

export enum EStatoOffertaUtente {
    Preventivo = "Preventivo",
    PrenotazioneInCorso = "PrenotazioneInCorso",
    Confermata = "Confermata",
    Annullata = "Annullata",
}

export enum EModalitaQuote {
    Naar = "Naar",
    Online = "Online",
    OnlineUpgrade = "OnlineUpgrade",
}

export class Offerta implements IOfferta {
    offertaID?: number;
    riferimento?: number;
    descrizione?: string | null;
    destinazioneID?: number | null;
    creazione?: string;
    partenza?: string;
    tipo?: ETipoViaggio | null;
    impiegatoUtenteID?: number;
    totale?: number | null;
    totaleCommissione?: number | null;
    totaleCommissioneCee?: number | null;
    totaleCosto?: number | null;
    operatore?: EOperatore;
    codiceAeroportoPartenza?: string | null;
    note?: string | null;
    numeroPax?: number | null;
    versione?: number;
    cookie?: string | null;
    nozze?: boolean;
    templateID?: number | null;
    tipologiaID?: number | null;
    offertaOrigineID?: number | null;
    totaleAssicurato?: number | null;
    anticipiAggiornati?: boolean;
    titoloViaggio?: string | null;
    penaleMassima?: number | null;
    ultimoAggiornamentoPenaleMassima?: string | null;
    ritorno?: string | null;
    servizioID?: number | null;

    constructor(data?: IOfferta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.riferimento = _data["riferimento"] !== undefined ? _data["riferimento"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.destinazioneID = _data["destinazioneID"] !== undefined ? _data["destinazioneID"] : <any>null;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.impiegatoUtenteID = _data["impiegatoUtenteID"] !== undefined ? _data["impiegatoUtenteID"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.totaleCommissione = _data["totaleCommissione"] !== undefined ? _data["totaleCommissione"] : <any>null;
            this.totaleCommissioneCee = _data["totaleCommissioneCee"] !== undefined ? _data["totaleCommissioneCee"] : <any>null;
            this.totaleCosto = _data["totaleCosto"] !== undefined ? _data["totaleCosto"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.codiceAeroportoPartenza = _data["codiceAeroportoPartenza"] !== undefined ? _data["codiceAeroportoPartenza"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.numeroPax = _data["numeroPax"] !== undefined ? _data["numeroPax"] : <any>null;
            this.versione = _data["versione"] !== undefined ? _data["versione"] : <any>null;
            this.cookie = _data["cookie"] !== undefined ? _data["cookie"] : <any>null;
            this.nozze = _data["nozze"] !== undefined ? _data["nozze"] : <any>null;
            this.templateID = _data["templateID"] !== undefined ? _data["templateID"] : <any>null;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : <any>null;
            this.offertaOrigineID = _data["offertaOrigineID"] !== undefined ? _data["offertaOrigineID"] : <any>null;
            this.totaleAssicurato = _data["totaleAssicurato"] !== undefined ? _data["totaleAssicurato"] : <any>null;
            this.anticipiAggiornati = _data["anticipiAggiornati"] !== undefined ? _data["anticipiAggiornati"] : <any>null;
            this.titoloViaggio = _data["titoloViaggio"] !== undefined ? _data["titoloViaggio"] : <any>null;
            this.penaleMassima = _data["penaleMassima"] !== undefined ? _data["penaleMassima"] : <any>null;
            this.ultimoAggiornamentoPenaleMassima = _data["ultimoAggiornamentoPenaleMassima"] !== undefined ? _data["ultimoAggiornamentoPenaleMassima"] : <any>null;
            this.ritorno = _data["ritorno"] !== undefined ? _data["ritorno"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
        }
    }

    static fromJS(data: any): Offerta {
        data = typeof data === 'object' ? data : {};
        let result = new Offerta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["riferimento"] = this.riferimento !== undefined ? this.riferimento : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["destinazioneID"] = this.destinazioneID !== undefined ? this.destinazioneID : <any>null;
        data["creazione"] = this.creazione !== undefined ? this.creazione : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["impiegatoUtenteID"] = this.impiegatoUtenteID !== undefined ? this.impiegatoUtenteID : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["totaleCommissione"] = this.totaleCommissione !== undefined ? this.totaleCommissione : <any>null;
        data["totaleCommissioneCee"] = this.totaleCommissioneCee !== undefined ? this.totaleCommissioneCee : <any>null;
        data["totaleCosto"] = this.totaleCosto !== undefined ? this.totaleCosto : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["codiceAeroportoPartenza"] = this.codiceAeroportoPartenza !== undefined ? this.codiceAeroportoPartenza : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["numeroPax"] = this.numeroPax !== undefined ? this.numeroPax : <any>null;
        data["versione"] = this.versione !== undefined ? this.versione : <any>null;
        data["cookie"] = this.cookie !== undefined ? this.cookie : <any>null;
        data["nozze"] = this.nozze !== undefined ? this.nozze : <any>null;
        data["templateID"] = this.templateID !== undefined ? this.templateID : <any>null;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : <any>null;
        data["offertaOrigineID"] = this.offertaOrigineID !== undefined ? this.offertaOrigineID : <any>null;
        data["totaleAssicurato"] = this.totaleAssicurato !== undefined ? this.totaleAssicurato : <any>null;
        data["anticipiAggiornati"] = this.anticipiAggiornati !== undefined ? this.anticipiAggiornati : <any>null;
        data["titoloViaggio"] = this.titoloViaggio !== undefined ? this.titoloViaggio : <any>null;
        data["penaleMassima"] = this.penaleMassima !== undefined ? this.penaleMassima : <any>null;
        data["ultimoAggiornamentoPenaleMassima"] = this.ultimoAggiornamentoPenaleMassima !== undefined ? this.ultimoAggiornamentoPenaleMassima : <any>null;
        data["ritorno"] = this.ritorno !== undefined ? this.ritorno : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        return data;
    }
}

export interface IOfferta {
    offertaID?: number;
    riferimento?: number;
    descrizione?: string | null;
    destinazioneID?: number | null;
    creazione?: string;
    partenza?: string;
    tipo?: ETipoViaggio | null;
    impiegatoUtenteID?: number;
    totale?: number | null;
    totaleCommissione?: number | null;
    totaleCommissioneCee?: number | null;
    totaleCosto?: number | null;
    operatore?: EOperatore;
    codiceAeroportoPartenza?: string | null;
    note?: string | null;
    numeroPax?: number | null;
    versione?: number;
    cookie?: string | null;
    nozze?: boolean;
    templateID?: number | null;
    tipologiaID?: number | null;
    offertaOrigineID?: number | null;
    totaleAssicurato?: number | null;
    anticipiAggiornati?: boolean;
    titoloViaggio?: string | null;
    penaleMassima?: number | null;
    ultimoAggiornamentoPenaleMassima?: string | null;
    ritorno?: string | null;
    servizioID?: number | null;
}

export class TripAgency implements ITripAgency {
    offertaAgenzia?: OffertaAgenzia;
    id?: number;
    contattoID?: number;
    nome?: string | null;
    cognome?: string | null;
    indirizzo?: string | null;
    civico?: string | null;
    cap?: string | null;
    luogo?: string | null;
    provincia?: string | null;
    paese?: string | null;
    telefono?: string | null;
    fax?: string | null;
    partitaIva?: string | null;
    email?: string | null;
    categoria?: string | null;
    pagamentoHtml?: string | null;
    contattoNetworkID?: number | null;
    network?: string | null;
    contattoPromoterID?: number | null;
    promoter?: string | null;
    telefonoPromoter?: string | null;
    acconto?: number | null;
    noAnticipoQuote?: boolean;
    accontoNozze?: number | null;
    noAnticipoBiglietti?: boolean;
    nomeAddetto?: string | null;
    emailAddetto?: string | null;
    addettoID?: number | null;
    username?: string | null;
    riferimentoCliente?: string | null;
    utentePreventivoID?: number | null;
    utentePreventivo?: string | null;
    utenteConfermaID?: number | null;
    utenteConferma?: string | null;
    utenteDocumentiID?: number | null;
    utenteDocumenti?: string | null;
    dataEvasionePrevista?: string | null;
    dataAppuntamentoAgenzia?: string | null;
    dataConferma?: string | null;
    dataConfermaTO?: string | null;
    dataCancellazioneADV?: string | null;
    dataCancellazioneTO?: string | null;
    commissione?: number | null;
    utenteTariffaID?: number | null;
    utenteTariffa?: string | null;
    utenteBiglietteriaID?: number | null;
    utenteBiglietteria?: string | null;
    richiedeAggiornamentoValute?: boolean;
    commissioneAccordo?: number | null;
    logoUrl?: string | null;
    statusPreventivo?: EStatusPreventivo | null;
    tagIDs?: number[];

    constructor(data?: ITripAgency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaAgenzia = _data["offertaAgenzia"] ? OffertaAgenzia.fromJS(_data["offertaAgenzia"]) : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.civico = _data["civico"] !== undefined ? _data["civico"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.partitaIva = _data["partitaIva"] !== undefined ? _data["partitaIva"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : <any>null;
            this.pagamentoHtml = _data["pagamentoHtml"] !== undefined ? _data["pagamentoHtml"] : <any>null;
            this.contattoNetworkID = _data["contattoNetworkID"] !== undefined ? _data["contattoNetworkID"] : <any>null;
            this.network = _data["network"] !== undefined ? _data["network"] : <any>null;
            this.contattoPromoterID = _data["contattoPromoterID"] !== undefined ? _data["contattoPromoterID"] : <any>null;
            this.promoter = _data["promoter"] !== undefined ? _data["promoter"] : <any>null;
            this.telefonoPromoter = _data["telefonoPromoter"] !== undefined ? _data["telefonoPromoter"] : <any>null;
            this.acconto = _data["acconto"] !== undefined ? _data["acconto"] : <any>null;
            this.noAnticipoQuote = _data["noAnticipoQuote"] !== undefined ? _data["noAnticipoQuote"] : <any>null;
            this.accontoNozze = _data["accontoNozze"] !== undefined ? _data["accontoNozze"] : <any>null;
            this.noAnticipoBiglietti = _data["noAnticipoBiglietti"] !== undefined ? _data["noAnticipoBiglietti"] : <any>null;
            this.nomeAddetto = _data["nomeAddetto"] !== undefined ? _data["nomeAddetto"] : <any>null;
            this.emailAddetto = _data["emailAddetto"] !== undefined ? _data["emailAddetto"] : <any>null;
            this.addettoID = _data["addettoID"] !== undefined ? _data["addettoID"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.riferimentoCliente = _data["riferimentoCliente"] !== undefined ? _data["riferimentoCliente"] : <any>null;
            this.utentePreventivoID = _data["utentePreventivoID"] !== undefined ? _data["utentePreventivoID"] : <any>null;
            this.utentePreventivo = _data["utentePreventivo"] !== undefined ? _data["utentePreventivo"] : <any>null;
            this.utenteConfermaID = _data["utenteConfermaID"] !== undefined ? _data["utenteConfermaID"] : <any>null;
            this.utenteConferma = _data["utenteConferma"] !== undefined ? _data["utenteConferma"] : <any>null;
            this.utenteDocumentiID = _data["utenteDocumentiID"] !== undefined ? _data["utenteDocumentiID"] : <any>null;
            this.utenteDocumenti = _data["utenteDocumenti"] !== undefined ? _data["utenteDocumenti"] : <any>null;
            this.dataEvasionePrevista = _data["dataEvasionePrevista"] !== undefined ? _data["dataEvasionePrevista"] : <any>null;
            this.dataAppuntamentoAgenzia = _data["dataAppuntamentoAgenzia"] !== undefined ? _data["dataAppuntamentoAgenzia"] : <any>null;
            this.dataConferma = _data["dataConferma"] !== undefined ? _data["dataConferma"] : <any>null;
            this.dataConfermaTO = _data["dataConfermaTO"] !== undefined ? _data["dataConfermaTO"] : <any>null;
            this.dataCancellazioneADV = _data["dataCancellazioneADV"] !== undefined ? _data["dataCancellazioneADV"] : <any>null;
            this.dataCancellazioneTO = _data["dataCancellazioneTO"] !== undefined ? _data["dataCancellazioneTO"] : <any>null;
            this.commissione = _data["commissione"] !== undefined ? _data["commissione"] : <any>null;
            this.utenteTariffaID = _data["utenteTariffaID"] !== undefined ? _data["utenteTariffaID"] : <any>null;
            this.utenteTariffa = _data["utenteTariffa"] !== undefined ? _data["utenteTariffa"] : <any>null;
            this.utenteBiglietteriaID = _data["utenteBiglietteriaID"] !== undefined ? _data["utenteBiglietteriaID"] : <any>null;
            this.utenteBiglietteria = _data["utenteBiglietteria"] !== undefined ? _data["utenteBiglietteria"] : <any>null;
            this.richiedeAggiornamentoValute = _data["richiedeAggiornamentoValute"] !== undefined ? _data["richiedeAggiornamentoValute"] : <any>null;
            this.commissioneAccordo = _data["commissioneAccordo"] !== undefined ? _data["commissioneAccordo"] : <any>null;
            this.logoUrl = _data["logoUrl"] !== undefined ? _data["logoUrl"] : <any>null;
            this.statusPreventivo = _data["statusPreventivo"] !== undefined ? _data["statusPreventivo"] : <any>null;
            if (Array.isArray(_data["tagIDs"])) {
                this.tagIDs = [] as any;
                for (let item of _data["tagIDs"])
                    this.tagIDs!.push(item);
            }
            else {
                this.tagIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): TripAgency {
        data = typeof data === 'object' ? data : {};
        let result = new TripAgency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaAgenzia"] = this.offertaAgenzia ? this.offertaAgenzia.toJSON() : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["civico"] = this.civico !== undefined ? this.civico : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["provincia"] = this.provincia !== undefined ? this.provincia : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["partitaIva"] = this.partitaIva !== undefined ? this.partitaIva : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["categoria"] = this.categoria !== undefined ? this.categoria : <any>null;
        data["pagamentoHtml"] = this.pagamentoHtml !== undefined ? this.pagamentoHtml : <any>null;
        data["contattoNetworkID"] = this.contattoNetworkID !== undefined ? this.contattoNetworkID : <any>null;
        data["network"] = this.network !== undefined ? this.network : <any>null;
        data["contattoPromoterID"] = this.contattoPromoterID !== undefined ? this.contattoPromoterID : <any>null;
        data["promoter"] = this.promoter !== undefined ? this.promoter : <any>null;
        data["telefonoPromoter"] = this.telefonoPromoter !== undefined ? this.telefonoPromoter : <any>null;
        data["acconto"] = this.acconto !== undefined ? this.acconto : <any>null;
        data["noAnticipoQuote"] = this.noAnticipoQuote !== undefined ? this.noAnticipoQuote : <any>null;
        data["accontoNozze"] = this.accontoNozze !== undefined ? this.accontoNozze : <any>null;
        data["noAnticipoBiglietti"] = this.noAnticipoBiglietti !== undefined ? this.noAnticipoBiglietti : <any>null;
        data["nomeAddetto"] = this.nomeAddetto !== undefined ? this.nomeAddetto : <any>null;
        data["emailAddetto"] = this.emailAddetto !== undefined ? this.emailAddetto : <any>null;
        data["addettoID"] = this.addettoID !== undefined ? this.addettoID : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["riferimentoCliente"] = this.riferimentoCliente !== undefined ? this.riferimentoCliente : <any>null;
        data["utentePreventivoID"] = this.utentePreventivoID !== undefined ? this.utentePreventivoID : <any>null;
        data["utentePreventivo"] = this.utentePreventivo !== undefined ? this.utentePreventivo : <any>null;
        data["utenteConfermaID"] = this.utenteConfermaID !== undefined ? this.utenteConfermaID : <any>null;
        data["utenteConferma"] = this.utenteConferma !== undefined ? this.utenteConferma : <any>null;
        data["utenteDocumentiID"] = this.utenteDocumentiID !== undefined ? this.utenteDocumentiID : <any>null;
        data["utenteDocumenti"] = this.utenteDocumenti !== undefined ? this.utenteDocumenti : <any>null;
        data["dataEvasionePrevista"] = this.dataEvasionePrevista !== undefined ? this.dataEvasionePrevista : <any>null;
        data["dataAppuntamentoAgenzia"] = this.dataAppuntamentoAgenzia !== undefined ? this.dataAppuntamentoAgenzia : <any>null;
        data["dataConferma"] = this.dataConferma !== undefined ? this.dataConferma : <any>null;
        data["dataConfermaTO"] = this.dataConfermaTO !== undefined ? this.dataConfermaTO : <any>null;
        data["dataCancellazioneADV"] = this.dataCancellazioneADV !== undefined ? this.dataCancellazioneADV : <any>null;
        data["dataCancellazioneTO"] = this.dataCancellazioneTO !== undefined ? this.dataCancellazioneTO : <any>null;
        data["commissione"] = this.commissione !== undefined ? this.commissione : <any>null;
        data["utenteTariffaID"] = this.utenteTariffaID !== undefined ? this.utenteTariffaID : <any>null;
        data["utenteTariffa"] = this.utenteTariffa !== undefined ? this.utenteTariffa : <any>null;
        data["utenteBiglietteriaID"] = this.utenteBiglietteriaID !== undefined ? this.utenteBiglietteriaID : <any>null;
        data["utenteBiglietteria"] = this.utenteBiglietteria !== undefined ? this.utenteBiglietteria : <any>null;
        data["richiedeAggiornamentoValute"] = this.richiedeAggiornamentoValute !== undefined ? this.richiedeAggiornamentoValute : <any>null;
        data["commissioneAccordo"] = this.commissioneAccordo !== undefined ? this.commissioneAccordo : <any>null;
        data["logoUrl"] = this.logoUrl !== undefined ? this.logoUrl : <any>null;
        data["statusPreventivo"] = this.statusPreventivo !== undefined ? this.statusPreventivo : <any>null;
        if (Array.isArray(this.tagIDs)) {
            data["tagIDs"] = [];
            for (let item of this.tagIDs)
                data["tagIDs"].push(item);
        }
        return data;
    }
}

export interface ITripAgency {
    offertaAgenzia?: OffertaAgenzia;
    id?: number;
    contattoID?: number;
    nome?: string | null;
    cognome?: string | null;
    indirizzo?: string | null;
    civico?: string | null;
    cap?: string | null;
    luogo?: string | null;
    provincia?: string | null;
    paese?: string | null;
    telefono?: string | null;
    fax?: string | null;
    partitaIva?: string | null;
    email?: string | null;
    categoria?: string | null;
    pagamentoHtml?: string | null;
    contattoNetworkID?: number | null;
    network?: string | null;
    contattoPromoterID?: number | null;
    promoter?: string | null;
    telefonoPromoter?: string | null;
    acconto?: number | null;
    noAnticipoQuote?: boolean;
    accontoNozze?: number | null;
    noAnticipoBiglietti?: boolean;
    nomeAddetto?: string | null;
    emailAddetto?: string | null;
    addettoID?: number | null;
    username?: string | null;
    riferimentoCliente?: string | null;
    utentePreventivoID?: number | null;
    utentePreventivo?: string | null;
    utenteConfermaID?: number | null;
    utenteConferma?: string | null;
    utenteDocumentiID?: number | null;
    utenteDocumenti?: string | null;
    dataEvasionePrevista?: string | null;
    dataAppuntamentoAgenzia?: string | null;
    dataConferma?: string | null;
    dataConfermaTO?: string | null;
    dataCancellazioneADV?: string | null;
    dataCancellazioneTO?: string | null;
    commissione?: number | null;
    utenteTariffaID?: number | null;
    utenteTariffa?: string | null;
    utenteBiglietteriaID?: number | null;
    utenteBiglietteria?: string | null;
    richiedeAggiornamentoValute?: boolean;
    commissioneAccordo?: number | null;
    logoUrl?: string | null;
    statusPreventivo?: EStatusPreventivo | null;
    tagIDs?: number[];
}

export class OffertaAgenzia implements IOffertaAgenzia {
    offertaAgenziaID?: number;
    offertaID?: number;
    utenteID?: number | null;
    contattoAgenziaID?: number | null;
    utentePreventivoID?: number | null;
    utenteConfermaID?: number | null;
    utenteDocumentiID?: number | null;
    utenteTariffaID?: number | null;
    utenteBigliettiAereiID?: number | null;
    contattoClienteDirettoID?: number | null;
    addetto?: string | null;
    emailAddetto?: string | null;
    riferimentoCliente?: string | null;
    commissione?: number | null;
    dataCreazione?: string;
    dataConferma?: string | null;
    dataConfermaTO?: string | null;
    dataCancellazioneTourOperator?: string | null;
    dataCancellazioneConferma?: string | null;
    fatturazioneAlNetto?: boolean;
    aggiornamentoValute?: EModalitaAggiornamentoValute;
    priorita?: string | null;
    cancellata?: number | null;
    teamID?: number | null;
    statusPreventivo?: EStatusPreventivo | null;
    dataAppuntamentoAgenzia?: string | null;
    contattoNetworkID?: number | null;
    contattoPromoterID?: number | null;
    dataInvioPreventivo?: string | null;
    lingua?: ELingua | null;

    constructor(data?: IOffertaAgenzia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaAgenziaID = _data["offertaAgenziaID"] !== undefined ? _data["offertaAgenziaID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.utenteID = _data["utenteID"] !== undefined ? _data["utenteID"] : <any>null;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : <any>null;
            this.utentePreventivoID = _data["utentePreventivoID"] !== undefined ? _data["utentePreventivoID"] : <any>null;
            this.utenteConfermaID = _data["utenteConfermaID"] !== undefined ? _data["utenteConfermaID"] : <any>null;
            this.utenteDocumentiID = _data["utenteDocumentiID"] !== undefined ? _data["utenteDocumentiID"] : <any>null;
            this.utenteTariffaID = _data["utenteTariffaID"] !== undefined ? _data["utenteTariffaID"] : <any>null;
            this.utenteBigliettiAereiID = _data["utenteBigliettiAereiID"] !== undefined ? _data["utenteBigliettiAereiID"] : <any>null;
            this.contattoClienteDirettoID = _data["contattoClienteDirettoID"] !== undefined ? _data["contattoClienteDirettoID"] : <any>null;
            this.addetto = _data["addetto"] !== undefined ? _data["addetto"] : <any>null;
            this.emailAddetto = _data["emailAddetto"] !== undefined ? _data["emailAddetto"] : <any>null;
            this.riferimentoCliente = _data["riferimentoCliente"] !== undefined ? _data["riferimentoCliente"] : <any>null;
            this.commissione = _data["commissione"] !== undefined ? _data["commissione"] : <any>null;
            this.dataCreazione = _data["dataCreazione"] !== undefined ? _data["dataCreazione"] : <any>null;
            this.dataConferma = _data["dataConferma"] !== undefined ? _data["dataConferma"] : <any>null;
            this.dataConfermaTO = _data["dataConfermaTO"] !== undefined ? _data["dataConfermaTO"] : <any>null;
            this.dataCancellazioneTourOperator = _data["dataCancellazioneTourOperator"] !== undefined ? _data["dataCancellazioneTourOperator"] : <any>null;
            this.dataCancellazioneConferma = _data["dataCancellazioneConferma"] !== undefined ? _data["dataCancellazioneConferma"] : <any>null;
            this.fatturazioneAlNetto = _data["fatturazioneAlNetto"] !== undefined ? _data["fatturazioneAlNetto"] : <any>null;
            this.aggiornamentoValute = _data["aggiornamentoValute"] !== undefined ? _data["aggiornamentoValute"] : <any>null;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : <any>null;
            this.cancellata = _data["cancellata"] !== undefined ? _data["cancellata"] : <any>null;
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : <any>null;
            this.statusPreventivo = _data["statusPreventivo"] !== undefined ? _data["statusPreventivo"] : <any>null;
            this.dataAppuntamentoAgenzia = _data["dataAppuntamentoAgenzia"] !== undefined ? _data["dataAppuntamentoAgenzia"] : <any>null;
            this.contattoNetworkID = _data["contattoNetworkID"] !== undefined ? _data["contattoNetworkID"] : <any>null;
            this.contattoPromoterID = _data["contattoPromoterID"] !== undefined ? _data["contattoPromoterID"] : <any>null;
            this.dataInvioPreventivo = _data["dataInvioPreventivo"] !== undefined ? _data["dataInvioPreventivo"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaAgenzia {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaAgenzia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaAgenziaID"] = this.offertaAgenziaID !== undefined ? this.offertaAgenziaID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["utenteID"] = this.utenteID !== undefined ? this.utenteID : <any>null;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : <any>null;
        data["utentePreventivoID"] = this.utentePreventivoID !== undefined ? this.utentePreventivoID : <any>null;
        data["utenteConfermaID"] = this.utenteConfermaID !== undefined ? this.utenteConfermaID : <any>null;
        data["utenteDocumentiID"] = this.utenteDocumentiID !== undefined ? this.utenteDocumentiID : <any>null;
        data["utenteTariffaID"] = this.utenteTariffaID !== undefined ? this.utenteTariffaID : <any>null;
        data["utenteBigliettiAereiID"] = this.utenteBigliettiAereiID !== undefined ? this.utenteBigliettiAereiID : <any>null;
        data["contattoClienteDirettoID"] = this.contattoClienteDirettoID !== undefined ? this.contattoClienteDirettoID : <any>null;
        data["addetto"] = this.addetto !== undefined ? this.addetto : <any>null;
        data["emailAddetto"] = this.emailAddetto !== undefined ? this.emailAddetto : <any>null;
        data["riferimentoCliente"] = this.riferimentoCliente !== undefined ? this.riferimentoCliente : <any>null;
        data["commissione"] = this.commissione !== undefined ? this.commissione : <any>null;
        data["dataCreazione"] = this.dataCreazione !== undefined ? this.dataCreazione : <any>null;
        data["dataConferma"] = this.dataConferma !== undefined ? this.dataConferma : <any>null;
        data["dataConfermaTO"] = this.dataConfermaTO !== undefined ? this.dataConfermaTO : <any>null;
        data["dataCancellazioneTourOperator"] = this.dataCancellazioneTourOperator !== undefined ? this.dataCancellazioneTourOperator : <any>null;
        data["dataCancellazioneConferma"] = this.dataCancellazioneConferma !== undefined ? this.dataCancellazioneConferma : <any>null;
        data["fatturazioneAlNetto"] = this.fatturazioneAlNetto !== undefined ? this.fatturazioneAlNetto : <any>null;
        data["aggiornamentoValute"] = this.aggiornamentoValute !== undefined ? this.aggiornamentoValute : <any>null;
        data["priorita"] = this.priorita !== undefined ? this.priorita : <any>null;
        data["cancellata"] = this.cancellata !== undefined ? this.cancellata : <any>null;
        data["teamID"] = this.teamID !== undefined ? this.teamID : <any>null;
        data["statusPreventivo"] = this.statusPreventivo !== undefined ? this.statusPreventivo : <any>null;
        data["dataAppuntamentoAgenzia"] = this.dataAppuntamentoAgenzia !== undefined ? this.dataAppuntamentoAgenzia : <any>null;
        data["contattoNetworkID"] = this.contattoNetworkID !== undefined ? this.contattoNetworkID : <any>null;
        data["contattoPromoterID"] = this.contattoPromoterID !== undefined ? this.contattoPromoterID : <any>null;
        data["dataInvioPreventivo"] = this.dataInvioPreventivo !== undefined ? this.dataInvioPreventivo : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        return data;
    }
}

export interface IOffertaAgenzia {
    offertaAgenziaID?: number;
    offertaID?: number;
    utenteID?: number | null;
    contattoAgenziaID?: number | null;
    utentePreventivoID?: number | null;
    utenteConfermaID?: number | null;
    utenteDocumentiID?: number | null;
    utenteTariffaID?: number | null;
    utenteBigliettiAereiID?: number | null;
    contattoClienteDirettoID?: number | null;
    addetto?: string | null;
    emailAddetto?: string | null;
    riferimentoCliente?: string | null;
    commissione?: number | null;
    dataCreazione?: string;
    dataConferma?: string | null;
    dataConfermaTO?: string | null;
    dataCancellazioneTourOperator?: string | null;
    dataCancellazioneConferma?: string | null;
    fatturazioneAlNetto?: boolean;
    aggiornamentoValute?: EModalitaAggiornamentoValute;
    priorita?: string | null;
    cancellata?: number | null;
    teamID?: number | null;
    statusPreventivo?: EStatusPreventivo | null;
    dataAppuntamentoAgenzia?: string | null;
    contattoNetworkID?: number | null;
    contattoPromoterID?: number | null;
    dataInvioPreventivo?: string | null;
    lingua?: ELingua | null;
}

export enum EModalitaAggiornamentoValute {
    NessunAdeguamento = "NessunAdeguamento",
    AggiornaCambi = "AggiornaCambi",
    CambiAggiornati = "CambiAggiornati",
    VerificaOfferta = "VerificaOfferta",
}

export enum EStatusPreventivo {
    DaVerificare = "DaVerificare",
    DaFare = "DaFare",
    DaModificare = "DaModificare",
    AttesaADV = "AttesaADV",
    Completato = "Completato",
    NonConcretizzato = "NonConcretizzato",
    NonEvaso = "NonEvaso",
    ConfermaDaModificare = "ConfermaDaModificare",
    NonParte = "NonParte",
    VendutoAltroTO = "VendutoAltroTO",
    NonRichiamare = "NonRichiamare",
    SupportPostVendita = "SupportPostVendita",
}

export class TripStatus implements ITripStatus {
    stato?: OffertaAgenziaStato | null;
    terminePagamento?: string | null;
    corriere?: string | null;
    acconto?: number;
    dataAcconto?: string | null;
    compensato?: number;
    dataCompensazione?: string | null;
    saldo?: number;
    dataSaldo?: string | null;
    incassi?: OffertaIncasso[];
    utenteSblocco?: string | null;
    righeSbloccabiliIDs?: number[];
    modalitaIncassi?: EModalitaIncassi;
    totaleDare?: number | null;
    totaleAvere?: number | null;
    totaleSbilancio?: number | null;
    totaleAvereScaduto?: number | null;

    constructor(data?: ITripStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stato = _data["stato"] ? OffertaAgenziaStato.fromJS(_data["stato"]) : <any>null;
            this.terminePagamento = _data["terminePagamento"] !== undefined ? _data["terminePagamento"] : <any>null;
            this.corriere = _data["corriere"] !== undefined ? _data["corriere"] : <any>null;
            this.acconto = _data["acconto"] !== undefined ? _data["acconto"] : <any>null;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : <any>null;
            this.compensato = _data["compensato"] !== undefined ? _data["compensato"] : <any>null;
            this.dataCompensazione = _data["dataCompensazione"] !== undefined ? _data["dataCompensazione"] : <any>null;
            this.saldo = _data["saldo"] !== undefined ? _data["saldo"] : <any>null;
            this.dataSaldo = _data["dataSaldo"] !== undefined ? _data["dataSaldo"] : <any>null;
            if (Array.isArray(_data["incassi"])) {
                this.incassi = [] as any;
                for (let item of _data["incassi"])
                    this.incassi!.push(OffertaIncasso.fromJS(item));
            }
            else {
                this.incassi = <any>null;
            }
            this.utenteSblocco = _data["utenteSblocco"] !== undefined ? _data["utenteSblocco"] : <any>null;
            if (Array.isArray(_data["righeSbloccabiliIDs"])) {
                this.righeSbloccabiliIDs = [] as any;
                for (let item of _data["righeSbloccabiliIDs"])
                    this.righeSbloccabiliIDs!.push(item);
            }
            else {
                this.righeSbloccabiliIDs = <any>null;
            }
            this.modalitaIncassi = _data["modalitaIncassi"] !== undefined ? _data["modalitaIncassi"] : <any>null;
            this.totaleDare = _data["totaleDare"] !== undefined ? _data["totaleDare"] : <any>null;
            this.totaleAvere = _data["totaleAvere"] !== undefined ? _data["totaleAvere"] : <any>null;
            this.totaleSbilancio = _data["totaleSbilancio"] !== undefined ? _data["totaleSbilancio"] : <any>null;
            this.totaleAvereScaduto = _data["totaleAvereScaduto"] !== undefined ? _data["totaleAvereScaduto"] : <any>null;
        }
    }

    static fromJS(data: any): TripStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TripStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stato"] = this.stato ? this.stato.toJSON() : <any>null;
        data["terminePagamento"] = this.terminePagamento !== undefined ? this.terminePagamento : <any>null;
        data["corriere"] = this.corriere !== undefined ? this.corriere : <any>null;
        data["acconto"] = this.acconto !== undefined ? this.acconto : <any>null;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : <any>null;
        data["compensato"] = this.compensato !== undefined ? this.compensato : <any>null;
        data["dataCompensazione"] = this.dataCompensazione !== undefined ? this.dataCompensazione : <any>null;
        data["saldo"] = this.saldo !== undefined ? this.saldo : <any>null;
        data["dataSaldo"] = this.dataSaldo !== undefined ? this.dataSaldo : <any>null;
        if (Array.isArray(this.incassi)) {
            data["incassi"] = [];
            for (let item of this.incassi)
                data["incassi"].push(item.toJSON());
        }
        data["utenteSblocco"] = this.utenteSblocco !== undefined ? this.utenteSblocco : <any>null;
        if (Array.isArray(this.righeSbloccabiliIDs)) {
            data["righeSbloccabiliIDs"] = [];
            for (let item of this.righeSbloccabiliIDs)
                data["righeSbloccabiliIDs"].push(item);
        }
        data["modalitaIncassi"] = this.modalitaIncassi !== undefined ? this.modalitaIncassi : <any>null;
        data["totaleDare"] = this.totaleDare !== undefined ? this.totaleDare : <any>null;
        data["totaleAvere"] = this.totaleAvere !== undefined ? this.totaleAvere : <any>null;
        data["totaleSbilancio"] = this.totaleSbilancio !== undefined ? this.totaleSbilancio : <any>null;
        data["totaleAvereScaduto"] = this.totaleAvereScaduto !== undefined ? this.totaleAvereScaduto : <any>null;
        return data;
    }
}

export interface ITripStatus {
    stato?: OffertaAgenziaStato | null;
    terminePagamento?: string | null;
    corriere?: string | null;
    acconto?: number;
    dataAcconto?: string | null;
    compensato?: number;
    dataCompensazione?: string | null;
    saldo?: number;
    dataSaldo?: string | null;
    incassi?: OffertaIncasso[];
    utenteSblocco?: string | null;
    righeSbloccabiliIDs?: number[];
    modalitaIncassi?: EModalitaIncassi;
    totaleDare?: number | null;
    totaleAvere?: number | null;
    totaleSbilancio?: number | null;
    totaleAvereScaduto?: number | null;
}

export class OffertaAgenziaStato implements IOffertaAgenziaStato {
    statusID?: number;
    offertaAgenziaID?: number;
    okAgenzia?: string | null;
    okFornitori?: string | null;
    terminePagamentoID?: number | null;
    acconto?: number | null;
    dataAcconto?: string | null;
    saldo?: number | null;
    dataSaldo?: string | null;
    invioDocumenti?: string | null;
    stampaProgramma?: string | null;
    bigliettiPresiInCarico?: string | null;
    ordinaEmissioneBiglietti?: string | null;
    stampaVoucher?: string | null;
    fattura?: number;
    networkID?: number | null;
    status?: EStatoOfferta | null;
    corriereID?: number | null;
    letteraVettura?: string | null;
    note?: string | null;
    creazioneDocumentiApp?: string | null;
    documentiAppStep1?: string | null;
    documentiAppStep2?: string | null;
    updateDocumentiApp?: string | null;
    invioDocumentiApp?: string | null;
    invioDocumentiMail?: string | null;
    okDocumenti?: string | null;
    bigliettiEmessi?: string | null;
    tipoEmissioneTicket?: ETipoTicketBiglietteria | null;
    importoAcconto?: number | null;
    tipoAccontoBiglietteria?: ETipoTicketBiglietteria | null;
    tipoAccontoServizi?: ETipoAcconto | null;
    okPassaporto?: string | null;
    haRigheConOrdinaBiglietteria?: boolean;
    righeCaricoBiglietteria?: EStatoInsieme;
    righeEmesseBiglietteria?: EStatoInsieme;
    righeOkContabileBiglietteria?: EStatoInsieme;
    okContabileBiglietteria?: string | null;
    autofattura?: number;
    dataSbloccoConferma?: string | null;
    utenteSbloccoConfermaID?: number | null;
    titoloViaggio?: string | null;
    bloccoRicalcolo?: string | null;

    constructor(data?: IOffertaAgenziaStato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusID = _data["statusID"] !== undefined ? _data["statusID"] : <any>null;
            this.offertaAgenziaID = _data["offertaAgenziaID"] !== undefined ? _data["offertaAgenziaID"] : <any>null;
            this.okAgenzia = _data["okAgenzia"] !== undefined ? _data["okAgenzia"] : <any>null;
            this.okFornitori = _data["okFornitori"] !== undefined ? _data["okFornitori"] : <any>null;
            this.terminePagamentoID = _data["terminePagamentoID"] !== undefined ? _data["terminePagamentoID"] : <any>null;
            this.acconto = _data["acconto"] !== undefined ? _data["acconto"] : <any>null;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : <any>null;
            this.saldo = _data["saldo"] !== undefined ? _data["saldo"] : <any>null;
            this.dataSaldo = _data["dataSaldo"] !== undefined ? _data["dataSaldo"] : <any>null;
            this.invioDocumenti = _data["invioDocumenti"] !== undefined ? _data["invioDocumenti"] : <any>null;
            this.stampaProgramma = _data["stampaProgramma"] !== undefined ? _data["stampaProgramma"] : <any>null;
            this.bigliettiPresiInCarico = _data["bigliettiPresiInCarico"] !== undefined ? _data["bigliettiPresiInCarico"] : <any>null;
            this.ordinaEmissioneBiglietti = _data["ordinaEmissioneBiglietti"] !== undefined ? _data["ordinaEmissioneBiglietti"] : <any>null;
            this.stampaVoucher = _data["stampaVoucher"] !== undefined ? _data["stampaVoucher"] : <any>null;
            this.fattura = _data["fattura"] !== undefined ? _data["fattura"] : <any>null;
            this.networkID = _data["networkID"] !== undefined ? _data["networkID"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.corriereID = _data["corriereID"] !== undefined ? _data["corriereID"] : <any>null;
            this.letteraVettura = _data["letteraVettura"] !== undefined ? _data["letteraVettura"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.creazioneDocumentiApp = _data["creazioneDocumentiApp"] !== undefined ? _data["creazioneDocumentiApp"] : <any>null;
            this.documentiAppStep1 = _data["documentiAppStep1"] !== undefined ? _data["documentiAppStep1"] : <any>null;
            this.documentiAppStep2 = _data["documentiAppStep2"] !== undefined ? _data["documentiAppStep2"] : <any>null;
            this.updateDocumentiApp = _data["updateDocumentiApp"] !== undefined ? _data["updateDocumentiApp"] : <any>null;
            this.invioDocumentiApp = _data["invioDocumentiApp"] !== undefined ? _data["invioDocumentiApp"] : <any>null;
            this.invioDocumentiMail = _data["invioDocumentiMail"] !== undefined ? _data["invioDocumentiMail"] : <any>null;
            this.okDocumenti = _data["okDocumenti"] !== undefined ? _data["okDocumenti"] : <any>null;
            this.bigliettiEmessi = _data["bigliettiEmessi"] !== undefined ? _data["bigliettiEmessi"] : <any>null;
            this.tipoEmissioneTicket = _data["tipoEmissioneTicket"] !== undefined ? _data["tipoEmissioneTicket"] : <any>null;
            this.importoAcconto = _data["importoAcconto"] !== undefined ? _data["importoAcconto"] : <any>null;
            this.tipoAccontoBiglietteria = _data["tipoAccontoBiglietteria"] !== undefined ? _data["tipoAccontoBiglietteria"] : <any>null;
            this.tipoAccontoServizi = _data["tipoAccontoServizi"] !== undefined ? _data["tipoAccontoServizi"] : <any>null;
            this.okPassaporto = _data["okPassaporto"] !== undefined ? _data["okPassaporto"] : <any>null;
            this.haRigheConOrdinaBiglietteria = _data["haRigheConOrdinaBiglietteria"] !== undefined ? _data["haRigheConOrdinaBiglietteria"] : <any>null;
            this.righeCaricoBiglietteria = _data["righeCaricoBiglietteria"] !== undefined ? _data["righeCaricoBiglietteria"] : <any>null;
            this.righeEmesseBiglietteria = _data["righeEmesseBiglietteria"] !== undefined ? _data["righeEmesseBiglietteria"] : <any>null;
            this.righeOkContabileBiglietteria = _data["righeOkContabileBiglietteria"] !== undefined ? _data["righeOkContabileBiglietteria"] : <any>null;
            this.okContabileBiglietteria = _data["okContabileBiglietteria"] !== undefined ? _data["okContabileBiglietteria"] : <any>null;
            this.autofattura = _data["autofattura"] !== undefined ? _data["autofattura"] : <any>null;
            this.dataSbloccoConferma = _data["dataSbloccoConferma"] !== undefined ? _data["dataSbloccoConferma"] : <any>null;
            this.utenteSbloccoConfermaID = _data["utenteSbloccoConfermaID"] !== undefined ? _data["utenteSbloccoConfermaID"] : <any>null;
            this.titoloViaggio = _data["titoloViaggio"] !== undefined ? _data["titoloViaggio"] : <any>null;
            this.bloccoRicalcolo = _data["bloccoRicalcolo"] !== undefined ? _data["bloccoRicalcolo"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaAgenziaStato {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaAgenziaStato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusID"] = this.statusID !== undefined ? this.statusID : <any>null;
        data["offertaAgenziaID"] = this.offertaAgenziaID !== undefined ? this.offertaAgenziaID : <any>null;
        data["okAgenzia"] = this.okAgenzia !== undefined ? this.okAgenzia : <any>null;
        data["okFornitori"] = this.okFornitori !== undefined ? this.okFornitori : <any>null;
        data["terminePagamentoID"] = this.terminePagamentoID !== undefined ? this.terminePagamentoID : <any>null;
        data["acconto"] = this.acconto !== undefined ? this.acconto : <any>null;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : <any>null;
        data["saldo"] = this.saldo !== undefined ? this.saldo : <any>null;
        data["dataSaldo"] = this.dataSaldo !== undefined ? this.dataSaldo : <any>null;
        data["invioDocumenti"] = this.invioDocumenti !== undefined ? this.invioDocumenti : <any>null;
        data["stampaProgramma"] = this.stampaProgramma !== undefined ? this.stampaProgramma : <any>null;
        data["bigliettiPresiInCarico"] = this.bigliettiPresiInCarico !== undefined ? this.bigliettiPresiInCarico : <any>null;
        data["ordinaEmissioneBiglietti"] = this.ordinaEmissioneBiglietti !== undefined ? this.ordinaEmissioneBiglietti : <any>null;
        data["stampaVoucher"] = this.stampaVoucher !== undefined ? this.stampaVoucher : <any>null;
        data["fattura"] = this.fattura !== undefined ? this.fattura : <any>null;
        data["networkID"] = this.networkID !== undefined ? this.networkID : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["corriereID"] = this.corriereID !== undefined ? this.corriereID : <any>null;
        data["letteraVettura"] = this.letteraVettura !== undefined ? this.letteraVettura : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["creazioneDocumentiApp"] = this.creazioneDocumentiApp !== undefined ? this.creazioneDocumentiApp : <any>null;
        data["documentiAppStep1"] = this.documentiAppStep1 !== undefined ? this.documentiAppStep1 : <any>null;
        data["documentiAppStep2"] = this.documentiAppStep2 !== undefined ? this.documentiAppStep2 : <any>null;
        data["updateDocumentiApp"] = this.updateDocumentiApp !== undefined ? this.updateDocumentiApp : <any>null;
        data["invioDocumentiApp"] = this.invioDocumentiApp !== undefined ? this.invioDocumentiApp : <any>null;
        data["invioDocumentiMail"] = this.invioDocumentiMail !== undefined ? this.invioDocumentiMail : <any>null;
        data["okDocumenti"] = this.okDocumenti !== undefined ? this.okDocumenti : <any>null;
        data["bigliettiEmessi"] = this.bigliettiEmessi !== undefined ? this.bigliettiEmessi : <any>null;
        data["tipoEmissioneTicket"] = this.tipoEmissioneTicket !== undefined ? this.tipoEmissioneTicket : <any>null;
        data["importoAcconto"] = this.importoAcconto !== undefined ? this.importoAcconto : <any>null;
        data["tipoAccontoBiglietteria"] = this.tipoAccontoBiglietteria !== undefined ? this.tipoAccontoBiglietteria : <any>null;
        data["tipoAccontoServizi"] = this.tipoAccontoServizi !== undefined ? this.tipoAccontoServizi : <any>null;
        data["okPassaporto"] = this.okPassaporto !== undefined ? this.okPassaporto : <any>null;
        data["haRigheConOrdinaBiglietteria"] = this.haRigheConOrdinaBiglietteria !== undefined ? this.haRigheConOrdinaBiglietteria : <any>null;
        data["righeCaricoBiglietteria"] = this.righeCaricoBiglietteria !== undefined ? this.righeCaricoBiglietteria : <any>null;
        data["righeEmesseBiglietteria"] = this.righeEmesseBiglietteria !== undefined ? this.righeEmesseBiglietteria : <any>null;
        data["righeOkContabileBiglietteria"] = this.righeOkContabileBiglietteria !== undefined ? this.righeOkContabileBiglietteria : <any>null;
        data["okContabileBiglietteria"] = this.okContabileBiglietteria !== undefined ? this.okContabileBiglietteria : <any>null;
        data["autofattura"] = this.autofattura !== undefined ? this.autofattura : <any>null;
        data["dataSbloccoConferma"] = this.dataSbloccoConferma !== undefined ? this.dataSbloccoConferma : <any>null;
        data["utenteSbloccoConfermaID"] = this.utenteSbloccoConfermaID !== undefined ? this.utenteSbloccoConfermaID : <any>null;
        data["titoloViaggio"] = this.titoloViaggio !== undefined ? this.titoloViaggio : <any>null;
        data["bloccoRicalcolo"] = this.bloccoRicalcolo !== undefined ? this.bloccoRicalcolo : <any>null;
        return data;
    }
}

export interface IOffertaAgenziaStato {
    statusID?: number;
    offertaAgenziaID?: number;
    okAgenzia?: string | null;
    okFornitori?: string | null;
    terminePagamentoID?: number | null;
    acconto?: number | null;
    dataAcconto?: string | null;
    saldo?: number | null;
    dataSaldo?: string | null;
    invioDocumenti?: string | null;
    stampaProgramma?: string | null;
    bigliettiPresiInCarico?: string | null;
    ordinaEmissioneBiglietti?: string | null;
    stampaVoucher?: string | null;
    fattura?: number;
    networkID?: number | null;
    status?: EStatoOfferta | null;
    corriereID?: number | null;
    letteraVettura?: string | null;
    note?: string | null;
    creazioneDocumentiApp?: string | null;
    documentiAppStep1?: string | null;
    documentiAppStep2?: string | null;
    updateDocumentiApp?: string | null;
    invioDocumentiApp?: string | null;
    invioDocumentiMail?: string | null;
    okDocumenti?: string | null;
    bigliettiEmessi?: string | null;
    tipoEmissioneTicket?: ETipoTicketBiglietteria | null;
    importoAcconto?: number | null;
    tipoAccontoBiglietteria?: ETipoTicketBiglietteria | null;
    tipoAccontoServizi?: ETipoAcconto | null;
    okPassaporto?: string | null;
    haRigheConOrdinaBiglietteria?: boolean;
    righeCaricoBiglietteria?: EStatoInsieme;
    righeEmesseBiglietteria?: EStatoInsieme;
    righeOkContabileBiglietteria?: EStatoInsieme;
    okContabileBiglietteria?: string | null;
    autofattura?: number;
    dataSbloccoConferma?: string | null;
    utenteSbloccoConfermaID?: number | null;
    titoloViaggio?: string | null;
    bloccoRicalcolo?: string | null;
}

export enum EStatoOfferta {
    Manuale = "Manuale",
    AttesaPagamento = "AttesaPagamento",
    InPrenotazione = "InPrenotazione",
    InEmissioneDoc = "InEmissioneDoc",
    ViaggioPronto = "ViaggioPronto",
    InCancellazione = "InCancellazione",
    Cancellato = "Cancellato",
    ViaggioChiuso = "ViaggioChiuso",
    ViaggioInContenzioso = "ViaggioInContenzioso",
}

export enum EStatoInsieme {
    Nessuno = "Nessuno",
    Parte = "Parte",
    Tutto = "Tutto",
}

export class TripEconomics implements ITripEconomics {
    dataConfermaTO?: string | null;
    margineLordo?: number;
    margineLordoPercentuale?: number;
    commissioniAgenzia?: number;
    commissioniAgenziaPercentuale?: number;
    margineNetto?: number;
    margineNettoPercentuale?: number;
    /** Percentuale massima delle commissioni d'agenzia sulla biglietteria. */
    maxPercentualeCommissioneAgenziaSuBiglietteria?: number;
    /** Importo massimo della commissione agenzia su biglietteria calcolata su questo viaggio */
    maxImportoCommissioneAgenziaSuBiglietteria?: number;
    /** Percentuale massima dei diritti d'agenzia */
    maxPercentualeDirittiAgenzia?: number;
    /** Importo massimo dei diritti d'agenzia calcolata su questo viaggio */
    maxImportoDirittiAgenzia?: number;
    /** Scadenze pagamenti agenzia (Avere o Previsione) */
    mastrino?: OffertaIncasso[];
    /** Per ricostruire la scaletta */
    tipoImportoAnticipo?: EImportoAnticipoMaggiore | null;
    /** Importo degli anticipi percentuali */
    importoAnticipoPercentuale?: number;
    /** Importo delle somme da anticipare comunque */
    importoSommeDaAnticipare?: number;
    /** Percentuale anticipo contrattuale */
    percentualeAnticipo?: number | null;
    /** Totale dei movimenti Dare */
    totaleIncassi?: number;
    /** Totale netto - totale incassi */
    residuoDaIncassare?: number;
    residuoDaIncassareScaduto?: number;

    constructor(data?: ITripEconomics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataConfermaTO = _data["dataConfermaTO"] !== undefined ? _data["dataConfermaTO"] : <any>null;
            this.margineLordo = _data["margineLordo"] !== undefined ? _data["margineLordo"] : <any>null;
            this.margineLordoPercentuale = _data["margineLordoPercentuale"] !== undefined ? _data["margineLordoPercentuale"] : <any>null;
            this.commissioniAgenzia = _data["commissioniAgenzia"] !== undefined ? _data["commissioniAgenzia"] : <any>null;
            this.commissioniAgenziaPercentuale = _data["commissioniAgenziaPercentuale"] !== undefined ? _data["commissioniAgenziaPercentuale"] : <any>null;
            this.margineNetto = _data["margineNetto"] !== undefined ? _data["margineNetto"] : <any>null;
            this.margineNettoPercentuale = _data["margineNettoPercentuale"] !== undefined ? _data["margineNettoPercentuale"] : <any>null;
            this.maxPercentualeCommissioneAgenziaSuBiglietteria = _data["maxPercentualeCommissioneAgenziaSuBiglietteria"] !== undefined ? _data["maxPercentualeCommissioneAgenziaSuBiglietteria"] : <any>null;
            this.maxImportoCommissioneAgenziaSuBiglietteria = _data["maxImportoCommissioneAgenziaSuBiglietteria"] !== undefined ? _data["maxImportoCommissioneAgenziaSuBiglietteria"] : <any>null;
            this.maxPercentualeDirittiAgenzia = _data["maxPercentualeDirittiAgenzia"] !== undefined ? _data["maxPercentualeDirittiAgenzia"] : <any>null;
            this.maxImportoDirittiAgenzia = _data["maxImportoDirittiAgenzia"] !== undefined ? _data["maxImportoDirittiAgenzia"] : <any>null;
            if (Array.isArray(_data["mastrino"])) {
                this.mastrino = [] as any;
                for (let item of _data["mastrino"])
                    this.mastrino!.push(OffertaIncasso.fromJS(item));
            }
            else {
                this.mastrino = <any>null;
            }
            this.tipoImportoAnticipo = _data["tipoImportoAnticipo"] !== undefined ? _data["tipoImportoAnticipo"] : <any>null;
            this.importoAnticipoPercentuale = _data["importoAnticipoPercentuale"] !== undefined ? _data["importoAnticipoPercentuale"] : <any>null;
            this.importoSommeDaAnticipare = _data["importoSommeDaAnticipare"] !== undefined ? _data["importoSommeDaAnticipare"] : <any>null;
            this.percentualeAnticipo = _data["percentualeAnticipo"] !== undefined ? _data["percentualeAnticipo"] : <any>null;
            this.totaleIncassi = _data["totaleIncassi"] !== undefined ? _data["totaleIncassi"] : <any>null;
            this.residuoDaIncassare = _data["residuoDaIncassare"] !== undefined ? _data["residuoDaIncassare"] : <any>null;
            this.residuoDaIncassareScaduto = _data["residuoDaIncassareScaduto"] !== undefined ? _data["residuoDaIncassareScaduto"] : <any>null;
        }
    }

    static fromJS(data: any): TripEconomics {
        data = typeof data === 'object' ? data : {};
        let result = new TripEconomics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataConfermaTO"] = this.dataConfermaTO !== undefined ? this.dataConfermaTO : <any>null;
        data["margineLordo"] = this.margineLordo !== undefined ? this.margineLordo : <any>null;
        data["margineLordoPercentuale"] = this.margineLordoPercentuale !== undefined ? this.margineLordoPercentuale : <any>null;
        data["commissioniAgenzia"] = this.commissioniAgenzia !== undefined ? this.commissioniAgenzia : <any>null;
        data["commissioniAgenziaPercentuale"] = this.commissioniAgenziaPercentuale !== undefined ? this.commissioniAgenziaPercentuale : <any>null;
        data["margineNetto"] = this.margineNetto !== undefined ? this.margineNetto : <any>null;
        data["margineNettoPercentuale"] = this.margineNettoPercentuale !== undefined ? this.margineNettoPercentuale : <any>null;
        data["maxPercentualeCommissioneAgenziaSuBiglietteria"] = this.maxPercentualeCommissioneAgenziaSuBiglietteria !== undefined ? this.maxPercentualeCommissioneAgenziaSuBiglietteria : <any>null;
        data["maxImportoCommissioneAgenziaSuBiglietteria"] = this.maxImportoCommissioneAgenziaSuBiglietteria !== undefined ? this.maxImportoCommissioneAgenziaSuBiglietteria : <any>null;
        data["maxPercentualeDirittiAgenzia"] = this.maxPercentualeDirittiAgenzia !== undefined ? this.maxPercentualeDirittiAgenzia : <any>null;
        data["maxImportoDirittiAgenzia"] = this.maxImportoDirittiAgenzia !== undefined ? this.maxImportoDirittiAgenzia : <any>null;
        if (Array.isArray(this.mastrino)) {
            data["mastrino"] = [];
            for (let item of this.mastrino)
                data["mastrino"].push(item.toJSON());
        }
        data["tipoImportoAnticipo"] = this.tipoImportoAnticipo !== undefined ? this.tipoImportoAnticipo : <any>null;
        data["importoAnticipoPercentuale"] = this.importoAnticipoPercentuale !== undefined ? this.importoAnticipoPercentuale : <any>null;
        data["importoSommeDaAnticipare"] = this.importoSommeDaAnticipare !== undefined ? this.importoSommeDaAnticipare : <any>null;
        data["percentualeAnticipo"] = this.percentualeAnticipo !== undefined ? this.percentualeAnticipo : <any>null;
        data["totaleIncassi"] = this.totaleIncassi !== undefined ? this.totaleIncassi : <any>null;
        data["residuoDaIncassare"] = this.residuoDaIncassare !== undefined ? this.residuoDaIncassare : <any>null;
        data["residuoDaIncassareScaduto"] = this.residuoDaIncassareScaduto !== undefined ? this.residuoDaIncassareScaduto : <any>null;
        return data;
    }
}

export interface ITripEconomics {
    dataConfermaTO?: string | null;
    margineLordo?: number;
    margineLordoPercentuale?: number;
    commissioniAgenzia?: number;
    commissioniAgenziaPercentuale?: number;
    margineNetto?: number;
    margineNettoPercentuale?: number;
    /** Percentuale massima delle commissioni d'agenzia sulla biglietteria. */
    maxPercentualeCommissioneAgenziaSuBiglietteria?: number;
    /** Importo massimo della commissione agenzia su biglietteria calcolata su questo viaggio */
    maxImportoCommissioneAgenziaSuBiglietteria?: number;
    /** Percentuale massima dei diritti d'agenzia */
    maxPercentualeDirittiAgenzia?: number;
    /** Importo massimo dei diritti d'agenzia calcolata su questo viaggio */
    maxImportoDirittiAgenzia?: number;
    /** Scadenze pagamenti agenzia (Avere o Previsione) */
    mastrino?: OffertaIncasso[];
    /** Per ricostruire la scaletta */
    tipoImportoAnticipo?: EImportoAnticipoMaggiore | null;
    /** Importo degli anticipi percentuali */
    importoAnticipoPercentuale?: number;
    /** Importo delle somme da anticipare comunque */
    importoSommeDaAnticipare?: number;
    /** Percentuale anticipo contrattuale */
    percentualeAnticipo?: number | null;
    /** Totale dei movimenti Dare */
    totaleIncassi?: number;
    /** Totale netto - totale incassi */
    residuoDaIncassare?: number;
    residuoDaIncassareScaduto?: number;
}

export enum EImportoAnticipoMaggiore {
    AnticipiContrattualiPercentuali = "AnticipiContrattualiPercentuali",
    ServiziDaPagareAllaConferma = "ServiziDaPagareAllaConferma",
}

export class TripCancelCosts implements ITripCancelCosts {
    cancelCosts?: TripCancelCostRow[];
    totalEnsuredCost?: number;

    constructor(data?: ITripCancelCosts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cancelCosts"])) {
                this.cancelCosts = [] as any;
                for (let item of _data["cancelCosts"])
                    this.cancelCosts!.push(TripCancelCostRow.fromJS(item));
            }
            else {
                this.cancelCosts = <any>null;
            }
            this.totalEnsuredCost = _data["totalEnsuredCost"] !== undefined ? _data["totalEnsuredCost"] : <any>null;
        }
    }

    static fromJS(data: any): TripCancelCosts {
        data = typeof data === 'object' ? data : {};
        let result = new TripCancelCosts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cancelCosts)) {
            data["cancelCosts"] = [];
            for (let item of this.cancelCosts)
                data["cancelCosts"].push(item.toJSON());
        }
        data["totalEnsuredCost"] = this.totalEnsuredCost !== undefined ? this.totalEnsuredCost : <any>null;
        return data;
    }
}

export interface ITripCancelCosts {
    cancelCosts?: TripCancelCostRow[];
    totalEnsuredCost?: number;
}

export class TripCancelCostRow implements ITripCancelCostRow {
    rowID?: number;
    name?: string;
    notRefundable?: boolean;
    limitDate?: string | null;
    amount?: number | null;

    constructor(data?: ITripCancelCostRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowID = _data["rowID"] !== undefined ? _data["rowID"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.notRefundable = _data["notRefundable"] !== undefined ? _data["notRefundable"] : <any>null;
            this.limitDate = _data["limitDate"] !== undefined ? _data["limitDate"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): TripCancelCostRow {
        data = typeof data === 'object' ? data : {};
        let result = new TripCancelCostRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowID"] = this.rowID !== undefined ? this.rowID : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["notRefundable"] = this.notRefundable !== undefined ? this.notRefundable : <any>null;
        data["limitDate"] = this.limitDate !== undefined ? this.limitDate : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

export interface ITripCancelCostRow {
    rowID?: number;
    name?: string;
    notRefundable?: boolean;
    limitDate?: string | null;
    amount?: number | null;
}

export class TripPaxes implements ITripPaxes {
    paxes?: TripPax[];
    abbinamenti?: TripRoom[];
    adulti?: number;
    bambini?: number;
    dataNascitaDefaultAdulto?: string;
    dataNascitaDefaultBambino?: string;
    camereSemplici?: boolean;

    constructor(data?: ITripPaxes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paxes"])) {
                this.paxes = [] as any;
                for (let item of _data["paxes"])
                    this.paxes!.push(TripPax.fromJS(item));
            }
            else {
                this.paxes = <any>null;
            }
            if (Array.isArray(_data["abbinamenti"])) {
                this.abbinamenti = [] as any;
                for (let item of _data["abbinamenti"])
                    this.abbinamenti!.push(TripRoom.fromJS(item));
            }
            else {
                this.abbinamenti = <any>null;
            }
            this.adulti = _data["adulti"] !== undefined ? _data["adulti"] : <any>null;
            this.bambini = _data["bambini"] !== undefined ? _data["bambini"] : <any>null;
            this.dataNascitaDefaultAdulto = _data["dataNascitaDefaultAdulto"] !== undefined ? _data["dataNascitaDefaultAdulto"] : <any>null;
            this.dataNascitaDefaultBambino = _data["dataNascitaDefaultBambino"] !== undefined ? _data["dataNascitaDefaultBambino"] : <any>null;
            this.camereSemplici = _data["camereSemplici"] !== undefined ? _data["camereSemplici"] : <any>null;
        }
    }

    static fromJS(data: any): TripPaxes {
        data = typeof data === 'object' ? data : {};
        let result = new TripPaxes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paxes)) {
            data["paxes"] = [];
            for (let item of this.paxes)
                data["paxes"].push(item.toJSON());
        }
        if (Array.isArray(this.abbinamenti)) {
            data["abbinamenti"] = [];
            for (let item of this.abbinamenti)
                data["abbinamenti"].push(item.toJSON());
        }
        data["adulti"] = this.adulti !== undefined ? this.adulti : <any>null;
        data["bambini"] = this.bambini !== undefined ? this.bambini : <any>null;
        data["dataNascitaDefaultAdulto"] = this.dataNascitaDefaultAdulto !== undefined ? this.dataNascitaDefaultAdulto : <any>null;
        data["dataNascitaDefaultBambino"] = this.dataNascitaDefaultBambino !== undefined ? this.dataNascitaDefaultBambino : <any>null;
        data["camereSemplici"] = this.camereSemplici !== undefined ? this.camereSemplici : <any>null;
        return data;
    }
}

export interface ITripPaxes {
    paxes?: TripPax[];
    abbinamenti?: TripRoom[];
    adulti?: number;
    bambini?: number;
    dataNascitaDefaultAdulto?: string;
    dataNascitaDefaultBambino?: string;
    camereSemplici?: boolean;
}

export class TripPax implements ITripPax {
    cliente?: Cliente;
    dati?: ClienteDato | null;
    completo?: boolean;
    camere?: string[];
    servizi?: TripService[];

    constructor(data?: ITripPax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cliente = _data["cliente"] ? Cliente.fromJS(_data["cliente"]) : <any>null;
            this.dati = _data["dati"] ? ClienteDato.fromJS(_data["dati"]) : <any>null;
            this.completo = _data["completo"] !== undefined ? _data["completo"] : <any>null;
            if (Array.isArray(_data["camere"])) {
                this.camere = [] as any;
                for (let item of _data["camere"])
                    this.camere!.push(item);
            }
            else {
                this.camere = <any>null;
            }
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(TripService.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
        }
    }

    static fromJS(data: any): TripPax {
        data = typeof data === 'object' ? data : {};
        let result = new TripPax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cliente"] = this.cliente ? this.cliente.toJSON() : <any>null;
        data["dati"] = this.dati ? this.dati.toJSON() : <any>null;
        data["completo"] = this.completo !== undefined ? this.completo : <any>null;
        if (Array.isArray(this.camere)) {
            data["camere"] = [];
            for (let item of this.camere)
                data["camere"].push(item);
        }
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripPax {
    cliente?: Cliente;
    dati?: ClienteDato | null;
    completo?: boolean;
    camere?: string[];
    servizi?: TripService[];
}

export class Cliente implements ICliente {
    clienteID?: number;
    clienteIdPrecedente?: number | null;
    offertaAgenziaID?: number | null;
    clienteLeaderID?: number | null;
    abbinamentoID?: number | null;
    titolo?: ETitolo;
    nome?: string | null;
    cognome?: string | null;
    codiceFiscale?: string | null;
    dataNascita?: string | null;
    tesseraTCI?: string | null;
    dataNascitaCorretta?: boolean;

    constructor(data?: ICliente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : <any>null;
            this.clienteIdPrecedente = _data["clienteIdPrecedente"] !== undefined ? _data["clienteIdPrecedente"] : <any>null;
            this.offertaAgenziaID = _data["offertaAgenziaID"] !== undefined ? _data["offertaAgenziaID"] : <any>null;
            this.clienteLeaderID = _data["clienteLeaderID"] !== undefined ? _data["clienteLeaderID"] : <any>null;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.codiceFiscale = _data["codiceFiscale"] !== undefined ? _data["codiceFiscale"] : <any>null;
            this.dataNascita = _data["dataNascita"] !== undefined ? _data["dataNascita"] : <any>null;
            this.tesseraTCI = _data["tesseraTCI"] !== undefined ? _data["tesseraTCI"] : <any>null;
            this.dataNascitaCorretta = _data["dataNascitaCorretta"] !== undefined ? _data["dataNascitaCorretta"] : <any>null;
        }
    }

    static fromJS(data: any): Cliente {
        data = typeof data === 'object' ? data : {};
        let result = new Cliente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : <any>null;
        data["clienteIdPrecedente"] = this.clienteIdPrecedente !== undefined ? this.clienteIdPrecedente : <any>null;
        data["offertaAgenziaID"] = this.offertaAgenziaID !== undefined ? this.offertaAgenziaID : <any>null;
        data["clienteLeaderID"] = this.clienteLeaderID !== undefined ? this.clienteLeaderID : <any>null;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["codiceFiscale"] = this.codiceFiscale !== undefined ? this.codiceFiscale : <any>null;
        data["dataNascita"] = this.dataNascita !== undefined ? this.dataNascita : <any>null;
        data["tesseraTCI"] = this.tesseraTCI !== undefined ? this.tesseraTCI : <any>null;
        data["dataNascitaCorretta"] = this.dataNascitaCorretta !== undefined ? this.dataNascitaCorretta : <any>null;
        return data;
    }
}

export interface ICliente {
    clienteID?: number;
    clienteIdPrecedente?: number | null;
    offertaAgenziaID?: number | null;
    clienteLeaderID?: number | null;
    abbinamentoID?: number | null;
    titolo?: ETitolo;
    nome?: string | null;
    cognome?: string | null;
    codiceFiscale?: string | null;
    dataNascita?: string | null;
    tesseraTCI?: string | null;
    dataNascitaCorretta?: boolean;
}

export class ClienteDato implements IClienteDato {
    id?: number;
    cellulare?: string | null;
    passaporto?: string | null;
    scadenzaPassaporto?: string | null;
    codiceIstatComune?: string | null;
    luogoNascita?: string | null;
    nazionalita?: string | null;
    paeseRilascioPass?: string | null;
    indirizzo?: string | null;
    cap?: string | null;
    comune?: string | null;
    provincia?: string | null;
    email?: string | null;

    constructor(data?: IClienteDato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.cellulare = _data["cellulare"] !== undefined ? _data["cellulare"] : <any>null;
            this.passaporto = _data["passaporto"] !== undefined ? _data["passaporto"] : <any>null;
            this.scadenzaPassaporto = _data["scadenzaPassaporto"] !== undefined ? _data["scadenzaPassaporto"] : <any>null;
            this.codiceIstatComune = _data["codiceIstatComune"] !== undefined ? _data["codiceIstatComune"] : <any>null;
            this.luogoNascita = _data["luogoNascita"] !== undefined ? _data["luogoNascita"] : <any>null;
            this.nazionalita = _data["nazionalita"] !== undefined ? _data["nazionalita"] : <any>null;
            this.paeseRilascioPass = _data["paeseRilascioPass"] !== undefined ? _data["paeseRilascioPass"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.comune = _data["comune"] !== undefined ? _data["comune"] : <any>null;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): ClienteDato {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteDato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["cellulare"] = this.cellulare !== undefined ? this.cellulare : <any>null;
        data["passaporto"] = this.passaporto !== undefined ? this.passaporto : <any>null;
        data["scadenzaPassaporto"] = this.scadenzaPassaporto !== undefined ? this.scadenzaPassaporto : <any>null;
        data["codiceIstatComune"] = this.codiceIstatComune !== undefined ? this.codiceIstatComune : <any>null;
        data["luogoNascita"] = this.luogoNascita !== undefined ? this.luogoNascita : <any>null;
        data["nazionalita"] = this.nazionalita !== undefined ? this.nazionalita : <any>null;
        data["paeseRilascioPass"] = this.paeseRilascioPass !== undefined ? this.paeseRilascioPass : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["comune"] = this.comune !== undefined ? this.comune : <any>null;
        data["provincia"] = this.provincia !== undefined ? this.provincia : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface IClienteDato {
    id?: number;
    cellulare?: string | null;
    passaporto?: string | null;
    scadenzaPassaporto?: string | null;
    codiceIstatComune?: string | null;
    luogoNascita?: string | null;
    nazionalita?: string | null;
    paeseRilascioPass?: string | null;
    indirizzo?: string | null;
    cap?: string | null;
    comune?: string | null;
    provincia?: string | null;
    email?: string | null;
}

export class TripService implements ITripService {
    id?: number;
    luogo?: string | null;
    luogoFine?: string | null;
    abbinamento?: string | null;
    cliente?: string | null;
    /** Data e ora di checkin / inizio */
    data?: string;
    /** Data e ora di checkout / fine */
    dataCheckout?: string | null;
    notti?: number;
    isHotel?: boolean;
    isVolo?: boolean;
    isNoleggio?: boolean;
    isTrasferimento?: boolean;
    isVisita?: boolean;
    haPaginaDettaglio?: boolean;
    descrizione?: string | null;
    /** Descrizione da usare nel programma di viaggio */
    descrizioneProgramma?: string | null;
    urlPart?: string | null;
    servizioID?: number | null;
    esterno?: boolean;
    disponibilita?: EStatoDisponibilita;
    disponibilitaPrecedente?: EStatoDisponibilita | null;
    daQuotare?: boolean;
    prezzoIndicativo?: boolean;
    status?: EStatoServizioUtente;
    numeroConferma?: string | null;
    accessori?: boolean;
    prezzo?: number;
    pagamentoAnticipato?: boolean;
    adulti?: number;
    bambini?: number;
    prezzoPrecedente?: number | null;
    dati?: TripServiceData | null;
    penale?: PenaleServizio | null;
    printableAccessori?: boolean;
    eliminabile?: boolean;
    eliminabileAgenzia?: boolean;
    nascostoAgenzia?: boolean;
    /** True se il servizio ha un pagamento fornitore associato che è sbloccabile */
    pagamentoSbloccabile?: boolean;
    /** Elenco delle note associate a questa riga prelevate dagli articoli */
    note?: TripTextHtml[] | null;
    /** Elenco delle offerte speciali / azioni applicate  */
    dettagliPrezzi?: TripServicePriceDetail[];
    /** Elenco delle componenti del prezzo */
    composizionePrezzo?: TripServicePriceDetail[] | null;
    /** Testo dell'articolo penali di cancellazione da visualizzare all'agenzia.
Calcolato in base alla presenza: di una nota custom, di un articolo di penale, dei dati aggiuntivi penale default, della nota fornitore
in questo ordine */
    testoPenali?: TripTextHtml | null;
    /** Indica quale degli eventuali molteplici testi di penale è destinato all'agenzia */
    tipoTestoPenale?: ETestoPenaleAgenzia;
    durata?: ServiceDuration | null;
    tappe?: string | null;
    /** Data di ultimo aggiornamento dei prezzi */
    dataUltimoAggiornamento?: string | null;
    /** Lista da usare per associare le note a piè di pagina sui documenti */
    elencoNotePiePagina?: number[];
    /** Lista da usare per associare le righe dello specchietto anticipi sui documenti. Per ora in teoria max 1 riferimento.
Ma conoscendo i nostri polli... */
    elencoRiferimentiAnticipi?: number[];
    fullContent?: boolean;

    constructor(data?: ITripService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.luogoFine = _data["luogoFine"] !== undefined ? _data["luogoFine"] : <any>null;
            this.abbinamento = _data["abbinamento"] !== undefined ? _data["abbinamento"] : <any>null;
            this.cliente = _data["cliente"] !== undefined ? _data["cliente"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.dataCheckout = _data["dataCheckout"] !== undefined ? _data["dataCheckout"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            this.isHotel = _data["isHotel"] !== undefined ? _data["isHotel"] : <any>null;
            this.isVolo = _data["isVolo"] !== undefined ? _data["isVolo"] : <any>null;
            this.isNoleggio = _data["isNoleggio"] !== undefined ? _data["isNoleggio"] : <any>null;
            this.isTrasferimento = _data["isTrasferimento"] !== undefined ? _data["isTrasferimento"] : <any>null;
            this.isVisita = _data["isVisita"] !== undefined ? _data["isVisita"] : <any>null;
            this.haPaginaDettaglio = _data["haPaginaDettaglio"] !== undefined ? _data["haPaginaDettaglio"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.descrizioneProgramma = _data["descrizioneProgramma"] !== undefined ? _data["descrizioneProgramma"] : <any>null;
            this.urlPart = _data["urlPart"] !== undefined ? _data["urlPart"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.esterno = _data["esterno"] !== undefined ? _data["esterno"] : <any>null;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : <any>null;
            this.disponibilitaPrecedente = _data["disponibilitaPrecedente"] !== undefined ? _data["disponibilitaPrecedente"] : <any>null;
            this.daQuotare = _data["daQuotare"] !== undefined ? _data["daQuotare"] : <any>null;
            this.prezzoIndicativo = _data["prezzoIndicativo"] !== undefined ? _data["prezzoIndicativo"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.numeroConferma = _data["numeroConferma"] !== undefined ? _data["numeroConferma"] : <any>null;
            this.accessori = _data["accessori"] !== undefined ? _data["accessori"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.pagamentoAnticipato = _data["pagamentoAnticipato"] !== undefined ? _data["pagamentoAnticipato"] : <any>null;
            this.adulti = _data["adulti"] !== undefined ? _data["adulti"] : <any>null;
            this.bambini = _data["bambini"] !== undefined ? _data["bambini"] : <any>null;
            this.prezzoPrecedente = _data["prezzoPrecedente"] !== undefined ? _data["prezzoPrecedente"] : <any>null;
            this.dati = _data["dati"] ? TripServiceData.fromJS(_data["dati"]) : <any>null;
            this.penale = _data["penale"] ? PenaleServizio.fromJS(_data["penale"]) : <any>null;
            this.printableAccessori = _data["printableAccessori"] !== undefined ? _data["printableAccessori"] : <any>null;
            this.eliminabile = _data["eliminabile"] !== undefined ? _data["eliminabile"] : <any>null;
            this.eliminabileAgenzia = _data["eliminabileAgenzia"] !== undefined ? _data["eliminabileAgenzia"] : <any>null;
            this.nascostoAgenzia = _data["nascostoAgenzia"] !== undefined ? _data["nascostoAgenzia"] : <any>null;
            this.pagamentoSbloccabile = _data["pagamentoSbloccabile"] !== undefined ? _data["pagamentoSbloccabile"] : <any>null;
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(TripTextHtml.fromJS(item));
            }
            else {
                this.note = <any>null;
            }
            if (Array.isArray(_data["dettagliPrezzi"])) {
                this.dettagliPrezzi = [] as any;
                for (let item of _data["dettagliPrezzi"])
                    this.dettagliPrezzi!.push(TripServicePriceDetail.fromJS(item));
            }
            else {
                this.dettagliPrezzi = <any>null;
            }
            if (Array.isArray(_data["composizionePrezzo"])) {
                this.composizionePrezzo = [] as any;
                for (let item of _data["composizionePrezzo"])
                    this.composizionePrezzo!.push(TripServicePriceDetail.fromJS(item));
            }
            else {
                this.composizionePrezzo = <any>null;
            }
            this.testoPenali = _data["testoPenali"] ? TripTextHtml.fromJS(_data["testoPenali"]) : <any>null;
            this.tipoTestoPenale = _data["tipoTestoPenale"] !== undefined ? _data["tipoTestoPenale"] : <any>null;
            this.durata = _data["durata"] ? ServiceDuration.fromJS(_data["durata"]) : <any>null;
            this.tappe = _data["tappe"] !== undefined ? _data["tappe"] : <any>null;
            this.dataUltimoAggiornamento = _data["dataUltimoAggiornamento"] !== undefined ? _data["dataUltimoAggiornamento"] : <any>null;
            if (Array.isArray(_data["elencoNotePiePagina"])) {
                this.elencoNotePiePagina = [] as any;
                for (let item of _data["elencoNotePiePagina"])
                    this.elencoNotePiePagina!.push(item);
            }
            else {
                this.elencoNotePiePagina = <any>null;
            }
            if (Array.isArray(_data["elencoRiferimentiAnticipi"])) {
                this.elencoRiferimentiAnticipi = [] as any;
                for (let item of _data["elencoRiferimentiAnticipi"])
                    this.elencoRiferimentiAnticipi!.push(item);
            }
            else {
                this.elencoRiferimentiAnticipi = <any>null;
            }
            this.fullContent = _data["fullContent"] !== undefined ? _data["fullContent"] : <any>null;
        }
    }

    static fromJS(data: any): TripService {
        data = typeof data === 'object' ? data : {};
        let result = new TripService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["luogoFine"] = this.luogoFine !== undefined ? this.luogoFine : <any>null;
        data["abbinamento"] = this.abbinamento !== undefined ? this.abbinamento : <any>null;
        data["cliente"] = this.cliente !== undefined ? this.cliente : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["dataCheckout"] = this.dataCheckout !== undefined ? this.dataCheckout : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        data["isHotel"] = this.isHotel !== undefined ? this.isHotel : <any>null;
        data["isVolo"] = this.isVolo !== undefined ? this.isVolo : <any>null;
        data["isNoleggio"] = this.isNoleggio !== undefined ? this.isNoleggio : <any>null;
        data["isTrasferimento"] = this.isTrasferimento !== undefined ? this.isTrasferimento : <any>null;
        data["isVisita"] = this.isVisita !== undefined ? this.isVisita : <any>null;
        data["haPaginaDettaglio"] = this.haPaginaDettaglio !== undefined ? this.haPaginaDettaglio : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["descrizioneProgramma"] = this.descrizioneProgramma !== undefined ? this.descrizioneProgramma : <any>null;
        data["urlPart"] = this.urlPart !== undefined ? this.urlPart : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["esterno"] = this.esterno !== undefined ? this.esterno : <any>null;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : <any>null;
        data["disponibilitaPrecedente"] = this.disponibilitaPrecedente !== undefined ? this.disponibilitaPrecedente : <any>null;
        data["daQuotare"] = this.daQuotare !== undefined ? this.daQuotare : <any>null;
        data["prezzoIndicativo"] = this.prezzoIndicativo !== undefined ? this.prezzoIndicativo : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["numeroConferma"] = this.numeroConferma !== undefined ? this.numeroConferma : <any>null;
        data["accessori"] = this.accessori !== undefined ? this.accessori : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["pagamentoAnticipato"] = this.pagamentoAnticipato !== undefined ? this.pagamentoAnticipato : <any>null;
        data["adulti"] = this.adulti !== undefined ? this.adulti : <any>null;
        data["bambini"] = this.bambini !== undefined ? this.bambini : <any>null;
        data["prezzoPrecedente"] = this.prezzoPrecedente !== undefined ? this.prezzoPrecedente : <any>null;
        data["dati"] = this.dati ? this.dati.toJSON() : <any>null;
        data["penale"] = this.penale ? this.penale.toJSON() : <any>null;
        data["printableAccessori"] = this.printableAccessori !== undefined ? this.printableAccessori : <any>null;
        data["eliminabile"] = this.eliminabile !== undefined ? this.eliminabile : <any>null;
        data["eliminabileAgenzia"] = this.eliminabileAgenzia !== undefined ? this.eliminabileAgenzia : <any>null;
        data["nascostoAgenzia"] = this.nascostoAgenzia !== undefined ? this.nascostoAgenzia : <any>null;
        data["pagamentoSbloccabile"] = this.pagamentoSbloccabile !== undefined ? this.pagamentoSbloccabile : <any>null;
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item.toJSON());
        }
        if (Array.isArray(this.dettagliPrezzi)) {
            data["dettagliPrezzi"] = [];
            for (let item of this.dettagliPrezzi)
                data["dettagliPrezzi"].push(item.toJSON());
        }
        if (Array.isArray(this.composizionePrezzo)) {
            data["composizionePrezzo"] = [];
            for (let item of this.composizionePrezzo)
                data["composizionePrezzo"].push(item.toJSON());
        }
        data["testoPenali"] = this.testoPenali ? this.testoPenali.toJSON() : <any>null;
        data["tipoTestoPenale"] = this.tipoTestoPenale !== undefined ? this.tipoTestoPenale : <any>null;
        data["durata"] = this.durata ? this.durata.toJSON() : <any>null;
        data["tappe"] = this.tappe !== undefined ? this.tappe : <any>null;
        data["dataUltimoAggiornamento"] = this.dataUltimoAggiornamento !== undefined ? this.dataUltimoAggiornamento : <any>null;
        if (Array.isArray(this.elencoNotePiePagina)) {
            data["elencoNotePiePagina"] = [];
            for (let item of this.elencoNotePiePagina)
                data["elencoNotePiePagina"].push(item);
        }
        if (Array.isArray(this.elencoRiferimentiAnticipi)) {
            data["elencoRiferimentiAnticipi"] = [];
            for (let item of this.elencoRiferimentiAnticipi)
                data["elencoRiferimentiAnticipi"].push(item);
        }
        data["fullContent"] = this.fullContent !== undefined ? this.fullContent : <any>null;
        return data;
    }
}

export interface ITripService {
    id?: number;
    luogo?: string | null;
    luogoFine?: string | null;
    abbinamento?: string | null;
    cliente?: string | null;
    /** Data e ora di checkin / inizio */
    data?: string;
    /** Data e ora di checkout / fine */
    dataCheckout?: string | null;
    notti?: number;
    isHotel?: boolean;
    isVolo?: boolean;
    isNoleggio?: boolean;
    isTrasferimento?: boolean;
    isVisita?: boolean;
    haPaginaDettaglio?: boolean;
    descrizione?: string | null;
    /** Descrizione da usare nel programma di viaggio */
    descrizioneProgramma?: string | null;
    urlPart?: string | null;
    servizioID?: number | null;
    esterno?: boolean;
    disponibilita?: EStatoDisponibilita;
    disponibilitaPrecedente?: EStatoDisponibilita | null;
    daQuotare?: boolean;
    prezzoIndicativo?: boolean;
    status?: EStatoServizioUtente;
    numeroConferma?: string | null;
    accessori?: boolean;
    prezzo?: number;
    pagamentoAnticipato?: boolean;
    adulti?: number;
    bambini?: number;
    prezzoPrecedente?: number | null;
    dati?: TripServiceData | null;
    penale?: PenaleServizio | null;
    printableAccessori?: boolean;
    eliminabile?: boolean;
    eliminabileAgenzia?: boolean;
    nascostoAgenzia?: boolean;
    /** True se il servizio ha un pagamento fornitore associato che è sbloccabile */
    pagamentoSbloccabile?: boolean;
    /** Elenco delle note associate a questa riga prelevate dagli articoli */
    note?: TripTextHtml[] | null;
    /** Elenco delle offerte speciali / azioni applicate  */
    dettagliPrezzi?: TripServicePriceDetail[];
    /** Elenco delle componenti del prezzo */
    composizionePrezzo?: TripServicePriceDetail[] | null;
    /** Testo dell'articolo penali di cancellazione da visualizzare all'agenzia.
Calcolato in base alla presenza: di una nota custom, di un articolo di penale, dei dati aggiuntivi penale default, della nota fornitore
in questo ordine */
    testoPenali?: TripTextHtml | null;
    /** Indica quale degli eventuali molteplici testi di penale è destinato all'agenzia */
    tipoTestoPenale?: ETestoPenaleAgenzia;
    durata?: ServiceDuration | null;
    tappe?: string | null;
    /** Data di ultimo aggiornamento dei prezzi */
    dataUltimoAggiornamento?: string | null;
    /** Lista da usare per associare le note a piè di pagina sui documenti */
    elencoNotePiePagina?: number[];
    /** Lista da usare per associare le righe dello specchietto anticipi sui documenti. Per ora in teoria max 1 riferimento.
Ma conoscendo i nostri polli... */
    elencoRiferimentiAnticipi?: number[];
    fullContent?: boolean;
}

export enum EStatoDisponibilita {
    NonDisponibile = "NonDisponibile",
    SuRichiesta = "SuRichiesta",
    Disponibile = "Disponibile",
    DaVerificare = "DaVerificare",
    DisponibileFreesale = "DisponibileFreesale",
    NonDisponibileNoMatchRegola = "NonDisponibileNoMatchRegola",
    Indeterminato = "Indeterminato",
}

export enum EStatoServizioUtente {
    Nessuno = "Nessuno",
    PrezziDispoVariati = "PrezziDispoVariati",
    InPrenotazione = "InPrenotazione",
    Confermato = "Confermato",
    Annullato = "Annullato",
}

export class TripServiceData implements ITripServiceData {
    offertaDato?: OffertaDato | null;
    stato?: OffertaDatoStato | null;
    datiH2H?: OffertaDatoH2H | null;
    /** Tipologia fornitore associata.
Null se non è un h2h oppure se è una tipologia basata su hashcode */
    tipologiaFornitore?: HHCodice | null;
    /** Nome per esteso ed in lingua della tipologia mappata (nei pochi casi in cui c'è) */
    tipologiaNaarMappata?: string | null;
    /** Servizio del fornitore associato
Null se non è un servizio H2H oppure se è una tipologia basata su hashcode */
    servizioFornitore?: HHServizio | null;
    /** Luogo del fornitore associato.
Null se non è un servizio H2H oppure se è una tipologia basata su hashcode */
    luogoFornitore?: HHLuogo | null;
    /** Nome per esteso del luogo Naar mappato sul LuogoFornitore se presente e mappato. */
    luogoNaarMappato?: string | null;
    /** Servizio H2H se è tale */
    servizioAggregato?: HHServizioAggregato | null;
    /** Nome per esteso del servizio Naar associato al ServizioAggregato se presente e mappato */
    servizioNaarMappato?: string | null;
    /** Descrizione dell'hashcode calcolato */
    hashcodeDescription?: HHAttributoHashcodeDescription | null;
    /** Hashcode originale associato alla tipologia fornitore */
    hashcodeTiplogia?: HHAttributoHashcode | null;
    /** Descrizione dell'hashcode sorgente della tipologia */
    hashcodeTipologiaDescription?: HHAttributoHashcodeDescription | null;
    dettagli?: OffertaDatoDettaglio[] | null;
    supplementi?: TripServiceData[] | null;
    /** Dati per i documenti */
    datiDocumento?: DatiDocumentoRiga | null;
    /** Dati di conferma */
    datiConferma?: DatiConfermaRiga | null;
    /** Note abbinate a questa riga */
    note?: OffertaNota[] | null;
    notaH2H?: string | null;
    data?: string;
    dataCheckout?: string | null;
    dataAcconto?: string | null;
    camera?: string | null;
    nomeServizioFornitore?: string | null;
    nomeServizioNaar?: string | null;
    eliminato?: boolean;
    obsoleto?: boolean;
    servizioH2H?: string | null;
    tipologiaH2H?: string | null;
    nomeAccordo?: string | null;
    costo?: number;
    valutaCosto?: string | null;
    marginePercentule?: number;
    accordoH2H?: boolean;
    totaleDaAnticipare?: number;
    tipoAcconto?: ETipoAcconto;
    statoServizioAlternativo?: EStatoServizioAlternativo;
    /** Eventuale nota H2H del fornitore. Tipicamente il testo è HTML */
    notaFornitore?: TripNote | null;
    /** Testo dell'articolo penali di cancellazione, se c'è. */
    articoloPenali?: TripTextHtml | null;
    /** Nota custom delle penali di cancellazione, se ce n'è una */
    notaPenaliCustom?: TripNote | null;
    /** Testo ricavato dalle penali di default dei dati aggiuntivi */
    testoPenaliDatiAggiuntivi?: string | null;
    /** Dati dell'anticipo al fornitore, se previsti */
    anticipoFornitore?: AnticipoFornitore | null;
    /** Nome della regola di anticipo al fornitore */
    regolaAnticipoFornitore?: string | null;
    /** Elenco degli invii dell'assicurazione, una riga per ogni cliente */
    inviiAssicurazioneFilodiretto?: InvioAssicurazioneFiloDiretto[] | null;
    inviiAssicurazione?: InvioAssicurazione[] | null;
    fullContent?: boolean;

    constructor(data?: ITripServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaDato = _data["offertaDato"] ? OffertaDato.fromJS(_data["offertaDato"]) : <any>null;
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : <any>null;
            this.datiH2H = _data["datiH2H"] ? OffertaDatoH2H.fromJS(_data["datiH2H"]) : <any>null;
            this.tipologiaFornitore = _data["tipologiaFornitore"] ? HHCodice.fromJS(_data["tipologiaFornitore"]) : <any>null;
            this.tipologiaNaarMappata = _data["tipologiaNaarMappata"] !== undefined ? _data["tipologiaNaarMappata"] : <any>null;
            this.servizioFornitore = _data["servizioFornitore"] ? HHServizio.fromJS(_data["servizioFornitore"]) : <any>null;
            this.luogoFornitore = _data["luogoFornitore"] ? HHLuogo.fromJS(_data["luogoFornitore"]) : <any>null;
            this.luogoNaarMappato = _data["luogoNaarMappato"] !== undefined ? _data["luogoNaarMappato"] : <any>null;
            this.servizioAggregato = _data["servizioAggregato"] ? HHServizioAggregato.fromJS(_data["servizioAggregato"]) : <any>null;
            this.servizioNaarMappato = _data["servizioNaarMappato"] !== undefined ? _data["servizioNaarMappato"] : <any>null;
            this.hashcodeDescription = _data["hashcodeDescription"] ? HHAttributoHashcodeDescription.fromJS(_data["hashcodeDescription"]) : <any>null;
            this.hashcodeTiplogia = _data["hashcodeTiplogia"] ? HHAttributoHashcode.fromJS(_data["hashcodeTiplogia"]) : <any>null;
            this.hashcodeTipologiaDescription = _data["hashcodeTipologiaDescription"] ? HHAttributoHashcodeDescription.fromJS(_data["hashcodeTipologiaDescription"]) : <any>null;
            if (Array.isArray(_data["dettagli"])) {
                this.dettagli = [] as any;
                for (let item of _data["dettagli"])
                    this.dettagli!.push(OffertaDatoDettaglio.fromJS(item));
            }
            else {
                this.dettagli = <any>null;
            }
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(TripServiceData.fromJS(item));
            }
            else {
                this.supplementi = <any>null;
            }
            this.datiDocumento = _data["datiDocumento"] ? DatiDocumentoRiga.fromJS(_data["datiDocumento"]) : <any>null;
            this.datiConferma = _data["datiConferma"] ? DatiConfermaRiga.fromJS(_data["datiConferma"]) : <any>null;
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(OffertaNota.fromJS(item));
            }
            else {
                this.note = <any>null;
            }
            this.notaH2H = _data["notaH2H"] !== undefined ? _data["notaH2H"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.dataCheckout = _data["dataCheckout"] !== undefined ? _data["dataCheckout"] : <any>null;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : <any>null;
            this.camera = _data["camera"] !== undefined ? _data["camera"] : <any>null;
            this.nomeServizioFornitore = _data["nomeServizioFornitore"] !== undefined ? _data["nomeServizioFornitore"] : <any>null;
            this.nomeServizioNaar = _data["nomeServizioNaar"] !== undefined ? _data["nomeServizioNaar"] : <any>null;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : <any>null;
            this.obsoleto = _data["obsoleto"] !== undefined ? _data["obsoleto"] : <any>null;
            this.servizioH2H = _data["servizioH2H"] !== undefined ? _data["servizioH2H"] : <any>null;
            this.tipologiaH2H = _data["tipologiaH2H"] !== undefined ? _data["tipologiaH2H"] : <any>null;
            this.nomeAccordo = _data["nomeAccordo"] !== undefined ? _data["nomeAccordo"] : <any>null;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : <any>null;
            this.valutaCosto = _data["valutaCosto"] !== undefined ? _data["valutaCosto"] : <any>null;
            this.marginePercentule = _data["marginePercentule"] !== undefined ? _data["marginePercentule"] : <any>null;
            this.accordoH2H = _data["accordoH2H"] !== undefined ? _data["accordoH2H"] : <any>null;
            this.totaleDaAnticipare = _data["totaleDaAnticipare"] !== undefined ? _data["totaleDaAnticipare"] : <any>null;
            this.tipoAcconto = _data["tipoAcconto"] !== undefined ? _data["tipoAcconto"] : <any>null;
            this.statoServizioAlternativo = _data["statoServizioAlternativo"] !== undefined ? _data["statoServizioAlternativo"] : <any>null;
            this.notaFornitore = _data["notaFornitore"] ? TripNote.fromJS(_data["notaFornitore"]) : <any>null;
            this.articoloPenali = _data["articoloPenali"] ? TripTextHtml.fromJS(_data["articoloPenali"]) : <any>null;
            this.notaPenaliCustom = _data["notaPenaliCustom"] ? TripNote.fromJS(_data["notaPenaliCustom"]) : <any>null;
            this.testoPenaliDatiAggiuntivi = _data["testoPenaliDatiAggiuntivi"] !== undefined ? _data["testoPenaliDatiAggiuntivi"] : <any>null;
            this.anticipoFornitore = _data["anticipoFornitore"] ? AnticipoFornitore.fromJS(_data["anticipoFornitore"]) : <any>null;
            this.regolaAnticipoFornitore = _data["regolaAnticipoFornitore"] !== undefined ? _data["regolaAnticipoFornitore"] : <any>null;
            if (Array.isArray(_data["inviiAssicurazioneFilodiretto"])) {
                this.inviiAssicurazioneFilodiretto = [] as any;
                for (let item of _data["inviiAssicurazioneFilodiretto"])
                    this.inviiAssicurazioneFilodiretto!.push(InvioAssicurazioneFiloDiretto.fromJS(item));
            }
            else {
                this.inviiAssicurazioneFilodiretto = <any>null;
            }
            if (Array.isArray(_data["inviiAssicurazione"])) {
                this.inviiAssicurazione = [] as any;
                for (let item of _data["inviiAssicurazione"])
                    this.inviiAssicurazione!.push(InvioAssicurazione.fromJS(item));
            }
            else {
                this.inviiAssicurazione = <any>null;
            }
            this.fullContent = _data["fullContent"] !== undefined ? _data["fullContent"] : <any>null;
        }
    }

    static fromJS(data: any): TripServiceData {
        data = typeof data === 'object' ? data : {};
        let result = new TripServiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDato"] = this.offertaDato ? this.offertaDato.toJSON() : <any>null;
        data["stato"] = this.stato ? this.stato.toJSON() : <any>null;
        data["datiH2H"] = this.datiH2H ? this.datiH2H.toJSON() : <any>null;
        data["tipologiaFornitore"] = this.tipologiaFornitore ? this.tipologiaFornitore.toJSON() : <any>null;
        data["tipologiaNaarMappata"] = this.tipologiaNaarMappata !== undefined ? this.tipologiaNaarMappata : <any>null;
        data["servizioFornitore"] = this.servizioFornitore ? this.servizioFornitore.toJSON() : <any>null;
        data["luogoFornitore"] = this.luogoFornitore ? this.luogoFornitore.toJSON() : <any>null;
        data["luogoNaarMappato"] = this.luogoNaarMappato !== undefined ? this.luogoNaarMappato : <any>null;
        data["servizioAggregato"] = this.servizioAggregato ? this.servizioAggregato.toJSON() : <any>null;
        data["servizioNaarMappato"] = this.servizioNaarMappato !== undefined ? this.servizioNaarMappato : <any>null;
        data["hashcodeDescription"] = this.hashcodeDescription ? this.hashcodeDescription.toJSON() : <any>null;
        data["hashcodeTiplogia"] = this.hashcodeTiplogia ? this.hashcodeTiplogia.toJSON() : <any>null;
        data["hashcodeTipologiaDescription"] = this.hashcodeTipologiaDescription ? this.hashcodeTipologiaDescription.toJSON() : <any>null;
        if (Array.isArray(this.dettagli)) {
            data["dettagli"] = [];
            for (let item of this.dettagli)
                data["dettagli"].push(item.toJSON());
        }
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item.toJSON());
        }
        data["datiDocumento"] = this.datiDocumento ? this.datiDocumento.toJSON() : <any>null;
        data["datiConferma"] = this.datiConferma ? this.datiConferma.toJSON() : <any>null;
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item.toJSON());
        }
        data["notaH2H"] = this.notaH2H !== undefined ? this.notaH2H : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["dataCheckout"] = this.dataCheckout !== undefined ? this.dataCheckout : <any>null;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : <any>null;
        data["camera"] = this.camera !== undefined ? this.camera : <any>null;
        data["nomeServizioFornitore"] = this.nomeServizioFornitore !== undefined ? this.nomeServizioFornitore : <any>null;
        data["nomeServizioNaar"] = this.nomeServizioNaar !== undefined ? this.nomeServizioNaar : <any>null;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : <any>null;
        data["obsoleto"] = this.obsoleto !== undefined ? this.obsoleto : <any>null;
        data["servizioH2H"] = this.servizioH2H !== undefined ? this.servizioH2H : <any>null;
        data["tipologiaH2H"] = this.tipologiaH2H !== undefined ? this.tipologiaH2H : <any>null;
        data["nomeAccordo"] = this.nomeAccordo !== undefined ? this.nomeAccordo : <any>null;
        data["costo"] = this.costo !== undefined ? this.costo : <any>null;
        data["valutaCosto"] = this.valutaCosto !== undefined ? this.valutaCosto : <any>null;
        data["marginePercentule"] = this.marginePercentule !== undefined ? this.marginePercentule : <any>null;
        data["accordoH2H"] = this.accordoH2H !== undefined ? this.accordoH2H : <any>null;
        data["totaleDaAnticipare"] = this.totaleDaAnticipare !== undefined ? this.totaleDaAnticipare : <any>null;
        data["tipoAcconto"] = this.tipoAcconto !== undefined ? this.tipoAcconto : <any>null;
        data["statoServizioAlternativo"] = this.statoServizioAlternativo !== undefined ? this.statoServizioAlternativo : <any>null;
        data["notaFornitore"] = this.notaFornitore ? this.notaFornitore.toJSON() : <any>null;
        data["articoloPenali"] = this.articoloPenali ? this.articoloPenali.toJSON() : <any>null;
        data["notaPenaliCustom"] = this.notaPenaliCustom ? this.notaPenaliCustom.toJSON() : <any>null;
        data["testoPenaliDatiAggiuntivi"] = this.testoPenaliDatiAggiuntivi !== undefined ? this.testoPenaliDatiAggiuntivi : <any>null;
        data["anticipoFornitore"] = this.anticipoFornitore ? this.anticipoFornitore.toJSON() : <any>null;
        data["regolaAnticipoFornitore"] = this.regolaAnticipoFornitore !== undefined ? this.regolaAnticipoFornitore : <any>null;
        if (Array.isArray(this.inviiAssicurazioneFilodiretto)) {
            data["inviiAssicurazioneFilodiretto"] = [];
            for (let item of this.inviiAssicurazioneFilodiretto)
                data["inviiAssicurazioneFilodiretto"].push(item.toJSON());
        }
        if (Array.isArray(this.inviiAssicurazione)) {
            data["inviiAssicurazione"] = [];
            for (let item of this.inviiAssicurazione)
                data["inviiAssicurazione"].push(item.toJSON());
        }
        data["fullContent"] = this.fullContent !== undefined ? this.fullContent : <any>null;
        return data;
    }
}

export interface ITripServiceData {
    offertaDato?: OffertaDato | null;
    stato?: OffertaDatoStato | null;
    datiH2H?: OffertaDatoH2H | null;
    /** Tipologia fornitore associata.
Null se non è un h2h oppure se è una tipologia basata su hashcode */
    tipologiaFornitore?: HHCodice | null;
    /** Nome per esteso ed in lingua della tipologia mappata (nei pochi casi in cui c'è) */
    tipologiaNaarMappata?: string | null;
    /** Servizio del fornitore associato
Null se non è un servizio H2H oppure se è una tipologia basata su hashcode */
    servizioFornitore?: HHServizio | null;
    /** Luogo del fornitore associato.
Null se non è un servizio H2H oppure se è una tipologia basata su hashcode */
    luogoFornitore?: HHLuogo | null;
    /** Nome per esteso del luogo Naar mappato sul LuogoFornitore se presente e mappato. */
    luogoNaarMappato?: string | null;
    /** Servizio H2H se è tale */
    servizioAggregato?: HHServizioAggregato | null;
    /** Nome per esteso del servizio Naar associato al ServizioAggregato se presente e mappato */
    servizioNaarMappato?: string | null;
    /** Descrizione dell'hashcode calcolato */
    hashcodeDescription?: HHAttributoHashcodeDescription | null;
    /** Hashcode originale associato alla tipologia fornitore */
    hashcodeTiplogia?: HHAttributoHashcode | null;
    /** Descrizione dell'hashcode sorgente della tipologia */
    hashcodeTipologiaDescription?: HHAttributoHashcodeDescription | null;
    dettagli?: OffertaDatoDettaglio[] | null;
    supplementi?: TripServiceData[] | null;
    /** Dati per i documenti */
    datiDocumento?: DatiDocumentoRiga | null;
    /** Dati di conferma */
    datiConferma?: DatiConfermaRiga | null;
    /** Note abbinate a questa riga */
    note?: OffertaNota[] | null;
    notaH2H?: string | null;
    data?: string;
    dataCheckout?: string | null;
    dataAcconto?: string | null;
    camera?: string | null;
    nomeServizioFornitore?: string | null;
    nomeServizioNaar?: string | null;
    eliminato?: boolean;
    obsoleto?: boolean;
    servizioH2H?: string | null;
    tipologiaH2H?: string | null;
    nomeAccordo?: string | null;
    costo?: number;
    valutaCosto?: string | null;
    marginePercentule?: number;
    accordoH2H?: boolean;
    totaleDaAnticipare?: number;
    tipoAcconto?: ETipoAcconto;
    statoServizioAlternativo?: EStatoServizioAlternativo;
    /** Eventuale nota H2H del fornitore. Tipicamente il testo è HTML */
    notaFornitore?: TripNote | null;
    /** Testo dell'articolo penali di cancellazione, se c'è. */
    articoloPenali?: TripTextHtml | null;
    /** Nota custom delle penali di cancellazione, se ce n'è una */
    notaPenaliCustom?: TripNote | null;
    /** Testo ricavato dalle penali di default dei dati aggiuntivi */
    testoPenaliDatiAggiuntivi?: string | null;
    /** Dati dell'anticipo al fornitore, se previsti */
    anticipoFornitore?: AnticipoFornitore | null;
    /** Nome della regola di anticipo al fornitore */
    regolaAnticipoFornitore?: string | null;
    /** Elenco degli invii dell'assicurazione, una riga per ogni cliente */
    inviiAssicurazioneFilodiretto?: InvioAssicurazioneFiloDiretto[] | null;
    inviiAssicurazione?: InvioAssicurazione[] | null;
    fullContent?: boolean;
}

export class OffertaDato implements IOffertaDato {
    offertaDatoID?: number;
    offertaID?: number;
    itinerarioID?: number;
    abbinamentoID?: number;
    servizioID?: number | null;
    servizioTipologiaID?: number | null;
    trattamentoID?: number | null;
    cancellato?: boolean;
    accordoID?: number | null;
    giorno?: number | null;
    ordine?: number | null;
    quantita?: number | null;
    descrizione?: string | null;
    note?: string | null;
    noteCliente?: string | null;
    prezzoAdulto?: number;
    prezzoAdultoOriginale?: number | null;
    prezzoBambino?: number;
    prezzoBambinoOriginale?: number | null;
    costoAdulto?: number;
    costoAdultoOriginale?: number | null;
    costoBambino?: number;
    costoBambinoOriginale?: number | null;
    valutaID?: number;
    valutaPrezzoID?: number | null;
    cambioValuta?: number;
    contabilizzazione?: EContabilizzazione | null;
    deregolamenta?: boolean | null;
    commissioniAgenzia?: number | null;
    commissionePercentuale?: number;
    costoID?: number | null;
    costoGlobale?: boolean | null;
    sistemazioneID?: number | null;
    numeroAdulti?: number;
    numeroBambini?: number;
    allotment?: number | null;
    allotmentPrecedente?: number | null;
    tabellaAllotmentID?: number | null;
    provider?: number | null;
    codiceTipologiaFornitore?: string | null;
    dataInserimento?: string | null;
    markup?: number | null;
    transactionID?: number | null;
    rigaManuale?: boolean | null;
    tipo?: ETipoRiga | null;
    regolaVenditaID?: number | null;
    codiceServizioH2H?: string | null;
    supplementoRiduzione?: number | null;
    tabellaCostoID?: number | null;
    maxEta?: number | null;
    codicePrenotazione?: string | null;
    penaleID?: number | null;
    articoloPenaleID?: number | null;
    dataAcconto?: string | null;
    inizio?: string | null;
    fine?: string | null;
    ottimizzataIl?: string | null;
    costoOttimizzato?: number | null;
    fornitoreOttimizzato?: number | null;
    descrizioneOttimizzato?: string | null;
    clienteID?: number | null;
    luogoDestinazioneID?: number | null;
    luogoID?: number | null;
    tipoAutocomplete?: EAutocompleteRiga | null;
    prezzoManuale?: boolean;
    periodoManuale?: boolean;
    dataPenale?: string | null;
    importoPenale?: number | null;
    tipoAcconto?: ETipoImportoAcconto | null;
    importoAcconto?: number | null;
    nonRimborsabile?: boolean;
    anticipoFornitoreID?: number | null;
    ultimaVerifica?: string | null;
    disponibilita?: EStatoDisponibilita;
    disponibilitaOriginal?: EStatoDisponibilita;

    constructor(data?: IOffertaDato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : <any>null;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
            this.cancellato = _data["cancellato"] !== undefined ? _data["cancellato"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.quantita = _data["quantita"] !== undefined ? _data["quantita"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.noteCliente = _data["noteCliente"] !== undefined ? _data["noteCliente"] : <any>null;
            this.prezzoAdulto = _data["prezzoAdulto"] !== undefined ? _data["prezzoAdulto"] : <any>null;
            this.prezzoAdultoOriginale = _data["prezzoAdultoOriginale"] !== undefined ? _data["prezzoAdultoOriginale"] : <any>null;
            this.prezzoBambino = _data["prezzoBambino"] !== undefined ? _data["prezzoBambino"] : <any>null;
            this.prezzoBambinoOriginale = _data["prezzoBambinoOriginale"] !== undefined ? _data["prezzoBambinoOriginale"] : <any>null;
            this.costoAdulto = _data["costoAdulto"] !== undefined ? _data["costoAdulto"] : <any>null;
            this.costoAdultoOriginale = _data["costoAdultoOriginale"] !== undefined ? _data["costoAdultoOriginale"] : <any>null;
            this.costoBambino = _data["costoBambino"] !== undefined ? _data["costoBambino"] : <any>null;
            this.costoBambinoOriginale = _data["costoBambinoOriginale"] !== undefined ? _data["costoBambinoOriginale"] : <any>null;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : <any>null;
            this.valutaPrezzoID = _data["valutaPrezzoID"] !== undefined ? _data["valutaPrezzoID"] : <any>null;
            this.cambioValuta = _data["cambioValuta"] !== undefined ? _data["cambioValuta"] : <any>null;
            this.contabilizzazione = _data["contabilizzazione"] !== undefined ? _data["contabilizzazione"] : <any>null;
            this.deregolamenta = _data["deregolamenta"] !== undefined ? _data["deregolamenta"] : <any>null;
            this.commissioniAgenzia = _data["commissioniAgenzia"] !== undefined ? _data["commissioniAgenzia"] : <any>null;
            this.commissionePercentuale = _data["commissionePercentuale"] !== undefined ? _data["commissionePercentuale"] : <any>null;
            this.costoID = _data["costoID"] !== undefined ? _data["costoID"] : <any>null;
            this.costoGlobale = _data["costoGlobale"] !== undefined ? _data["costoGlobale"] : <any>null;
            this.sistemazioneID = _data["sistemazioneID"] !== undefined ? _data["sistemazioneID"] : <any>null;
            this.numeroAdulti = _data["numeroAdulti"] !== undefined ? _data["numeroAdulti"] : <any>null;
            this.numeroBambini = _data["numeroBambini"] !== undefined ? _data["numeroBambini"] : <any>null;
            this.allotment = _data["allotment"] !== undefined ? _data["allotment"] : <any>null;
            this.allotmentPrecedente = _data["allotmentPrecedente"] !== undefined ? _data["allotmentPrecedente"] : <any>null;
            this.tabellaAllotmentID = _data["tabellaAllotmentID"] !== undefined ? _data["tabellaAllotmentID"] : <any>null;
            this.provider = _data["provider"] !== undefined ? _data["provider"] : <any>null;
            this.codiceTipologiaFornitore = _data["codiceTipologiaFornitore"] !== undefined ? _data["codiceTipologiaFornitore"] : <any>null;
            this.dataInserimento = _data["dataInserimento"] !== undefined ? _data["dataInserimento"] : <any>null;
            this.markup = _data["markup"] !== undefined ? _data["markup"] : <any>null;
            this.transactionID = _data["transactionID"] !== undefined ? _data["transactionID"] : <any>null;
            this.rigaManuale = _data["rigaManuale"] !== undefined ? _data["rigaManuale"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : <any>null;
            this.codiceServizioH2H = _data["codiceServizioH2H"] !== undefined ? _data["codiceServizioH2H"] : <any>null;
            this.supplementoRiduzione = _data["supplementoRiduzione"] !== undefined ? _data["supplementoRiduzione"] : <any>null;
            this.tabellaCostoID = _data["tabellaCostoID"] !== undefined ? _data["tabellaCostoID"] : <any>null;
            this.maxEta = _data["maxEta"] !== undefined ? _data["maxEta"] : <any>null;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : <any>null;
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : <any>null;
            this.articoloPenaleID = _data["articoloPenaleID"] !== undefined ? _data["articoloPenaleID"] : <any>null;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : <any>null;
            this.inizio = _data["inizio"] !== undefined ? _data["inizio"] : <any>null;
            this.fine = _data["fine"] !== undefined ? _data["fine"] : <any>null;
            this.ottimizzataIl = _data["ottimizzataIl"] !== undefined ? _data["ottimizzataIl"] : <any>null;
            this.costoOttimizzato = _data["costoOttimizzato"] !== undefined ? _data["costoOttimizzato"] : <any>null;
            this.fornitoreOttimizzato = _data["fornitoreOttimizzato"] !== undefined ? _data["fornitoreOttimizzato"] : <any>null;
            this.descrizioneOttimizzato = _data["descrizioneOttimizzato"] !== undefined ? _data["descrizioneOttimizzato"] : <any>null;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : <any>null;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.tipoAutocomplete = _data["tipoAutocomplete"] !== undefined ? _data["tipoAutocomplete"] : <any>null;
            this.prezzoManuale = _data["prezzoManuale"] !== undefined ? _data["prezzoManuale"] : <any>null;
            this.periodoManuale = _data["periodoManuale"] !== undefined ? _data["periodoManuale"] : <any>null;
            this.dataPenale = _data["dataPenale"] !== undefined ? _data["dataPenale"] : <any>null;
            this.importoPenale = _data["importoPenale"] !== undefined ? _data["importoPenale"] : <any>null;
            this.tipoAcconto = _data["tipoAcconto"] !== undefined ? _data["tipoAcconto"] : <any>null;
            this.importoAcconto = _data["importoAcconto"] !== undefined ? _data["importoAcconto"] : <any>null;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : <any>null;
            this.anticipoFornitoreID = _data["anticipoFornitoreID"] !== undefined ? _data["anticipoFornitoreID"] : <any>null;
            this.ultimaVerifica = _data["ultimaVerifica"] !== undefined ? _data["ultimaVerifica"] : <any>null;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : <any>null;
            this.disponibilitaOriginal = _data["disponibilitaOriginal"] !== undefined ? _data["disponibilitaOriginal"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaDato {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : <any>null;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        data["cancellato"] = this.cancellato !== undefined ? this.cancellato : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["quantita"] = this.quantita !== undefined ? this.quantita : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["noteCliente"] = this.noteCliente !== undefined ? this.noteCliente : <any>null;
        data["prezzoAdulto"] = this.prezzoAdulto !== undefined ? this.prezzoAdulto : <any>null;
        data["prezzoAdultoOriginale"] = this.prezzoAdultoOriginale !== undefined ? this.prezzoAdultoOriginale : <any>null;
        data["prezzoBambino"] = this.prezzoBambino !== undefined ? this.prezzoBambino : <any>null;
        data["prezzoBambinoOriginale"] = this.prezzoBambinoOriginale !== undefined ? this.prezzoBambinoOriginale : <any>null;
        data["costoAdulto"] = this.costoAdulto !== undefined ? this.costoAdulto : <any>null;
        data["costoAdultoOriginale"] = this.costoAdultoOriginale !== undefined ? this.costoAdultoOriginale : <any>null;
        data["costoBambino"] = this.costoBambino !== undefined ? this.costoBambino : <any>null;
        data["costoBambinoOriginale"] = this.costoBambinoOriginale !== undefined ? this.costoBambinoOriginale : <any>null;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : <any>null;
        data["valutaPrezzoID"] = this.valutaPrezzoID !== undefined ? this.valutaPrezzoID : <any>null;
        data["cambioValuta"] = this.cambioValuta !== undefined ? this.cambioValuta : <any>null;
        data["contabilizzazione"] = this.contabilizzazione !== undefined ? this.contabilizzazione : <any>null;
        data["deregolamenta"] = this.deregolamenta !== undefined ? this.deregolamenta : <any>null;
        data["commissioniAgenzia"] = this.commissioniAgenzia !== undefined ? this.commissioniAgenzia : <any>null;
        data["commissionePercentuale"] = this.commissionePercentuale !== undefined ? this.commissionePercentuale : <any>null;
        data["costoID"] = this.costoID !== undefined ? this.costoID : <any>null;
        data["costoGlobale"] = this.costoGlobale !== undefined ? this.costoGlobale : <any>null;
        data["sistemazioneID"] = this.sistemazioneID !== undefined ? this.sistemazioneID : <any>null;
        data["numeroAdulti"] = this.numeroAdulti !== undefined ? this.numeroAdulti : <any>null;
        data["numeroBambini"] = this.numeroBambini !== undefined ? this.numeroBambini : <any>null;
        data["allotment"] = this.allotment !== undefined ? this.allotment : <any>null;
        data["allotmentPrecedente"] = this.allotmentPrecedente !== undefined ? this.allotmentPrecedente : <any>null;
        data["tabellaAllotmentID"] = this.tabellaAllotmentID !== undefined ? this.tabellaAllotmentID : <any>null;
        data["provider"] = this.provider !== undefined ? this.provider : <any>null;
        data["codiceTipologiaFornitore"] = this.codiceTipologiaFornitore !== undefined ? this.codiceTipologiaFornitore : <any>null;
        data["dataInserimento"] = this.dataInserimento !== undefined ? this.dataInserimento : <any>null;
        data["markup"] = this.markup !== undefined ? this.markup : <any>null;
        data["transactionID"] = this.transactionID !== undefined ? this.transactionID : <any>null;
        data["rigaManuale"] = this.rigaManuale !== undefined ? this.rigaManuale : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : <any>null;
        data["codiceServizioH2H"] = this.codiceServizioH2H !== undefined ? this.codiceServizioH2H : <any>null;
        data["supplementoRiduzione"] = this.supplementoRiduzione !== undefined ? this.supplementoRiduzione : <any>null;
        data["tabellaCostoID"] = this.tabellaCostoID !== undefined ? this.tabellaCostoID : <any>null;
        data["maxEta"] = this.maxEta !== undefined ? this.maxEta : <any>null;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : <any>null;
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : <any>null;
        data["articoloPenaleID"] = this.articoloPenaleID !== undefined ? this.articoloPenaleID : <any>null;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : <any>null;
        data["inizio"] = this.inizio !== undefined ? this.inizio : <any>null;
        data["fine"] = this.fine !== undefined ? this.fine : <any>null;
        data["ottimizzataIl"] = this.ottimizzataIl !== undefined ? this.ottimizzataIl : <any>null;
        data["costoOttimizzato"] = this.costoOttimizzato !== undefined ? this.costoOttimizzato : <any>null;
        data["fornitoreOttimizzato"] = this.fornitoreOttimizzato !== undefined ? this.fornitoreOttimizzato : <any>null;
        data["descrizioneOttimizzato"] = this.descrizioneOttimizzato !== undefined ? this.descrizioneOttimizzato : <any>null;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : <any>null;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["tipoAutocomplete"] = this.tipoAutocomplete !== undefined ? this.tipoAutocomplete : <any>null;
        data["prezzoManuale"] = this.prezzoManuale !== undefined ? this.prezzoManuale : <any>null;
        data["periodoManuale"] = this.periodoManuale !== undefined ? this.periodoManuale : <any>null;
        data["dataPenale"] = this.dataPenale !== undefined ? this.dataPenale : <any>null;
        data["importoPenale"] = this.importoPenale !== undefined ? this.importoPenale : <any>null;
        data["tipoAcconto"] = this.tipoAcconto !== undefined ? this.tipoAcconto : <any>null;
        data["importoAcconto"] = this.importoAcconto !== undefined ? this.importoAcconto : <any>null;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : <any>null;
        data["anticipoFornitoreID"] = this.anticipoFornitoreID !== undefined ? this.anticipoFornitoreID : <any>null;
        data["ultimaVerifica"] = this.ultimaVerifica !== undefined ? this.ultimaVerifica : <any>null;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : <any>null;
        data["disponibilitaOriginal"] = this.disponibilitaOriginal !== undefined ? this.disponibilitaOriginal : <any>null;
        return data;
    }
}

export interface IOffertaDato {
    offertaDatoID?: number;
    offertaID?: number;
    itinerarioID?: number;
    abbinamentoID?: number;
    servizioID?: number | null;
    servizioTipologiaID?: number | null;
    trattamentoID?: number | null;
    cancellato?: boolean;
    accordoID?: number | null;
    giorno?: number | null;
    ordine?: number | null;
    quantita?: number | null;
    descrizione?: string | null;
    note?: string | null;
    noteCliente?: string | null;
    prezzoAdulto?: number;
    prezzoAdultoOriginale?: number | null;
    prezzoBambino?: number;
    prezzoBambinoOriginale?: number | null;
    costoAdulto?: number;
    costoAdultoOriginale?: number | null;
    costoBambino?: number;
    costoBambinoOriginale?: number | null;
    valutaID?: number;
    valutaPrezzoID?: number | null;
    cambioValuta?: number;
    contabilizzazione?: EContabilizzazione | null;
    deregolamenta?: boolean | null;
    commissioniAgenzia?: number | null;
    commissionePercentuale?: number;
    costoID?: number | null;
    costoGlobale?: boolean | null;
    sistemazioneID?: number | null;
    numeroAdulti?: number;
    numeroBambini?: number;
    allotment?: number | null;
    allotmentPrecedente?: number | null;
    tabellaAllotmentID?: number | null;
    provider?: number | null;
    codiceTipologiaFornitore?: string | null;
    dataInserimento?: string | null;
    markup?: number | null;
    transactionID?: number | null;
    rigaManuale?: boolean | null;
    tipo?: ETipoRiga | null;
    regolaVenditaID?: number | null;
    codiceServizioH2H?: string | null;
    supplementoRiduzione?: number | null;
    tabellaCostoID?: number | null;
    maxEta?: number | null;
    codicePrenotazione?: string | null;
    penaleID?: number | null;
    articoloPenaleID?: number | null;
    dataAcconto?: string | null;
    inizio?: string | null;
    fine?: string | null;
    ottimizzataIl?: string | null;
    costoOttimizzato?: number | null;
    fornitoreOttimizzato?: number | null;
    descrizioneOttimizzato?: string | null;
    clienteID?: number | null;
    luogoDestinazioneID?: number | null;
    luogoID?: number | null;
    tipoAutocomplete?: EAutocompleteRiga | null;
    prezzoManuale?: boolean;
    periodoManuale?: boolean;
    dataPenale?: string | null;
    importoPenale?: number | null;
    tipoAcconto?: ETipoImportoAcconto | null;
    importoAcconto?: number | null;
    nonRimborsabile?: boolean;
    anticipoFornitoreID?: number | null;
    ultimaVerifica?: string | null;
    disponibilita?: EStatoDisponibilita;
    disponibilitaOriginal?: EStatoDisponibilita;
}

export enum ETipoRiga {
    Default = "Default",
    Volo = "Volo",
    TasseVolo = "TasseVolo",
    UsoInterno = "UsoInterno",
}

export enum EAutocompleteRiga {
    NonCompletare = "NonCompletare",
    ServizioSpecifico = "ServizioSpecifico",
    ServizioTipologiaSpecifici = "ServizioTipologiaSpecifici",
    ServizioStessoTipo = "ServizioStessoTipo",
}

export enum ETipoImportoAcconto {
    Percentuale = "Percentuale",
    ValoreAssolutoCosto = "ValoreAssolutoCosto",
    ValoreCostoConMarkup = "ValoreCostoConMarkup",
    ValoreAssolutoPrezzo = "ValoreAssolutoPrezzo",
}

export class OffertaDatoStato implements IOffertaDatoStato {
    offertaDatoID?: number;
    numeroPrenotazione?: string | null;
    riferimentoFornitore?: string | null;
    dataPrenotazione?: string | null;
    dataConferma?: string | null;
    dataAnnullamento?: string | null;
    dataCancellazione?: string | null;
    prenotaDal?: string | null;
    stato?: EStatusServizio | null;
    documentoID?: number | null;
    host2Host?: boolean | null;
    pagato?: number | null;
    pagamentoID?: number | null;
    verificato?: boolean | null;
    ordinaBiglietteria?: string | null;
    presaInCaricoBiglietteria?: string | null;
    emessoBiglietteria?: string | null;
    okContabileBiglietteria?: string | null;
    dataEmissioneCustom?: string | null;
    richiestoRimborso?: boolean;
    importoAnticipoFornitore?: number | null;
    valutaAnticipoFornitoreID?: number | null;
    dataAnticipoFornitore?: string | null;
    statoServizioAlternativo?: EStatoServizioAlternativo;
    offertaDatoAlternativaID?: number | null;

    constructor(data?: IOffertaDatoStato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.numeroPrenotazione = _data["numeroPrenotazione"] !== undefined ? _data["numeroPrenotazione"] : <any>null;
            this.riferimentoFornitore = _data["riferimentoFornitore"] !== undefined ? _data["riferimentoFornitore"] : <any>null;
            this.dataPrenotazione = _data["dataPrenotazione"] !== undefined ? _data["dataPrenotazione"] : <any>null;
            this.dataConferma = _data["dataConferma"] !== undefined ? _data["dataConferma"] : <any>null;
            this.dataAnnullamento = _data["dataAnnullamento"] !== undefined ? _data["dataAnnullamento"] : <any>null;
            this.dataCancellazione = _data["dataCancellazione"] !== undefined ? _data["dataCancellazione"] : <any>null;
            this.prenotaDal = _data["prenotaDal"] !== undefined ? _data["prenotaDal"] : <any>null;
            this.stato = _data["stato"] !== undefined ? _data["stato"] : <any>null;
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
            this.host2Host = _data["host2Host"] !== undefined ? _data["host2Host"] : <any>null;
            this.pagato = _data["pagato"] !== undefined ? _data["pagato"] : <any>null;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : <any>null;
            this.verificato = _data["verificato"] !== undefined ? _data["verificato"] : <any>null;
            this.ordinaBiglietteria = _data["ordinaBiglietteria"] !== undefined ? _data["ordinaBiglietteria"] : <any>null;
            this.presaInCaricoBiglietteria = _data["presaInCaricoBiglietteria"] !== undefined ? _data["presaInCaricoBiglietteria"] : <any>null;
            this.emessoBiglietteria = _data["emessoBiglietteria"] !== undefined ? _data["emessoBiglietteria"] : <any>null;
            this.okContabileBiglietteria = _data["okContabileBiglietteria"] !== undefined ? _data["okContabileBiglietteria"] : <any>null;
            this.dataEmissioneCustom = _data["dataEmissioneCustom"] !== undefined ? _data["dataEmissioneCustom"] : <any>null;
            this.richiestoRimborso = _data["richiestoRimborso"] !== undefined ? _data["richiestoRimborso"] : <any>null;
            this.importoAnticipoFornitore = _data["importoAnticipoFornitore"] !== undefined ? _data["importoAnticipoFornitore"] : <any>null;
            this.valutaAnticipoFornitoreID = _data["valutaAnticipoFornitoreID"] !== undefined ? _data["valutaAnticipoFornitoreID"] : <any>null;
            this.dataAnticipoFornitore = _data["dataAnticipoFornitore"] !== undefined ? _data["dataAnticipoFornitore"] : <any>null;
            this.statoServizioAlternativo = _data["statoServizioAlternativo"] !== undefined ? _data["statoServizioAlternativo"] : <any>null;
            this.offertaDatoAlternativaID = _data["offertaDatoAlternativaID"] !== undefined ? _data["offertaDatoAlternativaID"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaDatoStato {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDatoStato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["numeroPrenotazione"] = this.numeroPrenotazione !== undefined ? this.numeroPrenotazione : <any>null;
        data["riferimentoFornitore"] = this.riferimentoFornitore !== undefined ? this.riferimentoFornitore : <any>null;
        data["dataPrenotazione"] = this.dataPrenotazione !== undefined ? this.dataPrenotazione : <any>null;
        data["dataConferma"] = this.dataConferma !== undefined ? this.dataConferma : <any>null;
        data["dataAnnullamento"] = this.dataAnnullamento !== undefined ? this.dataAnnullamento : <any>null;
        data["dataCancellazione"] = this.dataCancellazione !== undefined ? this.dataCancellazione : <any>null;
        data["prenotaDal"] = this.prenotaDal !== undefined ? this.prenotaDal : <any>null;
        data["stato"] = this.stato !== undefined ? this.stato : <any>null;
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        data["host2Host"] = this.host2Host !== undefined ? this.host2Host : <any>null;
        data["pagato"] = this.pagato !== undefined ? this.pagato : <any>null;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : <any>null;
        data["verificato"] = this.verificato !== undefined ? this.verificato : <any>null;
        data["ordinaBiglietteria"] = this.ordinaBiglietteria !== undefined ? this.ordinaBiglietteria : <any>null;
        data["presaInCaricoBiglietteria"] = this.presaInCaricoBiglietteria !== undefined ? this.presaInCaricoBiglietteria : <any>null;
        data["emessoBiglietteria"] = this.emessoBiglietteria !== undefined ? this.emessoBiglietteria : <any>null;
        data["okContabileBiglietteria"] = this.okContabileBiglietteria !== undefined ? this.okContabileBiglietteria : <any>null;
        data["dataEmissioneCustom"] = this.dataEmissioneCustom !== undefined ? this.dataEmissioneCustom : <any>null;
        data["richiestoRimborso"] = this.richiestoRimborso !== undefined ? this.richiestoRimborso : <any>null;
        data["importoAnticipoFornitore"] = this.importoAnticipoFornitore !== undefined ? this.importoAnticipoFornitore : <any>null;
        data["valutaAnticipoFornitoreID"] = this.valutaAnticipoFornitoreID !== undefined ? this.valutaAnticipoFornitoreID : <any>null;
        data["dataAnticipoFornitore"] = this.dataAnticipoFornitore !== undefined ? this.dataAnticipoFornitore : <any>null;
        data["statoServizioAlternativo"] = this.statoServizioAlternativo !== undefined ? this.statoServizioAlternativo : <any>null;
        data["offertaDatoAlternativaID"] = this.offertaDatoAlternativaID !== undefined ? this.offertaDatoAlternativaID : <any>null;
        return data;
    }
}

export interface IOffertaDatoStato {
    offertaDatoID?: number;
    numeroPrenotazione?: string | null;
    riferimentoFornitore?: string | null;
    dataPrenotazione?: string | null;
    dataConferma?: string | null;
    dataAnnullamento?: string | null;
    dataCancellazione?: string | null;
    prenotaDal?: string | null;
    stato?: EStatusServizio | null;
    documentoID?: number | null;
    host2Host?: boolean | null;
    pagato?: number | null;
    pagamentoID?: number | null;
    verificato?: boolean | null;
    ordinaBiglietteria?: string | null;
    presaInCaricoBiglietteria?: string | null;
    emessoBiglietteria?: string | null;
    okContabileBiglietteria?: string | null;
    dataEmissioneCustom?: string | null;
    richiestoRimborso?: boolean;
    importoAnticipoFornitore?: number | null;
    valutaAnticipoFornitoreID?: number | null;
    dataAnticipoFornitore?: string | null;
    statoServizioAlternativo?: EStatoServizioAlternativo;
    offertaDatoAlternativaID?: number | null;
}

export enum EStatusServizio {
    Manuale = "Manuale",
    DaPrenotare = "DaPrenotare",
    InPrenotazione = "InPrenotazione",
    PrezziVariati = "PrezziVariati",
    Confermato = "Confermato",
    ParzialmenteConfermato = "ParzialmenteConfermato",
    NonConfermato = "NonConfermato",
    DaCancellare = "DaCancellare",
    InCancellazione = "InCancellazione",
    Cancellato = "Cancellato",
}

export enum EStatoServizioAlternativo {
    Nessuno = "Nessuno",
    AlternativaProposta = "AlternativaProposta",
    AlternativaAccettata = "AlternativaAccettata",
}

export class OffertaDatoH2H implements IOffertaDatoH2H {
    offertaDatoID?: number;
    hhCodiceID?: number | null;
    codicePrenotazione?: string | null;
    codiceServizio?: string | null;
    codiceTipologia?: string | null;
    customData?: string | null;
    bookCustomData?: string | null;
    contattoPickupID?: number | null;
    contattoDropoffID?: number | null;
    puntoIniziale?: string | null;
    puntoFinale?: string | null;
    hashCode?: string | null;
    servizioH2hID?: number | null;

    constructor(data?: IOffertaDatoH2H) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.hhCodiceID = _data["hhCodiceID"] !== undefined ? _data["hhCodiceID"] : <any>null;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : <any>null;
            this.codiceServizio = _data["codiceServizio"] !== undefined ? _data["codiceServizio"] : <any>null;
            this.codiceTipologia = _data["codiceTipologia"] !== undefined ? _data["codiceTipologia"] : <any>null;
            this.customData = _data["customData"] !== undefined ? _data["customData"] : <any>null;
            this.bookCustomData = _data["bookCustomData"] !== undefined ? _data["bookCustomData"] : <any>null;
            this.contattoPickupID = _data["contattoPickupID"] !== undefined ? _data["contattoPickupID"] : <any>null;
            this.contattoDropoffID = _data["contattoDropoffID"] !== undefined ? _data["contattoDropoffID"] : <any>null;
            this.puntoIniziale = _data["puntoIniziale"] !== undefined ? _data["puntoIniziale"] : <any>null;
            this.puntoFinale = _data["puntoFinale"] !== undefined ? _data["puntoFinale"] : <any>null;
            this.hashCode = _data["hashCode"] !== undefined ? _data["hashCode"] : <any>null;
            this.servizioH2hID = _data["servizioH2hID"] !== undefined ? _data["servizioH2hID"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaDatoH2H {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDatoH2H();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["hhCodiceID"] = this.hhCodiceID !== undefined ? this.hhCodiceID : <any>null;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : <any>null;
        data["codiceServizio"] = this.codiceServizio !== undefined ? this.codiceServizio : <any>null;
        data["codiceTipologia"] = this.codiceTipologia !== undefined ? this.codiceTipologia : <any>null;
        data["customData"] = this.customData !== undefined ? this.customData : <any>null;
        data["bookCustomData"] = this.bookCustomData !== undefined ? this.bookCustomData : <any>null;
        data["contattoPickupID"] = this.contattoPickupID !== undefined ? this.contattoPickupID : <any>null;
        data["contattoDropoffID"] = this.contattoDropoffID !== undefined ? this.contattoDropoffID : <any>null;
        data["puntoIniziale"] = this.puntoIniziale !== undefined ? this.puntoIniziale : <any>null;
        data["puntoFinale"] = this.puntoFinale !== undefined ? this.puntoFinale : <any>null;
        data["hashCode"] = this.hashCode !== undefined ? this.hashCode : <any>null;
        data["servizioH2hID"] = this.servizioH2hID !== undefined ? this.servizioH2hID : <any>null;
        return data;
    }
}

export interface IOffertaDatoH2H {
    offertaDatoID?: number;
    hhCodiceID?: number | null;
    codicePrenotazione?: string | null;
    codiceServizio?: string | null;
    codiceTipologia?: string | null;
    customData?: string | null;
    bookCustomData?: string | null;
    contattoPickupID?: number | null;
    contattoDropoffID?: number | null;
    puntoIniziale?: string | null;
    puntoFinale?: string | null;
    hashCode?: string | null;
    servizioH2hID?: number | null;
}

export class HHCodice implements IHHCodice {
    id?: number;
    hhServizioID?: number | null;
    nomeTipologia?: string | null;
    codiceTipologia?: string | null;
    servizioTipologiaNaarID?: number | null;
    tipoTipologia?: ETipoTipologiaHH;
    ultimoAggiornamento?: string | null;
    codiceTrattamentoFornitore?: string | null;
    trattamentoID?: number | null;
    nonRimborsabile?: boolean | null;
    pagaSubito?: boolean;
    customData?: string | null;
    servizioRegolaVenditaID?: number | null;
    descrizioneID?: number | null;
    hashCodeID?: number | null;
    servizio?: HHServizio | null;
    bedsID?: number | null;
    mealID?: number | null;
    hashCode?: string | null;

    constructor(data?: IHHCodice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.hhServizioID = _data["hhServizioID"] !== undefined ? _data["hhServizioID"] : <any>null;
            this.nomeTipologia = _data["nomeTipologia"] !== undefined ? _data["nomeTipologia"] : <any>null;
            this.codiceTipologia = _data["codiceTipologia"] !== undefined ? _data["codiceTipologia"] : <any>null;
            this.servizioTipologiaNaarID = _data["servizioTipologiaNaarID"] !== undefined ? _data["servizioTipologiaNaarID"] : <any>null;
            this.tipoTipologia = _data["tipoTipologia"] !== undefined ? _data["tipoTipologia"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
            this.codiceTrattamentoFornitore = _data["codiceTrattamentoFornitore"] !== undefined ? _data["codiceTrattamentoFornitore"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : <any>null;
            this.pagaSubito = _data["pagaSubito"] !== undefined ? _data["pagaSubito"] : <any>null;
            this.customData = _data["customData"] !== undefined ? _data["customData"] : <any>null;
            this.servizioRegolaVenditaID = _data["servizioRegolaVenditaID"] !== undefined ? _data["servizioRegolaVenditaID"] : <any>null;
            this.descrizioneID = _data["descrizioneID"] !== undefined ? _data["descrizioneID"] : <any>null;
            this.hashCodeID = _data["hashCodeID"] !== undefined ? _data["hashCodeID"] : <any>null;
            this.servizio = _data["servizio"] ? HHServizio.fromJS(_data["servizio"]) : <any>null;
            this.bedsID = _data["bedsID"] !== undefined ? _data["bedsID"] : <any>null;
            this.mealID = _data["mealID"] !== undefined ? _data["mealID"] : <any>null;
            this.hashCode = _data["hashCode"] !== undefined ? _data["hashCode"] : <any>null;
        }
    }

    static fromJS(data: any): HHCodice {
        data = typeof data === 'object' ? data : {};
        let result = new HHCodice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["hhServizioID"] = this.hhServizioID !== undefined ? this.hhServizioID : <any>null;
        data["nomeTipologia"] = this.nomeTipologia !== undefined ? this.nomeTipologia : <any>null;
        data["codiceTipologia"] = this.codiceTipologia !== undefined ? this.codiceTipologia : <any>null;
        data["servizioTipologiaNaarID"] = this.servizioTipologiaNaarID !== undefined ? this.servizioTipologiaNaarID : <any>null;
        data["tipoTipologia"] = this.tipoTipologia !== undefined ? this.tipoTipologia : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        data["codiceTrattamentoFornitore"] = this.codiceTrattamentoFornitore !== undefined ? this.codiceTrattamentoFornitore : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : <any>null;
        data["pagaSubito"] = this.pagaSubito !== undefined ? this.pagaSubito : <any>null;
        data["customData"] = this.customData !== undefined ? this.customData : <any>null;
        data["servizioRegolaVenditaID"] = this.servizioRegolaVenditaID !== undefined ? this.servizioRegolaVenditaID : <any>null;
        data["descrizioneID"] = this.descrizioneID !== undefined ? this.descrizioneID : <any>null;
        data["hashCodeID"] = this.hashCodeID !== undefined ? this.hashCodeID : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        data["bedsID"] = this.bedsID !== undefined ? this.bedsID : <any>null;
        data["mealID"] = this.mealID !== undefined ? this.mealID : <any>null;
        data["hashCode"] = this.hashCode !== undefined ? this.hashCode : <any>null;
        return data;
    }
}

export interface IHHCodice {
    id?: number;
    hhServizioID?: number | null;
    nomeTipologia?: string | null;
    codiceTipologia?: string | null;
    servizioTipologiaNaarID?: number | null;
    tipoTipologia?: ETipoTipologiaHH;
    ultimoAggiornamento?: string | null;
    codiceTrattamentoFornitore?: string | null;
    trattamentoID?: number | null;
    nonRimborsabile?: boolean | null;
    pagaSubito?: boolean;
    customData?: string | null;
    servizioRegolaVenditaID?: number | null;
    descrizioneID?: number | null;
    hashCodeID?: number | null;
    servizio?: HHServizio | null;
    bedsID?: number | null;
    mealID?: number | null;
    hashCode?: string | null;
}

export enum ETipoTipologiaHH {
    Camera = "Camera",
    Supplemento = "Supplemento",
    Pasto = "Pasto",
}

export class HHServizio implements IHHServizio {
    id?: number;
    fornitore?: EFornitore;
    servizioNaarID?: number | null;
    luogoFornitoreID?: number;
    nomeServizio?: string | null;
    codiceServizio!: string;
    ultimoAggiornamento?: string | null;
    customData?: string | null;
    tipo?: ETipoServizio;
    daConfermare?: boolean;
    indirizzo?: string | null;
    telefono?: string | null;
    latitudine?: number | null;
    longitudine?: number | null;
    giataID?: number | null;
    servizioAggregatoID?: number | null;
    rating?: number | null;
    numeroRecensioni?: number | null;
    punteggioRecensioni?: string | null;
    accordoID?: number | null;
    deleted?: string | null;

    constructor(data?: IHHServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : <any>null;
            this.luogoFornitoreID = _data["luogoFornitoreID"] !== undefined ? _data["luogoFornitoreID"] : <any>null;
            this.nomeServizio = _data["nomeServizio"] !== undefined ? _data["nomeServizio"] : <any>null;
            this.codiceServizio = _data["codiceServizio"] !== undefined ? _data["codiceServizio"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
            this.customData = _data["customData"] !== undefined ? _data["customData"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.daConfermare = _data["daConfermare"] !== undefined ? _data["daConfermare"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : <any>null;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : <any>null;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : <any>null;
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : <any>null;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : <any>null;
            this.numeroRecensioni = _data["numeroRecensioni"] !== undefined ? _data["numeroRecensioni"] : <any>null;
            this.punteggioRecensioni = _data["punteggioRecensioni"] !== undefined ? _data["punteggioRecensioni"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
        }
    }

    static fromJS(data: any): HHServizio {
        data = typeof data === 'object' ? data : {};
        let result = new HHServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : <any>null;
        data["luogoFornitoreID"] = this.luogoFornitoreID !== undefined ? this.luogoFornitoreID : <any>null;
        data["nomeServizio"] = this.nomeServizio !== undefined ? this.nomeServizio : <any>null;
        data["codiceServizio"] = this.codiceServizio !== undefined ? this.codiceServizio : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        data["customData"] = this.customData !== undefined ? this.customData : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["daConfermare"] = this.daConfermare !== undefined ? this.daConfermare : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : <any>null;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : <any>null;
        data["giataID"] = this.giataID !== undefined ? this.giataID : <any>null;
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : <any>null;
        data["rating"] = this.rating !== undefined ? this.rating : <any>null;
        data["numeroRecensioni"] = this.numeroRecensioni !== undefined ? this.numeroRecensioni : <any>null;
        data["punteggioRecensioni"] = this.punteggioRecensioni !== undefined ? this.punteggioRecensioni : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        return data;
    }
}

export interface IHHServizio {
    id?: number;
    fornitore?: EFornitore;
    servizioNaarID?: number | null;
    luogoFornitoreID?: number;
    nomeServizio?: string | null;
    codiceServizio: string;
    ultimoAggiornamento?: string | null;
    customData?: string | null;
    tipo?: ETipoServizio;
    daConfermare?: boolean;
    indirizzo?: string | null;
    telefono?: string | null;
    latitudine?: number | null;
    longitudine?: number | null;
    giataID?: number | null;
    servizioAggregatoID?: number | null;
    rating?: number | null;
    numeroRecensioni?: number | null;
    punteggioRecensioni?: string | null;
    accordoID?: number | null;
    deleted?: string | null;
}

export class HHLuogo implements IHHLuogo {
    id?: number;
    codiceLuogo!: string;
    fornitoreID?: number;
    luogoNaarID?: number | null;
    accordoID?: number | null;
    nome!: string;
    codicePaese?: string | null;
    ultimoAggiornamento?: string | null;
    prioritaImmagini?: number | null;
    prioritaArticoli?: number | null;
    prioritaInfo?: number | null;
    disabilitato?: boolean;
    tipoLocation?: EH2HTipoLocation;
    tipoLuogo?: EHHTipoLuogo;
    priorita?: number;
    parentID?: number | null;
    rating?: number | null;
    customData?: string | null;
    deleted?: string | null;

    constructor(data?: IHHLuogo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.codiceLuogo = _data["codiceLuogo"] !== undefined ? _data["codiceLuogo"] : <any>null;
            this.fornitoreID = _data["fornitoreID"] !== undefined ? _data["fornitoreID"] : <any>null;
            this.luogoNaarID = _data["luogoNaarID"] !== undefined ? _data["luogoNaarID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.codicePaese = _data["codicePaese"] !== undefined ? _data["codicePaese"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
            this.prioritaImmagini = _data["prioritaImmagini"] !== undefined ? _data["prioritaImmagini"] : <any>null;
            this.prioritaArticoli = _data["prioritaArticoli"] !== undefined ? _data["prioritaArticoli"] : <any>null;
            this.prioritaInfo = _data["prioritaInfo"] !== undefined ? _data["prioritaInfo"] : <any>null;
            this.disabilitato = _data["disabilitato"] !== undefined ? _data["disabilitato"] : <any>null;
            this.tipoLocation = _data["tipoLocation"] !== undefined ? _data["tipoLocation"] : <any>null;
            this.tipoLuogo = _data["tipoLuogo"] !== undefined ? _data["tipoLuogo"] : <any>null;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : <any>null;
            this.parentID = _data["parentID"] !== undefined ? _data["parentID"] : <any>null;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : <any>null;
            this.customData = _data["customData"] !== undefined ? _data["customData"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
        }
    }

    static fromJS(data: any): HHLuogo {
        data = typeof data === 'object' ? data : {};
        let result = new HHLuogo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["codiceLuogo"] = this.codiceLuogo !== undefined ? this.codiceLuogo : <any>null;
        data["fornitoreID"] = this.fornitoreID !== undefined ? this.fornitoreID : <any>null;
        data["luogoNaarID"] = this.luogoNaarID !== undefined ? this.luogoNaarID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["codicePaese"] = this.codicePaese !== undefined ? this.codicePaese : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        data["prioritaImmagini"] = this.prioritaImmagini !== undefined ? this.prioritaImmagini : <any>null;
        data["prioritaArticoli"] = this.prioritaArticoli !== undefined ? this.prioritaArticoli : <any>null;
        data["prioritaInfo"] = this.prioritaInfo !== undefined ? this.prioritaInfo : <any>null;
        data["disabilitato"] = this.disabilitato !== undefined ? this.disabilitato : <any>null;
        data["tipoLocation"] = this.tipoLocation !== undefined ? this.tipoLocation : <any>null;
        data["tipoLuogo"] = this.tipoLuogo !== undefined ? this.tipoLuogo : <any>null;
        data["priorita"] = this.priorita !== undefined ? this.priorita : <any>null;
        data["parentID"] = this.parentID !== undefined ? this.parentID : <any>null;
        data["rating"] = this.rating !== undefined ? this.rating : <any>null;
        data["customData"] = this.customData !== undefined ? this.customData : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        return data;
    }
}

export interface IHHLuogo {
    id?: number;
    codiceLuogo: string;
    fornitoreID?: number;
    luogoNaarID?: number | null;
    accordoID?: number | null;
    nome: string;
    codicePaese?: string | null;
    ultimoAggiornamento?: string | null;
    prioritaImmagini?: number | null;
    prioritaArticoli?: number | null;
    prioritaInfo?: number | null;
    disabilitato?: boolean;
    tipoLocation?: EH2HTipoLocation;
    tipoLuogo?: EHHTipoLuogo;
    priorita?: number;
    parentID?: number | null;
    rating?: number | null;
    customData?: string | null;
    deleted?: string | null;
}

export enum EH2HTipoLocation {
    Indefinita = "Indefinita",
    Aeroporto = "Aeroporto",
}

export enum EHHTipoLuogo {
    Continente = "Continente",
    Zona = "Zona",
    Paese = "Paese",
    Citta = "Citta",
    Quartiere = "Quartiere",
    Regione = "Regione",
    Stato = "Stato",
    PuntoDiInteresse = "PuntoDiInteresse",
}

export class HHServizioAggregato implements IHHServizioAggregato {
    id?: number;
    luogoID?: number;
    nome!: string;
    indirizzo?: string | null;
    cap?: string | null;
    telefono?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    zoom?: number | null;
    tipo?: ETipoServizio;
    ultimoAggiornamento?: string;
    servizioID?: number | null;
    disabilitato?: boolean;
    giataID?: number | null;
    thumbUrl?: string | null;
    email?: string | null;
    website?: string | null;
    stelle?: number | null;
    giataUpdate?: string | null;
    codice?: string | null;

    constructor(data?: IHHServizioAggregato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.disabilitato = _data["disabilitato"] !== undefined ? _data["disabilitato"] : <any>null;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : <any>null;
            this.thumbUrl = _data["thumbUrl"] !== undefined ? _data["thumbUrl"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
            this.stelle = _data["stelle"] !== undefined ? _data["stelle"] : <any>null;
            this.giataUpdate = _data["giataUpdate"] !== undefined ? _data["giataUpdate"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
        }
    }

    static fromJS(data: any): HHServizioAggregato {
        data = typeof data === 'object' ? data : {};
        let result = new HHServizioAggregato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["zoom"] = this.zoom !== undefined ? this.zoom : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["disabilitato"] = this.disabilitato !== undefined ? this.disabilitato : <any>null;
        data["giataID"] = this.giataID !== undefined ? this.giataID : <any>null;
        data["thumbUrl"] = this.thumbUrl !== undefined ? this.thumbUrl : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["website"] = this.website !== undefined ? this.website : <any>null;
        data["stelle"] = this.stelle !== undefined ? this.stelle : <any>null;
        data["giataUpdate"] = this.giataUpdate !== undefined ? this.giataUpdate : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        return data;
    }
}

export interface IHHServizioAggregato {
    id?: number;
    luogoID?: number;
    nome: string;
    indirizzo?: string | null;
    cap?: string | null;
    telefono?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    zoom?: number | null;
    tipo?: ETipoServizio;
    ultimoAggiornamento?: string;
    servizioID?: number | null;
    disabilitato?: boolean;
    giataID?: number | null;
    thumbUrl?: string | null;
    email?: string | null;
    website?: string | null;
    stelle?: number | null;
    giataUpdate?: string | null;
    codice?: string | null;
}

export class HHAttributoHashcodeDescription implements IHHAttributoHashcodeDescription {
    lingua?: ELingua;
    room?: string | null;
    class?: string | null;
    view?: string | null;
    feature?: string | null;
    meals?: string | null;
    beds?: string | null;
    fullDescription?: string | null;

    constructor(data?: IHHAttributoHashcodeDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.room = _data["room"] !== undefined ? _data["room"] : <any>null;
            this.class = _data["class"] !== undefined ? _data["class"] : <any>null;
            this.view = _data["view"] !== undefined ? _data["view"] : <any>null;
            this.feature = _data["feature"] !== undefined ? _data["feature"] : <any>null;
            this.meals = _data["meals"] !== undefined ? _data["meals"] : <any>null;
            this.beds = _data["beds"] !== undefined ? _data["beds"] : <any>null;
            this.fullDescription = _data["fullDescription"] !== undefined ? _data["fullDescription"] : <any>null;
        }
    }

    static fromJS(data: any): HHAttributoHashcodeDescription {
        data = typeof data === 'object' ? data : {};
        let result = new HHAttributoHashcodeDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["room"] = this.room !== undefined ? this.room : <any>null;
        data["class"] = this.class !== undefined ? this.class : <any>null;
        data["view"] = this.view !== undefined ? this.view : <any>null;
        data["feature"] = this.feature !== undefined ? this.feature : <any>null;
        data["meals"] = this.meals !== undefined ? this.meals : <any>null;
        data["beds"] = this.beds !== undefined ? this.beds : <any>null;
        data["fullDescription"] = this.fullDescription !== undefined ? this.fullDescription : <any>null;
        return data;
    }
}

export interface IHHAttributoHashcodeDescription {
    lingua?: ELingua;
    room?: string | null;
    class?: string | null;
    view?: string | null;
    feature?: string | null;
    meals?: string | null;
    beds?: string | null;
    fullDescription?: string | null;
}

export class HHAttributoHashcode implements IHHAttributoHashcode {
    id?: number;
    hashcode!: string;
    roomID?: number | null;
    classID?: number | null;
    viewID?: number | null;
    bedsID?: number | null;
    featuresID?: number | null;
    mealsID?: number | null;

    constructor(data?: IHHAttributoHashcode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.hashcode = _data["hashcode"] !== undefined ? _data["hashcode"] : <any>null;
            this.roomID = _data["roomID"] !== undefined ? _data["roomID"] : <any>null;
            this.classID = _data["classID"] !== undefined ? _data["classID"] : <any>null;
            this.viewID = _data["viewID"] !== undefined ? _data["viewID"] : <any>null;
            this.bedsID = _data["bedsID"] !== undefined ? _data["bedsID"] : <any>null;
            this.featuresID = _data["featuresID"] !== undefined ? _data["featuresID"] : <any>null;
            this.mealsID = _data["mealsID"] !== undefined ? _data["mealsID"] : <any>null;
        }
    }

    static fromJS(data: any): HHAttributoHashcode {
        data = typeof data === 'object' ? data : {};
        let result = new HHAttributoHashcode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["hashcode"] = this.hashcode !== undefined ? this.hashcode : <any>null;
        data["roomID"] = this.roomID !== undefined ? this.roomID : <any>null;
        data["classID"] = this.classID !== undefined ? this.classID : <any>null;
        data["viewID"] = this.viewID !== undefined ? this.viewID : <any>null;
        data["bedsID"] = this.bedsID !== undefined ? this.bedsID : <any>null;
        data["featuresID"] = this.featuresID !== undefined ? this.featuresID : <any>null;
        data["mealsID"] = this.mealsID !== undefined ? this.mealsID : <any>null;
        return data;
    }
}

export interface IHHAttributoHashcode {
    id?: number;
    hashcode: string;
    roomID?: number | null;
    classID?: number | null;
    viewID?: number | null;
    bedsID?: number | null;
    featuresID?: number | null;
    mealsID?: number | null;
}

export class OffertaDatoDettaglio implements IOffertaDatoDettaglio {
    datoDettaglioID?: number;
    offertaDatoID?: number;
    associazioneID?: number;
    prezzo?: number;
    costo?: number;
    descrizione?: string | null;
    tipoAzione?: ETipoAzioneDettaglio;

    constructor(data?: IOffertaDatoDettaglio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datoDettaglioID = _data["datoDettaglioID"] !== undefined ? _data["datoDettaglioID"] : <any>null;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.associazioneID = _data["associazioneID"] !== undefined ? _data["associazioneID"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.tipoAzione = _data["tipoAzione"] !== undefined ? _data["tipoAzione"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaDatoDettaglio {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDatoDettaglio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datoDettaglioID"] = this.datoDettaglioID !== undefined ? this.datoDettaglioID : <any>null;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["associazioneID"] = this.associazioneID !== undefined ? this.associazioneID : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["costo"] = this.costo !== undefined ? this.costo : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["tipoAzione"] = this.tipoAzione !== undefined ? this.tipoAzione : <any>null;
        return data;
    }
}

export interface IOffertaDatoDettaglio {
    datoDettaglioID?: number;
    offertaDatoID?: number;
    associazioneID?: number;
    prezzo?: number;
    costo?: number;
    descrizione?: string | null;
    tipoAzione?: ETipoAzioneDettaglio;
}

export enum ETipoAzioneDettaglio {
    NessunCambiamento = "NessunCambiamento",
    Allerta = "Allerta",
    BloccoVendita = "BloccoVendita",
    RiduzioneApplicata = "RiduzioneApplicata",
    OffertaApplicata = "OffertaApplicata",
    Nascosto = "Nascosto",
    SupplementoApplicato = "SupplementoApplicato",
    VisualizzaInformazione = "VisualizzaInformazione",
}

export abstract class DatiRiga implements IDatiRiga {
    offertaDatoID?: number;

    constructor(data?: IDatiRiga) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
        }
    }

    static fromJS(data: any): DatiRiga {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'DatiRiga' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        return data;
    }
}

export interface IDatiRiga {
    offertaDatoID?: number;
}

export class DatiDocumentoRiga extends DatiRiga implements IDatiDocumentoRiga {
    descrizioneProgrammaDiViaggio?: string | null;
    inizio?: string | null;
    fine?: string | null;
    luogoInizioID?: number | null;
    puntoIniziale?: string | null;
    contattoPickupID?: number | null;
    luogoFineID?: number | null;
    puntoFinale?: string | null;
    contattoDropoffID?: number | null;

    constructor(data?: IDatiDocumentoRiga) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descrizioneProgrammaDiViaggio = _data["descrizioneProgrammaDiViaggio"] !== undefined ? _data["descrizioneProgrammaDiViaggio"] : <any>null;
            this.inizio = _data["inizio"] !== undefined ? _data["inizio"] : <any>null;
            this.fine = _data["fine"] !== undefined ? _data["fine"] : <any>null;
            this.luogoInizioID = _data["luogoInizioID"] !== undefined ? _data["luogoInizioID"] : <any>null;
            this.puntoIniziale = _data["puntoIniziale"] !== undefined ? _data["puntoIniziale"] : <any>null;
            this.contattoPickupID = _data["contattoPickupID"] !== undefined ? _data["contattoPickupID"] : <any>null;
            this.luogoFineID = _data["luogoFineID"] !== undefined ? _data["luogoFineID"] : <any>null;
            this.puntoFinale = _data["puntoFinale"] !== undefined ? _data["puntoFinale"] : <any>null;
            this.contattoDropoffID = _data["contattoDropoffID"] !== undefined ? _data["contattoDropoffID"] : <any>null;
        }
    }

    static fromJS(data: any): DatiDocumentoRiga {
        data = typeof data === 'object' ? data : {};
        let result = new DatiDocumentoRiga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizioneProgrammaDiViaggio"] = this.descrizioneProgrammaDiViaggio !== undefined ? this.descrizioneProgrammaDiViaggio : <any>null;
        data["inizio"] = this.inizio !== undefined ? this.inizio : <any>null;
        data["fine"] = this.fine !== undefined ? this.fine : <any>null;
        data["luogoInizioID"] = this.luogoInizioID !== undefined ? this.luogoInizioID : <any>null;
        data["puntoIniziale"] = this.puntoIniziale !== undefined ? this.puntoIniziale : <any>null;
        data["contattoPickupID"] = this.contattoPickupID !== undefined ? this.contattoPickupID : <any>null;
        data["luogoFineID"] = this.luogoFineID !== undefined ? this.luogoFineID : <any>null;
        data["puntoFinale"] = this.puntoFinale !== undefined ? this.puntoFinale : <any>null;
        data["contattoDropoffID"] = this.contattoDropoffID !== undefined ? this.contattoDropoffID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDatiDocumentoRiga extends IDatiRiga {
    descrizioneProgrammaDiViaggio?: string | null;
    inizio?: string | null;
    fine?: string | null;
    luogoInizioID?: number | null;
    puntoIniziale?: string | null;
    contattoPickupID?: number | null;
    luogoFineID?: number | null;
    puntoFinale?: string | null;
    contattoDropoffID?: number | null;
}

export class DatiConfermaRiga extends DatiRiga implements IDatiConfermaRiga {
    status?: EStatusServizio | null;
    bookingReference?: string | null;

    constructor(data?: IDatiConfermaRiga) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.bookingReference = _data["bookingReference"] !== undefined ? _data["bookingReference"] : <any>null;
        }
    }

    static fromJS(data: any): DatiConfermaRiga {
        data = typeof data === 'object' ? data : {};
        let result = new DatiConfermaRiga();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["bookingReference"] = this.bookingReference !== undefined ? this.bookingReference : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDatiConfermaRiga extends IDatiRiga {
    status?: EStatusServizio | null;
    bookingReference?: string | null;
}

export class OffertaNota implements IOffertaNota {
    offertaNotaID?: number;
    offertaID?: number;
    offertaDatoID?: number | null;
    accordoID?: number | null;
    testo!: string;
    data?: string;
    utenteImpiegatoID?: number | null;
    utentePresaInCaricoID?: number | null;
    fatto?: boolean;
    pubblica?: boolean;
    voucher?: boolean;
    kanban?: boolean;
    sistema?: boolean;
    tipo?: ETipoNota | null;

    constructor(data?: IOffertaNota) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaNotaID = _data["offertaNotaID"] !== undefined ? _data["offertaNotaID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.utenteImpiegatoID = _data["utenteImpiegatoID"] !== undefined ? _data["utenteImpiegatoID"] : <any>null;
            this.utentePresaInCaricoID = _data["utentePresaInCaricoID"] !== undefined ? _data["utentePresaInCaricoID"] : <any>null;
            this.fatto = _data["fatto"] !== undefined ? _data["fatto"] : <any>null;
            this.pubblica = _data["pubblica"] !== undefined ? _data["pubblica"] : <any>null;
            this.voucher = _data["voucher"] !== undefined ? _data["voucher"] : <any>null;
            this.kanban = _data["kanban"] !== undefined ? _data["kanban"] : <any>null;
            this.sistema = _data["sistema"] !== undefined ? _data["sistema"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaNota {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaNota();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaNotaID"] = this.offertaNotaID !== undefined ? this.offertaNotaID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["utenteImpiegatoID"] = this.utenteImpiegatoID !== undefined ? this.utenteImpiegatoID : <any>null;
        data["utentePresaInCaricoID"] = this.utentePresaInCaricoID !== undefined ? this.utentePresaInCaricoID : <any>null;
        data["fatto"] = this.fatto !== undefined ? this.fatto : <any>null;
        data["pubblica"] = this.pubblica !== undefined ? this.pubblica : <any>null;
        data["voucher"] = this.voucher !== undefined ? this.voucher : <any>null;
        data["kanban"] = this.kanban !== undefined ? this.kanban : <any>null;
        data["sistema"] = this.sistema !== undefined ? this.sistema : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        return data;
    }
}

export interface IOffertaNota {
    offertaNotaID?: number;
    offertaID?: number;
    offertaDatoID?: number | null;
    accordoID?: number | null;
    testo: string;
    data?: string;
    utenteImpiegatoID?: number | null;
    utentePresaInCaricoID?: number | null;
    fatto?: boolean;
    pubblica?: boolean;
    voucher?: boolean;
    kanban?: boolean;
    sistema?: boolean;
    tipo?: ETipoNota | null;
}

export enum ETipoNota {
    Interna = "Interna",
    PreventivoSingola = "PreventivoSingola",
    PreventivoMultipla = "PreventivoMultipla",
    Agenzia = "Agenzia",
    RispostaAgenzia = "RispostaAgenzia",
    Assistenza = "Assistenza",
    Passeggero = "Passeggero",
    Operatore = "Operatore",
}

export class TripNote implements ITripNote {
    nota?: OffertaNota;
    utente?: string | null;
    utentePresaInCarico?: string | null;

    constructor(data?: ITripNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nota = _data["nota"] ? OffertaNota.fromJS(_data["nota"]) : <any>null;
            this.utente = _data["utente"] !== undefined ? _data["utente"] : <any>null;
            this.utentePresaInCarico = _data["utentePresaInCarico"] !== undefined ? _data["utentePresaInCarico"] : <any>null;
        }
    }

    static fromJS(data: any): TripNote {
        data = typeof data === 'object' ? data : {};
        let result = new TripNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nota"] = this.nota ? this.nota.toJSON() : <any>null;
        data["utente"] = this.utente !== undefined ? this.utente : <any>null;
        data["utentePresaInCarico"] = this.utentePresaInCarico !== undefined ? this.utentePresaInCarico : <any>null;
        return data;
    }
}

export interface ITripNote {
    nota?: OffertaNota;
    utente?: string | null;
    utentePresaInCarico?: string | null;
}

export class AnticipoFornitore implements IAnticipoFornitore {
    accordoID?: number;
    importo?: number;
    valutaID?: number;
    codiceValuta?: string;
    data?: string | null;

    constructor(data?: IAnticipoFornitore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : <any>null;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static fromJS(data: any): AnticipoFornitore {
        data = typeof data === 'object' ? data : {};
        let result = new AnticipoFornitore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : <any>null;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        return data;
    }
}

export interface IAnticipoFornitore {
    accordoID?: number;
    importo?: number;
    valutaID?: number;
    codiceValuta?: string;
    data?: string | null;
}

export class InvioAssicurazioneFiloDiretto implements IInvioAssicurazioneFiloDiretto {
    id?: number;
    clienteID?: number;
    offertaDatoID?: number;
    dataInvio?: string;
    nome_Polizza?: string | null;
    cognome?: string | null;
    nome?: string | null;
    data_Prenotazione?: string | null;
    data_Partenza?: string | null;
    data_Rientro?: string | null;
    importo_Viaggio?: string | null;
    destinazione?: string | null;
    codice_Area?: string | null;
    bookingID?: string | null;
    tipo_Operazione?: string | null;
    login?: string | null;
    polizza?: string | null;
    capo_Nucleo?: string | null;
    tipo_Assicurato?: string | null;
    impremioAss?: string | null;
    codice_Fiscale?: string | null;

    constructor(data?: IInvioAssicurazioneFiloDiretto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : <any>null;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.dataInvio = _data["dataInvio"] !== undefined ? _data["dataInvio"] : <any>null;
            this.nome_Polizza = _data["nome_Polizza"] !== undefined ? _data["nome_Polizza"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.data_Prenotazione = _data["data_Prenotazione"] !== undefined ? _data["data_Prenotazione"] : <any>null;
            this.data_Partenza = _data["data_Partenza"] !== undefined ? _data["data_Partenza"] : <any>null;
            this.data_Rientro = _data["data_Rientro"] !== undefined ? _data["data_Rientro"] : <any>null;
            this.importo_Viaggio = _data["importo_Viaggio"] !== undefined ? _data["importo_Viaggio"] : <any>null;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : <any>null;
            this.codice_Area = _data["codice_Area"] !== undefined ? _data["codice_Area"] : <any>null;
            this.bookingID = _data["bookingID"] !== undefined ? _data["bookingID"] : <any>null;
            this.tipo_Operazione = _data["tipo_Operazione"] !== undefined ? _data["tipo_Operazione"] : <any>null;
            this.login = _data["login"] !== undefined ? _data["login"] : <any>null;
            this.polizza = _data["polizza"] !== undefined ? _data["polizza"] : <any>null;
            this.capo_Nucleo = _data["capo_Nucleo"] !== undefined ? _data["capo_Nucleo"] : <any>null;
            this.tipo_Assicurato = _data["tipo_Assicurato"] !== undefined ? _data["tipo_Assicurato"] : <any>null;
            this.impremioAss = _data["impremioAss"] !== undefined ? _data["impremioAss"] : <any>null;
            this.codice_Fiscale = _data["codice_Fiscale"] !== undefined ? _data["codice_Fiscale"] : <any>null;
        }
    }

    static fromJS(data: any): InvioAssicurazioneFiloDiretto {
        data = typeof data === 'object' ? data : {};
        let result = new InvioAssicurazioneFiloDiretto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : <any>null;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["dataInvio"] = this.dataInvio !== undefined ? this.dataInvio : <any>null;
        data["nome_Polizza"] = this.nome_Polizza !== undefined ? this.nome_Polizza : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["data_Prenotazione"] = this.data_Prenotazione !== undefined ? this.data_Prenotazione : <any>null;
        data["data_Partenza"] = this.data_Partenza !== undefined ? this.data_Partenza : <any>null;
        data["data_Rientro"] = this.data_Rientro !== undefined ? this.data_Rientro : <any>null;
        data["importo_Viaggio"] = this.importo_Viaggio !== undefined ? this.importo_Viaggio : <any>null;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : <any>null;
        data["codice_Area"] = this.codice_Area !== undefined ? this.codice_Area : <any>null;
        data["bookingID"] = this.bookingID !== undefined ? this.bookingID : <any>null;
        data["tipo_Operazione"] = this.tipo_Operazione !== undefined ? this.tipo_Operazione : <any>null;
        data["login"] = this.login !== undefined ? this.login : <any>null;
        data["polizza"] = this.polizza !== undefined ? this.polizza : <any>null;
        data["capo_Nucleo"] = this.capo_Nucleo !== undefined ? this.capo_Nucleo : <any>null;
        data["tipo_Assicurato"] = this.tipo_Assicurato !== undefined ? this.tipo_Assicurato : <any>null;
        data["impremioAss"] = this.impremioAss !== undefined ? this.impremioAss : <any>null;
        data["codice_Fiscale"] = this.codice_Fiscale !== undefined ? this.codice_Fiscale : <any>null;
        return data;
    }
}

export interface IInvioAssicurazioneFiloDiretto {
    id?: number;
    clienteID?: number;
    offertaDatoID?: number;
    dataInvio?: string;
    nome_Polizza?: string | null;
    cognome?: string | null;
    nome?: string | null;
    data_Prenotazione?: string | null;
    data_Partenza?: string | null;
    data_Rientro?: string | null;
    importo_Viaggio?: string | null;
    destinazione?: string | null;
    codice_Area?: string | null;
    bookingID?: string | null;
    tipo_Operazione?: string | null;
    login?: string | null;
    polizza?: string | null;
    capo_Nucleo?: string | null;
    tipo_Assicurato?: string | null;
    impremioAss?: string | null;
    codice_Fiscale?: string | null;
}

export class InvioAssicurazione implements IInvioAssicurazione {
    id?: number;
    offertaID!: number;
    clienteID!: number;
    offertaDatoID!: number;
    servizioID!: number;
    dataInvio!: string;
    idProdottoEA!: number;
    nomeProdottoEA?: string | null;
    cognome?: string | null;
    nome?: string | null;
    tipoAssicurato?: string | null;
    dataPrenotazione?: string | null;
    dataPartenza?: string | null;
    dataRientro?: string | null;
    importoViaggio?: string | null;
    destinazione?: string | null;
    codiceArea?: string | null;
    couponID?: string | null;
    tipoOperazione?: string | null;
    importoPremioAss?: string | null;
    codiceFiscale?: string | null;
    dataCancellazione?: string | null;
    dataUltimoAggiornamento?: string | null;

    constructor(data?: IInvioAssicurazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : <any>null;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.dataInvio = _data["dataInvio"] !== undefined ? _data["dataInvio"] : <any>null;
            this.idProdottoEA = _data["idProdottoEA"] !== undefined ? _data["idProdottoEA"] : <any>null;
            this.nomeProdottoEA = _data["nomeProdottoEA"] !== undefined ? _data["nomeProdottoEA"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.tipoAssicurato = _data["tipoAssicurato"] !== undefined ? _data["tipoAssicurato"] : <any>null;
            this.dataPrenotazione = _data["dataPrenotazione"] !== undefined ? _data["dataPrenotazione"] : <any>null;
            this.dataPartenza = _data["dataPartenza"] !== undefined ? _data["dataPartenza"] : <any>null;
            this.dataRientro = _data["dataRientro"] !== undefined ? _data["dataRientro"] : <any>null;
            this.importoViaggio = _data["importoViaggio"] !== undefined ? _data["importoViaggio"] : <any>null;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : <any>null;
            this.codiceArea = _data["codiceArea"] !== undefined ? _data["codiceArea"] : <any>null;
            this.couponID = _data["couponID"] !== undefined ? _data["couponID"] : <any>null;
            this.tipoOperazione = _data["tipoOperazione"] !== undefined ? _data["tipoOperazione"] : <any>null;
            this.importoPremioAss = _data["importoPremioAss"] !== undefined ? _data["importoPremioAss"] : <any>null;
            this.codiceFiscale = _data["codiceFiscale"] !== undefined ? _data["codiceFiscale"] : <any>null;
            this.dataCancellazione = _data["dataCancellazione"] !== undefined ? _data["dataCancellazione"] : <any>null;
            this.dataUltimoAggiornamento = _data["dataUltimoAggiornamento"] !== undefined ? _data["dataUltimoAggiornamento"] : <any>null;
        }
    }

    static fromJS(data: any): InvioAssicurazione {
        data = typeof data === 'object' ? data : {};
        let result = new InvioAssicurazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : <any>null;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["dataInvio"] = this.dataInvio !== undefined ? this.dataInvio : <any>null;
        data["idProdottoEA"] = this.idProdottoEA !== undefined ? this.idProdottoEA : <any>null;
        data["nomeProdottoEA"] = this.nomeProdottoEA !== undefined ? this.nomeProdottoEA : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["tipoAssicurato"] = this.tipoAssicurato !== undefined ? this.tipoAssicurato : <any>null;
        data["dataPrenotazione"] = this.dataPrenotazione !== undefined ? this.dataPrenotazione : <any>null;
        data["dataPartenza"] = this.dataPartenza !== undefined ? this.dataPartenza : <any>null;
        data["dataRientro"] = this.dataRientro !== undefined ? this.dataRientro : <any>null;
        data["importoViaggio"] = this.importoViaggio !== undefined ? this.importoViaggio : <any>null;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : <any>null;
        data["codiceArea"] = this.codiceArea !== undefined ? this.codiceArea : <any>null;
        data["couponID"] = this.couponID !== undefined ? this.couponID : <any>null;
        data["tipoOperazione"] = this.tipoOperazione !== undefined ? this.tipoOperazione : <any>null;
        data["importoPremioAss"] = this.importoPremioAss !== undefined ? this.importoPremioAss : <any>null;
        data["codiceFiscale"] = this.codiceFiscale !== undefined ? this.codiceFiscale : <any>null;
        data["dataCancellazione"] = this.dataCancellazione !== undefined ? this.dataCancellazione : <any>null;
        data["dataUltimoAggiornamento"] = this.dataUltimoAggiornamento !== undefined ? this.dataUltimoAggiornamento : <any>null;
        return data;
    }
}

export interface IInvioAssicurazione {
    id?: number;
    offertaID: number;
    clienteID: number;
    offertaDatoID: number;
    servizioID: number;
    dataInvio: string;
    idProdottoEA: number;
    nomeProdottoEA?: string | null;
    cognome?: string | null;
    nome?: string | null;
    tipoAssicurato?: string | null;
    dataPrenotazione?: string | null;
    dataPartenza?: string | null;
    dataRientro?: string | null;
    importoViaggio?: string | null;
    destinazione?: string | null;
    codiceArea?: string | null;
    couponID?: string | null;
    tipoOperazione?: string | null;
    importoPremioAss?: string | null;
    codiceFiscale?: string | null;
    dataCancellazione?: string | null;
    dataUltimoAggiornamento?: string | null;
}

export class PenaleServizio implements IPenaleServizio {
    nonRimborsabile?: boolean;
    dataLimite?: string | null;
    importo?: number | null;

    constructor(data?: IPenaleServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : <any>null;
            this.dataLimite = _data["dataLimite"] !== undefined ? _data["dataLimite"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
        }
    }

    static fromJS(data: any): PenaleServizio {
        data = typeof data === 'object' ? data : {};
        let result = new PenaleServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : <any>null;
        data["dataLimite"] = this.dataLimite !== undefined ? this.dataLimite : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        return data;
    }
}

export interface IPenaleServizio {
    nonRimborsabile?: boolean;
    dataLimite?: string | null;
    importo?: number | null;
}

export class TripServicePriceDetail implements ITripServicePriceDetail {
    descrizione?: string | null;
    costo?: number;
    prezzo?: number;
    tipo?: ETipoAzioneDettaglio;

    constructor(data?: ITripServicePriceDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
        }
    }

    static fromJS(data: any): TripServicePriceDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TripServicePriceDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["costo"] = this.costo !== undefined ? this.costo : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        return data;
    }
}

export interface ITripServicePriceDetail {
    descrizione?: string | null;
    costo?: number;
    prezzo?: number;
    tipo?: ETipoAzioneDettaglio;
}

export enum ETestoPenaleAgenzia {
    Nessuno = "Nessuno",
    NotaFornitore = "NotaFornitore",
    Articolo = "Articolo",
    NotaCustom = "NotaCustom",
    DatiAggiuntivi = "DatiAggiuntivi",
    PenaleH2H = "PenaleH2H",
}

export class TripRoom implements ITripRoom {
    abbinamento?: Abbinamento;
    clienti?: Cliente[];
    servizi?: TripService[];
    isTutti?: boolean;

    constructor(data?: ITripRoom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abbinamento = _data["abbinamento"] ? Abbinamento.fromJS(_data["abbinamento"]) : <any>null;
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(Cliente.fromJS(item));
            }
            else {
                this.clienti = <any>null;
            }
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(TripService.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
            this.isTutti = _data["isTutti"] !== undefined ? _data["isTutti"] : <any>null;
        }
    }

    static fromJS(data: any): TripRoom {
        data = typeof data === 'object' ? data : {};
        let result = new TripRoom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abbinamento"] = this.abbinamento ? this.abbinamento.toJSON() : <any>null;
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item.toJSON());
        }
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        data["isTutti"] = this.isTutti !== undefined ? this.isTutti : <any>null;
        return data;
    }
}

export interface ITripRoom {
    abbinamento?: Abbinamento;
    clienti?: Cliente[];
    servizi?: TripService[];
    isTutti?: boolean;
}

export class Abbinamento implements IAbbinamento {
    abbinamentoID?: number;
    abbinamentoIdPrecedente?: number | null;
    offertaID?: number | null;
    sistemazioneID?: number | null;
    nome?: string | null;
    nomiClienti?: string | null;
    tutti?: boolean | null;
    cameraDoppia?: boolean;
    voloID?: number | null;

    constructor(data?: IAbbinamento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : <any>null;
            this.abbinamentoIdPrecedente = _data["abbinamentoIdPrecedente"] !== undefined ? _data["abbinamentoIdPrecedente"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.sistemazioneID = _data["sistemazioneID"] !== undefined ? _data["sistemazioneID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomiClienti = _data["nomiClienti"] !== undefined ? _data["nomiClienti"] : <any>null;
            this.tutti = _data["tutti"] !== undefined ? _data["tutti"] : <any>null;
            this.cameraDoppia = _data["cameraDoppia"] !== undefined ? _data["cameraDoppia"] : <any>null;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : <any>null;
        }
    }

    static fromJS(data: any): Abbinamento {
        data = typeof data === 'object' ? data : {};
        let result = new Abbinamento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : <any>null;
        data["abbinamentoIdPrecedente"] = this.abbinamentoIdPrecedente !== undefined ? this.abbinamentoIdPrecedente : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["sistemazioneID"] = this.sistemazioneID !== undefined ? this.sistemazioneID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomiClienti"] = this.nomiClienti !== undefined ? this.nomiClienti : <any>null;
        data["tutti"] = this.tutti !== undefined ? this.tutti : <any>null;
        data["cameraDoppia"] = this.cameraDoppia !== undefined ? this.cameraDoppia : <any>null;
        data["voloID"] = this.voloID !== undefined ? this.voloID : <any>null;
        return data;
    }
}

export interface IAbbinamento {
    abbinamentoID?: number;
    abbinamentoIdPrecedente?: number | null;
    offertaID?: number | null;
    sistemazioneID?: number | null;
    nome?: string | null;
    nomiClienti?: string | null;
    tutti?: boolean | null;
    cameraDoppia?: boolean;
    voloID?: number | null;
}

export class WarningOfferta implements IWarningOfferta {
    tipo?: ETipoWarningOfferta;
    impedisceConferma?: boolean;
    oggetto?: string | null;
    oggettoID?: number;
    daData?: string | null;
    aData?: string | null;

    constructor(data?: IWarningOfferta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.impedisceConferma = _data["impedisceConferma"] !== undefined ? _data["impedisceConferma"] : <any>null;
            this.oggetto = _data["oggetto"] !== undefined ? _data["oggetto"] : <any>null;
            this.oggettoID = _data["oggettoID"] !== undefined ? _data["oggettoID"] : <any>null;
            this.daData = _data["daData"] !== undefined ? _data["daData"] : <any>null;
            this.aData = _data["aData"] !== undefined ? _data["aData"] : <any>null;
        }
    }

    static fromJS(data: any): WarningOfferta {
        data = typeof data === 'object' ? data : {};
        let result = new WarningOfferta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["impedisceConferma"] = this.impedisceConferma !== undefined ? this.impedisceConferma : <any>null;
        data["oggetto"] = this.oggetto !== undefined ? this.oggetto : <any>null;
        data["oggettoID"] = this.oggettoID !== undefined ? this.oggettoID : <any>null;
        data["daData"] = this.daData !== undefined ? this.daData : <any>null;
        data["aData"] = this.aData !== undefined ? this.aData : <any>null;
        return data;
    }
}

export interface IWarningOfferta {
    tipo?: ETipoWarningOfferta;
    impedisceConferma?: boolean;
    oggetto?: string | null;
    oggettoID?: number;
    daData?: string | null;
    aData?: string | null;
}

export enum ETipoWarningOfferta {
    NessunCliente = "NessunCliente",
    NessunAbbinamento = "NessunAbbinamento",
    NessunItinerario = "NessunItinerario",
    NessunServizio = "NessunServizio",
    ItinerariSovrapposti = "ItinerariSovrapposti",
    ItinerariNonConsecutivi = "ItinerariNonConsecutivi",
    DatiClienteIncompleti = "DatiClienteIncompleti",
    CodiceFiscaleNonValido = "CodiceFiscaleNonValido",
    DataNascitaNonCoerente = "DataNascitaNonCoerente",
    CodiceFiscaleMancante = "CodiceFiscaleMancante",
    DataNascitaNonConfermata = "DataNascitaNonConfermata",
    VoloSenzaPNR = "VoloSenzaPNR",
}

export class TripFlights implements ITripFlights {
    flightPlan?: TripFlightSegment[];
    serviziVolo?: TripFlightService[];
    voli?: TripFlight[] | null;

    constructor(data?: ITripFlights) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["flightPlan"])) {
                this.flightPlan = [] as any;
                for (let item of _data["flightPlan"])
                    this.flightPlan!.push(TripFlightSegment.fromJS(item));
            }
            else {
                this.flightPlan = <any>null;
            }
            if (Array.isArray(_data["serviziVolo"])) {
                this.serviziVolo = [] as any;
                for (let item of _data["serviziVolo"])
                    this.serviziVolo!.push(TripFlightService.fromJS(item));
            }
            else {
                this.serviziVolo = <any>null;
            }
            if (Array.isArray(_data["voli"])) {
                this.voli = [] as any;
                for (let item of _data["voli"])
                    this.voli!.push(TripFlight.fromJS(item));
            }
            else {
                this.voli = <any>null;
            }
        }
    }

    static fromJS(data: any): TripFlights {
        data = typeof data === 'object' ? data : {};
        let result = new TripFlights();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flightPlan)) {
            data["flightPlan"] = [];
            for (let item of this.flightPlan)
                data["flightPlan"].push(item.toJSON());
        }
        if (Array.isArray(this.serviziVolo)) {
            data["serviziVolo"] = [];
            for (let item of this.serviziVolo)
                data["serviziVolo"].push(item.toJSON());
        }
        if (Array.isArray(this.voli)) {
            data["voli"] = [];
            for (let item of this.voli)
                data["voli"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripFlights {
    flightPlan?: TripFlightSegment[];
    serviziVolo?: TripFlightService[];
    voli?: TripFlight[] | null;
}

export class TripFlightSegment implements ITripFlightSegment {
    pnr?: string | null;
    tratta?: VoloTratta;
    soluzione?: string | null;
    arrivoIlGiornoDopo?: boolean;
    compagnia?: string | null;
    aeroportoPartenza?: string | null;
    aeroportoArrivo?: string | null;
    codiceArea?: string | null;
    stato?: StatoVolo | null;
    isPnr?: boolean;
    tariffeTratteRel?: VoloRel[];
    tariffe?: VoloTariffa[];
    codiceOperatedBy?: string | null;
    nomeOperatedBy?: string | null;
    isNdc?: boolean;

    constructor(data?: ITripFlightSegment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : <any>null;
            this.tratta = _data["tratta"] ? VoloTratta.fromJS(_data["tratta"]) : <any>null;
            this.soluzione = _data["soluzione"] !== undefined ? _data["soluzione"] : <any>null;
            this.arrivoIlGiornoDopo = _data["arrivoIlGiornoDopo"] !== undefined ? _data["arrivoIlGiornoDopo"] : <any>null;
            this.compagnia = _data["compagnia"] !== undefined ? _data["compagnia"] : <any>null;
            this.aeroportoPartenza = _data["aeroportoPartenza"] !== undefined ? _data["aeroportoPartenza"] : <any>null;
            this.aeroportoArrivo = _data["aeroportoArrivo"] !== undefined ? _data["aeroportoArrivo"] : <any>null;
            this.codiceArea = _data["codiceArea"] !== undefined ? _data["codiceArea"] : <any>null;
            this.stato = _data["stato"] ? StatoVolo.fromJS(_data["stato"]) : <any>null;
            this.isPnr = _data["isPnr"] !== undefined ? _data["isPnr"] : <any>null;
            if (Array.isArray(_data["tariffeTratteRel"])) {
                this.tariffeTratteRel = [] as any;
                for (let item of _data["tariffeTratteRel"])
                    this.tariffeTratteRel!.push(VoloRel.fromJS(item));
            }
            else {
                this.tariffeTratteRel = <any>null;
            }
            if (Array.isArray(_data["tariffe"])) {
                this.tariffe = [] as any;
                for (let item of _data["tariffe"])
                    this.tariffe!.push(VoloTariffa.fromJS(item));
            }
            else {
                this.tariffe = <any>null;
            }
            this.codiceOperatedBy = _data["codiceOperatedBy"] !== undefined ? _data["codiceOperatedBy"] : <any>null;
            this.nomeOperatedBy = _data["nomeOperatedBy"] !== undefined ? _data["nomeOperatedBy"] : <any>null;
            this.isNdc = _data["isNdc"] !== undefined ? _data["isNdc"] : <any>null;
        }
    }

    static fromJS(data: any): TripFlightSegment {
        data = typeof data === 'object' ? data : {};
        let result = new TripFlightSegment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnr"] = this.pnr !== undefined ? this.pnr : <any>null;
        data["tratta"] = this.tratta ? this.tratta.toJSON() : <any>null;
        data["soluzione"] = this.soluzione !== undefined ? this.soluzione : <any>null;
        data["arrivoIlGiornoDopo"] = this.arrivoIlGiornoDopo !== undefined ? this.arrivoIlGiornoDopo : <any>null;
        data["compagnia"] = this.compagnia !== undefined ? this.compagnia : <any>null;
        data["aeroportoPartenza"] = this.aeroportoPartenza !== undefined ? this.aeroportoPartenza : <any>null;
        data["aeroportoArrivo"] = this.aeroportoArrivo !== undefined ? this.aeroportoArrivo : <any>null;
        data["codiceArea"] = this.codiceArea !== undefined ? this.codiceArea : <any>null;
        data["stato"] = this.stato ? this.stato.toJSON() : <any>null;
        data["isPnr"] = this.isPnr !== undefined ? this.isPnr : <any>null;
        if (Array.isArray(this.tariffeTratteRel)) {
            data["tariffeTratteRel"] = [];
            for (let item of this.tariffeTratteRel)
                data["tariffeTratteRel"].push(item.toJSON());
        }
        if (Array.isArray(this.tariffe)) {
            data["tariffe"] = [];
            for (let item of this.tariffe)
                data["tariffe"].push(item.toJSON());
        }
        data["codiceOperatedBy"] = this.codiceOperatedBy !== undefined ? this.codiceOperatedBy : <any>null;
        data["nomeOperatedBy"] = this.nomeOperatedBy !== undefined ? this.nomeOperatedBy : <any>null;
        data["isNdc"] = this.isNdc !== undefined ? this.isNdc : <any>null;
        return data;
    }
}

export interface ITripFlightSegment {
    pnr?: string | null;
    tratta?: VoloTratta;
    soluzione?: string | null;
    arrivoIlGiornoDopo?: boolean;
    compagnia?: string | null;
    aeroportoPartenza?: string | null;
    aeroportoArrivo?: string | null;
    codiceArea?: string | null;
    stato?: StatoVolo | null;
    isPnr?: boolean;
    tariffeTratteRel?: VoloRel[];
    tariffe?: VoloTariffa[];
    codiceOperatedBy?: string | null;
    nomeOperatedBy?: string | null;
    isNdc?: boolean;
}

export class VoloTratta implements IVoloTratta {
    voloTrattaID?: number;
    voloID?: number;
    numeroVolo?: number | null;
    partenza?: string | null;
    arrivo?: string | null;
    daAeroportoCodice?: string | null;
    adAeroportoCodice?: string | null;
    codiceCompagnia?: string | null;
    codiceCompagniaOperating?: string | null;
    codiceStato?: string | null;
    posti?: number | null;
    classe?: string | null;

    constructor(data?: IVoloTratta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voloTrattaID = _data["voloTrattaID"] !== undefined ? _data["voloTrattaID"] : <any>null;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : <any>null;
            this.numeroVolo = _data["numeroVolo"] !== undefined ? _data["numeroVolo"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.arrivo = _data["arrivo"] !== undefined ? _data["arrivo"] : <any>null;
            this.daAeroportoCodice = _data["daAeroportoCodice"] !== undefined ? _data["daAeroportoCodice"] : <any>null;
            this.adAeroportoCodice = _data["adAeroportoCodice"] !== undefined ? _data["adAeroportoCodice"] : <any>null;
            this.codiceCompagnia = _data["codiceCompagnia"] !== undefined ? _data["codiceCompagnia"] : <any>null;
            this.codiceCompagniaOperating = _data["codiceCompagniaOperating"] !== undefined ? _data["codiceCompagniaOperating"] : <any>null;
            this.codiceStato = _data["codiceStato"] !== undefined ? _data["codiceStato"] : <any>null;
            this.posti = _data["posti"] !== undefined ? _data["posti"] : <any>null;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : <any>null;
        }
    }

    static fromJS(data: any): VoloTratta {
        data = typeof data === 'object' ? data : {};
        let result = new VoloTratta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voloTrattaID"] = this.voloTrattaID !== undefined ? this.voloTrattaID : <any>null;
        data["voloID"] = this.voloID !== undefined ? this.voloID : <any>null;
        data["numeroVolo"] = this.numeroVolo !== undefined ? this.numeroVolo : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["arrivo"] = this.arrivo !== undefined ? this.arrivo : <any>null;
        data["daAeroportoCodice"] = this.daAeroportoCodice !== undefined ? this.daAeroportoCodice : <any>null;
        data["adAeroportoCodice"] = this.adAeroportoCodice !== undefined ? this.adAeroportoCodice : <any>null;
        data["codiceCompagnia"] = this.codiceCompagnia !== undefined ? this.codiceCompagnia : <any>null;
        data["codiceCompagniaOperating"] = this.codiceCompagniaOperating !== undefined ? this.codiceCompagniaOperating : <any>null;
        data["codiceStato"] = this.codiceStato !== undefined ? this.codiceStato : <any>null;
        data["posti"] = this.posti !== undefined ? this.posti : <any>null;
        data["classe"] = this.classe !== undefined ? this.classe : <any>null;
        return data;
    }
}

export interface IVoloTratta {
    voloTrattaID?: number;
    voloID?: number;
    numeroVolo?: number | null;
    partenza?: string | null;
    arrivo?: string | null;
    daAeroportoCodice?: string | null;
    adAeroportoCodice?: string | null;
    codiceCompagnia?: string | null;
    codiceCompagniaOperating?: string | null;
    codiceStato?: string | null;
    posti?: number | null;
    classe?: string | null;
}

export class VoloRel implements IVoloRel {
    voloRelID?: number;
    voloID?: number;
    voloTrattaID?: number;
    voloTariffaID?: number;
    fareBasis?: string | null;
    baggageIncluded?: number | null;
    cabin?: ETipoCabin | null;

    constructor(data?: IVoloRel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voloRelID = _data["voloRelID"] !== undefined ? _data["voloRelID"] : <any>null;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : <any>null;
            this.voloTrattaID = _data["voloTrattaID"] !== undefined ? _data["voloTrattaID"] : <any>null;
            this.voloTariffaID = _data["voloTariffaID"] !== undefined ? _data["voloTariffaID"] : <any>null;
            this.fareBasis = _data["fareBasis"] !== undefined ? _data["fareBasis"] : <any>null;
            this.baggageIncluded = _data["baggageIncluded"] !== undefined ? _data["baggageIncluded"] : <any>null;
            this.cabin = _data["cabin"] !== undefined ? _data["cabin"] : <any>null;
        }
    }

    static fromJS(data: any): VoloRel {
        data = typeof data === 'object' ? data : {};
        let result = new VoloRel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voloRelID"] = this.voloRelID !== undefined ? this.voloRelID : <any>null;
        data["voloID"] = this.voloID !== undefined ? this.voloID : <any>null;
        data["voloTrattaID"] = this.voloTrattaID !== undefined ? this.voloTrattaID : <any>null;
        data["voloTariffaID"] = this.voloTariffaID !== undefined ? this.voloTariffaID : <any>null;
        data["fareBasis"] = this.fareBasis !== undefined ? this.fareBasis : <any>null;
        data["baggageIncluded"] = this.baggageIncluded !== undefined ? this.baggageIncluded : <any>null;
        data["cabin"] = this.cabin !== undefined ? this.cabin : <any>null;
        return data;
    }
}

export interface IVoloRel {
    voloRelID?: number;
    voloID?: number;
    voloTrattaID?: number;
    voloTariffaID?: number;
    fareBasis?: string | null;
    baggageIncluded?: number | null;
    cabin?: ETipoCabin | null;
}

export enum ETipoCabin {
    Economy = "Economy",
    PremiumEconomy = "PremiumEconomy",
    Business = "Business",
    First = "First",
}

export class VoloTariffa implements IVoloTariffa {
    voloTariffaID?: number;
    voloID?: number | null;
    fareBasis?: string | null;
    idTariffaC?: number;
    tipoPaxID?: ETipoPax | null;
    tariffa?: number | null;
    tasse?: number | null;
    numeroPax?: number | null;
    costo?: number | null;
    costoTasse?: number | null;
    tariffaTO?: boolean;
    lastTicketDate?: string | null;
    baggageIncluded?: number | null;

    constructor(data?: IVoloTariffa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voloTariffaID = _data["voloTariffaID"] !== undefined ? _data["voloTariffaID"] : <any>null;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : <any>null;
            this.fareBasis = _data["fareBasis"] !== undefined ? _data["fareBasis"] : <any>null;
            this.idTariffaC = _data["idTariffaC"] !== undefined ? _data["idTariffaC"] : <any>null;
            this.tipoPaxID = _data["tipoPaxID"] !== undefined ? _data["tipoPaxID"] : <any>null;
            this.tariffa = _data["tariffa"] !== undefined ? _data["tariffa"] : <any>null;
            this.tasse = _data["tasse"] !== undefined ? _data["tasse"] : <any>null;
            this.numeroPax = _data["numeroPax"] !== undefined ? _data["numeroPax"] : <any>null;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : <any>null;
            this.costoTasse = _data["costoTasse"] !== undefined ? _data["costoTasse"] : <any>null;
            this.tariffaTO = _data["tariffaTO"] !== undefined ? _data["tariffaTO"] : <any>null;
            this.lastTicketDate = _data["lastTicketDate"] !== undefined ? _data["lastTicketDate"] : <any>null;
            this.baggageIncluded = _data["baggageIncluded"] !== undefined ? _data["baggageIncluded"] : <any>null;
        }
    }

    static fromJS(data: any): VoloTariffa {
        data = typeof data === 'object' ? data : {};
        let result = new VoloTariffa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voloTariffaID"] = this.voloTariffaID !== undefined ? this.voloTariffaID : <any>null;
        data["voloID"] = this.voloID !== undefined ? this.voloID : <any>null;
        data["fareBasis"] = this.fareBasis !== undefined ? this.fareBasis : <any>null;
        data["idTariffaC"] = this.idTariffaC !== undefined ? this.idTariffaC : <any>null;
        data["tipoPaxID"] = this.tipoPaxID !== undefined ? this.tipoPaxID : <any>null;
        data["tariffa"] = this.tariffa !== undefined ? this.tariffa : <any>null;
        data["tasse"] = this.tasse !== undefined ? this.tasse : <any>null;
        data["numeroPax"] = this.numeroPax !== undefined ? this.numeroPax : <any>null;
        data["costo"] = this.costo !== undefined ? this.costo : <any>null;
        data["costoTasse"] = this.costoTasse !== undefined ? this.costoTasse : <any>null;
        data["tariffaTO"] = this.tariffaTO !== undefined ? this.tariffaTO : <any>null;
        data["lastTicketDate"] = this.lastTicketDate !== undefined ? this.lastTicketDate : <any>null;
        data["baggageIncluded"] = this.baggageIncluded !== undefined ? this.baggageIncluded : <any>null;
        return data;
    }
}

export interface IVoloTariffa {
    voloTariffaID?: number;
    voloID?: number | null;
    fareBasis?: string | null;
    idTariffaC?: number;
    tipoPaxID?: ETipoPax | null;
    tariffa?: number | null;
    tasse?: number | null;
    numeroPax?: number | null;
    costo?: number | null;
    costoTasse?: number | null;
    tariffaTO?: boolean;
    lastTicketDate?: string | null;
    baggageIncluded?: number | null;
}

export enum ETipoPax {
    Sconosciuto = "Sconosciuto",
    Adulto = "Adulto",
    Child = "Child",
    Infant = "Infant",
}

export class TripFlightService extends TripService implements ITripFlightService {
    nome?: string | null;
    isTasseVolo?: boolean;
    daPrendereInCaricoTkt?: boolean;
    okContabTkt?: boolean;
    inCaricoTkt?: boolean;
    emessoTkt?: boolean;

    constructor(data?: ITripFlightService) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.isTasseVolo = _data["isTasseVolo"] !== undefined ? _data["isTasseVolo"] : <any>null;
            this.daPrendereInCaricoTkt = _data["daPrendereInCaricoTkt"] !== undefined ? _data["daPrendereInCaricoTkt"] : <any>null;
            this.okContabTkt = _data["okContabTkt"] !== undefined ? _data["okContabTkt"] : <any>null;
            this.inCaricoTkt = _data["inCaricoTkt"] !== undefined ? _data["inCaricoTkt"] : <any>null;
            this.emessoTkt = _data["emessoTkt"] !== undefined ? _data["emessoTkt"] : <any>null;
        }
    }

    static fromJS(data: any): TripFlightService {
        data = typeof data === 'object' ? data : {};
        let result = new TripFlightService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["isTasseVolo"] = this.isTasseVolo !== undefined ? this.isTasseVolo : <any>null;
        data["daPrendereInCaricoTkt"] = this.daPrendereInCaricoTkt !== undefined ? this.daPrendereInCaricoTkt : <any>null;
        data["okContabTkt"] = this.okContabTkt !== undefined ? this.okContabTkt : <any>null;
        data["inCaricoTkt"] = this.inCaricoTkt !== undefined ? this.inCaricoTkt : <any>null;
        data["emessoTkt"] = this.emessoTkt !== undefined ? this.emessoTkt : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITripFlightService extends ITripService {
    nome?: string | null;
    isTasseVolo?: boolean;
    daPrendereInCaricoTkt?: boolean;
    okContabTkt?: boolean;
    inCaricoTkt?: boolean;
    emessoTkt?: boolean;
}

export class TripFlight implements ITripFlight {
    volo?: Volo;
    fornitore?: string | null;
    tratte?: VoloTratta[];
    tariffe?: TripFlightFare[];
    note?: VoloNota[];
    relazioni?: VoloRel[];
    camera?: string | null;
    isPnr?: boolean;
    /** Se true vanno aggiornati i dati dei pax sul PNR */
    verificaPax?: boolean;

    constructor(data?: ITripFlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.volo = _data["volo"] ? Volo.fromJS(_data["volo"]) : <any>null;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            if (Array.isArray(_data["tratte"])) {
                this.tratte = [] as any;
                for (let item of _data["tratte"])
                    this.tratte!.push(VoloTratta.fromJS(item));
            }
            else {
                this.tratte = <any>null;
            }
            if (Array.isArray(_data["tariffe"])) {
                this.tariffe = [] as any;
                for (let item of _data["tariffe"])
                    this.tariffe!.push(TripFlightFare.fromJS(item));
            }
            else {
                this.tariffe = <any>null;
            }
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(VoloNota.fromJS(item));
            }
            else {
                this.note = <any>null;
            }
            if (Array.isArray(_data["relazioni"])) {
                this.relazioni = [] as any;
                for (let item of _data["relazioni"])
                    this.relazioni!.push(VoloRel.fromJS(item));
            }
            else {
                this.relazioni = <any>null;
            }
            this.camera = _data["camera"] !== undefined ? _data["camera"] : <any>null;
            this.isPnr = _data["isPnr"] !== undefined ? _data["isPnr"] : <any>null;
            this.verificaPax = _data["verificaPax"] !== undefined ? _data["verificaPax"] : <any>null;
        }
    }

    static fromJS(data: any): TripFlight {
        data = typeof data === 'object' ? data : {};
        let result = new TripFlight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["volo"] = this.volo ? this.volo.toJSON() : <any>null;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        if (Array.isArray(this.tratte)) {
            data["tratte"] = [];
            for (let item of this.tratte)
                data["tratte"].push(item.toJSON());
        }
        if (Array.isArray(this.tariffe)) {
            data["tariffe"] = [];
            for (let item of this.tariffe)
                data["tariffe"].push(item.toJSON());
        }
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item.toJSON());
        }
        if (Array.isArray(this.relazioni)) {
            data["relazioni"] = [];
            for (let item of this.relazioni)
                data["relazioni"].push(item.toJSON());
        }
        data["camera"] = this.camera !== undefined ? this.camera : <any>null;
        data["isPnr"] = this.isPnr !== undefined ? this.isPnr : <any>null;
        data["verificaPax"] = this.verificaPax !== undefined ? this.verificaPax : <any>null;
        return data;
    }
}

export interface ITripFlight {
    volo?: Volo;
    fornitore?: string | null;
    tratte?: VoloTratta[];
    tariffe?: TripFlightFare[];
    note?: VoloNota[];
    relazioni?: VoloRel[];
    camera?: string | null;
    isPnr?: boolean;
    /** Se true vanno aggiornati i dati dei pax sul PNR */
    verificaPax?: boolean;
}

export class Volo implements IVolo {
    voloID?: number;
    offertaID?: number | null;
    utenteID?: number | null;
    abbinamentoID?: number | null;
    offertaDatoID?: number | null;
    riga?: OffertaDato | null;
    pnr?: string | null;
    paxRef?: string | null;
    status?: EStatoVolo | null;
    dataSalvataggio?: string | null;
    dataPartenza?: string | null;
    dataCancellazioneAuto?: string | null;
    supplierID?: number | null;
    verificare?: boolean;

    constructor(data?: IVolo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.utenteID = _data["utenteID"] !== undefined ? _data["utenteID"] : <any>null;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : <any>null;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : <any>null;
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : <any>null;
            this.paxRef = _data["paxRef"] !== undefined ? _data["paxRef"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.dataSalvataggio = _data["dataSalvataggio"] !== undefined ? _data["dataSalvataggio"] : <any>null;
            this.dataPartenza = _data["dataPartenza"] !== undefined ? _data["dataPartenza"] : <any>null;
            this.dataCancellazioneAuto = _data["dataCancellazioneAuto"] !== undefined ? _data["dataCancellazioneAuto"] : <any>null;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : <any>null;
            this.verificare = _data["verificare"] !== undefined ? _data["verificare"] : <any>null;
        }
    }

    static fromJS(data: any): Volo {
        data = typeof data === 'object' ? data : {};
        let result = new Volo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voloID"] = this.voloID !== undefined ? this.voloID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["utenteID"] = this.utenteID !== undefined ? this.utenteID : <any>null;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : <any>null;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["riga"] = this.riga ? this.riga.toJSON() : <any>null;
        data["pnr"] = this.pnr !== undefined ? this.pnr : <any>null;
        data["paxRef"] = this.paxRef !== undefined ? this.paxRef : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["dataSalvataggio"] = this.dataSalvataggio !== undefined ? this.dataSalvataggio : <any>null;
        data["dataPartenza"] = this.dataPartenza !== undefined ? this.dataPartenza : <any>null;
        data["dataCancellazioneAuto"] = this.dataCancellazioneAuto !== undefined ? this.dataCancellazioneAuto : <any>null;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : <any>null;
        data["verificare"] = this.verificare !== undefined ? this.verificare : <any>null;
        return data;
    }
}

export interface IVolo {
    voloID?: number;
    offertaID?: number | null;
    utenteID?: number | null;
    abbinamentoID?: number | null;
    offertaDatoID?: number | null;
    riga?: OffertaDato | null;
    pnr?: string | null;
    paxRef?: string | null;
    status?: EStatoVolo | null;
    dataSalvataggio?: string | null;
    dataPartenza?: string | null;
    dataCancellazioneAuto?: string | null;
    supplierID?: number | null;
    verificare?: boolean;
}

export enum EStatoVolo {
    Attivo = "Attivo",
    Cancellato = "Cancellato",
    InEmissione = "InEmissione",
    Emesso = "Emesso",
    Monitorato = "Monitorato",
}

export class TripFlightFare implements ITripFlightFare {
    tariffa?: VoloTariffa;
    tratte?: VoloTratta[];
    relazioni?: VoloRel[];

    constructor(data?: ITripFlightFare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tariffa = _data["tariffa"] ? VoloTariffa.fromJS(_data["tariffa"]) : <any>null;
            if (Array.isArray(_data["tratte"])) {
                this.tratte = [] as any;
                for (let item of _data["tratte"])
                    this.tratte!.push(VoloTratta.fromJS(item));
            }
            else {
                this.tratte = <any>null;
            }
            if (Array.isArray(_data["relazioni"])) {
                this.relazioni = [] as any;
                for (let item of _data["relazioni"])
                    this.relazioni!.push(VoloRel.fromJS(item));
            }
            else {
                this.relazioni = <any>null;
            }
        }
    }

    static fromJS(data: any): TripFlightFare {
        data = typeof data === 'object' ? data : {};
        let result = new TripFlightFare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tariffa"] = this.tariffa ? this.tariffa.toJSON() : <any>null;
        if (Array.isArray(this.tratte)) {
            data["tratte"] = [];
            for (let item of this.tratte)
                data["tratte"].push(item.toJSON());
        }
        if (Array.isArray(this.relazioni)) {
            data["relazioni"] = [];
            for (let item of this.relazioni)
                data["relazioni"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripFlightFare {
    tariffa?: VoloTariffa;
    tratte?: VoloTratta[];
    relazioni?: VoloRel[];
}

export class VoloNota implements IVoloNota {
    voloNotaID?: number;
    voloID?: number;
    tipoID?: number | null;
    tipoMemo?: string | null;
    testo?: string | null;
    data?: string | null;

    constructor(data?: IVoloNota) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voloNotaID = _data["voloNotaID"] !== undefined ? _data["voloNotaID"] : <any>null;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : <any>null;
            this.tipoID = _data["tipoID"] !== undefined ? _data["tipoID"] : <any>null;
            this.tipoMemo = _data["tipoMemo"] !== undefined ? _data["tipoMemo"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static fromJS(data: any): VoloNota {
        data = typeof data === 'object' ? data : {};
        let result = new VoloNota();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voloNotaID"] = this.voloNotaID !== undefined ? this.voloNotaID : <any>null;
        data["voloID"] = this.voloID !== undefined ? this.voloID : <any>null;
        data["tipoID"] = this.tipoID !== undefined ? this.tipoID : <any>null;
        data["tipoMemo"] = this.tipoMemo !== undefined ? this.tipoMemo : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        return data;
    }
}

export interface IVoloNota {
    voloNotaID?: number;
    voloID?: number;
    tipoID?: number | null;
    tipoMemo?: string | null;
    testo?: string | null;
    data?: string | null;
}

export class TripStep implements ITripStep {
    itinerario?: OffertaItinerario;
    luogo?: string | null;
    dal?: string | null;
    al?: string | null;
    servizioCollegato?: string | null;
    tipologiaCollegata?: string | null;
    sovrapposto?: boolean;
    giorniMancantiAlPrecedente?: number;
    hotelStatus?: ETripStepHotelStatus;
    servizi?: TripService[];
    consentiRicercaHotel?: boolean;
    consentiRicercaTour?: boolean;
    consentiRicercaSelfdrive?: boolean;
    consentiRicercaTrasferimenti?: boolean;
    consentiRicercaVisite?: boolean;
    consentiRicercaVoli?: boolean;
    consentiRicercaNoleggi?: boolean;

    constructor(data?: ITripStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itinerario = _data["itinerario"] ? OffertaItinerario.fromJS(_data["itinerario"]) : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.servizioCollegato = _data["servizioCollegato"] !== undefined ? _data["servizioCollegato"] : <any>null;
            this.tipologiaCollegata = _data["tipologiaCollegata"] !== undefined ? _data["tipologiaCollegata"] : <any>null;
            this.sovrapposto = _data["sovrapposto"] !== undefined ? _data["sovrapposto"] : <any>null;
            this.giorniMancantiAlPrecedente = _data["giorniMancantiAlPrecedente"] !== undefined ? _data["giorniMancantiAlPrecedente"] : <any>null;
            this.hotelStatus = _data["hotelStatus"] !== undefined ? _data["hotelStatus"] : <any>null;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(TripService.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
            this.consentiRicercaHotel = _data["consentiRicercaHotel"] !== undefined ? _data["consentiRicercaHotel"] : <any>null;
            this.consentiRicercaTour = _data["consentiRicercaTour"] !== undefined ? _data["consentiRicercaTour"] : <any>null;
            this.consentiRicercaSelfdrive = _data["consentiRicercaSelfdrive"] !== undefined ? _data["consentiRicercaSelfdrive"] : <any>null;
            this.consentiRicercaTrasferimenti = _data["consentiRicercaTrasferimenti"] !== undefined ? _data["consentiRicercaTrasferimenti"] : <any>null;
            this.consentiRicercaVisite = _data["consentiRicercaVisite"] !== undefined ? _data["consentiRicercaVisite"] : <any>null;
            this.consentiRicercaVoli = _data["consentiRicercaVoli"] !== undefined ? _data["consentiRicercaVoli"] : <any>null;
            this.consentiRicercaNoleggi = _data["consentiRicercaNoleggi"] !== undefined ? _data["consentiRicercaNoleggi"] : <any>null;
        }
    }

    static fromJS(data: any): TripStep {
        data = typeof data === 'object' ? data : {};
        let result = new TripStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["servizioCollegato"] = this.servizioCollegato !== undefined ? this.servizioCollegato : <any>null;
        data["tipologiaCollegata"] = this.tipologiaCollegata !== undefined ? this.tipologiaCollegata : <any>null;
        data["sovrapposto"] = this.sovrapposto !== undefined ? this.sovrapposto : <any>null;
        data["giorniMancantiAlPrecedente"] = this.giorniMancantiAlPrecedente !== undefined ? this.giorniMancantiAlPrecedente : <any>null;
        data["hotelStatus"] = this.hotelStatus !== undefined ? this.hotelStatus : <any>null;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        data["consentiRicercaHotel"] = this.consentiRicercaHotel !== undefined ? this.consentiRicercaHotel : <any>null;
        data["consentiRicercaTour"] = this.consentiRicercaTour !== undefined ? this.consentiRicercaTour : <any>null;
        data["consentiRicercaSelfdrive"] = this.consentiRicercaSelfdrive !== undefined ? this.consentiRicercaSelfdrive : <any>null;
        data["consentiRicercaTrasferimenti"] = this.consentiRicercaTrasferimenti !== undefined ? this.consentiRicercaTrasferimenti : <any>null;
        data["consentiRicercaVisite"] = this.consentiRicercaVisite !== undefined ? this.consentiRicercaVisite : <any>null;
        data["consentiRicercaVoli"] = this.consentiRicercaVoli !== undefined ? this.consentiRicercaVoli : <any>null;
        data["consentiRicercaNoleggi"] = this.consentiRicercaNoleggi !== undefined ? this.consentiRicercaNoleggi : <any>null;
        return data;
    }
}

export interface ITripStep {
    itinerario?: OffertaItinerario;
    luogo?: string | null;
    dal?: string | null;
    al?: string | null;
    servizioCollegato?: string | null;
    tipologiaCollegata?: string | null;
    sovrapposto?: boolean;
    giorniMancantiAlPrecedente?: number;
    hotelStatus?: ETripStepHotelStatus;
    servizi?: TripService[];
    consentiRicercaHotel?: boolean;
    consentiRicercaTour?: boolean;
    consentiRicercaSelfdrive?: boolean;
    consentiRicercaTrasferimenti?: boolean;
    consentiRicercaVisite?: boolean;
    consentiRicercaVoli?: boolean;
    consentiRicercaNoleggi?: boolean;
}

export class OffertaItinerario implements IOffertaItinerario {
    itinerarioID?: number;
    offertaID?: number;
    luogoID?: number;
    giorno?: number | null;
    notti?: number | null;
    ordine?: number | null;
    tipo?: ETipoTappa | null;
    servizioTipologiaTourID?: number | null;
    tipoTrasporto?: ETipoTrasporto | null;
    autofillOperation?: EAutofillOperation;
    autofillStrategy?: EAutofillStrategy;
    autofillMinStars?: EAutofillMinStars;
    autofillFlags?: EAutofillFlags;
    airport?: string | null;
    offset?: number;
    servizioHotelID?: number | null;
    airportDeparture?: string | null;

    constructor(data?: IOffertaItinerario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.servizioTipologiaTourID = _data["servizioTipologiaTourID"] !== undefined ? _data["servizioTipologiaTourID"] : <any>null;
            this.tipoTrasporto = _data["tipoTrasporto"] !== undefined ? _data["tipoTrasporto"] : <any>null;
            this.autofillOperation = _data["autofillOperation"] !== undefined ? _data["autofillOperation"] : <any>null;
            this.autofillStrategy = _data["autofillStrategy"] !== undefined ? _data["autofillStrategy"] : <any>null;
            this.autofillMinStars = _data["autofillMinStars"] !== undefined ? _data["autofillMinStars"] : <any>null;
            this.autofillFlags = _data["autofillFlags"] !== undefined ? _data["autofillFlags"] : <any>null;
            this.airport = _data["airport"] !== undefined ? _data["airport"] : <any>null;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.servizioHotelID = _data["servizioHotelID"] !== undefined ? _data["servizioHotelID"] : <any>null;
            this.airportDeparture = _data["airportDeparture"] !== undefined ? _data["airportDeparture"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaItinerario {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaItinerario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["servizioTipologiaTourID"] = this.servizioTipologiaTourID !== undefined ? this.servizioTipologiaTourID : <any>null;
        data["tipoTrasporto"] = this.tipoTrasporto !== undefined ? this.tipoTrasporto : <any>null;
        data["autofillOperation"] = this.autofillOperation !== undefined ? this.autofillOperation : <any>null;
        data["autofillStrategy"] = this.autofillStrategy !== undefined ? this.autofillStrategy : <any>null;
        data["autofillMinStars"] = this.autofillMinStars !== undefined ? this.autofillMinStars : <any>null;
        data["autofillFlags"] = this.autofillFlags !== undefined ? this.autofillFlags : <any>null;
        data["airport"] = this.airport !== undefined ? this.airport : <any>null;
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["servizioHotelID"] = this.servizioHotelID !== undefined ? this.servizioHotelID : <any>null;
        data["airportDeparture"] = this.airportDeparture !== undefined ? this.airportDeparture : <any>null;
        return data;
    }
}

export interface IOffertaItinerario {
    itinerarioID?: number;
    offertaID?: number;
    luogoID?: number;
    giorno?: number | null;
    notti?: number | null;
    ordine?: number | null;
    tipo?: ETipoTappa | null;
    servizioTipologiaTourID?: number | null;
    tipoTrasporto?: ETipoTrasporto | null;
    autofillOperation?: EAutofillOperation;
    autofillStrategy?: EAutofillStrategy;
    autofillMinStars?: EAutofillMinStars;
    autofillFlags?: EAutofillFlags;
    airport?: string | null;
    offset?: number;
    servizioHotelID?: number | null;
    airportDeparture?: string | null;
}

export enum ETipoTappa {
    Normale = "Normale",
    Accessori = "Accessori",
    SoggiornoLibero = "SoggiornoLibero",
    InVolo = "InVolo",
    InizioViaggio = "InizioViaggio",
    TermineViaggio = "TermineViaggio",
    ItinerarioTour = "ItinerarioTour",
    ItinerarioSelfdrive = "ItinerarioSelfdrive",
    ItinerarioPacchetto = "ItinerarioPacchetto",
}

export enum EAutofillOperation {
    None = "None",
    Hotel = "Hotel",
    HotelAndPrivateTransfert = "HotelAndPrivateTransfert",
    HotelAndGroupTransfert = "HotelAndGroupTransfert",
    HotelAndPrivateCityViewTransfert = "HotelAndPrivateCityViewTransfert",
    HotelAndGroupCityViewTransfert = "HotelAndGroupCityViewTransfert",
}

export enum EAutofillStrategy {
    MostEconomic = "MostEconomic",
    HightestRating = "HightestRating",
}

export enum EAutofillMinStars {
    None = "None",
    Stars3 = "Stars3",
    Stars4 = "Stars4",
    Stars5 = "Stars5",
    Stars2 = "Stars2",
}

export enum EAutofillFlags {
    None = "None",
    IncludeOnRequestHotels = "IncludeOnRequestHotels",
    IncludeInstantPayHotels = "IncludeInstantPayHotels",
    IncludeNotRefundableHotels = "IncludeNotRefundableHotels",
    IncludeAirportHotels = "IncludeAirportHotels",
    IncludeOnRequestHotelsOrIncludeAirportHotels = "IncludeOnRequestHotelsOrIncludeAirportHotels",
    ExcludeFlightSearch = "ExcludeFlightSearch",
}

export enum ETripStepHotelStatus {
    Mancante = "Mancante",
    Parziale = "Parziale",
    Ok = "Ok",
}

export class TripAgreementCost implements ITripAgreementCost {
    accordoID?: number;
    accordo?: string | null;
    abbinamentoID?: number | null;
    abbinamento?: string | null;
    valuta?: string | null;
    costo?: number;
    prezzo?: number;

    constructor(data?: ITripAgreementCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : <any>null;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : <any>null;
            this.abbinamento = _data["abbinamento"] !== undefined ? _data["abbinamento"] : <any>null;
            this.valuta = _data["valuta"] !== undefined ? _data["valuta"] : <any>null;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
        }
    }

    static fromJS(data: any): TripAgreementCost {
        data = typeof data === 'object' ? data : {};
        let result = new TripAgreementCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["accordo"] = this.accordo !== undefined ? this.accordo : <any>null;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : <any>null;
        data["abbinamento"] = this.abbinamento !== undefined ? this.abbinamento : <any>null;
        data["valuta"] = this.valuta !== undefined ? this.valuta : <any>null;
        data["costo"] = this.costo !== undefined ? this.costo : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        return data;
    }
}

export interface ITripAgreementCost {
    accordoID?: number;
    accordo?: string | null;
    abbinamentoID?: number | null;
    abbinamento?: string | null;
    valuta?: string | null;
    costo?: number;
    prezzo?: number;
}

export class TripInvoicesListRow implements ITripInvoicesListRow {
    /** Invoice Id */
    id?: number;
    /** Invoice date */
    date?: string;
    /** Type of invoice */
    type?: ETipoDocumento;
    /** Invoice description */
    description?: string | null;

    constructor(data?: ITripInvoicesListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): TripInvoicesListRow {
        data = typeof data === 'object' ? data : {};
        let result = new TripInvoicesListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface ITripInvoicesListRow {
    /** Invoice Id */
    id?: number;
    /** Invoice date */
    date?: string;
    /** Type of invoice */
    type?: ETipoDocumento;
    /** Invoice description */
    description?: string | null;
}

export class TripDocument implements ITripDocument {
    /** ID del documento */
    id?: number;
    /** Entità del documento */
    documento?: Documento;
    /** Per i documenti condivisi è la url PRIVATA del documento.
Per i link Email è la url su Outlook.com */
    urlPrivato?: string | null;
    /** Url per la visualizzazione pubblica */
    urlPubblico?: string | null;
    /** Nome del documento */
    nome?: string | null;
    /** Nome del file collegato */
    nomeAllegato?: string | null;
    /** Nome del contatto */
    nomeContatto?: string | null;
    /** Content type dell'allegato */
    contentType?: string | null;
    /** Dimensione del file allegato */
    dimensioneAllegato?: number | null;
    /** Se true il documento è un link Email */
    isEmailLink?: boolean;
    /** Se true è possiible visualizzare l'anteprima */
    anteprimaVisibile?: boolean;
    /** Se true la stampa è visualizzabile */
    stampaVisibile?: boolean;
    /** Se true il documento può essere cancellato */
    eliminabile?: boolean;
    /** Se true esiste un editor per il documento */
    editabile?: boolean;
    /** Se true può usare l'editor a frasi */
    editabileFrasi?: boolean;
    /** Se true è possibioe duplicare la riga */
    duplicabile?: boolean;
    /** Se true il documento accetta la stampa multipla */
    stampaMulti?: boolean;
    /** Se true il documento può essere usato per la conversione multipla in PDF */
    pdfMulti?: boolean;
    /** True se il documento è convertibile in PDF */
    convertibilePdf?: boolean;
    /** True se il documento è inviabile per mail */
    inviabile?: boolean;
    /** Lista degli ID dei documenti extra (Post) */
    extraDocIDs?: number[];

    constructor(data?: ITripDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.documento = _data["documento"] ? Documento.fromJS(_data["documento"]) : <any>null;
            this.urlPrivato = _data["urlPrivato"] !== undefined ? _data["urlPrivato"] : <any>null;
            this.urlPubblico = _data["urlPubblico"] !== undefined ? _data["urlPubblico"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeAllegato = _data["nomeAllegato"] !== undefined ? _data["nomeAllegato"] : <any>null;
            this.nomeContatto = _data["nomeContatto"] !== undefined ? _data["nomeContatto"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
            this.dimensioneAllegato = _data["dimensioneAllegato"] !== undefined ? _data["dimensioneAllegato"] : <any>null;
            this.isEmailLink = _data["isEmailLink"] !== undefined ? _data["isEmailLink"] : <any>null;
            this.anteprimaVisibile = _data["anteprimaVisibile"] !== undefined ? _data["anteprimaVisibile"] : <any>null;
            this.stampaVisibile = _data["stampaVisibile"] !== undefined ? _data["stampaVisibile"] : <any>null;
            this.eliminabile = _data["eliminabile"] !== undefined ? _data["eliminabile"] : <any>null;
            this.editabile = _data["editabile"] !== undefined ? _data["editabile"] : <any>null;
            this.editabileFrasi = _data["editabileFrasi"] !== undefined ? _data["editabileFrasi"] : <any>null;
            this.duplicabile = _data["duplicabile"] !== undefined ? _data["duplicabile"] : <any>null;
            this.stampaMulti = _data["stampaMulti"] !== undefined ? _data["stampaMulti"] : <any>null;
            this.pdfMulti = _data["pdfMulti"] !== undefined ? _data["pdfMulti"] : <any>null;
            this.convertibilePdf = _data["convertibilePdf"] !== undefined ? _data["convertibilePdf"] : <any>null;
            this.inviabile = _data["inviabile"] !== undefined ? _data["inviabile"] : <any>null;
            if (Array.isArray(_data["extraDocIDs"])) {
                this.extraDocIDs = [] as any;
                for (let item of _data["extraDocIDs"])
                    this.extraDocIDs!.push(item);
            }
            else {
                this.extraDocIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): TripDocument {
        data = typeof data === 'object' ? data : {};
        let result = new TripDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["documento"] = this.documento ? this.documento.toJSON() : <any>null;
        data["urlPrivato"] = this.urlPrivato !== undefined ? this.urlPrivato : <any>null;
        data["urlPubblico"] = this.urlPubblico !== undefined ? this.urlPubblico : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeAllegato"] = this.nomeAllegato !== undefined ? this.nomeAllegato : <any>null;
        data["nomeContatto"] = this.nomeContatto !== undefined ? this.nomeContatto : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        data["dimensioneAllegato"] = this.dimensioneAllegato !== undefined ? this.dimensioneAllegato : <any>null;
        data["isEmailLink"] = this.isEmailLink !== undefined ? this.isEmailLink : <any>null;
        data["anteprimaVisibile"] = this.anteprimaVisibile !== undefined ? this.anteprimaVisibile : <any>null;
        data["stampaVisibile"] = this.stampaVisibile !== undefined ? this.stampaVisibile : <any>null;
        data["eliminabile"] = this.eliminabile !== undefined ? this.eliminabile : <any>null;
        data["editabile"] = this.editabile !== undefined ? this.editabile : <any>null;
        data["editabileFrasi"] = this.editabileFrasi !== undefined ? this.editabileFrasi : <any>null;
        data["duplicabile"] = this.duplicabile !== undefined ? this.duplicabile : <any>null;
        data["stampaMulti"] = this.stampaMulti !== undefined ? this.stampaMulti : <any>null;
        data["pdfMulti"] = this.pdfMulti !== undefined ? this.pdfMulti : <any>null;
        data["convertibilePdf"] = this.convertibilePdf !== undefined ? this.convertibilePdf : <any>null;
        data["inviabile"] = this.inviabile !== undefined ? this.inviabile : <any>null;
        if (Array.isArray(this.extraDocIDs)) {
            data["extraDocIDs"] = [];
            for (let item of this.extraDocIDs)
                data["extraDocIDs"].push(item);
        }
        return data;
    }
}

export interface ITripDocument {
    /** ID del documento */
    id?: number;
    /** Entità del documento */
    documento?: Documento;
    /** Per i documenti condivisi è la url PRIVATA del documento.
Per i link Email è la url su Outlook.com */
    urlPrivato?: string | null;
    /** Url per la visualizzazione pubblica */
    urlPubblico?: string | null;
    /** Nome del documento */
    nome?: string | null;
    /** Nome del file collegato */
    nomeAllegato?: string | null;
    /** Nome del contatto */
    nomeContatto?: string | null;
    /** Content type dell'allegato */
    contentType?: string | null;
    /** Dimensione del file allegato */
    dimensioneAllegato?: number | null;
    /** Se true il documento è un link Email */
    isEmailLink?: boolean;
    /** Se true è possiible visualizzare l'anteprima */
    anteprimaVisibile?: boolean;
    /** Se true la stampa è visualizzabile */
    stampaVisibile?: boolean;
    /** Se true il documento può essere cancellato */
    eliminabile?: boolean;
    /** Se true esiste un editor per il documento */
    editabile?: boolean;
    /** Se true può usare l'editor a frasi */
    editabileFrasi?: boolean;
    /** Se true è possibioe duplicare la riga */
    duplicabile?: boolean;
    /** Se true il documento accetta la stampa multipla */
    stampaMulti?: boolean;
    /** Se true il documento può essere usato per la conversione multipla in PDF */
    pdfMulti?: boolean;
    /** True se il documento è convertibile in PDF */
    convertibilePdf?: boolean;
    /** True se il documento è inviabile per mail */
    inviabile?: boolean;
    /** Lista degli ID dei documenti extra (Post) */
    extraDocIDs?: number[];
}

export class Documento implements IDocumento {
    documentoID?: number;
    offertaID?: number;
    contattoID?: number | null;
    tipoDocumento?: ETipoDocumento;
    testata?: string | null;
    corpo?: string | null;
    corpo2?: string | null;
    data?: string | null;
    userID?: number | null;
    spedito?: string | null;
    contatoreSpedizioni?: number | null;
    rootID?: number;
    opzioni?: string | null;
    storage?: EStorage;

    constructor(data?: IDocumento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : <any>null;
            this.testata = _data["testata"] !== undefined ? _data["testata"] : <any>null;
            this.corpo = _data["corpo"] !== undefined ? _data["corpo"] : <any>null;
            this.corpo2 = _data["corpo2"] !== undefined ? _data["corpo2"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : <any>null;
            this.spedito = _data["spedito"] !== undefined ? _data["spedito"] : <any>null;
            this.contatoreSpedizioni = _data["contatoreSpedizioni"] !== undefined ? _data["contatoreSpedizioni"] : <any>null;
            this.rootID = _data["rootID"] !== undefined ? _data["rootID"] : <any>null;
            this.opzioni = _data["opzioni"] !== undefined ? _data["opzioni"] : <any>null;
            this.storage = _data["storage"] !== undefined ? _data["storage"] : <any>null;
        }
    }

    static fromJS(data: any): Documento {
        data = typeof data === 'object' ? data : {};
        let result = new Documento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : <any>null;
        data["testata"] = this.testata !== undefined ? this.testata : <any>null;
        data["corpo"] = this.corpo !== undefined ? this.corpo : <any>null;
        data["corpo2"] = this.corpo2 !== undefined ? this.corpo2 : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["userID"] = this.userID !== undefined ? this.userID : <any>null;
        data["spedito"] = this.spedito !== undefined ? this.spedito : <any>null;
        data["contatoreSpedizioni"] = this.contatoreSpedizioni !== undefined ? this.contatoreSpedizioni : <any>null;
        data["rootID"] = this.rootID !== undefined ? this.rootID : <any>null;
        data["opzioni"] = this.opzioni !== undefined ? this.opzioni : <any>null;
        data["storage"] = this.storage !== undefined ? this.storage : <any>null;
        return data;
    }
}

export interface IDocumento {
    documentoID?: number;
    offertaID?: number;
    contattoID?: number | null;
    tipoDocumento?: ETipoDocumento;
    testata?: string | null;
    corpo?: string | null;
    corpo2?: string | null;
    data?: string | null;
    userID?: number | null;
    spedito?: string | null;
    contatoreSpedizioni?: number | null;
    rootID?: number;
    opzioni?: string | null;
    storage?: EStorage;
}

export enum EStorage {
    Unknown = "Unknown",
    SharedFilesystem = "SharedFilesystem",
    AzureMedia = "AzureMedia",
    Database = "Database",
}

export class TripVoucher implements ITripVoucher {
    nr?: string;
    voucher?: Voucher;
    servizio?: string;
    isNozze?: boolean;

    constructor(data?: ITripVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nr = _data["nr"] !== undefined ? _data["nr"] : <any>null;
            this.voucher = _data["voucher"] ? Voucher.fromJS(_data["voucher"]) : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.isNozze = _data["isNozze"] !== undefined ? _data["isNozze"] : <any>null;
        }
    }

    static fromJS(data: any): TripVoucher {
        data = typeof data === 'object' ? data : {};
        let result = new TripVoucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nr"] = this.nr !== undefined ? this.nr : <any>null;
        data["voucher"] = this.voucher ? this.voucher.toJSON() : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["isNozze"] = this.isNozze !== undefined ? this.isNozze : <any>null;
        return data;
    }
}

export interface ITripVoucher {
    nr?: string;
    voucher?: Voucher;
    servizio?: string;
    isNozze?: boolean;
}

export class Voucher implements IVoucher {
    voucherID?: number;
    offertaID?: number | null;
    ordine?: number | null;
    testata?: string | null;
    bookingRef?: string | null;
    clienti?: string | null;
    descrizioneServizio?: string | null;
    periodo?: string | null;
    dettaglio?: string | null;
    istruzioni?: string | null;
    servizioID?: number | null;
    lingua?: ELingua | null;
    versione?: number;

    constructor(data?: IVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voucherID = _data["voucherID"] !== undefined ? _data["voucherID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.testata = _data["testata"] !== undefined ? _data["testata"] : <any>null;
            this.bookingRef = _data["bookingRef"] !== undefined ? _data["bookingRef"] : <any>null;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : <any>null;
            this.descrizioneServizio = _data["descrizioneServizio"] !== undefined ? _data["descrizioneServizio"] : <any>null;
            this.periodo = _data["periodo"] !== undefined ? _data["periodo"] : <any>null;
            this.dettaglio = _data["dettaglio"] !== undefined ? _data["dettaglio"] : <any>null;
            this.istruzioni = _data["istruzioni"] !== undefined ? _data["istruzioni"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.versione = _data["versione"] !== undefined ? _data["versione"] : <any>null;
        }
    }

    static fromJS(data: any): Voucher {
        data = typeof data === 'object' ? data : {};
        let result = new Voucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherID"] = this.voucherID !== undefined ? this.voucherID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["testata"] = this.testata !== undefined ? this.testata : <any>null;
        data["bookingRef"] = this.bookingRef !== undefined ? this.bookingRef : <any>null;
        data["clienti"] = this.clienti !== undefined ? this.clienti : <any>null;
        data["descrizioneServizio"] = this.descrizioneServizio !== undefined ? this.descrizioneServizio : <any>null;
        data["periodo"] = this.periodo !== undefined ? this.periodo : <any>null;
        data["dettaglio"] = this.dettaglio !== undefined ? this.dettaglio : <any>null;
        data["istruzioni"] = this.istruzioni !== undefined ? this.istruzioni : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["versione"] = this.versione !== undefined ? this.versione : <any>null;
        return data;
    }
}

export interface IVoucher {
    voucherID?: number;
    offertaID?: number | null;
    ordine?: number | null;
    testata?: string | null;
    bookingRef?: string | null;
    clienti?: string | null;
    descrizioneServizio?: string | null;
    periodo?: string | null;
    dettaglio?: string | null;
    istruzioni?: string | null;
    servizioID?: number | null;
    lingua?: ELingua | null;
    versione?: number;
}

export class TripEmail implements ITripEmail {
    id?: number;
    from?: string;
    to?: string;
    cc?: string;
    bcc?: string;
    attachments?: TripEmailAttachment[];
    email?: EmailQueue;

    constructor(data?: ITripEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
            this.cc = _data["cc"] !== undefined ? _data["cc"] : <any>null;
            this.bcc = _data["bcc"] !== undefined ? _data["bcc"] : <any>null;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(TripEmailAttachment.fromJS(item));
            }
            else {
                this.attachments = <any>null;
            }
            this.email = _data["email"] ? EmailQueue.fromJS(_data["email"]) : <any>null;
        }
    }

    static fromJS(data: any): TripEmail {
        data = typeof data === 'object' ? data : {};
        let result = new TripEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["to"] = this.to !== undefined ? this.to : <any>null;
        data["cc"] = this.cc !== undefined ? this.cc : <any>null;
        data["bcc"] = this.bcc !== undefined ? this.bcc : <any>null;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["email"] = this.email ? this.email.toJSON() : <any>null;
        return data;
    }
}

export interface ITripEmail {
    id?: number;
    from?: string;
    to?: string;
    cc?: string;
    bcc?: string;
    attachments?: TripEmailAttachment[];
    email?: EmailQueue;
}

export class TripEmailAttachment implements ITripEmailAttachment {
    id?: number;
    name?: string;

    constructor(data?: ITripEmailAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): TripEmailAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new TripEmailAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ITripEmailAttachment {
    id?: number;
    name?: string;
}

export class EmailQueue implements IEmailQueue {
    id?: number;
    category?: EEmailCategory;
    senderUserID?: number | null;
    offertaID?: number | null;
    offertaDatoID?: number | null;
    fromAddress!: string;
    fromName?: string | null;
    subject!: string;
    bodyText!: string;
    isHtmlBoby?: boolean;
    requestNotify?: boolean;
    highPriority?: boolean;
    status?: EEmailStatus;
    statusText?: string | null;
    creationDate?: string;
    requestedSendDate?: string;
    processedDate?: string | null;
    headers?: string | null;

    constructor(data?: IEmailQueue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.senderUserID = _data["senderUserID"] !== undefined ? _data["senderUserID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.fromAddress = _data["fromAddress"] !== undefined ? _data["fromAddress"] : <any>null;
            this.fromName = _data["fromName"] !== undefined ? _data["fromName"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.bodyText = _data["bodyText"] !== undefined ? _data["bodyText"] : <any>null;
            this.isHtmlBoby = _data["isHtmlBoby"] !== undefined ? _data["isHtmlBoby"] : <any>null;
            this.requestNotify = _data["requestNotify"] !== undefined ? _data["requestNotify"] : <any>null;
            this.highPriority = _data["highPriority"] !== undefined ? _data["highPriority"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.statusText = _data["statusText"] !== undefined ? _data["statusText"] : <any>null;
            this.creationDate = _data["creationDate"] !== undefined ? _data["creationDate"] : <any>null;
            this.requestedSendDate = _data["requestedSendDate"] !== undefined ? _data["requestedSendDate"] : <any>null;
            this.processedDate = _data["processedDate"] !== undefined ? _data["processedDate"] : <any>null;
            this.headers = _data["headers"] !== undefined ? _data["headers"] : <any>null;
        }
    }

    static fromJS(data: any): EmailQueue {
        data = typeof data === 'object' ? data : {};
        let result = new EmailQueue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["senderUserID"] = this.senderUserID !== undefined ? this.senderUserID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["fromAddress"] = this.fromAddress !== undefined ? this.fromAddress : <any>null;
        data["fromName"] = this.fromName !== undefined ? this.fromName : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["bodyText"] = this.bodyText !== undefined ? this.bodyText : <any>null;
        data["isHtmlBoby"] = this.isHtmlBoby !== undefined ? this.isHtmlBoby : <any>null;
        data["requestNotify"] = this.requestNotify !== undefined ? this.requestNotify : <any>null;
        data["highPriority"] = this.highPriority !== undefined ? this.highPriority : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["statusText"] = this.statusText !== undefined ? this.statusText : <any>null;
        data["creationDate"] = this.creationDate !== undefined ? this.creationDate : <any>null;
        data["requestedSendDate"] = this.requestedSendDate !== undefined ? this.requestedSendDate : <any>null;
        data["processedDate"] = this.processedDate !== undefined ? this.processedDate : <any>null;
        data["headers"] = this.headers !== undefined ? this.headers : <any>null;
        return data;
    }
}

export interface IEmailQueue {
    id?: number;
    category?: EEmailCategory;
    senderUserID?: number | null;
    offertaID?: number | null;
    offertaDatoID?: number | null;
    fromAddress: string;
    fromName?: string | null;
    subject: string;
    bodyText: string;
    isHtmlBoby?: boolean;
    requestNotify?: boolean;
    highPriority?: boolean;
    status?: EEmailStatus;
    statusText?: string | null;
    creationDate?: string;
    requestedSendDate?: string;
    processedDate?: string | null;
    headers?: string | null;
}

export enum EEmailCategory {
    Accounting = "Accounting",
    Booking = "Booking",
    Documenti = "Documenti",
    DocumentiContabili = "DocumentiContabili",
    AreaAgenzie = "AreaAgenzie",
    InvioCliente = "InvioCliente",
    Assicurazioni = "Assicurazioni",
    Report = "Report",
}

export enum EEmailStatus {
    Queued = "Queued",
    Sent = "Sent",
    Error = "Error",
    Canceled = "Canceled",
}

export class TripAttachedDocCategory implements ITripAttachedDocCategory {
    nome?: string | null;
    documenti?: TripAttachedDoc[];

    constructor(data?: ITripAttachedDocCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            if (Array.isArray(_data["documenti"])) {
                this.documenti = [] as any;
                for (let item of _data["documenti"])
                    this.documenti!.push(TripAttachedDoc.fromJS(item));
            }
            else {
                this.documenti = <any>null;
            }
        }
    }

    static fromJS(data: any): TripAttachedDocCategory {
        data = typeof data === 'object' ? data : {};
        let result = new TripAttachedDocCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        if (Array.isArray(this.documenti)) {
            data["documenti"] = [];
            for (let item of this.documenti)
                data["documenti"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripAttachedDocCategory {
    nome?: string | null;
    documenti?: TripAttachedDoc[];
}

export class TripAttachedDoc implements ITripAttachedDoc {
    id?: number;
    nome?: string | null;
    selezionato?: boolean;
    allegato?: string | null;
    dimensioni?: number | null;
    url?: string | null;
    ordine?: number;

    constructor(data?: ITripAttachedDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.selezionato = _data["selezionato"] !== undefined ? _data["selezionato"] : <any>null;
            this.allegato = _data["allegato"] !== undefined ? _data["allegato"] : <any>null;
            this.dimensioni = _data["dimensioni"] !== undefined ? _data["dimensioni"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
        }
    }

    static fromJS(data: any): TripAttachedDoc {
        data = typeof data === 'object' ? data : {};
        let result = new TripAttachedDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["selezionato"] = this.selezionato !== undefined ? this.selezionato : <any>null;
        data["allegato"] = this.allegato !== undefined ? this.allegato : <any>null;
        data["dimensioni"] = this.dimensioni !== undefined ? this.dimensioni : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        return data;
    }
}

export interface ITripAttachedDoc {
    id?: number;
    nome?: string | null;
    selezionato?: boolean;
    allegato?: string | null;
    dimensioni?: number | null;
    url?: string | null;
    ordine?: number;
}

export class TripAgencyDocuments implements ITripAgencyDocuments {
    offerta?: TripDocument | null;
    preventivoCliente?: TripDocument | null;
    preventivoClientePlus?: TripDocument | null;
    conferma?: TripDocument | null;
    estrattoConto?: TripDocument | null;
    programma?: TripDocument | null;
    documentiOnline?: TripDocument[] | null;
    documentiAllegati?: TripDocument[] | null;
    consentiStampaVoucher?: boolean;
    consentiStampaFatture?: boolean;
    confermaProvvisoria?: TripDocument | null;
    confermaCliente?: TripDocument | null;

    constructor(data?: ITripAgencyDocuments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerta = _data["offerta"] ? TripDocument.fromJS(_data["offerta"]) : <any>null;
            this.preventivoCliente = _data["preventivoCliente"] ? TripDocument.fromJS(_data["preventivoCliente"]) : <any>null;
            this.preventivoClientePlus = _data["preventivoClientePlus"] ? TripDocument.fromJS(_data["preventivoClientePlus"]) : <any>null;
            this.conferma = _data["conferma"] ? TripDocument.fromJS(_data["conferma"]) : <any>null;
            this.estrattoConto = _data["estrattoConto"] ? TripDocument.fromJS(_data["estrattoConto"]) : <any>null;
            this.programma = _data["programma"] ? TripDocument.fromJS(_data["programma"]) : <any>null;
            if (Array.isArray(_data["documentiOnline"])) {
                this.documentiOnline = [] as any;
                for (let item of _data["documentiOnline"])
                    this.documentiOnline!.push(TripDocument.fromJS(item));
            }
            else {
                this.documentiOnline = <any>null;
            }
            if (Array.isArray(_data["documentiAllegati"])) {
                this.documentiAllegati = [] as any;
                for (let item of _data["documentiAllegati"])
                    this.documentiAllegati!.push(TripDocument.fromJS(item));
            }
            else {
                this.documentiAllegati = <any>null;
            }
            this.consentiStampaVoucher = _data["consentiStampaVoucher"] !== undefined ? _data["consentiStampaVoucher"] : <any>null;
            this.consentiStampaFatture = _data["consentiStampaFatture"] !== undefined ? _data["consentiStampaFatture"] : <any>null;
            this.confermaProvvisoria = _data["confermaProvvisoria"] ? TripDocument.fromJS(_data["confermaProvvisoria"]) : <any>null;
            this.confermaCliente = _data["confermaCliente"] ? TripDocument.fromJS(_data["confermaCliente"]) : <any>null;
        }
    }

    static fromJS(data: any): TripAgencyDocuments {
        data = typeof data === 'object' ? data : {};
        let result = new TripAgencyDocuments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        data["preventivoCliente"] = this.preventivoCliente ? this.preventivoCliente.toJSON() : <any>null;
        data["preventivoClientePlus"] = this.preventivoClientePlus ? this.preventivoClientePlus.toJSON() : <any>null;
        data["conferma"] = this.conferma ? this.conferma.toJSON() : <any>null;
        data["estrattoConto"] = this.estrattoConto ? this.estrattoConto.toJSON() : <any>null;
        data["programma"] = this.programma ? this.programma.toJSON() : <any>null;
        if (Array.isArray(this.documentiOnline)) {
            data["documentiOnline"] = [];
            for (let item of this.documentiOnline)
                data["documentiOnline"].push(item.toJSON());
        }
        if (Array.isArray(this.documentiAllegati)) {
            data["documentiAllegati"] = [];
            for (let item of this.documentiAllegati)
                data["documentiAllegati"].push(item.toJSON());
        }
        data["consentiStampaVoucher"] = this.consentiStampaVoucher !== undefined ? this.consentiStampaVoucher : <any>null;
        data["consentiStampaFatture"] = this.consentiStampaFatture !== undefined ? this.consentiStampaFatture : <any>null;
        data["confermaProvvisoria"] = this.confermaProvvisoria ? this.confermaProvvisoria.toJSON() : <any>null;
        data["confermaCliente"] = this.confermaCliente ? this.confermaCliente.toJSON() : <any>null;
        return data;
    }
}

export interface ITripAgencyDocuments {
    offerta?: TripDocument | null;
    preventivoCliente?: TripDocument | null;
    preventivoClientePlus?: TripDocument | null;
    conferma?: TripDocument | null;
    estrattoConto?: TripDocument | null;
    programma?: TripDocument | null;
    documentiOnline?: TripDocument[] | null;
    documentiAllegati?: TripDocument[] | null;
    consentiStampaVoucher?: boolean;
    consentiStampaFatture?: boolean;
    confermaProvvisoria?: TripDocument | null;
    confermaCliente?: TripDocument | null;
}

export enum EServizioAutomatico {
    Nessuno = "Nessuno",
    RinunciaWeCareYouSmile = "RinunciaWeCareYouSmile",
    SpeseMediche100K = "SpeseMediche100K",
    SpeseMediche300K = "SpeseMediche300K",
    SpeseMediche500K = "SpeseMediche500K",
    SpeseMediche1M = "SpeseMediche1M",
    WeCareYouSmilePlus = "WeCareYouSmilePlus",
    MedicoBagaglioBase = "MedicoBagaglioBase",
    QuoteNaar = "QuoteNaar",
    QuoteOnline = "QuoteOnline",
    UpgradeQuoteOnline = "UpgradeQuoteOnline",
    RinunciaBloccaPrezzo = "RinunciaBloccaPrezzo",
    DirittiAgenzia = "DirittiAgenzia",
    DirittiAgenziaSuBiglietteria = "DirittiAgenziaSuBiglietteria",
    QuoteOnlineFrance = "QuoteOnlineFrance",
    QuoteNaarFrance = "QuoteNaarFrance",
    PolizzaFr1 = "PolizzaFr1",
    PolizzaFr2 = "PolizzaFr2",
    PolizzaFr3 = "PolizzaFr3",
    CostiCancellazione = "CostiCancellazione",
    QuoteOnlineBenelux = "QuoteOnlineBenelux",
    QuoteNaarBenelux = "QuoteNaarBenelux",
    QuoteOnlineGermany = "QuoteOnlineGermany",
    QuoteNaarGermany = "QuoteNaarGermany",
    QuoteOnlineSalaun = "QuoteOnlineSalaun",
    QuoteNaarSalaun = "QuoteNaarSalaun",
    PeaceOfMind = "PeaceOfMind",
    EuropAssistanceOpzionale = "EuropAssistanceOpzionale",
    EuropAssistance300K = "EuropAssistance300K",
    EuropAssistance500K = "EuropAssistance500K",
    EuropAssistanceIllimitato = "EuropAssistanceIllimitato",
    RinunciaPeaceOfMind = "RinunciaPeaceOfMind",
}

export class TripGetRequest extends SiteRequest implements ITripGetRequest {
    /** ID dell'offerta di riferimento */
    offertaID!: number;
    resetPriceDispo?: boolean;

    constructor(data?: ITripGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.resetPriceDispo = _data["resetPriceDispo"] !== undefined ? _data["resetPriceDispo"] : <any>null;
        }
    }

    static fromJS(data: any): TripGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TripGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["resetPriceDispo"] = this.resetPriceDispo !== undefined ? this.resetPriceDispo : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITripGetRequest extends ISiteRequest {
    /** ID dell'offerta di riferimento */
    offertaID: number;
    resetPriceDispo?: boolean;
}

export class ConvertTraducibileRequest extends TripGetRequest implements IConvertTraducibileRequest {
    documentoID?: number;

    constructor(data?: IConvertTraducibileRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
        }
    }

    static fromJS(data: any): ConvertTraducibileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertTraducibileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IConvertTraducibileRequest extends ITripGetRequest {
    documentoID?: number;
}

/** Riposta alla stampa: tutta l'offerta + l'id del documento creato */
export class DocumentPrintResponse extends TripGetResponse implements IDocumentPrintResponse {
    /** ID del documento che è stato creato */
    documentoID?: number;

    constructor(data?: IDocumentPrintResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentPrintResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPrintResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Riposta alla stampa: tutta l'offerta + l'id del documento creato */
export interface IDocumentPrintResponse extends ITripGetResponse {
    /** ID del documento che è stato creato */
    documentoID?: number;
}

/** Richiesta di stampa di un documento per un'offerta */
export class DocumentPrintRequest extends TripGetRequest implements IDocumentPrintRequest {
    /** Tipo di documento da stampare */
    tipoDocumento!: ETipoDocumento;
    /** ID del documento che verrà convertito */
    documentoID?: number | null;
    /** Stringa con le tuple [id_ordine] separate da virgola delle miniguide da usare nel documento */
    extraDocs?: string;

    constructor(data?: IDocumentPrintRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : <any>null;
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
            this.extraDocs = _data["extraDocs"] !== undefined ? _data["extraDocs"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentPrintRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPrintRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : <any>null;
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        data["extraDocs"] = this.extraDocs !== undefined ? this.extraDocs : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Richiesta di stampa di un documento per un'offerta */
export interface IDocumentPrintRequest extends ITripGetRequest {
    /** Tipo di documento da stampare */
    tipoDocumento: ETipoDocumento;
    /** ID del documento che verrà convertito */
    documentoID?: number | null;
    /** Stringa con le tuple [id_ordine] separate da virgola delle miniguide da usare nel documento */
    extraDocs?: string;
}

export class CreateReservationDocumentResponse extends TripGetResponse implements ICreateReservationDocumentResponse {

    constructor(data?: ICreateReservationDocumentResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateReservationDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReservationDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateReservationDocumentResponse extends ITripGetResponse {
}

export class CreateReservationDocumentRequest extends TripGetRequest implements ICreateReservationDocumentRequest {
    /** Underscore separated string: "contactID_currencyID" */
    contactAndCurrency!: string[];

    constructor(data?: ICreateReservationDocumentRequest) {
        super(data);
        if (!data) {
            this.contactAndCurrency = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contactAndCurrency"])) {
                this.contactAndCurrency = [] as any;
                for (let item of _data["contactAndCurrency"])
                    this.contactAndCurrency!.push(item);
            }
            else {
                this.contactAndCurrency = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateReservationDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReservationDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactAndCurrency)) {
            data["contactAndCurrency"] = [];
            for (let item of this.contactAndCurrency)
                data["contactAndCurrency"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateReservationDocumentRequest extends ITripGetRequest {
    /** Underscore separated string: "contactID_currencyID" */
    contactAndCurrency: string[];
}

export class EditDocumentResponse extends OkApiResponse implements IEditDocumentResponse {
    /** Contenuto HTML del documento */
    content?: string;
    /** Link completo del CSS del documento */
    cssUrl?: string | null;
    /** Titolo del documento */
    title?: string | null;
    /** Link alla favicon */
    favIconUrl?: string | null;
    /** Lista dei css "extra" */
    extraCssUrls?: string[] | null;

    constructor(data?: IEditDocumentResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.cssUrl = _data["cssUrl"] !== undefined ? _data["cssUrl"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.favIconUrl = _data["favIconUrl"] !== undefined ? _data["favIconUrl"] : <any>null;
            if (Array.isArray(_data["extraCssUrls"])) {
                this.extraCssUrls = [] as any;
                for (let item of _data["extraCssUrls"])
                    this.extraCssUrls!.push(item);
            }
            else {
                this.extraCssUrls = <any>null;
            }
        }
    }

    static fromJS(data: any): EditDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["cssUrl"] = this.cssUrl !== undefined ? this.cssUrl : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["favIconUrl"] = this.favIconUrl !== undefined ? this.favIconUrl : <any>null;
        if (Array.isArray(this.extraCssUrls)) {
            data["extraCssUrls"] = [];
            for (let item of this.extraCssUrls)
                data["extraCssUrls"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEditDocumentResponse extends IOkApiResponse {
    /** Contenuto HTML del documento */
    content?: string;
    /** Link completo del CSS del documento */
    cssUrl?: string | null;
    /** Titolo del documento */
    title?: string | null;
    /** Link alla favicon */
    favIconUrl?: string | null;
    /** Lista dei css "extra" */
    extraCssUrls?: string[] | null;
}

export class EditDocumentRequest extends LocalizedRequest implements IEditDocumentRequest {
    /** ID del documento da editare */
    documentoID?: number;

    constructor(data?: IEditDocumentRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
        }
    }

    static fromJS(data: any): EditDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEditDocumentRequest extends ILocalizedRequest {
    /** ID del documento da editare */
    documentoID?: number;
}

export class GetDocumentoFrasiResponse extends OkApiResponse implements IGetDocumentoFrasiResponse {
    contatti?: IdValore[];
    accordi?: IdValore[];
    servizi?: IdValore[];
    luoghi?: IdValore[];
    sezioni?: SezioneView[];

    constructor(data?: IGetDocumentoFrasiResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contatti"])) {
                this.contatti = [] as any;
                for (let item of _data["contatti"])
                    this.contatti!.push(IdValore.fromJS(item));
            }
            else {
                this.contatti = <any>null;
            }
            if (Array.isArray(_data["accordi"])) {
                this.accordi = [] as any;
                for (let item of _data["accordi"])
                    this.accordi!.push(IdValore.fromJS(item));
            }
            else {
                this.accordi = <any>null;
            }
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(IdValore.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
            if (Array.isArray(_data["luoghi"])) {
                this.luoghi = [] as any;
                for (let item of _data["luoghi"])
                    this.luoghi!.push(IdValore.fromJS(item));
            }
            else {
                this.luoghi = <any>null;
            }
            if (Array.isArray(_data["sezioni"])) {
                this.sezioni = [] as any;
                for (let item of _data["sezioni"])
                    this.sezioni!.push(SezioneView.fromJS(item));
            }
            else {
                this.sezioni = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDocumentoFrasiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentoFrasiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contatti)) {
            data["contatti"] = [];
            for (let item of this.contatti)
                data["contatti"].push(item.toJSON());
        }
        if (Array.isArray(this.accordi)) {
            data["accordi"] = [];
            for (let item of this.accordi)
                data["accordi"].push(item.toJSON());
        }
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        if (Array.isArray(this.luoghi)) {
            data["luoghi"] = [];
            for (let item of this.luoghi)
                data["luoghi"].push(item.toJSON());
        }
        if (Array.isArray(this.sezioni)) {
            data["sezioni"] = [];
            for (let item of this.sezioni)
                data["sezioni"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDocumentoFrasiResponse extends IOkApiResponse {
    contatti?: IdValore[];
    accordi?: IdValore[];
    servizi?: IdValore[];
    luoghi?: IdValore[];
    sezioni?: SezioneView[];
}

export class SezioneView implements ISezioneView {
    id?: number;
    nome?: string;
    editabile?: boolean;
    giorni?: GiornoSezioneView[];

    constructor(data?: ISezioneView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.editabile = _data["editabile"] !== undefined ? _data["editabile"] : <any>null;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(GiornoSezioneView.fromJS(item));
            }
            else {
                this.giorni = <any>null;
            }
        }
    }

    static fromJS(data: any): SezioneView {
        data = typeof data === 'object' ? data : {};
        let result = new SezioneView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["editabile"] = this.editabile !== undefined ? this.editabile : <any>null;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISezioneView {
    id?: number;
    nome?: string;
    editabile?: boolean;
    giorni?: GiornoSezioneView[];
}

export class GiornoSezioneView implements IGiornoSezioneView {
    giorno?: number | null;
    data?: string | null;
    luoghi?: string | null;
    luoghiIds?: number[] | null;
    serviziIds?: number[] | null;
    contattiIds?: number[] | null;
    sottosezioni?: SottozioneGiornoView[];

    constructor(data?: IGiornoSezioneView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.luoghi = _data["luoghi"] !== undefined ? _data["luoghi"] : <any>null;
            if (Array.isArray(_data["luoghiIds"])) {
                this.luoghiIds = [] as any;
                for (let item of _data["luoghiIds"])
                    this.luoghiIds!.push(item);
            }
            else {
                this.luoghiIds = <any>null;
            }
            if (Array.isArray(_data["serviziIds"])) {
                this.serviziIds = [] as any;
                for (let item of _data["serviziIds"])
                    this.serviziIds!.push(item);
            }
            else {
                this.serviziIds = <any>null;
            }
            if (Array.isArray(_data["contattiIds"])) {
                this.contattiIds = [] as any;
                for (let item of _data["contattiIds"])
                    this.contattiIds!.push(item);
            }
            else {
                this.contattiIds = <any>null;
            }
            if (Array.isArray(_data["sottosezioni"])) {
                this.sottosezioni = [] as any;
                for (let item of _data["sottosezioni"])
                    this.sottosezioni!.push(SottozioneGiornoView.fromJS(item));
            }
            else {
                this.sottosezioni = <any>null;
            }
        }
    }

    static fromJS(data: any): GiornoSezioneView {
        data = typeof data === 'object' ? data : {};
        let result = new GiornoSezioneView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["luoghi"] = this.luoghi !== undefined ? this.luoghi : <any>null;
        if (Array.isArray(this.luoghiIds)) {
            data["luoghiIds"] = [];
            for (let item of this.luoghiIds)
                data["luoghiIds"].push(item);
        }
        if (Array.isArray(this.serviziIds)) {
            data["serviziIds"] = [];
            for (let item of this.serviziIds)
                data["serviziIds"].push(item);
        }
        if (Array.isArray(this.contattiIds)) {
            data["contattiIds"] = [];
            for (let item of this.contattiIds)
                data["contattiIds"].push(item);
        }
        if (Array.isArray(this.sottosezioni)) {
            data["sottosezioni"] = [];
            for (let item of this.sottosezioni)
                data["sottosezioni"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGiornoSezioneView {
    giorno?: number | null;
    data?: string | null;
    luoghi?: string | null;
    luoghiIds?: number[] | null;
    serviziIds?: number[] | null;
    contattiIds?: number[] | null;
    sottosezioni?: SottozioneGiornoView[];
}

export class SottozioneGiornoView implements ISottozioneGiornoView {
    id?: number | null;
    nome?: string | null;
    frasi?: FraseSottosezione[];

    constructor(data?: ISottozioneGiornoView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            if (Array.isArray(_data["frasi"])) {
                this.frasi = [] as any;
                for (let item of _data["frasi"])
                    this.frasi!.push(FraseSottosezione.fromJS(item));
            }
            else {
                this.frasi = <any>null;
            }
        }
    }

    static fromJS(data: any): SottozioneGiornoView {
        data = typeof data === 'object' ? data : {};
        let result = new SottozioneGiornoView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        if (Array.isArray(this.frasi)) {
            data["frasi"] = [];
            for (let item of this.frasi)
                data["frasi"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISottozioneGiornoView {
    id?: number | null;
    nome?: string | null;
    frasi?: FraseSottosezione[];
}

export class FraseSottosezione implements IFraseSottosezione {
    id?: number;
    /** ID dell'articolo associato. Se presente il testo deriva da un articolo */
    articoloID?: number | null;
    /** ID della frase. Se presente il testo deriva da una frase */
    fraseID?: number | null;
    /** ID del contatto associato, opzionale */
    contattoID?: number | null;
    /** ID dell'accordo associato, opzionale */
    accordoID?: number | null;
    /** ID del servizio associato, opzionale */
    servizioID?: number | null;
    /** ID della riga di offerta associata, opzionale */
    rigaID?: number | null;
    /** ID del luogo associato, opzionale */
    luogoID?: number | null;
    /** Terminatore da utilizzare */
    terminatore?: EFraseTerminatore;
    /** Testo non formattato */
    testo?: string;
    /** Dizionario delle variabili e rispettivi valori */
    variabili?: { [key: string]: VariabileValore; } | null;
    frase?: Frase | null;

    constructor(data?: IFraseSottosezione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.terminatore = _data["terminatore"] !== undefined ? _data["terminatore"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            if (_data["variabili"]) {
                this.variabili = {} as any;
                for (let key in _data["variabili"]) {
                    if (_data["variabili"].hasOwnProperty(key))
                        (<any>this.variabili)![key] = _data["variabili"][key] ? VariabileValore.fromJS(_data["variabili"][key]) : new VariabileValore();
                }
            }
            else {
                this.variabili = <any>null;
            }
            this.frase = _data["frase"] ? Frase.fromJS(_data["frase"]) : <any>null;
        }
    }

    static fromJS(data: any): FraseSottosezione {
        data = typeof data === 'object' ? data : {};
        let result = new FraseSottosezione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["terminatore"] = this.terminatore !== undefined ? this.terminatore : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        if (this.variabili) {
            data["variabili"] = {};
            for (let key in this.variabili) {
                if (this.variabili.hasOwnProperty(key))
                    (<any>data["variabili"])[key] = this.variabili[key] ? this.variabili[key].toJSON() : <any>null;
            }
        }
        data["frase"] = this.frase ? this.frase.toJSON() : <any>null;
        return data;
    }
}

export interface IFraseSottosezione {
    id?: number;
    /** ID dell'articolo associato. Se presente il testo deriva da un articolo */
    articoloID?: number | null;
    /** ID della frase. Se presente il testo deriva da una frase */
    fraseID?: number | null;
    /** ID del contatto associato, opzionale */
    contattoID?: number | null;
    /** ID dell'accordo associato, opzionale */
    accordoID?: number | null;
    /** ID del servizio associato, opzionale */
    servizioID?: number | null;
    /** ID della riga di offerta associata, opzionale */
    rigaID?: number | null;
    /** ID del luogo associato, opzionale */
    luogoID?: number | null;
    /** Terminatore da utilizzare */
    terminatore?: EFraseTerminatore;
    /** Testo non formattato */
    testo?: string;
    /** Dizionario delle variabili e rispettivi valori */
    variabili?: { [key: string]: VariabileValore; } | null;
    frase?: Frase | null;
}

export class GetDocumentoFrasiRequest extends LocalizedRequest implements IGetDocumentoFrasiRequest {
    documentoID?: number;

    constructor(data?: IGetDocumentoFrasiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
        }
    }

    static fromJS(data: any): GetDocumentoFrasiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentoFrasiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetDocumentoFrasiRequest extends ILocalizedRequest {
    documentoID?: number;
}

export class UpdateDocumentRequest extends LocalizedRequest implements IUpdateDocumentRequest {
    /** ID del documento */
    documentoID?: number;
    /** Contenuto HTML del documento */
    content!: string;
    /** Link completo del CSS del documento */
    cssUrl?: string | null;
    /** Titolo del documento */
    title?: string | null;
    /** Link alla favicon */
    favIconUrl?: string | null;
    /** Lista dei css "extra" */
    extraCssUrls?: string[] | null;

    constructor(data?: IUpdateDocumentRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.cssUrl = _data["cssUrl"] !== undefined ? _data["cssUrl"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.favIconUrl = _data["favIconUrl"] !== undefined ? _data["favIconUrl"] : <any>null;
            if (Array.isArray(_data["extraCssUrls"])) {
                this.extraCssUrls = [] as any;
                for (let item of _data["extraCssUrls"])
                    this.extraCssUrls!.push(item);
            }
            else {
                this.extraCssUrls = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["cssUrl"] = this.cssUrl !== undefined ? this.cssUrl : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["favIconUrl"] = this.favIconUrl !== undefined ? this.favIconUrl : <any>null;
        if (Array.isArray(this.extraCssUrls)) {
            data["extraCssUrls"] = [];
            for (let item of this.extraCssUrls)
                data["extraCssUrls"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDocumentRequest extends ILocalizedRequest {
    /** ID del documento */
    documentoID?: number;
    /** Contenuto HTML del documento */
    content: string;
    /** Link completo del CSS del documento */
    cssUrl?: string | null;
    /** Titolo del documento */
    title?: string | null;
    /** Link alla favicon */
    favIconUrl?: string | null;
    /** Lista dei css "extra" */
    extraCssUrls?: string[] | null;
}

export class UpdateDocumentPhrasesResponse extends GetDocumentoFrasiResponse implements IUpdateDocumentPhrasesResponse {

    constructor(data?: IUpdateDocumentPhrasesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateDocumentPhrasesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentPhrasesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDocumentPhrasesResponse extends IGetDocumentoFrasiResponse {
}

export class UpdateDocumentPhrasesRequest extends GetDocumentoFrasiRequest implements IUpdateDocumentPhrasesRequest {
    sezioni!: SezioneView[];

    constructor(data?: IUpdateDocumentPhrasesRequest) {
        super(data);
        if (!data) {
            this.sezioni = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sezioni"])) {
                this.sezioni = [] as any;
                for (let item of _data["sezioni"])
                    this.sezioni!.push(SezioneView.fromJS(item));
            }
            else {
                this.sezioni = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateDocumentPhrasesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentPhrasesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sezioni)) {
            data["sezioni"] = [];
            for (let item of this.sezioni)
                data["sezioni"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDocumentPhrasesRequest extends IGetDocumentoFrasiRequest {
    sezioni: SezioneView[];
}

export class UpdateExtraDocsRequest extends TripGetRequest implements IUpdateExtraDocsRequest {
    /** ID del documento */
    documentoID?: number;
    /** Stringa degli extra docs formato ID_Ordine,... */
    extraDocsString!: string;

    constructor(data?: IUpdateExtraDocsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
            this.extraDocsString = _data["extraDocsString"] !== undefined ? _data["extraDocsString"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateExtraDocsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExtraDocsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        data["extraDocsString"] = this.extraDocsString !== undefined ? this.extraDocsString : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateExtraDocsRequest extends ITripGetRequest {
    /** ID del documento */
    documentoID?: number;
    /** Stringa degli extra docs formato ID_Ordine,... */
    extraDocsString: string;
}

export class GetEmailResponse extends OkApiResponse implements IGetEmailResponse {
    email?: EmailQueue | null;
    toRecipients?: string | null;
    ccRecipients?: string | null;
    bccRecipients?: string | null;
    attachments?: EmailAttachmentInfo[] | null;

    constructor(data?: IGetEmailResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] ? EmailQueue.fromJS(_data["email"]) : <any>null;
            this.toRecipients = _data["toRecipients"] !== undefined ? _data["toRecipients"] : <any>null;
            this.ccRecipients = _data["ccRecipients"] !== undefined ? _data["ccRecipients"] : <any>null;
            this.bccRecipients = _data["bccRecipients"] !== undefined ? _data["bccRecipients"] : <any>null;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(EmailAttachmentInfo.fromJS(item));
            }
            else {
                this.attachments = <any>null;
            }
        }
    }

    static fromJS(data: any): GetEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email ? this.email.toJSON() : <any>null;
        data["toRecipients"] = this.toRecipients !== undefined ? this.toRecipients : <any>null;
        data["ccRecipients"] = this.ccRecipients !== undefined ? this.ccRecipients : <any>null;
        data["bccRecipients"] = this.bccRecipients !== undefined ? this.bccRecipients : <any>null;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetEmailResponse extends IOkApiResponse {
    email?: EmailQueue | null;
    toRecipients?: string | null;
    ccRecipients?: string | null;
    bccRecipients?: string | null;
    attachments?: EmailAttachmentInfo[] | null;
}

export class EmailAttachmentInfo implements IEmailAttachmentInfo {
    id?: number;
    attachment?: EmailQueueAttachment | null;

    constructor(data?: IEmailAttachmentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.attachment = _data["attachment"] ? EmailQueueAttachment.fromJS(_data["attachment"]) : <any>null;
        }
    }

    static fromJS(data: any): EmailAttachmentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAttachmentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : <any>null;
        return data;
    }
}

export interface IEmailAttachmentInfo {
    id?: number;
    attachment?: EmailQueueAttachment | null;
}

export class EmailQueueAttachment implements IEmailQueueAttachment {
    id?: number;
    emailID?: number;
    attachmentType?: EEmailAttachmentType;
    entityID?: number | null;
    mimeType!: string;
    convertToPdf?: boolean;
    attachmentFileName!: string;

    constructor(data?: IEmailQueueAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.emailID = _data["emailID"] !== undefined ? _data["emailID"] : <any>null;
            this.attachmentType = _data["attachmentType"] !== undefined ? _data["attachmentType"] : <any>null;
            this.entityID = _data["entityID"] !== undefined ? _data["entityID"] : <any>null;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : <any>null;
            this.convertToPdf = _data["convertToPdf"] !== undefined ? _data["convertToPdf"] : <any>null;
            this.attachmentFileName = _data["attachmentFileName"] !== undefined ? _data["attachmentFileName"] : <any>null;
        }
    }

    static fromJS(data: any): EmailQueueAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new EmailQueueAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["emailID"] = this.emailID !== undefined ? this.emailID : <any>null;
        data["attachmentType"] = this.attachmentType !== undefined ? this.attachmentType : <any>null;
        data["entityID"] = this.entityID !== undefined ? this.entityID : <any>null;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : <any>null;
        data["convertToPdf"] = this.convertToPdf !== undefined ? this.convertToPdf : <any>null;
        data["attachmentFileName"] = this.attachmentFileName !== undefined ? this.attachmentFileName : <any>null;
        return data;
    }
}

export interface IEmailQueueAttachment {
    id?: number;
    emailID?: number;
    attachmentType?: EEmailAttachmentType;
    entityID?: number | null;
    mimeType: string;
    convertToPdf?: boolean;
    attachmentFileName: string;
}

export enum EEmailAttachmentType {
    Custom = "Custom",
    DocumentoOfferta = "DocumentoOfferta",
    DocumentoContabile = "DocumentoContabile",
    Voucher = "Voucher",
}

export class GetEmailRequest extends LocalizedRequest implements IGetEmailRequest {
    emailID?: number;

    constructor(data?: IGetEmailRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailID = _data["emailID"] !== undefined ? _data["emailID"] : <any>null;
        }
    }

    static fromJS(data: any): GetEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailID"] = this.emailID !== undefined ? this.emailID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetEmailRequest extends ILocalizedRequest {
    emailID?: number;
}

export class CreateErrorRequest extends ApiRequest implements ICreateErrorRequest {
    /** In che controller */
    controller?: string | null;
    /** Dove è avvenuto l'errore */
    action?: string | null;
    /** Con quali parametri */
    request?: string | null;
    /** Che messaggio è stato visualizzato */
    message?: string | null;
    /** Informazioni aggiuntive sintetiche */
    info?: string | null;
    /** Se l'errore è stato gestito dall'applicazione */
    isApplicationHandled?: boolean;

    constructor(data?: ICreateErrorRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.controller = _data["controller"] !== undefined ? _data["controller"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.request = _data["request"] !== undefined ? _data["request"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.info = _data["info"] !== undefined ? _data["info"] : <any>null;
            this.isApplicationHandled = _data["isApplicationHandled"] !== undefined ? _data["isApplicationHandled"] : <any>null;
        }
    }

    static fromJS(data: any): CreateErrorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateErrorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controller"] = this.controller !== undefined ? this.controller : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["request"] = this.request !== undefined ? this.request : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["info"] = this.info !== undefined ? this.info : <any>null;
        data["isApplicationHandled"] = this.isApplicationHandled !== undefined ? this.isApplicationHandled : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateErrorRequest extends IApiRequest {
    /** In che controller */
    controller?: string | null;
    /** Dove è avvenuto l'errore */
    action?: string | null;
    /** Con quali parametri */
    request?: string | null;
    /** Che messaggio è stato visualizzato */
    message?: string | null;
    /** Informazioni aggiuntive sintetiche */
    info?: string | null;
    /** Se l'errore è stato gestito dall'applicazione */
    isApplicationHandled?: boolean;
}

export class DeleteErrorRequest extends ApiRequest implements IDeleteErrorRequest {
    errorID!: number;

    constructor(data?: IDeleteErrorRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorID = _data["errorID"] !== undefined ? _data["errorID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteErrorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteErrorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorID"] = this.errorID !== undefined ? this.errorID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteErrorRequest extends IApiRequest {
    errorID: number;
}

export class DeleteErrorMultiRequest extends ApiRequest implements IDeleteErrorMultiRequest {
    errorIDs!: number[];

    constructor(data?: IDeleteErrorMultiRequest) {
        super(data);
        if (!data) {
            this.errorIDs = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["errorIDs"])) {
                this.errorIDs = [] as any;
                for (let item of _data["errorIDs"])
                    this.errorIDs!.push(item);
            }
            else {
                this.errorIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteErrorMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteErrorMultiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorIDs)) {
            data["errorIDs"] = [];
            for (let item of this.errorIDs)
                data["errorIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteErrorMultiRequest extends IApiRequest {
    errorIDs: number[];
}

export class NrTableResponseOfErrorRow extends OkApiResponse implements INrTableResponseOfErrorRow {
    /** Array delle righe della pagina richiesta */
    rows?: ErrorRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfErrorRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ErrorRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfErrorRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfErrorRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfErrorRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ErrorRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ErrorRow implements IErrorRow {
    errore?: Errore | null;
    utente?: string | null;

    constructor(data?: IErrorRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errore = _data["errore"] ? Errore.fromJS(_data["errore"]) : <any>null;
            this.utente = _data["utente"] !== undefined ? _data["utente"] : <any>null;
        }
    }

    static fromJS(data: any): ErrorRow {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errore"] = this.errore ? this.errore.toJSON() : <any>null;
        data["utente"] = this.utente !== undefined ? this.utente : <any>null;
        return data;
    }
}

export interface IErrorRow {
    errore?: Errore | null;
    utente?: string | null;
}

export class Errore implements IErrore {
    id?: number;
    date?: string;
    userID?: number | null;
    ip?: string | null;
    controller?: string;
    action?: string;
    routeData?: string | null;
    request?: string | null;
    referrer?: string | null;
    message?: string;
    info?: string | null;
    stackTrace?: string | null;
    isDebug?: boolean;
    isApplicationHandled?: boolean;

    constructor(data?: IErrore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : <any>null;
            this.ip = _data["ip"] !== undefined ? _data["ip"] : <any>null;
            this.controller = _data["controller"] !== undefined ? _data["controller"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.routeData = _data["routeData"] !== undefined ? _data["routeData"] : <any>null;
            this.request = _data["request"] !== undefined ? _data["request"] : <any>null;
            this.referrer = _data["referrer"] !== undefined ? _data["referrer"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.info = _data["info"] !== undefined ? _data["info"] : <any>null;
            this.stackTrace = _data["stackTrace"] !== undefined ? _data["stackTrace"] : <any>null;
            this.isDebug = _data["isDebug"] !== undefined ? _data["isDebug"] : <any>null;
            this.isApplicationHandled = _data["isApplicationHandled"] !== undefined ? _data["isApplicationHandled"] : <any>null;
        }
    }

    static fromJS(data: any): Errore {
        data = typeof data === 'object' ? data : {};
        let result = new Errore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["userID"] = this.userID !== undefined ? this.userID : <any>null;
        data["ip"] = this.ip !== undefined ? this.ip : <any>null;
        data["controller"] = this.controller !== undefined ? this.controller : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["routeData"] = this.routeData !== undefined ? this.routeData : <any>null;
        data["request"] = this.request !== undefined ? this.request : <any>null;
        data["referrer"] = this.referrer !== undefined ? this.referrer : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["info"] = this.info !== undefined ? this.info : <any>null;
        data["stackTrace"] = this.stackTrace !== undefined ? this.stackTrace : <any>null;
        data["isDebug"] = this.isDebug !== undefined ? this.isDebug : <any>null;
        data["isApplicationHandled"] = this.isApplicationHandled !== undefined ? this.isApplicationHandled : <any>null;
        return data;
    }
}

export interface IErrore {
    id?: number;
    date?: string;
    userID?: number | null;
    ip?: string | null;
    controller?: string;
    action?: string;
    routeData?: string | null;
    request?: string | null;
    referrer?: string | null;
    message?: string;
    info?: string | null;
    stackTrace?: string | null;
    isDebug?: boolean;
    isApplicationHandled?: boolean;
}

export class ErrorsListRequest extends NrTableRequest implements IErrorsListRequest {
    userID?: number | null;
    errorsFilter?: DebugErrorsFilter;
    handledFilter?: ApplicationHandledFilter;
    dateFromFilter?: string | null;
    dateToFilter?: string | null;
    controllerFilter?: string | null;
    actionFilter?: string | null;
    messageFilter?: string | null;

    constructor(data?: IErrorsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userID = _data["userID"] !== undefined ? _data["userID"] : <any>null;
            this.errorsFilter = _data["errorsFilter"] !== undefined ? _data["errorsFilter"] : <any>null;
            this.handledFilter = _data["handledFilter"] !== undefined ? _data["handledFilter"] : <any>null;
            this.dateFromFilter = _data["dateFromFilter"] !== undefined ? _data["dateFromFilter"] : <any>null;
            this.dateToFilter = _data["dateToFilter"] !== undefined ? _data["dateToFilter"] : <any>null;
            this.controllerFilter = _data["controllerFilter"] !== undefined ? _data["controllerFilter"] : <any>null;
            this.actionFilter = _data["actionFilter"] !== undefined ? _data["actionFilter"] : <any>null;
            this.messageFilter = _data["messageFilter"] !== undefined ? _data["messageFilter"] : <any>null;
        }
    }

    static fromJS(data: any): ErrorsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID !== undefined ? this.userID : <any>null;
        data["errorsFilter"] = this.errorsFilter !== undefined ? this.errorsFilter : <any>null;
        data["handledFilter"] = this.handledFilter !== undefined ? this.handledFilter : <any>null;
        data["dateFromFilter"] = this.dateFromFilter !== undefined ? this.dateFromFilter : <any>null;
        data["dateToFilter"] = this.dateToFilter !== undefined ? this.dateToFilter : <any>null;
        data["controllerFilter"] = this.controllerFilter !== undefined ? this.controllerFilter : <any>null;
        data["actionFilter"] = this.actionFilter !== undefined ? this.actionFilter : <any>null;
        data["messageFilter"] = this.messageFilter !== undefined ? this.messageFilter : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IErrorsListRequest extends INrTableRequest {
    userID?: number | null;
    errorsFilter?: DebugErrorsFilter;
    handledFilter?: ApplicationHandledFilter;
    dateFromFilter?: string | null;
    dateToFilter?: string | null;
    controllerFilter?: string | null;
    actionFilter?: string | null;
    messageFilter?: string | null;
}

export enum DebugErrorsFilter {
    None = "None",
    DebugOnly = "DebugOnly",
    ProdOnly = "ProdOnly",
}

export enum ApplicationHandledFilter {
    None = "None",
    Handled = "Handled",
    Unhandled = "Unhandled",
}

export class NrTableResponseOfEstrattoContoReportRow extends OkApiResponse implements INrTableResponseOfEstrattoContoReportRow {
    /** Array delle righe della pagina richiesta */
    rows?: EstrattoContoReportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfEstrattoContoReportRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EstrattoContoReportRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfEstrattoContoReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfEstrattoContoReportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfEstrattoContoReportRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: EstrattoContoReportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetEstrattoContoReportResponse extends NrTableResponseOfEstrattoContoReportRow implements IGetEstrattoContoReportResponse {
    totale?: number | null;
    totaleNetto?: number | null;
    totaleVersato?: number | null;
    totaleDaPagare?: number | null;
    totaleCommissione?: number | null;

    constructor(data?: IGetEstrattoContoReportResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.totaleNetto = _data["totaleNetto"] !== undefined ? _data["totaleNetto"] : <any>null;
            this.totaleVersato = _data["totaleVersato"] !== undefined ? _data["totaleVersato"] : <any>null;
            this.totaleDaPagare = _data["totaleDaPagare"] !== undefined ? _data["totaleDaPagare"] : <any>null;
            this.totaleCommissione = _data["totaleCommissione"] !== undefined ? _data["totaleCommissione"] : <any>null;
        }
    }

    static fromJS(data: any): GetEstrattoContoReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEstrattoContoReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["totaleNetto"] = this.totaleNetto !== undefined ? this.totaleNetto : <any>null;
        data["totaleVersato"] = this.totaleVersato !== undefined ? this.totaleVersato : <any>null;
        data["totaleDaPagare"] = this.totaleDaPagare !== undefined ? this.totaleDaPagare : <any>null;
        data["totaleCommissione"] = this.totaleCommissione !== undefined ? this.totaleCommissione : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetEstrattoContoReportResponse extends INrTableResponseOfEstrattoContoReportRow {
    totale?: number | null;
    totaleNetto?: number | null;
    totaleVersato?: number | null;
    totaleDaPagare?: number | null;
    totaleCommissione?: number | null;
}

export class EstrattoContoReportRow implements IEstrattoContoReportRow {
    offertaID?: number;
    agenziaID?: number | null;
    agenzia?: string | null;
    luogoAgenzia?: string | null;
    network?: string | null;
    pagamento?: string | null;
    pagamentoID?: number | null;
    descrizione?: string | null;
    partenza?: string;
    totale?: number | null;
    commissione?: number | null;
    netto?: number;
    versato?: number;
    daPagare?: number;

    constructor(data?: IEstrattoContoReportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : <any>null;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : <any>null;
            this.luogoAgenzia = _data["luogoAgenzia"] !== undefined ? _data["luogoAgenzia"] : <any>null;
            this.network = _data["network"] !== undefined ? _data["network"] : <any>null;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : <any>null;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.commissione = _data["commissione"] !== undefined ? _data["commissione"] : <any>null;
            this.netto = _data["netto"] !== undefined ? _data["netto"] : <any>null;
            this.versato = _data["versato"] !== undefined ? _data["versato"] : <any>null;
            this.daPagare = _data["daPagare"] !== undefined ? _data["daPagare"] : <any>null;
        }
    }

    static fromJS(data: any): EstrattoContoReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoReportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : <any>null;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : <any>null;
        data["luogoAgenzia"] = this.luogoAgenzia !== undefined ? this.luogoAgenzia : <any>null;
        data["network"] = this.network !== undefined ? this.network : <any>null;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : <any>null;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["commissione"] = this.commissione !== undefined ? this.commissione : <any>null;
        data["netto"] = this.netto !== undefined ? this.netto : <any>null;
        data["versato"] = this.versato !== undefined ? this.versato : <any>null;
        data["daPagare"] = this.daPagare !== undefined ? this.daPagare : <any>null;
        return data;
    }
}

export interface IEstrattoContoReportRow {
    offertaID?: number;
    agenziaID?: number | null;
    agenzia?: string | null;
    luogoAgenzia?: string | null;
    network?: string | null;
    pagamento?: string | null;
    pagamentoID?: number | null;
    descrizione?: string | null;
    partenza?: string;
    totale?: number | null;
    commissione?: number | null;
    netto?: number;
    versato?: number;
    daPagare?: number;
}

export class GetEstrattoContoReportRequest extends NrTableRequest implements IGetEstrattoContoReportRequest {
    contattoID?: number | null;
    partitaIVA?: string | null;
    partenzaDa?: string | null;
    partenzaA?: string | null;
    pagamentoID?: number | null;
    opening?: boolean;

    constructor(data?: IGetEstrattoContoReportRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : <any>null;
            this.partenzaDa = _data["partenzaDa"] !== undefined ? _data["partenzaDa"] : <any>null;
            this.partenzaA = _data["partenzaA"] !== undefined ? _data["partenzaA"] : <any>null;
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : <any>null;
            this.opening = _data["opening"] !== undefined ? _data["opening"] : <any>null;
        }
    }

    static fromJS(data: any): GetEstrattoContoReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEstrattoContoReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : <any>null;
        data["partenzaDa"] = this.partenzaDa !== undefined ? this.partenzaDa : <any>null;
        data["partenzaA"] = this.partenzaA !== undefined ? this.partenzaA : <any>null;
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : <any>null;
        data["opening"] = this.opening !== undefined ? this.opening : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetEstrattoContoReportRequest extends INrTableRequest {
    contattoID?: number | null;
    partitaIVA?: string | null;
    partenzaDa?: string | null;
    partenzaA?: string | null;
    pagamentoID?: number | null;
    opening?: boolean;
}

export class NrTableResponseOfEstrattoContoRow extends OkApiResponse implements INrTableResponseOfEstrattoContoRow {
    /** Array delle righe della pagina richiesta */
    rows?: EstrattoContoRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfEstrattoContoRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EstrattoContoRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfEstrattoContoRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfEstrattoContoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfEstrattoContoRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: EstrattoContoRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class EstrattoContoRow implements IEstrattoContoRow {
    id?: number;
    contattoID?: number;
    nome?: string | null;
    data?: string;
    tipo?: ETipoEstrattoConto;
    invio?: string | null;

    constructor(data?: IEstrattoContoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.invio = _data["invio"] !== undefined ? _data["invio"] : <any>null;
        }
    }

    static fromJS(data: any): EstrattoContoRow {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["invio"] = this.invio !== undefined ? this.invio : <any>null;
        return data;
    }
}

export interface IEstrattoContoRow {
    id?: number;
    contattoID?: number;
    nome?: string | null;
    data?: string;
    tipo?: ETipoEstrattoConto;
    invio?: string | null;
}

export enum ETipoEstrattoConto {
    FineMese = "FineMese",
    Travelfactoring = "Travelfactoring",
}

export class EstrattiContoSearchRequest extends NrTableRequest implements IEstrattiContoSearchRequest {
    operatore?: EOperatore;
    contattoID?: number | null;
    partitaIVA?: string | null;
    dal?: string | null;
    al?: string | null;

    constructor(data?: IEstrattiContoSearchRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
        }
    }

    static fromJS(data: any): EstrattiContoSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattiContoSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEstrattiContoSearchRequest extends INrTableRequest {
    operatore?: EOperatore;
    contattoID?: number | null;
    partitaIVA?: string | null;
    dal?: string | null;
    al?: string | null;
}

export class EstrattoContoReadResponse extends OkApiResponse implements IEstrattoContoReadResponse {
    estrattoConto?: EstrattoConto | null;
    incassi?: IncassoRow[] | null;
    contatto?: string | null;
    email?: string | null;
    pagamento?: string | null;
    scadenza?: string;

    constructor(data?: IEstrattoContoReadResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estrattoConto = _data["estrattoConto"] ? EstrattoConto.fromJS(_data["estrattoConto"]) : <any>null;
            if (Array.isArray(_data["incassi"])) {
                this.incassi = [] as any;
                for (let item of _data["incassi"])
                    this.incassi!.push(IncassoRow.fromJS(item));
            }
            else {
                this.incassi = <any>null;
            }
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : <any>null;
            this.scadenza = _data["scadenza"] !== undefined ? _data["scadenza"] : <any>null;
        }
    }

    static fromJS(data: any): EstrattoContoReadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoReadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estrattoConto"] = this.estrattoConto ? this.estrattoConto.toJSON() : <any>null;
        if (Array.isArray(this.incassi)) {
            data["incassi"] = [];
            for (let item of this.incassi)
                data["incassi"].push(item.toJSON());
        }
        data["contatto"] = this.contatto !== undefined ? this.contatto : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : <any>null;
        data["scadenza"] = this.scadenza !== undefined ? this.scadenza : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEstrattoContoReadResponse extends IOkApiResponse {
    estrattoConto?: EstrattoConto | null;
    incassi?: IncassoRow[] | null;
    contatto?: string | null;
    email?: string | null;
    pagamento?: string | null;
    scadenza?: string;
}

export class EstrattoConto implements IEstrattoConto {
    id?: number;
    operatore?: EOperatore;
    tipo?: ETipoEstrattoConto;
    contattoID?: number;
    data?: string;
    invio?: string | null;
    note?: string | null;
    bancaID?: number | null;

    constructor(data?: IEstrattoConto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.invio = _data["invio"] !== undefined ? _data["invio"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.bancaID = _data["bancaID"] !== undefined ? _data["bancaID"] : <any>null;
        }
    }

    static fromJS(data: any): EstrattoConto {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoConto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["invio"] = this.invio !== undefined ? this.invio : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["bancaID"] = this.bancaID !== undefined ? this.bancaID : <any>null;
        return data;
    }
}

export interface IEstrattoConto {
    id?: number;
    operatore?: EOperatore;
    tipo?: ETipoEstrattoConto;
    contattoID?: number;
    data?: string;
    invio?: string | null;
    note?: string | null;
    bancaID?: number | null;
}

export class IncassoRow implements IIncassoRow {
    incassoID?: number;
    offertaID?: number;
    offerta?: string | null;
    dataScadenza?: string | null;
    dataCessione?: string | null;
    dataPagamento?: string | null;
    descrizione?: string | null;
    importo?: number | null;
    banca?: string | null;
    tipoOperazione?: string | null;
    tipoBiglietteria?: string | null;
    tipoPrepagamento?: string | null;

    constructor(data?: IIncassoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incassoID = _data["incassoID"] !== undefined ? _data["incassoID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.offerta = _data["offerta"] !== undefined ? _data["offerta"] : <any>null;
            this.dataScadenza = _data["dataScadenza"] !== undefined ? _data["dataScadenza"] : <any>null;
            this.dataCessione = _data["dataCessione"] !== undefined ? _data["dataCessione"] : <any>null;
            this.dataPagamento = _data["dataPagamento"] !== undefined ? _data["dataPagamento"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
            this.banca = _data["banca"] !== undefined ? _data["banca"] : <any>null;
            this.tipoOperazione = _data["tipoOperazione"] !== undefined ? _data["tipoOperazione"] : <any>null;
            this.tipoBiglietteria = _data["tipoBiglietteria"] !== undefined ? _data["tipoBiglietteria"] : <any>null;
            this.tipoPrepagamento = _data["tipoPrepagamento"] !== undefined ? _data["tipoPrepagamento"] : <any>null;
        }
    }

    static fromJS(data: any): IncassoRow {
        data = typeof data === 'object' ? data : {};
        let result = new IncassoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incassoID"] = this.incassoID !== undefined ? this.incassoID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["offerta"] = this.offerta !== undefined ? this.offerta : <any>null;
        data["dataScadenza"] = this.dataScadenza !== undefined ? this.dataScadenza : <any>null;
        data["dataCessione"] = this.dataCessione !== undefined ? this.dataCessione : <any>null;
        data["dataPagamento"] = this.dataPagamento !== undefined ? this.dataPagamento : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        data["banca"] = this.banca !== undefined ? this.banca : <any>null;
        data["tipoOperazione"] = this.tipoOperazione !== undefined ? this.tipoOperazione : <any>null;
        data["tipoBiglietteria"] = this.tipoBiglietteria !== undefined ? this.tipoBiglietteria : <any>null;
        data["tipoPrepagamento"] = this.tipoPrepagamento !== undefined ? this.tipoPrepagamento : <any>null;
        return data;
    }
}

export interface IIncassoRow {
    incassoID?: number;
    offertaID?: number;
    offerta?: string | null;
    dataScadenza?: string | null;
    dataCessione?: string | null;
    dataPagamento?: string | null;
    descrizione?: string | null;
    importo?: number | null;
    banca?: string | null;
    tipoOperazione?: string | null;
    tipoBiglietteria?: string | null;
    tipoPrepagamento?: string | null;
}

export class EstrattoContoReadRequest extends ApiRequest implements IEstrattoContoReadRequest {
    estrattoContoID?: number;

    constructor(data?: IEstrattoContoReadRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estrattoContoID = _data["estrattoContoID"] !== undefined ? _data["estrattoContoID"] : <any>null;
        }
    }

    static fromJS(data: any): EstrattoContoReadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoReadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estrattoContoID"] = this.estrattoContoID !== undefined ? this.estrattoContoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEstrattoContoReadRequest extends IApiRequest {
    estrattoContoID?: number;
}

export class EstrattoContoCreateResponse extends OkApiResponse implements IEstrattoContoCreateResponse {
    estrattoConto?: EstrattoConto | null;
    contatto?: string | null;

    constructor(data?: IEstrattoContoCreateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estrattoConto = _data["estrattoConto"] ? EstrattoConto.fromJS(_data["estrattoConto"]) : <any>null;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : <any>null;
        }
    }

    static fromJS(data: any): EstrattoContoCreateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoCreateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estrattoConto"] = this.estrattoConto ? this.estrattoConto.toJSON() : <any>null;
        data["contatto"] = this.contatto !== undefined ? this.contatto : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEstrattoContoCreateResponse extends IOkApiResponse {
    estrattoConto?: EstrattoConto | null;
    contatto?: string | null;
}

export class EstrattoContoCreateRequest extends ApiRequest implements IEstrattoContoCreateRequest {
    estrattoConto?: EstrattoConto | null;
    dal?: string;
    al?: string;

    constructor(data?: IEstrattoContoCreateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estrattoConto = _data["estrattoConto"] ? EstrattoConto.fromJS(_data["estrattoConto"]) : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
        }
    }

    static fromJS(data: any): EstrattoContoCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estrattoConto"] = this.estrattoConto ? this.estrattoConto.toJSON() : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEstrattoContoCreateRequest extends IApiRequest {
    estrattoConto?: EstrattoConto | null;
    dal?: string;
    al?: string;
}

export class EstrattoContoDeleteRequest extends ApiRequest implements IEstrattoContoDeleteRequest {
    estrattoContoID?: number;

    constructor(data?: IEstrattoContoDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estrattoContoID = _data["estrattoContoID"] !== undefined ? _data["estrattoContoID"] : <any>null;
        }
    }

    static fromJS(data: any): EstrattoContoDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EstrattoContoDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estrattoContoID"] = this.estrattoContoID !== undefined ? this.estrattoContoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEstrattoContoDeleteRequest extends IApiRequest {
    estrattoContoID?: number;
}

export class PreviewEstrattoContoResponse extends OkApiResponse implements IPreviewEstrattoContoResponse {
    incassi?: PreviewEstrattoContoRow[] | null;

    constructor(data?: IPreviewEstrattoContoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["incassi"])) {
                this.incassi = [] as any;
                for (let item of _data["incassi"])
                    this.incassi!.push(PreviewEstrattoContoRow.fromJS(item));
            }
            else {
                this.incassi = <any>null;
            }
        }
    }

    static fromJS(data: any): PreviewEstrattoContoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewEstrattoContoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incassi)) {
            data["incassi"] = [];
            for (let item of this.incassi)
                data["incassi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPreviewEstrattoContoResponse extends IOkApiResponse {
    incassi?: PreviewEstrattoContoRow[] | null;
}

export class PreviewEstrattoContoRow implements IPreviewEstrattoContoRow {
    offertaID?: number;
    offerta?: string | null;
    dataScadenza?: string | null;
    descrizione?: string | null;
    importo?: number | null;
    tipoOperazione?: string | null;
    tipoBiglietteria?: string | null;
    tipoPrepagamento?: string | null;

    constructor(data?: IPreviewEstrattoContoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.offerta = _data["offerta"] !== undefined ? _data["offerta"] : <any>null;
            this.dataScadenza = _data["dataScadenza"] !== undefined ? _data["dataScadenza"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
            this.tipoOperazione = _data["tipoOperazione"] !== undefined ? _data["tipoOperazione"] : <any>null;
            this.tipoBiglietteria = _data["tipoBiglietteria"] !== undefined ? _data["tipoBiglietteria"] : <any>null;
            this.tipoPrepagamento = _data["tipoPrepagamento"] !== undefined ? _data["tipoPrepagamento"] : <any>null;
        }
    }

    static fromJS(data: any): PreviewEstrattoContoRow {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewEstrattoContoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["offerta"] = this.offerta !== undefined ? this.offerta : <any>null;
        data["dataScadenza"] = this.dataScadenza !== undefined ? this.dataScadenza : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        data["tipoOperazione"] = this.tipoOperazione !== undefined ? this.tipoOperazione : <any>null;
        data["tipoBiglietteria"] = this.tipoBiglietteria !== undefined ? this.tipoBiglietteria : <any>null;
        data["tipoPrepagamento"] = this.tipoPrepagamento !== undefined ? this.tipoPrepagamento : <any>null;
        return data;
    }
}

export interface IPreviewEstrattoContoRow {
    offertaID?: number;
    offerta?: string | null;
    dataScadenza?: string | null;
    descrizione?: string | null;
    importo?: number | null;
    tipoOperazione?: string | null;
    tipoBiglietteria?: string | null;
    tipoPrepagamento?: string | null;
}

export class PreviewEstrattoContoRequest extends ApiRequest implements IPreviewEstrattoContoRequest {
    estrattoConto?: EstrattoConto | null;
    dal?: string;
    al?: string;

    constructor(data?: IPreviewEstrattoContoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estrattoConto = _data["estrattoConto"] ? EstrattoConto.fromJS(_data["estrattoConto"]) : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
        }
    }

    static fromJS(data: any): PreviewEstrattoContoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewEstrattoContoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estrattoConto"] = this.estrattoConto ? this.estrattoConto.toJSON() : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPreviewEstrattoContoRequest extends IApiRequest {
    estrattoConto?: EstrattoConto | null;
    dal?: string;
    al?: string;
}

export class PreviewExcelRequest extends ApiRequest implements IPreviewExcelRequest {
    rows?: IncassoSendRow[] | null;

    constructor(data?: IPreviewExcelRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(IncassoSendRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): PreviewExcelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewExcelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPreviewExcelRequest extends IApiRequest {
    rows?: IncassoSendRow[] | null;
}

export class IncassoSendRow implements IIncassoSendRow {
    offertaID?: number | null;
    offerta?: string | null;
    descrizione?: string | null;
    importo?: number | null;
    tipoOperazione?: string | null;
    tipoPrepagamento?: string | null;
    tipoBiglietteria?: string | null;
    subtotale?: number | null;

    constructor(data?: IIncassoSendRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.offerta = _data["offerta"] !== undefined ? _data["offerta"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
            this.tipoOperazione = _data["tipoOperazione"] !== undefined ? _data["tipoOperazione"] : <any>null;
            this.tipoPrepagamento = _data["tipoPrepagamento"] !== undefined ? _data["tipoPrepagamento"] : <any>null;
            this.tipoBiglietteria = _data["tipoBiglietteria"] !== undefined ? _data["tipoBiglietteria"] : <any>null;
            this.subtotale = _data["subtotale"] !== undefined ? _data["subtotale"] : <any>null;
        }
    }

    static fromJS(data: any): IncassoSendRow {
        data = typeof data === 'object' ? data : {};
        let result = new IncassoSendRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["offerta"] = this.offerta !== undefined ? this.offerta : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        data["tipoOperazione"] = this.tipoOperazione !== undefined ? this.tipoOperazione : <any>null;
        data["tipoPrepagamento"] = this.tipoPrepagamento !== undefined ? this.tipoPrepagamento : <any>null;
        data["tipoBiglietteria"] = this.tipoBiglietteria !== undefined ? this.tipoBiglietteria : <any>null;
        data["subtotale"] = this.subtotale !== undefined ? this.subtotale : <any>null;
        return data;
    }
}

export interface IIncassoSendRow {
    offertaID?: number | null;
    offerta?: string | null;
    descrizione?: string | null;
    importo?: number | null;
    tipoOperazione?: string | null;
    tipoPrepagamento?: string | null;
    tipoBiglietteria?: string | null;
    subtotale?: number | null;
}

export abstract class BaseRQ implements IBaseRQ {
    pid?: string | null;
    connectorsEnvironment?: ConnectorEnvironment[] | null;

    constructor(data?: IBaseRQ) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pid = _data["Pid"] !== undefined ? _data["Pid"] : <any>null;
            if (Array.isArray(_data["ConnectorsEnvironment"])) {
                this.connectorsEnvironment = [] as any;
                for (let item of _data["ConnectorsEnvironment"])
                    this.connectorsEnvironment!.push(ConnectorEnvironment.fromJS(item));
            }
            else {
                this.connectorsEnvironment = <any>null;
            }
        }
    }

    static fromJS(data: any): BaseRQ {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseRQ' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Pid"] = this.pid !== undefined ? this.pid : <any>null;
        if (Array.isArray(this.connectorsEnvironment)) {
            data["ConnectorsEnvironment"] = [];
            for (let item of this.connectorsEnvironment)
                data["ConnectorsEnvironment"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBaseRQ {
    pid?: string | null;
    connectorsEnvironment?: ConnectorEnvironment[] | null;
}

export abstract class BaseCacheableRQ extends BaseRQ implements IBaseCacheableRQ {
    forceNotCachedResponse?: boolean | null;

    constructor(data?: IBaseCacheableRQ) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.forceNotCachedResponse = _data["ForceNotCachedResponse"] !== undefined ? _data["ForceNotCachedResponse"] : <any>null;
        }
    }

    static fromJS(data: any): BaseCacheableRQ {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCacheableRQ' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ForceNotCachedResponse"] = this.forceNotCachedResponse !== undefined ? this.forceNotCachedResponse : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseCacheableRQ extends IBaseRQ {
    forceNotCachedResponse?: boolean | null;
}

export class JupiterFlightAvailabilityRQ extends BaseCacheableRQ implements IJupiterFlightAvailabilityRQ {
    request?: JupiterFlightAvailabilityInput | null;

    constructor(data?: IJupiterFlightAvailabilityRQ) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.request = _data["Request"] ? JupiterFlightAvailabilityInput.fromJS(_data["Request"]) : <any>null;
        }
    }

    static fromJS(data: any): JupiterFlightAvailabilityRQ {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightAvailabilityRQ();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Request"] = this.request ? this.request.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightAvailabilityRQ extends IBaseCacheableRQ {
    request?: JupiterFlightAvailabilityInput | null;
}

export abstract class BaseInput implements IBaseInput {
    connectorsDebug?: EH2HConnectorCode[] | null;

    constructor(data?: IBaseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ConnectorsDebug"])) {
                this.connectorsDebug = [] as any;
                for (let item of _data["ConnectorsDebug"])
                    this.connectorsDebug!.push(item);
            }
            else {
                this.connectorsDebug = <any>null;
            }
        }
    }

    static fromJS(data: any): BaseInput {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseInput' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.connectorsDebug)) {
            data["ConnectorsDebug"] = [];
            for (let item of this.connectorsDebug)
                data["ConnectorsDebug"].push(item);
        }
        return data;
    }
}

export interface IBaseInput {
    connectorsDebug?: EH2HConnectorCode[] | null;
}

export class JupiterFlightAvailabilityInput extends BaseInput implements IJupiterFlightAvailabilityInput {
    connectorsSearch!: EH2HConnectorCode[];
    flightSteps!: FlightStepRequest[];
    adultCount!: number;
    childCount!: number;
    infantCount!: number;
    preferredCurrency?: string | null;
    mergeConnectorResults?: boolean | null;
    connectorCustomData?: FlightAvailabilityInputCustomData[] | null;
    customerCustomData?: CustomerCustomDataOfJupiterFlightAvailabilityInput | null;

    constructor(data?: IJupiterFlightAvailabilityInput) {
        super(data);
        if (!data) {
            this.connectorsSearch = [];
            this.flightSteps = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ConnectorsSearch"])) {
                this.connectorsSearch = [] as any;
                for (let item of _data["ConnectorsSearch"])
                    this.connectorsSearch!.push(item);
            }
            else {
                this.connectorsSearch = <any>null;
            }
            if (Array.isArray(_data["FlightSteps"])) {
                this.flightSteps = [] as any;
                for (let item of _data["FlightSteps"])
                    this.flightSteps!.push(FlightStepRequest.fromJS(item));
            }
            else {
                this.flightSteps = <any>null;
            }
            this.adultCount = _data["AdultCount"] !== undefined ? _data["AdultCount"] : <any>null;
            this.childCount = _data["ChildCount"] !== undefined ? _data["ChildCount"] : <any>null;
            this.infantCount = _data["InfantCount"] !== undefined ? _data["InfantCount"] : <any>null;
            this.preferredCurrency = _data["PreferredCurrency"] !== undefined ? _data["PreferredCurrency"] : <any>null;
            this.mergeConnectorResults = _data["MergeConnectorResults"] !== undefined ? _data["MergeConnectorResults"] : <any>null;
            if (Array.isArray(_data["ConnectorCustomData"])) {
                this.connectorCustomData = [] as any;
                for (let item of _data["ConnectorCustomData"])
                    this.connectorCustomData!.push(FlightAvailabilityInputCustomData.fromJS(item));
            }
            else {
                this.connectorCustomData = <any>null;
            }
            this.customerCustomData = _data["CustomerCustomData"] ? CustomerCustomDataOfJupiterFlightAvailabilityInput.fromJS(_data["CustomerCustomData"]) : <any>null;
        }
    }

    static fromJS(data: any): JupiterFlightAvailabilityInput {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightAvailabilityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.connectorsSearch)) {
            data["ConnectorsSearch"] = [];
            for (let item of this.connectorsSearch)
                data["ConnectorsSearch"].push(item);
        }
        if (Array.isArray(this.flightSteps)) {
            data["FlightSteps"] = [];
            for (let item of this.flightSteps)
                data["FlightSteps"].push(item.toJSON());
        }
        data["AdultCount"] = this.adultCount !== undefined ? this.adultCount : <any>null;
        data["ChildCount"] = this.childCount !== undefined ? this.childCount : <any>null;
        data["InfantCount"] = this.infantCount !== undefined ? this.infantCount : <any>null;
        data["PreferredCurrency"] = this.preferredCurrency !== undefined ? this.preferredCurrency : <any>null;
        data["MergeConnectorResults"] = this.mergeConnectorResults !== undefined ? this.mergeConnectorResults : <any>null;
        if (Array.isArray(this.connectorCustomData)) {
            data["ConnectorCustomData"] = [];
            for (let item of this.connectorCustomData)
                data["ConnectorCustomData"].push(item.toJSON());
        }
        data["CustomerCustomData"] = this.customerCustomData ? this.customerCustomData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightAvailabilityInput extends IBaseInput {
    connectorsSearch: EH2HConnectorCode[];
    flightSteps: FlightStepRequest[];
    adultCount: number;
    childCount: number;
    infantCount: number;
    preferredCurrency?: string | null;
    mergeConnectorResults?: boolean | null;
    connectorCustomData?: FlightAvailabilityInputCustomData[] | null;
    customerCustomData?: CustomerCustomDataOfJupiterFlightAvailabilityInput | null;
}

export enum EH2HConnectorCode {
    UNKNOWN = "UNKNOWN",
    BOOKING_DOT_COM = "BOOKING_DOT_COM",
    SABRE_SYNXIS = "SABRE_SYNXIS",
    AMADEUS = "AMADEUS",
    SABRE = "SABRE",
    SABRE_CSL = "SABRE_CSL",
    CREOLE = "CREOLE",
    SANDALS = "SANDALS",
    TRAVELFUSION = "TRAVELFUSION",
    IHG_GRS = "IHG_GRS",
    OKKAMI = "OKKAMI",
    HOTELBEDS = "HOTELBEDS",
    EMINDS = "EMINDS",
    EXPEDIA = "EXPEDIA",
    TEKURA = "TEKURA",
    AIC = "AIC",
    ALLIED = "ALLIED",
    JTB = "JTB",
    HERTZ = "HERTZ",
    AMERICA_4_YOU = "AMERICA_4_YOU",
    TEAM_AMERICA = "TEAM_AMERICA",
    ARABIAN = "ARABIAN",
    JONVIEW = "JONVIEW",
    MECA = "MECA",
    ATI = "ATI",
    OLYMPIA = "OLYMPIA",
    PACIFIC_DESTINATIONS = "PACIFIC_DESTINATIONS",
    ROSIE = "ROSIE",
    RMH_TOURS = "RMH_TOURS",
    GO_WEST = "GO_WEST",
    AOT = "AOT",
    RESTEL = "RESTEL",
    TOURMAPPERS = "TOURMAPPERS",
    TRAVALCO = "TRAVALCO",
    WTS = "WTS",
    BONOTEL = "BONOTEL",
    ALAMO = "ALAMO",
    MSC = "MSC",
    BOOK_ME = "BOOK_ME",
    MAGIC_TRAVELS = "MAGIC_TRAVELS",
    CLUBMED = "CLUBMED",
    RIU = "RIU",
    KOEDIA = "KOEDIA",
    NTA = "NTA",
    RATE_HAWK = "RATE_HAWK",
    TRAVELGATE = "TRAVELGATE",
    PAN_PACIFIC = "PAN_PACIFIC",
    NET_STORMING = "NET_STORMING",
    HOTEL_TRADER = "HOTEL_TRADER",
    WONDERMILES = "WONDERMILES",
    TRAVELPORT = "TRAVELPORT",
    EXPEDIA_RAPID = "EXPEDIA_RAPID",
    WEBBEDS = "WEBBEDS",
    GO_WAY = "GO_WAY",
    GO_GLOBAL = "GO_GLOBAL",
    HDR = "HDR",
    HYPER_GUEST = "HYPER_GUEST",
    A_SAMPLE = "A_SAMPLE",
}

export class FlightStepRequest implements IFlightStepRequest {
    departureDate!: string;
    departureTime?: string | null;
    departureTimeWindow?: number | null;
    cabin?: EFlightCabin | null;
    enableJumpCabin?: boolean | null;
    departureAirport!: string;
    arrivalAirport!: string;
    excludedCarriers?: string[] | null;
    includedCarriers?: string[] | null;
    onlyDirectFlights?: boolean | null;
    baggageIncluded?: boolean | null;
    connectorCustomData?: FlightStepRequestCustomData[] | null;

    constructor(data?: IFlightStepRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departureDate = _data["DepartureDate"] !== undefined ? _data["DepartureDate"] : <any>null;
            this.departureTime = _data["DepartureTime"] !== undefined ? _data["DepartureTime"] : <any>null;
            this.departureTimeWindow = _data["DepartureTimeWindow"] !== undefined ? _data["DepartureTimeWindow"] : <any>null;
            this.cabin = _data["Cabin"] !== undefined ? _data["Cabin"] : <any>null;
            this.enableJumpCabin = _data["EnableJumpCabin"] !== undefined ? _data["EnableJumpCabin"] : <any>null;
            this.departureAirport = _data["DepartureAirport"] !== undefined ? _data["DepartureAirport"] : <any>null;
            this.arrivalAirport = _data["ArrivalAirport"] !== undefined ? _data["ArrivalAirport"] : <any>null;
            if (Array.isArray(_data["ExcludedCarriers"])) {
                this.excludedCarriers = [] as any;
                for (let item of _data["ExcludedCarriers"])
                    this.excludedCarriers!.push(item);
            }
            else {
                this.excludedCarriers = <any>null;
            }
            if (Array.isArray(_data["IncludedCarriers"])) {
                this.includedCarriers = [] as any;
                for (let item of _data["IncludedCarriers"])
                    this.includedCarriers!.push(item);
            }
            else {
                this.includedCarriers = <any>null;
            }
            this.onlyDirectFlights = _data["OnlyDirectFlights"] !== undefined ? _data["OnlyDirectFlights"] : <any>null;
            this.baggageIncluded = _data["BaggageIncluded"] !== undefined ? _data["BaggageIncluded"] : <any>null;
            if (Array.isArray(_data["ConnectorCustomData"])) {
                this.connectorCustomData = [] as any;
                for (let item of _data["ConnectorCustomData"])
                    this.connectorCustomData!.push(FlightStepRequestCustomData.fromJS(item));
            }
            else {
                this.connectorCustomData = <any>null;
            }
        }
    }

    static fromJS(data: any): FlightStepRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FlightStepRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DepartureDate"] = this.departureDate !== undefined ? this.departureDate : <any>null;
        data["DepartureTime"] = this.departureTime !== undefined ? this.departureTime : <any>null;
        data["DepartureTimeWindow"] = this.departureTimeWindow !== undefined ? this.departureTimeWindow : <any>null;
        data["Cabin"] = this.cabin !== undefined ? this.cabin : <any>null;
        data["EnableJumpCabin"] = this.enableJumpCabin !== undefined ? this.enableJumpCabin : <any>null;
        data["DepartureAirport"] = this.departureAirport !== undefined ? this.departureAirport : <any>null;
        data["ArrivalAirport"] = this.arrivalAirport !== undefined ? this.arrivalAirport : <any>null;
        if (Array.isArray(this.excludedCarriers)) {
            data["ExcludedCarriers"] = [];
            for (let item of this.excludedCarriers)
                data["ExcludedCarriers"].push(item);
        }
        if (Array.isArray(this.includedCarriers)) {
            data["IncludedCarriers"] = [];
            for (let item of this.includedCarriers)
                data["IncludedCarriers"].push(item);
        }
        data["OnlyDirectFlights"] = this.onlyDirectFlights !== undefined ? this.onlyDirectFlights : <any>null;
        data["BaggageIncluded"] = this.baggageIncluded !== undefined ? this.baggageIncluded : <any>null;
        if (Array.isArray(this.connectorCustomData)) {
            data["ConnectorCustomData"] = [];
            for (let item of this.connectorCustomData)
                data["ConnectorCustomData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlightStepRequest {
    departureDate: string;
    departureTime?: string | null;
    departureTimeWindow?: number | null;
    cabin?: EFlightCabin | null;
    enableJumpCabin?: boolean | null;
    departureAirport: string;
    arrivalAirport: string;
    excludedCarriers?: string[] | null;
    includedCarriers?: string[] | null;
    onlyDirectFlights?: boolean | null;
    baggageIncluded?: boolean | null;
    connectorCustomData?: FlightStepRequestCustomData[] | null;
}

export enum EFlightCabin {
    ECONOMY = "ECONOMY",
    PREMIUM_ECONOMY = "PREMIUM_ECONOMY",
    BUSINESS = "BUSINESS",
    PREMIUM_BUSINESS = "PREMIUM_BUSINESS",
    FIRST = "FIRST",
    PREMIUM_FIRST = "PREMIUM_FIRST",
}

export abstract class FlightStepRequestCustomData implements IFlightStepRequestCustomData {

    protected _discriminator: string;

    constructor(data?: IFlightStepRequestCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FlightStepRequestCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FlightStepRequestCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusFlightStepRequestCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FlightStepRequestCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IFlightStepRequestCustomData {
}

export class AmadeusFlightStepRequestCustomData extends FlightStepRequestCustomData implements IAmadeusFlightStepRequestCustomData {
    maxStopsQuantity?: number | null;

    constructor(data?: IAmadeusFlightStepRequestCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.maxStopsQuantity = _data["MaxStopsQuantity"] !== undefined ? _data["MaxStopsQuantity"] : <any>null;
        }
    }

    static fromJS(data: any): AmadeusFlightStepRequestCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightStepRequestCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MaxStopsQuantity"] = this.maxStopsQuantity !== undefined ? this.maxStopsQuantity : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusFlightStepRequestCustomData extends IFlightStepRequestCustomData {
    maxStopsQuantity?: number | null;
}

export abstract class FlightAvailabilityInputCustomData implements IFlightAvailabilityInputCustomData {
    accountCodes?: string[] | null;

    protected _discriminator: string;

    constructor(data?: IFlightAvailabilityInputCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FlightAvailabilityInputCustomData";
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["AccountCodes"])) {
                this.accountCodes = [] as any;
                for (let item of _data["AccountCodes"])
                    this.accountCodes!.push(item);
            }
            else {
                this.accountCodes = <any>null;
            }
        }
    }

    static fromJS(data: any): FlightAvailabilityInputCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusFlightAvailabilityInputCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FlightAvailabilityInputCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        if (Array.isArray(this.accountCodes)) {
            data["AccountCodes"] = [];
            for (let item of this.accountCodes)
                data["AccountCodes"].push(item);
        }
        return data;
    }
}

export interface IFlightAvailabilityInputCustomData {
    accountCodes?: string[] | null;
}

export class AmadeusFlightAvailabilityInputCustomData extends FlightAvailabilityInputCustomData implements IAmadeusFlightAvailabilityInputCustomData {
    amadeusSession?: AmadeusGdsSessionCustomData | null;
    isExpertSearch?: boolean | null;
    enableFareFamilies?: boolean | null;
    enableMiniRule?: boolean | null;
    onlyNdc?: boolean | null;
    includeNdc?: boolean | null;
    refundableFares?: boolean | null;
    exchangeableFares?: boolean | null;
    noAdvancedPurchaseFares?: boolean | null;
    noRestrictionFares?: boolean | null;
    includedAlliances?: string[] | null;
    excludedAlliances?: string[] | null;
    maxConnectionMinutes?: number | null;
    minimumConnectionMinutes?: number | null;
    getPureSolutions?: boolean | null;
    priceTypeList?: string[] | null;
    recommendationNumberOfUnits?: number | null;

    constructor(data?: IAmadeusFlightAvailabilityInputCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amadeusSession = _data["AmadeusSession"] ? AmadeusGdsSessionCustomData.fromJS(_data["AmadeusSession"]) : <any>null;
            this.isExpertSearch = _data["IsExpertSearch"] !== undefined ? _data["IsExpertSearch"] : <any>null;
            this.enableFareFamilies = _data["EnableFareFamilies"] !== undefined ? _data["EnableFareFamilies"] : <any>null;
            this.enableMiniRule = _data["EnableMiniRule"] !== undefined ? _data["EnableMiniRule"] : <any>null;
            this.onlyNdc = _data["OnlyNdc"] !== undefined ? _data["OnlyNdc"] : <any>null;
            this.includeNdc = _data["IncludeNdc"] !== undefined ? _data["IncludeNdc"] : <any>null;
            this.refundableFares = _data["RefundableFares"] !== undefined ? _data["RefundableFares"] : <any>null;
            this.exchangeableFares = _data["ExchangeableFares"] !== undefined ? _data["ExchangeableFares"] : <any>null;
            this.noAdvancedPurchaseFares = _data["NoAdvancedPurchaseFares"] !== undefined ? _data["NoAdvancedPurchaseFares"] : <any>null;
            this.noRestrictionFares = _data["NoRestrictionFares"] !== undefined ? _data["NoRestrictionFares"] : <any>null;
            if (Array.isArray(_data["IncludedAlliances"])) {
                this.includedAlliances = [] as any;
                for (let item of _data["IncludedAlliances"])
                    this.includedAlliances!.push(item);
            }
            else {
                this.includedAlliances = <any>null;
            }
            if (Array.isArray(_data["ExcludedAlliances"])) {
                this.excludedAlliances = [] as any;
                for (let item of _data["ExcludedAlliances"])
                    this.excludedAlliances!.push(item);
            }
            else {
                this.excludedAlliances = <any>null;
            }
            this.maxConnectionMinutes = _data["MaxConnectionMinutes"] !== undefined ? _data["MaxConnectionMinutes"] : <any>null;
            this.minimumConnectionMinutes = _data["MinimumConnectionMinutes"] !== undefined ? _data["MinimumConnectionMinutes"] : <any>null;
            this.getPureSolutions = _data["GetPureSolutions"] !== undefined ? _data["GetPureSolutions"] : <any>null;
            if (Array.isArray(_data["PriceTypeList"])) {
                this.priceTypeList = [] as any;
                for (let item of _data["PriceTypeList"])
                    this.priceTypeList!.push(item);
            }
            else {
                this.priceTypeList = <any>null;
            }
            this.recommendationNumberOfUnits = _data["RecommendationNumberOfUnits"] !== undefined ? _data["RecommendationNumberOfUnits"] : <any>null;
        }
    }

    static fromJS(data: any): AmadeusFlightAvailabilityInputCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightAvailabilityInputCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AmadeusSession"] = this.amadeusSession ? this.amadeusSession.toJSON() : <any>null;
        data["IsExpertSearch"] = this.isExpertSearch !== undefined ? this.isExpertSearch : <any>null;
        data["EnableFareFamilies"] = this.enableFareFamilies !== undefined ? this.enableFareFamilies : <any>null;
        data["EnableMiniRule"] = this.enableMiniRule !== undefined ? this.enableMiniRule : <any>null;
        data["OnlyNdc"] = this.onlyNdc !== undefined ? this.onlyNdc : <any>null;
        data["IncludeNdc"] = this.includeNdc !== undefined ? this.includeNdc : <any>null;
        data["RefundableFares"] = this.refundableFares !== undefined ? this.refundableFares : <any>null;
        data["ExchangeableFares"] = this.exchangeableFares !== undefined ? this.exchangeableFares : <any>null;
        data["NoAdvancedPurchaseFares"] = this.noAdvancedPurchaseFares !== undefined ? this.noAdvancedPurchaseFares : <any>null;
        data["NoRestrictionFares"] = this.noRestrictionFares !== undefined ? this.noRestrictionFares : <any>null;
        if (Array.isArray(this.includedAlliances)) {
            data["IncludedAlliances"] = [];
            for (let item of this.includedAlliances)
                data["IncludedAlliances"].push(item);
        }
        if (Array.isArray(this.excludedAlliances)) {
            data["ExcludedAlliances"] = [];
            for (let item of this.excludedAlliances)
                data["ExcludedAlliances"].push(item);
        }
        data["MaxConnectionMinutes"] = this.maxConnectionMinutes !== undefined ? this.maxConnectionMinutes : <any>null;
        data["MinimumConnectionMinutes"] = this.minimumConnectionMinutes !== undefined ? this.minimumConnectionMinutes : <any>null;
        data["GetPureSolutions"] = this.getPureSolutions !== undefined ? this.getPureSolutions : <any>null;
        if (Array.isArray(this.priceTypeList)) {
            data["PriceTypeList"] = [];
            for (let item of this.priceTypeList)
                data["PriceTypeList"].push(item);
        }
        data["RecommendationNumberOfUnits"] = this.recommendationNumberOfUnits !== undefined ? this.recommendationNumberOfUnits : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusFlightAvailabilityInputCustomData extends IFlightAvailabilityInputCustomData {
    amadeusSession?: AmadeusGdsSessionCustomData | null;
    isExpertSearch?: boolean | null;
    enableFareFamilies?: boolean | null;
    enableMiniRule?: boolean | null;
    onlyNdc?: boolean | null;
    includeNdc?: boolean | null;
    refundableFares?: boolean | null;
    exchangeableFares?: boolean | null;
    noAdvancedPurchaseFares?: boolean | null;
    noRestrictionFares?: boolean | null;
    includedAlliances?: string[] | null;
    excludedAlliances?: string[] | null;
    maxConnectionMinutes?: number | null;
    minimumConnectionMinutes?: number | null;
    getPureSolutions?: boolean | null;
    priceTypeList?: string[] | null;
    recommendationNumberOfUnits?: number | null;
}

export abstract class GdsSessionCustomData implements IGdsSessionCustomData {

    protected _discriminator: string;

    constructor(data?: IGdsSessionCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "GdsSessionCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GdsSessionCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusGdsSessionCustomData();
            result.init(data);
            return result;
        }
        if (data["CustomDataConnectorCode"] === "SABRE") {
            let result = new SabreGdsSessionCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'GdsSessionCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IGdsSessionCustomData {
}

export class AmadeusGdsSessionCustomData extends GdsSessionCustomData implements IAmadeusGdsSessionCustomData {
    sessionId?: string | null;
    sessionStatus?: EAmadeusSessionStatus | null;
    sequenceNumber?: number | null;
    securityToken?: string | null;

    constructor(data?: IAmadeusGdsSessionCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sessionId = _data["SessionId"] !== undefined ? _data["SessionId"] : <any>null;
            this.sessionStatus = _data["SessionStatus"] !== undefined ? _data["SessionStatus"] : <any>null;
            this.sequenceNumber = _data["SequenceNumber"] !== undefined ? _data["SequenceNumber"] : <any>null;
            this.securityToken = _data["SecurityToken"] !== undefined ? _data["SecurityToken"] : <any>null;
        }
    }

    static fromJS(data: any): AmadeusGdsSessionCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusGdsSessionCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SessionId"] = this.sessionId !== undefined ? this.sessionId : <any>null;
        data["SessionStatus"] = this.sessionStatus !== undefined ? this.sessionStatus : <any>null;
        data["SequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : <any>null;
        data["SecurityToken"] = this.securityToken !== undefined ? this.securityToken : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusGdsSessionCustomData extends IGdsSessionCustomData {
    sessionId?: string | null;
    sessionStatus?: EAmadeusSessionStatus | null;
    sequenceNumber?: number | null;
    securityToken?: string | null;
}

export enum EAmadeusSessionStatus {
    START = "START",
    END = "END",
    IN_SERIES = "IN_SERIES",
}

export class SabreGdsSessionCustomData extends GdsSessionCustomData implements ISabreGdsSessionCustomData {
    id?: string | null;
    type?: ESabreSessionType | null;
    environment?: string | null;
    status?: ESabreSessionStatus | null;
    lastCallUtc?: string | null;
    binarySecurityToken?: string | null;
    conversationId?: string | null;
    processId?: string | null;

    constructor(data?: ISabreGdsSessionCustomData) {
        super(data);
        this._discriminator = "SABRE";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : <any>null;
            this.type = _data["Type"] !== undefined ? _data["Type"] : <any>null;
            this.environment = _data["Environment"] !== undefined ? _data["Environment"] : <any>null;
            this.status = _data["Status"] !== undefined ? _data["Status"] : <any>null;
            this.lastCallUtc = _data["LastCallUtc"] !== undefined ? _data["LastCallUtc"] : <any>null;
            this.binarySecurityToken = _data["BinarySecurityToken"] !== undefined ? _data["BinarySecurityToken"] : <any>null;
            this.conversationId = _data["ConversationId"] !== undefined ? _data["ConversationId"] : <any>null;
            this.processId = _data["ProcessId"] !== undefined ? _data["ProcessId"] : <any>null;
        }
    }

    static fromJS(data: any): SabreGdsSessionCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new SabreGdsSessionCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : <any>null;
        data["Type"] = this.type !== undefined ? this.type : <any>null;
        data["Environment"] = this.environment !== undefined ? this.environment : <any>null;
        data["Status"] = this.status !== undefined ? this.status : <any>null;
        data["LastCallUtc"] = this.lastCallUtc !== undefined ? this.lastCallUtc : <any>null;
        data["BinarySecurityToken"] = this.binarySecurityToken !== undefined ? this.binarySecurityToken : <any>null;
        data["ConversationId"] = this.conversationId !== undefined ? this.conversationId : <any>null;
        data["ProcessId"] = this.processId !== undefined ? this.processId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISabreGdsSessionCustomData extends IGdsSessionCustomData {
    id?: string | null;
    type?: ESabreSessionType | null;
    environment?: string | null;
    status?: ESabreSessionStatus | null;
    lastCallUtc?: string | null;
    binarySecurityToken?: string | null;
    conversationId?: string | null;
    processId?: string | null;
}

export enum ESabreSessionType {
    SESSION = "SESSION",
    TOKEN = "TOKEN",
}

export enum ESabreSessionStatus {
    AVAILABLE = "AVAILABLE",
    BUSY = "BUSY",
    CLOSED = "CLOSED",
}

export abstract class CustomerCustomDataOfJupiterFlightAvailabilityInput implements ICustomerCustomDataOfJupiterFlightAvailabilityInput {

    protected _discriminator: string;

    constructor(data?: ICustomerCustomDataOfJupiterFlightAvailabilityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "CustomerCustomDataOfJupiterFlightAvailabilityInput";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CustomerCustomDataOfJupiterFlightAvailabilityInput {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataCode"] === "FlightAvailNaarData") {
            let result = new FlightAvailNaarData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'CustomerCustomDataOfJupiterFlightAvailabilityInput' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataCode"] = this._discriminator;
        return data;
    }
}

export interface ICustomerCustomDataOfJupiterFlightAvailabilityInput {
}

export class FlightAvailNaarData extends CustomerCustomDataOfJupiterFlightAvailabilityInput implements IFlightAvailNaarData {
    markupData?: MarkupData | null;

    constructor(data?: IFlightAvailNaarData) {
        super(data);
        this._discriminator = "FlightAvailNaarData";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.markupData = _data["MarkupData"] ? MarkupData.fromJS(_data["MarkupData"]) : <any>null;
        }
    }

    static fromJS(data: any): FlightAvailNaarData {
        data = typeof data === 'object' ? data : {};
        let result = new FlightAvailNaarData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MarkupData"] = this.markupData ? this.markupData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightAvailNaarData extends ICustomerCustomDataOfJupiterFlightAvailabilityInput {
    markupData?: MarkupData | null;
}

export class MarkupData implements IMarkupData {
    markupFlightFareIT?: number | null;
    markupFlightFareIP?: number | null;
    markupFlightTax?: number | null;

    constructor(data?: IMarkupData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.markupFlightFareIT = _data["MarkupFlightFareIT"] !== undefined ? _data["MarkupFlightFareIT"] : <any>null;
            this.markupFlightFareIP = _data["MarkupFlightFareIP"] !== undefined ? _data["MarkupFlightFareIP"] : <any>null;
            this.markupFlightTax = _data["MarkupFlightTax"] !== undefined ? _data["MarkupFlightTax"] : <any>null;
        }
    }

    static fromJS(data: any): MarkupData {
        data = typeof data === 'object' ? data : {};
        let result = new MarkupData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MarkupFlightFareIT"] = this.markupFlightFareIT !== undefined ? this.markupFlightFareIT : <any>null;
        data["MarkupFlightFareIP"] = this.markupFlightFareIP !== undefined ? this.markupFlightFareIP : <any>null;
        data["MarkupFlightTax"] = this.markupFlightTax !== undefined ? this.markupFlightTax : <any>null;
        return data;
    }
}

export interface IMarkupData {
    markupFlightFareIT?: number | null;
    markupFlightFareIP?: number | null;
    markupFlightTax?: number | null;
}

export class ConnectorEnvironment implements IConnectorEnvironment {
    connectorCode?: EH2HConnectorCode | null;
    environment?: string | null;

    constructor(data?: IConnectorEnvironment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : <any>null;
            this.environment = _data["Environment"] !== undefined ? _data["Environment"] : <any>null;
        }
    }

    static fromJS(data: any): ConnectorEnvironment {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectorEnvironment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : <any>null;
        data["Environment"] = this.environment !== undefined ? this.environment : <any>null;
        return data;
    }
}

export interface IConnectorEnvironment {
    connectorCode?: EH2HConnectorCode | null;
    environment?: string | null;
}

export abstract class BaseRS implements IBaseRS {
    pid?: string | null;
    status?: EOperationStatus | null;
    messages?: Message[] | null;
    connectorsResponseDetails?: ConnectorResponseDetails[] | null;

    constructor(data?: IBaseRS) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pid = _data["Pid"] !== undefined ? _data["Pid"] : <any>null;
            this.status = _data["Status"] !== undefined ? _data["Status"] : <any>null;
            if (Array.isArray(_data["Messages"])) {
                this.messages = [] as any;
                for (let item of _data["Messages"])
                    this.messages!.push(Message.fromJS(item));
            }
            else {
                this.messages = <any>null;
            }
            if (Array.isArray(_data["ConnectorsResponseDetails"])) {
                this.connectorsResponseDetails = [] as any;
                for (let item of _data["ConnectorsResponseDetails"])
                    this.connectorsResponseDetails!.push(ConnectorResponseDetails.fromJS(item));
            }
            else {
                this.connectorsResponseDetails = <any>null;
            }
        }
    }

    static fromJS(data: any): BaseRS {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseRS' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Pid"] = this.pid !== undefined ? this.pid : <any>null;
        data["Status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.messages)) {
            data["Messages"] = [];
            for (let item of this.messages)
                data["Messages"].push(item.toJSON());
        }
        if (Array.isArray(this.connectorsResponseDetails)) {
            data["ConnectorsResponseDetails"] = [];
            for (let item of this.connectorsResponseDetails)
                data["ConnectorsResponseDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBaseRS {
    pid?: string | null;
    status?: EOperationStatus | null;
    messages?: Message[] | null;
    connectorsResponseDetails?: ConnectorResponseDetails[] | null;
}

export abstract class BaseCacheableRS extends BaseRS implements IBaseCacheableRS {
    cacheResponseInfo?: CacheResponseInfo | null;

    constructor(data?: IBaseCacheableRS) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cacheResponseInfo = _data["CacheResponseInfo"] ? CacheResponseInfo.fromJS(_data["CacheResponseInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): BaseCacheableRS {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseCacheableRS' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CacheResponseInfo"] = this.cacheResponseInfo ? this.cacheResponseInfo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseCacheableRS extends IBaseRS {
    cacheResponseInfo?: CacheResponseInfo | null;
}

export class JupiterFlightAvailabilityRS extends BaseCacheableRS implements IJupiterFlightAvailabilityRS {
    response?: JupiterFlightAvailabilityOutput | null;

    constructor(data?: IJupiterFlightAvailabilityRS) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["Response"] ? JupiterFlightAvailabilityOutput.fromJS(_data["Response"]) : <any>null;
        }
    }

    static fromJS(data: any): JupiterFlightAvailabilityRS {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightAvailabilityRS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Response"] = this.response ? this.response.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightAvailabilityRS extends IBaseCacheableRS {
    response?: JupiterFlightAvailabilityOutput | null;
}

export abstract class BaseOutput implements IBaseOutput {

    constructor(data?: IBaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseOutput {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseOutput' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseOutput {
}

export class JupiterFlightAvailabilityOutput extends BaseOutput implements IJupiterFlightAvailabilityOutput {
    flightResults?: SingleFlightAvailResult[] | null;
    connectorCustomData?: FlightAvailabilityOutputCustomData[] | null;

    constructor(data?: IJupiterFlightAvailabilityOutput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["FlightResults"])) {
                this.flightResults = [] as any;
                for (let item of _data["FlightResults"])
                    this.flightResults!.push(SingleFlightAvailResult.fromJS(item));
            }
            else {
                this.flightResults = <any>null;
            }
            if (Array.isArray(_data["ConnectorCustomData"])) {
                this.connectorCustomData = [] as any;
                for (let item of _data["ConnectorCustomData"])
                    this.connectorCustomData!.push(FlightAvailabilityOutputCustomData.fromJS(item));
            }
            else {
                this.connectorCustomData = <any>null;
            }
        }
    }

    static fromJS(data: any): JupiterFlightAvailabilityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightAvailabilityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flightResults)) {
            data["FlightResults"] = [];
            for (let item of this.flightResults)
                data["FlightResults"].push(item.toJSON());
        }
        if (Array.isArray(this.connectorCustomData)) {
            data["ConnectorCustomData"] = [];
            for (let item of this.connectorCustomData)
                data["ConnectorCustomData"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightAvailabilityOutput extends IBaseOutput {
    flightResults?: SingleFlightAvailResult[] | null;
    connectorCustomData?: FlightAvailabilityOutputCustomData[] | null;
}

export class SingleFlightAvailResult implements ISingleFlightAvailResult {
    id?: string | null;
    resultKey?: string | null;
    routingKey?: string | null;
    isPure?: boolean | null;
    codeShareKey?: string | null;
    flightSegments?: FlightSegmentResult[] | null;
    totalDuration?: string | null;
    fareList?: FlightFareGroupResult[] | null;

    constructor(data?: ISingleFlightAvailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : <any>null;
            this.resultKey = _data["ResultKey"] !== undefined ? _data["ResultKey"] : <any>null;
            this.routingKey = _data["RoutingKey"] !== undefined ? _data["RoutingKey"] : <any>null;
            this.isPure = _data["IsPure"] !== undefined ? _data["IsPure"] : <any>null;
            this.codeShareKey = _data["CodeShareKey"] !== undefined ? _data["CodeShareKey"] : <any>null;
            if (Array.isArray(_data["FlightSegments"])) {
                this.flightSegments = [] as any;
                for (let item of _data["FlightSegments"])
                    this.flightSegments!.push(FlightSegmentResult.fromJS(item));
            }
            else {
                this.flightSegments = <any>null;
            }
            this.totalDuration = _data["TotalDuration"] !== undefined ? _data["TotalDuration"] : <any>null;
            if (Array.isArray(_data["FareList"])) {
                this.fareList = [] as any;
                for (let item of _data["FareList"])
                    this.fareList!.push(FlightFareGroupResult.fromJS(item));
            }
            else {
                this.fareList = <any>null;
            }
        }
    }

    static fromJS(data: any): SingleFlightAvailResult {
        data = typeof data === 'object' ? data : {};
        let result = new SingleFlightAvailResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : <any>null;
        data["ResultKey"] = this.resultKey !== undefined ? this.resultKey : <any>null;
        data["RoutingKey"] = this.routingKey !== undefined ? this.routingKey : <any>null;
        data["IsPure"] = this.isPure !== undefined ? this.isPure : <any>null;
        data["CodeShareKey"] = this.codeShareKey !== undefined ? this.codeShareKey : <any>null;
        if (Array.isArray(this.flightSegments)) {
            data["FlightSegments"] = [];
            for (let item of this.flightSegments)
                data["FlightSegments"].push(item.toJSON());
        }
        data["TotalDuration"] = this.totalDuration !== undefined ? this.totalDuration : <any>null;
        if (Array.isArray(this.fareList)) {
            data["FareList"] = [];
            for (let item of this.fareList)
                data["FareList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISingleFlightAvailResult {
    id?: string | null;
    resultKey?: string | null;
    routingKey?: string | null;
    isPure?: boolean | null;
    codeShareKey?: string | null;
    flightSegments?: FlightSegmentResult[] | null;
    totalDuration?: string | null;
    fareList?: FlightFareGroupResult[] | null;
}

export class FlightSegment implements IFlightSegment {
    id?: string | null;
    segmentKey?: string | null;
    segmentRoutingKey?: string | null;
    isPure?: boolean | null;
    stepGroupId?: string | null;
    connectionTime?: string | null;
    departureDate?: string | null;
    departureAirport?: AirportTerminal | null;
    arrivalDate?: string | null;
    arrivalAirport?: AirportTerminal | null;
    duration?: string | null;
    marketingCarrier?: FlightCarrier | null;
    operatingCarrier?: FlightCarrier | null;
    aircraft?: Aircraft | null;
    technicalStops?: FlightStop[] | null;

    constructor(data?: IFlightSegment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : <any>null;
            this.segmentKey = _data["SegmentKey"] !== undefined ? _data["SegmentKey"] : <any>null;
            this.segmentRoutingKey = _data["SegmentRoutingKey"] !== undefined ? _data["SegmentRoutingKey"] : <any>null;
            this.isPure = _data["IsPure"] !== undefined ? _data["IsPure"] : <any>null;
            this.stepGroupId = _data["StepGroupId"] !== undefined ? _data["StepGroupId"] : <any>null;
            this.connectionTime = _data["ConnectionTime"] !== undefined ? _data["ConnectionTime"] : <any>null;
            this.departureDate = _data["DepartureDate"] !== undefined ? _data["DepartureDate"] : <any>null;
            this.departureAirport = _data["DepartureAirport"] ? AirportTerminal.fromJS(_data["DepartureAirport"]) : <any>null;
            this.arrivalDate = _data["ArrivalDate"] !== undefined ? _data["ArrivalDate"] : <any>null;
            this.arrivalAirport = _data["ArrivalAirport"] ? AirportTerminal.fromJS(_data["ArrivalAirport"]) : <any>null;
            this.duration = _data["Duration"] !== undefined ? _data["Duration"] : <any>null;
            this.marketingCarrier = _data["MarketingCarrier"] ? FlightCarrier.fromJS(_data["MarketingCarrier"]) : <any>null;
            this.operatingCarrier = _data["OperatingCarrier"] ? FlightCarrier.fromJS(_data["OperatingCarrier"]) : <any>null;
            this.aircraft = _data["Aircraft"] ? Aircraft.fromJS(_data["Aircraft"]) : <any>null;
            if (Array.isArray(_data["TechnicalStops"])) {
                this.technicalStops = [] as any;
                for (let item of _data["TechnicalStops"])
                    this.technicalStops!.push(FlightStop.fromJS(item));
            }
            else {
                this.technicalStops = <any>null;
            }
        }
    }

    static fromJS(data: any): FlightSegment {
        data = typeof data === 'object' ? data : {};
        let result = new FlightSegment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : <any>null;
        data["SegmentKey"] = this.segmentKey !== undefined ? this.segmentKey : <any>null;
        data["SegmentRoutingKey"] = this.segmentRoutingKey !== undefined ? this.segmentRoutingKey : <any>null;
        data["IsPure"] = this.isPure !== undefined ? this.isPure : <any>null;
        data["StepGroupId"] = this.stepGroupId !== undefined ? this.stepGroupId : <any>null;
        data["ConnectionTime"] = this.connectionTime !== undefined ? this.connectionTime : <any>null;
        data["DepartureDate"] = this.departureDate !== undefined ? this.departureDate : <any>null;
        data["DepartureAirport"] = this.departureAirport ? this.departureAirport.toJSON() : <any>null;
        data["ArrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : <any>null;
        data["ArrivalAirport"] = this.arrivalAirport ? this.arrivalAirport.toJSON() : <any>null;
        data["Duration"] = this.duration !== undefined ? this.duration : <any>null;
        data["MarketingCarrier"] = this.marketingCarrier ? this.marketingCarrier.toJSON() : <any>null;
        data["OperatingCarrier"] = this.operatingCarrier ? this.operatingCarrier.toJSON() : <any>null;
        data["Aircraft"] = this.aircraft ? this.aircraft.toJSON() : <any>null;
        if (Array.isArray(this.technicalStops)) {
            data["TechnicalStops"] = [];
            for (let item of this.technicalStops)
                data["TechnicalStops"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlightSegment {
    id?: string | null;
    segmentKey?: string | null;
    segmentRoutingKey?: string | null;
    isPure?: boolean | null;
    stepGroupId?: string | null;
    connectionTime?: string | null;
    departureDate?: string | null;
    departureAirport?: AirportTerminal | null;
    arrivalDate?: string | null;
    arrivalAirport?: AirportTerminal | null;
    duration?: string | null;
    marketingCarrier?: FlightCarrier | null;
    operatingCarrier?: FlightCarrier | null;
    aircraft?: Aircraft | null;
    technicalStops?: FlightStop[] | null;
}

export class FlightSegmentResult extends FlightSegment implements IFlightSegmentResult {
    connectorCustomData?: FlightSegmentResultCustomData[] | null;

    constructor(data?: IFlightSegmentResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ConnectorCustomData"])) {
                this.connectorCustomData = [] as any;
                for (let item of _data["ConnectorCustomData"])
                    this.connectorCustomData!.push(FlightSegmentResultCustomData.fromJS(item));
            }
            else {
                this.connectorCustomData = <any>null;
            }
        }
    }

    static fromJS(data: any): FlightSegmentResult {
        data = typeof data === 'object' ? data : {};
        let result = new FlightSegmentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.connectorCustomData)) {
            data["ConnectorCustomData"] = [];
            for (let item of this.connectorCustomData)
                data["ConnectorCustomData"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFlightSegmentResult extends IFlightSegment {
    connectorCustomData?: FlightSegmentResultCustomData[] | null;
}

export abstract class FlightSegmentResultCustomData implements IFlightSegmentResultCustomData {

    protected _discriminator: string;

    constructor(data?: IFlightSegmentResultCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FlightSegmentResultCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FlightSegmentResultCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "SABRE") {
            let result = new SabreFlightSegmentResultCustomData();
            result.init(data);
            return result;
        }
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusFlightSegmentResultCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FlightSegmentResultCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IFlightSegmentResultCustomData {
}

export class SabreFlightSegmentResultCustomData extends FlightSegmentResultCustomData implements ISabreFlightSegmentResultCustomData {
    marriageGrp?: string | null;

    constructor(data?: ISabreFlightSegmentResultCustomData) {
        super(data);
        this._discriminator = "SABRE";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.marriageGrp = _data["MarriageGrp"] !== undefined ? _data["MarriageGrp"] : <any>null;
        }
    }

    static fromJS(data: any): SabreFlightSegmentResultCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new SabreFlightSegmentResultCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MarriageGrp"] = this.marriageGrp !== undefined ? this.marriageGrp : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISabreFlightSegmentResultCustomData extends IFlightSegmentResultCustomData {
    marriageGrp?: string | null;
}

export class AmadeusFlightSegmentResultCustomData extends FlightSegmentResultCustomData implements IAmadeusFlightSegmentResultCustomData {
    flightProposalRef?: string | null;
    flightIndex?: string | null;

    constructor(data?: IAmadeusFlightSegmentResultCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.flightProposalRef = _data["FlightProposalRef"] !== undefined ? _data["FlightProposalRef"] : <any>null;
            this.flightIndex = _data["FlightIndex"] !== undefined ? _data["FlightIndex"] : <any>null;
        }
    }

    static fromJS(data: any): AmadeusFlightSegmentResultCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightSegmentResultCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FlightProposalRef"] = this.flightProposalRef !== undefined ? this.flightProposalRef : <any>null;
        data["FlightIndex"] = this.flightIndex !== undefined ? this.flightIndex : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusFlightSegmentResultCustomData extends IFlightSegmentResultCustomData {
    flightProposalRef?: string | null;
    flightIndex?: string | null;
}

export class Airport implements IAirport {
    iataCode?: string | null;
    name?: string | null;
    cityName?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    location?: LatLng | null;

    constructor(data?: IAirport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iataCode = _data["IataCode"] !== undefined ? _data["IataCode"] : <any>null;
            this.name = _data["Name"] !== undefined ? _data["Name"] : <any>null;
            this.cityName = _data["CityName"] !== undefined ? _data["CityName"] : <any>null;
            this.countryCode = _data["CountryCode"] !== undefined ? _data["CountryCode"] : <any>null;
            this.countryName = _data["CountryName"] !== undefined ? _data["CountryName"] : <any>null;
            this.location = _data["Location"] ? LatLng.fromJS(_data["Location"]) : <any>null;
        }
    }

    static fromJS(data: any): Airport {
        data = typeof data === 'object' ? data : {};
        let result = new Airport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IataCode"] = this.iataCode !== undefined ? this.iataCode : <any>null;
        data["Name"] = this.name !== undefined ? this.name : <any>null;
        data["CityName"] = this.cityName !== undefined ? this.cityName : <any>null;
        data["CountryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["CountryName"] = this.countryName !== undefined ? this.countryName : <any>null;
        data["Location"] = this.location ? this.location.toJSON() : <any>null;
        return data;
    }
}

export interface IAirport {
    iataCode?: string | null;
    name?: string | null;
    cityName?: string | null;
    countryCode?: string | null;
    countryName?: string | null;
    location?: LatLng | null;
}

export class AirportTerminal extends Airport implements IAirportTerminal {
    terminalCode?: string | null;
    terminalText?: string | null;

    constructor(data?: IAirportTerminal) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.terminalCode = _data["TerminalCode"] !== undefined ? _data["TerminalCode"] : <any>null;
            this.terminalText = _data["TerminalText"] !== undefined ? _data["TerminalText"] : <any>null;
        }
    }

    static fromJS(data: any): AirportTerminal {
        data = typeof data === 'object' ? data : {};
        let result = new AirportTerminal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TerminalCode"] = this.terminalCode !== undefined ? this.terminalCode : <any>null;
        data["TerminalText"] = this.terminalText !== undefined ? this.terminalText : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAirportTerminal extends IAirport {
    terminalCode?: string | null;
    terminalText?: string | null;
}

export class LatLng implements ILatLng {
    lat?: number | null;
    lng?: number | null;

    constructor(data?: ILatLng) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["Lat"] !== undefined ? _data["Lat"] : <any>null;
            this.lng = _data["Lng"] !== undefined ? _data["Lng"] : <any>null;
        }
    }

    static fromJS(data: any): LatLng {
        data = typeof data === 'object' ? data : {};
        let result = new LatLng();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["Lng"] = this.lng !== undefined ? this.lng : <any>null;
        return data;
    }
}

export interface ILatLng {
    lat?: number | null;
    lng?: number | null;
}

export class Carrier implements ICarrier {
    iataCode?: string | null;
    name?: string | null;

    constructor(data?: ICarrier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iataCode = _data["IataCode"] !== undefined ? _data["IataCode"] : <any>null;
            this.name = _data["Name"] !== undefined ? _data["Name"] : <any>null;
        }
    }

    static fromJS(data: any): Carrier {
        data = typeof data === 'object' ? data : {};
        let result = new Carrier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IataCode"] = this.iataCode !== undefined ? this.iataCode : <any>null;
        data["Name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ICarrier {
    iataCode?: string | null;
    name?: string | null;
}

export class FlightCarrier extends Carrier implements IFlightCarrier {
    flightNumber?: string | null;
    flightCarrierDescription?: string | null;

    constructor(data?: IFlightCarrier) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.flightNumber = _data["FlightNumber"] !== undefined ? _data["FlightNumber"] : <any>null;
            this.flightCarrierDescription = _data["FlightCarrierDescription"] !== undefined ? _data["FlightCarrierDescription"] : <any>null;
        }
    }

    static fromJS(data: any): FlightCarrier {
        data = typeof data === 'object' ? data : {};
        let result = new FlightCarrier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FlightNumber"] = this.flightNumber !== undefined ? this.flightNumber : <any>null;
        data["FlightCarrierDescription"] = this.flightCarrierDescription !== undefined ? this.flightCarrierDescription : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightCarrier extends ICarrier {
    flightNumber?: string | null;
    flightCarrierDescription?: string | null;
}

export class Aircraft implements IAircraft {
    code?: string | null;
    text?: string | null;

    constructor(data?: IAircraft) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"] !== undefined ? _data["Code"] : <any>null;
            this.text = _data["Text"] !== undefined ? _data["Text"] : <any>null;
        }
    }

    static fromJS(data: any): Aircraft {
        data = typeof data === 'object' ? data : {};
        let result = new Aircraft();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code !== undefined ? this.code : <any>null;
        data["Text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface IAircraft {
    code?: string | null;
    text?: string | null;
}

export class FlightStop implements IFlightStop {
    airport?: Airport | null;
    arrivalDate?: string | null;
    departureDate?: string | null;
    duration?: string | null;

    constructor(data?: IFlightStop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airport = _data["Airport"] ? Airport.fromJS(_data["Airport"]) : <any>null;
            this.arrivalDate = _data["ArrivalDate"] !== undefined ? _data["ArrivalDate"] : <any>null;
            this.departureDate = _data["DepartureDate"] !== undefined ? _data["DepartureDate"] : <any>null;
            this.duration = _data["Duration"] !== undefined ? _data["Duration"] : <any>null;
        }
    }

    static fromJS(data: any): FlightStop {
        data = typeof data === 'object' ? data : {};
        let result = new FlightStop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Airport"] = this.airport ? this.airport.toJSON() : <any>null;
        data["ArrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : <any>null;
        data["DepartureDate"] = this.departureDate !== undefined ? this.departureDate : <any>null;
        data["Duration"] = this.duration !== undefined ? this.duration : <any>null;
        return data;
    }
}

export interface IFlightStop {
    airport?: Airport | null;
    arrivalDate?: string | null;
    departureDate?: string | null;
    duration?: string | null;
}

export class FlightFare implements IFlightFare {
    fareRules?: FareRule[] | null;
    id?: string | null;
    connectorCode?: EH2HConnectorCode | null;
    description?: string | null;
    paxFareList?: FlightPaxFare[] | null;
    feeList?: Tax[] | null;
    amount?: Total | null;
    isNdc?: boolean | null;
    isFullRefundable?: boolean | null;
    isPartialRefundable?: boolean | null;
    isFullExchangeable?: boolean | null;
    isPartialExchangeable?: boolean | null;
    fareKey?: string | null;
    fareGroupingKey?: string | null;

    constructor(data?: IFlightFare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["FareRules"])) {
                this.fareRules = [] as any;
                for (let item of _data["FareRules"])
                    this.fareRules!.push(FareRule.fromJS(item));
            }
            else {
                this.fareRules = <any>null;
            }
            this.id = _data["Id"] !== undefined ? _data["Id"] : <any>null;
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : <any>null;
            this.description = _data["Description"] !== undefined ? _data["Description"] : <any>null;
            if (Array.isArray(_data["PaxFareList"])) {
                this.paxFareList = [] as any;
                for (let item of _data["PaxFareList"])
                    this.paxFareList!.push(FlightPaxFare.fromJS(item));
            }
            else {
                this.paxFareList = <any>null;
            }
            if (Array.isArray(_data["FeeList"])) {
                this.feeList = [] as any;
                for (let item of _data["FeeList"])
                    this.feeList!.push(Tax.fromJS(item));
            }
            else {
                this.feeList = <any>null;
            }
            this.amount = _data["Amount"] ? Total.fromJS(_data["Amount"]) : <any>null;
            this.isNdc = _data["IsNdc"] !== undefined ? _data["IsNdc"] : <any>null;
            this.isFullRefundable = _data["IsFullRefundable"] !== undefined ? _data["IsFullRefundable"] : <any>null;
            this.isPartialRefundable = _data["IsPartialRefundable"] !== undefined ? _data["IsPartialRefundable"] : <any>null;
            this.isFullExchangeable = _data["IsFullExchangeable"] !== undefined ? _data["IsFullExchangeable"] : <any>null;
            this.isPartialExchangeable = _data["IsPartialExchangeable"] !== undefined ? _data["IsPartialExchangeable"] : <any>null;
            this.fareKey = _data["FareKey"] !== undefined ? _data["FareKey"] : <any>null;
            this.fareGroupingKey = _data["FareGroupingKey"] !== undefined ? _data["FareGroupingKey"] : <any>null;
        }
    }

    static fromJS(data: any): FlightFare {
        data = typeof data === 'object' ? data : {};
        let result = new FlightFare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fareRules)) {
            data["FareRules"] = [];
            for (let item of this.fareRules)
                data["FareRules"].push(item.toJSON());
        }
        data["Id"] = this.id !== undefined ? this.id : <any>null;
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : <any>null;
        data["Description"] = this.description !== undefined ? this.description : <any>null;
        if (Array.isArray(this.paxFareList)) {
            data["PaxFareList"] = [];
            for (let item of this.paxFareList)
                data["PaxFareList"].push(item.toJSON());
        }
        if (Array.isArray(this.feeList)) {
            data["FeeList"] = [];
            for (let item of this.feeList)
                data["FeeList"].push(item.toJSON());
        }
        data["Amount"] = this.amount ? this.amount.toJSON() : <any>null;
        data["IsNdc"] = this.isNdc !== undefined ? this.isNdc : <any>null;
        data["IsFullRefundable"] = this.isFullRefundable !== undefined ? this.isFullRefundable : <any>null;
        data["IsPartialRefundable"] = this.isPartialRefundable !== undefined ? this.isPartialRefundable : <any>null;
        data["IsFullExchangeable"] = this.isFullExchangeable !== undefined ? this.isFullExchangeable : <any>null;
        data["IsPartialExchangeable"] = this.isPartialExchangeable !== undefined ? this.isPartialExchangeable : <any>null;
        data["FareKey"] = this.fareKey !== undefined ? this.fareKey : <any>null;
        data["FareGroupingKey"] = this.fareGroupingKey !== undefined ? this.fareGroupingKey : <any>null;
        return data;
    }
}

export interface IFlightFare {
    fareRules?: FareRule[] | null;
    id?: string | null;
    connectorCode?: EH2HConnectorCode | null;
    description?: string | null;
    paxFareList?: FlightPaxFare[] | null;
    feeList?: Tax[] | null;
    amount?: Total | null;
    isNdc?: boolean | null;
    isFullRefundable?: boolean | null;
    isPartialRefundable?: boolean | null;
    isFullExchangeable?: boolean | null;
    isPartialExchangeable?: boolean | null;
    fareKey?: string | null;
    fareGroupingKey?: string | null;
}

export class FlightFareGroupResult extends FlightFare implements IFlightFareGroupResult {
    fullReferenceId?: string | null;
    customerCustomData?: CustomerCustomDataOfFlightFareGroupResult | null;

    constructor(data?: IFlightFareGroupResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullReferenceId = _data["FullReferenceId"] !== undefined ? _data["FullReferenceId"] : <any>null;
            this.customerCustomData = _data["CustomerCustomData"] ? CustomerCustomDataOfFlightFareGroupResult.fromJS(_data["CustomerCustomData"]) : <any>null;
        }
    }

    static fromJS(data: any): FlightFareGroupResult {
        data = typeof data === 'object' ? data : {};
        let result = new FlightFareGroupResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullReferenceId"] = this.fullReferenceId !== undefined ? this.fullReferenceId : <any>null;
        data["CustomerCustomData"] = this.customerCustomData ? this.customerCustomData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightFareGroupResult extends IFlightFare {
    fullReferenceId?: string | null;
    customerCustomData?: CustomerCustomDataOfFlightFareGroupResult | null;
}

export abstract class CustomerCustomDataOfFlightFareGroupResult implements ICustomerCustomDataOfFlightFareGroupResult {

    protected _discriminator: string;

    constructor(data?: ICustomerCustomDataOfFlightFareGroupResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "CustomerCustomDataOfFlightFareGroupResult";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CustomerCustomDataOfFlightFareGroupResult {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataCode"] === "FlightFareNaarData") {
            let result = new FlightFareNaarData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'CustomerCustomDataOfFlightFareGroupResult' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataCode"] = this._discriminator;
        return data;
    }
}

export interface ICustomerCustomDataOfFlightFareGroupResult {
}

export class FlightFareNaarData extends CustomerCustomDataOfFlightFareGroupResult implements IFlightFareNaarData {
    isToFare?: boolean | null;
    totalAmountWithoutTaxWithMarkup?: CurrencyAmount | null;
    totalAmountWithMarkup?: CurrencyAmount | null;
    totalTaxWithMarkup?: CurrencyAmount | null;
    perPaxAmountWithMarkup?: CurrencyAmount | null;

    constructor(data?: IFlightFareNaarData) {
        super(data);
        this._discriminator = "FlightFareNaarData";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isToFare = _data["isToFare"] !== undefined ? _data["isToFare"] : <any>null;
            this.totalAmountWithoutTaxWithMarkup = _data["TotalAmountWithoutTaxWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalAmountWithoutTaxWithMarkup"]) : <any>null;
            this.totalAmountWithMarkup = _data["TotalAmountWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalAmountWithMarkup"]) : <any>null;
            this.totalTaxWithMarkup = _data["TotalTaxWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalTaxWithMarkup"]) : <any>null;
            this.perPaxAmountWithMarkup = _data["PerPaxAmountWithMarkup"] ? CurrencyAmount.fromJS(_data["PerPaxAmountWithMarkup"]) : <any>null;
        }
    }

    static fromJS(data: any): FlightFareNaarData {
        data = typeof data === 'object' ? data : {};
        let result = new FlightFareNaarData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isToFare"] = this.isToFare !== undefined ? this.isToFare : <any>null;
        data["TotalAmountWithoutTaxWithMarkup"] = this.totalAmountWithoutTaxWithMarkup ? this.totalAmountWithoutTaxWithMarkup.toJSON() : <any>null;
        data["TotalAmountWithMarkup"] = this.totalAmountWithMarkup ? this.totalAmountWithMarkup.toJSON() : <any>null;
        data["TotalTaxWithMarkup"] = this.totalTaxWithMarkup ? this.totalTaxWithMarkup.toJSON() : <any>null;
        data["PerPaxAmountWithMarkup"] = this.perPaxAmountWithMarkup ? this.perPaxAmountWithMarkup.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightFareNaarData extends ICustomerCustomDataOfFlightFareGroupResult {
    isToFare?: boolean | null;
    totalAmountWithoutTaxWithMarkup?: CurrencyAmount | null;
    totalAmountWithMarkup?: CurrencyAmount | null;
    totalTaxWithMarkup?: CurrencyAmount | null;
    perPaxAmountWithMarkup?: CurrencyAmount | null;
}

export class CurrencyAmount implements ICurrencyAmount {
    currency?: string | null;
    amount?: number | null;

    constructor(data?: ICurrencyAmount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["Currency"] !== undefined ? _data["Currency"] : <any>null;
            this.amount = _data["Amount"] !== undefined ? _data["Amount"] : <any>null;
        }
    }

    static fromJS(data: any): CurrencyAmount {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyAmount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["Amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

export interface ICurrencyAmount {
    currency?: string | null;
    amount?: number | null;
}

export class FareRule implements IFareRule {
    title?: string | null;
    application?: string | null;
    description?: string | null;

    constructor(data?: IFareRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"] !== undefined ? _data["Title"] : <any>null;
            this.application = _data["Application"] !== undefined ? _data["Application"] : <any>null;
            this.description = _data["Description"] !== undefined ? _data["Description"] : <any>null;
        }
    }

    static fromJS(data: any): FareRule {
        data = typeof data === 'object' ? data : {};
        let result = new FareRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title !== undefined ? this.title : <any>null;
        data["Application"] = this.application !== undefined ? this.application : <any>null;
        data["Description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface IFareRule {
    title?: string | null;
    application?: string | null;
    description?: string | null;
}

export class FlightPaxFare implements IFlightPaxFare {
    id?: string | null;
    paxType?: EPaxType | null;
    paxTypeCode?: string | null;
    paxCount?: number | null;
    flightSegmentDetails?: FareSegmentDetail[] | null;
    farePenalties?: FarePenalties | null;
    refundable?: boolean | null;
    lastTicketDate?: string | null;
    amount?: Total | null;
    connectorCustomData?: FlightPaxFareCustomData | null;
    customerCustomData?: CustomerCustomDataOfFlightPaxFare | null;

    constructor(data?: IFlightPaxFare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : <any>null;
            this.paxType = _data["PaxType"] !== undefined ? _data["PaxType"] : <any>null;
            this.paxTypeCode = _data["PaxTypeCode"] !== undefined ? _data["PaxTypeCode"] : <any>null;
            this.paxCount = _data["PaxCount"] !== undefined ? _data["PaxCount"] : <any>null;
            if (Array.isArray(_data["FlightSegmentDetails"])) {
                this.flightSegmentDetails = [] as any;
                for (let item of _data["FlightSegmentDetails"])
                    this.flightSegmentDetails!.push(FareSegmentDetail.fromJS(item));
            }
            else {
                this.flightSegmentDetails = <any>null;
            }
            this.farePenalties = _data["FarePenalties"] ? FarePenalties.fromJS(_data["FarePenalties"]) : <any>null;
            this.refundable = _data["Refundable"] !== undefined ? _data["Refundable"] : <any>null;
            this.lastTicketDate = _data["LastTicketDate"] !== undefined ? _data["LastTicketDate"] : <any>null;
            this.amount = _data["Amount"] ? Total.fromJS(_data["Amount"]) : <any>null;
            this.connectorCustomData = _data["ConnectorCustomData"] ? FlightPaxFareCustomData.fromJS(_data["ConnectorCustomData"]) : <any>null;
            this.customerCustomData = _data["CustomerCustomData"] ? CustomerCustomDataOfFlightPaxFare.fromJS(_data["CustomerCustomData"]) : <any>null;
        }
    }

    static fromJS(data: any): FlightPaxFare {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPaxFare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : <any>null;
        data["PaxType"] = this.paxType !== undefined ? this.paxType : <any>null;
        data["PaxTypeCode"] = this.paxTypeCode !== undefined ? this.paxTypeCode : <any>null;
        data["PaxCount"] = this.paxCount !== undefined ? this.paxCount : <any>null;
        if (Array.isArray(this.flightSegmentDetails)) {
            data["FlightSegmentDetails"] = [];
            for (let item of this.flightSegmentDetails)
                data["FlightSegmentDetails"].push(item.toJSON());
        }
        data["FarePenalties"] = this.farePenalties ? this.farePenalties.toJSON() : <any>null;
        data["Refundable"] = this.refundable !== undefined ? this.refundable : <any>null;
        data["LastTicketDate"] = this.lastTicketDate !== undefined ? this.lastTicketDate : <any>null;
        data["Amount"] = this.amount ? this.amount.toJSON() : <any>null;
        data["ConnectorCustomData"] = this.connectorCustomData ? this.connectorCustomData.toJSON() : <any>null;
        data["CustomerCustomData"] = this.customerCustomData ? this.customerCustomData.toJSON() : <any>null;
        return data;
    }
}

export interface IFlightPaxFare {
    id?: string | null;
    paxType?: EPaxType | null;
    paxTypeCode?: string | null;
    paxCount?: number | null;
    flightSegmentDetails?: FareSegmentDetail[] | null;
    farePenalties?: FarePenalties | null;
    refundable?: boolean | null;
    lastTicketDate?: string | null;
    amount?: Total | null;
    connectorCustomData?: FlightPaxFareCustomData | null;
    customerCustomData?: CustomerCustomDataOfFlightPaxFare | null;
}

export enum EPaxType {
    INFANT = "INFANT",
    CHILD = "CHILD",
    ADULT = "ADULT",
}

export class FareSegmentDetail implements IFareSegmentDetail {
    flightSegmentRefId?: string | null;
    fareType?: EFareType | null;
    fareTypeCode?: string | null;
    cabin?: EFlightCabin | null;
    cabinCode?: string | null;
    class?: string | null;
    classAvail?: string | null;
    fareBasis?: string | null;
    matchedAccountCode?: string | null;
    meal?: FlightMeal | null;
    baggageDetails?: FlightBaggageDetails | null;
    brandedFare?: string | null;
    brandedFareCode?: string | null;
    fareDescription?: string | null;
    hostToken?: string | null;
    providerCode?: string | null;

    constructor(data?: IFareSegmentDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flightSegmentRefId = _data["FlightSegmentRefId"] !== undefined ? _data["FlightSegmentRefId"] : <any>null;
            this.fareType = _data["FareType"] !== undefined ? _data["FareType"] : <any>null;
            this.fareTypeCode = _data["FareTypeCode"] !== undefined ? _data["FareTypeCode"] : <any>null;
            this.cabin = _data["Cabin"] !== undefined ? _data["Cabin"] : <any>null;
            this.cabinCode = _data["CabinCode"] !== undefined ? _data["CabinCode"] : <any>null;
            this.class = _data["Class"] !== undefined ? _data["Class"] : <any>null;
            this.classAvail = _data["ClassAvail"] !== undefined ? _data["ClassAvail"] : <any>null;
            this.fareBasis = _data["FareBasis"] !== undefined ? _data["FareBasis"] : <any>null;
            this.matchedAccountCode = _data["MatchedAccountCode"] !== undefined ? _data["MatchedAccountCode"] : <any>null;
            this.meal = _data["Meal"] ? FlightMeal.fromJS(_data["Meal"]) : <any>null;
            this.baggageDetails = _data["BaggageDetails"] ? FlightBaggageDetails.fromJS(_data["BaggageDetails"]) : <any>null;
            this.brandedFare = _data["BrandedFare"] !== undefined ? _data["BrandedFare"] : <any>null;
            this.brandedFareCode = _data["BrandedFareCode"] !== undefined ? _data["BrandedFareCode"] : <any>null;
            this.fareDescription = _data["FareDescription"] !== undefined ? _data["FareDescription"] : <any>null;
            this.hostToken = _data["HostToken"] !== undefined ? _data["HostToken"] : <any>null;
            this.providerCode = _data["ProviderCode"] !== undefined ? _data["ProviderCode"] : <any>null;
        }
    }

    static fromJS(data: any): FareSegmentDetail {
        data = typeof data === 'object' ? data : {};
        let result = new FareSegmentDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FlightSegmentRefId"] = this.flightSegmentRefId !== undefined ? this.flightSegmentRefId : <any>null;
        data["FareType"] = this.fareType !== undefined ? this.fareType : <any>null;
        data["FareTypeCode"] = this.fareTypeCode !== undefined ? this.fareTypeCode : <any>null;
        data["Cabin"] = this.cabin !== undefined ? this.cabin : <any>null;
        data["CabinCode"] = this.cabinCode !== undefined ? this.cabinCode : <any>null;
        data["Class"] = this.class !== undefined ? this.class : <any>null;
        data["ClassAvail"] = this.classAvail !== undefined ? this.classAvail : <any>null;
        data["FareBasis"] = this.fareBasis !== undefined ? this.fareBasis : <any>null;
        data["MatchedAccountCode"] = this.matchedAccountCode !== undefined ? this.matchedAccountCode : <any>null;
        data["Meal"] = this.meal ? this.meal.toJSON() : <any>null;
        data["BaggageDetails"] = this.baggageDetails ? this.baggageDetails.toJSON() : <any>null;
        data["BrandedFare"] = this.brandedFare !== undefined ? this.brandedFare : <any>null;
        data["BrandedFareCode"] = this.brandedFareCode !== undefined ? this.brandedFareCode : <any>null;
        data["FareDescription"] = this.fareDescription !== undefined ? this.fareDescription : <any>null;
        data["HostToken"] = this.hostToken !== undefined ? this.hostToken : <any>null;
        data["ProviderCode"] = this.providerCode !== undefined ? this.providerCode : <any>null;
        return data;
    }
}

export interface IFareSegmentDetail {
    flightSegmentRefId?: string | null;
    fareType?: EFareType | null;
    fareTypeCode?: string | null;
    cabin?: EFlightCabin | null;
    cabinCode?: string | null;
    class?: string | null;
    classAvail?: string | null;
    fareBasis?: string | null;
    matchedAccountCode?: string | null;
    meal?: FlightMeal | null;
    baggageDetails?: FlightBaggageDetails | null;
    brandedFare?: string | null;
    brandedFareCode?: string | null;
    fareDescription?: string | null;
    hostToken?: string | null;
    providerCode?: string | null;
}

export enum EFareType {
    PUBLIC = "PUBLIC",
    PRIVATE = "PRIVATE",
    TO = "TO",
}

export class FlightMeal implements IFlightMeal {
    code?: string | null;
    text?: string | null;

    constructor(data?: IFlightMeal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"] !== undefined ? _data["Code"] : <any>null;
            this.text = _data["Text"] !== undefined ? _data["Text"] : <any>null;
        }
    }

    static fromJS(data: any): FlightMeal {
        data = typeof data === 'object' ? data : {};
        let result = new FlightMeal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code !== undefined ? this.code : <any>null;
        data["Text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface IFlightMeal {
    code?: string | null;
    text?: string | null;
}

export class FlightBaggageDetails implements IFlightBaggageDetails {
    baggageCount?: number | null;
    code?: string | null;
    text?: string | null;
    baggageTypeDetails?: BaggageTypeDetail[] | null;

    constructor(data?: IFlightBaggageDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baggageCount = _data["BaggageCount"] !== undefined ? _data["BaggageCount"] : <any>null;
            this.code = _data["Code"] !== undefined ? _data["Code"] : <any>null;
            this.text = _data["Text"] !== undefined ? _data["Text"] : <any>null;
            if (Array.isArray(_data["BaggageTypeDetails"])) {
                this.baggageTypeDetails = [] as any;
                for (let item of _data["BaggageTypeDetails"])
                    this.baggageTypeDetails!.push(BaggageTypeDetail.fromJS(item));
            }
            else {
                this.baggageTypeDetails = <any>null;
            }
        }
    }

    static fromJS(data: any): FlightBaggageDetails {
        data = typeof data === 'object' ? data : {};
        let result = new FlightBaggageDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BaggageCount"] = this.baggageCount !== undefined ? this.baggageCount : <any>null;
        data["Code"] = this.code !== undefined ? this.code : <any>null;
        data["Text"] = this.text !== undefined ? this.text : <any>null;
        if (Array.isArray(this.baggageTypeDetails)) {
            data["BaggageTypeDetails"] = [];
            for (let item of this.baggageTypeDetails)
                data["BaggageTypeDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlightBaggageDetails {
    baggageCount?: number | null;
    code?: string | null;
    text?: string | null;
    baggageTypeDetails?: BaggageTypeDetail[] | null;
}

export class BaggageTypeDetail implements IBaggageTypeDetail {
    count?: number | null;
    type?: EBaggageType | null;
    code?: string | null;
    text?: string | null;
    descriptions?: string[] | null;

    constructor(data?: IBaggageTypeDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"] !== undefined ? _data["Count"] : <any>null;
            this.type = _data["Type"] !== undefined ? _data["Type"] : <any>null;
            this.code = _data["Code"] !== undefined ? _data["Code"] : <any>null;
            this.text = _data["Text"] !== undefined ? _data["Text"] : <any>null;
            if (Array.isArray(_data["Descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["Descriptions"])
                    this.descriptions!.push(item);
            }
            else {
                this.descriptions = <any>null;
            }
        }
    }

    static fromJS(data: any): BaggageTypeDetail {
        data = typeof data === 'object' ? data : {};
        let result = new BaggageTypeDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count !== undefined ? this.count : <any>null;
        data["Type"] = this.type !== undefined ? this.type : <any>null;
        data["Code"] = this.code !== undefined ? this.code : <any>null;
        data["Text"] = this.text !== undefined ? this.text : <any>null;
        if (Array.isArray(this.descriptions)) {
            data["Descriptions"] = [];
            for (let item of this.descriptions)
                data["Descriptions"].push(item);
        }
        return data;
    }
}

export interface IBaggageTypeDetail {
    count?: number | null;
    type?: EBaggageType | null;
    code?: string | null;
    text?: string | null;
    descriptions?: string[] | null;
}

export enum EBaggageType {
    CARRY_ON = "CARRY_ON",
    CHECKED = "CHECKED",
    SPECIAL = "SPECIAL",
}

export class FarePenalties implements IFarePenalties {
    exchangeBefore?: FarePenalty | null;
    exchangeAfter?: FarePenalty | null;
    refundBefore?: FarePenalty | null;
    refundAfter?: FarePenalty | null;

    constructor(data?: IFarePenalties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exchangeBefore = _data["ExchangeBefore"] ? FarePenalty.fromJS(_data["ExchangeBefore"]) : <any>null;
            this.exchangeAfter = _data["ExchangeAfter"] ? FarePenalty.fromJS(_data["ExchangeAfter"]) : <any>null;
            this.refundBefore = _data["RefundBefore"] ? FarePenalty.fromJS(_data["RefundBefore"]) : <any>null;
            this.refundAfter = _data["RefundAfter"] ? FarePenalty.fromJS(_data["RefundAfter"]) : <any>null;
        }
    }

    static fromJS(data: any): FarePenalties {
        data = typeof data === 'object' ? data : {};
        let result = new FarePenalties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExchangeBefore"] = this.exchangeBefore ? this.exchangeBefore.toJSON() : <any>null;
        data["ExchangeAfter"] = this.exchangeAfter ? this.exchangeAfter.toJSON() : <any>null;
        data["RefundBefore"] = this.refundBefore ? this.refundBefore.toJSON() : <any>null;
        data["RefundAfter"] = this.refundAfter ? this.refundAfter.toJSON() : <any>null;
        return data;
    }
}

export interface IFarePenalties {
    exchangeBefore?: FarePenalty | null;
    exchangeAfter?: FarePenalty | null;
    refundBefore?: FarePenalty | null;
    refundAfter?: FarePenalty | null;
}

export class FarePenalty implements IFarePenalty {
    isApplicable?: boolean | null;
    penaltyConditions?: string[] | null;
    penaltyAmount?: CurrencyAmount | null;
    penaltyAmountNoShow?: CurrencyAmount | null;

    constructor(data?: IFarePenalty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isApplicable = _data["IsApplicable"] !== undefined ? _data["IsApplicable"] : <any>null;
            if (Array.isArray(_data["PenaltyConditions"])) {
                this.penaltyConditions = [] as any;
                for (let item of _data["PenaltyConditions"])
                    this.penaltyConditions!.push(item);
            }
            else {
                this.penaltyConditions = <any>null;
            }
            this.penaltyAmount = _data["PenaltyAmount"] ? CurrencyAmount.fromJS(_data["PenaltyAmount"]) : <any>null;
            this.penaltyAmountNoShow = _data["PenaltyAmountNoShow"] ? CurrencyAmount.fromJS(_data["PenaltyAmountNoShow"]) : <any>null;
        }
    }

    static fromJS(data: any): FarePenalty {
        data = typeof data === 'object' ? data : {};
        let result = new FarePenalty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsApplicable"] = this.isApplicable !== undefined ? this.isApplicable : <any>null;
        if (Array.isArray(this.penaltyConditions)) {
            data["PenaltyConditions"] = [];
            for (let item of this.penaltyConditions)
                data["PenaltyConditions"].push(item);
        }
        data["PenaltyAmount"] = this.penaltyAmount ? this.penaltyAmount.toJSON() : <any>null;
        data["PenaltyAmountNoShow"] = this.penaltyAmountNoShow ? this.penaltyAmountNoShow.toJSON() : <any>null;
        return data;
    }
}

export interface IFarePenalty {
    isApplicable?: boolean | null;
    penaltyConditions?: string[] | null;
    penaltyAmount?: CurrencyAmount | null;
    penaltyAmountNoShow?: CurrencyAmount | null;
}

export class Total extends CurrencyAmount implements ITotal {
    amountWithoutTax?: number | null;
    taxes?: Taxes | null;

    constructor(data?: ITotal) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amountWithoutTax = _data["AmountWithoutTax"] !== undefined ? _data["AmountWithoutTax"] : <any>null;
            this.taxes = _data["Taxes"] ? Taxes.fromJS(_data["Taxes"]) : <any>null;
        }
    }

    static fromJS(data: any): Total {
        data = typeof data === 'object' ? data : {};
        let result = new Total();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AmountWithoutTax"] = this.amountWithoutTax !== undefined ? this.amountWithoutTax : <any>null;
        data["Taxes"] = this.taxes ? this.taxes.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITotal extends ICurrencyAmount {
    amountWithoutTax?: number | null;
    taxes?: Taxes | null;
}

export class Taxes extends CurrencyAmount implements ITaxes {
    taxList?: Tax[] | null;

    constructor(data?: ITaxes) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["TaxList"])) {
                this.taxList = [] as any;
                for (let item of _data["TaxList"])
                    this.taxList!.push(Tax.fromJS(item));
            }
            else {
                this.taxList = <any>null;
            }
        }
    }

    static fromJS(data: any): Taxes {
        data = typeof data === 'object' ? data : {};
        let result = new Taxes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taxList)) {
            data["TaxList"] = [];
            for (let item of this.taxList)
                data["TaxList"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITaxes extends ICurrencyAmount {
    taxList?: Tax[] | null;
}

export class Tax extends CurrencyAmount implements ITax {
    code?: string | null;
    name?: string | null;
    description?: string | null;

    constructor(data?: ITax) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["Code"] !== undefined ? _data["Code"] : <any>null;
            this.name = _data["Name"] !== undefined ? _data["Name"] : <any>null;
            this.description = _data["Description"] !== undefined ? _data["Description"] : <any>null;
        }
    }

    static fromJS(data: any): Tax {
        data = typeof data === 'object' ? data : {};
        let result = new Tax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code !== undefined ? this.code : <any>null;
        data["Name"] = this.name !== undefined ? this.name : <any>null;
        data["Description"] = this.description !== undefined ? this.description : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITax extends ICurrencyAmount {
    code?: string | null;
    name?: string | null;
    description?: string | null;
}

export abstract class FlightPaxFareCustomData implements IFlightPaxFareCustomData {

    protected _discriminator: string;

    constructor(data?: IFlightPaxFareCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FlightPaxFareCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FlightPaxFareCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusFlightPaxFareCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FlightPaxFareCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IFlightPaxFareCustomData {
}

export class AmadeusFlightPaxFareCustomData extends FlightPaxFareCustomData implements IAmadeusFlightPaxFareCustomData {
    pnrFlightPaxFareId?: string | null;
    paxType?: EPaxType | null;
    shoppingResponseId?: string | null;
    offerId?: string | null;
    offerItemId?: string | null;
    dateAndTimeNdcLimits?: DateTimeNdcLimit[] | null;
    creationDate?: string | null;
    lastModificationDate?: string | null;
    tstIndicator?: string | null;
    orderId?: string | null;
    orderItemId?: string | null;
    ownerCode?: string | null;
    ownerItemCode?: string | null;

    constructor(data?: IAmadeusFlightPaxFareCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pnrFlightPaxFareId = _data["PnrFlightPaxFareId"] !== undefined ? _data["PnrFlightPaxFareId"] : <any>null;
            this.paxType = _data["PaxType"] !== undefined ? _data["PaxType"] : <any>null;
            this.shoppingResponseId = _data["ShoppingResponseId"] !== undefined ? _data["ShoppingResponseId"] : <any>null;
            this.offerId = _data["OfferId"] !== undefined ? _data["OfferId"] : <any>null;
            this.offerItemId = _data["OfferItemId"] !== undefined ? _data["OfferItemId"] : <any>null;
            if (Array.isArray(_data["DateAndTimeNdcLimits"])) {
                this.dateAndTimeNdcLimits = [] as any;
                for (let item of _data["DateAndTimeNdcLimits"])
                    this.dateAndTimeNdcLimits!.push(DateTimeNdcLimit.fromJS(item));
            }
            else {
                this.dateAndTimeNdcLimits = <any>null;
            }
            this.creationDate = _data["CreationDate"] !== undefined ? _data["CreationDate"] : <any>null;
            this.lastModificationDate = _data["LastModificationDate"] !== undefined ? _data["LastModificationDate"] : <any>null;
            this.tstIndicator = _data["TstIndicator"] !== undefined ? _data["TstIndicator"] : <any>null;
            this.orderId = _data["OrderId"] !== undefined ? _data["OrderId"] : <any>null;
            this.orderItemId = _data["OrderItemId"] !== undefined ? _data["OrderItemId"] : <any>null;
            this.ownerCode = _data["OwnerCode"] !== undefined ? _data["OwnerCode"] : <any>null;
            this.ownerItemCode = _data["OwnerItemCode"] !== undefined ? _data["OwnerItemCode"] : <any>null;
        }
    }

    static fromJS(data: any): AmadeusFlightPaxFareCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightPaxFareCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PnrFlightPaxFareId"] = this.pnrFlightPaxFareId !== undefined ? this.pnrFlightPaxFareId : <any>null;
        data["PaxType"] = this.paxType !== undefined ? this.paxType : <any>null;
        data["ShoppingResponseId"] = this.shoppingResponseId !== undefined ? this.shoppingResponseId : <any>null;
        data["OfferId"] = this.offerId !== undefined ? this.offerId : <any>null;
        data["OfferItemId"] = this.offerItemId !== undefined ? this.offerItemId : <any>null;
        if (Array.isArray(this.dateAndTimeNdcLimits)) {
            data["DateAndTimeNdcLimits"] = [];
            for (let item of this.dateAndTimeNdcLimits)
                data["DateAndTimeNdcLimits"].push(item.toJSON());
        }
        data["CreationDate"] = this.creationDate !== undefined ? this.creationDate : <any>null;
        data["LastModificationDate"] = this.lastModificationDate !== undefined ? this.lastModificationDate : <any>null;
        data["TstIndicator"] = this.tstIndicator !== undefined ? this.tstIndicator : <any>null;
        data["OrderId"] = this.orderId !== undefined ? this.orderId : <any>null;
        data["OrderItemId"] = this.orderItemId !== undefined ? this.orderItemId : <any>null;
        data["OwnerCode"] = this.ownerCode !== undefined ? this.ownerCode : <any>null;
        data["OwnerItemCode"] = this.ownerItemCode !== undefined ? this.ownerItemCode : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusFlightPaxFareCustomData extends IFlightPaxFareCustomData {
    pnrFlightPaxFareId?: string | null;
    paxType?: EPaxType | null;
    shoppingResponseId?: string | null;
    offerId?: string | null;
    offerItemId?: string | null;
    dateAndTimeNdcLimits?: DateTimeNdcLimit[] | null;
    creationDate?: string | null;
    lastModificationDate?: string | null;
    tstIndicator?: string | null;
    orderId?: string | null;
    orderItemId?: string | null;
    ownerCode?: string | null;
    ownerItemCode?: string | null;
}

export class DateTimeNdcLimit implements IDateTimeNdcLimit {
    code?: string | null;
    expirationDateTimeUtc?: string | null;

    constructor(data?: IDateTimeNdcLimit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"] !== undefined ? _data["Code"] : <any>null;
            this.expirationDateTimeUtc = _data["ExpirationDateTimeUtc"] !== undefined ? _data["ExpirationDateTimeUtc"] : <any>null;
        }
    }

    static fromJS(data: any): DateTimeNdcLimit {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeNdcLimit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code !== undefined ? this.code : <any>null;
        data["ExpirationDateTimeUtc"] = this.expirationDateTimeUtc !== undefined ? this.expirationDateTimeUtc : <any>null;
        return data;
    }
}

export interface IDateTimeNdcLimit {
    code?: string | null;
    expirationDateTimeUtc?: string | null;
}

export abstract class CustomerCustomDataOfFlightPaxFare implements ICustomerCustomDataOfFlightPaxFare {

    protected _discriminator: string;

    constructor(data?: ICustomerCustomDataOfFlightPaxFare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "CustomerCustomDataOfFlightPaxFare";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CustomerCustomDataOfFlightPaxFare {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataCode"] === "FlightPnrFlightPaxFareNaarData") {
            let result = new FlightPnrFlightPaxFareNaarData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'CustomerCustomDataOfFlightPaxFare' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataCode"] = this._discriminator;
        return data;
    }
}

export interface ICustomerCustomDataOfFlightPaxFare {
}

export class FlightPnrFlightPaxFareNaarData extends CustomerCustomDataOfFlightPaxFare implements IFlightPnrFlightPaxFareNaarData {
    isToFare?: boolean | null;
    totalAmountWithoutTaxWithMarkup?: CurrencyAmount | null;
    totalAmountWithMarkup?: CurrencyAmount | null;
    totalTaxWithMarkup?: CurrencyAmount | null;
    perPaxAmountWithMarkup?: CurrencyAmount | null;

    constructor(data?: IFlightPnrFlightPaxFareNaarData) {
        super(data);
        this._discriminator = "FlightPnrFlightPaxFareNaarData";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isToFare = _data["isToFare"] !== undefined ? _data["isToFare"] : <any>null;
            this.totalAmountWithoutTaxWithMarkup = _data["TotalAmountWithoutTaxWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalAmountWithoutTaxWithMarkup"]) : <any>null;
            this.totalAmountWithMarkup = _data["TotalAmountWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalAmountWithMarkup"]) : <any>null;
            this.totalTaxWithMarkup = _data["TotalTaxWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalTaxWithMarkup"]) : <any>null;
            this.perPaxAmountWithMarkup = _data["PerPaxAmountWithMarkup"] ? CurrencyAmount.fromJS(_data["PerPaxAmountWithMarkup"]) : <any>null;
        }
    }

    static fromJS(data: any): FlightPnrFlightPaxFareNaarData {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPnrFlightPaxFareNaarData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isToFare"] = this.isToFare !== undefined ? this.isToFare : <any>null;
        data["TotalAmountWithoutTaxWithMarkup"] = this.totalAmountWithoutTaxWithMarkup ? this.totalAmountWithoutTaxWithMarkup.toJSON() : <any>null;
        data["TotalAmountWithMarkup"] = this.totalAmountWithMarkup ? this.totalAmountWithMarkup.toJSON() : <any>null;
        data["TotalTaxWithMarkup"] = this.totalTaxWithMarkup ? this.totalTaxWithMarkup.toJSON() : <any>null;
        data["PerPaxAmountWithMarkup"] = this.perPaxAmountWithMarkup ? this.perPaxAmountWithMarkup.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightPnrFlightPaxFareNaarData extends ICustomerCustomDataOfFlightPaxFare {
    isToFare?: boolean | null;
    totalAmountWithoutTaxWithMarkup?: CurrencyAmount | null;
    totalAmountWithMarkup?: CurrencyAmount | null;
    totalTaxWithMarkup?: CurrencyAmount | null;
    perPaxAmountWithMarkup?: CurrencyAmount | null;
}

export abstract class FlightAvailabilityOutputCustomData implements IFlightAvailabilityOutputCustomData {

    protected _discriminator: string;

    constructor(data?: IFlightAvailabilityOutputCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FlightAvailabilityOutputCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FlightAvailabilityOutputCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusFlightAvailabilityOutputCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FlightAvailabilityOutputCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IFlightAvailabilityOutputCustomData {
}

export class AmadeusFlightAvailabilityOutputCustomData extends FlightAvailabilityOutputCustomData implements IAmadeusFlightAvailabilityOutputCustomData {
    amadeusSession?: AmadeusGdsSessionCustomData | null;

    constructor(data?: IAmadeusFlightAvailabilityOutputCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amadeusSession = _data["AmadeusSession"] ? AmadeusGdsSessionCustomData.fromJS(_data["AmadeusSession"]) : <any>null;
        }
    }

    static fromJS(data: any): AmadeusFlightAvailabilityOutputCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightAvailabilityOutputCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AmadeusSession"] = this.amadeusSession ? this.amadeusSession.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusFlightAvailabilityOutputCustomData extends IFlightAvailabilityOutputCustomData {
    amadeusSession?: AmadeusGdsSessionCustomData | null;
}

export class CacheResponseInfo implements ICacheResponseInfo {
    isCachedResponse?: boolean | null;
    cachedItemKey?: string | null;
    cachedDateTimeUtc?: string | null;
    expirationTimeSpan?: string | null;

    constructor(data?: ICacheResponseInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCachedResponse = _data["IsCachedResponse"] !== undefined ? _data["IsCachedResponse"] : <any>null;
            this.cachedItemKey = _data["CachedItemKey"] !== undefined ? _data["CachedItemKey"] : <any>null;
            this.cachedDateTimeUtc = _data["CachedDateTimeUtc"] !== undefined ? _data["CachedDateTimeUtc"] : <any>null;
            this.expirationTimeSpan = _data["ExpirationTimeSpan"] !== undefined ? _data["ExpirationTimeSpan"] : <any>null;
        }
    }

    static fromJS(data: any): CacheResponseInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CacheResponseInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsCachedResponse"] = this.isCachedResponse !== undefined ? this.isCachedResponse : <any>null;
        data["CachedItemKey"] = this.cachedItemKey !== undefined ? this.cachedItemKey : <any>null;
        data["CachedDateTimeUtc"] = this.cachedDateTimeUtc !== undefined ? this.cachedDateTimeUtc : <any>null;
        data["ExpirationTimeSpan"] = this.expirationTimeSpan !== undefined ? this.expirationTimeSpan : <any>null;
        return data;
    }
}

export interface ICacheResponseInfo {
    isCachedResponse?: boolean | null;
    cachedItemKey?: string | null;
    cachedDateTimeUtc?: string | null;
    expirationTimeSpan?: string | null;
}

export enum EOperationStatus {
    SUCCESS = "SUCCESS",
    WARNING = "WARNING",
    ERROR = "ERROR",
}

export class Message implements IMessage {
    connectorCode?: EH2HConnectorCode | null;
    type?: EMessageType | null;
    code?: EMessageCode | null;
    text?: string | null;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : <any>null;
            this.type = _data["Type"] !== undefined ? _data["Type"] : <any>null;
            this.code = _data["Code"] !== undefined ? _data["Code"] : <any>null;
            this.text = _data["Text"] !== undefined ? _data["Text"] : <any>null;
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : <any>null;
        data["Type"] = this.type !== undefined ? this.type : <any>null;
        data["Code"] = this.code !== undefined ? this.code : <any>null;
        data["Text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface IMessage {
    connectorCode?: EH2HConnectorCode | null;
    type?: EMessageType | null;
    code?: EMessageCode | null;
    text?: string | null;
}

export enum EMessageType {
    INFO = "INFO",
    WARNING = "WARNING",
    ERROR = "ERROR",
}

export enum EMessageCode {
    UNKNOWN = "UNKNOWN",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    NOT_ENABLED_CONNECTOR = "NOT_ENABLED_CONNECTOR",
    NOT_ENABLED_OPERATION = "NOT_ENABLED_OPERATION",
    CONNECTOR_ERROR = "CONNECTOR_ERROR",
    NO_AVAIL = "NO_AVAIL",
    NO_FARE_OR_RATE = "NO_FARE_OR_RATE",
    WRONG_CC = "WRONG_CC",
    IMPOSSIBLE_TO_CANCEL = "IMPOSSIBLE_TO_CANCEL",
    BOOK_NOT_FOUND = "BOOK_NOT_FOUND",
    WRONG_INPUTS = "WRONG_INPUTS",
    PRICE_CHANGED = "PRICE_CHANGED",
    NO_RESULTS = "NO_RESULTS",
    FULL_RESPONSE = "FULL_RESPONSE",
    CACHE_EXPIRED = "CACHE_EXPIRED",
}

export class ConnectorResponseDetails implements IConnectorResponseDetails {
    connectorCode?: EH2HConnectorCode | null;
    environment?: string | null;
    status?: EH2HOperationStatus | null;
    executionTime?: number | null;
    messages?: Message[] | null;
    messageCodes?: EMessageCode[] | null;
    connectorDebugData?: ConnectorDebugData | null;

    constructor(data?: IConnectorResponseDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : <any>null;
            this.environment = _data["Environment"] !== undefined ? _data["Environment"] : <any>null;
            this.status = _data["Status"] !== undefined ? _data["Status"] : <any>null;
            this.executionTime = _data["ExecutionTime"] !== undefined ? _data["ExecutionTime"] : <any>null;
            if (Array.isArray(_data["Messages"])) {
                this.messages = [] as any;
                for (let item of _data["Messages"])
                    this.messages!.push(Message.fromJS(item));
            }
            else {
                this.messages = <any>null;
            }
            if (Array.isArray(_data["MessageCodes"])) {
                this.messageCodes = [] as any;
                for (let item of _data["MessageCodes"])
                    this.messageCodes!.push(item);
            }
            else {
                this.messageCodes = <any>null;
            }
            this.connectorDebugData = _data["ConnectorDebugData"] ? ConnectorDebugData.fromJS(_data["ConnectorDebugData"]) : <any>null;
        }
    }

    static fromJS(data: any): ConnectorResponseDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectorResponseDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : <any>null;
        data["Environment"] = this.environment !== undefined ? this.environment : <any>null;
        data["Status"] = this.status !== undefined ? this.status : <any>null;
        data["ExecutionTime"] = this.executionTime !== undefined ? this.executionTime : <any>null;
        if (Array.isArray(this.messages)) {
            data["Messages"] = [];
            for (let item of this.messages)
                data["Messages"].push(item.toJSON());
        }
        if (Array.isArray(this.messageCodes)) {
            data["MessageCodes"] = [];
            for (let item of this.messageCodes)
                data["MessageCodes"].push(item);
        }
        data["ConnectorDebugData"] = this.connectorDebugData ? this.connectorDebugData.toJSON() : <any>null;
        return data;
    }
}

export interface IConnectorResponseDetails {
    connectorCode?: EH2HConnectorCode | null;
    environment?: string | null;
    status?: EH2HOperationStatus | null;
    executionTime?: number | null;
    messages?: Message[] | null;
    messageCodes?: EMessageCode[] | null;
    connectorDebugData?: ConnectorDebugData | null;
}

export enum EH2HOperationStatus {
    START = "START",
    PENDING = "PENDING",
    SUCCESS = "SUCCESS",
    WARNING = "WARNING",
    ERROR = "ERROR",
}

export class ConnectorDebugData implements IConnectorDebugData {
    request?: string | null;
    response?: string | null;

    constructor(data?: IConnectorDebugData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["Request"] !== undefined ? _data["Request"] : <any>null;
            this.response = _data["Response"] !== undefined ? _data["Response"] : <any>null;
        }
    }

    static fromJS(data: any): ConnectorDebugData {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectorDebugData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Request"] = this.request !== undefined ? this.request : <any>null;
        data["Response"] = this.response !== undefined ? this.response : <any>null;
        return data;
    }
}

export interface IConnectorDebugData {
    request?: string | null;
    response?: string | null;
}

export class JupiterCrypticRS extends BaseRS implements IJupiterCrypticRS {
    response?: JupiterCrypticOutput | null;

    constructor(data?: IJupiterCrypticRS) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["Response"] ? JupiterCrypticOutput.fromJS(_data["Response"]) : <any>null;
        }
    }

    static fromJS(data: any): JupiterCrypticRS {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterCrypticRS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Response"] = this.response ? this.response.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterCrypticRS extends IBaseRS {
    response?: JupiterCrypticOutput | null;
}

export abstract class BaseJupiterSessionOutput extends BaseOutput implements IBaseJupiterSessionOutput {
    connectorCode?: EH2HConnectorCode | null;
    sessionConnectorCustomData?: GdsSessionCustomData | null;

    constructor(data?: IBaseJupiterSessionOutput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : <any>null;
            this.sessionConnectorCustomData = _data["SessionConnectorCustomData"] ? GdsSessionCustomData.fromJS(_data["SessionConnectorCustomData"]) : <any>null;
        }
    }

    static fromJS(data: any): BaseJupiterSessionOutput {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseJupiterSessionOutput' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : <any>null;
        data["SessionConnectorCustomData"] = this.sessionConnectorCustomData ? this.sessionConnectorCustomData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseJupiterSessionOutput extends IBaseOutput {
    connectorCode?: EH2HConnectorCode | null;
    sessionConnectorCustomData?: GdsSessionCustomData | null;
}

export class JupiterCrypticOutput extends BaseJupiterSessionOutput implements IJupiterCrypticOutput {
    crypticResponse?: string | null;

    constructor(data?: IJupiterCrypticOutput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.crypticResponse = _data["CrypticResponse"] !== undefined ? _data["CrypticResponse"] : <any>null;
        }
    }

    static fromJS(data: any): JupiterCrypticOutput {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterCrypticOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CrypticResponse"] = this.crypticResponse !== undefined ? this.crypticResponse : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterCrypticOutput extends IBaseJupiterSessionOutput {
    crypticResponse?: string | null;
}

export class JupiterCrypticRQ extends BaseRQ implements IJupiterCrypticRQ {
    request?: JupiterCrypticInput | null;

    constructor(data?: IJupiterCrypticRQ) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.request = _data["Request"] ? JupiterCrypticInput.fromJS(_data["Request"]) : <any>null;
        }
    }

    static fromJS(data: any): JupiterCrypticRQ {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterCrypticRQ();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Request"] = this.request ? this.request.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterCrypticRQ extends IBaseRQ {
    request?: JupiterCrypticInput | null;
}

export abstract class BaseJupiterSessionInput extends BaseInput implements IBaseJupiterSessionInput {
    connectorCode?: EH2HConnectorCode | null;
    sessionConnectorCustomData?: GdsSessionCustomData | null;

    constructor(data?: IBaseJupiterSessionInput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : <any>null;
            this.sessionConnectorCustomData = _data["SessionConnectorCustomData"] ? GdsSessionCustomData.fromJS(_data["SessionConnectorCustomData"]) : <any>null;
        }
    }

    static fromJS(data: any): BaseJupiterSessionInput {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseJupiterSessionInput' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : <any>null;
        data["SessionConnectorCustomData"] = this.sessionConnectorCustomData ? this.sessionConnectorCustomData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseJupiterSessionInput extends IBaseInput {
    connectorCode?: EH2HConnectorCode | null;
    sessionConnectorCustomData?: GdsSessionCustomData | null;
}

export class JupiterCrypticInput extends BaseJupiterSessionInput implements IJupiterCrypticInput {
    crypticRequest?: string | null;

    constructor(data?: IJupiterCrypticInput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.crypticRequest = _data["CrypticRequest"] !== undefined ? _data["CrypticRequest"] : <any>null;
        }
    }

    static fromJS(data: any): JupiterCrypticInput {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterCrypticInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CrypticRequest"] = this.crypticRequest !== undefined ? this.crypticRequest : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterCrypticInput extends IBaseJupiterSessionInput {
    crypticRequest?: string | null;
}

export class JupiterFlightPnrRetrieveRS extends BaseRS implements IJupiterFlightPnrRetrieveRS {
    response?: JupiterFlightPnrRetrieveOutput | null;

    constructor(data?: IJupiterFlightPnrRetrieveRS) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["Response"] ? JupiterFlightPnrRetrieveOutput.fromJS(_data["Response"]) : <any>null;
        }
    }

    static fromJS(data: any): JupiterFlightPnrRetrieveRS {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightPnrRetrieveRS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Response"] = this.response ? this.response.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightPnrRetrieveRS extends IBaseRS {
    response?: JupiterFlightPnrRetrieveOutput | null;
}

export class JupiterFlightPnrRetrieveOutput extends BaseOutput implements IJupiterFlightPnrRetrieveOutput {
    pnr?: BaseOperationPnr | null;

    constructor(data?: IJupiterFlightPnrRetrieveOutput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pnr = _data["Pnr"] ? BaseOperationPnr.fromJS(_data["Pnr"]) : <any>null;
        }
    }

    static fromJS(data: any): JupiterFlightPnrRetrieveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightPnrRetrieveOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Pnr"] = this.pnr ? this.pnr.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightPnrRetrieveOutput extends IBaseOutput {
    pnr?: BaseOperationPnr | null;
}

export class BaseOperationPnr implements IBaseOperationPnr {
    fullReferenceId?: string | null;
    resultKey?: string | null;
    routingKey?: string | null;
    isPure?: boolean | null;
    codeShareKey?: string | null;
    connectorCode!: EH2HConnectorCode;
    closePnr?: boolean | null;
    bookingStatus?: EBookingStatus | null;
    pnrNumber?: string | null;
    pseudoCityCode?: string | null;
    pnrDate?: string | null;
    cancelDate?: string | null;
    lastTicketDate?: string | null;
    flightSegments?: PnrFlightSegment[] | null;
    fare?: PnrFlightFare | null;
    alternativeFares?: PnrFlightFare[] | null;
    ancillaries?: PnrBookedFlightAncillary[] | null;
    additionalAncillaries?: PnrFlightAdditionalAncillary[] | null;
    paxes?: PnrPaxDetails[] | null;
    creditCardPayment?: CreditCardInfo | null;
    travelCompany?: PnrTravelCompany | null;
    remarks?: PnrRemarks[] | null;
    osiSsr?: PnrOsiSsr[] | null;
    cO2Emissions?: CO2Emissions | null;
    connectorCustomData?: PnrCustomData | null;

    constructor(data?: IBaseOperationPnr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullReferenceId = _data["FullReferenceId"] !== undefined ? _data["FullReferenceId"] : <any>null;
            this.resultKey = _data["ResultKey"] !== undefined ? _data["ResultKey"] : <any>null;
            this.routingKey = _data["RoutingKey"] !== undefined ? _data["RoutingKey"] : <any>null;
            this.isPure = _data["IsPure"] !== undefined ? _data["IsPure"] : <any>null;
            this.codeShareKey = _data["CodeShareKey"] !== undefined ? _data["CodeShareKey"] : <any>null;
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : <any>null;
            this.closePnr = _data["ClosePnr"] !== undefined ? _data["ClosePnr"] : <any>null;
            this.bookingStatus = _data["BookingStatus"] !== undefined ? _data["BookingStatus"] : <any>null;
            this.pnrNumber = _data["PnrNumber"] !== undefined ? _data["PnrNumber"] : <any>null;
            this.pseudoCityCode = _data["PseudoCityCode"] !== undefined ? _data["PseudoCityCode"] : <any>null;
            this.pnrDate = _data["PnrDate"] !== undefined ? _data["PnrDate"] : <any>null;
            this.cancelDate = _data["CancelDate"] !== undefined ? _data["CancelDate"] : <any>null;
            this.lastTicketDate = _data["LastTicketDate"] !== undefined ? _data["LastTicketDate"] : <any>null;
            if (Array.isArray(_data["FlightSegments"])) {
                this.flightSegments = [] as any;
                for (let item of _data["FlightSegments"])
                    this.flightSegments!.push(PnrFlightSegment.fromJS(item));
            }
            else {
                this.flightSegments = <any>null;
            }
            this.fare = _data["Fare"] ? PnrFlightFare.fromJS(_data["Fare"]) : <any>null;
            if (Array.isArray(_data["AlternativeFares"])) {
                this.alternativeFares = [] as any;
                for (let item of _data["AlternativeFares"])
                    this.alternativeFares!.push(PnrFlightFare.fromJS(item));
            }
            else {
                this.alternativeFares = <any>null;
            }
            if (Array.isArray(_data["Ancillaries"])) {
                this.ancillaries = [] as any;
                for (let item of _data["Ancillaries"])
                    this.ancillaries!.push(PnrBookedFlightAncillary.fromJS(item));
            }
            else {
                this.ancillaries = <any>null;
            }
            if (Array.isArray(_data["AdditionalAncillaries"])) {
                this.additionalAncillaries = [] as any;
                for (let item of _data["AdditionalAncillaries"])
                    this.additionalAncillaries!.push(PnrFlightAdditionalAncillary.fromJS(item));
            }
            else {
                this.additionalAncillaries = <any>null;
            }
            if (Array.isArray(_data["Paxes"])) {
                this.paxes = [] as any;
                for (let item of _data["Paxes"])
                    this.paxes!.push(PnrPaxDetails.fromJS(item));
            }
            else {
                this.paxes = <any>null;
            }
            this.creditCardPayment = _data["CreditCardPayment"] ? CreditCardInfo.fromJS(_data["CreditCardPayment"]) : <any>null;
            this.travelCompany = _data["TravelCompany"] ? PnrTravelCompany.fromJS(_data["TravelCompany"]) : <any>null;
            if (Array.isArray(_data["Remarks"])) {
                this.remarks = [] as any;
                for (let item of _data["Remarks"])
                    this.remarks!.push(PnrRemarks.fromJS(item));
            }
            else {
                this.remarks = <any>null;
            }
            if (Array.isArray(_data["OsiSsr"])) {
                this.osiSsr = [] as any;
                for (let item of _data["OsiSsr"])
                    this.osiSsr!.push(PnrOsiSsr.fromJS(item));
            }
            else {
                this.osiSsr = <any>null;
            }
            this.cO2Emissions = _data["CO2Emissions"] ? CO2Emissions.fromJS(_data["CO2Emissions"]) : <any>null;
            this.connectorCustomData = _data["ConnectorCustomData"] ? PnrCustomData.fromJS(_data["ConnectorCustomData"]) : <any>null;
        }
    }

    static fromJS(data: any): BaseOperationPnr {
        data = typeof data === 'object' ? data : {};
        let result = new BaseOperationPnr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullReferenceId"] = this.fullReferenceId !== undefined ? this.fullReferenceId : <any>null;
        data["ResultKey"] = this.resultKey !== undefined ? this.resultKey : <any>null;
        data["RoutingKey"] = this.routingKey !== undefined ? this.routingKey : <any>null;
        data["IsPure"] = this.isPure !== undefined ? this.isPure : <any>null;
        data["CodeShareKey"] = this.codeShareKey !== undefined ? this.codeShareKey : <any>null;
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : <any>null;
        data["ClosePnr"] = this.closePnr !== undefined ? this.closePnr : <any>null;
        data["BookingStatus"] = this.bookingStatus !== undefined ? this.bookingStatus : <any>null;
        data["PnrNumber"] = this.pnrNumber !== undefined ? this.pnrNumber : <any>null;
        data["PseudoCityCode"] = this.pseudoCityCode !== undefined ? this.pseudoCityCode : <any>null;
        data["PnrDate"] = this.pnrDate !== undefined ? this.pnrDate : <any>null;
        data["CancelDate"] = this.cancelDate !== undefined ? this.cancelDate : <any>null;
        data["LastTicketDate"] = this.lastTicketDate !== undefined ? this.lastTicketDate : <any>null;
        if (Array.isArray(this.flightSegments)) {
            data["FlightSegments"] = [];
            for (let item of this.flightSegments)
                data["FlightSegments"].push(item.toJSON());
        }
        data["Fare"] = this.fare ? this.fare.toJSON() : <any>null;
        if (Array.isArray(this.alternativeFares)) {
            data["AlternativeFares"] = [];
            for (let item of this.alternativeFares)
                data["AlternativeFares"].push(item.toJSON());
        }
        if (Array.isArray(this.ancillaries)) {
            data["Ancillaries"] = [];
            for (let item of this.ancillaries)
                data["Ancillaries"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalAncillaries)) {
            data["AdditionalAncillaries"] = [];
            for (let item of this.additionalAncillaries)
                data["AdditionalAncillaries"].push(item.toJSON());
        }
        if (Array.isArray(this.paxes)) {
            data["Paxes"] = [];
            for (let item of this.paxes)
                data["Paxes"].push(item.toJSON());
        }
        data["CreditCardPayment"] = this.creditCardPayment ? this.creditCardPayment.toJSON() : <any>null;
        data["TravelCompany"] = this.travelCompany ? this.travelCompany.toJSON() : <any>null;
        if (Array.isArray(this.remarks)) {
            data["Remarks"] = [];
            for (let item of this.remarks)
                data["Remarks"].push(item.toJSON());
        }
        if (Array.isArray(this.osiSsr)) {
            data["OsiSsr"] = [];
            for (let item of this.osiSsr)
                data["OsiSsr"].push(item.toJSON());
        }
        data["CO2Emissions"] = this.cO2Emissions ? this.cO2Emissions.toJSON() : <any>null;
        data["ConnectorCustomData"] = this.connectorCustomData ? this.connectorCustomData.toJSON() : <any>null;
        return data;
    }
}

export interface IBaseOperationPnr {
    fullReferenceId?: string | null;
    resultKey?: string | null;
    routingKey?: string | null;
    isPure?: boolean | null;
    codeShareKey?: string | null;
    connectorCode: EH2HConnectorCode;
    closePnr?: boolean | null;
    bookingStatus?: EBookingStatus | null;
    pnrNumber?: string | null;
    pseudoCityCode?: string | null;
    pnrDate?: string | null;
    cancelDate?: string | null;
    lastTicketDate?: string | null;
    flightSegments?: PnrFlightSegment[] | null;
    fare?: PnrFlightFare | null;
    alternativeFares?: PnrFlightFare[] | null;
    ancillaries?: PnrBookedFlightAncillary[] | null;
    additionalAncillaries?: PnrFlightAdditionalAncillary[] | null;
    paxes?: PnrPaxDetails[] | null;
    creditCardPayment?: CreditCardInfo | null;
    travelCompany?: PnrTravelCompany | null;
    remarks?: PnrRemarks[] | null;
    osiSsr?: PnrOsiSsr[] | null;
    cO2Emissions?: CO2Emissions | null;
    connectorCustomData?: PnrCustomData | null;
}

export enum EBookingStatus {
    PENDING = "PENDING",
    BOOKED = "BOOKED",
    DELETED = "DELETED",
    ERROR = "ERROR",
    MODIFIED = "MODIFIED",
}

export class PnrFlightSegment extends FlightSegment implements IPnrFlightSegment {
    flightStatus?: EFlightStatus | null;
    connectorCustomData?: PnrFlightSegmentCustomData | null;

    constructor(data?: IPnrFlightSegment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.flightStatus = _data["FlightStatus"] !== undefined ? _data["FlightStatus"] : <any>null;
            this.connectorCustomData = _data["ConnectorCustomData"] ? PnrFlightSegmentCustomData.fromJS(_data["ConnectorCustomData"]) : <any>null;
        }
    }

    static fromJS(data: any): PnrFlightSegment {
        data = typeof data === 'object' ? data : {};
        let result = new PnrFlightSegment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FlightStatus"] = this.flightStatus !== undefined ? this.flightStatus : <any>null;
        data["ConnectorCustomData"] = this.connectorCustomData ? this.connectorCustomData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPnrFlightSegment extends IFlightSegment {
    flightStatus?: EFlightStatus | null;
    connectorCustomData?: PnrFlightSegmentCustomData | null;
}

export enum EFlightStatus {
    HK_CONFIRMED = "HK_CONFIRMED",
    WL_WAITLISTED = "WL_WAITLISTED",
    RQ_ON_REQUEST = "RQ_ON_REQUEST",
    X_CANCELLED = "X_CANCELLED",
    UC_IMPOSSIBLE = "UC_IMPOSSIBLE",
    SC_SCHEDULE_CHANGE = "SC_SCHEDULE_CHANGE",
    UNKNOWN = "UNKNOWN",
}

export abstract class PnrFlightSegmentCustomData implements IPnrFlightSegmentCustomData {

    protected _discriminator: string;

    constructor(data?: IPnrFlightSegmentCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "PnrFlightSegmentCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PnrFlightSegmentCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "SABRE") {
            let result = new SabrePnrFlightSegmentCustomData();
            result.init(data);
            return result;
        }
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusPnrFlightSegmentCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PnrFlightSegmentCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IPnrFlightSegmentCustomData {
}

export class SabrePnrFlightSegmentCustomData extends PnrFlightSegmentCustomData implements ISabrePnrFlightSegmentCustomData {
    marriageGrp?: string | null;
    statusCode?: string | null;

    constructor(data?: ISabrePnrFlightSegmentCustomData) {
        super(data);
        this._discriminator = "SABRE";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.marriageGrp = _data["MarriageGrp"] !== undefined ? _data["MarriageGrp"] : <any>null;
            this.statusCode = _data["StatusCode"] !== undefined ? _data["StatusCode"] : <any>null;
        }
    }

    static fromJS(data: any): SabrePnrFlightSegmentCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new SabrePnrFlightSegmentCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MarriageGrp"] = this.marriageGrp !== undefined ? this.marriageGrp : <any>null;
        data["StatusCode"] = this.statusCode !== undefined ? this.statusCode : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISabrePnrFlightSegmentCustomData extends IPnrFlightSegmentCustomData {
    marriageGrp?: string | null;
    statusCode?: string | null;
}

export class AmadeusPnrFlightSegmentCustomData extends PnrFlightSegmentCustomData implements IAmadeusPnrFlightSegmentCustomData {
    referenceNumber?: string | null;
    lineNumber?: string | null;
    classCode?: string | null;
    status?: string | null;
    eTicket?: boolean | null;
    quantity?: number | null;
    numOfStops?: string | null;
    operatedByText?: string | null;
    cabinDetails?: string | null;

    constructor(data?: IAmadeusPnrFlightSegmentCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.referenceNumber = _data["ReferenceNumber"] !== undefined ? _data["ReferenceNumber"] : <any>null;
            this.lineNumber = _data["LineNumber"] !== undefined ? _data["LineNumber"] : <any>null;
            this.classCode = _data["ClassCode"] !== undefined ? _data["ClassCode"] : <any>null;
            this.status = _data["Status"] !== undefined ? _data["Status"] : <any>null;
            this.eTicket = _data["ETicket"] !== undefined ? _data["ETicket"] : <any>null;
            this.quantity = _data["Quantity"] !== undefined ? _data["Quantity"] : <any>null;
            this.numOfStops = _data["NumOfStops"] !== undefined ? _data["NumOfStops"] : <any>null;
            this.operatedByText = _data["OperatedByText"] !== undefined ? _data["OperatedByText"] : <any>null;
            this.cabinDetails = _data["CabinDetails"] !== undefined ? _data["CabinDetails"] : <any>null;
        }
    }

    static fromJS(data: any): AmadeusPnrFlightSegmentCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusPnrFlightSegmentCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReferenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : <any>null;
        data["LineNumber"] = this.lineNumber !== undefined ? this.lineNumber : <any>null;
        data["ClassCode"] = this.classCode !== undefined ? this.classCode : <any>null;
        data["Status"] = this.status !== undefined ? this.status : <any>null;
        data["ETicket"] = this.eTicket !== undefined ? this.eTicket : <any>null;
        data["Quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["NumOfStops"] = this.numOfStops !== undefined ? this.numOfStops : <any>null;
        data["OperatedByText"] = this.operatedByText !== undefined ? this.operatedByText : <any>null;
        data["CabinDetails"] = this.cabinDetails !== undefined ? this.cabinDetails : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusPnrFlightSegmentCustomData extends IPnrFlightSegmentCustomData {
    referenceNumber?: string | null;
    lineNumber?: string | null;
    classCode?: string | null;
    status?: string | null;
    eTicket?: boolean | null;
    quantity?: number | null;
    numOfStops?: string | null;
    operatedByText?: string | null;
    cabinDetails?: string | null;
}

export class PnrFlightFare extends FlightFare implements IPnrFlightFare {
    customerCustomData?: CustomerCustomDataOfPnrFlightFare | null;

    constructor(data?: IPnrFlightFare) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerCustomData = _data["CustomerCustomData"] ? CustomerCustomDataOfPnrFlightFare.fromJS(_data["CustomerCustomData"]) : <any>null;
        }
    }

    static fromJS(data: any): PnrFlightFare {
        data = typeof data === 'object' ? data : {};
        let result = new PnrFlightFare();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerCustomData"] = this.customerCustomData ? this.customerCustomData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPnrFlightFare extends IFlightFare {
    customerCustomData?: CustomerCustomDataOfPnrFlightFare | null;
}

export abstract class CustomerCustomDataOfPnrFlightFare implements ICustomerCustomDataOfPnrFlightFare {

    protected _discriminator: string;

    constructor(data?: ICustomerCustomDataOfPnrFlightFare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "CustomerCustomDataOfPnrFlightFare";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CustomerCustomDataOfPnrFlightFare {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataCode"] === "FlightPnrFareNaarData") {
            let result = new FlightPnrFareNaarData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'CustomerCustomDataOfPnrFlightFare' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataCode"] = this._discriminator;
        return data;
    }
}

export interface ICustomerCustomDataOfPnrFlightFare {
}

export class FlightPnrFareNaarData extends CustomerCustomDataOfPnrFlightFare implements IFlightPnrFareNaarData {
    isToFare?: boolean | null;
    totalAmountWithoutTaxWithMarkup?: CurrencyAmount | null;
    totalAmountWithMarkup?: CurrencyAmount | null;
    totalTaxWithMarkup?: CurrencyAmount | null;
    perPaxAmountWithMarkup?: CurrencyAmount | null;

    constructor(data?: IFlightPnrFareNaarData) {
        super(data);
        this._discriminator = "FlightPnrFareNaarData";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isToFare = _data["isToFare"] !== undefined ? _data["isToFare"] : <any>null;
            this.totalAmountWithoutTaxWithMarkup = _data["TotalAmountWithoutTaxWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalAmountWithoutTaxWithMarkup"]) : <any>null;
            this.totalAmountWithMarkup = _data["TotalAmountWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalAmountWithMarkup"]) : <any>null;
            this.totalTaxWithMarkup = _data["TotalTaxWithMarkup"] ? CurrencyAmount.fromJS(_data["TotalTaxWithMarkup"]) : <any>null;
            this.perPaxAmountWithMarkup = _data["PerPaxAmountWithMarkup"] ? CurrencyAmount.fromJS(_data["PerPaxAmountWithMarkup"]) : <any>null;
        }
    }

    static fromJS(data: any): FlightPnrFareNaarData {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPnrFareNaarData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isToFare"] = this.isToFare !== undefined ? this.isToFare : <any>null;
        data["TotalAmountWithoutTaxWithMarkup"] = this.totalAmountWithoutTaxWithMarkup ? this.totalAmountWithoutTaxWithMarkup.toJSON() : <any>null;
        data["TotalAmountWithMarkup"] = this.totalAmountWithMarkup ? this.totalAmountWithMarkup.toJSON() : <any>null;
        data["TotalTaxWithMarkup"] = this.totalTaxWithMarkup ? this.totalTaxWithMarkup.toJSON() : <any>null;
        data["PerPaxAmountWithMarkup"] = this.perPaxAmountWithMarkup ? this.perPaxAmountWithMarkup.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightPnrFareNaarData extends ICustomerCustomDataOfPnrFlightFare {
    isToFare?: boolean | null;
    totalAmountWithoutTaxWithMarkup?: CurrencyAmount | null;
    totalAmountWithMarkup?: CurrencyAmount | null;
    totalTaxWithMarkup?: CurrencyAmount | null;
    perPaxAmountWithMarkup?: CurrencyAmount | null;
}

export abstract class BaseFlightAncillary implements IBaseFlightAncillary {
    id?: string | null;
    type?: EAncillaryType | null;
    code?: string | null;
    description?: string | null;

    constructor(data?: IBaseFlightAncillary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : <any>null;
            this.type = _data["Type"] !== undefined ? _data["Type"] : <any>null;
            this.code = _data["Code"] !== undefined ? _data["Code"] : <any>null;
            this.description = _data["Description"] !== undefined ? _data["Description"] : <any>null;
        }
    }

    static fromJS(data: any): BaseFlightAncillary {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseFlightAncillary' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : <any>null;
        data["Type"] = this.type !== undefined ? this.type : <any>null;
        data["Code"] = this.code !== undefined ? this.code : <any>null;
        data["Description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface IBaseFlightAncillary {
    id?: string | null;
    type?: EAncillaryType | null;
    code?: string | null;
    description?: string | null;
}

export class BookedFlightAncillary extends BaseFlightAncillary implements IBookedFlightAncillary {
    paxRefId?: string | null;
    flightSegmentRefIds?: string[] | null;
    chargeMode?: EAncillaryChargeMode | null;
    baseAmount?: CurrencyAmount | null;
    selectedOptionIdOrValue?: string | null;
    selectedOptionDescription?: string | null;
    totalAmount?: CurrencyAmount | null;

    constructor(data?: IBookedFlightAncillary) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paxRefId = _data["PaxRefId"] !== undefined ? _data["PaxRefId"] : <any>null;
            if (Array.isArray(_data["FlightSegmentRefIds"])) {
                this.flightSegmentRefIds = [] as any;
                for (let item of _data["FlightSegmentRefIds"])
                    this.flightSegmentRefIds!.push(item);
            }
            else {
                this.flightSegmentRefIds = <any>null;
            }
            this.chargeMode = _data["ChargeMode"] !== undefined ? _data["ChargeMode"] : <any>null;
            this.baseAmount = _data["BaseAmount"] ? CurrencyAmount.fromJS(_data["BaseAmount"]) : <any>null;
            this.selectedOptionIdOrValue = _data["SelectedOptionIdOrValue"] !== undefined ? _data["SelectedOptionIdOrValue"] : <any>null;
            this.selectedOptionDescription = _data["SelectedOptionDescription"] !== undefined ? _data["SelectedOptionDescription"] : <any>null;
            this.totalAmount = _data["TotalAmount"] ? CurrencyAmount.fromJS(_data["TotalAmount"]) : <any>null;
        }
    }

    static fromJS(data: any): BookedFlightAncillary {
        data = typeof data === 'object' ? data : {};
        let result = new BookedFlightAncillary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PaxRefId"] = this.paxRefId !== undefined ? this.paxRefId : <any>null;
        if (Array.isArray(this.flightSegmentRefIds)) {
            data["FlightSegmentRefIds"] = [];
            for (let item of this.flightSegmentRefIds)
                data["FlightSegmentRefIds"].push(item);
        }
        data["ChargeMode"] = this.chargeMode !== undefined ? this.chargeMode : <any>null;
        data["BaseAmount"] = this.baseAmount ? this.baseAmount.toJSON() : <any>null;
        data["SelectedOptionIdOrValue"] = this.selectedOptionIdOrValue !== undefined ? this.selectedOptionIdOrValue : <any>null;
        data["SelectedOptionDescription"] = this.selectedOptionDescription !== undefined ? this.selectedOptionDescription : <any>null;
        data["TotalAmount"] = this.totalAmount ? this.totalAmount.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBookedFlightAncillary extends IBaseFlightAncillary {
    paxRefId?: string | null;
    flightSegmentRefIds?: string[] | null;
    chargeMode?: EAncillaryChargeMode | null;
    baseAmount?: CurrencyAmount | null;
    selectedOptionIdOrValue?: string | null;
    selectedOptionDescription?: string | null;
    totalAmount?: CurrencyAmount | null;
}

export class PnrBookedFlightAncillary extends BookedFlightAncillary implements IPnrBookedFlightAncillary {

    constructor(data?: IPnrBookedFlightAncillary) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PnrBookedFlightAncillary {
        data = typeof data === 'object' ? data : {};
        let result = new PnrBookedFlightAncillary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPnrBookedFlightAncillary extends IBookedFlightAncillary {
}

export enum EAncillaryChargeMode {
    PER_PERSON = "PER_PERSON",
    PER_SEGMENT = "PER_SEGMENT",
    PER_PERSON_PER_SEGMENT = "PER_PERSON_PER_SEGMENT",
    TOTAL = "TOTAL",
}

export enum EAncillaryType {
    BAGGAGE = "BAGGAGE",
    OUTWARD_BAGGAGE = "OUTWARD_BAGGAGE",
    RETURN_BAGGAGE = "RETURN_BAGGAGE",
    HAND_BAGGAGE = "HAND_BAGGAGE",
    HAND_OUTWARD_BAGGAGE = "HAND_OUTWARD_BAGGAGE",
    HAND_RETURN_BAGGAGE = "HAND_RETURN_BAGGAGE",
    MEAL = "MEAL",
    INSURANCE = "INSURANCE",
    SPEEDY_BOARDING = "SPEEDY_BOARDING",
    ONLINE_CHECKIN = "ONLINE_CHECKIN",
    AIRPORT_CHECKIN = "AIRPORT_CHECKIN",
    SEAT_ASSIGNMENT = "SEAT_ASSIGNMENT",
    CARD_CHARGE = "CARD_CHARGE",
    EQUIPMENT = "EQUIPMENT",
    OTHER = "OTHER",
}

export class FlightAdditionalAncillary extends BaseFlightAncillary implements IFlightAdditionalAncillary {
    options?: FlightAncillaryOption[] | null;
    selectedPaxRefId?: string | null;
    selectedFlightSegmentRefIds?: string[] | null;
    selectedOptionIdOrValue?: string | null;

    constructor(data?: IFlightAdditionalAncillary) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Options"])) {
                this.options = [] as any;
                for (let item of _data["Options"])
                    this.options!.push(FlightAncillaryOption.fromJS(item));
            }
            else {
                this.options = <any>null;
            }
            this.selectedPaxRefId = _data["SelectedPaxRefId"] !== undefined ? _data["SelectedPaxRefId"] : <any>null;
            if (Array.isArray(_data["SelectedFlightSegmentRefIds"])) {
                this.selectedFlightSegmentRefIds = [] as any;
                for (let item of _data["SelectedFlightSegmentRefIds"])
                    this.selectedFlightSegmentRefIds!.push(item);
            }
            else {
                this.selectedFlightSegmentRefIds = <any>null;
            }
            this.selectedOptionIdOrValue = _data["SelectedOptionIdOrValue"] !== undefined ? _data["SelectedOptionIdOrValue"] : <any>null;
        }
    }

    static fromJS(data: any): FlightAdditionalAncillary {
        data = typeof data === 'object' ? data : {};
        let result = new FlightAdditionalAncillary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["Options"] = [];
            for (let item of this.options)
                data["Options"].push(item.toJSON());
        }
        data["SelectedPaxRefId"] = this.selectedPaxRefId !== undefined ? this.selectedPaxRefId : <any>null;
        if (Array.isArray(this.selectedFlightSegmentRefIds)) {
            data["SelectedFlightSegmentRefIds"] = [];
            for (let item of this.selectedFlightSegmentRefIds)
                data["SelectedFlightSegmentRefIds"].push(item);
        }
        data["SelectedOptionIdOrValue"] = this.selectedOptionIdOrValue !== undefined ? this.selectedOptionIdOrValue : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightAdditionalAncillary extends IBaseFlightAncillary {
    options?: FlightAncillaryOption[] | null;
    selectedPaxRefId?: string | null;
    selectedFlightSegmentRefIds?: string[] | null;
    selectedOptionIdOrValue?: string | null;
}

export class PnrFlightAdditionalAncillary extends FlightAdditionalAncillary implements IPnrFlightAdditionalAncillary {

    constructor(data?: IPnrFlightAdditionalAncillary) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PnrFlightAdditionalAncillary {
        data = typeof data === 'object' ? data : {};
        let result = new PnrFlightAdditionalAncillary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPnrFlightAdditionalAncillary extends IFlightAdditionalAncillary {
}

export class FlightAncillaryOption implements IFlightAncillaryOption {
    id!: string;
    description?: string | null;
    paxType?: EPaxType | null;
    chargeMode?: EAncillaryChargeMode | null;
    baseAmount!: CurrencyAmount;
    seatMapInfo?: SeatMap | null;
    baggageInfo?: BaggageInfo | null;

    constructor(data?: IFlightAncillaryOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.baseAmount = new CurrencyAmount();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : <any>null;
            this.description = _data["Description"] !== undefined ? _data["Description"] : <any>null;
            this.paxType = _data["PaxType"] !== undefined ? _data["PaxType"] : <any>null;
            this.chargeMode = _data["ChargeMode"] !== undefined ? _data["ChargeMode"] : <any>null;
            this.baseAmount = _data["BaseAmount"] ? CurrencyAmount.fromJS(_data["BaseAmount"]) : new CurrencyAmount();
            this.seatMapInfo = _data["SeatMapInfo"] ? SeatMap.fromJS(_data["SeatMapInfo"]) : <any>null;
            this.baggageInfo = _data["BaggageInfo"] ? BaggageInfo.fromJS(_data["BaggageInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): FlightAncillaryOption {
        data = typeof data === 'object' ? data : {};
        let result = new FlightAncillaryOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : <any>null;
        data["Description"] = this.description !== undefined ? this.description : <any>null;
        data["PaxType"] = this.paxType !== undefined ? this.paxType : <any>null;
        data["ChargeMode"] = this.chargeMode !== undefined ? this.chargeMode : <any>null;
        data["BaseAmount"] = this.baseAmount ? this.baseAmount.toJSON() : <any>null;
        data["SeatMapInfo"] = this.seatMapInfo ? this.seatMapInfo.toJSON() : <any>null;
        data["BaggageInfo"] = this.baggageInfo ? this.baggageInfo.toJSON() : <any>null;
        return data;
    }
}

export interface IFlightAncillaryOption {
    id: string;
    description?: string | null;
    paxType?: EPaxType | null;
    chargeMode?: EAncillaryChargeMode | null;
    baseAmount: CurrencyAmount;
    seatMapInfo?: SeatMap | null;
    baggageInfo?: BaggageInfo | null;
}

export class SeatMap implements ISeatMap {
    rowNumber?: number | null;
    rowPosition?: ESeatMapRowPosition | null;
    column?: string | null;
    columnPosition?: ESeatMapColumnPosition | null;
    seatAvailability?: ESeatMapAvailability | null;
    rowLevel?: ESeatMapRowLevel | null;
    seatCharacteristics?: string[] | null;
    extraLeg?: boolean | null;
    exitRow?: boolean | null;
    hasPaxTypeRestriction?: boolean | null;
    hasRestriction?: boolean | null;
    isFacility?: boolean | null;

    constructor(data?: ISeatMap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["RowNumber"] !== undefined ? _data["RowNumber"] : <any>null;
            this.rowPosition = _data["RowPosition"] !== undefined ? _data["RowPosition"] : <any>null;
            this.column = _data["Column"] !== undefined ? _data["Column"] : <any>null;
            this.columnPosition = _data["ColumnPosition"] !== undefined ? _data["ColumnPosition"] : <any>null;
            this.seatAvailability = _data["SeatAvailability"] !== undefined ? _data["SeatAvailability"] : <any>null;
            this.rowLevel = _data["RowLevel"] !== undefined ? _data["RowLevel"] : <any>null;
            if (Array.isArray(_data["SeatCharacteristics"])) {
                this.seatCharacteristics = [] as any;
                for (let item of _data["SeatCharacteristics"])
                    this.seatCharacteristics!.push(item);
            }
            else {
                this.seatCharacteristics = <any>null;
            }
            this.extraLeg = _data["ExtraLeg"] !== undefined ? _data["ExtraLeg"] : <any>null;
            this.exitRow = _data["ExitRow"] !== undefined ? _data["ExitRow"] : <any>null;
            this.hasPaxTypeRestriction = _data["HasPaxTypeRestriction"] !== undefined ? _data["HasPaxTypeRestriction"] : <any>null;
            this.hasRestriction = _data["HasRestriction"] !== undefined ? _data["HasRestriction"] : <any>null;
            this.isFacility = _data["IsFacility"] !== undefined ? _data["IsFacility"] : <any>null;
        }
    }

    static fromJS(data: any): SeatMap {
        data = typeof data === 'object' ? data : {};
        let result = new SeatMap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RowNumber"] = this.rowNumber !== undefined ? this.rowNumber : <any>null;
        data["RowPosition"] = this.rowPosition !== undefined ? this.rowPosition : <any>null;
        data["Column"] = this.column !== undefined ? this.column : <any>null;
        data["ColumnPosition"] = this.columnPosition !== undefined ? this.columnPosition : <any>null;
        data["SeatAvailability"] = this.seatAvailability !== undefined ? this.seatAvailability : <any>null;
        data["RowLevel"] = this.rowLevel !== undefined ? this.rowLevel : <any>null;
        if (Array.isArray(this.seatCharacteristics)) {
            data["SeatCharacteristics"] = [];
            for (let item of this.seatCharacteristics)
                data["SeatCharacteristics"].push(item);
        }
        data["ExtraLeg"] = this.extraLeg !== undefined ? this.extraLeg : <any>null;
        data["ExitRow"] = this.exitRow !== undefined ? this.exitRow : <any>null;
        data["HasPaxTypeRestriction"] = this.hasPaxTypeRestriction !== undefined ? this.hasPaxTypeRestriction : <any>null;
        data["HasRestriction"] = this.hasRestriction !== undefined ? this.hasRestriction : <any>null;
        data["IsFacility"] = this.isFacility !== undefined ? this.isFacility : <any>null;
        return data;
    }
}

export interface ISeatMap {
    rowNumber?: number | null;
    rowPosition?: ESeatMapRowPosition | null;
    column?: string | null;
    columnPosition?: ESeatMapColumnPosition | null;
    seatAvailability?: ESeatMapAvailability | null;
    rowLevel?: ESeatMapRowLevel | null;
    seatCharacteristics?: string[] | null;
    extraLeg?: boolean | null;
    exitRow?: boolean | null;
    hasPaxTypeRestriction?: boolean | null;
    hasRestriction?: boolean | null;
    isFacility?: boolean | null;
}

export enum ESeatMapRowPosition {
    BEFORE_WINGS = "BEFORE_WINGS",
    AFTER_WINGS = "AFTER_WINGS",
    ON_WINGS = "ON_WINGS",
}

export enum ESeatMapColumnPosition {
    CENTER_SEAT = "CENTER_SEAT",
    AISLE_SEAT = "AISLE_SEAT",
    WINDOW_SEAT = "WINDOW_SEAT",
}

export enum ESeatMapAvailability {
    UNKOWN = "UNKOWN",
    AVAILABLE = "AVAILABLE",
    OCCUPIED = "OCCUPIED",
    UNAVAILABLE = "UNAVAILABLE",
}

export enum ESeatMapRowLevel {
    LOWER_DECK = "LOWER_DECK",
    MAIN_DECK = "MAIN_DECK",
    UPPER_DECK = "UPPER_DECK",
}

export class BaggageInfo implements IBaggageInfo {
    parentId?: string | null;
    baggageInfoCode?: string | null;
    baggageCostType?: EBaggageCostType | null;
    baggageBookingCode?: string | null;
    freeBaggageData?: FreeBaggageData[] | null;

    constructor(data?: IBaggageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["ParentId"] !== undefined ? _data["ParentId"] : <any>null;
            this.baggageInfoCode = _data["BaggageInfoCode"] !== undefined ? _data["BaggageInfoCode"] : <any>null;
            this.baggageCostType = _data["BaggageCostType"] !== undefined ? _data["BaggageCostType"] : <any>null;
            this.baggageBookingCode = _data["BaggageBookingCode"] !== undefined ? _data["BaggageBookingCode"] : <any>null;
            if (Array.isArray(_data["FreeBaggageData"])) {
                this.freeBaggageData = [] as any;
                for (let item of _data["FreeBaggageData"])
                    this.freeBaggageData!.push(FreeBaggageData.fromJS(item));
            }
            else {
                this.freeBaggageData = <any>null;
            }
        }
    }

    static fromJS(data: any): BaggageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BaggageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ParentId"] = this.parentId !== undefined ? this.parentId : <any>null;
        data["BaggageInfoCode"] = this.baggageInfoCode !== undefined ? this.baggageInfoCode : <any>null;
        data["BaggageCostType"] = this.baggageCostType !== undefined ? this.baggageCostType : <any>null;
        data["BaggageBookingCode"] = this.baggageBookingCode !== undefined ? this.baggageBookingCode : <any>null;
        if (Array.isArray(this.freeBaggageData)) {
            data["FreeBaggageData"] = [];
            for (let item of this.freeBaggageData)
                data["FreeBaggageData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBaggageInfo {
    parentId?: string | null;
    baggageInfoCode?: string | null;
    baggageCostType?: EBaggageCostType | null;
    baggageBookingCode?: string | null;
    freeBaggageData?: FreeBaggageData[] | null;
}

export enum EBaggageCostType {
    PRICE_PER_PIECE = "PRICE_PER_PIECE",
    PRICE_PER_WEIGHT = "PRICE_PER_WEIGHT",
    PRICE_PER_RANGE_OF_WEIGHT = "PRICE_PER_RANGE_OF_WEIGHT",
}

export class FreeBaggageData implements IFreeBaggageData {
    fbaMinWeight?: number | null;
    fbaMaxWeight?: number | null;
    weightUnitValue?: string | null;
    fbaQuantity?: number | null;
    isWeightBased?: boolean | null;
    flightSegmentRefIds?: string[] | null;

    constructor(data?: IFreeBaggageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fbaMinWeight = _data["FbaMinWeight"] !== undefined ? _data["FbaMinWeight"] : <any>null;
            this.fbaMaxWeight = _data["FbaMaxWeight"] !== undefined ? _data["FbaMaxWeight"] : <any>null;
            this.weightUnitValue = _data["WeightUnitValue"] !== undefined ? _data["WeightUnitValue"] : <any>null;
            this.fbaQuantity = _data["FbaQuantity"] !== undefined ? _data["FbaQuantity"] : <any>null;
            this.isWeightBased = _data["IsWeightBased"] !== undefined ? _data["IsWeightBased"] : <any>null;
            if (Array.isArray(_data["FlightSegmentRefIds"])) {
                this.flightSegmentRefIds = [] as any;
                for (let item of _data["FlightSegmentRefIds"])
                    this.flightSegmentRefIds!.push(item);
            }
            else {
                this.flightSegmentRefIds = <any>null;
            }
        }
    }

    static fromJS(data: any): FreeBaggageData {
        data = typeof data === 'object' ? data : {};
        let result = new FreeBaggageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FbaMinWeight"] = this.fbaMinWeight !== undefined ? this.fbaMinWeight : <any>null;
        data["FbaMaxWeight"] = this.fbaMaxWeight !== undefined ? this.fbaMaxWeight : <any>null;
        data["WeightUnitValue"] = this.weightUnitValue !== undefined ? this.weightUnitValue : <any>null;
        data["FbaQuantity"] = this.fbaQuantity !== undefined ? this.fbaQuantity : <any>null;
        data["IsWeightBased"] = this.isWeightBased !== undefined ? this.isWeightBased : <any>null;
        if (Array.isArray(this.flightSegmentRefIds)) {
            data["FlightSegmentRefIds"] = [];
            for (let item of this.flightSegmentRefIds)
                data["FlightSegmentRefIds"].push(item);
        }
        return data;
    }
}

export interface IFreeBaggageData {
    fbaMinWeight?: number | null;
    fbaMaxWeight?: number | null;
    weightUnitValue?: string | null;
    fbaQuantity?: number | null;
    isWeightBased?: boolean | null;
    flightSegmentRefIds?: string[] | null;
}

export class PaxDetails implements IPaxDetails {
    paxTitle?: string | null;
    gender?: EPaxGender | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    emails?: Email[] | null;
    phoneNumbers?: Phone[] | null;
    documents?: PaxDocument[] | null;
    loyaltyCards?: PaxLoyaltyCard[] | null;
    company?: BusinessCompany | null;
    address?: Address | null;
    birthDate!: string;

    constructor(data?: IPaxDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paxTitle = _data["PaxTitle"] !== undefined ? _data["PaxTitle"] : <any>null;
            this.gender = _data["Gender"] !== undefined ? _data["Gender"] : <any>null;
            this.firstName = _data["FirstName"] !== undefined ? _data["FirstName"] : <any>null;
            this.middleName = _data["MiddleName"] !== undefined ? _data["MiddleName"] : <any>null;
            this.lastName = _data["LastName"] !== undefined ? _data["LastName"] : <any>null;
            if (Array.isArray(_data["Emails"])) {
                this.emails = [] as any;
                for (let item of _data["Emails"])
                    this.emails!.push(Email.fromJS(item));
            }
            else {
                this.emails = <any>null;
            }
            if (Array.isArray(_data["PhoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["PhoneNumbers"])
                    this.phoneNumbers!.push(Phone.fromJS(item));
            }
            else {
                this.phoneNumbers = <any>null;
            }
            if (Array.isArray(_data["Documents"])) {
                this.documents = [] as any;
                for (let item of _data["Documents"])
                    this.documents!.push(PaxDocument.fromJS(item));
            }
            else {
                this.documents = <any>null;
            }
            if (Array.isArray(_data["LoyaltyCards"])) {
                this.loyaltyCards = [] as any;
                for (let item of _data["LoyaltyCards"])
                    this.loyaltyCards!.push(PaxLoyaltyCard.fromJS(item));
            }
            else {
                this.loyaltyCards = <any>null;
            }
            this.company = _data["Company"] ? BusinessCompany.fromJS(_data["Company"]) : <any>null;
            this.address = _data["Address"] ? Address.fromJS(_data["Address"]) : <any>null;
            this.birthDate = _data["BirthDate"] !== undefined ? _data["BirthDate"] : <any>null;
        }
    }

    static fromJS(data: any): PaxDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PaxDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PaxTitle"] = this.paxTitle !== undefined ? this.paxTitle : <any>null;
        data["Gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["FirstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["MiddleName"] = this.middleName !== undefined ? this.middleName : <any>null;
        data["LastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        if (Array.isArray(this.emails)) {
            data["Emails"] = [];
            for (let item of this.emails)
                data["Emails"].push(item.toJSON());
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["PhoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["PhoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["Documents"] = [];
            for (let item of this.documents)
                data["Documents"].push(item.toJSON());
        }
        if (Array.isArray(this.loyaltyCards)) {
            data["LoyaltyCards"] = [];
            for (let item of this.loyaltyCards)
                data["LoyaltyCards"].push(item.toJSON());
        }
        data["Company"] = this.company ? this.company.toJSON() : <any>null;
        data["Address"] = this.address ? this.address.toJSON() : <any>null;
        data["BirthDate"] = this.birthDate !== undefined ? this.birthDate : <any>null;
        return data;
    }
}

export interface IPaxDetails {
    paxTitle?: string | null;
    gender?: EPaxGender | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    emails?: Email[] | null;
    phoneNumbers?: Phone[] | null;
    documents?: PaxDocument[] | null;
    loyaltyCards?: PaxLoyaltyCard[] | null;
    company?: BusinessCompany | null;
    address?: Address | null;
    birthDate: string;
}

export class PnrPaxDetails extends PaxDetails implements IPnrPaxDetails {
    id?: string | null;
    connectorCustomData?: PnrPaxDetailsCustomData | null;

    constructor(data?: IPnrPaxDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"] !== undefined ? _data["Id"] : <any>null;
            this.connectorCustomData = _data["ConnectorCustomData"] ? PnrPaxDetailsCustomData.fromJS(_data["ConnectorCustomData"]) : <any>null;
        }
    }

    static fromJS(data: any): PnrPaxDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PnrPaxDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id !== undefined ? this.id : <any>null;
        data["ConnectorCustomData"] = this.connectorCustomData ? this.connectorCustomData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPnrPaxDetails extends IPaxDetails {
    id?: string | null;
    connectorCustomData?: PnrPaxDetailsCustomData | null;
}

export abstract class PnrPaxDetailsCustomData implements IPnrPaxDetailsCustomData {

    protected _discriminator: string;

    constructor(data?: IPnrPaxDetailsCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "PnrPaxDetailsCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PnrPaxDetailsCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusPnrPaxDetailsCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PnrPaxDetailsCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IPnrPaxDetailsCustomData {
}

export class AmadeusPnrPaxDetailsCustomData extends PnrPaxDetailsCustomData implements IAmadeusPnrPaxDetailsCustomData {
    lineNumber?: string | null;
    paxType?: string | null;
    quantity?: string | null;
    infantIndicator?: string | null;

    constructor(data?: IAmadeusPnrPaxDetailsCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lineNumber = _data["LineNumber"] !== undefined ? _data["LineNumber"] : <any>null;
            this.paxType = _data["PaxType"] !== undefined ? _data["PaxType"] : <any>null;
            this.quantity = _data["Quantity"] !== undefined ? _data["Quantity"] : <any>null;
            this.infantIndicator = _data["InfantIndicator"] !== undefined ? _data["InfantIndicator"] : <any>null;
        }
    }

    static fromJS(data: any): AmadeusPnrPaxDetailsCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusPnrPaxDetailsCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LineNumber"] = this.lineNumber !== undefined ? this.lineNumber : <any>null;
        data["PaxType"] = this.paxType !== undefined ? this.paxType : <any>null;
        data["Quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["InfantIndicator"] = this.infantIndicator !== undefined ? this.infantIndicator : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusPnrPaxDetailsCustomData extends IPnrPaxDetailsCustomData {
    lineNumber?: string | null;
    paxType?: string | null;
    quantity?: string | null;
    infantIndicator?: string | null;
}

export enum EPaxGender {
    UNKNOWN = "UNKNOWN",
    MALE = "MALE",
    FEMALE = "FEMALE",
}

export class Email implements IEmail {
    title?: string | null;
    value?: string | null;

    constructor(data?: IEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"] !== undefined ? _data["Title"] : <any>null;
            this.value = _data["Value"] !== undefined ? _data["Value"] : <any>null;
        }
    }

    static fromJS(data: any): Email {
        data = typeof data === 'object' ? data : {};
        let result = new Email();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title !== undefined ? this.title : <any>null;
        data["Value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IEmail {
    title?: string | null;
    value?: string | null;
}

export class Phone implements IPhone {
    title?: string | null;
    value?: string | null;

    constructor(data?: IPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"] !== undefined ? _data["Title"] : <any>null;
            this.value = _data["Value"] !== undefined ? _data["Value"] : <any>null;
        }
    }

    static fromJS(data: any): Phone {
        data = typeof data === 'object' ? data : {};
        let result = new Phone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title !== undefined ? this.title : <any>null;
        data["Value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IPhone {
    title?: string | null;
    value?: string | null;
}

export class PaxDocument implements IPaxDocument {
    type?: EDocumentType | null;
    firstName?: string | null;
    lastName?: string | null;
    number?: string | null;
    issueIsoCode?: string | null;
    nationalityIsoCode?: string | null;
    expirationDate?: string | null;

    constructor(data?: IPaxDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"] !== undefined ? _data["Type"] : <any>null;
            this.firstName = _data["FirstName"] !== undefined ? _data["FirstName"] : <any>null;
            this.lastName = _data["LastName"] !== undefined ? _data["LastName"] : <any>null;
            this.number = _data["Number"] !== undefined ? _data["Number"] : <any>null;
            this.issueIsoCode = _data["IssueIsoCode"] !== undefined ? _data["IssueIsoCode"] : <any>null;
            this.nationalityIsoCode = _data["NationalityIsoCode"] !== undefined ? _data["NationalityIsoCode"] : <any>null;
            this.expirationDate = _data["ExpirationDate"] !== undefined ? _data["ExpirationDate"] : <any>null;
        }
    }

    static fromJS(data: any): PaxDocument {
        data = typeof data === 'object' ? data : {};
        let result = new PaxDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type !== undefined ? this.type : <any>null;
        data["FirstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["LastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["Number"] = this.number !== undefined ? this.number : <any>null;
        data["IssueIsoCode"] = this.issueIsoCode !== undefined ? this.issueIsoCode : <any>null;
        data["NationalityIsoCode"] = this.nationalityIsoCode !== undefined ? this.nationalityIsoCode : <any>null;
        data["ExpirationDate"] = this.expirationDate !== undefined ? this.expirationDate : <any>null;
        return data;
    }
}

export interface IPaxDocument {
    type?: EDocumentType | null;
    firstName?: string | null;
    lastName?: string | null;
    number?: string | null;
    issueIsoCode?: string | null;
    nationalityIsoCode?: string | null;
    expirationDate?: string | null;
}

export enum EDocumentType {
    ID = "ID",
    PASSPORT = "PASSPORT",
    FISCAL_CODE = "FISCAL_CODE",
}

export class PaxLoyaltyCard implements IPaxLoyaltyCard {
    membershipId?: string | null;
    programId?: string | null;
    iataCode?: string | null;
    cardExpirationDate?: string | null;

    constructor(data?: IPaxLoyaltyCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipId = _data["MembershipId"] !== undefined ? _data["MembershipId"] : <any>null;
            this.programId = _data["ProgramId"] !== undefined ? _data["ProgramId"] : <any>null;
            this.iataCode = _data["IataCode"] !== undefined ? _data["IataCode"] : <any>null;
            this.cardExpirationDate = _data["CardExpirationDate"] !== undefined ? _data["CardExpirationDate"] : <any>null;
        }
    }

    static fromJS(data: any): PaxLoyaltyCard {
        data = typeof data === 'object' ? data : {};
        let result = new PaxLoyaltyCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MembershipId"] = this.membershipId !== undefined ? this.membershipId : <any>null;
        data["ProgramId"] = this.programId !== undefined ? this.programId : <any>null;
        data["IataCode"] = this.iataCode !== undefined ? this.iataCode : <any>null;
        data["CardExpirationDate"] = this.cardExpirationDate !== undefined ? this.cardExpirationDate : <any>null;
        return data;
    }
}

export interface IPaxLoyaltyCard {
    membershipId?: string | null;
    programId?: string | null;
    iataCode?: string | null;
    cardExpirationDate?: string | null;
}

export class BaseCompany implements IBaseCompany {
    name?: string | null;
    addresses?: Address[] | null;
    vatNumber?: string | null;
    phoneNumbers?: Phone[] | null;
    emails?: Email[] | null;

    constructor(data?: IBaseCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"] !== undefined ? _data["Name"] : <any>null;
            if (Array.isArray(_data["Addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["Addresses"])
                    this.addresses!.push(Address.fromJS(item));
            }
            else {
                this.addresses = <any>null;
            }
            this.vatNumber = _data["VatNumber"] !== undefined ? _data["VatNumber"] : <any>null;
            if (Array.isArray(_data["PhoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["PhoneNumbers"])
                    this.phoneNumbers!.push(Phone.fromJS(item));
            }
            else {
                this.phoneNumbers = <any>null;
            }
            if (Array.isArray(_data["Emails"])) {
                this.emails = [] as any;
                for (let item of _data["Emails"])
                    this.emails!.push(Email.fromJS(item));
            }
            else {
                this.emails = <any>null;
            }
        }
    }

    static fromJS(data: any): BaseCompany {
        data = typeof data === 'object' ? data : {};
        let result = new BaseCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.addresses)) {
            data["Addresses"] = [];
            for (let item of this.addresses)
                data["Addresses"].push(item.toJSON());
        }
        data["VatNumber"] = this.vatNumber !== undefined ? this.vatNumber : <any>null;
        if (Array.isArray(this.phoneNumbers)) {
            data["PhoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["PhoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["Emails"] = [];
            for (let item of this.emails)
                data["Emails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBaseCompany {
    name?: string | null;
    addresses?: Address[] | null;
    vatNumber?: string | null;
    phoneNumbers?: Phone[] | null;
    emails?: Email[] | null;
}

export class BusinessCompany extends BaseCompany implements IBusinessCompany {

    constructor(data?: IBusinessCompany) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): BusinessCompany {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBusinessCompany extends IBaseCompany {
}

export class Address implements IAddress {
    type?: string | null;
    street?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    countryCode?: string | null;
    state?: string | null;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"] !== undefined ? _data["Type"] : <any>null;
            this.street = _data["Street"] !== undefined ? _data["Street"] : <any>null;
            this.zip = _data["Zip"] !== undefined ? _data["Zip"] : <any>null;
            this.city = _data["City"] !== undefined ? _data["City"] : <any>null;
            this.country = _data["Country"] !== undefined ? _data["Country"] : <any>null;
            this.countryCode = _data["CountryCode"] !== undefined ? _data["CountryCode"] : <any>null;
            this.state = _data["State"] !== undefined ? _data["State"] : <any>null;
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type !== undefined ? this.type : <any>null;
        data["Street"] = this.street !== undefined ? this.street : <any>null;
        data["Zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["City"] = this.city !== undefined ? this.city : <any>null;
        data["Country"] = this.country !== undefined ? this.country : <any>null;
        data["CountryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["State"] = this.state !== undefined ? this.state : <any>null;
        return data;
    }
}

export interface IAddress {
    type?: string | null;
    street?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    countryCode?: string | null;
    state?: string | null;
}

export class CreditCardInfo implements ICreditCardInfo {
    cardHolderName?: string | null;
    cardHolderFirstName?: string | null;
    cardHolderLastName?: string | null;
    creditCardType?: ECreditCardType | null;
    creditCardNumber?: string | null;
    creditCardCvv?: string | null;
    expireDate?: string | null;
    startDate?: string | null;
    issueNumber?: string | null;

    constructor(data?: ICreditCardInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardHolderName = _data["CardHolderName"] !== undefined ? _data["CardHolderName"] : <any>null;
            this.cardHolderFirstName = _data["CardHolderFirstName"] !== undefined ? _data["CardHolderFirstName"] : <any>null;
            this.cardHolderLastName = _data["CardHolderLastName"] !== undefined ? _data["CardHolderLastName"] : <any>null;
            this.creditCardType = _data["CreditCardType"] !== undefined ? _data["CreditCardType"] : <any>null;
            this.creditCardNumber = _data["CreditCardNumber"] !== undefined ? _data["CreditCardNumber"] : <any>null;
            this.creditCardCvv = _data["CreditCardCvv"] !== undefined ? _data["CreditCardCvv"] : <any>null;
            this.expireDate = _data["ExpireDate"] !== undefined ? _data["ExpireDate"] : <any>null;
            this.startDate = _data["StartDate"] !== undefined ? _data["StartDate"] : <any>null;
            this.issueNumber = _data["IssueNumber"] !== undefined ? _data["IssueNumber"] : <any>null;
        }
    }

    static fromJS(data: any): CreditCardInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CardHolderName"] = this.cardHolderName !== undefined ? this.cardHolderName : <any>null;
        data["CardHolderFirstName"] = this.cardHolderFirstName !== undefined ? this.cardHolderFirstName : <any>null;
        data["CardHolderLastName"] = this.cardHolderLastName !== undefined ? this.cardHolderLastName : <any>null;
        data["CreditCardType"] = this.creditCardType !== undefined ? this.creditCardType : <any>null;
        data["CreditCardNumber"] = this.creditCardNumber !== undefined ? this.creditCardNumber : <any>null;
        data["CreditCardCvv"] = this.creditCardCvv !== undefined ? this.creditCardCvv : <any>null;
        data["ExpireDate"] = this.expireDate !== undefined ? this.expireDate : <any>null;
        data["StartDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["IssueNumber"] = this.issueNumber !== undefined ? this.issueNumber : <any>null;
        return data;
    }
}

export interface ICreditCardInfo {
    cardHolderName?: string | null;
    cardHolderFirstName?: string | null;
    cardHolderLastName?: string | null;
    creditCardType?: ECreditCardType | null;
    creditCardNumber?: string | null;
    creditCardCvv?: string | null;
    expireDate?: string | null;
    startDate?: string | null;
    issueNumber?: string | null;
}

export enum ECreditCardType {
    MASTERCARD = "MASTERCARD",
    VISA = "VISA",
    AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
    JCB_INTERNATIONAL = "JCB_INTERNATIONAL",
    CARTE_BLANCHE = "CARTE_BLANCHE",
    CHINA_UNION_PAY_EXPEDIA = "CHINA_UNION_PAY_EXPEDIA",
    CHINA_UNION_PAY = "CHINA_UNION_PAY",
    DINERS_CLUB = "DINERS_CLUB",
    DISCOVER_CARD = "DISCOVER_CARD",
    EURO_CARD = "EURO_CARD",
    FORBRUGSFORENINGSKORT = "FORBRUGSFORENINGSKORT",
    MAESTRO = "MAESTRO",
    AIR_PLUS = "AIR_PLUS",
    UATP = "UATP",
    BUSINESS_CARD = "BUSINESS_CARD",
    NEXI_MASTERCARD = "NEXI_MASTERCARD",
    NEXI_VISA = "NEXI_VISA",
}

export class TravelCompany extends BaseCompany implements ITravelCompany {

    constructor(data?: ITravelCompany) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TravelCompany {
        data = typeof data === 'object' ? data : {};
        let result = new TravelCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITravelCompany extends IBaseCompany {
}

export class PnrTravelCompany extends TravelCompany implements IPnrTravelCompany {

    constructor(data?: IPnrTravelCompany) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PnrTravelCompany {
        data = typeof data === 'object' ? data : {};
        let result = new PnrTravelCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPnrTravelCompany extends ITravelCompany {
}

export class PnrRemarks implements IPnrRemarks {
    lineNumber?: string | null;
    id?: string | null;
    code?: string | null;
    type?: string | null;
    text?: string | null;
    flightSegmentRefId?: string | null;
    paxRefId?: string | null;

    constructor(data?: IPnrRemarks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data["LineNumber"] !== undefined ? _data["LineNumber"] : <any>null;
            this.id = _data["Id"] !== undefined ? _data["Id"] : <any>null;
            this.code = _data["Code"] !== undefined ? _data["Code"] : <any>null;
            this.type = _data["Type"] !== undefined ? _data["Type"] : <any>null;
            this.text = _data["Text"] !== undefined ? _data["Text"] : <any>null;
            this.flightSegmentRefId = _data["FlightSegmentRefId"] !== undefined ? _data["FlightSegmentRefId"] : <any>null;
            this.paxRefId = _data["PaxRefId"] !== undefined ? _data["PaxRefId"] : <any>null;
        }
    }

    static fromJS(data: any): PnrRemarks {
        data = typeof data === 'object' ? data : {};
        let result = new PnrRemarks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LineNumber"] = this.lineNumber !== undefined ? this.lineNumber : <any>null;
        data["Id"] = this.id !== undefined ? this.id : <any>null;
        data["Code"] = this.code !== undefined ? this.code : <any>null;
        data["Type"] = this.type !== undefined ? this.type : <any>null;
        data["Text"] = this.text !== undefined ? this.text : <any>null;
        data["FlightSegmentRefId"] = this.flightSegmentRefId !== undefined ? this.flightSegmentRefId : <any>null;
        data["PaxRefId"] = this.paxRefId !== undefined ? this.paxRefId : <any>null;
        return data;
    }
}

export interface IPnrRemarks {
    lineNumber?: string | null;
    id?: string | null;
    code?: string | null;
    type?: string | null;
    text?: string | null;
    flightSegmentRefId?: string | null;
    paxRefId?: string | null;
}

export class PnrOsiSsr implements IPnrOsiSsr {
    lineNumber?: string | null;
    id?: string | null;
    code?: string | null;
    type?: string | null;
    date?: string | null;
    text?: string | null;
    flightSegmentRefId?: string | null;
    airlineIataCode?: string | null;
    paxRefId?: string | null;

    constructor(data?: IPnrOsiSsr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineNumber = _data["LineNumber"] !== undefined ? _data["LineNumber"] : <any>null;
            this.id = _data["Id"] !== undefined ? _data["Id"] : <any>null;
            this.code = _data["Code"] !== undefined ? _data["Code"] : <any>null;
            this.type = _data["Type"] !== undefined ? _data["Type"] : <any>null;
            this.date = _data["Date"] !== undefined ? _data["Date"] : <any>null;
            this.text = _data["Text"] !== undefined ? _data["Text"] : <any>null;
            this.flightSegmentRefId = _data["FlightSegmentRefId"] !== undefined ? _data["FlightSegmentRefId"] : <any>null;
            this.airlineIataCode = _data["AirlineIataCode"] !== undefined ? _data["AirlineIataCode"] : <any>null;
            this.paxRefId = _data["PaxRefId"] !== undefined ? _data["PaxRefId"] : <any>null;
        }
    }

    static fromJS(data: any): PnrOsiSsr {
        data = typeof data === 'object' ? data : {};
        let result = new PnrOsiSsr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LineNumber"] = this.lineNumber !== undefined ? this.lineNumber : <any>null;
        data["Id"] = this.id !== undefined ? this.id : <any>null;
        data["Code"] = this.code !== undefined ? this.code : <any>null;
        data["Type"] = this.type !== undefined ? this.type : <any>null;
        data["Date"] = this.date !== undefined ? this.date : <any>null;
        data["Text"] = this.text !== undefined ? this.text : <any>null;
        data["FlightSegmentRefId"] = this.flightSegmentRefId !== undefined ? this.flightSegmentRefId : <any>null;
        data["AirlineIataCode"] = this.airlineIataCode !== undefined ? this.airlineIataCode : <any>null;
        data["PaxRefId"] = this.paxRefId !== undefined ? this.paxRefId : <any>null;
        return data;
    }
}

export interface IPnrOsiSsr {
    lineNumber?: string | null;
    id?: string | null;
    code?: string | null;
    type?: string | null;
    date?: string | null;
    text?: string | null;
    flightSegmentRefId?: string | null;
    airlineIataCode?: string | null;
    paxRefId?: string | null;
}

export class CO2Emissions implements ICO2Emissions {
    perSegment?: number | null;
    perPassenger?: number | null;
    perMile?: number | null;
    perKm?: number | null;
    distanceInMiles?: number | null;
    distanceInKm?: number | null;
    unit?: string | null;

    constructor(data?: ICO2Emissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.perSegment = _data["PerSegment"] !== undefined ? _data["PerSegment"] : <any>null;
            this.perPassenger = _data["PerPassenger"] !== undefined ? _data["PerPassenger"] : <any>null;
            this.perMile = _data["PerMile"] !== undefined ? _data["PerMile"] : <any>null;
            this.perKm = _data["PerKm"] !== undefined ? _data["PerKm"] : <any>null;
            this.distanceInMiles = _data["DistanceInMiles"] !== undefined ? _data["DistanceInMiles"] : <any>null;
            this.distanceInKm = _data["DistanceInKm"] !== undefined ? _data["DistanceInKm"] : <any>null;
            this.unit = _data["Unit"] !== undefined ? _data["Unit"] : <any>null;
        }
    }

    static fromJS(data: any): CO2Emissions {
        data = typeof data === 'object' ? data : {};
        let result = new CO2Emissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PerSegment"] = this.perSegment !== undefined ? this.perSegment : <any>null;
        data["PerPassenger"] = this.perPassenger !== undefined ? this.perPassenger : <any>null;
        data["PerMile"] = this.perMile !== undefined ? this.perMile : <any>null;
        data["PerKm"] = this.perKm !== undefined ? this.perKm : <any>null;
        data["DistanceInMiles"] = this.distanceInMiles !== undefined ? this.distanceInMiles : <any>null;
        data["DistanceInKm"] = this.distanceInKm !== undefined ? this.distanceInKm : <any>null;
        data["Unit"] = this.unit !== undefined ? this.unit : <any>null;
        return data;
    }
}

export interface ICO2Emissions {
    perSegment?: number | null;
    perPassenger?: number | null;
    perMile?: number | null;
    perKm?: number | null;
    distanceInMiles?: number | null;
    distanceInKm?: number | null;
    unit?: string | null;
}

export abstract class PnrCustomData implements IPnrCustomData {

    protected _discriminator: string;

    constructor(data?: IPnrCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "PnrCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PnrCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusPnrCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PnrCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IPnrCustomData {
}

export class AmadeusPnrCustomData extends PnrCustomData implements IAmadeusPnrCustomData {
    pnrCustomData?: AmadeusFlightPnrCustomData | null;

    constructor(data?: IAmadeusPnrCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pnrCustomData = _data["PnrCustomData"] ? AmadeusFlightPnrCustomData.fromJS(_data["PnrCustomData"]) : <any>null;
        }
    }

    static fromJS(data: any): AmadeusPnrCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusPnrCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PnrCustomData"] = this.pnrCustomData ? this.pnrCustomData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusPnrCustomData extends IPnrCustomData {
    pnrCustomData?: AmadeusFlightPnrCustomData | null;
}

export class AmadeusFlightPnrCustomData implements IAmadeusFlightPnrCustomData {
    receivedFrom?: string | null;
    tkXlAutoDeleteDate?: string | null;
    tkTlTimeLimitDate?: string | null;
    amadeusPnrRetrieveXmlRs?: string | null;
    ndcOrderId?: string | null;
    ndcOwnerCode?: string | null;
    ndcTicketNumbers?: string[] | null;

    constructor(data?: IAmadeusFlightPnrCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receivedFrom = _data["ReceivedFrom"] !== undefined ? _data["ReceivedFrom"] : <any>null;
            this.tkXlAutoDeleteDate = _data["TkXlAutoDeleteDate"] !== undefined ? _data["TkXlAutoDeleteDate"] : <any>null;
            this.tkTlTimeLimitDate = _data["TkTlTimeLimitDate"] !== undefined ? _data["TkTlTimeLimitDate"] : <any>null;
            this.amadeusPnrRetrieveXmlRs = _data["AmadeusPnrRetrieveXmlRs"] !== undefined ? _data["AmadeusPnrRetrieveXmlRs"] : <any>null;
            this.ndcOrderId = _data["NdcOrderId"] !== undefined ? _data["NdcOrderId"] : <any>null;
            this.ndcOwnerCode = _data["NdcOwnerCode"] !== undefined ? _data["NdcOwnerCode"] : <any>null;
            if (Array.isArray(_data["NdcTicketNumbers"])) {
                this.ndcTicketNumbers = [] as any;
                for (let item of _data["NdcTicketNumbers"])
                    this.ndcTicketNumbers!.push(item);
            }
            else {
                this.ndcTicketNumbers = <any>null;
            }
        }
    }

    static fromJS(data: any): AmadeusFlightPnrCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightPnrCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReceivedFrom"] = this.receivedFrom !== undefined ? this.receivedFrom : <any>null;
        data["TkXlAutoDeleteDate"] = this.tkXlAutoDeleteDate !== undefined ? this.tkXlAutoDeleteDate : <any>null;
        data["TkTlTimeLimitDate"] = this.tkTlTimeLimitDate !== undefined ? this.tkTlTimeLimitDate : <any>null;
        data["AmadeusPnrRetrieveXmlRs"] = this.amadeusPnrRetrieveXmlRs !== undefined ? this.amadeusPnrRetrieveXmlRs : <any>null;
        data["NdcOrderId"] = this.ndcOrderId !== undefined ? this.ndcOrderId : <any>null;
        data["NdcOwnerCode"] = this.ndcOwnerCode !== undefined ? this.ndcOwnerCode : <any>null;
        if (Array.isArray(this.ndcTicketNumbers)) {
            data["NdcTicketNumbers"] = [];
            for (let item of this.ndcTicketNumbers)
                data["NdcTicketNumbers"].push(item);
        }
        return data;
    }
}

export interface IAmadeusFlightPnrCustomData {
    receivedFrom?: string | null;
    tkXlAutoDeleteDate?: string | null;
    tkTlTimeLimitDate?: string | null;
    amadeusPnrRetrieveXmlRs?: string | null;
    ndcOrderId?: string | null;
    ndcOwnerCode?: string | null;
    ndcTicketNumbers?: string[] | null;
}

export class JupiterFlightPnrRetrieveRQ extends BaseRQ implements IJupiterFlightPnrRetrieveRQ {
    request?: JupiterFlightPnrRetrieveInput | null;

    constructor(data?: IJupiterFlightPnrRetrieveRQ) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.request = _data["Request"] ? JupiterFlightPnrRetrieveInput.fromJS(_data["Request"]) : <any>null;
        }
    }

    static fromJS(data: any): JupiterFlightPnrRetrieveRQ {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightPnrRetrieveRQ();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Request"] = this.request ? this.request.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightPnrRetrieveRQ extends IBaseRQ {
    request?: JupiterFlightPnrRetrieveInput | null;
}

export class JupiterFlightPnrRetrieveInput extends BaseInput implements IJupiterFlightPnrRetrieveInput {
    connectorCode!: EH2HConnectorCode;
    pnrNumber?: string | null;
    connectorCustomData?: FlightPnrRetrieveInputCustomData | null;
    sessionConnectorCustomData?: GdsSessionCustomData | null;
    customerCustomData?: CustomerCustomDataOfJupiterFlightPnrRetrieveInput | null;

    constructor(data?: IJupiterFlightPnrRetrieveInput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.connectorCode = _data["ConnectorCode"] !== undefined ? _data["ConnectorCode"] : <any>null;
            this.pnrNumber = _data["PnrNumber"] !== undefined ? _data["PnrNumber"] : <any>null;
            this.connectorCustomData = _data["ConnectorCustomData"] ? FlightPnrRetrieveInputCustomData.fromJS(_data["ConnectorCustomData"]) : <any>null;
            this.sessionConnectorCustomData = _data["SessionConnectorCustomData"] ? GdsSessionCustomData.fromJS(_data["SessionConnectorCustomData"]) : <any>null;
            this.customerCustomData = _data["CustomerCustomData"] ? CustomerCustomDataOfJupiterFlightPnrRetrieveInput.fromJS(_data["CustomerCustomData"]) : <any>null;
        }
    }

    static fromJS(data: any): JupiterFlightPnrRetrieveInput {
        data = typeof data === 'object' ? data : {};
        let result = new JupiterFlightPnrRetrieveInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectorCode"] = this.connectorCode !== undefined ? this.connectorCode : <any>null;
        data["PnrNumber"] = this.pnrNumber !== undefined ? this.pnrNumber : <any>null;
        data["ConnectorCustomData"] = this.connectorCustomData ? this.connectorCustomData.toJSON() : <any>null;
        data["SessionConnectorCustomData"] = this.sessionConnectorCustomData ? this.sessionConnectorCustomData.toJSON() : <any>null;
        data["CustomerCustomData"] = this.customerCustomData ? this.customerCustomData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IJupiterFlightPnrRetrieveInput extends IBaseInput {
    connectorCode: EH2HConnectorCode;
    pnrNumber?: string | null;
    connectorCustomData?: FlightPnrRetrieveInputCustomData | null;
    sessionConnectorCustomData?: GdsSessionCustomData | null;
    customerCustomData?: CustomerCustomDataOfJupiterFlightPnrRetrieveInput | null;
}

export abstract class FlightPnrRetrieveInputCustomData implements IFlightPnrRetrieveInputCustomData {

    protected _discriminator: string;

    constructor(data?: IFlightPnrRetrieveInputCustomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FlightPnrRetrieveInputCustomData";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FlightPnrRetrieveInputCustomData {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataConnectorCode"] === "AMADEUS") {
            let result = new AmadeusFlightPnrRetrieveInputCustomData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FlightPnrRetrieveInputCustomData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataConnectorCode"] = this._discriminator;
        return data;
    }
}

export interface IFlightPnrRetrieveInputCustomData {
}

export class AmadeusFlightPnrRetrieveInputCustomData extends FlightPnrRetrieveInputCustomData implements IAmadeusFlightPnrRetrieveInputCustomData {
    ndcOrderId?: string | null;
    ndcOwnerCode?: string | null;

    constructor(data?: IAmadeusFlightPnrRetrieveInputCustomData) {
        super(data);
        this._discriminator = "AMADEUS";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ndcOrderId = _data["NdcOrderId"] !== undefined ? _data["NdcOrderId"] : <any>null;
            this.ndcOwnerCode = _data["NdcOwnerCode"] !== undefined ? _data["NdcOwnerCode"] : <any>null;
        }
    }

    static fromJS(data: any): AmadeusFlightPnrRetrieveInputCustomData {
        data = typeof data === 'object' ? data : {};
        let result = new AmadeusFlightPnrRetrieveInputCustomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NdcOrderId"] = this.ndcOrderId !== undefined ? this.ndcOrderId : <any>null;
        data["NdcOwnerCode"] = this.ndcOwnerCode !== undefined ? this.ndcOwnerCode : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAmadeusFlightPnrRetrieveInputCustomData extends IFlightPnrRetrieveInputCustomData {
    ndcOrderId?: string | null;
    ndcOwnerCode?: string | null;
}

export abstract class CustomerCustomDataOfJupiterFlightPnrRetrieveInput implements ICustomerCustomDataOfJupiterFlightPnrRetrieveInput {

    protected _discriminator: string;

    constructor(data?: ICustomerCustomDataOfJupiterFlightPnrRetrieveInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "CustomerCustomDataOfJupiterFlightPnrRetrieveInput";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CustomerCustomDataOfJupiterFlightPnrRetrieveInput {
        data = typeof data === 'object' ? data : {};
        if (data["CustomDataCode"] === "FlightPnrRetrieveNaarData") {
            let result = new FlightPnrRetrieveNaarData();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'CustomerCustomDataOfJupiterFlightPnrRetrieveInput' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomDataCode"] = this._discriminator;
        return data;
    }
}

export interface ICustomerCustomDataOfJupiterFlightPnrRetrieveInput {
}

export class FlightPnrRetrieveNaarData extends CustomerCustomDataOfJupiterFlightPnrRetrieveInput implements IFlightPnrRetrieveNaarData {
    markupData?: MarkupData | null;

    constructor(data?: IFlightPnrRetrieveNaarData) {
        super(data);
        this._discriminator = "FlightPnrRetrieveNaarData";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.markupData = _data["MarkupData"] ? MarkupData.fromJS(_data["MarkupData"]) : <any>null;
        }
    }

    static fromJS(data: any): FlightPnrRetrieveNaarData {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPnrRetrieveNaarData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MarkupData"] = this.markupData ? this.markupData.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IFlightPnrRetrieveNaarData extends ICustomerCustomDataOfJupiterFlightPnrRetrieveInput {
    markupData?: MarkupData | null;
}

export class ImportPnrApiRequest extends ApiRequest implements IImportPnrApiRequest {
    /** Offerta ID */
    tripID?: number;
    /** Pnr Number */
    pnr?: string | null;
    /** Supplier ID -> 14 Amadeus */
    supplierID?: number;
    /** Abbinamento ID -> Camera */
    abbinamentoID?: number;
    /** Boolean indicating import services rows */
    importServiceRows?: boolean;
    /** Boolean indicating import fares */
    importFares?: boolean;

    constructor(data?: IImportPnrApiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : <any>null;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : <any>null;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : <any>null;
            this.importServiceRows = _data["importServiceRows"] !== undefined ? _data["importServiceRows"] : <any>null;
            this.importFares = _data["importFares"] !== undefined ? _data["importFares"] : <any>null;
        }
    }

    static fromJS(data: any): ImportPnrApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportPnrApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        data["pnr"] = this.pnr !== undefined ? this.pnr : <any>null;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : <any>null;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : <any>null;
        data["importServiceRows"] = this.importServiceRows !== undefined ? this.importServiceRows : <any>null;
        data["importFares"] = this.importFares !== undefined ? this.importFares : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IImportPnrApiRequest extends IApiRequest {
    /** Offerta ID */
    tripID?: number;
    /** Pnr Number */
    pnr?: string | null;
    /** Supplier ID -> 14 Amadeus */
    supplierID?: number;
    /** Abbinamento ID -> Camera */
    abbinamentoID?: number;
    /** Boolean indicating import services rows */
    importServiceRows?: boolean;
    /** Boolean indicating import fares */
    importFares?: boolean;
}

export class ImportCrypticPnrApiRequest extends ApiRequest implements IImportCrypticPnrApiRequest {
    /** Session Custom Data */
    sessionConnectorCustomData?: GdsSessionCustomData | null;
    /** Offerta ID */
    tripID?: number;
    /** Supplier ID -> 14 Amadeus */
    supplierID?: number | null;
    /** Abbinamento ID -> Camera */
    abbinamentoID?: number | null;
    /** Boolean indicating import services rows */
    importServiceRows?: boolean;
    /** Boolean indicating import fares */
    importFares?: boolean;
    /** Boolean indicating if replace existing Rows and PNRs
It work only if the PNR associated to the rows is the same PNR */
    replaceRows?: boolean;

    constructor(data?: IImportCrypticPnrApiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sessionConnectorCustomData = _data["sessionConnectorCustomData"] ? GdsSessionCustomData.fromJS(_data["sessionConnectorCustomData"]) : <any>null;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : <any>null;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : <any>null;
            this.importServiceRows = _data["importServiceRows"] !== undefined ? _data["importServiceRows"] : <any>null;
            this.importFares = _data["importFares"] !== undefined ? _data["importFares"] : <any>null;
            this.replaceRows = _data["replaceRows"] !== undefined ? _data["replaceRows"] : <any>null;
        }
    }

    static fromJS(data: any): ImportCrypticPnrApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCrypticPnrApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionConnectorCustomData"] = this.sessionConnectorCustomData ? this.sessionConnectorCustomData.toJSON() : <any>null;
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : <any>null;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : <any>null;
        data["importServiceRows"] = this.importServiceRows !== undefined ? this.importServiceRows : <any>null;
        data["importFares"] = this.importFares !== undefined ? this.importFares : <any>null;
        data["replaceRows"] = this.replaceRows !== undefined ? this.replaceRows : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IImportCrypticPnrApiRequest extends IApiRequest {
    /** Session Custom Data */
    sessionConnectorCustomData?: GdsSessionCustomData | null;
    /** Offerta ID */
    tripID?: number;
    /** Supplier ID -> 14 Amadeus */
    supplierID?: number | null;
    /** Abbinamento ID -> Camera */
    abbinamentoID?: number | null;
    /** Boolean indicating import services rows */
    importServiceRows?: boolean;
    /** Boolean indicating import fares */
    importFares?: boolean;
    /** Boolean indicating if replace existing Rows and PNRs
It work only if the PNR associated to the rows is the same PNR */
    replaceRows?: boolean;
}

export class ClosePnrApiRequest extends ApiRequest implements IClosePnrApiRequest {
    /** Offerta ID */
    tripID?: number;
    /** Abbinamento ID -> Camera */
    abbinamentoID?: number;

    constructor(data?: IClosePnrApiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : <any>null;
        }
    }

    static fromJS(data: any): ClosePnrApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClosePnrApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IClosePnrApiRequest extends IApiRequest {
    /** Offerta ID */
    tripID?: number;
    /** Abbinamento ID -> Camera */
    abbinamentoID?: number;
}

export class AddFlightFromSearchRequest extends ApiRequest implements IAddFlightFromSearchRequest {
    /** Offerta ID */
    tripID?: number;
    /** Availability Request */
    availabilityInput?: JupiterFlightAvailabilityInput | null;
    /** Selected Result */
    selectedResult?: SingleFlightAvailResult | null;

    constructor(data?: IAddFlightFromSearchRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
            this.availabilityInput = _data["availabilityInput"] ? JupiterFlightAvailabilityInput.fromJS(_data["availabilityInput"]) : <any>null;
            this.selectedResult = _data["selectedResult"] ? SingleFlightAvailResult.fromJS(_data["selectedResult"]) : <any>null;
        }
    }

    static fromJS(data: any): AddFlightFromSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddFlightFromSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        data["availabilityInput"] = this.availabilityInput ? this.availabilityInput.toJSON() : <any>null;
        data["selectedResult"] = this.selectedResult ? this.selectedResult.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddFlightFromSearchRequest extends IApiRequest {
    /** Offerta ID */
    tripID?: number;
    /** Availability Request */
    availabilityInput?: JupiterFlightAvailabilityInput | null;
    /** Selected Result */
    selectedResult?: SingleFlightAvailResult | null;
}

export class CreateTripFromSearchRequest extends ApiRequest implements ICreateTripFromSearchRequest {
    /** Availability Request */
    availabilityInput?: JupiterFlightAvailabilityInput | null;
    /** Selected Result */
    selectedResult?: SingleFlightAvailResult | null;
    /** Trip Paxes */
    tripPaxes?: ClienteDatoUpdate[] | null;

    constructor(data?: ICreateTripFromSearchRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.availabilityInput = _data["availabilityInput"] ? JupiterFlightAvailabilityInput.fromJS(_data["availabilityInput"]) : <any>null;
            this.selectedResult = _data["selectedResult"] ? SingleFlightAvailResult.fromJS(_data["selectedResult"]) : <any>null;
            if (Array.isArray(_data["tripPaxes"])) {
                this.tripPaxes = [] as any;
                for (let item of _data["tripPaxes"])
                    this.tripPaxes!.push(ClienteDatoUpdate.fromJS(item));
            }
            else {
                this.tripPaxes = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateTripFromSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTripFromSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityInput"] = this.availabilityInput ? this.availabilityInput.toJSON() : <any>null;
        data["selectedResult"] = this.selectedResult ? this.selectedResult.toJSON() : <any>null;
        if (Array.isArray(this.tripPaxes)) {
            data["tripPaxes"] = [];
            for (let item of this.tripPaxes)
                data["tripPaxes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateTripFromSearchRequest extends IApiRequest {
    /** Availability Request */
    availabilityInput?: JupiterFlightAvailabilityInput | null;
    /** Selected Result */
    selectedResult?: SingleFlightAvailResult | null;
    /** Trip Paxes */
    tripPaxes?: ClienteDatoUpdate[] | null;
}

export class ClienteDatoUpdate implements IClienteDatoUpdate {
    cliente?: Cliente | null;
    clienteDato?: ClienteDato | null;
    abbinamentoID?: number | null;
    nomeNuovoAbbinamento?: string | null;

    constructor(data?: IClienteDatoUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cliente = _data["cliente"] ? Cliente.fromJS(_data["cliente"]) : <any>null;
            this.clienteDato = _data["clienteDato"] ? ClienteDato.fromJS(_data["clienteDato"]) : <any>null;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : <any>null;
            this.nomeNuovoAbbinamento = _data["nomeNuovoAbbinamento"] !== undefined ? _data["nomeNuovoAbbinamento"] : <any>null;
        }
    }

    static fromJS(data: any): ClienteDatoUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteDatoUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cliente"] = this.cliente ? this.cliente.toJSON() : <any>null;
        data["clienteDato"] = this.clienteDato ? this.clienteDato.toJSON() : <any>null;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : <any>null;
        data["nomeNuovoAbbinamento"] = this.nomeNuovoAbbinamento !== undefined ? this.nomeNuovoAbbinamento : <any>null;
        return data;
    }
}

export interface IClienteDatoUpdate {
    cliente?: Cliente | null;
    clienteDato?: ClienteDato | null;
    abbinamentoID?: number | null;
    nomeNuovoAbbinamento?: string | null;
}

export class GetAllSuppliersResponse extends OkApiResponse implements IGetAllSuppliersResponse {
    rows?: SupplierRow[] | null;

    constructor(data?: IGetAllSuppliersResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SupplierRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAllSuppliersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSuppliersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAllSuppliersResponse extends IOkApiResponse {
    rows?: SupplierRow[] | null;
}

export class SupplierRow implements ISupplierRow {
    id?: number;
    code?: string | null;
    name?: string | null;
    attivo?: boolean;
    ricercaHotel?: boolean;
    bookingHotel?: boolean;
    ricercaVoli?: boolean;
    bookingVoli?: boolean;
    ricercaVisite?: boolean;
    bookingVisite?: boolean;
    ricercaNoleggi?: boolean;
    bookingNoleggi?: boolean;
    ricercaCrociere?: boolean;
    bookingCrociere?: boolean;
    ultimaRicerca?: string | null;
    ultimaRicercaFault?: string | null;
    durataRicerche?: number | null;
    durataRicercheFault?: number | null;
    ricercheAttive?: number;
    ricercheAttiveFault?: number;
    accordoObbligatorio?: boolean;
    dirty?: boolean;

    constructor(data?: ISupplierRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.attivo = _data["attivo"] !== undefined ? _data["attivo"] : <any>null;
            this.ricercaHotel = _data["ricercaHotel"] !== undefined ? _data["ricercaHotel"] : <any>null;
            this.bookingHotel = _data["bookingHotel"] !== undefined ? _data["bookingHotel"] : <any>null;
            this.ricercaVoli = _data["ricercaVoli"] !== undefined ? _data["ricercaVoli"] : <any>null;
            this.bookingVoli = _data["bookingVoli"] !== undefined ? _data["bookingVoli"] : <any>null;
            this.ricercaVisite = _data["ricercaVisite"] !== undefined ? _data["ricercaVisite"] : <any>null;
            this.bookingVisite = _data["bookingVisite"] !== undefined ? _data["bookingVisite"] : <any>null;
            this.ricercaNoleggi = _data["ricercaNoleggi"] !== undefined ? _data["ricercaNoleggi"] : <any>null;
            this.bookingNoleggi = _data["bookingNoleggi"] !== undefined ? _data["bookingNoleggi"] : <any>null;
            this.ricercaCrociere = _data["ricercaCrociere"] !== undefined ? _data["ricercaCrociere"] : <any>null;
            this.bookingCrociere = _data["bookingCrociere"] !== undefined ? _data["bookingCrociere"] : <any>null;
            this.ultimaRicerca = _data["ultimaRicerca"] !== undefined ? _data["ultimaRicerca"] : <any>null;
            this.ultimaRicercaFault = _data["ultimaRicercaFault"] !== undefined ? _data["ultimaRicercaFault"] : <any>null;
            this.durataRicerche = _data["durataRicerche"] !== undefined ? _data["durataRicerche"] : <any>null;
            this.durataRicercheFault = _data["durataRicercheFault"] !== undefined ? _data["durataRicercheFault"] : <any>null;
            this.ricercheAttive = _data["ricercheAttive"] !== undefined ? _data["ricercheAttive"] : <any>null;
            this.ricercheAttiveFault = _data["ricercheAttiveFault"] !== undefined ? _data["ricercheAttiveFault"] : <any>null;
            this.accordoObbligatorio = _data["accordoObbligatorio"] !== undefined ? _data["accordoObbligatorio"] : <any>null;
            this.dirty = _data["dirty"] !== undefined ? _data["dirty"] : <any>null;
        }
    }

    static fromJS(data: any): SupplierRow {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["attivo"] = this.attivo !== undefined ? this.attivo : <any>null;
        data["ricercaHotel"] = this.ricercaHotel !== undefined ? this.ricercaHotel : <any>null;
        data["bookingHotel"] = this.bookingHotel !== undefined ? this.bookingHotel : <any>null;
        data["ricercaVoli"] = this.ricercaVoli !== undefined ? this.ricercaVoli : <any>null;
        data["bookingVoli"] = this.bookingVoli !== undefined ? this.bookingVoli : <any>null;
        data["ricercaVisite"] = this.ricercaVisite !== undefined ? this.ricercaVisite : <any>null;
        data["bookingVisite"] = this.bookingVisite !== undefined ? this.bookingVisite : <any>null;
        data["ricercaNoleggi"] = this.ricercaNoleggi !== undefined ? this.ricercaNoleggi : <any>null;
        data["bookingNoleggi"] = this.bookingNoleggi !== undefined ? this.bookingNoleggi : <any>null;
        data["ricercaCrociere"] = this.ricercaCrociere !== undefined ? this.ricercaCrociere : <any>null;
        data["bookingCrociere"] = this.bookingCrociere !== undefined ? this.bookingCrociere : <any>null;
        data["ultimaRicerca"] = this.ultimaRicerca !== undefined ? this.ultimaRicerca : <any>null;
        data["ultimaRicercaFault"] = this.ultimaRicercaFault !== undefined ? this.ultimaRicercaFault : <any>null;
        data["durataRicerche"] = this.durataRicerche !== undefined ? this.durataRicerche : <any>null;
        data["durataRicercheFault"] = this.durataRicercheFault !== undefined ? this.durataRicercheFault : <any>null;
        data["ricercheAttive"] = this.ricercheAttive !== undefined ? this.ricercheAttive : <any>null;
        data["ricercheAttiveFault"] = this.ricercheAttiveFault !== undefined ? this.ricercheAttiveFault : <any>null;
        data["accordoObbligatorio"] = this.accordoObbligatorio !== undefined ? this.accordoObbligatorio : <any>null;
        data["dirty"] = this.dirty !== undefined ? this.dirty : <any>null;
        return data;
    }
}

export interface ISupplierRow {
    id?: number;
    code?: string | null;
    name?: string | null;
    attivo?: boolean;
    ricercaHotel?: boolean;
    bookingHotel?: boolean;
    ricercaVoli?: boolean;
    bookingVoli?: boolean;
    ricercaVisite?: boolean;
    bookingVisite?: boolean;
    ricercaNoleggi?: boolean;
    bookingNoleggi?: boolean;
    ricercaCrociere?: boolean;
    bookingCrociere?: boolean;
    ultimaRicerca?: string | null;
    ultimaRicercaFault?: string | null;
    durataRicerche?: number | null;
    durataRicercheFault?: number | null;
    ricercheAttive?: number;
    ricercheAttiveFault?: number;
    accordoObbligatorio?: boolean;
    dirty?: boolean;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetAllSuppliersRequest extends ApiRequest implements IGetAllSuppliersRequest {

    constructor(data?: IGetAllSuppliersRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetAllSuppliersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSuppliersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetAllSuppliersRequest extends IApiRequest {
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class SaveSuppliersRequest extends ApiRequest implements ISaveSuppliersRequest {
    suppliers?: SupplierItem[] | null;

    constructor(data?: ISaveSuppliersRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(SupplierItem.fromJS(item));
            }
            else {
                this.suppliers = <any>null;
            }
        }
    }

    static fromJS(data: any): SaveSuppliersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSuppliersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface ISaveSuppliersRequest extends IApiRequest {
    suppliers?: SupplierItem[] | null;
}

export class SupplierItem implements ISupplierItem {
    id?: number;
    attivo?: boolean;
    ricercaHotel?: boolean;
    bookingHotel?: boolean;
    ricercaVoli?: boolean;
    bookingVoli?: boolean;
    ricercaVisite?: boolean;
    bookingVisite?: boolean;
    ricercaNoleggi?: boolean;
    bookingNoleggi?: boolean;
    dirty?: boolean;

    constructor(data?: ISupplierItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.attivo = _data["attivo"] !== undefined ? _data["attivo"] : <any>null;
            this.ricercaHotel = _data["ricercaHotel"] !== undefined ? _data["ricercaHotel"] : <any>null;
            this.bookingHotel = _data["bookingHotel"] !== undefined ? _data["bookingHotel"] : <any>null;
            this.ricercaVoli = _data["ricercaVoli"] !== undefined ? _data["ricercaVoli"] : <any>null;
            this.bookingVoli = _data["bookingVoli"] !== undefined ? _data["bookingVoli"] : <any>null;
            this.ricercaVisite = _data["ricercaVisite"] !== undefined ? _data["ricercaVisite"] : <any>null;
            this.bookingVisite = _data["bookingVisite"] !== undefined ? _data["bookingVisite"] : <any>null;
            this.ricercaNoleggi = _data["ricercaNoleggi"] !== undefined ? _data["ricercaNoleggi"] : <any>null;
            this.bookingNoleggi = _data["bookingNoleggi"] !== undefined ? _data["bookingNoleggi"] : <any>null;
            this.dirty = _data["dirty"] !== undefined ? _data["dirty"] : <any>null;
        }
    }

    static fromJS(data: any): SupplierItem {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["attivo"] = this.attivo !== undefined ? this.attivo : <any>null;
        data["ricercaHotel"] = this.ricercaHotel !== undefined ? this.ricercaHotel : <any>null;
        data["bookingHotel"] = this.bookingHotel !== undefined ? this.bookingHotel : <any>null;
        data["ricercaVoli"] = this.ricercaVoli !== undefined ? this.ricercaVoli : <any>null;
        data["bookingVoli"] = this.bookingVoli !== undefined ? this.bookingVoli : <any>null;
        data["ricercaVisite"] = this.ricercaVisite !== undefined ? this.ricercaVisite : <any>null;
        data["bookingVisite"] = this.bookingVisite !== undefined ? this.bookingVisite : <any>null;
        data["ricercaNoleggi"] = this.ricercaNoleggi !== undefined ? this.ricercaNoleggi : <any>null;
        data["bookingNoleggi"] = this.bookingNoleggi !== undefined ? this.bookingNoleggi : <any>null;
        data["dirty"] = this.dirty !== undefined ? this.dirty : <any>null;
        return data;
    }
}

export interface ISupplierItem {
    id?: number;
    attivo?: boolean;
    ricercaHotel?: boolean;
    bookingHotel?: boolean;
    ricercaVoli?: boolean;
    bookingVoli?: boolean;
    ricercaVisite?: boolean;
    bookingVisite?: boolean;
    ricercaNoleggi?: boolean;
    bookingNoleggi?: boolean;
    dirty?: boolean;
}

export class CloneImageResponse extends OkApiResponse implements ICloneImageResponse {
    immagine?: ImageResponse | null;

    constructor(data?: ICloneImageResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.immagine = _data["immagine"] ? ImageResponse.fromJS(_data["immagine"]) : <any>null;
        }
    }

    static fromJS(data: any): CloneImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CloneImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["immagine"] = this.immagine ? this.immagine.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICloneImageResponse extends IOkApiResponse {
    immagine?: ImageResponse | null;
}

/** Elemento della lista immagini */
export class ImageResponse implements IImageResponse {
    /** ID dell'immagine */
    id?: number;
    /** Url assoluta della miniatura */
    webUrl?: string;
    didascalia?: string | null;
    ordine?: number | null;
    luogoID?: number | null;
    luogo?: string | null;
    luogoEliminato?: boolean;
    servizioID?: number | null;
    servizio?: string | null;
    servizioObsoleto?: boolean;
    servizioEliminato?: boolean;
    articoloID?: number | null;
    articolo?: string | null;
    nome_it?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    data?: string;
    /** Dati dell'immagine originale */
    originalImageData?: ImageData | null;
    programma?: boolean | null;
    sitoWeb?: boolean | null;
    preventivo?: boolean | null;
    miniGuida?: boolean | null;
    deleted?: boolean;
    thumbnails?: ThumbnailData[] | null;

    constructor(data?: IImageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.webUrl = _data["webUrl"] !== undefined ? _data["webUrl"] : <any>null;
            this.didascalia = _data["didascalia"] !== undefined ? _data["didascalia"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.luogoEliminato = _data["luogoEliminato"] !== undefined ? _data["luogoEliminato"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.servizioObsoleto = _data["servizioObsoleto"] !== undefined ? _data["servizioObsoleto"] : <any>null;
            this.servizioEliminato = _data["servizioEliminato"] !== undefined ? _data["servizioEliminato"] : <any>null;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
            this.articolo = _data["articolo"] !== undefined ? _data["articolo"] : <any>null;
            this.nome_it = _data["nome_it"] !== undefined ? _data["nome_it"] : <any>null;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : <any>null;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : <any>null;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.originalImageData = _data["originalImageData"] ? ImageData.fromJS(_data["originalImageData"]) : <any>null;
            this.programma = _data["programma"] !== undefined ? _data["programma"] : <any>null;
            this.sitoWeb = _data["sitoWeb"] !== undefined ? _data["sitoWeb"] : <any>null;
            this.preventivo = _data["preventivo"] !== undefined ? _data["preventivo"] : <any>null;
            this.miniGuida = _data["miniGuida"] !== undefined ? _data["miniGuida"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
            if (Array.isArray(_data["thumbnails"])) {
                this.thumbnails = [] as any;
                for (let item of _data["thumbnails"])
                    this.thumbnails!.push(ThumbnailData.fromJS(item));
            }
            else {
                this.thumbnails = <any>null;
            }
        }
    }

    static fromJS(data: any): ImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["webUrl"] = this.webUrl !== undefined ? this.webUrl : <any>null;
        data["didascalia"] = this.didascalia !== undefined ? this.didascalia : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["luogoEliminato"] = this.luogoEliminato !== undefined ? this.luogoEliminato : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["servizioObsoleto"] = this.servizioObsoleto !== undefined ? this.servizioObsoleto : <any>null;
        data["servizioEliminato"] = this.servizioEliminato !== undefined ? this.servizioEliminato : <any>null;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        data["articolo"] = this.articolo !== undefined ? this.articolo : <any>null;
        data["nome_it"] = this.nome_it !== undefined ? this.nome_it : <any>null;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : <any>null;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : <any>null;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["originalImageData"] = this.originalImageData ? this.originalImageData.toJSON() : <any>null;
        data["programma"] = this.programma !== undefined ? this.programma : <any>null;
        data["sitoWeb"] = this.sitoWeb !== undefined ? this.sitoWeb : <any>null;
        data["preventivo"] = this.preventivo !== undefined ? this.preventivo : <any>null;
        data["miniGuida"] = this.miniGuida !== undefined ? this.miniGuida : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        if (Array.isArray(this.thumbnails)) {
            data["thumbnails"] = [];
            for (let item of this.thumbnails)
                data["thumbnails"].push(item.toJSON());
        }
        return data;
    }
}

/** Elemento della lista immagini */
export interface IImageResponse {
    /** ID dell'immagine */
    id?: number;
    /** Url assoluta della miniatura */
    webUrl?: string;
    didascalia?: string | null;
    ordine?: number | null;
    luogoID?: number | null;
    luogo?: string | null;
    luogoEliminato?: boolean;
    servizioID?: number | null;
    servizio?: string | null;
    servizioObsoleto?: boolean;
    servizioEliminato?: boolean;
    articoloID?: number | null;
    articolo?: string | null;
    nome_it?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    data?: string;
    /** Dati dell'immagine originale */
    originalImageData?: ImageData | null;
    programma?: boolean | null;
    sitoWeb?: boolean | null;
    preventivo?: boolean | null;
    miniGuida?: boolean | null;
    deleted?: boolean;
    thumbnails?: ThumbnailData[] | null;
}

export class ImageData implements IImageData {
    width?: number;
    height?: number;
    size?: number;

    constructor(data?: IImageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
        }
    }

    static fromJS(data: any): ImageData {
        data = typeof data === 'object' ? data : {};
        let result = new ImageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        return data;
    }
}

export interface IImageData {
    width?: number;
    height?: number;
    size?: number;
}

export class ThumbnailData implements IThumbnailData {
    name?: string | null;
    path?: string | null;

    constructor(data?: IThumbnailData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
        }
    }

    static fromJS(data: any): ThumbnailData {
        data = typeof data === 'object' ? data : {};
        let result = new ThumbnailData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["path"] = this.path !== undefined ? this.path : <any>null;
        return data;
    }
}

export interface IThumbnailData {
    name?: string | null;
    path?: string | null;
}

export class CloneImageRequest extends LocalizedRequest implements ICloneImageRequest {
    immagineID?: number;

    constructor(data?: ICloneImageRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.immagineID = _data["immagineID"] !== undefined ? _data["immagineID"] : <any>null;
        }
    }

    static fromJS(data: any): CloneImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloneImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["immagineID"] = this.immagineID !== undefined ? this.immagineID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICloneImageRequest extends ILocalizedRequest {
    immagineID?: number;
}

export class DeleteImageResponse extends OkApiResponse implements IDeleteImageResponse {

    constructor(data?: IDeleteImageResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DeleteImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteImageResponse extends IOkApiResponse {
}

export class DeleteImageRequest extends LocalizedRequest implements IDeleteImageRequest {
    immagineID?: number;

    constructor(data?: IDeleteImageRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.immagineID = _data["immagineID"] !== undefined ? _data["immagineID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["immagineID"] = this.immagineID !== undefined ? this.immagineID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteImageRequest extends ILocalizedRequest {
    immagineID?: number;
}

export class DeleteMultiImageResponse extends OkApiResponse implements IDeleteMultiImageResponse {

    constructor(data?: IDeleteMultiImageResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DeleteMultiImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMultiImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMultiImageResponse extends IOkApiResponse {
}

export class DeleteMultiImageRequest extends LocalizedRequest implements IDeleteMultiImageRequest {
    immaginiID?: number[] | null;

    constructor(data?: IDeleteMultiImageRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["immaginiID"])) {
                this.immaginiID = [] as any;
                for (let item of _data["immaginiID"])
                    this.immaginiID!.push(item);
            }
            else {
                this.immaginiID = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteMultiImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMultiImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.immaginiID)) {
            data["immaginiID"] = [];
            for (let item of this.immaginiID)
                data["immaginiID"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMultiImageRequest extends ILocalizedRequest {
    immaginiID?: number[] | null;
}

export class ImageGetResponse extends OkApiResponse implements IImageGetResponse {
    image?: ImageResponse;

    constructor(data?: IImageGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? ImageResponse.fromJS(_data["image"]) : <any>null;
        }
    }

    static fromJS(data: any): ImageGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImageGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IImageGetResponse extends IOkApiResponse {
    image?: ImageResponse;
}

export class ImageGetRequest extends LocalizedRequest implements IImageGetRequest {
    immagineId?: number;

    constructor(data?: IImageGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.immagineId = _data["immagineId"] !== undefined ? _data["immagineId"] : <any>null;
        }
    }

    static fromJS(data: any): ImageGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImageGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["immagineId"] = this.immagineId !== undefined ? this.immagineId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IImageGetRequest extends ILocalizedRequest {
    immagineId?: number;
}

/** Enumeratore dei tipi di marker */
export enum EPriceMarkerType {
    Available = "Available",
    OnRequest = "OnRequest",
    Current = "Current",
}

export class NrTableResponseOfImageResponse extends OkApiResponse implements INrTableResponseOfImageResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ImageResponse[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfImageResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ImageResponse.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfImageResponse extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ImageResponse[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ImagesListResponse extends NrTableResponseOfImageResponse implements IImagesListResponse {

    constructor(data?: IImagesListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ImagesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImagesListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IImagesListResponse extends INrTableResponseOfImageResponse {
}

/** Filtri specifici per la lista immagini */
export class ImagesListRequest extends NrTableRequest implements IImagesListRequest {
    imageID?: number | null;
    luogoID?: number | null;
    paeseID?: number | null;
    regioneID?: number | null;
    servizioID?: number | null;
    didascalia?: string | null;
    soloLegateALuogo?: boolean | null;
    filters?: ImagesListFilters | null;
    showDeleted?: boolean;

    constructor(data?: IImagesListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageID = _data["imageID"] !== undefined ? _data["imageID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.paeseID = _data["paeseID"] !== undefined ? _data["paeseID"] : <any>null;
            this.regioneID = _data["regioneID"] !== undefined ? _data["regioneID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.didascalia = _data["didascalia"] !== undefined ? _data["didascalia"] : <any>null;
            this.soloLegateALuogo = _data["soloLegateALuogo"] !== undefined ? _data["soloLegateALuogo"] : <any>null;
            this.filters = _data["filters"] ? ImagesListFilters.fromJS(_data["filters"]) : <any>null;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): ImagesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImagesListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageID"] = this.imageID !== undefined ? this.imageID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["paeseID"] = this.paeseID !== undefined ? this.paeseID : <any>null;
        data["regioneID"] = this.regioneID !== undefined ? this.regioneID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["didascalia"] = this.didascalia !== undefined ? this.didascalia : <any>null;
        data["soloLegateALuogo"] = this.soloLegateALuogo !== undefined ? this.soloLegateALuogo : <any>null;
        data["filters"] = this.filters ? this.filters.toJSON() : <any>null;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Filtri specifici per la lista immagini */
export interface IImagesListRequest extends INrTableRequest {
    imageID?: number | null;
    luogoID?: number | null;
    paeseID?: number | null;
    regioneID?: number | null;
    servizioID?: number | null;
    didascalia?: string | null;
    soloLegateALuogo?: boolean | null;
    filters?: ImagesListFilters | null;
    showDeleted?: boolean;
}

export class ImagesListFilters implements IImagesListFilters {
    sitoWeb?: boolean;
    preventivo?: boolean;
    programma?: boolean;
    miniGuida?: boolean;
    hasValue?: boolean;

    constructor(data?: IImagesListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sitoWeb = _data["sitoWeb"] !== undefined ? _data["sitoWeb"] : <any>null;
            this.preventivo = _data["preventivo"] !== undefined ? _data["preventivo"] : <any>null;
            this.programma = _data["programma"] !== undefined ? _data["programma"] : <any>null;
            this.miniGuida = _data["miniGuida"] !== undefined ? _data["miniGuida"] : <any>null;
            this.hasValue = _data["hasValue"] !== undefined ? _data["hasValue"] : <any>null;
        }
    }

    static fromJS(data: any): ImagesListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new ImagesListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sitoWeb"] = this.sitoWeb !== undefined ? this.sitoWeb : <any>null;
        data["preventivo"] = this.preventivo !== undefined ? this.preventivo : <any>null;
        data["programma"] = this.programma !== undefined ? this.programma : <any>null;
        data["miniGuida"] = this.miniGuida !== undefined ? this.miniGuida : <any>null;
        data["hasValue"] = this.hasValue !== undefined ? this.hasValue : <any>null;
        return data;
    }
}

export interface IImagesListFilters {
    sitoWeb?: boolean;
    preventivo?: boolean;
    programma?: boolean;
    miniGuida?: boolean;
    hasValue?: boolean;
}

export class GetImagesListByLuogoResponse extends OkApiResponse implements IGetImagesListByLuogoResponse {
    imageList?: ImagesListByLuogo[] | null;

    constructor(data?: IGetImagesListByLuogoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["imageList"])) {
                this.imageList = [] as any;
                for (let item of _data["imageList"])
                    this.imageList!.push(ImagesListByLuogo.fromJS(item));
            }
            else {
                this.imageList = <any>null;
            }
        }
    }

    static fromJS(data: any): GetImagesListByLuogoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImagesListByLuogoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageList)) {
            data["imageList"] = [];
            for (let item of this.imageList)
                data["imageList"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetImagesListByLuogoResponse extends IOkApiResponse {
    imageList?: ImagesListByLuogo[] | null;
}

/** Classe usata per richiedere una lista di immagini per idLuogo */
export class ImagesListByLuogo implements IImagesListByLuogo {
    imageID?: number | null;
    luogoID?: number | null;
    didascalia?: string | null;
    url?: string | null;

    constructor(data?: IImagesListByLuogo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageID = _data["imageID"] !== undefined ? _data["imageID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.didascalia = _data["didascalia"] !== undefined ? _data["didascalia"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): ImagesListByLuogo {
        data = typeof data === 'object' ? data : {};
        let result = new ImagesListByLuogo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageID"] = this.imageID !== undefined ? this.imageID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["didascalia"] = this.didascalia !== undefined ? this.didascalia : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

/** Classe usata per richiedere una lista di immagini per idLuogo */
export interface IImagesListByLuogo {
    imageID?: number | null;
    luogoID?: number | null;
    didascalia?: string | null;
    url?: string | null;
}

/** Filtri specifici per la lista immagini */
export class ImagesListByLuogoRequest extends LocalizedRequest implements IImagesListByLuogoRequest {
    luogoID?: number;

    constructor(data?: IImagesListByLuogoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
        }
    }

    static fromJS(data: any): ImagesListByLuogoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImagesListByLuogoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Filtri specifici per la lista immagini */
export interface IImagesListByLuogoRequest extends ILocalizedRequest {
    luogoID?: number;
}

export class GetImageListByImageIdsListResponse extends OkApiResponse implements IGetImageListByImageIdsListResponse {
    imageList?: ImagesListByLuogo[] | null;

    constructor(data?: IGetImageListByImageIdsListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["imageList"])) {
                this.imageList = [] as any;
                for (let item of _data["imageList"])
                    this.imageList!.push(ImagesListByLuogo.fromJS(item));
            }
            else {
                this.imageList = <any>null;
            }
        }
    }

    static fromJS(data: any): GetImageListByImageIdsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImageListByImageIdsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageList)) {
            data["imageList"] = [];
            for (let item of this.imageList)
                data["imageList"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetImageListByImageIdsListResponse extends IOkApiResponse {
    imageList?: ImagesListByLuogo[] | null;
}

/** Filtri specifici per la lista immagini */
export class ImageListByImageIdsRequest extends LocalizedRequest implements IImageListByImageIdsRequest {
    imageIds?: number[] | null;

    constructor(data?: IImageListByImageIdsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["imageIds"])) {
                this.imageIds = [] as any;
                for (let item of _data["imageIds"])
                    this.imageIds!.push(item);
            }
            else {
                this.imageIds = <any>null;
            }
        }
    }

    static fromJS(data: any): ImageListByImageIdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImageListByImageIdsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageIds)) {
            data["imageIds"] = [];
            for (let item of this.imageIds)
                data["imageIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Filtri specifici per la lista immagini */
export interface IImageListByImageIdsRequest extends ILocalizedRequest {
    imageIds?: number[] | null;
}

export class PixabayImportImagesResponse extends OkApiResponse implements IPixabayImportImagesResponse {
    /** Immagini importate */
    images?: ImageResponse[];

    constructor(data?: IPixabayImportImagesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageResponse.fromJS(item));
            }
            else {
                this.images = <any>null;
            }
        }
    }

    static fromJS(data: any): PixabayImportImagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PixabayImportImagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPixabayImportImagesResponse extends IOkApiResponse {
    /** Immagini importate */
    images?: ImageResponse[];
}

export class PixabayImportImagesRequest extends LocalizedRequest implements IPixabayImportImagesRequest {
    /** Lista degli ID da importare */
    iDs?: string[];
    /** ID del luogo da assegnare */
    luogoID?: number | null;
    /** ID del servizio da assegnare */
    servizioID?: number | null;
    /** Se true è utilizzabile sul programma */
    programma?: boolean;
    /** Se true è utilizzabile sul sito */
    sitoWeb?: boolean;
    /** Se true è utilizzabile nel preventivo */
    preventivo?: boolean;
    /** Se true è utilizzabile nella miniguida */
    miniGuida?: boolean;
    /** Lingua per i metadati */
    linguaImport?: ELingua;

    constructor(data?: IPixabayImportImagesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["iDs"])) {
                this.iDs = [] as any;
                for (let item of _data["iDs"])
                    this.iDs!.push(item);
            }
            else {
                this.iDs = <any>null;
            }
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.programma = _data["programma"] !== undefined ? _data["programma"] : <any>null;
            this.sitoWeb = _data["sitoWeb"] !== undefined ? _data["sitoWeb"] : <any>null;
            this.preventivo = _data["preventivo"] !== undefined ? _data["preventivo"] : <any>null;
            this.miniGuida = _data["miniGuida"] !== undefined ? _data["miniGuida"] : <any>null;
            this.linguaImport = _data["linguaImport"] !== undefined ? _data["linguaImport"] : <any>null;
        }
    }

    static fromJS(data: any): PixabayImportImagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PixabayImportImagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.iDs)) {
            data["iDs"] = [];
            for (let item of this.iDs)
                data["iDs"].push(item);
        }
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["programma"] = this.programma !== undefined ? this.programma : <any>null;
        data["sitoWeb"] = this.sitoWeb !== undefined ? this.sitoWeb : <any>null;
        data["preventivo"] = this.preventivo !== undefined ? this.preventivo : <any>null;
        data["miniGuida"] = this.miniGuida !== undefined ? this.miniGuida : <any>null;
        data["linguaImport"] = this.linguaImport !== undefined ? this.linguaImport : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPixabayImportImagesRequest extends ILocalizedRequest {
    /** Lista degli ID da importare */
    iDs?: string[];
    /** ID del luogo da assegnare */
    luogoID?: number | null;
    /** ID del servizio da assegnare */
    servizioID?: number | null;
    /** Se true è utilizzabile sul programma */
    programma?: boolean;
    /** Se true è utilizzabile sul sito */
    sitoWeb?: boolean;
    /** Se true è utilizzabile nel preventivo */
    preventivo?: boolean;
    /** Se true è utilizzabile nella miniguida */
    miniGuida?: boolean;
    /** Lingua per i metadati */
    linguaImport?: ELingua;
}

export class NrTableResponseOfPixabayImageData extends OkApiResponse implements INrTableResponseOfPixabayImageData {
    /** Array delle righe della pagina richiesta */
    rows?: PixabayImageData[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPixabayImageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PixabayImageData.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfPixabayImageData {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPixabayImageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPixabayImageData extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PixabayImageData[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class PixabaySearchResponse extends NrTableResponseOfPixabayImageData implements IPixabaySearchResponse {

    constructor(data?: IPixabaySearchResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PixabaySearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PixabaySearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPixabaySearchResponse extends INrTableResponseOfPixabayImageData {
}

export class PixabayImageData implements IPixabayImageData {
    id?: string | null;
    type?: EImageType;
    pageURL?: string | null;
    tags?: string | null;
    previewURL?: string | null;
    previewWidth?: number;
    previewHeight?: number;
    imageWidth?: number;
    imageHeight?: number;
    imageSize?: number;
    largeImageURL?: string | null;

    constructor(data?: IPixabayImageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.pageURL = _data["pageURL"] !== undefined ? _data["pageURL"] : <any>null;
            this.tags = _data["tags"] !== undefined ? _data["tags"] : <any>null;
            this.previewURL = _data["previewURL"] !== undefined ? _data["previewURL"] : <any>null;
            this.previewWidth = _data["previewWidth"] !== undefined ? _data["previewWidth"] : <any>null;
            this.previewHeight = _data["previewHeight"] !== undefined ? _data["previewHeight"] : <any>null;
            this.imageWidth = _data["imageWidth"] !== undefined ? _data["imageWidth"] : <any>null;
            this.imageHeight = _data["imageHeight"] !== undefined ? _data["imageHeight"] : <any>null;
            this.imageSize = _data["imageSize"] !== undefined ? _data["imageSize"] : <any>null;
            this.largeImageURL = _data["largeImageURL"] !== undefined ? _data["largeImageURL"] : <any>null;
        }
    }

    static fromJS(data: any): PixabayImageData {
        data = typeof data === 'object' ? data : {};
        let result = new PixabayImageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["pageURL"] = this.pageURL !== undefined ? this.pageURL : <any>null;
        data["tags"] = this.tags !== undefined ? this.tags : <any>null;
        data["previewURL"] = this.previewURL !== undefined ? this.previewURL : <any>null;
        data["previewWidth"] = this.previewWidth !== undefined ? this.previewWidth : <any>null;
        data["previewHeight"] = this.previewHeight !== undefined ? this.previewHeight : <any>null;
        data["imageWidth"] = this.imageWidth !== undefined ? this.imageWidth : <any>null;
        data["imageHeight"] = this.imageHeight !== undefined ? this.imageHeight : <any>null;
        data["imageSize"] = this.imageSize !== undefined ? this.imageSize : <any>null;
        data["largeImageURL"] = this.largeImageURL !== undefined ? this.largeImageURL : <any>null;
        return data;
    }
}

export interface IPixabayImageData {
    id?: string | null;
    type?: EImageType;
    pageURL?: string | null;
    tags?: string | null;
    previewURL?: string | null;
    previewWidth?: number;
    previewHeight?: number;
    imageWidth?: number;
    imageHeight?: number;
    imageSize?: number;
    largeImageURL?: string | null;
}

export enum EImageType {
    All = "all",
    Photo = "photo",
    Illustration = "illustration",
    Vector = "vector",
}

export class PixabaySearchRequest extends NrTableRequest implements IPixabaySearchRequest {
    query?: PixabayQuery | null;

    constructor(data?: IPixabaySearchRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.query = _data["query"] ? PixabayQuery.fromJS(_data["query"]) : <any>null;
        }
    }

    static fromJS(data: any): PixabaySearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PixabaySearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPixabaySearchRequest extends INrTableRequest {
    query?: PixabayQuery | null;
}

export class PixabayQuery implements IPixabayQuery {
    query!: string;
    id?: string | null;
    lingua?: ELingua;
    imageType?: EImageType;
    orientation?: EImageOrientation;
    category?: EImageCategory | null;
    minWidth?: number;
    minHeight?: number;
    editorsChoiche?: boolean;
    safeSearch?: boolean;
    sortOrder?: ESortOrder;
    pageNr?: number;
    perPage?: number;

    constructor(data?: IPixabayQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] !== undefined ? _data["query"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.imageType = _data["imageType"] !== undefined ? _data["imageType"] : <any>null;
            this.orientation = _data["orientation"] !== undefined ? _data["orientation"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.minWidth = _data["minWidth"] !== undefined ? _data["minWidth"] : <any>null;
            this.minHeight = _data["minHeight"] !== undefined ? _data["minHeight"] : <any>null;
            this.editorsChoiche = _data["editorsChoiche"] !== undefined ? _data["editorsChoiche"] : <any>null;
            this.safeSearch = _data["safeSearch"] !== undefined ? _data["safeSearch"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.pageNr = _data["pageNr"] !== undefined ? _data["pageNr"] : <any>null;
            this.perPage = _data["perPage"] !== undefined ? _data["perPage"] : <any>null;
        }
    }

    static fromJS(data: any): PixabayQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PixabayQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query !== undefined ? this.query : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["imageType"] = this.imageType !== undefined ? this.imageType : <any>null;
        data["orientation"] = this.orientation !== undefined ? this.orientation : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["minWidth"] = this.minWidth !== undefined ? this.minWidth : <any>null;
        data["minHeight"] = this.minHeight !== undefined ? this.minHeight : <any>null;
        data["editorsChoiche"] = this.editorsChoiche !== undefined ? this.editorsChoiche : <any>null;
        data["safeSearch"] = this.safeSearch !== undefined ? this.safeSearch : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["pageNr"] = this.pageNr !== undefined ? this.pageNr : <any>null;
        data["perPage"] = this.perPage !== undefined ? this.perPage : <any>null;
        return data;
    }
}

export interface IPixabayQuery {
    query: string;
    id?: string | null;
    lingua?: ELingua;
    imageType?: EImageType;
    orientation?: EImageOrientation;
    category?: EImageCategory | null;
    minWidth?: number;
    minHeight?: number;
    editorsChoiche?: boolean;
    safeSearch?: boolean;
    sortOrder?: ESortOrder;
    pageNr?: number;
    perPage?: number;
}

export enum EImageOrientation {
    All = "all",
    Horizontal = "horizontal",
    Vertical = "vertical",
}

export enum EImageCategory {
    Backgrounds = "backgrounds",
    Fashion = "fashion",
    Nature = "nature",
    Science = "science",
    Education = "education",
    Feelings = "feelings",
    Health = "health",
    People = "people",
    Religion = "religion",
    Places = "places",
    Animals = "animals",
    Industry = "industry",
    Computer = "computer",
    Food = "food",
    Sports = "sports",
    Transportation = "transportation",
    Travel = "travel",
    Buildings = "buildings",
    Business = "business",
    Music = "music",
}

export enum ESortOrder {
    Popular = "popular",
    Latest = "latest",
}

export class RestoreImageResponse extends OkApiResponse implements IRestoreImageResponse {

    constructor(data?: IRestoreImageResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): RestoreImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreImageResponse extends IOkApiResponse {
}

export class RestoreImageRequest extends LocalizedRequest implements IRestoreImageRequest {
    immagineID?: number;

    constructor(data?: IRestoreImageRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.immagineID = _data["immagineID"] !== undefined ? _data["immagineID"] : <any>null;
        }
    }

    static fromJS(data: any): RestoreImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["immagineID"] = this.immagineID !== undefined ? this.immagineID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreImageRequest extends ILocalizedRequest {
    immagineID?: number;
}

export class UpdateImageResponse extends OkApiResponse implements IUpdateImageResponse {
    immagine?: ImageResponse | null;

    constructor(data?: IUpdateImageResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.immagine = _data["immagine"] ? ImageResponse.fromJS(_data["immagine"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["immagine"] = this.immagine ? this.immagine.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateImageResponse extends IOkApiResponse {
    immagine?: ImageResponse | null;
}

export class UpdateImageRequest extends LocalizedRequest implements IUpdateImageRequest {
    immagineID?: number;
    luogoID?: number | null;
    servizioID?: number | null;
    articoloID?: number | null;
    ordine?: number;
    nome_it?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    programma?: boolean;
    sitoWeb?: boolean;
    preventivo?: boolean;
    miniGuida?: boolean;
    hash?: string | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;

    constructor(data?: IUpdateImageRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.immagineID = _data["immagineID"] !== undefined ? _data["immagineID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.nome_it = _data["nome_it"] !== undefined ? _data["nome_it"] : <any>null;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : <any>null;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : <any>null;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.programma = _data["programma"] !== undefined ? _data["programma"] : <any>null;
            this.sitoWeb = _data["sitoWeb"] !== undefined ? _data["sitoWeb"] : <any>null;
            this.preventivo = _data["preventivo"] !== undefined ? _data["preventivo"] : <any>null;
            this.miniGuida = _data["miniGuida"] !== undefined ? _data["miniGuida"] : <any>null;
            this.hash = _data["hash"] !== undefined ? _data["hash"] : <any>null;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
            this.deletedAt = _data["deletedAt"] !== undefined ? _data["deletedAt"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["immagineID"] = this.immagineID !== undefined ? this.immagineID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["nome_it"] = this.nome_it !== undefined ? this.nome_it : <any>null;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : <any>null;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : <any>null;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["programma"] = this.programma !== undefined ? this.programma : <any>null;
        data["sitoWeb"] = this.sitoWeb !== undefined ? this.sitoWeb : <any>null;
        data["preventivo"] = this.preventivo !== undefined ? this.preventivo : <any>null;
        data["miniGuida"] = this.miniGuida !== undefined ? this.miniGuida : <any>null;
        data["hash"] = this.hash !== undefined ? this.hash : <any>null;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        data["deletedAt"] = this.deletedAt !== undefined ? this.deletedAt : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateImageRequest extends ILocalizedRequest {
    immagineID?: number;
    luogoID?: number | null;
    servizioID?: number | null;
    articoloID?: number | null;
    ordine?: number;
    nome_it?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    programma?: boolean;
    sitoWeb?: boolean;
    preventivo?: boolean;
    miniGuida?: boolean;
    hash?: string | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
}

export class UploadImageResponse extends OkApiResponse implements IUploadImageResponse {
    immagine?: ImageResponse;

    constructor(data?: IUploadImageResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.immagine = _data["immagine"] ? ImageResponse.fromJS(_data["immagine"]) : <any>null;
        }
    }

    static fromJS(data: any): UploadImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["immagine"] = this.immagine ? this.immagine.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUploadImageResponse extends IOkApiResponse {
    immagine?: ImageResponse;
}

export class InsuranceGetResponse extends OkApiResponse implements IInsuranceGetResponse {
    insurance?: Assicurazione | null;

    constructor(data?: IInsuranceGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.insurance = _data["insurance"] ? Assicurazione.fromJS(_data["insurance"]) : <any>null;
        }
    }

    static fromJS(data: any): InsuranceGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insurance"] = this.insurance ? this.insurance.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInsuranceGetResponse extends IOkApiResponse {
    insurance?: Assicurazione | null;
}

export class Assicurazione implements IAssicurazione {
    id?: number;
    codice!: string;
    codiceTemplateEmail?: string | null;
    nome!: string;
    query?: string | null;
    abilitata?: boolean;
    orarioInvio!: string;
    modalitaCalendario?: EModalitaCalendarioAssicurazione;
    tipoOperazioneDB?: ETipoOperazioneDbAssicurazione | null;
    oraInvio?: number;
    minutoInvio?: number;
    servizioID?: number | null;

    constructor(data?: IAssicurazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.codiceTemplateEmail = _data["codiceTemplateEmail"] !== undefined ? _data["codiceTemplateEmail"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.query = _data["query"] !== undefined ? _data["query"] : <any>null;
            this.abilitata = _data["abilitata"] !== undefined ? _data["abilitata"] : <any>null;
            this.orarioInvio = _data["orarioInvio"] !== undefined ? _data["orarioInvio"] : <any>null;
            this.modalitaCalendario = _data["modalitaCalendario"] !== undefined ? _data["modalitaCalendario"] : <any>null;
            this.tipoOperazioneDB = _data["tipoOperazioneDB"] !== undefined ? _data["tipoOperazioneDB"] : <any>null;
            this.oraInvio = _data["oraInvio"] !== undefined ? _data["oraInvio"] : <any>null;
            this.minutoInvio = _data["minutoInvio"] !== undefined ? _data["minutoInvio"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
        }
    }

    static fromJS(data: any): Assicurazione {
        data = typeof data === 'object' ? data : {};
        let result = new Assicurazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["codiceTemplateEmail"] = this.codiceTemplateEmail !== undefined ? this.codiceTemplateEmail : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["query"] = this.query !== undefined ? this.query : <any>null;
        data["abilitata"] = this.abilitata !== undefined ? this.abilitata : <any>null;
        data["orarioInvio"] = this.orarioInvio !== undefined ? this.orarioInvio : <any>null;
        data["modalitaCalendario"] = this.modalitaCalendario !== undefined ? this.modalitaCalendario : <any>null;
        data["tipoOperazioneDB"] = this.tipoOperazioneDB !== undefined ? this.tipoOperazioneDB : <any>null;
        data["oraInvio"] = this.oraInvio !== undefined ? this.oraInvio : <any>null;
        data["minutoInvio"] = this.minutoInvio !== undefined ? this.minutoInvio : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        return data;
    }
}

export interface IAssicurazione {
    id?: number;
    codice: string;
    codiceTemplateEmail?: string | null;
    nome: string;
    query?: string | null;
    abilitata?: boolean;
    orarioInvio: string;
    modalitaCalendario?: EModalitaCalendarioAssicurazione;
    tipoOperazioneDB?: ETipoOperazioneDbAssicurazione | null;
    oraInvio?: number;
    minutoInvio?: number;
    servizioID?: number | null;
}

export enum EModalitaCalendarioAssicurazione {
    Quotidiano = "Quotidiano",
    Feriali = "Feriali",
    Mensile = "Mensile",
    Filodiretto = "Filodiretto",
}

export enum ETipoOperazioneDbAssicurazione {
    Nessuna = "Nessuna",
    RischioZeroInsert = "RischioZeroInsert",
    FiloDirettoInsert = "FiloDirettoInsert",
    FiloDirettoUpdate = "FiloDirettoUpdate",
}

export class InsuranceGetRequest extends LocalizedRequest implements IInsuranceGetRequest {
    insuranceID?: number;

    constructor(data?: IInsuranceGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.insuranceID = _data["insuranceID"] !== undefined ? _data["insuranceID"] : <any>null;
        }
    }

    static fromJS(data: any): InsuranceGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceID"] = this.insuranceID !== undefined ? this.insuranceID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInsuranceGetRequest extends ILocalizedRequest {
    insuranceID?: number;
}

export class NrTableResponseOfInsuranceRow extends OkApiResponse implements INrTableResponseOfInsuranceRow {
    /** Array delle righe della pagina richiesta */
    rows?: InsuranceRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfInsuranceRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(InsuranceRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfInsuranceRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfInsuranceRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfInsuranceRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: InsuranceRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class InsuranceListResponse extends NrTableResponseOfInsuranceRow implements IInsuranceListResponse {

    constructor(data?: IInsuranceListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): InsuranceListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IInsuranceListResponse extends INrTableResponseOfInsuranceRow {
}

export class InsuranceRow implements IInsuranceRow {
    id?: number;
    insurance?: Assicurazione | null;
    lastSend?: AssicurazioneInvio | null;

    constructor(data?: IInsuranceRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.insurance = _data["insurance"] ? Assicurazione.fromJS(_data["insurance"]) : <any>null;
            this.lastSend = _data["lastSend"] ? AssicurazioneInvio.fromJS(_data["lastSend"]) : <any>null;
        }
    }

    static fromJS(data: any): InsuranceRow {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["insurance"] = this.insurance ? this.insurance.toJSON() : <any>null;
        data["lastSend"] = this.lastSend ? this.lastSend.toJSON() : <any>null;
        return data;
    }
}

export interface IInsuranceRow {
    id?: number;
    insurance?: Assicurazione | null;
    lastSend?: AssicurazioneInvio | null;
}

export class AssicurazioneInvio implements IAssicurazioneInvio {
    id?: number;
    assicurazioneID?: number;
    data?: string;
    rowCount?: number;
    esito?: EEsitoInvioAssicurazione;
    jsonData?: string | null;
    messaggio?: string | null;

    constructor(data?: IAssicurazioneInvio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.assicurazioneID = _data["assicurazioneID"] !== undefined ? _data["assicurazioneID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : <any>null;
            this.esito = _data["esito"] !== undefined ? _data["esito"] : <any>null;
            this.jsonData = _data["jsonData"] !== undefined ? _data["jsonData"] : <any>null;
            this.messaggio = _data["messaggio"] !== undefined ? _data["messaggio"] : <any>null;
        }
    }

    static fromJS(data: any): AssicurazioneInvio {
        data = typeof data === 'object' ? data : {};
        let result = new AssicurazioneInvio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["assicurazioneID"] = this.assicurazioneID !== undefined ? this.assicurazioneID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : <any>null;
        data["esito"] = this.esito !== undefined ? this.esito : <any>null;
        data["jsonData"] = this.jsonData !== undefined ? this.jsonData : <any>null;
        data["messaggio"] = this.messaggio !== undefined ? this.messaggio : <any>null;
        return data;
    }
}

export interface IAssicurazioneInvio {
    id?: number;
    assicurazioneID?: number;
    data?: string;
    rowCount?: number;
    esito?: EEsitoInvioAssicurazione;
    jsonData?: string | null;
    messaggio?: string | null;
}

export enum EEsitoInvioAssicurazione {
    Ok = "Ok",
    Errore = "Errore",
}

export class InsuranceListRequest extends NrTableRequest implements IInsuranceListRequest {

    constructor(data?: IInsuranceListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): InsuranceListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IInsuranceListRequest extends INrTableRequest {
}

export class NrTableResponseOfAssicurazioneInvio extends OkApiResponse implements INrTableResponseOfAssicurazioneInvio {
    /** Array delle righe della pagina richiesta */
    rows?: AssicurazioneInvio[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAssicurazioneInvio) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AssicurazioneInvio.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfAssicurazioneInvio {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAssicurazioneInvio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAssicurazioneInvio extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AssicurazioneInvio[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class InsuranceSendsListResponse extends NrTableResponseOfAssicurazioneInvio implements IInsuranceSendsListResponse {

    constructor(data?: IInsuranceSendsListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): InsuranceSendsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceSendsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IInsuranceSendsListResponse extends INrTableResponseOfAssicurazioneInvio {
}

export class InsuranceSendsListRequest extends NrTableRequest implements IInsuranceSendsListRequest {
    insuranceID?: number;

    constructor(data?: IInsuranceSendsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.insuranceID = _data["insuranceID"] !== undefined ? _data["insuranceID"] : <any>null;
        }
    }

    static fromJS(data: any): InsuranceSendsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceSendsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceID"] = this.insuranceID !== undefined ? this.insuranceID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInsuranceSendsListRequest extends INrTableRequest {
    insuranceID?: number;
}

export class NrTableResponseOfLinkRow extends OkApiResponse implements INrTableResponseOfLinkRow {
    /** Array delle righe della pagina richiesta */
    rows?: LinkRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfLinkRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(LinkRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfLinkRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfLinkRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfLinkRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: LinkRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class LinkRow implements ILinkRow {
    id?: number;
    nome?: string | null;
    ordine?: number;
    servizioID?: number | null;
    servizio?: string | null;
    luogoID?: number | null;
    luogo?: string | null;
    tipo?: ETipoLink;
    posizione?: EPosizioneLink;

    constructor(data?: ILinkRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.posizione = _data["posizione"] !== undefined ? _data["posizione"] : <any>null;
        }
    }

    static fromJS(data: any): LinkRow {
        data = typeof data === 'object' ? data : {};
        let result = new LinkRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["posizione"] = this.posizione !== undefined ? this.posizione : <any>null;
        return data;
    }
}

export interface ILinkRow {
    id?: number;
    nome?: string | null;
    ordine?: number;
    servizioID?: number | null;
    servizio?: string | null;
    luogoID?: number | null;
    luogo?: string | null;
    tipo?: ETipoLink;
    posizione?: EPosizioneLink;
}

export class GetLinksListRequest extends NrTableRequest implements IGetLinksListRequest {
    nome?: string | null;
    tipoLink?: ETipoLink | null;
    tipoLuogo?: ETipoLuogo | null;
    luogoID?: number | null;

    constructor(data?: IGetLinksListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.tipoLink = _data["tipoLink"] !== undefined ? _data["tipoLink"] : <any>null;
            this.tipoLuogo = _data["tipoLuogo"] !== undefined ? _data["tipoLuogo"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
        }
    }

    static fromJS(data: any): GetLinksListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLinksListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["tipoLink"] = this.tipoLink !== undefined ? this.tipoLink : <any>null;
        data["tipoLuogo"] = this.tipoLuogo !== undefined ? this.tipoLuogo : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLinksListRequest extends INrTableRequest {
    nome?: string | null;
    tipoLink?: ETipoLink | null;
    tipoLuogo?: ETipoLuogo | null;
    luogoID?: number | null;
}

export enum ETipoLuogo {
    Aeroporto = "Aeroporto",
    SubzonaAerea = "SubzonaAerea",
    Paese = "Paese",
    Regione = "Regione",
    Citta = "Citta",
    Area = "Area",
    GruppiDiCitta = "GruppiDiCitta",
    PuntoNoleggio = "PuntoNoleggio",
    PaginaWeb = "PaginaWeb",
    PaginaTci = "PaginaTci",
    Destinazione = "Destinazione",
    IdeeDiViaggio = "IdeeDiViaggio",
}

export class CheckServiziResponse extends OkApiResponse implements ICheckServiziResponse {
    rows?: CheckServiziRow[] | null;

    constructor(data?: ICheckServiziResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CheckServiziRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): CheckServiziResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckServiziResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICheckServiziResponse extends IOkApiResponse {
    rows?: CheckServiziRow[] | null;
}

export class CheckServiziRow implements ICheckServiziRow {
    luogo?: string | null;
    tipo?: string | null;
    servizio?: string | null;
    idServizio?: number | null;
    web?: number | null;
    preferito?: boolean | null;
    contatto?: string | null;
    idContatto?: number | null;
    articleDate?: string | null;
    totDati?: number | null;
    images?: number | null;
    part?: string | null;
    lastPrice?: string | null;
    h2HSuppliers?: number | null;
    allot?: string | null;
    latitude?: number | null;
    longitude?: number | null;

    constructor(data?: ICheckServiziRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.idServizio = _data["idServizio"] !== undefined ? _data["idServizio"] : <any>null;
            this.web = _data["web"] !== undefined ? _data["web"] : <any>null;
            this.preferito = _data["preferito"] !== undefined ? _data["preferito"] : <any>null;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : <any>null;
            this.idContatto = _data["idContatto"] !== undefined ? _data["idContatto"] : <any>null;
            this.articleDate = _data["articleDate"] !== undefined ? _data["articleDate"] : <any>null;
            this.totDati = _data["totDati"] !== undefined ? _data["totDati"] : <any>null;
            this.images = _data["images"] !== undefined ? _data["images"] : <any>null;
            this.part = _data["part"] !== undefined ? _data["part"] : <any>null;
            this.lastPrice = _data["lastPrice"] !== undefined ? _data["lastPrice"] : <any>null;
            this.h2HSuppliers = _data["h2HSuppliers"] !== undefined ? _data["h2HSuppliers"] : <any>null;
            this.allot = _data["allot"] !== undefined ? _data["allot"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
        }
    }

    static fromJS(data: any): CheckServiziRow {
        data = typeof data === 'object' ? data : {};
        let result = new CheckServiziRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["idServizio"] = this.idServizio !== undefined ? this.idServizio : <any>null;
        data["web"] = this.web !== undefined ? this.web : <any>null;
        data["preferito"] = this.preferito !== undefined ? this.preferito : <any>null;
        data["contatto"] = this.contatto !== undefined ? this.contatto : <any>null;
        data["idContatto"] = this.idContatto !== undefined ? this.idContatto : <any>null;
        data["articleDate"] = this.articleDate !== undefined ? this.articleDate : <any>null;
        data["totDati"] = this.totDati !== undefined ? this.totDati : <any>null;
        data["images"] = this.images !== undefined ? this.images : <any>null;
        data["part"] = this.part !== undefined ? this.part : <any>null;
        data["lastPrice"] = this.lastPrice !== undefined ? this.lastPrice : <any>null;
        data["h2HSuppliers"] = this.h2HSuppliers !== undefined ? this.h2HSuppliers : <any>null;
        data["allot"] = this.allot !== undefined ? this.allot : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        return data;
    }
}

export interface ICheckServiziRow {
    luogo?: string | null;
    tipo?: string | null;
    servizio?: string | null;
    idServizio?: number | null;
    web?: number | null;
    preferito?: boolean | null;
    contatto?: string | null;
    idContatto?: number | null;
    articleDate?: string | null;
    totDati?: number | null;
    images?: number | null;
    part?: string | null;
    lastPrice?: string | null;
    h2HSuppliers?: number | null;
    allot?: string | null;
    latitude?: number | null;
    longitude?: number | null;
}

export class CheckServiziRequest extends LocalizedRequest implements ICheckServiziRequest {
    luogoId?: number;
    export?: boolean;

    constructor(data?: ICheckServiziRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : <any>null;
            this.export = _data["export"] !== undefined ? _data["export"] : <any>null;
        }
    }

    static fromJS(data: any): CheckServiziRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckServiziRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : <any>null;
        data["export"] = this.export !== undefined ? this.export : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICheckServiziRequest extends ILocalizedRequest {
    luogoId?: number;
    export?: boolean;
}

export class LocationDetail extends OkApiResponse implements ILocationDetail {
    luogo?: Luogo | null;
    mappa?: Mappa | null;

    constructor(data?: ILocationDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogo = _data["luogo"] ? Luogo.fromJS(_data["luogo"]) : <any>null;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : <any>null;
        }
    }

    static fromJS(data: any): LocationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ILocationDetail extends IOkApiResponse {
    luogo?: Luogo | null;
    mappa?: Mappa | null;
}

export class Luogo implements ILuogo {
    luogoID?: number;
    nome!: string;
    pubblicazione1?: EStatoPubblicazioneLuogo | null;
    pubblicazione2?: EStatoPubblicazioneLuogo | null;
    pubblicazione3?: EStatoPubblicazioneLuogo | null;
    pubblicazione4?: EStatoPubblicazioneLuogo | null;
    tipo?: ETipoLuogo;
    cee?: boolean | null;
    iata?: string | null;
    tipoRicerca?: ETipoRicercaLuogo | null;
    autoFillFlags?: EAutofillFlags;
    provincia?: string | null;
    capoluogoProvincia?: boolean;
    giataCodeType?: ETipoLuogoGiata | null;
    giataCode?: string | null;
    modoNonMappati?: EModalitaNonMappati;
    popolarita?: number | null;
    nome_en?: string | null;
    traduzioni?: LocationTranslation[] | null;
    pubblicazioni?: LocationPublish[] | null;
    nascondiNrf?: boolean;
    eliminato?: string | null;
    cacheBypass?: boolean;
    codice?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
    astoiID?: number | null;

    constructor(data?: ILuogo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.pubblicazione1 = _data["pubblicazione1"] !== undefined ? _data["pubblicazione1"] : <any>null;
            this.pubblicazione2 = _data["pubblicazione2"] !== undefined ? _data["pubblicazione2"] : <any>null;
            this.pubblicazione3 = _data["pubblicazione3"] !== undefined ? _data["pubblicazione3"] : <any>null;
            this.pubblicazione4 = _data["pubblicazione4"] !== undefined ? _data["pubblicazione4"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.cee = _data["cee"] !== undefined ? _data["cee"] : <any>null;
            this.iata = _data["iata"] !== undefined ? _data["iata"] : <any>null;
            this.tipoRicerca = _data["tipoRicerca"] !== undefined ? _data["tipoRicerca"] : <any>null;
            this.autoFillFlags = _data["autoFillFlags"] !== undefined ? _data["autoFillFlags"] : <any>null;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : <any>null;
            this.capoluogoProvincia = _data["capoluogoProvincia"] !== undefined ? _data["capoluogoProvincia"] : <any>null;
            this.giataCodeType = _data["giataCodeType"] !== undefined ? _data["giataCodeType"] : <any>null;
            this.giataCode = _data["giataCode"] !== undefined ? _data["giataCode"] : <any>null;
            this.modoNonMappati = _data["modoNonMappati"] !== undefined ? _data["modoNonMappati"] : <any>null;
            this.popolarita = _data["popolarita"] !== undefined ? _data["popolarita"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(LocationTranslation.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            if (Array.isArray(_data["pubblicazioni"])) {
                this.pubblicazioni = [] as any;
                for (let item of _data["pubblicazioni"])
                    this.pubblicazioni!.push(LocationPublish.fromJS(item));
            }
            else {
                this.pubblicazioni = <any>null;
            }
            this.nascondiNrf = _data["nascondiNrf"] !== undefined ? _data["nascondiNrf"] : <any>null;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : <any>null;
            this.cacheBypass = _data["cacheBypass"] !== undefined ? _data["cacheBypass"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
            this.astoiID = _data["astoiID"] !== undefined ? _data["astoiID"] : <any>null;
        }
    }

    static fromJS(data: any): Luogo {
        data = typeof data === 'object' ? data : {};
        let result = new Luogo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["pubblicazione1"] = this.pubblicazione1 !== undefined ? this.pubblicazione1 : <any>null;
        data["pubblicazione2"] = this.pubblicazione2 !== undefined ? this.pubblicazione2 : <any>null;
        data["pubblicazione3"] = this.pubblicazione3 !== undefined ? this.pubblicazione3 : <any>null;
        data["pubblicazione4"] = this.pubblicazione4 !== undefined ? this.pubblicazione4 : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["cee"] = this.cee !== undefined ? this.cee : <any>null;
        data["iata"] = this.iata !== undefined ? this.iata : <any>null;
        data["tipoRicerca"] = this.tipoRicerca !== undefined ? this.tipoRicerca : <any>null;
        data["autoFillFlags"] = this.autoFillFlags !== undefined ? this.autoFillFlags : <any>null;
        data["provincia"] = this.provincia !== undefined ? this.provincia : <any>null;
        data["capoluogoProvincia"] = this.capoluogoProvincia !== undefined ? this.capoluogoProvincia : <any>null;
        data["giataCodeType"] = this.giataCodeType !== undefined ? this.giataCodeType : <any>null;
        data["giataCode"] = this.giataCode !== undefined ? this.giataCode : <any>null;
        data["modoNonMappati"] = this.modoNonMappati !== undefined ? this.modoNonMappati : <any>null;
        data["popolarita"] = this.popolarita !== undefined ? this.popolarita : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        if (Array.isArray(this.pubblicazioni)) {
            data["pubblicazioni"] = [];
            for (let item of this.pubblicazioni)
                data["pubblicazioni"].push(item.toJSON());
        }
        data["nascondiNrf"] = this.nascondiNrf !== undefined ? this.nascondiNrf : <any>null;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : <any>null;
        data["cacheBypass"] = this.cacheBypass !== undefined ? this.cacheBypass : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        data["astoiID"] = this.astoiID !== undefined ? this.astoiID : <any>null;
        return data;
    }
}

export interface ILuogo {
    luogoID?: number;
    nome: string;
    pubblicazione1?: EStatoPubblicazioneLuogo | null;
    pubblicazione2?: EStatoPubblicazioneLuogo | null;
    pubblicazione3?: EStatoPubblicazioneLuogo | null;
    pubblicazione4?: EStatoPubblicazioneLuogo | null;
    tipo?: ETipoLuogo;
    cee?: boolean | null;
    iata?: string | null;
    tipoRicerca?: ETipoRicercaLuogo | null;
    autoFillFlags?: EAutofillFlags;
    provincia?: string | null;
    capoluogoProvincia?: boolean;
    giataCodeType?: ETipoLuogoGiata | null;
    giataCode?: string | null;
    modoNonMappati?: EModalitaNonMappati;
    popolarita?: number | null;
    nome_en?: string | null;
    traduzioni?: LocationTranslation[] | null;
    pubblicazioni?: LocationPublish[] | null;
    nascondiNrf?: boolean;
    eliminato?: string | null;
    cacheBypass?: boolean;
    codice?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
    astoiID?: number | null;
}

export enum EStatoPubblicazioneLuogo {
    NonPubblicato = "NonPubblicato",
    PubblicaWeb = "PubblicaWeb",
    PubblicaIntranet = "PubblicaIntranet",
}

export enum ETipoRicercaLuogo {
    NoRicerca = "NoRicerca",
    Tutto = "Tutto",
    TuttoSalvoHotel = "TuttoSalvoHotel",
    SoloTour = "SoloTour",
}

export enum ETipoLuogoGiata {
    Paese = "Paese",
    Destinazione = "Destinazione",
    Citta = "Citta",
}

export enum EModalitaNonMappati {
    NonAttivi = "NonAttivi",
    SuRichiesta = "SuRichiesta",
    Sempre = "Sempre",
}

export class LocationTranslation extends WebTranslation implements ILocationTranslation {

    constructor(data?: ILocationTranslation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): LocationTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILocationTranslation extends IWebTranslation {
}

export class LocationPublish extends WebsitePublish implements ILocationPublish {
    statoPubblicazione?: EStatoPubblicazioneLuogo;

    constructor(data?: ILocationPublish) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statoPubblicazione = _data["statoPubblicazione"] !== undefined ? _data["statoPubblicazione"] : <any>null;
        }
    }

    static fromJS(data: any): LocationPublish {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPublish();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statoPubblicazione"] = this.statoPubblicazione !== undefined ? this.statoPubblicazione : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ILocationPublish extends IWebsitePublish {
    statoPubblicazione?: EStatoPubblicazioneLuogo;
}

export class CreateLocationRequest extends LocalizedRequest implements ICreateLocationRequest {
    luogo?: Luogo | null;

    constructor(data?: ICreateLocationRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogo = _data["luogo"] ? Luogo.fromJS(_data["luogo"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateLocationRequest extends ILocalizedRequest {
    luogo?: Luogo | null;
}

export class DeleteLocationRequest extends LocalizedRequest implements IDeleteLocationRequest {
    luogoId?: number;

    constructor(data?: IDeleteLocationRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteLocationRequest extends ILocalizedRequest {
    luogoId?: number;
}

export class DeleteMappaRequest extends LocalizedRequest implements IDeleteMappaRequest {
    luogoId?: number;

    constructor(data?: IDeleteMappaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteMappaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMappaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMappaRequest extends ILocalizedRequest {
    luogoId?: number;
}

export class GetLocationRequest extends LocalizedRequest implements IGetLocationRequest {
    luogoId?: number;

    constructor(data?: IGetLocationRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : <any>null;
        }
    }

    static fromJS(data: any): GetLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLocationRequest extends ILocalizedRequest {
    luogoId?: number;
}

export class LuogoRelazioneResponse extends OkApiResponse implements ILuogoRelazioneResponse {
    rows?: LuogoRelazioneRow[] | null;

    constructor(data?: ILuogoRelazioneResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(LuogoRelazioneRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): LuogoRelazioneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoRelazioneResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILuogoRelazioneResponse extends IOkApiResponse {
    rows?: LuogoRelazioneRow[] | null;
}

export class LuogoRelazioneRow implements ILuogoRelazioneRow {
    luogoID?: number;
    luogoPadreId?: number;
    relazioneId?: number;

    constructor(data?: ILuogoRelazioneRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogoPadreId = _data["luogoPadreId"] !== undefined ? _data["luogoPadreId"] : <any>null;
            this.relazioneId = _data["relazioneId"] !== undefined ? _data["relazioneId"] : <any>null;
        }
    }

    static fromJS(data: any): LuogoRelazioneRow {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoRelazioneRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogoPadreId"] = this.luogoPadreId !== undefined ? this.luogoPadreId : <any>null;
        data["relazioneId"] = this.relazioneId !== undefined ? this.relazioneId : <any>null;
        return data;
    }
}

export interface ILuogoRelazioneRow {
    luogoID?: number;
    luogoPadreId?: number;
    relazioneId?: number;
}

export class GetLuogoDistanzeRequest extends LocalizedRequest implements IGetLuogoDistanzeRequest {
    luogoId?: number;

    constructor(data?: IGetLuogoDistanzeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : <any>null;
        }
    }

    static fromJS(data: any): GetLuogoDistanzeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuogoDistanzeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLuogoDistanzeRequest extends ILocalizedRequest {
    luogoId?: number;
}

export class GetLuoghiRelazioniRequest extends LocalizedRequest implements IGetLuoghiRelazioniRequest {
    luogoId?: number;

    constructor(data?: IGetLuoghiRelazioniRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : <any>null;
        }
    }

    static fromJS(data: any): GetLuoghiRelazioniRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuoghiRelazioniRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLuoghiRelazioniRequest extends ILocalizedRequest {
    luogoId?: number;
}

export class LuoghiViciniResponse extends OkApiResponse implements ILuoghiViciniResponse {
    luoghiViciniIDs?: number[] | null;

    constructor(data?: ILuoghiViciniResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["luoghiViciniIDs"])) {
                this.luoghiViciniIDs = [] as any;
                for (let item of _data["luoghiViciniIDs"])
                    this.luoghiViciniIDs!.push(item);
            }
            else {
                this.luoghiViciniIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): LuoghiViciniResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LuoghiViciniResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.luoghiViciniIDs)) {
            data["luoghiViciniIDs"] = [];
            for (let item of this.luoghiViciniIDs)
                data["luoghiViciniIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILuoghiViciniResponse extends IOkApiResponse {
    luoghiViciniIDs?: number[] | null;
}

export class GetLuoghiViciniRequest extends LocalizedRequest implements IGetLuoghiViciniRequest {
    luogoId?: number;

    constructor(data?: IGetLuoghiViciniRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : <any>null;
        }
    }

    static fromJS(data: any): GetLuoghiViciniRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuoghiViciniRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLuoghiViciniRequest extends ILocalizedRequest {
    luogoId?: number;
}

export class NrTableResponseOfLocationListRow extends OkApiResponse implements INrTableResponseOfLocationListRow {
    /** Array delle righe della pagina richiesta */
    rows?: LocationListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfLocationListRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(LocationListRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfLocationListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfLocationListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfLocationListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: LocationListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

/** Classe che rappresenta la risposta ad una richiesta di elenco contatti */
export class LocationsListResponse extends NrTableResponseOfLocationListRow implements ILocationsListResponse {

    constructor(data?: ILocationsListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): LocationsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LocationsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta la risposta ad una richiesta di elenco contatti */
export interface ILocationsListResponse extends INrTableResponseOfLocationListRow {
}

export class LocationListRow implements ILocationListRow {
    id?: number;
    codice?: string | null;
    nome?: string | null;
    tipo?: ETipoLuogo;
    regione?: string | null;
    paese?: string | null;
    locationPublishes?: LocationPublish[] | null;
    pubblicazioneSito1?: EStatoPubblicazioneLuogo;

    constructor(data?: ILocationListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
            if (Array.isArray(_data["locationPublishes"])) {
                this.locationPublishes = [] as any;
                for (let item of _data["locationPublishes"])
                    this.locationPublishes!.push(LocationPublish.fromJS(item));
            }
            else {
                this.locationPublishes = <any>null;
            }
            this.pubblicazioneSito1 = _data["pubblicazioneSito1"] !== undefined ? _data["pubblicazioneSito1"] : <any>null;
        }
    }

    static fromJS(data: any): LocationListRow {
        data = typeof data === 'object' ? data : {};
        let result = new LocationListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["regione"] = this.regione !== undefined ? this.regione : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        if (Array.isArray(this.locationPublishes)) {
            data["locationPublishes"] = [];
            for (let item of this.locationPublishes)
                data["locationPublishes"].push(item.toJSON());
        }
        data["pubblicazioneSito1"] = this.pubblicazioneSito1 !== undefined ? this.pubblicazioneSito1 : <any>null;
        return data;
    }
}

export interface ILocationListRow {
    id?: number;
    codice?: string | null;
    nome?: string | null;
    tipo?: ETipoLuogo;
    regione?: string | null;
    paese?: string | null;
    locationPublishes?: LocationPublish[] | null;
    pubblicazioneSito1?: EStatoPubblicazioneLuogo;
}

export class ListLocationsRequest extends NrTableRequest implements IListLocationsRequest {
    term?: string | null;
    tipo?: ETipoLuogo | null;
    codice?: string | null;
    luogoPaeseID?: number | null;
    luogoRegioneID?: number | null;
    statoPubblicatione?: EStatoPubblicazioneLuogo | null;
    sitoPubblicazione?: number | null;

    constructor(data?: IListLocationsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.luogoPaeseID = _data["luogoPaeseID"] !== undefined ? _data["luogoPaeseID"] : <any>null;
            this.luogoRegioneID = _data["luogoRegioneID"] !== undefined ? _data["luogoRegioneID"] : <any>null;
            this.statoPubblicatione = _data["statoPubblicatione"] !== undefined ? _data["statoPubblicatione"] : <any>null;
            this.sitoPubblicazione = _data["sitoPubblicazione"] !== undefined ? _data["sitoPubblicazione"] : <any>null;
        }
    }

    static fromJS(data: any): ListLocationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListLocationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["luogoPaeseID"] = this.luogoPaeseID !== undefined ? this.luogoPaeseID : <any>null;
        data["luogoRegioneID"] = this.luogoRegioneID !== undefined ? this.luogoRegioneID : <any>null;
        data["statoPubblicatione"] = this.statoPubblicatione !== undefined ? this.statoPubblicatione : <any>null;
        data["sitoPubblicazione"] = this.sitoPubblicazione !== undefined ? this.sitoPubblicazione : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IListLocationsRequest extends INrTableRequest {
    term?: string | null;
    tipo?: ETipoLuogo | null;
    codice?: string | null;
    luogoPaeseID?: number | null;
    luogoRegioneID?: number | null;
    statoPubblicatione?: EStatoPubblicazioneLuogo | null;
    sitoPubblicazione?: number | null;
}

export class SetDistanzeRequest extends LocalizedRequest implements ISetDistanzeRequest {
    luogoId?: number;
    luoghiDistanze?: LuogoDistanza[] | null;

    constructor(data?: ISetDistanzeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : <any>null;
            if (Array.isArray(_data["luoghiDistanze"])) {
                this.luoghiDistanze = [] as any;
                for (let item of _data["luoghiDistanze"])
                    this.luoghiDistanze!.push(LuogoDistanza.fromJS(item));
            }
            else {
                this.luoghiDistanze = <any>null;
            }
        }
    }

    static fromJS(data: any): SetDistanzeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetDistanzeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : <any>null;
        if (Array.isArray(this.luoghiDistanze)) {
            data["luoghiDistanze"] = [];
            for (let item of this.luoghiDistanze)
                data["luoghiDistanze"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetDistanzeRequest extends ILocalizedRequest {
    luogoId?: number;
    luoghiDistanze?: LuogoDistanza[] | null;
}

export class LuogoDistanza implements ILuogoDistanza {
    luogoDistanzaID?: number;
    luogoID?: number;
    luogoID2?: number;
    distanzaAuto?: number | null;
    durataAuto?: number | null;

    constructor(data?: ILuogoDistanza) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoDistanzaID = _data["luogoDistanzaID"] !== undefined ? _data["luogoDistanzaID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogoID2 = _data["luogoID2"] !== undefined ? _data["luogoID2"] : <any>null;
            this.distanzaAuto = _data["distanzaAuto"] !== undefined ? _data["distanzaAuto"] : <any>null;
            this.durataAuto = _data["durataAuto"] !== undefined ? _data["durataAuto"] : <any>null;
        }
    }

    static fromJS(data: any): LuogoDistanza {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoDistanza();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoDistanzaID"] = this.luogoDistanzaID !== undefined ? this.luogoDistanzaID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogoID2"] = this.luogoID2 !== undefined ? this.luogoID2 : <any>null;
        data["distanzaAuto"] = this.distanzaAuto !== undefined ? this.distanzaAuto : <any>null;
        data["durataAuto"] = this.durataAuto !== undefined ? this.durataAuto : <any>null;
        return data;
    }
}

export interface ILuogoDistanza {
    luogoDistanzaID?: number;
    luogoID?: number;
    luogoID2?: number;
    distanzaAuto?: number | null;
    durataAuto?: number | null;
}

export class SetMappaResponse extends OkApiResponse implements ISetMappaResponse {
    mappa?: Mappa | null;

    constructor(data?: ISetMappaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : <any>null;
        }
    }

    static fromJS(data: any): SetMappaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappa"] = this.mappa ? this.mappa.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappaResponse extends IOkApiResponse {
    mappa?: Mappa | null;
}

export class SetMappaRequest extends LocalizedRequest implements ISetMappaRequest {
    luogoId?: number;
    mappa?: Mappa | null;

    constructor(data?: ISetMappaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : <any>null;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : <any>null;
        }
    }

    static fromJS(data: any): SetMappaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : <any>null;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappaRequest extends ILocalizedRequest {
    luogoId?: number;
    mappa?: Mappa | null;
}

export class SetRelazioniRequest extends LocalizedRequest implements ISetRelazioniRequest {
    luogoId?: number;
    luoghiRelazioni?: LuogoRelazione[] | null;

    constructor(data?: ISetRelazioniRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : <any>null;
            if (Array.isArray(_data["luoghiRelazioni"])) {
                this.luoghiRelazioni = [] as any;
                for (let item of _data["luoghiRelazioni"])
                    this.luoghiRelazioni!.push(LuogoRelazione.fromJS(item));
            }
            else {
                this.luoghiRelazioni = <any>null;
            }
        }
    }

    static fromJS(data: any): SetRelazioniRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRelazioniRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : <any>null;
        if (Array.isArray(this.luoghiRelazioni)) {
            data["luoghiRelazioni"] = [];
            for (let item of this.luoghiRelazioni)
                data["luoghiRelazioni"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetRelazioniRequest extends ILocalizedRequest {
    luogoId?: number;
    luoghiRelazioni?: LuogoRelazione[] | null;
}

export class LuogoRelazione implements ILuogoRelazione {
    relazioneID?: number;
    luogoID?: number;
    luogoPadreID?: number;

    constructor(data?: ILuogoRelazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relazioneID = _data["relazioneID"] !== undefined ? _data["relazioneID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogoPadreID = _data["luogoPadreID"] !== undefined ? _data["luogoPadreID"] : <any>null;
        }
    }

    static fromJS(data: any): LuogoRelazione {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoRelazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relazioneID"] = this.relazioneID !== undefined ? this.relazioneID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogoPadreID"] = this.luogoPadreID !== undefined ? this.luogoPadreID : <any>null;
        return data;
    }
}

export interface ILuogoRelazione {
    relazioneID?: number;
    luogoID?: number;
    luogoPadreID?: number;
}

export class SetViciniRequest extends LocalizedRequest implements ISetViciniRequest {
    luogoId?: number;
    luoghiViciniIds?: number[] | null;

    constructor(data?: ISetViciniRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoId = _data["luogoId"] !== undefined ? _data["luogoId"] : <any>null;
            if (Array.isArray(_data["luoghiViciniIds"])) {
                this.luoghiViciniIds = [] as any;
                for (let item of _data["luoghiViciniIds"])
                    this.luoghiViciniIds!.push(item);
            }
            else {
                this.luoghiViciniIds = <any>null;
            }
        }
    }

    static fromJS(data: any): SetViciniRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetViciniRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoId"] = this.luogoId !== undefined ? this.luogoId : <any>null;
        if (Array.isArray(this.luoghiViciniIds)) {
            data["luoghiViciniIds"] = [];
            for (let item of this.luoghiViciniIds)
                data["luoghiViciniIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetViciniRequest extends ILocalizedRequest {
    luogoId?: number;
    luoghiViciniIds?: number[] | null;
}

export class UpdateLocationRequest extends LocalizedRequest implements IUpdateLocationRequest {
    luogo?: Luogo | null;

    constructor(data?: IUpdateLocationRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogo = _data["luogo"] ? Luogo.fromJS(_data["luogo"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateLocationRequest extends ILocalizedRequest {
    luogo?: Luogo | null;
}

export class UpdateLocationPublishingRequest extends ApiRequest implements IUpdateLocationPublishingRequest {
    locationId?: number;
    siteId?: number;
    status?: EStatoPubblicazioneLuogo;

    constructor(data?: IUpdateLocationPublishingRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : <any>null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateLocationPublishingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLocationPublishingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId !== undefined ? this.locationId : <any>null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateLocationPublishingRequest extends IApiRequest {
    locationId?: number;
    siteId?: number;
    status?: EStatoPubblicazioneLuogo;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class ConfirmLuogoH2HRequest extends ApiRequest implements IConfirmLuogoH2HRequest {
    id?: number;

    constructor(data?: IConfirmLuogoH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): ConfirmLuogoH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmLuogoH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IConfirmLuogoH2HRequest extends IApiRequest {
    id?: number;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class DeleteLuogoH2HRequest extends ApiRequest implements IDeleteLuogoH2HRequest {
    id?: number;

    constructor(data?: IDeleteLuogoH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteLuogoH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLuogoH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IDeleteLuogoH2HRequest extends IApiRequest {
    id?: number;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class DiscardLuogoH2HRequest extends ApiRequest implements IDiscardLuogoH2HRequest {
    id?: number;

    constructor(data?: IDiscardLuogoH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DiscardLuogoH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DiscardLuogoH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IDiscardLuogoH2HRequest extends IApiRequest {
    id?: number;
}

export class LuogoH2HGetResponse extends OkApiResponse implements ILuogoH2HGetResponse {
    luogo?: LuogoH2HRow;

    constructor(data?: ILuogoH2HGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogo = _data["luogo"] ? LuogoH2HRow.fromJS(_data["luogo"]) : <any>null;
        }
    }

    static fromJS(data: any): LuogoH2HGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoH2HGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ILuogoH2HGetResponse extends IOkApiResponse {
    luogo?: LuogoH2HRow;
}

export class LuogoH2HRow implements ILuogoH2HRow {
    id?: number;
    paese?: string | null;
    tipo?: EHHTipoLuogo;
    hhLuogo?: HHLuogo | null;
    nome?: string | null;
    codice?: string | null;
    fornitore?: string | null;
    fornitoreID?: number;
    luogoNaar?: string | null;
    disabilitato?: boolean;
    ultimoAggiornamento?: string | null;
    accordo?: string | null;
    accordoMancante?: boolean;
    deleted?: string | null;

    constructor(data?: ILuogoH2HRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.hhLuogo = _data["hhLuogo"] ? HHLuogo.fromJS(_data["hhLuogo"]) : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            this.fornitoreID = _data["fornitoreID"] !== undefined ? _data["fornitoreID"] : <any>null;
            this.luogoNaar = _data["luogoNaar"] !== undefined ? _data["luogoNaar"] : <any>null;
            this.disabilitato = _data["disabilitato"] !== undefined ? _data["disabilitato"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : <any>null;
            this.accordoMancante = _data["accordoMancante"] !== undefined ? _data["accordoMancante"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
        }
    }

    static fromJS(data: any): LuogoH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["hhLuogo"] = this.hhLuogo ? this.hhLuogo.toJSON() : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        data["fornitoreID"] = this.fornitoreID !== undefined ? this.fornitoreID : <any>null;
        data["luogoNaar"] = this.luogoNaar !== undefined ? this.luogoNaar : <any>null;
        data["disabilitato"] = this.disabilitato !== undefined ? this.disabilitato : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        data["accordo"] = this.accordo !== undefined ? this.accordo : <any>null;
        data["accordoMancante"] = this.accordoMancante !== undefined ? this.accordoMancante : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        return data;
    }
}

export interface ILuogoH2HRow {
    id?: number;
    paese?: string | null;
    tipo?: EHHTipoLuogo;
    hhLuogo?: HHLuogo | null;
    nome?: string | null;
    codice?: string | null;
    fornitore?: string | null;
    fornitoreID?: number;
    luogoNaar?: string | null;
    disabilitato?: boolean;
    ultimoAggiornamento?: string | null;
    accordo?: string | null;
    accordoMancante?: boolean;
    deleted?: string | null;
}

export class LuogoH2HGetRequest extends LocalizedRequest implements ILuogoH2HGetRequest {
    luogoH2HID!: number;

    constructor(data?: ILuogoH2HGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoH2HID = _data["luogoH2HID"] !== undefined ? _data["luogoH2HID"] : <any>null;
        }
    }

    static fromJS(data: any): LuogoH2HGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoH2HGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoH2HID"] = this.luogoH2HID !== undefined ? this.luogoH2HID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ILuogoH2HGetRequest extends ILocalizedRequest {
    luogoH2HID: number;
}

export class NrTableResponseOfLuogoH2HRow extends OkApiResponse implements INrTableResponseOfLuogoH2HRow {
    /** Array delle righe della pagina richiesta */
    rows?: LuogoH2HRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfLuogoH2HRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(LuogoH2HRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfLuogoH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfLuogoH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfLuogoH2HRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: LuogoH2HRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetLuoghiH2HResponse extends NrTableResponseOfLuogoH2HRow implements IGetLuoghiH2HResponse {

    constructor(data?: IGetLuoghiH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetLuoghiH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuoghiH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetLuoghiH2HResponse extends INrTableResponseOfLuogoH2HRow {
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetLuoghiH2HRequest extends NrTableRequest implements IGetLuoghiH2HRequest {
    supplier?: number | null;
    luogoNaarID?: number | null;
    mapped?: boolean | null;
    disabled?: boolean | null;
    confirmed?: boolean | null;
    nomeLuogoFornitore?: string | null;
    codicePaese?: string | null;
    missingAc?: boolean;
    showDeleted?: boolean;

    constructor(data?: IGetLuoghiH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
            this.luogoNaarID = _data["luogoNaarID"] !== undefined ? _data["luogoNaarID"] : <any>null;
            this.mapped = _data["mapped"] !== undefined ? _data["mapped"] : <any>null;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.nomeLuogoFornitore = _data["nomeLuogoFornitore"] !== undefined ? _data["nomeLuogoFornitore"] : <any>null;
            this.codicePaese = _data["codicePaese"] !== undefined ? _data["codicePaese"] : <any>null;
            this.missingAc = _data["missingAc"] !== undefined ? _data["missingAc"] : <any>null;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): GetLuoghiH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuoghiH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        data["luogoNaarID"] = this.luogoNaarID !== undefined ? this.luogoNaarID : <any>null;
        data["mapped"] = this.mapped !== undefined ? this.mapped : <any>null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["nomeLuogoFornitore"] = this.nomeLuogoFornitore !== undefined ? this.nomeLuogoFornitore : <any>null;
        data["codicePaese"] = this.codicePaese !== undefined ? this.codicePaese : <any>null;
        data["missingAc"] = this.missingAc !== undefined ? this.missingAc : <any>null;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetLuoghiH2HRequest extends INrTableRequest {
    supplier?: number | null;
    luogoNaarID?: number | null;
    mapped?: boolean | null;
    disabled?: boolean | null;
    confirmed?: boolean | null;
    nomeLuogoFornitore?: string | null;
    codicePaese?: string | null;
    missingAc?: boolean;
    showDeleted?: boolean;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class RestoreLuogoH2HRequest extends ApiRequest implements IRestoreLuogoH2HRequest {
    id?: number;

    constructor(data?: IRestoreLuogoH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): RestoreLuogoH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreLuogoH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IRestoreLuogoH2HRequest extends IApiRequest {
    id?: number;
}

export class UpdateLuogoH2HResponse extends OkApiResponse implements IUpdateLuogoH2HResponse {
    luogo?: HHLuogo | null;

    constructor(data?: IUpdateLuogoH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogo = _data["luogo"] ? HHLuogo.fromJS(_data["luogo"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateLuogoH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLuogoH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateLuogoH2HResponse extends IOkApiResponse {
    luogo?: HHLuogo | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class UpdateLuogoH2HRequest extends ApiRequest implements IUpdateLuogoH2HRequest {
    luogo?: HHLuogo | null;

    constructor(data?: IUpdateLuogoH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogo = _data["luogo"] ? HHLuogo.fromJS(_data["luogo"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateLuogoH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLuogoH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IUpdateLuogoH2HRequest extends IApiRequest {
    luogo?: HHLuogo | null;
}

export class GetAgencyDataResponse extends OkApiResponse implements IGetAgencyDataResponse {
    /** ID del contatto agenzia */
    contattoID!: number;
    /** Nome del contatto / Ragione sociale semplice */
    nome!: string;
    /** Cognome del contatto / Ragione sociale estesa (incluso tipo società) */
    cognome?: string | null;
    /** Indirizzo del contatto. Dovrebbe essere solo la parte col nome della via */
    indirizzo?: string | null;
    /** Numero civico, qualora non incluso in Indirizzo */
    civico?: string | null;
    /** CAP dell'indirizzo del contatto */
    cap?: string | null;
    /** Città della sede del contatto */
    luogo?: string | null;
    /** Sigla della provincia della sede del contatto (solo contatti italiani) */
    provincia?: string | null;
    /** Numero di telefono. Campo libero, potrebbe contenenre più numeri e/o brevi note */
    telefono?: string | null;
    /** Numero di fax */
    fax?: string | null;
    /** Indirizzo email principale del contatto */
    email?: string | null;
    /** Nome della categoria dell'agenzia */
    categoria?: string | null;
    /** Codice della categoria dell'agenzia */
    codiceCategoria?: string | null;
    /** Descrizione della modalità di pagamento associata all'accordo corrente per l'operatore dell'offerta. Può contenere tag html */
    pagamentoHtml?: string | null;
    /** ID del contatto di tipo network agenzie (se appartenente a network) */
    contattoNetworkID?: number | null;
    /** Nome del network di agenzie (se appartenente a network) */
    network?: string | null;
    /** ID del contatto di tipo produttore/promoter se associato */
    contattoPromoterID?: number | null;
    /** Nome del produttore/promoter se associato */
    promoter?: string | null;
    /** Numero di telefono del produttore/promoter se associato. Campo libero, potrebbe contenenre più numeri e/o brevi note */
    telefonoPromoter?: string | null;
    /** Percentuale di acconto richiesta per viaggi standard */
    acconto?: number | null;
    /** Se true l'agenzia non paga anticipi sulle quote di apertura pratica */
    noAnticipoQuote?: boolean;
    /** Percentuale di acconto richiesta per viaggi di tipo nozze */
    accontoNozze?: number | null;
    /** Se true l'agenzia non paga anticipi sulla biglietteria aerea */
    noAnticipoBiglietti?: boolean;
    /** Nome dell'addetto in agenzia responsabile per questa pratica */
    nomeAddetto?: string | null;
    /** Email dell'addetto in agenzia responsabile per questa pratica */
    emailAddetto?: string | null;
    /** Nome esteso dell'utente dell'agenzia proprietario della pratica */
    username?: string | null;
    /** Elenco delle note commerciali per l'agenzia */
    noteAgenzia?: string[] | null;

    constructor(data?: IGetAgencyDataResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.civico = _data["civico"] !== undefined ? _data["civico"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : <any>null;
            this.codiceCategoria = _data["codiceCategoria"] !== undefined ? _data["codiceCategoria"] : <any>null;
            this.pagamentoHtml = _data["pagamentoHtml"] !== undefined ? _data["pagamentoHtml"] : <any>null;
            this.contattoNetworkID = _data["contattoNetworkID"] !== undefined ? _data["contattoNetworkID"] : <any>null;
            this.network = _data["network"] !== undefined ? _data["network"] : <any>null;
            this.contattoPromoterID = _data["contattoPromoterID"] !== undefined ? _data["contattoPromoterID"] : <any>null;
            this.promoter = _data["promoter"] !== undefined ? _data["promoter"] : <any>null;
            this.telefonoPromoter = _data["telefonoPromoter"] !== undefined ? _data["telefonoPromoter"] : <any>null;
            this.acconto = _data["acconto"] !== undefined ? _data["acconto"] : <any>null;
            this.noAnticipoQuote = _data["noAnticipoQuote"] !== undefined ? _data["noAnticipoQuote"] : <any>null;
            this.accontoNozze = _data["accontoNozze"] !== undefined ? _data["accontoNozze"] : <any>null;
            this.noAnticipoBiglietti = _data["noAnticipoBiglietti"] !== undefined ? _data["noAnticipoBiglietti"] : <any>null;
            this.nomeAddetto = _data["nomeAddetto"] !== undefined ? _data["nomeAddetto"] : <any>null;
            this.emailAddetto = _data["emailAddetto"] !== undefined ? _data["emailAddetto"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            if (Array.isArray(_data["noteAgenzia"])) {
                this.noteAgenzia = [] as any;
                for (let item of _data["noteAgenzia"])
                    this.noteAgenzia!.push(item);
            }
            else {
                this.noteAgenzia = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAgencyDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgencyDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["civico"] = this.civico !== undefined ? this.civico : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["provincia"] = this.provincia !== undefined ? this.provincia : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["categoria"] = this.categoria !== undefined ? this.categoria : <any>null;
        data["codiceCategoria"] = this.codiceCategoria !== undefined ? this.codiceCategoria : <any>null;
        data["pagamentoHtml"] = this.pagamentoHtml !== undefined ? this.pagamentoHtml : <any>null;
        data["contattoNetworkID"] = this.contattoNetworkID !== undefined ? this.contattoNetworkID : <any>null;
        data["network"] = this.network !== undefined ? this.network : <any>null;
        data["contattoPromoterID"] = this.contattoPromoterID !== undefined ? this.contattoPromoterID : <any>null;
        data["promoter"] = this.promoter !== undefined ? this.promoter : <any>null;
        data["telefonoPromoter"] = this.telefonoPromoter !== undefined ? this.telefonoPromoter : <any>null;
        data["acconto"] = this.acconto !== undefined ? this.acconto : <any>null;
        data["noAnticipoQuote"] = this.noAnticipoQuote !== undefined ? this.noAnticipoQuote : <any>null;
        data["accontoNozze"] = this.accontoNozze !== undefined ? this.accontoNozze : <any>null;
        data["noAnticipoBiglietti"] = this.noAnticipoBiglietti !== undefined ? this.noAnticipoBiglietti : <any>null;
        data["nomeAddetto"] = this.nomeAddetto !== undefined ? this.nomeAddetto : <any>null;
        data["emailAddetto"] = this.emailAddetto !== undefined ? this.emailAddetto : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        if (Array.isArray(this.noteAgenzia)) {
            data["noteAgenzia"] = [];
            for (let item of this.noteAgenzia)
                data["noteAgenzia"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAgencyDataResponse extends IOkApiResponse {
    /** ID del contatto agenzia */
    contattoID: number;
    /** Nome del contatto / Ragione sociale semplice */
    nome: string;
    /** Cognome del contatto / Ragione sociale estesa (incluso tipo società) */
    cognome?: string | null;
    /** Indirizzo del contatto. Dovrebbe essere solo la parte col nome della via */
    indirizzo?: string | null;
    /** Numero civico, qualora non incluso in Indirizzo */
    civico?: string | null;
    /** CAP dell'indirizzo del contatto */
    cap?: string | null;
    /** Città della sede del contatto */
    luogo?: string | null;
    /** Sigla della provincia della sede del contatto (solo contatti italiani) */
    provincia?: string | null;
    /** Numero di telefono. Campo libero, potrebbe contenenre più numeri e/o brevi note */
    telefono?: string | null;
    /** Numero di fax */
    fax?: string | null;
    /** Indirizzo email principale del contatto */
    email?: string | null;
    /** Nome della categoria dell'agenzia */
    categoria?: string | null;
    /** Codice della categoria dell'agenzia */
    codiceCategoria?: string | null;
    /** Descrizione della modalità di pagamento associata all'accordo corrente per l'operatore dell'offerta. Può contenere tag html */
    pagamentoHtml?: string | null;
    /** ID del contatto di tipo network agenzie (se appartenente a network) */
    contattoNetworkID?: number | null;
    /** Nome del network di agenzie (se appartenente a network) */
    network?: string | null;
    /** ID del contatto di tipo produttore/promoter se associato */
    contattoPromoterID?: number | null;
    /** Nome del produttore/promoter se associato */
    promoter?: string | null;
    /** Numero di telefono del produttore/promoter se associato. Campo libero, potrebbe contenenre più numeri e/o brevi note */
    telefonoPromoter?: string | null;
    /** Percentuale di acconto richiesta per viaggi standard */
    acconto?: number | null;
    /** Se true l'agenzia non paga anticipi sulle quote di apertura pratica */
    noAnticipoQuote?: boolean;
    /** Percentuale di acconto richiesta per viaggi di tipo nozze */
    accontoNozze?: number | null;
    /** Se true l'agenzia non paga anticipi sulla biglietteria aerea */
    noAnticipoBiglietti?: boolean;
    /** Nome dell'addetto in agenzia responsabile per questa pratica */
    nomeAddetto?: string | null;
    /** Email dell'addetto in agenzia responsabile per questa pratica */
    emailAddetto?: string | null;
    /** Nome esteso dell'utente dell'agenzia proprietario della pratica */
    username?: string | null;
    /** Elenco delle note commerciali per l'agenzia */
    noteAgenzia?: string[] | null;
}

export class M2MRequest extends ApiRequest implements IM2MRequest {
    /** Token di autorizzazione */
    authToken!: string;

    constructor(data?: IM2MRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.authToken = _data["authToken"] !== undefined ? _data["authToken"] : <any>null;
        }
    }

    static fromJS(data: any): M2MRequest {
        data = typeof data === 'object' ? data : {};
        let result = new M2MRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authToken"] = this.authToken !== undefined ? this.authToken : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IM2MRequest extends IApiRequest {
    /** Token di autorizzazione */
    authToken: string;
}

export class GetAgencyDataRequest extends M2MRequest implements IGetAgencyDataRequest {
    /** ID dell'offerta da cui estrarre i dati agenzia */
    offertaID!: number;

    constructor(data?: IGetAgencyDataRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
        }
    }

    static fromJS(data: any): GetAgencyDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgencyDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAgencyDataRequest extends IM2MRequest {
    /** ID dell'offerta da cui estrarre i dati agenzia */
    offertaID: number;
}

export class GetContabilityDocumentDataResponse extends OkApiResponse implements IGetContabilityDocumentDataResponse {
    listRow?: InvoicePrint;

    constructor(data?: IGetContabilityDocumentDataResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.listRow = _data["listRow"] ? InvoicePrint.fromJS(_data["listRow"]) : <any>null;
        }
    }

    static fromJS(data: any): GetContabilityDocumentDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContabilityDocumentDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listRow"] = this.listRow ? this.listRow.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetContabilityDocumentDataResponse extends IOkApiResponse {
    listRow?: InvoicePrint;
}

export class InvoicePrint implements IInvoicePrint {
    invoiceDocument?: InvoiceDocument;
    fatturaEmitter?: InvoiceEmitter;
    numOfPages?: number;
    /** Righe raggruppate per maxNumOfPages */
    groupedRighe?: InvoicesListRowDetail[][];

    constructor(data?: IInvoicePrint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceDocument = _data["invoiceDocument"] ? InvoiceDocument.fromJS(_data["invoiceDocument"]) : <any>null;
            this.fatturaEmitter = _data["fatturaEmitter"] ? InvoiceEmitter.fromJS(_data["fatturaEmitter"]) : <any>null;
            this.numOfPages = _data["numOfPages"] !== undefined ? _data["numOfPages"] : <any>null;
            if (Array.isArray(_data["groupedRighe"])) {
                this.groupedRighe = [] as any;
                for (let item of _data["groupedRighe"])
                    this.groupedRighe!.push(item);
            }
            else {
                this.groupedRighe = <any>null;
            }
        }
    }

    static fromJS(data: any): InvoicePrint {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePrint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceDocument"] = this.invoiceDocument ? this.invoiceDocument.toJSON() : <any>null;
        data["fatturaEmitter"] = this.fatturaEmitter ? this.fatturaEmitter.toJSON() : <any>null;
        data["numOfPages"] = this.numOfPages !== undefined ? this.numOfPages : <any>null;
        if (Array.isArray(this.groupedRighe)) {
            data["groupedRighe"] = [];
            for (let item of this.groupedRighe)
                data["groupedRighe"].push(item);
        }
        return data;
    }
}

export interface IInvoicePrint {
    invoiceDocument?: InvoiceDocument;
    fatturaEmitter?: InvoiceEmitter;
    numOfPages?: number;
    /** Righe raggruppate per maxNumOfPages */
    groupedRighe?: InvoicesListRowDetail[][];
}

export class InvoiceDocument implements IInvoiceDocument {
    id?: number;
    tipo?: ETipoDocumento;
    numero?: number;
    data?: string;
    contattoID?: number | null;
    contatto?: string | null;
    ragioneSociale?: string | null;
    indirizzoFatt?: string | null;
    numeroCivico?: string | null;
    cap?: string | null;
    comune?: string | null;
    cliente?: string | null;
    indirizzo?: string | null;
    importo?: number;
    totaleIva?: number;
    luogo?: string;
    partitaIva?: string | null;
    note?: string | null;

    constructor(data?: IInvoiceDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.numero = _data["numero"] !== undefined ? _data["numero"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : <any>null;
            this.ragioneSociale = _data["ragioneSociale"] !== undefined ? _data["ragioneSociale"] : <any>null;
            this.indirizzoFatt = _data["indirizzoFatt"] !== undefined ? _data["indirizzoFatt"] : <any>null;
            this.numeroCivico = _data["numeroCivico"] !== undefined ? _data["numeroCivico"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.comune = _data["comune"] !== undefined ? _data["comune"] : <any>null;
            this.cliente = _data["cliente"] !== undefined ? _data["cliente"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
            this.totaleIva = _data["totaleIva"] !== undefined ? _data["totaleIva"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.partitaIva = _data["partitaIva"] !== undefined ? _data["partitaIva"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceDocument {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["numero"] = this.numero !== undefined ? this.numero : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["contatto"] = this.contatto !== undefined ? this.contatto : <any>null;
        data["ragioneSociale"] = this.ragioneSociale !== undefined ? this.ragioneSociale : <any>null;
        data["indirizzoFatt"] = this.indirizzoFatt !== undefined ? this.indirizzoFatt : <any>null;
        data["numeroCivico"] = this.numeroCivico !== undefined ? this.numeroCivico : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["comune"] = this.comune !== undefined ? this.comune : <any>null;
        data["cliente"] = this.cliente !== undefined ? this.cliente : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        data["totaleIva"] = this.totaleIva !== undefined ? this.totaleIva : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["partitaIva"] = this.partitaIva !== undefined ? this.partitaIva : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        return data;
    }
}

export interface IInvoiceDocument {
    id?: number;
    tipo?: ETipoDocumento;
    numero?: number;
    data?: string;
    contattoID?: number | null;
    contatto?: string | null;
    ragioneSociale?: string | null;
    indirizzoFatt?: string | null;
    numeroCivico?: string | null;
    cap?: string | null;
    comune?: string | null;
    cliente?: string | null;
    indirizzo?: string | null;
    importo?: number;
    totaleIva?: number;
    luogo?: string;
    partitaIva?: string | null;
    note?: string | null;
}

export class InvoiceEmitter implements IInvoiceEmitter {
    id?: number;
    ragioneSociale?: string;
    indirizzo?: string;
    cap?: string;
    citta?: string;
    pIva?: string;
    fax?: string;
    tel?: string;
    lang?: ELingua;
    logoUrl?: string;

    constructor(data?: IInvoiceEmitter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.ragioneSociale = _data["ragioneSociale"] !== undefined ? _data["ragioneSociale"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.citta = _data["citta"] !== undefined ? _data["citta"] : <any>null;
            this.pIva = _data["pIva"] !== undefined ? _data["pIva"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.tel = _data["tel"] !== undefined ? _data["tel"] : <any>null;
            this.lang = _data["lang"] !== undefined ? _data["lang"] : <any>null;
            this.logoUrl = _data["logoUrl"] !== undefined ? _data["logoUrl"] : <any>null;
        }
    }

    static fromJS(data: any): InvoiceEmitter {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceEmitter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["ragioneSociale"] = this.ragioneSociale !== undefined ? this.ragioneSociale : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["citta"] = this.citta !== undefined ? this.citta : <any>null;
        data["pIva"] = this.pIva !== undefined ? this.pIva : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["tel"] = this.tel !== undefined ? this.tel : <any>null;
        data["lang"] = this.lang !== undefined ? this.lang : <any>null;
        data["logoUrl"] = this.logoUrl !== undefined ? this.logoUrl : <any>null;
        return data;
    }
}

export interface IInvoiceEmitter {
    id?: number;
    ragioneSociale?: string;
    indirizzo?: string;
    cap?: string;
    citta?: string;
    pIva?: string;
    fax?: string;
    tel?: string;
    lang?: ELingua;
    logoUrl?: string;
}

export class GetContabilityDocumentDataRequest extends SiteRequest implements IGetContabilityDocumentDataRequest {
    documentoID!: number;
    maxNumOfRowsPerPage?: number;

    constructor(data?: IGetContabilityDocumentDataRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
            this.maxNumOfRowsPerPage = _data["maxNumOfRowsPerPage"] !== undefined ? _data["maxNumOfRowsPerPage"] : <any>null;
        }
    }

    static fromJS(data: any): GetContabilityDocumentDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetContabilityDocumentDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        data["maxNumOfRowsPerPage"] = this.maxNumOfRowsPerPage !== undefined ? this.maxNumOfRowsPerPage : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetContabilityDocumentDataRequest extends ISiteRequest {
    documentoID: number;
    maxNumOfRowsPerPage?: number;
}

export class GetKanbanDocumentDataResponse extends OkApiResponse implements IGetKanbanDocumentDataResponse {
    kanban?: KanbanRaw | null;

    constructor(data?: IGetKanbanDocumentDataResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kanban = _data["kanban"] ? KanbanRaw.fromJS(_data["kanban"]) : <any>null;
        }
    }

    static fromJS(data: any): GetKanbanDocumentDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKanbanDocumentDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kanban"] = this.kanban ? this.kanban.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetKanbanDocumentDataResponse extends IOkApiResponse {
    kanban?: KanbanRaw | null;
}

export class KanbanRaw implements IKanbanRaw {
    id?: number;
    confermata?: boolean | null;
    descrizione?: string | null;
    creazione?: string | null;
    dataConferma?: string | null;
    partenza?: string | null;
    priorita?: string | null;
    destinazione?: string | null;
    nomeVisualizzato?: string | null;
    tipoViaggio?: ETipoViaggio;
    clienti?: string[] | null;
    riferimentoCliente?: string | null;
    addetto?: string | null;
    contattoAgenzia?: KanbanContattoRaw | null;
    categoria?: string | null;
    contattoNetwork?: KanbanContattoRaw | null;
    contattoPromoter?: KanbanContattoRaw | null;
    terminePagamentoAgenzia?: string | null;
    datiAgenzia?: KanbanDatiagenzia | null;
    statistiche?: KanbanStatisticsRaw | null;
    elencoNote?: KanbanNota[] | null;

    constructor(data?: IKanbanRaw) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.confermata = _data["confermata"] !== undefined ? _data["confermata"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : <any>null;
            this.dataConferma = _data["dataConferma"] !== undefined ? _data["dataConferma"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : <any>null;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : <any>null;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : <any>null;
            this.tipoViaggio = _data["tipoViaggio"] !== undefined ? _data["tipoViaggio"] : <any>null;
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(item);
            }
            else {
                this.clienti = <any>null;
            }
            this.riferimentoCliente = _data["riferimentoCliente"] !== undefined ? _data["riferimentoCliente"] : <any>null;
            this.addetto = _data["addetto"] !== undefined ? _data["addetto"] : <any>null;
            this.contattoAgenzia = _data["contattoAgenzia"] ? KanbanContattoRaw.fromJS(_data["contattoAgenzia"]) : <any>null;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : <any>null;
            this.contattoNetwork = _data["contattoNetwork"] ? KanbanContattoRaw.fromJS(_data["contattoNetwork"]) : <any>null;
            this.contattoPromoter = _data["contattoPromoter"] ? KanbanContattoRaw.fromJS(_data["contattoPromoter"]) : <any>null;
            this.terminePagamentoAgenzia = _data["terminePagamentoAgenzia"] !== undefined ? _data["terminePagamentoAgenzia"] : <any>null;
            this.datiAgenzia = _data["datiAgenzia"] ? KanbanDatiagenzia.fromJS(_data["datiAgenzia"]) : <any>null;
            this.statistiche = _data["statistiche"] ? KanbanStatisticsRaw.fromJS(_data["statistiche"]) : <any>null;
            if (Array.isArray(_data["elencoNote"])) {
                this.elencoNote = [] as any;
                for (let item of _data["elencoNote"])
                    this.elencoNote!.push(KanbanNota.fromJS(item));
            }
            else {
                this.elencoNote = <any>null;
            }
        }
    }

    static fromJS(data: any): KanbanRaw {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanRaw();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["confermata"] = this.confermata !== undefined ? this.confermata : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["creazione"] = this.creazione !== undefined ? this.creazione : <any>null;
        data["dataConferma"] = this.dataConferma !== undefined ? this.dataConferma : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["priorita"] = this.priorita !== undefined ? this.priorita : <any>null;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : <any>null;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : <any>null;
        data["tipoViaggio"] = this.tipoViaggio !== undefined ? this.tipoViaggio : <any>null;
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item);
        }
        data["riferimentoCliente"] = this.riferimentoCliente !== undefined ? this.riferimentoCliente : <any>null;
        data["addetto"] = this.addetto !== undefined ? this.addetto : <any>null;
        data["contattoAgenzia"] = this.contattoAgenzia ? this.contattoAgenzia.toJSON() : <any>null;
        data["categoria"] = this.categoria !== undefined ? this.categoria : <any>null;
        data["contattoNetwork"] = this.contattoNetwork ? this.contattoNetwork.toJSON() : <any>null;
        data["contattoPromoter"] = this.contattoPromoter ? this.contattoPromoter.toJSON() : <any>null;
        data["terminePagamentoAgenzia"] = this.terminePagamentoAgenzia !== undefined ? this.terminePagamentoAgenzia : <any>null;
        data["datiAgenzia"] = this.datiAgenzia ? this.datiAgenzia.toJSON() : <any>null;
        data["statistiche"] = this.statistiche ? this.statistiche.toJSON() : <any>null;
        if (Array.isArray(this.elencoNote)) {
            data["elencoNote"] = [];
            for (let item of this.elencoNote)
                data["elencoNote"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKanbanRaw {
    id?: number;
    confermata?: boolean | null;
    descrizione?: string | null;
    creazione?: string | null;
    dataConferma?: string | null;
    partenza?: string | null;
    priorita?: string | null;
    destinazione?: string | null;
    nomeVisualizzato?: string | null;
    tipoViaggio?: ETipoViaggio;
    clienti?: string[] | null;
    riferimentoCliente?: string | null;
    addetto?: string | null;
    contattoAgenzia?: KanbanContattoRaw | null;
    categoria?: string | null;
    contattoNetwork?: KanbanContattoRaw | null;
    contattoPromoter?: KanbanContattoRaw | null;
    terminePagamentoAgenzia?: string | null;
    datiAgenzia?: KanbanDatiagenzia | null;
    statistiche?: KanbanStatisticsRaw | null;
    elencoNote?: KanbanNota[] | null;
}

export class KanbanContattoRaw implements IKanbanContattoRaw {
    nome?: string | null;
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;

    constructor(data?: IKanbanContattoRaw) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): KanbanContattoRaw {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanContattoRaw();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface IKanbanContattoRaw {
    nome?: string | null;
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;
}

export class KanbanDatiagenzia implements IKanbanDatiagenzia {
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;
    categoria?: string | null;
    pagamento?: string | null;
    network?: string | null;
    promoter?: string | null;
    promoterTelefono?: string | null;

    constructor(data?: IKanbanDatiagenzia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : <any>null;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : <any>null;
            this.network = _data["network"] !== undefined ? _data["network"] : <any>null;
            this.promoter = _data["promoter"] !== undefined ? _data["promoter"] : <any>null;
            this.promoterTelefono = _data["promoterTelefono"] !== undefined ? _data["promoterTelefono"] : <any>null;
        }
    }

    static fromJS(data: any): KanbanDatiagenzia {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanDatiagenzia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["categoria"] = this.categoria !== undefined ? this.categoria : <any>null;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : <any>null;
        data["network"] = this.network !== undefined ? this.network : <any>null;
        data["promoter"] = this.promoter !== undefined ? this.promoter : <any>null;
        data["promoterTelefono"] = this.promoterTelefono !== undefined ? this.promoterTelefono : <any>null;
        return data;
    }
}

export interface IKanbanDatiagenzia {
    telefono?: string | null;
    fax?: string | null;
    email?: string | null;
    categoria?: string | null;
    pagamento?: string | null;
    network?: string | null;
    promoter?: string | null;
    promoterTelefono?: string | null;
}

export class KanbanStatisticsRaw implements IKanbanStatisticsRaw {
    priorita?: string | null;
    fatturato?: number;
    percentualeConferme?: number | null;
    confermePassate?: number | null;
    preventiviBkgPassati?: number | null;
    preventiviPassati?: number | null;
    confermeFuture?: number | null;
    preventiviBkgFuturi?: number | null;

    constructor(data?: IKanbanStatisticsRaw) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : <any>null;
            this.fatturato = _data["fatturato"] !== undefined ? _data["fatturato"] : <any>null;
            this.percentualeConferme = _data["percentualeConferme"] !== undefined ? _data["percentualeConferme"] : <any>null;
            this.confermePassate = _data["confermePassate"] !== undefined ? _data["confermePassate"] : <any>null;
            this.preventiviBkgPassati = _data["preventiviBkgPassati"] !== undefined ? _data["preventiviBkgPassati"] : <any>null;
            this.preventiviPassati = _data["preventiviPassati"] !== undefined ? _data["preventiviPassati"] : <any>null;
            this.confermeFuture = _data["confermeFuture"] !== undefined ? _data["confermeFuture"] : <any>null;
            this.preventiviBkgFuturi = _data["preventiviBkgFuturi"] !== undefined ? _data["preventiviBkgFuturi"] : <any>null;
        }
    }

    static fromJS(data: any): KanbanStatisticsRaw {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanStatisticsRaw();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priorita"] = this.priorita !== undefined ? this.priorita : <any>null;
        data["fatturato"] = this.fatturato !== undefined ? this.fatturato : <any>null;
        data["percentualeConferme"] = this.percentualeConferme !== undefined ? this.percentualeConferme : <any>null;
        data["confermePassate"] = this.confermePassate !== undefined ? this.confermePassate : <any>null;
        data["preventiviBkgPassati"] = this.preventiviBkgPassati !== undefined ? this.preventiviBkgPassati : <any>null;
        data["preventiviPassati"] = this.preventiviPassati !== undefined ? this.preventiviPassati : <any>null;
        data["confermeFuture"] = this.confermeFuture !== undefined ? this.confermeFuture : <any>null;
        data["preventiviBkgFuturi"] = this.preventiviBkgFuturi !== undefined ? this.preventiviBkgFuturi : <any>null;
        return data;
    }
}

export interface IKanbanStatisticsRaw {
    priorita?: string | null;
    fatturato?: number;
    percentualeConferme?: number | null;
    confermePassate?: number | null;
    preventiviBkgPassati?: number | null;
    preventiviPassati?: number | null;
    confermeFuture?: number | null;
    preventiviBkgFuturi?: number | null;
}

export class KanbanNota implements IKanbanNota {
    data?: string;
    testo?: string | null;
    isAdv?: boolean | null;
    noAcc?: boolean | null;

    constructor(data?: IKanbanNota) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.isAdv = _data["isAdv"] !== undefined ? _data["isAdv"] : <any>null;
            this.noAcc = _data["noAcc"] !== undefined ? _data["noAcc"] : <any>null;
        }
    }

    static fromJS(data: any): KanbanNota {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanNota();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["isAdv"] = this.isAdv !== undefined ? this.isAdv : <any>null;
        data["noAcc"] = this.noAcc !== undefined ? this.noAcc : <any>null;
        return data;
    }
}

export interface IKanbanNota {
    data?: string;
    testo?: string | null;
    isAdv?: boolean | null;
    noAcc?: boolean | null;
}

export class GetKanbanDocumentDataRequest extends SiteRequest implements IGetKanbanDocumentDataRequest {
    userID?: string;
    offertaID?: number;

    constructor(data?: IGetKanbanDocumentDataRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userID = _data["userID"] !== undefined ? _data["userID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
        }
    }

    static fromJS(data: any): GetKanbanDocumentDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetKanbanDocumentDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID !== undefined ? this.userID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetKanbanDocumentDataRequest extends ISiteRequest {
    userID?: string;
    offertaID?: number;
}

export class GetTripDocumentDataResponse extends OkApiResponse implements IGetTripDocumentDataResponse {
    tipoDocumento?: ETipoDocumento;
    /** Data e ora della stampa */
    printDate?: string;
    /** Dati del tour operator associato all'offerta */
    tourOperator?: TourOperator;
    /** Intestazione dell'offerta */
    header?: TripHeader;
    /** Dati finanziari dell'offerta */
    economics?: TripEconomics;
    paymentNameHtml?: string;
    totaleCommissionabile?: number;
    totaleCommissioni?: number;
    importoNettoDovutoDaAdv?: number;
    totaleDare?: number | null;
    totaleAvere?: number | null;
    totaleSbilancio?: number | null;
    /** Specchietto delle commissioni agenzia */
    agencyFees?: AgencyFee[];
    /** Dati dell'agenzia */
    agency?: TripAgency;
    /** Prezzi per pax */
    paxPrices?: PaxPrice[];
    /** Elenco tappe e servizi */
    steps?: TripStep[];
    /** Elenco servizi accessori, senza i voli */
    accessories?: TripService[];
    /** Elenco servizi accessori, senza i voli */
    insurances?: TripService[];
    /** Elenco servizi volo, separato dagli accessori */
    flights?: TripService[];
    /** Valori dei cambi */
    currencies?: CurrencyValue[];
    /** Lista delle penali cumulative per data */
    penaltiesByDate?: ImportoData[];
    /** Elenco dei PNR dell'offerta */
    pnrs?: FlightPnr[];
    /** Note a fine documento */
    footerNotes?: TripTextHtml[];
    /** Descrive l'itinerario completo giorno per giorno */
    daybyday?: DayByDay;
    /** Note a piè pagina dei servizi con ters organizzati con la legenda */
    servicesFooterNotes?: { [key: string]: TripTextHtml; };
    /** Sperimentale, il vecchio blocco testi */
    testi?: SezioneTesti[] | null;
    sections?: DocSections | null;
    estremiBancari?: EstremiBancari | null;
    elencoNote?: NoteDocumento[] | null;
    elencoMiniguide?: Miniguida[] | null;
    destinationInformation?: PassolutionAllInfo[] | null;

    constructor(data?: IGetTripDocumentDataResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : <any>null;
            this.printDate = _data["printDate"] !== undefined ? _data["printDate"] : <any>null;
            this.tourOperator = _data["tourOperator"] ? TourOperator.fromJS(_data["tourOperator"]) : <any>null;
            this.header = _data["header"] ? TripHeader.fromJS(_data["header"]) : <any>null;
            this.economics = _data["economics"] ? TripEconomics.fromJS(_data["economics"]) : <any>null;
            this.paymentNameHtml = _data["paymentNameHtml"] !== undefined ? _data["paymentNameHtml"] : <any>null;
            this.totaleCommissionabile = _data["totaleCommissionabile"] !== undefined ? _data["totaleCommissionabile"] : <any>null;
            this.totaleCommissioni = _data["totaleCommissioni"] !== undefined ? _data["totaleCommissioni"] : <any>null;
            this.importoNettoDovutoDaAdv = _data["importoNettoDovutoDaAdv"] !== undefined ? _data["importoNettoDovutoDaAdv"] : <any>null;
            this.totaleDare = _data["totaleDare"] !== undefined ? _data["totaleDare"] : <any>null;
            this.totaleAvere = _data["totaleAvere"] !== undefined ? _data["totaleAvere"] : <any>null;
            this.totaleSbilancio = _data["totaleSbilancio"] !== undefined ? _data["totaleSbilancio"] : <any>null;
            if (Array.isArray(_data["agencyFees"])) {
                this.agencyFees = [] as any;
                for (let item of _data["agencyFees"])
                    this.agencyFees!.push(AgencyFee.fromJS(item));
            }
            else {
                this.agencyFees = <any>null;
            }
            this.agency = _data["agency"] ? TripAgency.fromJS(_data["agency"]) : <any>null;
            if (Array.isArray(_data["paxPrices"])) {
                this.paxPrices = [] as any;
                for (let item of _data["paxPrices"])
                    this.paxPrices!.push(PaxPrice.fromJS(item));
            }
            else {
                this.paxPrices = <any>null;
            }
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(TripStep.fromJS(item));
            }
            else {
                this.steps = <any>null;
            }
            if (Array.isArray(_data["accessories"])) {
                this.accessories = [] as any;
                for (let item of _data["accessories"])
                    this.accessories!.push(TripService.fromJS(item));
            }
            else {
                this.accessories = <any>null;
            }
            if (Array.isArray(_data["insurances"])) {
                this.insurances = [] as any;
                for (let item of _data["insurances"])
                    this.insurances!.push(TripService.fromJS(item));
            }
            else {
                this.insurances = <any>null;
            }
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights!.push(TripService.fromJS(item));
            }
            else {
                this.flights = <any>null;
            }
            if (Array.isArray(_data["currencies"])) {
                this.currencies = [] as any;
                for (let item of _data["currencies"])
                    this.currencies!.push(CurrencyValue.fromJS(item));
            }
            else {
                this.currencies = <any>null;
            }
            if (Array.isArray(_data["penaltiesByDate"])) {
                this.penaltiesByDate = [] as any;
                for (let item of _data["penaltiesByDate"])
                    this.penaltiesByDate!.push(ImportoData.fromJS(item));
            }
            else {
                this.penaltiesByDate = <any>null;
            }
            if (Array.isArray(_data["pnrs"])) {
                this.pnrs = [] as any;
                for (let item of _data["pnrs"])
                    this.pnrs!.push(FlightPnr.fromJS(item));
            }
            else {
                this.pnrs = <any>null;
            }
            if (Array.isArray(_data["footerNotes"])) {
                this.footerNotes = [] as any;
                for (let item of _data["footerNotes"])
                    this.footerNotes!.push(TripTextHtml.fromJS(item));
            }
            else {
                this.footerNotes = <any>null;
            }
            this.daybyday = _data["daybyday"] ? DayByDay.fromJS(_data["daybyday"]) : <any>null;
            if (_data["servicesFooterNotes"]) {
                this.servicesFooterNotes = {} as any;
                for (let key in _data["servicesFooterNotes"]) {
                    if (_data["servicesFooterNotes"].hasOwnProperty(key))
                        (<any>this.servicesFooterNotes)![key] = _data["servicesFooterNotes"][key] ? TripTextHtml.fromJS(_data["servicesFooterNotes"][key]) : new TripTextHtml();
                }
            }
            else {
                this.servicesFooterNotes = <any>null;
            }
            if (Array.isArray(_data["testi"])) {
                this.testi = [] as any;
                for (let item of _data["testi"])
                    this.testi!.push(SezioneTesti.fromJS(item));
            }
            else {
                this.testi = <any>null;
            }
            this.sections = _data["sections"] ? DocSections.fromJS(_data["sections"]) : <any>null;
            this.estremiBancari = _data["estremiBancari"] ? EstremiBancari.fromJS(_data["estremiBancari"]) : <any>null;
            if (Array.isArray(_data["elencoNote"])) {
                this.elencoNote = [] as any;
                for (let item of _data["elencoNote"])
                    this.elencoNote!.push(NoteDocumento.fromJS(item));
            }
            else {
                this.elencoNote = <any>null;
            }
            if (Array.isArray(_data["elencoMiniguide"])) {
                this.elencoMiniguide = [] as any;
                for (let item of _data["elencoMiniguide"])
                    this.elencoMiniguide!.push(Miniguida.fromJS(item));
            }
            else {
                this.elencoMiniguide = <any>null;
            }
            if (Array.isArray(_data["destinationInformation"])) {
                this.destinationInformation = [] as any;
                for (let item of _data["destinationInformation"])
                    this.destinationInformation!.push(PassolutionAllInfo.fromJS(item));
            }
            else {
                this.destinationInformation = <any>null;
            }
        }
    }

    static fromJS(data: any): GetTripDocumentDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDocumentDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : <any>null;
        data["printDate"] = this.printDate !== undefined ? this.printDate : <any>null;
        data["tourOperator"] = this.tourOperator ? this.tourOperator.toJSON() : <any>null;
        data["header"] = this.header ? this.header.toJSON() : <any>null;
        data["economics"] = this.economics ? this.economics.toJSON() : <any>null;
        data["paymentNameHtml"] = this.paymentNameHtml !== undefined ? this.paymentNameHtml : <any>null;
        data["totaleCommissionabile"] = this.totaleCommissionabile !== undefined ? this.totaleCommissionabile : <any>null;
        data["totaleCommissioni"] = this.totaleCommissioni !== undefined ? this.totaleCommissioni : <any>null;
        data["importoNettoDovutoDaAdv"] = this.importoNettoDovutoDaAdv !== undefined ? this.importoNettoDovutoDaAdv : <any>null;
        data["totaleDare"] = this.totaleDare !== undefined ? this.totaleDare : <any>null;
        data["totaleAvere"] = this.totaleAvere !== undefined ? this.totaleAvere : <any>null;
        data["totaleSbilancio"] = this.totaleSbilancio !== undefined ? this.totaleSbilancio : <any>null;
        if (Array.isArray(this.agencyFees)) {
            data["agencyFees"] = [];
            for (let item of this.agencyFees)
                data["agencyFees"].push(item.toJSON());
        }
        data["agency"] = this.agency ? this.agency.toJSON() : <any>null;
        if (Array.isArray(this.paxPrices)) {
            data["paxPrices"] = [];
            for (let item of this.paxPrices)
                data["paxPrices"].push(item.toJSON());
        }
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        if (Array.isArray(this.accessories)) {
            data["accessories"] = [];
            for (let item of this.accessories)
                data["accessories"].push(item.toJSON());
        }
        if (Array.isArray(this.insurances)) {
            data["insurances"] = [];
            for (let item of this.insurances)
                data["insurances"].push(item.toJSON());
        }
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item.toJSON());
        }
        if (Array.isArray(this.currencies)) {
            data["currencies"] = [];
            for (let item of this.currencies)
                data["currencies"].push(item.toJSON());
        }
        if (Array.isArray(this.penaltiesByDate)) {
            data["penaltiesByDate"] = [];
            for (let item of this.penaltiesByDate)
                data["penaltiesByDate"].push(item.toJSON());
        }
        if (Array.isArray(this.pnrs)) {
            data["pnrs"] = [];
            for (let item of this.pnrs)
                data["pnrs"].push(item.toJSON());
        }
        if (Array.isArray(this.footerNotes)) {
            data["footerNotes"] = [];
            for (let item of this.footerNotes)
                data["footerNotes"].push(item.toJSON());
        }
        data["daybyday"] = this.daybyday ? this.daybyday.toJSON() : <any>null;
        if (this.servicesFooterNotes) {
            data["servicesFooterNotes"] = {};
            for (let key in this.servicesFooterNotes) {
                if (this.servicesFooterNotes.hasOwnProperty(key))
                    (<any>data["servicesFooterNotes"])[key] = this.servicesFooterNotes[key] ? this.servicesFooterNotes[key].toJSON() : <any>null;
            }
        }
        if (Array.isArray(this.testi)) {
            data["testi"] = [];
            for (let item of this.testi)
                data["testi"].push(item.toJSON());
        }
        data["sections"] = this.sections ? this.sections.toJSON() : <any>null;
        data["estremiBancari"] = this.estremiBancari ? this.estremiBancari.toJSON() : <any>null;
        if (Array.isArray(this.elencoNote)) {
            data["elencoNote"] = [];
            for (let item of this.elencoNote)
                data["elencoNote"].push(item.toJSON());
        }
        if (Array.isArray(this.elencoMiniguide)) {
            data["elencoMiniguide"] = [];
            for (let item of this.elencoMiniguide)
                data["elencoMiniguide"].push(item.toJSON());
        }
        if (Array.isArray(this.destinationInformation)) {
            data["destinationInformation"] = [];
            for (let item of this.destinationInformation)
                data["destinationInformation"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripDocumentDataResponse extends IOkApiResponse {
    tipoDocumento?: ETipoDocumento;
    /** Data e ora della stampa */
    printDate?: string;
    /** Dati del tour operator associato all'offerta */
    tourOperator?: TourOperator;
    /** Intestazione dell'offerta */
    header?: TripHeader;
    /** Dati finanziari dell'offerta */
    economics?: TripEconomics;
    paymentNameHtml?: string;
    totaleCommissionabile?: number;
    totaleCommissioni?: number;
    importoNettoDovutoDaAdv?: number;
    totaleDare?: number | null;
    totaleAvere?: number | null;
    totaleSbilancio?: number | null;
    /** Specchietto delle commissioni agenzia */
    agencyFees?: AgencyFee[];
    /** Dati dell'agenzia */
    agency?: TripAgency;
    /** Prezzi per pax */
    paxPrices?: PaxPrice[];
    /** Elenco tappe e servizi */
    steps?: TripStep[];
    /** Elenco servizi accessori, senza i voli */
    accessories?: TripService[];
    /** Elenco servizi accessori, senza i voli */
    insurances?: TripService[];
    /** Elenco servizi volo, separato dagli accessori */
    flights?: TripService[];
    /** Valori dei cambi */
    currencies?: CurrencyValue[];
    /** Lista delle penali cumulative per data */
    penaltiesByDate?: ImportoData[];
    /** Elenco dei PNR dell'offerta */
    pnrs?: FlightPnr[];
    /** Note a fine documento */
    footerNotes?: TripTextHtml[];
    /** Descrive l'itinerario completo giorno per giorno */
    daybyday?: DayByDay;
    /** Note a piè pagina dei servizi con ters organizzati con la legenda */
    servicesFooterNotes?: { [key: string]: TripTextHtml; };
    /** Sperimentale, il vecchio blocco testi */
    testi?: SezioneTesti[] | null;
    sections?: DocSections | null;
    estremiBancari?: EstremiBancari | null;
    elencoNote?: NoteDocumento[] | null;
    elencoMiniguide?: Miniguida[] | null;
    destinationInformation?: PassolutionAllInfo[] | null;
}

/** Dati del tour operator ricavati dal contatto associato */
export class TourOperator implements ITourOperator {
    ragioneSociale?: string;
    indirizzo?: string;
    civico?: string;
    cap?: string;
    luogo?: string;
    telefono?: string;
    fax?: string;
    email?: string;
    partitaIVA?: string;
    codiceSDI?: string;
    websiteUrl?: string;
    logoUrl?: string;

    constructor(data?: ITourOperator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ragioneSociale = _data["ragioneSociale"] !== undefined ? _data["ragioneSociale"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.civico = _data["civico"] !== undefined ? _data["civico"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.partitaIVA = _data["partitaIVA"] !== undefined ? _data["partitaIVA"] : <any>null;
            this.codiceSDI = _data["codiceSDI"] !== undefined ? _data["codiceSDI"] : <any>null;
            this.websiteUrl = _data["websiteUrl"] !== undefined ? _data["websiteUrl"] : <any>null;
            this.logoUrl = _data["logoUrl"] !== undefined ? _data["logoUrl"] : <any>null;
        }
    }

    static fromJS(data: any): TourOperator {
        data = typeof data === 'object' ? data : {};
        let result = new TourOperator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ragioneSociale"] = this.ragioneSociale !== undefined ? this.ragioneSociale : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["civico"] = this.civico !== undefined ? this.civico : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["partitaIVA"] = this.partitaIVA !== undefined ? this.partitaIVA : <any>null;
        data["codiceSDI"] = this.codiceSDI !== undefined ? this.codiceSDI : <any>null;
        data["websiteUrl"] = this.websiteUrl !== undefined ? this.websiteUrl : <any>null;
        data["logoUrl"] = this.logoUrl !== undefined ? this.logoUrl : <any>null;
        return data;
    }
}

/** Dati del tour operator ricavati dal contatto associato */
export interface ITourOperator {
    ragioneSociale?: string;
    indirizzo?: string;
    civico?: string;
    cap?: string;
    luogo?: string;
    telefono?: string;
    fax?: string;
    email?: string;
    partitaIVA?: string;
    codiceSDI?: string;
    websiteUrl?: string;
    logoUrl?: string;
}

/** Riga di commissione agenzia */
export class AgencyFee implements IAgencyFee {
    nettoIva?: boolean;
    percentuale?: number;
    totalePrezzo?: number;
    totaleCommissione?: number;

    constructor(data?: IAgencyFee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nettoIva = _data["nettoIva"] !== undefined ? _data["nettoIva"] : <any>null;
            this.percentuale = _data["percentuale"] !== undefined ? _data["percentuale"] : <any>null;
            this.totalePrezzo = _data["totalePrezzo"] !== undefined ? _data["totalePrezzo"] : <any>null;
            this.totaleCommissione = _data["totaleCommissione"] !== undefined ? _data["totaleCommissione"] : <any>null;
        }
    }

    static fromJS(data: any): AgencyFee {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyFee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nettoIva"] = this.nettoIva !== undefined ? this.nettoIva : <any>null;
        data["percentuale"] = this.percentuale !== undefined ? this.percentuale : <any>null;
        data["totalePrezzo"] = this.totalePrezzo !== undefined ? this.totalePrezzo : <any>null;
        data["totaleCommissione"] = this.totaleCommissione !== undefined ? this.totaleCommissione : <any>null;
        return data;
    }
}

/** Riga di commissione agenzia */
export interface IAgencyFee {
    nettoIva?: boolean;
    percentuale?: number;
    totalePrezzo?: number;
    totaleCommissione?: number;
}

/** Prezzi per passeggero */
export class PaxPrice implements IPaxPrice {
    titolo?: ETitolo;
    nomeVisualizzato?: string;
    codiceFiscale?: string;
    prezzo?: number;

    constructor(data?: IPaxPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : <any>null;
            this.codiceFiscale = _data["codiceFiscale"] !== undefined ? _data["codiceFiscale"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
        }
    }

    static fromJS(data: any): PaxPrice {
        data = typeof data === 'object' ? data : {};
        let result = new PaxPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : <any>null;
        data["codiceFiscale"] = this.codiceFiscale !== undefined ? this.codiceFiscale : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        return data;
    }
}

/** Prezzi per passeggero */
export interface IPaxPrice {
    titolo?: ETitolo;
    nomeVisualizzato?: string;
    codiceFiscale?: string;
    prezzo?: number;
}

/** Valore applicato nei cambi delle monete */
export class CurrencyValue implements ICurrencyValue {
    nome?: string;
    valore?: number;

    constructor(data?: ICurrencyValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : <any>null;
        }
    }

    static fromJS(data: any): CurrencyValue {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["valore"] = this.valore !== undefined ? this.valore : <any>null;
        return data;
    }
}

/** Valore applicato nei cambi delle monete */
export interface ICurrencyValue {
    nome?: string;
    valore?: number;
}

/** Tupla che abbina una data ad un importo */
export class ImportoData implements IImportoData {
    /** Importo */
    amount?: number;
    /** Data */
    date?: string;

    constructor(data?: IImportoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
        }
    }

    static fromJS(data: any): ImportoData {
        data = typeof data === 'object' ? data : {};
        let result = new ImportoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        return data;
    }
}

/** Tupla che abbina una data ad un importo */
export interface IImportoData {
    /** Importo */
    amount?: number;
    /** Data */
    date?: string;
}

/** Dati di un singolo PNR */
export class FlightPnr implements IFlightPnr {
    pnr?: string;
    abbinamento?: string | null;
    segmenti?: FlightSegment2[];
    compagnie?: FlightAirline[];
    noteCompagnie?: TripTextHtml[];

    constructor(data?: IFlightPnr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : <any>null;
            this.abbinamento = _data["abbinamento"] !== undefined ? _data["abbinamento"] : <any>null;
            if (Array.isArray(_data["segmenti"])) {
                this.segmenti = [] as any;
                for (let item of _data["segmenti"])
                    this.segmenti!.push(FlightSegment2.fromJS(item));
            }
            else {
                this.segmenti = <any>null;
            }
            if (Array.isArray(_data["compagnie"])) {
                this.compagnie = [] as any;
                for (let item of _data["compagnie"])
                    this.compagnie!.push(FlightAirline.fromJS(item));
            }
            else {
                this.compagnie = <any>null;
            }
            if (Array.isArray(_data["noteCompagnie"])) {
                this.noteCompagnie = [] as any;
                for (let item of _data["noteCompagnie"])
                    this.noteCompagnie!.push(TripTextHtml.fromJS(item));
            }
            else {
                this.noteCompagnie = <any>null;
            }
        }
    }

    static fromJS(data: any): FlightPnr {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPnr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnr"] = this.pnr !== undefined ? this.pnr : <any>null;
        data["abbinamento"] = this.abbinamento !== undefined ? this.abbinamento : <any>null;
        if (Array.isArray(this.segmenti)) {
            data["segmenti"] = [];
            for (let item of this.segmenti)
                data["segmenti"].push(item.toJSON());
        }
        if (Array.isArray(this.compagnie)) {
            data["compagnie"] = [];
            for (let item of this.compagnie)
                data["compagnie"].push(item.toJSON());
        }
        if (Array.isArray(this.noteCompagnie)) {
            data["noteCompagnie"] = [];
            for (let item of this.noteCompagnie)
                data["noteCompagnie"].push(item.toJSON());
        }
        return data;
    }
}

/** Dati di un singolo PNR */
export interface IFlightPnr {
    pnr?: string;
    abbinamento?: string | null;
    segmenti?: FlightSegment2[];
    compagnie?: FlightAirline[];
    noteCompagnie?: TripTextHtml[];
}

/** Dati di un singolo segmento volo */
export class FlightSegment2 implements IFlightSegment2 {
    partenza?: string;
    arrivo?: string;
    arrivoGiornoDopo?: boolean;
    codiceCompagnia?: string | null;
    nomeCompagnia?: string | null;
    volo?: number;
    da?: string;
    daCodice?: string | null;
    a?: string;
    aCodice?: string | null;
    status?: string | null;
    codiceOperatedBy?: string | null;
    nomeOperatedBy?: string | null;
    details?: FlightSegmentDetail[];

    constructor(data?: IFlightSegment2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.arrivo = _data["arrivo"] !== undefined ? _data["arrivo"] : <any>null;
            this.arrivoGiornoDopo = _data["arrivoGiornoDopo"] !== undefined ? _data["arrivoGiornoDopo"] : <any>null;
            this.codiceCompagnia = _data["codiceCompagnia"] !== undefined ? _data["codiceCompagnia"] : <any>null;
            this.nomeCompagnia = _data["nomeCompagnia"] !== undefined ? _data["nomeCompagnia"] : <any>null;
            this.volo = _data["volo"] !== undefined ? _data["volo"] : <any>null;
            this.da = _data["da"] !== undefined ? _data["da"] : <any>null;
            this.daCodice = _data["daCodice"] !== undefined ? _data["daCodice"] : <any>null;
            this.a = _data["a"] !== undefined ? _data["a"] : <any>null;
            this.aCodice = _data["aCodice"] !== undefined ? _data["aCodice"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.codiceOperatedBy = _data["codiceOperatedBy"] !== undefined ? _data["codiceOperatedBy"] : <any>null;
            this.nomeOperatedBy = _data["nomeOperatedBy"] !== undefined ? _data["nomeOperatedBy"] : <any>null;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(FlightSegmentDetail.fromJS(item));
            }
            else {
                this.details = <any>null;
            }
        }
    }

    static fromJS(data: any): FlightSegment2 {
        data = typeof data === 'object' ? data : {};
        let result = new FlightSegment2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["arrivo"] = this.arrivo !== undefined ? this.arrivo : <any>null;
        data["arrivoGiornoDopo"] = this.arrivoGiornoDopo !== undefined ? this.arrivoGiornoDopo : <any>null;
        data["codiceCompagnia"] = this.codiceCompagnia !== undefined ? this.codiceCompagnia : <any>null;
        data["nomeCompagnia"] = this.nomeCompagnia !== undefined ? this.nomeCompagnia : <any>null;
        data["volo"] = this.volo !== undefined ? this.volo : <any>null;
        data["da"] = this.da !== undefined ? this.da : <any>null;
        data["daCodice"] = this.daCodice !== undefined ? this.daCodice : <any>null;
        data["a"] = this.a !== undefined ? this.a : <any>null;
        data["aCodice"] = this.aCodice !== undefined ? this.aCodice : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["codiceOperatedBy"] = this.codiceOperatedBy !== undefined ? this.codiceOperatedBy : <any>null;
        data["nomeOperatedBy"] = this.nomeOperatedBy !== undefined ? this.nomeOperatedBy : <any>null;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

/** Dati di un singolo segmento volo */
export interface IFlightSegment2 {
    partenza?: string;
    arrivo?: string;
    arrivoGiornoDopo?: boolean;
    codiceCompagnia?: string | null;
    nomeCompagnia?: string | null;
    volo?: number;
    da?: string;
    daCodice?: string | null;
    a?: string;
    aCodice?: string | null;
    status?: string | null;
    codiceOperatedBy?: string | null;
    nomeOperatedBy?: string | null;
    details?: FlightSegmentDetail[];
}

export class FlightSegmentDetail implements IFlightSegmentDetail {
    tipoPaxID?: ETipoPax | null;
    numeroPax?: number | null;
    baggageIncluded?: number | null;

    constructor(data?: IFlightSegmentDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoPaxID = _data["tipoPaxID"] !== undefined ? _data["tipoPaxID"] : <any>null;
            this.numeroPax = _data["numeroPax"] !== undefined ? _data["numeroPax"] : <any>null;
            this.baggageIncluded = _data["baggageIncluded"] !== undefined ? _data["baggageIncluded"] : <any>null;
        }
    }

    static fromJS(data: any): FlightSegmentDetail {
        data = typeof data === 'object' ? data : {};
        let result = new FlightSegmentDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoPaxID"] = this.tipoPaxID !== undefined ? this.tipoPaxID : <any>null;
        data["numeroPax"] = this.numeroPax !== undefined ? this.numeroPax : <any>null;
        data["baggageIncluded"] = this.baggageIncluded !== undefined ? this.baggageIncluded : <any>null;
        return data;
    }
}

export interface IFlightSegmentDetail {
    tipoPaxID?: ETipoPax | null;
    numeroPax?: number | null;
    baggageIncluded?: number | null;
}

/** Descrittore compagia aerea */
export class FlightAirline implements IFlightAirline {
    codice?: string;
    nome?: string;

    constructor(data?: IFlightAirline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
        }
    }

    static fromJS(data: any): FlightAirline {
        data = typeof data === 'object' ? data : {};
        let result = new FlightAirline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        return data;
    }
}

/** Descrittore compagia aerea */
export interface IFlightAirline {
    codice?: string;
    nome?: string;
}

/** Elenco dei giorni del Viaggio */
export class DayByDay implements IDayByDay {
    days?: Day[];
    notes?: TextSeed[];

    constructor(data?: IDayByDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(Day.fromJS(item));
            }
            else {
                this.days = <any>null;
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(TextSeed.fromJS(item));
            }
            else {
                this.notes = <any>null;
            }
        }
    }

    static fromJS(data: any): DayByDay {
        data = typeof data === 'object' ? data : {};
        let result = new DayByDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        return data;
    }
}

/** Elenco dei giorni del Viaggio */
export interface IDayByDay {
    days?: Day[];
    notes?: TextSeed[];
}

export class Day implements IDay {
    date?: string | null;
    locations?: string;
    steps?: Step[];

    constructor(data?: IDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.locations = _data["locations"] !== undefined ? _data["locations"] : <any>null;
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(Step.fromJS(item));
            }
            else {
                this.steps = <any>null;
            }
        }
    }

    static fromJS(data: any): Day {
        data = typeof data === 'object' ? data : {};
        let result = new Day();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["locations"] = this.locations !== undefined ? this.locations : <any>null;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDay {
    date?: string | null;
    locations?: string;
    steps?: Step[];
}

/** Indica ogni passo della giornata di un viaggio completo di testi, immagini, dettagli servizi, dettagli voli */
export class Step implements IStep {
    idx?: number;
    luogo?: string | null;
    description?: TextSeed | null;
    imgUrl?: string | null;
    dateFrom?: string;
    dateTo?: string;
    servizi?: SvcDetail[] | null;
    voli?: FlightSegment2[] | null;
    images?: ImageSeed[] | null;

    constructor(data?: IStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idx = _data["idx"] !== undefined ? _data["idx"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.description = _data["description"] ? TextSeed.fromJS(_data["description"]) : <any>null;
            this.imgUrl = _data["imgUrl"] !== undefined ? _data["imgUrl"] : <any>null;
            this.dateFrom = _data["dateFrom"] !== undefined ? _data["dateFrom"] : <any>null;
            this.dateTo = _data["dateTo"] !== undefined ? _data["dateTo"] : <any>null;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(SvcDetail.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
            if (Array.isArray(_data["voli"])) {
                this.voli = [] as any;
                for (let item of _data["voli"])
                    this.voli!.push(FlightSegment2.fromJS(item));
            }
            else {
                this.voli = <any>null;
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageSeed.fromJS(item));
            }
            else {
                this.images = <any>null;
            }
        }
    }

    static fromJS(data: any): Step {
        data = typeof data === 'object' ? data : {};
        let result = new Step();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idx"] = this.idx !== undefined ? this.idx : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["description"] = this.description ? this.description.toJSON() : <any>null;
        data["imgUrl"] = this.imgUrl !== undefined ? this.imgUrl : <any>null;
        data["dateFrom"] = this.dateFrom !== undefined ? this.dateFrom : <any>null;
        data["dateTo"] = this.dateTo !== undefined ? this.dateTo : <any>null;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        if (Array.isArray(this.voli)) {
            data["voli"] = [];
            for (let item of this.voli)
                data["voli"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        return data;
    }
}

/** Indica ogni passo della giornata di un viaggio completo di testi, immagini, dettagli servizi, dettagli voli */
export interface IStep {
    idx?: number;
    luogo?: string | null;
    description?: TextSeed | null;
    imgUrl?: string | null;
    dateFrom?: string;
    dateTo?: string;
    servizi?: SvcDetail[] | null;
    voli?: FlightSegment2[] | null;
    images?: ImageSeed[] | null;
}

export class TextSeed implements ITextSeed {
    title?: string;
    text?: string;

    constructor(data?: ITextSeed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): TextSeed {
        data = typeof data === 'object' ? data : {};
        let result = new TextSeed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface ITextSeed {
    title?: string;
    text?: string;
}

export class SvcDetail implements ISvcDetail {
    id?: number;
    name?: string | null;
    imgUrl?: string | null;
    texts?: TextSeed[] | null;

    constructor(data?: ISvcDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.imgUrl = _data["imgUrl"] !== undefined ? _data["imgUrl"] : <any>null;
            if (Array.isArray(_data["texts"])) {
                this.texts = [] as any;
                for (let item of _data["texts"])
                    this.texts!.push(TextSeed.fromJS(item));
            }
            else {
                this.texts = <any>null;
            }
        }
    }

    static fromJS(data: any): SvcDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SvcDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["imgUrl"] = this.imgUrl !== undefined ? this.imgUrl : <any>null;
        if (Array.isArray(this.texts)) {
            data["texts"] = [];
            for (let item of this.texts)
                data["texts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISvcDetail {
    id?: number;
    name?: string | null;
    imgUrl?: string | null;
    texts?: TextSeed[] | null;
}

export class SezioneTesti implements ISezioneTesti {
    sezione?: ArticoloSezione | null;
    testo?: string | null;
    servizioID?: number | null;
    testiLuoghiGiorni?: SezioneLuoghiTesti[] | null;
    testiDescrittiviServizi?: SezioneTestoDescrizioneServizio[] | null;
    override?: OverrideServizi[] | null;
    ufficiLocali?: SezioneUfficioLocale[] | null;
    testiSintesi?: SezioneSintesiTesti[] | null;

    constructor(data?: ISezioneTesti) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sezione = _data["sezione"] ? ArticoloSezione.fromJS(_data["sezione"]) : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            if (Array.isArray(_data["testiLuoghiGiorni"])) {
                this.testiLuoghiGiorni = [] as any;
                for (let item of _data["testiLuoghiGiorni"])
                    this.testiLuoghiGiorni!.push(SezioneLuoghiTesti.fromJS(item));
            }
            else {
                this.testiLuoghiGiorni = <any>null;
            }
            if (Array.isArray(_data["testiDescrittiviServizi"])) {
                this.testiDescrittiviServizi = [] as any;
                for (let item of _data["testiDescrittiviServizi"])
                    this.testiDescrittiviServizi!.push(SezioneTestoDescrizioneServizio.fromJS(item));
            }
            else {
                this.testiDescrittiviServizi = <any>null;
            }
            if (Array.isArray(_data["override"])) {
                this.override = [] as any;
                for (let item of _data["override"])
                    this.override!.push(OverrideServizi.fromJS(item));
            }
            else {
                this.override = <any>null;
            }
            if (Array.isArray(_data["ufficiLocali"])) {
                this.ufficiLocali = [] as any;
                for (let item of _data["ufficiLocali"])
                    this.ufficiLocali!.push(SezioneUfficioLocale.fromJS(item));
            }
            else {
                this.ufficiLocali = <any>null;
            }
            if (Array.isArray(_data["testiSintesi"])) {
                this.testiSintesi = [] as any;
                for (let item of _data["testiSintesi"])
                    this.testiSintesi!.push(SezioneSintesiTesti.fromJS(item));
            }
            else {
                this.testiSintesi = <any>null;
            }
        }
    }

    static fromJS(data: any): SezioneTesti {
        data = typeof data === 'object' ? data : {};
        let result = new SezioneTesti();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sezione"] = this.sezione ? this.sezione.toJSON() : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        if (Array.isArray(this.testiLuoghiGiorni)) {
            data["testiLuoghiGiorni"] = [];
            for (let item of this.testiLuoghiGiorni)
                data["testiLuoghiGiorni"].push(item.toJSON());
        }
        if (Array.isArray(this.testiDescrittiviServizi)) {
            data["testiDescrittiviServizi"] = [];
            for (let item of this.testiDescrittiviServizi)
                data["testiDescrittiviServizi"].push(item.toJSON());
        }
        if (Array.isArray(this.override)) {
            data["override"] = [];
            for (let item of this.override)
                data["override"].push(item.toJSON());
        }
        if (Array.isArray(this.ufficiLocali)) {
            data["ufficiLocali"] = [];
            for (let item of this.ufficiLocali)
                data["ufficiLocali"].push(item.toJSON());
        }
        if (Array.isArray(this.testiSintesi)) {
            data["testiSintesi"] = [];
            for (let item of this.testiSintesi)
                data["testiSintesi"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISezioneTesti {
    sezione?: ArticoloSezione | null;
    testo?: string | null;
    servizioID?: number | null;
    testiLuoghiGiorni?: SezioneLuoghiTesti[] | null;
    testiDescrittiviServizi?: SezioneTestoDescrizioneServizio[] | null;
    override?: OverrideServizi[] | null;
    ufficiLocali?: SezioneUfficioLocale[] | null;
    testiSintesi?: SezioneSintesiTesti[] | null;
}

export class ArticoloSezione implements IArticoloSezione {
    id?: number;
    nomeITA!: string;
    nomeENG?: string | null;
    nomeFRA?: string | null;
    nomeDEU?: string | null;
    nomeDUT?: string | null;
    ordine?: number;
    visibilita?: EVisibilitaSezione;
    codice?: string | null;
    tipoServizio?: ETipoServizioFlags;
    isItinerary?: boolean;

    constructor(data?: IArticoloSezione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nomeITA = _data["nomeITA"] !== undefined ? _data["nomeITA"] : <any>null;
            this.nomeENG = _data["nomeENG"] !== undefined ? _data["nomeENG"] : <any>null;
            this.nomeFRA = _data["nomeFRA"] !== undefined ? _data["nomeFRA"] : <any>null;
            this.nomeDEU = _data["nomeDEU"] !== undefined ? _data["nomeDEU"] : <any>null;
            this.nomeDUT = _data["nomeDUT"] !== undefined ? _data["nomeDUT"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.isItinerary = _data["isItinerary"] !== undefined ? _data["isItinerary"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloSezione {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloSezione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nomeITA"] = this.nomeITA !== undefined ? this.nomeITA : <any>null;
        data["nomeENG"] = this.nomeENG !== undefined ? this.nomeENG : <any>null;
        data["nomeFRA"] = this.nomeFRA !== undefined ? this.nomeFRA : <any>null;
        data["nomeDEU"] = this.nomeDEU !== undefined ? this.nomeDEU : <any>null;
        data["nomeDUT"] = this.nomeDUT !== undefined ? this.nomeDUT : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["isItinerary"] = this.isItinerary !== undefined ? this.isItinerary : <any>null;
        return data;
    }
}

export interface IArticoloSezione {
    id?: number;
    nomeITA: string;
    nomeENG?: string | null;
    nomeFRA?: string | null;
    nomeDEU?: string | null;
    nomeDUT?: string | null;
    ordine?: number;
    visibilita?: EVisibilitaSezione;
    codice?: string | null;
    tipoServizio?: ETipoServizioFlags;
    isItinerary?: boolean;
}

export class SezioneLuoghiTesti implements ISezioneLuoghiTesti {
    giorno?: number;
    data?: string;
    dataFine?: string | null;
    nomiLuoghi?: string[] | null;
    testo?: string | null;
    hashLuoghi?: string | null;

    constructor(data?: ISezioneLuoghiTesti) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.dataFine = _data["dataFine"] !== undefined ? _data["dataFine"] : <any>null;
            if (Array.isArray(_data["nomiLuoghi"])) {
                this.nomiLuoghi = [] as any;
                for (let item of _data["nomiLuoghi"])
                    this.nomiLuoghi!.push(item);
            }
            else {
                this.nomiLuoghi = <any>null;
            }
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.hashLuoghi = _data["hashLuoghi"] !== undefined ? _data["hashLuoghi"] : <any>null;
        }
    }

    static fromJS(data: any): SezioneLuoghiTesti {
        data = typeof data === 'object' ? data : {};
        let result = new SezioneLuoghiTesti();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["dataFine"] = this.dataFine !== undefined ? this.dataFine : <any>null;
        if (Array.isArray(this.nomiLuoghi)) {
            data["nomiLuoghi"] = [];
            for (let item of this.nomiLuoghi)
                data["nomiLuoghi"].push(item);
        }
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["hashLuoghi"] = this.hashLuoghi !== undefined ? this.hashLuoghi : <any>null;
        return data;
    }
}

export interface ISezioneLuoghiTesti {
    giorno?: number;
    data?: string;
    dataFine?: string | null;
    nomiLuoghi?: string[] | null;
    testo?: string | null;
    hashLuoghi?: string | null;
}

export class SezioneTestoDescrizioneServizio implements ISezioneTestoDescrizioneServizio {
    servizioID?: number;
    testo?: string | null;

    constructor(data?: ISezioneTestoDescrizioneServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
        }
    }

    static fromJS(data: any): SezioneTestoDescrizioneServizio {
        data = typeof data === 'object' ? data : {};
        let result = new SezioneTestoDescrizioneServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        return data;
    }
}

export interface ISezioneTestoDescrizioneServizio {
    servizioID?: number;
    testo?: string | null;
}

export class OverrideServizi implements IOverrideServizi {
    rigaID?: number;
    servizioID?: number;
    giorno?: number;
    servizioOverrideID?: number;
    overrideDescrizione?: string | null;

    constructor(data?: IOverrideServizi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.servizioOverrideID = _data["servizioOverrideID"] !== undefined ? _data["servizioOverrideID"] : <any>null;
            this.overrideDescrizione = _data["overrideDescrizione"] !== undefined ? _data["overrideDescrizione"] : <any>null;
        }
    }

    static fromJS(data: any): OverrideServizi {
        data = typeof data === 'object' ? data : {};
        let result = new OverrideServizi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["servizioOverrideID"] = this.servizioOverrideID !== undefined ? this.servizioOverrideID : <any>null;
        data["overrideDescrizione"] = this.overrideDescrizione !== undefined ? this.overrideDescrizione : <any>null;
        return data;
    }
}

export interface IOverrideServizi {
    rigaID?: number;
    servizioID?: number;
    giorno?: number;
    servizioOverrideID?: number;
    overrideDescrizione?: string | null;
}

export class SezioneUfficioLocale implements ISezioneUfficioLocale {
    contattoID?: number;
    testo?: string | null;

    constructor(data?: ISezioneUfficioLocale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
        }
    }

    static fromJS(data: any): SezioneUfficioLocale {
        data = typeof data === 'object' ? data : {};
        let result = new SezioneUfficioLocale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        return data;
    }
}

export interface ISezioneUfficioLocale {
    contattoID?: number;
    testo?: string | null;
}

export class SezioneSintesiTesti implements ISezioneSintesiTesti {
    rigaID?: number;
    testo?: string | null;

    constructor(data?: ISezioneSintesiTesti) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
        }
    }

    static fromJS(data: any): SezioneSintesiTesti {
        data = typeof data === 'object' ? data : {};
        let result = new SezioneSintesiTesti();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        return data;
    }
}

export interface ISezioneSintesiTesti {
    rigaID?: number;
    testo?: string | null;
}

/** Usata per generare le sezioni del PreventivoClientePlus */
export class DocSections implements IDocSections {
    sectionServizi?: SectionServizi;
    sectionUffici?: SectionUffici;
    sectionInfoHotel?: SectionInfoHotel;
    sectionNote?: SectionNote;
    sectionPDV?: SectionProgrammaDiViaggio;
    sectionAssistenza?: SectionAssistenza;
    sectionAssicurazione?: SectionAssicurazione;
    sectionElencoVoucher?: SectionElencoVoucher;
    sectionMiniguide?: SectionMiniguide;
    sectionTicketsVoli?: SectionTicketsVoli;

    constructor(data?: IDocSections) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionServizi = _data["sectionServizi"] ? SectionServizi.fromJS(_data["sectionServizi"]) : <any>null;
            this.sectionUffici = _data["sectionUffici"] ? SectionUffici.fromJS(_data["sectionUffici"]) : <any>null;
            this.sectionInfoHotel = _data["sectionInfoHotel"] ? SectionInfoHotel.fromJS(_data["sectionInfoHotel"]) : <any>null;
            this.sectionNote = _data["sectionNote"] ? SectionNote.fromJS(_data["sectionNote"]) : <any>null;
            this.sectionPDV = _data["sectionPDV"] ? SectionProgrammaDiViaggio.fromJS(_data["sectionPDV"]) : <any>null;
            this.sectionAssistenza = _data["sectionAssistenza"] ? SectionAssistenza.fromJS(_data["sectionAssistenza"]) : <any>null;
            this.sectionAssicurazione = _data["sectionAssicurazione"] ? SectionAssicurazione.fromJS(_data["sectionAssicurazione"]) : <any>null;
            this.sectionElencoVoucher = _data["sectionElencoVoucher"] ? SectionElencoVoucher.fromJS(_data["sectionElencoVoucher"]) : <any>null;
            this.sectionMiniguide = _data["sectionMiniguide"] ? SectionMiniguide.fromJS(_data["sectionMiniguide"]) : <any>null;
            this.sectionTicketsVoli = _data["sectionTicketsVoli"] ? SectionTicketsVoli.fromJS(_data["sectionTicketsVoli"]) : <any>null;
        }
    }

    static fromJS(data: any): DocSections {
        data = typeof data === 'object' ? data : {};
        let result = new DocSections();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionServizi"] = this.sectionServizi ? this.sectionServizi.toJSON() : <any>null;
        data["sectionUffici"] = this.sectionUffici ? this.sectionUffici.toJSON() : <any>null;
        data["sectionInfoHotel"] = this.sectionInfoHotel ? this.sectionInfoHotel.toJSON() : <any>null;
        data["sectionNote"] = this.sectionNote ? this.sectionNote.toJSON() : <any>null;
        data["sectionPDV"] = this.sectionPDV ? this.sectionPDV.toJSON() : <any>null;
        data["sectionAssistenza"] = this.sectionAssistenza ? this.sectionAssistenza.toJSON() : <any>null;
        data["sectionAssicurazione"] = this.sectionAssicurazione ? this.sectionAssicurazione.toJSON() : <any>null;
        data["sectionElencoVoucher"] = this.sectionElencoVoucher ? this.sectionElencoVoucher.toJSON() : <any>null;
        data["sectionMiniguide"] = this.sectionMiniguide ? this.sectionMiniguide.toJSON() : <any>null;
        data["sectionTicketsVoli"] = this.sectionTicketsVoli ? this.sectionTicketsVoli.toJSON() : <any>null;
        return data;
    }
}

/** Usata per generare le sezioni del PreventivoClientePlus */
export interface IDocSections {
    sectionServizi?: SectionServizi;
    sectionUffici?: SectionUffici;
    sectionInfoHotel?: SectionInfoHotel;
    sectionNote?: SectionNote;
    sectionPDV?: SectionProgrammaDiViaggio;
    sectionAssistenza?: SectionAssistenza;
    sectionAssicurazione?: SectionAssicurazione;
    sectionElencoVoucher?: SectionElencoVoucher;
    sectionMiniguide?: SectionMiniguide;
    sectionTicketsVoli?: SectionTicketsVoli;
}

export class ExportableSection implements IExportableSection {

    constructor(data?: IExportableSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ExportableSection {
        data = typeof data === 'object' ? data : {};
        let result = new ExportableSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IExportableSection {
}

export class SectionServizi extends ExportableSection implements ISectionServizi {
    servizi?: RigaServizio[] | null;

    constructor(data?: ISectionServizi) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(RigaServizio.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
        }
    }

    static fromJS(data: any): SectionServizi {
        data = typeof data === 'object' ? data : {};
        let result = new SectionServizi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISectionServizi extends IExportableSection {
    servizi?: RigaServizio[] | null;
}

export class RigaServizio implements IRigaServizio {
    idServizio?: number;
    tipo?: string | null;
    nome?: string | null;
    indirizzo?: string | null;
    telefono?: string | null;
    luogo?: string | null;
    descrizioniRighe?: string[] | null;
    isHotel?: boolean;
    abbinamentiDate?: AbbinamentoData[] | null;
    isFullContent?: boolean;
    fullContentInfo?: string | null;

    constructor(data?: IRigaServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idServizio = _data["idServizio"] !== undefined ? _data["idServizio"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            if (Array.isArray(_data["descrizioniRighe"])) {
                this.descrizioniRighe = [] as any;
                for (let item of _data["descrizioniRighe"])
                    this.descrizioniRighe!.push(item);
            }
            else {
                this.descrizioniRighe = <any>null;
            }
            this.isHotel = _data["isHotel"] !== undefined ? _data["isHotel"] : <any>null;
            if (Array.isArray(_data["abbinamentiDate"])) {
                this.abbinamentiDate = [] as any;
                for (let item of _data["abbinamentiDate"])
                    this.abbinamentiDate!.push(AbbinamentoData.fromJS(item));
            }
            else {
                this.abbinamentiDate = <any>null;
            }
            this.isFullContent = _data["isFullContent"] !== undefined ? _data["isFullContent"] : <any>null;
            this.fullContentInfo = _data["fullContentInfo"] !== undefined ? _data["fullContentInfo"] : <any>null;
        }
    }

    static fromJS(data: any): RigaServizio {
        data = typeof data === 'object' ? data : {};
        let result = new RigaServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idServizio"] = this.idServizio !== undefined ? this.idServizio : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        if (Array.isArray(this.descrizioniRighe)) {
            data["descrizioniRighe"] = [];
            for (let item of this.descrizioniRighe)
                data["descrizioniRighe"].push(item);
        }
        data["isHotel"] = this.isHotel !== undefined ? this.isHotel : <any>null;
        if (Array.isArray(this.abbinamentiDate)) {
            data["abbinamentiDate"] = [];
            for (let item of this.abbinamentiDate)
                data["abbinamentiDate"].push(item.toJSON());
        }
        data["isFullContent"] = this.isFullContent !== undefined ? this.isFullContent : <any>null;
        data["fullContentInfo"] = this.fullContentInfo !== undefined ? this.fullContentInfo : <any>null;
        return data;
    }
}

export interface IRigaServizio {
    idServizio?: number;
    tipo?: string | null;
    nome?: string | null;
    indirizzo?: string | null;
    telefono?: string | null;
    luogo?: string | null;
    descrizioniRighe?: string[] | null;
    isHotel?: boolean;
    abbinamentiDate?: AbbinamentoData[] | null;
    isFullContent?: boolean;
    fullContentInfo?: string | null;
}

export class AbbinamentoData implements IAbbinamentoData {
    dal?: string;
    al?: string;
    notti?: number;
    abbinamenti?: AbbinamentoInfo[] | null;
    isTutti?: boolean;
    overrideDalAl?: string | null;
    chiaveAbbinamenti?: string | null;

    constructor(data?: IAbbinamentoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            if (Array.isArray(_data["abbinamenti"])) {
                this.abbinamenti = [] as any;
                for (let item of _data["abbinamenti"])
                    this.abbinamenti!.push(AbbinamentoInfo.fromJS(item));
            }
            else {
                this.abbinamenti = <any>null;
            }
            this.isTutti = _data["isTutti"] !== undefined ? _data["isTutti"] : <any>null;
            this.overrideDalAl = _data["overrideDalAl"] !== undefined ? _data["overrideDalAl"] : <any>null;
            this.chiaveAbbinamenti = _data["chiaveAbbinamenti"] !== undefined ? _data["chiaveAbbinamenti"] : <any>null;
        }
    }

    static fromJS(data: any): AbbinamentoData {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        if (Array.isArray(this.abbinamenti)) {
            data["abbinamenti"] = [];
            for (let item of this.abbinamenti)
                data["abbinamenti"].push(item.toJSON());
        }
        data["isTutti"] = this.isTutti !== undefined ? this.isTutti : <any>null;
        data["overrideDalAl"] = this.overrideDalAl !== undefined ? this.overrideDalAl : <any>null;
        data["chiaveAbbinamenti"] = this.chiaveAbbinamenti !== undefined ? this.chiaveAbbinamenti : <any>null;
        return data;
    }
}

export interface IAbbinamentoData {
    dal?: string;
    al?: string;
    notti?: number;
    abbinamenti?: AbbinamentoInfo[] | null;
    isTutti?: boolean;
    overrideDalAl?: string | null;
    chiaveAbbinamenti?: string | null;
}

export class AbbinamentoInfo implements IAbbinamentoInfo {
    id?: number;
    abbinamento?: Abbinamento | null;
    clientiID?: AbbinamentoCliente[] | null;
    clienti?: ClienteInfo[] | null;
    righe?: OffertaDatoInfo[] | null;
    clientiIdHash?: string | null;
    isTutti?: boolean;
    isVolo?: boolean;

    constructor(data?: IAbbinamentoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.abbinamento = _data["abbinamento"] ? Abbinamento.fromJS(_data["abbinamento"]) : <any>null;
            if (Array.isArray(_data["clientiID"])) {
                this.clientiID = [] as any;
                for (let item of _data["clientiID"])
                    this.clientiID!.push(AbbinamentoCliente.fromJS(item));
            }
            else {
                this.clientiID = <any>null;
            }
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(ClienteInfo.fromJS(item));
            }
            else {
                this.clienti = <any>null;
            }
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(OffertaDatoInfo.fromJS(item));
            }
            else {
                this.righe = <any>null;
            }
            this.clientiIdHash = _data["clientiIdHash"] !== undefined ? _data["clientiIdHash"] : <any>null;
            this.isTutti = _data["isTutti"] !== undefined ? _data["isTutti"] : <any>null;
            this.isVolo = _data["isVolo"] !== undefined ? _data["isVolo"] : <any>null;
        }
    }

    static fromJS(data: any): AbbinamentoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["abbinamento"] = this.abbinamento ? this.abbinamento.toJSON() : <any>null;
        if (Array.isArray(this.clientiID)) {
            data["clientiID"] = [];
            for (let item of this.clientiID)
                data["clientiID"].push(item.toJSON());
        }
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item.toJSON());
        }
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item.toJSON());
        }
        data["clientiIdHash"] = this.clientiIdHash !== undefined ? this.clientiIdHash : <any>null;
        data["isTutti"] = this.isTutti !== undefined ? this.isTutti : <any>null;
        data["isVolo"] = this.isVolo !== undefined ? this.isVolo : <any>null;
        return data;
    }
}

export interface IAbbinamentoInfo {
    id?: number;
    abbinamento?: Abbinamento | null;
    clientiID?: AbbinamentoCliente[] | null;
    clienti?: ClienteInfo[] | null;
    righe?: OffertaDatoInfo[] | null;
    clientiIdHash?: string | null;
    isTutti?: boolean;
    isVolo?: boolean;
}

export class AbbinamentoCliente implements IAbbinamentoCliente {
    abbinamentoID?: number;
    clienteID?: number;

    constructor(data?: IAbbinamentoCliente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : <any>null;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : <any>null;
        }
    }

    static fromJS(data: any): AbbinamentoCliente {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoCliente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : <any>null;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : <any>null;
        return data;
    }
}

export interface IAbbinamentoCliente {
    abbinamentoID?: number;
    clienteID?: number;
}

export class ClienteInfo implements IClienteInfo {
    id?: number;
    cliente?: Cliente | null;
    dati?: ClienteDato | null;
    offerta?: OffertaInfo | null;
    abbinamenti?: AbbinamentoInfo[] | null;
    dataNascitaDefault?: string;
    nomeVisualizzato?: string | null;
    nomeAbbreviato?: string | null;
    datiCompleti?: boolean;
    datiCompletiVolo?: boolean;
    isChild?: boolean;
    dataNascitaNormalizzata?: string;
    prezzo?: number;
    codiceFiscaleOk?: boolean;

    constructor(data?: IClienteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.cliente = _data["cliente"] ? Cliente.fromJS(_data["cliente"]) : <any>null;
            this.dati = _data["dati"] ? ClienteDato.fromJS(_data["dati"]) : <any>null;
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : <any>null;
            if (Array.isArray(_data["abbinamenti"])) {
                this.abbinamenti = [] as any;
                for (let item of _data["abbinamenti"])
                    this.abbinamenti!.push(AbbinamentoInfo.fromJS(item));
            }
            else {
                this.abbinamenti = <any>null;
            }
            this.dataNascitaDefault = _data["dataNascitaDefault"] !== undefined ? _data["dataNascitaDefault"] : <any>null;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : <any>null;
            this.nomeAbbreviato = _data["nomeAbbreviato"] !== undefined ? _data["nomeAbbreviato"] : <any>null;
            this.datiCompleti = _data["datiCompleti"] !== undefined ? _data["datiCompleti"] : <any>null;
            this.datiCompletiVolo = _data["datiCompletiVolo"] !== undefined ? _data["datiCompletiVolo"] : <any>null;
            this.isChild = _data["isChild"] !== undefined ? _data["isChild"] : <any>null;
            this.dataNascitaNormalizzata = _data["dataNascitaNormalizzata"] !== undefined ? _data["dataNascitaNormalizzata"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.codiceFiscaleOk = _data["codiceFiscaleOk"] !== undefined ? _data["codiceFiscaleOk"] : <any>null;
        }
    }

    static fromJS(data: any): ClienteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["cliente"] = this.cliente ? this.cliente.toJSON() : <any>null;
        data["dati"] = this.dati ? this.dati.toJSON() : <any>null;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        if (Array.isArray(this.abbinamenti)) {
            data["abbinamenti"] = [];
            for (let item of this.abbinamenti)
                data["abbinamenti"].push(item.toJSON());
        }
        data["dataNascitaDefault"] = this.dataNascitaDefault !== undefined ? this.dataNascitaDefault : <any>null;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : <any>null;
        data["nomeAbbreviato"] = this.nomeAbbreviato !== undefined ? this.nomeAbbreviato : <any>null;
        data["datiCompleti"] = this.datiCompleti !== undefined ? this.datiCompleti : <any>null;
        data["datiCompletiVolo"] = this.datiCompletiVolo !== undefined ? this.datiCompletiVolo : <any>null;
        data["isChild"] = this.isChild !== undefined ? this.isChild : <any>null;
        data["dataNascitaNormalizzata"] = this.dataNascitaNormalizzata !== undefined ? this.dataNascitaNormalizzata : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["codiceFiscaleOk"] = this.codiceFiscaleOk !== undefined ? this.codiceFiscaleOk : <any>null;
        return data;
    }
}

export interface IClienteInfo {
    id?: number;
    cliente?: Cliente | null;
    dati?: ClienteDato | null;
    offerta?: OffertaInfo | null;
    abbinamenti?: AbbinamentoInfo[] | null;
    dataNascitaDefault?: string;
    nomeVisualizzato?: string | null;
    nomeAbbreviato?: string | null;
    datiCompleti?: boolean;
    datiCompletiVolo?: boolean;
    isChild?: boolean;
    dataNascitaNormalizzata?: string;
    prezzo?: number;
    codiceFiscaleOk?: boolean;
}

export class OffertaInfo implements IOffertaInfo {
    id?: number;
    offerta?: Offerta | null;
    offertaAgenzia?: OffertaAgenzia | null;
    stato?: OffertaAgenziaStato | null;
    tipoViaggio?: ETipoViaggio;
    modalitaQuote?: EModalitaQuote;
    operatore?: OperatoreInfo | null;
    contattoAgenzia?: ContattoInfo | null;
    noteOffertaAgenzia?: string[] | null;
    contattoNetwork?: ContattoInfo | null;
    accordoOperatore?: AccordoContattoInfo | null;
    terminePagamentoAgenzia?: TerminePagamentoInfo | null;
    pricing?: PricingInfo | null;
    pricingRules?: PricingRule[] | null;
    quotaVoliNettoTasse?: number;
    commissioneBiglietteriaMassima?: number;
    dirittiAgenziaMassimi?: number;
    percentualeDirittiAgenzia?: number | null;
    tags?: TagOffertaInfo[] | null;
    isNozze?: boolean;
    percentualeAcconto?: number | null;
    percentualeAccontoNozze?: number | null;
    percentualeAccontoAgenzia?: number | null;
    noAnticipoBiglietti?: boolean;
    noAnticipoQuote?: boolean;
    clienti?: ClienteInfo[] | null;
    leader?: ClienteInfo | null;
    utenteCreatore?: UtenteInfo | null;
    utenteAgenzia?: UtenteInfo | null;
    emailAddetto?: string | null;
    utentePreventivo?: UtenteInfo | null;
    utenteConferma?: UtenteInfo | null;
    utenteDocumenti?: UtenteInfo | null;
    utenteTariffa?: UtenteInfo | null;
    utenteBigliettiAerei?: UtenteInfo | null;
    contattoClienteDiretto?: ContattoInfo | null;
    contattoPromoter?: ContattoInfo | null;
    contattoCorriere?: ContattoInfo | null;
    statoUtente?: EStatoOffertaUtente;
    allServiziIds?: number[] | null;
    allContattiIds?: number[] | null;
    allLuoghiIds?: number[] | null;
    itinerarioAccessori?: ItinerarioOffertaInfo | null;
    itinerari?: ItinerarioOffertaInfo[] | null;
    itinerarioServizio?: ServizioItinerarioInfo | null;
    itinerariPackage?: ItinerarioOffertaInfo[] | null;
    isPackage?: boolean;
    itinerariVoli?: ItinerarioVoloInfo[] | null;
    documenti?: DocumentoInfo[] | null;
    nomeCorriere?: string | null;
    email?: EmailInfo[] | null;
    abbinamentoTutti?: AbbinamentoInfo | null;
    abbinamenti?: AbbinamentoInfo[] | null;
    dataNascitaDefaultAdulto?: string;
    dataNascitaDefaultBambino?: string;
    righeDict?: { [key: string]: OffertaDatoInfo; } | null;
    righe?: OffertaDatoInfo[] | null;
    note?: OffertaNotaInfo[] | null;
    haVoli?: boolean;
    voli?: VoloInfo[] | null;
    voliTickets?: VoloTicketsInfo[] | null;
    destinazione?: LuogoInfo | null;
    aeroportoPartenza?: Aeroporto | null;
    aeroportoArrivo?: Aeroporto | null;
    voucher?: VoucherInfo[] | null;
    dataMinimaTappa?: string | null;
    dataMassimaTappa?: string | null;
    luoghiOfferta?: LuogoInfo[] | null;
    invoices?: DocumentoContabileTestata[] | null;
    incassi?: OffertaIncasso[] | null;
    saldata?: boolean;
    compensato?: number;
    dataCompensazione?: string | null;
    acconto?: number;
    dataAcconto?: string | null;
    saldo?: number;
    dataSaldo?: string | null;
    totaleLordo?: number;
    totaleNetto?: number;
    totaleCostoNetto?: number;
    totaleCommissioni?: number;
    giorni?: number;
    notti?: number;
    warnings?: WarningOfferta[] | null;
    confermabile?: boolean;
    confermabileAgenzia?: boolean;
    confermata?: boolean;
    annullata?: boolean;
    annullataADV?: boolean;
    annullataTO?: boolean;
    sbloccata?: boolean;
    utenteSblocco?: UtenteInfo | null;
    warningsVoli?: WarningOfferta[] | null;
    voliPrenotabili?: boolean;
    voucherTuristico?: OffertaDatoInfo | null;
    descrizioni?: OffertaTesto[] | null;

    constructor(data?: IOffertaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.offerta = _data["offerta"] ? Offerta.fromJS(_data["offerta"]) : <any>null;
            this.offertaAgenzia = _data["offertaAgenzia"] ? OffertaAgenzia.fromJS(_data["offertaAgenzia"]) : <any>null;
            this.stato = _data["stato"] ? OffertaAgenziaStato.fromJS(_data["stato"]) : <any>null;
            this.tipoViaggio = _data["tipoViaggio"] !== undefined ? _data["tipoViaggio"] : <any>null;
            this.modalitaQuote = _data["modalitaQuote"] !== undefined ? _data["modalitaQuote"] : <any>null;
            this.operatore = _data["operatore"] ? OperatoreInfo.fromJS(_data["operatore"]) : <any>null;
            this.contattoAgenzia = _data["contattoAgenzia"] ? ContattoInfo.fromJS(_data["contattoAgenzia"]) : <any>null;
            if (Array.isArray(_data["noteOffertaAgenzia"])) {
                this.noteOffertaAgenzia = [] as any;
                for (let item of _data["noteOffertaAgenzia"])
                    this.noteOffertaAgenzia!.push(item);
            }
            else {
                this.noteOffertaAgenzia = <any>null;
            }
            this.contattoNetwork = _data["contattoNetwork"] ? ContattoInfo.fromJS(_data["contattoNetwork"]) : <any>null;
            this.accordoOperatore = _data["accordoOperatore"] ? AccordoContattoInfo.fromJS(_data["accordoOperatore"]) : <any>null;
            this.terminePagamentoAgenzia = _data["terminePagamentoAgenzia"] ? TerminePagamentoInfo.fromJS(_data["terminePagamentoAgenzia"]) : <any>null;
            this.pricing = _data["pricing"] ? PricingInfo.fromJS(_data["pricing"]) : <any>null;
            if (Array.isArray(_data["pricingRules"])) {
                this.pricingRules = [] as any;
                for (let item of _data["pricingRules"])
                    this.pricingRules!.push(PricingRule.fromJS(item));
            }
            else {
                this.pricingRules = <any>null;
            }
            this.quotaVoliNettoTasse = _data["quotaVoliNettoTasse"] !== undefined ? _data["quotaVoliNettoTasse"] : <any>null;
            this.commissioneBiglietteriaMassima = _data["commissioneBiglietteriaMassima"] !== undefined ? _data["commissioneBiglietteriaMassima"] : <any>null;
            this.dirittiAgenziaMassimi = _data["dirittiAgenziaMassimi"] !== undefined ? _data["dirittiAgenziaMassimi"] : <any>null;
            this.percentualeDirittiAgenzia = _data["percentualeDirittiAgenzia"] !== undefined ? _data["percentualeDirittiAgenzia"] : <any>null;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagOffertaInfo.fromJS(item));
            }
            else {
                this.tags = <any>null;
            }
            this.isNozze = _data["isNozze"] !== undefined ? _data["isNozze"] : <any>null;
            this.percentualeAcconto = _data["percentualeAcconto"] !== undefined ? _data["percentualeAcconto"] : <any>null;
            this.percentualeAccontoNozze = _data["percentualeAccontoNozze"] !== undefined ? _data["percentualeAccontoNozze"] : <any>null;
            this.percentualeAccontoAgenzia = _data["percentualeAccontoAgenzia"] !== undefined ? _data["percentualeAccontoAgenzia"] : <any>null;
            this.noAnticipoBiglietti = _data["noAnticipoBiglietti"] !== undefined ? _data["noAnticipoBiglietti"] : <any>null;
            this.noAnticipoQuote = _data["noAnticipoQuote"] !== undefined ? _data["noAnticipoQuote"] : <any>null;
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(ClienteInfo.fromJS(item));
            }
            else {
                this.clienti = <any>null;
            }
            this.leader = _data["leader"] ? ClienteInfo.fromJS(_data["leader"]) : <any>null;
            this.utenteCreatore = _data["utenteCreatore"] ? UtenteInfo.fromJS(_data["utenteCreatore"]) : <any>null;
            this.utenteAgenzia = _data["utenteAgenzia"] ? UtenteInfo.fromJS(_data["utenteAgenzia"]) : <any>null;
            this.emailAddetto = _data["emailAddetto"] !== undefined ? _data["emailAddetto"] : <any>null;
            this.utentePreventivo = _data["utentePreventivo"] ? UtenteInfo.fromJS(_data["utentePreventivo"]) : <any>null;
            this.utenteConferma = _data["utenteConferma"] ? UtenteInfo.fromJS(_data["utenteConferma"]) : <any>null;
            this.utenteDocumenti = _data["utenteDocumenti"] ? UtenteInfo.fromJS(_data["utenteDocumenti"]) : <any>null;
            this.utenteTariffa = _data["utenteTariffa"] ? UtenteInfo.fromJS(_data["utenteTariffa"]) : <any>null;
            this.utenteBigliettiAerei = _data["utenteBigliettiAerei"] ? UtenteInfo.fromJS(_data["utenteBigliettiAerei"]) : <any>null;
            this.contattoClienteDiretto = _data["contattoClienteDiretto"] ? ContattoInfo.fromJS(_data["contattoClienteDiretto"]) : <any>null;
            this.contattoPromoter = _data["contattoPromoter"] ? ContattoInfo.fromJS(_data["contattoPromoter"]) : <any>null;
            this.contattoCorriere = _data["contattoCorriere"] ? ContattoInfo.fromJS(_data["contattoCorriere"]) : <any>null;
            this.statoUtente = _data["statoUtente"] !== undefined ? _data["statoUtente"] : <any>null;
            if (Array.isArray(_data["allServiziIds"])) {
                this.allServiziIds = [] as any;
                for (let item of _data["allServiziIds"])
                    this.allServiziIds!.push(item);
            }
            else {
                this.allServiziIds = <any>null;
            }
            if (Array.isArray(_data["allContattiIds"])) {
                this.allContattiIds = [] as any;
                for (let item of _data["allContattiIds"])
                    this.allContattiIds!.push(item);
            }
            else {
                this.allContattiIds = <any>null;
            }
            if (Array.isArray(_data["allLuoghiIds"])) {
                this.allLuoghiIds = [] as any;
                for (let item of _data["allLuoghiIds"])
                    this.allLuoghiIds!.push(item);
            }
            else {
                this.allLuoghiIds = <any>null;
            }
            this.itinerarioAccessori = _data["itinerarioAccessori"] ? ItinerarioOffertaInfo.fromJS(_data["itinerarioAccessori"]) : <any>null;
            if (Array.isArray(_data["itinerari"])) {
                this.itinerari = [] as any;
                for (let item of _data["itinerari"])
                    this.itinerari!.push(ItinerarioOffertaInfo.fromJS(item));
            }
            else {
                this.itinerari = <any>null;
            }
            this.itinerarioServizio = _data["itinerarioServizio"] ? ServizioItinerarioInfo.fromJS(_data["itinerarioServizio"]) : <any>null;
            if (Array.isArray(_data["itinerariPackage"])) {
                this.itinerariPackage = [] as any;
                for (let item of _data["itinerariPackage"])
                    this.itinerariPackage!.push(ItinerarioOffertaInfo.fromJS(item));
            }
            else {
                this.itinerariPackage = <any>null;
            }
            this.isPackage = _data["isPackage"] !== undefined ? _data["isPackage"] : <any>null;
            if (Array.isArray(_data["itinerariVoli"])) {
                this.itinerariVoli = [] as any;
                for (let item of _data["itinerariVoli"])
                    this.itinerariVoli!.push(ItinerarioVoloInfo.fromJS(item));
            }
            else {
                this.itinerariVoli = <any>null;
            }
            if (Array.isArray(_data["documenti"])) {
                this.documenti = [] as any;
                for (let item of _data["documenti"])
                    this.documenti!.push(DocumentoInfo.fromJS(item));
            }
            else {
                this.documenti = <any>null;
            }
            this.nomeCorriere = _data["nomeCorriere"] !== undefined ? _data["nomeCorriere"] : <any>null;
            if (Array.isArray(_data["email"])) {
                this.email = [] as any;
                for (let item of _data["email"])
                    this.email!.push(EmailInfo.fromJS(item));
            }
            else {
                this.email = <any>null;
            }
            this.abbinamentoTutti = _data["abbinamentoTutti"] ? AbbinamentoInfo.fromJS(_data["abbinamentoTutti"]) : <any>null;
            if (Array.isArray(_data["abbinamenti"])) {
                this.abbinamenti = [] as any;
                for (let item of _data["abbinamenti"])
                    this.abbinamenti!.push(AbbinamentoInfo.fromJS(item));
            }
            else {
                this.abbinamenti = <any>null;
            }
            this.dataNascitaDefaultAdulto = _data["dataNascitaDefaultAdulto"] !== undefined ? _data["dataNascitaDefaultAdulto"] : <any>null;
            this.dataNascitaDefaultBambino = _data["dataNascitaDefaultBambino"] !== undefined ? _data["dataNascitaDefaultBambino"] : <any>null;
            if (_data["righeDict"]) {
                this.righeDict = {} as any;
                for (let key in _data["righeDict"]) {
                    if (_data["righeDict"].hasOwnProperty(key))
                        (<any>this.righeDict)![key] = _data["righeDict"][key] ? OffertaDatoInfo.fromJS(_data["righeDict"][key]) : new OffertaDatoInfo();
                }
            }
            else {
                this.righeDict = <any>null;
            }
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(OffertaDatoInfo.fromJS(item));
            }
            else {
                this.righe = <any>null;
            }
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(OffertaNotaInfo.fromJS(item));
            }
            else {
                this.note = <any>null;
            }
            this.haVoli = _data["haVoli"] !== undefined ? _data["haVoli"] : <any>null;
            if (Array.isArray(_data["voli"])) {
                this.voli = [] as any;
                for (let item of _data["voli"])
                    this.voli!.push(VoloInfo.fromJS(item));
            }
            else {
                this.voli = <any>null;
            }
            if (Array.isArray(_data["voliTickets"])) {
                this.voliTickets = [] as any;
                for (let item of _data["voliTickets"])
                    this.voliTickets!.push(VoloTicketsInfo.fromJS(item));
            }
            else {
                this.voliTickets = <any>null;
            }
            this.destinazione = _data["destinazione"] ? LuogoInfo.fromJS(_data["destinazione"]) : <any>null;
            this.aeroportoPartenza = _data["aeroportoPartenza"] ? Aeroporto.fromJS(_data["aeroportoPartenza"]) : <any>null;
            this.aeroportoArrivo = _data["aeroportoArrivo"] ? Aeroporto.fromJS(_data["aeroportoArrivo"]) : <any>null;
            if (Array.isArray(_data["voucher"])) {
                this.voucher = [] as any;
                for (let item of _data["voucher"])
                    this.voucher!.push(VoucherInfo.fromJS(item));
            }
            else {
                this.voucher = <any>null;
            }
            this.dataMinimaTappa = _data["dataMinimaTappa"] !== undefined ? _data["dataMinimaTappa"] : <any>null;
            this.dataMassimaTappa = _data["dataMassimaTappa"] !== undefined ? _data["dataMassimaTappa"] : <any>null;
            if (Array.isArray(_data["luoghiOfferta"])) {
                this.luoghiOfferta = [] as any;
                for (let item of _data["luoghiOfferta"])
                    this.luoghiOfferta!.push(LuogoInfo.fromJS(item));
            }
            else {
                this.luoghiOfferta = <any>null;
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(DocumentoContabileTestata.fromJS(item));
            }
            else {
                this.invoices = <any>null;
            }
            if (Array.isArray(_data["incassi"])) {
                this.incassi = [] as any;
                for (let item of _data["incassi"])
                    this.incassi!.push(OffertaIncasso.fromJS(item));
            }
            else {
                this.incassi = <any>null;
            }
            this.saldata = _data["saldata"] !== undefined ? _data["saldata"] : <any>null;
            this.compensato = _data["compensato"] !== undefined ? _data["compensato"] : <any>null;
            this.dataCompensazione = _data["dataCompensazione"] !== undefined ? _data["dataCompensazione"] : <any>null;
            this.acconto = _data["acconto"] !== undefined ? _data["acconto"] : <any>null;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : <any>null;
            this.saldo = _data["saldo"] !== undefined ? _data["saldo"] : <any>null;
            this.dataSaldo = _data["dataSaldo"] !== undefined ? _data["dataSaldo"] : <any>null;
            this.totaleLordo = _data["totaleLordo"] !== undefined ? _data["totaleLordo"] : <any>null;
            this.totaleNetto = _data["totaleNetto"] !== undefined ? _data["totaleNetto"] : <any>null;
            this.totaleCostoNetto = _data["totaleCostoNetto"] !== undefined ? _data["totaleCostoNetto"] : <any>null;
            this.totaleCommissioni = _data["totaleCommissioni"] !== undefined ? _data["totaleCommissioni"] : <any>null;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(WarningOfferta.fromJS(item));
            }
            else {
                this.warnings = <any>null;
            }
            this.confermabile = _data["confermabile"] !== undefined ? _data["confermabile"] : <any>null;
            this.confermabileAgenzia = _data["confermabileAgenzia"] !== undefined ? _data["confermabileAgenzia"] : <any>null;
            this.confermata = _data["confermata"] !== undefined ? _data["confermata"] : <any>null;
            this.annullata = _data["annullata"] !== undefined ? _data["annullata"] : <any>null;
            this.annullataADV = _data["annullataADV"] !== undefined ? _data["annullataADV"] : <any>null;
            this.annullataTO = _data["annullataTO"] !== undefined ? _data["annullataTO"] : <any>null;
            this.sbloccata = _data["sbloccata"] !== undefined ? _data["sbloccata"] : <any>null;
            this.utenteSblocco = _data["utenteSblocco"] ? UtenteInfo.fromJS(_data["utenteSblocco"]) : <any>null;
            if (Array.isArray(_data["warningsVoli"])) {
                this.warningsVoli = [] as any;
                for (let item of _data["warningsVoli"])
                    this.warningsVoli!.push(WarningOfferta.fromJS(item));
            }
            else {
                this.warningsVoli = <any>null;
            }
            this.voliPrenotabili = _data["voliPrenotabili"] !== undefined ? _data["voliPrenotabili"] : <any>null;
            this.voucherTuristico = _data["voucherTuristico"] ? OffertaDatoInfo.fromJS(_data["voucherTuristico"]) : <any>null;
            if (Array.isArray(_data["descrizioni"])) {
                this.descrizioni = [] as any;
                for (let item of _data["descrizioni"])
                    this.descrizioni!.push(OffertaTesto.fromJS(item));
            }
            else {
                this.descrizioni = <any>null;
            }
        }
    }

    static fromJS(data: any): OffertaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        data["offertaAgenzia"] = this.offertaAgenzia ? this.offertaAgenzia.toJSON() : <any>null;
        data["stato"] = this.stato ? this.stato.toJSON() : <any>null;
        data["tipoViaggio"] = this.tipoViaggio !== undefined ? this.tipoViaggio : <any>null;
        data["modalitaQuote"] = this.modalitaQuote !== undefined ? this.modalitaQuote : <any>null;
        data["operatore"] = this.operatore ? this.operatore.toJSON() : <any>null;
        data["contattoAgenzia"] = this.contattoAgenzia ? this.contattoAgenzia.toJSON() : <any>null;
        if (Array.isArray(this.noteOffertaAgenzia)) {
            data["noteOffertaAgenzia"] = [];
            for (let item of this.noteOffertaAgenzia)
                data["noteOffertaAgenzia"].push(item);
        }
        data["contattoNetwork"] = this.contattoNetwork ? this.contattoNetwork.toJSON() : <any>null;
        data["accordoOperatore"] = this.accordoOperatore ? this.accordoOperatore.toJSON() : <any>null;
        data["terminePagamentoAgenzia"] = this.terminePagamentoAgenzia ? this.terminePagamentoAgenzia.toJSON() : <any>null;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : <any>null;
        if (Array.isArray(this.pricingRules)) {
            data["pricingRules"] = [];
            for (let item of this.pricingRules)
                data["pricingRules"].push(item.toJSON());
        }
        data["quotaVoliNettoTasse"] = this.quotaVoliNettoTasse !== undefined ? this.quotaVoliNettoTasse : <any>null;
        data["commissioneBiglietteriaMassima"] = this.commissioneBiglietteriaMassima !== undefined ? this.commissioneBiglietteriaMassima : <any>null;
        data["dirittiAgenziaMassimi"] = this.dirittiAgenziaMassimi !== undefined ? this.dirittiAgenziaMassimi : <any>null;
        data["percentualeDirittiAgenzia"] = this.percentualeDirittiAgenzia !== undefined ? this.percentualeDirittiAgenzia : <any>null;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["isNozze"] = this.isNozze !== undefined ? this.isNozze : <any>null;
        data["percentualeAcconto"] = this.percentualeAcconto !== undefined ? this.percentualeAcconto : <any>null;
        data["percentualeAccontoNozze"] = this.percentualeAccontoNozze !== undefined ? this.percentualeAccontoNozze : <any>null;
        data["percentualeAccontoAgenzia"] = this.percentualeAccontoAgenzia !== undefined ? this.percentualeAccontoAgenzia : <any>null;
        data["noAnticipoBiglietti"] = this.noAnticipoBiglietti !== undefined ? this.noAnticipoBiglietti : <any>null;
        data["noAnticipoQuote"] = this.noAnticipoQuote !== undefined ? this.noAnticipoQuote : <any>null;
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item.toJSON());
        }
        data["leader"] = this.leader ? this.leader.toJSON() : <any>null;
        data["utenteCreatore"] = this.utenteCreatore ? this.utenteCreatore.toJSON() : <any>null;
        data["utenteAgenzia"] = this.utenteAgenzia ? this.utenteAgenzia.toJSON() : <any>null;
        data["emailAddetto"] = this.emailAddetto !== undefined ? this.emailAddetto : <any>null;
        data["utentePreventivo"] = this.utentePreventivo ? this.utentePreventivo.toJSON() : <any>null;
        data["utenteConferma"] = this.utenteConferma ? this.utenteConferma.toJSON() : <any>null;
        data["utenteDocumenti"] = this.utenteDocumenti ? this.utenteDocumenti.toJSON() : <any>null;
        data["utenteTariffa"] = this.utenteTariffa ? this.utenteTariffa.toJSON() : <any>null;
        data["utenteBigliettiAerei"] = this.utenteBigliettiAerei ? this.utenteBigliettiAerei.toJSON() : <any>null;
        data["contattoClienteDiretto"] = this.contattoClienteDiretto ? this.contattoClienteDiretto.toJSON() : <any>null;
        data["contattoPromoter"] = this.contattoPromoter ? this.contattoPromoter.toJSON() : <any>null;
        data["contattoCorriere"] = this.contattoCorriere ? this.contattoCorriere.toJSON() : <any>null;
        data["statoUtente"] = this.statoUtente !== undefined ? this.statoUtente : <any>null;
        if (Array.isArray(this.allServiziIds)) {
            data["allServiziIds"] = [];
            for (let item of this.allServiziIds)
                data["allServiziIds"].push(item);
        }
        if (Array.isArray(this.allContattiIds)) {
            data["allContattiIds"] = [];
            for (let item of this.allContattiIds)
                data["allContattiIds"].push(item);
        }
        if (Array.isArray(this.allLuoghiIds)) {
            data["allLuoghiIds"] = [];
            for (let item of this.allLuoghiIds)
                data["allLuoghiIds"].push(item);
        }
        data["itinerarioAccessori"] = this.itinerarioAccessori ? this.itinerarioAccessori.toJSON() : <any>null;
        if (Array.isArray(this.itinerari)) {
            data["itinerari"] = [];
            for (let item of this.itinerari)
                data["itinerari"].push(item.toJSON());
        }
        data["itinerarioServizio"] = this.itinerarioServizio ? this.itinerarioServizio.toJSON() : <any>null;
        if (Array.isArray(this.itinerariPackage)) {
            data["itinerariPackage"] = [];
            for (let item of this.itinerariPackage)
                data["itinerariPackage"].push(item.toJSON());
        }
        data["isPackage"] = this.isPackage !== undefined ? this.isPackage : <any>null;
        if (Array.isArray(this.itinerariVoli)) {
            data["itinerariVoli"] = [];
            for (let item of this.itinerariVoli)
                data["itinerariVoli"].push(item.toJSON());
        }
        if (Array.isArray(this.documenti)) {
            data["documenti"] = [];
            for (let item of this.documenti)
                data["documenti"].push(item.toJSON());
        }
        data["nomeCorriere"] = this.nomeCorriere !== undefined ? this.nomeCorriere : <any>null;
        if (Array.isArray(this.email)) {
            data["email"] = [];
            for (let item of this.email)
                data["email"].push(item.toJSON());
        }
        data["abbinamentoTutti"] = this.abbinamentoTutti ? this.abbinamentoTutti.toJSON() : <any>null;
        if (Array.isArray(this.abbinamenti)) {
            data["abbinamenti"] = [];
            for (let item of this.abbinamenti)
                data["abbinamenti"].push(item.toJSON());
        }
        data["dataNascitaDefaultAdulto"] = this.dataNascitaDefaultAdulto !== undefined ? this.dataNascitaDefaultAdulto : <any>null;
        data["dataNascitaDefaultBambino"] = this.dataNascitaDefaultBambino !== undefined ? this.dataNascitaDefaultBambino : <any>null;
        if (this.righeDict) {
            data["righeDict"] = {};
            for (let key in this.righeDict) {
                if (this.righeDict.hasOwnProperty(key))
                    (<any>data["righeDict"])[key] = this.righeDict[key] ? this.righeDict[key].toJSON() : <any>null;
            }
        }
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item.toJSON());
        }
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item.toJSON());
        }
        data["haVoli"] = this.haVoli !== undefined ? this.haVoli : <any>null;
        if (Array.isArray(this.voli)) {
            data["voli"] = [];
            for (let item of this.voli)
                data["voli"].push(item.toJSON());
        }
        if (Array.isArray(this.voliTickets)) {
            data["voliTickets"] = [];
            for (let item of this.voliTickets)
                data["voliTickets"].push(item.toJSON());
        }
        data["destinazione"] = this.destinazione ? this.destinazione.toJSON() : <any>null;
        data["aeroportoPartenza"] = this.aeroportoPartenza ? this.aeroportoPartenza.toJSON() : <any>null;
        data["aeroportoArrivo"] = this.aeroportoArrivo ? this.aeroportoArrivo.toJSON() : <any>null;
        if (Array.isArray(this.voucher)) {
            data["voucher"] = [];
            for (let item of this.voucher)
                data["voucher"].push(item.toJSON());
        }
        data["dataMinimaTappa"] = this.dataMinimaTappa !== undefined ? this.dataMinimaTappa : <any>null;
        data["dataMassimaTappa"] = this.dataMassimaTappa !== undefined ? this.dataMassimaTappa : <any>null;
        if (Array.isArray(this.luoghiOfferta)) {
            data["luoghiOfferta"] = [];
            for (let item of this.luoghiOfferta)
                data["luoghiOfferta"].push(item.toJSON());
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        if (Array.isArray(this.incassi)) {
            data["incassi"] = [];
            for (let item of this.incassi)
                data["incassi"].push(item.toJSON());
        }
        data["saldata"] = this.saldata !== undefined ? this.saldata : <any>null;
        data["compensato"] = this.compensato !== undefined ? this.compensato : <any>null;
        data["dataCompensazione"] = this.dataCompensazione !== undefined ? this.dataCompensazione : <any>null;
        data["acconto"] = this.acconto !== undefined ? this.acconto : <any>null;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : <any>null;
        data["saldo"] = this.saldo !== undefined ? this.saldo : <any>null;
        data["dataSaldo"] = this.dataSaldo !== undefined ? this.dataSaldo : <any>null;
        data["totaleLordo"] = this.totaleLordo !== undefined ? this.totaleLordo : <any>null;
        data["totaleNetto"] = this.totaleNetto !== undefined ? this.totaleNetto : <any>null;
        data["totaleCostoNetto"] = this.totaleCostoNetto !== undefined ? this.totaleCostoNetto : <any>null;
        data["totaleCommissioni"] = this.totaleCommissioni !== undefined ? this.totaleCommissioni : <any>null;
        data["giorni"] = this.giorni !== undefined ? this.giorni : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        data["confermabile"] = this.confermabile !== undefined ? this.confermabile : <any>null;
        data["confermabileAgenzia"] = this.confermabileAgenzia !== undefined ? this.confermabileAgenzia : <any>null;
        data["confermata"] = this.confermata !== undefined ? this.confermata : <any>null;
        data["annullata"] = this.annullata !== undefined ? this.annullata : <any>null;
        data["annullataADV"] = this.annullataADV !== undefined ? this.annullataADV : <any>null;
        data["annullataTO"] = this.annullataTO !== undefined ? this.annullataTO : <any>null;
        data["sbloccata"] = this.sbloccata !== undefined ? this.sbloccata : <any>null;
        data["utenteSblocco"] = this.utenteSblocco ? this.utenteSblocco.toJSON() : <any>null;
        if (Array.isArray(this.warningsVoli)) {
            data["warningsVoli"] = [];
            for (let item of this.warningsVoli)
                data["warningsVoli"].push(item.toJSON());
        }
        data["voliPrenotabili"] = this.voliPrenotabili !== undefined ? this.voliPrenotabili : <any>null;
        data["voucherTuristico"] = this.voucherTuristico ? this.voucherTuristico.toJSON() : <any>null;
        if (Array.isArray(this.descrizioni)) {
            data["descrizioni"] = [];
            for (let item of this.descrizioni)
                data["descrizioni"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOffertaInfo {
    id?: number;
    offerta?: Offerta | null;
    offertaAgenzia?: OffertaAgenzia | null;
    stato?: OffertaAgenziaStato | null;
    tipoViaggio?: ETipoViaggio;
    modalitaQuote?: EModalitaQuote;
    operatore?: OperatoreInfo | null;
    contattoAgenzia?: ContattoInfo | null;
    noteOffertaAgenzia?: string[] | null;
    contattoNetwork?: ContattoInfo | null;
    accordoOperatore?: AccordoContattoInfo | null;
    terminePagamentoAgenzia?: TerminePagamentoInfo | null;
    pricing?: PricingInfo | null;
    pricingRules?: PricingRule[] | null;
    quotaVoliNettoTasse?: number;
    commissioneBiglietteriaMassima?: number;
    dirittiAgenziaMassimi?: number;
    percentualeDirittiAgenzia?: number | null;
    tags?: TagOffertaInfo[] | null;
    isNozze?: boolean;
    percentualeAcconto?: number | null;
    percentualeAccontoNozze?: number | null;
    percentualeAccontoAgenzia?: number | null;
    noAnticipoBiglietti?: boolean;
    noAnticipoQuote?: boolean;
    clienti?: ClienteInfo[] | null;
    leader?: ClienteInfo | null;
    utenteCreatore?: UtenteInfo | null;
    utenteAgenzia?: UtenteInfo | null;
    emailAddetto?: string | null;
    utentePreventivo?: UtenteInfo | null;
    utenteConferma?: UtenteInfo | null;
    utenteDocumenti?: UtenteInfo | null;
    utenteTariffa?: UtenteInfo | null;
    utenteBigliettiAerei?: UtenteInfo | null;
    contattoClienteDiretto?: ContattoInfo | null;
    contattoPromoter?: ContattoInfo | null;
    contattoCorriere?: ContattoInfo | null;
    statoUtente?: EStatoOffertaUtente;
    allServiziIds?: number[] | null;
    allContattiIds?: number[] | null;
    allLuoghiIds?: number[] | null;
    itinerarioAccessori?: ItinerarioOffertaInfo | null;
    itinerari?: ItinerarioOffertaInfo[] | null;
    itinerarioServizio?: ServizioItinerarioInfo | null;
    itinerariPackage?: ItinerarioOffertaInfo[] | null;
    isPackage?: boolean;
    itinerariVoli?: ItinerarioVoloInfo[] | null;
    documenti?: DocumentoInfo[] | null;
    nomeCorriere?: string | null;
    email?: EmailInfo[] | null;
    abbinamentoTutti?: AbbinamentoInfo | null;
    abbinamenti?: AbbinamentoInfo[] | null;
    dataNascitaDefaultAdulto?: string;
    dataNascitaDefaultBambino?: string;
    righeDict?: { [key: string]: OffertaDatoInfo; } | null;
    righe?: OffertaDatoInfo[] | null;
    note?: OffertaNotaInfo[] | null;
    haVoli?: boolean;
    voli?: VoloInfo[] | null;
    voliTickets?: VoloTicketsInfo[] | null;
    destinazione?: LuogoInfo | null;
    aeroportoPartenza?: Aeroporto | null;
    aeroportoArrivo?: Aeroporto | null;
    voucher?: VoucherInfo[] | null;
    dataMinimaTappa?: string | null;
    dataMassimaTappa?: string | null;
    luoghiOfferta?: LuogoInfo[] | null;
    invoices?: DocumentoContabileTestata[] | null;
    incassi?: OffertaIncasso[] | null;
    saldata?: boolean;
    compensato?: number;
    dataCompensazione?: string | null;
    acconto?: number;
    dataAcconto?: string | null;
    saldo?: number;
    dataSaldo?: string | null;
    totaleLordo?: number;
    totaleNetto?: number;
    totaleCostoNetto?: number;
    totaleCommissioni?: number;
    giorni?: number;
    notti?: number;
    warnings?: WarningOfferta[] | null;
    confermabile?: boolean;
    confermabileAgenzia?: boolean;
    confermata?: boolean;
    annullata?: boolean;
    annullataADV?: boolean;
    annullataTO?: boolean;
    sbloccata?: boolean;
    utenteSblocco?: UtenteInfo | null;
    warningsVoli?: WarningOfferta[] | null;
    voliPrenotabili?: boolean;
    voucherTuristico?: OffertaDatoInfo | null;
    descrizioni?: OffertaTesto[] | null;
}

export class OperatoreInfo implements IOperatoreInfo {
    _EOperatore?: EOperatore | null;
    id?: number;
    operatore?: OperatoreView;
    eOperatore?: EOperatore;
    searchTerms?: string;
    amadeusParams?: CrypticMarket | null;
    websites?: WebsiteInfo[];
    contatto?: ContattoInfo;
    valuta?: ValutaInfo;

    constructor(data?: IOperatoreInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._EOperatore = _data["_EOperatore"] !== undefined ? _data["_EOperatore"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.operatore = _data["operatore"] ? OperatoreView.fromJS(_data["operatore"]) : <any>null;
            this.eOperatore = _data["eOperatore"] !== undefined ? _data["eOperatore"] : <any>null;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : <any>null;
            this.amadeusParams = _data["amadeusParams"] ? CrypticMarket.fromJS(_data["amadeusParams"]) : <any>null;
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(WebsiteInfo.fromJS(item));
            }
            else {
                this.websites = <any>null;
            }
            this.contatto = _data["contatto"] ? ContattoInfo.fromJS(_data["contatto"]) : <any>null;
            this.valuta = _data["valuta"] ? ValutaInfo.fromJS(_data["valuta"]) : <any>null;
        }
    }

    static fromJS(data: any): OperatoreInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OperatoreInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_EOperatore"] = this._EOperatore !== undefined ? this._EOperatore : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["operatore"] = this.operatore ? this.operatore.toJSON() : <any>null;
        data["eOperatore"] = this.eOperatore !== undefined ? this.eOperatore : <any>null;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : <any>null;
        data["amadeusParams"] = this.amadeusParams ? this.amadeusParams.toJSON() : <any>null;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item.toJSON());
        }
        data["contatto"] = this.contatto ? this.contatto.toJSON() : <any>null;
        data["valuta"] = this.valuta ? this.valuta.toJSON() : <any>null;
        return data;
    }
}

export interface IOperatoreInfo {
    _EOperatore?: EOperatore | null;
    id?: number;
    operatore?: OperatoreView;
    eOperatore?: EOperatore;
    searchTerms?: string;
    amadeusParams?: CrypticMarket | null;
    websites?: WebsiteInfo[];
    contatto?: ContattoInfo;
    valuta?: ValutaInfo;
}

export abstract class OperatoreView implements IOperatoreView {
    operatoreID?: number;
    contattoID?: number;
    nome?: string;
    nomeVisualizzato?: string | null;
    valutaID?: number;
    visibile?: boolean;
    includeTaxesInFlightCommissions?: boolean;
    advHomeConf?: ActionBoxConfig[] | null;

    constructor(data?: IOperatoreView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : <any>null;
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : <any>null;
            this.visibile = _data["visibile"] !== undefined ? _data["visibile"] : <any>null;
            this.includeTaxesInFlightCommissions = _data["includeTaxesInFlightCommissions"] !== undefined ? _data["includeTaxesInFlightCommissions"] : <any>null;
            if (Array.isArray(_data["advHomeConf"])) {
                this.advHomeConf = [] as any;
                for (let item of _data["advHomeConf"])
                    this.advHomeConf!.push(ActionBoxConfig.fromJS(item));
            }
            else {
                this.advHomeConf = <any>null;
            }
        }
    }

    static fromJS(data: any): OperatoreView {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OperatoreView' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : <any>null;
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : <any>null;
        data["visibile"] = this.visibile !== undefined ? this.visibile : <any>null;
        data["includeTaxesInFlightCommissions"] = this.includeTaxesInFlightCommissions !== undefined ? this.includeTaxesInFlightCommissions : <any>null;
        if (Array.isArray(this.advHomeConf)) {
            data["advHomeConf"] = [];
            for (let item of this.advHomeConf)
                data["advHomeConf"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOperatoreView {
    operatoreID?: number;
    contattoID?: number;
    nome?: string;
    nomeVisualizzato?: string | null;
    valutaID?: number;
    visibile?: boolean;
    includeTaxesInFlightCommissions?: boolean;
    advHomeConf?: ActionBoxConfig[] | null;
}

export class CrypticMarket implements ICrypticMarket {
    name?: string;
    market?: string;
    jupiterEnv?: string;
    offices?: CrypticKeyValues[];
    selectedOffice?: string;
    companyCodes?: CrypticKeyValues[];
    selectedCompanyCode?: string;
    quotePrivateCodes?: CrypticKeyValues[];
    selectedQuotePrivateCode?: string;
    queueCodes?: CrypticKeyValues[];
    selectedQueueCode?: string;
    statuses?: CrypticKeyValues[];
    selectedStatus?: string;

    constructor(data?: ICrypticMarket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.market = _data["market"] !== undefined ? _data["market"] : <any>null;
            this.jupiterEnv = _data["jupiterEnv"] !== undefined ? _data["jupiterEnv"] : <any>null;
            if (Array.isArray(_data["offices"])) {
                this.offices = [] as any;
                for (let item of _data["offices"])
                    this.offices!.push(CrypticKeyValues.fromJS(item));
            }
            else {
                this.offices = <any>null;
            }
            this.selectedOffice = _data["selectedOffice"] !== undefined ? _data["selectedOffice"] : <any>null;
            if (Array.isArray(_data["companyCodes"])) {
                this.companyCodes = [] as any;
                for (let item of _data["companyCodes"])
                    this.companyCodes!.push(CrypticKeyValues.fromJS(item));
            }
            else {
                this.companyCodes = <any>null;
            }
            this.selectedCompanyCode = _data["selectedCompanyCode"] !== undefined ? _data["selectedCompanyCode"] : <any>null;
            if (Array.isArray(_data["quotePrivateCodes"])) {
                this.quotePrivateCodes = [] as any;
                for (let item of _data["quotePrivateCodes"])
                    this.quotePrivateCodes!.push(CrypticKeyValues.fromJS(item));
            }
            else {
                this.quotePrivateCodes = <any>null;
            }
            this.selectedQuotePrivateCode = _data["selectedQuotePrivateCode"] !== undefined ? _data["selectedQuotePrivateCode"] : <any>null;
            if (Array.isArray(_data["queueCodes"])) {
                this.queueCodes = [] as any;
                for (let item of _data["queueCodes"])
                    this.queueCodes!.push(CrypticKeyValues.fromJS(item));
            }
            else {
                this.queueCodes = <any>null;
            }
            this.selectedQueueCode = _data["selectedQueueCode"] !== undefined ? _data["selectedQueueCode"] : <any>null;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(CrypticKeyValues.fromJS(item));
            }
            else {
                this.statuses = <any>null;
            }
            this.selectedStatus = _data["selectedStatus"] !== undefined ? _data["selectedStatus"] : <any>null;
        }
    }

    static fromJS(data: any): CrypticMarket {
        data = typeof data === 'object' ? data : {};
        let result = new CrypticMarket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["market"] = this.market !== undefined ? this.market : <any>null;
        data["jupiterEnv"] = this.jupiterEnv !== undefined ? this.jupiterEnv : <any>null;
        if (Array.isArray(this.offices)) {
            data["offices"] = [];
            for (let item of this.offices)
                data["offices"].push(item.toJSON());
        }
        data["selectedOffice"] = this.selectedOffice !== undefined ? this.selectedOffice : <any>null;
        if (Array.isArray(this.companyCodes)) {
            data["companyCodes"] = [];
            for (let item of this.companyCodes)
                data["companyCodes"].push(item.toJSON());
        }
        data["selectedCompanyCode"] = this.selectedCompanyCode !== undefined ? this.selectedCompanyCode : <any>null;
        if (Array.isArray(this.quotePrivateCodes)) {
            data["quotePrivateCodes"] = [];
            for (let item of this.quotePrivateCodes)
                data["quotePrivateCodes"].push(item.toJSON());
        }
        data["selectedQuotePrivateCode"] = this.selectedQuotePrivateCode !== undefined ? this.selectedQuotePrivateCode : <any>null;
        if (Array.isArray(this.queueCodes)) {
            data["queueCodes"] = [];
            for (let item of this.queueCodes)
                data["queueCodes"].push(item.toJSON());
        }
        data["selectedQueueCode"] = this.selectedQueueCode !== undefined ? this.selectedQueueCode : <any>null;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        data["selectedStatus"] = this.selectedStatus !== undefined ? this.selectedStatus : <any>null;
        return data;
    }
}

export interface ICrypticMarket {
    name?: string;
    market?: string;
    jupiterEnv?: string;
    offices?: CrypticKeyValues[];
    selectedOffice?: string;
    companyCodes?: CrypticKeyValues[];
    selectedCompanyCode?: string;
    quotePrivateCodes?: CrypticKeyValues[];
    selectedQuotePrivateCode?: string;
    queueCodes?: CrypticKeyValues[];
    selectedQueueCode?: string;
    statuses?: CrypticKeyValues[];
    selectedStatus?: string;
}

export class CrypticKeyValues implements ICrypticKeyValues {
    name?: string;
    value?: string;

    constructor(data?: ICrypticKeyValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): CrypticKeyValues {
        data = typeof data === 'object' ? data : {};
        let result = new CrypticKeyValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface ICrypticKeyValues {
    name?: string;
    value?: string;
}

export class WebsiteInfo implements IWebsiteInfo {
    id?: number;
    website?: Website;
    hosts?: string[];
    linguaDefault?: Lingua;
    availableLanguages?: WebsiteLanguage[];
    operatore?: OperatoreInfo;
    accordo?: AccordoInfo;
    defaultLangCode?: string;

    constructor(data?: IWebsiteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.website = _data["website"] ? Website.fromJS(_data["website"]) : <any>null;
            if (Array.isArray(_data["hosts"])) {
                this.hosts = [] as any;
                for (let item of _data["hosts"])
                    this.hosts!.push(item);
            }
            else {
                this.hosts = <any>null;
            }
            this.linguaDefault = _data["linguaDefault"] ? Lingua.fromJS(_data["linguaDefault"]) : <any>null;
            if (Array.isArray(_data["availableLanguages"])) {
                this.availableLanguages = [] as any;
                for (let item of _data["availableLanguages"])
                    this.availableLanguages!.push(WebsiteLanguage.fromJS(item));
            }
            else {
                this.availableLanguages = <any>null;
            }
            this.operatore = _data["operatore"] ? OperatoreInfo.fromJS(_data["operatore"]) : <any>null;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : <any>null;
            this.defaultLangCode = _data["defaultLangCode"] !== undefined ? _data["defaultLangCode"] : <any>null;
        }
    }

    static fromJS(data: any): WebsiteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["website"] = this.website ? this.website.toJSON() : <any>null;
        if (Array.isArray(this.hosts)) {
            data["hosts"] = [];
            for (let item of this.hosts)
                data["hosts"].push(item);
        }
        data["linguaDefault"] = this.linguaDefault ? this.linguaDefault.toJSON() : <any>null;
        if (Array.isArray(this.availableLanguages)) {
            data["availableLanguages"] = [];
            for (let item of this.availableLanguages)
                data["availableLanguages"].push(item.toJSON());
        }
        data["operatore"] = this.operatore ? this.operatore.toJSON() : <any>null;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : <any>null;
        data["defaultLangCode"] = this.defaultLangCode !== undefined ? this.defaultLangCode : <any>null;
        return data;
    }
}

export interface IWebsiteInfo {
    id?: number;
    website?: Website;
    hosts?: string[];
    linguaDefault?: Lingua;
    availableLanguages?: WebsiteLanguage[];
    operatore?: OperatoreInfo;
    accordo?: AccordoInfo;
    defaultLangCode?: string;
}

export class Website implements IWebsite {
    id?: number;
    nome!: string;
    hosts!: string;
    operatore?: EOperatore;
    linguaDefaultID?: ELingua;
    accordoID?: number;
    lingueDisponibili?: string | null;

    constructor(data?: IWebsite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.hosts = _data["hosts"] !== undefined ? _data["hosts"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.linguaDefaultID = _data["linguaDefaultID"] !== undefined ? _data["linguaDefaultID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.lingueDisponibili = _data["lingueDisponibili"] !== undefined ? _data["lingueDisponibili"] : <any>null;
        }
    }

    static fromJS(data: any): Website {
        data = typeof data === 'object' ? data : {};
        let result = new Website();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["hosts"] = this.hosts !== undefined ? this.hosts : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["linguaDefaultID"] = this.linguaDefaultID !== undefined ? this.linguaDefaultID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["lingueDisponibili"] = this.lingueDisponibili !== undefined ? this.lingueDisponibili : <any>null;
        return data;
    }
}

export interface IWebsite {
    id?: number;
    nome: string;
    hosts: string;
    operatore?: EOperatore;
    linguaDefaultID?: ELingua;
    accordoID?: number;
    lingueDisponibili?: string | null;
}

export class Lingua implements ILingua {
    linguaID?: ELingua;
    nome?: string | null;
    codice!: string;

    constructor(data?: ILingua) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linguaID = _data["linguaID"] !== undefined ? _data["linguaID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
        }
    }

    static fromJS(data: any): Lingua {
        data = typeof data === 'object' ? data : {};
        let result = new Lingua();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linguaID"] = this.linguaID !== undefined ? this.linguaID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        return data;
    }
}

export interface ILingua {
    linguaID?: ELingua;
    nome?: string | null;
    codice: string;
}

export class WebsiteLanguage implements IWebsiteLanguage {
    linguaID?: ELingua;
    nome?: string | null;
    codice?: string | null;

    constructor(data?: IWebsiteLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linguaID = _data["linguaID"] !== undefined ? _data["linguaID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
        }
    }

    static fromJS(data: any): WebsiteLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linguaID"] = this.linguaID !== undefined ? this.linguaID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        return data;
    }
}

export interface IWebsiteLanguage {
    linguaID?: ELingua;
    nome?: string | null;
    codice?: string | null;
}

export class AccordoInfo implements IAccordoInfo {
    id?: number;
    accordo?: Accordo;
    searchTerms?: string;
    srtNome?: string;
    contatto?: ContattoInfo | null;
    srtContattoNome?: string | null;
    srtContattoLuogo_it?: string | null;
    srtContattoLuogo_en?: string | null;
    srtContattoLuogo_fr?: string | null;
    srtContattoLuogo_de?: string | null;
    articoliAccordo?: ArticoloInfo[];
    valuta?: ValutaInfo | null;
    host2Host?: boolean;
    tabellaCostiCommissioniDefault?: TabellaCostiCommissioniInfo | null;
    tabelleCostiCommissioni?: TabellaCostiCommissioniInfo[];
    tabelleCostiCommissioniByID?: { [key: string]: TabellaCostiCommissioniInfo; };
    datiAggiuntivi?: AccordoDatoAggiuntivo[];
    contraenti?: AccordoContatto[];
    fornitore?: EFornitore;
    isValid?: boolean;
    isDeleted?: boolean;
    reservationsFroms?: string[];

    constructor(data?: IAccordoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.accordo = _data["accordo"] ? Accordo.fromJS(_data["accordo"]) : <any>null;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : <any>null;
            this.srtNome = _data["srtNome"] !== undefined ? _data["srtNome"] : <any>null;
            this.contatto = _data["contatto"] ? ContattoInfo.fromJS(_data["contatto"]) : <any>null;
            this.srtContattoNome = _data["srtContattoNome"] !== undefined ? _data["srtContattoNome"] : <any>null;
            this.srtContattoLuogo_it = _data["srtContattoLuogo_it"] !== undefined ? _data["srtContattoLuogo_it"] : <any>null;
            this.srtContattoLuogo_en = _data["srtContattoLuogo_en"] !== undefined ? _data["srtContattoLuogo_en"] : <any>null;
            this.srtContattoLuogo_fr = _data["srtContattoLuogo_fr"] !== undefined ? _data["srtContattoLuogo_fr"] : <any>null;
            this.srtContattoLuogo_de = _data["srtContattoLuogo_de"] !== undefined ? _data["srtContattoLuogo_de"] : <any>null;
            if (Array.isArray(_data["articoliAccordo"])) {
                this.articoliAccordo = [] as any;
                for (let item of _data["articoliAccordo"])
                    this.articoliAccordo!.push(ArticoloInfo.fromJS(item));
            }
            else {
                this.articoliAccordo = <any>null;
            }
            this.valuta = _data["valuta"] ? ValutaInfo.fromJS(_data["valuta"]) : <any>null;
            this.host2Host = _data["host2Host"] !== undefined ? _data["host2Host"] : <any>null;
            this.tabellaCostiCommissioniDefault = _data["tabellaCostiCommissioniDefault"] ? TabellaCostiCommissioniInfo.fromJS(_data["tabellaCostiCommissioniDefault"]) : <any>null;
            if (Array.isArray(_data["tabelleCostiCommissioni"])) {
                this.tabelleCostiCommissioni = [] as any;
                for (let item of _data["tabelleCostiCommissioni"])
                    this.tabelleCostiCommissioni!.push(TabellaCostiCommissioniInfo.fromJS(item));
            }
            else {
                this.tabelleCostiCommissioni = <any>null;
            }
            if (_data["tabelleCostiCommissioniByID"]) {
                this.tabelleCostiCommissioniByID = {} as any;
                for (let key in _data["tabelleCostiCommissioniByID"]) {
                    if (_data["tabelleCostiCommissioniByID"].hasOwnProperty(key))
                        (<any>this.tabelleCostiCommissioniByID)![key] = _data["tabelleCostiCommissioniByID"][key] ? TabellaCostiCommissioniInfo.fromJS(_data["tabelleCostiCommissioniByID"][key]) : new TabellaCostiCommissioniInfo();
                }
            }
            else {
                this.tabelleCostiCommissioniByID = <any>null;
            }
            if (Array.isArray(_data["datiAggiuntivi"])) {
                this.datiAggiuntivi = [] as any;
                for (let item of _data["datiAggiuntivi"])
                    this.datiAggiuntivi!.push(AccordoDatoAggiuntivo.fromJS(item));
            }
            else {
                this.datiAggiuntivi = <any>null;
            }
            if (Array.isArray(_data["contraenti"])) {
                this.contraenti = [] as any;
                for (let item of _data["contraenti"])
                    this.contraenti!.push(AccordoContatto.fromJS(item));
            }
            else {
                this.contraenti = <any>null;
            }
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            if (Array.isArray(_data["reservationsFroms"])) {
                this.reservationsFroms = [] as any;
                for (let item of _data["reservationsFroms"])
                    this.reservationsFroms!.push(item);
            }
            else {
                this.reservationsFroms = <any>null;
            }
        }
    }

    static fromJS(data: any): AccordoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : <any>null;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : <any>null;
        data["srtNome"] = this.srtNome !== undefined ? this.srtNome : <any>null;
        data["contatto"] = this.contatto ? this.contatto.toJSON() : <any>null;
        data["srtContattoNome"] = this.srtContattoNome !== undefined ? this.srtContattoNome : <any>null;
        data["srtContattoLuogo_it"] = this.srtContattoLuogo_it !== undefined ? this.srtContattoLuogo_it : <any>null;
        data["srtContattoLuogo_en"] = this.srtContattoLuogo_en !== undefined ? this.srtContattoLuogo_en : <any>null;
        data["srtContattoLuogo_fr"] = this.srtContattoLuogo_fr !== undefined ? this.srtContattoLuogo_fr : <any>null;
        data["srtContattoLuogo_de"] = this.srtContattoLuogo_de !== undefined ? this.srtContattoLuogo_de : <any>null;
        if (Array.isArray(this.articoliAccordo)) {
            data["articoliAccordo"] = [];
            for (let item of this.articoliAccordo)
                data["articoliAccordo"].push(item.toJSON());
        }
        data["valuta"] = this.valuta ? this.valuta.toJSON() : <any>null;
        data["host2Host"] = this.host2Host !== undefined ? this.host2Host : <any>null;
        data["tabellaCostiCommissioniDefault"] = this.tabellaCostiCommissioniDefault ? this.tabellaCostiCommissioniDefault.toJSON() : <any>null;
        if (Array.isArray(this.tabelleCostiCommissioni)) {
            data["tabelleCostiCommissioni"] = [];
            for (let item of this.tabelleCostiCommissioni)
                data["tabelleCostiCommissioni"].push(item.toJSON());
        }
        if (this.tabelleCostiCommissioniByID) {
            data["tabelleCostiCommissioniByID"] = {};
            for (let key in this.tabelleCostiCommissioniByID) {
                if (this.tabelleCostiCommissioniByID.hasOwnProperty(key))
                    (<any>data["tabelleCostiCommissioniByID"])[key] = this.tabelleCostiCommissioniByID[key] ? this.tabelleCostiCommissioniByID[key].toJSON() : <any>null;
            }
        }
        if (Array.isArray(this.datiAggiuntivi)) {
            data["datiAggiuntivi"] = [];
            for (let item of this.datiAggiuntivi)
                data["datiAggiuntivi"].push(item.toJSON());
        }
        if (Array.isArray(this.contraenti)) {
            data["contraenti"] = [];
            for (let item of this.contraenti)
                data["contraenti"].push(item.toJSON());
        }
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        if (Array.isArray(this.reservationsFroms)) {
            data["reservationsFroms"] = [];
            for (let item of this.reservationsFroms)
                data["reservationsFroms"].push(item);
        }
        return data;
    }
}

export interface IAccordoInfo {
    id?: number;
    accordo?: Accordo;
    searchTerms?: string;
    srtNome?: string;
    contatto?: ContattoInfo | null;
    srtContattoNome?: string | null;
    srtContattoLuogo_it?: string | null;
    srtContattoLuogo_en?: string | null;
    srtContattoLuogo_fr?: string | null;
    srtContattoLuogo_de?: string | null;
    articoliAccordo?: ArticoloInfo[];
    valuta?: ValutaInfo | null;
    host2Host?: boolean;
    tabellaCostiCommissioniDefault?: TabellaCostiCommissioniInfo | null;
    tabelleCostiCommissioni?: TabellaCostiCommissioniInfo[];
    tabelleCostiCommissioniByID?: { [key: string]: TabellaCostiCommissioniInfo; };
    datiAggiuntivi?: AccordoDatoAggiuntivo[];
    contraenti?: AccordoContatto[];
    fornitore?: EFornitore;
    isValid?: boolean;
    isDeleted?: boolean;
    reservationsFroms?: string[];
}

export class ContattoInfo implements IContattoInfo {
    id?: number;
    uniqueID?: string | null;
    contatto?: Contatto | null;
    isFake?: boolean;
    nomeVisualizzato?: string | null;
    nomeAbbreviato?: string | null;
    ragioneSociale?: string | null;
    email?: string | null;
    descrizione?: string | null;
    relazioni?: ContattoRelazione[] | null;
    relazioniParent?: ContattoRelazione[] | null;
    contattoPromoter?: ContattoInfo | null;
    srtPromoter?: string | null;
    contattoNetwork?: ContattoInfo | null;
    srtNetwork?: string | null;
    recapiti?: ContattoRecapito[] | null;
    luogoContatto?: LuogoInfo | null;
    srtNomeLuogo_it?: string | null;
    srtNomeLuogo_fr?: string | null;
    srtNomeLuogo_de?: string | null;
    srtNomeLuogo_en?: string | null;
    srtNomeRegione_it?: string | null;
    srtNomeRegione_fr?: string | null;
    srtNomeRegione_de?: string | null;
    srtNomeRegione_en?: string | null;
    luogoFatturazione?: LuogoInfo | null;
    categoria?: CategoriaContatto | null;
    srtCategoria?: string | null;
    accordi?: AccordoContattoInfo[] | null;
    accordiOperatore?: { [key in keyof typeof EOperatore]?: AccordoContattoInfo; } | null;
    accordoNaar?: AccordoContattoInfo | null;
    srtAccordoNaar?: string | null;
    srtPagamentoAccordoNaar_it?: string | null;
    srtPagamentoAccordoNaar_fr?: string | null;
    srtPagamentoAccordoNaar_de?: string | null;
    srtPagamentoAccordoNaar_en?: string | null;
    srtPagamentoBiglietteriaNaar_it?: string | null;
    srtPagamentoBiglietteriaNaar_fr?: string | null;
    srtPagamentoBiglietteriaNaar_de?: string | null;
    srtPagamentoBiglietteriaNaar_en?: string | null;
    mappa?: Mappa | null;
    loghi?: ContattoLogo[] | null;
    logoADV?: LogoInfo | null;
    datiAggiuntivi?: ContattoDato[] | null;
    statistiche?: ContattoStatistica[] | null;
    indirizzoCompleto?: string | null;
    luogoFattura?: LuogoInfo | null;
    codiceNazioneFattura?: string | null;
    indirizzoFattura?: string | null;
    numeroCivicoFattura?: string | null;
    capFattura?: string | null;
    partitaIva?: string | null;
    searchTerms?: string | null;
    srtNome?: string | null;
    srtCognome?: string | null;
    opzioni?: ContattoOpzione | null;
    emailDocumentiContabili?: string | null;
    codiceUnivocoAgenziaFE?: string | null;
    indirizzoPecAgenziaFE?: string | null;
    datiHotelCompleti?: boolean;
    haMappa?: boolean;
    haServizio?: boolean;
    websiteUrl?: string | null;
    logoUrl?: string | null;
    lingua?: ELingua | null;

    constructor(data?: IContattoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : <any>null;
            this.contatto = _data["contatto"] ? Contatto.fromJS(_data["contatto"]) : <any>null;
            this.isFake = _data["isFake"] !== undefined ? _data["isFake"] : <any>null;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : <any>null;
            this.nomeAbbreviato = _data["nomeAbbreviato"] !== undefined ? _data["nomeAbbreviato"] : <any>null;
            this.ragioneSociale = _data["ragioneSociale"] !== undefined ? _data["ragioneSociale"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            if (Array.isArray(_data["relazioni"])) {
                this.relazioni = [] as any;
                for (let item of _data["relazioni"])
                    this.relazioni!.push(ContattoRelazione.fromJS(item));
            }
            else {
                this.relazioni = <any>null;
            }
            if (Array.isArray(_data["relazioniParent"])) {
                this.relazioniParent = [] as any;
                for (let item of _data["relazioniParent"])
                    this.relazioniParent!.push(ContattoRelazione.fromJS(item));
            }
            else {
                this.relazioniParent = <any>null;
            }
            this.contattoPromoter = _data["contattoPromoter"] ? ContattoInfo.fromJS(_data["contattoPromoter"]) : <any>null;
            this.srtPromoter = _data["srtPromoter"] !== undefined ? _data["srtPromoter"] : <any>null;
            this.contattoNetwork = _data["contattoNetwork"] ? ContattoInfo.fromJS(_data["contattoNetwork"]) : <any>null;
            this.srtNetwork = _data["srtNetwork"] !== undefined ? _data["srtNetwork"] : <any>null;
            if (Array.isArray(_data["recapiti"])) {
                this.recapiti = [] as any;
                for (let item of _data["recapiti"])
                    this.recapiti!.push(ContattoRecapito.fromJS(item));
            }
            else {
                this.recapiti = <any>null;
            }
            this.luogoContatto = _data["luogoContatto"] ? LuogoInfo.fromJS(_data["luogoContatto"]) : <any>null;
            this.srtNomeLuogo_it = _data["srtNomeLuogo_it"] !== undefined ? _data["srtNomeLuogo_it"] : <any>null;
            this.srtNomeLuogo_fr = _data["srtNomeLuogo_fr"] !== undefined ? _data["srtNomeLuogo_fr"] : <any>null;
            this.srtNomeLuogo_de = _data["srtNomeLuogo_de"] !== undefined ? _data["srtNomeLuogo_de"] : <any>null;
            this.srtNomeLuogo_en = _data["srtNomeLuogo_en"] !== undefined ? _data["srtNomeLuogo_en"] : <any>null;
            this.srtNomeRegione_it = _data["srtNomeRegione_it"] !== undefined ? _data["srtNomeRegione_it"] : <any>null;
            this.srtNomeRegione_fr = _data["srtNomeRegione_fr"] !== undefined ? _data["srtNomeRegione_fr"] : <any>null;
            this.srtNomeRegione_de = _data["srtNomeRegione_de"] !== undefined ? _data["srtNomeRegione_de"] : <any>null;
            this.srtNomeRegione_en = _data["srtNomeRegione_en"] !== undefined ? _data["srtNomeRegione_en"] : <any>null;
            this.luogoFatturazione = _data["luogoFatturazione"] ? LuogoInfo.fromJS(_data["luogoFatturazione"]) : <any>null;
            this.categoria = _data["categoria"] ? CategoriaContatto.fromJS(_data["categoria"]) : <any>null;
            this.srtCategoria = _data["srtCategoria"] !== undefined ? _data["srtCategoria"] : <any>null;
            if (Array.isArray(_data["accordi"])) {
                this.accordi = [] as any;
                for (let item of _data["accordi"])
                    this.accordi!.push(AccordoContattoInfo.fromJS(item));
            }
            else {
                this.accordi = <any>null;
            }
            if (_data["accordiOperatore"]) {
                this.accordiOperatore = {} as any;
                for (let key in _data["accordiOperatore"]) {
                    if (_data["accordiOperatore"].hasOwnProperty(key))
                        (<any>this.accordiOperatore)![key] = _data["accordiOperatore"][key] ? AccordoContattoInfo.fromJS(_data["accordiOperatore"][key]) : new AccordoContattoInfo();
                }
            }
            else {
                this.accordiOperatore = <any>null;
            }
            this.accordoNaar = _data["accordoNaar"] ? AccordoContattoInfo.fromJS(_data["accordoNaar"]) : <any>null;
            this.srtAccordoNaar = _data["srtAccordoNaar"] !== undefined ? _data["srtAccordoNaar"] : <any>null;
            this.srtPagamentoAccordoNaar_it = _data["srtPagamentoAccordoNaar_it"] !== undefined ? _data["srtPagamentoAccordoNaar_it"] : <any>null;
            this.srtPagamentoAccordoNaar_fr = _data["srtPagamentoAccordoNaar_fr"] !== undefined ? _data["srtPagamentoAccordoNaar_fr"] : <any>null;
            this.srtPagamentoAccordoNaar_de = _data["srtPagamentoAccordoNaar_de"] !== undefined ? _data["srtPagamentoAccordoNaar_de"] : <any>null;
            this.srtPagamentoAccordoNaar_en = _data["srtPagamentoAccordoNaar_en"] !== undefined ? _data["srtPagamentoAccordoNaar_en"] : <any>null;
            this.srtPagamentoBiglietteriaNaar_it = _data["srtPagamentoBiglietteriaNaar_it"] !== undefined ? _data["srtPagamentoBiglietteriaNaar_it"] : <any>null;
            this.srtPagamentoBiglietteriaNaar_fr = _data["srtPagamentoBiglietteriaNaar_fr"] !== undefined ? _data["srtPagamentoBiglietteriaNaar_fr"] : <any>null;
            this.srtPagamentoBiglietteriaNaar_de = _data["srtPagamentoBiglietteriaNaar_de"] !== undefined ? _data["srtPagamentoBiglietteriaNaar_de"] : <any>null;
            this.srtPagamentoBiglietteriaNaar_en = _data["srtPagamentoBiglietteriaNaar_en"] !== undefined ? _data["srtPagamentoBiglietteriaNaar_en"] : <any>null;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : <any>null;
            if (Array.isArray(_data["loghi"])) {
                this.loghi = [] as any;
                for (let item of _data["loghi"])
                    this.loghi!.push(ContattoLogo.fromJS(item));
            }
            else {
                this.loghi = <any>null;
            }
            this.logoADV = _data["logoADV"] ? LogoInfo.fromJS(_data["logoADV"]) : <any>null;
            if (Array.isArray(_data["datiAggiuntivi"])) {
                this.datiAggiuntivi = [] as any;
                for (let item of _data["datiAggiuntivi"])
                    this.datiAggiuntivi!.push(ContattoDato.fromJS(item));
            }
            else {
                this.datiAggiuntivi = <any>null;
            }
            if (Array.isArray(_data["statistiche"])) {
                this.statistiche = [] as any;
                for (let item of _data["statistiche"])
                    this.statistiche!.push(ContattoStatistica.fromJS(item));
            }
            else {
                this.statistiche = <any>null;
            }
            this.indirizzoCompleto = _data["indirizzoCompleto"] !== undefined ? _data["indirizzoCompleto"] : <any>null;
            this.luogoFattura = _data["luogoFattura"] ? LuogoInfo.fromJS(_data["luogoFattura"]) : <any>null;
            this.codiceNazioneFattura = _data["codiceNazioneFattura"] !== undefined ? _data["codiceNazioneFattura"] : <any>null;
            this.indirizzoFattura = _data["indirizzoFattura"] !== undefined ? _data["indirizzoFattura"] : <any>null;
            this.numeroCivicoFattura = _data["numeroCivicoFattura"] !== undefined ? _data["numeroCivicoFattura"] : <any>null;
            this.capFattura = _data["capFattura"] !== undefined ? _data["capFattura"] : <any>null;
            this.partitaIva = _data["partitaIva"] !== undefined ? _data["partitaIva"] : <any>null;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : <any>null;
            this.srtNome = _data["srtNome"] !== undefined ? _data["srtNome"] : <any>null;
            this.srtCognome = _data["srtCognome"] !== undefined ? _data["srtCognome"] : <any>null;
            this.opzioni = _data["opzioni"] ? ContattoOpzione.fromJS(_data["opzioni"]) : <any>null;
            this.emailDocumentiContabili = _data["emailDocumentiContabili"] !== undefined ? _data["emailDocumentiContabili"] : <any>null;
            this.codiceUnivocoAgenziaFE = _data["codiceUnivocoAgenziaFE"] !== undefined ? _data["codiceUnivocoAgenziaFE"] : <any>null;
            this.indirizzoPecAgenziaFE = _data["indirizzoPecAgenziaFE"] !== undefined ? _data["indirizzoPecAgenziaFE"] : <any>null;
            this.datiHotelCompleti = _data["datiHotelCompleti"] !== undefined ? _data["datiHotelCompleti"] : <any>null;
            this.haMappa = _data["haMappa"] !== undefined ? _data["haMappa"] : <any>null;
            this.haServizio = _data["haServizio"] !== undefined ? _data["haServizio"] : <any>null;
            this.websiteUrl = _data["websiteUrl"] !== undefined ? _data["websiteUrl"] : <any>null;
            this.logoUrl = _data["logoUrl"] !== undefined ? _data["logoUrl"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
        }
    }

    static fromJS(data: any): ContattoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : <any>null;
        data["contatto"] = this.contatto ? this.contatto.toJSON() : <any>null;
        data["isFake"] = this.isFake !== undefined ? this.isFake : <any>null;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : <any>null;
        data["nomeAbbreviato"] = this.nomeAbbreviato !== undefined ? this.nomeAbbreviato : <any>null;
        data["ragioneSociale"] = this.ragioneSociale !== undefined ? this.ragioneSociale : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        if (Array.isArray(this.relazioni)) {
            data["relazioni"] = [];
            for (let item of this.relazioni)
                data["relazioni"].push(item.toJSON());
        }
        if (Array.isArray(this.relazioniParent)) {
            data["relazioniParent"] = [];
            for (let item of this.relazioniParent)
                data["relazioniParent"].push(item.toJSON());
        }
        data["contattoPromoter"] = this.contattoPromoter ? this.contattoPromoter.toJSON() : <any>null;
        data["srtPromoter"] = this.srtPromoter !== undefined ? this.srtPromoter : <any>null;
        data["contattoNetwork"] = this.contattoNetwork ? this.contattoNetwork.toJSON() : <any>null;
        data["srtNetwork"] = this.srtNetwork !== undefined ? this.srtNetwork : <any>null;
        if (Array.isArray(this.recapiti)) {
            data["recapiti"] = [];
            for (let item of this.recapiti)
                data["recapiti"].push(item.toJSON());
        }
        data["luogoContatto"] = this.luogoContatto ? this.luogoContatto.toJSON() : <any>null;
        data["srtNomeLuogo_it"] = this.srtNomeLuogo_it !== undefined ? this.srtNomeLuogo_it : <any>null;
        data["srtNomeLuogo_fr"] = this.srtNomeLuogo_fr !== undefined ? this.srtNomeLuogo_fr : <any>null;
        data["srtNomeLuogo_de"] = this.srtNomeLuogo_de !== undefined ? this.srtNomeLuogo_de : <any>null;
        data["srtNomeLuogo_en"] = this.srtNomeLuogo_en !== undefined ? this.srtNomeLuogo_en : <any>null;
        data["srtNomeRegione_it"] = this.srtNomeRegione_it !== undefined ? this.srtNomeRegione_it : <any>null;
        data["srtNomeRegione_fr"] = this.srtNomeRegione_fr !== undefined ? this.srtNomeRegione_fr : <any>null;
        data["srtNomeRegione_de"] = this.srtNomeRegione_de !== undefined ? this.srtNomeRegione_de : <any>null;
        data["srtNomeRegione_en"] = this.srtNomeRegione_en !== undefined ? this.srtNomeRegione_en : <any>null;
        data["luogoFatturazione"] = this.luogoFatturazione ? this.luogoFatturazione.toJSON() : <any>null;
        data["categoria"] = this.categoria ? this.categoria.toJSON() : <any>null;
        data["srtCategoria"] = this.srtCategoria !== undefined ? this.srtCategoria : <any>null;
        if (Array.isArray(this.accordi)) {
            data["accordi"] = [];
            for (let item of this.accordi)
                data["accordi"].push(item.toJSON());
        }
        if (this.accordiOperatore) {
            data["accordiOperatore"] = {};
            for (let key in this.accordiOperatore) {
                if (this.accordiOperatore.hasOwnProperty(key))
                    (<any>data["accordiOperatore"])[key] = this.accordiOperatore[key] ? this.accordiOperatore[key].toJSON() : <any>null;
            }
        }
        data["accordoNaar"] = this.accordoNaar ? this.accordoNaar.toJSON() : <any>null;
        data["srtAccordoNaar"] = this.srtAccordoNaar !== undefined ? this.srtAccordoNaar : <any>null;
        data["srtPagamentoAccordoNaar_it"] = this.srtPagamentoAccordoNaar_it !== undefined ? this.srtPagamentoAccordoNaar_it : <any>null;
        data["srtPagamentoAccordoNaar_fr"] = this.srtPagamentoAccordoNaar_fr !== undefined ? this.srtPagamentoAccordoNaar_fr : <any>null;
        data["srtPagamentoAccordoNaar_de"] = this.srtPagamentoAccordoNaar_de !== undefined ? this.srtPagamentoAccordoNaar_de : <any>null;
        data["srtPagamentoAccordoNaar_en"] = this.srtPagamentoAccordoNaar_en !== undefined ? this.srtPagamentoAccordoNaar_en : <any>null;
        data["srtPagamentoBiglietteriaNaar_it"] = this.srtPagamentoBiglietteriaNaar_it !== undefined ? this.srtPagamentoBiglietteriaNaar_it : <any>null;
        data["srtPagamentoBiglietteriaNaar_fr"] = this.srtPagamentoBiglietteriaNaar_fr !== undefined ? this.srtPagamentoBiglietteriaNaar_fr : <any>null;
        data["srtPagamentoBiglietteriaNaar_de"] = this.srtPagamentoBiglietteriaNaar_de !== undefined ? this.srtPagamentoBiglietteriaNaar_de : <any>null;
        data["srtPagamentoBiglietteriaNaar_en"] = this.srtPagamentoBiglietteriaNaar_en !== undefined ? this.srtPagamentoBiglietteriaNaar_en : <any>null;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : <any>null;
        if (Array.isArray(this.loghi)) {
            data["loghi"] = [];
            for (let item of this.loghi)
                data["loghi"].push(item.toJSON());
        }
        data["logoADV"] = this.logoADV ? this.logoADV.toJSON() : <any>null;
        if (Array.isArray(this.datiAggiuntivi)) {
            data["datiAggiuntivi"] = [];
            for (let item of this.datiAggiuntivi)
                data["datiAggiuntivi"].push(item.toJSON());
        }
        if (Array.isArray(this.statistiche)) {
            data["statistiche"] = [];
            for (let item of this.statistiche)
                data["statistiche"].push(item.toJSON());
        }
        data["indirizzoCompleto"] = this.indirizzoCompleto !== undefined ? this.indirizzoCompleto : <any>null;
        data["luogoFattura"] = this.luogoFattura ? this.luogoFattura.toJSON() : <any>null;
        data["codiceNazioneFattura"] = this.codiceNazioneFattura !== undefined ? this.codiceNazioneFattura : <any>null;
        data["indirizzoFattura"] = this.indirizzoFattura !== undefined ? this.indirizzoFattura : <any>null;
        data["numeroCivicoFattura"] = this.numeroCivicoFattura !== undefined ? this.numeroCivicoFattura : <any>null;
        data["capFattura"] = this.capFattura !== undefined ? this.capFattura : <any>null;
        data["partitaIva"] = this.partitaIva !== undefined ? this.partitaIva : <any>null;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : <any>null;
        data["srtNome"] = this.srtNome !== undefined ? this.srtNome : <any>null;
        data["srtCognome"] = this.srtCognome !== undefined ? this.srtCognome : <any>null;
        data["opzioni"] = this.opzioni ? this.opzioni.toJSON() : <any>null;
        data["emailDocumentiContabili"] = this.emailDocumentiContabili !== undefined ? this.emailDocumentiContabili : <any>null;
        data["codiceUnivocoAgenziaFE"] = this.codiceUnivocoAgenziaFE !== undefined ? this.codiceUnivocoAgenziaFE : <any>null;
        data["indirizzoPecAgenziaFE"] = this.indirizzoPecAgenziaFE !== undefined ? this.indirizzoPecAgenziaFE : <any>null;
        data["datiHotelCompleti"] = this.datiHotelCompleti !== undefined ? this.datiHotelCompleti : <any>null;
        data["haMappa"] = this.haMappa !== undefined ? this.haMappa : <any>null;
        data["haServizio"] = this.haServizio !== undefined ? this.haServizio : <any>null;
        data["websiteUrl"] = this.websiteUrl !== undefined ? this.websiteUrl : <any>null;
        data["logoUrl"] = this.logoUrl !== undefined ? this.logoUrl : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        return data;
    }
}

export interface IContattoInfo {
    id?: number;
    uniqueID?: string | null;
    contatto?: Contatto | null;
    isFake?: boolean;
    nomeVisualizzato?: string | null;
    nomeAbbreviato?: string | null;
    ragioneSociale?: string | null;
    email?: string | null;
    descrizione?: string | null;
    relazioni?: ContattoRelazione[] | null;
    relazioniParent?: ContattoRelazione[] | null;
    contattoPromoter?: ContattoInfo | null;
    srtPromoter?: string | null;
    contattoNetwork?: ContattoInfo | null;
    srtNetwork?: string | null;
    recapiti?: ContattoRecapito[] | null;
    luogoContatto?: LuogoInfo | null;
    srtNomeLuogo_it?: string | null;
    srtNomeLuogo_fr?: string | null;
    srtNomeLuogo_de?: string | null;
    srtNomeLuogo_en?: string | null;
    srtNomeRegione_it?: string | null;
    srtNomeRegione_fr?: string | null;
    srtNomeRegione_de?: string | null;
    srtNomeRegione_en?: string | null;
    luogoFatturazione?: LuogoInfo | null;
    categoria?: CategoriaContatto | null;
    srtCategoria?: string | null;
    accordi?: AccordoContattoInfo[] | null;
    accordiOperatore?: { [key in keyof typeof EOperatore]?: AccordoContattoInfo; } | null;
    accordoNaar?: AccordoContattoInfo | null;
    srtAccordoNaar?: string | null;
    srtPagamentoAccordoNaar_it?: string | null;
    srtPagamentoAccordoNaar_fr?: string | null;
    srtPagamentoAccordoNaar_de?: string | null;
    srtPagamentoAccordoNaar_en?: string | null;
    srtPagamentoBiglietteriaNaar_it?: string | null;
    srtPagamentoBiglietteriaNaar_fr?: string | null;
    srtPagamentoBiglietteriaNaar_de?: string | null;
    srtPagamentoBiglietteriaNaar_en?: string | null;
    mappa?: Mappa | null;
    loghi?: ContattoLogo[] | null;
    logoADV?: LogoInfo | null;
    datiAggiuntivi?: ContattoDato[] | null;
    statistiche?: ContattoStatistica[] | null;
    indirizzoCompleto?: string | null;
    luogoFattura?: LuogoInfo | null;
    codiceNazioneFattura?: string | null;
    indirizzoFattura?: string | null;
    numeroCivicoFattura?: string | null;
    capFattura?: string | null;
    partitaIva?: string | null;
    searchTerms?: string | null;
    srtNome?: string | null;
    srtCognome?: string | null;
    opzioni?: ContattoOpzione | null;
    emailDocumentiContabili?: string | null;
    codiceUnivocoAgenziaFE?: string | null;
    indirizzoPecAgenziaFE?: string | null;
    datiHotelCompleti?: boolean;
    haMappa?: boolean;
    haServizio?: boolean;
    websiteUrl?: string | null;
    logoUrl?: string | null;
    lingua?: ELingua | null;
}

export class LuogoInfo implements ILuogoInfo {
    id?: number;
    table?: string | null;
    luogo?: Luogo | null;
    eliminato?: boolean;
    provincia?: string | null;
    prioritaParent?: number;
    isCity?: boolean;
    hasMap?: boolean;
    isPlaceholder?: boolean;
    codice?: string | null;
    mappa?: Mappa | null;
    regione?: LuogoInfo | null;
    paese?: LuogoInfo | null;
    destinazione?: LuogoInfo | null;
    subzonaAerea?: LuogoInfo | null;
    relazioni?: LuogoRelazione[] | null;
    distanze?: LuogoDistanza[] | null;
    isItalia?: boolean;
    isEuropa?: boolean;
    isCee?: boolean;
    isNordAmerica?: boolean;
    aeroportiList?: Aeroporto[] | null;
    aeroporto?: Aeroporto | null;
    padre?: LuogoInfo | null;
    luoghiPadre?: LuogoInfo[] | null;
    luoghiVicini?: LuogoInfo[] | null;
    articoli?: ArticoloInfo[] | null;
    immagini?: ImmagineInfo[] | null;
    srtNome_it?: string | null;
    srtNome_en?: string | null;
    srtNome_fr?: string | null;
    srtNome_de?: string | null;
    srtNome_be?: string | null;
    nome?: string | null;
    nome_en?: string | null;
    traduzioni?: IWebTranslationEntity[] | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;

    constructor(data?: ILuogoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
            this.luogo = _data["luogo"] ? Luogo.fromJS(_data["luogo"]) : <any>null;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : <any>null;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : <any>null;
            this.prioritaParent = _data["prioritaParent"] !== undefined ? _data["prioritaParent"] : <any>null;
            this.isCity = _data["isCity"] !== undefined ? _data["isCity"] : <any>null;
            this.hasMap = _data["hasMap"] !== undefined ? _data["hasMap"] : <any>null;
            this.isPlaceholder = _data["isPlaceholder"] !== undefined ? _data["isPlaceholder"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : <any>null;
            this.regione = _data["regione"] ? LuogoInfo.fromJS(_data["regione"]) : <any>null;
            this.paese = _data["paese"] ? LuogoInfo.fromJS(_data["paese"]) : <any>null;
            this.destinazione = _data["destinazione"] ? LuogoInfo.fromJS(_data["destinazione"]) : <any>null;
            this.subzonaAerea = _data["subzonaAerea"] ? LuogoInfo.fromJS(_data["subzonaAerea"]) : <any>null;
            if (Array.isArray(_data["relazioni"])) {
                this.relazioni = [] as any;
                for (let item of _data["relazioni"])
                    this.relazioni!.push(LuogoRelazione.fromJS(item));
            }
            else {
                this.relazioni = <any>null;
            }
            if (Array.isArray(_data["distanze"])) {
                this.distanze = [] as any;
                for (let item of _data["distanze"])
                    this.distanze!.push(LuogoDistanza.fromJS(item));
            }
            else {
                this.distanze = <any>null;
            }
            this.isItalia = _data["isItalia"] !== undefined ? _data["isItalia"] : <any>null;
            this.isEuropa = _data["isEuropa"] !== undefined ? _data["isEuropa"] : <any>null;
            this.isCee = _data["isCee"] !== undefined ? _data["isCee"] : <any>null;
            this.isNordAmerica = _data["isNordAmerica"] !== undefined ? _data["isNordAmerica"] : <any>null;
            if (Array.isArray(_data["aeroportiList"])) {
                this.aeroportiList = [] as any;
                for (let item of _data["aeroportiList"])
                    this.aeroportiList!.push(Aeroporto.fromJS(item));
            }
            else {
                this.aeroportiList = <any>null;
            }
            this.aeroporto = _data["aeroporto"] ? Aeroporto.fromJS(_data["aeroporto"]) : <any>null;
            this.padre = _data["padre"] ? LuogoInfo.fromJS(_data["padre"]) : <any>null;
            if (Array.isArray(_data["luoghiPadre"])) {
                this.luoghiPadre = [] as any;
                for (let item of _data["luoghiPadre"])
                    this.luoghiPadre!.push(LuogoInfo.fromJS(item));
            }
            else {
                this.luoghiPadre = <any>null;
            }
            if (Array.isArray(_data["luoghiVicini"])) {
                this.luoghiVicini = [] as any;
                for (let item of _data["luoghiVicini"])
                    this.luoghiVicini!.push(LuogoInfo.fromJS(item));
            }
            else {
                this.luoghiVicini = <any>null;
            }
            if (Array.isArray(_data["articoli"])) {
                this.articoli = [] as any;
                for (let item of _data["articoli"])
                    this.articoli!.push(ArticoloInfo.fromJS(item));
            }
            else {
                this.articoli = <any>null;
            }
            if (Array.isArray(_data["immagini"])) {
                this.immagini = [] as any;
                for (let item of _data["immagini"])
                    this.immagini!.push(ImmagineInfo.fromJS(item));
            }
            else {
                this.immagini = <any>null;
            }
            this.srtNome_it = _data["srtNome_it"] !== undefined ? _data["srtNome_it"] : <any>null;
            this.srtNome_en = _data["srtNome_en"] !== undefined ? _data["srtNome_en"] : <any>null;
            this.srtNome_fr = _data["srtNome_fr"] !== undefined ? _data["srtNome_fr"] : <any>null;
            this.srtNome_de = _data["srtNome_de"] !== undefined ? _data["srtNome_de"] : <any>null;
            this.srtNome_be = _data["srtNome_be"] !== undefined ? _data["srtNome_be"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
        }
    }

    static fromJS(data: any): LuogoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : <any>null;
        data["provincia"] = this.provincia !== undefined ? this.provincia : <any>null;
        data["prioritaParent"] = this.prioritaParent !== undefined ? this.prioritaParent : <any>null;
        data["isCity"] = this.isCity !== undefined ? this.isCity : <any>null;
        data["hasMap"] = this.hasMap !== undefined ? this.hasMap : <any>null;
        data["isPlaceholder"] = this.isPlaceholder !== undefined ? this.isPlaceholder : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : <any>null;
        data["regione"] = this.regione ? this.regione.toJSON() : <any>null;
        data["paese"] = this.paese ? this.paese.toJSON() : <any>null;
        data["destinazione"] = this.destinazione ? this.destinazione.toJSON() : <any>null;
        data["subzonaAerea"] = this.subzonaAerea ? this.subzonaAerea.toJSON() : <any>null;
        if (Array.isArray(this.relazioni)) {
            data["relazioni"] = [];
            for (let item of this.relazioni)
                data["relazioni"].push(item.toJSON());
        }
        if (Array.isArray(this.distanze)) {
            data["distanze"] = [];
            for (let item of this.distanze)
                data["distanze"].push(item.toJSON());
        }
        data["isItalia"] = this.isItalia !== undefined ? this.isItalia : <any>null;
        data["isEuropa"] = this.isEuropa !== undefined ? this.isEuropa : <any>null;
        data["isCee"] = this.isCee !== undefined ? this.isCee : <any>null;
        data["isNordAmerica"] = this.isNordAmerica !== undefined ? this.isNordAmerica : <any>null;
        if (Array.isArray(this.aeroportiList)) {
            data["aeroportiList"] = [];
            for (let item of this.aeroportiList)
                data["aeroportiList"].push(item.toJSON());
        }
        data["aeroporto"] = this.aeroporto ? this.aeroporto.toJSON() : <any>null;
        data["padre"] = this.padre ? this.padre.toJSON() : <any>null;
        if (Array.isArray(this.luoghiPadre)) {
            data["luoghiPadre"] = [];
            for (let item of this.luoghiPadre)
                data["luoghiPadre"].push(item.toJSON());
        }
        if (Array.isArray(this.luoghiVicini)) {
            data["luoghiVicini"] = [];
            for (let item of this.luoghiVicini)
                data["luoghiVicini"].push(item.toJSON());
        }
        if (Array.isArray(this.articoli)) {
            data["articoli"] = [];
            for (let item of this.articoli)
                data["articoli"].push(item.toJSON());
        }
        if (Array.isArray(this.immagini)) {
            data["immagini"] = [];
            for (let item of this.immagini)
                data["immagini"].push(item.toJSON());
        }
        data["srtNome_it"] = this.srtNome_it !== undefined ? this.srtNome_it : <any>null;
        data["srtNome_en"] = this.srtNome_en !== undefined ? this.srtNome_en : <any>null;
        data["srtNome_fr"] = this.srtNome_fr !== undefined ? this.srtNome_fr : <any>null;
        data["srtNome_de"] = this.srtNome_de !== undefined ? this.srtNome_de : <any>null;
        data["srtNome_be"] = this.srtNome_be !== undefined ? this.srtNome_be : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        return data;
    }
}

export interface ILuogoInfo {
    id?: number;
    table?: string | null;
    luogo?: Luogo | null;
    eliminato?: boolean;
    provincia?: string | null;
    prioritaParent?: number;
    isCity?: boolean;
    hasMap?: boolean;
    isPlaceholder?: boolean;
    codice?: string | null;
    mappa?: Mappa | null;
    regione?: LuogoInfo | null;
    paese?: LuogoInfo | null;
    destinazione?: LuogoInfo | null;
    subzonaAerea?: LuogoInfo | null;
    relazioni?: LuogoRelazione[] | null;
    distanze?: LuogoDistanza[] | null;
    isItalia?: boolean;
    isEuropa?: boolean;
    isCee?: boolean;
    isNordAmerica?: boolean;
    aeroportiList?: Aeroporto[] | null;
    aeroporto?: Aeroporto | null;
    padre?: LuogoInfo | null;
    luoghiPadre?: LuogoInfo[] | null;
    luoghiVicini?: LuogoInfo[] | null;
    articoli?: ArticoloInfo[] | null;
    immagini?: ImmagineInfo[] | null;
    srtNome_it?: string | null;
    srtNome_en?: string | null;
    srtNome_fr?: string | null;
    srtNome_de?: string | null;
    srtNome_be?: string | null;
    nome?: string | null;
    nome_en?: string | null;
    traduzioni?: IWebTranslationEntity[] | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
}

export class ArticoloInfo implements IArticoloInfo {
    id?: number;
    articolo?: Articolo;
    pubblicato?: boolean;
    titolo?: string;
    srtLuogo_it?: string | null;
    srtLuogo_en?: string | null;
    srtLuogo_fr?: string | null;
    srtLuogo_de?: string | null;
    srtServizio_it?: string | null;
    srtServizio_en?: string | null;
    srtServizio_fr?: string | null;
    srtServizio_de?: string | null;
    srtCompagnia?: string | null;
    srtAccordo?: string | null;
    srtOrdine?: string;
    intestazione?: ArticoloTestata | null;
    luogo?: LuogoInfo | null;
    servizio?: ServizioInfo | null;
    accordo?: AccordoInfo | null;
    link?: PageLinkInfo | null;
    compagnia?: CompagniaAerea | null;
    searchTerms?: string;
    attachments?: ArticoloAttachmentInfo[];
    giorno?: number;
    ordine?: number;
    gruppoTestata?: number | null;
    ordineTestata?: number | null;
    isGiorno?: boolean;
    isNota?: boolean;
    isNews?: boolean;
    isPenaliCancellazioneRiga?: boolean;
    isPenaliCancellazioneEstese?: boolean;
    isNoteServizioRiga?: boolean;
    isNoteServizioEstese?: boolean;
    traduzioni?: ArticoloTraduzione[];
    lastUpdate?: string | null;
    srtTitolo_it?: string | null;
    srtTitolo_en?: string | null;
    srtTitolo_fr?: string | null;
    srtTitolo_de?: string | null;
    operatore?: EOperatore | null;

    constructor(data?: IArticoloInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.articolo = _data["articolo"] ? Articolo.fromJS(_data["articolo"]) : <any>null;
            this.pubblicato = _data["pubblicato"] !== undefined ? _data["pubblicato"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.srtLuogo_it = _data["srtLuogo_it"] !== undefined ? _data["srtLuogo_it"] : <any>null;
            this.srtLuogo_en = _data["srtLuogo_en"] !== undefined ? _data["srtLuogo_en"] : <any>null;
            this.srtLuogo_fr = _data["srtLuogo_fr"] !== undefined ? _data["srtLuogo_fr"] : <any>null;
            this.srtLuogo_de = _data["srtLuogo_de"] !== undefined ? _data["srtLuogo_de"] : <any>null;
            this.srtServizio_it = _data["srtServizio_it"] !== undefined ? _data["srtServizio_it"] : <any>null;
            this.srtServizio_en = _data["srtServizio_en"] !== undefined ? _data["srtServizio_en"] : <any>null;
            this.srtServizio_fr = _data["srtServizio_fr"] !== undefined ? _data["srtServizio_fr"] : <any>null;
            this.srtServizio_de = _data["srtServizio_de"] !== undefined ? _data["srtServizio_de"] : <any>null;
            this.srtCompagnia = _data["srtCompagnia"] !== undefined ? _data["srtCompagnia"] : <any>null;
            this.srtAccordo = _data["srtAccordo"] !== undefined ? _data["srtAccordo"] : <any>null;
            this.srtOrdine = _data["srtOrdine"] !== undefined ? _data["srtOrdine"] : <any>null;
            this.intestazione = _data["intestazione"] ? ArticoloTestata.fromJS(_data["intestazione"]) : <any>null;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : <any>null;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : <any>null;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : <any>null;
            this.link = _data["link"] ? PageLinkInfo.fromJS(_data["link"]) : <any>null;
            this.compagnia = _data["compagnia"] ? CompagniaAerea.fromJS(_data["compagnia"]) : <any>null;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : <any>null;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(ArticoloAttachmentInfo.fromJS(item));
            }
            else {
                this.attachments = <any>null;
            }
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.gruppoTestata = _data["gruppoTestata"] !== undefined ? _data["gruppoTestata"] : <any>null;
            this.ordineTestata = _data["ordineTestata"] !== undefined ? _data["ordineTestata"] : <any>null;
            this.isGiorno = _data["isGiorno"] !== undefined ? _data["isGiorno"] : <any>null;
            this.isNota = _data["isNota"] !== undefined ? _data["isNota"] : <any>null;
            this.isNews = _data["isNews"] !== undefined ? _data["isNews"] : <any>null;
            this.isPenaliCancellazioneRiga = _data["isPenaliCancellazioneRiga"] !== undefined ? _data["isPenaliCancellazioneRiga"] : <any>null;
            this.isPenaliCancellazioneEstese = _data["isPenaliCancellazioneEstese"] !== undefined ? _data["isPenaliCancellazioneEstese"] : <any>null;
            this.isNoteServizioRiga = _data["isNoteServizioRiga"] !== undefined ? _data["isNoteServizioRiga"] : <any>null;
            this.isNoteServizioEstese = _data["isNoteServizioEstese"] !== undefined ? _data["isNoteServizioEstese"] : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(ArticoloTraduzione.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.srtTitolo_it = _data["srtTitolo_it"] !== undefined ? _data["srtTitolo_it"] : <any>null;
            this.srtTitolo_en = _data["srtTitolo_en"] !== undefined ? _data["srtTitolo_en"] : <any>null;
            this.srtTitolo_fr = _data["srtTitolo_fr"] !== undefined ? _data["srtTitolo_fr"] : <any>null;
            this.srtTitolo_de = _data["srtTitolo_de"] !== undefined ? _data["srtTitolo_de"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["articolo"] = this.articolo ? this.articolo.toJSON() : <any>null;
        data["pubblicato"] = this.pubblicato !== undefined ? this.pubblicato : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["srtLuogo_it"] = this.srtLuogo_it !== undefined ? this.srtLuogo_it : <any>null;
        data["srtLuogo_en"] = this.srtLuogo_en !== undefined ? this.srtLuogo_en : <any>null;
        data["srtLuogo_fr"] = this.srtLuogo_fr !== undefined ? this.srtLuogo_fr : <any>null;
        data["srtLuogo_de"] = this.srtLuogo_de !== undefined ? this.srtLuogo_de : <any>null;
        data["srtServizio_it"] = this.srtServizio_it !== undefined ? this.srtServizio_it : <any>null;
        data["srtServizio_en"] = this.srtServizio_en !== undefined ? this.srtServizio_en : <any>null;
        data["srtServizio_fr"] = this.srtServizio_fr !== undefined ? this.srtServizio_fr : <any>null;
        data["srtServizio_de"] = this.srtServizio_de !== undefined ? this.srtServizio_de : <any>null;
        data["srtCompagnia"] = this.srtCompagnia !== undefined ? this.srtCompagnia : <any>null;
        data["srtAccordo"] = this.srtAccordo !== undefined ? this.srtAccordo : <any>null;
        data["srtOrdine"] = this.srtOrdine !== undefined ? this.srtOrdine : <any>null;
        data["intestazione"] = this.intestazione ? this.intestazione.toJSON() : <any>null;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : <any>null;
        data["link"] = this.link ? this.link.toJSON() : <any>null;
        data["compagnia"] = this.compagnia ? this.compagnia.toJSON() : <any>null;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : <any>null;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["gruppoTestata"] = this.gruppoTestata !== undefined ? this.gruppoTestata : <any>null;
        data["ordineTestata"] = this.ordineTestata !== undefined ? this.ordineTestata : <any>null;
        data["isGiorno"] = this.isGiorno !== undefined ? this.isGiorno : <any>null;
        data["isNota"] = this.isNota !== undefined ? this.isNota : <any>null;
        data["isNews"] = this.isNews !== undefined ? this.isNews : <any>null;
        data["isPenaliCancellazioneRiga"] = this.isPenaliCancellazioneRiga !== undefined ? this.isPenaliCancellazioneRiga : <any>null;
        data["isPenaliCancellazioneEstese"] = this.isPenaliCancellazioneEstese !== undefined ? this.isPenaliCancellazioneEstese : <any>null;
        data["isNoteServizioRiga"] = this.isNoteServizioRiga !== undefined ? this.isNoteServizioRiga : <any>null;
        data["isNoteServizioEstese"] = this.isNoteServizioEstese !== undefined ? this.isNoteServizioEstese : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["srtTitolo_it"] = this.srtTitolo_it !== undefined ? this.srtTitolo_it : <any>null;
        data["srtTitolo_en"] = this.srtTitolo_en !== undefined ? this.srtTitolo_en : <any>null;
        data["srtTitolo_fr"] = this.srtTitolo_fr !== undefined ? this.srtTitolo_fr : <any>null;
        data["srtTitolo_de"] = this.srtTitolo_de !== undefined ? this.srtTitolo_de : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        return data;
    }
}

export interface IArticoloInfo {
    id?: number;
    articolo?: Articolo;
    pubblicato?: boolean;
    titolo?: string;
    srtLuogo_it?: string | null;
    srtLuogo_en?: string | null;
    srtLuogo_fr?: string | null;
    srtLuogo_de?: string | null;
    srtServizio_it?: string | null;
    srtServizio_en?: string | null;
    srtServizio_fr?: string | null;
    srtServizio_de?: string | null;
    srtCompagnia?: string | null;
    srtAccordo?: string | null;
    srtOrdine?: string;
    intestazione?: ArticoloTestata | null;
    luogo?: LuogoInfo | null;
    servizio?: ServizioInfo | null;
    accordo?: AccordoInfo | null;
    link?: PageLinkInfo | null;
    compagnia?: CompagniaAerea | null;
    searchTerms?: string;
    attachments?: ArticoloAttachmentInfo[];
    giorno?: number;
    ordine?: number;
    gruppoTestata?: number | null;
    ordineTestata?: number | null;
    isGiorno?: boolean;
    isNota?: boolean;
    isNews?: boolean;
    isPenaliCancellazioneRiga?: boolean;
    isPenaliCancellazioneEstese?: boolean;
    isNoteServizioRiga?: boolean;
    isNoteServizioEstese?: boolean;
    traduzioni?: ArticoloTraduzione[];
    lastUpdate?: string | null;
    srtTitolo_it?: string | null;
    srtTitolo_en?: string | null;
    srtTitolo_fr?: string | null;
    srtTitolo_de?: string | null;
    operatore?: EOperatore | null;
}

export class ArticoloTestata implements IArticoloTestata {
    articoloTestataID?: number;
    nome!: string;
    ordine?: number | null;
    gruppo?: number | null;
    nome_en?: string | null;

    constructor(data?: IArticoloTestata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articoloTestataID = _data["articoloTestataID"] !== undefined ? _data["articoloTestataID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.gruppo = _data["gruppo"] !== undefined ? _data["gruppo"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloTestata {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTestata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloTestataID"] = this.articoloTestataID !== undefined ? this.articoloTestataID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["gruppo"] = this.gruppo !== undefined ? this.gruppo : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        return data;
    }
}

export interface IArticoloTestata {
    articoloTestataID?: number;
    nome: string;
    ordine?: number | null;
    gruppo?: number | null;
    nome_en?: string | null;
}

export abstract class ServizioInfoBase implements IServizioInfoBase {
    luogo?: LuogoInfo | null;

    constructor(data?: IServizioInfoBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : <any>null;
        }
    }

    static fromJS(data: any): ServizioInfoBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioInfoBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        return data;
    }
}

export interface IServizioInfoBase {
    luogo?: LuogoInfo | null;
}

export class ServizioInfo extends ServizioInfoBase implements IServizioInfo {
    _Prezzi?: PrezzoOfferta[] | null;
    id?: number;
    table?: string | null;
    uniqueID?: string | null;
    servizio?: Servizio | null;
    eliminato?: boolean;
    luogoID?: number;
    contattoFornitore?: ContattoInfo | null;
    nomeFornitore?: string | null;
    srtNomeFornitore?: string | null;
    templateAssociati?: PacchettoInfo[] | null;
    regoleScontoPacchetto?: ServizioRegolaScontoPacchetto[] | null;
    deltaMargine?: number;
    immagini?: ImmagineInfo[] | null;
    coverImage?: string | null;
    isObsoleto?: boolean;
    isVolo?: boolean;
    isBookingFeeBiglietteria?: boolean;
    isNonMappato?: boolean;
    tipologie?: ServizioTipologiaInfo[] | null;
    hasMandatorySupplements?: boolean;
    tipologieDict?: { [key: string]: ServizioTipologiaInfo; } | null;
    ordine?: number;
    itinerari?: ServizioItinerario[] | null;
    itinerariTour?: ServizioItinerarioInfo[] | null;
    isAssicurazione?: boolean;
    isAssicurazioneSanitariaFacoltativa?: boolean;
    isVariazione?: boolean;
    isTasseVolo?: boolean;
    isCamper?: boolean;
    isMoto?: boolean;
    isTrasferimento?: boolean;
    isVisita?: boolean;
    isCrociera?: boolean;
    isQuoteApertura?: boolean;
    isBloccaPrezzo?: boolean;
    isCommissioneAgenziaSuBiglietteria?: boolean;
    isDirittiAgenzia?: boolean;
    tipoServizio?: ETipoServizioFlags;
    moltiplicatoreServizio?: number;
    accordi?: ServizioAccordoInfo[] | null;
    validita?: Validita[] | null;
    regoleServizio?: ServizioRegola[] | null;
    regoleServizioDict?: { [key: string]: ServizioRegola; } | null;
    regoleVendita?: ServizioRegolaVendita[] | null;
    regoleVenditaDict?: { [key: string]: ServizioRegolaVendita; } | null;
    costi?: CostoInfo[] | null;
    partenzeDict?: { [key: string]: Partenza; } | null;
    partenze?: Partenza[] | null;
    luoghi?: ServizioLuogo[] | null;
    associazioni?: ServizioAssociazioneInfo[] | null;
    associazioniOfferteComponibili?: ServizioAssociazioneInfo[] | null;
    giornaliero?: boolean;
    stelle?: number | null;
    escludiDaAutofill?: boolean;
    vicinoAeroporto?: boolean;
    haAttributiTestata?: boolean;
    haAttributiNoleggio?: boolean;
    attributiNoleggio?: ServizioDatoAggiuntivoInfo[] | null;
    haCategoria?: boolean;
    haNuovo?: boolean;
    haVantaggi?: boolean;
    haServizi?: boolean;
    datoAggiuntivoPenale?: ServizioDatoAggiuntivoInfo | null;
    aPartireDa?: number | null;
    isViaggiDelClub?: boolean;
    offerDestination?: DatoAggiuntivo | null;
    offerteDestinationCodice?: string | null;
    offerteDestinationNome?: string | null;
    offertaAPartireDa?: string | null;
    isOffertaViaggio?: boolean;
    servDatiAggiuntivi?: ServizioDatoAggiuntivoInfo[] | null;
    datiAggiuntiviPenaleDefault?: ServizioDatoAggiuntivoInfo[] | null;
    prezzi?: PrezzoOfferta[] | null;
    isSpecialOffert?: boolean;
    rangeValiditaCosti?: ServizioValiditaCosti | null;
    mappa?: Mappa | null;
    sunto?: ArticoloInfo | null;
    articoli?: ArticoloInfo[] | null;
    articoliGiorni?: ArticoloInfo[] | null;
    srtNome_it?: string | null;
    srtNome_en?: string | null;
    srtNome_fr?: string | null;
    srtNome_de?: string | null;
    traduzioni?: IWebTranslationEntity[] | null;
    nome?: string | null;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;

    constructor(data?: IServizioInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["_Prezzi"])) {
                this._Prezzi = [] as any;
                for (let item of _data["_Prezzi"])
                    this._Prezzi!.push(PrezzoOfferta.fromJS(item));
            }
            else {
                this._Prezzi = <any>null;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : <any>null;
            this.servizio = _data["servizio"] ? Servizio.fromJS(_data["servizio"]) : <any>null;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.contattoFornitore = _data["contattoFornitore"] ? ContattoInfo.fromJS(_data["contattoFornitore"]) : <any>null;
            this.nomeFornitore = _data["nomeFornitore"] !== undefined ? _data["nomeFornitore"] : <any>null;
            this.srtNomeFornitore = _data["srtNomeFornitore"] !== undefined ? _data["srtNomeFornitore"] : <any>null;
            if (Array.isArray(_data["templateAssociati"])) {
                this.templateAssociati = [] as any;
                for (let item of _data["templateAssociati"])
                    this.templateAssociati!.push(PacchettoInfo.fromJS(item));
            }
            else {
                this.templateAssociati = <any>null;
            }
            if (Array.isArray(_data["regoleScontoPacchetto"])) {
                this.regoleScontoPacchetto = [] as any;
                for (let item of _data["regoleScontoPacchetto"])
                    this.regoleScontoPacchetto!.push(ServizioRegolaScontoPacchetto.fromJS(item));
            }
            else {
                this.regoleScontoPacchetto = <any>null;
            }
            this.deltaMargine = _data["deltaMargine"] !== undefined ? _data["deltaMargine"] : <any>null;
            if (Array.isArray(_data["immagini"])) {
                this.immagini = [] as any;
                for (let item of _data["immagini"])
                    this.immagini!.push(ImmagineInfo.fromJS(item));
            }
            else {
                this.immagini = <any>null;
            }
            this.coverImage = _data["coverImage"] !== undefined ? _data["coverImage"] : <any>null;
            this.isObsoleto = _data["isObsoleto"] !== undefined ? _data["isObsoleto"] : <any>null;
            this.isVolo = _data["isVolo"] !== undefined ? _data["isVolo"] : <any>null;
            this.isBookingFeeBiglietteria = _data["isBookingFeeBiglietteria"] !== undefined ? _data["isBookingFeeBiglietteria"] : <any>null;
            this.isNonMappato = _data["isNonMappato"] !== undefined ? _data["isNonMappato"] : <any>null;
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(ServizioTipologiaInfo.fromJS(item));
            }
            else {
                this.tipologie = <any>null;
            }
            this.hasMandatorySupplements = _data["hasMandatorySupplements"] !== undefined ? _data["hasMandatorySupplements"] : <any>null;
            if (_data["tipologieDict"]) {
                this.tipologieDict = {} as any;
                for (let key in _data["tipologieDict"]) {
                    if (_data["tipologieDict"].hasOwnProperty(key))
                        (<any>this.tipologieDict)![key] = _data["tipologieDict"][key] ? ServizioTipologiaInfo.fromJS(_data["tipologieDict"][key]) : new ServizioTipologiaInfo();
                }
            }
            else {
                this.tipologieDict = <any>null;
            }
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            if (Array.isArray(_data["itinerari"])) {
                this.itinerari = [] as any;
                for (let item of _data["itinerari"])
                    this.itinerari!.push(ServizioItinerario.fromJS(item));
            }
            else {
                this.itinerari = <any>null;
            }
            if (Array.isArray(_data["itinerariTour"])) {
                this.itinerariTour = [] as any;
                for (let item of _data["itinerariTour"])
                    this.itinerariTour!.push(ServizioItinerarioInfo.fromJS(item));
            }
            else {
                this.itinerariTour = <any>null;
            }
            this.isAssicurazione = _data["isAssicurazione"] !== undefined ? _data["isAssicurazione"] : <any>null;
            this.isAssicurazioneSanitariaFacoltativa = _data["isAssicurazioneSanitariaFacoltativa"] !== undefined ? _data["isAssicurazioneSanitariaFacoltativa"] : <any>null;
            this.isVariazione = _data["isVariazione"] !== undefined ? _data["isVariazione"] : <any>null;
            this.isTasseVolo = _data["isTasseVolo"] !== undefined ? _data["isTasseVolo"] : <any>null;
            this.isCamper = _data["isCamper"] !== undefined ? _data["isCamper"] : <any>null;
            this.isMoto = _data["isMoto"] !== undefined ? _data["isMoto"] : <any>null;
            this.isTrasferimento = _data["isTrasferimento"] !== undefined ? _data["isTrasferimento"] : <any>null;
            this.isVisita = _data["isVisita"] !== undefined ? _data["isVisita"] : <any>null;
            this.isCrociera = _data["isCrociera"] !== undefined ? _data["isCrociera"] : <any>null;
            this.isQuoteApertura = _data["isQuoteApertura"] !== undefined ? _data["isQuoteApertura"] : <any>null;
            this.isBloccaPrezzo = _data["isBloccaPrezzo"] !== undefined ? _data["isBloccaPrezzo"] : <any>null;
            this.isCommissioneAgenziaSuBiglietteria = _data["isCommissioneAgenziaSuBiglietteria"] !== undefined ? _data["isCommissioneAgenziaSuBiglietteria"] : <any>null;
            this.isDirittiAgenzia = _data["isDirittiAgenzia"] !== undefined ? _data["isDirittiAgenzia"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.moltiplicatoreServizio = _data["moltiplicatoreServizio"] !== undefined ? _data["moltiplicatoreServizio"] : <any>null;
            if (Array.isArray(_data["accordi"])) {
                this.accordi = [] as any;
                for (let item of _data["accordi"])
                    this.accordi!.push(ServizioAccordoInfo.fromJS(item));
            }
            else {
                this.accordi = <any>null;
            }
            if (Array.isArray(_data["validita"])) {
                this.validita = [] as any;
                for (let item of _data["validita"])
                    this.validita!.push(Validita.fromJS(item));
            }
            else {
                this.validita = <any>null;
            }
            if (Array.isArray(_data["regoleServizio"])) {
                this.regoleServizio = [] as any;
                for (let item of _data["regoleServizio"])
                    this.regoleServizio!.push(ServizioRegola.fromJS(item));
            }
            else {
                this.regoleServizio = <any>null;
            }
            if (_data["regoleServizioDict"]) {
                this.regoleServizioDict = {} as any;
                for (let key in _data["regoleServizioDict"]) {
                    if (_data["regoleServizioDict"].hasOwnProperty(key))
                        (<any>this.regoleServizioDict)![key] = _data["regoleServizioDict"][key] ? ServizioRegola.fromJS(_data["regoleServizioDict"][key]) : new ServizioRegola();
                }
            }
            else {
                this.regoleServizioDict = <any>null;
            }
            if (Array.isArray(_data["regoleVendita"])) {
                this.regoleVendita = [] as any;
                for (let item of _data["regoleVendita"])
                    this.regoleVendita!.push(ServizioRegolaVendita.fromJS(item));
            }
            else {
                this.regoleVendita = <any>null;
            }
            if (_data["regoleVenditaDict"]) {
                this.regoleVenditaDict = {} as any;
                for (let key in _data["regoleVenditaDict"]) {
                    if (_data["regoleVenditaDict"].hasOwnProperty(key))
                        (<any>this.regoleVenditaDict)![key] = _data["regoleVenditaDict"][key] ? ServizioRegolaVendita.fromJS(_data["regoleVenditaDict"][key]) : new ServizioRegolaVendita();
                }
            }
            else {
                this.regoleVenditaDict = <any>null;
            }
            if (Array.isArray(_data["costi"])) {
                this.costi = [] as any;
                for (let item of _data["costi"])
                    this.costi!.push(CostoInfo.fromJS(item));
            }
            else {
                this.costi = <any>null;
            }
            if (_data["partenzeDict"]) {
                this.partenzeDict = {} as any;
                for (let key in _data["partenzeDict"]) {
                    if (_data["partenzeDict"].hasOwnProperty(key))
                        (<any>this.partenzeDict)![key] = _data["partenzeDict"][key] ? Partenza.fromJS(_data["partenzeDict"][key]) : new Partenza();
                }
            }
            else {
                this.partenzeDict = <any>null;
            }
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(Partenza.fromJS(item));
            }
            else {
                this.partenze = <any>null;
            }
            if (Array.isArray(_data["luoghi"])) {
                this.luoghi = [] as any;
                for (let item of _data["luoghi"])
                    this.luoghi!.push(ServizioLuogo.fromJS(item));
            }
            else {
                this.luoghi = <any>null;
            }
            if (Array.isArray(_data["associazioni"])) {
                this.associazioni = [] as any;
                for (let item of _data["associazioni"])
                    this.associazioni!.push(ServizioAssociazioneInfo.fromJS(item));
            }
            else {
                this.associazioni = <any>null;
            }
            if (Array.isArray(_data["associazioniOfferteComponibili"])) {
                this.associazioniOfferteComponibili = [] as any;
                for (let item of _data["associazioniOfferteComponibili"])
                    this.associazioniOfferteComponibili!.push(ServizioAssociazioneInfo.fromJS(item));
            }
            else {
                this.associazioniOfferteComponibili = <any>null;
            }
            this.giornaliero = _data["giornaliero"] !== undefined ? _data["giornaliero"] : <any>null;
            this.stelle = _data["stelle"] !== undefined ? _data["stelle"] : <any>null;
            this.escludiDaAutofill = _data["escludiDaAutofill"] !== undefined ? _data["escludiDaAutofill"] : <any>null;
            this.vicinoAeroporto = _data["vicinoAeroporto"] !== undefined ? _data["vicinoAeroporto"] : <any>null;
            this.haAttributiTestata = _data["haAttributiTestata"] !== undefined ? _data["haAttributiTestata"] : <any>null;
            this.haAttributiNoleggio = _data["haAttributiNoleggio"] !== undefined ? _data["haAttributiNoleggio"] : <any>null;
            if (Array.isArray(_data["attributiNoleggio"])) {
                this.attributiNoleggio = [] as any;
                for (let item of _data["attributiNoleggio"])
                    this.attributiNoleggio!.push(ServizioDatoAggiuntivoInfo.fromJS(item));
            }
            else {
                this.attributiNoleggio = <any>null;
            }
            this.haCategoria = _data["haCategoria"] !== undefined ? _data["haCategoria"] : <any>null;
            this.haNuovo = _data["haNuovo"] !== undefined ? _data["haNuovo"] : <any>null;
            this.haVantaggi = _data["haVantaggi"] !== undefined ? _data["haVantaggi"] : <any>null;
            this.haServizi = _data["haServizi"] !== undefined ? _data["haServizi"] : <any>null;
            this.datoAggiuntivoPenale = _data["datoAggiuntivoPenale"] ? ServizioDatoAggiuntivoInfo.fromJS(_data["datoAggiuntivoPenale"]) : <any>null;
            this.aPartireDa = _data["aPartireDa"] !== undefined ? _data["aPartireDa"] : <any>null;
            this.isViaggiDelClub = _data["isViaggiDelClub"] !== undefined ? _data["isViaggiDelClub"] : <any>null;
            this.offerDestination = _data["offerDestination"] ? DatoAggiuntivo.fromJS(_data["offerDestination"]) : <any>null;
            this.offerteDestinationCodice = _data["offerteDestinationCodice"] !== undefined ? _data["offerteDestinationCodice"] : <any>null;
            this.offerteDestinationNome = _data["offerteDestinationNome"] !== undefined ? _data["offerteDestinationNome"] : <any>null;
            this.offertaAPartireDa = _data["offertaAPartireDa"] !== undefined ? _data["offertaAPartireDa"] : <any>null;
            this.isOffertaViaggio = _data["isOffertaViaggio"] !== undefined ? _data["isOffertaViaggio"] : <any>null;
            if (Array.isArray(_data["servDatiAggiuntivi"])) {
                this.servDatiAggiuntivi = [] as any;
                for (let item of _data["servDatiAggiuntivi"])
                    this.servDatiAggiuntivi!.push(ServizioDatoAggiuntivoInfo.fromJS(item));
            }
            else {
                this.servDatiAggiuntivi = <any>null;
            }
            if (Array.isArray(_data["datiAggiuntiviPenaleDefault"])) {
                this.datiAggiuntiviPenaleDefault = [] as any;
                for (let item of _data["datiAggiuntiviPenaleDefault"])
                    this.datiAggiuntiviPenaleDefault!.push(ServizioDatoAggiuntivoInfo.fromJS(item));
            }
            else {
                this.datiAggiuntiviPenaleDefault = <any>null;
            }
            if (Array.isArray(_data["prezzi"])) {
                this.prezzi = [] as any;
                for (let item of _data["prezzi"])
                    this.prezzi!.push(PrezzoOfferta.fromJS(item));
            }
            else {
                this.prezzi = <any>null;
            }
            this.isSpecialOffert = _data["isSpecialOffert"] !== undefined ? _data["isSpecialOffert"] : <any>null;
            this.rangeValiditaCosti = _data["rangeValiditaCosti"] ? ServizioValiditaCosti.fromJS(_data["rangeValiditaCosti"]) : <any>null;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : <any>null;
            this.sunto = _data["sunto"] ? ArticoloInfo.fromJS(_data["sunto"]) : <any>null;
            if (Array.isArray(_data["articoli"])) {
                this.articoli = [] as any;
                for (let item of _data["articoli"])
                    this.articoli!.push(ArticoloInfo.fromJS(item));
            }
            else {
                this.articoli = <any>null;
            }
            if (Array.isArray(_data["articoliGiorni"])) {
                this.articoliGiorni = [] as any;
                for (let item of _data["articoliGiorni"])
                    this.articoliGiorni!.push(ArticoloInfo.fromJS(item));
            }
            else {
                this.articoliGiorni = <any>null;
            }
            this.srtNome_it = _data["srtNome_it"] !== undefined ? _data["srtNome_it"] : <any>null;
            this.srtNome_en = _data["srtNome_en"] !== undefined ? _data["srtNome_en"] : <any>null;
            this.srtNome_fr = _data["srtNome_fr"] !== undefined ? _data["srtNome_fr"] : <any>null;
            this.srtNome_de = _data["srtNome_de"] !== undefined ? _data["srtNome_de"] : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this._Prezzi)) {
            data["_Prezzi"] = [];
            for (let item of this._Prezzi)
                data["_Prezzi"].push(item.toJSON());
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["contattoFornitore"] = this.contattoFornitore ? this.contattoFornitore.toJSON() : <any>null;
        data["nomeFornitore"] = this.nomeFornitore !== undefined ? this.nomeFornitore : <any>null;
        data["srtNomeFornitore"] = this.srtNomeFornitore !== undefined ? this.srtNomeFornitore : <any>null;
        if (Array.isArray(this.templateAssociati)) {
            data["templateAssociati"] = [];
            for (let item of this.templateAssociati)
                data["templateAssociati"].push(item.toJSON());
        }
        if (Array.isArray(this.regoleScontoPacchetto)) {
            data["regoleScontoPacchetto"] = [];
            for (let item of this.regoleScontoPacchetto)
                data["regoleScontoPacchetto"].push(item.toJSON());
        }
        data["deltaMargine"] = this.deltaMargine !== undefined ? this.deltaMargine : <any>null;
        if (Array.isArray(this.immagini)) {
            data["immagini"] = [];
            for (let item of this.immagini)
                data["immagini"].push(item.toJSON());
        }
        data["coverImage"] = this.coverImage !== undefined ? this.coverImage : <any>null;
        data["isObsoleto"] = this.isObsoleto !== undefined ? this.isObsoleto : <any>null;
        data["isVolo"] = this.isVolo !== undefined ? this.isVolo : <any>null;
        data["isBookingFeeBiglietteria"] = this.isBookingFeeBiglietteria !== undefined ? this.isBookingFeeBiglietteria : <any>null;
        data["isNonMappato"] = this.isNonMappato !== undefined ? this.isNonMappato : <any>null;
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item.toJSON());
        }
        data["hasMandatorySupplements"] = this.hasMandatorySupplements !== undefined ? this.hasMandatorySupplements : <any>null;
        if (this.tipologieDict) {
            data["tipologieDict"] = {};
            for (let key in this.tipologieDict) {
                if (this.tipologieDict.hasOwnProperty(key))
                    (<any>data["tipologieDict"])[key] = this.tipologieDict[key] ? this.tipologieDict[key].toJSON() : <any>null;
            }
        }
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        if (Array.isArray(this.itinerari)) {
            data["itinerari"] = [];
            for (let item of this.itinerari)
                data["itinerari"].push(item.toJSON());
        }
        if (Array.isArray(this.itinerariTour)) {
            data["itinerariTour"] = [];
            for (let item of this.itinerariTour)
                data["itinerariTour"].push(item.toJSON());
        }
        data["isAssicurazione"] = this.isAssicurazione !== undefined ? this.isAssicurazione : <any>null;
        data["isAssicurazioneSanitariaFacoltativa"] = this.isAssicurazioneSanitariaFacoltativa !== undefined ? this.isAssicurazioneSanitariaFacoltativa : <any>null;
        data["isVariazione"] = this.isVariazione !== undefined ? this.isVariazione : <any>null;
        data["isTasseVolo"] = this.isTasseVolo !== undefined ? this.isTasseVolo : <any>null;
        data["isCamper"] = this.isCamper !== undefined ? this.isCamper : <any>null;
        data["isMoto"] = this.isMoto !== undefined ? this.isMoto : <any>null;
        data["isTrasferimento"] = this.isTrasferimento !== undefined ? this.isTrasferimento : <any>null;
        data["isVisita"] = this.isVisita !== undefined ? this.isVisita : <any>null;
        data["isCrociera"] = this.isCrociera !== undefined ? this.isCrociera : <any>null;
        data["isQuoteApertura"] = this.isQuoteApertura !== undefined ? this.isQuoteApertura : <any>null;
        data["isBloccaPrezzo"] = this.isBloccaPrezzo !== undefined ? this.isBloccaPrezzo : <any>null;
        data["isCommissioneAgenziaSuBiglietteria"] = this.isCommissioneAgenziaSuBiglietteria !== undefined ? this.isCommissioneAgenziaSuBiglietteria : <any>null;
        data["isDirittiAgenzia"] = this.isDirittiAgenzia !== undefined ? this.isDirittiAgenzia : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["moltiplicatoreServizio"] = this.moltiplicatoreServizio !== undefined ? this.moltiplicatoreServizio : <any>null;
        if (Array.isArray(this.accordi)) {
            data["accordi"] = [];
            for (let item of this.accordi)
                data["accordi"].push(item.toJSON());
        }
        if (Array.isArray(this.validita)) {
            data["validita"] = [];
            for (let item of this.validita)
                data["validita"].push(item.toJSON());
        }
        if (Array.isArray(this.regoleServizio)) {
            data["regoleServizio"] = [];
            for (let item of this.regoleServizio)
                data["regoleServizio"].push(item.toJSON());
        }
        if (this.regoleServizioDict) {
            data["regoleServizioDict"] = {};
            for (let key in this.regoleServizioDict) {
                if (this.regoleServizioDict.hasOwnProperty(key))
                    (<any>data["regoleServizioDict"])[key] = this.regoleServizioDict[key] ? this.regoleServizioDict[key].toJSON() : <any>null;
            }
        }
        if (Array.isArray(this.regoleVendita)) {
            data["regoleVendita"] = [];
            for (let item of this.regoleVendita)
                data["regoleVendita"].push(item.toJSON());
        }
        if (this.regoleVenditaDict) {
            data["regoleVenditaDict"] = {};
            for (let key in this.regoleVenditaDict) {
                if (this.regoleVenditaDict.hasOwnProperty(key))
                    (<any>data["regoleVenditaDict"])[key] = this.regoleVenditaDict[key] ? this.regoleVenditaDict[key].toJSON() : <any>null;
            }
        }
        if (Array.isArray(this.costi)) {
            data["costi"] = [];
            for (let item of this.costi)
                data["costi"].push(item.toJSON());
        }
        if (this.partenzeDict) {
            data["partenzeDict"] = {};
            for (let key in this.partenzeDict) {
                if (this.partenzeDict.hasOwnProperty(key))
                    (<any>data["partenzeDict"])[key] = this.partenzeDict[key] ? this.partenzeDict[key].toJSON() : <any>null;
            }
        }
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item.toJSON());
        }
        if (Array.isArray(this.luoghi)) {
            data["luoghi"] = [];
            for (let item of this.luoghi)
                data["luoghi"].push(item.toJSON());
        }
        if (Array.isArray(this.associazioni)) {
            data["associazioni"] = [];
            for (let item of this.associazioni)
                data["associazioni"].push(item.toJSON());
        }
        if (Array.isArray(this.associazioniOfferteComponibili)) {
            data["associazioniOfferteComponibili"] = [];
            for (let item of this.associazioniOfferteComponibili)
                data["associazioniOfferteComponibili"].push(item.toJSON());
        }
        data["giornaliero"] = this.giornaliero !== undefined ? this.giornaliero : <any>null;
        data["stelle"] = this.stelle !== undefined ? this.stelle : <any>null;
        data["escludiDaAutofill"] = this.escludiDaAutofill !== undefined ? this.escludiDaAutofill : <any>null;
        data["vicinoAeroporto"] = this.vicinoAeroporto !== undefined ? this.vicinoAeroporto : <any>null;
        data["haAttributiTestata"] = this.haAttributiTestata !== undefined ? this.haAttributiTestata : <any>null;
        data["haAttributiNoleggio"] = this.haAttributiNoleggio !== undefined ? this.haAttributiNoleggio : <any>null;
        if (Array.isArray(this.attributiNoleggio)) {
            data["attributiNoleggio"] = [];
            for (let item of this.attributiNoleggio)
                data["attributiNoleggio"].push(item.toJSON());
        }
        data["haCategoria"] = this.haCategoria !== undefined ? this.haCategoria : <any>null;
        data["haNuovo"] = this.haNuovo !== undefined ? this.haNuovo : <any>null;
        data["haVantaggi"] = this.haVantaggi !== undefined ? this.haVantaggi : <any>null;
        data["haServizi"] = this.haServizi !== undefined ? this.haServizi : <any>null;
        data["datoAggiuntivoPenale"] = this.datoAggiuntivoPenale ? this.datoAggiuntivoPenale.toJSON() : <any>null;
        data["aPartireDa"] = this.aPartireDa !== undefined ? this.aPartireDa : <any>null;
        data["isViaggiDelClub"] = this.isViaggiDelClub !== undefined ? this.isViaggiDelClub : <any>null;
        data["offerDestination"] = this.offerDestination ? this.offerDestination.toJSON() : <any>null;
        data["offerteDestinationCodice"] = this.offerteDestinationCodice !== undefined ? this.offerteDestinationCodice : <any>null;
        data["offerteDestinationNome"] = this.offerteDestinationNome !== undefined ? this.offerteDestinationNome : <any>null;
        data["offertaAPartireDa"] = this.offertaAPartireDa !== undefined ? this.offertaAPartireDa : <any>null;
        data["isOffertaViaggio"] = this.isOffertaViaggio !== undefined ? this.isOffertaViaggio : <any>null;
        if (Array.isArray(this.servDatiAggiuntivi)) {
            data["servDatiAggiuntivi"] = [];
            for (let item of this.servDatiAggiuntivi)
                data["servDatiAggiuntivi"].push(item.toJSON());
        }
        if (Array.isArray(this.datiAggiuntiviPenaleDefault)) {
            data["datiAggiuntiviPenaleDefault"] = [];
            for (let item of this.datiAggiuntiviPenaleDefault)
                data["datiAggiuntiviPenaleDefault"].push(item.toJSON());
        }
        if (Array.isArray(this.prezzi)) {
            data["prezzi"] = [];
            for (let item of this.prezzi)
                data["prezzi"].push(item.toJSON());
        }
        data["isSpecialOffert"] = this.isSpecialOffert !== undefined ? this.isSpecialOffert : <any>null;
        data["rangeValiditaCosti"] = this.rangeValiditaCosti ? this.rangeValiditaCosti.toJSON() : <any>null;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : <any>null;
        data["sunto"] = this.sunto ? this.sunto.toJSON() : <any>null;
        if (Array.isArray(this.articoli)) {
            data["articoli"] = [];
            for (let item of this.articoli)
                data["articoli"].push(item.toJSON());
        }
        if (Array.isArray(this.articoliGiorni)) {
            data["articoliGiorni"] = [];
            for (let item of this.articoliGiorni)
                data["articoliGiorni"].push(item.toJSON());
        }
        data["srtNome_it"] = this.srtNome_it !== undefined ? this.srtNome_it : <any>null;
        data["srtNome_en"] = this.srtNome_en !== undefined ? this.srtNome_en : <any>null;
        data["srtNome_fr"] = this.srtNome_fr !== undefined ? this.srtNome_fr : <any>null;
        data["srtNome_de"] = this.srtNome_de !== undefined ? this.srtNome_de : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioInfo extends IServizioInfoBase {
    _Prezzi?: PrezzoOfferta[] | null;
    id?: number;
    table?: string | null;
    uniqueID?: string | null;
    servizio?: Servizio | null;
    eliminato?: boolean;
    luogoID?: number;
    contattoFornitore?: ContattoInfo | null;
    nomeFornitore?: string | null;
    srtNomeFornitore?: string | null;
    templateAssociati?: PacchettoInfo[] | null;
    regoleScontoPacchetto?: ServizioRegolaScontoPacchetto[] | null;
    deltaMargine?: number;
    immagini?: ImmagineInfo[] | null;
    coverImage?: string | null;
    isObsoleto?: boolean;
    isVolo?: boolean;
    isBookingFeeBiglietteria?: boolean;
    isNonMappato?: boolean;
    tipologie?: ServizioTipologiaInfo[] | null;
    hasMandatorySupplements?: boolean;
    tipologieDict?: { [key: string]: ServizioTipologiaInfo; } | null;
    ordine?: number;
    itinerari?: ServizioItinerario[] | null;
    itinerariTour?: ServizioItinerarioInfo[] | null;
    isAssicurazione?: boolean;
    isAssicurazioneSanitariaFacoltativa?: boolean;
    isVariazione?: boolean;
    isTasseVolo?: boolean;
    isCamper?: boolean;
    isMoto?: boolean;
    isTrasferimento?: boolean;
    isVisita?: boolean;
    isCrociera?: boolean;
    isQuoteApertura?: boolean;
    isBloccaPrezzo?: boolean;
    isCommissioneAgenziaSuBiglietteria?: boolean;
    isDirittiAgenzia?: boolean;
    tipoServizio?: ETipoServizioFlags;
    moltiplicatoreServizio?: number;
    accordi?: ServizioAccordoInfo[] | null;
    validita?: Validita[] | null;
    regoleServizio?: ServizioRegola[] | null;
    regoleServizioDict?: { [key: string]: ServizioRegola; } | null;
    regoleVendita?: ServizioRegolaVendita[] | null;
    regoleVenditaDict?: { [key: string]: ServizioRegolaVendita; } | null;
    costi?: CostoInfo[] | null;
    partenzeDict?: { [key: string]: Partenza; } | null;
    partenze?: Partenza[] | null;
    luoghi?: ServizioLuogo[] | null;
    associazioni?: ServizioAssociazioneInfo[] | null;
    associazioniOfferteComponibili?: ServizioAssociazioneInfo[] | null;
    giornaliero?: boolean;
    stelle?: number | null;
    escludiDaAutofill?: boolean;
    vicinoAeroporto?: boolean;
    haAttributiTestata?: boolean;
    haAttributiNoleggio?: boolean;
    attributiNoleggio?: ServizioDatoAggiuntivoInfo[] | null;
    haCategoria?: boolean;
    haNuovo?: boolean;
    haVantaggi?: boolean;
    haServizi?: boolean;
    datoAggiuntivoPenale?: ServizioDatoAggiuntivoInfo | null;
    aPartireDa?: number | null;
    isViaggiDelClub?: boolean;
    offerDestination?: DatoAggiuntivo | null;
    offerteDestinationCodice?: string | null;
    offerteDestinationNome?: string | null;
    offertaAPartireDa?: string | null;
    isOffertaViaggio?: boolean;
    servDatiAggiuntivi?: ServizioDatoAggiuntivoInfo[] | null;
    datiAggiuntiviPenaleDefault?: ServizioDatoAggiuntivoInfo[] | null;
    prezzi?: PrezzoOfferta[] | null;
    isSpecialOffert?: boolean;
    rangeValiditaCosti?: ServizioValiditaCosti | null;
    mappa?: Mappa | null;
    sunto?: ArticoloInfo | null;
    articoli?: ArticoloInfo[] | null;
    articoliGiorni?: ArticoloInfo[] | null;
    srtNome_it?: string | null;
    srtNome_en?: string | null;
    srtNome_fr?: string | null;
    srtNome_de?: string | null;
    traduzioni?: IWebTranslationEntity[] | null;
    nome?: string | null;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
}

export class PrezzoOfferta implements IPrezzoOfferta {
    id?: number;
    offertaID?: number;
    data?: string;
    modalitaData?: EModalitaDataPrezzo;
    prezzoPersonaLand?: number;
    prezzoPersonaVoli?: number;
    aggiornato?: string | null;
    frequenzaAggiornamentoGiorni?: number | null;
    manuale?: boolean;
    prossimoCheck?: string | null;
    errore?: boolean;
    includiVoli?: boolean;

    constructor(data?: IPrezzoOfferta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.modalitaData = _data["modalitaData"] !== undefined ? _data["modalitaData"] : <any>null;
            this.prezzoPersonaLand = _data["prezzoPersonaLand"] !== undefined ? _data["prezzoPersonaLand"] : <any>null;
            this.prezzoPersonaVoli = _data["prezzoPersonaVoli"] !== undefined ? _data["prezzoPersonaVoli"] : <any>null;
            this.aggiornato = _data["aggiornato"] !== undefined ? _data["aggiornato"] : <any>null;
            this.frequenzaAggiornamentoGiorni = _data["frequenzaAggiornamentoGiorni"] !== undefined ? _data["frequenzaAggiornamentoGiorni"] : <any>null;
            this.manuale = _data["manuale"] !== undefined ? _data["manuale"] : <any>null;
            this.prossimoCheck = _data["prossimoCheck"] !== undefined ? _data["prossimoCheck"] : <any>null;
            this.errore = _data["errore"] !== undefined ? _data["errore"] : <any>null;
            this.includiVoli = _data["includiVoli"] !== undefined ? _data["includiVoli"] : <any>null;
        }
    }

    static fromJS(data: any): PrezzoOfferta {
        data = typeof data === 'object' ? data : {};
        let result = new PrezzoOfferta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["modalitaData"] = this.modalitaData !== undefined ? this.modalitaData : <any>null;
        data["prezzoPersonaLand"] = this.prezzoPersonaLand !== undefined ? this.prezzoPersonaLand : <any>null;
        data["prezzoPersonaVoli"] = this.prezzoPersonaVoli !== undefined ? this.prezzoPersonaVoli : <any>null;
        data["aggiornato"] = this.aggiornato !== undefined ? this.aggiornato : <any>null;
        data["frequenzaAggiornamentoGiorni"] = this.frequenzaAggiornamentoGiorni !== undefined ? this.frequenzaAggiornamentoGiorni : <any>null;
        data["manuale"] = this.manuale !== undefined ? this.manuale : <any>null;
        data["prossimoCheck"] = this.prossimoCheck !== undefined ? this.prossimoCheck : <any>null;
        data["errore"] = this.errore !== undefined ? this.errore : <any>null;
        data["includiVoli"] = this.includiVoli !== undefined ? this.includiVoli : <any>null;
        return data;
    }
}

export interface IPrezzoOfferta {
    id?: number;
    offertaID?: number;
    data?: string;
    modalitaData?: EModalitaDataPrezzo;
    prezzoPersonaLand?: number;
    prezzoPersonaVoli?: number;
    aggiornato?: string | null;
    frequenzaAggiornamentoGiorni?: number | null;
    manuale?: boolean;
    prossimoCheck?: string | null;
    errore?: boolean;
    includiVoli?: boolean;
}

export enum EModalitaDataPrezzo {
    DataEsatta = "DataEsatta",
    Mese = "Mese",
}

export class PacchettoInfo implements IPacchettoInfo {
    id?: number;
    offerta?: Offerta | null;
    tappe?: PacchettoTappaInfo[] | null;
    notti?: number;
    prezzi?: PrezzoOfferta[] | null;
    giorni?: number;
    destinazione?: LuogoInfo | null;

    constructor(data?: IPacchettoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.offerta = _data["offerta"] ? Offerta.fromJS(_data["offerta"]) : <any>null;
            if (Array.isArray(_data["tappe"])) {
                this.tappe = [] as any;
                for (let item of _data["tappe"])
                    this.tappe!.push(PacchettoTappaInfo.fromJS(item));
            }
            else {
                this.tappe = <any>null;
            }
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            if (Array.isArray(_data["prezzi"])) {
                this.prezzi = [] as any;
                for (let item of _data["prezzi"])
                    this.prezzi!.push(PrezzoOfferta.fromJS(item));
            }
            else {
                this.prezzi = <any>null;
            }
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : <any>null;
            this.destinazione = _data["destinazione"] ? LuogoInfo.fromJS(_data["destinazione"]) : <any>null;
        }
    }

    static fromJS(data: any): PacchettoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PacchettoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        if (Array.isArray(this.tappe)) {
            data["tappe"] = [];
            for (let item of this.tappe)
                data["tappe"].push(item.toJSON());
        }
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        if (Array.isArray(this.prezzi)) {
            data["prezzi"] = [];
            for (let item of this.prezzi)
                data["prezzi"].push(item.toJSON());
        }
        data["giorni"] = this.giorni !== undefined ? this.giorni : <any>null;
        data["destinazione"] = this.destinazione ? this.destinazione.toJSON() : <any>null;
        return data;
    }
}

export interface IPacchettoInfo {
    id?: number;
    offerta?: Offerta | null;
    tappe?: PacchettoTappaInfo[] | null;
    notti?: number;
    prezzi?: PrezzoOfferta[] | null;
    giorni?: number;
    destinazione?: LuogoInfo | null;
}

export class PacchettoTappaInfo implements IPacchettoTappaInfo {
    id?: number;
    tappa?: OffertaItinerario | null;
    luogo?: LuogoInfo | null;
    servizi?: PacchettoServizioInfo[] | null;
    hasHotel?: boolean;
    servizioHotelTappa?: ServizioInfo | null;
    contattoHotelTappaID?: number | null;

    constructor(data?: IPacchettoTappaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tappa = _data["tappa"] ? OffertaItinerario.fromJS(_data["tappa"]) : <any>null;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : <any>null;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(PacchettoServizioInfo.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
            this.hasHotel = _data["hasHotel"] !== undefined ? _data["hasHotel"] : <any>null;
            this.servizioHotelTappa = _data["servizioHotelTappa"] ? ServizioInfo.fromJS(_data["servizioHotelTappa"]) : <any>null;
            this.contattoHotelTappaID = _data["contattoHotelTappaID"] !== undefined ? _data["contattoHotelTappaID"] : <any>null;
        }
    }

    static fromJS(data: any): PacchettoTappaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PacchettoTappaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tappa"] = this.tappa ? this.tappa.toJSON() : <any>null;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        data["hasHotel"] = this.hasHotel !== undefined ? this.hasHotel : <any>null;
        data["servizioHotelTappa"] = this.servizioHotelTappa ? this.servizioHotelTappa.toJSON() : <any>null;
        data["contattoHotelTappaID"] = this.contattoHotelTappaID !== undefined ? this.contattoHotelTappaID : <any>null;
        return data;
    }
}

export interface IPacchettoTappaInfo {
    id?: number;
    tappa?: OffertaItinerario | null;
    luogo?: LuogoInfo | null;
    servizi?: PacchettoServizioInfo[] | null;
    hasHotel?: boolean;
    servizioHotelTappa?: ServizioInfo | null;
    contattoHotelTappaID?: number | null;
}

export class PacchettoServizioInfo implements IPacchettoServizioInfo {
    id?: number;
    riga?: OffertaDato | null;
    servizio?: ServizioInfo | null;

    constructor(data?: IPacchettoServizioInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : <any>null;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : <any>null;
        }
    }

    static fromJS(data: any): PacchettoServizioInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PacchettoServizioInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["riga"] = this.riga ? this.riga.toJSON() : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        return data;
    }
}

export interface IPacchettoServizioInfo {
    id?: number;
    riga?: OffertaDato | null;
    servizio?: ServizioInfo | null;
}

export class ServizioRegolaScontoPacchetto implements IServizioRegolaScontoPacchetto {
    id?: number;
    servizioID?: number;
    itinerarioID?: number | null;
    servizioScontoID?: number | null;
    prenotaDal?: string | null;
    prenotaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    scontoServiziTerra?: number;
    scontoQuote?: number;
    scontoBloccaPrezzo?: number;
    nome?: string | null;
    ordine?: number;

    constructor(data?: IServizioRegolaScontoPacchetto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : <any>null;
            this.servizioScontoID = _data["servizioScontoID"] !== undefined ? _data["servizioScontoID"] : <any>null;
            this.prenotaDal = _data["prenotaDal"] !== undefined ? _data["prenotaDal"] : <any>null;
            this.prenotaAl = _data["prenotaAl"] !== undefined ? _data["prenotaAl"] : <any>null;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
            this.scontoServiziTerra = _data["scontoServiziTerra"] !== undefined ? _data["scontoServiziTerra"] : <any>null;
            this.scontoQuote = _data["scontoQuote"] !== undefined ? _data["scontoQuote"] : <any>null;
            this.scontoBloccaPrezzo = _data["scontoBloccaPrezzo"] !== undefined ? _data["scontoBloccaPrezzo"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioRegolaScontoPacchetto {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioRegolaScontoPacchetto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : <any>null;
        data["servizioScontoID"] = this.servizioScontoID !== undefined ? this.servizioScontoID : <any>null;
        data["prenotaDal"] = this.prenotaDal !== undefined ? this.prenotaDal : <any>null;
        data["prenotaAl"] = this.prenotaAl !== undefined ? this.prenotaAl : <any>null;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        data["scontoServiziTerra"] = this.scontoServiziTerra !== undefined ? this.scontoServiziTerra : <any>null;
        data["scontoQuote"] = this.scontoQuote !== undefined ? this.scontoQuote : <any>null;
        data["scontoBloccaPrezzo"] = this.scontoBloccaPrezzo !== undefined ? this.scontoBloccaPrezzo : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        return data;
    }
}

export interface IServizioRegolaScontoPacchetto {
    id?: number;
    servizioID?: number;
    itinerarioID?: number | null;
    servizioScontoID?: number | null;
    prenotaDal?: string | null;
    prenotaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    scontoServiziTerra?: number;
    scontoQuote?: number;
    scontoBloccaPrezzo?: number;
    nome?: string | null;
    ordine?: number;
}

export class ImmagineInfo implements IImmagineInfo {
    id?: number;
    immagine?: Immagine;
    eliminata?: boolean;
    servizio?: ServizioInfo | null;
    luogo?: LuogoInfo | null;
    articolo?: ArticoloInfo | null;
    linkedFile?: FileInfoBase;
    thumbnails?: ThumbnailData[] | null;

    constructor(data?: IImmagineInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.immagine = _data["immagine"] ? Immagine.fromJS(_data["immagine"]) : <any>null;
            this.eliminata = _data["eliminata"] !== undefined ? _data["eliminata"] : <any>null;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : <any>null;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : <any>null;
            this.articolo = _data["articolo"] ? ArticoloInfo.fromJS(_data["articolo"]) : <any>null;
            this.linkedFile = _data["linkedFile"] ? FileInfoBase.fromJS(_data["linkedFile"]) : <any>null;
            if (Array.isArray(_data["thumbnails"])) {
                this.thumbnails = [] as any;
                for (let item of _data["thumbnails"])
                    this.thumbnails!.push(ThumbnailData.fromJS(item));
            }
            else {
                this.thumbnails = <any>null;
            }
        }
    }

    static fromJS(data: any): ImmagineInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ImmagineInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["immagine"] = this.immagine ? this.immagine.toJSON() : <any>null;
        data["eliminata"] = this.eliminata !== undefined ? this.eliminata : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        data["articolo"] = this.articolo ? this.articolo.toJSON() : <any>null;
        data["linkedFile"] = this.linkedFile ? this.linkedFile.toJSON() : <any>null;
        if (Array.isArray(this.thumbnails)) {
            data["thumbnails"] = [];
            for (let item of this.thumbnails)
                data["thumbnails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImmagineInfo {
    id?: number;
    immagine?: Immagine;
    eliminata?: boolean;
    servizio?: ServizioInfo | null;
    luogo?: LuogoInfo | null;
    articolo?: ArticoloInfo | null;
    linkedFile?: FileInfoBase;
    thumbnails?: ThumbnailData[] | null;
}

export class Immagine implements IImmagine {
    immagineID?: number;
    luogoID?: number | null;
    servizioID?: number | null;
    articoloID?: number | null;
    ordine?: number | null;
    nomeImmagine?: string | null;
    dataModifica?: string;
    pathWeb?: string | null;
    pathThumb?: string | null;
    pathOriginal?: string | null;
    nome_it?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    elaborata?: boolean;
    sorgente?: ESorgenteImmagine;
    idSorgente?: string | null;
    programma?: boolean | null;
    sitoWeb?: boolean | null;
    preventivo?: boolean | null;
    miniGuida?: boolean | null;
    hash?: string | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    storge?: EStorage;

    constructor(data?: IImmagine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.immagineID = _data["immagineID"] !== undefined ? _data["immagineID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.nomeImmagine = _data["nomeImmagine"] !== undefined ? _data["nomeImmagine"] : <any>null;
            this.dataModifica = _data["dataModifica"] !== undefined ? _data["dataModifica"] : <any>null;
            this.pathWeb = _data["pathWeb"] !== undefined ? _data["pathWeb"] : <any>null;
            this.pathThumb = _data["pathThumb"] !== undefined ? _data["pathThumb"] : <any>null;
            this.pathOriginal = _data["pathOriginal"] !== undefined ? _data["pathOriginal"] : <any>null;
            this.nome_it = _data["nome_it"] !== undefined ? _data["nome_it"] : <any>null;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : <any>null;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : <any>null;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.elaborata = _data["elaborata"] !== undefined ? _data["elaborata"] : <any>null;
            this.sorgente = _data["sorgente"] !== undefined ? _data["sorgente"] : <any>null;
            this.idSorgente = _data["idSorgente"] !== undefined ? _data["idSorgente"] : <any>null;
            this.programma = _data["programma"] !== undefined ? _data["programma"] : <any>null;
            this.sitoWeb = _data["sitoWeb"] !== undefined ? _data["sitoWeb"] : <any>null;
            this.preventivo = _data["preventivo"] !== undefined ? _data["preventivo"] : <any>null;
            this.miniGuida = _data["miniGuida"] !== undefined ? _data["miniGuida"] : <any>null;
            this.hash = _data["hash"] !== undefined ? _data["hash"] : <any>null;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
            this.deletedAt = _data["deletedAt"] !== undefined ? _data["deletedAt"] : <any>null;
            this.storge = _data["storge"] !== undefined ? _data["storge"] : <any>null;
        }
    }

    static fromJS(data: any): Immagine {
        data = typeof data === 'object' ? data : {};
        let result = new Immagine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["immagineID"] = this.immagineID !== undefined ? this.immagineID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["nomeImmagine"] = this.nomeImmagine !== undefined ? this.nomeImmagine : <any>null;
        data["dataModifica"] = this.dataModifica !== undefined ? this.dataModifica : <any>null;
        data["pathWeb"] = this.pathWeb !== undefined ? this.pathWeb : <any>null;
        data["pathThumb"] = this.pathThumb !== undefined ? this.pathThumb : <any>null;
        data["pathOriginal"] = this.pathOriginal !== undefined ? this.pathOriginal : <any>null;
        data["nome_it"] = this.nome_it !== undefined ? this.nome_it : <any>null;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : <any>null;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : <any>null;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["elaborata"] = this.elaborata !== undefined ? this.elaborata : <any>null;
        data["sorgente"] = this.sorgente !== undefined ? this.sorgente : <any>null;
        data["idSorgente"] = this.idSorgente !== undefined ? this.idSorgente : <any>null;
        data["programma"] = this.programma !== undefined ? this.programma : <any>null;
        data["sitoWeb"] = this.sitoWeb !== undefined ? this.sitoWeb : <any>null;
        data["preventivo"] = this.preventivo !== undefined ? this.preventivo : <any>null;
        data["miniGuida"] = this.miniGuida !== undefined ? this.miniGuida : <any>null;
        data["hash"] = this.hash !== undefined ? this.hash : <any>null;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        data["deletedAt"] = this.deletedAt !== undefined ? this.deletedAt : <any>null;
        data["storge"] = this.storge !== undefined ? this.storge : <any>null;
        return data;
    }
}

export interface IImmagine {
    immagineID?: number;
    luogoID?: number | null;
    servizioID?: number | null;
    articoloID?: number | null;
    ordine?: number | null;
    nomeImmagine?: string | null;
    dataModifica?: string;
    pathWeb?: string | null;
    pathThumb?: string | null;
    pathOriginal?: string | null;
    nome_it?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    elaborata?: boolean;
    sorgente?: ESorgenteImmagine;
    idSorgente?: string | null;
    programma?: boolean | null;
    sitoWeb?: boolean | null;
    preventivo?: boolean | null;
    miniGuida?: boolean | null;
    hash?: string | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    storge?: EStorage;
}

export enum ESorgenteImmagine {
    Ignota = "Ignota",
    Pixabay = "Pixabay",
}

export abstract class FileInfoBase implements IFileInfoBase {
    extension?: string;
    contentType?: string;
    isPdf?: boolean;
    canGetAsPdf?: boolean;

    constructor(data?: IFileInfoBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extension = _data["extension"] !== undefined ? _data["extension"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
            this.isPdf = _data["isPdf"] !== undefined ? _data["isPdf"] : <any>null;
            this.canGetAsPdf = _data["canGetAsPdf"] !== undefined ? _data["canGetAsPdf"] : <any>null;
        }
    }

    static fromJS(data: any): FileInfoBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FileInfoBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extension"] = this.extension !== undefined ? this.extension : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        data["isPdf"] = this.isPdf !== undefined ? this.isPdf : <any>null;
        data["canGetAsPdf"] = this.canGetAsPdf !== undefined ? this.canGetAsPdf : <any>null;
        return data;
    }
}

export interface IFileInfoBase {
    extension?: string;
    contentType?: string;
    isPdf?: boolean;
    canGetAsPdf?: boolean;
}

export class ServizioTipologiaInfo implements IServizioTipologiaInfo {
    id?: number;
    tipologia?: ServizioTipologia | null;
    templateAssociati?: PacchettoInfo[] | null;
    isSupplemento?: boolean;
    isObbligatorio?: boolean;
    prezzoMinimo?: number | null;
    aPartireDa?: PrezzoMin[] | null;
    nomeNormalized?: string | null;
    tipologiaStandard?: ServizioTipologiaStandardInfo | null;
    itinerario?: ServizioItinerarioInfo | null;
    richiedeCreazioneItinerario?: boolean;
    supplementoRiduzione?: ESupplementoRiduzione;
    orarioInizio?: OreMinuti | null;
    orarioFine?: OreMinuti | null;

    constructor(data?: IServizioTipologiaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : <any>null;
            if (Array.isArray(_data["templateAssociati"])) {
                this.templateAssociati = [] as any;
                for (let item of _data["templateAssociati"])
                    this.templateAssociati!.push(PacchettoInfo.fromJS(item));
            }
            else {
                this.templateAssociati = <any>null;
            }
            this.isSupplemento = _data["isSupplemento"] !== undefined ? _data["isSupplemento"] : <any>null;
            this.isObbligatorio = _data["isObbligatorio"] !== undefined ? _data["isObbligatorio"] : <any>null;
            this.prezzoMinimo = _data["prezzoMinimo"] !== undefined ? _data["prezzoMinimo"] : <any>null;
            if (Array.isArray(_data["aPartireDa"])) {
                this.aPartireDa = [] as any;
                for (let item of _data["aPartireDa"])
                    this.aPartireDa!.push(PrezzoMin.fromJS(item));
            }
            else {
                this.aPartireDa = <any>null;
            }
            this.nomeNormalized = _data["nomeNormalized"] !== undefined ? _data["nomeNormalized"] : <any>null;
            this.tipologiaStandard = _data["tipologiaStandard"] ? ServizioTipologiaStandardInfo.fromJS(_data["tipologiaStandard"]) : <any>null;
            this.itinerario = _data["itinerario"] ? ServizioItinerarioInfo.fromJS(_data["itinerario"]) : <any>null;
            this.richiedeCreazioneItinerario = _data["richiedeCreazioneItinerario"] !== undefined ? _data["richiedeCreazioneItinerario"] : <any>null;
            this.supplementoRiduzione = _data["supplementoRiduzione"] !== undefined ? _data["supplementoRiduzione"] : <any>null;
            this.orarioInizio = _data["orarioInizio"] ? OreMinuti.fromJS(_data["orarioInizio"]) : <any>null;
            this.orarioFine = _data["orarioFine"] ? OreMinuti.fromJS(_data["orarioFine"]) : <any>null;
        }
    }

    static fromJS(data: any): ServizioTipologiaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioTipologiaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : <any>null;
        if (Array.isArray(this.templateAssociati)) {
            data["templateAssociati"] = [];
            for (let item of this.templateAssociati)
                data["templateAssociati"].push(item.toJSON());
        }
        data["isSupplemento"] = this.isSupplemento !== undefined ? this.isSupplemento : <any>null;
        data["isObbligatorio"] = this.isObbligatorio !== undefined ? this.isObbligatorio : <any>null;
        data["prezzoMinimo"] = this.prezzoMinimo !== undefined ? this.prezzoMinimo : <any>null;
        if (Array.isArray(this.aPartireDa)) {
            data["aPartireDa"] = [];
            for (let item of this.aPartireDa)
                data["aPartireDa"].push(item.toJSON());
        }
        data["nomeNormalized"] = this.nomeNormalized !== undefined ? this.nomeNormalized : <any>null;
        data["tipologiaStandard"] = this.tipologiaStandard ? this.tipologiaStandard.toJSON() : <any>null;
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : <any>null;
        data["richiedeCreazioneItinerario"] = this.richiedeCreazioneItinerario !== undefined ? this.richiedeCreazioneItinerario : <any>null;
        data["supplementoRiduzione"] = this.supplementoRiduzione !== undefined ? this.supplementoRiduzione : <any>null;
        data["orarioInizio"] = this.orarioInizio ? this.orarioInizio.toJSON() : <any>null;
        data["orarioFine"] = this.orarioFine ? this.orarioFine.toJSON() : <any>null;
        return data;
    }
}

export interface IServizioTipologiaInfo {
    id?: number;
    tipologia?: ServizioTipologia | null;
    templateAssociati?: PacchettoInfo[] | null;
    isSupplemento?: boolean;
    isObbligatorio?: boolean;
    prezzoMinimo?: number | null;
    aPartireDa?: PrezzoMin[] | null;
    nomeNormalized?: string | null;
    tipologiaStandard?: ServizioTipologiaStandardInfo | null;
    itinerario?: ServizioItinerarioInfo | null;
    richiedeCreazioneItinerario?: boolean;
    supplementoRiduzione?: ESupplementoRiduzione;
    orarioInizio?: OreMinuti | null;
    orarioFine?: OreMinuti | null;
}

export abstract class ServizioTipologiaBase implements IServizioTipologiaBase {
    servizioTipologiaID?: number;
    servizioID?: number;
    tipologiaStandardID?: number | null;
    paramsJson?: string | null;
    orarioInizio?: string | null;
    puntoInizio?: string | null;
    orarioFine?: string | null;
    puntoFine?: string | null;
    tipoSupplemento?: ETipoSupplemento | null;
    supplementoRiduzione?: ESupplementoRiduzione | null;

    constructor(data?: IServizioTipologiaBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.tipologiaStandardID = _data["tipologiaStandardID"] !== undefined ? _data["tipologiaStandardID"] : <any>null;
            this.paramsJson = _data["paramsJson"] !== undefined ? _data["paramsJson"] : <any>null;
            this.orarioInizio = _data["orarioInizio"] !== undefined ? _data["orarioInizio"] : <any>null;
            this.puntoInizio = _data["puntoInizio"] !== undefined ? _data["puntoInizio"] : <any>null;
            this.orarioFine = _data["orarioFine"] !== undefined ? _data["orarioFine"] : <any>null;
            this.puntoFine = _data["puntoFine"] !== undefined ? _data["puntoFine"] : <any>null;
            this.tipoSupplemento = _data["tipoSupplemento"] !== undefined ? _data["tipoSupplemento"] : <any>null;
            this.supplementoRiduzione = _data["supplementoRiduzione"] !== undefined ? _data["supplementoRiduzione"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioTipologiaBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioTipologiaBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["tipologiaStandardID"] = this.tipologiaStandardID !== undefined ? this.tipologiaStandardID : <any>null;
        data["paramsJson"] = this.paramsJson !== undefined ? this.paramsJson : <any>null;
        data["orarioInizio"] = this.orarioInizio !== undefined ? this.orarioInizio : <any>null;
        data["puntoInizio"] = this.puntoInizio !== undefined ? this.puntoInizio : <any>null;
        data["orarioFine"] = this.orarioFine !== undefined ? this.orarioFine : <any>null;
        data["puntoFine"] = this.puntoFine !== undefined ? this.puntoFine : <any>null;
        data["tipoSupplemento"] = this.tipoSupplemento !== undefined ? this.tipoSupplemento : <any>null;
        data["supplementoRiduzione"] = this.supplementoRiduzione !== undefined ? this.supplementoRiduzione : <any>null;
        return data;
    }
}

export interface IServizioTipologiaBase {
    servizioTipologiaID?: number;
    servizioID?: number;
    tipologiaStandardID?: number | null;
    paramsJson?: string | null;
    orarioInizio?: string | null;
    puntoInizio?: string | null;
    orarioFine?: string | null;
    puntoFine?: string | null;
    tipoSupplemento?: ETipoSupplemento | null;
    supplementoRiduzione?: ESupplementoRiduzione | null;
}

export class ServizioTipologia extends ServizioTipologiaBase implements IServizioTipologia {
    contattoVoucherID?: number | null;
    nome?: string | null;
    nomeVoucher?: string | null;
    nomeSecondario?: string | null;
    nomeSecondarioVoucher?: string | null;
    verificaPartenze?: boolean;
    supplementoPercentuale?: boolean | null;
    itinerarioID?: number | null;
    ordine?: number | null;
    obbligatorio?: EObbligatorieta | null;
    alternativa?: number | null;
    interno?: boolean | null;
    costoPerPersona?: boolean;
    costoPerGiorno?: boolean | null;
    supplementoSuRichiesta?: boolean | null;
    selezionePax?: boolean | null;
    condividi?: boolean | null;
    memo?: string | null;
    contattoInizioID?: number | null;
    contattoInizio?: Contatto | null;
    contattoFineID?: number | null;
    contattoFine?: Contatto | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    deleted?: string | null;
    regolaPacchettoID?: number | null;
    languages?: ELingua[] | null;
    tipoTipologia?: ETipoSupplemento;

    constructor(data?: IServizioTipologia) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contattoVoucherID = _data["contattoVoucherID"] !== undefined ? _data["contattoVoucherID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeVoucher = _data["nomeVoucher"] !== undefined ? _data["nomeVoucher"] : <any>null;
            this.nomeSecondario = _data["nomeSecondario"] !== undefined ? _data["nomeSecondario"] : <any>null;
            this.nomeSecondarioVoucher = _data["nomeSecondarioVoucher"] !== undefined ? _data["nomeSecondarioVoucher"] : <any>null;
            this.verificaPartenze = _data["verificaPartenze"] !== undefined ? _data["verificaPartenze"] : <any>null;
            this.supplementoPercentuale = _data["supplementoPercentuale"] !== undefined ? _data["supplementoPercentuale"] : <any>null;
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.obbligatorio = _data["obbligatorio"] !== undefined ? _data["obbligatorio"] : <any>null;
            this.alternativa = _data["alternativa"] !== undefined ? _data["alternativa"] : <any>null;
            this.interno = _data["interno"] !== undefined ? _data["interno"] : <any>null;
            this.costoPerPersona = _data["costoPerPersona"] !== undefined ? _data["costoPerPersona"] : <any>null;
            this.costoPerGiorno = _data["costoPerGiorno"] !== undefined ? _data["costoPerGiorno"] : <any>null;
            this.supplementoSuRichiesta = _data["supplementoSuRichiesta"] !== undefined ? _data["supplementoSuRichiesta"] : <any>null;
            this.selezionePax = _data["selezionePax"] !== undefined ? _data["selezionePax"] : <any>null;
            this.condividi = _data["condividi"] !== undefined ? _data["condividi"] : <any>null;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : <any>null;
            this.contattoInizioID = _data["contattoInizioID"] !== undefined ? _data["contattoInizioID"] : <any>null;
            this.contattoInizio = _data["contattoInizio"] ? Contatto.fromJS(_data["contattoInizio"]) : <any>null;
            this.contattoFineID = _data["contattoFineID"] !== undefined ? _data["contattoFineID"] : <any>null;
            this.contattoFine = _data["contattoFine"] ? Contatto.fromJS(_data["contattoFine"]) : <any>null;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : <any>null;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : <any>null;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
            this.regolaPacchettoID = _data["regolaPacchettoID"] !== undefined ? _data["regolaPacchettoID"] : <any>null;
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            else {
                this.languages = <any>null;
            }
            this.tipoTipologia = _data["tipoTipologia"] !== undefined ? _data["tipoTipologia"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioTipologia {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioTipologia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoVoucherID"] = this.contattoVoucherID !== undefined ? this.contattoVoucherID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeVoucher"] = this.nomeVoucher !== undefined ? this.nomeVoucher : <any>null;
        data["nomeSecondario"] = this.nomeSecondario !== undefined ? this.nomeSecondario : <any>null;
        data["nomeSecondarioVoucher"] = this.nomeSecondarioVoucher !== undefined ? this.nomeSecondarioVoucher : <any>null;
        data["verificaPartenze"] = this.verificaPartenze !== undefined ? this.verificaPartenze : <any>null;
        data["supplementoPercentuale"] = this.supplementoPercentuale !== undefined ? this.supplementoPercentuale : <any>null;
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["obbligatorio"] = this.obbligatorio !== undefined ? this.obbligatorio : <any>null;
        data["alternativa"] = this.alternativa !== undefined ? this.alternativa : <any>null;
        data["interno"] = this.interno !== undefined ? this.interno : <any>null;
        data["costoPerPersona"] = this.costoPerPersona !== undefined ? this.costoPerPersona : <any>null;
        data["costoPerGiorno"] = this.costoPerGiorno !== undefined ? this.costoPerGiorno : <any>null;
        data["supplementoSuRichiesta"] = this.supplementoSuRichiesta !== undefined ? this.supplementoSuRichiesta : <any>null;
        data["selezionePax"] = this.selezionePax !== undefined ? this.selezionePax : <any>null;
        data["condividi"] = this.condividi !== undefined ? this.condividi : <any>null;
        data["memo"] = this.memo !== undefined ? this.memo : <any>null;
        data["contattoInizioID"] = this.contattoInizioID !== undefined ? this.contattoInizioID : <any>null;
        data["contattoInizio"] = this.contattoInizio ? this.contattoInizio.toJSON() : <any>null;
        data["contattoFineID"] = this.contattoFineID !== undefined ? this.contattoFineID : <any>null;
        data["contattoFine"] = this.contattoFine ? this.contattoFine.toJSON() : <any>null;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : <any>null;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : <any>null;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        data["regolaPacchettoID"] = this.regolaPacchettoID !== undefined ? this.regolaPacchettoID : <any>null;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["tipoTipologia"] = this.tipoTipologia !== undefined ? this.tipoTipologia : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioTipologia extends IServizioTipologiaBase {
    contattoVoucherID?: number | null;
    nome?: string | null;
    nomeVoucher?: string | null;
    nomeSecondario?: string | null;
    nomeSecondarioVoucher?: string | null;
    verificaPartenze?: boolean;
    supplementoPercentuale?: boolean | null;
    itinerarioID?: number | null;
    ordine?: number | null;
    obbligatorio?: EObbligatorieta | null;
    alternativa?: number | null;
    interno?: boolean | null;
    costoPerPersona?: boolean;
    costoPerGiorno?: boolean | null;
    supplementoSuRichiesta?: boolean | null;
    selezionePax?: boolean | null;
    condividi?: boolean | null;
    memo?: string | null;
    contattoInizioID?: number | null;
    contattoInizio?: Contatto | null;
    contattoFineID?: number | null;
    contattoFine?: Contatto | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    deleted?: string | null;
    regolaPacchettoID?: number | null;
    languages?: ELingua[] | null;
    tipoTipologia?: ETipoSupplemento;
}

export enum EObbligatorieta {
    Facoltativo = "Facoltativo",
    Obbligatorio = "Obbligatorio",
}

export enum ETipoSupplemento {
    Nessuno = "Nessuno",
    Ignoto = "Ignoto",
    OfferteRid = "OfferteRid",
    Pasti = "Pasti",
    Camera = "Camera",
    Trasferimenti = "Trasferimenti",
    Visite = "Visite",
    Appartamento = "Appartamento",
    LettoAggiunto = "LettoAggiunto",
    Supplemento = "Supplemento",
}

export enum ESupplementoRiduzione {
    Nessuno = "Nessuno",
    Supplemento = "Supplemento",
    Riduzione = "Riduzione",
    DaPagareInLoco = "DaPagareInLoco",
    GratisDaPrenotare = "GratisDaPrenotare",
}

export class PrezzoMin implements IPrezzoMin {
    servizioID?: number;
    servizioTipologiaID?: number;
    trattamentoID?: number | null;
    prezzoMinimo?: number;

    constructor(data?: IPrezzoMin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
            this.prezzoMinimo = _data["prezzoMinimo"] !== undefined ? _data["prezzoMinimo"] : <any>null;
        }
    }

    static fromJS(data: any): PrezzoMin {
        data = typeof data === 'object' ? data : {};
        let result = new PrezzoMin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        data["prezzoMinimo"] = this.prezzoMinimo !== undefined ? this.prezzoMinimo : <any>null;
        return data;
    }
}

export interface IPrezzoMin {
    servizioID?: number;
    servizioTipologiaID?: number;
    trattamentoID?: number | null;
    prezzoMinimo?: number;
}

export class ServizioTipologiaStandardInfo implements IServizioTipologiaStandardInfo {
    id?: number;
    tipologiaStandard?: ServizioTipologiaStandard | null;
    traduzioni?: IWebTranslationEntity[] | null;
    nome?: string | null;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string | null;

    constructor(data?: IServizioTipologiaStandardInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tipologiaStandard = _data["tipologiaStandard"] ? ServizioTipologiaStandard.fromJS(_data["tipologiaStandard"]) : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioTipologiaStandardInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioTipologiaStandardInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tipologiaStandard"] = this.tipologiaStandard ? this.tipologiaStandard.toJSON() : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        return data;
    }
}

export interface IServizioTipologiaStandardInfo {
    id?: number;
    tipologiaStandard?: ServizioTipologiaStandard | null;
    traduzioni?: IWebTranslationEntity[] | null;
    nome?: string | null;
    nome_en?: string | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string | null;
}

export abstract class IWebTranslationEntity implements IIWebTranslationEntity {
    id?: number;
    table?: string;
    entityID?: number;
    lang?: ELingua;
    culture?: string | null;
    translation?: string;
    lastUpdate?: string | null;
    confirmed?: boolean | null;

    constructor(data?: IIWebTranslationEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
            this.entityID = _data["entityID"] !== undefined ? _data["entityID"] : <any>null;
            this.lang = _data["lang"] !== undefined ? _data["lang"] : <any>null;
            this.culture = _data["culture"] !== undefined ? _data["culture"] : <any>null;
            this.translation = _data["translation"] !== undefined ? _data["translation"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
        }
    }

    static fromJS(data: any): IWebTranslationEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IWebTranslationEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        data["entityID"] = this.entityID !== undefined ? this.entityID : <any>null;
        data["lang"] = this.lang !== undefined ? this.lang : <any>null;
        data["culture"] = this.culture !== undefined ? this.culture : <any>null;
        data["translation"] = this.translation !== undefined ? this.translation : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        return data;
    }
}

export interface IIWebTranslationEntity {
    id?: number;
    table?: string;
    entityID?: number;
    lang?: ELingua;
    culture?: string | null;
    translation?: string;
    lastUpdate?: string | null;
    confirmed?: boolean | null;
}

export class ServizioItinerarioInfo implements IServizioItinerarioInfo {
    id?: number;
    servizioItinerario?: ServizioItinerario | null;
    numeroGiorni?: number;
    numeroNotti?: number;
    giorni?: ServizioItinerarioGiornoInfo[] | null;
    origine?: string | null;
    destinazione?: string | null;
    compagniaAerea?: string | null;

    constructor(data?: IServizioItinerarioInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioItinerario = _data["servizioItinerario"] ? ServizioItinerario.fromJS(_data["servizioItinerario"]) : <any>null;
            this.numeroGiorni = _data["numeroGiorni"] !== undefined ? _data["numeroGiorni"] : <any>null;
            this.numeroNotti = _data["numeroNotti"] !== undefined ? _data["numeroNotti"] : <any>null;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(ServizioItinerarioGiornoInfo.fromJS(item));
            }
            else {
                this.giorni = <any>null;
            }
            this.origine = _data["origine"] !== undefined ? _data["origine"] : <any>null;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : <any>null;
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioItinerarioInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioItinerario"] = this.servizioItinerario ? this.servizioItinerario.toJSON() : <any>null;
        data["numeroGiorni"] = this.numeroGiorni !== undefined ? this.numeroGiorni : <any>null;
        data["numeroNotti"] = this.numeroNotti !== undefined ? this.numeroNotti : <any>null;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item.toJSON());
        }
        data["origine"] = this.origine !== undefined ? this.origine : <any>null;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : <any>null;
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : <any>null;
        return data;
    }
}

export interface IServizioItinerarioInfo {
    id?: number;
    servizioItinerario?: ServizioItinerario | null;
    numeroGiorni?: number;
    numeroNotti?: number;
    giorni?: ServizioItinerarioGiornoInfo[] | null;
    origine?: string | null;
    destinazione?: string | null;
    compagniaAerea?: string | null;
}

export class ServizioItinerario implements IServizioItinerario {
    itinerarioID?: number;
    servizioID?: number;
    nome!: string;
    memo?: string | null;
    origine?: string | null;
    destinazione?: string | null;
    compagniaAerea?: string | null;

    constructor(data?: IServizioItinerario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : <any>null;
            this.origine = _data["origine"] !== undefined ? _data["origine"] : <any>null;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : <any>null;
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioItinerario {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["memo"] = this.memo !== undefined ? this.memo : <any>null;
        data["origine"] = this.origine !== undefined ? this.origine : <any>null;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : <any>null;
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : <any>null;
        return data;
    }
}

export interface IServizioItinerario {
    itinerarioID?: number;
    servizioID?: number;
    nome: string;
    memo?: string | null;
    origine?: string | null;
    destinazione?: string | null;
    compagniaAerea?: string | null;
}

export class ServizioItinerarioGiornoInfo implements IServizioItinerarioGiornoInfo {
    id?: number;
    itinerarioGiorno?: ServizioItinerarioGiorno | null;
    luogo?: LuogoInfo | null;
    contattoHotel?: ContattoInfo | null;
    servizioHotel?: ServizioInfo | null;
    servizi?: ServizioItinerarioGiornoServizioInfo[] | null;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;

    constructor(data?: IServizioItinerarioGiornoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.itinerarioGiorno = _data["itinerarioGiorno"] ? ServizioItinerarioGiorno.fromJS(_data["itinerarioGiorno"]) : <any>null;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : <any>null;
            this.contattoHotel = _data["contattoHotel"] ? ContattoInfo.fromJS(_data["contattoHotel"]) : <any>null;
            this.servizioHotel = _data["servizioHotel"] ? ServizioInfo.fromJS(_data["servizioHotel"]) : <any>null;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioItinerarioGiornoServizioInfo.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : <any>null;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : <any>null;
            this.compagniaAerea2 = _data["compagniaAerea2"] !== undefined ? _data["compagniaAerea2"] : <any>null;
            this.classe2 = _data["classe2"] !== undefined ? _data["classe2"] : <any>null;
            this.cambioHotel = _data["cambioHotel"] !== undefined ? _data["cambioHotel"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioItinerarioGiornoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioGiornoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["itinerarioGiorno"] = this.itinerarioGiorno ? this.itinerarioGiorno.toJSON() : <any>null;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        data["contattoHotel"] = this.contattoHotel ? this.contattoHotel.toJSON() : <any>null;
        data["servizioHotel"] = this.servizioHotel ? this.servizioHotel.toJSON() : <any>null;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : <any>null;
        data["classe"] = this.classe !== undefined ? this.classe : <any>null;
        data["compagniaAerea2"] = this.compagniaAerea2 !== undefined ? this.compagniaAerea2 : <any>null;
        data["classe2"] = this.classe2 !== undefined ? this.classe2 : <any>null;
        data["cambioHotel"] = this.cambioHotel !== undefined ? this.cambioHotel : <any>null;
        return data;
    }
}

export interface IServizioItinerarioGiornoInfo {
    id?: number;
    itinerarioGiorno?: ServizioItinerarioGiorno | null;
    luogo?: LuogoInfo | null;
    contattoHotel?: ContattoInfo | null;
    servizioHotel?: ServizioInfo | null;
    servizi?: ServizioItinerarioGiornoServizioInfo[] | null;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;
}

export class ServizioItinerarioGiorno implements IServizioItinerarioGiorno {
    giornoID?: number;
    itinerarioID?: number;
    luogoID?: number;
    giorno?: number;
    ordine?: number | null;
    contattoHotelID?: number | null;
    durata?: number | null;
    trasporto?: ETipoTrasporto | null;
    noRicercaVoli?: boolean;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean | null;

    constructor(data?: IServizioItinerarioGiorno) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giornoID = _data["giornoID"] !== undefined ? _data["giornoID"] : <any>null;
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.contattoHotelID = _data["contattoHotelID"] !== undefined ? _data["contattoHotelID"] : <any>null;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : <any>null;
            this.trasporto = _data["trasporto"] !== undefined ? _data["trasporto"] : <any>null;
            this.noRicercaVoli = _data["noRicercaVoli"] !== undefined ? _data["noRicercaVoli"] : <any>null;
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : <any>null;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : <any>null;
            this.compagniaAerea2 = _data["compagniaAerea2"] !== undefined ? _data["compagniaAerea2"] : <any>null;
            this.classe2 = _data["classe2"] !== undefined ? _data["classe2"] : <any>null;
            this.cambioHotel = _data["cambioHotel"] !== undefined ? _data["cambioHotel"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioItinerarioGiorno {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioGiorno();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giornoID"] = this.giornoID !== undefined ? this.giornoID : <any>null;
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["contattoHotelID"] = this.contattoHotelID !== undefined ? this.contattoHotelID : <any>null;
        data["durata"] = this.durata !== undefined ? this.durata : <any>null;
        data["trasporto"] = this.trasporto !== undefined ? this.trasporto : <any>null;
        data["noRicercaVoli"] = this.noRicercaVoli !== undefined ? this.noRicercaVoli : <any>null;
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : <any>null;
        data["classe"] = this.classe !== undefined ? this.classe : <any>null;
        data["compagniaAerea2"] = this.compagniaAerea2 !== undefined ? this.compagniaAerea2 : <any>null;
        data["classe2"] = this.classe2 !== undefined ? this.classe2 : <any>null;
        data["cambioHotel"] = this.cambioHotel !== undefined ? this.cambioHotel : <any>null;
        return data;
    }
}

export interface IServizioItinerarioGiorno {
    giornoID?: number;
    itinerarioID?: number;
    luogoID?: number;
    giorno?: number;
    ordine?: number | null;
    contattoHotelID?: number | null;
    durata?: number | null;
    trasporto?: ETipoTrasporto | null;
    noRicercaVoli?: boolean;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean | null;
}

export class ServizioItinerarioGiornoServizioInfo implements IServizioItinerarioGiornoServizioInfo {
    id?: number;
    servizioItinerarioGiornoServizio?: ServizioItinerarioGiornoServizio | null;
    tipologiaBase?: ServizioTipologiaInfo | null;
    servizio?: ServizioInfo | null;
    tipologia?: ServizioTipologiaInfo | null;
    servizioGiorno?: ServizioInfo | null;
    tipologiaGiorno?: ServizioTipologiaInfo | null;
    posizioneServizio?: EPosizioneDefaultServizioGiorno;
    ordine?: number;

    constructor(data?: IServizioItinerarioGiornoServizioInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioItinerarioGiornoServizio = _data["servizioItinerarioGiornoServizio"] ? ServizioItinerarioGiornoServizio.fromJS(_data["servizioItinerarioGiornoServizio"]) : <any>null;
            this.tipologiaBase = _data["tipologiaBase"] ? ServizioTipologiaInfo.fromJS(_data["tipologiaBase"]) : <any>null;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : <any>null;
            this.tipologia = _data["tipologia"] ? ServizioTipologiaInfo.fromJS(_data["tipologia"]) : <any>null;
            this.servizioGiorno = _data["servizioGiorno"] ? ServizioInfo.fromJS(_data["servizioGiorno"]) : <any>null;
            this.tipologiaGiorno = _data["tipologiaGiorno"] ? ServizioTipologiaInfo.fromJS(_data["tipologiaGiorno"]) : <any>null;
            this.posizioneServizio = _data["posizioneServizio"] !== undefined ? _data["posizioneServizio"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioItinerarioGiornoServizioInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioGiornoServizioInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioItinerarioGiornoServizio"] = this.servizioItinerarioGiornoServizio ? this.servizioItinerarioGiornoServizio.toJSON() : <any>null;
        data["tipologiaBase"] = this.tipologiaBase ? this.tipologiaBase.toJSON() : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : <any>null;
        data["servizioGiorno"] = this.servizioGiorno ? this.servizioGiorno.toJSON() : <any>null;
        data["tipologiaGiorno"] = this.tipologiaGiorno ? this.tipologiaGiorno.toJSON() : <any>null;
        data["posizioneServizio"] = this.posizioneServizio !== undefined ? this.posizioneServizio : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        return data;
    }
}

export interface IServizioItinerarioGiornoServizioInfo {
    id?: number;
    servizioItinerarioGiornoServizio?: ServizioItinerarioGiornoServizio | null;
    tipologiaBase?: ServizioTipologiaInfo | null;
    servizio?: ServizioInfo | null;
    tipologia?: ServizioTipologiaInfo | null;
    servizioGiorno?: ServizioInfo | null;
    tipologiaGiorno?: ServizioTipologiaInfo | null;
    posizioneServizio?: EPosizioneDefaultServizioGiorno;
    ordine?: number;
}

export class ServizioItinerarioGiornoServizio implements IServizioItinerarioGiornoServizio {
    id?: number;
    servizioItinerarioGiornoID?: number;
    tipologiaBaseID?: number | null;
    servizioID?: number | null;
    tipologiaID?: number | null;
    giorno?: number;
    durata?: number;
    alternativa?: number | null;
    trattamentoID?: number | null;

    constructor(data?: IServizioItinerarioGiornoServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioItinerarioGiornoID = _data["servizioItinerarioGiornoID"] !== undefined ? _data["servizioItinerarioGiornoID"] : <any>null;
            this.tipologiaBaseID = _data["tipologiaBaseID"] !== undefined ? _data["tipologiaBaseID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : <any>null;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : <any>null;
            this.alternativa = _data["alternativa"] !== undefined ? _data["alternativa"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioItinerarioGiornoServizio {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioGiornoServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioItinerarioGiornoID"] = this.servizioItinerarioGiornoID !== undefined ? this.servizioItinerarioGiornoID : <any>null;
        data["tipologiaBaseID"] = this.tipologiaBaseID !== undefined ? this.tipologiaBaseID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : <any>null;
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["durata"] = this.durata !== undefined ? this.durata : <any>null;
        data["alternativa"] = this.alternativa !== undefined ? this.alternativa : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        return data;
    }
}

export interface IServizioItinerarioGiornoServizio {
    id?: number;
    servizioItinerarioGiornoID?: number;
    tipologiaBaseID?: number | null;
    servizioID?: number | null;
    tipologiaID?: number | null;
    giorno?: number;
    durata?: number;
    alternativa?: number | null;
    trattamentoID?: number | null;
}

export enum EPosizioneDefaultServizioGiorno {
    InizioTappa = "InizioTappa",
    FineTappa = "FineTappa",
    GiornoIndicato = "GiornoIndicato",
}

export class OreMinuti implements IOreMinuti {
    ore?: number;
    minuti?: number;

    constructor(data?: IOreMinuti) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ore = _data["ore"] !== undefined ? _data["ore"] : <any>null;
            this.minuti = _data["minuti"] !== undefined ? _data["minuti"] : <any>null;
        }
    }

    static fromJS(data: any): OreMinuti {
        data = typeof data === 'object' ? data : {};
        let result = new OreMinuti();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ore"] = this.ore !== undefined ? this.ore : <any>null;
        data["minuti"] = this.minuti !== undefined ? this.minuti : <any>null;
        return data;
    }
}

export interface IOreMinuti {
    ore?: number;
    minuti?: number;
}

export class ServizioAccordoInfo implements IServizioAccordoInfo {
    id?: number;
    servizioAccordo?: ServizioAccordo;
    accordo?: AccordoInfo | null;

    constructor(data?: IServizioAccordoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioAccordo = _data["servizioAccordo"] ? ServizioAccordo.fromJS(_data["servizioAccordo"]) : <any>null;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : <any>null;
        }
    }

    static fromJS(data: any): ServizioAccordoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAccordoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioAccordo"] = this.servizioAccordo ? this.servizioAccordo.toJSON() : <any>null;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : <any>null;
        return data;
    }
}

export interface IServizioAccordoInfo {
    id?: number;
    servizioAccordo?: ServizioAccordo;
    accordo?: AccordoInfo | null;
}

export class ServizioAccordo implements IServizioAccordo {
    servizioAccordoID?: number;
    servizioID?: number | null;
    accordoID?: number | null;

    constructor(data?: IServizioAccordo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioAccordoID = _data["servizioAccordoID"] !== undefined ? _data["servizioAccordoID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioAccordo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAccordo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAccordoID"] = this.servizioAccordoID !== undefined ? this.servizioAccordoID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        return data;
    }
}

export interface IServizioAccordo {
    servizioAccordoID?: number;
    servizioID?: number | null;
    accordoID?: number | null;
}

export class Validita implements IValidita {
    validitaID?: number;
    servizioID?: number;
    dal?: string;
    al?: string;
    giorni?: string | null;
    overAdv?: number | null;
    note?: string | null;
    prezziIndicativi?: boolean;

    constructor(data?: IValidita) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validitaID = _data["validitaID"] !== undefined ? _data["validitaID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : <any>null;
            this.overAdv = _data["overAdv"] !== undefined ? _data["overAdv"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.prezziIndicativi = _data["prezziIndicativi"] !== undefined ? _data["prezziIndicativi"] : <any>null;
        }
    }

    static fromJS(data: any): Validita {
        data = typeof data === 'object' ? data : {};
        let result = new Validita();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validitaID"] = this.validitaID !== undefined ? this.validitaID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["giorni"] = this.giorni !== undefined ? this.giorni : <any>null;
        data["overAdv"] = this.overAdv !== undefined ? this.overAdv : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["prezziIndicativi"] = this.prezziIndicativi !== undefined ? this.prezziIndicativi : <any>null;
        return data;
    }
}

export interface IValidita {
    validitaID?: number;
    servizioID?: number;
    dal?: string;
    al?: string;
    giorni?: string | null;
    overAdv?: number | null;
    note?: string | null;
    prezziIndicativi?: boolean;
}

export class ServizioRegola implements IServizioRegola {
    regolaServizioID?: number;
    servizioID?: number;
    nome?: string | null;
    costoPerGiorno?: boolean;
    costoPerPersona?: boolean;
    minPax?: number;
    maxPax?: number;
    maxPaxCamera?: number | null;
    maxAdulti?: number | null;
    maxChild?: number | null;
    etaInfant?: number | null;
    etaChildFree?: number | null;
    freeSale?: number | null;
    maxLettiAggiungibili?: number | null;

    constructor(data?: IServizioRegola) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regolaServizioID = _data["regolaServizioID"] !== undefined ? _data["regolaServizioID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.costoPerGiorno = _data["costoPerGiorno"] !== undefined ? _data["costoPerGiorno"] : <any>null;
            this.costoPerPersona = _data["costoPerPersona"] !== undefined ? _data["costoPerPersona"] : <any>null;
            this.minPax = _data["minPax"] !== undefined ? _data["minPax"] : <any>null;
            this.maxPax = _data["maxPax"] !== undefined ? _data["maxPax"] : <any>null;
            this.maxPaxCamera = _data["maxPaxCamera"] !== undefined ? _data["maxPaxCamera"] : <any>null;
            this.maxAdulti = _data["maxAdulti"] !== undefined ? _data["maxAdulti"] : <any>null;
            this.maxChild = _data["maxChild"] !== undefined ? _data["maxChild"] : <any>null;
            this.etaInfant = _data["etaInfant"] !== undefined ? _data["etaInfant"] : <any>null;
            this.etaChildFree = _data["etaChildFree"] !== undefined ? _data["etaChildFree"] : <any>null;
            this.freeSale = _data["freeSale"] !== undefined ? _data["freeSale"] : <any>null;
            this.maxLettiAggiungibili = _data["maxLettiAggiungibili"] !== undefined ? _data["maxLettiAggiungibili"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioRegola {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioRegola();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regolaServizioID"] = this.regolaServizioID !== undefined ? this.regolaServizioID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["costoPerGiorno"] = this.costoPerGiorno !== undefined ? this.costoPerGiorno : <any>null;
        data["costoPerPersona"] = this.costoPerPersona !== undefined ? this.costoPerPersona : <any>null;
        data["minPax"] = this.minPax !== undefined ? this.minPax : <any>null;
        data["maxPax"] = this.maxPax !== undefined ? this.maxPax : <any>null;
        data["maxPaxCamera"] = this.maxPaxCamera !== undefined ? this.maxPaxCamera : <any>null;
        data["maxAdulti"] = this.maxAdulti !== undefined ? this.maxAdulti : <any>null;
        data["maxChild"] = this.maxChild !== undefined ? this.maxChild : <any>null;
        data["etaInfant"] = this.etaInfant !== undefined ? this.etaInfant : <any>null;
        data["etaChildFree"] = this.etaChildFree !== undefined ? this.etaChildFree : <any>null;
        data["freeSale"] = this.freeSale !== undefined ? this.freeSale : <any>null;
        data["maxLettiAggiungibili"] = this.maxLettiAggiungibili !== undefined ? this.maxLettiAggiungibili : <any>null;
        return data;
    }
}

export interface IServizioRegola {
    regolaServizioID?: number;
    servizioID?: number;
    nome?: string | null;
    costoPerGiorno?: boolean;
    costoPerPersona?: boolean;
    minPax?: number;
    maxPax?: number;
    maxPaxCamera?: number | null;
    maxAdulti?: number | null;
    maxChild?: number | null;
    etaInfant?: number | null;
    etaChildFree?: number | null;
    freeSale?: number | null;
    maxLettiAggiungibili?: number | null;
}

export abstract class ServizioRegolaVenditaBase implements IServizioRegolaVenditaBase {
    id?: number;
    servizioID?: number;
    penaleID?: number | null;
    giorniPenale?: number | null;
    percentualePenale?: number | null;
    articoloID?: number | null;

    constructor(data?: IServizioRegolaVenditaBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : <any>null;
            this.giorniPenale = _data["giorniPenale"] !== undefined ? _data["giorniPenale"] : <any>null;
            this.percentualePenale = _data["percentualePenale"] !== undefined ? _data["percentualePenale"] : <any>null;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioRegolaVenditaBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioRegolaVenditaBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : <any>null;
        data["giorniPenale"] = this.giorniPenale !== undefined ? this.giorniPenale : <any>null;
        data["percentualePenale"] = this.percentualePenale !== undefined ? this.percentualePenale : <any>null;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        return data;
    }
}

export interface IServizioRegolaVenditaBase {
    id?: number;
    servizioID?: number;
    penaleID?: number | null;
    giorniPenale?: number | null;
    percentualePenale?: number | null;
    articoloID?: number | null;
}

export class ServizioRegolaVendita extends ServizioRegolaVenditaBase implements IServizioRegolaVendita {
    nome?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    numeroGiorni?: number | null;
    minimoGiorni?: number | null;
    massimoGiorni?: number | null;
    etaMinima?: number | null;
    etaMassima?: number | null;
    dal?: string | null;
    al?: string | null;
    commissioniAgenzia?: number | null;
    commissioniTourOperator?: number | null;
    minimoNottiPeriodo?: number | null;
    giorniEntrata?: string | null;
    giorniUscita?: string | null;
    prenotaEntroData?: string | null;
    prenotaEntroGiorni?: number | null;
    deregolamentaSuRichiesta?: boolean | null;
    articolo?: Articolo | null;

    constructor(data?: IServizioRegolaVendita) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : <any>null;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : <any>null;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.numeroGiorni = _data["numeroGiorni"] !== undefined ? _data["numeroGiorni"] : <any>null;
            this.minimoGiorni = _data["minimoGiorni"] !== undefined ? _data["minimoGiorni"] : <any>null;
            this.massimoGiorni = _data["massimoGiorni"] !== undefined ? _data["massimoGiorni"] : <any>null;
            this.etaMinima = _data["etaMinima"] !== undefined ? _data["etaMinima"] : <any>null;
            this.etaMassima = _data["etaMassima"] !== undefined ? _data["etaMassima"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.commissioniAgenzia = _data["commissioniAgenzia"] !== undefined ? _data["commissioniAgenzia"] : <any>null;
            this.commissioniTourOperator = _data["commissioniTourOperator"] !== undefined ? _data["commissioniTourOperator"] : <any>null;
            this.minimoNottiPeriodo = _data["minimoNottiPeriodo"] !== undefined ? _data["minimoNottiPeriodo"] : <any>null;
            this.giorniEntrata = _data["giorniEntrata"] !== undefined ? _data["giorniEntrata"] : <any>null;
            this.giorniUscita = _data["giorniUscita"] !== undefined ? _data["giorniUscita"] : <any>null;
            this.prenotaEntroData = _data["prenotaEntroData"] !== undefined ? _data["prenotaEntroData"] : <any>null;
            this.prenotaEntroGiorni = _data["prenotaEntroGiorni"] !== undefined ? _data["prenotaEntroGiorni"] : <any>null;
            this.deregolamentaSuRichiesta = _data["deregolamentaSuRichiesta"] !== undefined ? _data["deregolamentaSuRichiesta"] : <any>null;
            this.articolo = _data["articolo"] ? Articolo.fromJS(_data["articolo"]) : <any>null;
        }
    }

    static fromJS(data: any): ServizioRegolaVendita {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioRegolaVendita();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : <any>null;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : <any>null;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["numeroGiorni"] = this.numeroGiorni !== undefined ? this.numeroGiorni : <any>null;
        data["minimoGiorni"] = this.minimoGiorni !== undefined ? this.minimoGiorni : <any>null;
        data["massimoGiorni"] = this.massimoGiorni !== undefined ? this.massimoGiorni : <any>null;
        data["etaMinima"] = this.etaMinima !== undefined ? this.etaMinima : <any>null;
        data["etaMassima"] = this.etaMassima !== undefined ? this.etaMassima : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["commissioniAgenzia"] = this.commissioniAgenzia !== undefined ? this.commissioniAgenzia : <any>null;
        data["commissioniTourOperator"] = this.commissioniTourOperator !== undefined ? this.commissioniTourOperator : <any>null;
        data["minimoNottiPeriodo"] = this.minimoNottiPeriodo !== undefined ? this.minimoNottiPeriodo : <any>null;
        data["giorniEntrata"] = this.giorniEntrata !== undefined ? this.giorniEntrata : <any>null;
        data["giorniUscita"] = this.giorniUscita !== undefined ? this.giorniUscita : <any>null;
        data["prenotaEntroData"] = this.prenotaEntroData !== undefined ? this.prenotaEntroData : <any>null;
        data["prenotaEntroGiorni"] = this.prenotaEntroGiorni !== undefined ? this.prenotaEntroGiorni : <any>null;
        data["deregolamentaSuRichiesta"] = this.deregolamentaSuRichiesta !== undefined ? this.deregolamentaSuRichiesta : <any>null;
        data["articolo"] = this.articolo ? this.articolo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioRegolaVendita extends IServizioRegolaVenditaBase {
    nome?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    numeroGiorni?: number | null;
    minimoGiorni?: number | null;
    massimoGiorni?: number | null;
    etaMinima?: number | null;
    etaMassima?: number | null;
    dal?: string | null;
    al?: string | null;
    commissioniAgenzia?: number | null;
    commissioniTourOperator?: number | null;
    minimoNottiPeriodo?: number | null;
    giorniEntrata?: string | null;
    giorniUscita?: string | null;
    prenotaEntroData?: string | null;
    prenotaEntroGiorni?: number | null;
    deregolamentaSuRichiesta?: boolean | null;
    articolo?: Articolo | null;
}

export class CostoInfo implements ICostoInfo {
    id?: number;
    costo?: Costo | null;
    tabellaCostiCommissioni?: TabellaCostiCommissioniInfo | null;
    tipologia?: ServizioTipologiaInfo | null;
    regolaServizio?: ServizioRegola | null;
    regolaVendita?: ServizioRegolaVendita | null;
    validita?: Validita | null;
    trattamento?: TrattamentoInfo | null;
    sistemazione?: SistemazioneInfo | null;

    constructor(data?: ICostoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.costo = _data["costo"] ? Costo.fromJS(_data["costo"]) : <any>null;
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] ? TabellaCostiCommissioniInfo.fromJS(_data["tabellaCostiCommissioni"]) : <any>null;
            this.tipologia = _data["tipologia"] ? ServizioTipologiaInfo.fromJS(_data["tipologia"]) : <any>null;
            this.regolaServizio = _data["regolaServizio"] ? ServizioRegola.fromJS(_data["regolaServizio"]) : <any>null;
            this.regolaVendita = _data["regolaVendita"] ? ServizioRegolaVendita.fromJS(_data["regolaVendita"]) : <any>null;
            this.validita = _data["validita"] ? Validita.fromJS(_data["validita"]) : <any>null;
            this.trattamento = _data["trattamento"] ? TrattamentoInfo.fromJS(_data["trattamento"]) : <any>null;
            this.sistemazione = _data["sistemazione"] ? SistemazioneInfo.fromJS(_data["sistemazione"]) : <any>null;
        }
    }

    static fromJS(data: any): CostoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CostoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["costo"] = this.costo ? this.costo.toJSON() : <any>null;
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni ? this.tabellaCostiCommissioni.toJSON() : <any>null;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : <any>null;
        data["regolaServizio"] = this.regolaServizio ? this.regolaServizio.toJSON() : <any>null;
        data["regolaVendita"] = this.regolaVendita ? this.regolaVendita.toJSON() : <any>null;
        data["validita"] = this.validita ? this.validita.toJSON() : <any>null;
        data["trattamento"] = this.trattamento ? this.trattamento.toJSON() : <any>null;
        data["sistemazione"] = this.sistemazione ? this.sistemazione.toJSON() : <any>null;
        return data;
    }
}

export interface ICostoInfo {
    id?: number;
    costo?: Costo | null;
    tabellaCostiCommissioni?: TabellaCostiCommissioniInfo | null;
    tipologia?: ServizioTipologiaInfo | null;
    regolaServizio?: ServizioRegola | null;
    regolaVendita?: ServizioRegolaVendita | null;
    validita?: Validita | null;
    trattamento?: TrattamentoInfo | null;
    sistemazione?: SistemazioneInfo | null;
}

export class Costo implements ICosto {
    costoID?: number;
    servizioTipologiaID?: number;
    tabellaCostiCommissioniID?: number;
    trattamentoID?: number | null;
    regolaServizioID?: number | null;
    regolaVenditaID?: number | null;
    validitaID?: number;
    sistemazioneID?: number | null;
    codicePrenotazione?: string | null;
    cost?: number;
    prezzo?: number | null;
    margine?: number | null;
    etaMassima?: number | null;
    regolaCostiBambino?: ERegolaCostiBambino | null;
    _ScontoBambinoPercentuale?: boolean | null;

    constructor(data?: ICosto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costoID = _data["costoID"] !== undefined ? _data["costoID"] : <any>null;
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : <any>null;
            this.tabellaCostiCommissioniID = _data["tabellaCostiCommissioniID"] !== undefined ? _data["tabellaCostiCommissioniID"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
            this.regolaServizioID = _data["regolaServizioID"] !== undefined ? _data["regolaServizioID"] : <any>null;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : <any>null;
            this.validitaID = _data["validitaID"] !== undefined ? _data["validitaID"] : <any>null;
            this.sistemazioneID = _data["sistemazioneID"] !== undefined ? _data["sistemazioneID"] : <any>null;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : <any>null;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.margine = _data["margine"] !== undefined ? _data["margine"] : <any>null;
            this.etaMassima = _data["etaMassima"] !== undefined ? _data["etaMassima"] : <any>null;
            this.regolaCostiBambino = _data["regolaCostiBambino"] !== undefined ? _data["regolaCostiBambino"] : <any>null;
            this._ScontoBambinoPercentuale = _data["_ScontoBambinoPercentuale"] !== undefined ? _data["_ScontoBambinoPercentuale"] : <any>null;
        }
    }

    static fromJS(data: any): Costo {
        data = typeof data === 'object' ? data : {};
        let result = new Costo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costoID"] = this.costoID !== undefined ? this.costoID : <any>null;
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : <any>null;
        data["tabellaCostiCommissioniID"] = this.tabellaCostiCommissioniID !== undefined ? this.tabellaCostiCommissioniID : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        data["regolaServizioID"] = this.regolaServizioID !== undefined ? this.regolaServizioID : <any>null;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : <any>null;
        data["validitaID"] = this.validitaID !== undefined ? this.validitaID : <any>null;
        data["sistemazioneID"] = this.sistemazioneID !== undefined ? this.sistemazioneID : <any>null;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : <any>null;
        data["cost"] = this.cost !== undefined ? this.cost : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["margine"] = this.margine !== undefined ? this.margine : <any>null;
        data["etaMassima"] = this.etaMassima !== undefined ? this.etaMassima : <any>null;
        data["regolaCostiBambino"] = this.regolaCostiBambino !== undefined ? this.regolaCostiBambino : <any>null;
        data["_ScontoBambinoPercentuale"] = this._ScontoBambinoPercentuale !== undefined ? this._ScontoBambinoPercentuale : <any>null;
        return data;
    }
}

export interface ICosto {
    costoID?: number;
    servizioTipologiaID?: number;
    tabellaCostiCommissioniID?: number;
    trattamentoID?: number | null;
    regolaServizioID?: number | null;
    regolaVenditaID?: number | null;
    validitaID?: number;
    sistemazioneID?: number | null;
    codicePrenotazione?: string | null;
    cost?: number;
    prezzo?: number | null;
    margine?: number | null;
    etaMassima?: number | null;
    regolaCostiBambino?: ERegolaCostiBambino | null;
    _ScontoBambinoPercentuale?: boolean | null;
}

export enum ERegolaCostiBambino {
    Nessuna = "Nessuna",
    Fino1Bambino = "Fino1Bambino",
    Fino2Bambini = "Fino2Bambini",
    Fino3Bambini = "Fino3Bambini",
    Fino1Infant = "Fino1Infant",
    Fino2Infant = "Fino2Infant",
    PrimoBambino = "PrimoBambino",
    SecondoBambino = "SecondoBambino",
    TerzoBambino = "TerzoBambino",
    QuartoBambino = "QuartoBambino",
    Fino4Bambini = "Fino4Bambini",
    Fino5Bambini = "Fino5Bambini",
    QuintoBambino = "QuintoBambino",
}

export class TabellaCostiCommissioniInfo implements ITabellaCostiCommissioniInfo {
    id?: number;
    tabellaCostiCommissioni?: TabellaCostiCommissioni;
    accordo?: AccordoInfo | null;
    esclusioni?: TabellaCostiCommissioniEsclusione[];
    eccezioni?: TabellaCostiCommissioniEccezione[];
    isValid?: boolean;
    wasValidLastYear?: boolean;

    constructor(data?: ITabellaCostiCommissioniInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] ? TabellaCostiCommissioni.fromJS(_data["tabellaCostiCommissioni"]) : <any>null;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : <any>null;
            if (Array.isArray(_data["esclusioni"])) {
                this.esclusioni = [] as any;
                for (let item of _data["esclusioni"])
                    this.esclusioni!.push(TabellaCostiCommissioniEsclusione.fromJS(item));
            }
            else {
                this.esclusioni = <any>null;
            }
            if (Array.isArray(_data["eccezioni"])) {
                this.eccezioni = [] as any;
                for (let item of _data["eccezioni"])
                    this.eccezioni!.push(TabellaCostiCommissioniEccezione.fromJS(item));
            }
            else {
                this.eccezioni = <any>null;
            }
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
            this.wasValidLastYear = _data["wasValidLastYear"] !== undefined ? _data["wasValidLastYear"] : <any>null;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni ? this.tabellaCostiCommissioni.toJSON() : <any>null;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : <any>null;
        if (Array.isArray(this.esclusioni)) {
            data["esclusioni"] = [];
            for (let item of this.esclusioni)
                data["esclusioni"].push(item.toJSON());
        }
        if (Array.isArray(this.eccezioni)) {
            data["eccezioni"] = [];
            for (let item of this.eccezioni)
                data["eccezioni"].push(item.toJSON());
        }
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        data["wasValidLastYear"] = this.wasValidLastYear !== undefined ? this.wasValidLastYear : <any>null;
        return data;
    }
}

export interface ITabellaCostiCommissioniInfo {
    id?: number;
    tabellaCostiCommissioni?: TabellaCostiCommissioni;
    accordo?: AccordoInfo | null;
    esclusioni?: TabellaCostiCommissioniEsclusione[];
    eccezioni?: TabellaCostiCommissioniEccezione[];
    isValid?: boolean;
    wasValidLastYear?: boolean;
}

export class TabellaCostiCommissioniEsclusione implements ITabellaCostiCommissioniEsclusione {
    tabellaCostiCommissioniEsclusioneID?: number;
    tabellaCostiCommissioniID?: number;
    dal?: string;
    al?: string;

    constructor(data?: ITabellaCostiCommissioniEsclusione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabellaCostiCommissioniEsclusioneID = _data["tabellaCostiCommissioniEsclusioneID"] !== undefined ? _data["tabellaCostiCommissioniEsclusioneID"] : <any>null;
            this.tabellaCostiCommissioniID = _data["tabellaCostiCommissioniID"] !== undefined ? _data["tabellaCostiCommissioniID"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniEsclusione {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniEsclusione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabellaCostiCommissioniEsclusioneID"] = this.tabellaCostiCommissioniEsclusioneID !== undefined ? this.tabellaCostiCommissioniEsclusioneID : <any>null;
        data["tabellaCostiCommissioniID"] = this.tabellaCostiCommissioniID !== undefined ? this.tabellaCostiCommissioniID : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        return data;
    }
}

export interface ITabellaCostiCommissioniEsclusione {
    tabellaCostiCommissioniEsclusioneID?: number;
    tabellaCostiCommissioniID?: number;
    dal?: string;
    al?: string;
}

export class TabellaCostiCommissioniEccezione implements ITabellaCostiCommissioniEccezione {
    id?: number;
    tabellaCostoCommissioniID?: number;
    dal?: string;
    al?: string;
    percentuale?: number;
    percentuale2?: number | null;
    differenzaCommissioneAdv?: number | null;

    constructor(data?: ITabellaCostiCommissioniEccezione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tabellaCostoCommissioniID = _data["tabellaCostoCommissioniID"] !== undefined ? _data["tabellaCostoCommissioniID"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.percentuale = _data["percentuale"] !== undefined ? _data["percentuale"] : <any>null;
            this.percentuale2 = _data["percentuale2"] !== undefined ? _data["percentuale2"] : <any>null;
            this.differenzaCommissioneAdv = _data["differenzaCommissioneAdv"] !== undefined ? _data["differenzaCommissioneAdv"] : <any>null;
        }
    }

    static fromJS(data: any): TabellaCostiCommissioniEccezione {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostiCommissioniEccezione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tabellaCostoCommissioniID"] = this.tabellaCostoCommissioniID !== undefined ? this.tabellaCostoCommissioniID : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["percentuale"] = this.percentuale !== undefined ? this.percentuale : <any>null;
        data["percentuale2"] = this.percentuale2 !== undefined ? this.percentuale2 : <any>null;
        data["differenzaCommissioneAdv"] = this.differenzaCommissioneAdv !== undefined ? this.differenzaCommissioneAdv : <any>null;
        return data;
    }
}

export interface ITabellaCostiCommissioniEccezione {
    id?: number;
    tabellaCostoCommissioniID?: number;
    dal?: string;
    al?: string;
    percentuale?: number;
    percentuale2?: number | null;
    differenzaCommissioneAdv?: number | null;
}

export class TrattamentoInfo implements ITrattamentoInfo {
    id?: number;
    trattamento?: Trattamento;
    traduzioni?: IWebTranslationEntity[];
    nome?: string;
    nome_en?: string;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string;

    constructor(data?: ITrattamentoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.trattamento = _data["trattamento"] ? Trattamento.fromJS(_data["trattamento"]) : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
        }
    }

    static fromJS(data: any): TrattamentoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TrattamentoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["trattamento"] = this.trattamento ? this.trattamento.toJSON() : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        return data;
    }
}

export interface ITrattamentoInfo {
    id?: number;
    trattamento?: Trattamento;
    traduzioni?: IWebTranslationEntity[];
    nome?: string;
    nome_en?: string;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string;
}

export class SistemazioneInfo implements ISistemazioneInfo {
    _Nomi?: { [key in keyof typeof ELingua]?: string; } | null;
    id?: number;
    sistemazione?: Sistemazione | null;
    isBase?: boolean;
    nomi?: { [key in keyof typeof ELingua]?: string; } | null;

    constructor(data?: ISistemazioneInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["_Nomi"]) {
                this._Nomi = {} as any;
                for (let key in _data["_Nomi"]) {
                    if (_data["_Nomi"].hasOwnProperty(key))
                        (<any>this._Nomi)![key] = _data["_Nomi"][key] !== undefined ? _data["_Nomi"][key] : <any>null;
                }
            }
            else {
                this._Nomi = <any>null;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.sistemazione = _data["sistemazione"] ? Sistemazione.fromJS(_data["sistemazione"]) : <any>null;
            this.isBase = _data["isBase"] !== undefined ? _data["isBase"] : <any>null;
            if (_data["nomi"]) {
                this.nomi = {} as any;
                for (let key in _data["nomi"]) {
                    if (_data["nomi"].hasOwnProperty(key))
                        (<any>this.nomi)![key] = _data["nomi"][key] !== undefined ? _data["nomi"][key] : <any>null;
                }
            }
            else {
                this.nomi = <any>null;
            }
        }
    }

    static fromJS(data: any): SistemazioneInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SistemazioneInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this._Nomi) {
            data["_Nomi"] = {};
            for (let key in this._Nomi) {
                if (this._Nomi.hasOwnProperty(key))
                    (<any>data["_Nomi"])[key] = this._Nomi[key] !== undefined ? this._Nomi[key] : <any>null;
            }
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["sistemazione"] = this.sistemazione ? this.sistemazione.toJSON() : <any>null;
        data["isBase"] = this.isBase !== undefined ? this.isBase : <any>null;
        if (this.nomi) {
            data["nomi"] = {};
            for (let key in this.nomi) {
                if (this.nomi.hasOwnProperty(key))
                    (<any>data["nomi"])[key] = this.nomi[key] !== undefined ? this.nomi[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ISistemazioneInfo {
    _Nomi?: { [key in keyof typeof ELingua]?: string; } | null;
    id?: number;
    sistemazione?: Sistemazione | null;
    isBase?: boolean;
    nomi?: { [key in keyof typeof ELingua]?: string; } | null;
}

export class Sistemazione implements ISistemazione {
    sistemazioneID?: number;
    sistemazioneBaseID?: number | null;
    nome!: string;
    nomeInglese?: string | null;
    memo?: string | null;
    nomeVoucher?: string | null;
    maxAdulti?: number;
    maxChildren?: number;
    nome_en?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_nl?: string | null;
    visibile?: boolean | null;

    constructor(data?: ISistemazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sistemazioneID = _data["sistemazioneID"] !== undefined ? _data["sistemazioneID"] : <any>null;
            this.sistemazioneBaseID = _data["sistemazioneBaseID"] !== undefined ? _data["sistemazioneBaseID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : <any>null;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : <any>null;
            this.nomeVoucher = _data["nomeVoucher"] !== undefined ? _data["nomeVoucher"] : <any>null;
            this.maxAdulti = _data["maxAdulti"] !== undefined ? _data["maxAdulti"] : <any>null;
            this.maxChildren = _data["maxChildren"] !== undefined ? _data["maxChildren"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : <any>null;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : <any>null;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : <any>null;
            this.nome_nl = _data["nome_nl"] !== undefined ? _data["nome_nl"] : <any>null;
            this.visibile = _data["visibile"] !== undefined ? _data["visibile"] : <any>null;
        }
    }

    static fromJS(data: any): Sistemazione {
        data = typeof data === 'object' ? data : {};
        let result = new Sistemazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sistemazioneID"] = this.sistemazioneID !== undefined ? this.sistemazioneID : <any>null;
        data["sistemazioneBaseID"] = this.sistemazioneBaseID !== undefined ? this.sistemazioneBaseID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : <any>null;
        data["memo"] = this.memo !== undefined ? this.memo : <any>null;
        data["nomeVoucher"] = this.nomeVoucher !== undefined ? this.nomeVoucher : <any>null;
        data["maxAdulti"] = this.maxAdulti !== undefined ? this.maxAdulti : <any>null;
        data["maxChildren"] = this.maxChildren !== undefined ? this.maxChildren : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : <any>null;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : <any>null;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : <any>null;
        data["nome_nl"] = this.nome_nl !== undefined ? this.nome_nl : <any>null;
        data["visibile"] = this.visibile !== undefined ? this.visibile : <any>null;
        return data;
    }
}

export interface ISistemazione {
    sistemazioneID?: number;
    sistemazioneBaseID?: number | null;
    nome: string;
    nomeInglese?: string | null;
    memo?: string | null;
    nomeVoucher?: string | null;
    maxAdulti?: number;
    maxChildren?: number;
    nome_en?: string | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_nl?: string | null;
    visibile?: boolean | null;
}

export abstract class PartenzaBase implements IPartenzaBase {
    partenzaID?: number;
    servizioID?: number;
    data?: string | null;
    flags?: EPartenzaFlags;

    constructor(data?: IPartenzaBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partenzaID = _data["partenzaID"] !== undefined ? _data["partenzaID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.flags = _data["flags"] !== undefined ? _data["flags"] : <any>null;
        }
    }

    static fromJS(data: any): PartenzaBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PartenzaBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partenzaID"] = this.partenzaID !== undefined ? this.partenzaID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["flags"] = this.flags !== undefined ? this.flags : <any>null;
        return data;
    }
}

export interface IPartenzaBase {
    partenzaID?: number;
    servizioID?: number;
    data?: string | null;
    flags?: EPartenzaFlags;
}

export class Partenza extends PartenzaBase implements IPartenza {

    constructor(data?: IPartenza) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): Partenza {
        data = typeof data === 'object' ? data : {};
        let result = new Partenza();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPartenza extends IPartenzaBase {
}

export enum EPartenzaFlags {
    Nessuno = "Nessuno",
    Garantita = "Garantita",
    InItaliano = "InItaliano",
    SuRichiesta = "SuRichiesta",
    InInglese = "InInglese",
    InTedesco = "InTedesco",
    InFrancese = "InFrancese",
    InSpagnolo = "InSpagnolo",
    InOlandese = "InOlandese",
}

export class ServizioLuogo implements IServizioLuogo {
    servizioLuogoID?: number;
    servizioID?: number;
    luogoID?: number;

    constructor(data?: IServizioLuogo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioLuogoID = _data["servizioLuogoID"] !== undefined ? _data["servizioLuogoID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioLuogo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioLuogo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioLuogoID"] = this.servizioLuogoID !== undefined ? this.servizioLuogoID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        return data;
    }
}

export interface IServizioLuogo {
    servizioLuogoID?: number;
    servizioID?: number;
    luogoID?: number;
}

export class ServizioAssociazioneInfo implements IServizioAssociazioneInfo {
    id?: number;
    associazione?: ServizioAssociazione;
    configurazioneOfferta?: OffertaComponibile | null;
    labelOfferta?: string | null;
    disabilitata?: boolean;
    esclusioni?: string | null;
    codice?: string | null;
    priorita?: number | null;
    cumulabilita?: string | null;
    tipologiaParent?: ServizioTipologiaInfo | null;
    tipologiaSupplemento?: ServizioTipologiaInfo | null;
    regolaVendita?: ServizioRegolaVendita | null;
    tabellaCosti?: TabellaCostiCommissioniInfo | null;
    sistemazione?: SistemazioneInfo | null;
    trattamento?: TrattamentoInfo | null;
    isOffertaComponibile?: boolean;
    isOffertaComponibilePerTipologia?: boolean;
    isPerTipologia?: boolean;

    constructor(data?: IServizioAssociazioneInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.associazione = _data["associazione"] ? ServizioAssociazione.fromJS(_data["associazione"]) : <any>null;
            this.configurazioneOfferta = _data["configurazioneOfferta"] ? OffertaComponibile.fromJS(_data["configurazioneOfferta"]) : <any>null;
            this.labelOfferta = _data["labelOfferta"] !== undefined ? _data["labelOfferta"] : <any>null;
            this.disabilitata = _data["disabilitata"] !== undefined ? _data["disabilitata"] : <any>null;
            this.esclusioni = _data["esclusioni"] !== undefined ? _data["esclusioni"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : <any>null;
            this.cumulabilita = _data["cumulabilita"] !== undefined ? _data["cumulabilita"] : <any>null;
            this.tipologiaParent = _data["tipologiaParent"] ? ServizioTipologiaInfo.fromJS(_data["tipologiaParent"]) : <any>null;
            this.tipologiaSupplemento = _data["tipologiaSupplemento"] ? ServizioTipologiaInfo.fromJS(_data["tipologiaSupplemento"]) : <any>null;
            this.regolaVendita = _data["regolaVendita"] ? ServizioRegolaVendita.fromJS(_data["regolaVendita"]) : <any>null;
            this.tabellaCosti = _data["tabellaCosti"] ? TabellaCostiCommissioniInfo.fromJS(_data["tabellaCosti"]) : <any>null;
            this.sistemazione = _data["sistemazione"] ? SistemazioneInfo.fromJS(_data["sistemazione"]) : <any>null;
            this.trattamento = _data["trattamento"] ? TrattamentoInfo.fromJS(_data["trattamento"]) : <any>null;
            this.isOffertaComponibile = _data["isOffertaComponibile"] !== undefined ? _data["isOffertaComponibile"] : <any>null;
            this.isOffertaComponibilePerTipologia = _data["isOffertaComponibilePerTipologia"] !== undefined ? _data["isOffertaComponibilePerTipologia"] : <any>null;
            this.isPerTipologia = _data["isPerTipologia"] !== undefined ? _data["isPerTipologia"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioAssociazioneInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAssociazioneInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["associazione"] = this.associazione ? this.associazione.toJSON() : <any>null;
        data["configurazioneOfferta"] = this.configurazioneOfferta ? this.configurazioneOfferta.toJSON() : <any>null;
        data["labelOfferta"] = this.labelOfferta !== undefined ? this.labelOfferta : <any>null;
        data["disabilitata"] = this.disabilitata !== undefined ? this.disabilitata : <any>null;
        data["esclusioni"] = this.esclusioni !== undefined ? this.esclusioni : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["priorita"] = this.priorita !== undefined ? this.priorita : <any>null;
        data["cumulabilita"] = this.cumulabilita !== undefined ? this.cumulabilita : <any>null;
        data["tipologiaParent"] = this.tipologiaParent ? this.tipologiaParent.toJSON() : <any>null;
        data["tipologiaSupplemento"] = this.tipologiaSupplemento ? this.tipologiaSupplemento.toJSON() : <any>null;
        data["regolaVendita"] = this.regolaVendita ? this.regolaVendita.toJSON() : <any>null;
        data["tabellaCosti"] = this.tabellaCosti ? this.tabellaCosti.toJSON() : <any>null;
        data["sistemazione"] = this.sistemazione ? this.sistemazione.toJSON() : <any>null;
        data["trattamento"] = this.trattamento ? this.trattamento.toJSON() : <any>null;
        data["isOffertaComponibile"] = this.isOffertaComponibile !== undefined ? this.isOffertaComponibile : <any>null;
        data["isOffertaComponibilePerTipologia"] = this.isOffertaComponibilePerTipologia !== undefined ? this.isOffertaComponibilePerTipologia : <any>null;
        data["isPerTipologia"] = this.isPerTipologia !== undefined ? this.isPerTipologia : <any>null;
        return data;
    }
}

export interface IServizioAssociazioneInfo {
    id?: number;
    associazione?: ServizioAssociazione;
    configurazioneOfferta?: OffertaComponibile | null;
    labelOfferta?: string | null;
    disabilitata?: boolean;
    esclusioni?: string | null;
    codice?: string | null;
    priorita?: number | null;
    cumulabilita?: string | null;
    tipologiaParent?: ServizioTipologiaInfo | null;
    tipologiaSupplemento?: ServizioTipologiaInfo | null;
    regolaVendita?: ServizioRegolaVendita | null;
    tabellaCosti?: TabellaCostiCommissioniInfo | null;
    sistemazione?: SistemazioneInfo | null;
    trattamento?: TrattamentoInfo | null;
    isOffertaComponibile?: boolean;
    isOffertaComponibilePerTipologia?: boolean;
    isPerTipologia?: boolean;
}

export class ServizioAssociazioneBase implements IServizioAssociazioneBase {
    id?: number;
    servizioID?: number;
    tipologiaSupplementoID?: number | null;
    tipologiaParentID?: number | null;
    tabellaCostoID?: number | null;
    sistemazioneID?: number | null;
    ordine?: number | null;
    macroTipologia?: EMacrotipologia | null;
    tipoSupplemento?: ETipoSupplemento | null;
    regolaVenditaID?: number | null;
    dal?: string | null;
    al?: string | null;
    parametriOfferta?: string | null;
    cumulabilita?: string | null;
    trattamentoID?: number | null;
    tipoAssociazione?: ETipoAssociazione | null;
    tipoOffertaID?: number | null;

    constructor(data?: IServizioAssociazioneBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.tipologiaSupplementoID = _data["tipologiaSupplementoID"] !== undefined ? _data["tipologiaSupplementoID"] : <any>null;
            this.tipologiaParentID = _data["tipologiaParentID"] !== undefined ? _data["tipologiaParentID"] : <any>null;
            this.tabellaCostoID = _data["tabellaCostoID"] !== undefined ? _data["tabellaCostoID"] : <any>null;
            this.sistemazioneID = _data["sistemazioneID"] !== undefined ? _data["sistemazioneID"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.macroTipologia = _data["macroTipologia"] !== undefined ? _data["macroTipologia"] : <any>null;
            this.tipoSupplemento = _data["tipoSupplemento"] !== undefined ? _data["tipoSupplemento"] : <any>null;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.parametriOfferta = _data["parametriOfferta"] !== undefined ? _data["parametriOfferta"] : <any>null;
            this.cumulabilita = _data["cumulabilita"] !== undefined ? _data["cumulabilita"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
            this.tipoAssociazione = _data["tipoAssociazione"] !== undefined ? _data["tipoAssociazione"] : <any>null;
            this.tipoOffertaID = _data["tipoOffertaID"] !== undefined ? _data["tipoOffertaID"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioAssociazioneBase {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAssociazioneBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["tipologiaSupplementoID"] = this.tipologiaSupplementoID !== undefined ? this.tipologiaSupplementoID : <any>null;
        data["tipologiaParentID"] = this.tipologiaParentID !== undefined ? this.tipologiaParentID : <any>null;
        data["tabellaCostoID"] = this.tabellaCostoID !== undefined ? this.tabellaCostoID : <any>null;
        data["sistemazioneID"] = this.sistemazioneID !== undefined ? this.sistemazioneID : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["macroTipologia"] = this.macroTipologia !== undefined ? this.macroTipologia : <any>null;
        data["tipoSupplemento"] = this.tipoSupplemento !== undefined ? this.tipoSupplemento : <any>null;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["parametriOfferta"] = this.parametriOfferta !== undefined ? this.parametriOfferta : <any>null;
        data["cumulabilita"] = this.cumulabilita !== undefined ? this.cumulabilita : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        data["tipoAssociazione"] = this.tipoAssociazione !== undefined ? this.tipoAssociazione : <any>null;
        data["tipoOffertaID"] = this.tipoOffertaID !== undefined ? this.tipoOffertaID : <any>null;
        return data;
    }
}

export interface IServizioAssociazioneBase {
    id?: number;
    servizioID?: number;
    tipologiaSupplementoID?: number | null;
    tipologiaParentID?: number | null;
    tabellaCostoID?: number | null;
    sistemazioneID?: number | null;
    ordine?: number | null;
    macroTipologia?: EMacrotipologia | null;
    tipoSupplemento?: ETipoSupplemento | null;
    regolaVenditaID?: number | null;
    dal?: string | null;
    al?: string | null;
    parametriOfferta?: string | null;
    cumulabilita?: string | null;
    trattamentoID?: number | null;
    tipoAssociazione?: ETipoAssociazione | null;
    tipoOffertaID?: number | null;
}

export class ServizioAssociazione extends ServizioAssociazioneBase implements IServizioAssociazione {
    tipologiaEsternaID?: number | null;
    descrizioneWeb?: string | null;
    descrizioneVoucher?: string | null;

    constructor(data?: IServizioAssociazione) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipologiaEsternaID = _data["tipologiaEsternaID"] !== undefined ? _data["tipologiaEsternaID"] : <any>null;
            this.descrizioneWeb = _data["descrizioneWeb"] !== undefined ? _data["descrizioneWeb"] : <any>null;
            this.descrizioneVoucher = _data["descrizioneVoucher"] !== undefined ? _data["descrizioneVoucher"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioAssociazione {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAssociazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologiaEsternaID"] = this.tipologiaEsternaID !== undefined ? this.tipologiaEsternaID : <any>null;
        data["descrizioneWeb"] = this.descrizioneWeb !== undefined ? this.descrizioneWeb : <any>null;
        data["descrizioneVoucher"] = this.descrizioneVoucher !== undefined ? this.descrizioneVoucher : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioAssociazione extends IServizioAssociazioneBase {
    tipologiaEsternaID?: number | null;
    descrizioneWeb?: string | null;
    descrizioneVoucher?: string | null;
}

export enum EMacrotipologia {
    TuttoTranneSupplementi = "TuttoTranneSupplementi",
    SoloSupplementi = "SoloSupplementi",
}

export enum ETipoAssociazione {
    TipologiaSupplemento = "TipologiaSupplemento",
    RegolaVenditaAggiuntiva = "RegolaVenditaAggiuntiva",
    OffertaComponibile = "OffertaComponibile",
    PenaliCancellazione = "PenaliCancellazione",
}

export class OffertaComponibile implements IOffertaComponibile {
    codice?: string;
    label?: string;
    priorita?: number;
    cumulabilita?: string | null;
    periodiEsclusione?: string | null;
    tipoApplicazione?: ETipoApplicazione;
    disabilitata?: boolean;
    noteInterne?: string | null;
    configurazionePrecondizioni?: EccezioneConfig[] | null;
    configurazioneAlgoritmo?: EccezioneConfig | null;

    constructor(data?: IOffertaComponibile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : <any>null;
            this.cumulabilita = _data["cumulabilita"] !== undefined ? _data["cumulabilita"] : <any>null;
            this.periodiEsclusione = _data["periodiEsclusione"] !== undefined ? _data["periodiEsclusione"] : <any>null;
            this.tipoApplicazione = _data["tipoApplicazione"] !== undefined ? _data["tipoApplicazione"] : <any>null;
            this.disabilitata = _data["disabilitata"] !== undefined ? _data["disabilitata"] : <any>null;
            this.noteInterne = _data["noteInterne"] !== undefined ? _data["noteInterne"] : <any>null;
            if (Array.isArray(_data["configurazionePrecondizioni"])) {
                this.configurazionePrecondizioni = [] as any;
                for (let item of _data["configurazionePrecondizioni"])
                    this.configurazionePrecondizioni!.push(EccezioneConfig.fromJS(item));
            }
            else {
                this.configurazionePrecondizioni = <any>null;
            }
            this.configurazioneAlgoritmo = _data["configurazioneAlgoritmo"] ? EccezioneConfig.fromJS(_data["configurazioneAlgoritmo"]) : <any>null;
        }
    }

    static fromJS(data: any): OffertaComponibile {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaComponibile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["priorita"] = this.priorita !== undefined ? this.priorita : <any>null;
        data["cumulabilita"] = this.cumulabilita !== undefined ? this.cumulabilita : <any>null;
        data["periodiEsclusione"] = this.periodiEsclusione !== undefined ? this.periodiEsclusione : <any>null;
        data["tipoApplicazione"] = this.tipoApplicazione !== undefined ? this.tipoApplicazione : <any>null;
        data["disabilitata"] = this.disabilitata !== undefined ? this.disabilitata : <any>null;
        data["noteInterne"] = this.noteInterne !== undefined ? this.noteInterne : <any>null;
        if (Array.isArray(this.configurazionePrecondizioni)) {
            data["configurazionePrecondizioni"] = [];
            for (let item of this.configurazionePrecondizioni)
                data["configurazionePrecondizioni"].push(item.toJSON());
        }
        data["configurazioneAlgoritmo"] = this.configurazioneAlgoritmo ? this.configurazioneAlgoritmo.toJSON() : <any>null;
        return data;
    }
}

export interface IOffertaComponibile {
    codice?: string;
    label?: string;
    priorita?: number;
    cumulabilita?: string | null;
    periodiEsclusione?: string | null;
    tipoApplicazione?: ETipoApplicazione;
    disabilitata?: boolean;
    noteInterne?: string | null;
    configurazionePrecondizioni?: EccezioneConfig[] | null;
    configurazioneAlgoritmo?: EccezioneConfig | null;
}

export enum ETipoApplicazione {
    Normale = "Normale",
    ApplicaENascondiPrezzo = "ApplicaENascondiPrezzo",
    ModificaQuoteBase = "ModificaQuoteBase",
    VisualizzaLabel = "VisualizzaLabel",
    BloccaVendita = "BloccaVendita",
    VisualizzaLabelAnonima = "VisualizzaLabelAnonima",
    VisualizzaLabelSupplemento = "VisualizzaLabelSupplemento",
    ForzaSuRichiesta = "ForzaSuRichiesta",
}

export class EccezioneConfig implements IEccezioneConfig {
    codice?: string;
    config?: any | null;

    constructor(data?: IEccezioneConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.config = _data["config"] !== undefined ? _data["config"] : <any>null;
        }
    }

    static fromJS(data: any): EccezioneConfig {
        data = typeof data === 'object' ? data : {};
        let result = new EccezioneConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["config"] = this.config !== undefined ? this.config : <any>null;
        return data;
    }
}

export interface IEccezioneConfig {
    codice?: string;
    config?: any | null;
}

export class ServizioDatoAggiuntivoInfo implements IServizioDatoAggiuntivoInfo {
    tipoInfo?: DatoAggiuntivoTipoInfo;
    datoAggiuntivoInfo?: DatoAggiuntivoInfo;
    datoAggiuntivo?: DatoAggiuntivo;
    valore?: ServizioDatoAggiuntivo;

    constructor(data?: IServizioDatoAggiuntivoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoInfo = _data["tipoInfo"] ? DatoAggiuntivoTipoInfo.fromJS(_data["tipoInfo"]) : <any>null;
            this.datoAggiuntivoInfo = _data["datoAggiuntivoInfo"] ? DatoAggiuntivoInfo.fromJS(_data["datoAggiuntivoInfo"]) : <any>null;
            this.datoAggiuntivo = _data["datoAggiuntivo"] ? DatoAggiuntivo.fromJS(_data["datoAggiuntivo"]) : <any>null;
            this.valore = _data["valore"] ? ServizioDatoAggiuntivo.fromJS(_data["valore"]) : <any>null;
        }
    }

    static fromJS(data: any): ServizioDatoAggiuntivoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioDatoAggiuntivoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoInfo"] = this.tipoInfo ? this.tipoInfo.toJSON() : <any>null;
        data["datoAggiuntivoInfo"] = this.datoAggiuntivoInfo ? this.datoAggiuntivoInfo.toJSON() : <any>null;
        data["datoAggiuntivo"] = this.datoAggiuntivo ? this.datoAggiuntivo.toJSON() : <any>null;
        data["valore"] = this.valore ? this.valore.toJSON() : <any>null;
        return data;
    }
}

export interface IServizioDatoAggiuntivoInfo {
    tipoInfo?: DatoAggiuntivoTipoInfo;
    datoAggiuntivoInfo?: DatoAggiuntivoInfo;
    datoAggiuntivo?: DatoAggiuntivo;
    valore?: ServizioDatoAggiuntivo;
}

export class DatoAggiuntivoTipoInfo implements IDatoAggiuntivoTipoInfo {
    id?: number;
    tipo?: DatoAggiuntivoTipo;
    traduzioni?: IWebTranslationEntity[];
    nome?: string;
    nome_en?: string;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string;

    constructor(data?: IDatoAggiuntivoTipoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tipo = _data["tipo"] ? DatoAggiuntivoTipo.fromJS(_data["tipo"]) : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
        }
    }

    static fromJS(data: any): DatoAggiuntivoTipoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoTipoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tipo"] = this.tipo ? this.tipo.toJSON() : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        return data;
    }
}

export interface IDatoAggiuntivoTipoInfo {
    id?: number;
    tipo?: DatoAggiuntivoTipo;
    traduzioni?: IWebTranslationEntity[];
    nome?: string;
    nome_en?: string;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string;
}

export class DatoAggiuntivoInfo implements IDatoAggiuntivoInfo {
    id?: number;
    dato?: DatoAggiuntivo;
    tipo?: DatoAggiuntivoTipoInfo;
    srtTipo?: string;
    tipoServizio?: ETipoServizio | null;
    srtLuogo?: string;
    luogo?: LuogoInfo | null;
    traduzioni?: IWebTranslationEntity[];
    nome?: string;
    nome_en?: string;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string;

    constructor(data?: IDatoAggiuntivoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dato = _data["dato"] ? DatoAggiuntivo.fromJS(_data["dato"]) : <any>null;
            this.tipo = _data["tipo"] ? DatoAggiuntivoTipoInfo.fromJS(_data["tipo"]) : <any>null;
            this.srtTipo = _data["srtTipo"] !== undefined ? _data["srtTipo"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.srtLuogo = _data["srtLuogo"] !== undefined ? _data["srtLuogo"] : <any>null;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
        }
    }

    static fromJS(data: any): DatoAggiuntivoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dato"] = this.dato ? this.dato.toJSON() : <any>null;
        data["tipo"] = this.tipo ? this.tipo.toJSON() : <any>null;
        data["srtTipo"] = this.srtTipo !== undefined ? this.srtTipo : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["srtLuogo"] = this.srtLuogo !== undefined ? this.srtLuogo : <any>null;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        return data;
    }
}

export interface IDatoAggiuntivoInfo {
    id?: number;
    dato?: DatoAggiuntivo;
    tipo?: DatoAggiuntivoTipoInfo;
    srtTipo?: string;
    tipoServizio?: ETipoServizio | null;
    srtLuogo?: string;
    luogo?: LuogoInfo | null;
    traduzioni?: IWebTranslationEntity[];
    nome?: string;
    nome_en?: string;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean;
    confirmed_en?: boolean;
    table?: string;
}

export class ServizioDatoAggiuntivo implements IServizioDatoAggiuntivo {
    id?: number;
    servizioID?: number;
    datoAggiuntivoID?: number;
    tipoServizio?: ETipoServizio | null;
    valore?: string | null;
    dal?: string | null;
    al?: string | null;
    valore_fr?: string | null;
    valore_de?: string | null;
    valore_es?: string | null;
    valore_en?: string | null;

    constructor(data?: IServizioDatoAggiuntivo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.datoAggiuntivoID = _data["datoAggiuntivoID"] !== undefined ? _data["datoAggiuntivoID"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.valore_fr = _data["valore_fr"] !== undefined ? _data["valore_fr"] : <any>null;
            this.valore_de = _data["valore_de"] !== undefined ? _data["valore_de"] : <any>null;
            this.valore_es = _data["valore_es"] !== undefined ? _data["valore_es"] : <any>null;
            this.valore_en = _data["valore_en"] !== undefined ? _data["valore_en"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioDatoAggiuntivo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioDatoAggiuntivo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["datoAggiuntivoID"] = this.datoAggiuntivoID !== undefined ? this.datoAggiuntivoID : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["valore"] = this.valore !== undefined ? this.valore : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["valore_fr"] = this.valore_fr !== undefined ? this.valore_fr : <any>null;
        data["valore_de"] = this.valore_de !== undefined ? this.valore_de : <any>null;
        data["valore_es"] = this.valore_es !== undefined ? this.valore_es : <any>null;
        data["valore_en"] = this.valore_en !== undefined ? this.valore_en : <any>null;
        return data;
    }
}

export interface IServizioDatoAggiuntivo {
    id?: number;
    servizioID?: number;
    datoAggiuntivoID?: number;
    tipoServizio?: ETipoServizio | null;
    valore?: string | null;
    dal?: string | null;
    al?: string | null;
    valore_fr?: string | null;
    valore_de?: string | null;
    valore_es?: string | null;
    valore_en?: string | null;
}

export class ServizioValiditaCosti implements IServizioValiditaCosti {
    servizioID?: number;
    dal?: string;
    al?: string;

    constructor(data?: IServizioValiditaCosti) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioValiditaCosti {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioValiditaCosti();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        return data;
    }
}

export interface IServizioValiditaCosti {
    servizioID?: number;
    dal?: string;
    al?: string;
}

export class PageLinkInfo implements IPageLinkInfo {
    id?: number;
    pageLink?: PageLink | null;
    luogo?: LuogoInfo | null;
    servizio?: ServizioInfo | null;
    contenuti?: PageLinkContentInfo[] | null;
    pubblicato?: boolean;

    constructor(data?: IPageLinkInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.pageLink = _data["pageLink"] ? PageLink.fromJS(_data["pageLink"]) : <any>null;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : <any>null;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : <any>null;
            if (Array.isArray(_data["contenuti"])) {
                this.contenuti = [] as any;
                for (let item of _data["contenuti"])
                    this.contenuti!.push(PageLinkContentInfo.fromJS(item));
            }
            else {
                this.contenuti = <any>null;
            }
            this.pubblicato = _data["pubblicato"] !== undefined ? _data["pubblicato"] : <any>null;
        }
    }

    static fromJS(data: any): PageLinkInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["pageLink"] = this.pageLink ? this.pageLink.toJSON() : <any>null;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        if (Array.isArray(this.contenuti)) {
            data["contenuti"] = [];
            for (let item of this.contenuti)
                data["contenuti"].push(item.toJSON());
        }
        data["pubblicato"] = this.pubblicato !== undefined ? this.pubblicato : <any>null;
        return data;
    }
}

export interface IPageLinkInfo {
    id?: number;
    pageLink?: PageLink | null;
    luogo?: LuogoInfo | null;
    servizio?: ServizioInfo | null;
    contenuti?: PageLinkContentInfo[] | null;
    pubblicato?: boolean;
}

export class PageLinkContentInfo implements IPageLinkContentInfo {
    id?: number;
    pageLinkContent?: PageLinkContent | null;
    articolo?: ArticoloInfo | null;
    isValid?: boolean;

    constructor(data?: IPageLinkContentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.pageLinkContent = _data["pageLinkContent"] ? PageLinkContent.fromJS(_data["pageLinkContent"]) : <any>null;
            this.articolo = _data["articolo"] ? ArticoloInfo.fromJS(_data["articolo"]) : <any>null;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
        }
    }

    static fromJS(data: any): PageLinkContentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PageLinkContentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["pageLinkContent"] = this.pageLinkContent ? this.pageLinkContent.toJSON() : <any>null;
        data["articolo"] = this.articolo ? this.articolo.toJSON() : <any>null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        return data;
    }
}

export interface IPageLinkContentInfo {
    id?: number;
    pageLinkContent?: PageLinkContent | null;
    articolo?: ArticoloInfo | null;
    isValid?: boolean;
}

export class ArticoloAttachmentInfo implements IArticoloAttachmentInfo {
    id?: number;
    articoloAttachment?: ArticoloAttachment;
    linkedFile?: FileInfoBase;

    constructor(data?: IArticoloAttachmentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.articoloAttachment = _data["articoloAttachment"] ? ArticoloAttachment.fromJS(_data["articoloAttachment"]) : <any>null;
            this.linkedFile = _data["linkedFile"] ? FileInfoBase.fromJS(_data["linkedFile"]) : <any>null;
        }
    }

    static fromJS(data: any): ArticoloAttachmentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloAttachmentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["articoloAttachment"] = this.articoloAttachment ? this.articoloAttachment.toJSON() : <any>null;
        data["linkedFile"] = this.linkedFile ? this.linkedFile.toJSON() : <any>null;
        return data;
    }
}

export interface IArticoloAttachmentInfo {
    id?: number;
    articoloAttachment?: ArticoloAttachment;
    linkedFile?: FileInfoBase;
}

export class ArticoloTraduzione implements IArticoloTraduzione {
    articoloID?: number;
    lingua?: ELingua;
    titolo?: string | null;
    sunto?: string | null;
    confermata?: boolean;
    ultimoAggiornamento?: string | null;

    constructor(data?: IArticoloTraduzione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : <any>null;
            this.confermata = _data["confermata"] !== undefined ? _data["confermata"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloTraduzione {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloTraduzione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["sunto"] = this.sunto !== undefined ? this.sunto : <any>null;
        data["confermata"] = this.confermata !== undefined ? this.confermata : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        return data;
    }
}

export interface IArticoloTraduzione {
    articoloID?: number;
    lingua?: ELingua;
    titolo?: string | null;
    sunto?: string | null;
    confermata?: boolean;
    ultimoAggiornamento?: string | null;
}

export class AccordoContattoInfo implements IAccordoContattoInfo {
    id?: number;
    accordoContatto?: AccordoContatto;
    accordo?: AccordoInfo | null;
    terminePagamento?: TerminePagamentoInfo | null;
    terminePagamentoBiglietteria?: TerminePagamentoInfo | null;

    constructor(data?: IAccordoContattoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.accordoContatto = _data["accordoContatto"] ? AccordoContatto.fromJS(_data["accordoContatto"]) : <any>null;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : <any>null;
            this.terminePagamento = _data["terminePagamento"] ? TerminePagamentoInfo.fromJS(_data["terminePagamento"]) : <any>null;
            this.terminePagamentoBiglietteria = _data["terminePagamentoBiglietteria"] ? TerminePagamentoInfo.fromJS(_data["terminePagamentoBiglietteria"]) : <any>null;
        }
    }

    static fromJS(data: any): AccordoContattoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoContattoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["accordoContatto"] = this.accordoContatto ? this.accordoContatto.toJSON() : <any>null;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : <any>null;
        data["terminePagamento"] = this.terminePagamento ? this.terminePagamento.toJSON() : <any>null;
        data["terminePagamentoBiglietteria"] = this.terminePagamentoBiglietteria ? this.terminePagamentoBiglietteria.toJSON() : <any>null;
        return data;
    }
}

export interface IAccordoContattoInfo {
    id?: number;
    accordoContatto?: AccordoContatto;
    accordo?: AccordoInfo | null;
    terminePagamento?: TerminePagamentoInfo | null;
    terminePagamentoBiglietteria?: TerminePagamentoInfo | null;
}

export class TerminePagamentoInfo implements ITerminePagamentoInfo {
    _Nomi?: { [key in keyof typeof ELingua]?: string; } | null;
    id?: number;
    terminePagamento?: TerminePagamento | null;
    isFactoring?: boolean;
    isAnticipato?: boolean;
    nomi?: { [key in keyof typeof ELingua]?: string; } | null;
    srtNome_it?: string | null;
    srtNome_en?: string | null;
    srtNome_fr?: string | null;
    srtNome_de?: string | null;
    srtNome_nl?: string | null;

    constructor(data?: ITerminePagamentoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["_Nomi"]) {
                this._Nomi = {} as any;
                for (let key in _data["_Nomi"]) {
                    if (_data["_Nomi"].hasOwnProperty(key))
                        (<any>this._Nomi)![key] = _data["_Nomi"][key] !== undefined ? _data["_Nomi"][key] : <any>null;
                }
            }
            else {
                this._Nomi = <any>null;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.terminePagamento = _data["terminePagamento"] ? TerminePagamento.fromJS(_data["terminePagamento"]) : <any>null;
            this.isFactoring = _data["isFactoring"] !== undefined ? _data["isFactoring"] : <any>null;
            this.isAnticipato = _data["isAnticipato"] !== undefined ? _data["isAnticipato"] : <any>null;
            if (_data["nomi"]) {
                this.nomi = {} as any;
                for (let key in _data["nomi"]) {
                    if (_data["nomi"].hasOwnProperty(key))
                        (<any>this.nomi)![key] = _data["nomi"][key] !== undefined ? _data["nomi"][key] : <any>null;
                }
            }
            else {
                this.nomi = <any>null;
            }
            this.srtNome_it = _data["srtNome_it"] !== undefined ? _data["srtNome_it"] : <any>null;
            this.srtNome_en = _data["srtNome_en"] !== undefined ? _data["srtNome_en"] : <any>null;
            this.srtNome_fr = _data["srtNome_fr"] !== undefined ? _data["srtNome_fr"] : <any>null;
            this.srtNome_de = _data["srtNome_de"] !== undefined ? _data["srtNome_de"] : <any>null;
            this.srtNome_nl = _data["srtNome_nl"] !== undefined ? _data["srtNome_nl"] : <any>null;
        }
    }

    static fromJS(data: any): TerminePagamentoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TerminePagamentoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this._Nomi) {
            data["_Nomi"] = {};
            for (let key in this._Nomi) {
                if (this._Nomi.hasOwnProperty(key))
                    (<any>data["_Nomi"])[key] = this._Nomi[key] !== undefined ? this._Nomi[key] : <any>null;
            }
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["terminePagamento"] = this.terminePagamento ? this.terminePagamento.toJSON() : <any>null;
        data["isFactoring"] = this.isFactoring !== undefined ? this.isFactoring : <any>null;
        data["isAnticipato"] = this.isAnticipato !== undefined ? this.isAnticipato : <any>null;
        if (this.nomi) {
            data["nomi"] = {};
            for (let key in this.nomi) {
                if (this.nomi.hasOwnProperty(key))
                    (<any>data["nomi"])[key] = this.nomi[key] !== undefined ? this.nomi[key] : <any>null;
            }
        }
        data["srtNome_it"] = this.srtNome_it !== undefined ? this.srtNome_it : <any>null;
        data["srtNome_en"] = this.srtNome_en !== undefined ? this.srtNome_en : <any>null;
        data["srtNome_fr"] = this.srtNome_fr !== undefined ? this.srtNome_fr : <any>null;
        data["srtNome_de"] = this.srtNome_de !== undefined ? this.srtNome_de : <any>null;
        data["srtNome_nl"] = this.srtNome_nl !== undefined ? this.srtNome_nl : <any>null;
        return data;
    }
}

export interface ITerminePagamentoInfo {
    _Nomi?: { [key in keyof typeof ELingua]?: string; } | null;
    id?: number;
    terminePagamento?: TerminePagamento | null;
    isFactoring?: boolean;
    isAnticipato?: boolean;
    nomi?: { [key in keyof typeof ELingua]?: string; } | null;
    srtNome_it?: string | null;
    srtNome_en?: string | null;
    srtNome_fr?: string | null;
    srtNome_de?: string | null;
    srtNome_nl?: string | null;
}

export class TerminePagamento implements ITerminePagamento {
    pagamentoID?: number;
    nome!: string;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    nome_nl?: string | null;
    memo?: string | null;
    visibile?: boolean | null;
    eliminato?: string | null;
    searchTerms?: string | null;

    constructor(data?: ITerminePagamento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pagamentoID = _data["pagamentoID"] !== undefined ? _data["pagamentoID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : <any>null;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : <any>null;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.nome_nl = _data["nome_nl"] !== undefined ? _data["nome_nl"] : <any>null;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : <any>null;
            this.visibile = _data["visibile"] !== undefined ? _data["visibile"] : <any>null;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : <any>null;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : <any>null;
        }
    }

    static fromJS(data: any): TerminePagamento {
        data = typeof data === 'object' ? data : {};
        let result = new TerminePagamento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagamentoID"] = this.pagamentoID !== undefined ? this.pagamentoID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : <any>null;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : <any>null;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["nome_nl"] = this.nome_nl !== undefined ? this.nome_nl : <any>null;
        data["memo"] = this.memo !== undefined ? this.memo : <any>null;
        data["visibile"] = this.visibile !== undefined ? this.visibile : <any>null;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : <any>null;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : <any>null;
        return data;
    }
}

export interface ITerminePagamento {
    pagamentoID?: number;
    nome: string;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    nome_nl?: string | null;
    memo?: string | null;
    visibile?: boolean | null;
    eliminato?: string | null;
    searchTerms?: string | null;
}

export class ContattoStatistica implements IContattoStatistica {
    contattoID?: number;
    operatore?: EOperatore;
    preventiviPassati?: number | null;
    preventiviBkgPassati?: number | null;
    confermePassate?: number | null;
    fatturatoPassato?: number | null;
    preventiviFuturi?: number | null;
    preventiviBkgFuturi?: number | null;
    confermeFuture?: number | null;
    fatturatoFuturo?: number | null;
    percentualeConfermePassate?: number | null;
    note?: string | null;

    constructor(data?: IContattoStatistica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.preventiviPassati = _data["preventiviPassati"] !== undefined ? _data["preventiviPassati"] : <any>null;
            this.preventiviBkgPassati = _data["preventiviBkgPassati"] !== undefined ? _data["preventiviBkgPassati"] : <any>null;
            this.confermePassate = _data["confermePassate"] !== undefined ? _data["confermePassate"] : <any>null;
            this.fatturatoPassato = _data["fatturatoPassato"] !== undefined ? _data["fatturatoPassato"] : <any>null;
            this.preventiviFuturi = _data["preventiviFuturi"] !== undefined ? _data["preventiviFuturi"] : <any>null;
            this.preventiviBkgFuturi = _data["preventiviBkgFuturi"] !== undefined ? _data["preventiviBkgFuturi"] : <any>null;
            this.confermeFuture = _data["confermeFuture"] !== undefined ? _data["confermeFuture"] : <any>null;
            this.fatturatoFuturo = _data["fatturatoFuturo"] !== undefined ? _data["fatturatoFuturo"] : <any>null;
            this.percentualeConfermePassate = _data["percentualeConfermePassate"] !== undefined ? _data["percentualeConfermePassate"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): ContattoStatistica {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoStatistica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["preventiviPassati"] = this.preventiviPassati !== undefined ? this.preventiviPassati : <any>null;
        data["preventiviBkgPassati"] = this.preventiviBkgPassati !== undefined ? this.preventiviBkgPassati : <any>null;
        data["confermePassate"] = this.confermePassate !== undefined ? this.confermePassate : <any>null;
        data["fatturatoPassato"] = this.fatturatoPassato !== undefined ? this.fatturatoPassato : <any>null;
        data["preventiviFuturi"] = this.preventiviFuturi !== undefined ? this.preventiviFuturi : <any>null;
        data["preventiviBkgFuturi"] = this.preventiviBkgFuturi !== undefined ? this.preventiviBkgFuturi : <any>null;
        data["confermeFuture"] = this.confermeFuture !== undefined ? this.confermeFuture : <any>null;
        data["fatturatoFuturo"] = this.fatturatoFuturo !== undefined ? this.fatturatoFuturo : <any>null;
        data["percentualeConfermePassate"] = this.percentualeConfermePassate !== undefined ? this.percentualeConfermePassate : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        return data;
    }
}

export interface IContattoStatistica {
    contattoID?: number;
    operatore?: EOperatore;
    preventiviPassati?: number | null;
    preventiviBkgPassati?: number | null;
    confermePassate?: number | null;
    fatturatoPassato?: number | null;
    preventiviFuturi?: number | null;
    preventiviBkgFuturi?: number | null;
    confermeFuture?: number | null;
    fatturatoFuturo?: number | null;
    percentualeConfermePassate?: number | null;
    note?: string | null;
}

export class ContattoOpzione implements IContattoOpzione {
    contattoID?: number;
    markupHotel?: number | null;
    markupVisite?: number | null;
    markupTrasferimenti?: number | null;
    markupAuto?: number | null;
    feeVoliNazionali?: number | null;
    feeVoliLowcost?: number | null;
    feeVoliEuropa?: number | null;
    feeVoliMondo?: number | null;

    constructor(data?: IContattoOpzione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.markupHotel = _data["markupHotel"] !== undefined ? _data["markupHotel"] : <any>null;
            this.markupVisite = _data["markupVisite"] !== undefined ? _data["markupVisite"] : <any>null;
            this.markupTrasferimenti = _data["markupTrasferimenti"] !== undefined ? _data["markupTrasferimenti"] : <any>null;
            this.markupAuto = _data["markupAuto"] !== undefined ? _data["markupAuto"] : <any>null;
            this.feeVoliNazionali = _data["feeVoliNazionali"] !== undefined ? _data["feeVoliNazionali"] : <any>null;
            this.feeVoliLowcost = _data["feeVoliLowcost"] !== undefined ? _data["feeVoliLowcost"] : <any>null;
            this.feeVoliEuropa = _data["feeVoliEuropa"] !== undefined ? _data["feeVoliEuropa"] : <any>null;
            this.feeVoliMondo = _data["feeVoliMondo"] !== undefined ? _data["feeVoliMondo"] : <any>null;
        }
    }

    static fromJS(data: any): ContattoOpzione {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoOpzione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["markupHotel"] = this.markupHotel !== undefined ? this.markupHotel : <any>null;
        data["markupVisite"] = this.markupVisite !== undefined ? this.markupVisite : <any>null;
        data["markupTrasferimenti"] = this.markupTrasferimenti !== undefined ? this.markupTrasferimenti : <any>null;
        data["markupAuto"] = this.markupAuto !== undefined ? this.markupAuto : <any>null;
        data["feeVoliNazionali"] = this.feeVoliNazionali !== undefined ? this.feeVoliNazionali : <any>null;
        data["feeVoliLowcost"] = this.feeVoliLowcost !== undefined ? this.feeVoliLowcost : <any>null;
        data["feeVoliEuropa"] = this.feeVoliEuropa !== undefined ? this.feeVoliEuropa : <any>null;
        data["feeVoliMondo"] = this.feeVoliMondo !== undefined ? this.feeVoliMondo : <any>null;
        return data;
    }
}

export interface IContattoOpzione {
    contattoID?: number;
    markupHotel?: number | null;
    markupVisite?: number | null;
    markupTrasferimenti?: number | null;
    markupAuto?: number | null;
    feeVoliNazionali?: number | null;
    feeVoliLowcost?: number | null;
    feeVoliEuropa?: number | null;
    feeVoliMondo?: number | null;
}

export class ValutaInfo implements IValutaInfo {
    id?: number;
    valuta?: Valuta;
    valoreCorrente?: ValutaValore | null;

    constructor(data?: IValutaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.valuta = _data["valuta"] ? Valuta.fromJS(_data["valuta"]) : <any>null;
            this.valoreCorrente = _data["valoreCorrente"] ? ValutaValore.fromJS(_data["valoreCorrente"]) : <any>null;
        }
    }

    static fromJS(data: any): ValutaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValutaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["valuta"] = this.valuta ? this.valuta.toJSON() : <any>null;
        data["valoreCorrente"] = this.valoreCorrente ? this.valoreCorrente.toJSON() : <any>null;
        return data;
    }
}

export interface IValutaInfo {
    id?: number;
    valuta?: Valuta;
    valoreCorrente?: ValutaValore | null;
}

export class Valuta implements IValuta {
    valutaID?: number;
    codice!: string;
    nome!: string;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    arrotondamento?: number | null;

    constructor(data?: IValuta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valutaID = _data["valutaID"] !== undefined ? _data["valutaID"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : <any>null;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : <any>null;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.arrotondamento = _data["arrotondamento"] !== undefined ? _data["arrotondamento"] : <any>null;
        }
    }

    static fromJS(data: any): Valuta {
        data = typeof data === 'object' ? data : {};
        let result = new Valuta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valutaID"] = this.valutaID !== undefined ? this.valutaID : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : <any>null;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : <any>null;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["arrotondamento"] = this.arrotondamento !== undefined ? this.arrotondamento : <any>null;
        return data;
    }
}

export interface IValuta {
    valutaID?: number;
    codice: string;
    nome: string;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    arrotondamento?: number | null;
}

export class PricingInfo implements IPricingInfo {
    id?: number;
    pricing?: Pricing;
    rules?: PricingRule[];
    operator?: OperatoreInfo | null;
    searchTerms?: string;

    constructor(data?: IPricingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.pricing = _data["pricing"] ? Pricing.fromJS(_data["pricing"]) : <any>null;
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(PricingRule.fromJS(item));
            }
            else {
                this.rules = <any>null;
            }
            this.operator = _data["operator"] ? OperatoreInfo.fromJS(_data["operator"]) : <any>null;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : <any>null;
        }
    }

    static fromJS(data: any): PricingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PricingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : <any>null;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["operator"] = this.operator ? this.operator.toJSON() : <any>null;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : <any>null;
        return data;
    }
}

export interface IPricingInfo {
    id?: number;
    pricing?: Pricing;
    rules?: PricingRule[];
    operator?: OperatoreInfo | null;
    searchTerms?: string;
}

export class PricingRule implements IPricingRule {
    id?: number;
    pricingID?: number;
    pricing?: Pricing | null;
    tripCreationFrom?: string | null;
    tripCreationTo?: string | null;
    tripDepartureFrom?: string | null;
    tripDepartureTo?: string | null;
    serviceType?: ETipoServizio | null;
    tripType?: EPriceRuleTripType;
    locationID?: number | null;
    deltaMargin?: number;
    priority?: number;

    constructor(data?: IPricingRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.pricingID = _data["pricingID"] !== undefined ? _data["pricingID"] : <any>null;
            this.pricing = _data["pricing"] ? Pricing.fromJS(_data["pricing"]) : <any>null;
            this.tripCreationFrom = _data["tripCreationFrom"] !== undefined ? _data["tripCreationFrom"] : <any>null;
            this.tripCreationTo = _data["tripCreationTo"] !== undefined ? _data["tripCreationTo"] : <any>null;
            this.tripDepartureFrom = _data["tripDepartureFrom"] !== undefined ? _data["tripDepartureFrom"] : <any>null;
            this.tripDepartureTo = _data["tripDepartureTo"] !== undefined ? _data["tripDepartureTo"] : <any>null;
            this.serviceType = _data["serviceType"] !== undefined ? _data["serviceType"] : <any>null;
            this.tripType = _data["tripType"] !== undefined ? _data["tripType"] : <any>null;
            this.locationID = _data["locationID"] !== undefined ? _data["locationID"] : <any>null;
            this.deltaMargin = _data["deltaMargin"] !== undefined ? _data["deltaMargin"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): PricingRule {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["pricingID"] = this.pricingID !== undefined ? this.pricingID : <any>null;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : <any>null;
        data["tripCreationFrom"] = this.tripCreationFrom !== undefined ? this.tripCreationFrom : <any>null;
        data["tripCreationTo"] = this.tripCreationTo !== undefined ? this.tripCreationTo : <any>null;
        data["tripDepartureFrom"] = this.tripDepartureFrom !== undefined ? this.tripDepartureFrom : <any>null;
        data["tripDepartureTo"] = this.tripDepartureTo !== undefined ? this.tripDepartureTo : <any>null;
        data["serviceType"] = this.serviceType !== undefined ? this.serviceType : <any>null;
        data["tripType"] = this.tripType !== undefined ? this.tripType : <any>null;
        data["locationID"] = this.locationID !== undefined ? this.locationID : <any>null;
        data["deltaMargin"] = this.deltaMargin !== undefined ? this.deltaMargin : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data;
    }
}

export interface IPricingRule {
    id?: number;
    pricingID?: number;
    pricing?: Pricing | null;
    tripCreationFrom?: string | null;
    tripCreationTo?: string | null;
    tripDepartureFrom?: string | null;
    tripDepartureTo?: string | null;
    serviceType?: ETipoServizio | null;
    tripType?: EPriceRuleTripType;
    locationID?: number | null;
    deltaMargin?: number;
    priority?: number;
}

export enum EPriceRuleTripType {
    All = "All",
    TailorMade = "TailorMade",
    Packages = "Packages",
}

export class TagOffertaInfo implements ITagOffertaInfo {
    id?: number;
    tag?: TagOfferta;
    eliminato?: boolean;
    sortName_it?: string;
    sortName_en?: string;
    sortName_fr?: string;
    sortName_de?: string;

    constructor(data?: ITagOffertaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tag = _data["tag"] ? TagOfferta.fromJS(_data["tag"]) : <any>null;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : <any>null;
            this.sortName_it = _data["sortName_it"] !== undefined ? _data["sortName_it"] : <any>null;
            this.sortName_en = _data["sortName_en"] !== undefined ? _data["sortName_en"] : <any>null;
            this.sortName_fr = _data["sortName_fr"] !== undefined ? _data["sortName_fr"] : <any>null;
            this.sortName_de = _data["sortName_de"] !== undefined ? _data["sortName_de"] : <any>null;
        }
    }

    static fromJS(data: any): TagOffertaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TagOffertaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>null;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : <any>null;
        data["sortName_it"] = this.sortName_it !== undefined ? this.sortName_it : <any>null;
        data["sortName_en"] = this.sortName_en !== undefined ? this.sortName_en : <any>null;
        data["sortName_fr"] = this.sortName_fr !== undefined ? this.sortName_fr : <any>null;
        data["sortName_de"] = this.sortName_de !== undefined ? this.sortName_de : <any>null;
        return data;
    }
}

export interface ITagOffertaInfo {
    id?: number;
    tag?: TagOfferta;
    eliminato?: boolean;
    sortName_it?: string;
    sortName_en?: string;
    sortName_fr?: string;
    sortName_de?: string;
}

export class TagOfferta implements ITagOfferta {
    id?: number;
    tag!: string;
    tag_en?: string | null;
    tag_fr?: string | null;
    tag_de?: string | null;
    tag_nl?: string | null;
    tag_es?: string | null;
    sistema?: boolean;
    uiOptions?: string | null;
    creato?: string;
    aggiornato?: string;
    eliminato?: string | null;

    constructor(data?: ITagOfferta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            this.tag_en = _data["tag_en"] !== undefined ? _data["tag_en"] : <any>null;
            this.tag_fr = _data["tag_fr"] !== undefined ? _data["tag_fr"] : <any>null;
            this.tag_de = _data["tag_de"] !== undefined ? _data["tag_de"] : <any>null;
            this.tag_nl = _data["tag_nl"] !== undefined ? _data["tag_nl"] : <any>null;
            this.tag_es = _data["tag_es"] !== undefined ? _data["tag_es"] : <any>null;
            this.sistema = _data["sistema"] !== undefined ? _data["sistema"] : <any>null;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : <any>null;
            this.creato = _data["creato"] !== undefined ? _data["creato"] : <any>null;
            this.aggiornato = _data["aggiornato"] !== undefined ? _data["aggiornato"] : <any>null;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : <any>null;
        }
    }

    static fromJS(data: any): TagOfferta {
        data = typeof data === 'object' ? data : {};
        let result = new TagOfferta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        data["tag_en"] = this.tag_en !== undefined ? this.tag_en : <any>null;
        data["tag_fr"] = this.tag_fr !== undefined ? this.tag_fr : <any>null;
        data["tag_de"] = this.tag_de !== undefined ? this.tag_de : <any>null;
        data["tag_nl"] = this.tag_nl !== undefined ? this.tag_nl : <any>null;
        data["tag_es"] = this.tag_es !== undefined ? this.tag_es : <any>null;
        data["sistema"] = this.sistema !== undefined ? this.sistema : <any>null;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : <any>null;
        data["creato"] = this.creato !== undefined ? this.creato : <any>null;
        data["aggiornato"] = this.aggiornato !== undefined ? this.aggiornato : <any>null;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : <any>null;
        return data;
    }
}

export interface ITagOfferta {
    id?: number;
    tag: string;
    tag_en?: string | null;
    tag_fr?: string | null;
    tag_de?: string | null;
    tag_nl?: string | null;
    tag_es?: string | null;
    sistema?: boolean;
    uiOptions?: string | null;
    creato?: string;
    aggiornato?: string;
    eliminato?: string | null;
}

export class UtenteInfo implements IUtenteInfo {
    id?: number;
    utente?: Utente;
    tipoUtente?: ETipoUtente;
    ultimaRichiesta?: string;
    username?: string;
    email?: string | null;
    nomeVisualizzato?: string;
    srtContattoAgenzia?: string | null;
    contattoUtente?: ContattoInfo;
    contattoAgenzia?: ContattoInfo | null;
    categoria?: CategoriaContatto | null;
    ruoli?: RuoloUtente[];
    isIntranet?: boolean;
    isDev?: boolean;
    isProduttore?: boolean;
    canBookFlights?: boolean;
    searchTerms?: string;
    permessi?: Permesso[];
    permessiCodici?: string[];
    uiOptions?: any;
    team?: TeamInfo | null;
    lingua?: ELingua | null;
    commissioneWebAgenzia?: number;

    constructor(data?: IUtenteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.utente = _data["utente"] ? Utente.fromJS(_data["utente"]) : <any>null;
            this.tipoUtente = _data["tipoUtente"] !== undefined ? _data["tipoUtente"] : <any>null;
            this.ultimaRichiesta = _data["ultimaRichiesta"] !== undefined ? _data["ultimaRichiesta"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : <any>null;
            this.srtContattoAgenzia = _data["srtContattoAgenzia"] !== undefined ? _data["srtContattoAgenzia"] : <any>null;
            this.contattoUtente = _data["contattoUtente"] ? ContattoInfo.fromJS(_data["contattoUtente"]) : <any>null;
            this.contattoAgenzia = _data["contattoAgenzia"] ? ContattoInfo.fromJS(_data["contattoAgenzia"]) : <any>null;
            this.categoria = _data["categoria"] ? CategoriaContatto.fromJS(_data["categoria"]) : <any>null;
            if (Array.isArray(_data["ruoli"])) {
                this.ruoli = [] as any;
                for (let item of _data["ruoli"])
                    this.ruoli!.push(RuoloUtente.fromJS(item));
            }
            else {
                this.ruoli = <any>null;
            }
            this.isIntranet = _data["isIntranet"] !== undefined ? _data["isIntranet"] : <any>null;
            this.isDev = _data["isDev"] !== undefined ? _data["isDev"] : <any>null;
            this.isProduttore = _data["isProduttore"] !== undefined ? _data["isProduttore"] : <any>null;
            this.canBookFlights = _data["canBookFlights"] !== undefined ? _data["canBookFlights"] : <any>null;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : <any>null;
            if (Array.isArray(_data["permessi"])) {
                this.permessi = [] as any;
                for (let item of _data["permessi"])
                    this.permessi!.push(Permesso.fromJS(item));
            }
            else {
                this.permessi = <any>null;
            }
            if (Array.isArray(_data["permessiCodici"])) {
                this.permessiCodici = [] as any;
                for (let item of _data["permessiCodici"])
                    this.permessiCodici!.push(item);
            }
            else {
                this.permessiCodici = <any>null;
            }
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : <any>null;
            this.team = _data["team"] ? TeamInfo.fromJS(_data["team"]) : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.commissioneWebAgenzia = _data["commissioneWebAgenzia"] !== undefined ? _data["commissioneWebAgenzia"] : <any>null;
        }
    }

    static fromJS(data: any): UtenteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UtenteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["utente"] = this.utente ? this.utente.toJSON() : <any>null;
        data["tipoUtente"] = this.tipoUtente !== undefined ? this.tipoUtente : <any>null;
        data["ultimaRichiesta"] = this.ultimaRichiesta !== undefined ? this.ultimaRichiesta : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : <any>null;
        data["srtContattoAgenzia"] = this.srtContattoAgenzia !== undefined ? this.srtContattoAgenzia : <any>null;
        data["contattoUtente"] = this.contattoUtente ? this.contattoUtente.toJSON() : <any>null;
        data["contattoAgenzia"] = this.contattoAgenzia ? this.contattoAgenzia.toJSON() : <any>null;
        data["categoria"] = this.categoria ? this.categoria.toJSON() : <any>null;
        if (Array.isArray(this.ruoli)) {
            data["ruoli"] = [];
            for (let item of this.ruoli)
                data["ruoli"].push(item.toJSON());
        }
        data["isIntranet"] = this.isIntranet !== undefined ? this.isIntranet : <any>null;
        data["isDev"] = this.isDev !== undefined ? this.isDev : <any>null;
        data["isProduttore"] = this.isProduttore !== undefined ? this.isProduttore : <any>null;
        data["canBookFlights"] = this.canBookFlights !== undefined ? this.canBookFlights : <any>null;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : <any>null;
        if (Array.isArray(this.permessi)) {
            data["permessi"] = [];
            for (let item of this.permessi)
                data["permessi"].push(item.toJSON());
        }
        if (Array.isArray(this.permessiCodici)) {
            data["permessiCodici"] = [];
            for (let item of this.permessiCodici)
                data["permessiCodici"].push(item);
        }
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : <any>null;
        data["team"] = this.team ? this.team.toJSON() : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["commissioneWebAgenzia"] = this.commissioneWebAgenzia !== undefined ? this.commissioneWebAgenzia : <any>null;
        return data;
    }
}

export interface IUtenteInfo {
    id?: number;
    utente?: Utente;
    tipoUtente?: ETipoUtente;
    ultimaRichiesta?: string;
    username?: string;
    email?: string | null;
    nomeVisualizzato?: string;
    srtContattoAgenzia?: string | null;
    contattoUtente?: ContattoInfo;
    contattoAgenzia?: ContattoInfo | null;
    categoria?: CategoriaContatto | null;
    ruoli?: RuoloUtente[];
    isIntranet?: boolean;
    isDev?: boolean;
    isProduttore?: boolean;
    canBookFlights?: boolean;
    searchTerms?: string;
    permessi?: Permesso[];
    permessiCodici?: string[];
    uiOptions?: any;
    team?: TeamInfo | null;
    lingua?: ELingua | null;
    commissioneWebAgenzia?: number;
}

export class RuoloUtente implements IRuoloUtente {
    id?: number;
    utenteID?: number;
    ruoloID?: number;

    constructor(data?: IRuoloUtente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.utenteID = _data["utenteID"] !== undefined ? _data["utenteID"] : <any>null;
            this.ruoloID = _data["ruoloID"] !== undefined ? _data["ruoloID"] : <any>null;
        }
    }

    static fromJS(data: any): RuoloUtente {
        data = typeof data === 'object' ? data : {};
        let result = new RuoloUtente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["utenteID"] = this.utenteID !== undefined ? this.utenteID : <any>null;
        data["ruoloID"] = this.ruoloID !== undefined ? this.ruoloID : <any>null;
        return data;
    }
}

export interface IRuoloUtente {
    id?: number;
    utenteID?: number;
    ruoloID?: number;
}

export class Permesso implements IPermesso {
    id?: number;
    categoriaID?: number;
    descrizione!: string;
    codice!: string;

    constructor(data?: IPermesso) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.categoriaID = _data["categoriaID"] !== undefined ? _data["categoriaID"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
        }
    }

    static fromJS(data: any): Permesso {
        data = typeof data === 'object' ? data : {};
        let result = new Permesso();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["categoriaID"] = this.categoriaID !== undefined ? this.categoriaID : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        return data;
    }
}

export interface IPermesso {
    id?: number;
    categoriaID?: number;
    descrizione: string;
    codice: string;
}

export class TeamInfo implements ITeamInfo {
    id?: string;
    team?: Team;

    constructor(data?: ITeamInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.team = _data["team"] ? Team.fromJS(_data["team"]) : <any>null;
        }
    }

    static fromJS(data: any): TeamInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TeamInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["team"] = this.team ? this.team.toJSON() : <any>null;
        return data;
    }
}

export interface ITeamInfo {
    id?: string;
    team?: Team;
}

export class Team implements ITeam {
    teamID!: string;
    nome!: string;
    email?: string | null;
    idTeam?: number;
    visibilita?: EVisibilitaTeam;
    operatore?: EOperatore;

    constructor(data?: ITeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.idTeam = _data["idTeam"] !== undefined ? _data["idTeam"] : <any>null;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
        }
    }

    static fromJS(data: any): Team {
        data = typeof data === 'object' ? data : {};
        let result = new Team();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamID"] = this.teamID !== undefined ? this.teamID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["idTeam"] = this.idTeam !== undefined ? this.idTeam : <any>null;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        return data;
    }
}

export interface ITeam {
    teamID: string;
    nome: string;
    email?: string | null;
    idTeam?: number;
    visibilita?: EVisibilitaTeam;
    operatore?: EOperatore;
}

export class ItinerarioOffertaInfo implements IItinerarioOffertaInfo {
    id?: number;
    itinerario?: OffertaItinerario;
    offerta?: OffertaInfo;
    itinerarioPackage?: ServizioItinerarioGiornoInfo | null;
    ordine?: number;
    dal?: string | null;
    localDal?: string | null;
    al?: string | null;
    localAl?: string | null;
    itinerarioAccessori?: boolean;
    luogo?: LuogoInfo;
    aeroporto?: Aeroporto | null;
    aeroportoPartenza?: Aeroporto | null;
    righe?: OffertaDatoInfo[];
    servizioCollegato?: ServizioInfo | null;
    servizioHotelCollegato?: ServizioInfo | null;
    tipologiaCollegata?: ServizioTipologia | null;
    itinerariSovrapposti?: ItinerarioOffertaInfo[];
    giorniMancantiPrima?: number;
    modificabile?: boolean;
    eliminabile?: boolean;
    haHotel?: boolean;
    haHotelTuttiIGiorni?: boolean;

    constructor(data?: IItinerarioOffertaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.itinerario = _data["itinerario"] ? OffertaItinerario.fromJS(_data["itinerario"]) : <any>null;
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : <any>null;
            this.itinerarioPackage = _data["itinerarioPackage"] ? ServizioItinerarioGiornoInfo.fromJS(_data["itinerarioPackage"]) : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.localDal = _data["localDal"] !== undefined ? _data["localDal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.localAl = _data["localAl"] !== undefined ? _data["localAl"] : <any>null;
            this.itinerarioAccessori = _data["itinerarioAccessori"] !== undefined ? _data["itinerarioAccessori"] : <any>null;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : <any>null;
            this.aeroporto = _data["aeroporto"] ? Aeroporto.fromJS(_data["aeroporto"]) : <any>null;
            this.aeroportoPartenza = _data["aeroportoPartenza"] ? Aeroporto.fromJS(_data["aeroportoPartenza"]) : <any>null;
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(OffertaDatoInfo.fromJS(item));
            }
            else {
                this.righe = <any>null;
            }
            this.servizioCollegato = _data["servizioCollegato"] ? ServizioInfo.fromJS(_data["servizioCollegato"]) : <any>null;
            this.servizioHotelCollegato = _data["servizioHotelCollegato"] ? ServizioInfo.fromJS(_data["servizioHotelCollegato"]) : <any>null;
            this.tipologiaCollegata = _data["tipologiaCollegata"] ? ServizioTipologia.fromJS(_data["tipologiaCollegata"]) : <any>null;
            if (Array.isArray(_data["itinerariSovrapposti"])) {
                this.itinerariSovrapposti = [] as any;
                for (let item of _data["itinerariSovrapposti"])
                    this.itinerariSovrapposti!.push(ItinerarioOffertaInfo.fromJS(item));
            }
            else {
                this.itinerariSovrapposti = <any>null;
            }
            this.giorniMancantiPrima = _data["giorniMancantiPrima"] !== undefined ? _data["giorniMancantiPrima"] : <any>null;
            this.modificabile = _data["modificabile"] !== undefined ? _data["modificabile"] : <any>null;
            this.eliminabile = _data["eliminabile"] !== undefined ? _data["eliminabile"] : <any>null;
            this.haHotel = _data["haHotel"] !== undefined ? _data["haHotel"] : <any>null;
            this.haHotelTuttiIGiorni = _data["haHotelTuttiIGiorni"] !== undefined ? _data["haHotelTuttiIGiorni"] : <any>null;
        }
    }

    static fromJS(data: any): ItinerarioOffertaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ItinerarioOffertaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : <any>null;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        data["itinerarioPackage"] = this.itinerarioPackage ? this.itinerarioPackage.toJSON() : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["localDal"] = this.localDal !== undefined ? this.localDal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["localAl"] = this.localAl !== undefined ? this.localAl : <any>null;
        data["itinerarioAccessori"] = this.itinerarioAccessori !== undefined ? this.itinerarioAccessori : <any>null;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        data["aeroporto"] = this.aeroporto ? this.aeroporto.toJSON() : <any>null;
        data["aeroportoPartenza"] = this.aeroportoPartenza ? this.aeroportoPartenza.toJSON() : <any>null;
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item.toJSON());
        }
        data["servizioCollegato"] = this.servizioCollegato ? this.servizioCollegato.toJSON() : <any>null;
        data["servizioHotelCollegato"] = this.servizioHotelCollegato ? this.servizioHotelCollegato.toJSON() : <any>null;
        data["tipologiaCollegata"] = this.tipologiaCollegata ? this.tipologiaCollegata.toJSON() : <any>null;
        if (Array.isArray(this.itinerariSovrapposti)) {
            data["itinerariSovrapposti"] = [];
            for (let item of this.itinerariSovrapposti)
                data["itinerariSovrapposti"].push(item.toJSON());
        }
        data["giorniMancantiPrima"] = this.giorniMancantiPrima !== undefined ? this.giorniMancantiPrima : <any>null;
        data["modificabile"] = this.modificabile !== undefined ? this.modificabile : <any>null;
        data["eliminabile"] = this.eliminabile !== undefined ? this.eliminabile : <any>null;
        data["haHotel"] = this.haHotel !== undefined ? this.haHotel : <any>null;
        data["haHotelTuttiIGiorni"] = this.haHotelTuttiIGiorni !== undefined ? this.haHotelTuttiIGiorni : <any>null;
        return data;
    }
}

export interface IItinerarioOffertaInfo {
    id?: number;
    itinerario?: OffertaItinerario;
    offerta?: OffertaInfo;
    itinerarioPackage?: ServizioItinerarioGiornoInfo | null;
    ordine?: number;
    dal?: string | null;
    localDal?: string | null;
    al?: string | null;
    localAl?: string | null;
    itinerarioAccessori?: boolean;
    luogo?: LuogoInfo;
    aeroporto?: Aeroporto | null;
    aeroportoPartenza?: Aeroporto | null;
    righe?: OffertaDatoInfo[];
    servizioCollegato?: ServizioInfo | null;
    servizioHotelCollegato?: ServizioInfo | null;
    tipologiaCollegata?: ServizioTipologia | null;
    itinerariSovrapposti?: ItinerarioOffertaInfo[];
    giorniMancantiPrima?: number;
    modificabile?: boolean;
    eliminabile?: boolean;
    haHotel?: boolean;
    haHotelTuttiIGiorni?: boolean;
}

export class OffertaDatoInfo implements IOffertaDatoInfo {
    id?: number;
    rigaParentID?: number | null;
    offertaDato?: OffertaDato | null;
    stato?: OffertaDatoStato | null;
    offerta?: OffertaInfo | null;
    totaleCommissione?: number;
    inviiAssicurazioneFilodiretto?: InvioAssicurazioneFiloDiretto[] | null;
    inviiAssicurazione?: InvioAssicurazione[] | null;
    tipoRiga?: ETipoRiga;
    statoUtente?: EStatoServizioUtente;
    disponibilita?: EStatoDisponibilita;
    disponibilitaPrecedente?: EStatoDisponibilita;
    servizioIdUnivoco?: string | null;
    pagamentoAnticipato?: boolean;
    score?: number;
    datiDocumento?: DatiDocumentoRiga | null;
    datiConferma?: DatiConfermaRiga | null;
    regolaAnticipoFornitore?: ServizioAnticipoFornitoreInfo | null;
    anticipoFornitore?: AnticipoFornitore | null;
    prezziDisponibilitaVariati?: boolean;
    dettagli?: OffertaDatoDettaglio[] | null;
    servizioNonMappato?: boolean;
    righeSupplemento?: OffertaDatoInfo[] | null;
    noteAssociate?: OffertaNotaInfo[] | null;
    notaPenaleFornitore?: OffertaNotaInfo | null;
    notaPenaleCustom?: OffertaNotaInfo | null;
    accordo?: AccordoInfo | null;
    contattoServizioAggregato?: ContattoInfo | null;
    tabellaCostiCommissioni?: TabellaCostiCommissioniInfo | null;
    valuta?: ValutaInfo | null;
    servizio?: ServizioInfo | null;
    tipologia?: ServizioTipologia | null;
    tipologiaInfo?: ServizioTipologiaInfo | null;
    cliente?: ClienteInfo | null;
    costo?: Costo | null;
    prezzoIndicativo?: boolean;
    tipoPenale?: PenaleInfo | null;
    penale?: PenaleServizio | null;
    articoloPenale?: ArticoloInfo | null;
    codicePrenotazione?: string | null;
    sistemazione?: SistemazioneInfo | null;
    trattamento?: TrattamentoInfo | null;
    nomeServizioVoucher?: string | null;
    descrizioneServizioVoucher?: string | null;
    nomeSistemazioneVoucher?: string | null;
    nomeCameraVoucher?: string | null;
    ordineServizio?: number;
    hhCodiceID?: number | null;
    hashcode?: string | null;
    tipologiaH2H?: HHCodice | null;
    servizioH2H?: HHServizioAggregato | null;
    codiceServizioH2H?: string | null;
    codiceTipologiaH2H?: string | null;
    outputCustomData?: string | null;
    isVolo?: boolean;
    isVoloIP?: boolean;
    isVoloTO?: boolean;
    isSupplemento?: boolean;
    isRinunciaPeaceOfMind?: boolean;
    isPeaceOfMind?: boolean;
    itinerario?: ItinerarioOffertaInfo | null;
    itinerarioTour?: ServizioItinerarioInfo | null;
    luogoInizio?: LuogoInfo | null;
    luogoFine?: LuogoInfo | null;
    abbinamento?: AbbinamentoInfo | null;
    data?: string;
    dataCheckout?: string | null;
    notti?: number | null;
    prezzoPrecedente?: number;
    prezzoTotale?: number;
    prezzoTotaleNetto?: number;
    costoTotale?: number;
    costoTotaleEuro?: number;
    costoTotaleNetto?: number;
    tipoAcconto?: ETipoAcconto;
    tipoImportoAcconto?: ETipoImportoAcconto | null;
    dataAcconto?: string | null;
    totaleDaAnticipare?: number;
    marginePercentuale?: number;
    commissionePercentuale?: number;
    nettoIva?: boolean;
    nonVisibileADV?: boolean;
    totaleCommissioneTO?: number;

    constructor(data?: IOffertaDatoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.rigaParentID = _data["rigaParentID"] !== undefined ? _data["rigaParentID"] : <any>null;
            this.offertaDato = _data["offertaDato"] ? OffertaDato.fromJS(_data["offertaDato"]) : <any>null;
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : <any>null;
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : <any>null;
            this.totaleCommissione = _data["totaleCommissione"] !== undefined ? _data["totaleCommissione"] : <any>null;
            if (Array.isArray(_data["inviiAssicurazioneFilodiretto"])) {
                this.inviiAssicurazioneFilodiretto = [] as any;
                for (let item of _data["inviiAssicurazioneFilodiretto"])
                    this.inviiAssicurazioneFilodiretto!.push(InvioAssicurazioneFiloDiretto.fromJS(item));
            }
            else {
                this.inviiAssicurazioneFilodiretto = <any>null;
            }
            if (Array.isArray(_data["inviiAssicurazione"])) {
                this.inviiAssicurazione = [] as any;
                for (let item of _data["inviiAssicurazione"])
                    this.inviiAssicurazione!.push(InvioAssicurazione.fromJS(item));
            }
            else {
                this.inviiAssicurazione = <any>null;
            }
            this.tipoRiga = _data["tipoRiga"] !== undefined ? _data["tipoRiga"] : <any>null;
            this.statoUtente = _data["statoUtente"] !== undefined ? _data["statoUtente"] : <any>null;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : <any>null;
            this.disponibilitaPrecedente = _data["disponibilitaPrecedente"] !== undefined ? _data["disponibilitaPrecedente"] : <any>null;
            this.servizioIdUnivoco = _data["servizioIdUnivoco"] !== undefined ? _data["servizioIdUnivoco"] : <any>null;
            this.pagamentoAnticipato = _data["pagamentoAnticipato"] !== undefined ? _data["pagamentoAnticipato"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
            this.datiDocumento = _data["datiDocumento"] ? DatiDocumentoRiga.fromJS(_data["datiDocumento"]) : <any>null;
            this.datiConferma = _data["datiConferma"] ? DatiConfermaRiga.fromJS(_data["datiConferma"]) : <any>null;
            this.regolaAnticipoFornitore = _data["regolaAnticipoFornitore"] ? ServizioAnticipoFornitoreInfo.fromJS(_data["regolaAnticipoFornitore"]) : <any>null;
            this.anticipoFornitore = _data["anticipoFornitore"] ? AnticipoFornitore.fromJS(_data["anticipoFornitore"]) : <any>null;
            this.prezziDisponibilitaVariati = _data["prezziDisponibilitaVariati"] !== undefined ? _data["prezziDisponibilitaVariati"] : <any>null;
            if (Array.isArray(_data["dettagli"])) {
                this.dettagli = [] as any;
                for (let item of _data["dettagli"])
                    this.dettagli!.push(OffertaDatoDettaglio.fromJS(item));
            }
            else {
                this.dettagli = <any>null;
            }
            this.servizioNonMappato = _data["servizioNonMappato"] !== undefined ? _data["servizioNonMappato"] : <any>null;
            if (Array.isArray(_data["righeSupplemento"])) {
                this.righeSupplemento = [] as any;
                for (let item of _data["righeSupplemento"])
                    this.righeSupplemento!.push(OffertaDatoInfo.fromJS(item));
            }
            else {
                this.righeSupplemento = <any>null;
            }
            if (Array.isArray(_data["noteAssociate"])) {
                this.noteAssociate = [] as any;
                for (let item of _data["noteAssociate"])
                    this.noteAssociate!.push(OffertaNotaInfo.fromJS(item));
            }
            else {
                this.noteAssociate = <any>null;
            }
            this.notaPenaleFornitore = _data["notaPenaleFornitore"] ? OffertaNotaInfo.fromJS(_data["notaPenaleFornitore"]) : <any>null;
            this.notaPenaleCustom = _data["notaPenaleCustom"] ? OffertaNotaInfo.fromJS(_data["notaPenaleCustom"]) : <any>null;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : <any>null;
            this.contattoServizioAggregato = _data["contattoServizioAggregato"] ? ContattoInfo.fromJS(_data["contattoServizioAggregato"]) : <any>null;
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] ? TabellaCostiCommissioniInfo.fromJS(_data["tabellaCostiCommissioni"]) : <any>null;
            this.valuta = _data["valuta"] ? ValutaInfo.fromJS(_data["valuta"]) : <any>null;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : <any>null;
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : <any>null;
            this.tipologiaInfo = _data["tipologiaInfo"] ? ServizioTipologiaInfo.fromJS(_data["tipologiaInfo"]) : <any>null;
            this.cliente = _data["cliente"] ? ClienteInfo.fromJS(_data["cliente"]) : <any>null;
            this.costo = _data["costo"] ? Costo.fromJS(_data["costo"]) : <any>null;
            this.prezzoIndicativo = _data["prezzoIndicativo"] !== undefined ? _data["prezzoIndicativo"] : <any>null;
            this.tipoPenale = _data["tipoPenale"] ? PenaleInfo.fromJS(_data["tipoPenale"]) : <any>null;
            this.penale = _data["penale"] ? PenaleServizio.fromJS(_data["penale"]) : <any>null;
            this.articoloPenale = _data["articoloPenale"] ? ArticoloInfo.fromJS(_data["articoloPenale"]) : <any>null;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : <any>null;
            this.sistemazione = _data["sistemazione"] ? SistemazioneInfo.fromJS(_data["sistemazione"]) : <any>null;
            this.trattamento = _data["trattamento"] ? TrattamentoInfo.fromJS(_data["trattamento"]) : <any>null;
            this.nomeServizioVoucher = _data["nomeServizioVoucher"] !== undefined ? _data["nomeServizioVoucher"] : <any>null;
            this.descrizioneServizioVoucher = _data["descrizioneServizioVoucher"] !== undefined ? _data["descrizioneServizioVoucher"] : <any>null;
            this.nomeSistemazioneVoucher = _data["nomeSistemazioneVoucher"] !== undefined ? _data["nomeSistemazioneVoucher"] : <any>null;
            this.nomeCameraVoucher = _data["nomeCameraVoucher"] !== undefined ? _data["nomeCameraVoucher"] : <any>null;
            this.ordineServizio = _data["ordineServizio"] !== undefined ? _data["ordineServizio"] : <any>null;
            this.hhCodiceID = _data["hhCodiceID"] !== undefined ? _data["hhCodiceID"] : <any>null;
            this.hashcode = _data["hashcode"] !== undefined ? _data["hashcode"] : <any>null;
            this.tipologiaH2H = _data["tipologiaH2H"] ? HHCodice.fromJS(_data["tipologiaH2H"]) : <any>null;
            this.servizioH2H = _data["servizioH2H"] ? HHServizioAggregato.fromJS(_data["servizioH2H"]) : <any>null;
            this.codiceServizioH2H = _data["codiceServizioH2H"] !== undefined ? _data["codiceServizioH2H"] : <any>null;
            this.codiceTipologiaH2H = _data["codiceTipologiaH2H"] !== undefined ? _data["codiceTipologiaH2H"] : <any>null;
            this.outputCustomData = _data["outputCustomData"] !== undefined ? _data["outputCustomData"] : <any>null;
            this.isVolo = _data["isVolo"] !== undefined ? _data["isVolo"] : <any>null;
            this.isVoloIP = _data["isVoloIP"] !== undefined ? _data["isVoloIP"] : <any>null;
            this.isVoloTO = _data["isVoloTO"] !== undefined ? _data["isVoloTO"] : <any>null;
            this.isSupplemento = _data["isSupplemento"] !== undefined ? _data["isSupplemento"] : <any>null;
            this.isRinunciaPeaceOfMind = _data["isRinunciaPeaceOfMind"] !== undefined ? _data["isRinunciaPeaceOfMind"] : <any>null;
            this.isPeaceOfMind = _data["isPeaceOfMind"] !== undefined ? _data["isPeaceOfMind"] : <any>null;
            this.itinerario = _data["itinerario"] ? ItinerarioOffertaInfo.fromJS(_data["itinerario"]) : <any>null;
            this.itinerarioTour = _data["itinerarioTour"] ? ServizioItinerarioInfo.fromJS(_data["itinerarioTour"]) : <any>null;
            this.luogoInizio = _data["luogoInizio"] ? LuogoInfo.fromJS(_data["luogoInizio"]) : <any>null;
            this.luogoFine = _data["luogoFine"] ? LuogoInfo.fromJS(_data["luogoFine"]) : <any>null;
            this.abbinamento = _data["abbinamento"] ? AbbinamentoInfo.fromJS(_data["abbinamento"]) : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.dataCheckout = _data["dataCheckout"] !== undefined ? _data["dataCheckout"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            this.prezzoPrecedente = _data["prezzoPrecedente"] !== undefined ? _data["prezzoPrecedente"] : <any>null;
            this.prezzoTotale = _data["prezzoTotale"] !== undefined ? _data["prezzoTotale"] : <any>null;
            this.prezzoTotaleNetto = _data["prezzoTotaleNetto"] !== undefined ? _data["prezzoTotaleNetto"] : <any>null;
            this.costoTotale = _data["costoTotale"] !== undefined ? _data["costoTotale"] : <any>null;
            this.costoTotaleEuro = _data["costoTotaleEuro"] !== undefined ? _data["costoTotaleEuro"] : <any>null;
            this.costoTotaleNetto = _data["costoTotaleNetto"] !== undefined ? _data["costoTotaleNetto"] : <any>null;
            this.tipoAcconto = _data["tipoAcconto"] !== undefined ? _data["tipoAcconto"] : <any>null;
            this.tipoImportoAcconto = _data["tipoImportoAcconto"] !== undefined ? _data["tipoImportoAcconto"] : <any>null;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : <any>null;
            this.totaleDaAnticipare = _data["totaleDaAnticipare"] !== undefined ? _data["totaleDaAnticipare"] : <any>null;
            this.marginePercentuale = _data["marginePercentuale"] !== undefined ? _data["marginePercentuale"] : <any>null;
            this.commissionePercentuale = _data["commissionePercentuale"] !== undefined ? _data["commissionePercentuale"] : <any>null;
            this.nettoIva = _data["nettoIva"] !== undefined ? _data["nettoIva"] : <any>null;
            this.nonVisibileADV = _data["nonVisibileADV"] !== undefined ? _data["nonVisibileADV"] : <any>null;
            this.totaleCommissioneTO = _data["totaleCommissioneTO"] !== undefined ? _data["totaleCommissioneTO"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaDatoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDatoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["rigaParentID"] = this.rigaParentID !== undefined ? this.rigaParentID : <any>null;
        data["offertaDato"] = this.offertaDato ? this.offertaDato.toJSON() : <any>null;
        data["stato"] = this.stato ? this.stato.toJSON() : <any>null;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        data["totaleCommissione"] = this.totaleCommissione !== undefined ? this.totaleCommissione : <any>null;
        if (Array.isArray(this.inviiAssicurazioneFilodiretto)) {
            data["inviiAssicurazioneFilodiretto"] = [];
            for (let item of this.inviiAssicurazioneFilodiretto)
                data["inviiAssicurazioneFilodiretto"].push(item.toJSON());
        }
        if (Array.isArray(this.inviiAssicurazione)) {
            data["inviiAssicurazione"] = [];
            for (let item of this.inviiAssicurazione)
                data["inviiAssicurazione"].push(item.toJSON());
        }
        data["tipoRiga"] = this.tipoRiga !== undefined ? this.tipoRiga : <any>null;
        data["statoUtente"] = this.statoUtente !== undefined ? this.statoUtente : <any>null;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : <any>null;
        data["disponibilitaPrecedente"] = this.disponibilitaPrecedente !== undefined ? this.disponibilitaPrecedente : <any>null;
        data["servizioIdUnivoco"] = this.servizioIdUnivoco !== undefined ? this.servizioIdUnivoco : <any>null;
        data["pagamentoAnticipato"] = this.pagamentoAnticipato !== undefined ? this.pagamentoAnticipato : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        data["datiDocumento"] = this.datiDocumento ? this.datiDocumento.toJSON() : <any>null;
        data["datiConferma"] = this.datiConferma ? this.datiConferma.toJSON() : <any>null;
        data["regolaAnticipoFornitore"] = this.regolaAnticipoFornitore ? this.regolaAnticipoFornitore.toJSON() : <any>null;
        data["anticipoFornitore"] = this.anticipoFornitore ? this.anticipoFornitore.toJSON() : <any>null;
        data["prezziDisponibilitaVariati"] = this.prezziDisponibilitaVariati !== undefined ? this.prezziDisponibilitaVariati : <any>null;
        if (Array.isArray(this.dettagli)) {
            data["dettagli"] = [];
            for (let item of this.dettagli)
                data["dettagli"].push(item.toJSON());
        }
        data["servizioNonMappato"] = this.servizioNonMappato !== undefined ? this.servizioNonMappato : <any>null;
        if (Array.isArray(this.righeSupplemento)) {
            data["righeSupplemento"] = [];
            for (let item of this.righeSupplemento)
                data["righeSupplemento"].push(item.toJSON());
        }
        if (Array.isArray(this.noteAssociate)) {
            data["noteAssociate"] = [];
            for (let item of this.noteAssociate)
                data["noteAssociate"].push(item.toJSON());
        }
        data["notaPenaleFornitore"] = this.notaPenaleFornitore ? this.notaPenaleFornitore.toJSON() : <any>null;
        data["notaPenaleCustom"] = this.notaPenaleCustom ? this.notaPenaleCustom.toJSON() : <any>null;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : <any>null;
        data["contattoServizioAggregato"] = this.contattoServizioAggregato ? this.contattoServizioAggregato.toJSON() : <any>null;
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni ? this.tabellaCostiCommissioni.toJSON() : <any>null;
        data["valuta"] = this.valuta ? this.valuta.toJSON() : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : <any>null;
        data["tipologiaInfo"] = this.tipologiaInfo ? this.tipologiaInfo.toJSON() : <any>null;
        data["cliente"] = this.cliente ? this.cliente.toJSON() : <any>null;
        data["costo"] = this.costo ? this.costo.toJSON() : <any>null;
        data["prezzoIndicativo"] = this.prezzoIndicativo !== undefined ? this.prezzoIndicativo : <any>null;
        data["tipoPenale"] = this.tipoPenale ? this.tipoPenale.toJSON() : <any>null;
        data["penale"] = this.penale ? this.penale.toJSON() : <any>null;
        data["articoloPenale"] = this.articoloPenale ? this.articoloPenale.toJSON() : <any>null;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : <any>null;
        data["sistemazione"] = this.sistemazione ? this.sistemazione.toJSON() : <any>null;
        data["trattamento"] = this.trattamento ? this.trattamento.toJSON() : <any>null;
        data["nomeServizioVoucher"] = this.nomeServizioVoucher !== undefined ? this.nomeServizioVoucher : <any>null;
        data["descrizioneServizioVoucher"] = this.descrizioneServizioVoucher !== undefined ? this.descrizioneServizioVoucher : <any>null;
        data["nomeSistemazioneVoucher"] = this.nomeSistemazioneVoucher !== undefined ? this.nomeSistemazioneVoucher : <any>null;
        data["nomeCameraVoucher"] = this.nomeCameraVoucher !== undefined ? this.nomeCameraVoucher : <any>null;
        data["ordineServizio"] = this.ordineServizio !== undefined ? this.ordineServizio : <any>null;
        data["hhCodiceID"] = this.hhCodiceID !== undefined ? this.hhCodiceID : <any>null;
        data["hashcode"] = this.hashcode !== undefined ? this.hashcode : <any>null;
        data["tipologiaH2H"] = this.tipologiaH2H ? this.tipologiaH2H.toJSON() : <any>null;
        data["servizioH2H"] = this.servizioH2H ? this.servizioH2H.toJSON() : <any>null;
        data["codiceServizioH2H"] = this.codiceServizioH2H !== undefined ? this.codiceServizioH2H : <any>null;
        data["codiceTipologiaH2H"] = this.codiceTipologiaH2H !== undefined ? this.codiceTipologiaH2H : <any>null;
        data["outputCustomData"] = this.outputCustomData !== undefined ? this.outputCustomData : <any>null;
        data["isVolo"] = this.isVolo !== undefined ? this.isVolo : <any>null;
        data["isVoloIP"] = this.isVoloIP !== undefined ? this.isVoloIP : <any>null;
        data["isVoloTO"] = this.isVoloTO !== undefined ? this.isVoloTO : <any>null;
        data["isSupplemento"] = this.isSupplemento !== undefined ? this.isSupplemento : <any>null;
        data["isRinunciaPeaceOfMind"] = this.isRinunciaPeaceOfMind !== undefined ? this.isRinunciaPeaceOfMind : <any>null;
        data["isPeaceOfMind"] = this.isPeaceOfMind !== undefined ? this.isPeaceOfMind : <any>null;
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : <any>null;
        data["itinerarioTour"] = this.itinerarioTour ? this.itinerarioTour.toJSON() : <any>null;
        data["luogoInizio"] = this.luogoInizio ? this.luogoInizio.toJSON() : <any>null;
        data["luogoFine"] = this.luogoFine ? this.luogoFine.toJSON() : <any>null;
        data["abbinamento"] = this.abbinamento ? this.abbinamento.toJSON() : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["dataCheckout"] = this.dataCheckout !== undefined ? this.dataCheckout : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        data["prezzoPrecedente"] = this.prezzoPrecedente !== undefined ? this.prezzoPrecedente : <any>null;
        data["prezzoTotale"] = this.prezzoTotale !== undefined ? this.prezzoTotale : <any>null;
        data["prezzoTotaleNetto"] = this.prezzoTotaleNetto !== undefined ? this.prezzoTotaleNetto : <any>null;
        data["costoTotale"] = this.costoTotale !== undefined ? this.costoTotale : <any>null;
        data["costoTotaleEuro"] = this.costoTotaleEuro !== undefined ? this.costoTotaleEuro : <any>null;
        data["costoTotaleNetto"] = this.costoTotaleNetto !== undefined ? this.costoTotaleNetto : <any>null;
        data["tipoAcconto"] = this.tipoAcconto !== undefined ? this.tipoAcconto : <any>null;
        data["tipoImportoAcconto"] = this.tipoImportoAcconto !== undefined ? this.tipoImportoAcconto : <any>null;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : <any>null;
        data["totaleDaAnticipare"] = this.totaleDaAnticipare !== undefined ? this.totaleDaAnticipare : <any>null;
        data["marginePercentuale"] = this.marginePercentuale !== undefined ? this.marginePercentuale : <any>null;
        data["commissionePercentuale"] = this.commissionePercentuale !== undefined ? this.commissionePercentuale : <any>null;
        data["nettoIva"] = this.nettoIva !== undefined ? this.nettoIva : <any>null;
        data["nonVisibileADV"] = this.nonVisibileADV !== undefined ? this.nonVisibileADV : <any>null;
        data["totaleCommissioneTO"] = this.totaleCommissioneTO !== undefined ? this.totaleCommissioneTO : <any>null;
        return data;
    }
}

export interface IOffertaDatoInfo {
    id?: number;
    rigaParentID?: number | null;
    offertaDato?: OffertaDato | null;
    stato?: OffertaDatoStato | null;
    offerta?: OffertaInfo | null;
    totaleCommissione?: number;
    inviiAssicurazioneFilodiretto?: InvioAssicurazioneFiloDiretto[] | null;
    inviiAssicurazione?: InvioAssicurazione[] | null;
    tipoRiga?: ETipoRiga;
    statoUtente?: EStatoServizioUtente;
    disponibilita?: EStatoDisponibilita;
    disponibilitaPrecedente?: EStatoDisponibilita;
    servizioIdUnivoco?: string | null;
    pagamentoAnticipato?: boolean;
    score?: number;
    datiDocumento?: DatiDocumentoRiga | null;
    datiConferma?: DatiConfermaRiga | null;
    regolaAnticipoFornitore?: ServizioAnticipoFornitoreInfo | null;
    anticipoFornitore?: AnticipoFornitore | null;
    prezziDisponibilitaVariati?: boolean;
    dettagli?: OffertaDatoDettaglio[] | null;
    servizioNonMappato?: boolean;
    righeSupplemento?: OffertaDatoInfo[] | null;
    noteAssociate?: OffertaNotaInfo[] | null;
    notaPenaleFornitore?: OffertaNotaInfo | null;
    notaPenaleCustom?: OffertaNotaInfo | null;
    accordo?: AccordoInfo | null;
    contattoServizioAggregato?: ContattoInfo | null;
    tabellaCostiCommissioni?: TabellaCostiCommissioniInfo | null;
    valuta?: ValutaInfo | null;
    servizio?: ServizioInfo | null;
    tipologia?: ServizioTipologia | null;
    tipologiaInfo?: ServizioTipologiaInfo | null;
    cliente?: ClienteInfo | null;
    costo?: Costo | null;
    prezzoIndicativo?: boolean;
    tipoPenale?: PenaleInfo | null;
    penale?: PenaleServizio | null;
    articoloPenale?: ArticoloInfo | null;
    codicePrenotazione?: string | null;
    sistemazione?: SistemazioneInfo | null;
    trattamento?: TrattamentoInfo | null;
    nomeServizioVoucher?: string | null;
    descrizioneServizioVoucher?: string | null;
    nomeSistemazioneVoucher?: string | null;
    nomeCameraVoucher?: string | null;
    ordineServizio?: number;
    hhCodiceID?: number | null;
    hashcode?: string | null;
    tipologiaH2H?: HHCodice | null;
    servizioH2H?: HHServizioAggregato | null;
    codiceServizioH2H?: string | null;
    codiceTipologiaH2H?: string | null;
    outputCustomData?: string | null;
    isVolo?: boolean;
    isVoloIP?: boolean;
    isVoloTO?: boolean;
    isSupplemento?: boolean;
    isRinunciaPeaceOfMind?: boolean;
    isPeaceOfMind?: boolean;
    itinerario?: ItinerarioOffertaInfo | null;
    itinerarioTour?: ServizioItinerarioInfo | null;
    luogoInizio?: LuogoInfo | null;
    luogoFine?: LuogoInfo | null;
    abbinamento?: AbbinamentoInfo | null;
    data?: string;
    dataCheckout?: string | null;
    notti?: number | null;
    prezzoPrecedente?: number;
    prezzoTotale?: number;
    prezzoTotaleNetto?: number;
    costoTotale?: number;
    costoTotaleEuro?: number;
    costoTotaleNetto?: number;
    tipoAcconto?: ETipoAcconto;
    tipoImportoAcconto?: ETipoImportoAcconto | null;
    dataAcconto?: string | null;
    totaleDaAnticipare?: number;
    marginePercentuale?: number;
    commissionePercentuale?: number;
    nettoIva?: boolean;
    nonVisibileADV?: boolean;
    totaleCommissioneTO?: number;
}

export class ServizioAnticipoFornitoreInfo implements IServizioAnticipoFornitoreInfo {
    id?: number;
    servizioAnticipoFornitore?: ServizioAnticipoFornitore;
    srtNome?: string;
    accordo?: AccordoInfo | null;
    srtAccordo?: string | null;
    servizio?: ServizioInfo | null;
    srtServizio_it?: string | null;
    srtServizio_en?: string | null;
    srtServizio_fr?: string | null;
    srtServizio_de?: string | null;
    luogo?: LuogoInfo | null;
    srtLuogo_it?: string | null;
    srtLuogo_en?: string | null;
    srtLuogo_fr?: string | null;
    srtLuogo_de?: string | null;
    terms?: string;

    constructor(data?: IServizioAnticipoFornitoreInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioAnticipoFornitore = _data["servizioAnticipoFornitore"] ? ServizioAnticipoFornitore.fromJS(_data["servizioAnticipoFornitore"]) : <any>null;
            this.srtNome = _data["srtNome"] !== undefined ? _data["srtNome"] : <any>null;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : <any>null;
            this.srtAccordo = _data["srtAccordo"] !== undefined ? _data["srtAccordo"] : <any>null;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : <any>null;
            this.srtServizio_it = _data["srtServizio_it"] !== undefined ? _data["srtServizio_it"] : <any>null;
            this.srtServizio_en = _data["srtServizio_en"] !== undefined ? _data["srtServizio_en"] : <any>null;
            this.srtServizio_fr = _data["srtServizio_fr"] !== undefined ? _data["srtServizio_fr"] : <any>null;
            this.srtServizio_de = _data["srtServizio_de"] !== undefined ? _data["srtServizio_de"] : <any>null;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : <any>null;
            this.srtLuogo_it = _data["srtLuogo_it"] !== undefined ? _data["srtLuogo_it"] : <any>null;
            this.srtLuogo_en = _data["srtLuogo_en"] !== undefined ? _data["srtLuogo_en"] : <any>null;
            this.srtLuogo_fr = _data["srtLuogo_fr"] !== undefined ? _data["srtLuogo_fr"] : <any>null;
            this.srtLuogo_de = _data["srtLuogo_de"] !== undefined ? _data["srtLuogo_de"] : <any>null;
            this.terms = _data["terms"] !== undefined ? _data["terms"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioAnticipoFornitoreInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAnticipoFornitoreInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioAnticipoFornitore"] = this.servizioAnticipoFornitore ? this.servizioAnticipoFornitore.toJSON() : <any>null;
        data["srtNome"] = this.srtNome !== undefined ? this.srtNome : <any>null;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : <any>null;
        data["srtAccordo"] = this.srtAccordo !== undefined ? this.srtAccordo : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        data["srtServizio_it"] = this.srtServizio_it !== undefined ? this.srtServizio_it : <any>null;
        data["srtServizio_en"] = this.srtServizio_en !== undefined ? this.srtServizio_en : <any>null;
        data["srtServizio_fr"] = this.srtServizio_fr !== undefined ? this.srtServizio_fr : <any>null;
        data["srtServizio_de"] = this.srtServizio_de !== undefined ? this.srtServizio_de : <any>null;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        data["srtLuogo_it"] = this.srtLuogo_it !== undefined ? this.srtLuogo_it : <any>null;
        data["srtLuogo_en"] = this.srtLuogo_en !== undefined ? this.srtLuogo_en : <any>null;
        data["srtLuogo_fr"] = this.srtLuogo_fr !== undefined ? this.srtLuogo_fr : <any>null;
        data["srtLuogo_de"] = this.srtLuogo_de !== undefined ? this.srtLuogo_de : <any>null;
        data["terms"] = this.terms !== undefined ? this.terms : <any>null;
        return data;
    }
}

export interface IServizioAnticipoFornitoreInfo {
    id?: number;
    servizioAnticipoFornitore?: ServizioAnticipoFornitore;
    srtNome?: string;
    accordo?: AccordoInfo | null;
    srtAccordo?: string | null;
    servizio?: ServizioInfo | null;
    srtServizio_it?: string | null;
    srtServizio_en?: string | null;
    srtServizio_fr?: string | null;
    srtServizio_de?: string | null;
    luogo?: LuogoInfo | null;
    srtLuogo_it?: string | null;
    srtLuogo_en?: string | null;
    srtLuogo_fr?: string | null;
    srtLuogo_de?: string | null;
    terms?: string;
}

export class OffertaNotaInfo implements IOffertaNotaInfo {
    id?: number;
    nota?: OffertaNota | null;
    utente?: UtenteInfo | null;
    utentePresaInCarico?: UtenteInfo | null;
    accordo?: AccordoInfo | null;
    testoSemplice?: string | null;

    constructor(data?: IOffertaNotaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nota = _data["nota"] ? OffertaNota.fromJS(_data["nota"]) : <any>null;
            this.utente = _data["utente"] ? UtenteInfo.fromJS(_data["utente"]) : <any>null;
            this.utentePresaInCarico = _data["utentePresaInCarico"] ? UtenteInfo.fromJS(_data["utentePresaInCarico"]) : <any>null;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : <any>null;
            this.testoSemplice = _data["testoSemplice"] !== undefined ? _data["testoSemplice"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaNotaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaNotaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nota"] = this.nota ? this.nota.toJSON() : <any>null;
        data["utente"] = this.utente ? this.utente.toJSON() : <any>null;
        data["utentePresaInCarico"] = this.utentePresaInCarico ? this.utentePresaInCarico.toJSON() : <any>null;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : <any>null;
        data["testoSemplice"] = this.testoSemplice !== undefined ? this.testoSemplice : <any>null;
        return data;
    }
}

export interface IOffertaNotaInfo {
    id?: number;
    nota?: OffertaNota | null;
    utente?: UtenteInfo | null;
    utentePresaInCarico?: UtenteInfo | null;
    accordo?: AccordoInfo | null;
    testoSemplice?: string | null;
}

export abstract class PenaleInfo implements IPenaleInfo {
    penale?: Penale;

    constructor(data?: IPenaleInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.penale = _data["penale"] ? Penale.fromJS(_data["penale"]) : <any>null;
        }
    }

    static fromJS(data: any): PenaleInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PenaleInfo' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["penale"] = this.penale ? this.penale.toJSON() : <any>null;
        return data;
    }
}

export interface IPenaleInfo {
    penale?: Penale;
}

export class Penale implements IPenale {
    id?: number;
    nome!: string;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    giorni?: number | null;
    valore?: number | null;

    constructor(data?: IPenale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : <any>null;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : <any>null;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : <any>null;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : <any>null;
        }
    }

    static fromJS(data: any): Penale {
        data = typeof data === 'object' ? data : {};
        let result = new Penale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : <any>null;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : <any>null;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["giorni"] = this.giorni !== undefined ? this.giorni : <any>null;
        data["valore"] = this.valore !== undefined ? this.valore : <any>null;
        return data;
    }
}

export interface IPenale {
    id?: number;
    nome: string;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    giorni?: number | null;
    valore?: number | null;
}

export class ItinerarioVoloInfo implements IItinerarioVoloInfo {
    offerta?: OffertaInfo | null;
    tappaFrom?: ItinerarioOffertaInfo | null;
    tappaTo?: ItinerarioOffertaInfo | null;
    aeroportoPartenza?: Aeroporto | null;
    aeroportoArrivo?: Aeroporto | null;
    dataVolo?: string;
    carrier?: string | null;

    constructor(data?: IItinerarioVoloInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : <any>null;
            this.tappaFrom = _data["tappaFrom"] ? ItinerarioOffertaInfo.fromJS(_data["tappaFrom"]) : <any>null;
            this.tappaTo = _data["tappaTo"] ? ItinerarioOffertaInfo.fromJS(_data["tappaTo"]) : <any>null;
            this.aeroportoPartenza = _data["aeroportoPartenza"] ? Aeroporto.fromJS(_data["aeroportoPartenza"]) : <any>null;
            this.aeroportoArrivo = _data["aeroportoArrivo"] ? Aeroporto.fromJS(_data["aeroportoArrivo"]) : <any>null;
            this.dataVolo = _data["dataVolo"] !== undefined ? _data["dataVolo"] : <any>null;
            this.carrier = _data["carrier"] !== undefined ? _data["carrier"] : <any>null;
        }
    }

    static fromJS(data: any): ItinerarioVoloInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ItinerarioVoloInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        data["tappaFrom"] = this.tappaFrom ? this.tappaFrom.toJSON() : <any>null;
        data["tappaTo"] = this.tappaTo ? this.tappaTo.toJSON() : <any>null;
        data["aeroportoPartenza"] = this.aeroportoPartenza ? this.aeroportoPartenza.toJSON() : <any>null;
        data["aeroportoArrivo"] = this.aeroportoArrivo ? this.aeroportoArrivo.toJSON() : <any>null;
        data["dataVolo"] = this.dataVolo !== undefined ? this.dataVolo : <any>null;
        data["carrier"] = this.carrier !== undefined ? this.carrier : <any>null;
        return data;
    }
}

export interface IItinerarioVoloInfo {
    offerta?: OffertaInfo | null;
    tappaFrom?: ItinerarioOffertaInfo | null;
    tappaTo?: ItinerarioOffertaInfo | null;
    aeroportoPartenza?: Aeroporto | null;
    aeroportoArrivo?: Aeroporto | null;
    dataVolo?: string;
    carrier?: string | null;
}

export class DocumentoInfo implements IDocumentoInfo {
    id?: number;
    documento?: Documento | null;
    contatto?: ContattoInfo | null;
    allegato?: DocumentoCondivisoInfo | null;
    pathDocumento?: string | null;
    offerta?: OffertaInfo | null;
    frasi?: DocumentoFrase[] | null;
    extraDocsIDs?: number[] | null;
    extraDocsString?: string | null;
    overrideServizi?: { [key: string]: number; } | null;
    isEmailLink?: boolean;
    emailUrl?: string | null;
    linkedFile?: FileInfoBase | null;
    programmaDiViaggioValido?: boolean;

    constructor(data?: IDocumentoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.documento = _data["documento"] ? Documento.fromJS(_data["documento"]) : <any>null;
            this.contatto = _data["contatto"] ? ContattoInfo.fromJS(_data["contatto"]) : <any>null;
            this.allegato = _data["allegato"] ? DocumentoCondivisoInfo.fromJS(_data["allegato"]) : <any>null;
            this.pathDocumento = _data["pathDocumento"] !== undefined ? _data["pathDocumento"] : <any>null;
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : <any>null;
            if (Array.isArray(_data["frasi"])) {
                this.frasi = [] as any;
                for (let item of _data["frasi"])
                    this.frasi!.push(DocumentoFrase.fromJS(item));
            }
            else {
                this.frasi = <any>null;
            }
            if (Array.isArray(_data["extraDocsIDs"])) {
                this.extraDocsIDs = [] as any;
                for (let item of _data["extraDocsIDs"])
                    this.extraDocsIDs!.push(item);
            }
            else {
                this.extraDocsIDs = <any>null;
            }
            this.extraDocsString = _data["extraDocsString"] !== undefined ? _data["extraDocsString"] : <any>null;
            if (_data["overrideServizi"]) {
                this.overrideServizi = {} as any;
                for (let key in _data["overrideServizi"]) {
                    if (_data["overrideServizi"].hasOwnProperty(key))
                        (<any>this.overrideServizi)![key] = _data["overrideServizi"][key] !== undefined ? _data["overrideServizi"][key] : <any>null;
                }
            }
            else {
                this.overrideServizi = <any>null;
            }
            this.isEmailLink = _data["isEmailLink"] !== undefined ? _data["isEmailLink"] : <any>null;
            this.emailUrl = _data["emailUrl"] !== undefined ? _data["emailUrl"] : <any>null;
            this.linkedFile = _data["linkedFile"] ? FileInfoBase.fromJS(_data["linkedFile"]) : <any>null;
            this.programmaDiViaggioValido = _data["programmaDiViaggioValido"] !== undefined ? _data["programmaDiViaggioValido"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["documento"] = this.documento ? this.documento.toJSON() : <any>null;
        data["contatto"] = this.contatto ? this.contatto.toJSON() : <any>null;
        data["allegato"] = this.allegato ? this.allegato.toJSON() : <any>null;
        data["pathDocumento"] = this.pathDocumento !== undefined ? this.pathDocumento : <any>null;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        if (Array.isArray(this.frasi)) {
            data["frasi"] = [];
            for (let item of this.frasi)
                data["frasi"].push(item.toJSON());
        }
        if (Array.isArray(this.extraDocsIDs)) {
            data["extraDocsIDs"] = [];
            for (let item of this.extraDocsIDs)
                data["extraDocsIDs"].push(item);
        }
        data["extraDocsString"] = this.extraDocsString !== undefined ? this.extraDocsString : <any>null;
        if (this.overrideServizi) {
            data["overrideServizi"] = {};
            for (let key in this.overrideServizi) {
                if (this.overrideServizi.hasOwnProperty(key))
                    (<any>data["overrideServizi"])[key] = this.overrideServizi[key] !== undefined ? this.overrideServizi[key] : <any>null;
            }
        }
        data["isEmailLink"] = this.isEmailLink !== undefined ? this.isEmailLink : <any>null;
        data["emailUrl"] = this.emailUrl !== undefined ? this.emailUrl : <any>null;
        data["linkedFile"] = this.linkedFile ? this.linkedFile.toJSON() : <any>null;
        data["programmaDiViaggioValido"] = this.programmaDiViaggioValido !== undefined ? this.programmaDiViaggioValido : <any>null;
        return data;
    }
}

export interface IDocumentoInfo {
    id?: number;
    documento?: Documento | null;
    contatto?: ContattoInfo | null;
    allegato?: DocumentoCondivisoInfo | null;
    pathDocumento?: string | null;
    offerta?: OffertaInfo | null;
    frasi?: DocumentoFrase[] | null;
    extraDocsIDs?: number[] | null;
    extraDocsString?: string | null;
    overrideServizi?: { [key: string]: number; } | null;
    isEmailLink?: boolean;
    emailUrl?: string | null;
    linkedFile?: FileInfoBase | null;
    programmaDiViaggioValido?: boolean;
}

export class DocumentoCondivisoInfo implements IDocumentoCondivisoInfo {
    id?: number;
    documentoCondiviso?: DocumentoCondiviso;
    eliminato?: boolean;
    luogo?: LuogoInfo | null;
    luogoDestinazione?: LuogoInfo | null;
    servizio?: ServizioInfo | null;
    accordo?: AccordoInfo | null;
    contatto?: ContattoInfo | null;
    creatoDa?: UtenteInfo;
    aggiornatoDa?: UtenteInfo;
    eliminatoDa?: UtenteInfo | null;
    srtNome_It?: string;
    srtNome_En?: string;
    srtNome_Fr?: string;
    srtNome_De?: string;
    srtCategoria_It?: string | null;
    srtCategoria_En?: string | null;
    srtCategoria_Fr?: string | null;
    srtCategoria_De?: string | null;
    linkedFile?: FileInfoBase;
    qualsiasiLingua?: boolean;
    lingue?: ELingua[];
    categoria?: DocumentoCondivisoCategoriaInfo | null;

    constructor(data?: IDocumentoCondivisoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.documentoCondiviso = _data["documentoCondiviso"] ? DocumentoCondiviso.fromJS(_data["documentoCondiviso"]) : <any>null;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : <any>null;
            this.luogo = _data["luogo"] ? LuogoInfo.fromJS(_data["luogo"]) : <any>null;
            this.luogoDestinazione = _data["luogoDestinazione"] ? LuogoInfo.fromJS(_data["luogoDestinazione"]) : <any>null;
            this.servizio = _data["servizio"] ? ServizioInfo.fromJS(_data["servizio"]) : <any>null;
            this.accordo = _data["accordo"] ? AccordoInfo.fromJS(_data["accordo"]) : <any>null;
            this.contatto = _data["contatto"] ? ContattoInfo.fromJS(_data["contatto"]) : <any>null;
            this.creatoDa = _data["creatoDa"] ? UtenteInfo.fromJS(_data["creatoDa"]) : <any>null;
            this.aggiornatoDa = _data["aggiornatoDa"] ? UtenteInfo.fromJS(_data["aggiornatoDa"]) : <any>null;
            this.eliminatoDa = _data["eliminatoDa"] ? UtenteInfo.fromJS(_data["eliminatoDa"]) : <any>null;
            this.srtNome_It = _data["srtNome_It"] !== undefined ? _data["srtNome_It"] : <any>null;
            this.srtNome_En = _data["srtNome_En"] !== undefined ? _data["srtNome_En"] : <any>null;
            this.srtNome_Fr = _data["srtNome_Fr"] !== undefined ? _data["srtNome_Fr"] : <any>null;
            this.srtNome_De = _data["srtNome_De"] !== undefined ? _data["srtNome_De"] : <any>null;
            this.srtCategoria_It = _data["srtCategoria_It"] !== undefined ? _data["srtCategoria_It"] : <any>null;
            this.srtCategoria_En = _data["srtCategoria_En"] !== undefined ? _data["srtCategoria_En"] : <any>null;
            this.srtCategoria_Fr = _data["srtCategoria_Fr"] !== undefined ? _data["srtCategoria_Fr"] : <any>null;
            this.srtCategoria_De = _data["srtCategoria_De"] !== undefined ? _data["srtCategoria_De"] : <any>null;
            this.linkedFile = _data["linkedFile"] ? FileInfoBase.fromJS(_data["linkedFile"]) : <any>null;
            this.qualsiasiLingua = _data["qualsiasiLingua"] !== undefined ? _data["qualsiasiLingua"] : <any>null;
            if (Array.isArray(_data["lingue"])) {
                this.lingue = [] as any;
                for (let item of _data["lingue"])
                    this.lingue!.push(item);
            }
            else {
                this.lingue = <any>null;
            }
            this.categoria = _data["categoria"] ? DocumentoCondivisoCategoriaInfo.fromJS(_data["categoria"]) : <any>null;
        }
    }

    static fromJS(data: any): DocumentoCondivisoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoCondivisoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["documentoCondiviso"] = this.documentoCondiviso ? this.documentoCondiviso.toJSON() : <any>null;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : <any>null;
        data["luogo"] = this.luogo ? this.luogo.toJSON() : <any>null;
        data["luogoDestinazione"] = this.luogoDestinazione ? this.luogoDestinazione.toJSON() : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        data["accordo"] = this.accordo ? this.accordo.toJSON() : <any>null;
        data["contatto"] = this.contatto ? this.contatto.toJSON() : <any>null;
        data["creatoDa"] = this.creatoDa ? this.creatoDa.toJSON() : <any>null;
        data["aggiornatoDa"] = this.aggiornatoDa ? this.aggiornatoDa.toJSON() : <any>null;
        data["eliminatoDa"] = this.eliminatoDa ? this.eliminatoDa.toJSON() : <any>null;
        data["srtNome_It"] = this.srtNome_It !== undefined ? this.srtNome_It : <any>null;
        data["srtNome_En"] = this.srtNome_En !== undefined ? this.srtNome_En : <any>null;
        data["srtNome_Fr"] = this.srtNome_Fr !== undefined ? this.srtNome_Fr : <any>null;
        data["srtNome_De"] = this.srtNome_De !== undefined ? this.srtNome_De : <any>null;
        data["srtCategoria_It"] = this.srtCategoria_It !== undefined ? this.srtCategoria_It : <any>null;
        data["srtCategoria_En"] = this.srtCategoria_En !== undefined ? this.srtCategoria_En : <any>null;
        data["srtCategoria_Fr"] = this.srtCategoria_Fr !== undefined ? this.srtCategoria_Fr : <any>null;
        data["srtCategoria_De"] = this.srtCategoria_De !== undefined ? this.srtCategoria_De : <any>null;
        data["linkedFile"] = this.linkedFile ? this.linkedFile.toJSON() : <any>null;
        data["qualsiasiLingua"] = this.qualsiasiLingua !== undefined ? this.qualsiasiLingua : <any>null;
        if (Array.isArray(this.lingue)) {
            data["lingue"] = [];
            for (let item of this.lingue)
                data["lingue"].push(item);
        }
        data["categoria"] = this.categoria ? this.categoria.toJSON() : <any>null;
        return data;
    }
}

export interface IDocumentoCondivisoInfo {
    id?: number;
    documentoCondiviso?: DocumentoCondiviso;
    eliminato?: boolean;
    luogo?: LuogoInfo | null;
    luogoDestinazione?: LuogoInfo | null;
    servizio?: ServizioInfo | null;
    accordo?: AccordoInfo | null;
    contatto?: ContattoInfo | null;
    creatoDa?: UtenteInfo;
    aggiornatoDa?: UtenteInfo;
    eliminatoDa?: UtenteInfo | null;
    srtNome_It?: string;
    srtNome_En?: string;
    srtNome_Fr?: string;
    srtNome_De?: string;
    srtCategoria_It?: string | null;
    srtCategoria_En?: string | null;
    srtCategoria_Fr?: string | null;
    srtCategoria_De?: string | null;
    linkedFile?: FileInfoBase;
    qualsiasiLingua?: boolean;
    lingue?: ELingua[];
    categoria?: DocumentoCondivisoCategoriaInfo | null;
}

export class DocumentoCondiviso implements IDocumentoCondiviso {
    id?: number;
    categoriaID?: number;
    nome!: string;
    nomeInglese?: string | null;
    nomeFrancese?: string | null;
    nomeTedesco?: string | null;
    nomeSpagnolo?: string | null;
    noteInterne?: string | null;
    path?: string | null;
    tipoPath?: ETipoPath;
    nomeFile?: string | null;
    dimensioneFile?: number | null;
    tipoContenuto?: ETipoDocumentoAllegato;
    luogoID?: number | null;
    luogoDestinazioneID?: number | null;
    servizioID?: number | null;
    accordoID?: number | null;
    contattoID?: number | null;
    tipoPubblicazione?: ETipoPubblicazioneAllegato;
    pubblicatoDal?: string | null;
    pubblicatoAl?: string | null;
    partenzeDal?: string | null;
    partenzeAl?: string | null;
    inserisciDefault?: boolean;
    ordine?: number;
    lingue?: string | null;
    creatoIl?: string;
    creatoDaUtenteID?: number;
    aggiornatoIl?: string;
    aggiornatoDaUtenteID?: number;
    eliminatoIl?: string | null;
    eliminatoDaUtenteID?: number | null;
    operatore?: EOperatore | null;

    constructor(data?: IDocumentoCondiviso) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.categoriaID = _data["categoriaID"] !== undefined ? _data["categoriaID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : <any>null;
            this.nomeFrancese = _data["nomeFrancese"] !== undefined ? _data["nomeFrancese"] : <any>null;
            this.nomeTedesco = _data["nomeTedesco"] !== undefined ? _data["nomeTedesco"] : <any>null;
            this.nomeSpagnolo = _data["nomeSpagnolo"] !== undefined ? _data["nomeSpagnolo"] : <any>null;
            this.noteInterne = _data["noteInterne"] !== undefined ? _data["noteInterne"] : <any>null;
            this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
            this.tipoPath = _data["tipoPath"] !== undefined ? _data["tipoPath"] : <any>null;
            this.nomeFile = _data["nomeFile"] !== undefined ? _data["nomeFile"] : <any>null;
            this.dimensioneFile = _data["dimensioneFile"] !== undefined ? _data["dimensioneFile"] : <any>null;
            this.tipoContenuto = _data["tipoContenuto"] !== undefined ? _data["tipoContenuto"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.tipoPubblicazione = _data["tipoPubblicazione"] !== undefined ? _data["tipoPubblicazione"] : <any>null;
            this.pubblicatoDal = _data["pubblicatoDal"] !== undefined ? _data["pubblicatoDal"] : <any>null;
            this.pubblicatoAl = _data["pubblicatoAl"] !== undefined ? _data["pubblicatoAl"] : <any>null;
            this.partenzeDal = _data["partenzeDal"] !== undefined ? _data["partenzeDal"] : <any>null;
            this.partenzeAl = _data["partenzeAl"] !== undefined ? _data["partenzeAl"] : <any>null;
            this.inserisciDefault = _data["inserisciDefault"] !== undefined ? _data["inserisciDefault"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.lingue = _data["lingue"] !== undefined ? _data["lingue"] : <any>null;
            this.creatoIl = _data["creatoIl"] !== undefined ? _data["creatoIl"] : <any>null;
            this.creatoDaUtenteID = _data["creatoDaUtenteID"] !== undefined ? _data["creatoDaUtenteID"] : <any>null;
            this.aggiornatoIl = _data["aggiornatoIl"] !== undefined ? _data["aggiornatoIl"] : <any>null;
            this.aggiornatoDaUtenteID = _data["aggiornatoDaUtenteID"] !== undefined ? _data["aggiornatoDaUtenteID"] : <any>null;
            this.eliminatoIl = _data["eliminatoIl"] !== undefined ? _data["eliminatoIl"] : <any>null;
            this.eliminatoDaUtenteID = _data["eliminatoDaUtenteID"] !== undefined ? _data["eliminatoDaUtenteID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentoCondiviso {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoCondiviso();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["categoriaID"] = this.categoriaID !== undefined ? this.categoriaID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : <any>null;
        data["nomeFrancese"] = this.nomeFrancese !== undefined ? this.nomeFrancese : <any>null;
        data["nomeTedesco"] = this.nomeTedesco !== undefined ? this.nomeTedesco : <any>null;
        data["nomeSpagnolo"] = this.nomeSpagnolo !== undefined ? this.nomeSpagnolo : <any>null;
        data["noteInterne"] = this.noteInterne !== undefined ? this.noteInterne : <any>null;
        data["path"] = this.path !== undefined ? this.path : <any>null;
        data["tipoPath"] = this.tipoPath !== undefined ? this.tipoPath : <any>null;
        data["nomeFile"] = this.nomeFile !== undefined ? this.nomeFile : <any>null;
        data["dimensioneFile"] = this.dimensioneFile !== undefined ? this.dimensioneFile : <any>null;
        data["tipoContenuto"] = this.tipoContenuto !== undefined ? this.tipoContenuto : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["tipoPubblicazione"] = this.tipoPubblicazione !== undefined ? this.tipoPubblicazione : <any>null;
        data["pubblicatoDal"] = this.pubblicatoDal !== undefined ? this.pubblicatoDal : <any>null;
        data["pubblicatoAl"] = this.pubblicatoAl !== undefined ? this.pubblicatoAl : <any>null;
        data["partenzeDal"] = this.partenzeDal !== undefined ? this.partenzeDal : <any>null;
        data["partenzeAl"] = this.partenzeAl !== undefined ? this.partenzeAl : <any>null;
        data["inserisciDefault"] = this.inserisciDefault !== undefined ? this.inserisciDefault : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["lingue"] = this.lingue !== undefined ? this.lingue : <any>null;
        data["creatoIl"] = this.creatoIl !== undefined ? this.creatoIl : <any>null;
        data["creatoDaUtenteID"] = this.creatoDaUtenteID !== undefined ? this.creatoDaUtenteID : <any>null;
        data["aggiornatoIl"] = this.aggiornatoIl !== undefined ? this.aggiornatoIl : <any>null;
        data["aggiornatoDaUtenteID"] = this.aggiornatoDaUtenteID !== undefined ? this.aggiornatoDaUtenteID : <any>null;
        data["eliminatoIl"] = this.eliminatoIl !== undefined ? this.eliminatoIl : <any>null;
        data["eliminatoDaUtenteID"] = this.eliminatoDaUtenteID !== undefined ? this.eliminatoDaUtenteID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        return data;
    }
}

export interface IDocumentoCondiviso {
    id?: number;
    categoriaID?: number;
    nome: string;
    nomeInglese?: string | null;
    nomeFrancese?: string | null;
    nomeTedesco?: string | null;
    nomeSpagnolo?: string | null;
    noteInterne?: string | null;
    path?: string | null;
    tipoPath?: ETipoPath;
    nomeFile?: string | null;
    dimensioneFile?: number | null;
    tipoContenuto?: ETipoDocumentoAllegato;
    luogoID?: number | null;
    luogoDestinazioneID?: number | null;
    servizioID?: number | null;
    accordoID?: number | null;
    contattoID?: number | null;
    tipoPubblicazione?: ETipoPubblicazioneAllegato;
    pubblicatoDal?: string | null;
    pubblicatoAl?: string | null;
    partenzeDal?: string | null;
    partenzeAl?: string | null;
    inserisciDefault?: boolean;
    ordine?: number;
    lingue?: string | null;
    creatoIl?: string;
    creatoDaUtenteID?: number;
    aggiornatoIl?: string;
    aggiornatoDaUtenteID?: number;
    eliminatoIl?: string | null;
    eliminatoDaUtenteID?: number | null;
    operatore?: EOperatore | null;
}

export enum ETipoPath {
    PathAssoluto = "PathAssoluto",
    PathRelativo = "PathRelativo",
    UrlAssoluta = "UrlAssoluta",
    UrlRelativa = "UrlRelativa",
}

export enum ETipoDocumentoAllegato {
    Html = "Html",
    Pdf = "Pdf",
    Text = "Text",
    Immagine = "Immagine",
}

export enum ETipoPubblicazioneAllegato {
    Bozza = "Bozza",
    Pubblicato = "Pubblicato",
    PubblicatoIntranet = "PubblicatoIntranet",
    Obsoleto = "Obsoleto",
}

export class DocumentoCondivisoCategoriaInfo implements IDocumentoCondivisoCategoriaInfo {
    id?: number;
    documentoCondivisoCategoria?: DocumentoCondivisoCategoria;
    eliminata?: boolean;
    srtNome_It?: string;
    srtNome_En?: string;
    srtNome_Fr?: string;
    srtNome_De?: string;

    constructor(data?: IDocumentoCondivisoCategoriaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.documentoCondivisoCategoria = _data["documentoCondivisoCategoria"] ? DocumentoCondivisoCategoria.fromJS(_data["documentoCondivisoCategoria"]) : <any>null;
            this.eliminata = _data["eliminata"] !== undefined ? _data["eliminata"] : <any>null;
            this.srtNome_It = _data["srtNome_It"] !== undefined ? _data["srtNome_It"] : <any>null;
            this.srtNome_En = _data["srtNome_En"] !== undefined ? _data["srtNome_En"] : <any>null;
            this.srtNome_Fr = _data["srtNome_Fr"] !== undefined ? _data["srtNome_Fr"] : <any>null;
            this.srtNome_De = _data["srtNome_De"] !== undefined ? _data["srtNome_De"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentoCondivisoCategoriaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoCondivisoCategoriaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["documentoCondivisoCategoria"] = this.documentoCondivisoCategoria ? this.documentoCondivisoCategoria.toJSON() : <any>null;
        data["eliminata"] = this.eliminata !== undefined ? this.eliminata : <any>null;
        data["srtNome_It"] = this.srtNome_It !== undefined ? this.srtNome_It : <any>null;
        data["srtNome_En"] = this.srtNome_En !== undefined ? this.srtNome_En : <any>null;
        data["srtNome_Fr"] = this.srtNome_Fr !== undefined ? this.srtNome_Fr : <any>null;
        data["srtNome_De"] = this.srtNome_De !== undefined ? this.srtNome_De : <any>null;
        return data;
    }
}

export interface IDocumentoCondivisoCategoriaInfo {
    id?: number;
    documentoCondivisoCategoria?: DocumentoCondivisoCategoria;
    eliminata?: boolean;
    srtNome_It?: string;
    srtNome_En?: string;
    srtNome_Fr?: string;
    srtNome_De?: string;
}

export class DocumentoCondivisoCategoria implements IDocumentoCondivisoCategoria {
    id?: number;
    nome!: string;
    nomeENG?: string | null;
    nomeFRA?: string | null;
    nomeDEU?: string | null;
    nomeESP?: string | null;
    eliminata?: boolean;

    constructor(data?: IDocumentoCondivisoCategoria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeENG = _data["nomeENG"] !== undefined ? _data["nomeENG"] : <any>null;
            this.nomeFRA = _data["nomeFRA"] !== undefined ? _data["nomeFRA"] : <any>null;
            this.nomeDEU = _data["nomeDEU"] !== undefined ? _data["nomeDEU"] : <any>null;
            this.nomeESP = _data["nomeESP"] !== undefined ? _data["nomeESP"] : <any>null;
            this.eliminata = _data["eliminata"] !== undefined ? _data["eliminata"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentoCondivisoCategoria {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoCondivisoCategoria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeENG"] = this.nomeENG !== undefined ? this.nomeENG : <any>null;
        data["nomeFRA"] = this.nomeFRA !== undefined ? this.nomeFRA : <any>null;
        data["nomeDEU"] = this.nomeDEU !== undefined ? this.nomeDEU : <any>null;
        data["nomeESP"] = this.nomeESP !== undefined ? this.nomeESP : <any>null;
        data["eliminata"] = this.eliminata !== undefined ? this.eliminata : <any>null;
        return data;
    }
}

export interface IDocumentoCondivisoCategoria {
    id?: number;
    nome: string;
    nomeENG?: string | null;
    nomeFRA?: string | null;
    nomeDEU?: string | null;
    nomeESP?: string | null;
    eliminata?: boolean;
}

export class DocumentoFrase implements IDocumentoFrase {
    id?: number;
    documentoID?: number;
    sezioneID?: number;
    sottoSezioneID?: number | null;
    articoloID?: number | null;
    fraseID?: number | null;
    giorno?: number | null;
    servizioID?: number | null;
    rigaID?: number | null;
    contattoID?: number | null;
    accordoID?: number | null;
    luogoID?: number | null;
    ordine?: number;
    terminatore?: EFraseTerminatore;
    parametri?: string | null;
    valoreInt?: number | null;

    constructor(data?: IDocumentoFrase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
            this.sezioneID = _data["sezioneID"] !== undefined ? _data["sezioneID"] : <any>null;
            this.sottoSezioneID = _data["sottoSezioneID"] !== undefined ? _data["sottoSezioneID"] : <any>null;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
            this.fraseID = _data["fraseID"] !== undefined ? _data["fraseID"] : <any>null;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.terminatore = _data["terminatore"] !== undefined ? _data["terminatore"] : <any>null;
            this.parametri = _data["parametri"] !== undefined ? _data["parametri"] : <any>null;
            this.valoreInt = _data["valoreInt"] !== undefined ? _data["valoreInt"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentoFrase {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentoFrase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        data["sezioneID"] = this.sezioneID !== undefined ? this.sezioneID : <any>null;
        data["sottoSezioneID"] = this.sottoSezioneID !== undefined ? this.sottoSezioneID : <any>null;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        data["fraseID"] = this.fraseID !== undefined ? this.fraseID : <any>null;
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["terminatore"] = this.terminatore !== undefined ? this.terminatore : <any>null;
        data["parametri"] = this.parametri !== undefined ? this.parametri : <any>null;
        data["valoreInt"] = this.valoreInt !== undefined ? this.valoreInt : <any>null;
        return data;
    }
}

export interface IDocumentoFrase {
    id?: number;
    documentoID?: number;
    sezioneID?: number;
    sottoSezioneID?: number | null;
    articoloID?: number | null;
    fraseID?: number | null;
    giorno?: number | null;
    servizioID?: number | null;
    rigaID?: number | null;
    contattoID?: number | null;
    accordoID?: number | null;
    luogoID?: number | null;
    ordine?: number;
    terminatore?: EFraseTerminatore;
    parametri?: string | null;
    valoreInt?: number | null;
}

export class EmailInfo implements IEmailInfo {
    id?: number;
    email?: EmailQueue;
    recipients?: EmailQueueRecipient[];
    toRecipients?: string;
    ccRecipients?: string;
    bccRecipients?: string;
    attachments?: EmailAttachmentInfo[];

    constructor(data?: IEmailInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] ? EmailQueue.fromJS(_data["email"]) : <any>null;
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(EmailQueueRecipient.fromJS(item));
            }
            else {
                this.recipients = <any>null;
            }
            this.toRecipients = _data["toRecipients"] !== undefined ? _data["toRecipients"] : <any>null;
            this.ccRecipients = _data["ccRecipients"] !== undefined ? _data["ccRecipients"] : <any>null;
            this.bccRecipients = _data["bccRecipients"] !== undefined ? _data["bccRecipients"] : <any>null;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(EmailAttachmentInfo.fromJS(item));
            }
            else {
                this.attachments = <any>null;
            }
        }
    }

    static fromJS(data: any): EmailInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EmailInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email ? this.email.toJSON() : <any>null;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        data["toRecipients"] = this.toRecipients !== undefined ? this.toRecipients : <any>null;
        data["ccRecipients"] = this.ccRecipients !== undefined ? this.ccRecipients : <any>null;
        data["bccRecipients"] = this.bccRecipients !== undefined ? this.bccRecipients : <any>null;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmailInfo {
    id?: number;
    email?: EmailQueue;
    recipients?: EmailQueueRecipient[];
    toRecipients?: string;
    ccRecipients?: string;
    bccRecipients?: string;
    attachments?: EmailAttachmentInfo[];
}

export class EmailQueueRecipient implements IEmailQueueRecipient {
    id?: number;
    emailID?: number;
    addressType?: EEmailAddressType;
    recipientAddress!: string;
    recipientName?: string | null;

    constructor(data?: IEmailQueueRecipient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.emailID = _data["emailID"] !== undefined ? _data["emailID"] : <any>null;
            this.addressType = _data["addressType"] !== undefined ? _data["addressType"] : <any>null;
            this.recipientAddress = _data["recipientAddress"] !== undefined ? _data["recipientAddress"] : <any>null;
            this.recipientName = _data["recipientName"] !== undefined ? _data["recipientName"] : <any>null;
        }
    }

    static fromJS(data: any): EmailQueueRecipient {
        data = typeof data === 'object' ? data : {};
        let result = new EmailQueueRecipient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["emailID"] = this.emailID !== undefined ? this.emailID : <any>null;
        data["addressType"] = this.addressType !== undefined ? this.addressType : <any>null;
        data["recipientAddress"] = this.recipientAddress !== undefined ? this.recipientAddress : <any>null;
        data["recipientName"] = this.recipientName !== undefined ? this.recipientName : <any>null;
        return data;
    }
}

export interface IEmailQueueRecipient {
    id?: number;
    emailID?: number;
    addressType?: EEmailAddressType;
    recipientAddress: string;
    recipientName?: string | null;
}

export class VoloInfo implements IVoloInfo {
    id?: number;
    volo?: Volo | null;
    offerta?: OffertaInfo | null;
    righe?: OffertaDatoInfo[] | null;
    haOrdinaBiglietteria?: boolean;
    soluzione?: string | null;
    nome?: string | null;
    isPnr?: boolean;
    isNdc?: boolean;
    abbinamento?: AbbinamentoInfo | null;
    fornitore?: FornitoreInfo | null;
    tratte?: VoloTrattaInfo[] | null;
    tariffe?: VoloTariffa[] | null;
    note?: VoloNota[] | null;
    relazioni?: VoloRel[] | null;

    constructor(data?: IVoloInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.volo = _data["volo"] ? Volo.fromJS(_data["volo"]) : <any>null;
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : <any>null;
            if (Array.isArray(_data["righe"])) {
                this.righe = [] as any;
                for (let item of _data["righe"])
                    this.righe!.push(OffertaDatoInfo.fromJS(item));
            }
            else {
                this.righe = <any>null;
            }
            this.haOrdinaBiglietteria = _data["haOrdinaBiglietteria"] !== undefined ? _data["haOrdinaBiglietteria"] : <any>null;
            this.soluzione = _data["soluzione"] !== undefined ? _data["soluzione"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.isPnr = _data["isPnr"] !== undefined ? _data["isPnr"] : <any>null;
            this.isNdc = _data["isNdc"] !== undefined ? _data["isNdc"] : <any>null;
            this.abbinamento = _data["abbinamento"] ? AbbinamentoInfo.fromJS(_data["abbinamento"]) : <any>null;
            this.fornitore = _data["fornitore"] ? FornitoreInfo.fromJS(_data["fornitore"]) : <any>null;
            if (Array.isArray(_data["tratte"])) {
                this.tratte = [] as any;
                for (let item of _data["tratte"])
                    this.tratte!.push(VoloTrattaInfo.fromJS(item));
            }
            else {
                this.tratte = <any>null;
            }
            if (Array.isArray(_data["tariffe"])) {
                this.tariffe = [] as any;
                for (let item of _data["tariffe"])
                    this.tariffe!.push(VoloTariffa.fromJS(item));
            }
            else {
                this.tariffe = <any>null;
            }
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(VoloNota.fromJS(item));
            }
            else {
                this.note = <any>null;
            }
            if (Array.isArray(_data["relazioni"])) {
                this.relazioni = [] as any;
                for (let item of _data["relazioni"])
                    this.relazioni!.push(VoloRel.fromJS(item));
            }
            else {
                this.relazioni = <any>null;
            }
        }
    }

    static fromJS(data: any): VoloInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VoloInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["volo"] = this.volo ? this.volo.toJSON() : <any>null;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        if (Array.isArray(this.righe)) {
            data["righe"] = [];
            for (let item of this.righe)
                data["righe"].push(item.toJSON());
        }
        data["haOrdinaBiglietteria"] = this.haOrdinaBiglietteria !== undefined ? this.haOrdinaBiglietteria : <any>null;
        data["soluzione"] = this.soluzione !== undefined ? this.soluzione : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["isPnr"] = this.isPnr !== undefined ? this.isPnr : <any>null;
        data["isNdc"] = this.isNdc !== undefined ? this.isNdc : <any>null;
        data["abbinamento"] = this.abbinamento ? this.abbinamento.toJSON() : <any>null;
        data["fornitore"] = this.fornitore ? this.fornitore.toJSON() : <any>null;
        if (Array.isArray(this.tratte)) {
            data["tratte"] = [];
            for (let item of this.tratte)
                data["tratte"].push(item.toJSON());
        }
        if (Array.isArray(this.tariffe)) {
            data["tariffe"] = [];
            for (let item of this.tariffe)
                data["tariffe"].push(item.toJSON());
        }
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item.toJSON());
        }
        if (Array.isArray(this.relazioni)) {
            data["relazioni"] = [];
            for (let item of this.relazioni)
                data["relazioni"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVoloInfo {
    id?: number;
    volo?: Volo | null;
    offerta?: OffertaInfo | null;
    righe?: OffertaDatoInfo[] | null;
    haOrdinaBiglietteria?: boolean;
    soluzione?: string | null;
    nome?: string | null;
    isPnr?: boolean;
    isNdc?: boolean;
    abbinamento?: AbbinamentoInfo | null;
    fornitore?: FornitoreInfo | null;
    tratte?: VoloTrattaInfo[] | null;
    tariffe?: VoloTariffa[] | null;
    note?: VoloNota[] | null;
    relazioni?: VoloRel[] | null;
}

export class FornitoreInfo implements IFornitoreInfo {
    id?: number;
    eFornitore?: EFornitore;
    fornitore?: HHFornitore;
    usaDescrizioniFornitoreSuTipologieMappate?: boolean;
    luoghiMappati?: { [key: string]: HHLuogo[]; };
    luoghiFornitore?: HHLuogo[];
    accordi?: AccordoInfo[];

    constructor(data?: IFornitoreInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.eFornitore = _data["eFornitore"] !== undefined ? _data["eFornitore"] : <any>null;
            this.fornitore = _data["fornitore"] ? HHFornitore.fromJS(_data["fornitore"]) : <any>null;
            this.usaDescrizioniFornitoreSuTipologieMappate = _data["usaDescrizioniFornitoreSuTipologieMappate"] !== undefined ? _data["usaDescrizioniFornitoreSuTipologieMappate"] : <any>null;
            if (_data["luoghiMappati"]) {
                this.luoghiMappati = {} as any;
                for (let key in _data["luoghiMappati"]) {
                    if (_data["luoghiMappati"].hasOwnProperty(key))
                        (<any>this.luoghiMappati)![key] = _data["luoghiMappati"][key] ? _data["luoghiMappati"][key].map((i: any) => HHLuogo.fromJS(i)) : [];
                }
            }
            else {
                this.luoghiMappati = <any>null;
            }
            if (Array.isArray(_data["luoghiFornitore"])) {
                this.luoghiFornitore = [] as any;
                for (let item of _data["luoghiFornitore"])
                    this.luoghiFornitore!.push(HHLuogo.fromJS(item));
            }
            else {
                this.luoghiFornitore = <any>null;
            }
            if (Array.isArray(_data["accordi"])) {
                this.accordi = [] as any;
                for (let item of _data["accordi"])
                    this.accordi!.push(AccordoInfo.fromJS(item));
            }
            else {
                this.accordi = <any>null;
            }
        }
    }

    static fromJS(data: any): FornitoreInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FornitoreInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["eFornitore"] = this.eFornitore !== undefined ? this.eFornitore : <any>null;
        data["fornitore"] = this.fornitore ? this.fornitore.toJSON() : <any>null;
        data["usaDescrizioniFornitoreSuTipologieMappate"] = this.usaDescrizioniFornitoreSuTipologieMappate !== undefined ? this.usaDescrizioniFornitoreSuTipologieMappate : <any>null;
        if (this.luoghiMappati) {
            data["luoghiMappati"] = {};
            for (let key in this.luoghiMappati) {
                if (this.luoghiMappati.hasOwnProperty(key))
                    (<any>data["luoghiMappati"])[key] = this.luoghiMappati[key] !== undefined ? this.luoghiMappati[key] : <any>null;
            }
        }
        if (Array.isArray(this.luoghiFornitore)) {
            data["luoghiFornitore"] = [];
            for (let item of this.luoghiFornitore)
                data["luoghiFornitore"].push(item.toJSON());
        }
        if (Array.isArray(this.accordi)) {
            data["accordi"] = [];
            for (let item of this.accordi)
                data["accordi"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFornitoreInfo {
    id?: number;
    eFornitore?: EFornitore;
    fornitore?: HHFornitore;
    usaDescrizioniFornitoreSuTipologieMappate?: boolean;
    luoghiMappati?: { [key: string]: HHLuogo[]; };
    luoghiFornitore?: HHLuogo[];
    accordi?: AccordoInfo[];
}

export class HHFornitore implements IHHFornitore {
    id?: number;
    nome!: string;
    attivo?: boolean;
    trattamentoDaXml?: boolean;
    instantPurchaseDaXml?: boolean;
    notRefoundableDaXml?: boolean;
    bookingUsaDateNascitaChild?: boolean;
    bookingUsaDateNascitaAdulti?: boolean;
    bookingUsaGenere?: boolean;
    bookingUsaNomiPax?: boolean;
    serviziAttiviRicerca?: EH2HServiceType;
    serviziAttiviBooking?: EH2HServiceType;
    ultimaRicerca?: string | null;
    ultimaRicercaFault?: string | null;
    durataRicercheSec?: number | null;
    durataRicercheFaultSec?: number | null;
    conteggioRicercheAttive?: number;
    conteggioRicercheAttiveFault?: number;
    ricercaUsaDisponibilitaReale?: boolean;
    codiceGiata?: string | null;
    tipoGestioneSupplementi?: ETipoGestioneSupplementi;
    modalitaPrenotazione?: EModalitaPrenotazione;
    accordoObbligatorio?: boolean;
    forzaIpSuNrf?: boolean;
    policiesCall?: boolean;
    dynamicSupplements?: boolean;
    affidabilita?: number;

    constructor(data?: IHHFornitore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.attivo = _data["attivo"] !== undefined ? _data["attivo"] : <any>null;
            this.trattamentoDaXml = _data["trattamentoDaXml"] !== undefined ? _data["trattamentoDaXml"] : <any>null;
            this.instantPurchaseDaXml = _data["instantPurchaseDaXml"] !== undefined ? _data["instantPurchaseDaXml"] : <any>null;
            this.notRefoundableDaXml = _data["notRefoundableDaXml"] !== undefined ? _data["notRefoundableDaXml"] : <any>null;
            this.bookingUsaDateNascitaChild = _data["bookingUsaDateNascitaChild"] !== undefined ? _data["bookingUsaDateNascitaChild"] : <any>null;
            this.bookingUsaDateNascitaAdulti = _data["bookingUsaDateNascitaAdulti"] !== undefined ? _data["bookingUsaDateNascitaAdulti"] : <any>null;
            this.bookingUsaGenere = _data["bookingUsaGenere"] !== undefined ? _data["bookingUsaGenere"] : <any>null;
            this.bookingUsaNomiPax = _data["bookingUsaNomiPax"] !== undefined ? _data["bookingUsaNomiPax"] : <any>null;
            this.serviziAttiviRicerca = _data["serviziAttiviRicerca"] !== undefined ? _data["serviziAttiviRicerca"] : <any>null;
            this.serviziAttiviBooking = _data["serviziAttiviBooking"] !== undefined ? _data["serviziAttiviBooking"] : <any>null;
            this.ultimaRicerca = _data["ultimaRicerca"] !== undefined ? _data["ultimaRicerca"] : <any>null;
            this.ultimaRicercaFault = _data["ultimaRicercaFault"] !== undefined ? _data["ultimaRicercaFault"] : <any>null;
            this.durataRicercheSec = _data["durataRicercheSec"] !== undefined ? _data["durataRicercheSec"] : <any>null;
            this.durataRicercheFaultSec = _data["durataRicercheFaultSec"] !== undefined ? _data["durataRicercheFaultSec"] : <any>null;
            this.conteggioRicercheAttive = _data["conteggioRicercheAttive"] !== undefined ? _data["conteggioRicercheAttive"] : <any>null;
            this.conteggioRicercheAttiveFault = _data["conteggioRicercheAttiveFault"] !== undefined ? _data["conteggioRicercheAttiveFault"] : <any>null;
            this.ricercaUsaDisponibilitaReale = _data["ricercaUsaDisponibilitaReale"] !== undefined ? _data["ricercaUsaDisponibilitaReale"] : <any>null;
            this.codiceGiata = _data["codiceGiata"] !== undefined ? _data["codiceGiata"] : <any>null;
            this.tipoGestioneSupplementi = _data["tipoGestioneSupplementi"] !== undefined ? _data["tipoGestioneSupplementi"] : <any>null;
            this.modalitaPrenotazione = _data["modalitaPrenotazione"] !== undefined ? _data["modalitaPrenotazione"] : <any>null;
            this.accordoObbligatorio = _data["accordoObbligatorio"] !== undefined ? _data["accordoObbligatorio"] : <any>null;
            this.forzaIpSuNrf = _data["forzaIpSuNrf"] !== undefined ? _data["forzaIpSuNrf"] : <any>null;
            this.policiesCall = _data["policiesCall"] !== undefined ? _data["policiesCall"] : <any>null;
            this.dynamicSupplements = _data["dynamicSupplements"] !== undefined ? _data["dynamicSupplements"] : <any>null;
            this.affidabilita = _data["affidabilita"] !== undefined ? _data["affidabilita"] : <any>null;
        }
    }

    static fromJS(data: any): HHFornitore {
        data = typeof data === 'object' ? data : {};
        let result = new HHFornitore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["attivo"] = this.attivo !== undefined ? this.attivo : <any>null;
        data["trattamentoDaXml"] = this.trattamentoDaXml !== undefined ? this.trattamentoDaXml : <any>null;
        data["instantPurchaseDaXml"] = this.instantPurchaseDaXml !== undefined ? this.instantPurchaseDaXml : <any>null;
        data["notRefoundableDaXml"] = this.notRefoundableDaXml !== undefined ? this.notRefoundableDaXml : <any>null;
        data["bookingUsaDateNascitaChild"] = this.bookingUsaDateNascitaChild !== undefined ? this.bookingUsaDateNascitaChild : <any>null;
        data["bookingUsaDateNascitaAdulti"] = this.bookingUsaDateNascitaAdulti !== undefined ? this.bookingUsaDateNascitaAdulti : <any>null;
        data["bookingUsaGenere"] = this.bookingUsaGenere !== undefined ? this.bookingUsaGenere : <any>null;
        data["bookingUsaNomiPax"] = this.bookingUsaNomiPax !== undefined ? this.bookingUsaNomiPax : <any>null;
        data["serviziAttiviRicerca"] = this.serviziAttiviRicerca !== undefined ? this.serviziAttiviRicerca : <any>null;
        data["serviziAttiviBooking"] = this.serviziAttiviBooking !== undefined ? this.serviziAttiviBooking : <any>null;
        data["ultimaRicerca"] = this.ultimaRicerca !== undefined ? this.ultimaRicerca : <any>null;
        data["ultimaRicercaFault"] = this.ultimaRicercaFault !== undefined ? this.ultimaRicercaFault : <any>null;
        data["durataRicercheSec"] = this.durataRicercheSec !== undefined ? this.durataRicercheSec : <any>null;
        data["durataRicercheFaultSec"] = this.durataRicercheFaultSec !== undefined ? this.durataRicercheFaultSec : <any>null;
        data["conteggioRicercheAttive"] = this.conteggioRicercheAttive !== undefined ? this.conteggioRicercheAttive : <any>null;
        data["conteggioRicercheAttiveFault"] = this.conteggioRicercheAttiveFault !== undefined ? this.conteggioRicercheAttiveFault : <any>null;
        data["ricercaUsaDisponibilitaReale"] = this.ricercaUsaDisponibilitaReale !== undefined ? this.ricercaUsaDisponibilitaReale : <any>null;
        data["codiceGiata"] = this.codiceGiata !== undefined ? this.codiceGiata : <any>null;
        data["tipoGestioneSupplementi"] = this.tipoGestioneSupplementi !== undefined ? this.tipoGestioneSupplementi : <any>null;
        data["modalitaPrenotazione"] = this.modalitaPrenotazione !== undefined ? this.modalitaPrenotazione : <any>null;
        data["accordoObbligatorio"] = this.accordoObbligatorio !== undefined ? this.accordoObbligatorio : <any>null;
        data["forzaIpSuNrf"] = this.forzaIpSuNrf !== undefined ? this.forzaIpSuNrf : <any>null;
        data["policiesCall"] = this.policiesCall !== undefined ? this.policiesCall : <any>null;
        data["dynamicSupplements"] = this.dynamicSupplements !== undefined ? this.dynamicSupplements : <any>null;
        data["affidabilita"] = this.affidabilita !== undefined ? this.affidabilita : <any>null;
        return data;
    }
}

export interface IHHFornitore {
    id?: number;
    nome: string;
    attivo?: boolean;
    trattamentoDaXml?: boolean;
    instantPurchaseDaXml?: boolean;
    notRefoundableDaXml?: boolean;
    bookingUsaDateNascitaChild?: boolean;
    bookingUsaDateNascitaAdulti?: boolean;
    bookingUsaGenere?: boolean;
    bookingUsaNomiPax?: boolean;
    serviziAttiviRicerca?: EH2HServiceType;
    serviziAttiviBooking?: EH2HServiceType;
    ultimaRicerca?: string | null;
    ultimaRicercaFault?: string | null;
    durataRicercheSec?: number | null;
    durataRicercheFaultSec?: number | null;
    conteggioRicercheAttive?: number;
    conteggioRicercheAttiveFault?: number;
    ricercaUsaDisponibilitaReale?: boolean;
    codiceGiata?: string | null;
    tipoGestioneSupplementi?: ETipoGestioneSupplementi;
    modalitaPrenotazione?: EModalitaPrenotazione;
    accordoObbligatorio?: boolean;
    forzaIpSuNrf?: boolean;
    policiesCall?: boolean;
    dynamicSupplements?: boolean;
    affidabilita?: number;
}

export enum EH2HServiceType {
    Nessuno = "Nessuno",
    Hotels = "Hotels",
    Flights = "Flights",
    Cars = "Cars",
    Ferries = "Ferries",
    Cruises = "Cruises",
    Visit = "Visit",
    Tours = "Tours",
    Selfdrive = "Selfdrive",
}

export enum ETipoGestioneSupplementi {
    NonGestiti = "NonGestiti",
    ComeServiziDistinti = "ComeServiziDistinti",
    AbbinatiAlServizioPrincipale = "AbbinatiAlServizioPrincipale",
}

export enum EModalitaPrenotazione {
    UnaPrenotazionePerRiga = "UnaPrenotazionePerRiga",
    UnaPrenotazionePerOfferta = "UnaPrenotazionePerOfferta",
}

export class VoloTrattaInfo implements IVoloTrattaInfo {
    _MinutiCheckinPartenza?: number | null;
    id?: number;
    voloTratta?: VoloTratta | null;
    compagnia?: CompagniaAerea | null;
    compagniaOperated?: CompagniaAerea | null;
    daAeroporto?: Aeroporto | null;
    adAeroporto?: Aeroporto | null;
    arrivoIlGiornoDopo?: boolean;
    stato?: StatoVolo | null;
    voloInternazionale?: boolean;
    minutiCheckinPartenza?: number;

    constructor(data?: IVoloTrattaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._MinutiCheckinPartenza = _data["_MinutiCheckinPartenza"] !== undefined ? _data["_MinutiCheckinPartenza"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.voloTratta = _data["voloTratta"] ? VoloTratta.fromJS(_data["voloTratta"]) : <any>null;
            this.compagnia = _data["compagnia"] ? CompagniaAerea.fromJS(_data["compagnia"]) : <any>null;
            this.compagniaOperated = _data["compagniaOperated"] ? CompagniaAerea.fromJS(_data["compagniaOperated"]) : <any>null;
            this.daAeroporto = _data["daAeroporto"] ? Aeroporto.fromJS(_data["daAeroporto"]) : <any>null;
            this.adAeroporto = _data["adAeroporto"] ? Aeroporto.fromJS(_data["adAeroporto"]) : <any>null;
            this.arrivoIlGiornoDopo = _data["arrivoIlGiornoDopo"] !== undefined ? _data["arrivoIlGiornoDopo"] : <any>null;
            this.stato = _data["stato"] ? StatoVolo.fromJS(_data["stato"]) : <any>null;
            this.voloInternazionale = _data["voloInternazionale"] !== undefined ? _data["voloInternazionale"] : <any>null;
            this.minutiCheckinPartenza = _data["minutiCheckinPartenza"] !== undefined ? _data["minutiCheckinPartenza"] : <any>null;
        }
    }

    static fromJS(data: any): VoloTrattaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VoloTrattaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_MinutiCheckinPartenza"] = this._MinutiCheckinPartenza !== undefined ? this._MinutiCheckinPartenza : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["voloTratta"] = this.voloTratta ? this.voloTratta.toJSON() : <any>null;
        data["compagnia"] = this.compagnia ? this.compagnia.toJSON() : <any>null;
        data["compagniaOperated"] = this.compagniaOperated ? this.compagniaOperated.toJSON() : <any>null;
        data["daAeroporto"] = this.daAeroporto ? this.daAeroporto.toJSON() : <any>null;
        data["adAeroporto"] = this.adAeroporto ? this.adAeroporto.toJSON() : <any>null;
        data["arrivoIlGiornoDopo"] = this.arrivoIlGiornoDopo !== undefined ? this.arrivoIlGiornoDopo : <any>null;
        data["stato"] = this.stato ? this.stato.toJSON() : <any>null;
        data["voloInternazionale"] = this.voloInternazionale !== undefined ? this.voloInternazionale : <any>null;
        data["minutiCheckinPartenza"] = this.minutiCheckinPartenza !== undefined ? this.minutiCheckinPartenza : <any>null;
        return data;
    }
}

export interface IVoloTrattaInfo {
    _MinutiCheckinPartenza?: number | null;
    id?: number;
    voloTratta?: VoloTratta | null;
    compagnia?: CompagniaAerea | null;
    compagniaOperated?: CompagniaAerea | null;
    daAeroporto?: Aeroporto | null;
    adAeroporto?: Aeroporto | null;
    arrivoIlGiornoDopo?: boolean;
    stato?: StatoVolo | null;
    voloInternazionale?: boolean;
    minutiCheckinPartenza?: number;
}

export class VoloTicketsInfo implements IVoloTicketsInfo {
    id?: number;
    voloTickets?: VoloTickets;
    isValid?: boolean;
    offertaID?: number;
    volo?: Volo | null;
    voloID?: number | null;
    ordine?: number;
    cliente?: Cliente | null;

    constructor(data?: IVoloTicketsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.voloTickets = _data["voloTickets"] ? VoloTickets.fromJS(_data["voloTickets"]) : <any>null;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.volo = _data["volo"] ? Volo.fromJS(_data["volo"]) : <any>null;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.cliente = _data["cliente"] ? Cliente.fromJS(_data["cliente"]) : <any>null;
        }
    }

    static fromJS(data: any): VoloTicketsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VoloTicketsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["voloTickets"] = this.voloTickets ? this.voloTickets.toJSON() : <any>null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["volo"] = this.volo ? this.volo.toJSON() : <any>null;
        data["voloID"] = this.voloID !== undefined ? this.voloID : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["cliente"] = this.cliente ? this.cliente.toJSON() : <any>null;
        return data;
    }
}

export interface IVoloTicketsInfo {
    id?: number;
    voloTickets?: VoloTickets;
    isValid?: boolean;
    offertaID?: number;
    volo?: Volo | null;
    voloID?: number | null;
    ordine?: number;
    cliente?: Cliente | null;
}

export class VoloTickets implements IVoloTickets {
    id?: number;
    offertaID?: number;
    voloID?: number | null;
    clienteID?: number | null;
    testoTicket?: string | null;
    ordine?: number;

    constructor(data?: IVoloTickets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : <any>null;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : <any>null;
            this.testoTicket = _data["testoTicket"] !== undefined ? _data["testoTicket"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
        }
    }

    static fromJS(data: any): VoloTickets {
        data = typeof data === 'object' ? data : {};
        let result = new VoloTickets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["voloID"] = this.voloID !== undefined ? this.voloID : <any>null;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : <any>null;
        data["testoTicket"] = this.testoTicket !== undefined ? this.testoTicket : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        return data;
    }
}

export interface IVoloTickets {
    id?: number;
    offertaID?: number;
    voloID?: number | null;
    clienteID?: number | null;
    testoTicket?: string | null;
    ordine?: number;
}

export class VoucherInfo implements IVoucherInfo {
    offerta?: OffertaInfo | null;
    isPreview?: boolean;
    id?: number;
    voucher?: Voucher | null;
    nr?: string | null;
    idStr?: string | null;
    testata?: string | null;
    prenotazione?: string | null;
    clienti?: string | null;
    clientiText?: string | null;
    servizio?: string | null;
    periodo?: string | null;
    istruzioni?: string | null;

    constructor(data?: IVoucherInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerta = _data["offerta"] ? OffertaInfo.fromJS(_data["offerta"]) : <any>null;
            this.isPreview = _data["isPreview"] !== undefined ? _data["isPreview"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.voucher = _data["voucher"] ? Voucher.fromJS(_data["voucher"]) : <any>null;
            this.nr = _data["nr"] !== undefined ? _data["nr"] : <any>null;
            this.idStr = _data["idStr"] !== undefined ? _data["idStr"] : <any>null;
            this.testata = _data["testata"] !== undefined ? _data["testata"] : <any>null;
            this.prenotazione = _data["prenotazione"] !== undefined ? _data["prenotazione"] : <any>null;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : <any>null;
            this.clientiText = _data["clientiText"] !== undefined ? _data["clientiText"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.periodo = _data["periodo"] !== undefined ? _data["periodo"] : <any>null;
            this.istruzioni = _data["istruzioni"] !== undefined ? _data["istruzioni"] : <any>null;
        }
    }

    static fromJS(data: any): VoucherInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        data["isPreview"] = this.isPreview !== undefined ? this.isPreview : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["voucher"] = this.voucher ? this.voucher.toJSON() : <any>null;
        data["nr"] = this.nr !== undefined ? this.nr : <any>null;
        data["idStr"] = this.idStr !== undefined ? this.idStr : <any>null;
        data["testata"] = this.testata !== undefined ? this.testata : <any>null;
        data["prenotazione"] = this.prenotazione !== undefined ? this.prenotazione : <any>null;
        data["clienti"] = this.clienti !== undefined ? this.clienti : <any>null;
        data["clientiText"] = this.clientiText !== undefined ? this.clientiText : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["periodo"] = this.periodo !== undefined ? this.periodo : <any>null;
        data["istruzioni"] = this.istruzioni !== undefined ? this.istruzioni : <any>null;
        return data;
    }
}

export interface IVoucherInfo {
    offerta?: OffertaInfo | null;
    isPreview?: boolean;
    id?: number;
    voucher?: Voucher | null;
    nr?: string | null;
    idStr?: string | null;
    testata?: string | null;
    prenotazione?: string | null;
    clienti?: string | null;
    clientiText?: string | null;
    servizio?: string | null;
    periodo?: string | null;
    istruzioni?: string | null;
}

export class OffertaTesto implements IOffertaTesto {
    id?: number;
    offertaID?: number;
    tappaID?: number;
    giornoTappa?: number;
    editAgenzia?: number;
    ordine?: number;
    testo?: string | null;

    constructor(data?: IOffertaTesto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.tappaID = _data["tappaID"] !== undefined ? _data["tappaID"] : <any>null;
            this.giornoTappa = _data["giornoTappa"] !== undefined ? _data["giornoTappa"] : <any>null;
            this.editAgenzia = _data["editAgenzia"] !== undefined ? _data["editAgenzia"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaTesto {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaTesto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["tappaID"] = this.tappaID !== undefined ? this.tappaID : <any>null;
        data["giornoTappa"] = this.giornoTappa !== undefined ? this.giornoTappa : <any>null;
        data["editAgenzia"] = this.editAgenzia !== undefined ? this.editAgenzia : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        return data;
    }
}

export interface IOffertaTesto {
    id?: number;
    offertaID?: number;
    tappaID?: number;
    giornoTappa?: number;
    editAgenzia?: number;
    ordine?: number;
    testo?: string | null;
}

export class SectionUffici extends ExportableSection implements ISectionUffici {
    uffici?: RigaUfficio[] | null;

    constructor(data?: ISectionUffici) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["uffici"])) {
                this.uffici = [] as any;
                for (let item of _data["uffici"])
                    this.uffici!.push(RigaUfficio.fromJS(item));
            }
            else {
                this.uffici = <any>null;
            }
        }
    }

    static fromJS(data: any): SectionUffici {
        data = typeof data === 'object' ? data : {};
        let result = new SectionUffici();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uffici)) {
            data["uffici"] = [];
            for (let item of this.uffici)
                data["uffici"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISectionUffici extends IExportableSection {
    uffici?: RigaUfficio[] | null;
}

export class RigaUfficio implements IRigaUfficio {
    nome?: string | null;
    telefono?: string | null;
    testo?: string | null;
    servizi?: ServizioUfficio[] | null;

    constructor(data?: IRigaUfficio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioUfficio.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
        }
    }

    static fromJS(data: any): RigaUfficio {
        data = typeof data === 'object' ? data : {};
        let result = new RigaUfficio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRigaUfficio {
    nome?: string | null;
    telefono?: string | null;
    testo?: string | null;
    servizi?: ServizioUfficio[] | null;
}

export class ServizioUfficio implements IServizioUfficio {
    tipo?: ETipoServizio;
    luogo?: string | null;
    nome?: string | null;
    date?: string | null;

    constructor(data?: IServizioUfficio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioUfficio {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioUfficio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        return data;
    }
}

export interface IServizioUfficio {
    tipo?: ETipoServizio;
    luogo?: string | null;
    nome?: string | null;
    date?: string | null;
}

export class SectionInfoHotel extends ExportableSection implements ISectionInfoHotel {
    elencoHotel?: HotelDescrizione[] | null;

    constructor(data?: ISectionInfoHotel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["elencoHotel"])) {
                this.elencoHotel = [] as any;
                for (let item of _data["elencoHotel"])
                    this.elencoHotel!.push(HotelDescrizione.fromJS(item));
            }
            else {
                this.elencoHotel = <any>null;
            }
        }
    }

    static fromJS(data: any): SectionInfoHotel {
        data = typeof data === 'object' ? data : {};
        let result = new SectionInfoHotel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elencoHotel)) {
            data["elencoHotel"] = [];
            for (let item of this.elencoHotel)
                data["elencoHotel"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISectionInfoHotel extends IExportableSection {
    elencoHotel?: HotelDescrizione[] | null;
}

export class HotelDescrizione implements IHotelDescrizione {
    inizio?: string;
    fine?: string;
    notti?: number;
    servizioID?: number | null;
    lat?: number | null;
    lon?: number | null;
    zoom?: number | null;
    descrizione?: string | null;
    contattoId?: number;
    contattoNome?: string | null;
    contattoLuogo?: string | null;
    contattoIndirizzo?: string | null;
    contattoTelefono?: string | null;
    imagesUrl?: string[] | null;
    vouchers?: ReservationVoucher[] | null;
    coverImageUrl?: string | null;
    mapGoogleUrl?: string | null;

    constructor(data?: IHotelDescrizione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inizio = _data["inizio"] !== undefined ? _data["inizio"] : <any>null;
            this.fine = _data["fine"] !== undefined ? _data["fine"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lon = _data["lon"] !== undefined ? _data["lon"] : <any>null;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
            this.contattoNome = _data["contattoNome"] !== undefined ? _data["contattoNome"] : <any>null;
            this.contattoLuogo = _data["contattoLuogo"] !== undefined ? _data["contattoLuogo"] : <any>null;
            this.contattoIndirizzo = _data["contattoIndirizzo"] !== undefined ? _data["contattoIndirizzo"] : <any>null;
            this.contattoTelefono = _data["contattoTelefono"] !== undefined ? _data["contattoTelefono"] : <any>null;
            if (Array.isArray(_data["imagesUrl"])) {
                this.imagesUrl = [] as any;
                for (let item of _data["imagesUrl"])
                    this.imagesUrl!.push(item);
            }
            else {
                this.imagesUrl = <any>null;
            }
            if (Array.isArray(_data["vouchers"])) {
                this.vouchers = [] as any;
                for (let item of _data["vouchers"])
                    this.vouchers!.push(ReservationVoucher.fromJS(item));
            }
            else {
                this.vouchers = <any>null;
            }
            this.coverImageUrl = _data["coverImageUrl"] !== undefined ? _data["coverImageUrl"] : <any>null;
            this.mapGoogleUrl = _data["mapGoogleUrl"] !== undefined ? _data["mapGoogleUrl"] : <any>null;
        }
    }

    static fromJS(data: any): HotelDescrizione {
        data = typeof data === 'object' ? data : {};
        let result = new HotelDescrizione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inizio"] = this.inizio !== undefined ? this.inizio : <any>null;
        data["fine"] = this.fine !== undefined ? this.fine : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lon"] = this.lon !== undefined ? this.lon : <any>null;
        data["zoom"] = this.zoom !== undefined ? this.zoom : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        data["contattoNome"] = this.contattoNome !== undefined ? this.contattoNome : <any>null;
        data["contattoLuogo"] = this.contattoLuogo !== undefined ? this.contattoLuogo : <any>null;
        data["contattoIndirizzo"] = this.contattoIndirizzo !== undefined ? this.contattoIndirizzo : <any>null;
        data["contattoTelefono"] = this.contattoTelefono !== undefined ? this.contattoTelefono : <any>null;
        if (Array.isArray(this.imagesUrl)) {
            data["imagesUrl"] = [];
            for (let item of this.imagesUrl)
                data["imagesUrl"].push(item);
        }
        if (Array.isArray(this.vouchers)) {
            data["vouchers"] = [];
            for (let item of this.vouchers)
                data["vouchers"].push(item.toJSON());
        }
        data["coverImageUrl"] = this.coverImageUrl !== undefined ? this.coverImageUrl : <any>null;
        data["mapGoogleUrl"] = this.mapGoogleUrl !== undefined ? this.mapGoogleUrl : <any>null;
        return data;
    }
}

export interface IHotelDescrizione {
    inizio?: string;
    fine?: string;
    notti?: number;
    servizioID?: number | null;
    lat?: number | null;
    lon?: number | null;
    zoom?: number | null;
    descrizione?: string | null;
    contattoId?: number;
    contattoNome?: string | null;
    contattoLuogo?: string | null;
    contattoIndirizzo?: string | null;
    contattoTelefono?: string | null;
    imagesUrl?: string[] | null;
    vouchers?: ReservationVoucher[] | null;
    coverImageUrl?: string | null;
    mapGoogleUrl?: string | null;
}

export class ReservationVoucher implements IReservationVoucher {
    nr?: string | null;
    voucherID?: number;
    offertaID?: number | null;
    ordine?: number | null;
    testata?: string | null;
    bookingRef?: string | null;
    clienti?: string | null;
    descrizioneServizio?: string | null;
    periodo?: string | null;
    dettaglio?: string | null;
    istruzioni?: string | null;
    servizioID?: number | null;
    lingua?: ELingua | null;
    versione?: number;
    paxList?: string[] | null;

    constructor(data?: IReservationVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nr = _data["nr"] !== undefined ? _data["nr"] : <any>null;
            this.voucherID = _data["voucherID"] !== undefined ? _data["voucherID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.testata = _data["testata"] !== undefined ? _data["testata"] : <any>null;
            this.bookingRef = _data["bookingRef"] !== undefined ? _data["bookingRef"] : <any>null;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : <any>null;
            this.descrizioneServizio = _data["descrizioneServizio"] !== undefined ? _data["descrizioneServizio"] : <any>null;
            this.periodo = _data["periodo"] !== undefined ? _data["periodo"] : <any>null;
            this.dettaglio = _data["dettaglio"] !== undefined ? _data["dettaglio"] : <any>null;
            this.istruzioni = _data["istruzioni"] !== undefined ? _data["istruzioni"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.versione = _data["versione"] !== undefined ? _data["versione"] : <any>null;
            if (Array.isArray(_data["paxList"])) {
                this.paxList = [] as any;
                for (let item of _data["paxList"])
                    this.paxList!.push(item);
            }
            else {
                this.paxList = <any>null;
            }
        }
    }

    static fromJS(data: any): ReservationVoucher {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationVoucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nr"] = this.nr !== undefined ? this.nr : <any>null;
        data["voucherID"] = this.voucherID !== undefined ? this.voucherID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["testata"] = this.testata !== undefined ? this.testata : <any>null;
        data["bookingRef"] = this.bookingRef !== undefined ? this.bookingRef : <any>null;
        data["clienti"] = this.clienti !== undefined ? this.clienti : <any>null;
        data["descrizioneServizio"] = this.descrizioneServizio !== undefined ? this.descrizioneServizio : <any>null;
        data["periodo"] = this.periodo !== undefined ? this.periodo : <any>null;
        data["dettaglio"] = this.dettaglio !== undefined ? this.dettaglio : <any>null;
        data["istruzioni"] = this.istruzioni !== undefined ? this.istruzioni : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["versione"] = this.versione !== undefined ? this.versione : <any>null;
        if (Array.isArray(this.paxList)) {
            data["paxList"] = [];
            for (let item of this.paxList)
                data["paxList"].push(item);
        }
        return data;
    }
}

export interface IReservationVoucher {
    nr?: string | null;
    voucherID?: number;
    offertaID?: number | null;
    ordine?: number | null;
    testata?: string | null;
    bookingRef?: string | null;
    clienti?: string | null;
    descrizioneServizio?: string | null;
    periodo?: string | null;
    dettaglio?: string | null;
    istruzioni?: string | null;
    servizioID?: number | null;
    lingua?: ELingua | null;
    versione?: number;
    paxList?: string[] | null;
}

export class SectionNote extends ExportableSection implements ISectionNote {
    note?: string | null;

    constructor(data?: ISectionNote) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): SectionNote {
        data = typeof data === 'object' ? data : {};
        let result = new SectionNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note !== undefined ? this.note : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISectionNote extends IExportableSection {
    note?: string | null;
}

export class SectionProgrammaDiViaggio extends ExportableSection implements ISectionProgrammaDiViaggio {
    days?: PdvDay[] | null;

    constructor(data?: ISectionProgrammaDiViaggio) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(PdvDay.fromJS(item));
            }
            else {
                this.days = <any>null;
            }
        }
    }

    static fromJS(data: any): SectionProgrammaDiViaggio {
        data = typeof data === 'object' ? data : {};
        let result = new SectionProgrammaDiViaggio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISectionProgrammaDiViaggio extends IExportableSection {
    days?: PdvDay[] | null;
}

export class PdvDay implements IPdvDay {
    orePrima?: number;
    minutiPrima?: number;
    giorno?: number;
    inizio?: string;
    fine?: string | null;
    locations?: string | null;
    headerDate?: string | null;
    testo?: string | null;
    voli?: PdvVolo[] | null;
    immagini?: PdvImage[] | null;
    elencoServizi?: PdvServizio[] | null;
    cityMap?: PdvImage | null;

    constructor(data?: IPdvDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orePrima = _data["orePrima"] !== undefined ? _data["orePrima"] : <any>null;
            this.minutiPrima = _data["minutiPrima"] !== undefined ? _data["minutiPrima"] : <any>null;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.inizio = _data["inizio"] !== undefined ? _data["inizio"] : <any>null;
            this.fine = _data["fine"] !== undefined ? _data["fine"] : <any>null;
            this.locations = _data["locations"] !== undefined ? _data["locations"] : <any>null;
            this.headerDate = _data["headerDate"] !== undefined ? _data["headerDate"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            if (Array.isArray(_data["voli"])) {
                this.voli = [] as any;
                for (let item of _data["voli"])
                    this.voli!.push(PdvVolo.fromJS(item));
            }
            else {
                this.voli = <any>null;
            }
            if (Array.isArray(_data["immagini"])) {
                this.immagini = [] as any;
                for (let item of _data["immagini"])
                    this.immagini!.push(PdvImage.fromJS(item));
            }
            else {
                this.immagini = <any>null;
            }
            if (Array.isArray(_data["elencoServizi"])) {
                this.elencoServizi = [] as any;
                for (let item of _data["elencoServizi"])
                    this.elencoServizi!.push(PdvServizio.fromJS(item));
            }
            else {
                this.elencoServizi = <any>null;
            }
            this.cityMap = _data["cityMap"] ? PdvImage.fromJS(_data["cityMap"]) : <any>null;
        }
    }

    static fromJS(data: any): PdvDay {
        data = typeof data === 'object' ? data : {};
        let result = new PdvDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orePrima"] = this.orePrima !== undefined ? this.orePrima : <any>null;
        data["minutiPrima"] = this.minutiPrima !== undefined ? this.minutiPrima : <any>null;
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["inizio"] = this.inizio !== undefined ? this.inizio : <any>null;
        data["fine"] = this.fine !== undefined ? this.fine : <any>null;
        data["locations"] = this.locations !== undefined ? this.locations : <any>null;
        data["headerDate"] = this.headerDate !== undefined ? this.headerDate : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        if (Array.isArray(this.voli)) {
            data["voli"] = [];
            for (let item of this.voli)
                data["voli"].push(item.toJSON());
        }
        if (Array.isArray(this.immagini)) {
            data["immagini"] = [];
            for (let item of this.immagini)
                data["immagini"].push(item.toJSON());
        }
        if (Array.isArray(this.elencoServizi)) {
            data["elencoServizi"] = [];
            for (let item of this.elencoServizi)
                data["elencoServizi"].push(item.toJSON());
        }
        data["cityMap"] = this.cityMap ? this.cityMap.toJSON() : <any>null;
        return data;
    }
}

export interface IPdvDay {
    orePrima?: number;
    minutiPrima?: number;
    giorno?: number;
    inizio?: string;
    fine?: string | null;
    locations?: string | null;
    headerDate?: string | null;
    testo?: string | null;
    voli?: PdvVolo[] | null;
    immagini?: PdvImage[] | null;
    elencoServizi?: PdvServizio[] | null;
    cityMap?: PdvImage | null;
}

export class PdvVolo implements IPdvVolo {
    compagniaNome?: string | null;
    compagniaCodice?: string | null;
    numeroVolo?: number;
    partenza?: string | null;
    partenzaAeroporto?: string | null;
    arrivo?: string | null;
    arrivoAeroporto?: string | null;
    arrivoIlGiornoDopo?: boolean;

    constructor(data?: IPdvVolo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.compagniaNome = _data["compagniaNome"] !== undefined ? _data["compagniaNome"] : <any>null;
            this.compagniaCodice = _data["compagniaCodice"] !== undefined ? _data["compagniaCodice"] : <any>null;
            this.numeroVolo = _data["numeroVolo"] !== undefined ? _data["numeroVolo"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.partenzaAeroporto = _data["partenzaAeroporto"] !== undefined ? _data["partenzaAeroporto"] : <any>null;
            this.arrivo = _data["arrivo"] !== undefined ? _data["arrivo"] : <any>null;
            this.arrivoAeroporto = _data["arrivoAeroporto"] !== undefined ? _data["arrivoAeroporto"] : <any>null;
            this.arrivoIlGiornoDopo = _data["arrivoIlGiornoDopo"] !== undefined ? _data["arrivoIlGiornoDopo"] : <any>null;
        }
    }

    static fromJS(data: any): PdvVolo {
        data = typeof data === 'object' ? data : {};
        let result = new PdvVolo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compagniaNome"] = this.compagniaNome !== undefined ? this.compagniaNome : <any>null;
        data["compagniaCodice"] = this.compagniaCodice !== undefined ? this.compagniaCodice : <any>null;
        data["numeroVolo"] = this.numeroVolo !== undefined ? this.numeroVolo : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["partenzaAeroporto"] = this.partenzaAeroporto !== undefined ? this.partenzaAeroporto : <any>null;
        data["arrivo"] = this.arrivo !== undefined ? this.arrivo : <any>null;
        data["arrivoAeroporto"] = this.arrivoAeroporto !== undefined ? this.arrivoAeroporto : <any>null;
        data["arrivoIlGiornoDopo"] = this.arrivoIlGiornoDopo !== undefined ? this.arrivoIlGiornoDopo : <any>null;
        return data;
    }
}

export interface IPdvVolo {
    compagniaNome?: string | null;
    compagniaCodice?: string | null;
    numeroVolo?: number;
    partenza?: string | null;
    partenzaAeroporto?: string | null;
    arrivo?: string | null;
    arrivoAeroporto?: string | null;
    arrivoIlGiornoDopo?: boolean;
}

export class PdvImage implements IPdvImage {
    id?: number;
    url?: string | null;
    caption?: string | null;

    constructor(data?: IPdvImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.caption = _data["caption"] !== undefined ? _data["caption"] : <any>null;
        }
    }

    static fromJS(data: any): PdvImage {
        data = typeof data === 'object' ? data : {};
        let result = new PdvImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        return data;
    }
}

export interface IPdvImage {
    id?: number;
    url?: string | null;
    caption?: string | null;
}

export class PdvServizio implements IPdvServizio {
    nome?: string | null;
    descrizione?: string | null;
    durata?: number;
    data?: string | null;
    tipoServizio?: ETipoServizio;
    imageUrl?: string | null;
    idServizio?: number;
    puntoIniziale?: TripServiceLocation | null;
    puntoFinale?: TripServiceLocation | null;

    constructor(data?: IPdvServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            this.idServizio = _data["idServizio"] !== undefined ? _data["idServizio"] : <any>null;
            this.puntoIniziale = _data["puntoIniziale"] ? TripServiceLocation.fromJS(_data["puntoIniziale"]) : <any>null;
            this.puntoFinale = _data["puntoFinale"] ? TripServiceLocation.fromJS(_data["puntoFinale"]) : <any>null;
        }
    }

    static fromJS(data: any): PdvServizio {
        data = typeof data === 'object' ? data : {};
        let result = new PdvServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["durata"] = this.durata !== undefined ? this.durata : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        data["idServizio"] = this.idServizio !== undefined ? this.idServizio : <any>null;
        data["puntoIniziale"] = this.puntoIniziale ? this.puntoIniziale.toJSON() : <any>null;
        data["puntoFinale"] = this.puntoFinale ? this.puntoFinale.toJSON() : <any>null;
        return data;
    }
}

export interface IPdvServizio {
    nome?: string | null;
    descrizione?: string | null;
    durata?: number;
    data?: string | null;
    tipoServizio?: ETipoServizio;
    imageUrl?: string | null;
    idServizio?: number;
    puntoIniziale?: TripServiceLocation | null;
    puntoFinale?: TripServiceLocation | null;
}

export class TripServiceLocation implements ITripServiceLocation {
    contattoId?: number;
    /** Data e ora  */
    date?: string;
    /** Nome del luogo / contatto */
    nome?: string | null;
    /** Indirizzo */
    indirizzo?: string | null;
    /** Numero civico */
    numero?: string | null;
    /** Cap */
    cap?: string | null;
    /** Nome del luogo (in lingua) */
    luogo?: string | null;
    /** Ulteriori dettagli */
    dettagli?: string | null;

    constructor(data?: ITripServiceLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.numero = _data["numero"] !== undefined ? _data["numero"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.dettagli = _data["dettagli"] !== undefined ? _data["dettagli"] : <any>null;
        }
    }

    static fromJS(data: any): TripServiceLocation {
        data = typeof data === 'object' ? data : {};
        let result = new TripServiceLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["numero"] = this.numero !== undefined ? this.numero : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["dettagli"] = this.dettagli !== undefined ? this.dettagli : <any>null;
        return data;
    }
}

export interface ITripServiceLocation {
    contattoId?: number;
    /** Data e ora  */
    date?: string;
    /** Nome del luogo / contatto */
    nome?: string | null;
    /** Indirizzo */
    indirizzo?: string | null;
    /** Numero civico */
    numero?: string | null;
    /** Cap */
    cap?: string | null;
    /** Nome del luogo (in lingua) */
    luogo?: string | null;
    /** Ulteriori dettagli */
    dettagli?: string | null;
}

export class SectionAssistenza implements ISectionAssistenza {
    titolo?: string | null;
    testo?: string | null;

    constructor(data?: ISectionAssistenza) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
        }
    }

    static fromJS(data: any): SectionAssistenza {
        data = typeof data === 'object' ? data : {};
        let result = new SectionAssistenza();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        return data;
    }
}

export interface ISectionAssistenza {
    titolo?: string | null;
    testo?: string | null;
}

export class SectionAssicurazione implements ISectionAssicurazione {
    insurancesList?: AssicurazioneItem[] | null;

    constructor(data?: ISectionAssicurazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insurancesList"])) {
                this.insurancesList = [] as any;
                for (let item of _data["insurancesList"])
                    this.insurancesList!.push(AssicurazioneItem.fromJS(item));
            }
            else {
                this.insurancesList = <any>null;
            }
        }
    }

    static fromJS(data: any): SectionAssicurazione {
        data = typeof data === 'object' ? data : {};
        let result = new SectionAssicurazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insurancesList)) {
            data["insurancesList"] = [];
            for (let item of this.insurancesList)
                data["insurancesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISectionAssicurazione {
    insurancesList?: AssicurazioneItem[] | null;
}

export class AssicurazioneItem implements IAssicurazioneItem {
    titolo?: string | null;
    testo?: string | null;
    qrCodeUrl?: string | null;
    idServizio?: number;

    constructor(data?: IAssicurazioneItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.qrCodeUrl = _data["qrCodeUrl"] !== undefined ? _data["qrCodeUrl"] : <any>null;
            this.idServizio = _data["idServizio"] !== undefined ? _data["idServizio"] : <any>null;
        }
    }

    static fromJS(data: any): AssicurazioneItem {
        data = typeof data === 'object' ? data : {};
        let result = new AssicurazioneItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["qrCodeUrl"] = this.qrCodeUrl !== undefined ? this.qrCodeUrl : <any>null;
        data["idServizio"] = this.idServizio !== undefined ? this.idServizio : <any>null;
        return data;
    }
}

export interface IAssicurazioneItem {
    titolo?: string | null;
    testo?: string | null;
    qrCodeUrl?: string | null;
    idServizio?: number;
}

export class SectionElencoVoucher extends ExportableSection implements ISectionElencoVoucher {
    elencoServizi?: ServizioVoucher[] | null;

    constructor(data?: ISectionElencoVoucher) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["elencoServizi"])) {
                this.elencoServizi = [] as any;
                for (let item of _data["elencoServizi"])
                    this.elencoServizi!.push(ServizioVoucher.fromJS(item));
            }
            else {
                this.elencoServizi = <any>null;
            }
        }
    }

    static fromJS(data: any): SectionElencoVoucher {
        data = typeof data === 'object' ? data : {};
        let result = new SectionElencoVoucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elencoServizi)) {
            data["elencoServizi"] = [];
            for (let item of this.elencoServizi)
                data["elencoServizi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISectionElencoVoucher extends IExportableSection {
    elencoServizi?: ServizioVoucher[] | null;
}

/** Si carica i dati del servizio necessari al voucher */
export class ServizioVoucher extends HotelDescrizione implements IServizioVoucher {
    descrizioniRighe?: string[] | null;
    tipoServizio?: ETipoServizio;
    nome?: string | null;
    stelle?: number | null;
    /** Dati del punto iniziale */
    puntoIniziale?: TripServiceLocation | null;
    /** Dati del punto finale */
    puntoFinale?: TripServiceLocation | null;
    offertaId?: number;
    bookingRef?: string | null;
    paxList?: VoucherPax[] | null;
    lingua?: ELingua;
    dettaglio?: string | null;
    note?: string[] | null;
    datiaggiuntivi?: string[] | null;
    statusServizio?: EStatusServizio | null;
    isFullContent?: boolean;
    fullContentInfo?: string | null;

    constructor(data?: IServizioVoucher) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["descrizioniRighe"])) {
                this.descrizioniRighe = [] as any;
                for (let item of _data["descrizioniRighe"])
                    this.descrizioniRighe!.push(item);
            }
            else {
                this.descrizioniRighe = <any>null;
            }
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.stelle = _data["stelle"] !== undefined ? _data["stelle"] : <any>null;
            this.puntoIniziale = _data["puntoIniziale"] ? TripServiceLocation.fromJS(_data["puntoIniziale"]) : <any>null;
            this.puntoFinale = _data["puntoFinale"] ? TripServiceLocation.fromJS(_data["puntoFinale"]) : <any>null;
            this.offertaId = _data["offertaId"] !== undefined ? _data["offertaId"] : <any>null;
            this.bookingRef = _data["bookingRef"] !== undefined ? _data["bookingRef"] : <any>null;
            if (Array.isArray(_data["paxList"])) {
                this.paxList = [] as any;
                for (let item of _data["paxList"])
                    this.paxList!.push(VoucherPax.fromJS(item));
            }
            else {
                this.paxList = <any>null;
            }
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.dettaglio = _data["dettaglio"] !== undefined ? _data["dettaglio"] : <any>null;
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(item);
            }
            else {
                this.note = <any>null;
            }
            if (Array.isArray(_data["datiaggiuntivi"])) {
                this.datiaggiuntivi = [] as any;
                for (let item of _data["datiaggiuntivi"])
                    this.datiaggiuntivi!.push(item);
            }
            else {
                this.datiaggiuntivi = <any>null;
            }
            this.statusServizio = _data["statusServizio"] !== undefined ? _data["statusServizio"] : <any>null;
            this.isFullContent = _data["isFullContent"] !== undefined ? _data["isFullContent"] : <any>null;
            this.fullContentInfo = _data["fullContentInfo"] !== undefined ? _data["fullContentInfo"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioVoucher {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioVoucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.descrizioniRighe)) {
            data["descrizioniRighe"] = [];
            for (let item of this.descrizioniRighe)
                data["descrizioniRighe"].push(item);
        }
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["stelle"] = this.stelle !== undefined ? this.stelle : <any>null;
        data["puntoIniziale"] = this.puntoIniziale ? this.puntoIniziale.toJSON() : <any>null;
        data["puntoFinale"] = this.puntoFinale ? this.puntoFinale.toJSON() : <any>null;
        data["offertaId"] = this.offertaId !== undefined ? this.offertaId : <any>null;
        data["bookingRef"] = this.bookingRef !== undefined ? this.bookingRef : <any>null;
        if (Array.isArray(this.paxList)) {
            data["paxList"] = [];
            for (let item of this.paxList)
                data["paxList"].push(item.toJSON());
        }
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["dettaglio"] = this.dettaglio !== undefined ? this.dettaglio : <any>null;
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item);
        }
        if (Array.isArray(this.datiaggiuntivi)) {
            data["datiaggiuntivi"] = [];
            for (let item of this.datiaggiuntivi)
                data["datiaggiuntivi"].push(item);
        }
        data["statusServizio"] = this.statusServizio !== undefined ? this.statusServizio : <any>null;
        data["isFullContent"] = this.isFullContent !== undefined ? this.isFullContent : <any>null;
        data["fullContentInfo"] = this.fullContentInfo !== undefined ? this.fullContentInfo : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Si carica i dati del servizio necessari al voucher */
export interface IServizioVoucher extends IHotelDescrizione {
    descrizioniRighe?: string[] | null;
    tipoServizio?: ETipoServizio;
    nome?: string | null;
    stelle?: number | null;
    /** Dati del punto iniziale */
    puntoIniziale?: TripServiceLocation | null;
    /** Dati del punto finale */
    puntoFinale?: TripServiceLocation | null;
    offertaId?: number;
    bookingRef?: string | null;
    paxList?: VoucherPax[] | null;
    lingua?: ELingua;
    dettaglio?: string | null;
    note?: string[] | null;
    datiaggiuntivi?: string[] | null;
    statusServizio?: EStatusServizio | null;
    isFullContent?: boolean;
    fullContentInfo?: string | null;
}

/** Ritaglio dei dati utente necessari per i voucher */
export class VoucherPax implements IVoucherPax {
    titolo?: ETitolo;
    nome?: string | null;
    cognome?: string | null;
    isChild?: boolean;

    constructor(data?: IVoucherPax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.isChild = _data["isChild"] !== undefined ? _data["isChild"] : <any>null;
        }
    }

    static fromJS(data: any): VoucherPax {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherPax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["isChild"] = this.isChild !== undefined ? this.isChild : <any>null;
        return data;
    }
}

/** Ritaglio dei dati utente necessari per i voucher */
export interface IVoucherPax {
    titolo?: ETitolo;
    nome?: string | null;
    cognome?: string | null;
    isChild?: boolean;
}

export class SectionMiniguide implements ISectionMiniguide {
    elencoMiniguide?: Miniguida[] | null;

    constructor(data?: ISectionMiniguide) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elencoMiniguide"])) {
                this.elencoMiniguide = [] as any;
                for (let item of _data["elencoMiniguide"])
                    this.elencoMiniguide!.push(Miniguida.fromJS(item));
            }
            else {
                this.elencoMiniguide = <any>null;
            }
        }
    }

    static fromJS(data: any): SectionMiniguide {
        data = typeof data === 'object' ? data : {};
        let result = new SectionMiniguide();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elencoMiniguide)) {
            data["elencoMiniguide"] = [];
            for (let item of this.elencoMiniguide)
                data["elencoMiniguide"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISectionMiniguide {
    elencoMiniguide?: Miniguida[] | null;
}

export class Miniguida extends MiniguidaHeader implements IMiniguida {
    giorno?: number;
    priorita?: number;
    text?: string | null;
    numImmagini?: number;

    constructor(data?: IMiniguida) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.numImmagini = _data["numImmagini"] !== undefined ? _data["numImmagini"] : <any>null;
        }
    }

    static fromJS(data: any): Miniguida {
        data = typeof data === 'object' ? data : {};
        let result = new Miniguida();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["priorita"] = this.priorita !== undefined ? this.priorita : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["numImmagini"] = this.numImmagini !== undefined ? this.numImmagini : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMiniguida extends IMiniguidaHeader {
    giorno?: number;
    priorita?: number;
    text?: string | null;
    numImmagini?: number;
}

export class SectionTicketsVoli implements ISectionTicketsVoli {
    elencoTicketsVoli?: VoloTicketsInfo[] | null;

    constructor(data?: ISectionTicketsVoli) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elencoTicketsVoli"])) {
                this.elencoTicketsVoli = [] as any;
                for (let item of _data["elencoTicketsVoli"])
                    this.elencoTicketsVoli!.push(VoloTicketsInfo.fromJS(item));
            }
            else {
                this.elencoTicketsVoli = <any>null;
            }
        }
    }

    static fromJS(data: any): SectionTicketsVoli {
        data = typeof data === 'object' ? data : {};
        let result = new SectionTicketsVoli();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elencoTicketsVoli)) {
            data["elencoTicketsVoli"] = [];
            for (let item of this.elencoTicketsVoli)
                data["elencoTicketsVoli"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISectionTicketsVoli {
    elencoTicketsVoli?: VoloTicketsInfo[] | null;
}

export class EstremiBancari implements IEstremiBancari {
    estremi?: EstremoBancario[];
    note?: string[];

    constructor(data?: IEstremiBancari) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["estremi"])) {
                this.estremi = [] as any;
                for (let item of _data["estremi"])
                    this.estremi!.push(EstremoBancario.fromJS(item));
            }
            else {
                this.estremi = <any>null;
            }
            if (Array.isArray(_data["note"])) {
                this.note = [] as any;
                for (let item of _data["note"])
                    this.note!.push(item);
            }
            else {
                this.note = <any>null;
            }
        }
    }

    static fromJS(data: any): EstremiBancari {
        data = typeof data === 'object' ? data : {};
        let result = new EstremiBancari();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.estremi)) {
            data["estremi"] = [];
            for (let item of this.estremi)
                data["estremi"].push(item.toJSON());
        }
        if (Array.isArray(this.note)) {
            data["note"] = [];
            for (let item of this.note)
                data["note"].push(item);
        }
        return data;
    }
}

export interface IEstremiBancari {
    estremi?: EstremoBancario[];
    note?: string[];
}

export class EstremoBancario implements IEstremoBancario {
    nome?: string;
    iban?: string;
    swift?: string;

    constructor(data?: IEstremoBancario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.iban = _data["iban"] !== undefined ? _data["iban"] : <any>null;
            this.swift = _data["swift"] !== undefined ? _data["swift"] : <any>null;
        }
    }

    static fromJS(data: any): EstremoBancario {
        data = typeof data === 'object' ? data : {};
        let result = new EstremoBancario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["iban"] = this.iban !== undefined ? this.iban : <any>null;
        data["swift"] = this.swift !== undefined ? this.swift : <any>null;
        return data;
    }
}

export interface IEstremoBancario {
    nome?: string;
    iban?: string;
    swift?: string;
}

export class NoteDocumento implements INoteDocumento {
    tipo?: ETipoNota;
    testo?: string | null;
    data?: string;

    constructor(data?: INoteDocumento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static fromJS(data: any): NoteDocumento {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDocumento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        return data;
    }
}

export interface INoteDocumento {
    tipo?: ETipoNota;
    testo?: string | null;
    data?: string;
}

export class PassolutionAllInfo implements IPassolutionAllInfo {
    destination?: string;
    nationality?: string;
    covid_status?: string;
    title?: string;
    corona?: PassolutionCoronaInfo;
    entry?: PassolutionEntryInfo;
    visa?: PassolutionVisaInfo;
    transit_visa?: PassolutionTransitVisaInfo;
    health?: PassolutionHealthInfo;
    final_provisions?: PassolutionBaseContentResponse;

    constructor(data?: IPassolutionAllInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destination = _data["destination"] !== undefined ? _data["destination"] : <any>null;
            this.nationality = _data["nationality"] !== undefined ? _data["nationality"] : <any>null;
            this.covid_status = _data["covid_status"] !== undefined ? _data["covid_status"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.corona = _data["corona"] ? PassolutionCoronaInfo.fromJS(_data["corona"]) : <any>null;
            this.entry = _data["entry"] ? PassolutionEntryInfo.fromJS(_data["entry"]) : <any>null;
            this.visa = _data["visa"] ? PassolutionVisaInfo.fromJS(_data["visa"]) : <any>null;
            this.transit_visa = _data["transit_visa"] ? PassolutionTransitVisaInfo.fromJS(_data["transit_visa"]) : <any>null;
            this.health = _data["health"] ? PassolutionHealthInfo.fromJS(_data["health"]) : <any>null;
            this.final_provisions = _data["final_provisions"] ? PassolutionBaseContentResponse.fromJS(_data["final_provisions"]) : <any>null;
        }
    }

    static fromJS(data: any): PassolutionAllInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionAllInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destination"] = this.destination !== undefined ? this.destination : <any>null;
        data["nationality"] = this.nationality !== undefined ? this.nationality : <any>null;
        data["covid_status"] = this.covid_status !== undefined ? this.covid_status : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["corona"] = this.corona ? this.corona.toJSON() : <any>null;
        data["entry"] = this.entry ? this.entry.toJSON() : <any>null;
        data["visa"] = this.visa ? this.visa.toJSON() : <any>null;
        data["transit_visa"] = this.transit_visa ? this.transit_visa.toJSON() : <any>null;
        data["health"] = this.health ? this.health.toJSON() : <any>null;
        data["final_provisions"] = this.final_provisions ? this.final_provisions.toJSON() : <any>null;
        return data;
    }
}

export interface IPassolutionAllInfo {
    destination?: string;
    nationality?: string;
    covid_status?: string;
    title?: string;
    corona?: PassolutionCoronaInfo;
    entry?: PassolutionEntryInfo;
    visa?: PassolutionVisaInfo;
    transit_visa?: PassolutionTransitVisaInfo;
    health?: PassolutionHealthInfo;
    final_provisions?: PassolutionBaseContentResponse;
}

export class PassolutionBaseContentResponse implements IPassolutionBaseContentResponse {
    title?: string | null;
    content?: string | null;
    updated_at?: string | null;
    destination?: string | null;
    nationality?: string | null;
    language?: string | null;
    has_important_changes?: boolean | null;

    constructor(data?: IPassolutionBaseContentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.updated_at = _data["updated_at"] !== undefined ? _data["updated_at"] : <any>null;
            this.destination = _data["destination"] !== undefined ? _data["destination"] : <any>null;
            this.nationality = _data["nationality"] !== undefined ? _data["nationality"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.has_important_changes = _data["has_important_changes"] !== undefined ? _data["has_important_changes"] : <any>null;
        }
    }

    static fromJS(data: any): PassolutionBaseContentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionBaseContentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["updated_at"] = this.updated_at !== undefined ? this.updated_at : <any>null;
        data["destination"] = this.destination !== undefined ? this.destination : <any>null;
        data["nationality"] = this.nationality !== undefined ? this.nationality : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["has_important_changes"] = this.has_important_changes !== undefined ? this.has_important_changes : <any>null;
        return data;
    }
}

export interface IPassolutionBaseContentResponse {
    title?: string | null;
    content?: string | null;
    updated_at?: string | null;
    destination?: string | null;
    nationality?: string | null;
    language?: string | null;
    has_important_changes?: boolean | null;
}

export class PassolutionCoronaInfo extends PassolutionBaseContentResponse implements IPassolutionCoronaInfo {

    constructor(data?: IPassolutionCoronaInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PassolutionCoronaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionCoronaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPassolutionCoronaInfo extends IPassolutionBaseContentResponse {
}

export class PassolutionEntryInfo extends PassolutionBaseContentResponse implements IPassolutionEntryInfo {

    constructor(data?: IPassolutionEntryInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PassolutionEntryInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionEntryInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPassolutionEntryInfo extends IPassolutionBaseContentResponse {
}

export class PassolutionVisaInfo extends PassolutionBaseContentResponse implements IPassolutionVisaInfo {

    constructor(data?: IPassolutionVisaInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PassolutionVisaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionVisaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPassolutionVisaInfo extends IPassolutionBaseContentResponse {
}

export class PassolutionTransitVisaInfo extends PassolutionBaseContentResponse implements IPassolutionTransitVisaInfo {

    constructor(data?: IPassolutionTransitVisaInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PassolutionTransitVisaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionTransitVisaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPassolutionTransitVisaInfo extends IPassolutionBaseContentResponse {
}

export class PassolutionHealthInfo extends PassolutionBaseContentResponse implements IPassolutionHealthInfo {

    constructor(data?: IPassolutionHealthInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PassolutionHealthInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PassolutionHealthInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPassolutionHealthInfo extends IPassolutionBaseContentResponse {
}

/** Richiesta dei dati per formattare un documento */
export class GetTripDocumentDataRequest extends SiteRequest implements IGetTripDocumentDataRequest {
    /** ID utente (ad uso delle anteprime di stampa) */
    userID?: string;
    /** ID dell'offerta */
    offertaID?: number;
    /** ID facoltativo di un documento a frasi di cui visualizzare l'anteprima */
    documentoID?: number | null;
    /** Tipo di documento */
    tipoDocumento?: ETipoDocumento;
    /** Stringa con le tuple [id_ordine] separate da virgola delle miniguide da usare nel documento */
    extraDocs?: string;

    constructor(data?: IGetTripDocumentDataRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userID = _data["userID"] !== undefined ? _data["userID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : <any>null;
            this.extraDocs = _data["extraDocs"] !== undefined ? _data["extraDocs"] : <any>null;
        }
    }

    static fromJS(data: any): GetTripDocumentDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDocumentDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID !== undefined ? this.userID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : <any>null;
        data["extraDocs"] = this.extraDocs !== undefined ? this.extraDocs : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Richiesta dei dati per formattare un documento */
export interface IGetTripDocumentDataRequest extends ISiteRequest {
    /** ID utente (ad uso delle anteprime di stampa) */
    userID?: string;
    /** ID dell'offerta */
    offertaID?: number;
    /** ID facoltativo di un documento a frasi di cui visualizzare l'anteprima */
    documentoID?: number | null;
    /** Tipo di documento */
    tipoDocumento?: ETipoDocumento;
    /** Stringa con le tuple [id_ordine] separate da virgola delle miniguide da usare nel documento */
    extraDocs?: string;
}

export class GetTripReservationDocDataResponse extends OkApiResponse implements IGetTripReservationDocDataResponse {
    prenotazioni?: TripReservation[];
    reservationEmitter?: InvoiceEmitter | null;

    constructor(data?: IGetTripReservationDocDataResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["prenotazioni"])) {
                this.prenotazioni = [] as any;
                for (let item of _data["prenotazioni"])
                    this.prenotazioni!.push(TripReservation.fromJS(item));
            }
            else {
                this.prenotazioni = <any>null;
            }
            this.reservationEmitter = _data["reservationEmitter"] ? InvoiceEmitter.fromJS(_data["reservationEmitter"]) : <any>null;
        }
    }

    static fromJS(data: any): GetTripReservationDocDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripReservationDocDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prenotazioni)) {
            data["prenotazioni"] = [];
            for (let item of this.prenotazioni)
                data["prenotazioni"].push(item.toJSON());
        }
        data["reservationEmitter"] = this.reservationEmitter ? this.reservationEmitter.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripReservationDocDataResponse extends IOkApiResponse {
    prenotazioni?: TripReservation[];
    reservationEmitter?: InvoiceEmitter | null;
}

export class TripReservation implements ITripReservation {
    offertaID?: number;
    isNozze?: boolean;
    contattoID?: number;
    accordo?: string;
    elencoAbbinamenti?: TripReservationAbbinamento[];
    elencoVoli?: TripReservationFlight[];
    hotelsInformation?: TripReservationHotel[];

    constructor(data?: ITripReservation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.isNozze = _data["isNozze"] !== undefined ? _data["isNozze"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : <any>null;
            if (Array.isArray(_data["elencoAbbinamenti"])) {
                this.elencoAbbinamenti = [] as any;
                for (let item of _data["elencoAbbinamenti"])
                    this.elencoAbbinamenti!.push(TripReservationAbbinamento.fromJS(item));
            }
            else {
                this.elencoAbbinamenti = <any>null;
            }
            if (Array.isArray(_data["elencoVoli"])) {
                this.elencoVoli = [] as any;
                for (let item of _data["elencoVoli"])
                    this.elencoVoli!.push(TripReservationFlight.fromJS(item));
            }
            else {
                this.elencoVoli = <any>null;
            }
            if (Array.isArray(_data["hotelsInformation"])) {
                this.hotelsInformation = [] as any;
                for (let item of _data["hotelsInformation"])
                    this.hotelsInformation!.push(TripReservationHotel.fromJS(item));
            }
            else {
                this.hotelsInformation = <any>null;
            }
        }
    }

    static fromJS(data: any): TripReservation {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["isNozze"] = this.isNozze !== undefined ? this.isNozze : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["accordo"] = this.accordo !== undefined ? this.accordo : <any>null;
        if (Array.isArray(this.elencoAbbinamenti)) {
            data["elencoAbbinamenti"] = [];
            for (let item of this.elencoAbbinamenti)
                data["elencoAbbinamenti"].push(item.toJSON());
        }
        if (Array.isArray(this.elencoVoli)) {
            data["elencoVoli"] = [];
            for (let item of this.elencoVoli)
                data["elencoVoli"].push(item.toJSON());
        }
        if (Array.isArray(this.hotelsInformation)) {
            data["hotelsInformation"] = [];
            for (let item of this.hotelsInformation)
                data["hotelsInformation"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripReservation {
    offertaID?: number;
    isNozze?: boolean;
    contattoID?: number;
    accordo?: string;
    elencoAbbinamenti?: TripReservationAbbinamento[];
    elencoVoli?: TripReservationFlight[];
    hotelsInformation?: TripReservationHotel[];
}

export class TripReservationAbbinamento implements ITripReservationAbbinamento {
    nome?: string;
    pax?: TripReservationPax[];
    clienti?: string;
    elencoServizi?: TripReservationService[];
    totale?: TripReservationServiceTotal;

    constructor(data?: ITripReservationAbbinamento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            if (Array.isArray(_data["pax"])) {
                this.pax = [] as any;
                for (let item of _data["pax"])
                    this.pax!.push(TripReservationPax.fromJS(item));
            }
            else {
                this.pax = <any>null;
            }
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : <any>null;
            if (Array.isArray(_data["elencoServizi"])) {
                this.elencoServizi = [] as any;
                for (let item of _data["elencoServizi"])
                    this.elencoServizi!.push(TripReservationService.fromJS(item));
            }
            else {
                this.elencoServizi = <any>null;
            }
            this.totale = _data["totale"] ? TripReservationServiceTotal.fromJS(_data["totale"]) : <any>null;
        }
    }

    static fromJS(data: any): TripReservationAbbinamento {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationAbbinamento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        if (Array.isArray(this.pax)) {
            data["pax"] = [];
            for (let item of this.pax)
                data["pax"].push(item.toJSON());
        }
        data["clienti"] = this.clienti !== undefined ? this.clienti : <any>null;
        if (Array.isArray(this.elencoServizi)) {
            data["elencoServizi"] = [];
            for (let item of this.elencoServizi)
                data["elencoServizi"].push(item.toJSON());
        }
        data["totale"] = this.totale ? this.totale.toJSON() : <any>null;
        return data;
    }
}

export interface ITripReservationAbbinamento {
    nome?: string;
    pax?: TripReservationPax[];
    clienti?: string;
    elencoServizi?: TripReservationService[];
    totale?: TripReservationServiceTotal;
}

export class TripReservationPax implements ITripReservationPax {
    nome?: string;
    cognome?: string;
    titolo?: ETitolo;
    dataDiNascita?: string | null;
    isChild?: boolean;

    constructor(data?: ITripReservationPax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.dataDiNascita = _data["dataDiNascita"] !== undefined ? _data["dataDiNascita"] : <any>null;
            this.isChild = _data["isChild"] !== undefined ? _data["isChild"] : <any>null;
        }
    }

    static fromJS(data: any): TripReservationPax {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationPax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["dataDiNascita"] = this.dataDiNascita !== undefined ? this.dataDiNascita : <any>null;
        data["isChild"] = this.isChild !== undefined ? this.isChild : <any>null;
        return data;
    }
}

export interface ITripReservationPax {
    nome?: string;
    cognome?: string;
    titolo?: ETitolo;
    dataDiNascita?: string | null;
    isChild?: boolean;
}

export class TripReservationService implements ITripReservationService {
    numeroPrenotazione?: string | null;
    stato?: string | null;
    tipoServizio?: string | null;
    nomeServizio?: string | null;
    luogo?: string | null;
    data?: string | null;
    dataDal?: string | null;
    dataAl?: string | null;
    notti?: number;
    sistemazione?: string | null;
    tipologia?: string | null;
    tipologiaAddData?: string | null;
    trattamento?: string | null;
    totalePrenotazione?: TripReservationServiceTotal | null;
    note?: string | null;
    statusFlag?: number;

    constructor(data?: ITripReservationService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroPrenotazione = _data["numeroPrenotazione"] !== undefined ? _data["numeroPrenotazione"] : <any>null;
            this.stato = _data["stato"] !== undefined ? _data["stato"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.nomeServizio = _data["nomeServizio"] !== undefined ? _data["nomeServizio"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.dataDal = _data["dataDal"] !== undefined ? _data["dataDal"] : <any>null;
            this.dataAl = _data["dataAl"] !== undefined ? _data["dataAl"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            this.sistemazione = _data["sistemazione"] !== undefined ? _data["sistemazione"] : <any>null;
            this.tipologia = _data["tipologia"] !== undefined ? _data["tipologia"] : <any>null;
            this.tipologiaAddData = _data["tipologiaAddData"] !== undefined ? _data["tipologiaAddData"] : <any>null;
            this.trattamento = _data["trattamento"] !== undefined ? _data["trattamento"] : <any>null;
            this.totalePrenotazione = _data["totalePrenotazione"] ? TripReservationServiceTotal.fromJS(_data["totalePrenotazione"]) : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.statusFlag = _data["statusFlag"] !== undefined ? _data["statusFlag"] : <any>null;
        }
    }

    static fromJS(data: any): TripReservationService {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroPrenotazione"] = this.numeroPrenotazione !== undefined ? this.numeroPrenotazione : <any>null;
        data["stato"] = this.stato !== undefined ? this.stato : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["nomeServizio"] = this.nomeServizio !== undefined ? this.nomeServizio : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["dataDal"] = this.dataDal !== undefined ? this.dataDal : <any>null;
        data["dataAl"] = this.dataAl !== undefined ? this.dataAl : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        data["sistemazione"] = this.sistemazione !== undefined ? this.sistemazione : <any>null;
        data["tipologia"] = this.tipologia !== undefined ? this.tipologia : <any>null;
        data["tipologiaAddData"] = this.tipologiaAddData !== undefined ? this.tipologiaAddData : <any>null;
        data["trattamento"] = this.trattamento !== undefined ? this.trattamento : <any>null;
        data["totalePrenotazione"] = this.totalePrenotazione ? this.totalePrenotazione.toJSON() : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["statusFlag"] = this.statusFlag !== undefined ? this.statusFlag : <any>null;
        return data;
    }
}

export interface ITripReservationService {
    numeroPrenotazione?: string | null;
    stato?: string | null;
    tipoServizio?: string | null;
    nomeServizio?: string | null;
    luogo?: string | null;
    data?: string | null;
    dataDal?: string | null;
    dataAl?: string | null;
    notti?: number;
    sistemazione?: string | null;
    tipologia?: string | null;
    tipologiaAddData?: string | null;
    trattamento?: string | null;
    totalePrenotazione?: TripReservationServiceTotal | null;
    note?: string | null;
    statusFlag?: number;
}

export class TripReservationServiceTotal implements ITripReservationServiceTotal {
    valuta?: string | null;
    totale?: number;

    constructor(data?: ITripReservationServiceTotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valuta = _data["valuta"] !== undefined ? _data["valuta"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
        }
    }

    static fromJS(data: any): TripReservationServiceTotal {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationServiceTotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valuta"] = this.valuta !== undefined ? this.valuta : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        return data;
    }
}

export interface ITripReservationServiceTotal {
    valuta?: string | null;
    totale?: number;
}

export class TripReservationFlight implements ITripReservationFlight {
    abbinamento?: string;
    pnr?: string;
    elencoTratte?: TripReservationFlightRoute[];
    elencoCompagnie?: TripReservationFlightCompany[];

    constructor(data?: ITripReservationFlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abbinamento = _data["abbinamento"] !== undefined ? _data["abbinamento"] : <any>null;
            this.pnr = _data["pnr"] !== undefined ? _data["pnr"] : <any>null;
            if (Array.isArray(_data["elencoTratte"])) {
                this.elencoTratte = [] as any;
                for (let item of _data["elencoTratte"])
                    this.elencoTratte!.push(TripReservationFlightRoute.fromJS(item));
            }
            else {
                this.elencoTratte = <any>null;
            }
            if (Array.isArray(_data["elencoCompagnie"])) {
                this.elencoCompagnie = [] as any;
                for (let item of _data["elencoCompagnie"])
                    this.elencoCompagnie!.push(TripReservationFlightCompany.fromJS(item));
            }
            else {
                this.elencoCompagnie = <any>null;
            }
        }
    }

    static fromJS(data: any): TripReservationFlight {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationFlight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abbinamento"] = this.abbinamento !== undefined ? this.abbinamento : <any>null;
        data["pnr"] = this.pnr !== undefined ? this.pnr : <any>null;
        if (Array.isArray(this.elencoTratte)) {
            data["elencoTratte"] = [];
            for (let item of this.elencoTratte)
                data["elencoTratte"].push(item.toJSON());
        }
        if (Array.isArray(this.elencoCompagnie)) {
            data["elencoCompagnie"] = [];
            for (let item of this.elencoCompagnie)
                data["elencoCompagnie"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripReservationFlight {
    abbinamento?: string;
    pnr?: string;
    elencoTratte?: TripReservationFlightRoute[];
    elencoCompagnie?: TripReservationFlightCompany[];
}

export class TripReservationFlightRoute implements ITripReservationFlightRoute {
    codiceCompagnia?: string | null;
    numeroVolo?: string | null;
    partenza?: string | null;
    daAeroporto?: string | null;
    daNomeItaliano?: string | null;
    status?: string | null;
    arrivoIlGiornoDopo?: boolean;
    arrivo?: string | null;
    adAeroporto?: string | null;
    aaNomeItaliano?: string | null;

    constructor(data?: ITripReservationFlightRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codiceCompagnia = _data["codiceCompagnia"] !== undefined ? _data["codiceCompagnia"] : <any>null;
            this.numeroVolo = _data["numeroVolo"] !== undefined ? _data["numeroVolo"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.daAeroporto = _data["daAeroporto"] !== undefined ? _data["daAeroporto"] : <any>null;
            this.daNomeItaliano = _data["daNomeItaliano"] !== undefined ? _data["daNomeItaliano"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.arrivoIlGiornoDopo = _data["arrivoIlGiornoDopo"] !== undefined ? _data["arrivoIlGiornoDopo"] : <any>null;
            this.arrivo = _data["arrivo"] !== undefined ? _data["arrivo"] : <any>null;
            this.adAeroporto = _data["adAeroporto"] !== undefined ? _data["adAeroporto"] : <any>null;
            this.aaNomeItaliano = _data["aaNomeItaliano"] !== undefined ? _data["aaNomeItaliano"] : <any>null;
        }
    }

    static fromJS(data: any): TripReservationFlightRoute {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationFlightRoute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codiceCompagnia"] = this.codiceCompagnia !== undefined ? this.codiceCompagnia : <any>null;
        data["numeroVolo"] = this.numeroVolo !== undefined ? this.numeroVolo : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["daAeroporto"] = this.daAeroporto !== undefined ? this.daAeroporto : <any>null;
        data["daNomeItaliano"] = this.daNomeItaliano !== undefined ? this.daNomeItaliano : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["arrivoIlGiornoDopo"] = this.arrivoIlGiornoDopo !== undefined ? this.arrivoIlGiornoDopo : <any>null;
        data["arrivo"] = this.arrivo !== undefined ? this.arrivo : <any>null;
        data["adAeroporto"] = this.adAeroporto !== undefined ? this.adAeroporto : <any>null;
        data["aaNomeItaliano"] = this.aaNomeItaliano !== undefined ? this.aaNomeItaliano : <any>null;
        return data;
    }
}

export interface ITripReservationFlightRoute {
    codiceCompagnia?: string | null;
    numeroVolo?: string | null;
    partenza?: string | null;
    daAeroporto?: string | null;
    daNomeItaliano?: string | null;
    status?: string | null;
    arrivoIlGiornoDopo?: boolean;
    arrivo?: string | null;
    adAeroporto?: string | null;
    aaNomeItaliano?: string | null;
}

export class TripReservationFlightCompany implements ITripReservationFlightCompany {
    codice?: string;
    nome?: string;

    constructor(data?: ITripReservationFlightCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
        }
    }

    static fromJS(data: any): TripReservationFlightCompany {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationFlightCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        return data;
    }
}

export interface ITripReservationFlightCompany {
    codice?: string;
    nome?: string;
}

export class TripReservationHotel implements ITripReservationHotel {
    nome?: string | null;
    luogo?: string | null;
    indirizzo?: string | null;
    telefono?: string | null;
    fax?: string | null;
    reservations?: TripReservationHotelReservationInformation[];

    constructor(data?: ITripReservationHotel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.fax = _data["fax"] !== undefined ? _data["fax"] : <any>null;
            if (Array.isArray(_data["reservations"])) {
                this.reservations = [] as any;
                for (let item of _data["reservations"])
                    this.reservations!.push(TripReservationHotelReservationInformation.fromJS(item));
            }
            else {
                this.reservations = <any>null;
            }
        }
    }

    static fromJS(data: any): TripReservationHotel {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationHotel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["fax"] = this.fax !== undefined ? this.fax : <any>null;
        if (Array.isArray(this.reservations)) {
            data["reservations"] = [];
            for (let item of this.reservations)
                data["reservations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripReservationHotel {
    nome?: string | null;
    luogo?: string | null;
    indirizzo?: string | null;
    telefono?: string | null;
    fax?: string | null;
    reservations?: TripReservationHotelReservationInformation[];
}

export class TripReservationHotelReservationInformation implements ITripReservationHotelReservationInformation {
    dataDa?: string;
    dataA?: string;
    notti?: number;

    constructor(data?: ITripReservationHotelReservationInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataDa = _data["dataDa"] !== undefined ? _data["dataDa"] : <any>null;
            this.dataA = _data["dataA"] !== undefined ? _data["dataA"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
        }
    }

    static fromJS(data: any): TripReservationHotelReservationInformation {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationHotelReservationInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataDa"] = this.dataDa !== undefined ? this.dataDa : <any>null;
        data["dataA"] = this.dataA !== undefined ? this.dataA : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        return data;
    }
}

export interface ITripReservationHotelReservationInformation {
    dataDa?: string;
    dataA?: string;
    notti?: number;
}

export class GetTripReservationDocDataRequest extends LocalizedRequest implements IGetTripReservationDocDataRequest {
    offertaID!: number;
    /** Underscore separated string: "contactID_currencyID" */
    contactAndCurrency!: string[];

    constructor(data?: IGetTripReservationDocDataRequest) {
        super(data);
        if (!data) {
            this.contactAndCurrency = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            if (Array.isArray(_data["contactAndCurrency"])) {
                this.contactAndCurrency = [] as any;
                for (let item of _data["contactAndCurrency"])
                    this.contactAndCurrency!.push(item);
            }
            else {
                this.contactAndCurrency = <any>null;
            }
        }
    }

    static fromJS(data: any): GetTripReservationDocDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripReservationDocDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        if (Array.isArray(this.contactAndCurrency)) {
            data["contactAndCurrency"] = [];
            for (let item of this.contactAndCurrency)
                data["contactAndCurrency"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripReservationDocDataRequest extends ILocalizedRequest {
    offertaID: number;
    /** Underscore separated string: "contactID_currencyID" */
    contactAndCurrency: string[];
}

export class GetTripVoucherDataResponse extends OkApiResponse implements IGetTripVoucherDataResponse {
    /** Elenco dei voucher selezionati passato attraverso il campo ExtraDocs */
    selectedVoucher?: number[];
    elencoVouchers?: VoucherRaw[];
    voucherEmitter?: InvoiceEmitter;

    constructor(data?: IGetTripVoucherDataResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["selectedVoucher"])) {
                this.selectedVoucher = [] as any;
                for (let item of _data["selectedVoucher"])
                    this.selectedVoucher!.push(item);
            }
            else {
                this.selectedVoucher = <any>null;
            }
            if (Array.isArray(_data["elencoVouchers"])) {
                this.elencoVouchers = [] as any;
                for (let item of _data["elencoVouchers"])
                    this.elencoVouchers!.push(VoucherRaw.fromJS(item));
            }
            else {
                this.elencoVouchers = <any>null;
            }
            this.voucherEmitter = _data["voucherEmitter"] ? InvoiceEmitter.fromJS(_data["voucherEmitter"]) : <any>null;
        }
    }

    static fromJS(data: any): GetTripVoucherDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripVoucherDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedVoucher)) {
            data["selectedVoucher"] = [];
            for (let item of this.selectedVoucher)
                data["selectedVoucher"].push(item);
        }
        if (Array.isArray(this.elencoVouchers)) {
            data["elencoVouchers"] = [];
            for (let item of this.elencoVouchers)
                data["elencoVouchers"].push(item.toJSON());
        }
        data["voucherEmitter"] = this.voucherEmitter ? this.voucherEmitter.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripVoucherDataResponse extends IOkApiResponse {
    /** Elenco dei voucher selezionati passato attraverso il campo ExtraDocs */
    selectedVoucher?: number[];
    elencoVouchers?: VoucherRaw[];
    voucherEmitter?: InvoiceEmitter;
}

export class VoucherRaw implements IVoucherRaw {
    dataVoucher?: TripVoucher;

    constructor(data?: IVoucherRaw) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataVoucher = _data["dataVoucher"] ? TripVoucher.fromJS(_data["dataVoucher"]) : <any>null;
        }
    }

    static fromJS(data: any): VoucherRaw {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherRaw();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataVoucher"] = this.dataVoucher ? this.dataVoucher.toJSON() : <any>null;
        return data;
    }
}

export interface IVoucherRaw {
    dataVoucher?: TripVoucher;
}

export class GetTripVoucherDataRequest extends SiteRequest implements IGetTripVoucherDataRequest {
    offertaID?: number;
    maxNumOfVouchersPerPage?: number;
    /** Stringa con le tuple [id_ordine] separate da virgola dei voucher da usare nel documento */
    extraDocs?: string;
    preview?: boolean;

    constructor(data?: IGetTripVoucherDataRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.maxNumOfVouchersPerPage = _data["maxNumOfVouchersPerPage"] !== undefined ? _data["maxNumOfVouchersPerPage"] : <any>null;
            this.extraDocs = _data["extraDocs"] !== undefined ? _data["extraDocs"] : <any>null;
            this.preview = _data["preview"] !== undefined ? _data["preview"] : <any>null;
        }
    }

    static fromJS(data: any): GetTripVoucherDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripVoucherDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["maxNumOfVouchersPerPage"] = this.maxNumOfVouchersPerPage !== undefined ? this.maxNumOfVouchersPerPage : <any>null;
        data["extraDocs"] = this.extraDocs !== undefined ? this.extraDocs : <any>null;
        data["preview"] = this.preview !== undefined ? this.preview : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripVoucherDataRequest extends ISiteRequest {
    offertaID?: number;
    maxNumOfVouchersPerPage?: number;
    /** Stringa con le tuple [id_ordine] separate da virgola dei voucher da usare nel documento */
    extraDocs?: string;
    preview?: boolean;
}

export class GetNearbyPlacesResponse extends OkApiResponse implements IGetNearbyPlacesResponse {
    luoghiVicini?: LuogoVicino[] | null;

    constructor(data?: IGetNearbyPlacesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["luoghiVicini"])) {
                this.luoghiVicini = [] as any;
                for (let item of _data["luoghiVicini"])
                    this.luoghiVicini!.push(LuogoVicino.fromJS(item));
            }
            else {
                this.luoghiVicini = <any>null;
            }
        }
    }

    static fromJS(data: any): GetNearbyPlacesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNearbyPlacesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.luoghiVicini)) {
            data["luoghiVicini"] = [];
            for (let item of this.luoghiVicini)
                data["luoghiVicini"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetNearbyPlacesResponse extends IOkApiResponse {
    luoghiVicini?: LuogoVicino[] | null;
}

export class LuogoVicino implements ILuogoVicino {
    id?: number;
    nome?: string | null;
    latitudine?: number;
    longitudine?: number;
    distanzaKm?: number;
    tempoPercorrenza?: number | null;
    consentePernottamento?: boolean;
    distanzaReale?: boolean;

    constructor(data?: ILuogoVicino) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : <any>null;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : <any>null;
            this.distanzaKm = _data["distanzaKm"] !== undefined ? _data["distanzaKm"] : <any>null;
            this.tempoPercorrenza = _data["tempoPercorrenza"] !== undefined ? _data["tempoPercorrenza"] : <any>null;
            this.consentePernottamento = _data["consentePernottamento"] !== undefined ? _data["consentePernottamento"] : <any>null;
            this.distanzaReale = _data["distanzaReale"] !== undefined ? _data["distanzaReale"] : <any>null;
        }
    }

    static fromJS(data: any): LuogoVicino {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoVicino();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : <any>null;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : <any>null;
        data["distanzaKm"] = this.distanzaKm !== undefined ? this.distanzaKm : <any>null;
        data["tempoPercorrenza"] = this.tempoPercorrenza !== undefined ? this.tempoPercorrenza : <any>null;
        data["consentePernottamento"] = this.consentePernottamento !== undefined ? this.consentePernottamento : <any>null;
        data["distanzaReale"] = this.distanzaReale !== undefined ? this.distanzaReale : <any>null;
        return data;
    }
}

export interface ILuogoVicino {
    id?: number;
    nome?: string | null;
    latitudine?: number;
    longitudine?: number;
    distanzaKm?: number;
    tempoPercorrenza?: number | null;
    consentePernottamento?: boolean;
    distanzaReale?: boolean;
}

export class GetNearbyPlacesRequest extends SiteRequest implements IGetNearbyPlacesRequest {
    luogoID?: number;
    maxDistanzaKm?: number;

    constructor(data?: IGetNearbyPlacesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.maxDistanzaKm = _data["maxDistanzaKm"] !== undefined ? _data["maxDistanzaKm"] : <any>null;
        }
    }

    static fromJS(data: any): GetNearbyPlacesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetNearbyPlacesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["maxDistanzaKm"] = this.maxDistanzaKm !== undefined ? this.maxDistanzaKm : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetNearbyPlacesRequest extends ISiteRequest {
    luogoID?: number;
    maxDistanzaKm?: number;
}

export class GetPlannerMapResponse extends OkApiResponse implements IGetPlannerMapResponse {
    punti?: MapPinPoint[] | null;
    flightPaths?: MapPath[] | null;
    carPaths?: MapPath[] | null;
    carDirections?: CarPath[] | null;
    trainPaths?: MapPath[] | null;
    trainDirections?: TrainPath[] | null;
    otherPaths?: MapPath[] | null;

    constructor(data?: IGetPlannerMapResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["punti"])) {
                this.punti = [] as any;
                for (let item of _data["punti"])
                    this.punti!.push(MapPinPoint.fromJS(item));
            }
            else {
                this.punti = <any>null;
            }
            if (Array.isArray(_data["flightPaths"])) {
                this.flightPaths = [] as any;
                for (let item of _data["flightPaths"])
                    this.flightPaths!.push(MapPath.fromJS(item));
            }
            else {
                this.flightPaths = <any>null;
            }
            if (Array.isArray(_data["carPaths"])) {
                this.carPaths = [] as any;
                for (let item of _data["carPaths"])
                    this.carPaths!.push(MapPath.fromJS(item));
            }
            else {
                this.carPaths = <any>null;
            }
            if (Array.isArray(_data["carDirections"])) {
                this.carDirections = [] as any;
                for (let item of _data["carDirections"])
                    this.carDirections!.push(CarPath.fromJS(item));
            }
            else {
                this.carDirections = <any>null;
            }
            if (Array.isArray(_data["trainPaths"])) {
                this.trainPaths = [] as any;
                for (let item of _data["trainPaths"])
                    this.trainPaths!.push(MapPath.fromJS(item));
            }
            else {
                this.trainPaths = <any>null;
            }
            if (Array.isArray(_data["trainDirections"])) {
                this.trainDirections = [] as any;
                for (let item of _data["trainDirections"])
                    this.trainDirections!.push(TrainPath.fromJS(item));
            }
            else {
                this.trainDirections = <any>null;
            }
            if (Array.isArray(_data["otherPaths"])) {
                this.otherPaths = [] as any;
                for (let item of _data["otherPaths"])
                    this.otherPaths!.push(MapPath.fromJS(item));
            }
            else {
                this.otherPaths = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPlannerMapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlannerMapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.punti)) {
            data["punti"] = [];
            for (let item of this.punti)
                data["punti"].push(item.toJSON());
        }
        if (Array.isArray(this.flightPaths)) {
            data["flightPaths"] = [];
            for (let item of this.flightPaths)
                data["flightPaths"].push(item.toJSON());
        }
        if (Array.isArray(this.carPaths)) {
            data["carPaths"] = [];
            for (let item of this.carPaths)
                data["carPaths"].push(item.toJSON());
        }
        if (Array.isArray(this.carDirections)) {
            data["carDirections"] = [];
            for (let item of this.carDirections)
                data["carDirections"].push(item.toJSON());
        }
        if (Array.isArray(this.trainPaths)) {
            data["trainPaths"] = [];
            for (let item of this.trainPaths)
                data["trainPaths"].push(item.toJSON());
        }
        if (Array.isArray(this.trainDirections)) {
            data["trainDirections"] = [];
            for (let item of this.trainDirections)
                data["trainDirections"].push(item.toJSON());
        }
        if (Array.isArray(this.otherPaths)) {
            data["otherPaths"] = [];
            for (let item of this.otherPaths)
                data["otherPaths"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPlannerMapResponse extends IOkApiResponse {
    punti?: MapPinPoint[] | null;
    flightPaths?: MapPath[] | null;
    carPaths?: MapPath[] | null;
    carDirections?: CarPath[] | null;
    trainPaths?: MapPath[] | null;
    trainDirections?: TrainPath[] | null;
    otherPaths?: MapPath[] | null;
}

export class MapPinPoint implements IMapPinPoint {
    tipoTappa?: ETipoTappa;
    tipoTrasporto?: ETipoTrasporto;
    latitudine?: number;
    longitudine?: number;
    nome?: string | null;
    luogoID?: number;
    itinerarioId?: number;

    constructor(data?: IMapPinPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoTappa = _data["tipoTappa"] !== undefined ? _data["tipoTappa"] : <any>null;
            this.tipoTrasporto = _data["tipoTrasporto"] !== undefined ? _data["tipoTrasporto"] : <any>null;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : <any>null;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.itinerarioId = _data["itinerarioId"] !== undefined ? _data["itinerarioId"] : <any>null;
        }
    }

    static fromJS(data: any): MapPinPoint {
        data = typeof data === 'object' ? data : {};
        let result = new MapPinPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoTappa"] = this.tipoTappa !== undefined ? this.tipoTappa : <any>null;
        data["tipoTrasporto"] = this.tipoTrasporto !== undefined ? this.tipoTrasporto : <any>null;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : <any>null;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["itinerarioId"] = this.itinerarioId !== undefined ? this.itinerarioId : <any>null;
        return data;
    }
}

export interface IMapPinPoint {
    tipoTappa?: ETipoTappa;
    tipoTrasporto?: ETipoTrasporto;
    latitudine?: number;
    longitudine?: number;
    nome?: string | null;
    luogoID?: number;
    itinerarioId?: number;
}

export class MapPath implements IMapPath {
    punti?: MapPinPoint[] | null;

    constructor(data?: IMapPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["punti"])) {
                this.punti = [] as any;
                for (let item of _data["punti"])
                    this.punti!.push(MapPinPoint.fromJS(item));
            }
            else {
                this.punti = <any>null;
            }
        }
    }

    static fromJS(data: any): MapPath {
        data = typeof data === 'object' ? data : {};
        let result = new MapPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.punti)) {
            data["punti"] = [];
            for (let item of this.punti)
                data["punti"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMapPath {
    punti?: MapPinPoint[] | null;
}

export class CarPath implements ICarPath {
    origin?: GMapPoint | null;
    destination?: GMapPoint | null;
    waypoints?: GMapWayPoint[] | null;

    constructor(data?: ICarPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? GMapPoint.fromJS(_data["origin"]) : <any>null;
            this.destination = _data["destination"] ? GMapPoint.fromJS(_data["destination"]) : <any>null;
            if (Array.isArray(_data["waypoints"])) {
                this.waypoints = [] as any;
                for (let item of _data["waypoints"])
                    this.waypoints!.push(GMapWayPoint.fromJS(item));
            }
            else {
                this.waypoints = <any>null;
            }
        }
    }

    static fromJS(data: any): CarPath {
        data = typeof data === 'object' ? data : {};
        let result = new CarPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>null;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>null;
        if (Array.isArray(this.waypoints)) {
            data["waypoints"] = [];
            for (let item of this.waypoints)
                data["waypoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICarPath {
    origin?: GMapPoint | null;
    destination?: GMapPoint | null;
    waypoints?: GMapWayPoint[] | null;
}

export class GMapPoint implements IGMapPoint {
    lat?: number;
    lng?: number;
    name?: string | null;

    constructor(data?: IGMapPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): GMapPoint {
        data = typeof data === 'object' ? data : {};
        let result = new GMapPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lng"] = this.lng !== undefined ? this.lng : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IGMapPoint {
    lat?: number;
    lng?: number;
    name?: string | null;
}

export class GMapWayPoint implements IGMapWayPoint {
    location?: GMapPoint | null;
    stopover?: boolean;

    constructor(data?: IGMapWayPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] ? GMapPoint.fromJS(_data["location"]) : <any>null;
            this.stopover = _data["stopover"] !== undefined ? _data["stopover"] : <any>null;
        }
    }

    static fromJS(data: any): GMapWayPoint {
        data = typeof data === 'object' ? data : {};
        let result = new GMapWayPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : <any>null;
        data["stopover"] = this.stopover !== undefined ? this.stopover : <any>null;
        return data;
    }
}

export interface IGMapWayPoint {
    location?: GMapPoint | null;
    stopover?: boolean;
}

export class TrainPath implements ITrainPath {
    origin?: GMapPoint | null;
    destination?: GMapPoint | null;

    constructor(data?: ITrainPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? GMapPoint.fromJS(_data["origin"]) : <any>null;
            this.destination = _data["destination"] ? GMapPoint.fromJS(_data["destination"]) : <any>null;
        }
    }

    static fromJS(data: any): TrainPath {
        data = typeof data === 'object' ? data : {};
        let result = new TrainPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>null;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>null;
        return data;
    }
}

export interface ITrainPath {
    origin?: GMapPoint | null;
    destination?: GMapPoint | null;
}

export class GetPlannerMapRequest extends SiteRequest implements IGetPlannerMapRequest {
    itinerario?: OffertaItinerario[] | null;

    constructor(data?: IGetPlannerMapRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["itinerario"])) {
                this.itinerario = [] as any;
                for (let item of _data["itinerario"])
                    this.itinerario!.push(OffertaItinerario.fromJS(item));
            }
            else {
                this.itinerario = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPlannerMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlannerMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itinerario)) {
            data["itinerario"] = [];
            for (let item of this.itinerario)
                data["itinerario"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPlannerMapRequest extends ISiteRequest {
    itinerario?: OffertaItinerario[] | null;
}

export class MarginGetRequest extends LocalizedRequest implements IMarginGetRequest {
    /** ID dell'entità da recuperare */
    id?: number;

    constructor(data?: IMarginGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): MarginGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarginGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMarginGetRequest extends ILocalizedRequest {
    /** ID dell'entità da recuperare */
    id?: number;
}

export class MarginGetResponse extends OkApiResponse implements IMarginGetResponse {
    /** Entità letta */
    servizioMargine?: ServizioMargine;

    constructor(data?: IMarginGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioMargine = _data["servizioMargine"] ? ServizioMargine.fromJS(_data["servizioMargine"]) : <any>null;
        }
    }

    static fromJS(data: any): MarginGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarginGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioMargine"] = this.servizioMargine ? this.servizioMargine.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMarginGetResponse extends IOkApiResponse {
    /** Entità letta */
    servizioMargine?: ServizioMargine;
}

export class ServizioMargine implements IServizioMargine {
    id?: number;
    dal?: string | null;
    al?: string | null;
    servizioDal?: string | null;
    servizioAl?: string | null;
    accordoID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
    tipoServizio?: ETipoServizio | null;
    deltaMarkup?: number;
    proporzionale?: boolean;
    ordine?: number;
    note?: string | null;

    constructor(data?: IServizioMargine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.servizioDal = _data["servizioDal"] !== undefined ? _data["servizioDal"] : <any>null;
            this.servizioAl = _data["servizioAl"] !== undefined ? _data["servizioAl"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.deltaMarkup = _data["deltaMarkup"] !== undefined ? _data["deltaMarkup"] : <any>null;
            this.proporzionale = _data["proporzionale"] !== undefined ? _data["proporzionale"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioMargine {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioMargine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["servizioDal"] = this.servizioDal !== undefined ? this.servizioDal : <any>null;
        data["servizioAl"] = this.servizioAl !== undefined ? this.servizioAl : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["deltaMarkup"] = this.deltaMarkup !== undefined ? this.deltaMarkup : <any>null;
        data["proporzionale"] = this.proporzionale !== undefined ? this.proporzionale : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        return data;
    }
}

export interface IServizioMargine {
    id?: number;
    dal?: string | null;
    al?: string | null;
    servizioDal?: string | null;
    servizioAl?: string | null;
    accordoID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
    tipoServizio?: ETipoServizio | null;
    deltaMarkup?: number;
    proporzionale?: boolean;
    ordine?: number;
    note?: string | null;
}

export class NrTableResponseOfMarginRow extends OkApiResponse implements INrTableResponseOfMarginRow {
    /** Array delle righe della pagina richiesta */
    rows?: MarginRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfMarginRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MarginRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfMarginRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfMarginRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfMarginRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: MarginRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class MarginsList extends NrTableResponseOfMarginRow implements IMarginsList {

    constructor(data?: IMarginsList) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MarginsList {
        data = typeof data === 'object' ? data : {};
        let result = new MarginsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMarginsList extends INrTableResponseOfMarginRow {
}

export class MarginRow implements IMarginRow {
    /** ID dell'entità */
    id?: number;
    /** Entità */
    servizioMargine?: ServizioMargine;
    /** Nome in lingua del servizio (se c'è) */
    servizio?: string | null;
    /** True se il servizio è obsoleto */
    servizioObsoleto?: boolean;
    /** True se il servizio è eliminato */
    servizioEliminato?: boolean;
    /** Nome dell'accordo (se c'è) */
    accordo?: string | null;
    /** Nome in lingua del luogo (se c'è) */
    luogo?: string | null;
    luogoEliminato?: boolean;

    constructor(data?: IMarginRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioMargine = _data["servizioMargine"] ? ServizioMargine.fromJS(_data["servizioMargine"]) : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.servizioObsoleto = _data["servizioObsoleto"] !== undefined ? _data["servizioObsoleto"] : <any>null;
            this.servizioEliminato = _data["servizioEliminato"] !== undefined ? _data["servizioEliminato"] : <any>null;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.luogoEliminato = _data["luogoEliminato"] !== undefined ? _data["luogoEliminato"] : <any>null;
        }
    }

    static fromJS(data: any): MarginRow {
        data = typeof data === 'object' ? data : {};
        let result = new MarginRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioMargine"] = this.servizioMargine ? this.servizioMargine.toJSON() : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["servizioObsoleto"] = this.servizioObsoleto !== undefined ? this.servizioObsoleto : <any>null;
        data["servizioEliminato"] = this.servizioEliminato !== undefined ? this.servizioEliminato : <any>null;
        data["accordo"] = this.accordo !== undefined ? this.accordo : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["luogoEliminato"] = this.luogoEliminato !== undefined ? this.luogoEliminato : <any>null;
        return data;
    }
}

export interface IMarginRow {
    /** ID dell'entità */
    id?: number;
    /** Entità */
    servizioMargine?: ServizioMargine;
    /** Nome in lingua del servizio (se c'è) */
    servizio?: string | null;
    /** True se il servizio è obsoleto */
    servizioObsoleto?: boolean;
    /** True se il servizio è eliminato */
    servizioEliminato?: boolean;
    /** Nome dell'accordo (se c'è) */
    accordo?: string | null;
    /** Nome in lingua del luogo (se c'è) */
    luogo?: string | null;
    luogoEliminato?: boolean;
}

export class MarginsListRequest extends NrTableRequest implements IMarginsListRequest {
    /** ID o qualcosa che gli somiglia */
    term?: string | null;
    /** Accordo associato */
    accordoID?: number | null;
    /** Solo non associati ad accordo */
    noAccordo?: boolean;
    /** Tipo di servizio associato */
    tipoServizio?: ETipoServizio | null;
    /** Sono non associati a tipo servizio */
    noTipoServizio?: boolean;
    /** Servizio associato */
    servizioID?: number | null;
    /** Solo non associati a servizio */
    noServizio?: boolean;
    /** Luogo associato */
    luogoID?: number | null;
    /** Solo non associati a luogo */
    noLuogo?: boolean;

    constructor(data?: IMarginsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.noAccordo = _data["noAccordo"] !== undefined ? _data["noAccordo"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.noTipoServizio = _data["noTipoServizio"] !== undefined ? _data["noTipoServizio"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.noServizio = _data["noServizio"] !== undefined ? _data["noServizio"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.noLuogo = _data["noLuogo"] !== undefined ? _data["noLuogo"] : <any>null;
        }
    }

    static fromJS(data: any): MarginsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarginsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["noAccordo"] = this.noAccordo !== undefined ? this.noAccordo : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["noTipoServizio"] = this.noTipoServizio !== undefined ? this.noTipoServizio : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["noServizio"] = this.noServizio !== undefined ? this.noServizio : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["noLuogo"] = this.noLuogo !== undefined ? this.noLuogo : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMarginsListRequest extends INrTableRequest {
    /** ID o qualcosa che gli somiglia */
    term?: string | null;
    /** Accordo associato */
    accordoID?: number | null;
    /** Solo non associati ad accordo */
    noAccordo?: boolean;
    /** Tipo di servizio associato */
    tipoServizio?: ETipoServizio | null;
    /** Sono non associati a tipo servizio */
    noTipoServizio?: boolean;
    /** Servizio associato */
    servizioID?: number | null;
    /** Solo non associati a servizio */
    noServizio?: boolean;
    /** Luogo associato */
    luogoID?: number | null;
    /** Solo non associati a luogo */
    noLuogo?: boolean;
}

export class MarginUpsertRequest extends LocalizedRequest implements IMarginUpsertRequest {
    /** Entità da persistere (nuova o modificata) */
    servizioMargine?: ServizioMargineBase;

    constructor(data?: IMarginUpsertRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioMargine = _data["servizioMargine"] ? ServizioMargineBase.fromJS(_data["servizioMargine"]) : <any>null;
        }
    }

    static fromJS(data: any): MarginUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarginUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioMargine"] = this.servizioMargine ? this.servizioMargine.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMarginUpsertRequest extends ILocalizedRequest {
    /** Entità da persistere (nuova o modificata) */
    servizioMargine?: ServizioMargineBase;
}

export abstract class ServizioMargineBase implements IServizioMargineBase {
    id?: number;
    dal?: string | null;
    al?: string | null;
    servizioDal?: string | null;
    servizioAl?: string | null;
    accordoID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
    tipoServizio?: ETipoServizio | null;
    deltaMarkup?: number;
    proporzionale?: boolean;
    ordine?: number;
    note?: string | null;

    constructor(data?: IServizioMargineBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.servizioDal = _data["servizioDal"] !== undefined ? _data["servizioDal"] : <any>null;
            this.servizioAl = _data["servizioAl"] !== undefined ? _data["servizioAl"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.deltaMarkup = _data["deltaMarkup"] !== undefined ? _data["deltaMarkup"] : <any>null;
            this.proporzionale = _data["proporzionale"] !== undefined ? _data["proporzionale"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioMargineBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioMargineBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["servizioDal"] = this.servizioDal !== undefined ? this.servizioDal : <any>null;
        data["servizioAl"] = this.servizioAl !== undefined ? this.servizioAl : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["deltaMarkup"] = this.deltaMarkup !== undefined ? this.deltaMarkup : <any>null;
        data["proporzionale"] = this.proporzionale !== undefined ? this.proporzionale : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        return data;
    }
}

export interface IServizioMargineBase {
    id?: number;
    dal?: string | null;
    al?: string | null;
    servizioDal?: string | null;
    servizioAl?: string | null;
    accordoID?: number | null;
    luogoID?: number | null;
    servizioID?: number | null;
    tipoServizio?: ETipoServizio | null;
    deltaMarkup?: number;
    proporzionale?: boolean;
    ordine?: number;
    note?: string | null;
}

export class NaarCrypticJResponse extends OkApiResponse implements INaarCrypticJResponse {
    /** ID del luogo parsato */
    locationID?: number;
    /** Nome (in lingua) del luogo parsato */
    location?: string;
    /** Data dal */
    from?: string;
    /** Data al */
    to?: string;
    /** Elenco dei servizi prezzati */
    services?: JService[];
    /** Percentuale dei servizi con almeno una nightly rate */
    servicesWithNightlyRatesPercent?: number;
    /** Gap medio delle tariffe */
    averagePriceGap?: number | null;
    /** Severità del gap tariffario */
    averagePriceGapSeverity?: EPriceGapSeverity;

    constructor(data?: INaarCrypticJResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.locationID = _data["locationID"] !== undefined ? _data["locationID"] : <any>null;
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(JService.fromJS(item));
            }
            else {
                this.services = <any>null;
            }
            this.servicesWithNightlyRatesPercent = _data["servicesWithNightlyRatesPercent"] !== undefined ? _data["servicesWithNightlyRatesPercent"] : <any>null;
            this.averagePriceGap = _data["averagePriceGap"] !== undefined ? _data["averagePriceGap"] : <any>null;
            this.averagePriceGapSeverity = _data["averagePriceGapSeverity"] !== undefined ? _data["averagePriceGapSeverity"] : <any>null;
        }
    }

    static fromJS(data: any): NaarCrypticJResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarCrypticJResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationID"] = this.locationID !== undefined ? this.locationID : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["to"] = this.to !== undefined ? this.to : <any>null;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        data["servicesWithNightlyRatesPercent"] = this.servicesWithNightlyRatesPercent !== undefined ? this.servicesWithNightlyRatesPercent : <any>null;
        data["averagePriceGap"] = this.averagePriceGap !== undefined ? this.averagePriceGap : <any>null;
        data["averagePriceGapSeverity"] = this.averagePriceGapSeverity !== undefined ? this.averagePriceGapSeverity : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarCrypticJResponse extends IOkApiResponse {
    /** ID del luogo parsato */
    locationID?: number;
    /** Nome (in lingua) del luogo parsato */
    location?: string;
    /** Data dal */
    from?: string;
    /** Data al */
    to?: string;
    /** Elenco dei servizi prezzati */
    services?: JService[];
    /** Percentuale dei servizi con almeno una nightly rate */
    servicesWithNightlyRatesPercent?: number;
    /** Gap medio delle tariffe */
    averagePriceGap?: number | null;
    /** Severità del gap tariffario */
    averagePriceGapSeverity?: EPriceGapSeverity;
}

export class JService implements IJService {
    /** ID servizio Naar */
    id?: number;
    /** Nome servizio Naar */
    name?: string;
    /** Lista delle tipologie */
    types?: JType[];
    /** Costo minimo */
    minCost?: number;
    /** Prezzo minimo */
    minPrice?: number;
    /** Prezzo minimo per le tipologie con nightly rates */
    minNightlyPrice?: number | null;
    nightlyMinPriceGapPercent?: number | null;
    /** Severità del gap tra tariffe con e senza nightly rates */
    priceGapSeverity?: EPriceGapSeverity | null;
    /** True se una qualsiasi delle tipologie ha le nightly rates */
    hasSomeNightlyRate?: boolean;

    constructor(data?: IJService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(JType.fromJS(item));
            }
            else {
                this.types = <any>null;
            }
            this.minCost = _data["minCost"] !== undefined ? _data["minCost"] : <any>null;
            this.minPrice = _data["minPrice"] !== undefined ? _data["minPrice"] : <any>null;
            this.minNightlyPrice = _data["minNightlyPrice"] !== undefined ? _data["minNightlyPrice"] : <any>null;
            this.nightlyMinPriceGapPercent = _data["nightlyMinPriceGapPercent"] !== undefined ? _data["nightlyMinPriceGapPercent"] : <any>null;
            this.priceGapSeverity = _data["priceGapSeverity"] !== undefined ? _data["priceGapSeverity"] : <any>null;
            this.hasSomeNightlyRate = _data["hasSomeNightlyRate"] !== undefined ? _data["hasSomeNightlyRate"] : <any>null;
        }
    }

    static fromJS(data: any): JService {
        data = typeof data === 'object' ? data : {};
        let result = new JService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        data["minCost"] = this.minCost !== undefined ? this.minCost : <any>null;
        data["minPrice"] = this.minPrice !== undefined ? this.minPrice : <any>null;
        data["minNightlyPrice"] = this.minNightlyPrice !== undefined ? this.minNightlyPrice : <any>null;
        data["nightlyMinPriceGapPercent"] = this.nightlyMinPriceGapPercent !== undefined ? this.nightlyMinPriceGapPercent : <any>null;
        data["priceGapSeverity"] = this.priceGapSeverity !== undefined ? this.priceGapSeverity : <any>null;
        data["hasSomeNightlyRate"] = this.hasSomeNightlyRate !== undefined ? this.hasSomeNightlyRate : <any>null;
        return data;
    }
}

export interface IJService {
    /** ID servizio Naar */
    id?: number;
    /** Nome servizio Naar */
    name?: string;
    /** Lista delle tipologie */
    types?: JType[];
    /** Costo minimo */
    minCost?: number;
    /** Prezzo minimo */
    minPrice?: number;
    /** Prezzo minimo per le tipologie con nightly rates */
    minNightlyPrice?: number | null;
    nightlyMinPriceGapPercent?: number | null;
    /** Severità del gap tra tariffe con e senza nightly rates */
    priceGapSeverity?: EPriceGapSeverity | null;
    /** True se una qualsiasi delle tipologie ha le nightly rates */
    hasSomeNightlyRate?: boolean;
}

export class JType implements IJType {
    /** ID tipologia Naar */
    id?: number;
    /** Fornitore della camera */
    supplier?: EFornitore;
    /** Codice fornitore */
    code?: string;
    /** Descrizione (Naar o fornitore) */
    description?: string;
    /** Codice valuta */
    currencyCode?: string;
    /** Tariffe giornaliere */
    rates?: JRate[];
    /** Se true ci sono le nigthly rates */
    hasRates?: boolean;
    /** Costo totale */
    cost?: number;
    /** Prezzo totale */
    price?: number;
    /** Non rimborsabile */
    notRefundlable?: boolean;
    /** Acquisto immediato */
    instantPurchase?: boolean;
    /** True se disponibile */
    available?: boolean;
    /** Hashcode calcolato della camera */
    hashcode?: string | null;
    /** Descrizione dell'hashcode */
    hascodeDescription?: string | null;

    constructor(data?: IJType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.currencyCode = _data["currencyCode"] !== undefined ? _data["currencyCode"] : <any>null;
            if (Array.isArray(_data["rates"])) {
                this.rates = [] as any;
                for (let item of _data["rates"])
                    this.rates!.push(JRate.fromJS(item));
            }
            else {
                this.rates = <any>null;
            }
            this.hasRates = _data["hasRates"] !== undefined ? _data["hasRates"] : <any>null;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.notRefundlable = _data["notRefundlable"] !== undefined ? _data["notRefundlable"] : <any>null;
            this.instantPurchase = _data["instantPurchase"] !== undefined ? _data["instantPurchase"] : <any>null;
            this.available = _data["available"] !== undefined ? _data["available"] : <any>null;
            this.hashcode = _data["hashcode"] !== undefined ? _data["hashcode"] : <any>null;
            this.hascodeDescription = _data["hascodeDescription"] !== undefined ? _data["hascodeDescription"] : <any>null;
        }
    }

    static fromJS(data: any): JType {
        data = typeof data === 'object' ? data : {};
        let result = new JType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["currencyCode"] = this.currencyCode !== undefined ? this.currencyCode : <any>null;
        if (Array.isArray(this.rates)) {
            data["rates"] = [];
            for (let item of this.rates)
                data["rates"].push(item.toJSON());
        }
        data["hasRates"] = this.hasRates !== undefined ? this.hasRates : <any>null;
        data["cost"] = this.cost !== undefined ? this.cost : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["notRefundlable"] = this.notRefundlable !== undefined ? this.notRefundlable : <any>null;
        data["instantPurchase"] = this.instantPurchase !== undefined ? this.instantPurchase : <any>null;
        data["available"] = this.available !== undefined ? this.available : <any>null;
        data["hashcode"] = this.hashcode !== undefined ? this.hashcode : <any>null;
        data["hascodeDescription"] = this.hascodeDescription !== undefined ? this.hascodeDescription : <any>null;
        return data;
    }
}

export interface IJType {
    /** ID tipologia Naar */
    id?: number;
    /** Fornitore della camera */
    supplier?: EFornitore;
    /** Codice fornitore */
    code?: string;
    /** Descrizione (Naar o fornitore) */
    description?: string;
    /** Codice valuta */
    currencyCode?: string;
    /** Tariffe giornaliere */
    rates?: JRate[];
    /** Se true ci sono le nigthly rates */
    hasRates?: boolean;
    /** Costo totale */
    cost?: number;
    /** Prezzo totale */
    price?: number;
    /** Non rimborsabile */
    notRefundlable?: boolean;
    /** Acquisto immediato */
    instantPurchase?: boolean;
    /** True se disponibile */
    available?: boolean;
    /** Hashcode calcolato della camera */
    hashcode?: string | null;
    /** Descrizione dell'hashcode */
    hascodeDescription?: string | null;
}

export class JRate implements IJRate {
    /** Data */
    date?: string;
    /** Costo */
    cost?: number;
    /** Prezzo */
    price?: number;

    constructor(data?: IJRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
        }
    }

    static fromJS(data: any): JRate {
        data = typeof data === 'object' ? data : {};
        let result = new JRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["cost"] = this.cost !== undefined ? this.cost : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        return data;
    }
}

export interface IJRate {
    /** Data */
    date?: string;
    /** Costo */
    cost?: number;
    /** Prezzo */
    price?: number;
}

export enum EPriceGapSeverity {
    None = "None",
    Medium = "Medium",
    High = "High",
}

export class NaarCrypticJRequest extends LocalizedRequest implements INaarCrypticJRequest {
    /** Codice IATA */
    iata?: string | null;
    /** Luogo (ricerca generica) */
    location?: string | null;
    /** ID del luogo */
    locationID?: number | null;
    /** Se true cerca solo sulla località principale e non sulle vicine */
    mainLocationOnly?: boolean;
    /** Data di inizio */
    startDate!: string;
    /** Numero di notti */
    duration!: number;
    /** Definizione delle camere (A[A..][Ce][Ce...] */
    roomsDef?: string | null;
    /** Lista opzionale di fornitori */
    suppliers?: EFornitore[] | null;
    /** Se true usa l'emulazione della cache (usa solo hashcodes di quotazioni con nightly rate) */
    emulateCache?: boolean;

    constructor(data?: INaarCrypticJRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.iata = _data["iata"] !== undefined ? _data["iata"] : <any>null;
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.locationID = _data["locationID"] !== undefined ? _data["locationID"] : <any>null;
            this.mainLocationOnly = _data["mainLocationOnly"] !== undefined ? _data["mainLocationOnly"] : <any>null;
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : <any>null;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : <any>null;
            this.roomsDef = _data["roomsDef"] !== undefined ? _data["roomsDef"] : <any>null;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(item);
            }
            else {
                this.suppliers = <any>null;
            }
            this.emulateCache = _data["emulateCache"] !== undefined ? _data["emulateCache"] : <any>null;
        }
    }

    static fromJS(data: any): NaarCrypticJRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarCrypticJRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iata"] = this.iata !== undefined ? this.iata : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["locationID"] = this.locationID !== undefined ? this.locationID : <any>null;
        data["mainLocationOnly"] = this.mainLocationOnly !== undefined ? this.mainLocationOnly : <any>null;
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["duration"] = this.duration !== undefined ? this.duration : <any>null;
        data["roomsDef"] = this.roomsDef !== undefined ? this.roomsDef : <any>null;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item);
        }
        data["emulateCache"] = this.emulateCache !== undefined ? this.emulateCache : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarCrypticJRequest extends ILocalizedRequest {
    /** Codice IATA */
    iata?: string | null;
    /** Luogo (ricerca generica) */
    location?: string | null;
    /** ID del luogo */
    locationID?: number | null;
    /** Se true cerca solo sulla località principale e non sulle vicine */
    mainLocationOnly?: boolean;
    /** Data di inizio */
    startDate: string;
    /** Numero di notti */
    duration: number;
    /** Definizione delle camere (A[A..][Ce][Ce...] */
    roomsDef?: string | null;
    /** Lista opzionale di fornitori */
    suppliers?: EFornitore[] | null;
    /** Se true usa l'emulazione della cache (usa solo hashcodes di quotazioni con nightly rate) */
    emulateCache?: boolean;
}

export class NaarCrypticNResponse extends OkApiResponse implements INaarCrypticNResponse {
    /** Dizionario di traduzione accordo fornitore */
    suppliers?: { [key: string]: EFornitore; };
    /** Elenco dei servizi */
    services?: NService[];

    constructor(data?: INaarCrypticNResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["suppliers"]) {
                this.suppliers = {} as any;
                for (let key in _data["suppliers"]) {
                    if (_data["suppliers"].hasOwnProperty(key))
                        (<any>this.suppliers)![key] = _data["suppliers"][key] !== undefined ? _data["suppliers"][key] : <any>null;
                }
            }
            else {
                this.suppliers = <any>null;
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(NService.fromJS(item));
            }
            else {
                this.services = <any>null;
            }
        }
    }

    static fromJS(data: any): NaarCrypticNResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarCrypticNResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.suppliers) {
            data["suppliers"] = {};
            for (let key in this.suppliers) {
                if (this.suppliers.hasOwnProperty(key))
                    (<any>data["suppliers"])[key] = this.suppliers[key] !== undefined ? this.suppliers[key] : <any>null;
            }
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface INaarCrypticNResponse extends IOkApiResponse {
    /** Dizionario di traduzione accordo fornitore */
    suppliers?: { [key: string]: EFornitore; };
    /** Elenco dei servizi */
    services?: NService[];
}

export class NService implements INService {
    uniqueID?: string;
    servizioID?: number | null;
    internal?: boolean;
    minPrice?: number;
    types?: NType[];

    constructor(data?: INService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.internal = _data["internal"] !== undefined ? _data["internal"] : <any>null;
            this.minPrice = _data["minPrice"] !== undefined ? _data["minPrice"] : <any>null;
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(NType.fromJS(item));
            }
            else {
                this.types = <any>null;
            }
        }
    }

    static fromJS(data: any): NService {
        data = typeof data === 'object' ? data : {};
        let result = new NService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["internal"] = this.internal !== undefined ? this.internal : <any>null;
        data["minPrice"] = this.minPrice !== undefined ? this.minPrice : <any>null;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        return data;
    }
}

export interface INService {
    uniqueID?: string;
    servizioID?: number | null;
    internal?: boolean;
    minPrice?: number;
    types?: NType[];
}

export class NType implements INType {
    servizioH2hID?: number;
    hashCode?: string;
    attributoHashcode?: HHAttributoHashcode;
    name?: string;
    nrf?: boolean;
    ip?: boolean;
    cost?: number;
    price?: number;
    agreementID?: number;
    available?: boolean;
    roomID?: number | null;

    constructor(data?: INType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioH2hID = _data["servizioH2hID"] !== undefined ? _data["servizioH2hID"] : <any>null;
            this.hashCode = _data["hashCode"] !== undefined ? _data["hashCode"] : <any>null;
            this.attributoHashcode = _data["attributoHashcode"] ? HHAttributoHashcode.fromJS(_data["attributoHashcode"]) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.nrf = _data["nrf"] !== undefined ? _data["nrf"] : <any>null;
            this.ip = _data["ip"] !== undefined ? _data["ip"] : <any>null;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.agreementID = _data["agreementID"] !== undefined ? _data["agreementID"] : <any>null;
            this.available = _data["available"] !== undefined ? _data["available"] : <any>null;
            this.roomID = _data["roomID"] !== undefined ? _data["roomID"] : <any>null;
        }
    }

    static fromJS(data: any): NType {
        data = typeof data === 'object' ? data : {};
        let result = new NType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioH2hID"] = this.servizioH2hID !== undefined ? this.servizioH2hID : <any>null;
        data["hashCode"] = this.hashCode !== undefined ? this.hashCode : <any>null;
        data["attributoHashcode"] = this.attributoHashcode ? this.attributoHashcode.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["nrf"] = this.nrf !== undefined ? this.nrf : <any>null;
        data["ip"] = this.ip !== undefined ? this.ip : <any>null;
        data["cost"] = this.cost !== undefined ? this.cost : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["agreementID"] = this.agreementID !== undefined ? this.agreementID : <any>null;
        data["available"] = this.available !== undefined ? this.available : <any>null;
        data["roomID"] = this.roomID !== undefined ? this.roomID : <any>null;
        return data;
    }
}

export interface INType {
    servizioH2hID?: number;
    hashCode?: string;
    attributoHashcode?: HHAttributoHashcode;
    name?: string;
    nrf?: boolean;
    ip?: boolean;
    cost?: number;
    price?: number;
    agreementID?: number;
    available?: boolean;
    roomID?: number | null;
}

export class NaarCrypticNRequest extends LocalizedRequest implements INaarCrypticNRequest {
    /** Codice IATA */
    iata?: string | null;
    /** Luogo (ricerca generica) */
    location?: string | null;
    /** ID del luogo */
    locationID?: number | null;
    /** Se true cerca solo sulla località principale e non sulle vicine */
    mainLocationOnly?: boolean;
    /** Data di inizio */
    startDate!: string;
    /** Numero di notti */
    duration!: number;
    /** Definizione delle camere (A[1-4][-...]) */
    roomsDef?: string | null;

    constructor(data?: INaarCrypticNRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.iata = _data["iata"] !== undefined ? _data["iata"] : <any>null;
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.locationID = _data["locationID"] !== undefined ? _data["locationID"] : <any>null;
            this.mainLocationOnly = _data["mainLocationOnly"] !== undefined ? _data["mainLocationOnly"] : <any>null;
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : <any>null;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : <any>null;
            this.roomsDef = _data["roomsDef"] !== undefined ? _data["roomsDef"] : <any>null;
        }
    }

    static fromJS(data: any): NaarCrypticNRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarCrypticNRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iata"] = this.iata !== undefined ? this.iata : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["locationID"] = this.locationID !== undefined ? this.locationID : <any>null;
        data["mainLocationOnly"] = this.mainLocationOnly !== undefined ? this.mainLocationOnly : <any>null;
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["duration"] = this.duration !== undefined ? this.duration : <any>null;
        data["roomsDef"] = this.roomsDef !== undefined ? this.roomsDef : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarCrypticNRequest extends ILocalizedRequest {
    /** Codice IATA */
    iata?: string | null;
    /** Luogo (ricerca generica) */
    location?: string | null;
    /** ID del luogo */
    locationID?: number | null;
    /** Se true cerca solo sulla località principale e non sulle vicine */
    mainLocationOnly?: boolean;
    /** Data di inizio */
    startDate: string;
    /** Numero di notti */
    duration: number;
    /** Definizione delle camere (A[1-4][-...]) */
    roomsDef?: string | null;
}

export class NaarCrypticPMIResponse extends OkApiResponse implements INaarCrypticPMIResponse {
    data?: ServiceSearchData;
    /** Nome del gruppo. Vuoto se è un nuovo viaggio. */
    gruppo?: string | null;
    /** Nome del servizio Naar */
    servizio?: string | null;
    /** Nome della tipologia Naar */
    tipologia?: string | null;
    /** Nome della tipologia parent Naar */
    tipologiaParent?: string | null;
    /** Nome del bedding */
    bedding?: string | null;
    /** Nome dell'accordo */
    accordo?: string | null;
    /** Codice valuta dell'accordo */
    codiceValuta?: string | null;
    /** Data aggiornamento valuta */
    dataValuta?: string | null;
    /** Nome della valuta dell'accordo */
    valuta?: string | null;
    /** Valore reale valuta */
    valoreAttuale?: number;
    /** Valore applicato valuta */
    valoreApplicato?: number;
    /** ID del luogo fornitore */
    luogoFornitoreID?: number | null;
    /** Codice del luogo del fornitore */
    codiceLuogoFornitore?: string | null;
    /** Nome del luogo del fornitore */
    luogoFornitore?: string | null;
    /** Codice della tipologia del fornitore */
    codiceTiplogiaFornitore?: string | null;
    /** Nome della tipologia fornitore */
    tipologiaFornitore?: string | null;
    /** ID del servizio fornitore */
    servizioFornitoreID?: number | null;
    /** Codice servizio del fornitore */
    codiceServizioFornitore?: string | null;
    /** Nome servizio del fornitore */
    nomeServizioFornitore?: string | null;
    /** ID del servizio h2h */
    servizioH2HID?: number | null;
    /** Nome del servizio H2H */
    servizioH2H?: string | null;
    /** Trattamento */
    trattamento?: string | null;
    /** Disponibilità */
    disponibilita?: EStatoDisponibilita;
    /** Nome della tabella costo */
    tabellaCosto?: string | null;
    /** Fornitore */
    fornitore?: EFornitore;
    /** Luogo */
    luogo?: string | null;
    /** Luogo di destinazione */
    luogoDestionatione?: string | null;

    constructor(data?: INaarCrypticPMIResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ServiceSearchData.fromJS(_data["data"]) : <any>null;
            this.gruppo = _data["gruppo"] !== undefined ? _data["gruppo"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.tipologia = _data["tipologia"] !== undefined ? _data["tipologia"] : <any>null;
            this.tipologiaParent = _data["tipologiaParent"] !== undefined ? _data["tipologiaParent"] : <any>null;
            this.bedding = _data["bedding"] !== undefined ? _data["bedding"] : <any>null;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : <any>null;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : <any>null;
            this.dataValuta = _data["dataValuta"] !== undefined ? _data["dataValuta"] : <any>null;
            this.valuta = _data["valuta"] !== undefined ? _data["valuta"] : <any>null;
            this.valoreAttuale = _data["valoreAttuale"] !== undefined ? _data["valoreAttuale"] : <any>null;
            this.valoreApplicato = _data["valoreApplicato"] !== undefined ? _data["valoreApplicato"] : <any>null;
            this.luogoFornitoreID = _data["luogoFornitoreID"] !== undefined ? _data["luogoFornitoreID"] : <any>null;
            this.codiceLuogoFornitore = _data["codiceLuogoFornitore"] !== undefined ? _data["codiceLuogoFornitore"] : <any>null;
            this.luogoFornitore = _data["luogoFornitore"] !== undefined ? _data["luogoFornitore"] : <any>null;
            this.codiceTiplogiaFornitore = _data["codiceTiplogiaFornitore"] !== undefined ? _data["codiceTiplogiaFornitore"] : <any>null;
            this.tipologiaFornitore = _data["tipologiaFornitore"] !== undefined ? _data["tipologiaFornitore"] : <any>null;
            this.servizioFornitoreID = _data["servizioFornitoreID"] !== undefined ? _data["servizioFornitoreID"] : <any>null;
            this.codiceServizioFornitore = _data["codiceServizioFornitore"] !== undefined ? _data["codiceServizioFornitore"] : <any>null;
            this.nomeServizioFornitore = _data["nomeServizioFornitore"] !== undefined ? _data["nomeServizioFornitore"] : <any>null;
            this.servizioH2HID = _data["servizioH2HID"] !== undefined ? _data["servizioH2HID"] : <any>null;
            this.servizioH2H = _data["servizioH2H"] !== undefined ? _data["servizioH2H"] : <any>null;
            this.trattamento = _data["trattamento"] !== undefined ? _data["trattamento"] : <any>null;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : <any>null;
            this.tabellaCosto = _data["tabellaCosto"] !== undefined ? _data["tabellaCosto"] : <any>null;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.luogoDestionatione = _data["luogoDestionatione"] !== undefined ? _data["luogoDestionatione"] : <any>null;
        }
    }

    static fromJS(data: any): NaarCrypticPMIResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarCrypticPMIResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>null;
        data["gruppo"] = this.gruppo !== undefined ? this.gruppo : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["tipologia"] = this.tipologia !== undefined ? this.tipologia : <any>null;
        data["tipologiaParent"] = this.tipologiaParent !== undefined ? this.tipologiaParent : <any>null;
        data["bedding"] = this.bedding !== undefined ? this.bedding : <any>null;
        data["accordo"] = this.accordo !== undefined ? this.accordo : <any>null;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : <any>null;
        data["dataValuta"] = this.dataValuta !== undefined ? this.dataValuta : <any>null;
        data["valuta"] = this.valuta !== undefined ? this.valuta : <any>null;
        data["valoreAttuale"] = this.valoreAttuale !== undefined ? this.valoreAttuale : <any>null;
        data["valoreApplicato"] = this.valoreApplicato !== undefined ? this.valoreApplicato : <any>null;
        data["luogoFornitoreID"] = this.luogoFornitoreID !== undefined ? this.luogoFornitoreID : <any>null;
        data["codiceLuogoFornitore"] = this.codiceLuogoFornitore !== undefined ? this.codiceLuogoFornitore : <any>null;
        data["luogoFornitore"] = this.luogoFornitore !== undefined ? this.luogoFornitore : <any>null;
        data["codiceTiplogiaFornitore"] = this.codiceTiplogiaFornitore !== undefined ? this.codiceTiplogiaFornitore : <any>null;
        data["tipologiaFornitore"] = this.tipologiaFornitore !== undefined ? this.tipologiaFornitore : <any>null;
        data["servizioFornitoreID"] = this.servizioFornitoreID !== undefined ? this.servizioFornitoreID : <any>null;
        data["codiceServizioFornitore"] = this.codiceServizioFornitore !== undefined ? this.codiceServizioFornitore : <any>null;
        data["nomeServizioFornitore"] = this.nomeServizioFornitore !== undefined ? this.nomeServizioFornitore : <any>null;
        data["servizioH2HID"] = this.servizioH2HID !== undefined ? this.servizioH2HID : <any>null;
        data["servizioH2H"] = this.servizioH2H !== undefined ? this.servizioH2H : <any>null;
        data["trattamento"] = this.trattamento !== undefined ? this.trattamento : <any>null;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : <any>null;
        data["tabellaCosto"] = this.tabellaCosto !== undefined ? this.tabellaCosto : <any>null;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["luogoDestionatione"] = this.luogoDestionatione !== undefined ? this.luogoDestionatione : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarCrypticPMIResponse extends IOkApiResponse {
    data?: ServiceSearchData;
    /** Nome del gruppo. Vuoto se è un nuovo viaggio. */
    gruppo?: string | null;
    /** Nome del servizio Naar */
    servizio?: string | null;
    /** Nome della tipologia Naar */
    tipologia?: string | null;
    /** Nome della tipologia parent Naar */
    tipologiaParent?: string | null;
    /** Nome del bedding */
    bedding?: string | null;
    /** Nome dell'accordo */
    accordo?: string | null;
    /** Codice valuta dell'accordo */
    codiceValuta?: string | null;
    /** Data aggiornamento valuta */
    dataValuta?: string | null;
    /** Nome della valuta dell'accordo */
    valuta?: string | null;
    /** Valore reale valuta */
    valoreAttuale?: number;
    /** Valore applicato valuta */
    valoreApplicato?: number;
    /** ID del luogo fornitore */
    luogoFornitoreID?: number | null;
    /** Codice del luogo del fornitore */
    codiceLuogoFornitore?: string | null;
    /** Nome del luogo del fornitore */
    luogoFornitore?: string | null;
    /** Codice della tipologia del fornitore */
    codiceTiplogiaFornitore?: string | null;
    /** Nome della tipologia fornitore */
    tipologiaFornitore?: string | null;
    /** ID del servizio fornitore */
    servizioFornitoreID?: number | null;
    /** Codice servizio del fornitore */
    codiceServizioFornitore?: string | null;
    /** Nome servizio del fornitore */
    nomeServizioFornitore?: string | null;
    /** ID del servizio h2h */
    servizioH2HID?: number | null;
    /** Nome del servizio H2H */
    servizioH2H?: string | null;
    /** Trattamento */
    trattamento?: string | null;
    /** Disponibilità */
    disponibilita?: EStatoDisponibilita;
    /** Nome della tabella costo */
    tabellaCosto?: string | null;
    /** Fornitore */
    fornitore?: EFornitore;
    /** Luogo */
    luogo?: string | null;
    /** Luogo di destinazione */
    luogoDestionatione?: string | null;
}

export class ServiceSearchData implements IServiceSearchData {
    gruppoID?: number;
    dataInizio?: string;
    servizioID?: number;
    servizioTipologiaID?: number;
    servizioTipologiaParentID?: number;
    beddingID?: number | null;
    quantita?: number;
    accordoID?: number;
    servizioFornitoreID?: number;
    codPrenotazione?: string | null;
    trattamentoID?: number;
    supplemento?: boolean;
    prezzo?: number;
    costo?: number;
    maxEta?: number;
    numeroPax?: number;
    tabAllotmentID?: number;
    disponibilita?: number;
    costoID?: number;
    tabellaCostoID?: number;
    fornitoreID?: number;
    numeroChild?: number;
    prezzoChild?: number;
    costoChild?: number;
    descrizione?: string | null;
    descrizioneFornitore?: string | null;
    notRefundable?: boolean;
    instantPurchase?: boolean;
    weddingRate?: boolean;
    penaleID?: number;
    hasFurtherInfo?: boolean;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    opzioni?: ServiceSearchSupplement[] | null;
    paxIDs?: number[] | null;
    dataFine?: string;
    luogoDestinazioneID?: number | null;
    luogoID?: number;
    tipoServizio?: ETipoServizioSearch;
    nota?: string | null;
    notaAgenzia?: string | null;
    notFound?: boolean;
    providerCustomData?: string | null;
    dataPenale?: string | null;
    importoPenale?: number | null;
    articoloPenaleID?: number | null;
    supplementi?: DisponibilitaSupplemento[] | null;
    supplementiAlt?: Supplemento[] | null;
    hashCode?: string | null;
    descrizioneHashCode?: string | null;
    supplementiDaInserire?: ServiceSearchData[] | null;
    servizioH2hID?: number | null;

    constructor(data?: IServiceSearchData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gruppoID = _data["gruppoID"] !== undefined ? _data["gruppoID"] : <any>null;
            this.dataInizio = _data["dataInizio"] !== undefined ? _data["dataInizio"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : <any>null;
            this.servizioTipologiaParentID = _data["servizioTipologiaParentID"] !== undefined ? _data["servizioTipologiaParentID"] : <any>null;
            this.beddingID = _data["beddingID"] !== undefined ? _data["beddingID"] : <any>null;
            this.quantita = _data["quantita"] !== undefined ? _data["quantita"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.servizioFornitoreID = _data["servizioFornitoreID"] !== undefined ? _data["servizioFornitoreID"] : <any>null;
            this.codPrenotazione = _data["codPrenotazione"] !== undefined ? _data["codPrenotazione"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
            this.supplemento = _data["supplemento"] !== undefined ? _data["supplemento"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : <any>null;
            this.maxEta = _data["maxEta"] !== undefined ? _data["maxEta"] : <any>null;
            this.numeroPax = _data["numeroPax"] !== undefined ? _data["numeroPax"] : <any>null;
            this.tabAllotmentID = _data["tabAllotmentID"] !== undefined ? _data["tabAllotmentID"] : <any>null;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : <any>null;
            this.costoID = _data["costoID"] !== undefined ? _data["costoID"] : <any>null;
            this.tabellaCostoID = _data["tabellaCostoID"] !== undefined ? _data["tabellaCostoID"] : <any>null;
            this.fornitoreID = _data["fornitoreID"] !== undefined ? _data["fornitoreID"] : <any>null;
            this.numeroChild = _data["numeroChild"] !== undefined ? _data["numeroChild"] : <any>null;
            this.prezzoChild = _data["prezzoChild"] !== undefined ? _data["prezzoChild"] : <any>null;
            this.costoChild = _data["costoChild"] !== undefined ? _data["costoChild"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.descrizioneFornitore = _data["descrizioneFornitore"] !== undefined ? _data["descrizioneFornitore"] : <any>null;
            this.notRefundable = _data["notRefundable"] !== undefined ? _data["notRefundable"] : <any>null;
            this.instantPurchase = _data["instantPurchase"] !== undefined ? _data["instantPurchase"] : <any>null;
            this.weddingRate = _data["weddingRate"] !== undefined ? _data["weddingRate"] : <any>null;
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : <any>null;
            this.hasFurtherInfo = _data["hasFurtherInfo"] !== undefined ? _data["hasFurtherInfo"] : <any>null;
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(DisponibilitaTipologiaOfferta.fromJS(item));
            }
            else {
                this.offerte = <any>null;
            }
            if (Array.isArray(_data["opzioni"])) {
                this.opzioni = [] as any;
                for (let item of _data["opzioni"])
                    this.opzioni!.push(ServiceSearchSupplement.fromJS(item));
            }
            else {
                this.opzioni = <any>null;
            }
            if (Array.isArray(_data["paxIDs"])) {
                this.paxIDs = [] as any;
                for (let item of _data["paxIDs"])
                    this.paxIDs!.push(item);
            }
            else {
                this.paxIDs = <any>null;
            }
            this.dataFine = _data["dataFine"] !== undefined ? _data["dataFine"] : <any>null;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.nota = _data["nota"] !== undefined ? _data["nota"] : <any>null;
            this.notaAgenzia = _data["notaAgenzia"] !== undefined ? _data["notaAgenzia"] : <any>null;
            this.notFound = _data["notFound"] !== undefined ? _data["notFound"] : <any>null;
            this.providerCustomData = _data["providerCustomData"] !== undefined ? _data["providerCustomData"] : <any>null;
            this.dataPenale = _data["dataPenale"] !== undefined ? _data["dataPenale"] : <any>null;
            this.importoPenale = _data["importoPenale"] !== undefined ? _data["importoPenale"] : <any>null;
            this.articoloPenaleID = _data["articoloPenaleID"] !== undefined ? _data["articoloPenaleID"] : <any>null;
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(DisponibilitaSupplemento.fromJS(item));
            }
            else {
                this.supplementi = <any>null;
            }
            if (Array.isArray(_data["supplementiAlt"])) {
                this.supplementiAlt = [] as any;
                for (let item of _data["supplementiAlt"])
                    this.supplementiAlt!.push(Supplemento.fromJS(item));
            }
            else {
                this.supplementiAlt = <any>null;
            }
            this.hashCode = _data["hashCode"] !== undefined ? _data["hashCode"] : <any>null;
            this.descrizioneHashCode = _data["descrizioneHashCode"] !== undefined ? _data["descrizioneHashCode"] : <any>null;
            if (Array.isArray(_data["supplementiDaInserire"])) {
                this.supplementiDaInserire = [] as any;
                for (let item of _data["supplementiDaInserire"])
                    this.supplementiDaInserire!.push(ServiceSearchData.fromJS(item));
            }
            else {
                this.supplementiDaInserire = <any>null;
            }
            this.servizioH2hID = _data["servizioH2hID"] !== undefined ? _data["servizioH2hID"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceSearchData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSearchData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gruppoID"] = this.gruppoID !== undefined ? this.gruppoID : <any>null;
        data["dataInizio"] = this.dataInizio !== undefined ? this.dataInizio : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : <any>null;
        data["servizioTipologiaParentID"] = this.servizioTipologiaParentID !== undefined ? this.servizioTipologiaParentID : <any>null;
        data["beddingID"] = this.beddingID !== undefined ? this.beddingID : <any>null;
        data["quantita"] = this.quantita !== undefined ? this.quantita : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["servizioFornitoreID"] = this.servizioFornitoreID !== undefined ? this.servizioFornitoreID : <any>null;
        data["codPrenotazione"] = this.codPrenotazione !== undefined ? this.codPrenotazione : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        data["supplemento"] = this.supplemento !== undefined ? this.supplemento : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["costo"] = this.costo !== undefined ? this.costo : <any>null;
        data["maxEta"] = this.maxEta !== undefined ? this.maxEta : <any>null;
        data["numeroPax"] = this.numeroPax !== undefined ? this.numeroPax : <any>null;
        data["tabAllotmentID"] = this.tabAllotmentID !== undefined ? this.tabAllotmentID : <any>null;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : <any>null;
        data["costoID"] = this.costoID !== undefined ? this.costoID : <any>null;
        data["tabellaCostoID"] = this.tabellaCostoID !== undefined ? this.tabellaCostoID : <any>null;
        data["fornitoreID"] = this.fornitoreID !== undefined ? this.fornitoreID : <any>null;
        data["numeroChild"] = this.numeroChild !== undefined ? this.numeroChild : <any>null;
        data["prezzoChild"] = this.prezzoChild !== undefined ? this.prezzoChild : <any>null;
        data["costoChild"] = this.costoChild !== undefined ? this.costoChild : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["descrizioneFornitore"] = this.descrizioneFornitore !== undefined ? this.descrizioneFornitore : <any>null;
        data["notRefundable"] = this.notRefundable !== undefined ? this.notRefundable : <any>null;
        data["instantPurchase"] = this.instantPurchase !== undefined ? this.instantPurchase : <any>null;
        data["weddingRate"] = this.weddingRate !== undefined ? this.weddingRate : <any>null;
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : <any>null;
        data["hasFurtherInfo"] = this.hasFurtherInfo !== undefined ? this.hasFurtherInfo : <any>null;
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item.toJSON());
        }
        if (Array.isArray(this.opzioni)) {
            data["opzioni"] = [];
            for (let item of this.opzioni)
                data["opzioni"].push(item.toJSON());
        }
        if (Array.isArray(this.paxIDs)) {
            data["paxIDs"] = [];
            for (let item of this.paxIDs)
                data["paxIDs"].push(item);
        }
        data["dataFine"] = this.dataFine !== undefined ? this.dataFine : <any>null;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["nota"] = this.nota !== undefined ? this.nota : <any>null;
        data["notaAgenzia"] = this.notaAgenzia !== undefined ? this.notaAgenzia : <any>null;
        data["notFound"] = this.notFound !== undefined ? this.notFound : <any>null;
        data["providerCustomData"] = this.providerCustomData !== undefined ? this.providerCustomData : <any>null;
        data["dataPenale"] = this.dataPenale !== undefined ? this.dataPenale : <any>null;
        data["importoPenale"] = this.importoPenale !== undefined ? this.importoPenale : <any>null;
        data["articoloPenaleID"] = this.articoloPenaleID !== undefined ? this.articoloPenaleID : <any>null;
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item.toJSON());
        }
        if (Array.isArray(this.supplementiAlt)) {
            data["supplementiAlt"] = [];
            for (let item of this.supplementiAlt)
                data["supplementiAlt"].push(item.toJSON());
        }
        data["hashCode"] = this.hashCode !== undefined ? this.hashCode : <any>null;
        data["descrizioneHashCode"] = this.descrizioneHashCode !== undefined ? this.descrizioneHashCode : <any>null;
        if (Array.isArray(this.supplementiDaInserire)) {
            data["supplementiDaInserire"] = [];
            for (let item of this.supplementiDaInserire)
                data["supplementiDaInserire"].push(item.toJSON());
        }
        data["servizioH2hID"] = this.servizioH2hID !== undefined ? this.servizioH2hID : <any>null;
        return data;
    }
}

export interface IServiceSearchData {
    gruppoID?: number;
    dataInizio?: string;
    servizioID?: number;
    servizioTipologiaID?: number;
    servizioTipologiaParentID?: number;
    beddingID?: number | null;
    quantita?: number;
    accordoID?: number;
    servizioFornitoreID?: number;
    codPrenotazione?: string | null;
    trattamentoID?: number;
    supplemento?: boolean;
    prezzo?: number;
    costo?: number;
    maxEta?: number;
    numeroPax?: number;
    tabAllotmentID?: number;
    disponibilita?: number;
    costoID?: number;
    tabellaCostoID?: number;
    fornitoreID?: number;
    numeroChild?: number;
    prezzoChild?: number;
    costoChild?: number;
    descrizione?: string | null;
    descrizioneFornitore?: string | null;
    notRefundable?: boolean;
    instantPurchase?: boolean;
    weddingRate?: boolean;
    penaleID?: number;
    hasFurtherInfo?: boolean;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    opzioni?: ServiceSearchSupplement[] | null;
    paxIDs?: number[] | null;
    dataFine?: string;
    luogoDestinazioneID?: number | null;
    luogoID?: number;
    tipoServizio?: ETipoServizioSearch;
    nota?: string | null;
    notaAgenzia?: string | null;
    notFound?: boolean;
    providerCustomData?: string | null;
    dataPenale?: string | null;
    importoPenale?: number | null;
    articoloPenaleID?: number | null;
    supplementi?: DisponibilitaSupplemento[] | null;
    supplementiAlt?: Supplemento[] | null;
    hashCode?: string | null;
    descrizioneHashCode?: string | null;
    supplementiDaInserire?: ServiceSearchData[] | null;
    servizioH2hID?: number | null;
}

export class DisponibilitaTipologiaOfferta implements IDisponibilitaTipologiaOfferta {
    prezzo?: number;
    costo?: number;
    label?: string | null;
    idserv_sup?: number;
    tipo?: ETipoAzioneDettaglio;

    constructor(data?: IDisponibilitaTipologiaOfferta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.idserv_sup = _data["idserv_sup"] !== undefined ? _data["idserv_sup"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
        }
    }

    static fromJS(data: any): DisponibilitaTipologiaOfferta {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaTipologiaOfferta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["costo"] = this.costo !== undefined ? this.costo : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["idserv_sup"] = this.idserv_sup !== undefined ? this.idserv_sup : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        return data;
    }
}

export interface IDisponibilitaTipologiaOfferta {
    prezzo?: number;
    costo?: number;
    label?: string | null;
    idserv_sup?: number;
    tipo?: ETipoAzioneDettaglio;
}

export class ServiceSearchSupplement implements IServiceSearchSupplement {
    supplierID?: number;
    resultID?: number;
    resultItemID?: number;
    departureID?: number | null;
    optionID?: number;
    mandatory?: boolean;

    constructor(data?: IServiceSearchSupplement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : <any>null;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : <any>null;
            this.resultItemID = _data["resultItemID"] !== undefined ? _data["resultItemID"] : <any>null;
            this.departureID = _data["departureID"] !== undefined ? _data["departureID"] : <any>null;
            this.optionID = _data["optionID"] !== undefined ? _data["optionID"] : <any>null;
            this.mandatory = _data["mandatory"] !== undefined ? _data["mandatory"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceSearchSupplement {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSearchSupplement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : <any>null;
        data["resultID"] = this.resultID !== undefined ? this.resultID : <any>null;
        data["resultItemID"] = this.resultItemID !== undefined ? this.resultItemID : <any>null;
        data["departureID"] = this.departureID !== undefined ? this.departureID : <any>null;
        data["optionID"] = this.optionID !== undefined ? this.optionID : <any>null;
        data["mandatory"] = this.mandatory !== undefined ? this.mandatory : <any>null;
        return data;
    }
}

export interface IServiceSearchSupplement {
    supplierID?: number;
    resultID?: number;
    resultItemID?: number;
    departureID?: number | null;
    optionID?: number;
    mandatory?: boolean;
}

export enum ETipoServizioSearch {
    Hotel = "Hotel",
    Visite = "Visite",
    Noleggi = "Noleggi",
    SelfDrive = "SelfDrive",
    Tour = "Tour",
    Unknown = "Unknown",
    Pacchetti = "Pacchetti",
    Voli = "Voli",
    ItinerariConsigliati = "ItinerariConsigliati",
    Traghetti = "Traghetti",
}

export class DisponibilitaSupplemento implements IDisponibilitaSupplemento {
    isObbligatorio?: boolean;
    percentuale?: boolean;
    alternative?: DisponibilitaTipologia[] | null;

    constructor(data?: IDisponibilitaSupplemento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isObbligatorio = _data["isObbligatorio"] !== undefined ? _data["isObbligatorio"] : <any>null;
            this.percentuale = _data["percentuale"] !== undefined ? _data["percentuale"] : <any>null;
            if (Array.isArray(_data["alternative"])) {
                this.alternative = [] as any;
                for (let item of _data["alternative"])
                    this.alternative!.push(DisponibilitaTipologia.fromJS(item));
            }
            else {
                this.alternative = <any>null;
            }
        }
    }

    static fromJS(data: any): DisponibilitaSupplemento {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaSupplemento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isObbligatorio"] = this.isObbligatorio !== undefined ? this.isObbligatorio : <any>null;
        data["percentuale"] = this.percentuale !== undefined ? this.percentuale : <any>null;
        if (Array.isArray(this.alternative)) {
            data["alternative"] = [];
            for (let item of this.alternative)
                data["alternative"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDisponibilitaSupplemento {
    isObbligatorio?: boolean;
    percentuale?: boolean;
    alternative?: DisponibilitaTipologia[] | null;
}

export class DisponibilitaTipologia implements IDisponibilitaTipologia {
    id?: number;
    prenotabile?: boolean;
    messaggioPrenotabile?: string | null;
    resultItemID?: number;
    accordoID?: number;
    servizioFornitoreID?: number;
    gruppoID?: number;
    servizioTipologiaID?: number | null;
    trattamentoID?: number | null;
    codTipologiaServizio?: string | null;
    codPrenotazione?: string | null;
    descrizione?: string | null;
    descrizioneTipologia?: string | null;
    statoDisponibilita?: EStatoDisponibilita;
    tabAllotmentID?: number | null;
    costi?: DisponibilitaTipologiaCosto[] | null;
    supplementi?: DisponibilitaSupplemento[] | null;
    partenze?: DisponibilitaPartenza[] | null;
    penaleID?: number;
    providerCustomData?: string | null;
    descrizioneFornitore?: string | null;
    codiceMappingGenerico?: string | null;
    notRefundable?: boolean;
    instantPurchase?: boolean;
    weddingRate?: boolean;
    tabellaCostoID?: number;
    descrizioneTabellaCosto?: string | null;
    resultID?: number;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    nota?: string | null;
    prezzoAdulti?: number;
    prezzoBambini?: number;
    descrizioneID?: number | null;
    dataPenale?: string | null;
    importoPenale?: number | null;
    articoloPenaleID?: number | null;
    tariffeMezzaDoppia?: TariffaMezzaDoppia[] | null;
    prezziGiorniPax?: PrezzoGiornoPax[] | null;
    beddignCalcolatoID?: number | null;
    regolaVenditaPenaleID?: number | null;
    hashcodeID?: number | null;
    bedsID?: number | null;
    mealID?: number | null;
    regolaVenditaID?: number | null;
    descrizioneTariffa?: string | null;
    fullContent?: boolean;
    nomeAccordo?: string | null;
    accordoFisso?: boolean;
    prezzoTotaleDebug?: number;
    costoTotale?: number;
    markup?: number | null;
    trattamento?: string | null;

    constructor(data?: IDisponibilitaTipologia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.prenotabile = _data["prenotabile"] !== undefined ? _data["prenotabile"] : <any>null;
            this.messaggioPrenotabile = _data["messaggioPrenotabile"] !== undefined ? _data["messaggioPrenotabile"] : <any>null;
            this.resultItemID = _data["resultItemID"] !== undefined ? _data["resultItemID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.servizioFornitoreID = _data["servizioFornitoreID"] !== undefined ? _data["servizioFornitoreID"] : <any>null;
            this.gruppoID = _data["gruppoID"] !== undefined ? _data["gruppoID"] : <any>null;
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
            this.codTipologiaServizio = _data["codTipologiaServizio"] !== undefined ? _data["codTipologiaServizio"] : <any>null;
            this.codPrenotazione = _data["codPrenotazione"] !== undefined ? _data["codPrenotazione"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.descrizioneTipologia = _data["descrizioneTipologia"] !== undefined ? _data["descrizioneTipologia"] : <any>null;
            this.statoDisponibilita = _data["statoDisponibilita"] !== undefined ? _data["statoDisponibilita"] : <any>null;
            this.tabAllotmentID = _data["tabAllotmentID"] !== undefined ? _data["tabAllotmentID"] : <any>null;
            if (Array.isArray(_data["costi"])) {
                this.costi = [] as any;
                for (let item of _data["costi"])
                    this.costi!.push(DisponibilitaTipologiaCosto.fromJS(item));
            }
            else {
                this.costi = <any>null;
            }
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(DisponibilitaSupplemento.fromJS(item));
            }
            else {
                this.supplementi = <any>null;
            }
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(DisponibilitaPartenza.fromJS(item));
            }
            else {
                this.partenze = <any>null;
            }
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : <any>null;
            this.providerCustomData = _data["providerCustomData"] !== undefined ? _data["providerCustomData"] : <any>null;
            this.descrizioneFornitore = _data["descrizioneFornitore"] !== undefined ? _data["descrizioneFornitore"] : <any>null;
            this.codiceMappingGenerico = _data["codiceMappingGenerico"] !== undefined ? _data["codiceMappingGenerico"] : <any>null;
            this.notRefundable = _data["notRefundable"] !== undefined ? _data["notRefundable"] : <any>null;
            this.instantPurchase = _data["instantPurchase"] !== undefined ? _data["instantPurchase"] : <any>null;
            this.weddingRate = _data["weddingRate"] !== undefined ? _data["weddingRate"] : <any>null;
            this.tabellaCostoID = _data["tabellaCostoID"] !== undefined ? _data["tabellaCostoID"] : <any>null;
            this.descrizioneTabellaCosto = _data["descrizioneTabellaCosto"] !== undefined ? _data["descrizioneTabellaCosto"] : <any>null;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : <any>null;
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(DisponibilitaTipologiaOfferta.fromJS(item));
            }
            else {
                this.offerte = <any>null;
            }
            this.nota = _data["nota"] !== undefined ? _data["nota"] : <any>null;
            this.prezzoAdulti = _data["prezzoAdulti"] !== undefined ? _data["prezzoAdulti"] : <any>null;
            this.prezzoBambini = _data["prezzoBambini"] !== undefined ? _data["prezzoBambini"] : <any>null;
            this.descrizioneID = _data["descrizioneID"] !== undefined ? _data["descrizioneID"] : <any>null;
            this.dataPenale = _data["dataPenale"] !== undefined ? _data["dataPenale"] : <any>null;
            this.importoPenale = _data["importoPenale"] !== undefined ? _data["importoPenale"] : <any>null;
            this.articoloPenaleID = _data["articoloPenaleID"] !== undefined ? _data["articoloPenaleID"] : <any>null;
            if (Array.isArray(_data["tariffeMezzaDoppia"])) {
                this.tariffeMezzaDoppia = [] as any;
                for (let item of _data["tariffeMezzaDoppia"])
                    this.tariffeMezzaDoppia!.push(TariffaMezzaDoppia.fromJS(item));
            }
            else {
                this.tariffeMezzaDoppia = <any>null;
            }
            if (Array.isArray(_data["prezziGiorniPax"])) {
                this.prezziGiorniPax = [] as any;
                for (let item of _data["prezziGiorniPax"])
                    this.prezziGiorniPax!.push(PrezzoGiornoPax.fromJS(item));
            }
            else {
                this.prezziGiorniPax = <any>null;
            }
            this.beddignCalcolatoID = _data["beddignCalcolatoID"] !== undefined ? _data["beddignCalcolatoID"] : <any>null;
            this.regolaVenditaPenaleID = _data["regolaVenditaPenaleID"] !== undefined ? _data["regolaVenditaPenaleID"] : <any>null;
            this.hashcodeID = _data["hashcodeID"] !== undefined ? _data["hashcodeID"] : <any>null;
            this.bedsID = _data["bedsID"] !== undefined ? _data["bedsID"] : <any>null;
            this.mealID = _data["mealID"] !== undefined ? _data["mealID"] : <any>null;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : <any>null;
            this.descrizioneTariffa = _data["descrizioneTariffa"] !== undefined ? _data["descrizioneTariffa"] : <any>null;
            this.fullContent = _data["fullContent"] !== undefined ? _data["fullContent"] : <any>null;
            this.nomeAccordo = _data["nomeAccordo"] !== undefined ? _data["nomeAccordo"] : <any>null;
            this.accordoFisso = _data["accordoFisso"] !== undefined ? _data["accordoFisso"] : <any>null;
            this.prezzoTotaleDebug = _data["prezzoTotaleDebug"] !== undefined ? _data["prezzoTotaleDebug"] : <any>null;
            this.costoTotale = _data["costoTotale"] !== undefined ? _data["costoTotale"] : <any>null;
            this.markup = _data["markup"] !== undefined ? _data["markup"] : <any>null;
            this.trattamento = _data["trattamento"] !== undefined ? _data["trattamento"] : <any>null;
        }
    }

    static fromJS(data: any): DisponibilitaTipologia {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaTipologia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["prenotabile"] = this.prenotabile !== undefined ? this.prenotabile : <any>null;
        data["messaggioPrenotabile"] = this.messaggioPrenotabile !== undefined ? this.messaggioPrenotabile : <any>null;
        data["resultItemID"] = this.resultItemID !== undefined ? this.resultItemID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["servizioFornitoreID"] = this.servizioFornitoreID !== undefined ? this.servizioFornitoreID : <any>null;
        data["gruppoID"] = this.gruppoID !== undefined ? this.gruppoID : <any>null;
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        data["codTipologiaServizio"] = this.codTipologiaServizio !== undefined ? this.codTipologiaServizio : <any>null;
        data["codPrenotazione"] = this.codPrenotazione !== undefined ? this.codPrenotazione : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["descrizioneTipologia"] = this.descrizioneTipologia !== undefined ? this.descrizioneTipologia : <any>null;
        data["statoDisponibilita"] = this.statoDisponibilita !== undefined ? this.statoDisponibilita : <any>null;
        data["tabAllotmentID"] = this.tabAllotmentID !== undefined ? this.tabAllotmentID : <any>null;
        if (Array.isArray(this.costi)) {
            data["costi"] = [];
            for (let item of this.costi)
                data["costi"].push(item.toJSON());
        }
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item.toJSON());
        }
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item.toJSON());
        }
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : <any>null;
        data["providerCustomData"] = this.providerCustomData !== undefined ? this.providerCustomData : <any>null;
        data["descrizioneFornitore"] = this.descrizioneFornitore !== undefined ? this.descrizioneFornitore : <any>null;
        data["codiceMappingGenerico"] = this.codiceMappingGenerico !== undefined ? this.codiceMappingGenerico : <any>null;
        data["notRefundable"] = this.notRefundable !== undefined ? this.notRefundable : <any>null;
        data["instantPurchase"] = this.instantPurchase !== undefined ? this.instantPurchase : <any>null;
        data["weddingRate"] = this.weddingRate !== undefined ? this.weddingRate : <any>null;
        data["tabellaCostoID"] = this.tabellaCostoID !== undefined ? this.tabellaCostoID : <any>null;
        data["descrizioneTabellaCosto"] = this.descrizioneTabellaCosto !== undefined ? this.descrizioneTabellaCosto : <any>null;
        data["resultID"] = this.resultID !== undefined ? this.resultID : <any>null;
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item.toJSON());
        }
        data["nota"] = this.nota !== undefined ? this.nota : <any>null;
        data["prezzoAdulti"] = this.prezzoAdulti !== undefined ? this.prezzoAdulti : <any>null;
        data["prezzoBambini"] = this.prezzoBambini !== undefined ? this.prezzoBambini : <any>null;
        data["descrizioneID"] = this.descrizioneID !== undefined ? this.descrizioneID : <any>null;
        data["dataPenale"] = this.dataPenale !== undefined ? this.dataPenale : <any>null;
        data["importoPenale"] = this.importoPenale !== undefined ? this.importoPenale : <any>null;
        data["articoloPenaleID"] = this.articoloPenaleID !== undefined ? this.articoloPenaleID : <any>null;
        if (Array.isArray(this.tariffeMezzaDoppia)) {
            data["tariffeMezzaDoppia"] = [];
            for (let item of this.tariffeMezzaDoppia)
                data["tariffeMezzaDoppia"].push(item.toJSON());
        }
        if (Array.isArray(this.prezziGiorniPax)) {
            data["prezziGiorniPax"] = [];
            for (let item of this.prezziGiorniPax)
                data["prezziGiorniPax"].push(item.toJSON());
        }
        data["beddignCalcolatoID"] = this.beddignCalcolatoID !== undefined ? this.beddignCalcolatoID : <any>null;
        data["regolaVenditaPenaleID"] = this.regolaVenditaPenaleID !== undefined ? this.regolaVenditaPenaleID : <any>null;
        data["hashcodeID"] = this.hashcodeID !== undefined ? this.hashcodeID : <any>null;
        data["bedsID"] = this.bedsID !== undefined ? this.bedsID : <any>null;
        data["mealID"] = this.mealID !== undefined ? this.mealID : <any>null;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : <any>null;
        data["descrizioneTariffa"] = this.descrizioneTariffa !== undefined ? this.descrizioneTariffa : <any>null;
        data["fullContent"] = this.fullContent !== undefined ? this.fullContent : <any>null;
        data["nomeAccordo"] = this.nomeAccordo !== undefined ? this.nomeAccordo : <any>null;
        data["accordoFisso"] = this.accordoFisso !== undefined ? this.accordoFisso : <any>null;
        data["prezzoTotaleDebug"] = this.prezzoTotaleDebug !== undefined ? this.prezzoTotaleDebug : <any>null;
        data["costoTotale"] = this.costoTotale !== undefined ? this.costoTotale : <any>null;
        data["markup"] = this.markup !== undefined ? this.markup : <any>null;
        data["trattamento"] = this.trattamento !== undefined ? this.trattamento : <any>null;
        return data;
    }
}

export interface IDisponibilitaTipologia {
    id?: number;
    prenotabile?: boolean;
    messaggioPrenotabile?: string | null;
    resultItemID?: number;
    accordoID?: number;
    servizioFornitoreID?: number;
    gruppoID?: number;
    servizioTipologiaID?: number | null;
    trattamentoID?: number | null;
    codTipologiaServizio?: string | null;
    codPrenotazione?: string | null;
    descrizione?: string | null;
    descrizioneTipologia?: string | null;
    statoDisponibilita?: EStatoDisponibilita;
    tabAllotmentID?: number | null;
    costi?: DisponibilitaTipologiaCosto[] | null;
    supplementi?: DisponibilitaSupplemento[] | null;
    partenze?: DisponibilitaPartenza[] | null;
    penaleID?: number;
    providerCustomData?: string | null;
    descrizioneFornitore?: string | null;
    codiceMappingGenerico?: string | null;
    notRefundable?: boolean;
    instantPurchase?: boolean;
    weddingRate?: boolean;
    tabellaCostoID?: number;
    descrizioneTabellaCosto?: string | null;
    resultID?: number;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    nota?: string | null;
    prezzoAdulti?: number;
    prezzoBambini?: number;
    descrizioneID?: number | null;
    dataPenale?: string | null;
    importoPenale?: number | null;
    articoloPenaleID?: number | null;
    tariffeMezzaDoppia?: TariffaMezzaDoppia[] | null;
    prezziGiorniPax?: PrezzoGiornoPax[] | null;
    beddignCalcolatoID?: number | null;
    regolaVenditaPenaleID?: number | null;
    hashcodeID?: number | null;
    bedsID?: number | null;
    mealID?: number | null;
    regolaVenditaID?: number | null;
    descrizioneTariffa?: string | null;
    fullContent?: boolean;
    nomeAccordo?: string | null;
    accordoFisso?: boolean;
    prezzoTotaleDebug?: number;
    costoTotale?: number;
    markup?: number | null;
    trattamento?: string | null;
}

export class DisponibilitaTipologiaCosto implements IDisponibilitaTipologiaCosto {
    viaggiatoreID?: number;
    name?: string | null;
    prezzo?: number | null;
    costo?: number;
    costoID?: number;
    numPersone?: number;
    maxEta?: number;
    tipoPax?: ETipoPax;

    constructor(data?: IDisponibilitaTipologiaCosto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.viaggiatoreID = _data["viaggiatoreID"] !== undefined ? _data["viaggiatoreID"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : <any>null;
            this.costoID = _data["costoID"] !== undefined ? _data["costoID"] : <any>null;
            this.numPersone = _data["numPersone"] !== undefined ? _data["numPersone"] : <any>null;
            this.maxEta = _data["maxEta"] !== undefined ? _data["maxEta"] : <any>null;
            this.tipoPax = _data["tipoPax"] !== undefined ? _data["tipoPax"] : <any>null;
        }
    }

    static fromJS(data: any): DisponibilitaTipologiaCosto {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaTipologiaCosto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viaggiatoreID"] = this.viaggiatoreID !== undefined ? this.viaggiatoreID : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["costo"] = this.costo !== undefined ? this.costo : <any>null;
        data["costoID"] = this.costoID !== undefined ? this.costoID : <any>null;
        data["numPersone"] = this.numPersone !== undefined ? this.numPersone : <any>null;
        data["maxEta"] = this.maxEta !== undefined ? this.maxEta : <any>null;
        data["tipoPax"] = this.tipoPax !== undefined ? this.tipoPax : <any>null;
        return data;
    }
}

export interface IDisponibilitaTipologiaCosto {
    viaggiatoreID?: number;
    name?: string | null;
    prezzo?: number | null;
    costo?: number;
    costoID?: number;
    numPersone?: number;
    maxEta?: number;
    tipoPax?: ETipoPax;
}

export class DisponibilitaPartenza implements IDisponibilitaPartenza {
    referenceID?: number;
    partenza?: string;
    costi?: DisponibilitaTipologiaCosto[] | null;
    prezzoAdulti?: number;
    prezzoBambini?: number;
    statoDisponibilita?: EStatoDisponibilita;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    supplementi?: DisponibilitaSupplemento[] | null;
    penaleID?: number | null;
    dataPenale?: string | null;
    importoPenale?: number | null;
    articoloPenaleID?: number | null;
    tariffeMezzaDoppia?: TariffaMezzaDoppia[] | null;
    prezziGiorniPax?: PrezzoGiornoPax[] | null;
    beddignCalcolatoID?: number | null;
    regolaVenditaPenaleID?: number | null;

    constructor(data?: IDisponibilitaPartenza) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceID = _data["referenceID"] !== undefined ? _data["referenceID"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            if (Array.isArray(_data["costi"])) {
                this.costi = [] as any;
                for (let item of _data["costi"])
                    this.costi!.push(DisponibilitaTipologiaCosto.fromJS(item));
            }
            else {
                this.costi = <any>null;
            }
            this.prezzoAdulti = _data["prezzoAdulti"] !== undefined ? _data["prezzoAdulti"] : <any>null;
            this.prezzoBambini = _data["prezzoBambini"] !== undefined ? _data["prezzoBambini"] : <any>null;
            this.statoDisponibilita = _data["statoDisponibilita"] !== undefined ? _data["statoDisponibilita"] : <any>null;
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(DisponibilitaTipologiaOfferta.fromJS(item));
            }
            else {
                this.offerte = <any>null;
            }
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(DisponibilitaSupplemento.fromJS(item));
            }
            else {
                this.supplementi = <any>null;
            }
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : <any>null;
            this.dataPenale = _data["dataPenale"] !== undefined ? _data["dataPenale"] : <any>null;
            this.importoPenale = _data["importoPenale"] !== undefined ? _data["importoPenale"] : <any>null;
            this.articoloPenaleID = _data["articoloPenaleID"] !== undefined ? _data["articoloPenaleID"] : <any>null;
            if (Array.isArray(_data["tariffeMezzaDoppia"])) {
                this.tariffeMezzaDoppia = [] as any;
                for (let item of _data["tariffeMezzaDoppia"])
                    this.tariffeMezzaDoppia!.push(TariffaMezzaDoppia.fromJS(item));
            }
            else {
                this.tariffeMezzaDoppia = <any>null;
            }
            if (Array.isArray(_data["prezziGiorniPax"])) {
                this.prezziGiorniPax = [] as any;
                for (let item of _data["prezziGiorniPax"])
                    this.prezziGiorniPax!.push(PrezzoGiornoPax.fromJS(item));
            }
            else {
                this.prezziGiorniPax = <any>null;
            }
            this.beddignCalcolatoID = _data["beddignCalcolatoID"] !== undefined ? _data["beddignCalcolatoID"] : <any>null;
            this.regolaVenditaPenaleID = _data["regolaVenditaPenaleID"] !== undefined ? _data["regolaVenditaPenaleID"] : <any>null;
        }
    }

    static fromJS(data: any): DisponibilitaPartenza {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaPartenza();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceID"] = this.referenceID !== undefined ? this.referenceID : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        if (Array.isArray(this.costi)) {
            data["costi"] = [];
            for (let item of this.costi)
                data["costi"].push(item.toJSON());
        }
        data["prezzoAdulti"] = this.prezzoAdulti !== undefined ? this.prezzoAdulti : <any>null;
        data["prezzoBambini"] = this.prezzoBambini !== undefined ? this.prezzoBambini : <any>null;
        data["statoDisponibilita"] = this.statoDisponibilita !== undefined ? this.statoDisponibilita : <any>null;
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item.toJSON());
        }
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item.toJSON());
        }
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : <any>null;
        data["dataPenale"] = this.dataPenale !== undefined ? this.dataPenale : <any>null;
        data["importoPenale"] = this.importoPenale !== undefined ? this.importoPenale : <any>null;
        data["articoloPenaleID"] = this.articoloPenaleID !== undefined ? this.articoloPenaleID : <any>null;
        if (Array.isArray(this.tariffeMezzaDoppia)) {
            data["tariffeMezzaDoppia"] = [];
            for (let item of this.tariffeMezzaDoppia)
                data["tariffeMezzaDoppia"].push(item.toJSON());
        }
        if (Array.isArray(this.prezziGiorniPax)) {
            data["prezziGiorniPax"] = [];
            for (let item of this.prezziGiorniPax)
                data["prezziGiorniPax"].push(item.toJSON());
        }
        data["beddignCalcolatoID"] = this.beddignCalcolatoID !== undefined ? this.beddignCalcolatoID : <any>null;
        data["regolaVenditaPenaleID"] = this.regolaVenditaPenaleID !== undefined ? this.regolaVenditaPenaleID : <any>null;
        return data;
    }
}

export interface IDisponibilitaPartenza {
    referenceID?: number;
    partenza?: string;
    costi?: DisponibilitaTipologiaCosto[] | null;
    prezzoAdulti?: number;
    prezzoBambini?: number;
    statoDisponibilita?: EStatoDisponibilita;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    supplementi?: DisponibilitaSupplemento[] | null;
    penaleID?: number | null;
    dataPenale?: string | null;
    importoPenale?: number | null;
    articoloPenaleID?: number | null;
    tariffeMezzaDoppia?: TariffaMezzaDoppia[] | null;
    prezziGiorniPax?: PrezzoGiornoPax[] | null;
    beddignCalcolatoID?: number | null;
    regolaVenditaPenaleID?: number | null;
}

export class TariffaMezzaDoppia implements ITariffaMezzaDoppia {
    prezzo?: number;
    costo?: number;
    data?: string;

    constructor(data?: ITariffaMezzaDoppia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static fromJS(data: any): TariffaMezzaDoppia {
        data = typeof data === 'object' ? data : {};
        let result = new TariffaMezzaDoppia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["costo"] = this.costo !== undefined ? this.costo : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        return data;
    }
}

export interface ITariffaMezzaDoppia {
    prezzo?: number;
    costo?: number;
    data?: string;
}

export class PrezzoGiornoPax implements IPrezzoGiornoPax {
    paxID?: number;
    data?: string;
    prezzo?: number;
    costo?: number;
    regolaVenditaApplicata?: number | null;
    prezzoChild?: boolean;
    costoID?: number;

    constructor(data?: IPrezzoGiornoPax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paxID = _data["paxID"] !== undefined ? _data["paxID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : <any>null;
            this.regolaVenditaApplicata = _data["regolaVenditaApplicata"] !== undefined ? _data["regolaVenditaApplicata"] : <any>null;
            this.prezzoChild = _data["prezzoChild"] !== undefined ? _data["prezzoChild"] : <any>null;
            this.costoID = _data["costoID"] !== undefined ? _data["costoID"] : <any>null;
        }
    }

    static fromJS(data: any): PrezzoGiornoPax {
        data = typeof data === 'object' ? data : {};
        let result = new PrezzoGiornoPax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paxID"] = this.paxID !== undefined ? this.paxID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["costo"] = this.costo !== undefined ? this.costo : <any>null;
        data["regolaVenditaApplicata"] = this.regolaVenditaApplicata !== undefined ? this.regolaVenditaApplicata : <any>null;
        data["prezzoChild"] = this.prezzoChild !== undefined ? this.prezzoChild : <any>null;
        data["costoID"] = this.costoID !== undefined ? this.costoID : <any>null;
        return data;
    }
}

export interface IPrezzoGiornoPax {
    paxID?: number;
    data?: string;
    prezzo?: number;
    costo?: number;
    regolaVenditaApplicata?: number | null;
    prezzoChild?: boolean;
    costoID?: number;
}

export class Supplemento implements ISupplemento {
    id?: number;
    obbligatorio?: boolean;
    percentuale?: boolean;
    alternative?: SupplementoAlternativa[] | null;

    constructor(data?: ISupplemento) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.obbligatorio = _data["obbligatorio"] !== undefined ? _data["obbligatorio"] : <any>null;
            this.percentuale = _data["percentuale"] !== undefined ? _data["percentuale"] : <any>null;
            if (Array.isArray(_data["alternative"])) {
                this.alternative = [] as any;
                for (let item of _data["alternative"])
                    this.alternative!.push(SupplementoAlternativa.fromJS(item));
            }
            else {
                this.alternative = <any>null;
            }
        }
    }

    static fromJS(data: any): Supplemento {
        data = typeof data === 'object' ? data : {};
        let result = new Supplemento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["obbligatorio"] = this.obbligatorio !== undefined ? this.obbligatorio : <any>null;
        data["percentuale"] = this.percentuale !== undefined ? this.percentuale : <any>null;
        if (Array.isArray(this.alternative)) {
            data["alternative"] = [];
            for (let item of this.alternative)
                data["alternative"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISupplemento {
    id?: number;
    obbligatorio?: boolean;
    percentuale?: boolean;
    alternative?: SupplementoAlternativa[] | null;
}

export class SupplementoAlternativa implements ISupplementoAlternativa {
    id?: number;
    nome?: string;
    prezzoPieno?: number | null;
    prezzo?: number;
    prezzoIndicativo?: boolean;

    constructor(data?: ISupplementoAlternativa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.prezzoIndicativo = _data["prezzoIndicativo"] !== undefined ? _data["prezzoIndicativo"] : <any>null;
        }
    }

    static fromJS(data: any): SupplementoAlternativa {
        data = typeof data === 'object' ? data : {};
        let result = new SupplementoAlternativa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["prezzoIndicativo"] = this.prezzoIndicativo !== undefined ? this.prezzoIndicativo : <any>null;
        return data;
    }
}

export interface ISupplementoAlternativa {
    id?: number;
    nome?: string;
    prezzoPieno?: number | null;
    prezzo?: number;
    prezzoIndicativo?: boolean;
}

export class NaarCrypticPMIRequest extends LocalizedRequest implements INaarCrypticPMIRequest {
    /** ID dell'eventuale offerta, se non è un nuovo viaggio */
    offertaID?: number | null;
    jobID!: string;
    resultID!: string;
    serviceID!: number;
    typeID!: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;

    constructor(data?: INaarCrypticPMIRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : <any>null;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : <any>null;
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : <any>null;
            this.departureID = _data["departureID"] !== undefined ? _data["departureID"] : <any>null;
            this.optionID = _data["optionID"] !== undefined ? _data["optionID"] : <any>null;
            this.optionItemID = _data["optionItemID"] !== undefined ? _data["optionItemID"] : <any>null;
        }
    }

    static fromJS(data: any): NaarCrypticPMIRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarCrypticPMIRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["resultID"] = this.resultID !== undefined ? this.resultID : <any>null;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : <any>null;
        data["typeID"] = this.typeID !== undefined ? this.typeID : <any>null;
        data["departureID"] = this.departureID !== undefined ? this.departureID : <any>null;
        data["optionID"] = this.optionID !== undefined ? this.optionID : <any>null;
        data["optionItemID"] = this.optionItemID !== undefined ? this.optionItemID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarCrypticPMIRequest extends ILocalizedRequest {
    /** ID dell'eventuale offerta, se non è un nuovo viaggio */
    offertaID?: number | null;
    jobID: string;
    resultID: string;
    serviceID: number;
    typeID: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;
}

export class NaarCrypticExecuteResponse extends OkApiResponse implements INaarCrypticExecuteResponse {
    /** Se true il comando è stato eseguito con successo */
    success?: boolean;
    /** Stringa di risposta */
    responseString?: string;
    /** Se true è richiesto l'update del viaggio ID=TripID */
    tripRefreshRequired?: boolean;
    /** Eventuale ID di viaggio (corrente o creato) */
    tripID?: number | null;
    /** Eventuale lista degli warning */
    warnings?: string[];

    constructor(data?: INaarCrypticExecuteResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.responseString = _data["responseString"] !== undefined ? _data["responseString"] : <any>null;
            this.tripRefreshRequired = _data["tripRefreshRequired"] !== undefined ? _data["tripRefreshRequired"] : <any>null;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            else {
                this.warnings = <any>null;
            }
        }
    }

    static fromJS(data: any): NaarCrypticExecuteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarCrypticExecuteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["responseString"] = this.responseString !== undefined ? this.responseString : <any>null;
        data["tripRefreshRequired"] = this.tripRefreshRequired !== undefined ? this.tripRefreshRequired : <any>null;
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface INaarCrypticExecuteResponse extends IOkApiResponse {
    /** Se true il comando è stato eseguito con successo */
    success?: boolean;
    /** Stringa di risposta */
    responseString?: string;
    /** Se true è richiesto l'update del viaggio ID=TripID */
    tripRefreshRequired?: boolean;
    /** Eventuale ID di viaggio (corrente o creato) */
    tripID?: number | null;
    /** Eventuale lista degli warning */
    warnings?: string[];
}

export class NaarCrypticExecuteRequest extends LocalizedRequest implements INaarCrypticExecuteRequest {
    /** ID del viaggio corrente, per comandi in contesto di viaggio */
    tripID?: number | null;
    /** Comando da eseguire */
    command?: string;
    /** Argomenti */
    args?: string | null;

    constructor(data?: INaarCrypticExecuteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
            this.command = _data["command"] !== undefined ? _data["command"] : <any>null;
            this.args = _data["args"] !== undefined ? _data["args"] : <any>null;
        }
    }

    static fromJS(data: any): NaarCrypticExecuteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarCrypticExecuteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        data["command"] = this.command !== undefined ? this.command : <any>null;
        data["args"] = this.args !== undefined ? this.args : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarCrypticExecuteRequest extends ILocalizedRequest {
    /** ID del viaggio corrente, per comandi in contesto di viaggio */
    tripID?: number | null;
    /** Comando da eseguire */
    command?: string;
    /** Argomenti */
    args?: string | null;
}

export class GetAgreementsResponse extends OkApiResponse implements IGetAgreementsResponse {
    defaultAgreement?: number;
    agreements?: AgreementItem[] | null;

    constructor(data?: IGetAgreementsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.defaultAgreement = _data["defaultAgreement"] !== undefined ? _data["defaultAgreement"] : <any>null;
            if (Array.isArray(_data["agreements"])) {
                this.agreements = [] as any;
                for (let item of _data["agreements"])
                    this.agreements!.push(AgreementItem.fromJS(item));
            }
            else {
                this.agreements = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAgreementsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgreementsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultAgreement"] = this.defaultAgreement !== undefined ? this.defaultAgreement : <any>null;
        if (Array.isArray(this.agreements)) {
            data["agreements"] = [];
            for (let item of this.agreements)
                data["agreements"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAgreementsResponse extends IOkApiResponse {
    defaultAgreement?: number;
    agreements?: AgreementItem[] | null;
}

export class AgreementItem implements IAgreementItem {
    id?: number;
    name?: string | null;

    constructor(data?: IAgreementItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): AgreementItem {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IAgreementItem {
    id?: number;
    name?: string | null;
}

export class GetAmadeusMarketsResponse extends OkApiResponse implements IGetAmadeusMarketsResponse {
    markets?: CrypticMarket[] | null;

    constructor(data?: IGetAmadeusMarketsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["markets"])) {
                this.markets = [] as any;
                for (let item of _data["markets"])
                    this.markets!.push(CrypticMarket.fromJS(item));
            }
            else {
                this.markets = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAmadeusMarketsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAmadeusMarketsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.markets)) {
            data["markets"] = [];
            for (let item of this.markets)
                data["markets"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAmadeusMarketsResponse extends IOkApiResponse {
    markets?: CrypticMarket[] | null;
}

export class GetAmadeusMarketsRequest extends ApiRequest implements IGetAmadeusMarketsRequest {
    operator?: EOperatore | null;

    constructor(data?: IGetAmadeusMarketsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
        }
    }

    static fromJS(data: any): GetAmadeusMarketsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAmadeusMarketsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAmadeusMarketsRequest extends IApiRequest {
    operator?: EOperatore | null;
}

export class GetPaymentTermsResponse extends OkApiResponse implements IGetPaymentTermsResponse {
    defaultPaymentTerm?: number;
    paymentTerms?: PaymentTermItem[] | null;

    constructor(data?: IGetPaymentTermsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.defaultPaymentTerm = _data["defaultPaymentTerm"] !== undefined ? _data["defaultPaymentTerm"] : <any>null;
            if (Array.isArray(_data["paymentTerms"])) {
                this.paymentTerms = [] as any;
                for (let item of _data["paymentTerms"])
                    this.paymentTerms!.push(PaymentTermItem.fromJS(item));
            }
            else {
                this.paymentTerms = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPaymentTermsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentTermsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultPaymentTerm"] = this.defaultPaymentTerm !== undefined ? this.defaultPaymentTerm : <any>null;
        if (Array.isArray(this.paymentTerms)) {
            data["paymentTerms"] = [];
            for (let item of this.paymentTerms)
                data["paymentTerms"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPaymentTermsResponse extends IOkApiResponse {
    defaultPaymentTerm?: number;
    paymentTerms?: PaymentTermItem[] | null;
}

export class PaymentTermItem implements IPaymentTermItem {
    id?: number;
    name?: string | null;

    constructor(data?: IPaymentTermItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentTermItem {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IPaymentTermItem {
    id?: number;
    name?: string | null;
}

export class NaarGoFileUploadResponse extends OkApiResponse implements INaarGoFileUploadResponse {
    guid?: string | null;

    constructor(data?: INaarGoFileUploadResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
        }
    }

    static fromJS(data: any): NaarGoFileUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoFileUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoFileUploadResponse extends IOkApiResponse {
    guid?: string | null;
}

export class NaarGoFileDownloadResponse extends OkApiResponse implements INaarGoFileDownloadResponse {
    bytes?: string | null;

    constructor(data?: INaarGoFileDownloadResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.bytes = _data["bytes"] !== undefined ? _data["bytes"] : <any>null;
        }
    }

    static fromJS(data: any): NaarGoFileDownloadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoFileDownloadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bytes"] = this.bytes !== undefined ? this.bytes : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoFileDownloadResponse extends IOkApiResponse {
    bytes?: string | null;
}

export class NaarGoFileDownloadRequest extends ApiRequest implements INaarGoFileDownloadRequest {
    threadId?: string | null;
    guid?: string | null;
    getPreview?: boolean;

    constructor(data?: INaarGoFileDownloadRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.threadId = _data["threadId"] !== undefined ? _data["threadId"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.getPreview = _data["getPreview"] !== undefined ? _data["getPreview"] : <any>null;
        }
    }

    static fromJS(data: any): NaarGoFileDownloadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoFileDownloadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["threadId"] = this.threadId !== undefined ? this.threadId : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["getPreview"] = this.getPreview !== undefined ? this.getPreview : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoFileDownloadRequest extends IApiRequest {
    threadId?: string | null;
    guid?: string | null;
    getPreview?: boolean;
}

export class NaarGoGetSystemResponse extends OkApiResponse implements INaarGoGetSystemResponse {
    system?: NaarGoUserRow | null;

    constructor(data?: INaarGoGetSystemResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.system = _data["system"] ? NaarGoUserRow.fromJS(_data["system"]) : <any>null;
        }
    }

    static fromJS(data: any): NaarGoGetSystemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoGetSystemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["system"] = this.system ? this.system.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoGetSystemResponse extends IOkApiResponse {
    system?: NaarGoUserRow | null;
}

export class NaarGoUserRow implements INaarGoUserRow {
    id?: number;
    emailAddress?: string | null;
    name?: string | null;
    lastname?: string | null;
    role?: EUserRole;
    azureCSIdentity?: string | null;
    azureCSToken?: string | null;
    authToken?: string | null;
    language?: ELingua;
    intranetUserID?: number | null;
    lastAccess?: string | null;
    deletedDate?: string | null;

    constructor(data?: INaarGoUserRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.azureCSIdentity = _data["azureCSIdentity"] !== undefined ? _data["azureCSIdentity"] : <any>null;
            this.azureCSToken = _data["azureCSToken"] !== undefined ? _data["azureCSToken"] : <any>null;
            this.authToken = _data["authToken"] !== undefined ? _data["authToken"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.intranetUserID = _data["intranetUserID"] !== undefined ? _data["intranetUserID"] : <any>null;
            this.lastAccess = _data["lastAccess"] !== undefined ? _data["lastAccess"] : <any>null;
            this.deletedDate = _data["deletedDate"] !== undefined ? _data["deletedDate"] : <any>null;
        }
    }

    static fromJS(data: any): NaarGoUserRow {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoUserRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["lastname"] = this.lastname !== undefined ? this.lastname : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["azureCSIdentity"] = this.azureCSIdentity !== undefined ? this.azureCSIdentity : <any>null;
        data["azureCSToken"] = this.azureCSToken !== undefined ? this.azureCSToken : <any>null;
        data["authToken"] = this.authToken !== undefined ? this.authToken : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["intranetUserID"] = this.intranetUserID !== undefined ? this.intranetUserID : <any>null;
        data["lastAccess"] = this.lastAccess !== undefined ? this.lastAccess : <any>null;
        data["deletedDate"] = this.deletedDate !== undefined ? this.deletedDate : <any>null;
        return data;
    }
}

export interface INaarGoUserRow {
    id?: number;
    emailAddress?: string | null;
    name?: string | null;
    lastname?: string | null;
    role?: EUserRole;
    azureCSIdentity?: string | null;
    azureCSToken?: string | null;
    authToken?: string | null;
    language?: ELingua;
    intranetUserID?: number | null;
    lastAccess?: string | null;
    deletedDate?: string | null;
}

export enum EUserRole {
    User = "User",
    Admin = "Admin",
    System = "System",
}

export class NaarGoGetAdminsResponse extends OkApiResponse implements INaarGoGetAdminsResponse {
    admins?: NaarGoUserRow[] | null;

    constructor(data?: INaarGoGetAdminsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["admins"])) {
                this.admins = [] as any;
                for (let item of _data["admins"])
                    this.admins!.push(NaarGoUserRow.fromJS(item));
            }
            else {
                this.admins = <any>null;
            }
        }
    }

    static fromJS(data: any): NaarGoGetAdminsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoGetAdminsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.admins)) {
            data["admins"] = [];
            for (let item of this.admins)
                data["admins"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoGetAdminsResponse extends IOkApiResponse {
    admins?: NaarGoUserRow[] | null;
}

export class NaarGoGetUserResponse extends OkApiResponse implements INaarGoGetUserResponse {
    user?: NaarGoUserRow | null;

    constructor(data?: INaarGoGetUserResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? NaarGoUserRow.fromJS(_data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): NaarGoGetUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoGetUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoGetUserResponse extends IOkApiResponse {
    user?: NaarGoUserRow | null;
}

export class NaarGoNotificationSubscribeRequest extends ApiRequest implements INaarGoNotificationSubscribeRequest {
    userId?: number;
    subscription?: PushSubscription | null;

    constructor(data?: INaarGoNotificationSubscribeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.subscription = _data["subscription"] ? PushSubscription.fromJS(_data["subscription"]) : <any>null;
        }
    }

    static fromJS(data: any): NaarGoNotificationSubscribeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoNotificationSubscribeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoNotificationSubscribeRequest extends IApiRequest {
    userId?: number;
    subscription?: PushSubscription | null;
}

export class PushSubscription implements IPushSubscription {
    endpoint?: string | null;
    p256DH?: string | null;
    auth?: string | null;

    constructor(data?: IPushSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"] !== undefined ? _data["endpoint"] : <any>null;
            this.p256DH = _data["p256DH"] !== undefined ? _data["p256DH"] : <any>null;
            this.auth = _data["auth"] !== undefined ? _data["auth"] : <any>null;
        }
    }

    static fromJS(data: any): PushSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new PushSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint !== undefined ? this.endpoint : <any>null;
        data["p256DH"] = this.p256DH !== undefined ? this.p256DH : <any>null;
        data["auth"] = this.auth !== undefined ? this.auth : <any>null;
        return data;
    }
}

export interface IPushSubscription {
    endpoint?: string | null;
    p256DH?: string | null;
    auth?: string | null;
}

export class NaarGoNotificationUnsubscribeRequest extends ApiRequest implements INaarGoNotificationUnsubscribeRequest {
    userId?: number;

    constructor(data?: INaarGoNotificationUnsubscribeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): NaarGoNotificationUnsubscribeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaarGoNotificationUnsubscribeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INaarGoNotificationUnsubscribeRequest extends IApiRequest {
    userId?: number;
}

export class NrTableResponseOfOperatoreListRow extends OkApiResponse implements INrTableResponseOfOperatoreListRow {
    /** Array delle righe della pagina richiesta */
    rows?: OperatoreListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfOperatoreListRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(OperatoreListRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfOperatoreListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfOperatoreListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfOperatoreListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: OperatoreListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class OperatoriListResponse extends NrTableResponseOfOperatoreListRow implements IOperatoriListResponse {

    constructor(data?: IOperatoriListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): OperatoriListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OperatoriListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOperatoriListResponse extends INrTableResponseOfOperatoreListRow {
}

export class OperatoreListRow implements IOperatoreListRow {
    /** ID dell'operatore */
    id?: number;
    /** Nome interno */
    nome?: string;
    /** Nome visualizzato */
    nomeVisualizzato?: string | null;
    /** Contatto di riferimento */
    contatto?: string;
    /** Valuta utilizzata */
    valuta?: string;

    constructor(data?: IOperatoreListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : <any>null;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : <any>null;
            this.valuta = _data["valuta"] !== undefined ? _data["valuta"] : <any>null;
        }
    }

    static fromJS(data: any): OperatoreListRow {
        data = typeof data === 'object' ? data : {};
        let result = new OperatoreListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : <any>null;
        data["contatto"] = this.contatto !== undefined ? this.contatto : <any>null;
        data["valuta"] = this.valuta !== undefined ? this.valuta : <any>null;
        return data;
    }
}

export interface IOperatoreListRow {
    /** ID dell'operatore */
    id?: number;
    /** Nome interno */
    nome?: string;
    /** Nome visualizzato */
    nomeVisualizzato?: string | null;
    /** Contatto di riferimento */
    contatto?: string;
    /** Valuta utilizzata */
    valuta?: string;
}

export class OperatoriListRequest extends NrTableRequest implements IOperatoriListRequest {
    /** Termine di ricerca oppure ID */
    term?: string | null;

    constructor(data?: IOperatoriListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
        }
    }

    static fromJS(data: any): OperatoriListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OperatoriListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IOperatoriListRequest extends INrTableRequest {
    /** Termine di ricerca oppure ID */
    term?: string | null;
}

export class OptimizeRequest extends ApiRequest implements IOptimizeRequest {
    /** Offerta singola, tutto */
    offertaID?: number | null;
    /** Solo righe appartenenti ad itinerario nel luogo scelto */
    luogoID?: number | null;
    /** Solo partenze dopo la data indicata (inclusa). In ogni caso dopo oggi */
    partenzaDal?: string | null;
    /** Solo partenze prima della data indicata (inclusa) */
    partenzaAl?: string | null;
    /** ID del contatto fornitore associato all'accordo */
    contattoFornitoreID?: number | null;
    /** Aolo se offerte confermate */
    soloConferme?: boolean;
    /** Se true aggiunge le ottimizzazioni a quelle eventualmente già presenti */
    appendToExisting?: boolean;
    /** Dati di testata */
    job?: OffertaDatoAlternativaJob | null;

    constructor(data?: IOptimizeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
            this.contattoFornitoreID = _data["contattoFornitoreID"] !== undefined ? _data["contattoFornitoreID"] : <any>null;
            this.soloConferme = _data["soloConferme"] !== undefined ? _data["soloConferme"] : <any>null;
            this.appendToExisting = _data["appendToExisting"] !== undefined ? _data["appendToExisting"] : <any>null;
            this.job = _data["job"] ? OffertaDatoAlternativaJob.fromJS(_data["job"]) : <any>null;
        }
    }

    static fromJS(data: any): OptimizeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OptimizeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        data["contattoFornitoreID"] = this.contattoFornitoreID !== undefined ? this.contattoFornitoreID : <any>null;
        data["soloConferme"] = this.soloConferme !== undefined ? this.soloConferme : <any>null;
        data["appendToExisting"] = this.appendToExisting !== undefined ? this.appendToExisting : <any>null;
        data["job"] = this.job ? this.job.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IOptimizeRequest extends IApiRequest {
    /** Offerta singola, tutto */
    offertaID?: number | null;
    /** Solo righe appartenenti ad itinerario nel luogo scelto */
    luogoID?: number | null;
    /** Solo partenze dopo la data indicata (inclusa). In ogni caso dopo oggi */
    partenzaDal?: string | null;
    /** Solo partenze prima della data indicata (inclusa) */
    partenzaAl?: string | null;
    /** ID del contatto fornitore associato all'accordo */
    contattoFornitoreID?: number | null;
    /** Aolo se offerte confermate */
    soloConferme?: boolean;
    /** Se true aggiunge le ottimizzazioni a quelle eventualmente già presenti */
    appendToExisting?: boolean;
    /** Dati di testata */
    job?: OffertaDatoAlternativaJob | null;
}

export class OffertaDatoAlternativaJob implements IOffertaDatoAlternativaJob {
    id?: number;
    alternativaID?: number;
    noFornitoreOriginale?: boolean;
    delta?: number;
    tipoDelta?: ETipoDeltaAlternativa;
    creato?: string;
    emailNotifica?: string | null;

    constructor(data?: IOffertaDatoAlternativaJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.alternativaID = _data["alternativaID"] !== undefined ? _data["alternativaID"] : <any>null;
            this.noFornitoreOriginale = _data["noFornitoreOriginale"] !== undefined ? _data["noFornitoreOriginale"] : <any>null;
            this.delta = _data["delta"] !== undefined ? _data["delta"] : <any>null;
            this.tipoDelta = _data["tipoDelta"] !== undefined ? _data["tipoDelta"] : <any>null;
            this.creato = _data["creato"] !== undefined ? _data["creato"] : <any>null;
            this.emailNotifica = _data["emailNotifica"] !== undefined ? _data["emailNotifica"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaDatoAlternativaJob {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDatoAlternativaJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["alternativaID"] = this.alternativaID !== undefined ? this.alternativaID : <any>null;
        data["noFornitoreOriginale"] = this.noFornitoreOriginale !== undefined ? this.noFornitoreOriginale : <any>null;
        data["delta"] = this.delta !== undefined ? this.delta : <any>null;
        data["tipoDelta"] = this.tipoDelta !== undefined ? this.tipoDelta : <any>null;
        data["creato"] = this.creato !== undefined ? this.creato : <any>null;
        data["emailNotifica"] = this.emailNotifica !== undefined ? this.emailNotifica : <any>null;
        return data;
    }
}

export interface IOffertaDatoAlternativaJob {
    id?: number;
    alternativaID?: number;
    noFornitoreOriginale?: boolean;
    delta?: number;
    tipoDelta?: ETipoDeltaAlternativa;
    creato?: string;
    emailNotifica?: string | null;
}

export enum ETipoDeltaAlternativa {
    PercentualePrezzo = "PercentualePrezzo",
    PercentualeCosto = "PercentualeCosto",
    PrezzoAssoluto = "PrezzoAssoluto",
    CostoAssoluto = "CostoAssoluto",
}

export class OptimizeDeleteMultiRequest extends ApiRequest implements IOptimizeDeleteMultiRequest {
    ids!: number[];

    constructor(data?: IOptimizeDeleteMultiRequest) {
        super(data);
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = <any>null;
            }
        }
    }

    static fromJS(data: any): OptimizeDeleteMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OptimizeDeleteMultiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOptimizeDeleteMultiRequest extends IApiRequest {
    ids: number[];
}

export class OptimizePreviewResponse extends OkApiResponse implements IOptimizePreviewResponse {
    righeTotali?: number;

    constructor(data?: IOptimizePreviewResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.righeTotali = _data["righeTotali"] !== undefined ? _data["righeTotali"] : <any>null;
        }
    }

    static fromJS(data: any): OptimizePreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OptimizePreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["righeTotali"] = this.righeTotali !== undefined ? this.righeTotali : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IOptimizePreviewResponse extends IOkApiResponse {
    righeTotali?: number;
}

export class OptimizationsQueryResponse extends OkApiResponse implements IOptimizationsQueryResponse {
    hasWork?: boolean;
    done?: number;
    total?: number;

    constructor(data?: IOptimizationsQueryResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasWork = _data["hasWork"] !== undefined ? _data["hasWork"] : <any>null;
            this.done = _data["done"] !== undefined ? _data["done"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): OptimizationsQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OptimizationsQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasWork"] = this.hasWork !== undefined ? this.hasWork : <any>null;
        data["done"] = this.done !== undefined ? this.done : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IOptimizationsQueryResponse extends IOkApiResponse {
    hasWork?: boolean;
    done?: number;
    total?: number;
}

export class SearchOrdersResponse extends OkApiResponse implements ISearchOrdersResponse {
    trips?: OrderListRow[];

    constructor(data?: ISearchOrdersResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["trips"])) {
                this.trips = [] as any;
                for (let item of _data["trips"])
                    this.trips!.push(OrderListRow.fromJS(item));
            }
            else {
                this.trips = <any>null;
            }
        }
    }

    static fromJS(data: any): SearchOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOrdersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trips)) {
            data["trips"] = [];
            for (let item of this.trips)
                data["trips"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISearchOrdersResponse extends IOkApiResponse {
    trips?: OrderListRow[];
}

export class OrderListRow implements IOrderListRow {
    offertaID?: number;
    descrizione?: string | null;
    clienti?: string | null;
    destinazione?: string | null;
    creazione?: string;
    partenza?: string;
    conferma?: string | null;
    totale?: number;
    agenzia?: string | null;
    telefono?: string | null;
    email?: string | null;
    categoriaAgenzia?: string | null;
    impiegato?: string | null;
    utentePreventivo?: string | null;
    utenteConferma?: string | null;
    annullataTO?: boolean;
    annullataADV?: boolean;
    sales?: string | null;
    pagamento?: string | null;
    saldato?: number;
    compensato?: number;
    saldare?: number;
    duplicabileAgenzia?: boolean;
    coverUrl?: string | null;

    constructor(data?: IOrderListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : <any>null;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : <any>null;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.categoriaAgenzia = _data["categoriaAgenzia"] !== undefined ? _data["categoriaAgenzia"] : <any>null;
            this.impiegato = _data["impiegato"] !== undefined ? _data["impiegato"] : <any>null;
            this.utentePreventivo = _data["utentePreventivo"] !== undefined ? _data["utentePreventivo"] : <any>null;
            this.utenteConferma = _data["utenteConferma"] !== undefined ? _data["utenteConferma"] : <any>null;
            this.annullataTO = _data["annullataTO"] !== undefined ? _data["annullataTO"] : <any>null;
            this.annullataADV = _data["annullataADV"] !== undefined ? _data["annullataADV"] : <any>null;
            this.sales = _data["sales"] !== undefined ? _data["sales"] : <any>null;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : <any>null;
            this.saldato = _data["saldato"] !== undefined ? _data["saldato"] : <any>null;
            this.compensato = _data["compensato"] !== undefined ? _data["compensato"] : <any>null;
            this.saldare = _data["saldare"] !== undefined ? _data["saldare"] : <any>null;
            this.duplicabileAgenzia = _data["duplicabileAgenzia"] !== undefined ? _data["duplicabileAgenzia"] : <any>null;
            this.coverUrl = _data["coverUrl"] !== undefined ? _data["coverUrl"] : <any>null;
        }
    }

    static fromJS(data: any): OrderListRow {
        data = typeof data === 'object' ? data : {};
        let result = new OrderListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["clienti"] = this.clienti !== undefined ? this.clienti : <any>null;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : <any>null;
        data["creazione"] = this.creazione !== undefined ? this.creazione : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["conferma"] = this.conferma !== undefined ? this.conferma : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["categoriaAgenzia"] = this.categoriaAgenzia !== undefined ? this.categoriaAgenzia : <any>null;
        data["impiegato"] = this.impiegato !== undefined ? this.impiegato : <any>null;
        data["utentePreventivo"] = this.utentePreventivo !== undefined ? this.utentePreventivo : <any>null;
        data["utenteConferma"] = this.utenteConferma !== undefined ? this.utenteConferma : <any>null;
        data["annullataTO"] = this.annullataTO !== undefined ? this.annullataTO : <any>null;
        data["annullataADV"] = this.annullataADV !== undefined ? this.annullataADV : <any>null;
        data["sales"] = this.sales !== undefined ? this.sales : <any>null;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : <any>null;
        data["saldato"] = this.saldato !== undefined ? this.saldato : <any>null;
        data["compensato"] = this.compensato !== undefined ? this.compensato : <any>null;
        data["saldare"] = this.saldare !== undefined ? this.saldare : <any>null;
        data["duplicabileAgenzia"] = this.duplicabileAgenzia !== undefined ? this.duplicabileAgenzia : <any>null;
        data["coverUrl"] = this.coverUrl !== undefined ? this.coverUrl : <any>null;
        return data;
    }
}

export interface IOrderListRow {
    offertaID?: number;
    descrizione?: string | null;
    clienti?: string | null;
    destinazione?: string | null;
    creazione?: string;
    partenza?: string;
    conferma?: string | null;
    totale?: number;
    agenzia?: string | null;
    telefono?: string | null;
    email?: string | null;
    categoriaAgenzia?: string | null;
    impiegato?: string | null;
    utentePreventivo?: string | null;
    utenteConferma?: string | null;
    annullataTO?: boolean;
    annullataADV?: boolean;
    sales?: string | null;
    pagamento?: string | null;
    saldato?: number;
    compensato?: number;
    saldare?: number;
    duplicabileAgenzia?: boolean;
    coverUrl?: string | null;
}

export class SearchOrdersRequest extends SiteRequest implements ISearchOrdersRequest {
    offertaID?: number | null;
    agenziaID?: number | null;
    impiegatoID?: number | null;
    soloUtente?: boolean;
    soloConfermate?: boolean;
    soloIncomplete?: boolean;
    soloAnnullate?: boolean;
    dataCreazione?: string | null;
    operatore?: EOperatore | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    confermaDal?: string | null;
    confermaAl?: string | null;
    descrizione?: string | null;
    nomePax?: string | null;
    servizioID?: number | null;
    partitaIva?: string | null;

    constructor(data?: ISearchOrdersRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : <any>null;
            this.impiegatoID = _data["impiegatoID"] !== undefined ? _data["impiegatoID"] : <any>null;
            this.soloUtente = _data["soloUtente"] !== undefined ? _data["soloUtente"] : <any>null;
            this.soloConfermate = _data["soloConfermate"] !== undefined ? _data["soloConfermate"] : <any>null;
            this.soloIncomplete = _data["soloIncomplete"] !== undefined ? _data["soloIncomplete"] : <any>null;
            this.soloAnnullate = _data["soloAnnullate"] !== undefined ? _data["soloAnnullate"] : <any>null;
            this.dataCreazione = _data["dataCreazione"] !== undefined ? _data["dataCreazione"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
            this.confermaDal = _data["confermaDal"] !== undefined ? _data["confermaDal"] : <any>null;
            this.confermaAl = _data["confermaAl"] !== undefined ? _data["confermaAl"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.nomePax = _data["nomePax"] !== undefined ? _data["nomePax"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.partitaIva = _data["partitaIva"] !== undefined ? _data["partitaIva"] : <any>null;
        }
    }

    static fromJS(data: any): SearchOrdersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOrdersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : <any>null;
        data["impiegatoID"] = this.impiegatoID !== undefined ? this.impiegatoID : <any>null;
        data["soloUtente"] = this.soloUtente !== undefined ? this.soloUtente : <any>null;
        data["soloConfermate"] = this.soloConfermate !== undefined ? this.soloConfermate : <any>null;
        data["soloIncomplete"] = this.soloIncomplete !== undefined ? this.soloIncomplete : <any>null;
        data["soloAnnullate"] = this.soloAnnullate !== undefined ? this.soloAnnullate : <any>null;
        data["dataCreazione"] = this.dataCreazione !== undefined ? this.dataCreazione : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        data["confermaDal"] = this.confermaDal !== undefined ? this.confermaDal : <any>null;
        data["confermaAl"] = this.confermaAl !== undefined ? this.confermaAl : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["nomePax"] = this.nomePax !== undefined ? this.nomePax : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["partitaIva"] = this.partitaIva !== undefined ? this.partitaIva : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchOrdersRequest extends ISiteRequest {
    offertaID?: number | null;
    agenziaID?: number | null;
    impiegatoID?: number | null;
    soloUtente?: boolean;
    soloConfermate?: boolean;
    soloIncomplete?: boolean;
    soloAnnullate?: boolean;
    dataCreazione?: string | null;
    operatore?: EOperatore | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    confermaDal?: string | null;
    confermaAl?: string | null;
    descrizione?: string | null;
    nomePax?: string | null;
    servizioID?: number | null;
    partitaIva?: string | null;
}

export class NrTableResponseOfConfirmSearchResponseRow extends OkApiResponse implements INrTableResponseOfConfirmSearchResponseRow {
    /** Array delle righe della pagina richiesta */
    rows?: ConfirmSearchResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfConfirmSearchResponseRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ConfirmSearchResponseRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfConfirmSearchResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfConfirmSearchResponseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfConfirmSearchResponseRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ConfirmSearchResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ConfirmSearchResponseRow implements IConfirmSearchResponseRow {
    offertaID?: number;
    offertaDatoID?: number;
    partenza?: string;
    conferma?: string | null;
    fornitore?: string | null;
    tipo?: ETipoServizio | null;
    servizio?: string | null;
    disponibilita?: EStatoDisponibilitaConferma;
    prenotazione?: string | null;
    confermaTO?: string | null;
    ottimizzataIl?: string | null;
    costoOttimizzato?: number | null;
    deltaOttimizzato?: number | null;
    deltaPositivo?: boolean;
    costoCorrente?: number;
    codiceValuta?: string | null;
    fornitoreOttimizzato?: string | null;
    descrizioneOttimizzato?: string | null;
    luogoID?: number | null;
    luogo?: string | null;
    abbinamentoID?: number;
    abbinamento?: string | null;
    luogoUrl?: string | null;
    stepID?: number;
    servizioID?: number | null;
    dal?: string;
    al?: string;
    canReplace?: boolean;
    numeroConfermaFornitore?: string | null;
    numeroConfermaNaar?: string | null;
    status?: EStatusServizio | null;

    constructor(data?: IConfirmSearchResponseRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : <any>null;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : <any>null;
            this.prenotazione = _data["prenotazione"] !== undefined ? _data["prenotazione"] : <any>null;
            this.confermaTO = _data["confermaTO"] !== undefined ? _data["confermaTO"] : <any>null;
            this.ottimizzataIl = _data["ottimizzataIl"] !== undefined ? _data["ottimizzataIl"] : <any>null;
            this.costoOttimizzato = _data["costoOttimizzato"] !== undefined ? _data["costoOttimizzato"] : <any>null;
            this.deltaOttimizzato = _data["deltaOttimizzato"] !== undefined ? _data["deltaOttimizzato"] : <any>null;
            this.deltaPositivo = _data["deltaPositivo"] !== undefined ? _data["deltaPositivo"] : <any>null;
            this.costoCorrente = _data["costoCorrente"] !== undefined ? _data["costoCorrente"] : <any>null;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : <any>null;
            this.fornitoreOttimizzato = _data["fornitoreOttimizzato"] !== undefined ? _data["fornitoreOttimizzato"] : <any>null;
            this.descrizioneOttimizzato = _data["descrizioneOttimizzato"] !== undefined ? _data["descrizioneOttimizzato"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : <any>null;
            this.abbinamento = _data["abbinamento"] !== undefined ? _data["abbinamento"] : <any>null;
            this.luogoUrl = _data["luogoUrl"] !== undefined ? _data["luogoUrl"] : <any>null;
            this.stepID = _data["stepID"] !== undefined ? _data["stepID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.canReplace = _data["canReplace"] !== undefined ? _data["canReplace"] : <any>null;
            this.numeroConfermaFornitore = _data["numeroConfermaFornitore"] !== undefined ? _data["numeroConfermaFornitore"] : <any>null;
            this.numeroConfermaNaar = _data["numeroConfermaNaar"] !== undefined ? _data["numeroConfermaNaar"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): ConfirmSearchResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmSearchResponseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["conferma"] = this.conferma !== undefined ? this.conferma : <any>null;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : <any>null;
        data["prenotazione"] = this.prenotazione !== undefined ? this.prenotazione : <any>null;
        data["confermaTO"] = this.confermaTO !== undefined ? this.confermaTO : <any>null;
        data["ottimizzataIl"] = this.ottimizzataIl !== undefined ? this.ottimizzataIl : <any>null;
        data["costoOttimizzato"] = this.costoOttimizzato !== undefined ? this.costoOttimizzato : <any>null;
        data["deltaOttimizzato"] = this.deltaOttimizzato !== undefined ? this.deltaOttimizzato : <any>null;
        data["deltaPositivo"] = this.deltaPositivo !== undefined ? this.deltaPositivo : <any>null;
        data["costoCorrente"] = this.costoCorrente !== undefined ? this.costoCorrente : <any>null;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : <any>null;
        data["fornitoreOttimizzato"] = this.fornitoreOttimizzato !== undefined ? this.fornitoreOttimizzato : <any>null;
        data["descrizioneOttimizzato"] = this.descrizioneOttimizzato !== undefined ? this.descrizioneOttimizzato : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : <any>null;
        data["abbinamento"] = this.abbinamento !== undefined ? this.abbinamento : <any>null;
        data["luogoUrl"] = this.luogoUrl !== undefined ? this.luogoUrl : <any>null;
        data["stepID"] = this.stepID !== undefined ? this.stepID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["canReplace"] = this.canReplace !== undefined ? this.canReplace : <any>null;
        data["numeroConfermaFornitore"] = this.numeroConfermaFornitore !== undefined ? this.numeroConfermaFornitore : <any>null;
        data["numeroConfermaNaar"] = this.numeroConfermaNaar !== undefined ? this.numeroConfermaNaar : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IConfirmSearchResponseRow {
    offertaID?: number;
    offertaDatoID?: number;
    partenza?: string;
    conferma?: string | null;
    fornitore?: string | null;
    tipo?: ETipoServizio | null;
    servizio?: string | null;
    disponibilita?: EStatoDisponibilitaConferma;
    prenotazione?: string | null;
    confermaTO?: string | null;
    ottimizzataIl?: string | null;
    costoOttimizzato?: number | null;
    deltaOttimizzato?: number | null;
    deltaPositivo?: boolean;
    costoCorrente?: number;
    codiceValuta?: string | null;
    fornitoreOttimizzato?: string | null;
    descrizioneOttimizzato?: string | null;
    luogoID?: number | null;
    luogo?: string | null;
    abbinamentoID?: number;
    abbinamento?: string | null;
    luogoUrl?: string | null;
    stepID?: number;
    servizioID?: number | null;
    dal?: string;
    al?: string;
    canReplace?: boolean;
    numeroConfermaFornitore?: string | null;
    numeroConfermaNaar?: string | null;
    status?: EStatusServizio | null;
}

export enum EStatoDisponibilitaConferma {
    NonDisponibile = "NonDisponibile",
    Cancellata = "Cancellata",
    Ok = "Ok",
    OkAllotment = "OkAllotment",
    OnRequestReg = "OnRequestReg",
    OnRequest = "OnRequest",
}

export class SearchConfirmsRequest extends NrTableRequest implements ISearchConfirmsRequest {
    operatore?: EOperatore;
    confermaDal?: string | null;
    confermaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    contattoFornitoreID?: number | null;
    status?: ConfirmSearchStatus | null;
    tipoServizio?: ETipoServizio | null;
    numeroConferma?: string | null;
    nascondiSeriviziAccessori?: boolean | null;

    constructor(data?: ISearchConfirmsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.confermaDal = _data["confermaDal"] !== undefined ? _data["confermaDal"] : <any>null;
            this.confermaAl = _data["confermaAl"] !== undefined ? _data["confermaAl"] : <any>null;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
            this.contattoFornitoreID = _data["contattoFornitoreID"] !== undefined ? _data["contattoFornitoreID"] : <any>null;
            this.status = _data["status"] ? ConfirmSearchStatus.fromJS(_data["status"]) : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.numeroConferma = _data["numeroConferma"] !== undefined ? _data["numeroConferma"] : <any>null;
            this.nascondiSeriviziAccessori = _data["nascondiSeriviziAccessori"] !== undefined ? _data["nascondiSeriviziAccessori"] : <any>null;
        }
    }

    static fromJS(data: any): SearchConfirmsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchConfirmsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["confermaDal"] = this.confermaDal !== undefined ? this.confermaDal : <any>null;
        data["confermaAl"] = this.confermaAl !== undefined ? this.confermaAl : <any>null;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        data["contattoFornitoreID"] = this.contattoFornitoreID !== undefined ? this.contattoFornitoreID : <any>null;
        data["status"] = this.status ? this.status.toJSON() : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["numeroConferma"] = this.numeroConferma !== undefined ? this.numeroConferma : <any>null;
        data["nascondiSeriviziAccessori"] = this.nascondiSeriviziAccessori !== undefined ? this.nascondiSeriviziAccessori : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchConfirmsRequest extends INrTableRequest {
    operatore?: EOperatore;
    confermaDal?: string | null;
    confermaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    contattoFornitoreID?: number | null;
    status?: ConfirmSearchStatus | null;
    tipoServizio?: ETipoServizio | null;
    numeroConferma?: string | null;
    nascondiSeriviziAccessori?: boolean | null;
}

export class ConfirmSearchStatus implements IConfirmSearchStatus {
    man?: boolean;
    pren?: boolean;
    inPren?: boolean;
    conf?: boolean;
    nonConf?: boolean;
    daCanc?: boolean;
    inCanc?: boolean;
    canc?: boolean;
    hasValue?: boolean;

    constructor(data?: IConfirmSearchStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.man = _data["man"] !== undefined ? _data["man"] : <any>null;
            this.pren = _data["pren"] !== undefined ? _data["pren"] : <any>null;
            this.inPren = _data["inPren"] !== undefined ? _data["inPren"] : <any>null;
            this.conf = _data["conf"] !== undefined ? _data["conf"] : <any>null;
            this.nonConf = _data["nonConf"] !== undefined ? _data["nonConf"] : <any>null;
            this.daCanc = _data["daCanc"] !== undefined ? _data["daCanc"] : <any>null;
            this.inCanc = _data["inCanc"] !== undefined ? _data["inCanc"] : <any>null;
            this.canc = _data["canc"] !== undefined ? _data["canc"] : <any>null;
            this.hasValue = _data["hasValue"] !== undefined ? _data["hasValue"] : <any>null;
        }
    }

    static fromJS(data: any): ConfirmSearchStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmSearchStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["man"] = this.man !== undefined ? this.man : <any>null;
        data["pren"] = this.pren !== undefined ? this.pren : <any>null;
        data["inPren"] = this.inPren !== undefined ? this.inPren : <any>null;
        data["conf"] = this.conf !== undefined ? this.conf : <any>null;
        data["nonConf"] = this.nonConf !== undefined ? this.nonConf : <any>null;
        data["daCanc"] = this.daCanc !== undefined ? this.daCanc : <any>null;
        data["inCanc"] = this.inCanc !== undefined ? this.inCanc : <any>null;
        data["canc"] = this.canc !== undefined ? this.canc : <any>null;
        data["hasValue"] = this.hasValue !== undefined ? this.hasValue : <any>null;
        return data;
    }
}

export interface IConfirmSearchStatus {
    man?: boolean;
    pren?: boolean;
    inPren?: boolean;
    conf?: boolean;
    nonConf?: boolean;
    daCanc?: boolean;
    inCanc?: boolean;
    canc?: boolean;
    hasValue?: boolean;
}

export class NrTableResponseOfSearchDocumentsResponseRow extends OkApiResponse implements INrTableResponseOfSearchDocumentsResponseRow {
    /** Array delle righe della pagina richiesta */
    rows?: SearchDocumentsResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSearchDocumentsResponseRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SearchDocumentsResponseRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfSearchDocumentsResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSearchDocumentsResponseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSearchDocumentsResponseRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SearchDocumentsResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SearchDocumentsResponseRow implements ISearchDocumentsResponseRow {
    offertaID?: number;
    operatore?: string | null;
    team?: string | null;
    adv?: string | null;
    dataPartenza?: string;
    dataConferma?: string | null;
    dataRientro?: string | null;
    dataRilascioDoc?: string | null;
    dest?: string | null;
    preventivo?: string | null;
    conferma?: string | null;
    documenti?: string | null;
    tipoQI?: string | null;
    pagamento?: string | null;
    statusDoc?: string | null;
    creaApp?: string | null;
    spedizione?: string | null;
    totNetto?: number | null;
    acconto?: number | null;
    dataAcconto?: string | null;
    saldo?: number | null;
    dataSaldo?: string | null;
    totale?: number | null;
    pax?: number | null;

    constructor(data?: ISearchDocumentsResponseRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.team = _data["team"] !== undefined ? _data["team"] : <any>null;
            this.adv = _data["adv"] !== undefined ? _data["adv"] : <any>null;
            this.dataPartenza = _data["dataPartenza"] !== undefined ? _data["dataPartenza"] : <any>null;
            this.dataConferma = _data["dataConferma"] !== undefined ? _data["dataConferma"] : <any>null;
            this.dataRientro = _data["dataRientro"] !== undefined ? _data["dataRientro"] : <any>null;
            this.dataRilascioDoc = _data["dataRilascioDoc"] !== undefined ? _data["dataRilascioDoc"] : <any>null;
            this.dest = _data["dest"] !== undefined ? _data["dest"] : <any>null;
            this.preventivo = _data["preventivo"] !== undefined ? _data["preventivo"] : <any>null;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : <any>null;
            this.documenti = _data["documenti"] !== undefined ? _data["documenti"] : <any>null;
            this.tipoQI = _data["tipoQI"] !== undefined ? _data["tipoQI"] : <any>null;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : <any>null;
            this.statusDoc = _data["statusDoc"] !== undefined ? _data["statusDoc"] : <any>null;
            this.creaApp = _data["creaApp"] !== undefined ? _data["creaApp"] : <any>null;
            this.spedizione = _data["spedizione"] !== undefined ? _data["spedizione"] : <any>null;
            this.totNetto = _data["totNetto"] !== undefined ? _data["totNetto"] : <any>null;
            this.acconto = _data["acconto"] !== undefined ? _data["acconto"] : <any>null;
            this.dataAcconto = _data["dataAcconto"] !== undefined ? _data["dataAcconto"] : <any>null;
            this.saldo = _data["saldo"] !== undefined ? _data["saldo"] : <any>null;
            this.dataSaldo = _data["dataSaldo"] !== undefined ? _data["dataSaldo"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.pax = _data["pax"] !== undefined ? _data["pax"] : <any>null;
        }
    }

    static fromJS(data: any): SearchDocumentsResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDocumentsResponseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["team"] = this.team !== undefined ? this.team : <any>null;
        data["adv"] = this.adv !== undefined ? this.adv : <any>null;
        data["dataPartenza"] = this.dataPartenza !== undefined ? this.dataPartenza : <any>null;
        data["dataConferma"] = this.dataConferma !== undefined ? this.dataConferma : <any>null;
        data["dataRientro"] = this.dataRientro !== undefined ? this.dataRientro : <any>null;
        data["dataRilascioDoc"] = this.dataRilascioDoc !== undefined ? this.dataRilascioDoc : <any>null;
        data["dest"] = this.dest !== undefined ? this.dest : <any>null;
        data["preventivo"] = this.preventivo !== undefined ? this.preventivo : <any>null;
        data["conferma"] = this.conferma !== undefined ? this.conferma : <any>null;
        data["documenti"] = this.documenti !== undefined ? this.documenti : <any>null;
        data["tipoQI"] = this.tipoQI !== undefined ? this.tipoQI : <any>null;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : <any>null;
        data["statusDoc"] = this.statusDoc !== undefined ? this.statusDoc : <any>null;
        data["creaApp"] = this.creaApp !== undefined ? this.creaApp : <any>null;
        data["spedizione"] = this.spedizione !== undefined ? this.spedizione : <any>null;
        data["totNetto"] = this.totNetto !== undefined ? this.totNetto : <any>null;
        data["acconto"] = this.acconto !== undefined ? this.acconto : <any>null;
        data["dataAcconto"] = this.dataAcconto !== undefined ? this.dataAcconto : <any>null;
        data["saldo"] = this.saldo !== undefined ? this.saldo : <any>null;
        data["dataSaldo"] = this.dataSaldo !== undefined ? this.dataSaldo : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["pax"] = this.pax !== undefined ? this.pax : <any>null;
        return data;
    }
}

export interface ISearchDocumentsResponseRow {
    offertaID?: number;
    operatore?: string | null;
    team?: string | null;
    adv?: string | null;
    dataPartenza?: string;
    dataConferma?: string | null;
    dataRientro?: string | null;
    dataRilascioDoc?: string | null;
    dest?: string | null;
    preventivo?: string | null;
    conferma?: string | null;
    documenti?: string | null;
    tipoQI?: string | null;
    pagamento?: string | null;
    statusDoc?: string | null;
    creaApp?: string | null;
    spedizione?: string | null;
    totNetto?: number | null;
    acconto?: number | null;
    dataAcconto?: string | null;
    saldo?: number | null;
    dataSaldo?: string | null;
    totale?: number | null;
    pax?: number | null;
}

export class SearchDocumentsRequest extends NrTableRequest implements ISearchDocumentsRequest {
    luoghi?: SearchDocumentsLuoghi | null;
    confermaDal?: string;
    confermaAl?: string;

    constructor(data?: ISearchDocumentsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luoghi = _data["luoghi"] ? SearchDocumentsLuoghi.fromJS(_data["luoghi"]) : <any>null;
            this.confermaDal = _data["confermaDal"] !== undefined ? _data["confermaDal"] : <any>null;
            this.confermaAl = _data["confermaAl"] !== undefined ? _data["confermaAl"] : <any>null;
        }
    }

    static fromJS(data: any): SearchDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luoghi"] = this.luoghi ? this.luoghi.toJSON() : <any>null;
        data["confermaDal"] = this.confermaDal !== undefined ? this.confermaDal : <any>null;
        data["confermaAl"] = this.confermaAl !== undefined ? this.confermaAl : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchDocumentsRequest extends INrTableRequest {
    luoghi?: SearchDocumentsLuoghi | null;
    confermaDal?: string;
    confermaAl?: string;
}

export class SearchDocumentsLuoghi implements ISearchDocumentsLuoghi {
    americhe?: boolean;
    caraibi?: boolean;
    sudPacifico?: boolean;
    ocIndiano?: boolean;
    australia?: boolean;
    oriente?: boolean;
    africa?: boolean;
    sE_Asia?: boolean;
    hasValue?: boolean;

    constructor(data?: ISearchDocumentsLuoghi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.americhe = _data["americhe"] !== undefined ? _data["americhe"] : <any>null;
            this.caraibi = _data["caraibi"] !== undefined ? _data["caraibi"] : <any>null;
            this.sudPacifico = _data["sudPacifico"] !== undefined ? _data["sudPacifico"] : <any>null;
            this.ocIndiano = _data["ocIndiano"] !== undefined ? _data["ocIndiano"] : <any>null;
            this.australia = _data["australia"] !== undefined ? _data["australia"] : <any>null;
            this.oriente = _data["oriente"] !== undefined ? _data["oriente"] : <any>null;
            this.africa = _data["africa"] !== undefined ? _data["africa"] : <any>null;
            this.sE_Asia = _data["sE_Asia"] !== undefined ? _data["sE_Asia"] : <any>null;
            this.hasValue = _data["hasValue"] !== undefined ? _data["hasValue"] : <any>null;
        }
    }

    static fromJS(data: any): SearchDocumentsLuoghi {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDocumentsLuoghi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["americhe"] = this.americhe !== undefined ? this.americhe : <any>null;
        data["caraibi"] = this.caraibi !== undefined ? this.caraibi : <any>null;
        data["sudPacifico"] = this.sudPacifico !== undefined ? this.sudPacifico : <any>null;
        data["ocIndiano"] = this.ocIndiano !== undefined ? this.ocIndiano : <any>null;
        data["australia"] = this.australia !== undefined ? this.australia : <any>null;
        data["oriente"] = this.oriente !== undefined ? this.oriente : <any>null;
        data["africa"] = this.africa !== undefined ? this.africa : <any>null;
        data["sE_Asia"] = this.sE_Asia !== undefined ? this.sE_Asia : <any>null;
        data["hasValue"] = this.hasValue !== undefined ? this.hasValue : <any>null;
        return data;
    }
}

export interface ISearchDocumentsLuoghi {
    americhe?: boolean;
    caraibi?: boolean;
    sudPacifico?: boolean;
    ocIndiano?: boolean;
    australia?: boolean;
    oriente?: boolean;
    africa?: boolean;
    sE_Asia?: boolean;
    hasValue?: boolean;
}

export class NrTableResponseOfSearchEmailsResponseRow extends OkApiResponse implements INrTableResponseOfSearchEmailsResponseRow {
    /** Array delle righe della pagina richiesta */
    rows?: SearchEmailsResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSearchEmailsResponseRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SearchEmailsResponseRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfSearchEmailsResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSearchEmailsResponseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSearchEmailsResponseRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SearchEmailsResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SearchEmailsResponseRow implements ISearchEmailsResponseRow {
    documentoID?: number;
    offertaID?: number;
    data?: string;
    testata?: string | null;
    corpo?: string | null;
    corpo2?: string | null;
    isEmailLink?: boolean;
    emailUrl?: string | null;
    urlAllegato?: string | null;
    nome?: string | null;
    nomeAllegato?: string | null;
    nomeContatto?: string | null;
    dimensioneAllegato?: number | null;
    spedito?: string | null;
    contatoreSpedizioni?: number | null;

    constructor(data?: ISearchEmailsResponseRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.testata = _data["testata"] !== undefined ? _data["testata"] : <any>null;
            this.corpo = _data["corpo"] !== undefined ? _data["corpo"] : <any>null;
            this.corpo2 = _data["corpo2"] !== undefined ? _data["corpo2"] : <any>null;
            this.isEmailLink = _data["isEmailLink"] !== undefined ? _data["isEmailLink"] : <any>null;
            this.emailUrl = _data["emailUrl"] !== undefined ? _data["emailUrl"] : <any>null;
            this.urlAllegato = _data["urlAllegato"] !== undefined ? _data["urlAllegato"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeAllegato = _data["nomeAllegato"] !== undefined ? _data["nomeAllegato"] : <any>null;
            this.nomeContatto = _data["nomeContatto"] !== undefined ? _data["nomeContatto"] : <any>null;
            this.dimensioneAllegato = _data["dimensioneAllegato"] !== undefined ? _data["dimensioneAllegato"] : <any>null;
            this.spedito = _data["spedito"] !== undefined ? _data["spedito"] : <any>null;
            this.contatoreSpedizioni = _data["contatoreSpedizioni"] !== undefined ? _data["contatoreSpedizioni"] : <any>null;
        }
    }

    static fromJS(data: any): SearchEmailsResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new SearchEmailsResponseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["testata"] = this.testata !== undefined ? this.testata : <any>null;
        data["corpo"] = this.corpo !== undefined ? this.corpo : <any>null;
        data["corpo2"] = this.corpo2 !== undefined ? this.corpo2 : <any>null;
        data["isEmailLink"] = this.isEmailLink !== undefined ? this.isEmailLink : <any>null;
        data["emailUrl"] = this.emailUrl !== undefined ? this.emailUrl : <any>null;
        data["urlAllegato"] = this.urlAllegato !== undefined ? this.urlAllegato : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeAllegato"] = this.nomeAllegato !== undefined ? this.nomeAllegato : <any>null;
        data["nomeContatto"] = this.nomeContatto !== undefined ? this.nomeContatto : <any>null;
        data["dimensioneAllegato"] = this.dimensioneAllegato !== undefined ? this.dimensioneAllegato : <any>null;
        data["spedito"] = this.spedito !== undefined ? this.spedito : <any>null;
        data["contatoreSpedizioni"] = this.contatoreSpedizioni !== undefined ? this.contatoreSpedizioni : <any>null;
        return data;
    }
}

export interface ISearchEmailsResponseRow {
    documentoID?: number;
    offertaID?: number;
    data?: string;
    testata?: string | null;
    corpo?: string | null;
    corpo2?: string | null;
    isEmailLink?: boolean;
    emailUrl?: string | null;
    urlAllegato?: string | null;
    nome?: string | null;
    nomeAllegato?: string | null;
    nomeContatto?: string | null;
    dimensioneAllegato?: number | null;
    spedito?: string | null;
    contatoreSpedizioni?: number | null;
}

export class SearchEmailsRequest extends NrTableRequest implements ISearchEmailsRequest {
    agenziaID?: number | null;
    impiegatoID?: number | null;
    operatore?: EOperatore;
    confermaDal?: string | null;
    confermaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    inserimentoDal?: string | null;
    inserimentoAl?: string | null;

    constructor(data?: ISearchEmailsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : <any>null;
            this.impiegatoID = _data["impiegatoID"] !== undefined ? _data["impiegatoID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.confermaDal = _data["confermaDal"] !== undefined ? _data["confermaDal"] : <any>null;
            this.confermaAl = _data["confermaAl"] !== undefined ? _data["confermaAl"] : <any>null;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
            this.inserimentoDal = _data["inserimentoDal"] !== undefined ? _data["inserimentoDal"] : <any>null;
            this.inserimentoAl = _data["inserimentoAl"] !== undefined ? _data["inserimentoAl"] : <any>null;
        }
    }

    static fromJS(data: any): SearchEmailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchEmailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : <any>null;
        data["impiegatoID"] = this.impiegatoID !== undefined ? this.impiegatoID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["confermaDal"] = this.confermaDal !== undefined ? this.confermaDal : <any>null;
        data["confermaAl"] = this.confermaAl !== undefined ? this.confermaAl : <any>null;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        data["inserimentoDal"] = this.inserimentoDal !== undefined ? this.inserimentoDal : <any>null;
        data["inserimentoAl"] = this.inserimentoAl !== undefined ? this.inserimentoAl : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchEmailsRequest extends INrTableRequest {
    agenziaID?: number | null;
    impiegatoID?: number | null;
    operatore?: EOperatore;
    confermaDal?: string | null;
    confermaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    inserimentoDal?: string | null;
    inserimentoAl?: string | null;
}

export class NrTableResponseOfSearchNoteResponseRow extends OkApiResponse implements INrTableResponseOfSearchNoteResponseRow {
    /** Array delle righe della pagina richiesta */
    rows?: SearchNoteResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSearchNoteResponseRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SearchNoteResponseRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfSearchNoteResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSearchNoteResponseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSearchNoteResponseRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SearchNoteResponseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SearchNoteResponseRow implements ISearchNoteResponseRow {
    offertaNotaID?: number;
    offertaID?: number;
    offertaDatoID?: number | null;
    accordoID?: number | null;
    testo?: string | null;
    data?: string;
    fatto?: boolean;
    pubblica?: boolean;
    voucher?: boolean;
    kanban?: boolean;
    sistema?: boolean;
    tipo?: ETipoNota | null;
    utente?: string | null;
    utentePresaInCarico?: string | null;

    constructor(data?: ISearchNoteResponseRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaNotaID = _data["offertaNotaID"] !== undefined ? _data["offertaNotaID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.fatto = _data["fatto"] !== undefined ? _data["fatto"] : <any>null;
            this.pubblica = _data["pubblica"] !== undefined ? _data["pubblica"] : <any>null;
            this.voucher = _data["voucher"] !== undefined ? _data["voucher"] : <any>null;
            this.kanban = _data["kanban"] !== undefined ? _data["kanban"] : <any>null;
            this.sistema = _data["sistema"] !== undefined ? _data["sistema"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.utente = _data["utente"] !== undefined ? _data["utente"] : <any>null;
            this.utentePresaInCarico = _data["utentePresaInCarico"] !== undefined ? _data["utentePresaInCarico"] : <any>null;
        }
    }

    static fromJS(data: any): SearchNoteResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new SearchNoteResponseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaNotaID"] = this.offertaNotaID !== undefined ? this.offertaNotaID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["fatto"] = this.fatto !== undefined ? this.fatto : <any>null;
        data["pubblica"] = this.pubblica !== undefined ? this.pubblica : <any>null;
        data["voucher"] = this.voucher !== undefined ? this.voucher : <any>null;
        data["kanban"] = this.kanban !== undefined ? this.kanban : <any>null;
        data["sistema"] = this.sistema !== undefined ? this.sistema : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["utente"] = this.utente !== undefined ? this.utente : <any>null;
        data["utentePresaInCarico"] = this.utentePresaInCarico !== undefined ? this.utentePresaInCarico : <any>null;
        return data;
    }
}

export interface ISearchNoteResponseRow {
    offertaNotaID?: number;
    offertaID?: number;
    offertaDatoID?: number | null;
    accordoID?: number | null;
    testo?: string | null;
    data?: string;
    fatto?: boolean;
    pubblica?: boolean;
    voucher?: boolean;
    kanban?: boolean;
    sistema?: boolean;
    tipo?: ETipoNota | null;
    utente?: string | null;
    utentePresaInCarico?: string | null;
}

export class SearchNoteRequest extends NrTableRequest implements ISearchNoteRequest {
    agenziaID?: number | null;
    impiegatoID?: number | null;
    impiegatoPresaInCaricoID?: number | null;
    operatore?: EOperatore;
    confermaDal?: string | null;
    confermaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    inserimentoDal?: string | null;
    inserimentoAl?: string | null;
    tipologieNota?: NoteTypeSearch | null;

    constructor(data?: ISearchNoteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : <any>null;
            this.impiegatoID = _data["impiegatoID"] !== undefined ? _data["impiegatoID"] : <any>null;
            this.impiegatoPresaInCaricoID = _data["impiegatoPresaInCaricoID"] !== undefined ? _data["impiegatoPresaInCaricoID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.confermaDal = _data["confermaDal"] !== undefined ? _data["confermaDal"] : <any>null;
            this.confermaAl = _data["confermaAl"] !== undefined ? _data["confermaAl"] : <any>null;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
            this.inserimentoDal = _data["inserimentoDal"] !== undefined ? _data["inserimentoDal"] : <any>null;
            this.inserimentoAl = _data["inserimentoAl"] !== undefined ? _data["inserimentoAl"] : <any>null;
            this.tipologieNota = _data["tipologieNota"] ? NoteTypeSearch.fromJS(_data["tipologieNota"]) : <any>null;
        }
    }

    static fromJS(data: any): SearchNoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchNoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : <any>null;
        data["impiegatoID"] = this.impiegatoID !== undefined ? this.impiegatoID : <any>null;
        data["impiegatoPresaInCaricoID"] = this.impiegatoPresaInCaricoID !== undefined ? this.impiegatoPresaInCaricoID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["confermaDal"] = this.confermaDal !== undefined ? this.confermaDal : <any>null;
        data["confermaAl"] = this.confermaAl !== undefined ? this.confermaAl : <any>null;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        data["inserimentoDal"] = this.inserimentoDal !== undefined ? this.inserimentoDal : <any>null;
        data["inserimentoAl"] = this.inserimentoAl !== undefined ? this.inserimentoAl : <any>null;
        data["tipologieNota"] = this.tipologieNota ? this.tipologieNota.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchNoteRequest extends INrTableRequest {
    agenziaID?: number | null;
    impiegatoID?: number | null;
    impiegatoPresaInCaricoID?: number | null;
    operatore?: EOperatore;
    confermaDal?: string | null;
    confermaAl?: string | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    inserimentoDal?: string | null;
    inserimentoAl?: string | null;
    tipologieNota?: NoteTypeSearch | null;
}

export class NoteTypeSearch implements INoteTypeSearch {
    int?: boolean;
    prSin?: boolean;
    prMul?: boolean;
    ag?: boolean;
    rAg?: boolean;
    as?: boolean;
    pas?: boolean;
    op?: boolean;
    hasValue?: boolean;
    tipiNota?: ETipoNota[] | null;

    constructor(data?: INoteTypeSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.int = _data["int"] !== undefined ? _data["int"] : <any>null;
            this.prSin = _data["prSin"] !== undefined ? _data["prSin"] : <any>null;
            this.prMul = _data["prMul"] !== undefined ? _data["prMul"] : <any>null;
            this.ag = _data["ag"] !== undefined ? _data["ag"] : <any>null;
            this.rAg = _data["rAg"] !== undefined ? _data["rAg"] : <any>null;
            this.as = _data["as"] !== undefined ? _data["as"] : <any>null;
            this.pas = _data["pas"] !== undefined ? _data["pas"] : <any>null;
            this.op = _data["op"] !== undefined ? _data["op"] : <any>null;
            this.hasValue = _data["hasValue"] !== undefined ? _data["hasValue"] : <any>null;
            if (Array.isArray(_data["tipiNota"])) {
                this.tipiNota = [] as any;
                for (let item of _data["tipiNota"])
                    this.tipiNota!.push(item);
            }
            else {
                this.tipiNota = <any>null;
            }
        }
    }

    static fromJS(data: any): NoteTypeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new NoteTypeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["int"] = this.int !== undefined ? this.int : <any>null;
        data["prSin"] = this.prSin !== undefined ? this.prSin : <any>null;
        data["prMul"] = this.prMul !== undefined ? this.prMul : <any>null;
        data["ag"] = this.ag !== undefined ? this.ag : <any>null;
        data["rAg"] = this.rAg !== undefined ? this.rAg : <any>null;
        data["as"] = this.as !== undefined ? this.as : <any>null;
        data["pas"] = this.pas !== undefined ? this.pas : <any>null;
        data["op"] = this.op !== undefined ? this.op : <any>null;
        data["hasValue"] = this.hasValue !== undefined ? this.hasValue : <any>null;
        if (Array.isArray(this.tipiNota)) {
            data["tipiNota"] = [];
            for (let item of this.tipiNota)
                data["tipiNota"].push(item);
        }
        return data;
    }
}

export interface INoteTypeSearch {
    int?: boolean;
    prSin?: boolean;
    prMul?: boolean;
    ag?: boolean;
    rAg?: boolean;
    as?: boolean;
    pas?: boolean;
    op?: boolean;
    hasValue?: boolean;
    tipiNota?: ETipoNota[] | null;
}

export class NrTableResponseOfOptimizationRow extends OkApiResponse implements INrTableResponseOfOptimizationRow {
    /** Array delle righe della pagina richiesta */
    rows?: OptimizationRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfOptimizationRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(OptimizationRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfOptimizationRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfOptimizationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfOptimizationRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: OptimizationRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SearchOptimizationsResponse extends NrTableResponseOfOptimizationRow implements ISearchOptimizationsResponse {

    constructor(data?: ISearchOptimizationsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SearchOptimizationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOptimizationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISearchOptimizationsResponse extends INrTableResponseOfOptimizationRow {
}

export class OptimizationRow implements IOptimizationRow {
    id?: number;
    offerta?: Offerta;
    riga?: OffertaDato;
    alternativa?: OffertaDatoAlternativa;
    job?: OffertaDatoAlternativaJob;
    luogo?: string | null;
    dal?: string;
    fornitoreOriginale?: EFornitore | null;
    valutaCostoOriginale?: string | null;
    valutaCostoAlternativa?: string | null;

    constructor(data?: IOptimizationRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.offerta = _data["offerta"] ? Offerta.fromJS(_data["offerta"]) : <any>null;
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : <any>null;
            this.alternativa = _data["alternativa"] ? OffertaDatoAlternativa.fromJS(_data["alternativa"]) : <any>null;
            this.job = _data["job"] ? OffertaDatoAlternativaJob.fromJS(_data["job"]) : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.fornitoreOriginale = _data["fornitoreOriginale"] !== undefined ? _data["fornitoreOriginale"] : <any>null;
            this.valutaCostoOriginale = _data["valutaCostoOriginale"] !== undefined ? _data["valutaCostoOriginale"] : <any>null;
            this.valutaCostoAlternativa = _data["valutaCostoAlternativa"] !== undefined ? _data["valutaCostoAlternativa"] : <any>null;
        }
    }

    static fromJS(data: any): OptimizationRow {
        data = typeof data === 'object' ? data : {};
        let result = new OptimizationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        data["riga"] = this.riga ? this.riga.toJSON() : <any>null;
        data["alternativa"] = this.alternativa ? this.alternativa.toJSON() : <any>null;
        data["job"] = this.job ? this.job.toJSON() : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["fornitoreOriginale"] = this.fornitoreOriginale !== undefined ? this.fornitoreOriginale : <any>null;
        data["valutaCostoOriginale"] = this.valutaCostoOriginale !== undefined ? this.valutaCostoOriginale : <any>null;
        data["valutaCostoAlternativa"] = this.valutaCostoAlternativa !== undefined ? this.valutaCostoAlternativa : <any>null;
        return data;
    }
}

export interface IOptimizationRow {
    id?: number;
    offerta?: Offerta;
    riga?: OffertaDato;
    alternativa?: OffertaDatoAlternativa;
    job?: OffertaDatoAlternativaJob;
    luogo?: string | null;
    dal?: string;
    fornitoreOriginale?: EFornitore | null;
    valutaCostoOriginale?: string | null;
    valutaCostoAlternativa?: string | null;
}

export class OffertaDatoAlternativa implements IOffertaDatoAlternativa {
    id?: number;
    rigaID?: number;
    jobID?: number;
    status?: EStatusAlternativa;
    creato?: string;
    aggiornato?: string;
    descrizione?: string | null;
    note?: string | null;
    costo?: number | null;
    valutaCostoID?: number | null;
    prezzo?: number | null;
    fornitore?: EFornitore | null;
    searchData?: string | null;

    constructor(data?: IOffertaDatoAlternativa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : <any>null;
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.creato = _data["creato"] !== undefined ? _data["creato"] : <any>null;
            this.aggiornato = _data["aggiornato"] !== undefined ? _data["aggiornato"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : <any>null;
            this.valutaCostoID = _data["valutaCostoID"] !== undefined ? _data["valutaCostoID"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            this.searchData = _data["searchData"] !== undefined ? _data["searchData"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaDatoAlternativa {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaDatoAlternativa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : <any>null;
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["creato"] = this.creato !== undefined ? this.creato : <any>null;
        data["aggiornato"] = this.aggiornato !== undefined ? this.aggiornato : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["costo"] = this.costo !== undefined ? this.costo : <any>null;
        data["valutaCostoID"] = this.valutaCostoID !== undefined ? this.valutaCostoID : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        data["searchData"] = this.searchData !== undefined ? this.searchData : <any>null;
        return data;
    }
}

export interface IOffertaDatoAlternativa {
    id?: number;
    rigaID?: number;
    jobID?: number;
    status?: EStatusAlternativa;
    creato?: string;
    aggiornato?: string;
    descrizione?: string | null;
    note?: string | null;
    costo?: number | null;
    valutaCostoID?: number | null;
    prezzo?: number | null;
    fornitore?: EFornitore | null;
    searchData?: string | null;
}

export enum EStatusAlternativa {
    Pronto = "Pronto",
    InCorso = "InCorso",
    EseguitoSuccesso = "EseguitoSuccesso",
    EseguitoNoRisultati = "EseguitoNoRisultati",
    Errore = "Errore",
    Annullato = "Annullato",
}

export class SearchOptimizationsRequest extends NrTableRequest implements ISearchOptimizationsRequest {
    partenzaDal?: string | null;
    partenzaAl?: string | null;

    constructor(data?: ISearchOptimizationsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
        }
    }

    static fromJS(data: any): SearchOptimizationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOptimizationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchOptimizationsRequest extends INrTableRequest {
    partenzaDal?: string | null;
    partenzaAl?: string | null;
}

export class NrTableResponseOfPreventivoListRow extends OkApiResponse implements INrTableResponseOfPreventivoListRow {
    /** Array delle righe della pagina richiesta */
    rows?: PreventivoListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPreventivoListRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PreventivoListRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfPreventivoListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPreventivoListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPreventivoListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PreventivoListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SearchPreventiviResponse extends NrTableResponseOfPreventivoListRow implements ISearchPreventiviResponse {
    ordersWorkLoad?: OrdersWorkLoad | null;

    constructor(data?: ISearchPreventiviResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ordersWorkLoad = _data["ordersWorkLoad"] ? OrdersWorkLoad.fromJS(_data["ordersWorkLoad"]) : <any>null;
        }
    }

    static fromJS(data: any): SearchPreventiviResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPreventiviResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordersWorkLoad"] = this.ordersWorkLoad ? this.ordersWorkLoad.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchPreventiviResponse extends INrTableResponseOfPreventivoListRow {
    ordersWorkLoad?: OrdersWorkLoad | null;
}

export class OrdersWorkLoad implements IOrdersWorkLoad {
    teamsLoad?: OrdersTeamWorkLoad[] | null;
    totalOrders?: number;

    constructor(data?: IOrdersWorkLoad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["teamsLoad"])) {
                this.teamsLoad = [] as any;
                for (let item of _data["teamsLoad"])
                    this.teamsLoad!.push(OrdersTeamWorkLoad.fromJS(item));
            }
            else {
                this.teamsLoad = <any>null;
            }
            this.totalOrders = _data["totalOrders"] !== undefined ? _data["totalOrders"] : <any>null;
        }
    }

    static fromJS(data: any): OrdersWorkLoad {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersWorkLoad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.teamsLoad)) {
            data["teamsLoad"] = [];
            for (let item of this.teamsLoad)
                data["teamsLoad"].push(item.toJSON());
        }
        data["totalOrders"] = this.totalOrders !== undefined ? this.totalOrders : <any>null;
        return data;
    }
}

export interface IOrdersWorkLoad {
    teamsLoad?: OrdersTeamWorkLoad[] | null;
    totalOrders?: number;
}

export class OrdersTeamWorkLoad implements IOrdersTeamWorkLoad {
    teamID?: number;
    teamName?: string | null;
    totalOrders?: number;
    users?: OrdersUserWorkLoad[] | null;

    constructor(data?: IOrdersTeamWorkLoad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : <any>null;
            this.teamName = _data["teamName"] !== undefined ? _data["teamName"] : <any>null;
            this.totalOrders = _data["totalOrders"] !== undefined ? _data["totalOrders"] : <any>null;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(OrdersUserWorkLoad.fromJS(item));
            }
            else {
                this.users = <any>null;
            }
        }
    }

    static fromJS(data: any): OrdersTeamWorkLoad {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersTeamWorkLoad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamID"] = this.teamID !== undefined ? this.teamID : <any>null;
        data["teamName"] = this.teamName !== undefined ? this.teamName : <any>null;
        data["totalOrders"] = this.totalOrders !== undefined ? this.totalOrders : <any>null;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrdersTeamWorkLoad {
    teamID?: number;
    teamName?: string | null;
    totalOrders?: number;
    users?: OrdersUserWorkLoad[] | null;
}

export class OrdersUserWorkLoad implements IOrdersUserWorkLoad {
    userID?: number;
    userName?: string | null;
    totalOrders?: number;
    orders?: OrdersOrderDetails[] | null;

    constructor(data?: IOrdersUserWorkLoad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"] !== undefined ? _data["userID"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.totalOrders = _data["totalOrders"] !== undefined ? _data["totalOrders"] : <any>null;
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrdersOrderDetails.fromJS(item));
            }
            else {
                this.orders = <any>null;
            }
        }
    }

    static fromJS(data: any): OrdersUserWorkLoad {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersUserWorkLoad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID !== undefined ? this.userID : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["totalOrders"] = this.totalOrders !== undefined ? this.totalOrders : <any>null;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrdersUserWorkLoad {
    userID?: number;
    userName?: string | null;
    totalOrders?: number;
    orders?: OrdersOrderDetails[] | null;
}

export class OrdersOrderDetails implements IOrdersOrderDetails {
    offertaID?: number;
    title?: string | null;
    description?: string | null;
    orderStatus?: EStatusPreventivo | null;

    constructor(data?: IOrdersOrderDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.orderStatus = _data["orderStatus"] !== undefined ? _data["orderStatus"] : <any>null;
        }
    }

    static fromJS(data: any): OrdersOrderDetails {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersOrderDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["orderStatus"] = this.orderStatus !== undefined ? this.orderStatus : <any>null;
        return data;
    }
}

export interface IOrdersOrderDetails {
    offertaID?: number;
    title?: string | null;
    description?: string | null;
    orderStatus?: EStatusPreventivo | null;
}

export class PreventivoListRow implements IPreventivoListRow {
    offertaID?: number;
    descrizione?: string | null;
    clienti?: string;
    destinazione?: string | null;
    creazione?: string;
    partenza?: string;
    priorita?: string | null;
    dataAppuntamentoADV?: string | null;
    totale?: number;
    agenzia?: string | null;
    telefono?: string | null;
    email?: string | null;
    categoriaAgenzia?: string | null;
    categoriaUtente?: string | null;
    impiegato?: string | null;
    utentePreventivo?: string | null;
    utenteConferma?: string | null;
    sales?: string | null;
    pagamento?: string | null;
    duplicabileAgenzia?: boolean;
    teamId?: number | null;
    teamName?: string | null;
    statusPreventivo?: EStatusPreventivo | null;
    tagIds?: number[];
    numOfPax?: number;
    emails?: TripEmail[] | null;
    coverUrl?: string | null;

    constructor(data?: IPreventivoListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.clienti = _data["clienti"] !== undefined ? _data["clienti"] : <any>null;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : <any>null;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : <any>null;
            this.dataAppuntamentoADV = _data["dataAppuntamentoADV"] !== undefined ? _data["dataAppuntamentoADV"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.categoriaAgenzia = _data["categoriaAgenzia"] !== undefined ? _data["categoriaAgenzia"] : <any>null;
            this.categoriaUtente = _data["categoriaUtente"] !== undefined ? _data["categoriaUtente"] : <any>null;
            this.impiegato = _data["impiegato"] !== undefined ? _data["impiegato"] : <any>null;
            this.utentePreventivo = _data["utentePreventivo"] !== undefined ? _data["utentePreventivo"] : <any>null;
            this.utenteConferma = _data["utenteConferma"] !== undefined ? _data["utenteConferma"] : <any>null;
            this.sales = _data["sales"] !== undefined ? _data["sales"] : <any>null;
            this.pagamento = _data["pagamento"] !== undefined ? _data["pagamento"] : <any>null;
            this.duplicabileAgenzia = _data["duplicabileAgenzia"] !== undefined ? _data["duplicabileAgenzia"] : <any>null;
            this.teamId = _data["teamId"] !== undefined ? _data["teamId"] : <any>null;
            this.teamName = _data["teamName"] !== undefined ? _data["teamName"] : <any>null;
            this.statusPreventivo = _data["statusPreventivo"] !== undefined ? _data["statusPreventivo"] : <any>null;
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            else {
                this.tagIds = <any>null;
            }
            this.numOfPax = _data["numOfPax"] !== undefined ? _data["numOfPax"] : <any>null;
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(TripEmail.fromJS(item));
            }
            else {
                this.emails = <any>null;
            }
            this.coverUrl = _data["coverUrl"] !== undefined ? _data["coverUrl"] : <any>null;
        }
    }

    static fromJS(data: any): PreventivoListRow {
        data = typeof data === 'object' ? data : {};
        let result = new PreventivoListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["clienti"] = this.clienti !== undefined ? this.clienti : <any>null;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : <any>null;
        data["creazione"] = this.creazione !== undefined ? this.creazione : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["priorita"] = this.priorita !== undefined ? this.priorita : <any>null;
        data["dataAppuntamentoADV"] = this.dataAppuntamentoADV !== undefined ? this.dataAppuntamentoADV : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["categoriaAgenzia"] = this.categoriaAgenzia !== undefined ? this.categoriaAgenzia : <any>null;
        data["categoriaUtente"] = this.categoriaUtente !== undefined ? this.categoriaUtente : <any>null;
        data["impiegato"] = this.impiegato !== undefined ? this.impiegato : <any>null;
        data["utentePreventivo"] = this.utentePreventivo !== undefined ? this.utentePreventivo : <any>null;
        data["utenteConferma"] = this.utenteConferma !== undefined ? this.utenteConferma : <any>null;
        data["sales"] = this.sales !== undefined ? this.sales : <any>null;
        data["pagamento"] = this.pagamento !== undefined ? this.pagamento : <any>null;
        data["duplicabileAgenzia"] = this.duplicabileAgenzia !== undefined ? this.duplicabileAgenzia : <any>null;
        data["teamId"] = this.teamId !== undefined ? this.teamId : <any>null;
        data["teamName"] = this.teamName !== undefined ? this.teamName : <any>null;
        data["statusPreventivo"] = this.statusPreventivo !== undefined ? this.statusPreventivo : <any>null;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["numOfPax"] = this.numOfPax !== undefined ? this.numOfPax : <any>null;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        data["coverUrl"] = this.coverUrl !== undefined ? this.coverUrl : <any>null;
        return data;
    }
}

export interface IPreventivoListRow {
    offertaID?: number;
    descrizione?: string | null;
    clienti?: string;
    destinazione?: string | null;
    creazione?: string;
    partenza?: string;
    priorita?: string | null;
    dataAppuntamentoADV?: string | null;
    totale?: number;
    agenzia?: string | null;
    telefono?: string | null;
    email?: string | null;
    categoriaAgenzia?: string | null;
    categoriaUtente?: string | null;
    impiegato?: string | null;
    utentePreventivo?: string | null;
    utenteConferma?: string | null;
    sales?: string | null;
    pagamento?: string | null;
    duplicabileAgenzia?: boolean;
    teamId?: number | null;
    teamName?: string | null;
    statusPreventivo?: EStatusPreventivo | null;
    tagIds?: number[];
    numOfPax?: number;
    emails?: TripEmail[] | null;
    coverUrl?: string | null;
}

export class SearchPreventiviRequest extends NrTableRequest implements ISearchPreventiviRequest {
    offertaID?: number | null;
    agenziaID?: number | null;
    categorieContattoIDs?: (number | null)[] | null;
    impiegatoID?: number | null;
    promotoreID?: number | null;
    luogoDestinazioneID?: number | null;
    operatore?: EOperatore | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    scadenzaDal?: string | null;
    scadenzaAl?: string | null;
    creazioneDal?: string | null;
    creazioneAl?: string | null;
    appuntamentoAgenziaDal?: string | null;
    appuntamentoAgenziaAl?: string | null;
    teamIds?: number[] | null;
    statusPreventivo?: EStatusPreventivo[] | null;
    tagIds?: number[] | null;
    tagFilterMode?: EFilterMode | null;

    constructor(data?: ISearchPreventiviRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : <any>null;
            if (Array.isArray(_data["categorieContattoIDs"])) {
                this.categorieContattoIDs = [] as any;
                for (let item of _data["categorieContattoIDs"])
                    this.categorieContattoIDs!.push(item);
            }
            else {
                this.categorieContattoIDs = <any>null;
            }
            this.impiegatoID = _data["impiegatoID"] !== undefined ? _data["impiegatoID"] : <any>null;
            this.promotoreID = _data["promotoreID"] !== undefined ? _data["promotoreID"] : <any>null;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
            this.scadenzaDal = _data["scadenzaDal"] !== undefined ? _data["scadenzaDal"] : <any>null;
            this.scadenzaAl = _data["scadenzaAl"] !== undefined ? _data["scadenzaAl"] : <any>null;
            this.creazioneDal = _data["creazioneDal"] !== undefined ? _data["creazioneDal"] : <any>null;
            this.creazioneAl = _data["creazioneAl"] !== undefined ? _data["creazioneAl"] : <any>null;
            this.appuntamentoAgenziaDal = _data["appuntamentoAgenziaDal"] !== undefined ? _data["appuntamentoAgenziaDal"] : <any>null;
            this.appuntamentoAgenziaAl = _data["appuntamentoAgenziaAl"] !== undefined ? _data["appuntamentoAgenziaAl"] : <any>null;
            if (Array.isArray(_data["teamIds"])) {
                this.teamIds = [] as any;
                for (let item of _data["teamIds"])
                    this.teamIds!.push(item);
            }
            else {
                this.teamIds = <any>null;
            }
            if (Array.isArray(_data["statusPreventivo"])) {
                this.statusPreventivo = [] as any;
                for (let item of _data["statusPreventivo"])
                    this.statusPreventivo!.push(item);
            }
            else {
                this.statusPreventivo = <any>null;
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            else {
                this.tagIds = <any>null;
            }
            this.tagFilterMode = _data["tagFilterMode"] !== undefined ? _data["tagFilterMode"] : <any>null;
        }
    }

    static fromJS(data: any): SearchPreventiviRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPreventiviRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : <any>null;
        if (Array.isArray(this.categorieContattoIDs)) {
            data["categorieContattoIDs"] = [];
            for (let item of this.categorieContattoIDs)
                data["categorieContattoIDs"].push(item);
        }
        data["impiegatoID"] = this.impiegatoID !== undefined ? this.impiegatoID : <any>null;
        data["promotoreID"] = this.promotoreID !== undefined ? this.promotoreID : <any>null;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        data["scadenzaDal"] = this.scadenzaDal !== undefined ? this.scadenzaDal : <any>null;
        data["scadenzaAl"] = this.scadenzaAl !== undefined ? this.scadenzaAl : <any>null;
        data["creazioneDal"] = this.creazioneDal !== undefined ? this.creazioneDal : <any>null;
        data["creazioneAl"] = this.creazioneAl !== undefined ? this.creazioneAl : <any>null;
        data["appuntamentoAgenziaDal"] = this.appuntamentoAgenziaDal !== undefined ? this.appuntamentoAgenziaDal : <any>null;
        data["appuntamentoAgenziaAl"] = this.appuntamentoAgenziaAl !== undefined ? this.appuntamentoAgenziaAl : <any>null;
        if (Array.isArray(this.teamIds)) {
            data["teamIds"] = [];
            for (let item of this.teamIds)
                data["teamIds"].push(item);
        }
        if (Array.isArray(this.statusPreventivo)) {
            data["statusPreventivo"] = [];
            for (let item of this.statusPreventivo)
                data["statusPreventivo"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["tagFilterMode"] = this.tagFilterMode !== undefined ? this.tagFilterMode : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchPreventiviRequest extends INrTableRequest {
    offertaID?: number | null;
    agenziaID?: number | null;
    categorieContattoIDs?: (number | null)[] | null;
    impiegatoID?: number | null;
    promotoreID?: number | null;
    luogoDestinazioneID?: number | null;
    operatore?: EOperatore | null;
    partenzaDal?: string | null;
    partenzaAl?: string | null;
    scadenzaDal?: string | null;
    scadenzaAl?: string | null;
    creazioneDal?: string | null;
    creazioneAl?: string | null;
    appuntamentoAgenziaDal?: string | null;
    appuntamentoAgenziaAl?: string | null;
    teamIds?: number[] | null;
    statusPreventivo?: EStatusPreventivo[] | null;
    tagIds?: number[] | null;
    tagFilterMode?: EFilterMode | null;
}

export enum EFilterMode {
    AND = "AND",
    OR = "OR",
}

export class UpdateOrdersStatusMultiRequest extends ApiRequest implements IUpdateOrdersStatusMultiRequest {
    /** Lista degli ID da modificare */
    iDs!: number[];
    /** Se presente è la nuova data del campo priorità da impostare */
    newPriorita?: string | null;
    /** Se presente è il valore in giorni +/- da impostare sulla data di priorità. Se c'è la data questo viene ignorato */
    offsetPriorita?: number | null;
    /** Se presente è il nuovo ID del team da assegnare */
    newTeamID?: number | null;
    /** Se presente è il nuovo status da assegnare */
    newStatusPreventivo?: EStatusPreventivo | null;
    /** Se presente è il nuovo id utente preventivo */
    newUtenteID?: number | null;
    /** Elenco degli id dei tag da assegnare */
    tagsIDs?: number[] | null;

    constructor(data?: IUpdateOrdersStatusMultiRequest) {
        super(data);
        if (!data) {
            this.iDs = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["iDs"])) {
                this.iDs = [] as any;
                for (let item of _data["iDs"])
                    this.iDs!.push(item);
            }
            else {
                this.iDs = <any>null;
            }
            this.newPriorita = _data["newPriorita"] !== undefined ? _data["newPriorita"] : <any>null;
            this.offsetPriorita = _data["offsetPriorita"] !== undefined ? _data["offsetPriorita"] : <any>null;
            this.newTeamID = _data["newTeamID"] !== undefined ? _data["newTeamID"] : <any>null;
            this.newStatusPreventivo = _data["newStatusPreventivo"] !== undefined ? _data["newStatusPreventivo"] : <any>null;
            this.newUtenteID = _data["newUtenteID"] !== undefined ? _data["newUtenteID"] : <any>null;
            if (Array.isArray(_data["tagsIDs"])) {
                this.tagsIDs = [] as any;
                for (let item of _data["tagsIDs"])
                    this.tagsIDs!.push(item);
            }
            else {
                this.tagsIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateOrdersStatusMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrdersStatusMultiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.iDs)) {
            data["iDs"] = [];
            for (let item of this.iDs)
                data["iDs"].push(item);
        }
        data["newPriorita"] = this.newPriorita !== undefined ? this.newPriorita : <any>null;
        data["offsetPriorita"] = this.offsetPriorita !== undefined ? this.offsetPriorita : <any>null;
        data["newTeamID"] = this.newTeamID !== undefined ? this.newTeamID : <any>null;
        data["newStatusPreventivo"] = this.newStatusPreventivo !== undefined ? this.newStatusPreventivo : <any>null;
        data["newUtenteID"] = this.newUtenteID !== undefined ? this.newUtenteID : <any>null;
        if (Array.isArray(this.tagsIDs)) {
            data["tagsIDs"] = [];
            for (let item of this.tagsIDs)
                data["tagsIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateOrdersStatusMultiRequest extends IApiRequest {
    /** Lista degli ID da modificare */
    iDs: number[];
    /** Se presente è la nuova data del campo priorità da impostare */
    newPriorita?: string | null;
    /** Se presente è il valore in giorni +/- da impostare sulla data di priorità. Se c'è la data questo viene ignorato */
    offsetPriorita?: number | null;
    /** Se presente è il nuovo ID del team da assegnare */
    newTeamID?: number | null;
    /** Se presente è il nuovo status da assegnare */
    newStatusPreventivo?: EStatusPreventivo | null;
    /** Se presente è il nuovo id utente preventivo */
    newUtenteID?: number | null;
    /** Elenco degli id dei tag da assegnare */
    tagsIDs?: number[] | null;
}

export class PaymentTermsGetResponse extends OkApiResponse implements IPaymentTermsGetResponse {
    paymentTerm?: TerminePagamento | null;

    constructor(data?: IPaymentTermsGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paymentTerm = _data["paymentTerm"] ? TerminePagamento.fromJS(_data["paymentTerm"]) : <any>null;
        }
    }

    static fromJS(data: any): PaymentTermsGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermsGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTerm"] = this.paymentTerm ? this.paymentTerm.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermsGetResponse extends IOkApiResponse {
    paymentTerm?: TerminePagamento | null;
}

export class PaymentTermUpsertResponse extends PaymentTermsGetResponse implements IPaymentTermUpsertResponse {

    constructor(data?: IPaymentTermUpsertResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PaymentTermUpsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermUpsertResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermUpsertResponse extends IPaymentTermsGetResponse {
}

export class PaymentTermsUpsertRequest extends ApiRequest implements IPaymentTermsUpsertRequest {
    paymentTerm?: TerminePagamento | null;

    constructor(data?: IPaymentTermsUpsertRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paymentTerm = _data["paymentTerm"] ? TerminePagamento.fromJS(_data["paymentTerm"]) : <any>null;
        }
    }

    static fromJS(data: any): PaymentTermsUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermsUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTerm"] = this.paymentTerm ? this.paymentTerm.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermsUpsertRequest extends IApiRequest {
    paymentTerm?: TerminePagamento | null;
}

export class PaymentTermsDeleteRequest extends ApiRequest implements IPaymentTermsDeleteRequest {
    id?: number;

    constructor(data?: IPaymentTermsDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentTermsDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermsDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermsDeleteRequest extends IApiRequest {
    id?: number;
}

export class PaymentTermsGetRequest extends ApiRequest implements IPaymentTermsGetRequest {
    termID?: number;

    constructor(data?: IPaymentTermsGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.termID = _data["termID"] !== undefined ? _data["termID"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentTermsGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermsGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID !== undefined ? this.termID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermsGetRequest extends IApiRequest {
    termID?: number;
}

export class NrTableResponseOfTerminePagamento extends OkApiResponse implements INrTableResponseOfTerminePagamento {
    /** Array delle righe della pagina richiesta */
    rows?: TerminePagamento[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTerminePagamento) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TerminePagamento.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfTerminePagamento {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTerminePagamento();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTerminePagamento extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TerminePagamento[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class PaymentTermsListRequest extends NrTableRequest implements IPaymentTermsListRequest {
    term?: string | null;
    showDeleted?: boolean;

    constructor(data?: IPaymentTermsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentTermsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermsListRequest extends INrTableRequest {
    term?: string | null;
    showDeleted?: boolean;
}

export class PaymentTermsRestoreRequest extends ApiRequest implements IPaymentTermsRestoreRequest {
    id?: number;

    constructor(data?: IPaymentTermsRestoreRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentTermsRestoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTermsRestoreRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentTermsRestoreRequest extends IApiRequest {
    id?: number;
}

export class GetCacheIndexResponse extends OkApiResponse implements IGetCacheIndexResponse {
    /** Indice della cache */
    indice?: CostsIndex;

    constructor(data?: IGetCacheIndexResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.indice = _data["indice"] ? CostsIndex.fromJS(_data["indice"]) : <any>null;
        }
    }

    static fromJS(data: any): GetCacheIndexResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCacheIndexResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indice"] = this.indice ? this.indice.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCacheIndexResponse extends IOkApiResponse {
    /** Indice della cache */
    indice?: CostsIndex;
}

export class CostsIndex implements ICostsIndex {
    key?: string;
    input?: CacheDisponibilitaInput;
    deleteAt?: string;
    createdAt?: string;
    lastHitDate?: string | null;
    updatedAt?: string;
    hits?: number;
    uniqueID?: string | null;
    locationID?: number | null;
    date?: string | null;
    nights?: number | null;
    serviceType?: ETipoServizioSearch | null;
    costi?: { [key: string]: SupplierCostsPointer; };
    generation?: number;
    isFinal?: boolean;
    doneCount?: number;
    okCount?: number;
    searchesCount?: number;
    now?: string;
    hasResults?: boolean;
    status?: EStatusCostiFornitore;

    constructor(data?: ICostsIndex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.input = _data["input"] ? CacheDisponibilitaInput.fromJS(_data["input"]) : <any>null;
            this.deleteAt = _data["deleteAt"] !== undefined ? _data["deleteAt"] : <any>null;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : <any>null;
            this.lastHitDate = _data["lastHitDate"] !== undefined ? _data["lastHitDate"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
            this.hits = _data["hits"] !== undefined ? _data["hits"] : <any>null;
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : <any>null;
            this.locationID = _data["locationID"] !== undefined ? _data["locationID"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.nights = _data["nights"] !== undefined ? _data["nights"] : <any>null;
            this.serviceType = _data["serviceType"] !== undefined ? _data["serviceType"] : <any>null;
            if (_data["costi"]) {
                this.costi = {} as any;
                for (let key in _data["costi"]) {
                    if (_data["costi"].hasOwnProperty(key))
                        (<any>this.costi)![key] = _data["costi"][key] ? SupplierCostsPointer.fromJS(_data["costi"][key]) : new SupplierCostsPointer();
                }
            }
            else {
                this.costi = <any>null;
            }
            this.generation = _data["generation"] !== undefined ? _data["generation"] : <any>null;
            this.isFinal = _data["isFinal"] !== undefined ? _data["isFinal"] : <any>null;
            this.doneCount = _data["doneCount"] !== undefined ? _data["doneCount"] : <any>null;
            this.okCount = _data["okCount"] !== undefined ? _data["okCount"] : <any>null;
            this.searchesCount = _data["searchesCount"] !== undefined ? _data["searchesCount"] : <any>null;
            this.now = _data["now"] !== undefined ? _data["now"] : <any>null;
            this.hasResults = _data["hasResults"] !== undefined ? _data["hasResults"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): CostsIndex {
        data = typeof data === 'object' ? data : {};
        let result = new CostsIndex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["input"] = this.input ? this.input.toJSON() : <any>null;
        data["deleteAt"] = this.deleteAt !== undefined ? this.deleteAt : <any>null;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : <any>null;
        data["lastHitDate"] = this.lastHitDate !== undefined ? this.lastHitDate : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        data["hits"] = this.hits !== undefined ? this.hits : <any>null;
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : <any>null;
        data["locationID"] = this.locationID !== undefined ? this.locationID : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["nights"] = this.nights !== undefined ? this.nights : <any>null;
        data["serviceType"] = this.serviceType !== undefined ? this.serviceType : <any>null;
        if (this.costi) {
            data["costi"] = {};
            for (let key in this.costi) {
                if (this.costi.hasOwnProperty(key))
                    (<any>data["costi"])[key] = this.costi[key] ? this.costi[key].toJSON() : <any>null;
            }
        }
        data["generation"] = this.generation !== undefined ? this.generation : <any>null;
        data["isFinal"] = this.isFinal !== undefined ? this.isFinal : <any>null;
        data["doneCount"] = this.doneCount !== undefined ? this.doneCount : <any>null;
        data["okCount"] = this.okCount !== undefined ? this.okCount : <any>null;
        data["searchesCount"] = this.searchesCount !== undefined ? this.searchesCount : <any>null;
        data["now"] = this.now !== undefined ? this.now : <any>null;
        data["hasResults"] = this.hasResults !== undefined ? this.hasResults : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface ICostsIndex {
    key?: string;
    input?: CacheDisponibilitaInput;
    deleteAt?: string;
    createdAt?: string;
    lastHitDate?: string | null;
    updatedAt?: string;
    hits?: number;
    uniqueID?: string | null;
    locationID?: number | null;
    date?: string | null;
    nights?: number | null;
    serviceType?: ETipoServizioSearch | null;
    costi?: { [key: string]: SupplierCostsPointer; };
    generation?: number;
    isFinal?: boolean;
    doneCount?: number;
    okCount?: number;
    searchesCount?: number;
    now?: string;
    hasResults?: boolean;
    status?: EStatusCostiFornitore;
}

export abstract class H2HRequestInputBase implements IH2HRequestInputBase {
    supplier?: EFornitore | null;
    contesto?: EContestoRicerca;
    tipoServizio?: ETipoServizioSearch;
    siteID?: EH2HClient;
    taskLogID?: number | null;

    constructor(data?: IH2HRequestInputBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
            this.contesto = _data["contesto"] !== undefined ? _data["contesto"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.siteID = _data["siteID"] !== undefined ? _data["siteID"] : <any>null;
            this.taskLogID = _data["taskLogID"] !== undefined ? _data["taskLogID"] : <any>null;
        }
    }

    static fromJS(data: any): H2HRequestInputBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'H2HRequestInputBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        data["contesto"] = this.contesto !== undefined ? this.contesto : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["siteID"] = this.siteID !== undefined ? this.siteID : <any>null;
        data["taskLogID"] = this.taskLogID !== undefined ? this.taskLogID : <any>null;
        return data;
    }
}

export interface IH2HRequestInputBase {
    supplier?: EFornitore | null;
    contesto?: EContestoRicerca;
    tipoServizio?: ETipoServizioSearch;
    siteID?: EH2HClient;
    taskLogID?: number | null;
}

export class DisponibilitaInput extends H2HRequestInputBase implements IDisponibilitaInput {
    jobID?: string;
    operatore?: EOperatore;
    userID?: number;
    dataDal?: string;
    oraDal?: number | null;
    dataAl?: string;
    oraAl?: number | null;
    gruppi?: DisponibilitaGruppo[];
    usaPrezziNetti?: boolean;
    moltiplicatoreMarkupAdv?: number;
    listino?: EListinoPrezzi;
    nozze?: boolean;
    lingua?: ELingua;
    tripID?: number | null;
    tripDetailID?: number | null;

    constructor(data?: IDisponibilitaInput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : <any>null;
            this.dataDal = _data["dataDal"] !== undefined ? _data["dataDal"] : <any>null;
            this.oraDal = _data["oraDal"] !== undefined ? _data["oraDal"] : <any>null;
            this.dataAl = _data["dataAl"] !== undefined ? _data["dataAl"] : <any>null;
            this.oraAl = _data["oraAl"] !== undefined ? _data["oraAl"] : <any>null;
            if (Array.isArray(_data["gruppi"])) {
                this.gruppi = [] as any;
                for (let item of _data["gruppi"])
                    this.gruppi!.push(DisponibilitaGruppo.fromJS(item));
            }
            else {
                this.gruppi = <any>null;
            }
            this.usaPrezziNetti = _data["usaPrezziNetti"] !== undefined ? _data["usaPrezziNetti"] : <any>null;
            this.moltiplicatoreMarkupAdv = _data["moltiplicatoreMarkupAdv"] !== undefined ? _data["moltiplicatoreMarkupAdv"] : <any>null;
            this.listino = _data["listino"] !== undefined ? _data["listino"] : <any>null;
            this.nozze = _data["nozze"] !== undefined ? _data["nozze"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
            this.tripDetailID = _data["tripDetailID"] !== undefined ? _data["tripDetailID"] : <any>null;
        }
    }

    static fromJS(data: any): DisponibilitaInput {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["userID"] = this.userID !== undefined ? this.userID : <any>null;
        data["dataDal"] = this.dataDal !== undefined ? this.dataDal : <any>null;
        data["oraDal"] = this.oraDal !== undefined ? this.oraDal : <any>null;
        data["dataAl"] = this.dataAl !== undefined ? this.dataAl : <any>null;
        data["oraAl"] = this.oraAl !== undefined ? this.oraAl : <any>null;
        if (Array.isArray(this.gruppi)) {
            data["gruppi"] = [];
            for (let item of this.gruppi)
                data["gruppi"].push(item.toJSON());
        }
        data["usaPrezziNetti"] = this.usaPrezziNetti !== undefined ? this.usaPrezziNetti : <any>null;
        data["moltiplicatoreMarkupAdv"] = this.moltiplicatoreMarkupAdv !== undefined ? this.moltiplicatoreMarkupAdv : <any>null;
        data["listino"] = this.listino !== undefined ? this.listino : <any>null;
        data["nozze"] = this.nozze !== undefined ? this.nozze : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        data["tripDetailID"] = this.tripDetailID !== undefined ? this.tripDetailID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDisponibilitaInput extends IH2HRequestInputBase {
    jobID?: string;
    operatore?: EOperatore;
    userID?: number;
    dataDal?: string;
    oraDal?: number | null;
    dataAl?: string;
    oraAl?: number | null;
    gruppi?: DisponibilitaGruppo[];
    usaPrezziNetti?: boolean;
    moltiplicatoreMarkupAdv?: number;
    listino?: EListinoPrezzi;
    nozze?: boolean;
    lingua?: ELingua;
    tripID?: number | null;
    tripDetailID?: number | null;
}

export class CacheDisponibilitaInput extends DisponibilitaInput implements ICacheDisponibilitaInput {
    luogoID?: number;
    luogoDestinazioneID?: number | null;
    bypassCache?: boolean;
    servizioID?: number | null;
    hasDelta?: boolean;

    constructor(data?: ICacheDisponibilitaInput) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : <any>null;
            this.bypassCache = _data["bypassCache"] !== undefined ? _data["bypassCache"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.hasDelta = _data["hasDelta"] !== undefined ? _data["hasDelta"] : <any>null;
        }
    }

    static fromJS(data: any): CacheDisponibilitaInput {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDisponibilitaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : <any>null;
        data["bypassCache"] = this.bypassCache !== undefined ? this.bypassCache : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["hasDelta"] = this.hasDelta !== undefined ? this.hasDelta : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICacheDisponibilitaInput extends IDisponibilitaInput {
    luogoID?: number;
    luogoDestinazioneID?: number | null;
    bypassCache?: boolean;
    servizioID?: number | null;
    hasDelta?: boolean;
}

export class DisponibilitaGruppo implements IDisponibilitaGruppo {
    id?: number;
    nome?: string | null;
    partecipanti?: DisponibilitaPartecipante[];
    prezzoBase?: number;
    ordine?: number;
    adulti?: number;
    children?: number;
    infants?: number;

    constructor(data?: IDisponibilitaGruppo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            if (Array.isArray(_data["partecipanti"])) {
                this.partecipanti = [] as any;
                for (let item of _data["partecipanti"])
                    this.partecipanti!.push(DisponibilitaPartecipante.fromJS(item));
            }
            else {
                this.partecipanti = <any>null;
            }
            this.prezzoBase = _data["prezzoBase"] !== undefined ? _data["prezzoBase"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.adulti = _data["adulti"] !== undefined ? _data["adulti"] : <any>null;
            this.children = _data["children"] !== undefined ? _data["children"] : <any>null;
            this.infants = _data["infants"] !== undefined ? _data["infants"] : <any>null;
        }
    }

    static fromJS(data: any): DisponibilitaGruppo {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaGruppo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        if (Array.isArray(this.partecipanti)) {
            data["partecipanti"] = [];
            for (let item of this.partecipanti)
                data["partecipanti"].push(item.toJSON());
        }
        data["prezzoBase"] = this.prezzoBase !== undefined ? this.prezzoBase : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["adulti"] = this.adulti !== undefined ? this.adulti : <any>null;
        data["children"] = this.children !== undefined ? this.children : <any>null;
        data["infants"] = this.infants !== undefined ? this.infants : <any>null;
        return data;
    }
}

export interface IDisponibilitaGruppo {
    id?: number;
    nome?: string | null;
    partecipanti?: DisponibilitaPartecipante[];
    prezzoBase?: number;
    ordine?: number;
    adulti?: number;
    children?: number;
    infants?: number;
}

export class DisponibilitaPartecipante implements IDisponibilitaPartecipante {
    id?: number;
    nome?: string | null;
    cognome?: string;
    dataDiNascita?: string;
    titoloPaxID?: number;

    constructor(data?: IDisponibilitaPartecipante) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.dataDiNascita = _data["dataDiNascita"] !== undefined ? _data["dataDiNascita"] : <any>null;
            this.titoloPaxID = _data["titoloPaxID"] !== undefined ? _data["titoloPaxID"] : <any>null;
        }
    }

    static fromJS(data: any): DisponibilitaPartecipante {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaPartecipante();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["dataDiNascita"] = this.dataDiNascita !== undefined ? this.dataDiNascita : <any>null;
        data["titoloPaxID"] = this.titoloPaxID !== undefined ? this.titoloPaxID : <any>null;
        return data;
    }
}

export interface IDisponibilitaPartecipante {
    id?: number;
    nome?: string | null;
    cognome?: string;
    dataDiNascita?: string;
    titoloPaxID?: number;
}

export enum EListinoPrezzi {
    Default = "Default",
    PrezziNetti = "PrezziNetti",
    Pacchetto = "Pacchetto",
}

export enum EContestoRicerca {
    Ricerca = "Ricerca",
    VerificaPrezzi = "VerificaPrezzi",
    Booking = "Booking",
    RicercaCache = "RicercaCache",
    Autofill = "Autofill",
    CacheFill = "CacheFill",
}

export enum EH2HClient {
    NAAR = "NAAR",
    NAAR_FRANCE = "NAAR_FRANCE",
}

export class SupplierCostsPointer implements ISupplierCostsPointer {
    supplier?: EFornitore;
    key?: string;
    searchStatus?: EStatusCostiFornitore;
    luoghiFornitoreIDs?: number[];
    objectId?: string | null;
    resultsCount?: number | null;
    searchTimeSeconds?: number | null;
    startedAt?: string | null;
    resultsDate?: string | null;
    expireDate?: string;
    timeoutDate?: string;
    resultsStatus?: EStatusCostiFornitore;
    isFinal?: boolean;
    elapsed?: number | null;

    constructor(data?: ISupplierCostsPointer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.searchStatus = _data["searchStatus"] !== undefined ? _data["searchStatus"] : <any>null;
            if (Array.isArray(_data["luoghiFornitoreIDs"])) {
                this.luoghiFornitoreIDs = [] as any;
                for (let item of _data["luoghiFornitoreIDs"])
                    this.luoghiFornitoreIDs!.push(item);
            }
            else {
                this.luoghiFornitoreIDs = <any>null;
            }
            this.objectId = _data["objectId"] !== undefined ? _data["objectId"] : <any>null;
            this.resultsCount = _data["resultsCount"] !== undefined ? _data["resultsCount"] : <any>null;
            this.searchTimeSeconds = _data["searchTimeSeconds"] !== undefined ? _data["searchTimeSeconds"] : <any>null;
            this.startedAt = _data["startedAt"] !== undefined ? _data["startedAt"] : <any>null;
            this.resultsDate = _data["resultsDate"] !== undefined ? _data["resultsDate"] : <any>null;
            this.expireDate = _data["expireDate"] !== undefined ? _data["expireDate"] : <any>null;
            this.timeoutDate = _data["timeoutDate"] !== undefined ? _data["timeoutDate"] : <any>null;
            this.resultsStatus = _data["resultsStatus"] !== undefined ? _data["resultsStatus"] : <any>null;
            this.isFinal = _data["isFinal"] !== undefined ? _data["isFinal"] : <any>null;
            this.elapsed = _data["elapsed"] !== undefined ? _data["elapsed"] : <any>null;
        }
    }

    static fromJS(data: any): SupplierCostsPointer {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierCostsPointer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["searchStatus"] = this.searchStatus !== undefined ? this.searchStatus : <any>null;
        if (Array.isArray(this.luoghiFornitoreIDs)) {
            data["luoghiFornitoreIDs"] = [];
            for (let item of this.luoghiFornitoreIDs)
                data["luoghiFornitoreIDs"].push(item);
        }
        data["objectId"] = this.objectId !== undefined ? this.objectId : <any>null;
        data["resultsCount"] = this.resultsCount !== undefined ? this.resultsCount : <any>null;
        data["searchTimeSeconds"] = this.searchTimeSeconds !== undefined ? this.searchTimeSeconds : <any>null;
        data["startedAt"] = this.startedAt !== undefined ? this.startedAt : <any>null;
        data["resultsDate"] = this.resultsDate !== undefined ? this.resultsDate : <any>null;
        data["expireDate"] = this.expireDate !== undefined ? this.expireDate : <any>null;
        data["timeoutDate"] = this.timeoutDate !== undefined ? this.timeoutDate : <any>null;
        data["resultsStatus"] = this.resultsStatus !== undefined ? this.resultsStatus : <any>null;
        data["isFinal"] = this.isFinal !== undefined ? this.isFinal : <any>null;
        data["elapsed"] = this.elapsed !== undefined ? this.elapsed : <any>null;
        return data;
    }
}

export interface ISupplierCostsPointer {
    supplier?: EFornitore;
    key?: string;
    searchStatus?: EStatusCostiFornitore;
    luoghiFornitoreIDs?: number[];
    objectId?: string | null;
    resultsCount?: number | null;
    searchTimeSeconds?: number | null;
    startedAt?: string | null;
    resultsDate?: string | null;
    expireDate?: string;
    timeoutDate?: string;
    resultsStatus?: EStatusCostiFornitore;
    isFinal?: boolean;
    elapsed?: number | null;
}

export enum EStatusCostiFornitore {
    Ready = "Ready",
    Running = "Running",
    Done = "Done",
    Error = "Error",
    Expired = "Expired",
    Empty = "Empty",
}

export class GetCacheIndexRequest extends SiteRequest implements IGetCacheIndexRequest {
    /** Chiave da cercare */
    key?: string;

    constructor(data?: IGetCacheIndexRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
        }
    }

    static fromJS(data: any): GetCacheIndexRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCacheIndexRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCacheIndexRequest extends ISiteRequest {
    /** Chiave da cercare */
    key?: string;
}

export class ExpireCacheRequest extends GetCacheIndexRequest implements IExpireCacheRequest {
    fornitore?: EFornitore | null;

    constructor(data?: IExpireCacheRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
        }
    }

    static fromJS(data: any): ExpireCacheRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExpireCacheRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IExpireCacheRequest extends IGetCacheIndexRequest {
    fornitore?: EFornitore | null;
}

export class GetFullContentInfoResponse extends OkApiResponse implements IGetFullContentInfoResponse {
    notFound?: boolean;
    providerCustomDataJson?: string | null;

    constructor(data?: IGetFullContentInfoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notFound = _data["notFound"] !== undefined ? _data["notFound"] : <any>null;
            this.providerCustomDataJson = _data["providerCustomDataJson"] !== undefined ? _data["providerCustomDataJson"] : <any>null;
        }
    }

    static fromJS(data: any): GetFullContentInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFullContentInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notFound"] = this.notFound !== undefined ? this.notFound : <any>null;
        data["providerCustomDataJson"] = this.providerCustomDataJson !== undefined ? this.providerCustomDataJson : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFullContentInfoResponse extends IOkApiResponse {
    notFound?: boolean;
    providerCustomDataJson?: string | null;
}

export class GetFullContentInfoRequest extends SiteRequest implements IGetFullContentInfoRequest {
    jobID!: string;
    resultID!: string;
    serviceID!: number;
    typeID!: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;

    constructor(data?: IGetFullContentInfoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : <any>null;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : <any>null;
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : <any>null;
            this.departureID = _data["departureID"] !== undefined ? _data["departureID"] : <any>null;
            this.optionID = _data["optionID"] !== undefined ? _data["optionID"] : <any>null;
            this.optionItemID = _data["optionItemID"] !== undefined ? _data["optionItemID"] : <any>null;
        }
    }

    static fromJS(data: any): GetFullContentInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFullContentInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["resultID"] = this.resultID !== undefined ? this.resultID : <any>null;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : <any>null;
        data["typeID"] = this.typeID !== undefined ? this.typeID : <any>null;
        data["departureID"] = this.departureID !== undefined ? this.departureID : <any>null;
        data["optionID"] = this.optionID !== undefined ? this.optionID : <any>null;
        data["optionItemID"] = this.optionItemID !== undefined ? this.optionItemID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFullContentInfoRequest extends ISiteRequest {
    jobID: string;
    resultID: string;
    serviceID: number;
    typeID: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;
}

export class GetPoliciesResponse extends OkApiResponse implements IGetPoliciesResponse {
    notFound?: boolean;
    nota?: string | null;
    nonRimborsabile?: boolean;
    pagamentoImmediato?: boolean;
    dataPenale?: string | null;
    importoPenale?: number | null;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    supplementi?: Supplemento[] | null;
    /** Testi delle penali descrittive. Se c'è un articolo in arrivo dall'H2H usa quello. Altrimenti cerca le penali di riga
negli articoli */
    penaliDescrittive?: TripTextHtml[] | null;

    constructor(data?: IGetPoliciesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notFound = _data["notFound"] !== undefined ? _data["notFound"] : <any>null;
            this.nota = _data["nota"] !== undefined ? _data["nota"] : <any>null;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : <any>null;
            this.pagamentoImmediato = _data["pagamentoImmediato"] !== undefined ? _data["pagamentoImmediato"] : <any>null;
            this.dataPenale = _data["dataPenale"] !== undefined ? _data["dataPenale"] : <any>null;
            this.importoPenale = _data["importoPenale"] !== undefined ? _data["importoPenale"] : <any>null;
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(DisponibilitaTipologiaOfferta.fromJS(item));
            }
            else {
                this.offerte = <any>null;
            }
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(Supplemento.fromJS(item));
            }
            else {
                this.supplementi = <any>null;
            }
            if (Array.isArray(_data["penaliDescrittive"])) {
                this.penaliDescrittive = [] as any;
                for (let item of _data["penaliDescrittive"])
                    this.penaliDescrittive!.push(TripTextHtml.fromJS(item));
            }
            else {
                this.penaliDescrittive = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPoliciesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPoliciesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notFound"] = this.notFound !== undefined ? this.notFound : <any>null;
        data["nota"] = this.nota !== undefined ? this.nota : <any>null;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : <any>null;
        data["pagamentoImmediato"] = this.pagamentoImmediato !== undefined ? this.pagamentoImmediato : <any>null;
        data["dataPenale"] = this.dataPenale !== undefined ? this.dataPenale : <any>null;
        data["importoPenale"] = this.importoPenale !== undefined ? this.importoPenale : <any>null;
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item.toJSON());
        }
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item.toJSON());
        }
        if (Array.isArray(this.penaliDescrittive)) {
            data["penaliDescrittive"] = [];
            for (let item of this.penaliDescrittive)
                data["penaliDescrittive"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPoliciesResponse extends IOkApiResponse {
    notFound?: boolean;
    nota?: string | null;
    nonRimborsabile?: boolean;
    pagamentoImmediato?: boolean;
    dataPenale?: string | null;
    importoPenale?: number | null;
    offerte?: DisponibilitaTipologiaOfferta[] | null;
    supplementi?: Supplemento[] | null;
    /** Testi delle penali descrittive. Se c'è un articolo in arrivo dall'H2H usa quello. Altrimenti cerca le penali di riga
negli articoli */
    penaliDescrittive?: TripTextHtml[] | null;
}

export class GetPoliciesRequest extends SiteRequest implements IGetPoliciesRequest {
    jobID!: string;
    resultID!: string;
    serviceID!: number;
    typeID!: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;

    constructor(data?: IGetPoliciesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : <any>null;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : <any>null;
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : <any>null;
            this.departureID = _data["departureID"] !== undefined ? _data["departureID"] : <any>null;
            this.optionID = _data["optionID"] !== undefined ? _data["optionID"] : <any>null;
            this.optionItemID = _data["optionItemID"] !== undefined ? _data["optionItemID"] : <any>null;
        }
    }

    static fromJS(data: any): GetPoliciesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPoliciesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["resultID"] = this.resultID !== undefined ? this.resultID : <any>null;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : <any>null;
        data["typeID"] = this.typeID !== undefined ? this.typeID : <any>null;
        data["departureID"] = this.departureID !== undefined ? this.departureID : <any>null;
        data["optionID"] = this.optionID !== undefined ? this.optionID : <any>null;
        data["optionItemID"] = this.optionItemID !== undefined ? this.optionItemID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPoliciesRequest extends ISiteRequest {
    jobID: string;
    resultID: string;
    serviceID: number;
    typeID: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;
}

export class GetQueuesResponse extends OkApiResponse implements IGetQueuesResponse {
    cacheSummary?: QueueStats | null;
    cacheStats?: CacheHitStat[] | null;
    lastSarches?: SearchItem[] | null;
    suppliersStatus?: SupplierSearchStats[] | null;
    suppliersSearchStatsTotals?: SuppliersSearchStatsTotals | null;
    searchesByTime?: QueueChartData[] | null;

    constructor(data?: IGetQueuesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cacheSummary = _data["cacheSummary"] ? QueueStats.fromJS(_data["cacheSummary"]) : <any>null;
            if (Array.isArray(_data["cacheStats"])) {
                this.cacheStats = [] as any;
                for (let item of _data["cacheStats"])
                    this.cacheStats!.push(CacheHitStat.fromJS(item));
            }
            else {
                this.cacheStats = <any>null;
            }
            if (Array.isArray(_data["lastSarches"])) {
                this.lastSarches = [] as any;
                for (let item of _data["lastSarches"])
                    this.lastSarches!.push(SearchItem.fromJS(item));
            }
            else {
                this.lastSarches = <any>null;
            }
            if (Array.isArray(_data["suppliersStatus"])) {
                this.suppliersStatus = [] as any;
                for (let item of _data["suppliersStatus"])
                    this.suppliersStatus!.push(SupplierSearchStats.fromJS(item));
            }
            else {
                this.suppliersStatus = <any>null;
            }
            this.suppliersSearchStatsTotals = _data["suppliersSearchStatsTotals"] ? SuppliersSearchStatsTotals.fromJS(_data["suppliersSearchStatsTotals"]) : <any>null;
            if (Array.isArray(_data["searchesByTime"])) {
                this.searchesByTime = [] as any;
                for (let item of _data["searchesByTime"])
                    this.searchesByTime!.push(QueueChartData.fromJS(item));
            }
            else {
                this.searchesByTime = <any>null;
            }
        }
    }

    static fromJS(data: any): GetQueuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cacheSummary"] = this.cacheSummary ? this.cacheSummary.toJSON() : <any>null;
        if (Array.isArray(this.cacheStats)) {
            data["cacheStats"] = [];
            for (let item of this.cacheStats)
                data["cacheStats"].push(item.toJSON());
        }
        if (Array.isArray(this.lastSarches)) {
            data["lastSarches"] = [];
            for (let item of this.lastSarches)
                data["lastSarches"].push(item.toJSON());
        }
        if (Array.isArray(this.suppliersStatus)) {
            data["suppliersStatus"] = [];
            for (let item of this.suppliersStatus)
                data["suppliersStatus"].push(item.toJSON());
        }
        data["suppliersSearchStatsTotals"] = this.suppliersSearchStatsTotals ? this.suppliersSearchStatsTotals.toJSON() : <any>null;
        if (Array.isArray(this.searchesByTime)) {
            data["searchesByTime"] = [];
            for (let item of this.searchesByTime)
                data["searchesByTime"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetQueuesResponse extends IOkApiResponse {
    cacheSummary?: QueueStats | null;
    cacheStats?: CacheHitStat[] | null;
    lastSarches?: SearchItem[] | null;
    suppliersStatus?: SupplierSearchStats[] | null;
    suppliersSearchStatsTotals?: SuppliersSearchStatsTotals | null;
    searchesByTime?: QueueChartData[] | null;
}

export class QueueStats implements IQueueStats {
    items?: number;
    size?: number;
    avgSize?: number | null;
    storageSize?: number;

    constructor(data?: IQueueStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.items = _data["items"] !== undefined ? _data["items"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
            this.avgSize = _data["avgSize"] !== undefined ? _data["avgSize"] : <any>null;
            this.storageSize = _data["storageSize"] !== undefined ? _data["storageSize"] : <any>null;
        }
    }

    static fromJS(data: any): QueueStats {
        data = typeof data === 'object' ? data : {};
        let result = new QueueStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["items"] = this.items !== undefined ? this.items : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        data["avgSize"] = this.avgSize !== undefined ? this.avgSize : <any>null;
        data["storageSize"] = this.storageSize !== undefined ? this.storageSize : <any>null;
        return data;
    }
}

export interface IQueueStats {
    items?: number;
    size?: number;
    avgSize?: number | null;
    storageSize?: number;
}

export class CacheHitStat implements ICacheHitStat {
    hits?: number;
    count?: number;

    constructor(data?: ICacheHitStat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hits = _data["hits"] !== undefined ? _data["hits"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): CacheHitStat {
        data = typeof data === 'object' ? data : {};
        let result = new CacheHitStat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hits"] = this.hits !== undefined ? this.hits : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data;
    }
}

export interface ICacheHitStat {
    hits?: number;
    count?: number;
}

export class SearchItem implements ISearchItem {
    data?: string;
    tipo?: ETipoServizioSearch;
    luogo?: string | null;
    dal?: string;
    al?: string;
    abbinamenti?: number;
    adulti?: number;
    bambini?: number;
    infant?: number;
    stato?: EStatusCostiFornitore;
    statoID?: number;
    utente?: string | null;
    supplierCompleti?: number;
    supplierTotali?: number;

    constructor(data?: ISearchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.abbinamenti = _data["abbinamenti"] !== undefined ? _data["abbinamenti"] : <any>null;
            this.adulti = _data["adulti"] !== undefined ? _data["adulti"] : <any>null;
            this.bambini = _data["bambini"] !== undefined ? _data["bambini"] : <any>null;
            this.infant = _data["infant"] !== undefined ? _data["infant"] : <any>null;
            this.stato = _data["stato"] !== undefined ? _data["stato"] : <any>null;
            this.statoID = _data["statoID"] !== undefined ? _data["statoID"] : <any>null;
            this.utente = _data["utente"] !== undefined ? _data["utente"] : <any>null;
            this.supplierCompleti = _data["supplierCompleti"] !== undefined ? _data["supplierCompleti"] : <any>null;
            this.supplierTotali = _data["supplierTotali"] !== undefined ? _data["supplierTotali"] : <any>null;
        }
    }

    static fromJS(data: any): SearchItem {
        data = typeof data === 'object' ? data : {};
        let result = new SearchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["abbinamenti"] = this.abbinamenti !== undefined ? this.abbinamenti : <any>null;
        data["adulti"] = this.adulti !== undefined ? this.adulti : <any>null;
        data["bambini"] = this.bambini !== undefined ? this.bambini : <any>null;
        data["infant"] = this.infant !== undefined ? this.infant : <any>null;
        data["stato"] = this.stato !== undefined ? this.stato : <any>null;
        data["statoID"] = this.statoID !== undefined ? this.statoID : <any>null;
        data["utente"] = this.utente !== undefined ? this.utente : <any>null;
        data["supplierCompleti"] = this.supplierCompleti !== undefined ? this.supplierCompleti : <any>null;
        data["supplierTotali"] = this.supplierTotali !== undefined ? this.supplierTotali : <any>null;
        return data;
    }
}

export interface ISearchItem {
    data?: string;
    tipo?: ETipoServizioSearch;
    luogo?: string | null;
    dal?: string;
    al?: string;
    abbinamenti?: number;
    adulti?: number;
    bambini?: number;
    infant?: number;
    stato?: EStatusCostiFornitore;
    statoID?: number;
    utente?: string | null;
    supplierCompleti?: number;
    supplierTotali?: number;
}

export class SupplierSearchStats implements ISupplierSearchStats {
    supplier?: string | null;
    lastRunTime?: string | null;
    running?: number;
    total?: number;
    complete?: number;
    minSearchTimeSec?: number | null;
    maxSearchTimeSec?: number | null;
    avgSearchTimeSec?: number | null;

    constructor(data?: ISupplierSearchStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
            this.lastRunTime = _data["lastRunTime"] !== undefined ? _data["lastRunTime"] : <any>null;
            this.running = _data["running"] !== undefined ? _data["running"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.complete = _data["complete"] !== undefined ? _data["complete"] : <any>null;
            this.minSearchTimeSec = _data["minSearchTimeSec"] !== undefined ? _data["minSearchTimeSec"] : <any>null;
            this.maxSearchTimeSec = _data["maxSearchTimeSec"] !== undefined ? _data["maxSearchTimeSec"] : <any>null;
            this.avgSearchTimeSec = _data["avgSearchTimeSec"] !== undefined ? _data["avgSearchTimeSec"] : <any>null;
        }
    }

    static fromJS(data: any): SupplierSearchStats {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierSearchStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        data["lastRunTime"] = this.lastRunTime !== undefined ? this.lastRunTime : <any>null;
        data["running"] = this.running !== undefined ? this.running : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["complete"] = this.complete !== undefined ? this.complete : <any>null;
        data["minSearchTimeSec"] = this.minSearchTimeSec !== undefined ? this.minSearchTimeSec : <any>null;
        data["maxSearchTimeSec"] = this.maxSearchTimeSec !== undefined ? this.maxSearchTimeSec : <any>null;
        data["avgSearchTimeSec"] = this.avgSearchTimeSec !== undefined ? this.avgSearchTimeSec : <any>null;
        return data;
    }
}

export interface ISupplierSearchStats {
    supplier?: string | null;
    lastRunTime?: string | null;
    running?: number;
    total?: number;
    complete?: number;
    minSearchTimeSec?: number | null;
    maxSearchTimeSec?: number | null;
    avgSearchTimeSec?: number | null;
}

export class SuppliersSearchStatsTotals implements ISuppliersSearchStatsTotals {
    searches?: number;
    searchesNaar?: number;
    searchesH2H?: number;
    done?: number;
    running?: number;
    faulted?: number;

    constructor(data?: ISuppliersSearchStatsTotals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searches = _data["searches"] !== undefined ? _data["searches"] : <any>null;
            this.searchesNaar = _data["searchesNaar"] !== undefined ? _data["searchesNaar"] : <any>null;
            this.searchesH2H = _data["searchesH2H"] !== undefined ? _data["searchesH2H"] : <any>null;
            this.done = _data["done"] !== undefined ? _data["done"] : <any>null;
            this.running = _data["running"] !== undefined ? _data["running"] : <any>null;
            this.faulted = _data["faulted"] !== undefined ? _data["faulted"] : <any>null;
        }
    }

    static fromJS(data: any): SuppliersSearchStatsTotals {
        data = typeof data === 'object' ? data : {};
        let result = new SuppliersSearchStatsTotals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searches"] = this.searches !== undefined ? this.searches : <any>null;
        data["searchesNaar"] = this.searchesNaar !== undefined ? this.searchesNaar : <any>null;
        data["searchesH2H"] = this.searchesH2H !== undefined ? this.searchesH2H : <any>null;
        data["done"] = this.done !== undefined ? this.done : <any>null;
        data["running"] = this.running !== undefined ? this.running : <any>null;
        data["faulted"] = this.faulted !== undefined ? this.faulted : <any>null;
        return data;
    }
}

export interface ISuppliersSearchStatsTotals {
    searches?: number;
    searchesNaar?: number;
    searchesH2H?: number;
    done?: number;
    running?: number;
    faulted?: number;
}

export class QueueChartData implements IQueueChartData {
    label?: string | null;
    date?: string;
    done?: number;
    faulted?: number;
    running?: number;
    duration?: number | null;
    avg?: number | null;

    constructor(data?: IQueueChartData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.done = _data["done"] !== undefined ? _data["done"] : <any>null;
            this.faulted = _data["faulted"] !== undefined ? _data["faulted"] : <any>null;
            this.running = _data["running"] !== undefined ? _data["running"] : <any>null;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : <any>null;
            this.avg = _data["avg"] !== undefined ? _data["avg"] : <any>null;
        }
    }

    static fromJS(data: any): QueueChartData {
        data = typeof data === 'object' ? data : {};
        let result = new QueueChartData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["done"] = this.done !== undefined ? this.done : <any>null;
        data["faulted"] = this.faulted !== undefined ? this.faulted : <any>null;
        data["running"] = this.running !== undefined ? this.running : <any>null;
        data["duration"] = this.duration !== undefined ? this.duration : <any>null;
        data["avg"] = this.avg !== undefined ? this.avg : <any>null;
        return data;
    }
}

export interface IQueueChartData {
    label?: string | null;
    date?: string;
    done?: number;
    faulted?: number;
    running?: number;
    duration?: number | null;
    avg?: number | null;
}

export class GetSupplierPricesResponse extends OkApiResponse implements IGetSupplierPricesResponse {
    jobID?: string;
    servizi?: ServicePrice[];
    logs?: H2HLog[];
    contracts?: ContractCurrency[];

    constructor(data?: IGetSupplierPricesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServicePrice.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(H2HLog.fromJS(item));
            }
            else {
                this.logs = <any>null;
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(ContractCurrency.fromJS(item));
            }
            else {
                this.contracts = <any>null;
            }
        }
    }

    static fromJS(data: any): GetSupplierPricesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupplierPricesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetSupplierPricesResponse extends IOkApiResponse {
    jobID?: string;
    servizi?: ServicePrice[];
    logs?: H2HLog[];
    contracts?: ContractCurrency[];
}

export class GetRawPricesResponse extends GetSupplierPricesResponse implements IGetRawPricesResponse {
    mappedRequest?: GetSupplierPricesRequest;

    constructor(data?: IGetRawPricesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mappedRequest = _data["mappedRequest"] ? GetSupplierPricesRequest.fromJS(_data["mappedRequest"]) : <any>null;
        }
    }

    static fromJS(data: any): GetRawPricesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRawPricesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappedRequest"] = this.mappedRequest ? this.mappedRequest.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetRawPricesResponse extends IGetSupplierPricesResponse {
    mappedRequest?: GetSupplierPricesRequest;
}

export class GetSupplierPricesRequest extends LocalizedRequest implements IGetSupplierPricesRequest {
    fornitore!: EFornitore;
    tipoLuogoRicercaPrezzi!: ETipoLuogoRicercaPrezzi;
    luogoID?: number;
    luogoDestinazioneID?: number | null;
    data?: string;
    notti?: number;
    tipoServizio!: ETipoServizio;
    camere!: SupplierPricesRoom[];
    listinoPrezzi!: EListinoPrezzi;
    utenteRicercaID?: number | null;
    oraPickup?: number | null;
    oraDropoff?: number | null;
    /** ID di servizio singolo */
    servizioID?: number | null;

    constructor(data?: IGetSupplierPricesRequest) {
        super(data);
        if (!data) {
            this.camere = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            this.tipoLuogoRicercaPrezzi = _data["tipoLuogoRicercaPrezzi"] !== undefined ? _data["tipoLuogoRicercaPrezzi"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            if (Array.isArray(_data["camere"])) {
                this.camere = [] as any;
                for (let item of _data["camere"])
                    this.camere!.push(SupplierPricesRoom.fromJS(item));
            }
            else {
                this.camere = <any>null;
            }
            this.listinoPrezzi = _data["listinoPrezzi"] !== undefined ? _data["listinoPrezzi"] : <any>null;
            this.utenteRicercaID = _data["utenteRicercaID"] !== undefined ? _data["utenteRicercaID"] : <any>null;
            this.oraPickup = _data["oraPickup"] !== undefined ? _data["oraPickup"] : <any>null;
            this.oraDropoff = _data["oraDropoff"] !== undefined ? _data["oraDropoff"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
        }
    }

    static fromJS(data: any): GetSupplierPricesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupplierPricesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        data["tipoLuogoRicercaPrezzi"] = this.tipoLuogoRicercaPrezzi !== undefined ? this.tipoLuogoRicercaPrezzi : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        if (Array.isArray(this.camere)) {
            data["camere"] = [];
            for (let item of this.camere)
                data["camere"].push(item.toJSON());
        }
        data["listinoPrezzi"] = this.listinoPrezzi !== undefined ? this.listinoPrezzi : <any>null;
        data["utenteRicercaID"] = this.utenteRicercaID !== undefined ? this.utenteRicercaID : <any>null;
        data["oraPickup"] = this.oraPickup !== undefined ? this.oraPickup : <any>null;
        data["oraDropoff"] = this.oraDropoff !== undefined ? this.oraDropoff : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSupplierPricesRequest extends ILocalizedRequest {
    fornitore: EFornitore;
    tipoLuogoRicercaPrezzi: ETipoLuogoRicercaPrezzi;
    luogoID?: number;
    luogoDestinazioneID?: number | null;
    data?: string;
    notti?: number;
    tipoServizio: ETipoServizio;
    camere: SupplierPricesRoom[];
    listinoPrezzi: EListinoPrezzi;
    utenteRicercaID?: number | null;
    oraPickup?: number | null;
    oraDropoff?: number | null;
    /** ID di servizio singolo */
    servizioID?: number | null;
}

export enum ETipoLuogoRicercaPrezzi {
    LuogoNaar = "LuogoNaar",
    LuogoFornitore = "LuogoFornitore",
}

export class SupplierPricesRoom implements ISupplierPricesRoom {
    adulti?: number;
    senior?: number;
    bambini?: SupplierPricesChild[] | null;

    constructor(data?: ISupplierPricesRoom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adulti = _data["adulti"] !== undefined ? _data["adulti"] : <any>null;
            this.senior = _data["senior"] !== undefined ? _data["senior"] : <any>null;
            if (Array.isArray(_data["bambini"])) {
                this.bambini = [] as any;
                for (let item of _data["bambini"])
                    this.bambini!.push(SupplierPricesChild.fromJS(item));
            }
            else {
                this.bambini = <any>null;
            }
        }
    }

    static fromJS(data: any): SupplierPricesRoom {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierPricesRoom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adulti"] = this.adulti !== undefined ? this.adulti : <any>null;
        data["senior"] = this.senior !== undefined ? this.senior : <any>null;
        if (Array.isArray(this.bambini)) {
            data["bambini"] = [];
            for (let item of this.bambini)
                data["bambini"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISupplierPricesRoom {
    adulti?: number;
    senior?: number;
    bambini?: SupplierPricesChild[] | null;
}

export class SupplierPricesChild implements ISupplierPricesChild {
    eta?: number;

    constructor(data?: ISupplierPricesChild) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eta = _data["eta"] !== undefined ? _data["eta"] : <any>null;
        }
    }

    static fromJS(data: any): SupplierPricesChild {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierPricesChild();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eta"] = this.eta !== undefined ? this.eta : <any>null;
        return data;
    }
}

export interface ISupplierPricesChild {
    eta?: number;
}

export class ServicePrice implements IServicePrice {
    id?: number;
    uniqueID?: string;
    unmapped?: boolean;
    nome?: string;
    codice?: string;
    details?: boolean;
    roomsCount?: number;
    minPrice?: number;
    results?: DisponibilitaServizio[];

    constructor(data?: IServicePrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.uniqueID = _data["uniqueID"] !== undefined ? _data["uniqueID"] : <any>null;
            this.unmapped = _data["unmapped"] !== undefined ? _data["unmapped"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.details = _data["details"] !== undefined ? _data["details"] : <any>null;
            this.roomsCount = _data["roomsCount"] !== undefined ? _data["roomsCount"] : <any>null;
            this.minPrice = _data["minPrice"] !== undefined ? _data["minPrice"] : <any>null;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DisponibilitaServizio.fromJS(item));
            }
            else {
                this.results = <any>null;
            }
        }
    }

    static fromJS(data: any): ServicePrice {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["uniqueID"] = this.uniqueID !== undefined ? this.uniqueID : <any>null;
        data["unmapped"] = this.unmapped !== undefined ? this.unmapped : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["details"] = this.details !== undefined ? this.details : <any>null;
        data["roomsCount"] = this.roomsCount !== undefined ? this.roomsCount : <any>null;
        data["minPrice"] = this.minPrice !== undefined ? this.minPrice : <any>null;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServicePrice {
    id?: number;
    uniqueID?: string;
    unmapped?: boolean;
    nome?: string;
    codice?: string;
    details?: boolean;
    roomsCount?: number;
    minPrice?: number;
    results?: DisponibilitaServizio[];
}

export class DisponibilitaServizio implements IDisponibilitaServizio {
    servizioID?: number;
    codServizio?: string | null;
    tipologie?: DisponibilitaTipologia[] | null;
    providerCustomData?: string | null;
    nonMappato?: boolean;
    resultID?: number;
    datiCosto?: DisponibilitaDatiCosto | null;
    servizioH2HID?: number | null;
    tipologieByID?: { [key: string]: DisponibilitaTipologia; } | null;

    constructor(data?: IDisponibilitaServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.codServizio = _data["codServizio"] !== undefined ? _data["codServizio"] : <any>null;
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(DisponibilitaTipologia.fromJS(item));
            }
            else {
                this.tipologie = <any>null;
            }
            this.providerCustomData = _data["providerCustomData"] !== undefined ? _data["providerCustomData"] : <any>null;
            this.nonMappato = _data["nonMappato"] !== undefined ? _data["nonMappato"] : <any>null;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : <any>null;
            this.datiCosto = _data["datiCosto"] ? DisponibilitaDatiCosto.fromJS(_data["datiCosto"]) : <any>null;
            this.servizioH2HID = _data["servizioH2HID"] !== undefined ? _data["servizioH2HID"] : <any>null;
            if (_data["tipologieByID"]) {
                this.tipologieByID = {} as any;
                for (let key in _data["tipologieByID"]) {
                    if (_data["tipologieByID"].hasOwnProperty(key))
                        (<any>this.tipologieByID)![key] = _data["tipologieByID"][key] ? DisponibilitaTipologia.fromJS(_data["tipologieByID"][key]) : new DisponibilitaTipologia();
                }
            }
            else {
                this.tipologieByID = <any>null;
            }
        }
    }

    static fromJS(data: any): DisponibilitaServizio {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["codServizio"] = this.codServizio !== undefined ? this.codServizio : <any>null;
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item.toJSON());
        }
        data["providerCustomData"] = this.providerCustomData !== undefined ? this.providerCustomData : <any>null;
        data["nonMappato"] = this.nonMappato !== undefined ? this.nonMappato : <any>null;
        data["resultID"] = this.resultID !== undefined ? this.resultID : <any>null;
        data["datiCosto"] = this.datiCosto ? this.datiCosto.toJSON() : <any>null;
        data["servizioH2HID"] = this.servizioH2HID !== undefined ? this.servizioH2HID : <any>null;
        if (this.tipologieByID) {
            data["tipologieByID"] = {};
            for (let key in this.tipologieByID) {
                if (this.tipologieByID.hasOwnProperty(key))
                    (<any>data["tipologieByID"])[key] = this.tipologieByID[key] ? this.tipologieByID[key].toJSON() : <any>null;
            }
        }
        return data;
    }
}

export interface IDisponibilitaServizio {
    servizioID?: number;
    codServizio?: string | null;
    tipologie?: DisponibilitaTipologia[] | null;
    providerCustomData?: string | null;
    nonMappato?: boolean;
    resultID?: number;
    datiCosto?: DisponibilitaDatiCosto | null;
    servizioH2HID?: number | null;
    tipologieByID?: { [key: string]: DisponibilitaTipologia; } | null;
}

export class DisponibilitaDatiCosto implements IDisponibilitaDatiCosto {
    costiConPrezzoIndicativoIDs?: number[];
    costiConMarkupPersonalizzato?: { [key: string]: number; };

    constructor(data?: IDisponibilitaDatiCosto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["costiConPrezzoIndicativoIDs"])) {
                this.costiConPrezzoIndicativoIDs = [] as any;
                for (let item of _data["costiConPrezzoIndicativoIDs"])
                    this.costiConPrezzoIndicativoIDs!.push(item);
            }
            else {
                this.costiConPrezzoIndicativoIDs = <any>null;
            }
            if (_data["costiConMarkupPersonalizzato"]) {
                this.costiConMarkupPersonalizzato = {} as any;
                for (let key in _data["costiConMarkupPersonalizzato"]) {
                    if (_data["costiConMarkupPersonalizzato"].hasOwnProperty(key))
                        (<any>this.costiConMarkupPersonalizzato)![key] = _data["costiConMarkupPersonalizzato"][key] !== undefined ? _data["costiConMarkupPersonalizzato"][key] : <any>null;
                }
            }
            else {
                this.costiConMarkupPersonalizzato = <any>null;
            }
        }
    }

    static fromJS(data: any): DisponibilitaDatiCosto {
        data = typeof data === 'object' ? data : {};
        let result = new DisponibilitaDatiCosto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costiConPrezzoIndicativoIDs)) {
            data["costiConPrezzoIndicativoIDs"] = [];
            for (let item of this.costiConPrezzoIndicativoIDs)
                data["costiConPrezzoIndicativoIDs"].push(item);
        }
        if (this.costiConMarkupPersonalizzato) {
            data["costiConMarkupPersonalizzato"] = {};
            for (let key in this.costiConMarkupPersonalizzato) {
                if (this.costiConMarkupPersonalizzato.hasOwnProperty(key))
                    (<any>data["costiConMarkupPersonalizzato"])[key] = this.costiConMarkupPersonalizzato[key] !== undefined ? this.costiConMarkupPersonalizzato[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IDisponibilitaDatiCosto {
    costiConPrezzoIndicativoIDs?: number[];
    costiConMarkupPersonalizzato?: { [key: string]: number; };
}

export class H2HLog implements IH2HLog {
    id?: string;
    supplier?: EFornitore;
    jobID?: string;
    itemNr?: number;
    requestData?: string;
    requestSize?: number;
    requestDataType?: ELogDataType;
    responseData?: string;
    responseSize?: number;
    responseDataType?: ELogDataType;
    date?: string;

    constructor(data?: IH2HLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.itemNr = _data["itemNr"] !== undefined ? _data["itemNr"] : <any>null;
            this.requestData = _data["requestData"] !== undefined ? _data["requestData"] : <any>null;
            this.requestSize = _data["requestSize"] !== undefined ? _data["requestSize"] : <any>null;
            this.requestDataType = _data["requestDataType"] !== undefined ? _data["requestDataType"] : <any>null;
            this.responseData = _data["responseData"] !== undefined ? _data["responseData"] : <any>null;
            this.responseSize = _data["responseSize"] !== undefined ? _data["responseSize"] : <any>null;
            this.responseDataType = _data["responseDataType"] !== undefined ? _data["responseDataType"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
        }
    }

    static fromJS(data: any): H2HLog {
        data = typeof data === 'object' ? data : {};
        let result = new H2HLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["itemNr"] = this.itemNr !== undefined ? this.itemNr : <any>null;
        data["requestData"] = this.requestData !== undefined ? this.requestData : <any>null;
        data["requestSize"] = this.requestSize !== undefined ? this.requestSize : <any>null;
        data["requestDataType"] = this.requestDataType !== undefined ? this.requestDataType : <any>null;
        data["responseData"] = this.responseData !== undefined ? this.responseData : <any>null;
        data["responseSize"] = this.responseSize !== undefined ? this.responseSize : <any>null;
        data["responseDataType"] = this.responseDataType !== undefined ? this.responseDataType : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        return data;
    }
}

export interface IH2HLog {
    id?: string;
    supplier?: EFornitore;
    jobID?: string;
    itemNr?: number;
    requestData?: string;
    requestSize?: number;
    requestDataType?: ELogDataType;
    responseData?: string;
    responseSize?: number;
    responseDataType?: ELogDataType;
    date?: string;
}

export enum ELogDataType {
    Text = "Text",
    Xml = "Xml",
    Json = "Json",
}

export class ContractCurrency implements IContractCurrency {
    accordoID?: number;
    codiceValuta?: string;

    constructor(data?: IContractCurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : <any>null;
        }
    }

    static fromJS(data: any): ContractCurrency {
        data = typeof data === 'object' ? data : {};
        let result = new ContractCurrency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : <any>null;
        return data;
    }
}

export interface IContractCurrency {
    accordoID?: number;
    codiceValuta?: string;
}

export class GetRawPricesRequest extends LocalizedRequest implements IGetRawPricesRequest {
    jobID!: string;
    resultID!: string;

    constructor(data?: IGetRawPricesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : <any>null;
        }
    }

    static fromJS(data: any): GetRawPricesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRawPricesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["resultID"] = this.resultID !== undefined ? this.resultID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetRawPricesRequest extends ILocalizedRequest {
    jobID: string;
    resultID: string;
}

export class GetResultsResponse extends OkApiResponse implements IGetResultsResponse {
    dati?: RicercaDati;
    idsByPrice?: string[];

    constructor(data?: IGetResultsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dati = _data["dati"] ? RicercaDati.fromJS(_data["dati"]) : <any>null;
            if (Array.isArray(_data["idsByPrice"])) {
                this.idsByPrice = [] as any;
                for (let item of _data["idsByPrice"])
                    this.idsByPrice!.push(item);
            }
            else {
                this.idsByPrice = <any>null;
            }
        }
    }

    static fromJS(data: any): GetResultsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetResultsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dati"] = this.dati ? this.dati.toJSON() : <any>null;
        if (Array.isArray(this.idsByPrice)) {
            data["idsByPrice"] = [];
            for (let item of this.idsByPrice)
                data["idsByPrice"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetResultsResponse extends IOkApiResponse {
    dati?: RicercaDati;
    idsByPrice?: string[];
}

export class RicercaDati implements IRicercaDati {
    jobID?: string;
    generationID?: number;
    servizi?: ServizioSearch[];
    minPrice?: number | null;
    maxPrice?: number | null;
    cacheResult?: boolean;
    descriptions?: string[] | null;
    sourceResults?: SourceResultPointer[];
    hasExpiredCosts?: boolean;

    constructor(data?: IRicercaDati) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.generationID = _data["generationID"] !== undefined ? _data["generationID"] : <any>null;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioSearch.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
            this.minPrice = _data["minPrice"] !== undefined ? _data["minPrice"] : <any>null;
            this.maxPrice = _data["maxPrice"] !== undefined ? _data["maxPrice"] : <any>null;
            this.cacheResult = _data["cacheResult"] !== undefined ? _data["cacheResult"] : <any>null;
            if (Array.isArray(_data["descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["descriptions"])
                    this.descriptions!.push(item);
            }
            else {
                this.descriptions = <any>null;
            }
            if (Array.isArray(_data["sourceResults"])) {
                this.sourceResults = [] as any;
                for (let item of _data["sourceResults"])
                    this.sourceResults!.push(SourceResultPointer.fromJS(item));
            }
            else {
                this.sourceResults = <any>null;
            }
            this.hasExpiredCosts = _data["hasExpiredCosts"] !== undefined ? _data["hasExpiredCosts"] : <any>null;
        }
    }

    static fromJS(data: any): RicercaDati {
        data = typeof data === 'object' ? data : {};
        let result = new RicercaDati();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["generationID"] = this.generationID !== undefined ? this.generationID : <any>null;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        data["minPrice"] = this.minPrice !== undefined ? this.minPrice : <any>null;
        data["maxPrice"] = this.maxPrice !== undefined ? this.maxPrice : <any>null;
        data["cacheResult"] = this.cacheResult !== undefined ? this.cacheResult : <any>null;
        if (Array.isArray(this.descriptions)) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item);
        }
        if (Array.isArray(this.sourceResults)) {
            data["sourceResults"] = [];
            for (let item of this.sourceResults)
                data["sourceResults"].push(item.toJSON());
        }
        data["hasExpiredCosts"] = this.hasExpiredCosts !== undefined ? this.hasExpiredCosts : <any>null;
        return data;
    }
}

export interface IRicercaDati {
    jobID?: string;
    generationID?: number;
    servizi?: ServizioSearch[];
    minPrice?: number | null;
    maxPrice?: number | null;
    cacheResult?: boolean;
    descriptions?: string[] | null;
    sourceResults?: SourceResultPointer[];
    hasExpiredCosts?: boolean;
}

export class ServizioSearch implements IServizioSearch {
    id?: string | null;
    codice?: string | null;
    nonMappato?: boolean;
    servizioID?: number;
    prezzoPieno?: number | null;
    prezzo?: number;
    disponibilitaPrezzoMinimo?: EStatoDisponibilita;
    abbinamentiTipologie?: AbbinamentoTipologie[] | null;
    hasAvailable?: boolean;
    isOpen?: boolean;
    drilledDown?: boolean;
    bests?: Best[] | null;
    hasExpired?: boolean;

    constructor(data?: IServizioSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.nonMappato = _data["nonMappato"] !== undefined ? _data["nonMappato"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.disponibilitaPrezzoMinimo = _data["disponibilitaPrezzoMinimo"] !== undefined ? _data["disponibilitaPrezzoMinimo"] : <any>null;
            if (Array.isArray(_data["abbinamentiTipologie"])) {
                this.abbinamentiTipologie = [] as any;
                for (let item of _data["abbinamentiTipologie"])
                    this.abbinamentiTipologie!.push(AbbinamentoTipologie.fromJS(item));
            }
            else {
                this.abbinamentiTipologie = <any>null;
            }
            this.hasAvailable = _data["hasAvailable"] !== undefined ? _data["hasAvailable"] : <any>null;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : <any>null;
            this.drilledDown = _data["drilledDown"] !== undefined ? _data["drilledDown"] : <any>null;
            if (Array.isArray(_data["bests"])) {
                this.bests = [] as any;
                for (let item of _data["bests"])
                    this.bests!.push(Best.fromJS(item));
            }
            else {
                this.bests = <any>null;
            }
            this.hasExpired = _data["hasExpired"] !== undefined ? _data["hasExpired"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["nonMappato"] = this.nonMappato !== undefined ? this.nonMappato : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["disponibilitaPrezzoMinimo"] = this.disponibilitaPrezzoMinimo !== undefined ? this.disponibilitaPrezzoMinimo : <any>null;
        if (Array.isArray(this.abbinamentiTipologie)) {
            data["abbinamentiTipologie"] = [];
            for (let item of this.abbinamentiTipologie)
                data["abbinamentiTipologie"].push(item.toJSON());
        }
        data["hasAvailable"] = this.hasAvailable !== undefined ? this.hasAvailable : <any>null;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : <any>null;
        data["drilledDown"] = this.drilledDown !== undefined ? this.drilledDown : <any>null;
        if (Array.isArray(this.bests)) {
            data["bests"] = [];
            for (let item of this.bests)
                data["bests"].push(item.toJSON());
        }
        data["hasExpired"] = this.hasExpired !== undefined ? this.hasExpired : <any>null;
        return data;
    }
}

export interface IServizioSearch {
    id?: string | null;
    codice?: string | null;
    nonMappato?: boolean;
    servizioID?: number;
    prezzoPieno?: number | null;
    prezzo?: number;
    disponibilitaPrezzoMinimo?: EStatoDisponibilita;
    abbinamentiTipologie?: AbbinamentoTipologie[] | null;
    hasAvailable?: boolean;
    isOpen?: boolean;
    drilledDown?: boolean;
    bests?: Best[] | null;
    hasExpired?: boolean;
}

export class AbbinamentoTipologie implements IAbbinamentoTipologie {
    gruppoID?: number;
    nomeGruppo?: string;
    nomiPax?: string;
    macroTipologie?: GruppoMacroTipologie[];

    constructor(data?: IAbbinamentoTipologie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gruppoID = _data["gruppoID"] !== undefined ? _data["gruppoID"] : <any>null;
            this.nomeGruppo = _data["nomeGruppo"] !== undefined ? _data["nomeGruppo"] : <any>null;
            this.nomiPax = _data["nomiPax"] !== undefined ? _data["nomiPax"] : <any>null;
            if (Array.isArray(_data["macroTipologie"])) {
                this.macroTipologie = [] as any;
                for (let item of _data["macroTipologie"])
                    this.macroTipologie!.push(GruppoMacroTipologie.fromJS(item));
            }
            else {
                this.macroTipologie = <any>null;
            }
        }
    }

    static fromJS(data: any): AbbinamentoTipologie {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoTipologie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gruppoID"] = this.gruppoID !== undefined ? this.gruppoID : <any>null;
        data["nomeGruppo"] = this.nomeGruppo !== undefined ? this.nomeGruppo : <any>null;
        data["nomiPax"] = this.nomiPax !== undefined ? this.nomiPax : <any>null;
        if (Array.isArray(this.macroTipologie)) {
            data["macroTipologie"] = [];
            for (let item of this.macroTipologie)
                data["macroTipologie"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAbbinamentoTipologie {
    gruppoID?: number;
    nomeGruppo?: string;
    nomiPax?: string;
    macroTipologie?: GruppoMacroTipologie[];
}

export class GruppoMacroTipologie implements IGruppoMacroTipologie {
    nome?: string | null;
    tipologie?: TipologiaSearch[];

    constructor(data?: IGruppoMacroTipologie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(TipologiaSearch.fromJS(item));
            }
            else {
                this.tipologie = <any>null;
            }
        }
    }

    static fromJS(data: any): GruppoMacroTipologie {
        data = typeof data === 'object' ? data : {};
        let result = new GruppoMacroTipologie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGruppoMacroTipologie {
    nome?: string | null;
    tipologie?: TipologiaSearch[];
}

export class TipologiaSearch implements ITipologiaSearch {
    id?: string | null;
    sourceMainCacheID?: string | null;
    sourceResultItemID?: number;
    sourceResultID?: number;
    supplierID?: number;
    fornitore?: string | null;
    gruppoID?: number;
    nome?: string | null;
    prezzoPieno?: number | null;
    prezzo?: number;
    prezzoIndicativo?: boolean;
    disponibilita?: EStatoDisponibilita;
    nonRimborsabile?: boolean;
    instantPurchase?: boolean;
    supplementi?: Supplemento[] | null;
    partenze?: PartenzaSearch[] | null;
    hashcode?: string | null;
    fullContent?: boolean;
    hashMacro?: string | null;
    score?: number;

    constructor(data?: ITipologiaSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.sourceMainCacheID = _data["sourceMainCacheID"] !== undefined ? _data["sourceMainCacheID"] : <any>null;
            this.sourceResultItemID = _data["sourceResultItemID"] !== undefined ? _data["sourceResultItemID"] : <any>null;
            this.sourceResultID = _data["sourceResultID"] !== undefined ? _data["sourceResultID"] : <any>null;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : <any>null;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            this.gruppoID = _data["gruppoID"] !== undefined ? _data["gruppoID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.prezzoIndicativo = _data["prezzoIndicativo"] !== undefined ? _data["prezzoIndicativo"] : <any>null;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : <any>null;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : <any>null;
            this.instantPurchase = _data["instantPurchase"] !== undefined ? _data["instantPurchase"] : <any>null;
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(Supplemento.fromJS(item));
            }
            else {
                this.supplementi = <any>null;
            }
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(PartenzaSearch.fromJS(item));
            }
            else {
                this.partenze = <any>null;
            }
            this.hashcode = _data["hashcode"] !== undefined ? _data["hashcode"] : <any>null;
            this.fullContent = _data["fullContent"] !== undefined ? _data["fullContent"] : <any>null;
            this.hashMacro = _data["hashMacro"] !== undefined ? _data["hashMacro"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
        }
    }

    static fromJS(data: any): TipologiaSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TipologiaSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["sourceMainCacheID"] = this.sourceMainCacheID !== undefined ? this.sourceMainCacheID : <any>null;
        data["sourceResultItemID"] = this.sourceResultItemID !== undefined ? this.sourceResultItemID : <any>null;
        data["sourceResultID"] = this.sourceResultID !== undefined ? this.sourceResultID : <any>null;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : <any>null;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        data["gruppoID"] = this.gruppoID !== undefined ? this.gruppoID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["prezzoIndicativo"] = this.prezzoIndicativo !== undefined ? this.prezzoIndicativo : <any>null;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : <any>null;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : <any>null;
        data["instantPurchase"] = this.instantPurchase !== undefined ? this.instantPurchase : <any>null;
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item.toJSON());
        }
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item.toJSON());
        }
        data["hashcode"] = this.hashcode !== undefined ? this.hashcode : <any>null;
        data["fullContent"] = this.fullContent !== undefined ? this.fullContent : <any>null;
        data["hashMacro"] = this.hashMacro !== undefined ? this.hashMacro : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        return data;
    }
}

export interface ITipologiaSearch {
    id?: string | null;
    sourceMainCacheID?: string | null;
    sourceResultItemID?: number;
    sourceResultID?: number;
    supplierID?: number;
    fornitore?: string | null;
    gruppoID?: number;
    nome?: string | null;
    prezzoPieno?: number | null;
    prezzo?: number;
    prezzoIndicativo?: boolean;
    disponibilita?: EStatoDisponibilita;
    nonRimborsabile?: boolean;
    instantPurchase?: boolean;
    supplementi?: Supplemento[] | null;
    partenze?: PartenzaSearch[] | null;
    hashcode?: string | null;
    fullContent?: boolean;
    hashMacro?: string | null;
    score?: number;
}

export class PartenzaSearch implements IPartenzaSearch {
    sourceReferenceID?: number;
    data?: string;
    prezzoPieno?: number | null;
    prezzo?: number;
    prezzoIndicativo?: boolean;
    disponibilita?: EStatoDisponibilita;
    supplementi?: Supplemento[] | null;
    garantita?: boolean;
    italiano?: boolean;
    inglese?: boolean;
    francese?: boolean;
    tedesco?: boolean;
    spagnolo?: boolean;

    constructor(data?: IPartenzaSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceReferenceID = _data["sourceReferenceID"] !== undefined ? _data["sourceReferenceID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.prezzoIndicativo = _data["prezzoIndicativo"] !== undefined ? _data["prezzoIndicativo"] : <any>null;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : <any>null;
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(Supplemento.fromJS(item));
            }
            else {
                this.supplementi = <any>null;
            }
            this.garantita = _data["garantita"] !== undefined ? _data["garantita"] : <any>null;
            this.italiano = _data["italiano"] !== undefined ? _data["italiano"] : <any>null;
            this.inglese = _data["inglese"] !== undefined ? _data["inglese"] : <any>null;
            this.francese = _data["francese"] !== undefined ? _data["francese"] : <any>null;
            this.tedesco = _data["tedesco"] !== undefined ? _data["tedesco"] : <any>null;
            this.spagnolo = _data["spagnolo"] !== undefined ? _data["spagnolo"] : <any>null;
        }
    }

    static fromJS(data: any): PartenzaSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PartenzaSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceReferenceID"] = this.sourceReferenceID !== undefined ? this.sourceReferenceID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["prezzoIndicativo"] = this.prezzoIndicativo !== undefined ? this.prezzoIndicativo : <any>null;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : <any>null;
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item.toJSON());
        }
        data["garantita"] = this.garantita !== undefined ? this.garantita : <any>null;
        data["italiano"] = this.italiano !== undefined ? this.italiano : <any>null;
        data["inglese"] = this.inglese !== undefined ? this.inglese : <any>null;
        data["francese"] = this.francese !== undefined ? this.francese : <any>null;
        data["tedesco"] = this.tedesco !== undefined ? this.tedesco : <any>null;
        data["spagnolo"] = this.spagnolo !== undefined ? this.spagnolo : <any>null;
        return data;
    }
}

export interface IPartenzaSearch {
    sourceReferenceID?: number;
    data?: string;
    prezzoPieno?: number | null;
    prezzo?: number;
    prezzoIndicativo?: boolean;
    disponibilita?: EStatoDisponibilita;
    supplementi?: Supplemento[] | null;
    garantita?: boolean;
    italiano?: boolean;
    inglese?: boolean;
    francese?: boolean;
    tedesco?: boolean;
    spagnolo?: boolean;
}

export class Best implements IBest {
    attributoID?: number | null;
    nomeMacro?: string | null;
    prezzoPieno?: number | null;
    prezzo?: number;
    nonRimborsabile?: boolean;
    instantPurchase?: boolean;
    haPartenze?: boolean;
    disponibilita?: EStatoDisponibilita;
    gruppo?: string | null;
    chiave?: string;
    acquistabile?: boolean;
    serviceSearchDataBuffer?: string | null;
    nomeMacroDescID?: number | null;
    gruppoDescID?: number | null;

    constructor(data?: IBest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributoID = _data["attributoID"] !== undefined ? _data["attributoID"] : <any>null;
            this.nomeMacro = _data["nomeMacro"] !== undefined ? _data["nomeMacro"] : <any>null;
            this.prezzoPieno = _data["prezzoPieno"] !== undefined ? _data["prezzoPieno"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.nonRimborsabile = _data["nonRimborsabile"] !== undefined ? _data["nonRimborsabile"] : <any>null;
            this.instantPurchase = _data["instantPurchase"] !== undefined ? _data["instantPurchase"] : <any>null;
            this.haPartenze = _data["haPartenze"] !== undefined ? _data["haPartenze"] : <any>null;
            this.disponibilita = _data["disponibilita"] !== undefined ? _data["disponibilita"] : <any>null;
            this.gruppo = _data["gruppo"] !== undefined ? _data["gruppo"] : <any>null;
            this.chiave = _data["chiave"] !== undefined ? _data["chiave"] : <any>null;
            this.acquistabile = _data["acquistabile"] !== undefined ? _data["acquistabile"] : <any>null;
            this.serviceSearchDataBuffer = _data["serviceSearchDataBuffer"] !== undefined ? _data["serviceSearchDataBuffer"] : <any>null;
            this.nomeMacroDescID = _data["nomeMacroDescID"] !== undefined ? _data["nomeMacroDescID"] : <any>null;
            this.gruppoDescID = _data["gruppoDescID"] !== undefined ? _data["gruppoDescID"] : <any>null;
        }
    }

    static fromJS(data: any): Best {
        data = typeof data === 'object' ? data : {};
        let result = new Best();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributoID"] = this.attributoID !== undefined ? this.attributoID : <any>null;
        data["nomeMacro"] = this.nomeMacro !== undefined ? this.nomeMacro : <any>null;
        data["prezzoPieno"] = this.prezzoPieno !== undefined ? this.prezzoPieno : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["nonRimborsabile"] = this.nonRimborsabile !== undefined ? this.nonRimborsabile : <any>null;
        data["instantPurchase"] = this.instantPurchase !== undefined ? this.instantPurchase : <any>null;
        data["haPartenze"] = this.haPartenze !== undefined ? this.haPartenze : <any>null;
        data["disponibilita"] = this.disponibilita !== undefined ? this.disponibilita : <any>null;
        data["gruppo"] = this.gruppo !== undefined ? this.gruppo : <any>null;
        data["chiave"] = this.chiave !== undefined ? this.chiave : <any>null;
        data["acquistabile"] = this.acquistabile !== undefined ? this.acquistabile : <any>null;
        data["serviceSearchDataBuffer"] = this.serviceSearchDataBuffer !== undefined ? this.serviceSearchDataBuffer : <any>null;
        data["nomeMacroDescID"] = this.nomeMacroDescID !== undefined ? this.nomeMacroDescID : <any>null;
        data["gruppoDescID"] = this.gruppoDescID !== undefined ? this.gruppoDescID : <any>null;
        return data;
    }
}

export interface IBest {
    attributoID?: number | null;
    nomeMacro?: string | null;
    prezzoPieno?: number | null;
    prezzo?: number;
    nonRimborsabile?: boolean;
    instantPurchase?: boolean;
    haPartenze?: boolean;
    disponibilita?: EStatoDisponibilita;
    gruppo?: string | null;
    chiave?: string;
    acquistabile?: boolean;
    serviceSearchDataBuffer?: string | null;
    nomeMacroDescID?: number | null;
    gruppoDescID?: number | null;
}

export class SourceResultPointer implements ISourceResultPointer {
    fornitore?: EFornitore;
    resultID?: string;
    resultIDStr?: string;
    pricedObjectID?: string | null;
    pricedResultIDStr?: string | null;
    expired?: boolean;
    offersApplied?: boolean;

    constructor(data?: ISourceResultPointer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : <any>null;
            this.resultIDStr = _data["resultIDStr"] !== undefined ? _data["resultIDStr"] : <any>null;
            this.pricedObjectID = _data["pricedObjectID"] !== undefined ? _data["pricedObjectID"] : <any>null;
            this.pricedResultIDStr = _data["pricedResultIDStr"] !== undefined ? _data["pricedResultIDStr"] : <any>null;
            this.expired = _data["expired"] !== undefined ? _data["expired"] : <any>null;
            this.offersApplied = _data["offersApplied"] !== undefined ? _data["offersApplied"] : <any>null;
        }
    }

    static fromJS(data: any): SourceResultPointer {
        data = typeof data === 'object' ? data : {};
        let result = new SourceResultPointer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        data["resultID"] = this.resultID !== undefined ? this.resultID : <any>null;
        data["resultIDStr"] = this.resultIDStr !== undefined ? this.resultIDStr : <any>null;
        data["pricedObjectID"] = this.pricedObjectID !== undefined ? this.pricedObjectID : <any>null;
        data["pricedResultIDStr"] = this.pricedResultIDStr !== undefined ? this.pricedResultIDStr : <any>null;
        data["expired"] = this.expired !== undefined ? this.expired : <any>null;
        data["offersApplied"] = this.offersApplied !== undefined ? this.offersApplied : <any>null;
        return data;
    }
}

export interface ISourceResultPointer {
    fornitore?: EFornitore;
    resultID?: string;
    resultIDStr?: string;
    pricedObjectID?: string | null;
    pricedResultIDStr?: string | null;
    expired?: boolean;
    offersApplied?: boolean;
}

export class GetResultsRequest extends SiteRequest implements IGetResultsRequest {
    jobID!: string;

    constructor(data?: IGetResultsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
        }
    }

    static fromJS(data: any): GetResultsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetResultsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetResultsRequest extends ISiteRequest {
    jobID: string;
}

export class GetSearchLogFileResponse extends OkApiResponse implements IGetSearchLogFileResponse {
    logContent?: string | null;
    dataType?: ELogDataType;

    constructor(data?: IGetSearchLogFileResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logContent = _data["logContent"] !== undefined ? _data["logContent"] : <any>null;
            this.dataType = _data["dataType"] !== undefined ? _data["dataType"] : <any>null;
        }
    }

    static fromJS(data: any): GetSearchLogFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchLogFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logContent"] = this.logContent !== undefined ? this.logContent : <any>null;
        data["dataType"] = this.dataType !== undefined ? this.dataType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSearchLogFileResponse extends IOkApiResponse {
    logContent?: string | null;
    dataType?: ELogDataType;
}

export class GetSearchLogFileRequest extends ApiRequest implements IGetSearchLogFileRequest {
    /** Source job ID */
    jobID!: string;
    /** Log ID */
    logID!: string;
    getRequest?: boolean;
    download?: boolean;

    constructor(data?: IGetSearchLogFileRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.logID = _data["logID"] !== undefined ? _data["logID"] : <any>null;
            this.getRequest = _data["getRequest"] !== undefined ? _data["getRequest"] : <any>null;
            this.download = _data["download"] !== undefined ? _data["download"] : <any>null;
        }
    }

    static fromJS(data: any): GetSearchLogFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchLogFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["logID"] = this.logID !== undefined ? this.logID : <any>null;
        data["getRequest"] = this.getRequest !== undefined ? this.getRequest : <any>null;
        data["download"] = this.download !== undefined ? this.download : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSearchLogFileRequest extends IApiRequest {
    /** Source job ID */
    jobID: string;
    /** Log ID */
    logID: string;
    getRequest?: boolean;
    download?: boolean;
}

export class GetServiceDrilldownResponse extends OkApiResponse implements IGetServiceDrilldownResponse {
    servizio?: ServizioSearch | null;

    constructor(data?: IGetServiceDrilldownResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? ServizioSearch.fromJS(_data["servizio"]) : <any>null;
        }
    }

    static fromJS(data: any): GetServiceDrilldownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceDrilldownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiceDrilldownResponse extends IOkApiResponse {
    servizio?: ServizioSearch | null;
}

export class GetServiceDrilldownRequest extends ApiRequest implements IGetServiceDrilldownRequest {
    jobID?: string;
    generationID?: number;
    serviceID?: string;

    constructor(data?: IGetServiceDrilldownRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.generationID = _data["generationID"] !== undefined ? _data["generationID"] : <any>null;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : <any>null;
        }
    }

    static fromJS(data: any): GetServiceDrilldownRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceDrilldownRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["generationID"] = this.generationID !== undefined ? this.generationID : <any>null;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiceDrilldownRequest extends IApiRequest {
    jobID?: string;
    generationID?: number;
    serviceID?: string;
}

export class GetSingleServicePriceResponse extends OkApiResponse implements IGetSingleServicePriceResponse {
    datiServizio?: ServiceData | null;
    servizio?: ServizioSearch | null;
    abbinamentiTipologiePartenze?: AbbinamentoTipologiaPartenza[] | null;
    jobID?: string | null;
    searchKey?: string | null;
    generationID?: number;

    constructor(data?: IGetSingleServicePriceResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.datiServizio = _data["datiServizio"] ? ServiceData.fromJS(_data["datiServizio"]) : <any>null;
            this.servizio = _data["servizio"] ? ServizioSearch.fromJS(_data["servizio"]) : <any>null;
            if (Array.isArray(_data["abbinamentiTipologiePartenze"])) {
                this.abbinamentiTipologiePartenze = [] as any;
                for (let item of _data["abbinamentiTipologiePartenze"])
                    this.abbinamentiTipologiePartenze!.push(AbbinamentoTipologiaPartenza.fromJS(item));
            }
            else {
                this.abbinamentiTipologiePartenze = <any>null;
            }
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.searchKey = _data["searchKey"] !== undefined ? _data["searchKey"] : <any>null;
            this.generationID = _data["generationID"] !== undefined ? _data["generationID"] : <any>null;
        }
    }

    static fromJS(data: any): GetSingleServicePriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSingleServicePriceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datiServizio"] = this.datiServizio ? this.datiServizio.toJSON() : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        if (Array.isArray(this.abbinamentiTipologiePartenze)) {
            data["abbinamentiTipologiePartenze"] = [];
            for (let item of this.abbinamentiTipologiePartenze)
                data["abbinamentiTipologiePartenze"].push(item.toJSON());
        }
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["searchKey"] = this.searchKey !== undefined ? this.searchKey : <any>null;
        data["generationID"] = this.generationID !== undefined ? this.generationID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSingleServicePriceResponse extends IOkApiResponse {
    datiServizio?: ServiceData | null;
    servizio?: ServizioSearch | null;
    abbinamentiTipologiePartenze?: AbbinamentoTipologiaPartenza[] | null;
    jobID?: string | null;
    searchKey?: string | null;
    generationID?: number;
}

export class ServiceData implements IServiceData {
    id?: string;
    servizioID?: number;
    interno?: boolean;
    prezzoBase?: number | null;
    nome?: string | null;
    sottoTitolo?: string | null;
    stringaRicerca?: string | null;
    indirizzo?: string | null;
    altroLuogo?: boolean;
    luogo?: string | null;
    destinazioneID?: number | null;
    cover?: string | null;
    durata?: ServiceDuration | null;
    stelle?: number | null;
    urlName?: string | null;
    mappa?: Mappa | null;
    attributiFiltro?: number[] | null;
    haAttributiTestata?: boolean;
    haCategoria?: boolean;
    categoria?: string | null;
    haNuovo?: boolean;
    nuovo?: string | null;
    haVantaggi?: boolean;
    vantaggi?: string | null;
    haServizi?: boolean;
    inRistrutturazione?: string | null;
    tipoServizio?: ETipoServizio;
    popolarita?: number | null;
    haAttributiNoleggi?: boolean;
    attributiNoleggi?: ElencoAttributiNoleggio[] | null;
    tappe?: (string | null)[] | null;
    luoghi?: number[] | null;
    date?: ServiceDeparture[] | null;
    attributi?: ServiceAttribute[] | null;
    preferito?: boolean;
    prezzi?: ServizioSearch | null;
    testiPrincipali?: TestoCompleto[] | null;
    testiGiorni?: TestoCompleto[] | null;
    testiNote?: TestoCompleto[] | null;
    itinerario?: (ServiceItineraryStep | null)[] | null;
    immagini?: ServiceImage[] | null;
    partenzePerFiltri?: ServiceDepartureFilterValues | null;
    regolePacchetto?: ServizioRegolaScontoPacchetto[] | null;
    tipologie?: TipologieServiziItinerario[] | null;

    constructor(data?: IServiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.interno = _data["interno"] !== undefined ? _data["interno"] : <any>null;
            this.prezzoBase = _data["prezzoBase"] !== undefined ? _data["prezzoBase"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.sottoTitolo = _data["sottoTitolo"] !== undefined ? _data["sottoTitolo"] : <any>null;
            this.stringaRicerca = _data["stringaRicerca"] !== undefined ? _data["stringaRicerca"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.altroLuogo = _data["altroLuogo"] !== undefined ? _data["altroLuogo"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.destinazioneID = _data["destinazioneID"] !== undefined ? _data["destinazioneID"] : <any>null;
            this.cover = _data["cover"] !== undefined ? _data["cover"] : <any>null;
            this.durata = _data["durata"] ? ServiceDuration.fromJS(_data["durata"]) : <any>null;
            this.stelle = _data["stelle"] !== undefined ? _data["stelle"] : <any>null;
            this.urlName = _data["urlName"] !== undefined ? _data["urlName"] : <any>null;
            this.mappa = _data["mappa"] ? Mappa.fromJS(_data["mappa"]) : <any>null;
            if (Array.isArray(_data["attributiFiltro"])) {
                this.attributiFiltro = [] as any;
                for (let item of _data["attributiFiltro"])
                    this.attributiFiltro!.push(item);
            }
            else {
                this.attributiFiltro = <any>null;
            }
            this.haAttributiTestata = _data["haAttributiTestata"] !== undefined ? _data["haAttributiTestata"] : <any>null;
            this.haCategoria = _data["haCategoria"] !== undefined ? _data["haCategoria"] : <any>null;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : <any>null;
            this.haNuovo = _data["haNuovo"] !== undefined ? _data["haNuovo"] : <any>null;
            this.nuovo = _data["nuovo"] !== undefined ? _data["nuovo"] : <any>null;
            this.haVantaggi = _data["haVantaggi"] !== undefined ? _data["haVantaggi"] : <any>null;
            this.vantaggi = _data["vantaggi"] !== undefined ? _data["vantaggi"] : <any>null;
            this.haServizi = _data["haServizi"] !== undefined ? _data["haServizi"] : <any>null;
            this.inRistrutturazione = _data["inRistrutturazione"] !== undefined ? _data["inRistrutturazione"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.popolarita = _data["popolarita"] !== undefined ? _data["popolarita"] : <any>null;
            this.haAttributiNoleggi = _data["haAttributiNoleggi"] !== undefined ? _data["haAttributiNoleggi"] : <any>null;
            if (Array.isArray(_data["attributiNoleggi"])) {
                this.attributiNoleggi = [] as any;
                for (let item of _data["attributiNoleggi"])
                    this.attributiNoleggi!.push(ElencoAttributiNoleggio.fromJS(item));
            }
            else {
                this.attributiNoleggi = <any>null;
            }
            if (Array.isArray(_data["tappe"])) {
                this.tappe = [] as any;
                for (let item of _data["tappe"])
                    this.tappe!.push(item);
            }
            else {
                this.tappe = <any>null;
            }
            if (Array.isArray(_data["luoghi"])) {
                this.luoghi = [] as any;
                for (let item of _data["luoghi"])
                    this.luoghi!.push(item);
            }
            else {
                this.luoghi = <any>null;
            }
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(ServiceDeparture.fromJS(item));
            }
            else {
                this.date = <any>null;
            }
            if (Array.isArray(_data["attributi"])) {
                this.attributi = [] as any;
                for (let item of _data["attributi"])
                    this.attributi!.push(ServiceAttribute.fromJS(item));
            }
            else {
                this.attributi = <any>null;
            }
            this.preferito = _data["preferito"] !== undefined ? _data["preferito"] : <any>null;
            this.prezzi = _data["prezzi"] ? ServizioSearch.fromJS(_data["prezzi"]) : <any>null;
            if (Array.isArray(_data["testiPrincipali"])) {
                this.testiPrincipali = [] as any;
                for (let item of _data["testiPrincipali"])
                    this.testiPrincipali!.push(TestoCompleto.fromJS(item));
            }
            else {
                this.testiPrincipali = <any>null;
            }
            if (Array.isArray(_data["testiGiorni"])) {
                this.testiGiorni = [] as any;
                for (let item of _data["testiGiorni"])
                    this.testiGiorni!.push(TestoCompleto.fromJS(item));
            }
            else {
                this.testiGiorni = <any>null;
            }
            if (Array.isArray(_data["testiNote"])) {
                this.testiNote = [] as any;
                for (let item of _data["testiNote"])
                    this.testiNote!.push(TestoCompleto.fromJS(item));
            }
            else {
                this.testiNote = <any>null;
            }
            if (Array.isArray(_data["itinerario"])) {
                this.itinerario = [] as any;
                for (let item of _data["itinerario"])
                    this.itinerario!.push(ServiceItineraryStep.fromJS(item));
            }
            else {
                this.itinerario = <any>null;
            }
            if (Array.isArray(_data["immagini"])) {
                this.immagini = [] as any;
                for (let item of _data["immagini"])
                    this.immagini!.push(ServiceImage.fromJS(item));
            }
            else {
                this.immagini = <any>null;
            }
            this.partenzePerFiltri = _data["partenzePerFiltri"] ? ServiceDepartureFilterValues.fromJS(_data["partenzePerFiltri"]) : <any>null;
            if (Array.isArray(_data["regolePacchetto"])) {
                this.regolePacchetto = [] as any;
                for (let item of _data["regolePacchetto"])
                    this.regolePacchetto!.push(ServizioRegolaScontoPacchetto.fromJS(item));
            }
            else {
                this.regolePacchetto = <any>null;
            }
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(TipologieServiziItinerario.fromJS(item));
            }
            else {
                this.tipologie = <any>null;
            }
        }
    }

    static fromJS(data: any): ServiceData {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["interno"] = this.interno !== undefined ? this.interno : <any>null;
        data["prezzoBase"] = this.prezzoBase !== undefined ? this.prezzoBase : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["sottoTitolo"] = this.sottoTitolo !== undefined ? this.sottoTitolo : <any>null;
        data["stringaRicerca"] = this.stringaRicerca !== undefined ? this.stringaRicerca : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["altroLuogo"] = this.altroLuogo !== undefined ? this.altroLuogo : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["destinazioneID"] = this.destinazioneID !== undefined ? this.destinazioneID : <any>null;
        data["cover"] = this.cover !== undefined ? this.cover : <any>null;
        data["durata"] = this.durata ? this.durata.toJSON() : <any>null;
        data["stelle"] = this.stelle !== undefined ? this.stelle : <any>null;
        data["urlName"] = this.urlName !== undefined ? this.urlName : <any>null;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : <any>null;
        if (Array.isArray(this.attributiFiltro)) {
            data["attributiFiltro"] = [];
            for (let item of this.attributiFiltro)
                data["attributiFiltro"].push(item);
        }
        data["haAttributiTestata"] = this.haAttributiTestata !== undefined ? this.haAttributiTestata : <any>null;
        data["haCategoria"] = this.haCategoria !== undefined ? this.haCategoria : <any>null;
        data["categoria"] = this.categoria !== undefined ? this.categoria : <any>null;
        data["haNuovo"] = this.haNuovo !== undefined ? this.haNuovo : <any>null;
        data["nuovo"] = this.nuovo !== undefined ? this.nuovo : <any>null;
        data["haVantaggi"] = this.haVantaggi !== undefined ? this.haVantaggi : <any>null;
        data["vantaggi"] = this.vantaggi !== undefined ? this.vantaggi : <any>null;
        data["haServizi"] = this.haServizi !== undefined ? this.haServizi : <any>null;
        data["inRistrutturazione"] = this.inRistrutturazione !== undefined ? this.inRistrutturazione : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["popolarita"] = this.popolarita !== undefined ? this.popolarita : <any>null;
        data["haAttributiNoleggi"] = this.haAttributiNoleggi !== undefined ? this.haAttributiNoleggi : <any>null;
        if (Array.isArray(this.attributiNoleggi)) {
            data["attributiNoleggi"] = [];
            for (let item of this.attributiNoleggi)
                data["attributiNoleggi"].push(item.toJSON());
        }
        if (Array.isArray(this.tappe)) {
            data["tappe"] = [];
            for (let item of this.tappe)
                data["tappe"].push(item);
        }
        if (Array.isArray(this.luoghi)) {
            data["luoghi"] = [];
            for (let item of this.luoghi)
                data["luoghi"].push(item);
        }
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toJSON());
        }
        if (Array.isArray(this.attributi)) {
            data["attributi"] = [];
            for (let item of this.attributi)
                data["attributi"].push(item.toJSON());
        }
        data["preferito"] = this.preferito !== undefined ? this.preferito : <any>null;
        data["prezzi"] = this.prezzi ? this.prezzi.toJSON() : <any>null;
        if (Array.isArray(this.testiPrincipali)) {
            data["testiPrincipali"] = [];
            for (let item of this.testiPrincipali)
                data["testiPrincipali"].push(item.toJSON());
        }
        if (Array.isArray(this.testiGiorni)) {
            data["testiGiorni"] = [];
            for (let item of this.testiGiorni)
                data["testiGiorni"].push(item.toJSON());
        }
        if (Array.isArray(this.testiNote)) {
            data["testiNote"] = [];
            for (let item of this.testiNote)
                data["testiNote"].push(item.toJSON());
        }
        if (Array.isArray(this.itinerario)) {
            data["itinerario"] = [];
            for (let item of this.itinerario)
                data["itinerario"].push(item.toJSON());
        }
        if (Array.isArray(this.immagini)) {
            data["immagini"] = [];
            for (let item of this.immagini)
                data["immagini"].push(item.toJSON());
        }
        data["partenzePerFiltri"] = this.partenzePerFiltri ? this.partenzePerFiltri.toJSON() : <any>null;
        if (Array.isArray(this.regolePacchetto)) {
            data["regolePacchetto"] = [];
            for (let item of this.regolePacchetto)
                data["regolePacchetto"].push(item.toJSON());
        }
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceData {
    id?: string;
    servizioID?: number;
    interno?: boolean;
    prezzoBase?: number | null;
    nome?: string | null;
    sottoTitolo?: string | null;
    stringaRicerca?: string | null;
    indirizzo?: string | null;
    altroLuogo?: boolean;
    luogo?: string | null;
    destinazioneID?: number | null;
    cover?: string | null;
    durata?: ServiceDuration | null;
    stelle?: number | null;
    urlName?: string | null;
    mappa?: Mappa | null;
    attributiFiltro?: number[] | null;
    haAttributiTestata?: boolean;
    haCategoria?: boolean;
    categoria?: string | null;
    haNuovo?: boolean;
    nuovo?: string | null;
    haVantaggi?: boolean;
    vantaggi?: string | null;
    haServizi?: boolean;
    inRistrutturazione?: string | null;
    tipoServizio?: ETipoServizio;
    popolarita?: number | null;
    haAttributiNoleggi?: boolean;
    attributiNoleggi?: ElencoAttributiNoleggio[] | null;
    tappe?: (string | null)[] | null;
    luoghi?: number[] | null;
    date?: ServiceDeparture[] | null;
    attributi?: ServiceAttribute[] | null;
    preferito?: boolean;
    prezzi?: ServizioSearch | null;
    testiPrincipali?: TestoCompleto[] | null;
    testiGiorni?: TestoCompleto[] | null;
    testiNote?: TestoCompleto[] | null;
    itinerario?: (ServiceItineraryStep | null)[] | null;
    immagini?: ServiceImage[] | null;
    partenzePerFiltri?: ServiceDepartureFilterValues | null;
    regolePacchetto?: ServizioRegolaScontoPacchetto[] | null;
    tipologie?: TipologieServiziItinerario[] | null;
}

export class ElencoAttributiNoleggio implements IElencoAttributiNoleggio {
    titolo?: string | null;
    attributiNoleggio?: AttributoNoleggio[] | null;

    constructor(data?: IElencoAttributiNoleggio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            if (Array.isArray(_data["attributiNoleggio"])) {
                this.attributiNoleggio = [] as any;
                for (let item of _data["attributiNoleggio"])
                    this.attributiNoleggio!.push(AttributoNoleggio.fromJS(item));
            }
            else {
                this.attributiNoleggio = <any>null;
            }
        }
    }

    static fromJS(data: any): ElencoAttributiNoleggio {
        data = typeof data === 'object' ? data : {};
        let result = new ElencoAttributiNoleggio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        if (Array.isArray(this.attributiNoleggio)) {
            data["attributiNoleggio"] = [];
            for (let item of this.attributiNoleggio)
                data["attributiNoleggio"].push(item.toJSON());
        }
        return data;
    }
}

export interface IElencoAttributiNoleggio {
    titolo?: string | null;
    attributiNoleggio?: AttributoNoleggio[] | null;
}

export class AttributoNoleggio implements IAttributoNoleggio {
    icona?: string | null;
    nome?: string | null;
    valore?: string | null;
    titolo?: string | null;

    constructor(data?: IAttributoNoleggio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icona = _data["icona"] !== undefined ? _data["icona"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
        }
    }

    static fromJS(data: any): AttributoNoleggio {
        data = typeof data === 'object' ? data : {};
        let result = new AttributoNoleggio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icona"] = this.icona !== undefined ? this.icona : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["valore"] = this.valore !== undefined ? this.valore : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        return data;
    }
}

export interface IAttributoNoleggio {
    icona?: string | null;
    nome?: string | null;
    valore?: string | null;
    titolo?: string | null;
}

export class ServiceDeparture implements IServiceDeparture {
    anno?: number;
    mese?: number;
    annoSuccessivo?: boolean;
    tag?: number;
    giorni?: string[] | null;
    flags?: EPartenzaFlags;

    constructor(data?: IServiceDeparture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anno = _data["anno"] !== undefined ? _data["anno"] : <any>null;
            this.mese = _data["mese"] !== undefined ? _data["mese"] : <any>null;
            this.annoSuccessivo = _data["annoSuccessivo"] !== undefined ? _data["annoSuccessivo"] : <any>null;
            this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(item);
            }
            else {
                this.giorni = <any>null;
            }
            this.flags = _data["flags"] !== undefined ? _data["flags"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceDeparture {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDeparture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anno"] = this.anno !== undefined ? this.anno : <any>null;
        data["mese"] = this.mese !== undefined ? this.mese : <any>null;
        data["annoSuccessivo"] = this.annoSuccessivo !== undefined ? this.annoSuccessivo : <any>null;
        data["tag"] = this.tag !== undefined ? this.tag : <any>null;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item);
        }
        data["flags"] = this.flags !== undefined ? this.flags : <any>null;
        return data;
    }
}

export interface IServiceDeparture {
    anno?: number;
    mese?: number;
    annoSuccessivo?: boolean;
    tag?: number;
    giorni?: string[] | null;
    flags?: EPartenzaFlags;
}

export class ServiceItineraryStep implements IServiceItineraryStep {
    luogoID?: number;
    luogo?: string | null;
    latitudine?: number;
    longitudine?: number;
    notti?: number;
    tipoTrasporto?: ETipoTrasporto;
    ordine?: number;
    giorno?: number;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;

    constructor(data?: IServiceItineraryStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : <any>null;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            this.tipoTrasporto = _data["tipoTrasporto"] !== undefined ? _data["tipoTrasporto"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : <any>null;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : <any>null;
            this.compagniaAerea2 = _data["compagniaAerea2"] !== undefined ? _data["compagniaAerea2"] : <any>null;
            this.classe2 = _data["classe2"] !== undefined ? _data["classe2"] : <any>null;
            this.cambioHotel = _data["cambioHotel"] !== undefined ? _data["cambioHotel"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceItineraryStep {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceItineraryStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : <any>null;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        data["tipoTrasporto"] = this.tipoTrasporto !== undefined ? this.tipoTrasporto : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : <any>null;
        data["classe"] = this.classe !== undefined ? this.classe : <any>null;
        data["compagniaAerea2"] = this.compagniaAerea2 !== undefined ? this.compagniaAerea2 : <any>null;
        data["classe2"] = this.classe2 !== undefined ? this.classe2 : <any>null;
        data["cambioHotel"] = this.cambioHotel !== undefined ? this.cambioHotel : <any>null;
        return data;
    }
}

export interface IServiceItineraryStep {
    luogoID?: number;
    luogo?: string | null;
    latitudine?: number;
    longitudine?: number;
    notti?: number;
    tipoTrasporto?: ETipoTrasporto;
    ordine?: number;
    giorno?: number;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;
}

export class ServiceImage implements IServiceImage {
    url?: string | null;
    title?: string | null;

    constructor(data?: IServiceImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceImage {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data;
    }
}

export interface IServiceImage {
    url?: string | null;
    title?: string | null;
}

export class ServiceDepartureFilterValues implements IServiceDepartureFilterValues {
    dataMinima?: number | null;
    dataMassima?: number | null;
    dateValide?: number[] | null;
    giornaliero?: boolean;

    constructor(data?: IServiceDepartureFilterValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataMinima = _data["dataMinima"] !== undefined ? _data["dataMinima"] : <any>null;
            this.dataMassima = _data["dataMassima"] !== undefined ? _data["dataMassima"] : <any>null;
            if (Array.isArray(_data["dateValide"])) {
                this.dateValide = [] as any;
                for (let item of _data["dateValide"])
                    this.dateValide!.push(item);
            }
            else {
                this.dateValide = <any>null;
            }
            this.giornaliero = _data["giornaliero"] !== undefined ? _data["giornaliero"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceDepartureFilterValues {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDepartureFilterValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMinima"] = this.dataMinima !== undefined ? this.dataMinima : <any>null;
        data["dataMassima"] = this.dataMassima !== undefined ? this.dataMassima : <any>null;
        if (Array.isArray(this.dateValide)) {
            data["dateValide"] = [];
            for (let item of this.dateValide)
                data["dateValide"].push(item);
        }
        data["giornaliero"] = this.giornaliero !== undefined ? this.giornaliero : <any>null;
        return data;
    }
}

export interface IServiceDepartureFilterValues {
    dataMinima?: number | null;
    dataMassima?: number | null;
    dateValide?: number[] | null;
    giornaliero?: boolean;
}

export class TipologieServiziItinerario implements ITipologieServiziItinerario {
    tipologia?: string;
    giorni?: TipologieServiziItinerarioGiorno[];

    constructor(data?: ITipologieServiziItinerario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipologia = _data["tipologia"] !== undefined ? _data["tipologia"] : <any>null;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(TipologieServiziItinerarioGiorno.fromJS(item));
            }
            else {
                this.giorni = <any>null;
            }
        }
    }

    static fromJS(data: any): TipologieServiziItinerario {
        data = typeof data === 'object' ? data : {};
        let result = new TipologieServiziItinerario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologia"] = this.tipologia !== undefined ? this.tipologia : <any>null;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITipologieServiziItinerario {
    tipologia?: string;
    giorni?: TipologieServiziItinerarioGiorno[];
}

export class TipologieServiziItinerarioGiorno implements ITipologieServiziItinerarioGiorno {
    luogo?: string;
    giorno?: number;
    durata?: number;
    servizi?: TipologieServiziItinerarioGiornoServizio[];

    constructor(data?: ITipologieServiziItinerarioGiorno) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.durata = _data["durata"] !== undefined ? _data["durata"] : <any>null;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(TipologieServiziItinerarioGiornoServizio.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
        }
    }

    static fromJS(data: any): TipologieServiziItinerarioGiorno {
        data = typeof data === 'object' ? data : {};
        let result = new TipologieServiziItinerarioGiorno();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["durata"] = this.durata !== undefined ? this.durata : <any>null;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITipologieServiziItinerarioGiorno {
    luogo?: string;
    giorno?: number;
    durata?: number;
    servizi?: TipologieServiziItinerarioGiornoServizio[];
}

export class TipologieServiziItinerarioGiornoServizio implements ITipologieServiziItinerarioGiornoServizio {
    nome?: string;
    alternativa?: boolean;
    url?: string | null;

    constructor(data?: ITipologieServiziItinerarioGiornoServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.alternativa = _data["alternativa"] !== undefined ? _data["alternativa"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): TipologieServiziItinerarioGiornoServizio {
        data = typeof data === 'object' ? data : {};
        let result = new TipologieServiziItinerarioGiornoServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["alternativa"] = this.alternativa !== undefined ? this.alternativa : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

export interface ITipologieServiziItinerarioGiornoServizio {
    nome?: string;
    alternativa?: boolean;
    url?: string | null;
}

export class AbbinamentoTipologiaPartenza implements IAbbinamentoTipologiaPartenza {
    abbinamento?: AbbinamentoTipologie | null;
    tipologia?: TipologiaSearch | null;
    partenza?: PartenzaSearch | null;

    constructor(data?: IAbbinamentoTipologiaPartenza) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abbinamento = _data["abbinamento"] ? AbbinamentoTipologie.fromJS(_data["abbinamento"]) : <any>null;
            this.tipologia = _data["tipologia"] ? TipologiaSearch.fromJS(_data["tipologia"]) : <any>null;
            this.partenza = _data["partenza"] ? PartenzaSearch.fromJS(_data["partenza"]) : <any>null;
        }
    }

    static fromJS(data: any): AbbinamentoTipologiaPartenza {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoTipologiaPartenza();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abbinamento"] = this.abbinamento ? this.abbinamento.toJSON() : <any>null;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : <any>null;
        data["partenza"] = this.partenza ? this.partenza.toJSON() : <any>null;
        return data;
    }
}

export interface IAbbinamentoTipologiaPartenza {
    abbinamento?: AbbinamentoTipologie | null;
    tipologia?: TipologiaSearch | null;
    partenza?: PartenzaSearch | null;
}

export class StartPriceSearchRequest extends SiteRequest implements IStartPriceSearchRequest {
    tipoServizio?: ETipoServizio;
    luogoID?: number | null;
    luogoDestinazioneID?: number | null;
    offertaID?: number | null;
    tappaID?: number | null;
    dal?: string | null;
    daOre?: number | null;
    al?: string | null;
    aOre?: number | null;
    paxIds?: number[] | null;
    abbinamentiIds?: number[] | null;
    paxDefs?: PaxDef[] | null;
    abbinamentiDefs?: AbbinamentoDef[] | null;
    nomeGruppoCustom?: string | null;
    abilitaLog?: boolean;
    bypassCache?: boolean;

    constructor(data?: IStartPriceSearchRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.tappaID = _data["tappaID"] !== undefined ? _data["tappaID"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.daOre = _data["daOre"] !== undefined ? _data["daOre"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.aOre = _data["aOre"] !== undefined ? _data["aOre"] : <any>null;
            if (Array.isArray(_data["paxIds"])) {
                this.paxIds = [] as any;
                for (let item of _data["paxIds"])
                    this.paxIds!.push(item);
            }
            else {
                this.paxIds = <any>null;
            }
            if (Array.isArray(_data["abbinamentiIds"])) {
                this.abbinamentiIds = [] as any;
                for (let item of _data["abbinamentiIds"])
                    this.abbinamentiIds!.push(item);
            }
            else {
                this.abbinamentiIds = <any>null;
            }
            if (Array.isArray(_data["paxDefs"])) {
                this.paxDefs = [] as any;
                for (let item of _data["paxDefs"])
                    this.paxDefs!.push(PaxDef.fromJS(item));
            }
            else {
                this.paxDefs = <any>null;
            }
            if (Array.isArray(_data["abbinamentiDefs"])) {
                this.abbinamentiDefs = [] as any;
                for (let item of _data["abbinamentiDefs"])
                    this.abbinamentiDefs!.push(AbbinamentoDef.fromJS(item));
            }
            else {
                this.abbinamentiDefs = <any>null;
            }
            this.nomeGruppoCustom = _data["nomeGruppoCustom"] !== undefined ? _data["nomeGruppoCustom"] : <any>null;
            this.abilitaLog = _data["abilitaLog"] !== undefined ? _data["abilitaLog"] : <any>null;
            this.bypassCache = _data["bypassCache"] !== undefined ? _data["bypassCache"] : <any>null;
        }
    }

    static fromJS(data: any): StartPriceSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartPriceSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["tappaID"] = this.tappaID !== undefined ? this.tappaID : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["daOre"] = this.daOre !== undefined ? this.daOre : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["aOre"] = this.aOre !== undefined ? this.aOre : <any>null;
        if (Array.isArray(this.paxIds)) {
            data["paxIds"] = [];
            for (let item of this.paxIds)
                data["paxIds"].push(item);
        }
        if (Array.isArray(this.abbinamentiIds)) {
            data["abbinamentiIds"] = [];
            for (let item of this.abbinamentiIds)
                data["abbinamentiIds"].push(item);
        }
        if (Array.isArray(this.paxDefs)) {
            data["paxDefs"] = [];
            for (let item of this.paxDefs)
                data["paxDefs"].push(item.toJSON());
        }
        if (Array.isArray(this.abbinamentiDefs)) {
            data["abbinamentiDefs"] = [];
            for (let item of this.abbinamentiDefs)
                data["abbinamentiDefs"].push(item.toJSON());
        }
        data["nomeGruppoCustom"] = this.nomeGruppoCustom !== undefined ? this.nomeGruppoCustom : <any>null;
        data["abilitaLog"] = this.abilitaLog !== undefined ? this.abilitaLog : <any>null;
        data["bypassCache"] = this.bypassCache !== undefined ? this.bypassCache : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IStartPriceSearchRequest extends ISiteRequest {
    tipoServizio?: ETipoServizio;
    luogoID?: number | null;
    luogoDestinazioneID?: number | null;
    offertaID?: number | null;
    tappaID?: number | null;
    dal?: string | null;
    daOre?: number | null;
    al?: string | null;
    aOre?: number | null;
    paxIds?: number[] | null;
    abbinamentiIds?: number[] | null;
    paxDefs?: PaxDef[] | null;
    abbinamentiDefs?: AbbinamentoDef[] | null;
    nomeGruppoCustom?: string | null;
    abilitaLog?: boolean;
    bypassCache?: boolean;
}

export class GetSingleServicePriceRequest extends StartPriceSearchRequest implements IGetSingleServicePriceRequest {
    servizioID?: number;
    tipologiaID?: number;
    trattamentoID?: number | null;
    partenza?: string;

    constructor(data?: IGetSingleServicePriceRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
        }
    }

    static fromJS(data: any): GetSingleServicePriceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSingleServicePriceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSingleServicePriceRequest extends IStartPriceSearchRequest {
    servizioID?: number;
    tipologiaID?: number;
    trattamentoID?: number | null;
    partenza?: string;
}

export class PaxDef implements IPaxDef {
    id?: number;
    titolo?: ETitolo;
    nome?: string | null;
    cognome?: string | null;
    dataDiNascita?: string;

    constructor(data?: IPaxDef) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.dataDiNascita = _data["dataDiNascita"] !== undefined ? _data["dataDiNascita"] : <any>null;
        }
    }

    static fromJS(data: any): PaxDef {
        data = typeof data === 'object' ? data : {};
        let result = new PaxDef();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["dataDiNascita"] = this.dataDiNascita !== undefined ? this.dataDiNascita : <any>null;
        return data;
    }
}

export interface IPaxDef {
    id?: number;
    titolo?: ETitolo;
    nome?: string | null;
    cognome?: string | null;
    dataDiNascita?: string;
}

export class AbbinamentoDef implements IAbbinamentoDef {
    id?: number;
    nome?: string | null;
    paxDefs?: PaxDef[] | null;

    constructor(data?: IAbbinamentoDef) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            if (Array.isArray(_data["paxDefs"])) {
                this.paxDefs = [] as any;
                for (let item of _data["paxDefs"])
                    this.paxDefs!.push(PaxDef.fromJS(item));
            }
            else {
                this.paxDefs = <any>null;
            }
        }
    }

    static fromJS(data: any): AbbinamentoDef {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoDef();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        if (Array.isArray(this.paxDefs)) {
            data["paxDefs"] = [];
            for (let item of this.paxDefs)
                data["paxDefs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAbbinamentoDef {
    id?: number;
    nome?: string | null;
    paxDefs?: PaxDef[] | null;
}

export class StartPriceSearchResponse extends OkApiResponse implements IStartPriceSearchResponse {
    startSearchResult?: EStartSearchResult;
    jobID?: string | null;
    searchKey?: string | null;
    gruppi?: DisponibilitaGruppo[] | null;
    dati?: RicercaDati | null;
    idsByPrice?: string[] | null;

    constructor(data?: IStartPriceSearchResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startSearchResult = _data["startSearchResult"] !== undefined ? _data["startSearchResult"] : <any>null;
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.searchKey = _data["searchKey"] !== undefined ? _data["searchKey"] : <any>null;
            if (Array.isArray(_data["gruppi"])) {
                this.gruppi = [] as any;
                for (let item of _data["gruppi"])
                    this.gruppi!.push(DisponibilitaGruppo.fromJS(item));
            }
            else {
                this.gruppi = <any>null;
            }
            this.dati = _data["dati"] ? RicercaDati.fromJS(_data["dati"]) : <any>null;
            if (Array.isArray(_data["idsByPrice"])) {
                this.idsByPrice = [] as any;
                for (let item of _data["idsByPrice"])
                    this.idsByPrice!.push(item);
            }
            else {
                this.idsByPrice = <any>null;
            }
        }
    }

    static fromJS(data: any): StartPriceSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StartPriceSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startSearchResult"] = this.startSearchResult !== undefined ? this.startSearchResult : <any>null;
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["searchKey"] = this.searchKey !== undefined ? this.searchKey : <any>null;
        if (Array.isArray(this.gruppi)) {
            data["gruppi"] = [];
            for (let item of this.gruppi)
                data["gruppi"].push(item.toJSON());
        }
        data["dati"] = this.dati ? this.dati.toJSON() : <any>null;
        if (Array.isArray(this.idsByPrice)) {
            data["idsByPrice"] = [];
            for (let item of this.idsByPrice)
                data["idsByPrice"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStartPriceSearchResponse extends IOkApiResponse {
    startSearchResult?: EStartSearchResult;
    jobID?: string | null;
    searchKey?: string | null;
    gruppi?: DisponibilitaGruppo[] | null;
    dati?: RicercaDati | null;
    idsByPrice?: string[] | null;
}

export enum EStartSearchResult {
    Ok = "Ok",
    Error = "Error",
    Busy = "Busy",
}

export class PricingGetRequest extends ApiRequest implements IPricingGetRequest {
    /** L'ID del pricing */
    id?: number;

    constructor(data?: IPricingGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): PricingGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPricingGetRequest extends IApiRequest {
    /** L'ID del pricing */
    id?: number;
}

export class PricingDeleteRequest extends PricingGetRequest implements IPricingDeleteRequest {

    constructor(data?: IPricingDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PricingDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPricingDeleteRequest extends IPricingGetRequest {
}

export class PricingGetResponse extends OkApiResponse implements IPricingGetResponse {
    pricing?: Pricing;

    constructor(data?: IPricingGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pricing = _data["pricing"] ? Pricing.fromJS(_data["pricing"]) : <any>null;
        }
    }

    static fromJS(data: any): PricingGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PricingGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricing"] = this.pricing ? this.pricing.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPricingGetResponse extends IOkApiResponse {
    pricing?: Pricing;
}

export class NrTableResponseOfPricingRow extends OkApiResponse implements INrTableResponseOfPricingRow {
    /** Array delle righe della pagina richiesta */
    rows?: PricingRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfPricingRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PricingRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfPricingRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfPricingRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfPricingRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: PricingRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class PricingRow implements IPricingRow {
    id?: number;
    nome?: string | null;
    operatore?: EOperatore | null;
    rulesCount?: number;

    constructor(data?: IPricingRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.rulesCount = _data["rulesCount"] !== undefined ? _data["rulesCount"] : <any>null;
        }
    }

    static fromJS(data: any): PricingRow {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["rulesCount"] = this.rulesCount !== undefined ? this.rulesCount : <any>null;
        return data;
    }
}

export interface IPricingRow {
    id?: number;
    nome?: string | null;
    operatore?: EOperatore | null;
    rulesCount?: number;
}

export class PricingListRequest extends NrTableRequest implements IPricingListRequest {
    term?: string | null;
    operatore?: EOperatore | null;

    constructor(data?: IPricingListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
        }
    }

    static fromJS(data: any): PricingListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPricingListRequest extends INrTableRequest {
    term?: string | null;
    operatore?: EOperatore | null;
}

export class PricingRulesListRequest extends PricingGetRequest implements IPricingRulesListRequest {

    constructor(data?: IPricingRulesListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PricingRulesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRulesListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPricingRulesListRequest extends IPricingGetRequest {
}

export class PricingRulesDeleteRequest extends PricingRulesListRequest implements IPricingRulesDeleteRequest {
    ruleID?: number;

    constructor(data?: IPricingRulesDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ruleID = _data["ruleID"] !== undefined ? _data["ruleID"] : <any>null;
        }
    }

    static fromJS(data: any): PricingRulesDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRulesDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleID"] = this.ruleID !== undefined ? this.ruleID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPricingRulesDeleteRequest extends IPricingRulesListRequest {
    ruleID?: number;
}

export class PricingRulesListResponse extends OkApiResponse implements IPricingRulesListResponse {
    rules?: PricingRule[];

    constructor(data?: IPricingRulesListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(PricingRule.fromJS(item));
            }
            else {
                this.rules = <any>null;
            }
        }
    }

    static fromJS(data: any): PricingRulesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRulesListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPricingRulesListResponse extends IOkApiResponse {
    rules?: PricingRule[];
}

export class PricingRulesUpsertRequest extends PricingRulesListRequest implements IPricingRulesUpsertRequest {
    rule?: PricingRule;

    constructor(data?: IPricingRulesUpsertRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rule = _data["rule"] ? PricingRule.fromJS(_data["rule"]) : <any>null;
        }
    }

    static fromJS(data: any): PricingRulesUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingRulesUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rule"] = this.rule ? this.rule.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPricingRulesUpsertRequest extends IPricingRulesListRequest {
    rule?: PricingRule;
}

export class PricingUpsertRequest extends ApiRequest implements IPricingUpsertRequest {
    id?: number;
    nome?: string;
    eOperatore?: EOperatore;

    constructor(data?: IPricingUpsertRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.eOperatore = _data["eOperatore"] !== undefined ? _data["eOperatore"] : <any>null;
        }
    }

    static fromJS(data: any): PricingUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricingUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["eOperatore"] = this.eOperatore !== undefined ? this.eOperatore : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPricingUpsertRequest extends IApiRequest {
    id?: number;
    nome?: string;
    eOperatore?: EOperatore;
}

export class NrTableResponseOfAdvancePaymentsReportRow extends OkApiResponse implements INrTableResponseOfAdvancePaymentsReportRow {
    /** Array delle righe della pagina richiesta */
    rows?: AdvancePaymentsReportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAdvancePaymentsReportRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AdvancePaymentsReportRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfAdvancePaymentsReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAdvancePaymentsReportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAdvancePaymentsReportRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: AdvancePaymentsReportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetAdvancePaymentsReportResponse extends NrTableResponseOfAdvancePaymentsReportRow implements IGetAdvancePaymentsReportResponse {

    constructor(data?: IGetAdvancePaymentsReportResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetAdvancePaymentsReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvancePaymentsReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetAdvancePaymentsReportResponse extends INrTableResponseOfAdvancePaymentsReportRow {
}

export class AdvancePaymentsReportRow implements IAdvancePaymentsReportRow {
    /** ID dell'offerta di riferimento */
    offertaID?: number;
    /** ID della riga di riferimento */
    rigaID?: number;
    /** Data di effettuazione del servizio */
    dataServizio?: string;
    /** Descrizione (come da offerta) */
    descrizione?: string;
    /** ID dell'accordo */
    accordoID?: number;
    /** Nome dell'accordo */
    accordo?: string;
    /** ID del contatto dell'accordo */
    contattoID?: number;
    /** Nome del contatto dell'accordo */
    contatto?: string;
    /** Importo da versare */
    importo?: number;
    /** Codice della valuta */
    codiceValuta?: string;
    /** Data del pagamento (se presente) */
    data?: string | null;

    constructor(data?: IAdvancePaymentsReportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : <any>null;
            this.dataServizio = _data["dataServizio"] !== undefined ? _data["dataServizio"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static fromJS(data: any): AdvancePaymentsReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancePaymentsReportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : <any>null;
        data["dataServizio"] = this.dataServizio !== undefined ? this.dataServizio : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["accordo"] = this.accordo !== undefined ? this.accordo : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["contatto"] = this.contatto !== undefined ? this.contatto : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        return data;
    }
}

export interface IAdvancePaymentsReportRow {
    /** ID dell'offerta di riferimento */
    offertaID?: number;
    /** ID della riga di riferimento */
    rigaID?: number;
    /** Data di effettuazione del servizio */
    dataServizio?: string;
    /** Descrizione (come da offerta) */
    descrizione?: string;
    /** ID dell'accordo */
    accordoID?: number;
    /** Nome dell'accordo */
    accordo?: string;
    /** ID del contatto dell'accordo */
    contattoID?: number;
    /** Nome del contatto dell'accordo */
    contatto?: string;
    /** Importo da versare */
    importo?: number;
    /** Codice della valuta */
    codiceValuta?: string;
    /** Data del pagamento (se presente) */
    data?: string | null;
}

export class GetAdvancePaymentsReportRequest extends NrTableRequest implements IGetAdvancePaymentsReportRequest {
    /** Filtro su singola offerta */
    offertaID?: number | null;
    /** Filtro sull'ID dell'accordo */
    accordoID?: number | null;
    /** Filtro sull'ID del contatto dell'accordo */
    contattoID?: number | null;
    /** Filtro data partenza "dal" */
    partenzaDal?: string | null;
    /** Filtro data partenza "al" */
    partenzaAl?: string | null;
    /** Filtro da pagare "dal" */
    daPagareDal?: string | null;
    /** Filtro da pagare "al" */
    daPagareAl?: string | null;

    constructor(data?: IGetAdvancePaymentsReportRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.contattoID = _data["contattoID"] !== undefined ? _data["contattoID"] : <any>null;
            this.partenzaDal = _data["partenzaDal"] !== undefined ? _data["partenzaDal"] : <any>null;
            this.partenzaAl = _data["partenzaAl"] !== undefined ? _data["partenzaAl"] : <any>null;
            this.daPagareDal = _data["daPagareDal"] !== undefined ? _data["daPagareDal"] : <any>null;
            this.daPagareAl = _data["daPagareAl"] !== undefined ? _data["daPagareAl"] : <any>null;
        }
    }

    static fromJS(data: any): GetAdvancePaymentsReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvancePaymentsReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["contattoID"] = this.contattoID !== undefined ? this.contattoID : <any>null;
        data["partenzaDal"] = this.partenzaDal !== undefined ? this.partenzaDal : <any>null;
        data["partenzaAl"] = this.partenzaAl !== undefined ? this.partenzaAl : <any>null;
        data["daPagareDal"] = this.daPagareDal !== undefined ? this.daPagareDal : <any>null;
        data["daPagareAl"] = this.daPagareAl !== undefined ? this.daPagareAl : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAdvancePaymentsReportRequest extends INrTableRequest {
    /** Filtro su singola offerta */
    offertaID?: number | null;
    /** Filtro sull'ID dell'accordo */
    accordoID?: number | null;
    /** Filtro sull'ID del contatto dell'accordo */
    contattoID?: number | null;
    /** Filtro data partenza "dal" */
    partenzaDal?: string | null;
    /** Filtro data partenza "al" */
    partenzaAl?: string | null;
    /** Filtro da pagare "dal" */
    daPagareDal?: string | null;
    /** Filtro da pagare "al" */
    daPagareAl?: string | null;
}

export class OfferteIncompleteReportResponse extends OkApiResponse implements IOfferteIncompleteReportResponse {
    offerteIncomplete?: OfferteIncompleteReportRow[];

    constructor(data?: IOfferteIncompleteReportResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["offerteIncomplete"])) {
                this.offerteIncomplete = [] as any;
                for (let item of _data["offerteIncomplete"])
                    this.offerteIncomplete!.push(OfferteIncompleteReportRow.fromJS(item));
            }
            else {
                this.offerteIncomplete = <any>null;
            }
        }
    }

    static fromJS(data: any): OfferteIncompleteReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OfferteIncompleteReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.offerteIncomplete)) {
            data["offerteIncomplete"] = [];
            for (let item of this.offerteIncomplete)
                data["offerteIncomplete"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOfferteIncompleteReportResponse extends IOkApiResponse {
    offerteIncomplete?: OfferteIncompleteReportRow[];
}

export abstract class OfferteIncompleteReportRowBase implements IOfferteIncompleteReportRowBase {
    offertaID?: number;
    partenza?: string;
    agenziaID?: number | null;
    agenzia?: string | null;
    utente?: string | null;
    emailUtente?: string | null;
    utentePreventivo?: string | null;
    emailUtentePreventivo?: string | null;
    utenteConferma?: string | null;
    emailUtenteConferma?: string | null;

    constructor(data?: IOfferteIncompleteReportRowBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.agenziaID = _data["agenziaID"] !== undefined ? _data["agenziaID"] : <any>null;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : <any>null;
            this.utente = _data["utente"] !== undefined ? _data["utente"] : <any>null;
            this.emailUtente = _data["emailUtente"] !== undefined ? _data["emailUtente"] : <any>null;
            this.utentePreventivo = _data["utentePreventivo"] !== undefined ? _data["utentePreventivo"] : <any>null;
            this.emailUtentePreventivo = _data["emailUtentePreventivo"] !== undefined ? _data["emailUtentePreventivo"] : <any>null;
            this.utenteConferma = _data["utenteConferma"] !== undefined ? _data["utenteConferma"] : <any>null;
            this.emailUtenteConferma = _data["emailUtenteConferma"] !== undefined ? _data["emailUtenteConferma"] : <any>null;
        }
    }

    static fromJS(data: any): OfferteIncompleteReportRowBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OfferteIncompleteReportRowBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["agenziaID"] = this.agenziaID !== undefined ? this.agenziaID : <any>null;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : <any>null;
        data["utente"] = this.utente !== undefined ? this.utente : <any>null;
        data["emailUtente"] = this.emailUtente !== undefined ? this.emailUtente : <any>null;
        data["utentePreventivo"] = this.utentePreventivo !== undefined ? this.utentePreventivo : <any>null;
        data["emailUtentePreventivo"] = this.emailUtentePreventivo !== undefined ? this.emailUtentePreventivo : <any>null;
        data["utenteConferma"] = this.utenteConferma !== undefined ? this.utenteConferma : <any>null;
        data["emailUtenteConferma"] = this.emailUtenteConferma !== undefined ? this.emailUtenteConferma : <any>null;
        return data;
    }
}

export interface IOfferteIncompleteReportRowBase {
    offertaID?: number;
    partenza?: string;
    agenziaID?: number | null;
    agenzia?: string | null;
    utente?: string | null;
    emailUtente?: string | null;
    utentePreventivo?: string | null;
    emailUtentePreventivo?: string | null;
    utenteConferma?: string | null;
    emailUtenteConferma?: string | null;
}

export class OfferteIncompleteReportRow extends OfferteIncompleteReportRowBase implements IOfferteIncompleteReportRow {
    datiMancantiOfferta?: EDatoClienteMancante[];
    datiMancantiClienti?: ClienteDatiMancanti[];

    constructor(data?: IOfferteIncompleteReportRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datiMancantiOfferta"])) {
                this.datiMancantiOfferta = [] as any;
                for (let item of _data["datiMancantiOfferta"])
                    this.datiMancantiOfferta!.push(item);
            }
            else {
                this.datiMancantiOfferta = <any>null;
            }
            if (Array.isArray(_data["datiMancantiClienti"])) {
                this.datiMancantiClienti = [] as any;
                for (let item of _data["datiMancantiClienti"])
                    this.datiMancantiClienti!.push(ClienteDatiMancanti.fromJS(item));
            }
            else {
                this.datiMancantiClienti = <any>null;
            }
        }
    }

    static fromJS(data: any): OfferteIncompleteReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new OfferteIncompleteReportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datiMancantiOfferta)) {
            data["datiMancantiOfferta"] = [];
            for (let item of this.datiMancantiOfferta)
                data["datiMancantiOfferta"].push(item);
        }
        if (Array.isArray(this.datiMancantiClienti)) {
            data["datiMancantiClienti"] = [];
            for (let item of this.datiMancantiClienti)
                data["datiMancantiClienti"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOfferteIncompleteReportRow extends IOfferteIncompleteReportRowBase {
    datiMancantiOfferta?: EDatoClienteMancante[];
    datiMancantiClienti?: ClienteDatiMancanti[];
}

export enum EDatoClienteMancante {
    NumeroPassaporto = "NumeroPassaporto",
    ScadenzaPassaporto = "ScadenzaPassaporto",
    PaeseRilascioPassaporto = "PaeseRilascioPassaporto",
    NumeroCellulare = "NumeroCellulare",
    Email = "Email",
    CodiceFiscale = "CodiceFiscale",
}

export class ClienteDatiMancanti implements IClienteDatiMancanti {
    cliente?: Cliente;
    datiMancanti?: EDatoClienteMancante[];
    traduzioniDatoClienteMancante?: { [key in keyof typeof EDatoClienteMancante]?: string; } | null;
    datiMancantiStr?: string;

    constructor(data?: IClienteDatiMancanti) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cliente = _data["cliente"] ? Cliente.fromJS(_data["cliente"]) : <any>null;
            if (Array.isArray(_data["datiMancanti"])) {
                this.datiMancanti = [] as any;
                for (let item of _data["datiMancanti"])
                    this.datiMancanti!.push(item);
            }
            else {
                this.datiMancanti = <any>null;
            }
            if (_data["traduzioniDatoClienteMancante"]) {
                this.traduzioniDatoClienteMancante = {} as any;
                for (let key in _data["traduzioniDatoClienteMancante"]) {
                    if (_data["traduzioniDatoClienteMancante"].hasOwnProperty(key))
                        (<any>this.traduzioniDatoClienteMancante)![key] = _data["traduzioniDatoClienteMancante"][key] !== undefined ? _data["traduzioniDatoClienteMancante"][key] : <any>null;
                }
            }
            else {
                this.traduzioniDatoClienteMancante = <any>null;
            }
            this.datiMancantiStr = _data["datiMancantiStr"] !== undefined ? _data["datiMancantiStr"] : <any>null;
        }
    }

    static fromJS(data: any): ClienteDatiMancanti {
        data = typeof data === 'object' ? data : {};
        let result = new ClienteDatiMancanti();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cliente"] = this.cliente ? this.cliente.toJSON() : <any>null;
        if (Array.isArray(this.datiMancanti)) {
            data["datiMancanti"] = [];
            for (let item of this.datiMancanti)
                data["datiMancanti"].push(item);
        }
        if (this.traduzioniDatoClienteMancante) {
            data["traduzioniDatoClienteMancante"] = {};
            for (let key in this.traduzioniDatoClienteMancante) {
                if (this.traduzioniDatoClienteMancante.hasOwnProperty(key))
                    (<any>data["traduzioniDatoClienteMancante"])[key] = this.traduzioniDatoClienteMancante[key] !== undefined ? this.traduzioniDatoClienteMancante[key] : <any>null;
            }
        }
        data["datiMancantiStr"] = this.datiMancantiStr !== undefined ? this.datiMancantiStr : <any>null;
        return data;
    }
}

export interface IClienteDatiMancanti {
    cliente?: Cliente;
    datiMancanti?: EDatoClienteMancante[];
    traduzioniDatoClienteMancante?: { [key in keyof typeof EDatoClienteMancante]?: string; } | null;
    datiMancantiStr?: string;
}

export class OfferteIncompleteReportRequest extends ApiRequest implements IOfferteIncompleteReportRequest {
    giorniPartenza?: number | null;
    contattoAgenziaID?: number | null;
    export?: boolean;

    constructor(data?: IOfferteIncompleteReportRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.giorniPartenza = _data["giorniPartenza"] !== undefined ? _data["giorniPartenza"] : <any>null;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : <any>null;
            this.export = _data["export"] !== undefined ? _data["export"] : <any>null;
        }
    }

    static fromJS(data: any): OfferteIncompleteReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OfferteIncompleteReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorniPartenza"] = this.giorniPartenza !== undefined ? this.giorniPartenza : <any>null;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : <any>null;
        data["export"] = this.export !== undefined ? this.export : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IOfferteIncompleteReportRequest extends IApiRequest {
    giorniPartenza?: number | null;
    contattoAgenziaID?: number | null;
    export?: boolean;
}

export class SendOfferteIncompleteEmail extends OfferteIncompleteReportRequest implements ISendOfferteIncompleteEmail {
    recipient?: EOfferteIncompleteEmailRecipient;
    traduzioniDatoClienteMancante?: { [key in keyof typeof EDatoClienteMancante]?: string; } | null;

    constructor(data?: ISendOfferteIncompleteEmail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recipient = _data["recipient"] !== undefined ? _data["recipient"] : <any>null;
            if (_data["traduzioniDatoClienteMancante"]) {
                this.traduzioniDatoClienteMancante = {} as any;
                for (let key in _data["traduzioniDatoClienteMancante"]) {
                    if (_data["traduzioniDatoClienteMancante"].hasOwnProperty(key))
                        (<any>this.traduzioniDatoClienteMancante)![key] = _data["traduzioniDatoClienteMancante"][key] !== undefined ? _data["traduzioniDatoClienteMancante"][key] : <any>null;
                }
            }
            else {
                this.traduzioniDatoClienteMancante = <any>null;
            }
        }
    }

    static fromJS(data: any): SendOfferteIncompleteEmail {
        data = typeof data === 'object' ? data : {};
        let result = new SendOfferteIncompleteEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient !== undefined ? this.recipient : <any>null;
        if (this.traduzioniDatoClienteMancante) {
            data["traduzioniDatoClienteMancante"] = {};
            for (let key in this.traduzioniDatoClienteMancante) {
                if (this.traduzioniDatoClienteMancante.hasOwnProperty(key))
                    (<any>data["traduzioniDatoClienteMancante"])[key] = this.traduzioniDatoClienteMancante[key] !== undefined ? this.traduzioniDatoClienteMancante[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISendOfferteIncompleteEmail extends IOfferteIncompleteReportRequest {
    recipient?: EOfferteIncompleteEmailRecipient;
    traduzioniDatoClienteMancante?: { [key in keyof typeof EDatoClienteMancante]?: string; } | null;
}

export enum EOfferteIncompleteEmailRecipient {
    Agenzia = "Agenzia",
    Utente = "Utente",
    UtentePreventivo = "UtentePreventivo",
    UtenteConferma = "UtenteConferma",
}

export class NrTableResponseOfReservationRow extends OkApiResponse implements INrTableResponseOfReservationRow {
    /** Array delle righe della pagina richiesta */
    rows?: ReservationRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfReservationRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ReservationRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfReservationRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfReservationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfReservationRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ReservationRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ReservationsListRequestResponse extends NrTableResponseOfReservationRow implements IReservationsListRequestResponse {

    constructor(data?: IReservationsListRequestResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ReservationsListRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationsListRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReservationsListRequestResponse extends INrTableResponseOfReservationRow {
}

export class ReservationRow implements IReservationRow {
    contattoNome?: string | null;
    contattoValuta?: string | null;
    contattoId?: number | null;
    valutaId?: number | null;
    reservationIndex?: number;

    constructor(data?: IReservationRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contattoNome = _data["contattoNome"] !== undefined ? _data["contattoNome"] : <any>null;
            this.contattoValuta = _data["contattoValuta"] !== undefined ? _data["contattoValuta"] : <any>null;
            this.contattoId = _data["contattoId"] !== undefined ? _data["contattoId"] : <any>null;
            this.valutaId = _data["valutaId"] !== undefined ? _data["valutaId"] : <any>null;
            this.reservationIndex = _data["reservationIndex"] !== undefined ? _data["reservationIndex"] : <any>null;
        }
    }

    static fromJS(data: any): ReservationRow {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contattoNome"] = this.contattoNome !== undefined ? this.contattoNome : <any>null;
        data["contattoValuta"] = this.contattoValuta !== undefined ? this.contattoValuta : <any>null;
        data["contattoId"] = this.contattoId !== undefined ? this.contattoId : <any>null;
        data["valutaId"] = this.valutaId !== undefined ? this.valutaId : <any>null;
        data["reservationIndex"] = this.reservationIndex !== undefined ? this.reservationIndex : <any>null;
        return data;
    }
}

export interface IReservationRow {
    contattoNome?: string | null;
    contattoValuta?: string | null;
    contattoId?: number | null;
    valutaId?: number | null;
    reservationIndex?: number;
}

export class ReservationsListRequestRequest extends NrTableRequest implements IReservationsListRequestRequest {
    offertaID?: number;

    constructor(data?: IReservationsListRequestRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
        }
    }

    static fromJS(data: any): ReservationsListRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationsListRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IReservationsListRequestRequest extends INrTableRequest {
    offertaID?: number;
}

export class IntranetSearchResponse extends OkApiResponse implements IIntranetSearchResponse {
    luoghiCount?: number;
    luoghi?: LuogoSearchRow[] | null;
    serviziCount?: number;
    servizi?: ServizioSearchRow[] | null;
    contattiCount?: number;
    contatti?: ContattoSearchRow[] | null;
    accordiCount?: number;
    accordi?: AccordoSearchRow[] | null;
    articoliCount?: number;
    articoli?: ArticoloSearchRow[] | null;

    constructor(data?: IIntranetSearchResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.luoghiCount = _data["luoghiCount"] !== undefined ? _data["luoghiCount"] : <any>null;
            if (Array.isArray(_data["luoghi"])) {
                this.luoghi = [] as any;
                for (let item of _data["luoghi"])
                    this.luoghi!.push(LuogoSearchRow.fromJS(item));
            }
            else {
                this.luoghi = <any>null;
            }
            this.serviziCount = _data["serviziCount"] !== undefined ? _data["serviziCount"] : <any>null;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioSearchRow.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
            this.contattiCount = _data["contattiCount"] !== undefined ? _data["contattiCount"] : <any>null;
            if (Array.isArray(_data["contatti"])) {
                this.contatti = [] as any;
                for (let item of _data["contatti"])
                    this.contatti!.push(ContattoSearchRow.fromJS(item));
            }
            else {
                this.contatti = <any>null;
            }
            this.accordiCount = _data["accordiCount"] !== undefined ? _data["accordiCount"] : <any>null;
            if (Array.isArray(_data["accordi"])) {
                this.accordi = [] as any;
                for (let item of _data["accordi"])
                    this.accordi!.push(AccordoSearchRow.fromJS(item));
            }
            else {
                this.accordi = <any>null;
            }
            this.articoliCount = _data["articoliCount"] !== undefined ? _data["articoliCount"] : <any>null;
            if (Array.isArray(_data["articoli"])) {
                this.articoli = [] as any;
                for (let item of _data["articoli"])
                    this.articoli!.push(ArticoloSearchRow.fromJS(item));
            }
            else {
                this.articoli = <any>null;
            }
        }
    }

    static fromJS(data: any): IntranetSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntranetSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luoghiCount"] = this.luoghiCount !== undefined ? this.luoghiCount : <any>null;
        if (Array.isArray(this.luoghi)) {
            data["luoghi"] = [];
            for (let item of this.luoghi)
                data["luoghi"].push(item.toJSON());
        }
        data["serviziCount"] = this.serviziCount !== undefined ? this.serviziCount : <any>null;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        data["contattiCount"] = this.contattiCount !== undefined ? this.contattiCount : <any>null;
        if (Array.isArray(this.contatti)) {
            data["contatti"] = [];
            for (let item of this.contatti)
                data["contatti"].push(item.toJSON());
        }
        data["accordiCount"] = this.accordiCount !== undefined ? this.accordiCount : <any>null;
        if (Array.isArray(this.accordi)) {
            data["accordi"] = [];
            for (let item of this.accordi)
                data["accordi"].push(item.toJSON());
        }
        data["articoliCount"] = this.articoliCount !== undefined ? this.articoliCount : <any>null;
        if (Array.isArray(this.articoli)) {
            data["articoli"] = [];
            for (let item of this.articoli)
                data["articoli"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIntranetSearchResponse extends IOkApiResponse {
    luoghiCount?: number;
    luoghi?: LuogoSearchRow[] | null;
    serviziCount?: number;
    servizi?: ServizioSearchRow[] | null;
    contattiCount?: number;
    contatti?: ContattoSearchRow[] | null;
    accordiCount?: number;
    accordi?: AccordoSearchRow[] | null;
    articoliCount?: number;
    articoli?: ArticoloSearchRow[] | null;
}

export class LuogoSearchRow implements ILuogoSearchRow {
    id?: number;
    nome?: string | null;
    tipo?: ETipoLuogo;
    regione?: string | null;
    paese?: string | null;

    constructor(data?: ILuogoSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
        }
    }

    static fromJS(data: any): LuogoSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["regione"] = this.regione !== undefined ? this.regione : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        return data;
    }
}

export interface ILuogoSearchRow {
    id?: number;
    nome?: string | null;
    tipo?: ETipoLuogo;
    regione?: string | null;
    paese?: string | null;
}

export class ServizioSearchRow implements IServizioSearchRow {
    id?: number;
    nome?: string | null;
    tipo?: ETipoServizio;
    luogo?: string | null;

    constructor(data?: IServizioSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        return data;
    }
}

export interface IServizioSearchRow {
    id?: number;
    nome?: string | null;
    tipo?: ETipoServizio;
    luogo?: string | null;
}

export class ContattoSearchRow implements IContattoSearchRow {
    id?: number;
    nome?: string | null;
    luogo?: string | null;
    tipo?: ETipoContatto;

    constructor(data?: IContattoSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
        }
    }

    static fromJS(data: any): ContattoSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new ContattoSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        return data;
    }
}

export interface IContattoSearchRow {
    id?: number;
    nome?: string | null;
    luogo?: string | null;
    tipo?: ETipoContatto;
}

export class AccordoSearchRow implements IAccordoSearchRow {
    id?: number;
    nome?: string | null;
    tipo?: ETipoAccordo;

    constructor(data?: IAccordoSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
        }
    }

    static fromJS(data: any): AccordoSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new AccordoSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        return data;
    }
}

export interface IAccordoSearchRow {
    id?: number;
    nome?: string | null;
    tipo?: ETipoAccordo;
}

export class ArticoloSearchRow implements IArticoloSearchRow {
    id?: number;
    titolo?: string | null;
    luogo?: string | null;
    servizio?: string | null;

    constructor(data?: IArticoloSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
        }
    }

    static fromJS(data: any): ArticoloSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        return data;
    }
}

export interface IArticoloSearchRow {
    id?: number;
    titolo?: string | null;
    luogo?: string | null;
    servizio?: string | null;
}

export class IntranetSearchRequest extends LocalizedRequest implements IIntranetSearchRequest {
    term!: string;

    constructor(data?: IIntranetSearchRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
        }
    }

    static fromJS(data: any): IntranetSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IntranetSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIntranetSearchRequest extends ILocalizedRequest {
    term: string;
}

export class SiteSearchResponse extends OkApiResponse implements ISiteSearchResponse {
    conteggioLuoghi?: number;
    altriLuoghi?: boolean;
    luoghi?: LuogoSiteSearchRow[] | null;
    conteggioServizi?: number;
    altriServizi?: boolean;
    servizi?: ServizioSiteSearchRow[] | null;

    constructor(data?: ISiteSearchResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.conteggioLuoghi = _data["conteggioLuoghi"] !== undefined ? _data["conteggioLuoghi"] : <any>null;
            this.altriLuoghi = _data["altriLuoghi"] !== undefined ? _data["altriLuoghi"] : <any>null;
            if (Array.isArray(_data["luoghi"])) {
                this.luoghi = [] as any;
                for (let item of _data["luoghi"])
                    this.luoghi!.push(LuogoSiteSearchRow.fromJS(item));
            }
            else {
                this.luoghi = <any>null;
            }
            this.conteggioServizi = _data["conteggioServizi"] !== undefined ? _data["conteggioServizi"] : <any>null;
            this.altriServizi = _data["altriServizi"] !== undefined ? _data["altriServizi"] : <any>null;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioSiteSearchRow.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
        }
    }

    static fromJS(data: any): SiteSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SiteSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conteggioLuoghi"] = this.conteggioLuoghi !== undefined ? this.conteggioLuoghi : <any>null;
        data["altriLuoghi"] = this.altriLuoghi !== undefined ? this.altriLuoghi : <any>null;
        if (Array.isArray(this.luoghi)) {
            data["luoghi"] = [];
            for (let item of this.luoghi)
                data["luoghi"].push(item.toJSON());
        }
        data["conteggioServizi"] = this.conteggioServizi !== undefined ? this.conteggioServizi : <any>null;
        data["altriServizi"] = this.altriServizi !== undefined ? this.altriServizi : <any>null;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISiteSearchResponse extends IOkApiResponse {
    conteggioLuoghi?: number;
    altriLuoghi?: boolean;
    luoghi?: LuogoSiteSearchRow[] | null;
    conteggioServizi?: number;
    altriServizi?: boolean;
    servizi?: ServizioSiteSearchRow[] | null;
}

export class LuogoSiteSearchRow implements ILuogoSiteSearchRow {
    id?: number;
    nome?: string | null;
    nomeClean?: string | null;
    urlPart?: string | null;
    regione?: string | null;
    paese?: string | null;
    hotel?: number;
    tour?: number;
    selfDrive?: number;
    trasferimenti?: number;
    visite?: number;
    itinerariConsigliati?: number;

    constructor(data?: ILuogoSiteSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeClean = _data["nomeClean"] !== undefined ? _data["nomeClean"] : <any>null;
            this.urlPart = _data["urlPart"] !== undefined ? _data["urlPart"] : <any>null;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
            this.hotel = _data["hotel"] !== undefined ? _data["hotel"] : <any>null;
            this.tour = _data["tour"] !== undefined ? _data["tour"] : <any>null;
            this.selfDrive = _data["selfDrive"] !== undefined ? _data["selfDrive"] : <any>null;
            this.trasferimenti = _data["trasferimenti"] !== undefined ? _data["trasferimenti"] : <any>null;
            this.visite = _data["visite"] !== undefined ? _data["visite"] : <any>null;
            this.itinerariConsigliati = _data["itinerariConsigliati"] !== undefined ? _data["itinerariConsigliati"] : <any>null;
        }
    }

    static fromJS(data: any): LuogoSiteSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new LuogoSiteSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeClean"] = this.nomeClean !== undefined ? this.nomeClean : <any>null;
        data["urlPart"] = this.urlPart !== undefined ? this.urlPart : <any>null;
        data["regione"] = this.regione !== undefined ? this.regione : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        data["hotel"] = this.hotel !== undefined ? this.hotel : <any>null;
        data["tour"] = this.tour !== undefined ? this.tour : <any>null;
        data["selfDrive"] = this.selfDrive !== undefined ? this.selfDrive : <any>null;
        data["trasferimenti"] = this.trasferimenti !== undefined ? this.trasferimenti : <any>null;
        data["visite"] = this.visite !== undefined ? this.visite : <any>null;
        data["itinerariConsigliati"] = this.itinerariConsigliati !== undefined ? this.itinerariConsigliati : <any>null;
        return data;
    }
}

export interface ILuogoSiteSearchRow {
    id?: number;
    nome?: string | null;
    nomeClean?: string | null;
    urlPart?: string | null;
    regione?: string | null;
    paese?: string | null;
    hotel?: number;
    tour?: number;
    selfDrive?: number;
    trasferimenti?: number;
    visite?: number;
    itinerariConsigliati?: number;
}

export class ServizioSiteSearchRow implements IServizioSiteSearchRow {
    id?: number;
    nome?: string | null;
    esterno?: boolean;
    nomeClean?: string | null;
    urlPart?: string | null;
    tipo?: ETipoServizio;
    isVisita?: boolean;
    luogoID?: number;
    luogo?: string | null;
    luogoUrlPart?: string | null;
    regione?: string | null;
    paese?: string | null;
    giornaliero?: boolean;
    partenze?: PartenzaSiteSearch[] | null;

    constructor(data?: IServizioSiteSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.esterno = _data["esterno"] !== undefined ? _data["esterno"] : <any>null;
            this.nomeClean = _data["nomeClean"] !== undefined ? _data["nomeClean"] : <any>null;
            this.urlPart = _data["urlPart"] !== undefined ? _data["urlPart"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.isVisita = _data["isVisita"] !== undefined ? _data["isVisita"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.luogoUrlPart = _data["luogoUrlPart"] !== undefined ? _data["luogoUrlPart"] : <any>null;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
            this.giornaliero = _data["giornaliero"] !== undefined ? _data["giornaliero"] : <any>null;
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(PartenzaSiteSearch.fromJS(item));
            }
            else {
                this.partenze = <any>null;
            }
        }
    }

    static fromJS(data: any): ServizioSiteSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioSiteSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["esterno"] = this.esterno !== undefined ? this.esterno : <any>null;
        data["nomeClean"] = this.nomeClean !== undefined ? this.nomeClean : <any>null;
        data["urlPart"] = this.urlPart !== undefined ? this.urlPart : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["isVisita"] = this.isVisita !== undefined ? this.isVisita : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["luogoUrlPart"] = this.luogoUrlPart !== undefined ? this.luogoUrlPart : <any>null;
        data["regione"] = this.regione !== undefined ? this.regione : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        data["giornaliero"] = this.giornaliero !== undefined ? this.giornaliero : <any>null;
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServizioSiteSearchRow {
    id?: number;
    nome?: string | null;
    esterno?: boolean;
    nomeClean?: string | null;
    urlPart?: string | null;
    tipo?: ETipoServizio;
    isVisita?: boolean;
    luogoID?: number;
    luogo?: string | null;
    luogoUrlPart?: string | null;
    regione?: string | null;
    paese?: string | null;
    giornaliero?: boolean;
    partenze?: PartenzaSiteSearch[] | null;
}

export class PartenzaSiteSearch implements IPartenzaSiteSearch {
    data?: string;
    prima?: boolean;
    dopo?: boolean;

    constructor(data?: IPartenzaSiteSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.prima = _data["prima"] !== undefined ? _data["prima"] : <any>null;
            this.dopo = _data["dopo"] !== undefined ? _data["dopo"] : <any>null;
        }
    }

    static fromJS(data: any): PartenzaSiteSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PartenzaSiteSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["prima"] = this.prima !== undefined ? this.prima : <any>null;
        data["dopo"] = this.dopo !== undefined ? this.dopo : <any>null;
        return data;
    }
}

export interface IPartenzaSiteSearch {
    data?: string;
    prima?: boolean;
    dopo?: boolean;
}

export class SiteSearchRequest extends SiteRequest implements ISiteSearchRequest {
    term?: string | null;
    fullResult?: boolean;
    fromDate?: string;
    toDate?: string;

    constructor(data?: ISiteSearchRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.fullResult = _data["fullResult"] !== undefined ? _data["fullResult"] : <any>null;
            this.fromDate = _data["fromDate"] !== undefined ? _data["fromDate"] : <any>null;
            this.toDate = _data["toDate"] !== undefined ? _data["toDate"] : <any>null;
        }
    }

    static fromJS(data: any): SiteSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SiteSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["fullResult"] = this.fullResult !== undefined ? this.fullResult : <any>null;
        data["fromDate"] = this.fromDate !== undefined ? this.fromDate : <any>null;
        data["toDate"] = this.toDate !== undefined ? this.toDate : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISiteSearchRequest extends ISiteRequest {
    term?: string | null;
    fullResult?: boolean;
    fromDate?: string;
    toDate?: string;
}

export class TripsSearchResponse extends OkApiResponse implements ITripsSearchResponse {
    offerte?: OffertaSearchRow[] | null;

    constructor(data?: ITripsSearchResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["offerte"])) {
                this.offerte = [] as any;
                for (let item of _data["offerte"])
                    this.offerte!.push(OffertaSearchRow.fromJS(item));
            }
            else {
                this.offerte = <any>null;
            }
        }
    }

    static fromJS(data: any): TripsSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TripsSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.offerte)) {
            data["offerte"] = [];
            for (let item of this.offerte)
                data["offerte"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITripsSearchResponse extends IOkApiResponse {
    offerte?: OffertaSearchRow[] | null;
}

export class OffertaSearchRow implements IOffertaSearchRow {
    id?: number;
    nome?: string | null;
    destinazione?: string | null;
    partenza?: string;
    conferma?: boolean;
    annullamentoTO?: boolean;
    nomiPax?: string | null;

    constructor(data?: IOffertaSearchRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : <any>null;
            this.annullamentoTO = _data["annullamentoTO"] !== undefined ? _data["annullamentoTO"] : <any>null;
            this.nomiPax = _data["nomiPax"] !== undefined ? _data["nomiPax"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaSearchRow {
        data = typeof data === 'object' ? data : {};
        let result = new OffertaSearchRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["conferma"] = this.conferma !== undefined ? this.conferma : <any>null;
        data["annullamentoTO"] = this.annullamentoTO !== undefined ? this.annullamentoTO : <any>null;
        data["nomiPax"] = this.nomiPax !== undefined ? this.nomiPax : <any>null;
        return data;
    }
}

export interface IOffertaSearchRow {
    id?: number;
    nome?: string | null;
    destinazione?: string | null;
    partenza?: string;
    conferma?: boolean;
    annullamentoTO?: boolean;
    nomiPax?: string | null;
}

export class ServizioGetResponse extends OkApiResponse implements IServizioGetResponse {
    nome?: string | null;
    luogo?: string | null;
    servizio?: Servizio | null;

    constructor(data?: IServizioGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.servizio = _data["servizio"] ? Servizio.fromJS(_data["servizio"]) : <any>null;
        }
    }

    static fromJS(data: any): ServizioGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioGetResponse extends IOkApiResponse {
    nome?: string | null;
    luogo?: string | null;
    servizio?: Servizio | null;
}

export class ServizioGetRequest extends LocalizedRequest implements IServizioGetRequest {
    servizioID?: number;

    constructor(data?: IServizioGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioGetRequest extends ILocalizedRequest {
    servizioID?: number;
}

export class CloneServizioRequest extends ServizioGetRequest implements ICloneServizioRequest {
    tipologie?: boolean;
    itinerari?: boolean;
    attributi?: boolean;
    partenze?: boolean;
    accordi?: boolean;
    validita?: boolean;
    regoleServizio?: boolean;
    regoleVendita?: boolean;
    costi?: boolean;
    associazioni?: boolean;
    multiluogo?: boolean;
    immagini?: boolean;

    constructor(data?: ICloneServizioRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipologie = _data["tipologie"] !== undefined ? _data["tipologie"] : <any>null;
            this.itinerari = _data["itinerari"] !== undefined ? _data["itinerari"] : <any>null;
            this.attributi = _data["attributi"] !== undefined ? _data["attributi"] : <any>null;
            this.partenze = _data["partenze"] !== undefined ? _data["partenze"] : <any>null;
            this.accordi = _data["accordi"] !== undefined ? _data["accordi"] : <any>null;
            this.validita = _data["validita"] !== undefined ? _data["validita"] : <any>null;
            this.regoleServizio = _data["regoleServizio"] !== undefined ? _data["regoleServizio"] : <any>null;
            this.regoleVendita = _data["regoleVendita"] !== undefined ? _data["regoleVendita"] : <any>null;
            this.costi = _data["costi"] !== undefined ? _data["costi"] : <any>null;
            this.associazioni = _data["associazioni"] !== undefined ? _data["associazioni"] : <any>null;
            this.multiluogo = _data["multiluogo"] !== undefined ? _data["multiluogo"] : <any>null;
            this.immagini = _data["immagini"] !== undefined ? _data["immagini"] : <any>null;
        }
    }

    static fromJS(data: any): CloneServizioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloneServizioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologie"] = this.tipologie !== undefined ? this.tipologie : <any>null;
        data["itinerari"] = this.itinerari !== undefined ? this.itinerari : <any>null;
        data["attributi"] = this.attributi !== undefined ? this.attributi : <any>null;
        data["partenze"] = this.partenze !== undefined ? this.partenze : <any>null;
        data["accordi"] = this.accordi !== undefined ? this.accordi : <any>null;
        data["validita"] = this.validita !== undefined ? this.validita : <any>null;
        data["regoleServizio"] = this.regoleServizio !== undefined ? this.regoleServizio : <any>null;
        data["regoleVendita"] = this.regoleVendita !== undefined ? this.regoleVendita : <any>null;
        data["costi"] = this.costi !== undefined ? this.costi : <any>null;
        data["associazioni"] = this.associazioni !== undefined ? this.associazioni : <any>null;
        data["multiluogo"] = this.multiluogo !== undefined ? this.multiluogo : <any>null;
        data["immagini"] = this.immagini !== undefined ? this.immagini : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICloneServizioRequest extends IServizioGetRequest {
    tipologie?: boolean;
    itinerari?: boolean;
    attributi?: boolean;
    partenze?: boolean;
    accordi?: boolean;
    validita?: boolean;
    regoleServizio?: boolean;
    regoleVendita?: boolean;
    costi?: boolean;
    associazioni?: boolean;
    multiluogo?: boolean;
    immagini?: boolean;
}

export class GetValiditaResponse extends OkApiResponse implements IGetValiditaResponse {
    validita?: ValiditaListRow[] | null;

    constructor(data?: IGetValiditaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["validita"])) {
                this.validita = [] as any;
                for (let item of _data["validita"])
                    this.validita!.push(ValiditaListRow.fromJS(item));
            }
            else {
                this.validita = <any>null;
            }
        }
    }

    static fromJS(data: any): GetValiditaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetValiditaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validita)) {
            data["validita"] = [];
            for (let item of this.validita)
                data["validita"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetValiditaResponse extends IOkApiResponse {
    validita?: ValiditaListRow[] | null;
}

export class ValiditaListRow implements IValiditaListRow {
    id?: number;
    validita?: Validita | null;
    giorni?: EGiornoSettimana[] | null;
    scaduta?: boolean;

    constructor(data?: IValiditaListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.validita = _data["validita"] ? Validita.fromJS(_data["validita"]) : <any>null;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(item);
            }
            else {
                this.giorni = <any>null;
            }
            this.scaduta = _data["scaduta"] !== undefined ? _data["scaduta"] : <any>null;
        }
    }

    static fromJS(data: any): ValiditaListRow {
        data = typeof data === 'object' ? data : {};
        let result = new ValiditaListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["validita"] = this.validita ? this.validita.toJSON() : <any>null;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item);
        }
        data["scaduta"] = this.scaduta !== undefined ? this.scaduta : <any>null;
        return data;
    }
}

export interface IValiditaListRow {
    id?: number;
    validita?: Validita | null;
    giorni?: EGiornoSettimana[] | null;
    scaduta?: boolean;
}

export enum EGiornoSettimana {
    Lunedi = "Lunedi",
    Martedi = "Martedi",
    Mercoledi = "Mercoledi",
    Giovedi = "Giovedi",
    Venerdi = "Venerdi",
    Sabato = "Sabato",
    Domenica = "Domenica",
}

export class CloneValiditaRequest extends ServizioGetRequest implements ICloneValiditaRequest {
    validitaIDs?: number[] | null;
    deltaDays?: number;
    deltaCostoPercentuale?: number;

    constructor(data?: ICloneValiditaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["validitaIDs"])) {
                this.validitaIDs = [] as any;
                for (let item of _data["validitaIDs"])
                    this.validitaIDs!.push(item);
            }
            else {
                this.validitaIDs = <any>null;
            }
            this.deltaDays = _data["deltaDays"] !== undefined ? _data["deltaDays"] : <any>null;
            this.deltaCostoPercentuale = _data["deltaCostoPercentuale"] !== undefined ? _data["deltaCostoPercentuale"] : <any>null;
        }
    }

    static fromJS(data: any): CloneValiditaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloneValiditaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validitaIDs)) {
            data["validitaIDs"] = [];
            for (let item of this.validitaIDs)
                data["validitaIDs"].push(item);
        }
        data["deltaDays"] = this.deltaDays !== undefined ? this.deltaDays : <any>null;
        data["deltaCostoPercentuale"] = this.deltaCostoPercentuale !== undefined ? this.deltaCostoPercentuale : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICloneValiditaRequest extends IServizioGetRequest {
    validitaIDs?: number[] | null;
    deltaDays?: number;
    deltaCostoPercentuale?: number;
}

export class GetPartenzeResponse extends OkApiResponse implements IGetPartenzeResponse {
    /** Partenze raggruppare per mese, in ordine di data */
    partenzeMese?: PartenzeMese[];

    constructor(data?: IGetPartenzeResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["partenzeMese"])) {
                this.partenzeMese = [] as any;
                for (let item of _data["partenzeMese"])
                    this.partenzeMese!.push(PartenzeMese.fromJS(item));
            }
            else {
                this.partenzeMese = <any>null;
            }
        }
    }

    static fromJS(data: any): GetPartenzeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartenzeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partenzeMese)) {
            data["partenzeMese"] = [];
            for (let item of this.partenzeMese)
                data["partenzeMese"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetPartenzeResponse extends IOkApiResponse {
    /** Partenze raggruppare per mese, in ordine di data */
    partenzeMese?: PartenzeMese[];
}

export class PartenzeMese implements IPartenzeMese {
    /** Data fissata al primo del mese che rappresenta questo raggruppamento */
    primoDelMese?: string;
    /** Elenco delle partenze, in ordine di data */
    partenze?: Partenza[];

    constructor(data?: IPartenzeMese) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primoDelMese = _data["primoDelMese"] !== undefined ? _data["primoDelMese"] : <any>null;
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(Partenza.fromJS(item));
            }
            else {
                this.partenze = <any>null;
            }
        }
    }

    static fromJS(data: any): PartenzeMese {
        data = typeof data === 'object' ? data : {};
        let result = new PartenzeMese();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primoDelMese"] = this.primoDelMese !== undefined ? this.primoDelMese : <any>null;
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPartenzeMese {
    /** Data fissata al primo del mese che rappresenta questo raggruppamento */
    primoDelMese?: string;
    /** Elenco delle partenze, in ordine di data */
    partenze?: Partenza[];
}

export class CreatePartenzeRequest extends ServizioGetRequest implements ICreatePartenzeRequest {
    /** Partenza stampino usata per i flag */
    stampino!: IPartenzaBase;
    /** Data iniziale */
    start?: string;
    /** Data finale */
    stop?: string;
    /** Incremento in giorni, da 1 a 255 */
    step?: number;

    constructor(data?: ICreatePartenzeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stampino = _data["stampino"] ? IPartenzaBase.fromJS(_data["stampino"]) : <any>null;
            this.start = _data["start"] !== undefined ? _data["start"] : <any>null;
            this.stop = _data["stop"] !== undefined ? _data["stop"] : <any>null;
            this.step = _data["step"] !== undefined ? _data["step"] : <any>null;
        }
    }

    static fromJS(data: any): CreatePartenzeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartenzeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stampino"] = this.stampino ? this.stampino.toJSON() : <any>null;
        data["start"] = this.start !== undefined ? this.start : <any>null;
        data["stop"] = this.stop !== undefined ? this.stop : <any>null;
        data["step"] = this.step !== undefined ? this.step : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreatePartenzeRequest extends IServizioGetRequest {
    /** Partenza stampino usata per i flag */
    stampino: IPartenzaBase;
    /** Data iniziale */
    start?: string;
    /** Data finale */
    stop?: string;
    /** Incremento in giorni, da 1 a 255 */
    step?: number;
}

export abstract class IPartenzaBase implements IIPartenzaBase {
    partenzaID?: number;
    servizioID?: number;
    data?: string | null;
    flags?: EPartenzaFlags;

    constructor(data?: IIPartenzaBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partenzaID = _data["partenzaID"] !== undefined ? _data["partenzaID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.flags = _data["flags"] !== undefined ? _data["flags"] : <any>null;
        }
    }

    static fromJS(data: any): IPartenzaBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IPartenzaBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partenzaID"] = this.partenzaID !== undefined ? this.partenzaID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["flags"] = this.flags !== undefined ? this.flags : <any>null;
        return data;
    }
}

export interface IIPartenzaBase {
    partenzaID?: number;
    servizioID?: number;
    data?: string | null;
    flags?: EPartenzaFlags;
}

export class GetAssociazioniResponse extends OkApiResponse implements IGetAssociazioniResponse {
    /** Elenco delle associazioni non specifiche di questo servizio */
    associazioni?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche tipologia / supplemento */
    associazioniSupplementi?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche di regole vendita aggiuntive */
    associazioniRegoleVenditaAggiuntive?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche di offerte */
    associazioniOfferte?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche di penali di cancellazione */
    associazioniPenali?: ServizioAssociazioneRow[];

    constructor(data?: IGetAssociazioniResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["associazioni"])) {
                this.associazioni = [] as any;
                for (let item of _data["associazioni"])
                    this.associazioni!.push(ServizioAssociazioneRow.fromJS(item));
            }
            else {
                this.associazioni = <any>null;
            }
            if (Array.isArray(_data["associazioniSupplementi"])) {
                this.associazioniSupplementi = [] as any;
                for (let item of _data["associazioniSupplementi"])
                    this.associazioniSupplementi!.push(ServizioAssociazioneRow.fromJS(item));
            }
            else {
                this.associazioniSupplementi = <any>null;
            }
            if (Array.isArray(_data["associazioniRegoleVenditaAggiuntive"])) {
                this.associazioniRegoleVenditaAggiuntive = [] as any;
                for (let item of _data["associazioniRegoleVenditaAggiuntive"])
                    this.associazioniRegoleVenditaAggiuntive!.push(ServizioAssociazioneRow.fromJS(item));
            }
            else {
                this.associazioniRegoleVenditaAggiuntive = <any>null;
            }
            if (Array.isArray(_data["associazioniOfferte"])) {
                this.associazioniOfferte = [] as any;
                for (let item of _data["associazioniOfferte"])
                    this.associazioniOfferte!.push(ServizioAssociazioneRow.fromJS(item));
            }
            else {
                this.associazioniOfferte = <any>null;
            }
            if (Array.isArray(_data["associazioniPenali"])) {
                this.associazioniPenali = [] as any;
                for (let item of _data["associazioniPenali"])
                    this.associazioniPenali!.push(ServizioAssociazioneRow.fromJS(item));
            }
            else {
                this.associazioniPenali = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAssociazioniResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssociazioniResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associazioni)) {
            data["associazioni"] = [];
            for (let item of this.associazioni)
                data["associazioni"].push(item.toJSON());
        }
        if (Array.isArray(this.associazioniSupplementi)) {
            data["associazioniSupplementi"] = [];
            for (let item of this.associazioniSupplementi)
                data["associazioniSupplementi"].push(item.toJSON());
        }
        if (Array.isArray(this.associazioniRegoleVenditaAggiuntive)) {
            data["associazioniRegoleVenditaAggiuntive"] = [];
            for (let item of this.associazioniRegoleVenditaAggiuntive)
                data["associazioniRegoleVenditaAggiuntive"].push(item.toJSON());
        }
        if (Array.isArray(this.associazioniOfferte)) {
            data["associazioniOfferte"] = [];
            for (let item of this.associazioniOfferte)
                data["associazioniOfferte"].push(item.toJSON());
        }
        if (Array.isArray(this.associazioniPenali)) {
            data["associazioniPenali"] = [];
            for (let item of this.associazioniPenali)
                data["associazioniPenali"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAssociazioniResponse extends IOkApiResponse {
    /** Elenco delle associazioni non specifiche di questo servizio */
    associazioni?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche tipologia / supplemento */
    associazioniSupplementi?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche di regole vendita aggiuntive */
    associazioniRegoleVenditaAggiuntive?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche di offerte */
    associazioniOfferte?: ServizioAssociazioneRow[];
    /** Elenco delle associazioni specifiche di penali di cancellazione */
    associazioniPenali?: ServizioAssociazioneRow[];
}

/** Rappresentazione tabulare di un'associazione + Dati per ricavare la maschera di edit */
export class ServizioAssociazioneRow implements IServizioAssociazioneRow {
    /** ID dell'associazione */
    id?: number;
    /** Entità dell'associazione */
    associazione?: ServizioAssociazione;
    /** Eventuale configurazione di un'offerta componibile */
    offertaComponibile?: OffertaComponibile | null;
    /** Nome della tipologia associata. Se null => si associa a tutte le tipologie */
    tipologiaParent?: string | null;
    /** Nome del supplemento specifico. Se null => si associa a tutti i supplementi */
    supplementoSpecifico?: string | null;
    /** Nome della tabella costi commissioni. Se null => si associa a tutte le tabelle */
    tabellaCostiCommissioni?: string | null;
    /** Nome della regola vendita. Se null => si associa a tutte le regole vendita */
    regolaVendita?: string | null;
    /** Nome della sistemazione. Se null => si associa a tutte le sistemazioni */
    sistemazione?: string | null;
    /** Nome del trattamento. Se null => si associa a tutti i trattamenti */
    trattamento?: string | null;
    /** Periodi di esclusione (solo offerte componibili) */
    esclusioni?: string | null;
    /** Flag di disabilitazione (solo offerte componibili) */
    disabilitata?: boolean;
    /** Label dell'offerta (solo offerte componibili) */
    labelOfferta?: string | null;
    /** Codice dell'offerta (solo offerte componibili) */
    codice?: string | null;
    /** Ordine di priorità (solo offerte componibili) */
    priorita?: number | null;
    /** Codici di cumulabilità (solo offerte componibili, T=tutte) */
    cumulabilita?: string | null;
    /** True se l'associazione è generica e può essere convertita in tipo supplemento */
    convertibileSupplemento?: boolean;
    /** True se l'associazione è generica e può essere convertita in tipo regola vendita aggiuntiva */
    convertibileRegola?: boolean;
    /** True se l'associazione è generica e può essere convertita in tipo regola vendita penale */
    convertibilePenale?: boolean;
    /** True se l'associazione è generica e può essere convertita in tipo offerta componibile */
    convertibileOfferta?: boolean;

    constructor(data?: IServizioAssociazioneRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.associazione = _data["associazione"] ? ServizioAssociazione.fromJS(_data["associazione"]) : <any>null;
            this.offertaComponibile = _data["offertaComponibile"] ? OffertaComponibile.fromJS(_data["offertaComponibile"]) : <any>null;
            this.tipologiaParent = _data["tipologiaParent"] !== undefined ? _data["tipologiaParent"] : <any>null;
            this.supplementoSpecifico = _data["supplementoSpecifico"] !== undefined ? _data["supplementoSpecifico"] : <any>null;
            this.tabellaCostiCommissioni = _data["tabellaCostiCommissioni"] !== undefined ? _data["tabellaCostiCommissioni"] : <any>null;
            this.regolaVendita = _data["regolaVendita"] !== undefined ? _data["regolaVendita"] : <any>null;
            this.sistemazione = _data["sistemazione"] !== undefined ? _data["sistemazione"] : <any>null;
            this.trattamento = _data["trattamento"] !== undefined ? _data["trattamento"] : <any>null;
            this.esclusioni = _data["esclusioni"] !== undefined ? _data["esclusioni"] : <any>null;
            this.disabilitata = _data["disabilitata"] !== undefined ? _data["disabilitata"] : <any>null;
            this.labelOfferta = _data["labelOfferta"] !== undefined ? _data["labelOfferta"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.priorita = _data["priorita"] !== undefined ? _data["priorita"] : <any>null;
            this.cumulabilita = _data["cumulabilita"] !== undefined ? _data["cumulabilita"] : <any>null;
            this.convertibileSupplemento = _data["convertibileSupplemento"] !== undefined ? _data["convertibileSupplemento"] : <any>null;
            this.convertibileRegola = _data["convertibileRegola"] !== undefined ? _data["convertibileRegola"] : <any>null;
            this.convertibilePenale = _data["convertibilePenale"] !== undefined ? _data["convertibilePenale"] : <any>null;
            this.convertibileOfferta = _data["convertibileOfferta"] !== undefined ? _data["convertibileOfferta"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioAssociazioneRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAssociazioneRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["associazione"] = this.associazione ? this.associazione.toJSON() : <any>null;
        data["offertaComponibile"] = this.offertaComponibile ? this.offertaComponibile.toJSON() : <any>null;
        data["tipologiaParent"] = this.tipologiaParent !== undefined ? this.tipologiaParent : <any>null;
        data["supplementoSpecifico"] = this.supplementoSpecifico !== undefined ? this.supplementoSpecifico : <any>null;
        data["tabellaCostiCommissioni"] = this.tabellaCostiCommissioni !== undefined ? this.tabellaCostiCommissioni : <any>null;
        data["regolaVendita"] = this.regolaVendita !== undefined ? this.regolaVendita : <any>null;
        data["sistemazione"] = this.sistemazione !== undefined ? this.sistemazione : <any>null;
        data["trattamento"] = this.trattamento !== undefined ? this.trattamento : <any>null;
        data["esclusioni"] = this.esclusioni !== undefined ? this.esclusioni : <any>null;
        data["disabilitata"] = this.disabilitata !== undefined ? this.disabilitata : <any>null;
        data["labelOfferta"] = this.labelOfferta !== undefined ? this.labelOfferta : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["priorita"] = this.priorita !== undefined ? this.priorita : <any>null;
        data["cumulabilita"] = this.cumulabilita !== undefined ? this.cumulabilita : <any>null;
        data["convertibileSupplemento"] = this.convertibileSupplemento !== undefined ? this.convertibileSupplemento : <any>null;
        data["convertibileRegola"] = this.convertibileRegola !== undefined ? this.convertibileRegola : <any>null;
        data["convertibilePenale"] = this.convertibilePenale !== undefined ? this.convertibilePenale : <any>null;
        data["convertibileOfferta"] = this.convertibileOfferta !== undefined ? this.convertibileOfferta : <any>null;
        return data;
    }
}

/** Rappresentazione tabulare di un'associazione + Dati per ricavare la maschera di edit */
export interface IServizioAssociazioneRow {
    /** ID dell'associazione */
    id?: number;
    /** Entità dell'associazione */
    associazione?: ServizioAssociazione;
    /** Eventuale configurazione di un'offerta componibile */
    offertaComponibile?: OffertaComponibile | null;
    /** Nome della tipologia associata. Se null => si associa a tutte le tipologie */
    tipologiaParent?: string | null;
    /** Nome del supplemento specifico. Se null => si associa a tutti i supplementi */
    supplementoSpecifico?: string | null;
    /** Nome della tabella costi commissioni. Se null => si associa a tutte le tabelle */
    tabellaCostiCommissioni?: string | null;
    /** Nome della regola vendita. Se null => si associa a tutte le regole vendita */
    regolaVendita?: string | null;
    /** Nome della sistemazione. Se null => si associa a tutte le sistemazioni */
    sistemazione?: string | null;
    /** Nome del trattamento. Se null => si associa a tutti i trattamenti */
    trattamento?: string | null;
    /** Periodi di esclusione (solo offerte componibili) */
    esclusioni?: string | null;
    /** Flag di disabilitazione (solo offerte componibili) */
    disabilitata?: boolean;
    /** Label dell'offerta (solo offerte componibili) */
    labelOfferta?: string | null;
    /** Codice dell'offerta (solo offerte componibili) */
    codice?: string | null;
    /** Ordine di priorità (solo offerte componibili) */
    priorita?: number | null;
    /** Codici di cumulabilità (solo offerte componibili, T=tutte) */
    cumulabilita?: string | null;
    /** True se l'associazione è generica e può essere convertita in tipo supplemento */
    convertibileSupplemento?: boolean;
    /** True se l'associazione è generica e può essere convertita in tipo regola vendita aggiuntiva */
    convertibileRegola?: boolean;
    /** True se l'associazione è generica e può essere convertita in tipo regola vendita penale */
    convertibilePenale?: boolean;
    /** True se l'associazione è generica e può essere convertita in tipo offerta componibile */
    convertibileOfferta?: boolean;
}

export class DeleteAssocizioneRequest extends ServizioGetRequest implements IDeleteAssocizioneRequest {
    /** ID dell'associazione da eliminare */
    associazioneID?: number;

    constructor(data?: IDeleteAssocizioneRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.associazioneID = _data["associazioneID"] !== undefined ? _data["associazioneID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteAssocizioneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAssocizioneRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["associazioneID"] = this.associazioneID !== undefined ? this.associazioneID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteAssocizioneRequest extends IServizioGetRequest {
    /** ID dell'associazione da eliminare */
    associazioneID?: number;
}

export class DeleteAssocizioniRequest extends ServizioGetRequest implements IDeleteAssocizioniRequest {
    /** Lista degli ID delle associazioni da eliminare */
    associazioniIDs!: number[];

    constructor(data?: IDeleteAssocizioniRequest) {
        super(data);
        if (!data) {
            this.associazioniIDs = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["associazioniIDs"])) {
                this.associazioniIDs = [] as any;
                for (let item of _data["associazioniIDs"])
                    this.associazioniIDs!.push(item);
            }
            else {
                this.associazioniIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteAssocizioniRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAssocizioniRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associazioniIDs)) {
            data["associazioniIDs"] = [];
            for (let item of this.associazioniIDs)
                data["associazioniIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteAssocizioniRequest extends IServizioGetRequest {
    /** Lista degli ID delle associazioni da eliminare */
    associazioniIDs: number[];
}

export class GetCostiResponse extends OkApiResponse implements IGetCostiResponse {
    tabelle?: CostiTabellaCostoRow[];

    constructor(data?: IGetCostiResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tabelle"])) {
                this.tabelle = [] as any;
                for (let item of _data["tabelle"])
                    this.tabelle!.push(CostiTabellaCostoRow.fromJS(item));
            }
            else {
                this.tabelle = <any>null;
            }
        }
    }

    static fromJS(data: any): GetCostiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCostiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tabelle)) {
            data["tabelle"] = [];
            for (let item of this.tabelle)
                data["tabelle"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetCostiResponse extends IOkApiResponse {
    tabelle?: CostiTabellaCostoRow[];
}

export class CostiTabellaCostoRow implements ICostiTabellaCostoRow {
    /** ID della tabella costi commissioni */
    tabellaID?: number;
    /** Nome localizzato della tabella costi commissioni */
    nomeTabella?: string;
    /** Data di inizio validità della tabella costi commissioni */
    tabellaValidaDal?: string;
    /** Data di fine validità della tabella costi commissioni */
    tabellaValidaAl?: string;
    /** ID dell'accordo a cui appartiene la tabella costi commissioni */
    accordoID?: number;
    /** Nome dell'accordo a cui appartiene la tabella costi commissioni */
    nomeAccordo?: string | null;
    /** Codice della valuta dell'accordo a cui appartiene la tabella costi commissioni */
    codiceValuta?: string | null;
    /** Raggruppamento per tipologie e trattamenti */
    tipologie?: CostiTipologiaRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;

    constructor(data?: ICostiTabellaCostoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabellaID = _data["tabellaID"] !== undefined ? _data["tabellaID"] : <any>null;
            this.nomeTabella = _data["nomeTabella"] !== undefined ? _data["nomeTabella"] : <any>null;
            this.tabellaValidaDal = _data["tabellaValidaDal"] !== undefined ? _data["tabellaValidaDal"] : <any>null;
            this.tabellaValidaAl = _data["tabellaValidaAl"] !== undefined ? _data["tabellaValidaAl"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.nomeAccordo = _data["nomeAccordo"] !== undefined ? _data["nomeAccordo"] : <any>null;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : <any>null;
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(CostiTipologiaRow.fromJS(item));
            }
            else {
                this.tipologie = <any>null;
            }
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
        }
    }

    static fromJS(data: any): CostiTabellaCostoRow {
        data = typeof data === 'object' ? data : {};
        let result = new CostiTabellaCostoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabellaID"] = this.tabellaID !== undefined ? this.tabellaID : <any>null;
        data["nomeTabella"] = this.nomeTabella !== undefined ? this.nomeTabella : <any>null;
        data["tabellaValidaDal"] = this.tabellaValidaDal !== undefined ? this.tabellaValidaDal : <any>null;
        data["tabellaValidaAl"] = this.tabellaValidaAl !== undefined ? this.tabellaValidaAl : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["nomeAccordo"] = this.nomeAccordo !== undefined ? this.nomeAccordo : <any>null;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : <any>null;
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item.toJSON());
        }
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        return data;
    }
}

export interface ICostiTabellaCostoRow {
    /** ID della tabella costi commissioni */
    tabellaID?: number;
    /** Nome localizzato della tabella costi commissioni */
    nomeTabella?: string;
    /** Data di inizio validità della tabella costi commissioni */
    tabellaValidaDal?: string;
    /** Data di fine validità della tabella costi commissioni */
    tabellaValidaAl?: string;
    /** ID dell'accordo a cui appartiene la tabella costi commissioni */
    accordoID?: number;
    /** Nome dell'accordo a cui appartiene la tabella costi commissioni */
    nomeAccordo?: string | null;
    /** Codice della valuta dell'accordo a cui appartiene la tabella costi commissioni */
    codiceValuta?: string | null;
    /** Raggruppamento per tipologie e trattamenti */
    tipologie?: CostiTipologiaRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;
}

export class CostiTipologiaRow implements ICostiTipologiaRow {
    /** ID della tipologia */
    servizioTipologiaID?: number;
    /** Nome localizzato della tipologia */
    tipologia?: string;
    /** True se la tiplogia ha il "verifica partenze" */
    verificaPartenze?: boolean;
    /** ID del trattamento */
    trattamentoID?: number | null;
    /** Nome localizzato del trattamento */
    trattamento?: string | null;
    /** Raggruppamento per regole servizio / vendita / codice prenotazione / vincoli età / regole bambino */
    regole?: CostoRegolaRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;

    constructor(data?: ICostiTipologiaRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : <any>null;
            this.tipologia = _data["tipologia"] !== undefined ? _data["tipologia"] : <any>null;
            this.verificaPartenze = _data["verificaPartenze"] !== undefined ? _data["verificaPartenze"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
            this.trattamento = _data["trattamento"] !== undefined ? _data["trattamento"] : <any>null;
            if (Array.isArray(_data["regole"])) {
                this.regole = [] as any;
                for (let item of _data["regole"])
                    this.regole!.push(CostoRegolaRow.fromJS(item));
            }
            else {
                this.regole = <any>null;
            }
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
        }
    }

    static fromJS(data: any): CostiTipologiaRow {
        data = typeof data === 'object' ? data : {};
        let result = new CostiTipologiaRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : <any>null;
        data["tipologia"] = this.tipologia !== undefined ? this.tipologia : <any>null;
        data["verificaPartenze"] = this.verificaPartenze !== undefined ? this.verificaPartenze : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        data["trattamento"] = this.trattamento !== undefined ? this.trattamento : <any>null;
        if (Array.isArray(this.regole)) {
            data["regole"] = [];
            for (let item of this.regole)
                data["regole"].push(item.toJSON());
        }
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        return data;
    }
}

export interface ICostiTipologiaRow {
    /** ID della tipologia */
    servizioTipologiaID?: number;
    /** Nome localizzato della tipologia */
    tipologia?: string;
    /** True se la tiplogia ha il "verifica partenze" */
    verificaPartenze?: boolean;
    /** ID del trattamento */
    trattamentoID?: number | null;
    /** Nome localizzato del trattamento */
    trattamento?: string | null;
    /** Raggruppamento per regole servizio / vendita / codice prenotazione / vincoli età / regole bambino */
    regole?: CostoRegolaRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;
}

export class CostoRegolaRow implements ICostoRegolaRow {
    /** Se true la regola di inserimento costi indica uno sconto percentuale sull'omologo costo adulto invece di una cifra */
    scontoBambinoPercentuale?: boolean;
    /** Regola servizio */
    regolaServizio?: ServizioRegola | null;
    /** Regola vendita, se c'è */
    regolaVendita?: ServizioRegolaVendita | null;
    /** Nome localizzato della regola vendita */
    nomeRegolaVendita?: string | null;
    /** Età massima bambino, se questo è un costo bambino */
    etaMassima?: number | null;
    /** Tipo di applicazione costi bambino, se sono costi bambino */
    regolaCostiBambino?: ERegolaCostiBambino | null;
    /** Codice di prenotazione facoltativo */
    codicePrenotazione?: string | null;
    /** Raggruppamento per validità */
    validita?: CostoValiditaRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;

    constructor(data?: ICostoRegolaRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scontoBambinoPercentuale = _data["scontoBambinoPercentuale"] !== undefined ? _data["scontoBambinoPercentuale"] : <any>null;
            this.regolaServizio = _data["regolaServizio"] ? ServizioRegola.fromJS(_data["regolaServizio"]) : <any>null;
            this.regolaVendita = _data["regolaVendita"] ? ServizioRegolaVendita.fromJS(_data["regolaVendita"]) : <any>null;
            this.nomeRegolaVendita = _data["nomeRegolaVendita"] !== undefined ? _data["nomeRegolaVendita"] : <any>null;
            this.etaMassima = _data["etaMassima"] !== undefined ? _data["etaMassima"] : <any>null;
            this.regolaCostiBambino = _data["regolaCostiBambino"] !== undefined ? _data["regolaCostiBambino"] : <any>null;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : <any>null;
            if (Array.isArray(_data["validita"])) {
                this.validita = [] as any;
                for (let item of _data["validita"])
                    this.validita!.push(CostoValiditaRow.fromJS(item));
            }
            else {
                this.validita = <any>null;
            }
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
        }
    }

    static fromJS(data: any): CostoRegolaRow {
        data = typeof data === 'object' ? data : {};
        let result = new CostoRegolaRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scontoBambinoPercentuale"] = this.scontoBambinoPercentuale !== undefined ? this.scontoBambinoPercentuale : <any>null;
        data["regolaServizio"] = this.regolaServizio ? this.regolaServizio.toJSON() : <any>null;
        data["regolaVendita"] = this.regolaVendita ? this.regolaVendita.toJSON() : <any>null;
        data["nomeRegolaVendita"] = this.nomeRegolaVendita !== undefined ? this.nomeRegolaVendita : <any>null;
        data["etaMassima"] = this.etaMassima !== undefined ? this.etaMassima : <any>null;
        data["regolaCostiBambino"] = this.regolaCostiBambino !== undefined ? this.regolaCostiBambino : <any>null;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : <any>null;
        if (Array.isArray(this.validita)) {
            data["validita"] = [];
            for (let item of this.validita)
                data["validita"].push(item.toJSON());
        }
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        return data;
    }
}

export interface ICostoRegolaRow {
    /** Se true la regola di inserimento costi indica uno sconto percentuale sull'omologo costo adulto invece di una cifra */
    scontoBambinoPercentuale?: boolean;
    /** Regola servizio */
    regolaServizio?: ServizioRegola | null;
    /** Regola vendita, se c'è */
    regolaVendita?: ServizioRegolaVendita | null;
    /** Nome localizzato della regola vendita */
    nomeRegolaVendita?: string | null;
    /** Età massima bambino, se questo è un costo bambino */
    etaMassima?: number | null;
    /** Tipo di applicazione costi bambino, se sono costi bambino */
    regolaCostiBambino?: ERegolaCostiBambino | null;
    /** Codice di prenotazione facoltativo */
    codicePrenotazione?: string | null;
    /** Raggruppamento per validità */
    validita?: CostoValiditaRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;
}

export class CostoValiditaRow implements ICostoValiditaRow {
    /** ID della validità */
    validitaID?: number;
    /** True se la validità associata ha i prezzi indicativi */
    prezziIndicativi?: boolean;
    /** Elenco dei giorni della settimana della validità associata */
    giorni?: EGiornoSettimana[];
    /** True se la regola è valida tutti i giorni */
    tuttiIGiorni?: boolean;
    /** Data di inizio della validità */
    dataInizio?: string;
    /** Data di fine della validità */
    dataFine?: string;
    /** True se le date di validità sono nel passato */
    scaduta?: boolean;
    /** Raggruppamento per sistemazione */
    beddings?: CostoBeddingRow[];
    /** Flag ad uso della UI */
    selected?: boolean;

    constructor(data?: ICostoValiditaRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validitaID = _data["validitaID"] !== undefined ? _data["validitaID"] : <any>null;
            this.prezziIndicativi = _data["prezziIndicativi"] !== undefined ? _data["prezziIndicativi"] : <any>null;
            if (Array.isArray(_data["giorni"])) {
                this.giorni = [] as any;
                for (let item of _data["giorni"])
                    this.giorni!.push(item);
            }
            else {
                this.giorni = <any>null;
            }
            this.tuttiIGiorni = _data["tuttiIGiorni"] !== undefined ? _data["tuttiIGiorni"] : <any>null;
            this.dataInizio = _data["dataInizio"] !== undefined ? _data["dataInizio"] : <any>null;
            this.dataFine = _data["dataFine"] !== undefined ? _data["dataFine"] : <any>null;
            this.scaduta = _data["scaduta"] !== undefined ? _data["scaduta"] : <any>null;
            if (Array.isArray(_data["beddings"])) {
                this.beddings = [] as any;
                for (let item of _data["beddings"])
                    this.beddings!.push(CostoBeddingRow.fromJS(item));
            }
            else {
                this.beddings = <any>null;
            }
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
        }
    }

    static fromJS(data: any): CostoValiditaRow {
        data = typeof data === 'object' ? data : {};
        let result = new CostoValiditaRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validitaID"] = this.validitaID !== undefined ? this.validitaID : <any>null;
        data["prezziIndicativi"] = this.prezziIndicativi !== undefined ? this.prezziIndicativi : <any>null;
        if (Array.isArray(this.giorni)) {
            data["giorni"] = [];
            for (let item of this.giorni)
                data["giorni"].push(item);
        }
        data["tuttiIGiorni"] = this.tuttiIGiorni !== undefined ? this.tuttiIGiorni : <any>null;
        data["dataInizio"] = this.dataInizio !== undefined ? this.dataInizio : <any>null;
        data["dataFine"] = this.dataFine !== undefined ? this.dataFine : <any>null;
        data["scaduta"] = this.scaduta !== undefined ? this.scaduta : <any>null;
        if (Array.isArray(this.beddings)) {
            data["beddings"] = [];
            for (let item of this.beddings)
                data["beddings"].push(item.toJSON());
        }
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        return data;
    }
}

export interface ICostoValiditaRow {
    /** ID della validità */
    validitaID?: number;
    /** True se la validità associata ha i prezzi indicativi */
    prezziIndicativi?: boolean;
    /** Elenco dei giorni della settimana della validità associata */
    giorni?: EGiornoSettimana[];
    /** True se la regola è valida tutti i giorni */
    tuttiIGiorni?: boolean;
    /** Data di inizio della validità */
    dataInizio?: string;
    /** Data di fine della validità */
    dataFine?: string;
    /** True se le date di validità sono nel passato */
    scaduta?: boolean;
    /** Raggruppamento per sistemazione */
    beddings?: CostoBeddingRow[];
    /** Flag ad uso della UI */
    selected?: boolean;
}

export class CostoBeddingRow implements ICostoBeddingRow {
    /** Questa voce è un segnaposto (vuoto) per creare la griglia */
    placeholder?: boolean;
    /** ID della riga di costo */
    costoID?: number;
    /** ID del bedding associato. Null se corrispondente a "nessuno" */
    beddingID?: number | null;
    /** Sigla del tipo di bedding (S1, D2, D3, ecc) */
    codice?: string | null;
    /** Prezzo associato in EURO */
    prezzo?: number | null;
    /** Ad uso della UI */
    prezzoOriginale?: number | null;
    /** Costo associato nella valuta dell'accordo */
    costo?: number;
    /** Ad uso della UI */
    costoOriginale?: number;
    /** Margine personalizzato, se diverso da quello previsto da accordo e tabella costi */
    margine?: number | null;
    /** True se questo costo è molteplice. E non dovrebbe esserlo... */
    haConflitti?: boolean;
    /** True se si tratta di uno sconto percentuale. Da capire se serve davvero. */
    scontoBambinoPercentuale?: boolean;
    /** Lista dei conflitti */
    conflitti?: CostoBeddingRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;

    constructor(data?: ICostoBeddingRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeholder = _data["placeholder"] !== undefined ? _data["placeholder"] : <any>null;
            this.costoID = _data["costoID"] !== undefined ? _data["costoID"] : <any>null;
            this.beddingID = _data["beddingID"] !== undefined ? _data["beddingID"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.prezzo = _data["prezzo"] !== undefined ? _data["prezzo"] : <any>null;
            this.prezzoOriginale = _data["prezzoOriginale"] !== undefined ? _data["prezzoOriginale"] : <any>null;
            this.costo = _data["costo"] !== undefined ? _data["costo"] : <any>null;
            this.costoOriginale = _data["costoOriginale"] !== undefined ? _data["costoOriginale"] : <any>null;
            this.margine = _data["margine"] !== undefined ? _data["margine"] : <any>null;
            this.haConflitti = _data["haConflitti"] !== undefined ? _data["haConflitti"] : <any>null;
            this.scontoBambinoPercentuale = _data["scontoBambinoPercentuale"] !== undefined ? _data["scontoBambinoPercentuale"] : <any>null;
            if (Array.isArray(_data["conflitti"])) {
                this.conflitti = [] as any;
                for (let item of _data["conflitti"])
                    this.conflitti!.push(CostoBeddingRow.fromJS(item));
            }
            else {
                this.conflitti = <any>null;
            }
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
        }
    }

    static fromJS(data: any): CostoBeddingRow {
        data = typeof data === 'object' ? data : {};
        let result = new CostoBeddingRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeholder"] = this.placeholder !== undefined ? this.placeholder : <any>null;
        data["costoID"] = this.costoID !== undefined ? this.costoID : <any>null;
        data["beddingID"] = this.beddingID !== undefined ? this.beddingID : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["prezzo"] = this.prezzo !== undefined ? this.prezzo : <any>null;
        data["prezzoOriginale"] = this.prezzoOriginale !== undefined ? this.prezzoOriginale : <any>null;
        data["costo"] = this.costo !== undefined ? this.costo : <any>null;
        data["costoOriginale"] = this.costoOriginale !== undefined ? this.costoOriginale : <any>null;
        data["margine"] = this.margine !== undefined ? this.margine : <any>null;
        data["haConflitti"] = this.haConflitti !== undefined ? this.haConflitti : <any>null;
        data["scontoBambinoPercentuale"] = this.scontoBambinoPercentuale !== undefined ? this.scontoBambinoPercentuale : <any>null;
        if (Array.isArray(this.conflitti)) {
            data["conflitti"] = [];
            for (let item of this.conflitti)
                data["conflitti"].push(item.toJSON());
        }
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        return data;
    }
}

export interface ICostoBeddingRow {
    /** Questa voce è un segnaposto (vuoto) per creare la griglia */
    placeholder?: boolean;
    /** ID della riga di costo */
    costoID?: number;
    /** ID del bedding associato. Null se corrispondente a "nessuno" */
    beddingID?: number | null;
    /** Sigla del tipo di bedding (S1, D2, D3, ecc) */
    codice?: string | null;
    /** Prezzo associato in EURO */
    prezzo?: number | null;
    /** Ad uso della UI */
    prezzoOriginale?: number | null;
    /** Costo associato nella valuta dell'accordo */
    costo?: number;
    /** Ad uso della UI */
    costoOriginale?: number;
    /** Margine personalizzato, se diverso da quello previsto da accordo e tabella costi */
    margine?: number | null;
    /** True se questo costo è molteplice. E non dovrebbe esserlo... */
    haConflitti?: boolean;
    /** True se si tratta di uno sconto percentuale. Da capire se serve davvero. */
    scontoBambinoPercentuale?: boolean;
    /** Lista dei conflitti */
    conflitti?: CostoBeddingRow[];
    /** Campo ad uso della UI, per selezionare i valori */
    selected?: boolean;
}

export class DeleteCostiRequest extends ServizioGetRequest implements IDeleteCostiRequest {
    costiIDs?: number[] | null;

    constructor(data?: IDeleteCostiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["costiIDs"])) {
                this.costiIDs = [] as any;
                for (let item of _data["costiIDs"])
                    this.costiIDs!.push(item);
            }
            else {
                this.costiIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteCostiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCostiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costiIDs)) {
            data["costiIDs"] = [];
            for (let item of this.costiIDs)
                data["costiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteCostiRequest extends IServizioGetRequest {
    costiIDs?: number[] | null;
}

export class GetDynamicPackageRulesResponse extends OkApiResponse implements IGetDynamicPackageRulesResponse {
    regole?: ServizioRegolaScontoPacchettoRow[] | null;

    constructor(data?: IGetDynamicPackageRulesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["regole"])) {
                this.regole = [] as any;
                for (let item of _data["regole"])
                    this.regole!.push(ServizioRegolaScontoPacchettoRow.fromJS(item));
            }
            else {
                this.regole = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDynamicPackageRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDynamicPackageRulesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regole)) {
            data["regole"] = [];
            for (let item of this.regole)
                data["regole"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDynamicPackageRulesResponse extends IOkApiResponse {
    regole?: ServizioRegolaScontoPacchettoRow[] | null;
}

export class ServizioRegolaScontoPacchettoRow extends ServizioRegolaScontoPacchetto implements IServizioRegolaScontoPacchettoRow {
    servizioSconto?: string | null;

    constructor(data?: IServizioRegolaScontoPacchettoRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioSconto = _data["servizioSconto"] !== undefined ? _data["servizioSconto"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioRegolaScontoPacchettoRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioRegolaScontoPacchettoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioSconto"] = this.servizioSconto !== undefined ? this.servizioSconto : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioRegolaScontoPacchettoRow extends IServizioRegolaScontoPacchetto {
    servizioSconto?: string | null;
}

export class GetDynamicPackageRulesRequest extends ServizioGetRequest implements IGetDynamicPackageRulesRequest {

    constructor(data?: IGetDynamicPackageRulesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetDynamicPackageRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDynamicPackageRulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetDynamicPackageRulesRequest extends IServizioGetRequest {
}

export class DeleteDynamicPackageRuleRequest extends GetDynamicPackageRulesRequest implements IDeleteDynamicPackageRuleRequest {
    regolaPacchettoID?: number;

    constructor(data?: IDeleteDynamicPackageRuleRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regolaPacchettoID = _data["regolaPacchettoID"] !== undefined ? _data["regolaPacchettoID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteDynamicPackageRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDynamicPackageRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regolaPacchettoID"] = this.regolaPacchettoID !== undefined ? this.regolaPacchettoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteDynamicPackageRuleRequest extends IGetDynamicPackageRulesRequest {
    regolaPacchettoID?: number;
}

export class DeleteDynamicPackageRulesRequest extends GetDynamicPackageRulesRequest implements IDeleteDynamicPackageRulesRequest {
    regolePacchettoIDs?: number[] | null;

    constructor(data?: IDeleteDynamicPackageRulesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["regolePacchettoIDs"])) {
                this.regolePacchettoIDs = [] as any;
                for (let item of _data["regolePacchettoIDs"])
                    this.regolePacchettoIDs!.push(item);
            }
            else {
                this.regolePacchettoIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteDynamicPackageRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDynamicPackageRulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regolePacchettoIDs)) {
            data["regolePacchettoIDs"] = [];
            for (let item of this.regolePacchettoIDs)
                data["regolePacchettoIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteDynamicPackageRulesRequest extends IGetDynamicPackageRulesRequest {
    regolePacchettoIDs?: number[] | null;
}

export class GetItinerariResponse extends OkApiResponse implements IGetItinerariResponse {
    itinerari?: ItinerarioListRow[] | null;

    constructor(data?: IGetItinerariResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["itinerari"])) {
                this.itinerari = [] as any;
                for (let item of _data["itinerari"])
                    this.itinerari!.push(ItinerarioListRow.fromJS(item));
            }
            else {
                this.itinerari = <any>null;
            }
        }
    }

    static fromJS(data: any): GetItinerariResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetItinerariResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itinerari)) {
            data["itinerari"] = [];
            for (let item of this.itinerari)
                data["itinerari"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetItinerariResponse extends IOkApiResponse {
    itinerari?: ItinerarioListRow[] | null;
}

export class ItinerarioListRow implements IItinerarioListRow {
    id?: number;
    nome?: string | null;
    giorni?: number;
    notti?: number;
    origine?: string | null;
    destinazione?: string | null;
    compagniaAerea?: string | null;
    itinerario?: ServizioItinerario | null;
    tappe?: ServizioItinerarioGiornoRow[] | null;

    constructor(data?: IItinerarioListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            this.origine = _data["origine"] !== undefined ? _data["origine"] : <any>null;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : <any>null;
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : <any>null;
            this.itinerario = _data["itinerario"] ? ServizioItinerario.fromJS(_data["itinerario"]) : <any>null;
            if (Array.isArray(_data["tappe"])) {
                this.tappe = [] as any;
                for (let item of _data["tappe"])
                    this.tappe!.push(ServizioItinerarioGiornoRow.fromJS(item));
            }
            else {
                this.tappe = <any>null;
            }
        }
    }

    static fromJS(data: any): ItinerarioListRow {
        data = typeof data === 'object' ? data : {};
        let result = new ItinerarioListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["giorni"] = this.giorni !== undefined ? this.giorni : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        data["origine"] = this.origine !== undefined ? this.origine : <any>null;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : <any>null;
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : <any>null;
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : <any>null;
        if (Array.isArray(this.tappe)) {
            data["tappe"] = [];
            for (let item of this.tappe)
                data["tappe"].push(item.toJSON());
        }
        return data;
    }
}

export interface IItinerarioListRow {
    id?: number;
    nome?: string | null;
    giorni?: number;
    notti?: number;
    origine?: string | null;
    destinazione?: string | null;
    compagniaAerea?: string | null;
    itinerario?: ServizioItinerario | null;
    tappe?: ServizioItinerarioGiornoRow[] | null;
}

export class ServizioItinerarioGiornoRow implements IServizioItinerarioGiornoRow {
    tappa?: ServizioItinerarioGiorno | null;
    luogo?: string | null;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;
    servizi?: ServizioItinerarioGiornoServizioRow[] | null;

    constructor(data?: IServizioItinerarioGiornoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tappa = _data["tappa"] ? ServizioItinerarioGiorno.fromJS(_data["tappa"]) : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.compagniaAerea = _data["compagniaAerea"] !== undefined ? _data["compagniaAerea"] : <any>null;
            this.classe = _data["classe"] !== undefined ? _data["classe"] : <any>null;
            this.compagniaAerea2 = _data["compagniaAerea2"] !== undefined ? _data["compagniaAerea2"] : <any>null;
            this.classe2 = _data["classe2"] !== undefined ? _data["classe2"] : <any>null;
            this.cambioHotel = _data["cambioHotel"] !== undefined ? _data["cambioHotel"] : <any>null;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioItinerarioGiornoServizioRow.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
        }
    }

    static fromJS(data: any): ServizioItinerarioGiornoRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioGiornoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tappa"] = this.tappa ? this.tappa.toJSON() : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["compagniaAerea"] = this.compagniaAerea !== undefined ? this.compagniaAerea : <any>null;
        data["classe"] = this.classe !== undefined ? this.classe : <any>null;
        data["compagniaAerea2"] = this.compagniaAerea2 !== undefined ? this.compagniaAerea2 : <any>null;
        data["classe2"] = this.classe2 !== undefined ? this.classe2 : <any>null;
        data["cambioHotel"] = this.cambioHotel !== undefined ? this.cambioHotel : <any>null;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServizioItinerarioGiornoRow {
    tappa?: ServizioItinerarioGiorno | null;
    luogo?: string | null;
    compagniaAerea?: string | null;
    classe?: string | null;
    compagniaAerea2?: string | null;
    classe2?: string | null;
    cambioHotel?: boolean;
    servizi?: ServizioItinerarioGiornoServizioRow[] | null;
}

export class ServizioItinerarioGiornoServizioRow implements IServizioItinerarioGiornoServizioRow {
    servizio?: ServizioItinerarioGiornoServizio | null;
    tipoServizio?: ETipoServizio;
    nomeServizio?: string | null;
    nomeTipologia?: string | null;

    constructor(data?: IServizioItinerarioGiornoServizioRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizio = _data["servizio"] ? ServizioItinerarioGiornoServizio.fromJS(_data["servizio"]) : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.nomeServizio = _data["nomeServizio"] !== undefined ? _data["nomeServizio"] : <any>null;
            this.nomeTipologia = _data["nomeTipologia"] !== undefined ? _data["nomeTipologia"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioItinerarioGiornoServizioRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioItinerarioGiornoServizioRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["nomeServizio"] = this.nomeServizio !== undefined ? this.nomeServizio : <any>null;
        data["nomeTipologia"] = this.nomeTipologia !== undefined ? this.nomeTipologia : <any>null;
        return data;
    }
}

export interface IServizioItinerarioGiornoServizioRow {
    servizio?: ServizioItinerarioGiornoServizio | null;
    tipoServizio?: ETipoServizio;
    nomeServizio?: string | null;
    nomeTipologia?: string | null;
}

export class DeleteItinerarioRequest extends ServizioGetRequest implements IDeleteItinerarioRequest {
    servizioItinerarioID?: number;

    constructor(data?: IDeleteItinerarioRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioItinerarioID = _data["servizioItinerarioID"] !== undefined ? _data["servizioItinerarioID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteItinerarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteItinerarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioItinerarioID"] = this.servizioItinerarioID !== undefined ? this.servizioItinerarioID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteItinerarioRequest extends IServizioGetRequest {
    servizioItinerarioID?: number;
}

export class DeletePartenzeRequest extends ServizioGetRequest implements IDeletePartenzeRequest {
    /** Data iniziale */
    start?: string;
    /** Data finale */
    stop?: string;

    constructor(data?: IDeletePartenzeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.start = _data["start"] !== undefined ? _data["start"] : <any>null;
            this.stop = _data["stop"] !== undefined ? _data["stop"] : <any>null;
        }
    }

    static fromJS(data: any): DeletePartenzeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePartenzeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start !== undefined ? this.start : <any>null;
        data["stop"] = this.stop !== undefined ? this.stop : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeletePartenzeRequest extends IServizioGetRequest {
    /** Data iniziale */
    start?: string;
    /** Data finale */
    stop?: string;
}

export class GetRegoleServizioResponse extends OkApiResponse implements IGetRegoleServizioResponse {
    regole?: ServizioRegola[] | null;

    constructor(data?: IGetRegoleServizioResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["regole"])) {
                this.regole = [] as any;
                for (let item of _data["regole"])
                    this.regole!.push(ServizioRegola.fromJS(item));
            }
            else {
                this.regole = <any>null;
            }
        }
    }

    static fromJS(data: any): GetRegoleServizioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegoleServizioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regole)) {
            data["regole"] = [];
            for (let item of this.regole)
                data["regole"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetRegoleServizioResponse extends IOkApiResponse {
    regole?: ServizioRegola[] | null;
}

export class DeleteRegolaServizioRequest extends ServizioGetRequest implements IDeleteRegolaServizioRequest {
    regolaServizioID?: number;

    constructor(data?: IDeleteRegolaServizioRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regolaServizioID = _data["regolaServizioID"] !== undefined ? _data["regolaServizioID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteRegolaServizioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRegolaServizioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regolaServizioID"] = this.regolaServizioID !== undefined ? this.regolaServizioID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteRegolaServizioRequest extends IServizioGetRequest {
    regolaServizioID?: number;
}

export class GetRegoleVenditaResponse extends OkApiResponse implements IGetRegoleVenditaResponse {
    regole?: RegolaVenditaRow[];

    constructor(data?: IGetRegoleVenditaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["regole"])) {
                this.regole = [] as any;
                for (let item of _data["regole"])
                    this.regole!.push(RegolaVenditaRow.fromJS(item));
            }
            else {
                this.regole = <any>null;
            }
        }
    }

    static fromJS(data: any): GetRegoleVenditaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegoleVenditaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regole)) {
            data["regole"] = [];
            for (let item of this.regole)
                data["regole"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetRegoleVenditaResponse extends IOkApiResponse {
    regole?: RegolaVenditaRow[];
}

export class RegolaVenditaRow implements IRegolaVenditaRow {
    id?: number;
    nome?: string | null;
    regola?: ServizioRegolaVendita;
    testoPenale?: TripTextHtml | null;

    constructor(data?: IRegolaVenditaRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.regola = _data["regola"] ? ServizioRegolaVendita.fromJS(_data["regola"]) : <any>null;
            this.testoPenale = _data["testoPenale"] ? TripTextHtml.fromJS(_data["testoPenale"]) : <any>null;
        }
    }

    static fromJS(data: any): RegolaVenditaRow {
        data = typeof data === 'object' ? data : {};
        let result = new RegolaVenditaRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["regola"] = this.regola ? this.regola.toJSON() : <any>null;
        data["testoPenale"] = this.testoPenale ? this.testoPenale.toJSON() : <any>null;
        return data;
    }
}

export interface IRegolaVenditaRow {
    id?: number;
    nome?: string | null;
    regola?: ServizioRegolaVendita;
    testoPenale?: TripTextHtml | null;
}

export class DeleteRegolaVenditaRequest extends ServizioGetRequest implements IDeleteRegolaVenditaRequest {
    regolaVenditaID?: number;

    constructor(data?: IDeleteRegolaVenditaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteRegolaVenditaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRegolaVenditaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteRegolaVenditaRequest extends IServizioGetRequest {
    regolaVenditaID?: number;
}

export class DeleteRegoleServizioRequest extends ServizioGetRequest implements IDeleteRegoleServizioRequest {
    regoleServizioIDs?: number[] | null;

    constructor(data?: IDeleteRegoleServizioRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["regoleServizioIDs"])) {
                this.regoleServizioIDs = [] as any;
                for (let item of _data["regoleServizioIDs"])
                    this.regoleServizioIDs!.push(item);
            }
            else {
                this.regoleServizioIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteRegoleServizioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRegoleServizioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regoleServizioIDs)) {
            data["regoleServizioIDs"] = [];
            for (let item of this.regoleServizioIDs)
                data["regoleServizioIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteRegoleServizioRequest extends IServizioGetRequest {
    regoleServizioIDs?: number[] | null;
}

export class DeleteRegoleVenditaRequest extends ServizioGetRequest implements IDeleteRegoleVenditaRequest {
    regoleVenditaIDs?: number[] | null;

    constructor(data?: IDeleteRegoleVenditaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["regoleVenditaIDs"])) {
                this.regoleVenditaIDs = [] as any;
                for (let item of _data["regoleVenditaIDs"])
                    this.regoleVenditaIDs!.push(item);
            }
            else {
                this.regoleVenditaIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteRegoleVenditaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRegoleVenditaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regoleVenditaIDs)) {
            data["regoleVenditaIDs"] = [];
            for (let item of this.regoleVenditaIDs)
                data["regoleVenditaIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteRegoleVenditaRequest extends IServizioGetRequest {
    regoleVenditaIDs?: number[] | null;
}

export class GetTipologieResponse extends OkApiResponse implements IGetTipologieResponse {
    tipologie?: TipologiaListRow[] | null;

    constructor(data?: IGetTipologieResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(TipologiaListRow.fromJS(item));
            }
            else {
                this.tipologie = <any>null;
            }
        }
    }

    static fromJS(data: any): GetTipologieResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipologieResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTipologieResponse extends IOkApiResponse {
    tipologie?: TipologiaListRow[] | null;
}

export class TipologiaListRow implements ITipologiaListRow {
    id?: number;
    nome?: string | null;
    tipologia?: ServizioTipologia | null;

    constructor(data?: ITipologiaListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : <any>null;
        }
    }

    static fromJS(data: any): TipologiaListRow {
        data = typeof data === 'object' ? data : {};
        let result = new TipologiaListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : <any>null;
        return data;
    }
}

export interface ITipologiaListRow {
    id?: number;
    nome?: string | null;
    tipologia?: ServizioTipologia | null;
}

export class GetTipologieRequest extends ServizioGetRequest implements IGetTipologieRequest {
    showDeleted?: boolean;

    constructor(data?: IGetTipologieRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): GetTipologieRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipologieRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTipologieRequest extends IServizioGetRequest {
    showDeleted?: boolean;
}

export class DeleteTipologiaRequest extends GetTipologieRequest implements IDeleteTipologiaRequest {
    servizioTipologiaID?: number;

    constructor(data?: IDeleteTipologiaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteTipologiaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTipologiaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteTipologiaRequest extends IGetTipologieRequest {
    servizioTipologiaID?: number;
}

export class DeleteTipologieRequest extends GetTipologieRequest implements IDeleteTipologieRequest {
    tipologieIDs?: number[] | null;

    constructor(data?: IDeleteTipologieRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tipologieIDs"])) {
                this.tipologieIDs = [] as any;
                for (let item of _data["tipologieIDs"])
                    this.tipologieIDs!.push(item);
            }
            else {
                this.tipologieIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteTipologieRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTipologieRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipologieIDs)) {
            data["tipologieIDs"] = [];
            for (let item of this.tipologieIDs)
                data["tipologieIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteTipologieRequest extends IGetTipologieRequest {
    tipologieIDs?: number[] | null;
}

export class DeleteValiditaRequest extends ServizioGetRequest implements IDeleteValiditaRequest {
    validitaID?: number;

    constructor(data?: IDeleteValiditaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validitaID = _data["validitaID"] !== undefined ? _data["validitaID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteValiditaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteValiditaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validitaID"] = this.validitaID !== undefined ? this.validitaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteValiditaRequest extends IServizioGetRequest {
    validitaID?: number;
}

export class GetAccordiServizioResponse extends OkApiResponse implements IGetAccordiServizioResponse {
    accordi?: ServizioAccordoRow[];

    constructor(data?: IGetAccordiServizioResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["accordi"])) {
                this.accordi = [] as any;
                for (let item of _data["accordi"])
                    this.accordi!.push(ServizioAccordoRow.fromJS(item));
            }
            else {
                this.accordi = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAccordiServizioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccordiServizioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accordi)) {
            data["accordi"] = [];
            for (let item of this.accordi)
                data["accordi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetAccordiServizioResponse extends IOkApiResponse {
    accordi?: ServizioAccordoRow[];
}

export class ServizioAccordoRow implements IServizioAccordoRow {
    /** ID dell'accordo */
    accordoID?: number;
    /** Nome dell'accordo */
    nome?: string;
    /** True se l'accordo è scaduto */
    scaduto?: boolean;

    constructor(data?: IServizioAccordoRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.scaduto = _data["scaduto"] !== undefined ? _data["scaduto"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioAccordoRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioAccordoRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["scaduto"] = this.scaduto !== undefined ? this.scaduto : <any>null;
        return data;
    }
}

export interface IServizioAccordoRow {
    /** ID dell'accordo */
    accordoID?: number;
    /** Nome dell'accordo */
    nome?: string;
    /** True se l'accordo è scaduto */
    scaduto?: boolean;
}

export class GetArticoliServizioResponse extends OkApiResponse implements IGetArticoliServizioResponse {
    articoli?: ArticoloServizio[];

    constructor(data?: IGetArticoliServizioResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["articoli"])) {
                this.articoli = [] as any;
                for (let item of _data["articoli"])
                    this.articoli!.push(ArticoloServizio.fromJS(item));
            }
            else {
                this.articoli = <any>null;
            }
        }
    }

    static fromJS(data: any): GetArticoliServizioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticoliServizioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.articoli)) {
            data["articoli"] = [];
            for (let item of this.articoli)
                data["articoli"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetArticoliServizioResponse extends IOkApiResponse {
    articoli?: ArticoloServizio[];
}

export class ArticoloServizio implements IArticoloServizio {
    id?: number;
    /** Titolo nella lingua dell'utente */
    titolo?: string | null;
    /** Sunto nella lingua dell'utente */
    sunto?: string | null;
    /** Testo nella lingua dell'utente */
    testo?: string;
    giorno?: number;
    ordine?: number;
    /** Concatenazione ordinabile di giorno / ordine / priorità */
    ordineAssoluto?: string;
    /** Data di inizio pubblicazione se prevista */
    pubblicatoDal?: string | null;
    /** Data di fine pubblicazione se prevista */
    pubblicatoAl?: string | null;
    pubblicaWeb?: boolean;
    pubblicaOfferta?: boolean;
    pubblicaPreventivo?: boolean;
    pubblicaProgramma?: boolean;
    pubblicaVoucher?: boolean;
    pubblicaEstrattoConto?: boolean;
    categoria?: ECategoriaArticolo | null;
    intestazione?: string | null;
    articolo?: Articolo;

    constructor(data?: IArticoloServizio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
            this.sunto = _data["sunto"] !== undefined ? _data["sunto"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            this.giorno = _data["giorno"] !== undefined ? _data["giorno"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.ordineAssoluto = _data["ordineAssoluto"] !== undefined ? _data["ordineAssoluto"] : <any>null;
            this.pubblicatoDal = _data["pubblicatoDal"] !== undefined ? _data["pubblicatoDal"] : <any>null;
            this.pubblicatoAl = _data["pubblicatoAl"] !== undefined ? _data["pubblicatoAl"] : <any>null;
            this.pubblicaWeb = _data["pubblicaWeb"] !== undefined ? _data["pubblicaWeb"] : <any>null;
            this.pubblicaOfferta = _data["pubblicaOfferta"] !== undefined ? _data["pubblicaOfferta"] : <any>null;
            this.pubblicaPreventivo = _data["pubblicaPreventivo"] !== undefined ? _data["pubblicaPreventivo"] : <any>null;
            this.pubblicaProgramma = _data["pubblicaProgramma"] !== undefined ? _data["pubblicaProgramma"] : <any>null;
            this.pubblicaVoucher = _data["pubblicaVoucher"] !== undefined ? _data["pubblicaVoucher"] : <any>null;
            this.pubblicaEstrattoConto = _data["pubblicaEstrattoConto"] !== undefined ? _data["pubblicaEstrattoConto"] : <any>null;
            this.categoria = _data["categoria"] !== undefined ? _data["categoria"] : <any>null;
            this.intestazione = _data["intestazione"] !== undefined ? _data["intestazione"] : <any>null;
            this.articolo = _data["articolo"] ? Articolo.fromJS(_data["articolo"]) : <any>null;
        }
    }

    static fromJS(data: any): ArticoloServizio {
        data = typeof data === 'object' ? data : {};
        let result = new ArticoloServizio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        data["sunto"] = this.sunto !== undefined ? this.sunto : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        data["giorno"] = this.giorno !== undefined ? this.giorno : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["ordineAssoluto"] = this.ordineAssoluto !== undefined ? this.ordineAssoluto : <any>null;
        data["pubblicatoDal"] = this.pubblicatoDal !== undefined ? this.pubblicatoDal : <any>null;
        data["pubblicatoAl"] = this.pubblicatoAl !== undefined ? this.pubblicatoAl : <any>null;
        data["pubblicaWeb"] = this.pubblicaWeb !== undefined ? this.pubblicaWeb : <any>null;
        data["pubblicaOfferta"] = this.pubblicaOfferta !== undefined ? this.pubblicaOfferta : <any>null;
        data["pubblicaPreventivo"] = this.pubblicaPreventivo !== undefined ? this.pubblicaPreventivo : <any>null;
        data["pubblicaProgramma"] = this.pubblicaProgramma !== undefined ? this.pubblicaProgramma : <any>null;
        data["pubblicaVoucher"] = this.pubblicaVoucher !== undefined ? this.pubblicaVoucher : <any>null;
        data["pubblicaEstrattoConto"] = this.pubblicaEstrattoConto !== undefined ? this.pubblicaEstrattoConto : <any>null;
        data["categoria"] = this.categoria !== undefined ? this.categoria : <any>null;
        data["intestazione"] = this.intestazione !== undefined ? this.intestazione : <any>null;
        data["articolo"] = this.articolo ? this.articolo.toJSON() : <any>null;
        return data;
    }
}

export interface IArticoloServizio {
    id?: number;
    /** Titolo nella lingua dell'utente */
    titolo?: string | null;
    /** Sunto nella lingua dell'utente */
    sunto?: string | null;
    /** Testo nella lingua dell'utente */
    testo?: string;
    giorno?: number;
    ordine?: number;
    /** Concatenazione ordinabile di giorno / ordine / priorità */
    ordineAssoluto?: string;
    /** Data di inizio pubblicazione se prevista */
    pubblicatoDal?: string | null;
    /** Data di fine pubblicazione se prevista */
    pubblicatoAl?: string | null;
    pubblicaWeb?: boolean;
    pubblicaOfferta?: boolean;
    pubblicaPreventivo?: boolean;
    pubblicaProgramma?: boolean;
    pubblicaVoucher?: boolean;
    pubblicaEstrattoConto?: boolean;
    categoria?: ECategoriaArticolo | null;
    intestazione?: string | null;
    articolo?: Articolo;
}

export class GetDatiAggiuntiviResponse extends OkApiResponse implements IGetDatiAggiuntiviResponse {
    /** Elenco dei valori di dati aggiuntivi */
    dati?: DatoAggiuntivoServizioValoreRow[];

    constructor(data?: IGetDatiAggiuntiviResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["dati"])) {
                this.dati = [] as any;
                for (let item of _data["dati"])
                    this.dati!.push(DatoAggiuntivoServizioValoreRow.fromJS(item));
            }
            else {
                this.dati = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDatiAggiuntiviResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatiAggiuntiviResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dati)) {
            data["dati"] = [];
            for (let item of this.dati)
                data["dati"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDatiAggiuntiviResponse extends IOkApiResponse {
    /** Elenco dei valori di dati aggiuntivi */
    dati?: DatoAggiuntivoServizioValoreRow[];
}

export class DatoAggiuntivoServizioValoreRow implements IDatoAggiuntivoServizioValoreRow {
    /** ID del tipo di dato, per recuperare l'intestazione e fare raggruppamento */
    tipoDatoID?: number;
    /** Entità con i valori specifici */
    valore?: ServizioDatoAggiuntivo;

    constructor(data?: IDatoAggiuntivoServizioValoreRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoDatoID = _data["tipoDatoID"] !== undefined ? _data["tipoDatoID"] : <any>null;
            this.valore = _data["valore"] ? ServizioDatoAggiuntivo.fromJS(_data["valore"]) : <any>null;
        }
    }

    static fromJS(data: any): DatoAggiuntivoServizioValoreRow {
        data = typeof data === 'object' ? data : {};
        let result = new DatoAggiuntivoServizioValoreRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDatoID"] = this.tipoDatoID !== undefined ? this.tipoDatoID : <any>null;
        data["valore"] = this.valore ? this.valore.toJSON() : <any>null;
        return data;
    }
}

export interface IDatoAggiuntivoServizioValoreRow {
    /** ID del tipo di dato, per recuperare l'intestazione e fare raggruppamento */
    tipoDatoID?: number;
    /** Entità con i valori specifici */
    valore?: ServizioDatoAggiuntivo;
}

export class GetDestinationsListResponse extends OkApiResponse implements IGetDestinationsListResponse {
    destinationsAreas?: DestinationGroupRow[];

    constructor(data?: IGetDestinationsListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["destinationsAreas"])) {
                this.destinationsAreas = [] as any;
                for (let item of _data["destinationsAreas"])
                    this.destinationsAreas!.push(DestinationGroupRow.fromJS(item));
            }
            else {
                this.destinationsAreas = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDestinationsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDestinationsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.destinationsAreas)) {
            data["destinationsAreas"] = [];
            for (let item of this.destinationsAreas)
                data["destinationsAreas"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDestinationsListResponse extends IOkApiResponse {
    destinationsAreas?: DestinationGroupRow[];
}

export class DestinationRow implements IDestinationRow {
    id?: number;
    name?: string;
    cover?: string | null;
    servicesCount?: number;

    constructor(data?: IDestinationRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.cover = _data["cover"] !== undefined ? _data["cover"] : <any>null;
            this.servicesCount = _data["servicesCount"] !== undefined ? _data["servicesCount"] : <any>null;
        }
    }

    static fromJS(data: any): DestinationRow {
        data = typeof data === 'object' ? data : {};
        let result = new DestinationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["cover"] = this.cover !== undefined ? this.cover : <any>null;
        data["servicesCount"] = this.servicesCount !== undefined ? this.servicesCount : <any>null;
        return data;
    }
}

export interface IDestinationRow {
    id?: number;
    name?: string;
    cover?: string | null;
    servicesCount?: number;
}

export class DestinationGroupRow extends DestinationRow implements IDestinationGroupRow {
    destinations?: DestinationRow[];

    constructor(data?: IDestinationGroupRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["destinations"])) {
                this.destinations = [] as any;
                for (let item of _data["destinations"])
                    this.destinations!.push(DestinationRow.fromJS(item));
            }
            else {
                this.destinations = <any>null;
            }
        }
    }

    static fromJS(data: any): DestinationGroupRow {
        data = typeof data === 'object' ? data : {};
        let result = new DestinationGroupRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.destinations)) {
            data["destinations"] = [];
            for (let item of this.destinations)
                data["destinations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDestinationGroupRow extends IDestinationRow {
    destinations?: DestinationRow[];
}

export class GetDestinationsListRequest extends SiteRequest implements IGetDestinationsListRequest {

    constructor(data?: IGetDestinationsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetDestinationsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDestinationsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetDestinationsListRequest extends ISiteRequest {
}

export class GetInsurancesResponse extends OkApiResponse implements IGetInsurancesResponse {
    assicurazioni?: Insurance[] | null;

    constructor(data?: IGetInsurancesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["assicurazioni"])) {
                this.assicurazioni = [] as any;
                for (let item of _data["assicurazioni"])
                    this.assicurazioni!.push(Insurance.fromJS(item));
            }
            else {
                this.assicurazioni = <any>null;
            }
        }
    }

    static fromJS(data: any): GetInsurancesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInsurancesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assicurazioni)) {
            data["assicurazioni"] = [];
            for (let item of this.assicurazioni)
                data["assicurazioni"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetInsurancesResponse extends IOkApiResponse {
    assicurazioni?: Insurance[] | null;
}

export class Insurance implements IInsurance {
    servizio?: EServizioAutomatico;
    nome?: string | null;
    descrizione?: string | null;
    allegati?: ArticoloAllegato[] | null;
    consentiSceltaAbbinamento?: boolean;

    constructor(data?: IInsurance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            if (Array.isArray(_data["allegati"])) {
                this.allegati = [] as any;
                for (let item of _data["allegati"])
                    this.allegati!.push(ArticoloAllegato.fromJS(item));
            }
            else {
                this.allegati = <any>null;
            }
            this.consentiSceltaAbbinamento = _data["consentiSceltaAbbinamento"] !== undefined ? _data["consentiSceltaAbbinamento"] : <any>null;
        }
    }

    static fromJS(data: any): Insurance {
        data = typeof data === 'object' ? data : {};
        let result = new Insurance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        if (Array.isArray(this.allegati)) {
            data["allegati"] = [];
            for (let item of this.allegati)
                data["allegati"].push(item.toJSON());
        }
        data["consentiSceltaAbbinamento"] = this.consentiSceltaAbbinamento !== undefined ? this.consentiSceltaAbbinamento : <any>null;
        return data;
    }
}

export interface IInsurance {
    servizio?: EServizioAutomatico;
    nome?: string | null;
    descrizione?: string | null;
    allegati?: ArticoloAllegato[] | null;
    consentiSceltaAbbinamento?: boolean;
}

export class GetItinerariRequest extends ServizioGetRequest implements IGetItinerariRequest {
    includiDati?: boolean;

    constructor(data?: IGetItinerariRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.includiDati = _data["includiDati"] !== undefined ? _data["includiDati"] : <any>null;
        }
    }

    static fromJS(data: any): GetItinerariRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetItinerariRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includiDati"] = this.includiDati !== undefined ? this.includiDati : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetItinerariRequest extends IServizioGetRequest {
    includiDati?: boolean;
}

export class GetLuoghiServizioResponse extends OkApiResponse implements IGetLuoghiServizioResponse {
    /** Elenco dei luoghi del servizio */
    luoghi?: ServizioLuogoView[];

    constructor(data?: IGetLuoghiServizioResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["luoghi"])) {
                this.luoghi = [] as any;
                for (let item of _data["luoghi"])
                    this.luoghi!.push(ServizioLuogoView.fromJS(item));
            }
            else {
                this.luoghi = <any>null;
            }
        }
    }

    static fromJS(data: any): GetLuoghiServizioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLuoghiServizioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.luoghi)) {
            data["luoghi"] = [];
            for (let item of this.luoghi)
                data["luoghi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetLuoghiServizioResponse extends IOkApiResponse {
    /** Elenco dei luoghi del servizio */
    luoghi?: ServizioLuogoView[];
}

export class ServizioLuogoView implements IServizioLuogoView {
    /** ID del luogo associato */
    luogoID?: number;
    /** Nome del luogo associato */
    luogo?: string;
    /** Nome della regione del luogo associato */
    regione?: string | null;
    /** Nome del paese del luogo associato */
    paese?: string | null;

    constructor(data?: IServizioLuogoView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioLuogoView {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioLuogoView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["regione"] = this.regione !== undefined ? this.regione : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        return data;
    }
}

export interface IServizioLuogoView {
    /** ID del luogo associato */
    luogoID?: number;
    /** Nome del luogo associato */
    luogo?: string;
    /** Nome della regione del luogo associato */
    regione?: string | null;
    /** Nome del paese del luogo associato */
    paese?: string | null;
}

export class GetPublishedServiceResponse extends OkApiResponse implements IGetPublishedServiceResponse {
    servizio?: ServiceData | null;

    constructor(data?: IGetPublishedServiceResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? ServiceData.fromJS(_data["servizio"]) : <any>null;
        }
    }

    static fromJS(data: any): GetPublishedServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublishedServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPublishedServiceResponse extends IOkApiResponse {
    servizio?: ServiceData | null;
}

export class GetPublishedServiceRequest extends SiteRequest implements IGetPublishedServiceRequest {
    /** ID del servizio Naar (se Esterno � false) oppure del servizio hh */
    servizioID?: number;
    /** Se true � un servizio hh, altrimenti un servizio Naar */
    esterno?: boolean;
    /** Tipo di articoli da utilizzare */
    tipoArticoliRichiesti?: ETipoArticoliRichiesti;

    constructor(data?: IGetPublishedServiceRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.esterno = _data["esterno"] !== undefined ? _data["esterno"] : <any>null;
            this.tipoArticoliRichiesti = _data["tipoArticoliRichiesti"] !== undefined ? _data["tipoArticoliRichiesti"] : <any>null;
        }
    }

    static fromJS(data: any): GetPublishedServiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublishedServiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["esterno"] = this.esterno !== undefined ? this.esterno : <any>null;
        data["tipoArticoliRichiesti"] = this.tipoArticoliRichiesti !== undefined ? this.tipoArticoliRichiesti : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPublishedServiceRequest extends ISiteRequest {
    /** ID del servizio Naar (se Esterno � false) oppure del servizio hh */
    servizioID?: number;
    /** Se true � un servizio hh, altrimenti un servizio Naar */
    esterno?: boolean;
    /** Tipo di articoli da utilizzare */
    tipoArticoliRichiesti?: ETipoArticoliRichiesti;
}

export enum ETipoArticoliRichiesti {
    PreferTraducibili = "preferTraducibili",
    SoloTraducibili = "soloTraducibili",
    SoloCanonici = "soloCanonici",
    Tutti = "tutti",
}

export class GetTabelleCostiAssociateResponse extends OkApiResponse implements IGetTabelleCostiAssociateResponse {
    tabelle?: TabellaCostoListRow[];

    constructor(data?: IGetTabelleCostiAssociateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tabelle"])) {
                this.tabelle = [] as any;
                for (let item of _data["tabelle"])
                    this.tabelle!.push(TabellaCostoListRow.fromJS(item));
            }
            else {
                this.tabelle = <any>null;
            }
        }
    }

    static fromJS(data: any): GetTabelleCostiAssociateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTabelleCostiAssociateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tabelle)) {
            data["tabelle"] = [];
            for (let item of this.tabelle)
                data["tabelle"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTabelleCostiAssociateResponse extends IOkApiResponse {
    tabelle?: TabellaCostoListRow[];
}

export class TabellaCostoListRow implements ITabellaCostoListRow {
    id?: number;
    accordoID?: number;
    accordo?: string;
    accordoScaduto?: boolean;
    tabella?: string;
    tabellaScaduta?: boolean;
    dal?: string;
    al?: string;
    codiceValuta?: string | null;
    ordine?: number | null;

    constructor(data?: ITabellaCostoListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.accordoID = _data["accordoID"] !== undefined ? _data["accordoID"] : <any>null;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : <any>null;
            this.accordoScaduto = _data["accordoScaduto"] !== undefined ? _data["accordoScaduto"] : <any>null;
            this.tabella = _data["tabella"] !== undefined ? _data["tabella"] : <any>null;
            this.tabellaScaduta = _data["tabellaScaduta"] !== undefined ? _data["tabellaScaduta"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.codiceValuta = _data["codiceValuta"] !== undefined ? _data["codiceValuta"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
        }
    }

    static fromJS(data: any): TabellaCostoListRow {
        data = typeof data === 'object' ? data : {};
        let result = new TabellaCostoListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["accordoID"] = this.accordoID !== undefined ? this.accordoID : <any>null;
        data["accordo"] = this.accordo !== undefined ? this.accordo : <any>null;
        data["accordoScaduto"] = this.accordoScaduto !== undefined ? this.accordoScaduto : <any>null;
        data["tabella"] = this.tabella !== undefined ? this.tabella : <any>null;
        data["tabellaScaduta"] = this.tabellaScaduta !== undefined ? this.tabellaScaduta : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["codiceValuta"] = this.codiceValuta !== undefined ? this.codiceValuta : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        return data;
    }
}

export interface ITabellaCostoListRow {
    id?: number;
    accordoID?: number;
    accordo?: string;
    accordoScaduto?: boolean;
    tabella?: string;
    tabellaScaduta?: boolean;
    dal?: string;
    al?: string;
    codiceValuta?: string | null;
    ordine?: number | null;
}

export class GetTypesResponse extends OkApiResponse implements IGetTypesResponse {
    tipologie?: TipologiaTradotta[] | null;

    constructor(data?: IGetTypesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tipologie"])) {
                this.tipologie = [] as any;
                for (let item of _data["tipologie"])
                    this.tipologie!.push(TipologiaTradotta.fromJS(item));
            }
            else {
                this.tipologie = <any>null;
            }
        }
    }

    static fromJS(data: any): GetTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipologie)) {
            data["tipologie"] = [];
            for (let item of this.tipologie)
                data["tipologie"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTypesResponse extends IOkApiResponse {
    tipologie?: TipologiaTradotta[] | null;
}

export class TipologiaTradotta implements ITipologiaTradotta {
    tipologia?: ServizioTipologia | null;
    nome?: string | null;

    constructor(data?: ITipologiaTradotta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
        }
    }

    static fromJS(data: any): TipologiaTradotta {
        data = typeof data === 'object' ? data : {};
        let result = new TipologiaTradotta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        return data;
    }
}

export interface ITipologiaTradotta {
    tipologia?: ServizioTipologia | null;
    nome?: string | null;
}

export class GetTypesRequest extends SiteRequest implements IGetTypesRequest {
    servizioID?: number;

    constructor(data?: IGetTypesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
        }
    }

    static fromJS(data: any): GetTypesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTypesRequest extends ISiteRequest {
    servizioID?: number;
}

export class InsertCostiRequest extends ServizioGetRequest implements IInsertCostiRequest {
    /** Regola di inserimento dei costi per maneggiare i dati */
    regola?: ERegolaInserimentoCosti;
    /** ID del trattamento, se specificato */
    trattamentoID?: number | null;
    /** ID della regola servizio, se specificata */
    regolaServizioID?: number | null;
    /** ID della regola vendita, se specificata */
    regolaVenditaID?: number | null;
    /** Codice prenotazione facoltativo */
    codicePrenotazione?: string | null;
    /** Regola inserimento costi bambino, se richiesta */
    regolaCostiBambino?: ERegolaCostiBambino;
    /** Età bambino. Obbligatoria se presente la regola costi bambino, ignorata altrimenti */
    etaChild?: number | null;
    /** Se si stanno inserendo i costi bambino considera i valori come sconti percentuali sulle corrispondenti tipologie */
    scontoChildPercentuale?: boolean;
    /** ID delle tabelle costo da associare. Almeno una */
    tabelleCostoIDs?: number[];
    /** ID delle tipologie da associare. Almeno una */
    tipologieIDs?: number[];
    /** ID delle validità da associare. Almeno una */
    validitaIDs?: number[];
    /** ID bedding associato al costo 1 */
    beddingID1?: number | null;
    /** Costo associato al bedding 1, obbligatorio se presente */
    costo1?: number | null;
    /** ID bedding associato al costo 2 */
    beddingID2?: number | null;
    /** Costo associato al bedding 2, obbligatorio se presente */
    costo2?: number | null;
    /** ID bedding associato al costo 3 */
    beddingID3?: number | null;
    /** Costo associato al bedding 3, obbligatorio se presente */
    costo3?: number | null;
    /** ID bedding associato al costo 4 */
    beddingID4?: number | null;
    /** Costo associato al bedding 4, obbligatorio se presente */
    costo4?: number | null;
    /** ID bedding associato al costo 5 */
    beddingID5?: number | null;
    /** Costo associato al bedding 1. Viene inserito comunque indipendentemente dal bedding */
    costo5?: number | null;
    /** ID aggiuntivo per la gestione delle regole di inserimento costi 9, 10 e 12 */
    extraID?: number | null;

    constructor(data?: IInsertCostiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] !== undefined ? _data["regola"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
            this.regolaServizioID = _data["regolaServizioID"] !== undefined ? _data["regolaServizioID"] : <any>null;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : <any>null;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : <any>null;
            this.regolaCostiBambino = _data["regolaCostiBambino"] !== undefined ? _data["regolaCostiBambino"] : <any>null;
            this.etaChild = _data["etaChild"] !== undefined ? _data["etaChild"] : <any>null;
            this.scontoChildPercentuale = _data["scontoChildPercentuale"] !== undefined ? _data["scontoChildPercentuale"] : <any>null;
            if (Array.isArray(_data["tabelleCostoIDs"])) {
                this.tabelleCostoIDs = [] as any;
                for (let item of _data["tabelleCostoIDs"])
                    this.tabelleCostoIDs!.push(item);
            }
            else {
                this.tabelleCostoIDs = <any>null;
            }
            if (Array.isArray(_data["tipologieIDs"])) {
                this.tipologieIDs = [] as any;
                for (let item of _data["tipologieIDs"])
                    this.tipologieIDs!.push(item);
            }
            else {
                this.tipologieIDs = <any>null;
            }
            if (Array.isArray(_data["validitaIDs"])) {
                this.validitaIDs = [] as any;
                for (let item of _data["validitaIDs"])
                    this.validitaIDs!.push(item);
            }
            else {
                this.validitaIDs = <any>null;
            }
            this.beddingID1 = _data["beddingID1"] !== undefined ? _data["beddingID1"] : <any>null;
            this.costo1 = _data["costo1"] !== undefined ? _data["costo1"] : <any>null;
            this.beddingID2 = _data["beddingID2"] !== undefined ? _data["beddingID2"] : <any>null;
            this.costo2 = _data["costo2"] !== undefined ? _data["costo2"] : <any>null;
            this.beddingID3 = _data["beddingID3"] !== undefined ? _data["beddingID3"] : <any>null;
            this.costo3 = _data["costo3"] !== undefined ? _data["costo3"] : <any>null;
            this.beddingID4 = _data["beddingID4"] !== undefined ? _data["beddingID4"] : <any>null;
            this.costo4 = _data["costo4"] !== undefined ? _data["costo4"] : <any>null;
            this.beddingID5 = _data["beddingID5"] !== undefined ? _data["beddingID5"] : <any>null;
            this.costo5 = _data["costo5"] !== undefined ? _data["costo5"] : <any>null;
            this.extraID = _data["extraID"] !== undefined ? _data["extraID"] : <any>null;
        }
    }

    static fromJS(data: any): InsertCostiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertCostiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola !== undefined ? this.regola : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        data["regolaServizioID"] = this.regolaServizioID !== undefined ? this.regolaServizioID : <any>null;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : <any>null;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : <any>null;
        data["regolaCostiBambino"] = this.regolaCostiBambino !== undefined ? this.regolaCostiBambino : <any>null;
        data["etaChild"] = this.etaChild !== undefined ? this.etaChild : <any>null;
        data["scontoChildPercentuale"] = this.scontoChildPercentuale !== undefined ? this.scontoChildPercentuale : <any>null;
        if (Array.isArray(this.tabelleCostoIDs)) {
            data["tabelleCostoIDs"] = [];
            for (let item of this.tabelleCostoIDs)
                data["tabelleCostoIDs"].push(item);
        }
        if (Array.isArray(this.tipologieIDs)) {
            data["tipologieIDs"] = [];
            for (let item of this.tipologieIDs)
                data["tipologieIDs"].push(item);
        }
        if (Array.isArray(this.validitaIDs)) {
            data["validitaIDs"] = [];
            for (let item of this.validitaIDs)
                data["validitaIDs"].push(item);
        }
        data["beddingID1"] = this.beddingID1 !== undefined ? this.beddingID1 : <any>null;
        data["costo1"] = this.costo1 !== undefined ? this.costo1 : <any>null;
        data["beddingID2"] = this.beddingID2 !== undefined ? this.beddingID2 : <any>null;
        data["costo2"] = this.costo2 !== undefined ? this.costo2 : <any>null;
        data["beddingID3"] = this.beddingID3 !== undefined ? this.beddingID3 : <any>null;
        data["costo3"] = this.costo3 !== undefined ? this.costo3 : <any>null;
        data["beddingID4"] = this.beddingID4 !== undefined ? this.beddingID4 : <any>null;
        data["costo4"] = this.costo4 !== undefined ? this.costo4 : <any>null;
        data["beddingID5"] = this.beddingID5 !== undefined ? this.beddingID5 : <any>null;
        data["costo5"] = this.costo5 !== undefined ? this.costo5 : <any>null;
        data["extraID"] = this.extraID !== undefined ? this.extraID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInsertCostiRequest extends IServizioGetRequest {
    /** Regola di inserimento dei costi per maneggiare i dati */
    regola?: ERegolaInserimentoCosti;
    /** ID del trattamento, se specificato */
    trattamentoID?: number | null;
    /** ID della regola servizio, se specificata */
    regolaServizioID?: number | null;
    /** ID della regola vendita, se specificata */
    regolaVenditaID?: number | null;
    /** Codice prenotazione facoltativo */
    codicePrenotazione?: string | null;
    /** Regola inserimento costi bambino, se richiesta */
    regolaCostiBambino?: ERegolaCostiBambino;
    /** Età bambino. Obbligatoria se presente la regola costi bambino, ignorata altrimenti */
    etaChild?: number | null;
    /** Se si stanno inserendo i costi bambino considera i valori come sconti percentuali sulle corrispondenti tipologie */
    scontoChildPercentuale?: boolean;
    /** ID delle tabelle costo da associare. Almeno una */
    tabelleCostoIDs?: number[];
    /** ID delle tipologie da associare. Almeno una */
    tipologieIDs?: number[];
    /** ID delle validità da associare. Almeno una */
    validitaIDs?: number[];
    /** ID bedding associato al costo 1 */
    beddingID1?: number | null;
    /** Costo associato al bedding 1, obbligatorio se presente */
    costo1?: number | null;
    /** ID bedding associato al costo 2 */
    beddingID2?: number | null;
    /** Costo associato al bedding 2, obbligatorio se presente */
    costo2?: number | null;
    /** ID bedding associato al costo 3 */
    beddingID3?: number | null;
    /** Costo associato al bedding 3, obbligatorio se presente */
    costo3?: number | null;
    /** ID bedding associato al costo 4 */
    beddingID4?: number | null;
    /** Costo associato al bedding 4, obbligatorio se presente */
    costo4?: number | null;
    /** ID bedding associato al costo 5 */
    beddingID5?: number | null;
    /** Costo associato al bedding 1. Viene inserito comunque indipendentemente dal bedding */
    costo5?: number | null;
    /** ID aggiuntivo per la gestione delle regole di inserimento costi 9, 10 e 12 */
    extraID?: number | null;
}

export enum ERegolaInserimentoCosti {
    Nessuna = "Nessuna",
    SingolaDoppiaTriplaQuadruplaPerPax = "SingolaDoppiaTriplaQuadruplaPerPax",
    SingolaDoppiaPerCameraSupplementoTriplaQuadruplaPerPax = "SingolaDoppiaPerCameraSupplementoTriplaQuadruplaPerPax",
    DoppiaPerPaxSupplementoSingolaRiduzioneTriplaQuadruplaPerPax = "DoppiaPerPaxSupplementoSingolaRiduzioneTriplaQuadruplaPerPax",
    DoppiaTriplaQuadruplaPerPaxSupplementoSingolaPerPax = "DoppiaTriplaQuadruplaPerPaxSupplementoSingolaPerPax",
    DoppiaPerPaxSupplementoSingolaPerTriplaQuadruplaPerPax = "DoppiaPerPaxSupplementoSingolaPerTriplaQuadruplaPerPax",
    DoppiaPerPaxSupplementoSingolaTriplaQuadruplaPerPax = "DoppiaPerPaxSupplementoSingolaTriplaQuadruplaPerPax",
    DoppiaPerPaxSupplementoSingolaGlobaleRiduzioneTerzoQuartoLettoPerc = "DoppiaPerPaxSupplementoSingolaGlobaleRiduzioneTerzoQuartoLettoPerc",
    DoppiaPerPaxSupplementoSingolaPercRiduzioneTerzoQuartoLettoPerc = "DoppiaPerPaxSupplementoSingolaPercRiduzioneTerzoQuartoLettoPerc",
    SupplementoSuTipologiaGlobale = "SupplementoSuTipologiaGlobale",
    SupplementoSuTipologiaPerPax = "SupplementoSuTipologiaPerPax",
    DoppiaPerPaxSupplementoSingolaRiduzioneTerzoQuartoLetto = "DoppiaPerPaxSupplementoSingolaRiduzioneTerzoQuartoLetto",
    SupplementoSuTrattamentoBasePerPax = "SupplementoSuTrattamentoBasePerPax",
    DoppiaPerPaxSupplementoSingolaTriplaQuadruplaGlobale = "DoppiaPerPaxSupplementoSingolaTriplaQuadruplaGlobale",
    SingolaDoppiaPerPaxSupplementoTriplaQuadruplaGlobale = "SingolaDoppiaPerPaxSupplementoTriplaQuadruplaGlobale",
}

export class InsertTipologiaStandardRequest extends ApiRequest implements IInsertTipologiaStandardRequest {
    nome?: string | null;
    nome_en?: string | null;
    eTipoServizio?: ETipoServizio;

    constructor(data?: IInsertTipologiaStandardRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.eTipoServizio = _data["eTipoServizio"] !== undefined ? _data["eTipoServizio"] : <any>null;
        }
    }

    static fromJS(data: any): InsertTipologiaStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTipologiaStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["eTipoServizio"] = this.eTipoServizio !== undefined ? this.eTipoServizio : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInsertTipologiaStandardRequest extends IApiRequest {
    nome?: string | null;
    nome_en?: string | null;
    eTipoServizio?: ETipoServizio;
}

export class NrTableResponseOfAPI_ServiceGetRow extends OkApiResponse implements INrTableResponseOfAPI_ServiceGetRow {
    /** Array delle righe della pagina richiesta */
    rows?: API_ServiceGetRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAPI_ServiceGetRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(API_ServiceGetRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfAPI_ServiceGetRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAPI_ServiceGetRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAPI_ServiceGetRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: API_ServiceGetRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class API_ServiceGetRow implements IAPI_ServiceGetRow {
    idServizio?: number;
    category?: string | null;
    englishName?: string | null;
    languageName?: string | null;
    productName?: string | null;
    supplier?: string | null;
    city?: string | null;
    region?: string | null;
    country?: string | null;
    publish?: EStatoPubblicazioneServizio | null;
    publishFR?: EStatoPubblicazioneServizio | null;
    publishDE?: EStatoPubblicazioneServizio | null;
    publishBE?: EStatoPubblicazioneServizio | null;
    status?: EStatoUtilizzoServizio | null;
    lastUpdate?: string | null;
    deleted?: boolean;
    publishes?: PublishData[];

    constructor(data?: IAPI_ServiceGetRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idServizio = _data["idServizio"] !== undefined ? _data["idServizio"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.englishName = _data["englishName"] !== undefined ? _data["englishName"] : <any>null;
            this.languageName = _data["languageName"] !== undefined ? _data["languageName"] : <any>null;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : <any>null;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.region = _data["region"] !== undefined ? _data["region"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.publish = _data["publish"] !== undefined ? _data["publish"] : <any>null;
            this.publishFR = _data["publishFR"] !== undefined ? _data["publishFR"] : <any>null;
            this.publishDE = _data["publishDE"] !== undefined ? _data["publishDE"] : <any>null;
            this.publishBE = _data["publishBE"] !== undefined ? _data["publishBE"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
            if (Array.isArray(_data["publishes"])) {
                this.publishes = [] as any;
                for (let item of _data["publishes"])
                    this.publishes!.push(PublishData.fromJS(item));
            }
            else {
                this.publishes = <any>null;
            }
        }
    }

    static fromJS(data: any): API_ServiceGetRow {
        data = typeof data === 'object' ? data : {};
        let result = new API_ServiceGetRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idServizio"] = this.idServizio !== undefined ? this.idServizio : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["englishName"] = this.englishName !== undefined ? this.englishName : <any>null;
        data["languageName"] = this.languageName !== undefined ? this.languageName : <any>null;
        data["productName"] = this.productName !== undefined ? this.productName : <any>null;
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["region"] = this.region !== undefined ? this.region : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["publish"] = this.publish !== undefined ? this.publish : <any>null;
        data["publishFR"] = this.publishFR !== undefined ? this.publishFR : <any>null;
        data["publishDE"] = this.publishDE !== undefined ? this.publishDE : <any>null;
        data["publishBE"] = this.publishBE !== undefined ? this.publishBE : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        if (Array.isArray(this.publishes)) {
            data["publishes"] = [];
            for (let item of this.publishes)
                data["publishes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAPI_ServiceGetRow {
    idServizio?: number;
    category?: string | null;
    englishName?: string | null;
    languageName?: string | null;
    productName?: string | null;
    supplier?: string | null;
    city?: string | null;
    region?: string | null;
    country?: string | null;
    publish?: EStatoPubblicazioneServizio | null;
    publishFR?: EStatoPubblicazioneServizio | null;
    publishDE?: EStatoPubblicazioneServizio | null;
    publishBE?: EStatoPubblicazioneServizio | null;
    status?: EStatoUtilizzoServizio | null;
    lastUpdate?: string | null;
    deleted?: boolean;
    publishes?: PublishData[];
}

export class PublishData implements IPublishData {
    id?: number;
    name?: string;
    status?: EStatoPubblicazioneServizio | null;

    constructor(data?: IPublishData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): PublishData {
        data = typeof data === 'object' ? data : {};
        let result = new PublishData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IPublishData {
    id?: number;
    name?: string;
    status?: EStatoPubblicazioneServizio | null;
}

export class ListServicesRequest extends NrTableRequest implements IListServicesRequest {
    term?: string | null;
    luogoID?: number | null;
    luogoPaeseID?: number | null;
    tipo?: ETipoServizio | null;
    showDeleted?: boolean | null;
    language?: ELingua | null;
    statoUtilizzo?: EStatoUtilizzoServizio | null;
    sitoPubblicazioneID?: number | null;
    statoPubblicazione?: EStatoPubblicazioneServizio | null;
    fornitoreTerziID?: number | null;
    showOnlyPublished?: boolean | null;
    nomiStatiUtilizzo?: { [key in keyof typeof EStatoUtilizzoServizio]?: string; } | null;
    nomiStatiPubblicazione?: { [key in keyof typeof EStatoPubblicazioneServizio]?: string; } | null;

    constructor(data?: IListServicesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogoPaeseID = _data["luogoPaeseID"] !== undefined ? _data["luogoPaeseID"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.statoUtilizzo = _data["statoUtilizzo"] !== undefined ? _data["statoUtilizzo"] : <any>null;
            this.sitoPubblicazioneID = _data["sitoPubblicazioneID"] !== undefined ? _data["sitoPubblicazioneID"] : <any>null;
            this.statoPubblicazione = _data["statoPubblicazione"] !== undefined ? _data["statoPubblicazione"] : <any>null;
            this.fornitoreTerziID = _data["fornitoreTerziID"] !== undefined ? _data["fornitoreTerziID"] : <any>null;
            this.showOnlyPublished = _data["showOnlyPublished"] !== undefined ? _data["showOnlyPublished"] : <any>null;
            if (_data["nomiStatiUtilizzo"]) {
                this.nomiStatiUtilizzo = {} as any;
                for (let key in _data["nomiStatiUtilizzo"]) {
                    if (_data["nomiStatiUtilizzo"].hasOwnProperty(key))
                        (<any>this.nomiStatiUtilizzo)![key] = _data["nomiStatiUtilizzo"][key] !== undefined ? _data["nomiStatiUtilizzo"][key] : <any>null;
                }
            }
            else {
                this.nomiStatiUtilizzo = <any>null;
            }
            if (_data["nomiStatiPubblicazione"]) {
                this.nomiStatiPubblicazione = {} as any;
                for (let key in _data["nomiStatiPubblicazione"]) {
                    if (_data["nomiStatiPubblicazione"].hasOwnProperty(key))
                        (<any>this.nomiStatiPubblicazione)![key] = _data["nomiStatiPubblicazione"][key] !== undefined ? _data["nomiStatiPubblicazione"][key] : <any>null;
                }
            }
            else {
                this.nomiStatiPubblicazione = <any>null;
            }
        }
    }

    static fromJS(data: any): ListServicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListServicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogoPaeseID"] = this.luogoPaeseID !== undefined ? this.luogoPaeseID : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["statoUtilizzo"] = this.statoUtilizzo !== undefined ? this.statoUtilizzo : <any>null;
        data["sitoPubblicazioneID"] = this.sitoPubblicazioneID !== undefined ? this.sitoPubblicazioneID : <any>null;
        data["statoPubblicazione"] = this.statoPubblicazione !== undefined ? this.statoPubblicazione : <any>null;
        data["fornitoreTerziID"] = this.fornitoreTerziID !== undefined ? this.fornitoreTerziID : <any>null;
        data["showOnlyPublished"] = this.showOnlyPublished !== undefined ? this.showOnlyPublished : <any>null;
        if (this.nomiStatiUtilizzo) {
            data["nomiStatiUtilizzo"] = {};
            for (let key in this.nomiStatiUtilizzo) {
                if (this.nomiStatiUtilizzo.hasOwnProperty(key))
                    (<any>data["nomiStatiUtilizzo"])[key] = this.nomiStatiUtilizzo[key] !== undefined ? this.nomiStatiUtilizzo[key] : <any>null;
            }
        }
        if (this.nomiStatiPubblicazione) {
            data["nomiStatiPubblicazione"] = {};
            for (let key in this.nomiStatiPubblicazione) {
                if (this.nomiStatiPubblicazione.hasOwnProperty(key))
                    (<any>data["nomiStatiPubblicazione"])[key] = this.nomiStatiPubblicazione[key] !== undefined ? this.nomiStatiPubblicazione[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IListServicesRequest extends INrTableRequest {
    term?: string | null;
    luogoID?: number | null;
    luogoPaeseID?: number | null;
    tipo?: ETipoServizio | null;
    showDeleted?: boolean | null;
    language?: ELingua | null;
    statoUtilizzo?: EStatoUtilizzoServizio | null;
    sitoPubblicazioneID?: number | null;
    statoPubblicazione?: EStatoPubblicazioneServizio | null;
    fornitoreTerziID?: number | null;
    showOnlyPublished?: boolean | null;
    nomiStatiUtilizzo?: { [key in keyof typeof EStatoUtilizzoServizio]?: string; } | null;
    nomiStatiPubblicazione?: { [key in keyof typeof EStatoPubblicazioneServizio]?: string; } | null;
}

export class ListPublishedServicesResponse extends OkApiResponse implements IListPublishedServicesResponse {
    filters?: ServiceFilter[] | null;
    services?: { [key: string]: ServiceData; } | null;
    location?: string | null;
    locationUrlPart?: string | null;
    unmappedMode?: EModalitaNonMappati;
    idsByName?: string[] | null;
    idsByPopularity?: string[] | null;
    idsShown?: string[] | null;
    idsExternal?: string[] | null;
    destinazioni?: ServiceDestination[] | null;
    luoghiTappe?: ServiceDestination[] | null;
    abilitaFiltroDurata?: boolean;
    abilitaFiltroCittaTappa?: boolean;
    nascondiNrf?: boolean;
    deleted?: boolean;
    serviceTypeListCount?: { [key in keyof typeof ETipoServizio]?: number; } | null;

    constructor(data?: IListPublishedServicesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(ServiceFilter.fromJS(item));
            }
            else {
                this.filters = <any>null;
            }
            if (_data["services"]) {
                this.services = {} as any;
                for (let key in _data["services"]) {
                    if (_data["services"].hasOwnProperty(key))
                        (<any>this.services)![key] = _data["services"][key] ? ServiceData.fromJS(_data["services"][key]) : new ServiceData();
                }
            }
            else {
                this.services = <any>null;
            }
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.locationUrlPart = _data["locationUrlPart"] !== undefined ? _data["locationUrlPart"] : <any>null;
            this.unmappedMode = _data["unmappedMode"] !== undefined ? _data["unmappedMode"] : <any>null;
            if (Array.isArray(_data["idsByName"])) {
                this.idsByName = [] as any;
                for (let item of _data["idsByName"])
                    this.idsByName!.push(item);
            }
            else {
                this.idsByName = <any>null;
            }
            if (Array.isArray(_data["idsByPopularity"])) {
                this.idsByPopularity = [] as any;
                for (let item of _data["idsByPopularity"])
                    this.idsByPopularity!.push(item);
            }
            else {
                this.idsByPopularity = <any>null;
            }
            if (Array.isArray(_data["idsShown"])) {
                this.idsShown = [] as any;
                for (let item of _data["idsShown"])
                    this.idsShown!.push(item);
            }
            else {
                this.idsShown = <any>null;
            }
            if (Array.isArray(_data["idsExternal"])) {
                this.idsExternal = [] as any;
                for (let item of _data["idsExternal"])
                    this.idsExternal!.push(item);
            }
            else {
                this.idsExternal = <any>null;
            }
            if (Array.isArray(_data["destinazioni"])) {
                this.destinazioni = [] as any;
                for (let item of _data["destinazioni"])
                    this.destinazioni!.push(ServiceDestination.fromJS(item));
            }
            else {
                this.destinazioni = <any>null;
            }
            if (Array.isArray(_data["luoghiTappe"])) {
                this.luoghiTappe = [] as any;
                for (let item of _data["luoghiTappe"])
                    this.luoghiTappe!.push(ServiceDestination.fromJS(item));
            }
            else {
                this.luoghiTappe = <any>null;
            }
            this.abilitaFiltroDurata = _data["abilitaFiltroDurata"] !== undefined ? _data["abilitaFiltroDurata"] : <any>null;
            this.abilitaFiltroCittaTappa = _data["abilitaFiltroCittaTappa"] !== undefined ? _data["abilitaFiltroCittaTappa"] : <any>null;
            this.nascondiNrf = _data["nascondiNrf"] !== undefined ? _data["nascondiNrf"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
            if (_data["serviceTypeListCount"]) {
                this.serviceTypeListCount = {} as any;
                for (let key in _data["serviceTypeListCount"]) {
                    if (_data["serviceTypeListCount"].hasOwnProperty(key))
                        (<any>this.serviceTypeListCount)![key] = _data["serviceTypeListCount"][key] !== undefined ? _data["serviceTypeListCount"][key] : <any>null;
                }
            }
            else {
                this.serviceTypeListCount = <any>null;
            }
        }
    }

    static fromJS(data: any): ListPublishedServicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListPublishedServicesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (this.services) {
            data["services"] = {};
            for (let key in this.services) {
                if (this.services.hasOwnProperty(key))
                    (<any>data["services"])[key] = this.services[key] ? this.services[key].toJSON() : <any>null;
            }
        }
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["locationUrlPart"] = this.locationUrlPart !== undefined ? this.locationUrlPart : <any>null;
        data["unmappedMode"] = this.unmappedMode !== undefined ? this.unmappedMode : <any>null;
        if (Array.isArray(this.idsByName)) {
            data["idsByName"] = [];
            for (let item of this.idsByName)
                data["idsByName"].push(item);
        }
        if (Array.isArray(this.idsByPopularity)) {
            data["idsByPopularity"] = [];
            for (let item of this.idsByPopularity)
                data["idsByPopularity"].push(item);
        }
        if (Array.isArray(this.idsShown)) {
            data["idsShown"] = [];
            for (let item of this.idsShown)
                data["idsShown"].push(item);
        }
        if (Array.isArray(this.idsExternal)) {
            data["idsExternal"] = [];
            for (let item of this.idsExternal)
                data["idsExternal"].push(item);
        }
        if (Array.isArray(this.destinazioni)) {
            data["destinazioni"] = [];
            for (let item of this.destinazioni)
                data["destinazioni"].push(item.toJSON());
        }
        if (Array.isArray(this.luoghiTappe)) {
            data["luoghiTappe"] = [];
            for (let item of this.luoghiTappe)
                data["luoghiTappe"].push(item.toJSON());
        }
        data["abilitaFiltroDurata"] = this.abilitaFiltroDurata !== undefined ? this.abilitaFiltroDurata : <any>null;
        data["abilitaFiltroCittaTappa"] = this.abilitaFiltroCittaTappa !== undefined ? this.abilitaFiltroCittaTappa : <any>null;
        data["nascondiNrf"] = this.nascondiNrf !== undefined ? this.nascondiNrf : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        if (this.serviceTypeListCount) {
            data["serviceTypeListCount"] = {};
            for (let key in this.serviceTypeListCount) {
                if (this.serviceTypeListCount.hasOwnProperty(key))
                    (<any>data["serviceTypeListCount"])[key] = this.serviceTypeListCount[key] !== undefined ? this.serviceTypeListCount[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IListPublishedServicesResponse extends IOkApiResponse {
    filters?: ServiceFilter[] | null;
    services?: { [key: string]: ServiceData; } | null;
    location?: string | null;
    locationUrlPart?: string | null;
    unmappedMode?: EModalitaNonMappati;
    idsByName?: string[] | null;
    idsByPopularity?: string[] | null;
    idsShown?: string[] | null;
    idsExternal?: string[] | null;
    destinazioni?: ServiceDestination[] | null;
    luoghiTappe?: ServiceDestination[] | null;
    abilitaFiltroDurata?: boolean;
    abilitaFiltroCittaTappa?: boolean;
    nascondiNrf?: boolean;
    deleted?: boolean;
    serviceTypeListCount?: { [key in keyof typeof ETipoServizio]?: number; } | null;
}

export class ServiceFilter implements IServiceFilter {
    id?: number;
    name?: string | null;
    logic?: EServiceFilterLogic;
    primary?: boolean;
    values?: ServiceFilterValue[] | null;
    sortOrder?: number;

    constructor(data?: IServiceFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.logic = _data["logic"] !== undefined ? _data["logic"] : <any>null;
            this.primary = _data["primary"] !== undefined ? _data["primary"] : <any>null;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ServiceFilterValue.fromJS(item));
            }
            else {
                this.values = <any>null;
            }
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["logic"] = this.logic !== undefined ? this.logic : <any>null;
        data["primary"] = this.primary !== undefined ? this.primary : <any>null;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        return data;
    }
}

export interface IServiceFilter {
    id?: number;
    name?: string | null;
    logic?: EServiceFilterLogic;
    primary?: boolean;
    values?: ServiceFilterValue[] | null;
    sortOrder?: number;
}

export enum EServiceFilterLogic {
    AND = "AND",
    OR = "OR",
}

export class ServiceFilterValue implements IServiceFilterValue {
    id?: number;
    name?: string | null;
    sortOrder?: number;

    constructor(data?: IServiceFilterValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceFilterValue {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceFilterValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        return data;
    }
}

export interface IServiceFilterValue {
    id?: number;
    name?: string | null;
    sortOrder?: number;
}

export class ServiceDestination implements IServiceDestination {
    destinazioneID?: number;
    nome?: string | null;
    regione?: string | null;
    paese?: string | null;

    constructor(data?: IServiceDestination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinazioneID = _data["destinazioneID"] !== undefined ? _data["destinazioneID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : <any>null;
            this.paese = _data["paese"] !== undefined ? _data["paese"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceDestination {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDestination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinazioneID"] = this.destinazioneID !== undefined ? this.destinazioneID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["regione"] = this.regione !== undefined ? this.regione : <any>null;
        data["paese"] = this.paese !== undefined ? this.paese : <any>null;
        return data;
    }
}

export interface IServiceDestination {
    destinazioneID?: number;
    nome?: string | null;
    regione?: string | null;
    paese?: string | null;
}

export class ListPublishedServicesRequest extends SiteRequest implements IListPublishedServicesRequest {
    /** Eventuale offerta associata alla richiesta */
    offertaID?: number | null;
    /** Tappa associata all'offerta, obbligatorio se OffertaID � non nullo */
    tappaID?: number | null;
    luogoID?: number | null;
    luogoDestinazioneID?: number | null;
    tipoServizio?: ETipoServizio;
    sottoTipoServizio?: ESottoTipoServizio | null;
    filtroCatalogoTour?: boolean;
    filtriAttributo?: number[] | null;
    showValid?: boolean | null;
    page?: number;
    pageSize?: number;
    allServiceTypes?: boolean;

    constructor(data?: IListPublishedServicesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.tappaID = _data["tappaID"] !== undefined ? _data["tappaID"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogoDestinazioneID = _data["luogoDestinazioneID"] !== undefined ? _data["luogoDestinazioneID"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.sottoTipoServizio = _data["sottoTipoServizio"] !== undefined ? _data["sottoTipoServizio"] : <any>null;
            this.filtroCatalogoTour = _data["filtroCatalogoTour"] !== undefined ? _data["filtroCatalogoTour"] : <any>null;
            if (Array.isArray(_data["filtriAttributo"])) {
                this.filtriAttributo = [] as any;
                for (let item of _data["filtriAttributo"])
                    this.filtriAttributo!.push(item);
            }
            else {
                this.filtriAttributo = <any>null;
            }
            this.showValid = _data["showValid"] !== undefined ? _data["showValid"] : <any>null;
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.allServiceTypes = _data["allServiceTypes"] !== undefined ? _data["allServiceTypes"] : <any>null;
        }
    }

    static fromJS(data: any): ListPublishedServicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListPublishedServicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["tappaID"] = this.tappaID !== undefined ? this.tappaID : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogoDestinazioneID"] = this.luogoDestinazioneID !== undefined ? this.luogoDestinazioneID : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["sottoTipoServizio"] = this.sottoTipoServizio !== undefined ? this.sottoTipoServizio : <any>null;
        data["filtroCatalogoTour"] = this.filtroCatalogoTour !== undefined ? this.filtroCatalogoTour : <any>null;
        if (Array.isArray(this.filtriAttributo)) {
            data["filtriAttributo"] = [];
            for (let item of this.filtriAttributo)
                data["filtriAttributo"].push(item);
        }
        data["showValid"] = this.showValid !== undefined ? this.showValid : <any>null;
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["allServiceTypes"] = this.allServiceTypes !== undefined ? this.allServiceTypes : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IListPublishedServicesRequest extends ISiteRequest {
    /** Eventuale offerta associata alla richiesta */
    offertaID?: number | null;
    /** Tappa associata all'offerta, obbligatorio se OffertaID � non nullo */
    tappaID?: number | null;
    luogoID?: number | null;
    luogoDestinazioneID?: number | null;
    tipoServizio?: ETipoServizio;
    sottoTipoServizio?: ESottoTipoServizio | null;
    filtroCatalogoTour?: boolean;
    filtriAttributo?: number[] | null;
    showValid?: boolean | null;
    page?: number;
    pageSize?: number;
    allServiceTypes?: boolean;
}

export enum ESottoTipoServizio {
    Minitour = "Minitour",
    FullTour = "FullTour",
    FlyBeach = "FlyBeach",
    FlyCity = "FlyCity",
    FlyTour = "FlyTour",
    FlyCruise = "FlyCruise",
}

export class RestoreTipologiaRequest extends GetTipologieRequest implements IRestoreTipologiaRequest {
    servizioTipologiaID?: number;

    constructor(data?: IRestoreTipologiaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioTipologiaID = _data["servizioTipologiaID"] !== undefined ? _data["servizioTipologiaID"] : <any>null;
        }
    }

    static fromJS(data: any): RestoreTipologiaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreTipologiaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioTipologiaID"] = this.servizioTipologiaID !== undefined ? this.servizioTipologiaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreTipologiaRequest extends IGetTipologieRequest {
    servizioTipologiaID?: number;
}

export class RestoreTipologieRequest extends GetTipologieRequest implements IRestoreTipologieRequest {
    tipologieIDs?: number[] | null;

    constructor(data?: IRestoreTipologieRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tipologieIDs"])) {
                this.tipologieIDs = [] as any;
                for (let item of _data["tipologieIDs"])
                    this.tipologieIDs!.push(item);
            }
            else {
                this.tipologieIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): RestoreTipologieRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreTipologieRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipologieIDs)) {
            data["tipologieIDs"] = [];
            for (let item of this.tipologieIDs)
                data["tipologieIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreTipologieRequest extends IGetTipologieRequest {
    tipologieIDs?: number[] | null;
}

export class SetAccordiServizioRequest extends ServizioGetRequest implements ISetAccordiServizioRequest {
    /** Elenco degli ID degli accordi da associare */
    accordiIDs?: number[];

    constructor(data?: ISetAccordiServizioRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["accordiIDs"])) {
                this.accordiIDs = [] as any;
                for (let item of _data["accordiIDs"])
                    this.accordiIDs!.push(item);
            }
            else {
                this.accordiIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): SetAccordiServizioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetAccordiServizioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accordiIDs)) {
            data["accordiIDs"] = [];
            for (let item of this.accordiIDs)
                data["accordiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetAccordiServizioRequest extends IServizioGetRequest {
    /** Elenco degli ID degli accordi da associare */
    accordiIDs?: number[];
}

export class SetDatiAggiuntiviRequest extends ServizioGetRequest implements ISetDatiAggiuntiviRequest {
    /** Elenco dei dati aggiuntivi da impostare */
    dati?: ServizioDatoAggiuntivoBase[];

    constructor(data?: ISetDatiAggiuntiviRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["dati"])) {
                this.dati = [] as any;
                for (let item of _data["dati"])
                    this.dati!.push(ServizioDatoAggiuntivoBase.fromJS(item));
            }
            else {
                this.dati = <any>null;
            }
        }
    }

    static fromJS(data: any): SetDatiAggiuntiviRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetDatiAggiuntiviRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dati)) {
            data["dati"] = [];
            for (let item of this.dati)
                data["dati"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetDatiAggiuntiviRequest extends IServizioGetRequest {
    /** Elenco dei dati aggiuntivi da impostare */
    dati?: ServizioDatoAggiuntivoBase[];
}

export abstract class ServizioDatoAggiuntivoBase implements IServizioDatoAggiuntivoBase {
    id?: number;
    servizioID?: number;
    datoAggiuntivoID?: number;
    tipoServizio?: ETipoServizio | null;
    valore?: string | null;
    dal?: string | null;
    al?: string | null;
    valore_fr?: string | null;
    valore_de?: string | null;
    valore_es?: string | null;
    valore_en?: string | null;

    constructor(data?: IServizioDatoAggiuntivoBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.datoAggiuntivoID = _data["datoAggiuntivoID"] !== undefined ? _data["datoAggiuntivoID"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.valore_fr = _data["valore_fr"] !== undefined ? _data["valore_fr"] : <any>null;
            this.valore_de = _data["valore_de"] !== undefined ? _data["valore_de"] : <any>null;
            this.valore_es = _data["valore_es"] !== undefined ? _data["valore_es"] : <any>null;
            this.valore_en = _data["valore_en"] !== undefined ? _data["valore_en"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioDatoAggiuntivoBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServizioDatoAggiuntivoBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["datoAggiuntivoID"] = this.datoAggiuntivoID !== undefined ? this.datoAggiuntivoID : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["valore"] = this.valore !== undefined ? this.valore : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["valore_fr"] = this.valore_fr !== undefined ? this.valore_fr : <any>null;
        data["valore_de"] = this.valore_de !== undefined ? this.valore_de : <any>null;
        data["valore_es"] = this.valore_es !== undefined ? this.valore_es : <any>null;
        data["valore_en"] = this.valore_en !== undefined ? this.valore_en : <any>null;
        return data;
    }
}

export interface IServizioDatoAggiuntivoBase {
    id?: number;
    servizioID?: number;
    datoAggiuntivoID?: number;
    tipoServizio?: ETipoServizio | null;
    valore?: string | null;
    dal?: string | null;
    al?: string | null;
    valore_fr?: string | null;
    valore_de?: string | null;
    valore_es?: string | null;
    valore_en?: string | null;
}

export class SetLuoghiServizioRequest extends ServizioGetRequest implements ISetLuoghiServizioRequest {
    /** Elenco degli ID dei luoghi */
    luoghiIDs?: number[];

    constructor(data?: ISetLuoghiServizioRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["luoghiIDs"])) {
                this.luoghiIDs = [] as any;
                for (let item of _data["luoghiIDs"])
                    this.luoghiIDs!.push(item);
            }
            else {
                this.luoghiIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): SetLuoghiServizioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetLuoghiServizioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.luoghiIDs)) {
            data["luoghiIDs"] = [];
            for (let item of this.luoghiIDs)
                data["luoghiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetLuoghiServizioRequest extends IServizioGetRequest {
    /** Elenco degli ID dei luoghi */
    luoghiIDs?: number[];
}

export class SetPartenzeRequest extends ServizioGetRequest implements ISetPartenzeRequest {
    /** Elenco delle partenze da impostare */
    partenze?: IPartenzaBase[];

    constructor(data?: ISetPartenzeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["partenze"])) {
                this.partenze = [] as any;
                for (let item of _data["partenze"])
                    this.partenze!.push(IPartenzaBase.fromJS(item));
            }
            else {
                this.partenze = <any>null;
            }
        }
    }

    static fromJS(data: any): SetPartenzeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetPartenzeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partenze)) {
            data["partenze"] = [];
            for (let item of this.partenze)
                data["partenze"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetPartenzeRequest extends IServizioGetRequest {
    /** Elenco delle partenze da impostare */
    partenze?: IPartenzaBase[];
}

export class UpdateCostiRequest extends ServizioGetRequest implements IUpdateCostiRequest {
    /** Costi da aggiornare */
    costi?: Costo[];
    /** Lista di ID di costi doppi che vanno eliminati */
    doppioniDaEliminareIDs?: number[] | null;

    constructor(data?: IUpdateCostiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["costi"])) {
                this.costi = [] as any;
                for (let item of _data["costi"])
                    this.costi!.push(Costo.fromJS(item));
            }
            else {
                this.costi = <any>null;
            }
            if (Array.isArray(_data["doppioniDaEliminareIDs"])) {
                this.doppioniDaEliminareIDs = [] as any;
                for (let item of _data["doppioniDaEliminareIDs"])
                    this.doppioniDaEliminareIDs!.push(item);
            }
            else {
                this.doppioniDaEliminareIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateCostiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCostiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costi)) {
            data["costi"] = [];
            for (let item of this.costi)
                data["costi"].push(item.toJSON());
        }
        if (Array.isArray(this.doppioniDaEliminareIDs)) {
            data["doppioniDaEliminareIDs"] = [];
            for (let item of this.doppioniDaEliminareIDs)
                data["doppioniDaEliminareIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCostiRequest extends IServizioGetRequest {
    /** Costi da aggiornare */
    costi?: Costo[];
    /** Lista di ID di costi doppi che vanno eliminati */
    doppioniDaEliminareIDs?: number[] | null;
}

export class UpdateDatiCostiRequest extends ServizioGetRequest implements IUpdateDatiCostiRequest {
    /** Lista degli ID dei costi da modificare */
    costiIDs?: number[];
    /** Dati da aggiornare */
    dati?: CostiUpdateData;

    constructor(data?: IUpdateDatiCostiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["costiIDs"])) {
                this.costiIDs = [] as any;
                for (let item of _data["costiIDs"])
                    this.costiIDs!.push(item);
            }
            else {
                this.costiIDs = <any>null;
            }
            this.dati = _data["dati"] ? CostiUpdateData.fromJS(_data["dati"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateDatiCostiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDatiCostiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costiIDs)) {
            data["costiIDs"] = [];
            for (let item of this.costiIDs)
                data["costiIDs"].push(item);
        }
        data["dati"] = this.dati ? this.dati.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDatiCostiRequest extends IServizioGetRequest {
    /** Lista degli ID dei costi da modificare */
    costiIDs?: number[];
    /** Dati da aggiornare */
    dati?: CostiUpdateData;
}

export class CostiUpdateData implements ICostiUpdateData {
    tabellaCostiID?: number | null;
    tipologiaID?: number | null;
    validitaID?: number | null;
    updateRegolaServizio?: boolean;
    regolaServizioID?: number | null;
    updateRegolaVendita?: boolean;
    regolaVenditaID?: number | null;
    updateTrattamento?: boolean;
    trattamentoID?: number | null;
    updateCodicePrenotazione?: boolean;
    codicePrenotazione?: string | null;
    updateRegolaCostiBambino?: boolean;
    regolaCostiBambino?: ERegolaCostiBambino | null;
    updateEtaChild?: boolean;
    etaChild?: number | null;

    constructor(data?: ICostiUpdateData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabellaCostiID = _data["tabellaCostiID"] !== undefined ? _data["tabellaCostiID"] : <any>null;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : <any>null;
            this.validitaID = _data["validitaID"] !== undefined ? _data["validitaID"] : <any>null;
            this.updateRegolaServizio = _data["updateRegolaServizio"] !== undefined ? _data["updateRegolaServizio"] : <any>null;
            this.regolaServizioID = _data["regolaServizioID"] !== undefined ? _data["regolaServizioID"] : <any>null;
            this.updateRegolaVendita = _data["updateRegolaVendita"] !== undefined ? _data["updateRegolaVendita"] : <any>null;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : <any>null;
            this.updateTrattamento = _data["updateTrattamento"] !== undefined ? _data["updateTrattamento"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
            this.updateCodicePrenotazione = _data["updateCodicePrenotazione"] !== undefined ? _data["updateCodicePrenotazione"] : <any>null;
            this.codicePrenotazione = _data["codicePrenotazione"] !== undefined ? _data["codicePrenotazione"] : <any>null;
            this.updateRegolaCostiBambino = _data["updateRegolaCostiBambino"] !== undefined ? _data["updateRegolaCostiBambino"] : <any>null;
            this.regolaCostiBambino = _data["regolaCostiBambino"] !== undefined ? _data["regolaCostiBambino"] : <any>null;
            this.updateEtaChild = _data["updateEtaChild"] !== undefined ? _data["updateEtaChild"] : <any>null;
            this.etaChild = _data["etaChild"] !== undefined ? _data["etaChild"] : <any>null;
        }
    }

    static fromJS(data: any): CostiUpdateData {
        data = typeof data === 'object' ? data : {};
        let result = new CostiUpdateData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabellaCostiID"] = this.tabellaCostiID !== undefined ? this.tabellaCostiID : <any>null;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : <any>null;
        data["validitaID"] = this.validitaID !== undefined ? this.validitaID : <any>null;
        data["updateRegolaServizio"] = this.updateRegolaServizio !== undefined ? this.updateRegolaServizio : <any>null;
        data["regolaServizioID"] = this.regolaServizioID !== undefined ? this.regolaServizioID : <any>null;
        data["updateRegolaVendita"] = this.updateRegolaVendita !== undefined ? this.updateRegolaVendita : <any>null;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : <any>null;
        data["updateTrattamento"] = this.updateTrattamento !== undefined ? this.updateTrattamento : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        data["updateCodicePrenotazione"] = this.updateCodicePrenotazione !== undefined ? this.updateCodicePrenotazione : <any>null;
        data["codicePrenotazione"] = this.codicePrenotazione !== undefined ? this.codicePrenotazione : <any>null;
        data["updateRegolaCostiBambino"] = this.updateRegolaCostiBambino !== undefined ? this.updateRegolaCostiBambino : <any>null;
        data["regolaCostiBambino"] = this.regolaCostiBambino !== undefined ? this.regolaCostiBambino : <any>null;
        data["updateEtaChild"] = this.updateEtaChild !== undefined ? this.updateEtaChild : <any>null;
        data["etaChild"] = this.etaChild !== undefined ? this.etaChild : <any>null;
        return data;
    }
}

export interface ICostiUpdateData {
    tabellaCostiID?: number | null;
    tipologiaID?: number | null;
    validitaID?: number | null;
    updateRegolaServizio?: boolean;
    regolaServizioID?: number | null;
    updateRegolaVendita?: boolean;
    regolaVenditaID?: number | null;
    updateTrattamento?: boolean;
    trattamentoID?: number | null;
    updateCodicePrenotazione?: boolean;
    codicePrenotazione?: string | null;
    updateRegolaCostiBambino?: boolean;
    regolaCostiBambino?: ERegolaCostiBambino | null;
    updateEtaChild?: boolean;
    etaChild?: number | null;
}

export class UpdateMargineRequest extends ServizioGetRequest implements IUpdateMargineRequest {
    /** Costi da aggiornare */
    costi?: Costo[];
    /** Margine da impostare */
    margine?: number;

    constructor(data?: IUpdateMargineRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["costi"])) {
                this.costi = [] as any;
                for (let item of _data["costi"])
                    this.costi!.push(Costo.fromJS(item));
            }
            else {
                this.costi = <any>null;
            }
            this.margine = _data["margine"] !== undefined ? _data["margine"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateMargineRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMargineRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costi)) {
            data["costi"] = [];
            for (let item of this.costi)
                data["costi"].push(item.toJSON());
        }
        data["margine"] = this.margine !== undefined ? this.margine : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMargineRequest extends IServizioGetRequest {
    /** Costi da aggiornare */
    costi?: Costo[];
    /** Margine da impostare */
    margine?: number;
}

export class UpdatePublishingRequest extends ApiRequest implements IUpdatePublishingRequest {
    servizioId?: number;
    siteId?: number;
    status?: EStatoPubblicazioneServizio;

    constructor(data?: IUpdatePublishingRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioId = _data["servizioId"] !== undefined ? _data["servizioId"] : <any>null;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): UpdatePublishingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePublishingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioId"] = this.servizioId !== undefined ? this.servizioId : <any>null;
        data["siteId"] = this.siteId !== undefined ? this.siteId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePublishingRequest extends IApiRequest {
    servizioId?: number;
    siteId?: number;
    status?: EStatoPubblicazioneServizio;
}

export class ServizioUpsertRequest extends ServizioGetRequest implements IServizioUpsertRequest {
    servizio?: Servizio | null;

    constructor(data?: IServizioUpsertRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? Servizio.fromJS(_data["servizio"]) : <any>null;
        }
    }

    static fromJS(data: any): ServizioUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IServizioUpsertRequest extends IServizioGetRequest {
    servizio?: Servizio | null;
}

export class UpsertAssociazioneResponse extends GetAssociazioniResponse implements IUpsertAssociazioneResponse {
    associazione?: ServizioAssociazione;
    offerta?: OffertaComponibile | null;

    constructor(data?: IUpsertAssociazioneResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.associazione = _data["associazione"] ? ServizioAssociazione.fromJS(_data["associazione"]) : <any>null;
            this.offerta = _data["offerta"] ? OffertaComponibile.fromJS(_data["offerta"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertAssociazioneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssociazioneResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["associazione"] = this.associazione ? this.associazione.toJSON() : <any>null;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertAssociazioneResponse extends IGetAssociazioniResponse {
    associazione?: ServizioAssociazione;
    offerta?: OffertaComponibile | null;
}

export class UpsertAssociazioneRequest extends ServizioGetRequest implements IUpsertAssociazioneRequest {
    /** Entità dell'associazione */
    associazione!: ServizioAssociazione;
    /** Entità dell'offerta componibile. Compilare se l'associazione è di tipo Offerta */
    offerta?: OffertaComponibile | null;
    /** Lista delle configurazioni delle precondizioni di un'offerta componibile */
    configurazionePrecondizioni?: ConfigValue[] | null;
    /** Configurazione dell'eventuale algorirmo dell'offerta componibile */
    configurazioneAlgoritmo?: ConfigValue | null;

    constructor(data?: IUpsertAssociazioneRequest) {
        super(data);
        if (!data) {
            this.associazione = new ServizioAssociazione();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.associazione = _data["associazione"] ? ServizioAssociazione.fromJS(_data["associazione"]) : new ServizioAssociazione();
            this.offerta = _data["offerta"] ? OffertaComponibile.fromJS(_data["offerta"]) : <any>null;
            if (Array.isArray(_data["configurazionePrecondizioni"])) {
                this.configurazionePrecondizioni = [] as any;
                for (let item of _data["configurazionePrecondizioni"])
                    this.configurazionePrecondizioni!.push(ConfigValue.fromJS(item));
            }
            else {
                this.configurazionePrecondizioni = <any>null;
            }
            this.configurazioneAlgoritmo = _data["configurazioneAlgoritmo"] ? ConfigValue.fromJS(_data["configurazioneAlgoritmo"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertAssociazioneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAssociazioneRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["associazione"] = this.associazione ? this.associazione.toJSON() : <any>null;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        if (Array.isArray(this.configurazionePrecondizioni)) {
            data["configurazionePrecondizioni"] = [];
            for (let item of this.configurazionePrecondizioni)
                data["configurazionePrecondizioni"].push(item.toJSON());
        }
        data["configurazioneAlgoritmo"] = this.configurazioneAlgoritmo ? this.configurazioneAlgoritmo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertAssociazioneRequest extends IServizioGetRequest {
    /** Entità dell'associazione */
    associazione: ServizioAssociazione;
    /** Entità dell'offerta componibile. Compilare se l'associazione è di tipo Offerta */
    offerta?: OffertaComponibile | null;
    /** Lista delle configurazioni delle precondizioni di un'offerta componibile */
    configurazionePrecondizioni?: ConfigValue[] | null;
    /** Configurazione dell'eventuale algorirmo dell'offerta componibile */
    configurazioneAlgoritmo?: ConfigValue | null;
}

export class ConfigValue implements IConfigValue {
    codice?: string;
    configurazione?: any;

    constructor(data?: IConfigValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.configurazione = _data["configurazione"] !== undefined ? _data["configurazione"] : <any>null;
        }
    }

    static fromJS(data: any): ConfigValue {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["configurazione"] = this.configurazione !== undefined ? this.configurazione : <any>null;
        return data;
    }
}

export interface IConfigValue {
    codice?: string;
    configurazione?: any;
}

export class UpsertDynamicPackageRulesResponse extends GetDynamicPackageRulesResponse implements IUpsertDynamicPackageRulesResponse {
    regola?: ServizioRegolaScontoPacchetto | null;

    constructor(data?: IUpsertDynamicPackageRulesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] ? ServizioRegolaScontoPacchetto.fromJS(_data["regola"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertDynamicPackageRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertDynamicPackageRulesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola ? this.regola.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertDynamicPackageRulesResponse extends IGetDynamicPackageRulesResponse {
    regola?: ServizioRegolaScontoPacchetto | null;
}

export class UpsertDynamicPackageRulesRequest extends GetDynamicPackageRulesRequest implements IUpsertDynamicPackageRulesRequest {
    regola?: ServizioRegolaScontoPacchetto | null;

    constructor(data?: IUpsertDynamicPackageRulesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] ? ServizioRegolaScontoPacchetto.fromJS(_data["regola"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertDynamicPackageRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertDynamicPackageRulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola ? this.regola.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertDynamicPackageRulesRequest extends IGetDynamicPackageRulesRequest {
    regola?: ServizioRegolaScontoPacchetto | null;
}

export class UpsertItinerarioResponse extends GetItinerariResponse implements IUpsertItinerarioResponse {
    itinerario?: ServizioItinerario | null;

    constructor(data?: IUpsertItinerarioResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.itinerario = _data["itinerario"] ? ServizioItinerario.fromJS(_data["itinerario"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertItinerarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertItinerarioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertItinerarioResponse extends IGetItinerariResponse {
    itinerario?: ServizioItinerario | null;
}

export class UpsertItinerarioRequest extends ServizioGetRequest implements IUpsertItinerarioRequest {
    itinerario?: ServizioItinerario | null;
    tappe?: ItinerioGiornoServizi[] | null;

    constructor(data?: IUpsertItinerarioRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.itinerario = _data["itinerario"] ? ServizioItinerario.fromJS(_data["itinerario"]) : <any>null;
            if (Array.isArray(_data["tappe"])) {
                this.tappe = [] as any;
                for (let item of _data["tappe"])
                    this.tappe!.push(ItinerioGiornoServizi.fromJS(item));
            }
            else {
                this.tappe = <any>null;
            }
        }
    }

    static fromJS(data: any): UpsertItinerarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertItinerarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : <any>null;
        if (Array.isArray(this.tappe)) {
            data["tappe"] = [];
            for (let item of this.tappe)
                data["tappe"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertItinerarioRequest extends IServizioGetRequest {
    itinerario?: ServizioItinerario | null;
    tappe?: ItinerioGiornoServizi[] | null;
}

export class ItinerioGiornoServizi implements IItinerioGiornoServizi {
    giorno?: ServizioItinerarioGiorno | null;
    servizi?: ServizioItinerarioGiornoServizio[] | null;

    constructor(data?: IItinerioGiornoServizi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorno = _data["giorno"] ? ServizioItinerarioGiorno.fromJS(_data["giorno"]) : <any>null;
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(ServizioItinerarioGiornoServizio.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
        }
    }

    static fromJS(data: any): ItinerioGiornoServizi {
        data = typeof data === 'object' ? data : {};
        let result = new ItinerioGiornoServizi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorno"] = this.giorno ? this.giorno.toJSON() : <any>null;
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        return data;
    }
}

export interface IItinerioGiornoServizi {
    giorno?: ServizioItinerarioGiorno | null;
    servizi?: ServizioItinerarioGiornoServizio[] | null;
}

export class UpsertRegolaServizioResponse extends GetRegoleServizioResponse implements IUpsertRegolaServizioResponse {
    regola?: ServizioRegola | null;

    constructor(data?: IUpsertRegolaServizioResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] ? ServizioRegola.fromJS(_data["regola"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertRegolaServizioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRegolaServizioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola ? this.regola.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertRegolaServizioResponse extends IGetRegoleServizioResponse {
    regola?: ServizioRegola | null;
}

export class UpsertRegolaServizioRequest extends ServizioGetRequest implements IUpsertRegolaServizioRequest {
    regola?: ServizioRegola | null;

    constructor(data?: IUpsertRegolaServizioRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] ? ServizioRegola.fromJS(_data["regola"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertRegolaServizioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRegolaServizioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola ? this.regola.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertRegolaServizioRequest extends IServizioGetRequest {
    regola?: ServizioRegola | null;
}

export class UpsertRegolaVenditaResponse extends GetRegoleVenditaResponse implements IUpsertRegolaVenditaResponse {
    regola?: ServizioRegolaVendita | null;

    constructor(data?: IUpsertRegolaVenditaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] ? ServizioRegolaVendita.fromJS(_data["regola"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertRegolaVenditaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRegolaVenditaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola ? this.regola.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertRegolaVenditaResponse extends IGetRegoleVenditaResponse {
    regola?: ServizioRegolaVendita | null;
}

export class UpsertRegolaVenditaRequest extends ServizioGetRequest implements IUpsertRegolaVenditaRequest {
    regola?: IServizioRegolaVendita | null;

    constructor(data?: IUpsertRegolaVenditaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regola = _data["regola"] ? IServizioRegolaVendita.fromJS(_data["regola"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertRegolaVenditaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRegolaVenditaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regola"] = this.regola ? this.regola.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertRegolaVenditaRequest extends IServizioGetRequest {
    regola?: IServizioRegolaVendita | null;
}

export abstract class IServizioRegolaVendita implements IIServizioRegolaVendita {
    id?: number;
    servizioID?: number;
    nome?: string | null;
    numeroGiorni?: number | null;
    minimoGiorni?: number | null;
    massimoGiorni?: number | null;
    etaMinima?: number | null;
    etaMassima?: number | null;
    dal?: string | null;
    al?: string | null;
    commissioniAgenzia?: number | null;
    commissioniTourOperator?: number | null;
    minimoNottiPeriodo?: number | null;
    giorniEntrata?: string | null;
    giorniUscita?: string | null;
    prenotaEntroData?: string | null;
    prenotaEntroGiorni?: number | null;
    deregolamentaSuRichiesta?: boolean | null;
    penaleID?: number | null;
    giorniPenale?: number | null;
    percentualePenale?: number | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    articoloID?: number | null;

    constructor(data?: IIServizioRegolaVendita) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.numeroGiorni = _data["numeroGiorni"] !== undefined ? _data["numeroGiorni"] : <any>null;
            this.minimoGiorni = _data["minimoGiorni"] !== undefined ? _data["minimoGiorni"] : <any>null;
            this.massimoGiorni = _data["massimoGiorni"] !== undefined ? _data["massimoGiorni"] : <any>null;
            this.etaMinima = _data["etaMinima"] !== undefined ? _data["etaMinima"] : <any>null;
            this.etaMassima = _data["etaMassima"] !== undefined ? _data["etaMassima"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.commissioniAgenzia = _data["commissioniAgenzia"] !== undefined ? _data["commissioniAgenzia"] : <any>null;
            this.commissioniTourOperator = _data["commissioniTourOperator"] !== undefined ? _data["commissioniTourOperator"] : <any>null;
            this.minimoNottiPeriodo = _data["minimoNottiPeriodo"] !== undefined ? _data["minimoNottiPeriodo"] : <any>null;
            this.giorniEntrata = _data["giorniEntrata"] !== undefined ? _data["giorniEntrata"] : <any>null;
            this.giorniUscita = _data["giorniUscita"] !== undefined ? _data["giorniUscita"] : <any>null;
            this.prenotaEntroData = _data["prenotaEntroData"] !== undefined ? _data["prenotaEntroData"] : <any>null;
            this.prenotaEntroGiorni = _data["prenotaEntroGiorni"] !== undefined ? _data["prenotaEntroGiorni"] : <any>null;
            this.deregolamentaSuRichiesta = _data["deregolamentaSuRichiesta"] !== undefined ? _data["deregolamentaSuRichiesta"] : <any>null;
            this.penaleID = _data["penaleID"] !== undefined ? _data["penaleID"] : <any>null;
            this.giorniPenale = _data["giorniPenale"] !== undefined ? _data["giorniPenale"] : <any>null;
            this.percentualePenale = _data["percentualePenale"] !== undefined ? _data["percentualePenale"] : <any>null;
            this.nome_fr = _data["nome_fr"] !== undefined ? _data["nome_fr"] : <any>null;
            this.nome_de = _data["nome_de"] !== undefined ? _data["nome_de"] : <any>null;
            this.nome_es = _data["nome_es"] !== undefined ? _data["nome_es"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
        }
    }

    static fromJS(data: any): IServizioRegolaVendita {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IServizioRegolaVendita' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["numeroGiorni"] = this.numeroGiorni !== undefined ? this.numeroGiorni : <any>null;
        data["minimoGiorni"] = this.minimoGiorni !== undefined ? this.minimoGiorni : <any>null;
        data["massimoGiorni"] = this.massimoGiorni !== undefined ? this.massimoGiorni : <any>null;
        data["etaMinima"] = this.etaMinima !== undefined ? this.etaMinima : <any>null;
        data["etaMassima"] = this.etaMassima !== undefined ? this.etaMassima : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["commissioniAgenzia"] = this.commissioniAgenzia !== undefined ? this.commissioniAgenzia : <any>null;
        data["commissioniTourOperator"] = this.commissioniTourOperator !== undefined ? this.commissioniTourOperator : <any>null;
        data["minimoNottiPeriodo"] = this.minimoNottiPeriodo !== undefined ? this.minimoNottiPeriodo : <any>null;
        data["giorniEntrata"] = this.giorniEntrata !== undefined ? this.giorniEntrata : <any>null;
        data["giorniUscita"] = this.giorniUscita !== undefined ? this.giorniUscita : <any>null;
        data["prenotaEntroData"] = this.prenotaEntroData !== undefined ? this.prenotaEntroData : <any>null;
        data["prenotaEntroGiorni"] = this.prenotaEntroGiorni !== undefined ? this.prenotaEntroGiorni : <any>null;
        data["deregolamentaSuRichiesta"] = this.deregolamentaSuRichiesta !== undefined ? this.deregolamentaSuRichiesta : <any>null;
        data["penaleID"] = this.penaleID !== undefined ? this.penaleID : <any>null;
        data["giorniPenale"] = this.giorniPenale !== undefined ? this.giorniPenale : <any>null;
        data["percentualePenale"] = this.percentualePenale !== undefined ? this.percentualePenale : <any>null;
        data["nome_fr"] = this.nome_fr !== undefined ? this.nome_fr : <any>null;
        data["nome_de"] = this.nome_de !== undefined ? this.nome_de : <any>null;
        data["nome_es"] = this.nome_es !== undefined ? this.nome_es : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        return data;
    }
}

export interface IIServizioRegolaVendita {
    id?: number;
    servizioID?: number;
    nome?: string | null;
    numeroGiorni?: number | null;
    minimoGiorni?: number | null;
    massimoGiorni?: number | null;
    etaMinima?: number | null;
    etaMassima?: number | null;
    dal?: string | null;
    al?: string | null;
    commissioniAgenzia?: number | null;
    commissioniTourOperator?: number | null;
    minimoNottiPeriodo?: number | null;
    giorniEntrata?: string | null;
    giorniUscita?: string | null;
    prenotaEntroData?: string | null;
    prenotaEntroGiorni?: number | null;
    deregolamentaSuRichiesta?: boolean | null;
    penaleID?: number | null;
    giorniPenale?: number | null;
    percentualePenale?: number | null;
    nome_fr?: string | null;
    nome_de?: string | null;
    nome_es?: string | null;
    nome_en?: string | null;
    articoloID?: number | null;
}

export class UpsertTipologiaResponse extends GetTipologieResponse implements IUpsertTipologiaResponse {
    tipologia?: ServizioTipologia | null;
    nome?: string | null;

    constructor(data?: IUpsertTipologiaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
        }
    }

    static fromJS(data: any): UpsertTipologiaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertTipologiaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertTipologiaResponse extends IGetTipologieResponse {
    tipologia?: ServizioTipologia | null;
    nome?: string | null;
}

export class UpsertTiplogiaRequest extends GetTipologieRequest implements IUpsertTiplogiaRequest {
    tipologia?: ServizioTipologia | null;

    constructor(data?: IUpsertTiplogiaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertTiplogiaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertTiplogiaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertTiplogiaRequest extends IGetTipologieRequest {
    tipologia?: ServizioTipologia | null;
}

export class UpsertValiditaResponse extends GetValiditaResponse implements IUpsertValiditaResponse {
    validitaEdit?: Validita | null;

    constructor(data?: IUpsertValiditaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validitaEdit = _data["validitaEdit"] ? Validita.fromJS(_data["validitaEdit"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertValiditaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertValiditaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validitaEdit"] = this.validitaEdit ? this.validitaEdit.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertValiditaResponse extends IGetValiditaResponse {
    validitaEdit?: Validita | null;
}

export class UpsertValiditaRequest extends ServizioGetRequest implements IUpsertValiditaRequest {
    validita?: Validita | null;

    constructor(data?: IUpsertValiditaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validita = _data["validita"] ? Validita.fromJS(_data["validita"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertValiditaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertValiditaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validita"] = this.validita ? this.validita.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertValiditaRequest extends IServizioGetRequest {
    validita?: Validita | null;
}

export class ChangeMacroTypeRequest extends LocalizedRequest implements IChangeMacroTypeRequest {
    servizioHHID?: number;
    tipologiaHHID?: number;
    newMacroTypeID?: number;

    constructor(data?: IChangeMacroTypeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHID = _data["servizioHHID"] !== undefined ? _data["servizioHHID"] : <any>null;
            this.tipologiaHHID = _data["tipologiaHHID"] !== undefined ? _data["tipologiaHHID"] : <any>null;
            this.newMacroTypeID = _data["newMacroTypeID"] !== undefined ? _data["newMacroTypeID"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeMacroTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMacroTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHID"] = this.servizioHHID !== undefined ? this.servizioHHID : <any>null;
        data["tipologiaHHID"] = this.tipologiaHHID !== undefined ? this.tipologiaHHID : <any>null;
        data["newMacroTypeID"] = this.newMacroTypeID !== undefined ? this.newMacroTypeID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IChangeMacroTypeRequest extends ILocalizedRequest {
    servizioHHID?: number;
    tipologiaHHID?: number;
    newMacroTypeID?: number;
}

export class ConfirmAutomatchServizioH2HRequest extends ApiRequest implements IConfirmAutomatchServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IConfirmAutomatchServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
        }
    }

    static fromJS(data: any): ConfirmAutomatchServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAutomatchServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmAutomatchServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class ConfirmAutomatchServizioH2HMultiRequest extends ApiRequest implements IConfirmAutomatchServizioH2HMultiRequest {
    servizioHHIds?: number[] | null;

    constructor(data?: IConfirmAutomatchServizioH2HMultiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["servizioHHIds"])) {
                this.servizioHHIds = [] as any;
                for (let item of _data["servizioHHIds"])
                    this.servizioHHIds!.push(item);
            }
            else {
                this.servizioHHIds = <any>null;
            }
        }
    }

    static fromJS(data: any): ConfirmAutomatchServizioH2HMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAutomatchServizioH2HMultiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servizioHHIds)) {
            data["servizioHHIds"] = [];
            for (let item of this.servizioHHIds)
                data["servizioHHIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmAutomatchServizioH2HMultiRequest extends IApiRequest {
    servizioHHIds?: number[] | null;
}

export class ConfirmMappingServizioH2HRequest extends ApiRequest implements IConfirmMappingServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IConfirmMappingServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
        }
    }

    static fromJS(data: any): ConfirmMappingServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmMappingServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmMappingServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class ConfirmTypeMappingResponse extends OkApiResponse implements IConfirmTypeMappingResponse {
    codice?: HHCodice | null;

    constructor(data?: IConfirmTypeMappingResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] ? HHCodice.fromJS(_data["codice"]) : <any>null;
        }
    }

    static fromJS(data: any): ConfirmTypeMappingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmTypeMappingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice ? this.codice.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmTypeMappingResponse extends IOkApiResponse {
    codice?: HHCodice | null;
}

export class ConfirmTypeMappingRequest extends ApiRequest implements IConfirmTypeMappingRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;

    constructor(data?: IConfirmTypeMappingRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
            this.tipologiaHHID = _data["tipologiaHHID"] !== undefined ? _data["tipologiaHHID"] : <any>null;
        }
    }

    static fromJS(data: any): ConfirmTypeMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmTypeMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        data["tipologiaHHID"] = this.tipologiaHHID !== undefined ? this.tipologiaHHID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmTypeMappingRequest extends IApiRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;
}

export class CreateServizioH2HResponse extends OkApiResponse implements ICreateServizioH2HResponse {
    servizio?: HHServizioAggregato | null;
    luogo?: string | null;

    constructor(data?: ICreateServizioH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizioAggregato.fromJS(_data["servizio"]) : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
        }
    }

    static fromJS(data: any): CreateServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServizioH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizioAggregato | null;
    luogo?: string | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class CreateServizioH2HRequest extends ApiRequest implements ICreateServizioH2HRequest {
    servizioHH?: HHServizioAggregato | null;
    createNaarService?: boolean;
    servizioNaar?: CreateServizioNaarRequest | null;
    mappa?: CreateMappaRequest | null;

    constructor(data?: ICreateServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHH = _data["servizioHH"] ? HHServizioAggregato.fromJS(_data["servizioHH"]) : <any>null;
            this.createNaarService = _data["createNaarService"] !== undefined ? _data["createNaarService"] : <any>null;
            this.servizioNaar = _data["servizioNaar"] ? CreateServizioNaarRequest.fromJS(_data["servizioNaar"]) : <any>null;
            this.mappa = _data["mappa"] ? CreateMappaRequest.fromJS(_data["mappa"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHH"] = this.servizioHH ? this.servizioHH.toJSON() : <any>null;
        data["createNaarService"] = this.createNaarService !== undefined ? this.createNaarService : <any>null;
        data["servizioNaar"] = this.servizioNaar ? this.servizioNaar.toJSON() : <any>null;
        data["mappa"] = this.mappa ? this.mappa.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface ICreateServizioH2HRequest extends IApiRequest {
    servizioHH?: HHServizioAggregato | null;
    createNaarService?: boolean;
    servizioNaar?: CreateServizioNaarRequest | null;
    mappa?: CreateMappaRequest | null;
}

export class CreateServizioNaarRequest implements ICreateServizioNaarRequest {
    ordine?: number | null;
    preferito?: boolean;
    pubblicazione?: EStatoPubblicazioneServizio | null;
    status?: EStatoUtilizzoServizio | null;
    attributiIDs?: number[] | null;

    constructor(data?: ICreateServizioNaarRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.preferito = _data["preferito"] !== undefined ? _data["preferito"] : <any>null;
            this.pubblicazione = _data["pubblicazione"] !== undefined ? _data["pubblicazione"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["attributiIDs"])) {
                this.attributiIDs = [] as any;
                for (let item of _data["attributiIDs"])
                    this.attributiIDs!.push(item);
            }
            else {
                this.attributiIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateServizioNaarRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServizioNaarRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["preferito"] = this.preferito !== undefined ? this.preferito : <any>null;
        data["pubblicazione"] = this.pubblicazione !== undefined ? this.pubblicazione : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.attributiIDs)) {
            data["attributiIDs"] = [];
            for (let item of this.attributiIDs)
                data["attributiIDs"].push(item);
        }
        return data;
    }
}

export interface ICreateServizioNaarRequest {
    ordine?: number | null;
    preferito?: boolean;
    pubblicazione?: EStatoPubblicazioneServizio | null;
    status?: EStatoUtilizzoServizio | null;
    attributiIDs?: number[] | null;
}

export class CreateMappaRequest implements ICreateMappaRequest {
    latitude?: number | null;
    longitude?: number | null;
    zoom?: number | null;

    constructor(data?: ICreateMappaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : <any>null;
        }
    }

    static fromJS(data: any): CreateMappaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMappaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["zoom"] = this.zoom !== undefined ? this.zoom : <any>null;
        return data;
    }
}

export interface ICreateMappaRequest {
    latitude?: number | null;
    longitude?: number | null;
    zoom?: number | null;
}

export class CreateServiceResponse extends OkApiResponse implements ICreateServiceResponse {
    servizio?: Servizio | null;

    constructor(data?: ICreateServiceResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? Servizio.fromJS(_data["servizio"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateServiceResponse extends IOkApiResponse {
    servizio?: Servizio | null;
}

export class CreateServiceRequest extends ApiRequest implements ICreateServiceRequest {
    nome!: string;
    nomeInglese?: string | null;
    luogoID!: number;
    giataID?: number | null;
    ordine?: number | null;
    preferito?: boolean;
    pubblicazione?: EStatoPubblicazioneServizio | null;
    status?: EStatoUtilizzoServizio | null;
    cap?: string | null;
    indirizzo?: string | null;
    telefono?: string | null;
    latitudine?: number | null;
    longitudine?: number | null;
    zoom?: number | null;
    attributiIDs?: number[] | null;

    constructor(data?: ICreateServiceRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : <any>null;
            this.ordine = _data["ordine"] !== undefined ? _data["ordine"] : <any>null;
            this.preferito = _data["preferito"] !== undefined ? _data["preferito"] : <any>null;
            this.pubblicazione = _data["pubblicazione"] !== undefined ? _data["pubblicazione"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.indirizzo = _data["indirizzo"] !== undefined ? _data["indirizzo"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.latitudine = _data["latitudine"] !== undefined ? _data["latitudine"] : <any>null;
            this.longitudine = _data["longitudine"] !== undefined ? _data["longitudine"] : <any>null;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : <any>null;
            if (Array.isArray(_data["attributiIDs"])) {
                this.attributiIDs = [] as any;
                for (let item of _data["attributiIDs"])
                    this.attributiIDs!.push(item);
            }
            else {
                this.attributiIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateServiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["giataID"] = this.giataID !== undefined ? this.giataID : <any>null;
        data["ordine"] = this.ordine !== undefined ? this.ordine : <any>null;
        data["preferito"] = this.preferito !== undefined ? this.preferito : <any>null;
        data["pubblicazione"] = this.pubblicazione !== undefined ? this.pubblicazione : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["indirizzo"] = this.indirizzo !== undefined ? this.indirizzo : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["latitudine"] = this.latitudine !== undefined ? this.latitudine : <any>null;
        data["longitudine"] = this.longitudine !== undefined ? this.longitudine : <any>null;
        data["zoom"] = this.zoom !== undefined ? this.zoom : <any>null;
        if (Array.isArray(this.attributiIDs)) {
            data["attributiIDs"] = [];
            for (let item of this.attributiIDs)
                data["attributiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateServiceRequest extends IApiRequest {
    nome: string;
    nomeInglese?: string | null;
    luogoID: number;
    giataID?: number | null;
    ordine?: number | null;
    preferito?: boolean;
    pubblicazione?: EStatoPubblicazioneServizio | null;
    status?: EStatoUtilizzoServizio | null;
    cap?: string | null;
    indirizzo?: string | null;
    telefono?: string | null;
    latitudine?: number | null;
    longitudine?: number | null;
    zoom?: number | null;
    attributiIDs?: number[] | null;
}

export class DeleteServizioH2HRequest extends ApiRequest implements IDeleteServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IDeleteServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class DeleteServizioAggregatoH2HRequest extends ApiRequest implements IDeleteServizioAggregatoH2HRequest {
    servizioAggregatoHHId?: number;

    constructor(data?: IDeleteServizioAggregatoH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAggregatoHHId = _data["servizioAggregatoHHId"] !== undefined ? _data["servizioAggregatoHHId"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteServizioAggregatoH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteServizioAggregatoH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAggregatoHHId"] = this.servizioAggregatoHHId !== undefined ? this.servizioAggregatoHHId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteServizioAggregatoH2HRequest extends IApiRequest {
    servizioAggregatoHHId?: number;
}

export class DeleteMapH2HRequest extends ApiRequest implements IDeleteMapH2HRequest {
    servizioHHId?: number;

    constructor(data?: IDeleteMapH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteMapH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMapH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMapH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class DisableServizioH2HResponse extends OkApiResponse implements IDisableServizioH2HResponse {
    servizio?: HHServizioAggregato | null;

    constructor(data?: IDisableServizioH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizioAggregato.fromJS(_data["servizio"]) : <any>null;
        }
    }

    static fromJS(data: any): DisableServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisableServizioH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDisableServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizioAggregato | null;
}

export class DisableServizioH2HRequest extends ApiRequest implements IDisableServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IDisableServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
        }
    }

    static fromJS(data: any): DisableServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisableServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDisableServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class DisableDescriptionH2HResponse extends OkApiResponse implements IDisableDescriptionH2HResponse {
    description?: HHDescrizione | null;

    constructor(data?: IDisableDescriptionH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"] ? HHDescrizione.fromJS(_data["description"]) : <any>null;
        }
    }

    static fromJS(data: any): DisableDescriptionH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisableDescriptionH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDisableDescriptionH2HResponse extends IOkApiResponse {
    description?: HHDescrizione | null;
}

export class HHDescrizione implements IHHDescrizione {
    id?: number;
    servizioAggregatoID?: number;
    fornitore?: EFornitore;
    sourceRef?: string | null;
    lingua?: ELingua;
    title?: string | null;
    text!: string;
    html?: boolean;
    sortOrder?: number;
    disabled?: boolean;
    createdAt?: string;
    updatedAt?: string;
    translated?: boolean;

    constructor(data?: IHHDescrizione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : <any>null;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            this.sourceRef = _data["sourceRef"] !== undefined ? _data["sourceRef"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.html = _data["html"] !== undefined ? _data["html"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
            this.translated = _data["translated"] !== undefined ? _data["translated"] : <any>null;
        }
    }

    static fromJS(data: any): HHDescrizione {
        data = typeof data === 'object' ? data : {};
        let result = new HHDescrizione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : <any>null;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        data["sourceRef"] = this.sourceRef !== undefined ? this.sourceRef : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["html"] = this.html !== undefined ? this.html : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        data["translated"] = this.translated !== undefined ? this.translated : <any>null;
        return data;
    }
}

export interface IHHDescrizione {
    id?: number;
    servizioAggregatoID?: number;
    fornitore?: EFornitore;
    sourceRef?: string | null;
    lingua?: ELingua;
    title?: string | null;
    text: string;
    html?: boolean;
    sortOrder?: number;
    disabled?: boolean;
    createdAt?: string;
    updatedAt?: string;
    translated?: boolean;
}

export class DisableDescriptionH2HRequest extends ApiRequest implements IDisableDescriptionH2HRequest {
    descriptionH2HId?: number;

    constructor(data?: IDisableDescriptionH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descriptionH2HId = _data["descriptionH2HId"] !== undefined ? _data["descriptionH2HId"] : <any>null;
        }
    }

    static fromJS(data: any): DisableDescriptionH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisableDescriptionH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descriptionH2HId"] = this.descriptionH2HId !== undefined ? this.descriptionH2HId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDisableDescriptionH2HRequest extends IApiRequest {
    descriptionH2HId?: number;
}

export class DisableImageH2HResponse extends OkApiResponse implements IDisableImageH2HResponse {
    image?: HHImmagine | null;

    constructor(data?: IDisableImageH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? HHImmagine.fromJS(_data["image"]) : <any>null;
        }
    }

    static fromJS(data: any): DisableImageH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisableImageH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDisableImageH2HResponse extends IOkApiResponse {
    image?: HHImmagine | null;
}

export class HHImmagine implements IHHImmagine {
    id?: number;
    servizioAggregatoID?: number;
    fornitore?: EFornitore;
    sourceRef?: string | null;
    imageUrl!: string;
    thumbUrl?: string | null;
    sortOrder?: number;
    disabled?: boolean;
    createdAt?: string;
    updatedAt?: string;
    ordineNaar?: number | null;

    constructor(data?: IHHImmagine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : <any>null;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            this.sourceRef = _data["sourceRef"] !== undefined ? _data["sourceRef"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            this.thumbUrl = _data["thumbUrl"] !== undefined ? _data["thumbUrl"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
            this.ordineNaar = _data["ordineNaar"] !== undefined ? _data["ordineNaar"] : <any>null;
        }
    }

    static fromJS(data: any): HHImmagine {
        data = typeof data === 'object' ? data : {};
        let result = new HHImmagine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : <any>null;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        data["sourceRef"] = this.sourceRef !== undefined ? this.sourceRef : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        data["thumbUrl"] = this.thumbUrl !== undefined ? this.thumbUrl : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        data["ordineNaar"] = this.ordineNaar !== undefined ? this.ordineNaar : <any>null;
        return data;
    }
}

export interface IHHImmagine {
    id?: number;
    servizioAggregatoID?: number;
    fornitore?: EFornitore;
    sourceRef?: string | null;
    imageUrl: string;
    thumbUrl?: string | null;
    sortOrder?: number;
    disabled?: boolean;
    createdAt?: string;
    updatedAt?: string;
    ordineNaar?: number | null;
}

export class DisableImageH2HRequest extends ApiRequest implements IDisableImageH2HRequest {
    imageH2HId?: number;

    constructor(data?: IDisableImageH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageH2HId = _data["imageH2HId"] !== undefined ? _data["imageH2HId"] : <any>null;
        }
    }

    static fromJS(data: any): DisableImageH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisableImageH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageH2HId"] = this.imageH2HId !== undefined ? this.imageH2HId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDisableImageH2HRequest extends IApiRequest {
    imageH2HId?: number;
}

export class EnableServizioH2HResponse extends OkApiResponse implements IEnableServizioH2HResponse {
    servizio?: HHServizioAggregato | null;

    constructor(data?: IEnableServizioH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizioAggregato.fromJS(_data["servizio"]) : <any>null;
        }
    }

    static fromJS(data: any): EnableServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnableServizioH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEnableServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizioAggregato | null;
}

export class EnableServizioH2HRequest extends ApiRequest implements IEnableServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IEnableServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
        }
    }

    static fromJS(data: any): EnableServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnableServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEnableServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class EnableDescriptionH2HResponse extends OkApiResponse implements IEnableDescriptionH2HResponse {
    description?: HHDescrizione | null;

    constructor(data?: IEnableDescriptionH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"] ? HHDescrizione.fromJS(_data["description"]) : <any>null;
        }
    }

    static fromJS(data: any): EnableDescriptionH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnableDescriptionH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEnableDescriptionH2HResponse extends IOkApiResponse {
    description?: HHDescrizione | null;
}

export class EnableDescriptionH2HRequest extends ApiRequest implements IEnableDescriptionH2HRequest {
    descriptionH2HId?: number;

    constructor(data?: IEnableDescriptionH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descriptionH2HId = _data["descriptionH2HId"] !== undefined ? _data["descriptionH2HId"] : <any>null;
        }
    }

    static fromJS(data: any): EnableDescriptionH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnableDescriptionH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descriptionH2HId"] = this.descriptionH2HId !== undefined ? this.descriptionH2HId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEnableDescriptionH2HRequest extends IApiRequest {
    descriptionH2HId?: number;
}

export class EnableImageH2HResponse extends OkApiResponse implements IEnableImageH2HResponse {
    image?: HHImmagine | null;

    constructor(data?: IEnableImageH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? HHImmagine.fromJS(_data["image"]) : <any>null;
        }
    }

    static fromJS(data: any): EnableImageH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnableImageH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEnableImageH2HResponse extends IOkApiResponse {
    image?: HHImmagine | null;
}

export class EnableImageH2HRequest extends ApiRequest implements IEnableImageH2HRequest {
    imageH2HId?: number;

    constructor(data?: IEnableImageH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageH2HId = _data["imageH2HId"] !== undefined ? _data["imageH2HId"] : <any>null;
        }
    }

    static fromJS(data: any): EnableImageH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnableImageH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageH2HId"] = this.imageH2HId !== undefined ? this.imageH2HId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEnableImageH2HRequest extends IApiRequest {
    imageH2HId?: number;
}

export class GetServizioFornitoreResponse extends OkApiResponse implements IGetServizioFornitoreResponse {
    servizioFornitore?: SVCRow | null;

    constructor(data?: IGetServizioFornitoreResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioFornitore = _data["servizioFornitore"] ? SVCRow.fromJS(_data["servizioFornitore"]) : <any>null;
        }
    }

    static fromJS(data: any): GetServizioFornitoreResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServizioFornitoreResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioFornitore"] = this.servizioFornitore ? this.servizioFornitore.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServizioFornitoreResponse extends IOkApiResponse {
    servizioFornitore?: SVCRow | null;
}

export class SVCRow implements ISVCRow {
    id?: number;
    giataID?: number | null;
    codiceRicercaGiata?: string | null;
    codiceGiataFornitore?: string | null;
    luogoNaar?: string | null;
    luogoNaarID?: number | null;
    luogoFornitore?: string | null;
    codiceLuogoFornitore?: string | null;
    fornitore?: string | null;
    codiceFornitore?: string | null;
    nomeServizioFornitore?: string | null;
    servizioNaarID?: number | null;
    servizioAggregatoID?: number | null;
    haServizioAggregato?: boolean;
    svcAggregatoMappato?: boolean;
    aggregatoDaConfermare?: boolean;
    indirizzoAggregato?: string | null;
    servizioNaar?: string | null;
    rating?: number | null;
    daConfermare?: boolean;
    indirizzoFornitore?: string | null;
    lat?: number | null;
    lon?: number | null;
    indirizzoNaar?: string | null;
    ultimoAggiornamento?: string | null;
    servizio?: HHServizio | null;
    deleted?: boolean;
    agreementId?: number | null;

    constructor(data?: ISVCRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : <any>null;
            this.codiceRicercaGiata = _data["codiceRicercaGiata"] !== undefined ? _data["codiceRicercaGiata"] : <any>null;
            this.codiceGiataFornitore = _data["codiceGiataFornitore"] !== undefined ? _data["codiceGiataFornitore"] : <any>null;
            this.luogoNaar = _data["luogoNaar"] !== undefined ? _data["luogoNaar"] : <any>null;
            this.luogoNaarID = _data["luogoNaarID"] !== undefined ? _data["luogoNaarID"] : <any>null;
            this.luogoFornitore = _data["luogoFornitore"] !== undefined ? _data["luogoFornitore"] : <any>null;
            this.codiceLuogoFornitore = _data["codiceLuogoFornitore"] !== undefined ? _data["codiceLuogoFornitore"] : <any>null;
            this.fornitore = _data["fornitore"] !== undefined ? _data["fornitore"] : <any>null;
            this.codiceFornitore = _data["codiceFornitore"] !== undefined ? _data["codiceFornitore"] : <any>null;
            this.nomeServizioFornitore = _data["nomeServizioFornitore"] !== undefined ? _data["nomeServizioFornitore"] : <any>null;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : <any>null;
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : <any>null;
            this.haServizioAggregato = _data["haServizioAggregato"] !== undefined ? _data["haServizioAggregato"] : <any>null;
            this.svcAggregatoMappato = _data["svcAggregatoMappato"] !== undefined ? _data["svcAggregatoMappato"] : <any>null;
            this.aggregatoDaConfermare = _data["aggregatoDaConfermare"] !== undefined ? _data["aggregatoDaConfermare"] : <any>null;
            this.indirizzoAggregato = _data["indirizzoAggregato"] !== undefined ? _data["indirizzoAggregato"] : <any>null;
            this.servizioNaar = _data["servizioNaar"] !== undefined ? _data["servizioNaar"] : <any>null;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : <any>null;
            this.daConfermare = _data["daConfermare"] !== undefined ? _data["daConfermare"] : <any>null;
            this.indirizzoFornitore = _data["indirizzoFornitore"] !== undefined ? _data["indirizzoFornitore"] : <any>null;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lon = _data["lon"] !== undefined ? _data["lon"] : <any>null;
            this.indirizzoNaar = _data["indirizzoNaar"] !== undefined ? _data["indirizzoNaar"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
            this.servizio = _data["servizio"] ? HHServizio.fromJS(_data["servizio"]) : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
            this.agreementId = _data["agreementId"] !== undefined ? _data["agreementId"] : <any>null;
        }
    }

    static fromJS(data: any): SVCRow {
        data = typeof data === 'object' ? data : {};
        let result = new SVCRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["giataID"] = this.giataID !== undefined ? this.giataID : <any>null;
        data["codiceRicercaGiata"] = this.codiceRicercaGiata !== undefined ? this.codiceRicercaGiata : <any>null;
        data["codiceGiataFornitore"] = this.codiceGiataFornitore !== undefined ? this.codiceGiataFornitore : <any>null;
        data["luogoNaar"] = this.luogoNaar !== undefined ? this.luogoNaar : <any>null;
        data["luogoNaarID"] = this.luogoNaarID !== undefined ? this.luogoNaarID : <any>null;
        data["luogoFornitore"] = this.luogoFornitore !== undefined ? this.luogoFornitore : <any>null;
        data["codiceLuogoFornitore"] = this.codiceLuogoFornitore !== undefined ? this.codiceLuogoFornitore : <any>null;
        data["fornitore"] = this.fornitore !== undefined ? this.fornitore : <any>null;
        data["codiceFornitore"] = this.codiceFornitore !== undefined ? this.codiceFornitore : <any>null;
        data["nomeServizioFornitore"] = this.nomeServizioFornitore !== undefined ? this.nomeServizioFornitore : <any>null;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : <any>null;
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : <any>null;
        data["haServizioAggregato"] = this.haServizioAggregato !== undefined ? this.haServizioAggregato : <any>null;
        data["svcAggregatoMappato"] = this.svcAggregatoMappato !== undefined ? this.svcAggregatoMappato : <any>null;
        data["aggregatoDaConfermare"] = this.aggregatoDaConfermare !== undefined ? this.aggregatoDaConfermare : <any>null;
        data["indirizzoAggregato"] = this.indirizzoAggregato !== undefined ? this.indirizzoAggregato : <any>null;
        data["servizioNaar"] = this.servizioNaar !== undefined ? this.servizioNaar : <any>null;
        data["rating"] = this.rating !== undefined ? this.rating : <any>null;
        data["daConfermare"] = this.daConfermare !== undefined ? this.daConfermare : <any>null;
        data["indirizzoFornitore"] = this.indirizzoFornitore !== undefined ? this.indirizzoFornitore : <any>null;
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lon"] = this.lon !== undefined ? this.lon : <any>null;
        data["indirizzoNaar"] = this.indirizzoNaar !== undefined ? this.indirizzoNaar : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        data["agreementId"] = this.agreementId !== undefined ? this.agreementId : <any>null;
        return data;
    }
}

export interface ISVCRow {
    id?: number;
    giataID?: number | null;
    codiceRicercaGiata?: string | null;
    codiceGiataFornitore?: string | null;
    luogoNaar?: string | null;
    luogoNaarID?: number | null;
    luogoFornitore?: string | null;
    codiceLuogoFornitore?: string | null;
    fornitore?: string | null;
    codiceFornitore?: string | null;
    nomeServizioFornitore?: string | null;
    servizioNaarID?: number | null;
    servizioAggregatoID?: number | null;
    haServizioAggregato?: boolean;
    svcAggregatoMappato?: boolean;
    aggregatoDaConfermare?: boolean;
    indirizzoAggregato?: string | null;
    servizioNaar?: string | null;
    rating?: number | null;
    daConfermare?: boolean;
    indirizzoFornitore?: string | null;
    lat?: number | null;
    lon?: number | null;
    indirizzoNaar?: string | null;
    ultimoAggiornamento?: string | null;
    servizio?: HHServizio | null;
    deleted?: boolean;
    agreementId?: number | null;
}

export class GetServizioFornitoreRequest extends ApiRequest implements IGetServizioFornitoreRequest {
    servizioFornitoreID?: number;

    constructor(data?: IGetServizioFornitoreRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioFornitoreID = _data["servizioFornitoreID"] !== undefined ? _data["servizioFornitoreID"] : <any>null;
        }
    }

    static fromJS(data: any): GetServizioFornitoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServizioFornitoreRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioFornitoreID"] = this.servizioFornitoreID !== undefined ? this.servizioFornitoreID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServizioFornitoreRequest extends IApiRequest {
    servizioFornitoreID?: number;
}

export class GetDescriptionsServiziH2HResponse extends OkApiResponse implements IGetDescriptionsServiziH2HResponse {
    rows?: DescrizioneServizioH2HRow[] | null;

    constructor(data?: IGetDescriptionsServiziH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DescrizioneServizioH2HRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): GetDescriptionsServiziH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDescriptionsServiziH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetDescriptionsServiziH2HResponse extends IOkApiResponse {
    rows?: DescrizioneServizioH2HRow[] | null;
}

export class DescrizioneServizioH2HRow implements IDescrizioneServizioH2HRow {
    id?: number;
    supplier?: string | null;
    sortOrder?: number;
    lang?: ELingua;
    enabled?: boolean;
    title?: string | null;
    text?: string | null;
    html?: boolean;
    updatedAt?: string;

    constructor(data?: IDescrizioneServizioH2HRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.lang = _data["lang"] !== undefined ? _data["lang"] : <any>null;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.html = _data["html"] !== undefined ? _data["html"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
        }
    }

    static fromJS(data: any): DescrizioneServizioH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new DescrizioneServizioH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["lang"] = this.lang !== undefined ? this.lang : <any>null;
        data["enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["html"] = this.html !== undefined ? this.html : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        return data;
    }
}

export interface IDescrizioneServizioH2HRow {
    id?: number;
    supplier?: string | null;
    sortOrder?: number;
    lang?: ELingua;
    enabled?: boolean;
    title?: string | null;
    text?: string | null;
    html?: boolean;
    updatedAt?: string;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetDescriptionsServiziH2HRequest extends ApiRequest implements IGetDescriptionsServiziH2HRequest {
    servizioAggregatoID?: number;

    constructor(data?: IGetDescriptionsServiziH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : <any>null;
        }
    }

    static fromJS(data: any): GetDescriptionsServiziH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDescriptionsServiziH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetDescriptionsServiziH2HRequest extends IApiRequest {
    servizioAggregatoID?: number;
}

export class GetGiataCodesResponse extends OkApiResponse implements IGetGiataCodesResponse {
    giataCity?: string | null;
    giataCityId?: string | null;
    giataCountryCode?: string | null;
    giataCountry?: string | null;
    giataId?: number;
    mapped?: boolean;
    suppliers?: SupplierRow2[] | null;

    constructor(data?: IGetGiataCodesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.giataCity = _data["giataCity"] !== undefined ? _data["giataCity"] : <any>null;
            this.giataCityId = _data["giataCityId"] !== undefined ? _data["giataCityId"] : <any>null;
            this.giataCountryCode = _data["giataCountryCode"] !== undefined ? _data["giataCountryCode"] : <any>null;
            this.giataCountry = _data["giataCountry"] !== undefined ? _data["giataCountry"] : <any>null;
            this.giataId = _data["giataId"] !== undefined ? _data["giataId"] : <any>null;
            this.mapped = _data["mapped"] !== undefined ? _data["mapped"] : <any>null;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(SupplierRow2.fromJS(item));
            }
            else {
                this.suppliers = <any>null;
            }
        }
    }

    static fromJS(data: any): GetGiataCodesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiataCodesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giataCity"] = this.giataCity !== undefined ? this.giataCity : <any>null;
        data["giataCityId"] = this.giataCityId !== undefined ? this.giataCityId : <any>null;
        data["giataCountryCode"] = this.giataCountryCode !== undefined ? this.giataCountryCode : <any>null;
        data["giataCountry"] = this.giataCountry !== undefined ? this.giataCountry : <any>null;
        data["giataId"] = this.giataId !== undefined ? this.giataId : <any>null;
        data["mapped"] = this.mapped !== undefined ? this.mapped : <any>null;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetGiataCodesResponse extends IOkApiResponse {
    giataCity?: string | null;
    giataCityId?: string | null;
    giataCountryCode?: string | null;
    giataCountry?: string | null;
    giataId?: number;
    mapped?: boolean;
    suppliers?: SupplierRow2[] | null;
}

export class SupplierRow2 implements ISupplierRow2 {
    supplier?: EFornitore;
    codici?: CodiceGiataRow[] | null;

    constructor(data?: ISupplierRow2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
            if (Array.isArray(_data["codici"])) {
                this.codici = [] as any;
                for (let item of _data["codici"])
                    this.codici!.push(CodiceGiataRow.fromJS(item));
            }
            else {
                this.codici = <any>null;
            }
        }
    }

    static fromJS(data: any): SupplierRow2 {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierRow2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        if (Array.isArray(this.codici)) {
            data["codici"] = [];
            for (let item of this.codici)
                data["codici"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISupplierRow2 {
    supplier?: EFornitore;
    codici?: CodiceGiataRow[] | null;
}

export class CodiceGiataRow implements ICodiceGiataRow {
    giataCode?: GiataCode | null;
    servizioH2H?: HHServizio | null;
    servizioID?: number | null;
    nomeServizio?: string | null;

    constructor(data?: ICodiceGiataRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giataCode = _data["giataCode"] ? GiataCode.fromJS(_data["giataCode"]) : <any>null;
            this.servizioH2H = _data["servizioH2H"] ? HHServizio.fromJS(_data["servizioH2H"]) : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.nomeServizio = _data["nomeServizio"] !== undefined ? _data["nomeServizio"] : <any>null;
        }
    }

    static fromJS(data: any): CodiceGiataRow {
        data = typeof data === 'object' ? data : {};
        let result = new CodiceGiataRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giataCode"] = this.giataCode ? this.giataCode.toJSON() : <any>null;
        data["servizioH2H"] = this.servizioH2H ? this.servizioH2H.toJSON() : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["nomeServizio"] = this.nomeServizio !== undefined ? this.nomeServizio : <any>null;
        return data;
    }
}

export interface ICodiceGiataRow {
    giataCode?: GiataCode | null;
    servizioH2H?: HHServizio | null;
    servizioID?: number | null;
    nomeServizio?: string | null;
}

export class GiataCode implements IGiataCode {
    cityCode?: string | null;
    propertyCode?: string | null;

    constructor(data?: IGiataCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCode = _data["cityCode"] !== undefined ? _data["cityCode"] : <any>null;
            this.propertyCode = _data["propertyCode"] !== undefined ? _data["propertyCode"] : <any>null;
        }
    }

    static fromJS(data: any): GiataCode {
        data = typeof data === 'object' ? data : {};
        let result = new GiataCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode !== undefined ? this.cityCode : <any>null;
        data["propertyCode"] = this.propertyCode !== undefined ? this.propertyCode : <any>null;
        return data;
    }
}

export interface IGiataCode {
    cityCode?: string | null;
    propertyCode?: string | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetGiataCodesRequest extends ApiRequest implements IGetGiataCodesRequest {
    supplierGiataCode?: string | null;
    supplier?: EFornitore;

    constructor(data?: IGetGiataCodesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.supplierGiataCode = _data["supplierGiataCode"] !== undefined ? _data["supplierGiataCode"] : <any>null;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
        }
    }

    static fromJS(data: any): GetGiataCodesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiataCodesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierGiataCode"] = this.supplierGiataCode !== undefined ? this.supplierGiataCode : <any>null;
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetGiataCodesRequest extends IApiRequest {
    supplierGiataCode?: string | null;
    supplier?: EFornitore;
}

export abstract class IGiataService implements IIGiataService {

    constructor(data?: IIGiataService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IGiataService {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IGiataService' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIGiataService {
}

export class GetGroupedServizioH2HResponse extends OkApiResponse implements IGetGroupedServizioH2HResponse {
    servizio?: ServizioH2HRow | null;

    constructor(data?: IGetGroupedServizioH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? ServizioH2HRow.fromJS(_data["servizio"]) : <any>null;
        }
    }

    static fromJS(data: any): GetGroupedServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupedServizioH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetGroupedServizioH2HResponse extends IOkApiResponse {
    servizio?: ServizioH2HRow | null;
}

export class ServizioH2HRow implements IServizioH2HRow {
    id?: number;
    giataID?: number | null;
    luogoNaar?: string | null;
    luogoNaarID?: number;
    nomeServizioFornitore?: string | null;
    servizioNaarID?: number | null;
    servizioNaar?: string | null;
    attivo?: boolean;
    completo?: boolean;
    indirizzoFornitore?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    ultimoAggiornamento?: string;
    servizio?: HHServizioAggregato | null;

    constructor(data?: IServizioH2HRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : <any>null;
            this.luogoNaar = _data["luogoNaar"] !== undefined ? _data["luogoNaar"] : <any>null;
            this.luogoNaarID = _data["luogoNaarID"] !== undefined ? _data["luogoNaarID"] : <any>null;
            this.nomeServizioFornitore = _data["nomeServizioFornitore"] !== undefined ? _data["nomeServizioFornitore"] : <any>null;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : <any>null;
            this.servizioNaar = _data["servizioNaar"] !== undefined ? _data["servizioNaar"] : <any>null;
            this.attivo = _data["attivo"] !== undefined ? _data["attivo"] : <any>null;
            this.completo = _data["completo"] !== undefined ? _data["completo"] : <any>null;
            this.indirizzoFornitore = _data["indirizzoFornitore"] !== undefined ? _data["indirizzoFornitore"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
            this.servizio = _data["servizio"] ? HHServizioAggregato.fromJS(_data["servizio"]) : <any>null;
        }
    }

    static fromJS(data: any): ServizioH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["giataID"] = this.giataID !== undefined ? this.giataID : <any>null;
        data["luogoNaar"] = this.luogoNaar !== undefined ? this.luogoNaar : <any>null;
        data["luogoNaarID"] = this.luogoNaarID !== undefined ? this.luogoNaarID : <any>null;
        data["nomeServizioFornitore"] = this.nomeServizioFornitore !== undefined ? this.nomeServizioFornitore : <any>null;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : <any>null;
        data["servizioNaar"] = this.servizioNaar !== undefined ? this.servizioNaar : <any>null;
        data["attivo"] = this.attivo !== undefined ? this.attivo : <any>null;
        data["completo"] = this.completo !== undefined ? this.completo : <any>null;
        data["indirizzoFornitore"] = this.indirizzoFornitore !== undefined ? this.indirizzoFornitore : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        return data;
    }
}

export interface IServizioH2HRow {
    id?: number;
    giataID?: number | null;
    luogoNaar?: string | null;
    luogoNaarID?: number;
    nomeServizioFornitore?: string | null;
    servizioNaarID?: number | null;
    servizioNaar?: string | null;
    attivo?: boolean;
    completo?: boolean;
    indirizzoFornitore?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    ultimoAggiornamento?: string;
    servizio?: HHServizioAggregato | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetGroupedServizioH2HRequest extends ApiRequest implements IGetGroupedServizioH2HRequest {
    servizioAggregatoID?: number;

    constructor(data?: IGetGroupedServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : <any>null;
        }
    }

    static fromJS(data: any): GetGroupedServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupedServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetGroupedServizioH2HRequest extends IApiRequest {
    servizioAggregatoID?: number;
}

export class NrTableResponseOfServizioH2HRow extends OkApiResponse implements INrTableResponseOfServizioH2HRow {
    /** Array delle righe della pagina richiesta */
    rows?: ServizioH2HRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfServizioH2HRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ServizioH2HRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfServizioH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfServizioH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfServizioH2HRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ServizioH2HRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetServiziH2HResponse extends NrTableResponseOfServizioH2HRow implements IGetServiziH2HResponse {

    constructor(data?: IGetServiziH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetServiziH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiziH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiziH2HResponse extends INrTableResponseOfServizioH2HRow {
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetServiziH2HRequest extends NrTableRequest implements IGetServiziH2HRequest {
    supplier?: number | null;
    svcType?: ETipoServizio | null;
    luogoNaarID?: number | null;
    mapped?: boolean | null;
    confirmed?: boolean | null;
    enabled?: boolean | null;
    complete?: boolean | null;
    withoutRank?: boolean | null;
    excludeLowerRating?: boolean;
    hideLowerRating?: boolean;
    servizioNaarID?: number | null;
    nomeServizioFornitore?: string | null;
    luogoFornitoreID?: number | null;
    servizioAggregatoID?: number | null;
    giataID?: number | null;
    withoutGrouped?: boolean | null;
    luoghiVicini?: boolean;

    constructor(data?: IGetServiziH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
            this.svcType = _data["svcType"] !== undefined ? _data["svcType"] : <any>null;
            this.luogoNaarID = _data["luogoNaarID"] !== undefined ? _data["luogoNaarID"] : <any>null;
            this.mapped = _data["mapped"] !== undefined ? _data["mapped"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : <any>null;
            this.complete = _data["complete"] !== undefined ? _data["complete"] : <any>null;
            this.withoutRank = _data["withoutRank"] !== undefined ? _data["withoutRank"] : <any>null;
            this.excludeLowerRating = _data["excludeLowerRating"] !== undefined ? _data["excludeLowerRating"] : <any>null;
            this.hideLowerRating = _data["hideLowerRating"] !== undefined ? _data["hideLowerRating"] : <any>null;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : <any>null;
            this.nomeServizioFornitore = _data["nomeServizioFornitore"] !== undefined ? _data["nomeServizioFornitore"] : <any>null;
            this.luogoFornitoreID = _data["luogoFornitoreID"] !== undefined ? _data["luogoFornitoreID"] : <any>null;
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : <any>null;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : <any>null;
            this.withoutGrouped = _data["withoutGrouped"] !== undefined ? _data["withoutGrouped"] : <any>null;
            this.luoghiVicini = _data["luoghiVicini"] !== undefined ? _data["luoghiVicini"] : <any>null;
        }
    }

    static fromJS(data: any): GetServiziH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiziH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        data["svcType"] = this.svcType !== undefined ? this.svcType : <any>null;
        data["luogoNaarID"] = this.luogoNaarID !== undefined ? this.luogoNaarID : <any>null;
        data["mapped"] = this.mapped !== undefined ? this.mapped : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
        data["complete"] = this.complete !== undefined ? this.complete : <any>null;
        data["withoutRank"] = this.withoutRank !== undefined ? this.withoutRank : <any>null;
        data["excludeLowerRating"] = this.excludeLowerRating !== undefined ? this.excludeLowerRating : <any>null;
        data["hideLowerRating"] = this.hideLowerRating !== undefined ? this.hideLowerRating : <any>null;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : <any>null;
        data["nomeServizioFornitore"] = this.nomeServizioFornitore !== undefined ? this.nomeServizioFornitore : <any>null;
        data["luogoFornitoreID"] = this.luogoFornitoreID !== undefined ? this.luogoFornitoreID : <any>null;
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : <any>null;
        data["giataID"] = this.giataID !== undefined ? this.giataID : <any>null;
        data["withoutGrouped"] = this.withoutGrouped !== undefined ? this.withoutGrouped : <any>null;
        data["luoghiVicini"] = this.luoghiVicini !== undefined ? this.luoghiVicini : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetServiziH2HRequest extends INrTableRequest {
    supplier?: number | null;
    svcType?: ETipoServizio | null;
    luogoNaarID?: number | null;
    mapped?: boolean | null;
    confirmed?: boolean | null;
    enabled?: boolean | null;
    complete?: boolean | null;
    withoutRank?: boolean | null;
    excludeLowerRating?: boolean;
    hideLowerRating?: boolean;
    servizioNaarID?: number | null;
    nomeServizioFornitore?: string | null;
    luogoFornitoreID?: number | null;
    servizioAggregatoID?: number | null;
    giataID?: number | null;
    withoutGrouped?: boolean | null;
    luoghiVicini?: boolean;
}

export class GetImmaginiServiziH2HResponse extends OkApiResponse implements IGetImmaginiServiziH2HResponse {
    rows?: ImmagineServizioH2HRow[] | null;

    constructor(data?: IGetImmaginiServiziH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ImmagineServizioH2HRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): GetImmaginiServiziH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImmaginiServiziH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetImmaginiServiziH2HResponse extends IOkApiResponse {
    rows?: ImmagineServizioH2HRow[] | null;
}

export class ImmagineServizioH2HRow implements IImmagineServizioH2HRow {
    id?: number;
    thumbUrl?: string | null;
    imageUrl?: string | null;
    sortOrder?: number;
    ordineNaar?: number | null;
    enabled?: boolean;
    updatedAt?: string;
    supplier?: string | null;
    descrizioni?: DescrizioneImmagineServizioH2H[] | null;

    constructor(data?: IImmagineServizioH2HRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.thumbUrl = _data["thumbUrl"] !== undefined ? _data["thumbUrl"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.ordineNaar = _data["ordineNaar"] !== undefined ? _data["ordineNaar"] : <any>null;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
            if (Array.isArray(_data["descrizioni"])) {
                this.descrizioni = [] as any;
                for (let item of _data["descrizioni"])
                    this.descrizioni!.push(DescrizioneImmagineServizioH2H.fromJS(item));
            }
            else {
                this.descrizioni = <any>null;
            }
        }
    }

    static fromJS(data: any): ImmagineServizioH2HRow {
        data = typeof data === 'object' ? data : {};
        let result = new ImmagineServizioH2HRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["thumbUrl"] = this.thumbUrl !== undefined ? this.thumbUrl : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["ordineNaar"] = this.ordineNaar !== undefined ? this.ordineNaar : <any>null;
        data["enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        if (Array.isArray(this.descrizioni)) {
            data["descrizioni"] = [];
            for (let item of this.descrizioni)
                data["descrizioni"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImmagineServizioH2HRow {
    id?: number;
    thumbUrl?: string | null;
    imageUrl?: string | null;
    sortOrder?: number;
    ordineNaar?: number | null;
    enabled?: boolean;
    updatedAt?: string;
    supplier?: string | null;
    descrizioni?: DescrizioneImmagineServizioH2H[] | null;
}

export class DescrizioneImmagineServizioH2H implements IDescrizioneImmagineServizioH2H {
    lang?: ELingua;
    descrizione?: string | null;

    constructor(data?: IDescrizioneImmagineServizioH2H) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lang = _data["lang"] !== undefined ? _data["lang"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
        }
    }

    static fromJS(data: any): DescrizioneImmagineServizioH2H {
        data = typeof data === 'object' ? data : {};
        let result = new DescrizioneImmagineServizioH2H();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lang"] = this.lang !== undefined ? this.lang : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        return data;
    }
}

export interface IDescrizioneImmagineServizioH2H {
    lang?: ELingua;
    descrizione?: string | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetImmaginiServiziH2HRequest extends ApiRequest implements IGetImmaginiServiziH2HRequest {
    servizioAggregatoID?: number;

    constructor(data?: IGetImmaginiServiziH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : <any>null;
        }
    }

    static fromJS(data: any): GetImmaginiServiziH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetImmaginiServiziH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetImmaginiServiziH2HRequest extends IApiRequest {
    servizioAggregatoID?: number;
}

export class GetServiceAttrsResponse extends OkApiResponse implements IGetServiceAttrsResponse {
    categories?: ServiceAttrRow[] | null;
    stars?: ServiceAttrRow[] | null;
    positions?: ServiceAttrRow[] | null;
    classifications?: ServiceAttrRow[] | null;
    penalties?: ServiceAttrRow[] | null;

    constructor(data?: IGetServiceAttrsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(ServiceAttrRow.fromJS(item));
            }
            else {
                this.categories = <any>null;
            }
            if (Array.isArray(_data["stars"])) {
                this.stars = [] as any;
                for (let item of _data["stars"])
                    this.stars!.push(ServiceAttrRow.fromJS(item));
            }
            else {
                this.stars = <any>null;
            }
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(ServiceAttrRow.fromJS(item));
            }
            else {
                this.positions = <any>null;
            }
            if (Array.isArray(_data["classifications"])) {
                this.classifications = [] as any;
                for (let item of _data["classifications"])
                    this.classifications!.push(ServiceAttrRow.fromJS(item));
            }
            else {
                this.classifications = <any>null;
            }
            if (Array.isArray(_data["penalties"])) {
                this.penalties = [] as any;
                for (let item of _data["penalties"])
                    this.penalties!.push(ServiceAttrRow.fromJS(item));
            }
            else {
                this.penalties = <any>null;
            }
        }
    }

    static fromJS(data: any): GetServiceAttrsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceAttrsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.stars)) {
            data["stars"] = [];
            for (let item of this.stars)
                data["stars"].push(item.toJSON());
        }
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item.toJSON());
        }
        if (Array.isArray(this.classifications)) {
            data["classifications"] = [];
            for (let item of this.classifications)
                data["classifications"].push(item.toJSON());
        }
        if (Array.isArray(this.penalties)) {
            data["penalties"] = [];
            for (let item of this.penalties)
                data["penalties"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiceAttrsResponse extends IOkApiResponse {
    categories?: ServiceAttrRow[] | null;
    stars?: ServiceAttrRow[] | null;
    positions?: ServiceAttrRow[] | null;
    classifications?: ServiceAttrRow[] | null;
    penalties?: ServiceAttrRow[] | null;
}

export class ServiceAttrRow implements IServiceAttrRow {
    id?: number;
    nome?: string | null;
    mostraDescrizione?: boolean;
    luogoID?: number | null;

    constructor(data?: IServiceAttrRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.mostraDescrizione = _data["mostraDescrizione"] !== undefined ? _data["mostraDescrizione"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceAttrRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAttrRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["mostraDescrizione"] = this.mostraDescrizione !== undefined ? this.mostraDescrizione : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        return data;
    }
}

export interface IServiceAttrRow {
    id?: number;
    nome?: string | null;
    mostraDescrizione?: boolean;
    luogoID?: number | null;
}

export class NrTableResponseOfSVCRow extends OkApiResponse implements INrTableResponseOfSVCRow {
    /** Array delle righe della pagina richiesta */
    rows?: SVCRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSVCRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SVCRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfSVCRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSVCRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSVCRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SVCRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetSVCListResponse extends NrTableResponseOfSVCRow implements IGetSVCListResponse {

    constructor(data?: IGetSVCListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetSVCListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSVCListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetSVCListResponse extends INrTableResponseOfSVCRow {
}

export class GetSVCListRequest extends NrTableRequest implements IGetSVCListRequest {
    ratingRange?: number[] | null;
    supplier?: number | null;
    svcType?: ETipoServizio | null;
    luogoNaarID?: number | null;
    mapped?: boolean | null;
    confirmed?: boolean | null;
    enabled?: boolean | null;
    complete?: boolean | null;
    withoutRank?: boolean | null;
    excludeLowerRating?: boolean;
    hideLowerRating?: boolean;
    servizioNaarID?: number | null;
    nomeServizioFornitore?: string | null;
    luogoFornitoreID?: number | null;
    servizioAggregatoID?: number | null;
    giataID?: number | null;
    withoutGrouped?: boolean | null;
    luoghiVicini?: boolean;
    showDeleted?: boolean;

    constructor(data?: IGetSVCListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ratingRange"])) {
                this.ratingRange = [] as any;
                for (let item of _data["ratingRange"])
                    this.ratingRange!.push(item);
            }
            else {
                this.ratingRange = <any>null;
            }
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
            this.svcType = _data["svcType"] !== undefined ? _data["svcType"] : <any>null;
            this.luogoNaarID = _data["luogoNaarID"] !== undefined ? _data["luogoNaarID"] : <any>null;
            this.mapped = _data["mapped"] !== undefined ? _data["mapped"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : <any>null;
            this.complete = _data["complete"] !== undefined ? _data["complete"] : <any>null;
            this.withoutRank = _data["withoutRank"] !== undefined ? _data["withoutRank"] : <any>null;
            this.excludeLowerRating = _data["excludeLowerRating"] !== undefined ? _data["excludeLowerRating"] : <any>null;
            this.hideLowerRating = _data["hideLowerRating"] !== undefined ? _data["hideLowerRating"] : <any>null;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : <any>null;
            this.nomeServizioFornitore = _data["nomeServizioFornitore"] !== undefined ? _data["nomeServizioFornitore"] : <any>null;
            this.luogoFornitoreID = _data["luogoFornitoreID"] !== undefined ? _data["luogoFornitoreID"] : <any>null;
            this.servizioAggregatoID = _data["servizioAggregatoID"] !== undefined ? _data["servizioAggregatoID"] : <any>null;
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : <any>null;
            this.withoutGrouped = _data["withoutGrouped"] !== undefined ? _data["withoutGrouped"] : <any>null;
            this.luoghiVicini = _data["luoghiVicini"] !== undefined ? _data["luoghiVicini"] : <any>null;
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): GetSVCListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSVCListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ratingRange)) {
            data["ratingRange"] = [];
            for (let item of this.ratingRange)
                data["ratingRange"].push(item);
        }
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        data["svcType"] = this.svcType !== undefined ? this.svcType : <any>null;
        data["luogoNaarID"] = this.luogoNaarID !== undefined ? this.luogoNaarID : <any>null;
        data["mapped"] = this.mapped !== undefined ? this.mapped : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
        data["complete"] = this.complete !== undefined ? this.complete : <any>null;
        data["withoutRank"] = this.withoutRank !== undefined ? this.withoutRank : <any>null;
        data["excludeLowerRating"] = this.excludeLowerRating !== undefined ? this.excludeLowerRating : <any>null;
        data["hideLowerRating"] = this.hideLowerRating !== undefined ? this.hideLowerRating : <any>null;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : <any>null;
        data["nomeServizioFornitore"] = this.nomeServizioFornitore !== undefined ? this.nomeServizioFornitore : <any>null;
        data["luogoFornitoreID"] = this.luogoFornitoreID !== undefined ? this.luogoFornitoreID : <any>null;
        data["servizioAggregatoID"] = this.servizioAggregatoID !== undefined ? this.servizioAggregatoID : <any>null;
        data["giataID"] = this.giataID !== undefined ? this.giataID : <any>null;
        data["withoutGrouped"] = this.withoutGrouped !== undefined ? this.withoutGrouped : <any>null;
        data["luoghiVicini"] = this.luoghiVicini !== undefined ? this.luoghiVicini : <any>null;
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSVCListRequest extends INrTableRequest {
    ratingRange?: number[] | null;
    supplier?: number | null;
    svcType?: ETipoServizio | null;
    luogoNaarID?: number | null;
    mapped?: boolean | null;
    confirmed?: boolean | null;
    enabled?: boolean | null;
    complete?: boolean | null;
    withoutRank?: boolean | null;
    excludeLowerRating?: boolean;
    hideLowerRating?: boolean;
    servizioNaarID?: number | null;
    nomeServizioFornitore?: string | null;
    luogoFornitoreID?: number | null;
    servizioAggregatoID?: number | null;
    giataID?: number | null;
    withoutGrouped?: boolean | null;
    luoghiVicini?: boolean;
    showDeleted?: boolean;
}

export class NrTableResponseOfTypeRow extends OkApiResponse implements INrTableResponseOfTypeRow {
    /** Array delle righe della pagina richiesta */
    rows?: TypeRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTypeRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TypeRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfTypeRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTypeRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTypeRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TypeRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetTypesListResponse extends NrTableResponseOfTypeRow implements IGetTypesListResponse {

    constructor(data?: IGetTypesListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetTypesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypesListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetTypesListResponse extends INrTableResponseOfTypeRow {
}

export class TypeRow implements ITypeRow {
    id?: number;
    codice?: string | null;
    nome?: string | null;
    tipologiaNaar?: string | null;
    tipologiaNaarID?: number | null;
    regolaVenditaID?: number | null;
    nrf?: boolean | null;
    ultimoAggiornamento?: string | null;
    hashCodeID?: number | null;

    constructor(data?: ITypeRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.tipologiaNaar = _data["tipologiaNaar"] !== undefined ? _data["tipologiaNaar"] : <any>null;
            this.tipologiaNaarID = _data["tipologiaNaarID"] !== undefined ? _data["tipologiaNaarID"] : <any>null;
            this.regolaVenditaID = _data["regolaVenditaID"] !== undefined ? _data["regolaVenditaID"] : <any>null;
            this.nrf = _data["nrf"] !== undefined ? _data["nrf"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
            this.hashCodeID = _data["hashCodeID"] !== undefined ? _data["hashCodeID"] : <any>null;
        }
    }

    static fromJS(data: any): TypeRow {
        data = typeof data === 'object' ? data : {};
        let result = new TypeRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["tipologiaNaar"] = this.tipologiaNaar !== undefined ? this.tipologiaNaar : <any>null;
        data["tipologiaNaarID"] = this.tipologiaNaarID !== undefined ? this.tipologiaNaarID : <any>null;
        data["regolaVenditaID"] = this.regolaVenditaID !== undefined ? this.regolaVenditaID : <any>null;
        data["nrf"] = this.nrf !== undefined ? this.nrf : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        data["hashCodeID"] = this.hashCodeID !== undefined ? this.hashCodeID : <any>null;
        return data;
    }
}

export interface ITypeRow {
    id?: number;
    codice?: string | null;
    nome?: string | null;
    tipologiaNaar?: string | null;
    tipologiaNaarID?: number | null;
    regolaVenditaID?: number | null;
    nrf?: boolean | null;
    ultimoAggiornamento?: string | null;
    hashCodeID?: number | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class GetTypesListRequest extends NrTableRequest implements IGetTypesListRequest {
    hhSvcID?: number;

    constructor(data?: IGetTypesListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hhSvcID = _data["hhSvcID"] !== undefined ? _data["hhSvcID"] : <any>null;
        }
    }

    static fromJS(data: any): GetTypesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypesListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hhSvcID"] = this.hhSvcID !== undefined ? this.hhSvcID : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IGetTypesListRequest extends INrTableRequest {
    hhSvcID?: number;
}

export class LinkServizioH2HResponse extends OkApiResponse implements ILinkServizioH2HResponse {
    servizioAggregato?: HHServizioAggregato | null;
    address?: string | null;

    constructor(data?: ILinkServizioH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAggregato = _data["servizioAggregato"] ? HHServizioAggregato.fromJS(_data["servizioAggregato"]) : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
        }
    }

    static fromJS(data: any): LinkServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkServizioH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAggregato"] = this.servizioAggregato ? this.servizioAggregato.toJSON() : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ILinkServizioH2HResponse extends IOkApiResponse {
    servizioAggregato?: HHServizioAggregato | null;
    address?: string | null;
}

export class LinkServizioH2HRequest extends ApiRequest implements ILinkServizioH2HRequest {
    servizioHHId?: number;
    servizioAggregatoHHID?: number | null;

    constructor(data?: ILinkServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
            this.servizioAggregatoHHID = _data["servizioAggregatoHHID"] !== undefined ? _data["servizioAggregatoHHID"] : <any>null;
        }
    }

    static fromJS(data: any): LinkServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        data["servizioAggregatoHHID"] = this.servizioAggregatoHHID !== undefined ? this.servizioAggregatoHHID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ILinkServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
    servizioAggregatoHHID?: number | null;
}

export class MigrateServizioH2HRequest extends ApiRequest implements IMigrateServizioH2HRequest {
    sourceId?: number;
    destinationId?: number;

    constructor(data?: IMigrateServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : <any>null;
            this.destinationId = _data["destinationId"] !== undefined ? _data["destinationId"] : <any>null;
        }
    }

    static fromJS(data: any): MigrateServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MigrateServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : <any>null;
        data["destinationId"] = this.destinationId !== undefined ? this.destinationId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMigrateServizioH2HRequest extends IApiRequest {
    sourceId?: number;
    destinationId?: number;
}

export class RestoreServizioH2HRequest extends ApiRequest implements IRestoreServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IRestoreServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
        }
    }

    static fromJS(data: any): RestoreServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRestoreServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class SetAgreementServizioH2HResponse extends OkApiResponse implements ISetAgreementServizioH2HResponse {
    servizio?: HHServizio | null;

    constructor(data?: ISetAgreementServizioH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizio.fromJS(_data["servizio"]) : <any>null;
        }
    }

    static fromJS(data: any): SetAgreementServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetAgreementServizioH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetAgreementServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizio | null;
}

export class SetAgreementServizioH2HRequest extends ApiRequest implements ISetAgreementServizioH2HRequest {
    servizioHHId?: number;
    agreementId?: number;

    constructor(data?: ISetAgreementServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
            this.agreementId = _data["agreementId"] !== undefined ? _data["agreementId"] : <any>null;
        }
    }

    static fromJS(data: any): SetAgreementServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetAgreementServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        data["agreementId"] = this.agreementId !== undefined ? this.agreementId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetAgreementServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
    agreementId?: number;
}

export class SetGiataIdResponse extends OkApiResponse implements ISetGiataIdResponse {
    servizi?: HHServizio[] | null;

    constructor(data?: ISetGiataIdResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(HHServizio.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
        }
    }

    static fromJS(data: any): SetGiataIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetGiataIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetGiataIdResponse extends IOkApiResponse {
    servizi?: HHServizio[] | null;
}

export class SetGiataIdRequest extends ApiRequest implements ISetGiataIdRequest {
    giataID?: number;
    hhServIDs?: number[] | null;

    constructor(data?: ISetGiataIdRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.giataID = _data["giataID"] !== undefined ? _data["giataID"] : <any>null;
            if (Array.isArray(_data["hhServIDs"])) {
                this.hhServIDs = [] as any;
                for (let item of _data["hhServIDs"])
                    this.hhServIDs!.push(item);
            }
            else {
                this.hhServIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): SetGiataIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetGiataIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giataID"] = this.giataID !== undefined ? this.giataID : <any>null;
        if (Array.isArray(this.hhServIDs)) {
            data["hhServIDs"] = [];
            for (let item of this.hhServIDs)
                data["hhServIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetGiataIdRequest extends IApiRequest {
    giataID?: number;
    hhServIDs?: number[] | null;
}

export class SetGroupedMappingServizioH2HResponse extends OkApiResponse implements ISetGroupedMappingServizioH2HResponse {
    servizio?: HHServizioAggregato | null;
    other?: HHServizio[] | null;
    address?: string | null;

    constructor(data?: ISetGroupedMappingServizioH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizioAggregato.fromJS(_data["servizio"]) : <any>null;
            if (Array.isArray(_data["other"])) {
                this.other = [] as any;
                for (let item of _data["other"])
                    this.other!.push(HHServizio.fromJS(item));
            }
            else {
                this.other = <any>null;
            }
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
        }
    }

    static fromJS(data: any): SetGroupedMappingServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetGroupedMappingServizioH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        if (Array.isArray(this.other)) {
            data["other"] = [];
            for (let item of this.other)
                data["other"].push(item.toJSON());
        }
        data["address"] = this.address !== undefined ? this.address : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetGroupedMappingServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizioAggregato | null;
    other?: HHServizio[] | null;
    address?: string | null;
}

export class SetGroupedMappingServizioH2HRequest extends ApiRequest implements ISetGroupedMappingServizioH2HRequest {
    servizioHHId?: number;
    servizioNaarID?: number;

    constructor(data?: ISetGroupedMappingServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : <any>null;
        }
    }

    static fromJS(data: any): SetGroupedMappingServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetGroupedMappingServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetGroupedMappingServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
    servizioNaarID?: number;
}

export class SetMapH2HResponse extends OkApiResponse implements ISetMapH2HResponse {
    latitude?: number | null;
    longitude?: number | null;
    zoom?: number | null;

    constructor(data?: ISetMapH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : <any>null;
        }
    }

    static fromJS(data: any): SetMapH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetMapH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["zoom"] = this.zoom !== undefined ? this.zoom : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMapH2HResponse extends IOkApiResponse {
    latitude?: number | null;
    longitude?: number | null;
    zoom?: number | null;
}

export class SetMapH2HRequest extends ApiRequest implements ISetMapH2HRequest {
    servizio?: HHServizioAggregato | null;

    constructor(data?: ISetMapH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizioAggregato.fromJS(_data["servizio"]) : <any>null;
        }
    }

    static fromJS(data: any): SetMapH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMapH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMapH2HRequest extends IApiRequest {
    servizio?: HHServizioAggregato | null;
}

export class SetMappingServizioH2HResponse extends OkApiResponse implements ISetMappingServizioH2HResponse {
    servizio?: HHServizio | null;
    other?: HHServizio[] | null;
    address?: string | null;

    constructor(data?: ISetMappingServizioH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizio.fromJS(_data["servizio"]) : <any>null;
            if (Array.isArray(_data["other"])) {
                this.other = [] as any;
                for (let item of _data["other"])
                    this.other!.push(HHServizio.fromJS(item));
            }
            else {
                this.other = <any>null;
            }
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
        }
    }

    static fromJS(data: any): SetMappingServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappingServizioH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        if (Array.isArray(this.other)) {
            data["other"] = [];
            for (let item of this.other)
                data["other"].push(item.toJSON());
        }
        data["address"] = this.address !== undefined ? this.address : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappingServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizio | null;
    other?: HHServizio[] | null;
    address?: string | null;
}

export class SetMappingServizioH2HRequest extends ApiRequest implements ISetMappingServizioH2HRequest {
    servizioHHId?: number;
    servizioNaarID?: number;

    constructor(data?: ISetMappingServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : <any>null;
        }
    }

    static fromJS(data: any): SetMappingServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappingServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappingServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
    servizioNaarID?: number;
}

export class SetMappingMultiResponse extends OkApiResponse implements ISetMappingMultiResponse {
    servizi?: HHServizio[] | null;

    constructor(data?: ISetMappingMultiResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(HHServizio.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
        }
    }

    static fromJS(data: any): SetMappingMultiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappingMultiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappingMultiResponse extends IOkApiResponse {
    servizi?: HHServizio[] | null;
}

export class SetMappingMultiRequest extends ApiRequest implements ISetMappingMultiRequest {
    servizioNaarID?: number;
    hhServIDs?: number[] | null;

    constructor(data?: ISetMappingMultiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioNaarID = _data["servizioNaarID"] !== undefined ? _data["servizioNaarID"] : <any>null;
            if (Array.isArray(_data["hhServIDs"])) {
                this.hhServIDs = [] as any;
                for (let item of _data["hhServIDs"])
                    this.hhServIDs!.push(item);
            }
            else {
                this.hhServIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): SetMappingMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMappingMultiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioNaarID"] = this.servizioNaarID !== undefined ? this.servizioNaarID : <any>null;
        if (Array.isArray(this.hhServIDs)) {
            data["hhServIDs"] = [];
            for (let item of this.hhServIDs)
                data["hhServIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetMappingMultiRequest extends IApiRequest {
    servizioNaarID?: number;
    hhServIDs?: number[] | null;
}

export class SetRuleMappingResponse extends OkApiResponse implements ISetRuleMappingResponse {
    codice?: HHCodice | null;

    constructor(data?: ISetRuleMappingResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] ? HHCodice.fromJS(_data["codice"]) : <any>null;
        }
    }

    static fromJS(data: any): SetRuleMappingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetRuleMappingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice ? this.codice.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetRuleMappingResponse extends IOkApiResponse {
    codice?: HHCodice | null;
}

export class SetRuleMappingRequest extends ApiRequest implements ISetRuleMappingRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;
    servizioRegolaVenditaID?: number | null;

    constructor(data?: ISetRuleMappingRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
            this.tipologiaHHID = _data["tipologiaHHID"] !== undefined ? _data["tipologiaHHID"] : <any>null;
            this.servizioRegolaVenditaID = _data["servizioRegolaVenditaID"] !== undefined ? _data["servizioRegolaVenditaID"] : <any>null;
        }
    }

    static fromJS(data: any): SetRuleMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRuleMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        data["tipologiaHHID"] = this.tipologiaHHID !== undefined ? this.tipologiaHHID : <any>null;
        data["servizioRegolaVenditaID"] = this.servizioRegolaVenditaID !== undefined ? this.servizioRegolaVenditaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetRuleMappingRequest extends IApiRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;
    servizioRegolaVenditaID?: number | null;
}

export class SetTypeMappingResponse extends OkApiResponse implements ISetTypeMappingResponse {
    codice?: HHCodice | null;

    constructor(data?: ISetTypeMappingResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] ? HHCodice.fromJS(_data["codice"]) : <any>null;
        }
    }

    static fromJS(data: any): SetTypeMappingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetTypeMappingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice ? this.codice.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetTypeMappingResponse extends IOkApiResponse {
    codice?: HHCodice | null;
}

export class SetTypeMappingRequest extends ApiRequest implements ISetTypeMappingRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;
    servizioTipologiaNaarID?: number | null;

    constructor(data?: ISetTypeMappingRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
            this.tipologiaHHID = _data["tipologiaHHID"] !== undefined ? _data["tipologiaHHID"] : <any>null;
            this.servizioTipologiaNaarID = _data["servizioTipologiaNaarID"] !== undefined ? _data["servizioTipologiaNaarID"] : <any>null;
        }
    }

    static fromJS(data: any): SetTypeMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetTypeMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        data["tipologiaHHID"] = this.tipologiaHHID !== undefined ? this.tipologiaHHID : <any>null;
        data["servizioTipologiaNaarID"] = this.servizioTipologiaNaarID !== undefined ? this.servizioTipologiaNaarID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISetTypeMappingRequest extends IApiRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;
    servizioTipologiaNaarID?: number | null;
}

export class UnConfirmMappingServizioH2HRequest extends ApiRequest implements IUnConfirmMappingServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IUnConfirmMappingServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
        }
    }

    static fromJS(data: any): UnConfirmMappingServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnConfirmMappingServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUnConfirmMappingServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class UnConfirmTypeMappingResponse extends OkApiResponse implements IUnConfirmTypeMappingResponse {
    codice?: HHCodice | null;

    constructor(data?: IUnConfirmTypeMappingResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] ? HHCodice.fromJS(_data["codice"]) : <any>null;
        }
    }

    static fromJS(data: any): UnConfirmTypeMappingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnConfirmTypeMappingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice ? this.codice.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUnConfirmTypeMappingResponse extends IOkApiResponse {
    codice?: HHCodice | null;
}

export class UnConfirmTypeMappingRequest extends ApiRequest implements IUnConfirmTypeMappingRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;

    constructor(data?: IUnConfirmTypeMappingRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
            this.tipologiaHHID = _data["tipologiaHHID"] !== undefined ? _data["tipologiaHHID"] : <any>null;
        }
    }

    static fromJS(data: any): UnConfirmTypeMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnConfirmTypeMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        data["tipologiaHHID"] = this.tipologiaHHID !== undefined ? this.tipologiaHHID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUnConfirmTypeMappingRequest extends IApiRequest {
    servizioHHId?: number;
    tipologiaHHID?: number;
}

export class UnlinkServizioH2HRequest extends ApiRequest implements IUnlinkServizioH2HRequest {
    servizioHHId?: number;

    constructor(data?: IUnlinkServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHHId = _data["servizioHHId"] !== undefined ? _data["servizioHHId"] : <any>null;
        }
    }

    static fromJS(data: any): UnlinkServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHHId"] = this.servizioHHId !== undefined ? this.servizioHHId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUnlinkServizioH2HRequest extends IApiRequest {
    servizioHHId?: number;
}

export class UpdateServizioH2HResponse extends OkApiResponse implements IUpdateServizioH2HResponse {
    servizio?: HHServizioAggregato | null;
    luogo?: string | null;

    constructor(data?: IUpdateServizioH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] ? HHServizioAggregato.fromJS(_data["servizio"]) : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateServizioH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServizioH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateServizioH2HResponse extends IOkApiResponse {
    servizio?: HHServizioAggregato | null;
    luogo?: string | null;
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export class UpdateServizioH2HRequest extends ApiRequest implements IUpdateServizioH2HRequest {
    servizioHH?: HHServizioAggregato | null;

    constructor(data?: IUpdateServizioH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioHH = _data["servizioHH"] ? HHServizioAggregato.fromJS(_data["servizioHH"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateServizioH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServizioH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioHH"] = this.servizioHH ? this.servizioHH.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe che rappresenta i parametri di ricerca della lista contatti */
export interface IUpdateServizioH2HRequest extends IApiRequest {
    servizioHH?: HHServizioAggregato | null;
}

export class UpdateDescriptionH2HResponse extends OkApiResponse implements IUpdateDescriptionH2HResponse {
    description?: HHDescrizione | null;

    constructor(data?: IUpdateDescriptionH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"] ? HHDescrizione.fromJS(_data["description"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateDescriptionH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDescriptionH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDescriptionH2HResponse extends IOkApiResponse {
    description?: HHDescrizione | null;
}

export class UpdateDescriptionH2HRequest extends ApiRequest implements IUpdateDescriptionH2HRequest {
    description?: HHDescrizione | null;

    constructor(data?: IUpdateDescriptionH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"] ? HHDescrizione.fromJS(_data["description"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateDescriptionH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDescriptionH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDescriptionH2HRequest extends IApiRequest {
    description?: HHDescrizione | null;
}

export class UpdateImageH2HResponse extends OkApiResponse implements IUpdateImageH2HResponse {
    image?: HHImmagine | null;

    constructor(data?: IUpdateImageH2HResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? HHImmagine.fromJS(_data["image"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateImageH2HResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImageH2HResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateImageH2HResponse extends IOkApiResponse {
    image?: HHImmagine | null;
}

export class UpdateImageH2HRequest extends ApiRequest implements IUpdateImageH2HRequest {
    image?: HHImmagine | null;

    constructor(data?: IUpdateImageH2HRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.image = _data["image"] ? HHImmagine.fromJS(_data["image"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateImageH2HRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImageH2HRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateImageH2HRequest extends IApiRequest {
    image?: HHImmagine | null;
}

export class GetSharedDocumentResponse extends OkApiResponse implements IGetSharedDocumentResponse {
    /** Entità del documento condiviso */
    documento?: DocumentoCondiviso;

    constructor(data?: IGetSharedDocumentResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documento = _data["documento"] ? DocumentoCondiviso.fromJS(_data["documento"]) : <any>null;
        }
    }

    static fromJS(data: any): GetSharedDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharedDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documento"] = this.documento ? this.documento.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSharedDocumentResponse extends IOkApiResponse {
    /** Entità del documento condiviso */
    documento?: DocumentoCondiviso;
}

export class GetSharedDocumentRequest extends LocalizedRequest implements IGetSharedDocumentRequest {
    /** ID del documento condiviso */
    documentoCondivisoID?: number;

    constructor(data?: IGetSharedDocumentRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoCondivisoID = _data["documentoCondivisoID"] !== undefined ? _data["documentoCondivisoID"] : <any>null;
        }
    }

    static fromJS(data: any): GetSharedDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharedDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoCondivisoID"] = this.documentoCondivisoID !== undefined ? this.documentoCondivisoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSharedDocumentRequest extends ILocalizedRequest {
    /** ID del documento condiviso */
    documentoCondivisoID?: number;
}

export class NrTableResponseOfSharedDocumentRow extends OkApiResponse implements INrTableResponseOfSharedDocumentRow {
    /** Array delle righe della pagina richiesta */
    rows?: SharedDocumentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSharedDocumentRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SharedDocumentRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfSharedDocumentRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSharedDocumentRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSharedDocumentRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SharedDocumentRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class GetSharedDocumentsListResponse extends NrTableResponseOfSharedDocumentRow implements IGetSharedDocumentsListResponse {

    constructor(data?: IGetSharedDocumentsListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetSharedDocumentsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharedDocumentsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetSharedDocumentsListResponse extends INrTableResponseOfSharedDocumentRow {
}

/** Rappresentazione di un documento allegato */
export class SharedDocumentRow implements ISharedDocumentRow {
    /** ID del documento */
    id?: number;
    /** True se l'allegato esiste (ancora...) */
    exists?: boolean;
    /** Nome dell'allegato */
    name?: string;
    /** Nome del servizio associato */
    servizio?: string | null;
    /** Nome del luogo associato */
    luogo?: string | null;
    /** Nome del luogo di destinazione associato */
    luogoDestinazione?: string | null;
    /** Nome del contatto associato */
    contatto?: string | null;
    /** Nome dell'accordo associato */
    accordo?: string | null;
    /** Se true è fuori range per data di pubblicazione / partenza */
    scaduto?: boolean;
    /** Dimensione del file associato */
    dimensioneFile?: number;
    /** Nome del file */
    nomeFile?: string | null;
    /** Content Type del file */
    contentType?: string | null;
    /** Url per il download (solo intranet!) */
    downloadUrl?: string | null;

    constructor(data?: ISharedDocumentRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.exists = _data["exists"] !== undefined ? _data["exists"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.luogoDestinazione = _data["luogoDestinazione"] !== undefined ? _data["luogoDestinazione"] : <any>null;
            this.contatto = _data["contatto"] !== undefined ? _data["contatto"] : <any>null;
            this.accordo = _data["accordo"] !== undefined ? _data["accordo"] : <any>null;
            this.scaduto = _data["scaduto"] !== undefined ? _data["scaduto"] : <any>null;
            this.dimensioneFile = _data["dimensioneFile"] !== undefined ? _data["dimensioneFile"] : <any>null;
            this.nomeFile = _data["nomeFile"] !== undefined ? _data["nomeFile"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
            this.downloadUrl = _data["downloadUrl"] !== undefined ? _data["downloadUrl"] : <any>null;
        }
    }

    static fromJS(data: any): SharedDocumentRow {
        data = typeof data === 'object' ? data : {};
        let result = new SharedDocumentRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["exists"] = this.exists !== undefined ? this.exists : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["luogoDestinazione"] = this.luogoDestinazione !== undefined ? this.luogoDestinazione : <any>null;
        data["contatto"] = this.contatto !== undefined ? this.contatto : <any>null;
        data["accordo"] = this.accordo !== undefined ? this.accordo : <any>null;
        data["scaduto"] = this.scaduto !== undefined ? this.scaduto : <any>null;
        data["dimensioneFile"] = this.dimensioneFile !== undefined ? this.dimensioneFile : <any>null;
        data["nomeFile"] = this.nomeFile !== undefined ? this.nomeFile : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        data["downloadUrl"] = this.downloadUrl !== undefined ? this.downloadUrl : <any>null;
        return data;
    }
}

/** Rappresentazione di un documento allegato */
export interface ISharedDocumentRow {
    /** ID del documento */
    id?: number;
    /** True se l'allegato esiste (ancora...) */
    exists?: boolean;
    /** Nome dell'allegato */
    name?: string;
    /** Nome del servizio associato */
    servizio?: string | null;
    /** Nome del luogo associato */
    luogo?: string | null;
    /** Nome del luogo di destinazione associato */
    luogoDestinazione?: string | null;
    /** Nome del contatto associato */
    contatto?: string | null;
    /** Nome dell'accordo associato */
    accordo?: string | null;
    /** Se true è fuori range per data di pubblicazione / partenza */
    scaduto?: boolean;
    /** Dimensione del file associato */
    dimensioneFile?: number;
    /** Nome del file */
    nomeFile?: string | null;
    /** Content Type del file */
    contentType?: string | null;
    /** Url per il download (solo intranet!) */
    downloadUrl?: string | null;
}

export class GetSharedDocumentsListRequest extends NrTableRequest implements IGetSharedDocumentsListRequest {
    /** Termine di ricerca oppure ID */
    term?: string | null;

    constructor(data?: IGetSharedDocumentsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
        }
    }

    static fromJS(data: any): GetSharedDocumentsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharedDocumentsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSharedDocumentsListRequest extends INrTableRequest {
    /** Termine di ricerca oppure ID */
    term?: string | null;
}

export class StatisticMonthSalesResponse extends OkApiResponse implements IStatisticMonthSalesResponse {
    table?: StatisticTable;
    preventiviPerc?: number;
    venditePerc?: number;
    partitoPerc?: number;

    constructor(data?: IStatisticMonthSalesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.table = _data["table"] ? StatisticTable.fromJS(_data["table"]) : <any>null;
            this.preventiviPerc = _data["preventiviPerc"] !== undefined ? _data["preventiviPerc"] : <any>null;
            this.venditePerc = _data["venditePerc"] !== undefined ? _data["venditePerc"] : <any>null;
            this.partitoPerc = _data["partitoPerc"] !== undefined ? _data["partitoPerc"] : <any>null;
        }
    }

    static fromJS(data: any): StatisticMonthSalesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticMonthSalesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table"] = this.table ? this.table.toJSON() : <any>null;
        data["preventiviPerc"] = this.preventiviPerc !== undefined ? this.preventiviPerc : <any>null;
        data["venditePerc"] = this.venditePerc !== undefined ? this.venditePerc : <any>null;
        data["partitoPerc"] = this.partitoPerc !== undefined ? this.partitoPerc : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticMonthSalesResponse extends IOkApiResponse {
    table?: StatisticTable;
    preventiviPerc?: number;
    venditePerc?: number;
    partitoPerc?: number;
}

export class StatisticMonthSalesRequest extends LocalizedRequest implements IStatisticMonthSalesRequest {
    operator?: EOperatore;
    dateLimit?: string;
    export?: boolean | null;

    constructor(data?: IStatisticMonthSalesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
            this.dateLimit = _data["dateLimit"] !== undefined ? _data["dateLimit"] : <any>null;
            this.export = _data["export"] !== undefined ? _data["export"] : <any>null;
        }
    }

    static fromJS(data: any): StatisticMonthSalesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticMonthSalesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        data["dateLimit"] = this.dateLimit !== undefined ? this.dateLimit : <any>null;
        data["export"] = this.export !== undefined ? this.export : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticMonthSalesRequest extends ILocalizedRequest {
    operator?: EOperatore;
    dateLimit?: string;
    export?: boolean | null;
}

export class QuotationsGetResponse extends OkApiResponse implements IQuotationsGetResponse {
    rows?: QuotationsRow[];
    totalSales?: number | null;
    totalQuotation?: number | null;
    percentage?: number | null;

    constructor(data?: IQuotationsGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(QuotationsRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.totalSales = _data["totalSales"] !== undefined ? _data["totalSales"] : <any>null;
            this.totalQuotation = _data["totalQuotation"] !== undefined ? _data["totalQuotation"] : <any>null;
            this.percentage = _data["percentage"] !== undefined ? _data["percentage"] : <any>null;
        }
    }

    static fromJS(data: any): QuotationsGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationsGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalSales"] = this.totalSales !== undefined ? this.totalSales : <any>null;
        data["totalQuotation"] = this.totalQuotation !== undefined ? this.totalQuotation : <any>null;
        data["percentage"] = this.percentage !== undefined ? this.percentage : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IQuotationsGetResponse extends IOkApiResponse {
    rows?: QuotationsRow[];
    totalSales?: number | null;
    totalQuotation?: number | null;
    percentage?: number | null;
}

export class QuotationsRow implements IQuotationsRow {
    id?: number;
    network?: string | null;
    regione?: string | null;
    citta?: string | null;
    provincia?: string | null;
    agenzia?: string | null;
    pax?: number | null;
    destinazione?: string | null;
    idOfferta?: number | null;
    descrizione?: string | null;
    creazione?: string | null;
    partenza?: string | null;
    conferma?: string | null;
    cancellazioneADV?: string | null;
    pag?: string | null;
    totale?: number | null;
    dirittiAgenzia?: number | null;
    commissioneAgenzia?: number | null;
    percentualeCommissione?: number | null;
    margineNetto?: number | null;
    tipoV?: string | null;
    catADV?: string | null;
    mailSpedizioneADV?: string | null;
    qtApPr?: number | null;
    wcys?: number | null;
    wcysPlus?: number | null;
    int100K?: number | null;
    int300K?: number | null;
    int500K?: number | null;
    int1000K?: number | null;
    blcPrz?: number | null;
    intComm?: number | null;
    tipoPrev?: string | null;
    sGruppo?: string | null;
    gestPreventivo?: string | null;
    gestConferma?: string | null;
    accVoucher?: number | null;

    constructor(data?: IQuotationsRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.network = _data["network"] !== undefined ? _data["network"] : <any>null;
            this.regione = _data["regione"] !== undefined ? _data["regione"] : <any>null;
            this.citta = _data["citta"] !== undefined ? _data["citta"] : <any>null;
            this.provincia = _data["provincia"] !== undefined ? _data["provincia"] : <any>null;
            this.agenzia = _data["agenzia"] !== undefined ? _data["agenzia"] : <any>null;
            this.pax = _data["pax"] !== undefined ? _data["pax"] : <any>null;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : <any>null;
            this.idOfferta = _data["idOfferta"] !== undefined ? _data["idOfferta"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : <any>null;
            this.cancellazioneADV = _data["cancellazioneADV"] !== undefined ? _data["cancellazioneADV"] : <any>null;
            this.pag = _data["pag"] !== undefined ? _data["pag"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.dirittiAgenzia = _data["dirittiAgenzia"] !== undefined ? _data["dirittiAgenzia"] : <any>null;
            this.commissioneAgenzia = _data["commissioneAgenzia"] !== undefined ? _data["commissioneAgenzia"] : <any>null;
            this.percentualeCommissione = _data["percentualeCommissione"] !== undefined ? _data["percentualeCommissione"] : <any>null;
            this.margineNetto = _data["margineNetto"] !== undefined ? _data["margineNetto"] : <any>null;
            this.tipoV = _data["tipoV"] !== undefined ? _data["tipoV"] : <any>null;
            this.catADV = _data["catADV"] !== undefined ? _data["catADV"] : <any>null;
            this.mailSpedizioneADV = _data["mailSpedizioneADV"] !== undefined ? _data["mailSpedizioneADV"] : <any>null;
            this.qtApPr = _data["qtApPr"] !== undefined ? _data["qtApPr"] : <any>null;
            this.wcys = _data["wcys"] !== undefined ? _data["wcys"] : <any>null;
            this.wcysPlus = _data["wcysPlus"] !== undefined ? _data["wcysPlus"] : <any>null;
            this.int100K = _data["int100K"] !== undefined ? _data["int100K"] : <any>null;
            this.int300K = _data["int300K"] !== undefined ? _data["int300K"] : <any>null;
            this.int500K = _data["int500K"] !== undefined ? _data["int500K"] : <any>null;
            this.int1000K = _data["int1000K"] !== undefined ? _data["int1000K"] : <any>null;
            this.blcPrz = _data["blcPrz"] !== undefined ? _data["blcPrz"] : <any>null;
            this.intComm = _data["intComm"] !== undefined ? _data["intComm"] : <any>null;
            this.tipoPrev = _data["tipoPrev"] !== undefined ? _data["tipoPrev"] : <any>null;
            this.sGruppo = _data["sGruppo"] !== undefined ? _data["sGruppo"] : <any>null;
            this.gestPreventivo = _data["gestPreventivo"] !== undefined ? _data["gestPreventivo"] : <any>null;
            this.gestConferma = _data["gestConferma"] !== undefined ? _data["gestConferma"] : <any>null;
            this.accVoucher = _data["accVoucher"] !== undefined ? _data["accVoucher"] : <any>null;
        }
    }

    static fromJS(data: any): QuotationsRow {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["network"] = this.network !== undefined ? this.network : <any>null;
        data["regione"] = this.regione !== undefined ? this.regione : <any>null;
        data["citta"] = this.citta !== undefined ? this.citta : <any>null;
        data["provincia"] = this.provincia !== undefined ? this.provincia : <any>null;
        data["agenzia"] = this.agenzia !== undefined ? this.agenzia : <any>null;
        data["pax"] = this.pax !== undefined ? this.pax : <any>null;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : <any>null;
        data["idOfferta"] = this.idOfferta !== undefined ? this.idOfferta : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["creazione"] = this.creazione !== undefined ? this.creazione : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["conferma"] = this.conferma !== undefined ? this.conferma : <any>null;
        data["cancellazioneADV"] = this.cancellazioneADV !== undefined ? this.cancellazioneADV : <any>null;
        data["pag"] = this.pag !== undefined ? this.pag : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["dirittiAgenzia"] = this.dirittiAgenzia !== undefined ? this.dirittiAgenzia : <any>null;
        data["commissioneAgenzia"] = this.commissioneAgenzia !== undefined ? this.commissioneAgenzia : <any>null;
        data["percentualeCommissione"] = this.percentualeCommissione !== undefined ? this.percentualeCommissione : <any>null;
        data["margineNetto"] = this.margineNetto !== undefined ? this.margineNetto : <any>null;
        data["tipoV"] = this.tipoV !== undefined ? this.tipoV : <any>null;
        data["catADV"] = this.catADV !== undefined ? this.catADV : <any>null;
        data["mailSpedizioneADV"] = this.mailSpedizioneADV !== undefined ? this.mailSpedizioneADV : <any>null;
        data["qtApPr"] = this.qtApPr !== undefined ? this.qtApPr : <any>null;
        data["wcys"] = this.wcys !== undefined ? this.wcys : <any>null;
        data["wcysPlus"] = this.wcysPlus !== undefined ? this.wcysPlus : <any>null;
        data["int100K"] = this.int100K !== undefined ? this.int100K : <any>null;
        data["int300K"] = this.int300K !== undefined ? this.int300K : <any>null;
        data["int500K"] = this.int500K !== undefined ? this.int500K : <any>null;
        data["int1000K"] = this.int1000K !== undefined ? this.int1000K : <any>null;
        data["blcPrz"] = this.blcPrz !== undefined ? this.blcPrz : <any>null;
        data["intComm"] = this.intComm !== undefined ? this.intComm : <any>null;
        data["tipoPrev"] = this.tipoPrev !== undefined ? this.tipoPrev : <any>null;
        data["sGruppo"] = this.sGruppo !== undefined ? this.sGruppo : <any>null;
        data["gestPreventivo"] = this.gestPreventivo !== undefined ? this.gestPreventivo : <any>null;
        data["gestConferma"] = this.gestConferma !== undefined ? this.gestConferma : <any>null;
        data["accVoucher"] = this.accVoucher !== undefined ? this.accVoucher : <any>null;
        return data;
    }
}

export interface IQuotationsRow {
    id?: number;
    network?: string | null;
    regione?: string | null;
    citta?: string | null;
    provincia?: string | null;
    agenzia?: string | null;
    pax?: number | null;
    destinazione?: string | null;
    idOfferta?: number | null;
    descrizione?: string | null;
    creazione?: string | null;
    partenza?: string | null;
    conferma?: string | null;
    cancellazioneADV?: string | null;
    pag?: string | null;
    totale?: number | null;
    dirittiAgenzia?: number | null;
    commissioneAgenzia?: number | null;
    percentualeCommissione?: number | null;
    margineNetto?: number | null;
    tipoV?: string | null;
    catADV?: string | null;
    mailSpedizioneADV?: string | null;
    qtApPr?: number | null;
    wcys?: number | null;
    wcysPlus?: number | null;
    int100K?: number | null;
    int300K?: number | null;
    int500K?: number | null;
    int1000K?: number | null;
    blcPrz?: number | null;
    intComm?: number | null;
    tipoPrev?: string | null;
    sGruppo?: string | null;
    gestPreventivo?: string | null;
    gestConferma?: string | null;
    accVoucher?: number | null;
}

export class QuotationsGetRequest extends ApiRequest implements IQuotationsGetRequest {
    operator!: EOperatore;
    departFrom!: string;
    departTo!: string;
    creationFrom!: string;
    creationTo!: string;
    confirmFrom?: string | null;
    confirmTo?: string | null;
    export?: boolean;

    constructor(data?: IQuotationsGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
            this.departFrom = _data["departFrom"] !== undefined ? _data["departFrom"] : <any>null;
            this.departTo = _data["departTo"] !== undefined ? _data["departTo"] : <any>null;
            this.creationFrom = _data["creationFrom"] !== undefined ? _data["creationFrom"] : <any>null;
            this.creationTo = _data["creationTo"] !== undefined ? _data["creationTo"] : <any>null;
            this.confirmFrom = _data["confirmFrom"] !== undefined ? _data["confirmFrom"] : <any>null;
            this.confirmTo = _data["confirmTo"] !== undefined ? _data["confirmTo"] : <any>null;
            this.export = _data["export"] !== undefined ? _data["export"] : <any>null;
        }
    }

    static fromJS(data: any): QuotationsGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationsGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        data["departFrom"] = this.departFrom !== undefined ? this.departFrom : <any>null;
        data["departTo"] = this.departTo !== undefined ? this.departTo : <any>null;
        data["creationFrom"] = this.creationFrom !== undefined ? this.creationFrom : <any>null;
        data["creationTo"] = this.creationTo !== undefined ? this.creationTo : <any>null;
        data["confirmFrom"] = this.confirmFrom !== undefined ? this.confirmFrom : <any>null;
        data["confirmTo"] = this.confirmTo !== undefined ? this.confirmTo : <any>null;
        data["export"] = this.export !== undefined ? this.export : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IQuotationsGetRequest extends IApiRequest {
    operator: EOperatore;
    departFrom: string;
    departTo: string;
    creationFrom: string;
    creationTo: string;
    confirmFrom?: string | null;
    confirmTo?: string | null;
    export?: boolean;
}

export class DeleteReportValuesResponse extends OkApiResponse implements IDeleteReportValuesResponse {
    savedValues?: ReportValoreSalvato[];

    constructor(data?: IDeleteReportValuesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["savedValues"])) {
                this.savedValues = [] as any;
                for (let item of _data["savedValues"])
                    this.savedValues!.push(ReportValoreSalvato.fromJS(item));
            }
            else {
                this.savedValues = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteReportValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteReportValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.savedValues)) {
            data["savedValues"] = [];
            for (let item of this.savedValues)
                data["savedValues"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteReportValuesResponse extends IOkApiResponse {
    savedValues?: ReportValoreSalvato[];
}

export class ReportValoreSalvato implements IReportValoreSalvato {
    id?: number;
    reportID?: number;
    nome!: string;
    valori!: string;

    constructor(data?: IReportValoreSalvato) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.reportID = _data["reportID"] !== undefined ? _data["reportID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.valori = _data["valori"] !== undefined ? _data["valori"] : <any>null;
        }
    }

    static fromJS(data: any): ReportValoreSalvato {
        data = typeof data === 'object' ? data : {};
        let result = new ReportValoreSalvato();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["reportID"] = this.reportID !== undefined ? this.reportID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["valori"] = this.valori !== undefined ? this.valori : <any>null;
        return data;
    }
}

export interface IReportValoreSalvato {
    id?: number;
    reportID?: number;
    nome: string;
    valori: string;
}

export class DeleteReportValuesRequest extends ApiRequest implements IDeleteReportValuesRequest {
    reportID?: number;
    valuesID?: number;

    constructor(data?: IDeleteReportValuesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reportID = _data["reportID"] !== undefined ? _data["reportID"] : <any>null;
            this.valuesID = _data["valuesID"] !== undefined ? _data["valuesID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteReportValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteReportValuesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportID"] = this.reportID !== undefined ? this.reportID : <any>null;
        data["valuesID"] = this.valuesID !== undefined ? this.valuesID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteReportValuesRequest extends IApiRequest {
    reportID?: number;
    valuesID?: number;
}

export class ReportExportRequest extends ApiRequest implements IReportExportRequest {
    reportID?: number;
    parameters?: ReportExportParameters[] | null;

    constructor(data?: IReportExportRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reportID = _data["reportID"] !== undefined ? _data["reportID"] : <any>null;
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ReportExportParameters.fromJS(item));
            }
            else {
                this.parameters = <any>null;
            }
        }
    }

    static fromJS(data: any): ReportExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportID"] = this.reportID !== undefined ? this.reportID : <any>null;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IReportExportRequest extends IApiRequest {
    reportID?: number;
    parameters?: ReportExportParameters[] | null;
}

export class ReportExportParameters implements IReportExportParameters {
    name?: string;
    value?: string | null;
    isArray?: boolean | null;

    constructor(data?: IReportExportParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.isArray = _data["isArray"] !== undefined ? _data["isArray"] : <any>null;
        }
    }

    static fromJS(data: any): ReportExportParameters {
        data = typeof data === 'object' ? data : {};
        let result = new ReportExportParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["isArray"] = this.isArray !== undefined ? this.isArray : <any>null;
        return data;
    }
}

export interface IReportExportParameters {
    name?: string;
    value?: string | null;
    isArray?: boolean | null;
}

export class NrTableResponseOfReportRow extends OkApiResponse implements INrTableResponseOfReportRow {
    /** Array delle righe della pagina richiesta */
    rows?: ReportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfReportRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ReportRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfReportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfReportRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: ReportRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class ReportsResponse extends NrTableResponseOfReportRow implements IReportsResponse {

    constructor(data?: IReportsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ReportsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReportsResponse extends INrTableResponseOfReportRow {
}

export class ReportRow implements IReportRow {
    id?: number;
    name?: string | null;
    enabled?: boolean;
    sentTime?: string | null;
    lastSent?: ReportSend | null;
    parameters?: any | null;
    savedValues?: ReportValoreSalvato[] | null;
    calendarMode?: EModalitaCalendarioAssicurazione;
    report?: Report | null;

    constructor(data?: IReportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : <any>null;
            this.sentTime = _data["sentTime"] !== undefined ? _data["sentTime"] : <any>null;
            this.lastSent = _data["lastSent"] ? ReportSend.fromJS(_data["lastSent"]) : <any>null;
            this.parameters = _data["parameters"] !== undefined ? _data["parameters"] : <any>null;
            if (Array.isArray(_data["savedValues"])) {
                this.savedValues = [] as any;
                for (let item of _data["savedValues"])
                    this.savedValues!.push(ReportValoreSalvato.fromJS(item));
            }
            else {
                this.savedValues = <any>null;
            }
            this.calendarMode = _data["calendarMode"] !== undefined ? _data["calendarMode"] : <any>null;
            this.report = _data["report"] ? Report.fromJS(_data["report"]) : <any>null;
        }
    }

    static fromJS(data: any): ReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new ReportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
        data["sentTime"] = this.sentTime !== undefined ? this.sentTime : <any>null;
        data["lastSent"] = this.lastSent ? this.lastSent.toJSON() : <any>null;
        data["parameters"] = this.parameters !== undefined ? this.parameters : <any>null;
        if (Array.isArray(this.savedValues)) {
            data["savedValues"] = [];
            for (let item of this.savedValues)
                data["savedValues"].push(item.toJSON());
        }
        data["calendarMode"] = this.calendarMode !== undefined ? this.calendarMode : <any>null;
        data["report"] = this.report ? this.report.toJSON() : <any>null;
        return data;
    }
}

export interface IReportRow {
    id?: number;
    name?: string | null;
    enabled?: boolean;
    sentTime?: string | null;
    lastSent?: ReportSend | null;
    parameters?: any | null;
    savedValues?: ReportValoreSalvato[] | null;
    calendarMode?: EModalitaCalendarioAssicurazione;
    report?: Report | null;
}

export class ReportInvio implements IReportInvio {
    id?: number;
    reportID?: number;
    data?: string;
    esito?: EEsitoInvioAssicurazione;
    jsonData?: string | null;
    messaggio?: string | null;

    constructor(data?: IReportInvio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.reportID = _data["reportID"] !== undefined ? _data["reportID"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.esito = _data["esito"] !== undefined ? _data["esito"] : <any>null;
            this.jsonData = _data["jsonData"] !== undefined ? _data["jsonData"] : <any>null;
            this.messaggio = _data["messaggio"] !== undefined ? _data["messaggio"] : <any>null;
        }
    }

    static fromJS(data: any): ReportInvio {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInvio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["reportID"] = this.reportID !== undefined ? this.reportID : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["esito"] = this.esito !== undefined ? this.esito : <any>null;
        data["jsonData"] = this.jsonData !== undefined ? this.jsonData : <any>null;
        data["messaggio"] = this.messaggio !== undefined ? this.messaggio : <any>null;
        return data;
    }
}

export interface IReportInvio {
    id?: number;
    reportID?: number;
    data?: string;
    esito?: EEsitoInvioAssicurazione;
    jsonData?: string | null;
    messaggio?: string | null;
}

export class ReportSend extends ReportInvio implements IReportSend {
    reportEmails?: ReportSendEmail[] | null;

    constructor(data?: IReportSend) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["reportEmails"])) {
                this.reportEmails = [] as any;
                for (let item of _data["reportEmails"])
                    this.reportEmails!.push(ReportSendEmail.fromJS(item));
            }
            else {
                this.reportEmails = <any>null;
            }
        }
    }

    static fromJS(data: any): ReportSend {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportEmails)) {
            data["reportEmails"] = [];
            for (let item of this.reportEmails)
                data["reportEmails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IReportSend extends IReportInvio {
    reportEmails?: ReportSendEmail[] | null;
}

export class ReportSendEmail implements IReportSendEmail {
    emailID?: number;
    recipients?: ReportSendEmailRecipient[];

    constructor(data?: IReportSendEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailID = _data["emailID"] !== undefined ? _data["emailID"] : <any>null;
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(ReportSendEmailRecipient.fromJS(item));
            }
            else {
                this.recipients = <any>null;
            }
        }
    }

    static fromJS(data: any): ReportSendEmail {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSendEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailID"] = this.emailID !== undefined ? this.emailID : <any>null;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportSendEmail {
    emailID?: number;
    recipients?: ReportSendEmailRecipient[];
}

export class ReportSendEmailRecipient implements IReportSendEmailRecipient {
    address?: string | null;
    name?: string | null;

    constructor(data?: IReportSendEmailRecipient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ReportSendEmailRecipient {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSendEmailRecipient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IReportSendEmailRecipient {
    address?: string | null;
    name?: string | null;
}

export class Report implements IReport {
    id?: number;
    codice!: string;
    codiceTemplateEmail!: string;
    nome!: string;
    abilitato?: boolean;
    modalitaCalendario?: EModalitaCalendarioAssicurazione;
    permissions?: string | null;
    query?: string | null;
    parametri?: string | null;
    orarioInvio!: string;
    oraInvio?: number;
    minutoInvio?: number;

    constructor(data?: IReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.codiceTemplateEmail = _data["codiceTemplateEmail"] !== undefined ? _data["codiceTemplateEmail"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.abilitato = _data["abilitato"] !== undefined ? _data["abilitato"] : <any>null;
            this.modalitaCalendario = _data["modalitaCalendario"] !== undefined ? _data["modalitaCalendario"] : <any>null;
            this.permissions = _data["permissions"] !== undefined ? _data["permissions"] : <any>null;
            this.query = _data["query"] !== undefined ? _data["query"] : <any>null;
            this.parametri = _data["parametri"] !== undefined ? _data["parametri"] : <any>null;
            this.orarioInvio = _data["orarioInvio"] !== undefined ? _data["orarioInvio"] : <any>null;
            this.oraInvio = _data["oraInvio"] !== undefined ? _data["oraInvio"] : <any>null;
            this.minutoInvio = _data["minutoInvio"] !== undefined ? _data["minutoInvio"] : <any>null;
        }
    }

    static fromJS(data: any): Report {
        data = typeof data === 'object' ? data : {};
        let result = new Report();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["codiceTemplateEmail"] = this.codiceTemplateEmail !== undefined ? this.codiceTemplateEmail : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["abilitato"] = this.abilitato !== undefined ? this.abilitato : <any>null;
        data["modalitaCalendario"] = this.modalitaCalendario !== undefined ? this.modalitaCalendario : <any>null;
        data["permissions"] = this.permissions !== undefined ? this.permissions : <any>null;
        data["query"] = this.query !== undefined ? this.query : <any>null;
        data["parametri"] = this.parametri !== undefined ? this.parametri : <any>null;
        data["orarioInvio"] = this.orarioInvio !== undefined ? this.orarioInvio : <any>null;
        data["oraInvio"] = this.oraInvio !== undefined ? this.oraInvio : <any>null;
        data["minutoInvio"] = this.minutoInvio !== undefined ? this.minutoInvio : <any>null;
        return data;
    }
}

export interface IReport {
    id?: number;
    codice: string;
    codiceTemplateEmail: string;
    nome: string;
    abilitato?: boolean;
    modalitaCalendario?: EModalitaCalendarioAssicurazione;
    permissions?: string | null;
    query?: string | null;
    parametri?: string | null;
    orarioInvio: string;
    oraInvio?: number;
    minutoInvio?: number;
}

export class ReportsRequest extends NrTableRequest implements IReportsRequest {
    name?: string | null;

    constructor(data?: IReportsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ReportsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IReportsRequest extends INrTableRequest {
    name?: string | null;
}

export class SaveReportValuesResponse extends OkApiResponse implements ISaveReportValuesResponse {
    savedValues?: ReportValoreSalvato[];

    constructor(data?: ISaveReportValuesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["savedValues"])) {
                this.savedValues = [] as any;
                for (let item of _data["savedValues"])
                    this.savedValues!.push(ReportValoreSalvato.fromJS(item));
            }
            else {
                this.savedValues = <any>null;
            }
        }
    }

    static fromJS(data: any): SaveReportValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveReportValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.savedValues)) {
            data["savedValues"] = [];
            for (let item of this.savedValues)
                data["savedValues"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISaveReportValuesResponse extends IOkApiResponse {
    savedValues?: ReportValoreSalvato[];
}

export class SaveReportValuesRequest extends ApiRequest implements ISaveReportValuesRequest {
    reportID?: number;
    valuesID?: number | null;
    name?: string | null;
    values?: string | null;

    constructor(data?: ISaveReportValuesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reportID = _data["reportID"] !== undefined ? _data["reportID"] : <any>null;
            this.valuesID = _data["valuesID"] !== undefined ? _data["valuesID"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.values = _data["values"] !== undefined ? _data["values"] : <any>null;
        }
    }

    static fromJS(data: any): SaveReportValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveReportValuesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportID"] = this.reportID !== undefined ? this.reportID : <any>null;
        data["valuesID"] = this.valuesID !== undefined ? this.valuesID : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["values"] = this.values !== undefined ? this.values : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISaveReportValuesRequest extends IApiRequest {
    reportID?: number;
    valuesID?: number | null;
    name?: string | null;
    values?: string | null;
}

export class StatisticResultResponse extends OkApiResponse implements IStatisticResultResponse {
    table?: StatisticTable;

    constructor(data?: IStatisticResultResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.table = _data["table"] ? StatisticTable.fromJS(_data["table"]) : <any>null;
        }
    }

    static fromJS(data: any): StatisticResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table"] = this.table ? this.table.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticResultResponse extends IOkApiResponse {
    table?: StatisticTable;
}

export class StatisticResultRequest extends LocalizedRequest implements IStatisticResultRequest {
    statisticID?: number;
    parameters?: string | null;
    export?: boolean | null;

    constructor(data?: IStatisticResultRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statisticID = _data["statisticID"] !== undefined ? _data["statisticID"] : <any>null;
            this.parameters = _data["parameters"] !== undefined ? _data["parameters"] : <any>null;
            this.export = _data["export"] !== undefined ? _data["export"] : <any>null;
        }
    }

    static fromJS(data: any): StatisticResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticResultRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statisticID"] = this.statisticID !== undefined ? this.statisticID : <any>null;
        data["parameters"] = this.parameters !== undefined ? this.parameters : <any>null;
        data["export"] = this.export !== undefined ? this.export : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticResultRequest extends ILocalizedRequest {
    statisticID?: number;
    parameters?: string | null;
    export?: boolean | null;
}

export class NrTableResponseOfSalesDetailsRow extends OkApiResponse implements INrTableResponseOfSalesDetailsRow {
    /** Array delle righe della pagina richiesta */
    rows?: SalesDetailsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSalesDetailsRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SalesDetailsRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfSalesDetailsRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSalesDetailsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSalesDetailsRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SalesDetailsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SalesDetailsResponse extends NrTableResponseOfSalesDetailsRow implements ISalesDetailsResponse {

    constructor(data?: ISalesDetailsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SalesDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SalesDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISalesDetailsResponse extends INrTableResponseOfSalesDetailsRow {
}

export class SalesDetailsRow implements ISalesDetailsRow {
    id?: number;
    descrizione?: string | null;
    totale?: number | null;
    riferimento?: number;
    creazione?: string | null;
    partenza?: string | null;
    conferma?: string | null;
    impiegato?: string | null;
    addetto?: string | null;

    constructor(data?: ISalesDetailsRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.riferimento = _data["riferimento"] !== undefined ? _data["riferimento"] : <any>null;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.conferma = _data["conferma"] !== undefined ? _data["conferma"] : <any>null;
            this.impiegato = _data["impiegato"] !== undefined ? _data["impiegato"] : <any>null;
            this.addetto = _data["addetto"] !== undefined ? _data["addetto"] : <any>null;
        }
    }

    static fromJS(data: any): SalesDetailsRow {
        data = typeof data === 'object' ? data : {};
        let result = new SalesDetailsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["riferimento"] = this.riferimento !== undefined ? this.riferimento : <any>null;
        data["creazione"] = this.creazione !== undefined ? this.creazione : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["conferma"] = this.conferma !== undefined ? this.conferma : <any>null;
        data["impiegato"] = this.impiegato !== undefined ? this.impiegato : <any>null;
        data["addetto"] = this.addetto !== undefined ? this.addetto : <any>null;
        return data;
    }
}

export interface ISalesDetailsRow {
    id?: number;
    descrizione?: string | null;
    totale?: number | null;
    riferimento?: number;
    creazione?: string | null;
    partenza?: string | null;
    conferma?: string | null;
    impiegato?: string | null;
    addetto?: string | null;
}

export class SalesDetailsRequest extends NrTableRequest implements ISalesDetailsRequest {
    agencyID?: number;
    departFrom?: string | null;
    departTo?: string | null;
    quotationFrom?: string | null;
    quotationTo?: string | null;

    constructor(data?: ISalesDetailsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agencyID = _data["agencyID"] !== undefined ? _data["agencyID"] : <any>null;
            this.departFrom = _data["departFrom"] !== undefined ? _data["departFrom"] : <any>null;
            this.departTo = _data["departTo"] !== undefined ? _data["departTo"] : <any>null;
            this.quotationFrom = _data["quotationFrom"] !== undefined ? _data["quotationFrom"] : <any>null;
            this.quotationTo = _data["quotationTo"] !== undefined ? _data["quotationTo"] : <any>null;
        }
    }

    static fromJS(data: any): SalesDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SalesDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyID"] = this.agencyID !== undefined ? this.agencyID : <any>null;
        data["departFrom"] = this.departFrom !== undefined ? this.departFrom : <any>null;
        data["departTo"] = this.departTo !== undefined ? this.departTo : <any>null;
        data["quotationFrom"] = this.quotationFrom !== undefined ? this.quotationFrom : <any>null;
        data["quotationTo"] = this.quotationTo !== undefined ? this.quotationTo : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISalesDetailsRequest extends INrTableRequest {
    agencyID?: number;
    departFrom?: string | null;
    departTo?: string | null;
    quotationFrom?: string | null;
    quotationTo?: string | null;
}

export class SalesGetResponse extends OkApiResponse implements ISalesGetResponse {
    table?: StatisticTable;
    totalQuotation?: number | null;
    totalSales?: number | null;
    avaragePercent?: number | null;
    totalNQuotation?: number | null;
    totalNSales?: number | null;
    avarageNPercent?: number | null;

    constructor(data?: ISalesGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.table = _data["table"] ? StatisticTable.fromJS(_data["table"]) : <any>null;
            this.totalQuotation = _data["totalQuotation"] !== undefined ? _data["totalQuotation"] : <any>null;
            this.totalSales = _data["totalSales"] !== undefined ? _data["totalSales"] : <any>null;
            this.avaragePercent = _data["avaragePercent"] !== undefined ? _data["avaragePercent"] : <any>null;
            this.totalNQuotation = _data["totalNQuotation"] !== undefined ? _data["totalNQuotation"] : <any>null;
            this.totalNSales = _data["totalNSales"] !== undefined ? _data["totalNSales"] : <any>null;
            this.avarageNPercent = _data["avarageNPercent"] !== undefined ? _data["avarageNPercent"] : <any>null;
        }
    }

    static fromJS(data: any): SalesGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SalesGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table"] = this.table ? this.table.toJSON() : <any>null;
        data["totalQuotation"] = this.totalQuotation !== undefined ? this.totalQuotation : <any>null;
        data["totalSales"] = this.totalSales !== undefined ? this.totalSales : <any>null;
        data["avaragePercent"] = this.avaragePercent !== undefined ? this.avaragePercent : <any>null;
        data["totalNQuotation"] = this.totalNQuotation !== undefined ? this.totalNQuotation : <any>null;
        data["totalNSales"] = this.totalNSales !== undefined ? this.totalNSales : <any>null;
        data["avarageNPercent"] = this.avarageNPercent !== undefined ? this.avarageNPercent : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISalesGetResponse extends IOkApiResponse {
    table?: StatisticTable;
    totalQuotation?: number | null;
    totalSales?: number | null;
    avaragePercent?: number | null;
    totalNQuotation?: number | null;
    totalNSales?: number | null;
    avarageNPercent?: number | null;
}

export class SalesGetRequest extends ApiRequest implements ISalesGetRequest {
    operator!: EOperatore;
    name?: string | null;
    region?: string | null;
    city?: string | null;
    cap?: string | null;
    province?: string | null;
    departFrom!: string;
    departTo!: string;
    quotationFrom!: string;
    quotationTo!: string;
    export?: boolean;

    constructor(data?: ISalesGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.region = _data["region"] !== undefined ? _data["region"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.cap = _data["cap"] !== undefined ? _data["cap"] : <any>null;
            this.province = _data["province"] !== undefined ? _data["province"] : <any>null;
            this.departFrom = _data["departFrom"] !== undefined ? _data["departFrom"] : <any>null;
            this.departTo = _data["departTo"] !== undefined ? _data["departTo"] : <any>null;
            this.quotationFrom = _data["quotationFrom"] !== undefined ? _data["quotationFrom"] : <any>null;
            this.quotationTo = _data["quotationTo"] !== undefined ? _data["quotationTo"] : <any>null;
            this.export = _data["export"] !== undefined ? _data["export"] : <any>null;
        }
    }

    static fromJS(data: any): SalesGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SalesGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["region"] = this.region !== undefined ? this.region : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["cap"] = this.cap !== undefined ? this.cap : <any>null;
        data["province"] = this.province !== undefined ? this.province : <any>null;
        data["departFrom"] = this.departFrom !== undefined ? this.departFrom : <any>null;
        data["departTo"] = this.departTo !== undefined ? this.departTo : <any>null;
        data["quotationFrom"] = this.quotationFrom !== undefined ? this.quotationFrom : <any>null;
        data["quotationTo"] = this.quotationTo !== undefined ? this.quotationTo : <any>null;
        data["export"] = this.export !== undefined ? this.export : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISalesGetRequest extends IApiRequest {
    operator: EOperatore;
    name?: string | null;
    region?: string | null;
    city?: string | null;
    cap?: string | null;
    province?: string | null;
    departFrom: string;
    departTo: string;
    quotationFrom: string;
    quotationTo: string;
    export?: boolean;
}

export class StatisticsAllResponse extends OkApiResponse implements IStatisticsAllResponse {
    statistics?: StatisticsRow[];

    constructor(data?: IStatisticsAllResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["statistics"])) {
                this.statistics = [] as any;
                for (let item of _data["statistics"])
                    this.statistics!.push(StatisticsRow.fromJS(item));
            }
            else {
                this.statistics = <any>null;
            }
        }
    }

    static fromJS(data: any): StatisticsAllResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsAllResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statistics)) {
            data["statistics"] = [];
            for (let item of this.statistics)
                data["statistics"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticsAllResponse extends IOkApiResponse {
    statistics?: StatisticsRow[];
}

export class StatisticsRow implements IStatisticsRow {
    id?: number;
    name?: string;
    alias?: string;
    statistica?: Statistica | null;

    constructor(data?: IStatisticsRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.statistica = _data["statistica"] ? Statistica.fromJS(_data["statistica"]) : <any>null;
        }
    }

    static fromJS(data: any): StatisticsRow {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["statistica"] = this.statistica ? this.statistica.toJSON() : <any>null;
        return data;
    }
}

export interface IStatisticsRow {
    id?: number;
    name?: string;
    alias?: string;
    statistica?: Statistica | null;
}

export class Statistica implements IStatistica {
    id?: number;
    nome!: string;
    alias?: string;
    query?: string;
    tipo?: number | null;

    constructor(data?: IStatistica) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.alias = _data["alias"] !== undefined ? _data["alias"] : <any>null;
            this.query = _data["query"] !== undefined ? _data["query"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
        }
    }

    static fromJS(data: any): Statistica {
        data = typeof data === 'object' ? data : {};
        let result = new Statistica();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["alias"] = this.alias !== undefined ? this.alias : <any>null;
        data["query"] = this.query !== undefined ? this.query : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        return data;
    }
}

export interface IStatistica {
    id?: number;
    nome: string;
    alias?: string;
    query?: string;
    tipo?: number | null;
}

export class StatisticsAllRequest extends LocalizedRequest implements IStatisticsAllRequest {

    constructor(data?: IStatisticsAllRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): StatisticsAllRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsAllRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticsAllRequest extends ILocalizedRequest {
}

export class StatisticGetResponse extends OkApiResponse implements IStatisticGetResponse {
    statistic?: Statistica | null;

    constructor(data?: IStatisticGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statistic = _data["statistic"] ? Statistica.fromJS(_data["statistic"]) : <any>null;
        }
    }

    static fromJS(data: any): StatisticGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statistic"] = this.statistic ? this.statistic.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticGetResponse extends IOkApiResponse {
    statistic?: Statistica | null;
}

export class StatisticGetRequest extends LocalizedRequest implements IStatisticGetRequest {
    statisticID?: number;

    constructor(data?: IStatisticGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statisticID = _data["statisticID"] !== undefined ? _data["statisticID"] : <any>null;
        }
    }

    static fromJS(data: any): StatisticGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statisticID"] = this.statisticID !== undefined ? this.statisticID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticGetRequest extends ILocalizedRequest {
    statisticID?: number;
}

export class StatisticUpdateRequest extends StatisticGetRequest implements IStatisticUpdateRequest {
    statistic?: Statistica | null;

    constructor(data?: IStatisticUpdateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statistic = _data["statistic"] ? Statistica.fromJS(_data["statistic"]) : <any>null;
        }
    }

    static fromJS(data: any): StatisticUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statistic"] = this.statistic ? this.statistic.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticUpdateRequest extends IStatisticGetRequest {
    statistic?: Statistica | null;
}

export class StatisticDeleteRequest extends LocalizedRequest implements IStatisticDeleteRequest {
    statisticID?: number;

    constructor(data?: IStatisticDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statisticID = _data["statisticID"] !== undefined ? _data["statisticID"] : <any>null;
        }
    }

    static fromJS(data: any): StatisticDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statisticID"] = this.statisticID !== undefined ? this.statisticID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticDeleteRequest extends ILocalizedRequest {
    statisticID?: number;
}

export class NrTableResponseOfStatisticsRow extends OkApiResponse implements INrTableResponseOfStatisticsRow {
    /** Array delle righe della pagina richiesta */
    rows?: StatisticsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfStatisticsRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(StatisticsRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfStatisticsRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfStatisticsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfStatisticsRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: StatisticsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class StatisticsListResponse extends NrTableResponseOfStatisticsRow implements IStatisticsListResponse {

    constructor(data?: IStatisticsListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): StatisticsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticsListResponse extends INrTableResponseOfStatisticsRow {
}

export class StatisticsListRequest extends NrTableRequest implements IStatisticsListRequest {
    name?: string | null;

    constructor(data?: IStatisticsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): StatisticsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IStatisticsListRequest extends INrTableRequest {
    name?: string | null;
}

export class SynchTripRequest extends ApiRequest implements ISynchTripRequest {
    offertaID?: number;

    constructor(data?: ISynchTripRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
        }
    }

    static fromJS(data: any): SynchTripRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISynchTripRequest extends IApiRequest {
    offertaID?: number;
}

export class SynchTripMidocoRequest extends SynchTripRequest implements ISynchTripMidocoRequest {

    constructor(data?: ISynchTripMidocoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SynchTripMidocoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripMidocoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISynchTripMidocoRequest extends ISynchTripRequest {
}

export class SynchTripBosysRequest extends SynchTripRequest implements ISynchTripBosysRequest {

    constructor(data?: ISynchTripBosysRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SynchTripBosysRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripBosysRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISynchTripBosysRequest extends ISynchTripRequest {
}

export class SystemEmailGetResponse extends OkApiResponse implements ISystemEmailGetResponse {
    email?: SystemEmailRow2 | null;

    constructor(data?: ISystemEmailGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] ? SystemEmailRow2.fromJS(_data["email"]) : <any>null;
        }
    }

    static fromJS(data: any): SystemEmailGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email ? this.email.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailGetResponse extends IOkApiResponse {
    email?: SystemEmailRow2 | null;
}

export class SystemEmailRow2 implements ISystemEmailRow2 {
    id?: number;
    code?: string;
    operator?: EOperatore;
    hasDynamicBody?: boolean;
    hasDynamicRecipient?: boolean;
    isHtmlBody?: boolean;
    name?: string;
    texts?: SystemEmailTextRow2[];
    deleted?: boolean;

    constructor(data?: ISystemEmailRow2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
            this.hasDynamicBody = _data["hasDynamicBody"] !== undefined ? _data["hasDynamicBody"] : <any>null;
            this.hasDynamicRecipient = _data["hasDynamicRecipient"] !== undefined ? _data["hasDynamicRecipient"] : <any>null;
            this.isHtmlBody = _data["isHtmlBody"] !== undefined ? _data["isHtmlBody"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["texts"])) {
                this.texts = [] as any;
                for (let item of _data["texts"])
                    this.texts!.push(SystemEmailTextRow2.fromJS(item));
            }
            else {
                this.texts = <any>null;
            }
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
        }
    }

    static fromJS(data: any): SystemEmailRow2 {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailRow2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        data["hasDynamicBody"] = this.hasDynamicBody !== undefined ? this.hasDynamicBody : <any>null;
        data["hasDynamicRecipient"] = this.hasDynamicRecipient !== undefined ? this.hasDynamicRecipient : <any>null;
        data["isHtmlBody"] = this.isHtmlBody !== undefined ? this.isHtmlBody : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.texts)) {
            data["texts"] = [];
            for (let item of this.texts)
                data["texts"].push(item.toJSON());
        }
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        return data;
    }
}

export interface ISystemEmailRow2 {
    id?: number;
    code?: string;
    operator?: EOperatore;
    hasDynamicBody?: boolean;
    hasDynamicRecipient?: boolean;
    isHtmlBody?: boolean;
    name?: string;
    texts?: SystemEmailTextRow2[];
    deleted?: boolean;
}

export class SystemEmailTextRow2 implements ISystemEmailTextRow2 {
    id?: number;
    body?: string | null;
    language?: ELingua;
    senderAddress?: string | null;
    senderName?: string | null;
    subject?: string | null;
    addresses?: SystemEmailAddress[];

    constructor(data?: ISystemEmailTextRow2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.body = _data["body"] !== undefined ? _data["body"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.senderAddress = _data["senderAddress"] !== undefined ? _data["senderAddress"] : <any>null;
            this.senderName = _data["senderName"] !== undefined ? _data["senderName"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(SystemEmailAddress.fromJS(item));
            }
            else {
                this.addresses = <any>null;
            }
        }
    }

    static fromJS(data: any): SystemEmailTextRow2 {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailTextRow2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["body"] = this.body !== undefined ? this.body : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["senderAddress"] = this.senderAddress !== undefined ? this.senderAddress : <any>null;
        data["senderName"] = this.senderName !== undefined ? this.senderName : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISystemEmailTextRow2 {
    id?: number;
    body?: string | null;
    language?: ELingua;
    senderAddress?: string | null;
    senderName?: string | null;
    subject?: string | null;
    addresses?: SystemEmailAddress[];
}

export class SystemEmailGetRequest extends ApiRequest implements ISystemEmailGetRequest {
    emailID?: number;

    constructor(data?: ISystemEmailGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailID = _data["emailID"] !== undefined ? _data["emailID"] : <any>null;
        }
    }

    static fromJS(data: any): SystemEmailGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailID"] = this.emailID !== undefined ? this.emailID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailGetRequest extends IApiRequest {
    emailID?: number;
}

export class SystemEmailUpdateRequest extends SystemEmailGetRequest implements ISystemEmailUpdateRequest {
    email?: SystemEmailRow2 | null;

    constructor(data?: ISystemEmailUpdateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] ? SystemEmailRow2.fromJS(_data["email"]) : <any>null;
        }
    }

    static fromJS(data: any): SystemEmailUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email ? this.email.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailUpdateRequest extends ISystemEmailGetRequest {
    email?: SystemEmailRow2 | null;
}

export class SystemEmailCreateRequest extends SystemEmailUpdateRequest implements ISystemEmailCreateRequest {

    constructor(data?: ISystemEmailCreateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SystemEmailCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailCreateRequest extends ISystemEmailUpdateRequest {
}

export class SystemEmailDeleteRequest extends SystemEmailGetRequest implements ISystemEmailDeleteRequest {

    constructor(data?: ISystemEmailDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SystemEmailDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailDeleteRequest extends ISystemEmailGetRequest {
}

export class NrTableResponseOfSystemEmailRow extends OkApiResponse implements INrTableResponseOfSystemEmailRow {
    /** Array delle righe della pagina richiesta */
    rows?: SystemEmailRow2[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfSystemEmailRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SystemEmailRow2.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfSystemEmailRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfSystemEmailRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfSystemEmailRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: SystemEmailRow2[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class SystemEmailListResponse extends NrTableResponseOfSystemEmailRow implements ISystemEmailListResponse {

    constructor(data?: ISystemEmailListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SystemEmailListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailListResponse extends INrTableResponseOfSystemEmailRow {
}

export class SystemEmailListRequest extends NrTableRequest implements ISystemEmailListRequest {
    showDeleted?: boolean;
    term?: string | null;
    name?: string | null;
    operator?: EOperatore | null;

    constructor(data?: ISystemEmailListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.showDeleted = _data["showDeleted"] !== undefined ? _data["showDeleted"] : <any>null;
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
        }
    }

    static fromJS(data: any): SystemEmailListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showDeleted"] = this.showDeleted !== undefined ? this.showDeleted : <any>null;
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailListRequest extends INrTableRequest {
    showDeleted?: boolean;
    term?: string | null;
    name?: string | null;
    operator?: EOperatore | null;
}

export class SystemEmailRestoreRequest extends SystemEmailGetRequest implements ISystemEmailRestoreRequest {

    constructor(data?: ISystemEmailRestoreRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SystemEmailRestoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailRestoreRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailRestoreRequest extends ISystemEmailGetRequest {
}

export class SystemEmailUpdateResponse extends SystemEmailGetResponse implements ISystemEmailUpdateResponse {

    constructor(data?: ISystemEmailUpdateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SystemEmailUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEmailUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISystemEmailUpdateResponse extends ISystemEmailGetResponse {
}

export class GetTasksLogsResponse extends OkApiResponse implements IGetTasksLogsResponse {
    logs?: TaskLogInfo[];

    constructor(data?: IGetTasksLogsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(TaskLogInfo.fromJS(item));
            }
            else {
                this.logs = <any>null;
            }
        }
    }

    static fromJS(data: any): GetTasksLogsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTasksLogsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTasksLogsResponse extends IOkApiResponse {
    logs?: TaskLogInfo[];
}

export class TaskLogInfo implements ITaskLogInfo {
    id?: number;
    taskLog?: TaskLog;
    operations?: TaskLogOperationInfo[];

    constructor(data?: ITaskLogInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.taskLog = _data["taskLog"] ? TaskLog.fromJS(_data["taskLog"]) : <any>null;
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(TaskLogOperationInfo.fromJS(item));
            }
            else {
                this.operations = <any>null;
            }
        }
    }

    static fromJS(data: any): TaskLogInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLogInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["taskLog"] = this.taskLog ? this.taskLog.toJSON() : <any>null;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskLogInfo {
    id?: number;
    taskLog?: TaskLog;
    operations?: TaskLogOperationInfo[];
}

export class TaskLog implements ITaskLog {
    id?: number;
    operationType?: ETaskOperationType;
    starterProcess?: ETaskProcess;
    createdAt?: string;
    updatedAt?: string;
    status?: ETaskStatus;
    tripID?: number | null;
    tripRowID?: number | null;
    deleteAfter?: string | null;

    constructor(data?: ITaskLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.operationType = _data["operationType"] !== undefined ? _data["operationType"] : <any>null;
            this.starterProcess = _data["starterProcess"] !== undefined ? _data["starterProcess"] : <any>null;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
            this.tripRowID = _data["tripRowID"] !== undefined ? _data["tripRowID"] : <any>null;
            this.deleteAfter = _data["deleteAfter"] !== undefined ? _data["deleteAfter"] : <any>null;
        }
    }

    static fromJS(data: any): TaskLog {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["operationType"] = this.operationType !== undefined ? this.operationType : <any>null;
        data["starterProcess"] = this.starterProcess !== undefined ? this.starterProcess : <any>null;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        data["tripRowID"] = this.tripRowID !== undefined ? this.tripRowID : <any>null;
        data["deleteAfter"] = this.deleteAfter !== undefined ? this.deleteAfter : <any>null;
        return data;
    }
}

export interface ITaskLog {
    id?: number;
    operationType?: ETaskOperationType;
    starterProcess?: ETaskProcess;
    createdAt?: string;
    updatedAt?: string;
    status?: ETaskStatus;
    tripID?: number | null;
    tripRowID?: number | null;
    deleteAfter?: string | null;
}

export enum ETaskOperationType {
    PriceVerify = "PriceVerify",
    Booking = "Booking",
}

export enum ETaskProcess {
    API = "API",
    Pricer = "Pricer",
    Functions = "Functions",
    Lrt = "Lrt",
    Agent = "Agent",
    DataManager = "DataManager",
    CacheFiller = "CacheFiller",
}

export enum ETaskStatus {
    Ready = "Ready",
    Running = "Running",
    Ok = "Ok",
    Fail = "Fail",
}

export class TaskLogOperationInfo implements ITaskLogOperationInfo {
    hasAttachment?: boolean;
    id?: number;
    logOperation?: TaskLogOperation;
    attachment?: TaskLogAttachment | null;

    constructor(data?: ITaskLogOperationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAttachment = _data["hasAttachment"] !== undefined ? _data["hasAttachment"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.logOperation = _data["logOperation"] ? TaskLogOperation.fromJS(_data["logOperation"]) : <any>null;
            this.attachment = _data["attachment"] ? TaskLogAttachment.fromJS(_data["attachment"]) : <any>null;
        }
    }

    static fromJS(data: any): TaskLogOperationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLogOperationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAttachment"] = this.hasAttachment !== undefined ? this.hasAttachment : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["logOperation"] = this.logOperation ? this.logOperation.toJSON() : <any>null;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : <any>null;
        return data;
    }
}

export interface ITaskLogOperationInfo {
    hasAttachment?: boolean;
    id?: number;
    logOperation?: TaskLogOperation;
    attachment?: TaskLogAttachment | null;
}

export class TaskLogOperation implements ITaskLogOperation {
    id?: number;
    taskID?: number;
    tripID?: number | null;
    tripRowID?: number | null;
    date?: string;
    process?: ETaskProcess;
    level?: ETaskLogOperationLevel;
    name!: string;
    message?: string | null;
    filePath?: string | null;

    constructor(data?: ITaskLogOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.taskID = _data["taskID"] !== undefined ? _data["taskID"] : <any>null;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
            this.tripRowID = _data["tripRowID"] !== undefined ? _data["tripRowID"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.process = _data["process"] !== undefined ? _data["process"] : <any>null;
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.filePath = _data["filePath"] !== undefined ? _data["filePath"] : <any>null;
        }
    }

    static fromJS(data: any): TaskLogOperation {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLogOperation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["taskID"] = this.taskID !== undefined ? this.taskID : <any>null;
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        data["tripRowID"] = this.tripRowID !== undefined ? this.tripRowID : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["process"] = this.process !== undefined ? this.process : <any>null;
        data["level"] = this.level !== undefined ? this.level : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["filePath"] = this.filePath !== undefined ? this.filePath : <any>null;
        return data;
    }
}

export interface ITaskLogOperation {
    id?: number;
    taskID?: number;
    tripID?: number | null;
    tripRowID?: number | null;
    date?: string;
    process?: ETaskProcess;
    level?: ETaskLogOperationLevel;
    name: string;
    message?: string | null;
    filePath?: string | null;
}

export enum ETaskLogOperationLevel {
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
}

export class TaskLogAttachment implements ITaskLogAttachment {
    filePath?: string | null;
    mimeType?: string | null;
    sizeBytes?: number;

    constructor(data?: ITaskLogAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filePath = _data["filePath"] !== undefined ? _data["filePath"] : <any>null;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : <any>null;
            this.sizeBytes = _data["sizeBytes"] !== undefined ? _data["sizeBytes"] : <any>null;
        }
    }

    static fromJS(data: any): TaskLogAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLogAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath !== undefined ? this.filePath : <any>null;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : <any>null;
        data["sizeBytes"] = this.sizeBytes !== undefined ? this.sizeBytes : <any>null;
        return data;
    }
}

export interface ITaskLogAttachment {
    filePath?: string | null;
    mimeType?: string | null;
    sizeBytes?: number;
}

export class GetTasksLogsRequest extends ApiRequest implements IGetTasksLogsRequest {
    /** Single log ID */
    logID?: number | null;
    /** Single trip ID */
    tripID?: number | null;
    /** Optional trip row ID */
    tripRowID?: number | null;

    constructor(data?: IGetTasksLogsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logID = _data["logID"] !== undefined ? _data["logID"] : <any>null;
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
            this.tripRowID = _data["tripRowID"] !== undefined ? _data["tripRowID"] : <any>null;
        }
    }

    static fromJS(data: any): GetTasksLogsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTasksLogsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logID"] = this.logID !== undefined ? this.logID : <any>null;
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        data["tripRowID"] = this.tripRowID !== undefined ? this.tripRowID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTasksLogsRequest extends IApiRequest {
    /** Single log ID */
    logID?: number | null;
    /** Single trip ID */
    tripID?: number | null;
    /** Optional trip row ID */
    tripRowID?: number | null;
}

export class GetTaskLogAttachmentResponse extends OkApiResponse implements IGetTaskLogAttachmentResponse {
    attachmentContent?: string;

    constructor(data?: IGetTaskLogAttachmentResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.attachmentContent = _data["attachmentContent"] !== undefined ? _data["attachmentContent"] : <any>null;
        }
    }

    static fromJS(data: any): GetTaskLogAttachmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskLogAttachmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentContent"] = this.attachmentContent !== undefined ? this.attachmentContent : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTaskLogAttachmentResponse extends IOkApiResponse {
    attachmentContent?: string;
}

export class GetTaskLogAttachmentRequest extends ApiRequest implements IGetTaskLogAttachmentRequest {
    logID!: number;
    operationID!: number;

    constructor(data?: IGetTaskLogAttachmentRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logID = _data["logID"] !== undefined ? _data["logID"] : <any>null;
            this.operationID = _data["operationID"] !== undefined ? _data["operationID"] : <any>null;
        }
    }

    static fromJS(data: any): GetTaskLogAttachmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskLogAttachmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logID"] = this.logID !== undefined ? this.logID : <any>null;
        data["operationID"] = this.operationID !== undefined ? this.operationID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTaskLogAttachmentRequest extends IApiRequest {
    logID: number;
    operationID: number;
}

export class TicketCreateResponse extends OkApiResponse implements ITicketCreateResponse {
    ticket?: ImportTicket | null;
    created?: boolean;

    constructor(data?: ITicketCreateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ticket = _data["ticket"] ? ImportTicket.fromJS(_data["ticket"]) : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
        }
    }

    static fromJS(data: any): TicketCreateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCreateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticket"] = this.ticket ? this.ticket.toJSON() : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITicketCreateResponse extends IOkApiResponse {
    ticket?: ImportTicket | null;
    created?: boolean;
}

export class TicketCreateRequest extends ApiRequest implements ITicketCreateRequest {
    ticket?: ImportTicket | null;

    constructor(data?: ITicketCreateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ticket = _data["ticket"] ? ImportTicket.fromJS(_data["ticket"]) : <any>null;
        }
    }

    static fromJS(data: any): TicketCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticket"] = this.ticket ? this.ticket.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITicketCreateRequest extends IApiRequest {
    ticket?: ImportTicket | null;
}

export class TranslationsAllResponse extends OkApiResponse implements ITranslationsAllResponse {
    total?: number;
    totalToTranslate?: number;
    totalTranslated?: number;

    constructor(data?: ITranslationsAllResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.totalToTranslate = _data["totalToTranslate"] !== undefined ? _data["totalToTranslate"] : <any>null;
            this.totalTranslated = _data["totalTranslated"] !== undefined ? _data["totalTranslated"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsAllResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsAllResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["totalToTranslate"] = this.totalToTranslate !== undefined ? this.totalToTranslate : <any>null;
        data["totalTranslated"] = this.totalTranslated !== undefined ? this.totalTranslated : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsAllResponse extends IOkApiResponse {
    total?: number;
    totalToTranslate?: number;
    totalTranslated?: number;
}

export class TranslationsAllRequest extends ApiRequest implements ITranslationsAllRequest {
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsAllRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsAllRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsAllRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["to"] = this.to !== undefined ? this.to : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsAllRequest extends IApiRequest {
    from?: ELingua;
    to?: ELingua;
}

export class NrTableResponseOfTranslationsArticleRow extends OkApiResponse implements INrTableResponseOfTranslationsArticleRow {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsArticleRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTranslationsArticleRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TranslationsArticleRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfTranslationsArticleRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTranslationsArticleRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTranslationsArticleRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsArticleRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

/** Classe base per la RESPONSE della lista di traduzioni */
export class TranslationsListRow implements ITranslationsListRow {
    id?: number;
    title?: string | null;
    translations?: TranslationsListRowTranslation[];
    lastUpdate?: string | null;

    constructor(data?: ITranslationsListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(TranslationsListRowTranslation.fromJS(item));
            }
            else {
                this.translations = <any>null;
            }
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsListRow {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        return data;
    }
}

/** Classe base per la RESPONSE della lista di traduzioni */
export interface ITranslationsListRow {
    id?: number;
    title?: string | null;
    translations?: TranslationsListRowTranslation[];
    lastUpdate?: string | null;
}

export class TranslationsArticleRow extends TranslationsListRow implements ITranslationsArticleRow {
    originalTitle?: string | null;

    constructor(data?: ITranslationsArticleRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.originalTitle = _data["originalTitle"] !== undefined ? _data["originalTitle"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsArticleRow {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsArticleRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalTitle"] = this.originalTitle !== undefined ? this.originalTitle : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsArticleRow extends ITranslationsListRow {
    originalTitle?: string | null;
}

/** Traduzione di una riga della lista di traduzioni */
export class TranslationsListRowTranslation implements ITranslationsListRowTranslation {
    language?: ELingua;
    value?: string;
    update?: string | null;

    constructor(data?: ITranslationsListRowTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.update = _data["update"] !== undefined ? _data["update"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsListRowTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsListRowTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["update"] = this.update !== undefined ? this.update : <any>null;
        return data;
    }
}

/** Traduzione di una riga della lista di traduzioni */
export interface ITranslationsListRowTranslation {
    language?: ELingua;
    value?: string;
    update?: string | null;
}

/** Classe base per la REQUEST della lista di traduzioni */
export class TranslationsListRequest extends NrTableRequest implements ITranslationsListRequest {
    term?: string | null;
    text?: string | null;
    notTranslatedIn?: ELingua | null;
    lastLanguageUpdate?: TranslationsLastLanguageUpdate | null;
    automated?: boolean | null;
    toBeUpdatedIn?: ELingua | null;

    constructor(data?: ITranslationsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.notTranslatedIn = _data["notTranslatedIn"] !== undefined ? _data["notTranslatedIn"] : <any>null;
            this.lastLanguageUpdate = _data["lastLanguageUpdate"] ? TranslationsLastLanguageUpdate.fromJS(_data["lastLanguageUpdate"]) : <any>null;
            this.automated = _data["automated"] !== undefined ? _data["automated"] : <any>null;
            this.toBeUpdatedIn = _data["toBeUpdatedIn"] !== undefined ? _data["toBeUpdatedIn"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["notTranslatedIn"] = this.notTranslatedIn !== undefined ? this.notTranslatedIn : <any>null;
        data["lastLanguageUpdate"] = this.lastLanguageUpdate ? this.lastLanguageUpdate.toJSON() : <any>null;
        data["automated"] = this.automated !== undefined ? this.automated : <any>null;
        data["toBeUpdatedIn"] = this.toBeUpdatedIn !== undefined ? this.toBeUpdatedIn : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Classe base per la REQUEST della lista di traduzioni */
export interface ITranslationsListRequest extends INrTableRequest {
    term?: string | null;
    text?: string | null;
    notTranslatedIn?: ELingua | null;
    lastLanguageUpdate?: TranslationsLastLanguageUpdate | null;
    automated?: boolean | null;
    toBeUpdatedIn?: ELingua | null;
}

/** Ultimo aggiornamento lingua per la REQUEST */
export class TranslationsLastLanguageUpdate implements ITranslationsLastLanguageUpdate {
    language?: ELingua | null;
    lastModify?: string | null;

    constructor(data?: ITranslationsLastLanguageUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.lastModify = _data["lastModify"] !== undefined ? _data["lastModify"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsLastLanguageUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsLastLanguageUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["lastModify"] = this.lastModify !== undefined ? this.lastModify : <any>null;
        return data;
    }
}

/** Ultimo aggiornamento lingua per la REQUEST */
export interface ITranslationsLastLanguageUpdate {
    language?: ELingua | null;
    lastModify?: string | null;
}

export class TranslationsArticlesTranslateResponse extends OkApiResponse implements ITranslationsArticlesTranslateResponse {
    translatedText?: string | null;
    translatedTitle?: string | null;
    language?: ELingua | null;

    constructor(data?: ITranslationsArticlesTranslateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translatedText = _data["translatedText"] !== undefined ? _data["translatedText"] : <any>null;
            this.translatedTitle = _data["translatedTitle"] !== undefined ? _data["translatedTitle"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsArticlesTranslateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsArticlesTranslateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translatedText"] = this.translatedText !== undefined ? this.translatedText : <any>null;
        data["translatedTitle"] = this.translatedTitle !== undefined ? this.translatedTitle : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsArticlesTranslateResponse extends IOkApiResponse {
    translatedText?: string | null;
    translatedTitle?: string | null;
    language?: ELingua | null;
}

export class TranslationsArticlesTranslateRequest extends ApiRequest implements ITranslationsArticlesTranslateRequest {
    articleID?: number;
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsArticlesTranslateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articleID = _data["articleID"] !== undefined ? _data["articleID"] : <any>null;
            this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsArticlesTranslateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsArticlesTranslateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleID"] = this.articleID !== undefined ? this.articleID : <any>null;
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["to"] = this.to !== undefined ? this.to : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsArticlesTranslateRequest extends IApiRequest {
    articleID?: number;
    from?: ELingua;
    to?: ELingua;
}

export class TranslationsArticlesTranslateTextResponse extends OkApiResponse implements ITranslationsArticlesTranslateTextResponse {
    translatedText?: string | null;
    translatedTitle?: string | null;
    language?: ELingua | null;

    constructor(data?: ITranslationsArticlesTranslateTextResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translatedText = _data["translatedText"] !== undefined ? _data["translatedText"] : <any>null;
            this.translatedTitle = _data["translatedTitle"] !== undefined ? _data["translatedTitle"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsArticlesTranslateTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsArticlesTranslateTextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translatedText"] = this.translatedText !== undefined ? this.translatedText : <any>null;
        data["translatedTitle"] = this.translatedTitle !== undefined ? this.translatedTitle : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsArticlesTranslateTextResponse extends IOkApiResponse {
    translatedText?: string | null;
    translatedTitle?: string | null;
    language?: ELingua | null;
}

export class TranslationsArticlesTranslateTextRequest extends ApiRequest implements ITranslationsArticlesTranslateTextRequest {
    title?: string;
    text?: string;
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsArticlesTranslateTextRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsArticlesTranslateTextRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsArticlesTranslateTextRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["to"] = this.to !== undefined ? this.to : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsArticlesTranslateTextRequest extends IApiRequest {
    title?: string;
    text?: string;
    from?: ELingua;
    to?: ELingua;
}

export class NrTableResponseOfTranslationsLocationRow extends OkApiResponse implements INrTableResponseOfTranslationsLocationRow {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsLocationRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTranslationsLocationRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TranslationsLocationRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfTranslationsLocationRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTranslationsLocationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTranslationsLocationRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsLocationRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TranslationsLocationsListResponse extends NrTableResponseOfTranslationsLocationRow implements ITranslationsLocationsListResponse {

    constructor(data?: ITranslationsLocationsListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TranslationsLocationsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsLocationsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsLocationsListResponse extends INrTableResponseOfTranslationsLocationRow {
}

export class TranslationsLocationRow implements ITranslationsLocationRow {
    luogoID?: number;
    ultimoAggiornamento?: string | null;
    nome?: string | null;
    nomeInglese?: string | null;
    lingueDisponibili?: ELingua[] | null;
    traduzioni?: IWebTranslationEntity[];

    constructor(data?: ITranslationsLocationRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : <any>null;
            if (Array.isArray(_data["lingueDisponibili"])) {
                this.lingueDisponibili = [] as any;
                for (let item of _data["lingueDisponibili"])
                    this.lingueDisponibili!.push(item);
            }
            else {
                this.lingueDisponibili = <any>null;
            }
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
        }
    }

    static fromJS(data: any): TranslationsLocationRow {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsLocationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : <any>null;
        if (Array.isArray(this.lingueDisponibili)) {
            data["lingueDisponibili"] = [];
            for (let item of this.lingueDisponibili)
                data["lingueDisponibili"].push(item);
        }
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITranslationsLocationRow {
    luogoID?: number;
    ultimoAggiornamento?: string | null;
    nome?: string | null;
    nomeInglese?: string | null;
    lingueDisponibili?: ELingua[] | null;
    traduzioni?: IWebTranslationEntity[];
}

export class TranslationsLocationsListRequest extends NrTableRequest implements ITranslationsLocationsListRequest {
    term?: string | null;
    lastModify?: string | null;
    automated?: boolean | null;
    languageLastUpdate?: TranslationsLastLanguageUpdate | null;
    notTranslated?: ELingua | null;

    constructor(data?: ITranslationsLocationsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.lastModify = _data["lastModify"] !== undefined ? _data["lastModify"] : <any>null;
            this.automated = _data["automated"] !== undefined ? _data["automated"] : <any>null;
            this.languageLastUpdate = _data["languageLastUpdate"] ? TranslationsLastLanguageUpdate.fromJS(_data["languageLastUpdate"]) : <any>null;
            this.notTranslated = _data["notTranslated"] !== undefined ? _data["notTranslated"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsLocationsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsLocationsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["lastModify"] = this.lastModify !== undefined ? this.lastModify : <any>null;
        data["automated"] = this.automated !== undefined ? this.automated : <any>null;
        data["languageLastUpdate"] = this.languageLastUpdate ? this.languageLastUpdate.toJSON() : <any>null;
        data["notTranslated"] = this.notTranslated !== undefined ? this.notTranslated : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsLocationsListRequest extends INrTableRequest {
    term?: string | null;
    lastModify?: string | null;
    automated?: boolean | null;
    languageLastUpdate?: TranslationsLastLanguageUpdate | null;
    notTranslated?: ELingua | null;
}

export class NrTableResponseOfTranslationsPhraseRow extends OkApiResponse implements INrTableResponseOfTranslationsPhraseRow {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsPhraseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTranslationsPhraseRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TranslationsPhraseRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfTranslationsPhraseRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTranslationsPhraseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTranslationsPhraseRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsPhraseRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TranslationsPhraseRow extends TranslationsListRow implements ITranslationsPhraseRow {
    text?: string | null;

    constructor(data?: ITranslationsPhraseRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsPhraseRow {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsPhraseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsPhraseRow extends ITranslationsListRow {
    text?: string | null;
}

export class TranslationsPhrasesTranslateResponse extends OkApiResponse implements ITranslationsPhrasesTranslateResponse {
    translation?: string | null;
    language?: ELingua | null;

    constructor(data?: ITranslationsPhrasesTranslateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translation = _data["translation"] !== undefined ? _data["translation"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsPhrasesTranslateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsPhrasesTranslateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translation"] = this.translation !== undefined ? this.translation : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsPhrasesTranslateResponse extends IOkApiResponse {
    translation?: string | null;
    language?: ELingua | null;
}

export class TranslationsPhrasesTranslateRequest extends ApiRequest implements ITranslationsPhrasesTranslateRequest {
    phraseID?: number;
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsPhrasesTranslateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phraseID = _data["phraseID"] !== undefined ? _data["phraseID"] : <any>null;
            this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsPhrasesTranslateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsPhrasesTranslateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phraseID"] = this.phraseID !== undefined ? this.phraseID : <any>null;
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["to"] = this.to !== undefined ? this.to : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsPhrasesTranslateRequest extends IApiRequest {
    phraseID?: number;
    from?: ELingua;
    to?: ELingua;
}

export class TranslationsPhrasesTranslateTextResponse extends OkApiResponse implements ITranslationsPhrasesTranslateTextResponse {
    translation?: string | null;
    language?: ELingua | null;

    constructor(data?: ITranslationsPhrasesTranslateTextResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translation = _data["translation"] !== undefined ? _data["translation"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsPhrasesTranslateTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsPhrasesTranslateTextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translation"] = this.translation !== undefined ? this.translation : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsPhrasesTranslateTextResponse extends IOkApiResponse {
    translation?: string | null;
    language?: ELingua | null;
}

export class TranslationsPhrasesTranslateTextRequest extends ApiRequest implements ITranslationsPhrasesTranslateTextRequest {
    text?: string;
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsPhrasesTranslateTextRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsPhrasesTranslateTextRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsPhrasesTranslateTextRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["to"] = this.to !== undefined ? this.to : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsPhrasesTranslateTextRequest extends IApiRequest {
    text?: string;
    from?: ELingua;
    to?: ELingua;
}

export class NrTableResponseOfTranslationsServicesRow extends OkApiResponse implements INrTableResponseOfTranslationsServicesRow {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsServicesRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTranslationsServicesRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TranslationsServicesRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfTranslationsServicesRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTranslationsServicesRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTranslationsServicesRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TranslationsServicesRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TranslationsServicesListResponse extends NrTableResponseOfTranslationsServicesRow implements ITranslationsServicesListResponse {

    constructor(data?: ITranslationsServicesListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TranslationsServicesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsServicesListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsServicesListResponse extends INrTableResponseOfTranslationsServicesRow {
}

export class TranslationsServicesRow implements ITranslationsServicesRow {
    servizioID?: number;
    ultimoAggiornamento?: string | null;
    nome?: string | null;
    nomeInglese?: string | null;
    lingueDisponibili?: ELingua[] | null;
    traduzioni?: IWebTranslationEntity[];

    constructor(data?: ITranslationsServicesRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.ultimoAggiornamento = _data["ultimoAggiornamento"] !== undefined ? _data["ultimoAggiornamento"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : <any>null;
            if (Array.isArray(_data["lingueDisponibili"])) {
                this.lingueDisponibili = [] as any;
                for (let item of _data["lingueDisponibili"])
                    this.lingueDisponibili!.push(item);
            }
            else {
                this.lingueDisponibili = <any>null;
            }
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
        }
    }

    static fromJS(data: any): TranslationsServicesRow {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsServicesRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["ultimoAggiornamento"] = this.ultimoAggiornamento !== undefined ? this.ultimoAggiornamento : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : <any>null;
        if (Array.isArray(this.lingueDisponibili)) {
            data["lingueDisponibili"] = [];
            for (let item of this.lingueDisponibili)
                data["lingueDisponibili"].push(item);
        }
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITranslationsServicesRow {
    servizioID?: number;
    ultimoAggiornamento?: string | null;
    nome?: string | null;
    nomeInglese?: string | null;
    lingueDisponibili?: ELingua[] | null;
    traduzioni?: IWebTranslationEntity[];
}

export class TranslationsServicesListRequest extends NrTableRequest implements ITranslationsServicesListRequest {
    term?: string | null;
    lastModify?: string | null;
    automated?: boolean | null;
    languageLastUpdate?: TranslationsLastLanguageUpdate | null;
    notTranslated?: ELingua | null;

    constructor(data?: ITranslationsServicesListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.lastModify = _data["lastModify"] !== undefined ? _data["lastModify"] : <any>null;
            this.automated = _data["automated"] !== undefined ? _data["automated"] : <any>null;
            this.languageLastUpdate = _data["languageLastUpdate"] ? TranslationsLastLanguageUpdate.fromJS(_data["languageLastUpdate"]) : <any>null;
            this.notTranslated = _data["notTranslated"] !== undefined ? _data["notTranslated"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsServicesListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsServicesListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["lastModify"] = this.lastModify !== undefined ? this.lastModify : <any>null;
        data["automated"] = this.automated !== undefined ? this.automated : <any>null;
        data["languageLastUpdate"] = this.languageLastUpdate ? this.languageLastUpdate.toJSON() : <any>null;
        data["notTranslated"] = this.notTranslated !== undefined ? this.notTranslated : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsServicesListRequest extends INrTableRequest {
    term?: string | null;
    lastModify?: string | null;
    automated?: boolean | null;
    languageLastUpdate?: TranslationsLastLanguageUpdate | null;
    notTranslated?: ELingua | null;
}

export class TranslationsServiceTranslateResponse extends OkApiResponse implements ITranslationsServiceTranslateResponse {
    translation?: string | null;
    language?: ELingua | null;

    constructor(data?: ITranslationsServiceTranslateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translation = _data["translation"] !== undefined ? _data["translation"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsServiceTranslateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsServiceTranslateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translation"] = this.translation !== undefined ? this.translation : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsServiceTranslateResponse extends IOkApiResponse {
    translation?: string | null;
    language?: ELingua | null;
}

export class TranslationsServiceTranslateRequest extends ApiRequest implements ITranslationsServiceTranslateRequest {
    serviceID?: number;
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsServiceTranslateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : <any>null;
            this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsServiceTranslateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsServiceTranslateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : <any>null;
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["to"] = this.to !== undefined ? this.to : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsServiceTranslateRequest extends IApiRequest {
    serviceID?: number;
    from?: ELingua;
    to?: ELingua;
}

export class TranslationsTranslateResponse extends OkApiResponse implements ITranslationsTranslateResponse {
    translation?: string | null;
    language?: ELingua | null;

    constructor(data?: ITranslationsTranslateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translation = _data["translation"] !== undefined ? _data["translation"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsTranslateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsTranslateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translation"] = this.translation !== undefined ? this.translation : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsTranslateResponse extends IOkApiResponse {
    translation?: string | null;
    language?: ELingua | null;
}

export class TranslationsTranslateRequest extends ApiRequest implements ITranslationsTranslateRequest {
    message?: string;
    from?: ELingua;
    to?: ELingua;

    constructor(data?: ITranslationsTranslateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
        }
    }

    static fromJS(data: any): TranslationsTranslateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsTranslateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["to"] = this.to !== undefined ? this.to : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationsTranslateRequest extends IApiRequest {
    message?: string;
    from?: ELingua;
    to?: ELingua;
}

export class WebTranslatableGetResponse extends OkApiResponse implements IWebTranslatableGetResponse {
    nome?: string | null;
    nome_en?: string | null;
    traduzioni?: IWebTranslationEntity[] | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;

    constructor(data?: IWebTranslatableGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(IWebTranslationEntity.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
            this.lastUpdate = _data["lastUpdate"] !== undefined ? _data["lastUpdate"] : <any>null;
            this.lastUpdate_en = _data["lastUpdate_en"] !== undefined ? _data["lastUpdate_en"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
        }
    }

    static fromJS(data: any): WebTranslatableGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebTranslatableGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        data["lastUpdate"] = this.lastUpdate !== undefined ? this.lastUpdate : <any>null;
        data["lastUpdate_en"] = this.lastUpdate_en !== undefined ? this.lastUpdate_en : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IWebTranslatableGetResponse extends IOkApiResponse {
    nome?: string | null;
    nome_en?: string | null;
    traduzioni?: IWebTranslationEntity[] | null;
    lastUpdate?: string | null;
    lastUpdate_en?: string | null;
    confirmed?: boolean | null;
    confirmed_en?: boolean | null;
}

export class WebTranslatableGetRequest extends LocalizedRequest implements IWebTranslatableGetRequest {
    id?: number;
    table?: string | null;

    constructor(data?: IWebTranslatableGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
        }
    }

    static fromJS(data: any): WebTranslatableGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebTranslatableGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IWebTranslatableGetRequest extends ILocalizedRequest {
    id?: number;
    table?: string | null;
}

export class NrTableResponseOfAPI_Website_translationsGetRow extends OkApiResponse implements INrTableResponseOfAPI_Website_translationsGetRow {
    /** Array delle righe della pagina richiesta */
    rows?: API_Website_translationsGetRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfAPI_Website_translationsGetRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(API_Website_translationsGetRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfAPI_Website_translationsGetRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfAPI_Website_translationsGetRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfAPI_Website_translationsGetRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: API_Website_translationsGetRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class API_Website_translationsGetRow implements IAPI_Website_translationsGetRow {
    id?: number;
    category?: string | null;
    englishName?: string | null;
    translated?: number;
    languageName?: string | null;
    info?: string | null;
    dateUpdated?: string | null;
    dateUpdatedLingua?: string | null;
    isTranslated?: boolean;

    constructor(data?: IAPI_Website_translationsGetRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.englishName = _data["englishName"] !== undefined ? _data["englishName"] : <any>null;
            this.translated = _data["translated"] !== undefined ? _data["translated"] : <any>null;
            this.languageName = _data["languageName"] !== undefined ? _data["languageName"] : <any>null;
            this.info = _data["info"] !== undefined ? _data["info"] : <any>null;
            this.dateUpdated = _data["dateUpdated"] !== undefined ? _data["dateUpdated"] : <any>null;
            this.dateUpdatedLingua = _data["dateUpdatedLingua"] !== undefined ? _data["dateUpdatedLingua"] : <any>null;
            this.isTranslated = _data["isTranslated"] !== undefined ? _data["isTranslated"] : <any>null;
        }
    }

    static fromJS(data: any): API_Website_translationsGetRow {
        data = typeof data === 'object' ? data : {};
        let result = new API_Website_translationsGetRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["englishName"] = this.englishName !== undefined ? this.englishName : <any>null;
        data["translated"] = this.translated !== undefined ? this.translated : <any>null;
        data["languageName"] = this.languageName !== undefined ? this.languageName : <any>null;
        data["info"] = this.info !== undefined ? this.info : <any>null;
        data["dateUpdated"] = this.dateUpdated !== undefined ? this.dateUpdated : <any>null;
        data["dateUpdatedLingua"] = this.dateUpdatedLingua !== undefined ? this.dateUpdatedLingua : <any>null;
        data["isTranslated"] = this.isTranslated !== undefined ? this.isTranslated : <any>null;
        return data;
    }
}

export interface IAPI_Website_translationsGetRow {
    id?: number;
    category?: string | null;
    englishName?: string | null;
    translated?: number;
    languageName?: string | null;
    info?: string | null;
    dateUpdated?: string | null;
    dateUpdatedLingua?: string | null;
    isTranslated?: boolean;
}

/** for LUOGHI, SERVIZI, DATI_AGG_SERVIZI show places entity and set @idluogo for LUOGHI, SERVIZI show countries entities and set @idpaese for LUOGHI show placetypes entities and set @idcategory for SERVIZI show servicetype entities and set @idcategory */
export class WebTranslatableListRequest extends NrTableRequest implements IWebTranslatableListRequest {
    tableName?: string;
    text?: string;
    language?: ELingua;
    toBeUpdated?: boolean;
    idLocation?: number | null;
    idCountry?: number | null;
    idCategory?: number | null;

    constructor(data?: IWebTranslatableListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tableName = _data["tableName"] !== undefined ? _data["tableName"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.toBeUpdated = _data["toBeUpdated"] !== undefined ? _data["toBeUpdated"] : <any>null;
            this.idLocation = _data["idLocation"] !== undefined ? _data["idLocation"] : <any>null;
            this.idCountry = _data["idCountry"] !== undefined ? _data["idCountry"] : <any>null;
            this.idCategory = _data["idCategory"] !== undefined ? _data["idCategory"] : <any>null;
        }
    }

    static fromJS(data: any): WebTranslatableListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebTranslatableListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName !== undefined ? this.tableName : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["toBeUpdated"] = this.toBeUpdated !== undefined ? this.toBeUpdated : <any>null;
        data["idLocation"] = this.idLocation !== undefined ? this.idLocation : <any>null;
        data["idCountry"] = this.idCountry !== undefined ? this.idCountry : <any>null;
        data["idCategory"] = this.idCategory !== undefined ? this.idCategory : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** for LUOGHI, SERVIZI, DATI_AGG_SERVIZI show places entity and set @idluogo for LUOGHI, SERVIZI show countries entities and set @idpaese for LUOGHI show placetypes entities and set @idcategory for SERVIZI show servicetype entities and set @idcategory */
export interface IWebTranslatableListRequest extends INrTableRequest {
    tableName?: string;
    text?: string;
    language?: ELingua;
    toBeUpdated?: boolean;
    idLocation?: number | null;
    idCountry?: number | null;
    idCategory?: number | null;
}

export class WebTranslatableUpdateRequest extends LocalizedRequest implements IWebTranslatableUpdateRequest {
    id?: number;
    table?: string | null;
    nome?: string | null;
    nome_en?: string | null;
    confirmed_en?: boolean | null;
    traduzioni?: WebTranslation[] | null;

    constructor(data?: IWebTranslatableUpdateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nome_en = _data["nome_en"] !== undefined ? _data["nome_en"] : <any>null;
            this.confirmed_en = _data["confirmed_en"] !== undefined ? _data["confirmed_en"] : <any>null;
            if (Array.isArray(_data["traduzioni"])) {
                this.traduzioni = [] as any;
                for (let item of _data["traduzioni"])
                    this.traduzioni!.push(WebTranslation.fromJS(item));
            }
            else {
                this.traduzioni = <any>null;
            }
        }
    }

    static fromJS(data: any): WebTranslatableUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebTranslatableUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nome_en"] = this.nome_en !== undefined ? this.nome_en : <any>null;
        data["confirmed_en"] = this.confirmed_en !== undefined ? this.confirmed_en : <any>null;
        if (Array.isArray(this.traduzioni)) {
            data["traduzioni"] = [];
            for (let item of this.traduzioni)
                data["traduzioni"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWebTranslatableUpdateRequest extends ILocalizedRequest {
    id?: number;
    table?: string | null;
    nome?: string | null;
    nome_en?: string | null;
    confirmed_en?: boolean | null;
    traduzioni?: WebTranslation[] | null;
}

export class AddCameraHashcodeRequest extends TripGetRequest implements IAddCameraHashcodeRequest {
    dati!: string;
    /** ID della tappa */
    stepID?: number;

    constructor(data?: IAddCameraHashcodeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dati = _data["dati"] !== undefined ? _data["dati"] : <any>null;
            this.stepID = _data["stepID"] !== undefined ? _data["stepID"] : <any>null;
        }
    }

    static fromJS(data: any): AddCameraHashcodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddCameraHashcodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dati"] = this.dati !== undefined ? this.dati : <any>null;
        data["stepID"] = this.stepID !== undefined ? this.stepID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddCameraHashcodeRequest extends ITripGetRequest {
    dati: string;
    /** ID della tappa */
    stepID?: number;
}

export class AddServiziRequest extends TripGetRequest implements IAddServiziRequest {
    /** Servizi i cui search data sono da recuperare dal pricer */
    servizi?: DatiServizioAdd[] | null;
    /** Servizi i cui search data siano già noti */
    serviziSearch?: ServizioDaAggiungere[] | null;

    constructor(data?: IAddServiziRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(DatiServizioAdd.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
            if (Array.isArray(_data["serviziSearch"])) {
                this.serviziSearch = [] as any;
                for (let item of _data["serviziSearch"])
                    this.serviziSearch!.push(ServizioDaAggiungere.fromJS(item));
            }
            else {
                this.serviziSearch = <any>null;
            }
        }
    }

    static fromJS(data: any): AddServiziRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddServiziRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        if (Array.isArray(this.serviziSearch)) {
            data["serviziSearch"] = [];
            for (let item of this.serviziSearch)
                data["serviziSearch"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAddServiziRequest extends ITripGetRequest {
    /** Servizi i cui search data sono da recuperare dal pricer */
    servizi?: DatiServizioAdd[] | null;
    /** Servizi i cui search data siano già noti */
    serviziSearch?: ServizioDaAggiungere[] | null;
}

export class DatiServizioAdd implements IDatiServizioAdd {
    jobID!: string;
    resultID!: string;
    serviceID!: number;
    typeID!: number;
    supplierID?: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;
    clienteID?: number | null;
    tappaID?: number;
    supplementi?: DatiOpzioneAdd[] | null;
    paxIds?: number[] | null;
    nomeGruppoCustom?: string | null;
    usaHashcode?: boolean;

    constructor(data?: IDatiServizioAdd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : <any>null;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : <any>null;
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : <any>null;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : <any>null;
            this.departureID = _data["departureID"] !== undefined ? _data["departureID"] : <any>null;
            this.optionID = _data["optionID"] !== undefined ? _data["optionID"] : <any>null;
            this.optionItemID = _data["optionItemID"] !== undefined ? _data["optionItemID"] : <any>null;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : <any>null;
            this.tappaID = _data["tappaID"] !== undefined ? _data["tappaID"] : <any>null;
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(DatiOpzioneAdd.fromJS(item));
            }
            else {
                this.supplementi = <any>null;
            }
            if (Array.isArray(_data["paxIds"])) {
                this.paxIds = [] as any;
                for (let item of _data["paxIds"])
                    this.paxIds!.push(item);
            }
            else {
                this.paxIds = <any>null;
            }
            this.nomeGruppoCustom = _data["nomeGruppoCustom"] !== undefined ? _data["nomeGruppoCustom"] : <any>null;
            this.usaHashcode = _data["usaHashcode"] !== undefined ? _data["usaHashcode"] : <any>null;
        }
    }

    static fromJS(data: any): DatiServizioAdd {
        data = typeof data === 'object' ? data : {};
        let result = new DatiServizioAdd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["resultID"] = this.resultID !== undefined ? this.resultID : <any>null;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : <any>null;
        data["typeID"] = this.typeID !== undefined ? this.typeID : <any>null;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : <any>null;
        data["departureID"] = this.departureID !== undefined ? this.departureID : <any>null;
        data["optionID"] = this.optionID !== undefined ? this.optionID : <any>null;
        data["optionItemID"] = this.optionItemID !== undefined ? this.optionItemID : <any>null;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : <any>null;
        data["tappaID"] = this.tappaID !== undefined ? this.tappaID : <any>null;
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item.toJSON());
        }
        if (Array.isArray(this.paxIds)) {
            data["paxIds"] = [];
            for (let item of this.paxIds)
                data["paxIds"].push(item);
        }
        data["nomeGruppoCustom"] = this.nomeGruppoCustom !== undefined ? this.nomeGruppoCustom : <any>null;
        data["usaHashcode"] = this.usaHashcode !== undefined ? this.usaHashcode : <any>null;
        return data;
    }
}

export interface IDatiServizioAdd {
    jobID: string;
    resultID: string;
    serviceID: number;
    typeID: number;
    supplierID?: number;
    departureID?: number | null;
    optionID?: number | null;
    optionItemID?: number | null;
    clienteID?: number | null;
    tappaID?: number;
    supplementi?: DatiOpzioneAdd[] | null;
    paxIds?: number[] | null;
    nomeGruppoCustom?: string | null;
    usaHashcode?: boolean;
}

export class DatiOpzioneAdd implements IDatiOpzioneAdd {
    optionID?: number;
    optionItemID?: number;

    constructor(data?: IDatiOpzioneAdd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optionID = _data["optionID"] !== undefined ? _data["optionID"] : <any>null;
            this.optionItemID = _data["optionItemID"] !== undefined ? _data["optionItemID"] : <any>null;
        }
    }

    static fromJS(data: any): DatiOpzioneAdd {
        data = typeof data === 'object' ? data : {};
        let result = new DatiOpzioneAdd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optionID"] = this.optionID !== undefined ? this.optionID : <any>null;
        data["optionItemID"] = this.optionItemID !== undefined ? this.optionItemID : <any>null;
        return data;
    }
}

export interface IDatiOpzioneAdd {
    optionID?: number;
    optionItemID?: number;
}

export class ServizioDaAggiungere implements IServizioDaAggiungere {
    bufferDati?: string | null;
    dati?: ServiceSearchData | null;
    tappaID?: number;
    clienteID?: number | null;
    supplementi?: ServizioDaAggiungere[] | null;
    paxIds?: number[] | null;
    nomeGruppoCustom?: string | null;
    usaHashcode?: boolean;

    constructor(data?: IServizioDaAggiungere) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bufferDati = _data["bufferDati"] !== undefined ? _data["bufferDati"] : <any>null;
            this.dati = _data["dati"] ? ServiceSearchData.fromJS(_data["dati"]) : <any>null;
            this.tappaID = _data["tappaID"] !== undefined ? _data["tappaID"] : <any>null;
            this.clienteID = _data["clienteID"] !== undefined ? _data["clienteID"] : <any>null;
            if (Array.isArray(_data["supplementi"])) {
                this.supplementi = [] as any;
                for (let item of _data["supplementi"])
                    this.supplementi!.push(ServizioDaAggiungere.fromJS(item));
            }
            else {
                this.supplementi = <any>null;
            }
            if (Array.isArray(_data["paxIds"])) {
                this.paxIds = [] as any;
                for (let item of _data["paxIds"])
                    this.paxIds!.push(item);
            }
            else {
                this.paxIds = <any>null;
            }
            this.nomeGruppoCustom = _data["nomeGruppoCustom"] !== undefined ? _data["nomeGruppoCustom"] : <any>null;
            this.usaHashcode = _data["usaHashcode"] !== undefined ? _data["usaHashcode"] : <any>null;
        }
    }

    static fromJS(data: any): ServizioDaAggiungere {
        data = typeof data === 'object' ? data : {};
        let result = new ServizioDaAggiungere();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bufferDati"] = this.bufferDati !== undefined ? this.bufferDati : <any>null;
        data["dati"] = this.dati ? this.dati.toJSON() : <any>null;
        data["tappaID"] = this.tappaID !== undefined ? this.tappaID : <any>null;
        data["clienteID"] = this.clienteID !== undefined ? this.clienteID : <any>null;
        if (Array.isArray(this.supplementi)) {
            data["supplementi"] = [];
            for (let item of this.supplementi)
                data["supplementi"].push(item.toJSON());
        }
        if (Array.isArray(this.paxIds)) {
            data["paxIds"] = [];
            for (let item of this.paxIds)
                data["paxIds"].push(item);
        }
        data["nomeGruppoCustom"] = this.nomeGruppoCustom !== undefined ? this.nomeGruppoCustom : <any>null;
        data["usaHashcode"] = this.usaHashcode !== undefined ? this.usaHashcode : <any>null;
        return data;
    }
}

export interface IServizioDaAggiungere {
    bufferDati?: string | null;
    dati?: ServiceSearchData | null;
    tappaID?: number;
    clienteID?: number | null;
    supplementi?: ServizioDaAggiungere[] | null;
    paxIds?: number[] | null;
    nomeGruppoCustom?: string | null;
    usaHashcode?: boolean;
}

export class AddServizioAutomaticoRequest extends TripGetRequest implements IAddServizioAutomaticoRequest {
    servizioAutomatico?: EServizioAutomatico;
    importo?: number | null;
    abbinamentoID?: number | null;
    paxIDs?: number[] | null;
    /** Se true per i servizi che lo supportano richiede che l'aggiornamento sia manuale */
    aggiornamentoManuale?: boolean;

    constructor(data?: IAddServizioAutomaticoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioAutomatico = _data["servizioAutomatico"] !== undefined ? _data["servizioAutomatico"] : <any>null;
            this.importo = _data["importo"] !== undefined ? _data["importo"] : <any>null;
            this.abbinamentoID = _data["abbinamentoID"] !== undefined ? _data["abbinamentoID"] : <any>null;
            if (Array.isArray(_data["paxIDs"])) {
                this.paxIDs = [] as any;
                for (let item of _data["paxIDs"])
                    this.paxIDs!.push(item);
            }
            else {
                this.paxIDs = <any>null;
            }
            this.aggiornamentoManuale = _data["aggiornamentoManuale"] !== undefined ? _data["aggiornamentoManuale"] : <any>null;
        }
    }

    static fromJS(data: any): AddServizioAutomaticoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddServizioAutomaticoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioAutomatico"] = this.servizioAutomatico !== undefined ? this.servizioAutomatico : <any>null;
        data["importo"] = this.importo !== undefined ? this.importo : <any>null;
        data["abbinamentoID"] = this.abbinamentoID !== undefined ? this.abbinamentoID : <any>null;
        if (Array.isArray(this.paxIDs)) {
            data["paxIDs"] = [];
            for (let item of this.paxIDs)
                data["paxIDs"].push(item);
        }
        data["aggiornamentoManuale"] = this.aggiornamentoManuale !== undefined ? this.aggiornamentoManuale : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddServizioAutomaticoRequest extends ITripGetRequest {
    servizioAutomatico?: EServizioAutomatico;
    importo?: number | null;
    abbinamentoID?: number | null;
    paxIDs?: number[] | null;
    /** Se true per i servizi che lo supportano richiede che l'aggiornamento sia manuale */
    aggiornamentoManuale?: boolean;
}

export class AddServizioMacroRequest extends TripGetRequest implements IAddServizioMacroRequest {
    jobID!: string;
    resultID!: string;
    serviceID!: number;
    typeID!: number;
    tappaID!: number;
    nomeGruppoCustom?: string | null;

    constructor(data?: IAddServizioMacroRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.resultID = _data["resultID"] !== undefined ? _data["resultID"] : <any>null;
            this.serviceID = _data["serviceID"] !== undefined ? _data["serviceID"] : <any>null;
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : <any>null;
            this.tappaID = _data["tappaID"] !== undefined ? _data["tappaID"] : <any>null;
            this.nomeGruppoCustom = _data["nomeGruppoCustom"] !== undefined ? _data["nomeGruppoCustom"] : <any>null;
        }
    }

    static fromJS(data: any): AddServizioMacroRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddServizioMacroRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["resultID"] = this.resultID !== undefined ? this.resultID : <any>null;
        data["serviceID"] = this.serviceID !== undefined ? this.serviceID : <any>null;
        data["typeID"] = this.typeID !== undefined ? this.typeID : <any>null;
        data["tappaID"] = this.tappaID !== undefined ? this.tappaID : <any>null;
        data["nomeGruppoCustom"] = this.nomeGruppoCustom !== undefined ? this.nomeGruppoCustom : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddServizioMacroRequest extends ITripGetRequest {
    jobID: string;
    resultID: string;
    serviceID: number;
    typeID: number;
    tappaID: number;
    nomeGruppoCustom?: string | null;
}

export class AvviaCompletamentoResponse extends OkApiResponse implements IAvviaCompletamentoResponse {
    autofillResponse?: AutofillResponse;

    constructor(data?: IAvviaCompletamentoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.autofillResponse = _data["autofillResponse"] ? AutofillResponse.fromJS(_data["autofillResponse"]) : <any>null;
        }
    }

    static fromJS(data: any): AvviaCompletamentoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvviaCompletamentoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autofillResponse"] = this.autofillResponse ? this.autofillResponse.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAvviaCompletamentoResponse extends IOkApiResponse {
    autofillResponse?: AutofillResponse;
}

export class AutofillResponse implements IAutofillResponse {
    ok?: boolean;
    error?: string | null;
    jobID?: string | null;

    constructor(data?: IAutofillResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"] !== undefined ? _data["ok"] : <any>null;
            this.error = _data["error"] !== undefined ? _data["error"] : <any>null;
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
        }
    }

    static fromJS(data: any): AutofillResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AutofillResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok !== undefined ? this.ok : <any>null;
        data["error"] = this.error !== undefined ? this.error : <any>null;
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        return data;
    }
}

export interface IAutofillResponse {
    ok?: boolean;
    error?: string | null;
    jobID?: string | null;
}

export class AvviaCompletamentoRequest extends TripGetRequest implements IAvviaCompletamentoRequest {
    completaLand?: boolean;
    completaVoli?: boolean;

    constructor(data?: IAvviaCompletamentoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.completaLand = _data["completaLand"] !== undefined ? _data["completaLand"] : <any>null;
            this.completaVoli = _data["completaVoli"] !== undefined ? _data["completaVoli"] : <any>null;
        }
    }

    static fromJS(data: any): AvviaCompletamentoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AvviaCompletamentoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completaLand"] = this.completaLand !== undefined ? this.completaLand : <any>null;
        data["completaVoli"] = this.completaVoli !== undefined ? this.completaVoli : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAvviaCompletamentoRequest extends ITripGetRequest {
    completaLand?: boolean;
    completaVoli?: boolean;
}

export class AvviaVerificaPrezziResponse extends OkApiResponse implements IAvviaVerificaPrezziResponse {
    priceVerifyRequestResult?: PriceVerifyRequestResult | null;

    constructor(data?: IAvviaVerificaPrezziResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.priceVerifyRequestResult = _data["priceVerifyRequestResult"] ? PriceVerifyRequestResult.fromJS(_data["priceVerifyRequestResult"]) : <any>null;
        }
    }

    static fromJS(data: any): AvviaVerificaPrezziResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvviaVerificaPrezziResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceVerifyRequestResult"] = this.priceVerifyRequestResult ? this.priceVerifyRequestResult.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAvviaVerificaPrezziResponse extends IOkApiResponse {
    priceVerifyRequestResult?: PriceVerifyRequestResult | null;
}

export class PriceVerifyRequestResult implements IPriceVerifyRequestResult {
    result?: EPriceVerifyRequestResult;
    jobID?: string | null;
    error?: string | null;

    constructor(data?: IPriceVerifyRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : <any>null;
            this.jobID = _data["jobID"] !== undefined ? _data["jobID"] : <any>null;
            this.error = _data["error"] !== undefined ? _data["error"] : <any>null;
        }
    }

    static fromJS(data: any): PriceVerifyRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new PriceVerifyRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : <any>null;
        data["jobID"] = this.jobID !== undefined ? this.jobID : <any>null;
        data["error"] = this.error !== undefined ? this.error : <any>null;
        return data;
    }
}

export interface IPriceVerifyRequestResult {
    result?: EPriceVerifyRequestResult;
    jobID?: string | null;
    error?: string | null;
}

export enum EPriceVerifyRequestResult {
    OK = "OK",
    ALREADY_RUNNING = "ALREADY_RUNNING",
    AUTOCOMPLETE_RUNNING = "AUTOCOMPLETE_RUNNING",
    ERROR = "ERROR",
    TIMEOUT = "TIMEOUT",
}

export class AvviaVerificaPrezziRequest extends TripGetRequest implements IAvviaVerificaPrezziRequest {
    /** Se true è richiesta una contestuale conferma */
    confirming?: boolean;
    /** Lista opzionale di righe singole */
    rowIDs?: number[] | null;

    constructor(data?: IAvviaVerificaPrezziRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.confirming = _data["confirming"] !== undefined ? _data["confirming"] : <any>null;
            if (Array.isArray(_data["rowIDs"])) {
                this.rowIDs = [] as any;
                for (let item of _data["rowIDs"])
                    this.rowIDs!.push(item);
            }
            else {
                this.rowIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): AvviaVerificaPrezziRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AvviaVerificaPrezziRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirming"] = this.confirming !== undefined ? this.confirming : <any>null;
        if (Array.isArray(this.rowIDs)) {
            data["rowIDs"] = [];
            for (let item of this.rowIDs)
                data["rowIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAvviaVerificaPrezziRequest extends ITripGetRequest {
    /** Se true è richiesta una contestuale conferma */
    confirming?: boolean;
    /** Lista opzionale di righe singole */
    rowIDs?: number[] | null;
}

export class CheckTripStatusResponse extends OkApiResponse implements ICheckTripStatusResponse {
    status?: TripBatch | null;
    priceVerifyStatus?: UiPriceVerifyStatus | null;

    constructor(data?: ICheckTripStatusResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"] ? TripBatch.fromJS(_data["status"]) : <any>null;
            this.priceVerifyStatus = _data["priceVerifyStatus"] ? UiPriceVerifyStatus.fromJS(_data["priceVerifyStatus"]) : <any>null;
        }
    }

    static fromJS(data: any): CheckTripStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckTripStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status ? this.status.toJSON() : <any>null;
        data["priceVerifyStatus"] = this.priceVerifyStatus ? this.priceVerifyStatus.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICheckTripStatusResponse extends IOkApiResponse {
    status?: TripBatch | null;
    priceVerifyStatus?: UiPriceVerifyStatus | null;
}

export class TripBatch implements ITripBatch {
    offertaID?: number;
    batchType?: EBatchType;
    status?: EBatchStatus;
    autofillStatus?: AutofillStatus | null;
    priceVerifyStatus?: PriceVerifyStatus | null;
    statusJson?: string | null;

    constructor(data?: ITripBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.batchType = _data["batchType"] !== undefined ? _data["batchType"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.autofillStatus = _data["autofillStatus"] ? AutofillStatus.fromJS(_data["autofillStatus"]) : <any>null;
            this.priceVerifyStatus = _data["priceVerifyStatus"] ? PriceVerifyStatus.fromJS(_data["priceVerifyStatus"]) : <any>null;
            this.statusJson = _data["statusJson"] !== undefined ? _data["statusJson"] : <any>null;
        }
    }

    static fromJS(data: any): TripBatch {
        data = typeof data === 'object' ? data : {};
        let result = new TripBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["batchType"] = this.batchType !== undefined ? this.batchType : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["autofillStatus"] = this.autofillStatus ? this.autofillStatus.toJSON() : <any>null;
        data["priceVerifyStatus"] = this.priceVerifyStatus ? this.priceVerifyStatus.toJSON() : <any>null;
        data["statusJson"] = this.statusJson !== undefined ? this.statusJson : <any>null;
        return data;
    }
}

export interface ITripBatch {
    offertaID?: number;
    batchType?: EBatchType;
    status?: EBatchStatus;
    autofillStatus?: AutofillStatus | null;
    priceVerifyStatus?: PriceVerifyStatus | null;
    statusJson?: string | null;
}

export enum EBatchType {
    VerificaPrezzi = "VerificaPrezzi",
    Autofill = "Autofill",
}

export enum EBatchStatus {
    Missing = "Missing",
    Running = "Running",
    Done = "Done",
    Error = "Error",
}

export class TripBatchStatus implements ITripBatchStatus {
    status?: EBatchStatus;
    batchType?: EBatchType;
    lingua?: ELingua;
    offertaID?: number;
    rigaID?: number | null;
    total?: number;
    current?: number;
    errorCode?: string | null;
    errorMessage?: string | null;
    errorValues?: { [key: string]: string; } | null;

    constructor(data?: ITripBatchStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.batchType = _data["batchType"] !== undefined ? _data["batchType"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.current = _data["current"] !== undefined ? _data["current"] : <any>null;
            this.errorCode = _data["errorCode"] !== undefined ? _data["errorCode"] : <any>null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
            if (_data["errorValues"]) {
                this.errorValues = {} as any;
                for (let key in _data["errorValues"]) {
                    if (_data["errorValues"].hasOwnProperty(key))
                        (<any>this.errorValues)![key] = _data["errorValues"][key] !== undefined ? _data["errorValues"][key] : <any>null;
                }
            }
            else {
                this.errorValues = <any>null;
            }
        }
    }

    static fromJS(data: any): TripBatchStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TripBatchStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["batchType"] = this.batchType !== undefined ? this.batchType : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : <any>null;
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["current"] = this.current !== undefined ? this.current : <any>null;
        data["errorCode"] = this.errorCode !== undefined ? this.errorCode : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        if (this.errorValues) {
            data["errorValues"] = {};
            for (let key in this.errorValues) {
                if (this.errorValues.hasOwnProperty(key))
                    (<any>data["errorValues"])[key] = this.errorValues[key] !== undefined ? this.errorValues[key] : <any>null;
            }
        }
        return data;
    }
}

export interface ITripBatchStatus {
    status?: EBatchStatus;
    batchType?: EBatchType;
    lingua?: ELingua;
    offertaID?: number;
    rigaID?: number | null;
    total?: number;
    current?: number;
    errorCode?: string | null;
    errorMessage?: string | null;
    errorValues?: { [key: string]: string; } | null;
}

export class AutofillStatus extends TripBatchStatus implements IAutofillStatus {
    exists?: boolean;
    done?: boolean;
    startedAt?: string;
    tasks?: AutofillTask[];

    constructor(data?: IAutofillStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.exists = _data["exists"] !== undefined ? _data["exists"] : <any>null;
            this.done = _data["done"] !== undefined ? _data["done"] : <any>null;
            this.startedAt = _data["startedAt"] !== undefined ? _data["startedAt"] : <any>null;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(AutofillTask.fromJS(item));
            }
            else {
                this.tasks = <any>null;
            }
        }
    }

    static fromJS(data: any): AutofillStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AutofillStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists !== undefined ? this.exists : <any>null;
        data["done"] = this.done !== undefined ? this.done : <any>null;
        data["startedAt"] = this.startedAt !== undefined ? this.startedAt : <any>null;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAutofillStatus extends ITripBatchStatus {
    exists?: boolean;
    done?: boolean;
    startedAt?: string;
    tasks?: AutofillTask[];
}

export class AutofillTask implements IAutofillTask {
    luogoID?: number | null;
    luogo?: string | null;
    dal?: string | null;
    al?: string | null;
    tipoServizio?: ETipoServizio;
    status?: EAutofillTaskStatus;
    warnings?: AutofillTaskWarning[];
    errors?: string[];

    constructor(data?: IAutofillTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.tipoServizio = _data["tipoServizio"] !== undefined ? _data["tipoServizio"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(AutofillTaskWarning.fromJS(item));
            }
            else {
                this.warnings = <any>null;
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = <any>null;
            }
        }
    }

    static fromJS(data: any): AutofillTask {
        data = typeof data === 'object' ? data : {};
        let result = new AutofillTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["tipoServizio"] = this.tipoServizio !== undefined ? this.tipoServizio : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IAutofillTask {
    luogoID?: number | null;
    luogo?: string | null;
    dal?: string | null;
    al?: string | null;
    tipoServizio?: ETipoServizio;
    status?: EAutofillTaskStatus;
    warnings?: AutofillTaskWarning[];
    errors?: string[];
}

export enum EAutofillTaskStatus {
    Queued = "Queued",
    Running = "Running",
    Ok = "Ok",
    Warning = "Warning",
    Error = "Error",
}

export class AutofillTaskWarning implements IAutofillTaskWarning {
    gruppoID?: number;
    gruppo?: string | null;
    tipo?: EAutofillWarningType;
    luogoID?: number | null;
    luogo?: string | null;
    dal?: string | null;
    al?: string | null;
    servizioID?: number | null;
    servizio?: string | null;
    servizioUrl?: string | null;
    rigaID?: number | null;

    constructor(data?: IAutofillTaskWarning) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gruppoID = _data["gruppoID"] !== undefined ? _data["gruppoID"] : <any>null;
            this.gruppo = _data["gruppo"] !== undefined ? _data["gruppo"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.dal = _data["dal"] !== undefined ? _data["dal"] : <any>null;
            this.al = _data["al"] !== undefined ? _data["al"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.servizioUrl = _data["servizioUrl"] !== undefined ? _data["servizioUrl"] : <any>null;
            this.rigaID = _data["rigaID"] !== undefined ? _data["rigaID"] : <any>null;
        }
    }

    static fromJS(data: any): AutofillTaskWarning {
        data = typeof data === 'object' ? data : {};
        let result = new AutofillTaskWarning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gruppoID"] = this.gruppoID !== undefined ? this.gruppoID : <any>null;
        data["gruppo"] = this.gruppo !== undefined ? this.gruppo : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["dal"] = this.dal !== undefined ? this.dal : <any>null;
        data["al"] = this.al !== undefined ? this.al : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["servizioUrl"] = this.servizioUrl !== undefined ? this.servizioUrl : <any>null;
        data["rigaID"] = this.rigaID !== undefined ? this.rigaID : <any>null;
        return data;
    }
}

export interface IAutofillTaskWarning {
    gruppoID?: number;
    gruppo?: string | null;
    tipo?: EAutofillWarningType;
    luogoID?: number | null;
    luogo?: string | null;
    dal?: string | null;
    al?: string | null;
    servizioID?: number | null;
    servizio?: string | null;
    servizioUrl?: string | null;
    rigaID?: number | null;
}

export enum EAutofillWarningType {
    VoliNonTrovati = "VoliNonTrovati",
    TappeModificatePerInserimentoVoli = "TappeModificatePerInserimentoVoli",
    HotelNonTrovato = "HotelNonTrovato",
    HotelNonCorrispondenteAiCriteri = "HotelNonCorrispondenteAiCriteri",
    TrasferimentoNonTrovato = "TrasferimentoNonTrovato",
}

export class PriceVerifyStatus extends TripBatchStatus implements IPriceVerifyStatus {
    confirming?: boolean;
    canConfirm?: boolean;
    result?: EPriceVerifyResult;
    rowResults?: PriceVerifyRowStatus[] | null;
    percentage?: number;

    constructor(data?: IPriceVerifyStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.confirming = _data["confirming"] !== undefined ? _data["confirming"] : <any>null;
            this.canConfirm = _data["canConfirm"] !== undefined ? _data["canConfirm"] : <any>null;
            this.result = _data["result"] !== undefined ? _data["result"] : <any>null;
            if (Array.isArray(_data["rowResults"])) {
                this.rowResults = [] as any;
                for (let item of _data["rowResults"])
                    this.rowResults!.push(PriceVerifyRowStatus.fromJS(item));
            }
            else {
                this.rowResults = <any>null;
            }
            this.percentage = _data["percentage"] !== undefined ? _data["percentage"] : <any>null;
        }
    }

    static fromJS(data: any): PriceVerifyStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PriceVerifyStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirming"] = this.confirming !== undefined ? this.confirming : <any>null;
        data["canConfirm"] = this.canConfirm !== undefined ? this.canConfirm : <any>null;
        data["result"] = this.result !== undefined ? this.result : <any>null;
        if (Array.isArray(this.rowResults)) {
            data["rowResults"] = [];
            for (let item of this.rowResults)
                data["rowResults"].push(item.toJSON());
        }
        data["percentage"] = this.percentage !== undefined ? this.percentage : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPriceVerifyStatus extends ITripBatchStatus {
    confirming?: boolean;
    canConfirm?: boolean;
    result?: EPriceVerifyResult;
    rowResults?: PriceVerifyRowStatus[] | null;
    percentage?: number;
}

export enum EPriceVerifyResult {
    NONE = "NONE",
    OK = "OK",
    PRICE_AVAIL_CHANGED = "PRICE_AVAIL_CHANGED",
    INVALID = "INVALID",
    ERROR = "ERROR",
    NOT_AVAILABLE = "NOT_AVAILABLE",
    RUNNING = "RUNNING",
}

export class PriceVerifyRowStatus implements IPriceVerifyRowStatus {
    id?: number;
    date?: string;
    group?: string | null;
    description?: string | null;
    verifyError?: boolean;
    priceChanged?: boolean;
    previousPrice?: number;
    newPrice?: number | null;
    availabilityChanged?: boolean;
    previousAvailability?: EStatoDisponibilita;
    newAvailability?: EStatoDisponibilita | null;
    result?: EPriceVerifyResult;

    constructor(data?: IPriceVerifyRowStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.group = _data["group"] !== undefined ? _data["group"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.verifyError = _data["verifyError"] !== undefined ? _data["verifyError"] : <any>null;
            this.priceChanged = _data["priceChanged"] !== undefined ? _data["priceChanged"] : <any>null;
            this.previousPrice = _data["previousPrice"] !== undefined ? _data["previousPrice"] : <any>null;
            this.newPrice = _data["newPrice"] !== undefined ? _data["newPrice"] : <any>null;
            this.availabilityChanged = _data["availabilityChanged"] !== undefined ? _data["availabilityChanged"] : <any>null;
            this.previousAvailability = _data["previousAvailability"] !== undefined ? _data["previousAvailability"] : <any>null;
            this.newAvailability = _data["newAvailability"] !== undefined ? _data["newAvailability"] : <any>null;
            this.result = _data["result"] !== undefined ? _data["result"] : <any>null;
        }
    }

    static fromJS(data: any): PriceVerifyRowStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PriceVerifyRowStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["group"] = this.group !== undefined ? this.group : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["verifyError"] = this.verifyError !== undefined ? this.verifyError : <any>null;
        data["priceChanged"] = this.priceChanged !== undefined ? this.priceChanged : <any>null;
        data["previousPrice"] = this.previousPrice !== undefined ? this.previousPrice : <any>null;
        data["newPrice"] = this.newPrice !== undefined ? this.newPrice : <any>null;
        data["availabilityChanged"] = this.availabilityChanged !== undefined ? this.availabilityChanged : <any>null;
        data["previousAvailability"] = this.previousAvailability !== undefined ? this.previousAvailability : <any>null;
        data["newAvailability"] = this.newAvailability !== undefined ? this.newAvailability : <any>null;
        data["result"] = this.result !== undefined ? this.result : <any>null;
        return data;
    }
}

export interface IPriceVerifyRowStatus {
    id?: number;
    date?: string;
    group?: string | null;
    description?: string | null;
    verifyError?: boolean;
    priceChanged?: boolean;
    previousPrice?: number;
    newPrice?: number | null;
    availabilityChanged?: boolean;
    previousAvailability?: EStatoDisponibilita;
    newAvailability?: EStatoDisponibilita | null;
    result?: EPriceVerifyResult;
}

export class UiPriceVerifyStatus extends PriceVerifyStatus implements IUiPriceVerifyStatus {

    constructor(data?: IUiPriceVerifyStatus) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UiPriceVerifyStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UiPriceVerifyStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUiPriceVerifyStatus extends IPriceVerifyStatus {
}

export class CheckTripStatusRequest extends LocalizedRequest implements ICheckTripStatusRequest {
    offertaID?: number;

    constructor(data?: ICheckTripStatusRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
        }
    }

    static fromJS(data: any): CheckTripStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckTripStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICheckTripStatusRequest extends ILocalizedRequest {
    offertaID?: number;
}

export class ConfermaRequest extends TripGetRequest implements IConfermaRequest {
    manuale?: boolean;
    inviaEmailConferma?: boolean;
    recipientUserID?: number | null;

    constructor(data?: IConfermaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.manuale = _data["manuale"] !== undefined ? _data["manuale"] : <any>null;
            this.inviaEmailConferma = _data["inviaEmailConferma"] !== undefined ? _data["inviaEmailConferma"] : <any>null;
            this.recipientUserID = _data["recipientUserID"] !== undefined ? _data["recipientUserID"] : <any>null;
        }
    }

    static fromJS(data: any): ConfermaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfermaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manuale"] = this.manuale !== undefined ? this.manuale : <any>null;
        data["inviaEmailConferma"] = this.inviaEmailConferma !== undefined ? this.inviaEmailConferma : <any>null;
        data["recipientUserID"] = this.recipientUserID !== undefined ? this.recipientUserID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IConfermaRequest extends ITripGetRequest {
    manuale?: boolean;
    inviaEmailConferma?: boolean;
    recipientUserID?: number | null;
}

export class CopiaDocumentoResponse extends TripGetResponse implements ICopiaDocumentoResponse {
    documentoCopia?: Documento | null;

    constructor(data?: ICopiaDocumentoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoCopia = _data["documentoCopia"] ? Documento.fromJS(_data["documentoCopia"]) : <any>null;
        }
    }

    static fromJS(data: any): CopiaDocumentoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopiaDocumentoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoCopia"] = this.documentoCopia ? this.documentoCopia.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICopiaDocumentoResponse extends ITripGetResponse {
    documentoCopia?: Documento | null;
}

export class CopiaDocumentoRequest extends TripGetRequest implements ICopiaDocumentoRequest {
    documentoID?: number;

    constructor(data?: ICopiaDocumentoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
        }
    }

    static fromJS(data: any): CopiaDocumentoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopiaDocumentoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICopiaDocumentoRequest extends ITripGetRequest {
    documentoID?: number;
}

export class CopiaRigaResponse extends TripGetResponse implements ICopiaRigaResponse {
    rigaCopiata?: OffertaDato | null;

    constructor(data?: ICopiaRigaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rigaCopiata = _data["rigaCopiata"] ? OffertaDato.fromJS(_data["rigaCopiata"]) : <any>null;
        }
    }

    static fromJS(data: any): CopiaRigaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopiaRigaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rigaCopiata"] = this.rigaCopiata ? this.rigaCopiata.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICopiaRigaResponse extends ITripGetResponse {
    rigaCopiata?: OffertaDato | null;
}

export class CopiaRigaRequest extends TripGetRequest implements ICopiaRigaRequest {
    offertaDatoID?: number;

    constructor(data?: ICopiaRigaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaDatoID = _data["offertaDatoID"] !== undefined ? _data["offertaDatoID"] : <any>null;
        }
    }

    static fromJS(data: any): CopiaRigaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopiaRigaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaDatoID"] = this.offertaDatoID !== undefined ? this.offertaDatoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICopiaRigaRequest extends ITripGetRequest {
    offertaDatoID?: number;
}

export class CopiaVoucherResponse extends TripGetResponse implements ICopiaVoucherResponse {
    voucherCopia?: Voucher | null;

    constructor(data?: ICopiaVoucherResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voucherCopia = _data["voucherCopia"] ? Voucher.fromJS(_data["voucherCopia"]) : <any>null;
        }
    }

    static fromJS(data: any): CopiaVoucherResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopiaVoucherResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCopia"] = this.voucherCopia ? this.voucherCopia.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICopiaVoucherResponse extends ITripGetResponse {
    voucherCopia?: Voucher | null;
}

export class CopiaVoucherRequest extends TripGetRequest implements ICopiaVoucherRequest {
    voucherID?: number;

    constructor(data?: ICopiaVoucherRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voucherID = _data["voucherID"] !== undefined ? _data["voucherID"] : <any>null;
        }
    }

    static fromJS(data: any): CopiaVoucherRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopiaVoucherRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherID"] = this.voucherID !== undefined ? this.voucherID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICopiaVoucherRequest extends ITripGetRequest {
    voucherID?: number;
}

export class CreateDocumentiAllegatiRequest extends TripGetRequest implements ICreateDocumentiAllegatiRequest {
    allegatiIds?: number[] | null;

    constructor(data?: ICreateDocumentiAllegatiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["allegatiIds"])) {
                this.allegatiIds = [] as any;
                for (let item of _data["allegatiIds"])
                    this.allegatiIds!.push(item);
            }
            else {
                this.allegatiIds = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateDocumentiAllegatiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentiAllegatiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allegatiIds)) {
            data["allegatiIds"] = [];
            for (let item of this.allegatiIds)
                data["allegatiIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateDocumentiAllegatiRequest extends ITripGetRequest {
    allegatiIds?: number[] | null;
}

export class CreateDocumentoResponse extends TripGetResponse implements ICreateDocumentoResponse {
    documentoID?: number;

    constructor(data?: ICreateDocumentoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
        }
    }

    static fromJS(data: any): CreateDocumentoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateDocumentoResponse extends ITripGetResponse {
    documentoID?: number;
}

export class CreateDocumentoRequest extends TripGetRequest implements ICreateDocumentoRequest {
    tipoDocumento?: ETipoDocumento;
    extraArgs?: string | null;

    constructor(data?: ICreateDocumentoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : <any>null;
            this.extraArgs = _data["extraArgs"] !== undefined ? _data["extraArgs"] : <any>null;
        }
    }

    static fromJS(data: any): CreateDocumentoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : <any>null;
        data["extraArgs"] = this.extraArgs !== undefined ? this.extraArgs : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateDocumentoRequest extends ITripGetRequest {
    tipoDocumento?: ETipoDocumento;
    extraArgs?: string | null;
}

export class EditNotaResponse extends TripGetResponse implements IEditNotaResponse {
    /** Entità della nota creata / modificata */
    nota?: OffertaNota;
    /** Dati aggiuntivi ad uso della UI */
    tripNote?: TripNote;

    constructor(data?: IEditNotaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nota = _data["nota"] ? OffertaNota.fromJS(_data["nota"]) : <any>null;
            this.tripNote = _data["tripNote"] ? TripNote.fromJS(_data["tripNote"]) : <any>null;
        }
    }

    static fromJS(data: any): EditNotaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditNotaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nota"] = this.nota ? this.nota.toJSON() : <any>null;
        data["tripNote"] = this.tripNote ? this.tripNote.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEditNotaResponse extends ITripGetResponse {
    /** Entità della nota creata / modificata */
    nota?: OffertaNota;
    /** Dati aggiuntivi ad uso della UI */
    tripNote?: TripNote;
}

export class EditNotaRequest extends TripGetRequest implements IEditNotaRequest {
    nota?: OffertaNota;

    constructor(data?: IEditNotaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nota = _data["nota"] ? OffertaNota.fromJS(_data["nota"]) : <any>null;
        }
    }

    static fromJS(data: any): EditNotaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditNotaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nota"] = this.nota ? this.nota.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEditNotaRequest extends ITripGetRequest {
    nota?: OffertaNota;
}

export class UpdateWebRequest extends TripGetRequest implements IUpdateWebRequest {
    /** Nome interno del viaggio */
    descrizione!: string;
    /** Note o meglio descrizione */
    note?: string | null;
    /** Titolo facoltativo da usare nei documenti */
    titolo?: string | null;

    constructor(data?: IUpdateWebRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.titolo = _data["titolo"] !== undefined ? _data["titolo"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateWebRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWebRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["titolo"] = this.titolo !== undefined ? this.titolo : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateWebRequest extends ITripGetRequest {
    /** Nome interno del viaggio */
    descrizione: string;
    /** Note o meglio descrizione */
    note?: string | null;
    /** Titolo facoltativo da usare nei documenti */
    titolo?: string | null;
}

export class CreateTripRequest extends UpdateWebRequest implements ICreateTripRequest {
    viaggioDiNozze?: boolean;
    fatturazioneAlNetto?: boolean;
    tipoViaggio?: ETipoViaggio;
    operatoreID?: number;
    contattoAgenziaID?: number;
    utenteID?: number | null;
    partenza?: string;
    servizioID?: number | null;
    tipologiaID?: number | null;
    /** Se true la tipologia usa le descrizioni macro */
    usaTipologieMacro?: boolean;
    itinerario!: OffertaItinerario[];
    clienti!: ClienteDatoUpdate[];
    servizi?: DatiServizioAdd[] | null;
    /** Se presente è una singola camera da cache */
    cameraCache?: string | null;
    /** ID della tappa per la camera cache */
    tappaCameraCache?: number | null;

    constructor(data?: ICreateTripRequest) {
        super(data);
        if (!data) {
            this.itinerario = [];
            this.clienti = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viaggioDiNozze = _data["viaggioDiNozze"] !== undefined ? _data["viaggioDiNozze"] : <any>null;
            this.fatturazioneAlNetto = _data["fatturazioneAlNetto"] !== undefined ? _data["fatturazioneAlNetto"] : <any>null;
            this.tipoViaggio = _data["tipoViaggio"] !== undefined ? _data["tipoViaggio"] : <any>null;
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : <any>null;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : <any>null;
            this.utenteID = _data["utenteID"] !== undefined ? _data["utenteID"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : <any>null;
            this.usaTipologieMacro = _data["usaTipologieMacro"] !== undefined ? _data["usaTipologieMacro"] : <any>null;
            if (Array.isArray(_data["itinerario"])) {
                this.itinerario = [] as any;
                for (let item of _data["itinerario"])
                    this.itinerario!.push(OffertaItinerario.fromJS(item));
            }
            else {
                this.itinerario = <any>null;
            }
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(ClienteDatoUpdate.fromJS(item));
            }
            else {
                this.clienti = <any>null;
            }
            if (Array.isArray(_data["servizi"])) {
                this.servizi = [] as any;
                for (let item of _data["servizi"])
                    this.servizi!.push(DatiServizioAdd.fromJS(item));
            }
            else {
                this.servizi = <any>null;
            }
            this.cameraCache = _data["cameraCache"] !== undefined ? _data["cameraCache"] : <any>null;
            this.tappaCameraCache = _data["tappaCameraCache"] !== undefined ? _data["tappaCameraCache"] : <any>null;
        }
    }

    static fromJS(data: any): CreateTripRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTripRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viaggioDiNozze"] = this.viaggioDiNozze !== undefined ? this.viaggioDiNozze : <any>null;
        data["fatturazioneAlNetto"] = this.fatturazioneAlNetto !== undefined ? this.fatturazioneAlNetto : <any>null;
        data["tipoViaggio"] = this.tipoViaggio !== undefined ? this.tipoViaggio : <any>null;
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : <any>null;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : <any>null;
        data["utenteID"] = this.utenteID !== undefined ? this.utenteID : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : <any>null;
        data["usaTipologieMacro"] = this.usaTipologieMacro !== undefined ? this.usaTipologieMacro : <any>null;
        if (Array.isArray(this.itinerario)) {
            data["itinerario"] = [];
            for (let item of this.itinerario)
                data["itinerario"].push(item.toJSON());
        }
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item.toJSON());
        }
        if (Array.isArray(this.servizi)) {
            data["servizi"] = [];
            for (let item of this.servizi)
                data["servizi"].push(item.toJSON());
        }
        data["cameraCache"] = this.cameraCache !== undefined ? this.cameraCache : <any>null;
        data["tappaCameraCache"] = this.tappaCameraCache !== undefined ? this.tappaCameraCache : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateTripRequest extends IUpdateWebRequest {
    viaggioDiNozze?: boolean;
    fatturazioneAlNetto?: boolean;
    tipoViaggio?: ETipoViaggio;
    operatoreID?: number;
    contattoAgenziaID?: number;
    utenteID?: number | null;
    partenza?: string;
    servizioID?: number | null;
    tipologiaID?: number | null;
    /** Se true la tipologia usa le descrizioni macro */
    usaTipologieMacro?: boolean;
    itinerario: OffertaItinerario[];
    clienti: ClienteDatoUpdate[];
    servizi?: DatiServizioAdd[] | null;
    /** Se presente è una singola camera da cache */
    cameraCache?: string | null;
    /** ID della tappa per la camera cache */
    tappaCameraCache?: number | null;
}

export class CreateQuotationRequest extends CreateTripRequest implements ICreateQuotationRequest {
    /** Tipo di viaggio, combina tipo e nozze */
    tipoViaggioPreventivo!: ETipoViaggioPreventivo;
    /** ID del luogo di partenza */
    luogoPartenzaID?: number | null;
    /** Data dell'appuntamento dell'ADV con il cliente */
    dataAppuntamentoADV?: string | null;
    /** Note abbinate all'appuntamento ADV */
    noteAppuntamento?: string | null;
    /** Descrizione testuale della destinazione */
    destinazione!: string;
    teamID?: number;
    /** Descrizione testuale delle opzioni di volo */
    opzioniVolo!: string;
    /** Descrizione testuale del budget */
    budget!: string;
    /** Descrizione testuale dei trasferimenti */
    trasferimenti?: string | null;
    /** Descrizione testuale dei noleggi */
    noleggi?: string | null;
    /** Descrizione testuale della categoria hotel */
    categoriaHotel?: string | null;
    /** Tolleranza della data di partenza in giorni */
    tolleranzaPartenza?: number | null;

    constructor(data?: ICreateQuotationRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoViaggioPreventivo = _data["tipoViaggioPreventivo"] !== undefined ? _data["tipoViaggioPreventivo"] : <any>null;
            this.luogoPartenzaID = _data["luogoPartenzaID"] !== undefined ? _data["luogoPartenzaID"] : <any>null;
            this.dataAppuntamentoADV = _data["dataAppuntamentoADV"] !== undefined ? _data["dataAppuntamentoADV"] : <any>null;
            this.noteAppuntamento = _data["noteAppuntamento"] !== undefined ? _data["noteAppuntamento"] : <any>null;
            this.destinazione = _data["destinazione"] !== undefined ? _data["destinazione"] : <any>null;
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : <any>null;
            this.opzioniVolo = _data["opzioniVolo"] !== undefined ? _data["opzioniVolo"] : <any>null;
            this.budget = _data["budget"] !== undefined ? _data["budget"] : <any>null;
            this.trasferimenti = _data["trasferimenti"] !== undefined ? _data["trasferimenti"] : <any>null;
            this.noleggi = _data["noleggi"] !== undefined ? _data["noleggi"] : <any>null;
            this.categoriaHotel = _data["categoriaHotel"] !== undefined ? _data["categoriaHotel"] : <any>null;
            this.tolleranzaPartenza = _data["tolleranzaPartenza"] !== undefined ? _data["tolleranzaPartenza"] : <any>null;
        }
    }

    static fromJS(data: any): CreateQuotationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuotationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoViaggioPreventivo"] = this.tipoViaggioPreventivo !== undefined ? this.tipoViaggioPreventivo : <any>null;
        data["luogoPartenzaID"] = this.luogoPartenzaID !== undefined ? this.luogoPartenzaID : <any>null;
        data["dataAppuntamentoADV"] = this.dataAppuntamentoADV !== undefined ? this.dataAppuntamentoADV : <any>null;
        data["noteAppuntamento"] = this.noteAppuntamento !== undefined ? this.noteAppuntamento : <any>null;
        data["destinazione"] = this.destinazione !== undefined ? this.destinazione : <any>null;
        data["teamID"] = this.teamID !== undefined ? this.teamID : <any>null;
        data["opzioniVolo"] = this.opzioniVolo !== undefined ? this.opzioniVolo : <any>null;
        data["budget"] = this.budget !== undefined ? this.budget : <any>null;
        data["trasferimenti"] = this.trasferimenti !== undefined ? this.trasferimenti : <any>null;
        data["noleggi"] = this.noleggi !== undefined ? this.noleggi : <any>null;
        data["categoriaHotel"] = this.categoriaHotel !== undefined ? this.categoriaHotel : <any>null;
        data["tolleranzaPartenza"] = this.tolleranzaPartenza !== undefined ? this.tolleranzaPartenza : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateQuotationRequest extends ICreateTripRequest {
    /** Tipo di viaggio, combina tipo e nozze */
    tipoViaggioPreventivo: ETipoViaggioPreventivo;
    /** ID del luogo di partenza */
    luogoPartenzaID?: number | null;
    /** Data dell'appuntamento dell'ADV con il cliente */
    dataAppuntamentoADV?: string | null;
    /** Note abbinate all'appuntamento ADV */
    noteAppuntamento?: string | null;
    /** Descrizione testuale della destinazione */
    destinazione: string;
    teamID?: number;
    /** Descrizione testuale delle opzioni di volo */
    opzioniVolo: string;
    /** Descrizione testuale del budget */
    budget: string;
    /** Descrizione testuale dei trasferimenti */
    trasferimenti?: string | null;
    /** Descrizione testuale dei noleggi */
    noleggi?: string | null;
    /** Descrizione testuale della categoria hotel */
    categoriaHotel?: string | null;
    /** Tolleranza della data di partenza in giorni */
    tolleranzaPartenza?: number | null;
}

export enum ETipoViaggioPreventivo {
    Indefinito = "Indefinito",
    Nozze = "Nozze",
    Gruppo = "Gruppo",
}

export class CreateRigaResponse extends TripGetResponse implements ICreateRigaResponse {
    rigaCreata?: TripService;

    constructor(data?: ICreateRigaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rigaCreata = _data["rigaCreata"] ? TripService.fromJS(_data["rigaCreata"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateRigaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRigaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rigaCreata"] = this.rigaCreata ? this.rigaCreata.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateRigaResponse extends ITripGetResponse {
    rigaCreata?: TripService;
}

export class CreateRigaRequest extends TripGetRequest implements ICreateRigaRequest {
    riga?: OffertaDato;
    stato?: OffertaDatoStato | null;

    constructor(data?: ICreateRigaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : <any>null;
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateRigaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRigaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : <any>null;
        data["stato"] = this.stato ? this.stato.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateRigaRequest extends ITripGetRequest {
    riga?: OffertaDato;
    stato?: OffertaDatoStato | null;
}

export class CreateSegnapostoPagamentoRequest extends TripGetRequest implements ICreateSegnapostoPagamentoRequest {
    rigaOriginaleID?: number;

    constructor(data?: ICreateSegnapostoPagamentoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rigaOriginaleID = _data["rigaOriginaleID"] !== undefined ? _data["rigaOriginaleID"] : <any>null;
        }
    }

    static fromJS(data: any): CreateSegnapostoPagamentoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSegnapostoPagamentoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rigaOriginaleID"] = this.rigaOriginaleID !== undefined ? this.rigaOriginaleID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateSegnapostoPagamentoRequest extends ITripGetRequest {
    rigaOriginaleID?: number;
}

export class CreateTripFromQuotationRequest extends CreateTripRequest implements ICreateTripFromQuotationRequest {

    constructor(data?: ICreateTripFromQuotationRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateTripFromQuotationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTripFromQuotationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateTripFromQuotationRequest extends ICreateTripRequest {
}

export class DeleteDocumentoRequest extends TripGetRequest implements IDeleteDocumentoRequest {
    documentoID?: number;

    constructor(data?: IDeleteDocumentoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentoID = _data["documentoID"] !== undefined ? _data["documentoID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteDocumentoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDocumentoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentoID"] = this.documentoID !== undefined ? this.documentoID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteDocumentoRequest extends ITripGetRequest {
    documentoID?: number;
}

export class DeleteDocumentoMultiRequest extends TripGetRequest implements IDeleteDocumentoMultiRequest {
    documentiIds?: number[] | null;

    constructor(data?: IDeleteDocumentoMultiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["documentiIds"])) {
                this.documentiIds = [] as any;
                for (let item of _data["documentiIds"])
                    this.documentiIds!.push(item);
            }
            else {
                this.documentiIds = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteDocumentoMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDocumentoMultiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentiIds)) {
            data["documentiIds"] = [];
            for (let item of this.documentiIds)
                data["documentiIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteDocumentoMultiRequest extends ITripGetRequest {
    documentiIds?: number[] | null;
}

export class DeleteNotaMultiRequest extends TripGetRequest implements IDeleteNotaMultiRequest {
    noteIds?: number[] | null;

    constructor(data?: IDeleteNotaMultiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["noteIds"])) {
                this.noteIds = [] as any;
                for (let item of _data["noteIds"])
                    this.noteIds!.push(item);
            }
            else {
                this.noteIds = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteNotaMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteNotaMultiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.noteIds)) {
            data["noteIds"] = [];
            for (let item of this.noteIds)
                data["noteIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteNotaMultiRequest extends ITripGetRequest {
    noteIds?: number[] | null;
}

export class DeleteServiziRequest extends TripGetRequest implements IDeleteServiziRequest {
    righeIds?: number[] | null;
    eliminaItinerariTour?: boolean;

    constructor(data?: IDeleteServiziRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["righeIds"])) {
                this.righeIds = [] as any;
                for (let item of _data["righeIds"])
                    this.righeIds!.push(item);
            }
            else {
                this.righeIds = <any>null;
            }
            this.eliminaItinerariTour = _data["eliminaItinerariTour"] !== undefined ? _data["eliminaItinerariTour"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteServiziRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteServiziRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.righeIds)) {
            data["righeIds"] = [];
            for (let item of this.righeIds)
                data["righeIds"].push(item);
        }
        data["eliminaItinerariTour"] = this.eliminaItinerariTour !== undefined ? this.eliminaItinerariTour : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteServiziRequest extends ITripGetRequest {
    righeIds?: number[] | null;
    eliminaItinerariTour?: boolean;
}

export class UpdateVoloRequest extends TripGetRequest implements IUpdateVoloRequest {
    volo?: Volo | null;
    segmenti?: VoloTratta[] | null;

    constructor(data?: IUpdateVoloRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.volo = _data["volo"] ? Volo.fromJS(_data["volo"]) : <any>null;
            if (Array.isArray(_data["segmenti"])) {
                this.segmenti = [] as any;
                for (let item of _data["segmenti"])
                    this.segmenti!.push(VoloTratta.fromJS(item));
            }
            else {
                this.segmenti = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateVoloRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVoloRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["volo"] = this.volo ? this.volo.toJSON() : <any>null;
        if (Array.isArray(this.segmenti)) {
            data["segmenti"] = [];
            for (let item of this.segmenti)
                data["segmenti"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateVoloRequest extends ITripGetRequest {
    volo?: Volo | null;
    segmenti?: VoloTratta[] | null;
}

export class DeleteVoucherRequest extends TripGetRequest implements IDeleteVoucherRequest {
    voucherID?: number;

    constructor(data?: IDeleteVoucherRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voucherID = _data["voucherID"] !== undefined ? _data["voucherID"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteVoucherRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteVoucherRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherID"] = this.voucherID !== undefined ? this.voucherID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteVoucherRequest extends ITripGetRequest {
    voucherID?: number;
}

export class DeleteVoucherMultiRequest extends TripGetRequest implements IDeleteVoucherMultiRequest {
    voucherIds?: number[] | null;

    constructor(data?: IDeleteVoucherMultiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["voucherIds"])) {
                this.voucherIds = [] as any;
                for (let item of _data["voucherIds"])
                    this.voucherIds!.push(item);
            }
            else {
                this.voucherIds = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteVoucherMultiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteVoucherMultiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.voucherIds)) {
            data["voucherIds"] = [];
            for (let item of this.voucherIds)
                data["voucherIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteVoucherMultiRequest extends ITripGetRequest {
    voucherIds?: number[] | null;
}

export class NrTableResponseOfTripActivityLogRow extends OkApiResponse implements INrTableResponseOfTripActivityLogRow {
    /** Array delle righe della pagina richiesta */
    rows?: TripActivityLogRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfTripActivityLogRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TripActivityLogRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfTripActivityLogRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfTripActivityLogRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfTripActivityLogRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: TripActivityLogRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class TripActivityLogRow implements ITripActivityLogRow {
    log?: SqlTripActivityLogItem | null;
    username?: string | null;
    agency?: string | null;

    constructor(data?: ITripActivityLogRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.log = _data["log"] ? SqlTripActivityLogItem.fromJS(_data["log"]) : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.agency = _data["agency"] !== undefined ? _data["agency"] : <any>null;
        }
    }

    static fromJS(data: any): TripActivityLogRow {
        data = typeof data === 'object' ? data : {};
        let result = new TripActivityLogRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["log"] = this.log ? this.log.toJSON() : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["agency"] = this.agency !== undefined ? this.agency : <any>null;
        return data;
    }
}

export interface ITripActivityLogRow {
    log?: SqlTripActivityLogItem | null;
    username?: string | null;
    agency?: string | null;
}

export class GetActivityLogsRequest extends NrTableRequest implements IGetActivityLogsRequest {
    offertaID?: number;
    date?: string | null;
    username?: string | null;
    message?: string | null;

    constructor(data?: IGetActivityLogsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): GetActivityLogsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityLogsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetActivityLogsRequest extends INrTableRequest {
    offertaID?: number;
    date?: string | null;
    username?: string | null;
    message?: string | null;
}

export class GetFlightsTicketsResponse extends OkApiResponse implements IGetFlightsTicketsResponse {
    tickets?: VoloTickets[] | null;

    constructor(data?: IGetFlightsTicketsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tickets"])) {
                this.tickets = [] as any;
                for (let item of _data["tickets"])
                    this.tickets!.push(VoloTickets.fromJS(item));
            }
            else {
                this.tickets = <any>null;
            }
        }
    }

    static fromJS(data: any): GetFlightsTicketsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlightsTicketsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tickets)) {
            data["tickets"] = [];
            for (let item of this.tickets)
                data["tickets"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetFlightsTicketsResponse extends IOkApiResponse {
    tickets?: VoloTickets[] | null;
}

export class GetFlightsTicketsRequest extends ApiRequest implements IGetFlightsTicketsRequest {
    offertaID?: number;

    constructor(data?: IGetFlightsTicketsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
        }
    }

    static fromJS(data: any): GetFlightsTicketsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlightsTicketsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFlightsTicketsRequest extends IApiRequest {
    offertaID?: number;
}

export class GetPaxConnectTripResponse extends OkApiResponse implements IGetPaxConnectTripResponse {
    paxConnectSerializedXML?: string | null;

    constructor(data?: IGetPaxConnectTripResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paxConnectSerializedXML = _data["paxConnectSerializedXML"] !== undefined ? _data["paxConnectSerializedXML"] : <any>null;
        }
    }

    static fromJS(data: any): GetPaxConnectTripResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaxConnectTripResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paxConnectSerializedXML"] = this.paxConnectSerializedXML !== undefined ? this.paxConnectSerializedXML : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPaxConnectTripResponse extends IOkApiResponse {
    paxConnectSerializedXML?: string | null;
}

export class GetPaxConnectTripRequest extends ApiRequest implements IGetPaxConnectTripRequest {
    tripID?: number;

    constructor(data?: IGetPaxConnectTripRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
        }
    }

    static fromJS(data: any): GetPaxConnectTripRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaxConnectTripRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPaxConnectTripRequest extends IApiRequest {
    tripID?: number;
}

export class GetQuotesResponse extends OkApiResponse implements IGetQuotesResponse {
    quotes?: string[];

    constructor(data?: IGetQuotesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["quotes"])) {
                this.quotes = [] as any;
                for (let item of _data["quotes"])
                    this.quotes!.push(item);
            }
            else {
                this.quotes = <any>null;
            }
        }
    }

    static fromJS(data: any): GetQuotesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuotesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.quotes)) {
            data["quotes"] = [];
            for (let item of this.quotes)
                data["quotes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetQuotesResponse extends IOkApiResponse {
    quotes?: string[];
}

export class GetQuotesRequest extends SiteRequest implements IGetQuotesRequest {

    constructor(data?: IGetQuotesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetQuotesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuotesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetQuotesRequest extends ISiteRequest {
}

export class GetServiziOffertaResponse extends OkApiResponse implements IGetServiziOffertaResponse {
    services?: TripService[] | null;

    constructor(data?: IGetServiziOffertaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(TripService.fromJS(item));
            }
            else {
                this.services = <any>null;
            }
        }
    }

    static fromJS(data: any): GetServiziOffertaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiziOffertaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiziOffertaResponse extends IOkApiResponse {
    services?: TripService[] | null;
}

export class GetServiziOffertaRequest extends TripGetRequest implements IGetServiziOffertaRequest {

    constructor(data?: IGetServiziOffertaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetServiziOffertaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiziOffertaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiziOffertaRequest extends ITripGetRequest {
}

export class GetServizioManualeResponse extends TripGetResponse implements IGetServizioManualeResponse {
    rigaServizioManuale?: OffertaDato | null;

    constructor(data?: IGetServizioManualeResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rigaServizioManuale = _data["rigaServizioManuale"] ? OffertaDato.fromJS(_data["rigaServizioManuale"]) : <any>null;
        }
    }

    static fromJS(data: any): GetServizioManualeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServizioManualeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rigaServizioManuale"] = this.rigaServizioManuale ? this.rigaServizioManuale.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServizioManualeResponse extends ITripGetResponse {
    rigaServizioManuale?: OffertaDato | null;
}

export class GetServizioManualeRequest extends TripGetRequest implements IGetServizioManualeRequest {
    servizio?: EServizioManuale;
    itinerarioID?: number | null;

    constructor(data?: IGetServizioManualeRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : <any>null;
        }
    }

    static fromJS(data: any): GetServizioManualeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetServizioManualeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetServizioManualeRequest extends ITripGetRequest {
    servizio?: EServizioManuale;
    itinerarioID?: number | null;
}

export enum EServizioManuale {
    ServizioManuale = "ServizioManuale",
    TariffaAerea = "TariffaAerea",
    TariffaAereaInstantPurchase = "TariffaAereaInstantPurchase",
    TasseAeroportuali = "TasseAeroportuali",
    InterventoCommerciale = "InterventoCommerciale",
    InterventoOperativo = "InterventoOperativo",
    RettificaPrezzi = "RettificaPrezzi",
    DirittiAgenzia = "DirittiAgenzia",
    Traghetti = "Traghetti",
    RailAndFly = "RailAndFly",
}

export class GetTripDescriptionsResponse extends OkApiResponse implements IGetTripDescriptionsResponse {
    descriptions?: TripDescriptionDay[];

    constructor(data?: IGetTripDescriptionsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["descriptions"])
                    this.descriptions!.push(TripDescriptionDay.fromJS(item));
            }
            else {
                this.descriptions = <any>null;
            }
        }
    }

    static fromJS(data: any): GetTripDescriptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDescriptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.descriptions)) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripDescriptionsResponse extends IOkApiResponse {
    descriptions?: TripDescriptionDay[];
}

export class GetTripDefaultDescriptionsResponse extends GetTripDescriptionsResponse implements IGetTripDefaultDescriptionsResponse {

    constructor(data?: IGetTripDefaultDescriptionsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetTripDefaultDescriptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDefaultDescriptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripDefaultDescriptionsResponse extends IGetTripDescriptionsResponse {
}

export class TripDescriptionDay implements ITripDescriptionDay {
    stop?: number;
    day?: number;
    order?: number;
    description?: string;
    canEdit?: boolean;

    constructor(data?: ITripDescriptionDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stop = _data["stop"] !== undefined ? _data["stop"] : <any>null;
            this.day = _data["day"] !== undefined ? _data["day"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.canEdit = _data["canEdit"] !== undefined ? _data["canEdit"] : <any>null;
        }
    }

    static fromJS(data: any): TripDescriptionDay {
        data = typeof data === 'object' ? data : {};
        let result = new TripDescriptionDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stop"] = this.stop !== undefined ? this.stop : <any>null;
        data["day"] = this.day !== undefined ? this.day : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["canEdit"] = this.canEdit !== undefined ? this.canEdit : <any>null;
        return data;
    }
}

export interface ITripDescriptionDay {
    stop?: number;
    day?: number;
    order?: number;
    description?: string;
    canEdit?: boolean;
}

export class GetTripDefaultDescriptionsRequest extends SiteRequest implements IGetTripDefaultDescriptionsRequest {
    days!: GetTripDefaultDescriptionsDay[];

    constructor(data?: IGetTripDefaultDescriptionsRequest) {
        super(data);
        if (!data) {
            this.days = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(GetTripDefaultDescriptionsDay.fromJS(item));
            }
            else {
                this.days = <any>null;
            }
        }
    }

    static fromJS(data: any): GetTripDefaultDescriptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDefaultDescriptionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripDefaultDescriptionsRequest extends ISiteRequest {
    days: GetTripDefaultDescriptionsDay[];
}

export class GetTripDefaultDescriptionsDay implements IGetTripDefaultDescriptionsDay {
    stopID?: number;
    day?: number;
    placeID?: number;
    transportType?: ETipoTrasporto;

    constructor(data?: IGetTripDefaultDescriptionsDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stopID = _data["stopID"] !== undefined ? _data["stopID"] : <any>null;
            this.day = _data["day"] !== undefined ? _data["day"] : <any>null;
            this.placeID = _data["placeID"] !== undefined ? _data["placeID"] : <any>null;
            this.transportType = _data["transportType"] !== undefined ? _data["transportType"] : <any>null;
        }
    }

    static fromJS(data: any): GetTripDefaultDescriptionsDay {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDefaultDescriptionsDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stopID"] = this.stopID !== undefined ? this.stopID : <any>null;
        data["day"] = this.day !== undefined ? this.day : <any>null;
        data["placeID"] = this.placeID !== undefined ? this.placeID : <any>null;
        data["transportType"] = this.transportType !== undefined ? this.transportType : <any>null;
        return data;
    }
}

export interface IGetTripDefaultDescriptionsDay {
    stopID?: number;
    day?: number;
    placeID?: number;
    transportType?: ETipoTrasporto;
}

export class GetTripDescriptionsRequest extends SiteRequest implements IGetTripDescriptionsRequest {
    offertaID?: number;

    constructor(data?: IGetTripDescriptionsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
        }
    }

    static fromJS(data: any): GetTripDescriptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripDescriptionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripDescriptionsRequest extends ISiteRequest {
    offertaID?: number;
}

export class GetTripSkelethonResponse extends TripGetResponse implements IGetTripSkelethonResponse {
    servizioID?: number | null;
    servizio?: string | null;
    tipologiaID?: number | null;
    trattamentoID?: number | null;
    tipologiaKey?: string | null;
    partenza?: string | null;
    luogoServizioTappaID?: number | null;
    tipologieDisponibili?: TripCreateType[] | null;
    richiediQuotazione?: boolean;
    roomsDef?: string;
    roomsDefDefault?: boolean;
    fromQuotationID?: number | null;

    constructor(data?: IGetTripSkelethonResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.servizio = _data["servizio"] !== undefined ? _data["servizio"] : <any>null;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
            this.tipologiaKey = _data["tipologiaKey"] !== undefined ? _data["tipologiaKey"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.luogoServizioTappaID = _data["luogoServizioTappaID"] !== undefined ? _data["luogoServizioTappaID"] : <any>null;
            if (Array.isArray(_data["tipologieDisponibili"])) {
                this.tipologieDisponibili = [] as any;
                for (let item of _data["tipologieDisponibili"])
                    this.tipologieDisponibili!.push(TripCreateType.fromJS(item));
            }
            else {
                this.tipologieDisponibili = <any>null;
            }
            this.richiediQuotazione = _data["richiediQuotazione"] !== undefined ? _data["richiediQuotazione"] : <any>null;
            this.roomsDef = _data["roomsDef"] !== undefined ? _data["roomsDef"] : <any>null;
            this.roomsDefDefault = _data["roomsDefDefault"] !== undefined ? _data["roomsDefDefault"] : <any>null;
            this.fromQuotationID = _data["fromQuotationID"] !== undefined ? _data["fromQuotationID"] : <any>null;
        }
    }

    static fromJS(data: any): GetTripSkelethonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripSkelethonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["servizio"] = this.servizio !== undefined ? this.servizio : <any>null;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        data["tipologiaKey"] = this.tipologiaKey !== undefined ? this.tipologiaKey : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["luogoServizioTappaID"] = this.luogoServizioTappaID !== undefined ? this.luogoServizioTappaID : <any>null;
        if (Array.isArray(this.tipologieDisponibili)) {
            data["tipologieDisponibili"] = [];
            for (let item of this.tipologieDisponibili)
                data["tipologieDisponibili"].push(item.toJSON());
        }
        data["richiediQuotazione"] = this.richiediQuotazione !== undefined ? this.richiediQuotazione : <any>null;
        data["roomsDef"] = this.roomsDef !== undefined ? this.roomsDef : <any>null;
        data["roomsDefDefault"] = this.roomsDefDefault !== undefined ? this.roomsDefDefault : <any>null;
        data["fromQuotationID"] = this.fromQuotationID !== undefined ? this.fromQuotationID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripSkelethonResponse extends ITripGetResponse {
    servizioID?: number | null;
    servizio?: string | null;
    tipologiaID?: number | null;
    trattamentoID?: number | null;
    tipologiaKey?: string | null;
    partenza?: string | null;
    luogoServizioTappaID?: number | null;
    tipologieDisponibili?: TripCreateType[] | null;
    richiediQuotazione?: boolean;
    roomsDef?: string;
    roomsDefDefault?: boolean;
    fromQuotationID?: number | null;
}

export class TripCreateType implements ITripCreateType {
    key?: string;
    tipologiaID?: number;
    nome?: string;
    trattamentoID?: number | null;
    trattamento?: string | null;
    aPartireDa?: number | null;

    constructor(data?: ITripCreateType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.trattamentoID = _data["trattamentoID"] !== undefined ? _data["trattamentoID"] : <any>null;
            this.trattamento = _data["trattamento"] !== undefined ? _data["trattamento"] : <any>null;
            this.aPartireDa = _data["aPartireDa"] !== undefined ? _data["aPartireDa"] : <any>null;
        }
    }

    static fromJS(data: any): TripCreateType {
        data = typeof data === 'object' ? data : {};
        let result = new TripCreateType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["trattamentoID"] = this.trattamentoID !== undefined ? this.trattamentoID : <any>null;
        data["trattamento"] = this.trattamento !== undefined ? this.trattamento : <any>null;
        data["aPartireDa"] = this.aPartireDa !== undefined ? this.aPartireDa : <any>null;
        return data;
    }
}

export interface ITripCreateType {
    key?: string;
    tipologiaID?: number;
    nome?: string;
    trattamentoID?: number | null;
    trattamento?: string | null;
    aPartireDa?: number | null;
}

export class GetTripSkelethonRequest extends SiteRequest implements IGetTripSkelethonRequest {
    nomeCameraFormat!: string;
    nomeAdultoFormat!: string;
    nomeBambinoFormat!: string;
    offerta?: OffertaBase;
    servizioID?: number | null;
    tipologiaID?: number | null;
    itinerarioID?: number | null;
    quotationID?: number | null;
    partenza?: string | null;
    notti?: number | null;
    soloItinerario?: boolean;
    luogoID?: number | null;
    roomsDef?: string | null;

    constructor(data?: IGetTripSkelethonRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nomeCameraFormat = _data["nomeCameraFormat"] !== undefined ? _data["nomeCameraFormat"] : <any>null;
            this.nomeAdultoFormat = _data["nomeAdultoFormat"] !== undefined ? _data["nomeAdultoFormat"] : <any>null;
            this.nomeBambinoFormat = _data["nomeBambinoFormat"] !== undefined ? _data["nomeBambinoFormat"] : <any>null;
            this.offerta = _data["offerta"] ? OffertaBase.fromJS(_data["offerta"]) : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : <any>null;
            this.itinerarioID = _data["itinerarioID"] !== undefined ? _data["itinerarioID"] : <any>null;
            this.quotationID = _data["quotationID"] !== undefined ? _data["quotationID"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.notti = _data["notti"] !== undefined ? _data["notti"] : <any>null;
            this.soloItinerario = _data["soloItinerario"] !== undefined ? _data["soloItinerario"] : <any>null;
            this.luogoID = _data["luogoID"] !== undefined ? _data["luogoID"] : <any>null;
            this.roomsDef = _data["roomsDef"] !== undefined ? _data["roomsDef"] : <any>null;
        }
    }

    static fromJS(data: any): GetTripSkelethonRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTripSkelethonRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nomeCameraFormat"] = this.nomeCameraFormat !== undefined ? this.nomeCameraFormat : <any>null;
        data["nomeAdultoFormat"] = this.nomeAdultoFormat !== undefined ? this.nomeAdultoFormat : <any>null;
        data["nomeBambinoFormat"] = this.nomeBambinoFormat !== undefined ? this.nomeBambinoFormat : <any>null;
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : <any>null;
        data["itinerarioID"] = this.itinerarioID !== undefined ? this.itinerarioID : <any>null;
        data["quotationID"] = this.quotationID !== undefined ? this.quotationID : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["notti"] = this.notti !== undefined ? this.notti : <any>null;
        data["soloItinerario"] = this.soloItinerario !== undefined ? this.soloItinerario : <any>null;
        data["luogoID"] = this.luogoID !== undefined ? this.luogoID : <any>null;
        data["roomsDef"] = this.roomsDef !== undefined ? this.roomsDef : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetTripSkelethonRequest extends ISiteRequest {
    nomeCameraFormat: string;
    nomeAdultoFormat: string;
    nomeBambinoFormat: string;
    offerta?: OffertaBase;
    servizioID?: number | null;
    tipologiaID?: number | null;
    itinerarioID?: number | null;
    quotationID?: number | null;
    partenza?: string | null;
    notti?: number | null;
    soloItinerario?: boolean;
    luogoID?: number | null;
    roomsDef?: string | null;
}

export abstract class OffertaBase implements IOffertaBase {
    offertaID?: number;
    riferimento?: number;
    descrizione?: string | null;
    destinazioneID?: number | null;
    creazione?: string;
    partenza?: string;
    tipo?: ETipoViaggio | null;
    impiegatoUtenteID?: number;
    totale?: number | null;
    totaleCommissione?: number | null;
    totaleCommissioneCee?: number | null;
    totaleCosto?: number | null;
    operatore?: EOperatore;
    codiceAeroportoPartenza?: string | null;
    note?: string | null;
    numeroPax?: number | null;
    versione?: number;
    cookie?: string | null;
    nozze?: boolean;
    templateID?: number | null;
    servizioID?: number | null;
    tipologiaID?: number | null;
    offertaOrigineID?: number | null;
    titoloViaggio?: string | null;
    ritorno?: string | null;

    constructor(data?: IOffertaBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.riferimento = _data["riferimento"] !== undefined ? _data["riferimento"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.destinazioneID = _data["destinazioneID"] !== undefined ? _data["destinazioneID"] : <any>null;
            this.creazione = _data["creazione"] !== undefined ? _data["creazione"] : <any>null;
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            this.tipo = _data["tipo"] !== undefined ? _data["tipo"] : <any>null;
            this.impiegatoUtenteID = _data["impiegatoUtenteID"] !== undefined ? _data["impiegatoUtenteID"] : <any>null;
            this.totale = _data["totale"] !== undefined ? _data["totale"] : <any>null;
            this.totaleCommissione = _data["totaleCommissione"] !== undefined ? _data["totaleCommissione"] : <any>null;
            this.totaleCommissioneCee = _data["totaleCommissioneCee"] !== undefined ? _data["totaleCommissioneCee"] : <any>null;
            this.totaleCosto = _data["totaleCosto"] !== undefined ? _data["totaleCosto"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.codiceAeroportoPartenza = _data["codiceAeroportoPartenza"] !== undefined ? _data["codiceAeroportoPartenza"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.numeroPax = _data["numeroPax"] !== undefined ? _data["numeroPax"] : <any>null;
            this.versione = _data["versione"] !== undefined ? _data["versione"] : <any>null;
            this.cookie = _data["cookie"] !== undefined ? _data["cookie"] : <any>null;
            this.nozze = _data["nozze"] !== undefined ? _data["nozze"] : <any>null;
            this.templateID = _data["templateID"] !== undefined ? _data["templateID"] : <any>null;
            this.servizioID = _data["servizioID"] !== undefined ? _data["servizioID"] : <any>null;
            this.tipologiaID = _data["tipologiaID"] !== undefined ? _data["tipologiaID"] : <any>null;
            this.offertaOrigineID = _data["offertaOrigineID"] !== undefined ? _data["offertaOrigineID"] : <any>null;
            this.titoloViaggio = _data["titoloViaggio"] !== undefined ? _data["titoloViaggio"] : <any>null;
            this.ritorno = _data["ritorno"] !== undefined ? _data["ritorno"] : <any>null;
        }
    }

    static fromJS(data: any): OffertaBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OffertaBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["riferimento"] = this.riferimento !== undefined ? this.riferimento : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["destinazioneID"] = this.destinazioneID !== undefined ? this.destinazioneID : <any>null;
        data["creazione"] = this.creazione !== undefined ? this.creazione : <any>null;
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        data["tipo"] = this.tipo !== undefined ? this.tipo : <any>null;
        data["impiegatoUtenteID"] = this.impiegatoUtenteID !== undefined ? this.impiegatoUtenteID : <any>null;
        data["totale"] = this.totale !== undefined ? this.totale : <any>null;
        data["totaleCommissione"] = this.totaleCommissione !== undefined ? this.totaleCommissione : <any>null;
        data["totaleCommissioneCee"] = this.totaleCommissioneCee !== undefined ? this.totaleCommissioneCee : <any>null;
        data["totaleCosto"] = this.totaleCosto !== undefined ? this.totaleCosto : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["codiceAeroportoPartenza"] = this.codiceAeroportoPartenza !== undefined ? this.codiceAeroportoPartenza : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["numeroPax"] = this.numeroPax !== undefined ? this.numeroPax : <any>null;
        data["versione"] = this.versione !== undefined ? this.versione : <any>null;
        data["cookie"] = this.cookie !== undefined ? this.cookie : <any>null;
        data["nozze"] = this.nozze !== undefined ? this.nozze : <any>null;
        data["templateID"] = this.templateID !== undefined ? this.templateID : <any>null;
        data["servizioID"] = this.servizioID !== undefined ? this.servizioID : <any>null;
        data["tipologiaID"] = this.tipologiaID !== undefined ? this.tipologiaID : <any>null;
        data["offertaOrigineID"] = this.offertaOrigineID !== undefined ? this.offertaOrigineID : <any>null;
        data["titoloViaggio"] = this.titoloViaggio !== undefined ? this.titoloViaggio : <any>null;
        data["ritorno"] = this.ritorno !== undefined ? this.ritorno : <any>null;
        return data;
    }
}

export interface IOffertaBase {
    offertaID?: number;
    riferimento?: number;
    descrizione?: string | null;
    destinazioneID?: number | null;
    creazione?: string;
    partenza?: string;
    tipo?: ETipoViaggio | null;
    impiegatoUtenteID?: number;
    totale?: number | null;
    totaleCommissione?: number | null;
    totaleCommissioneCee?: number | null;
    totaleCosto?: number | null;
    operatore?: EOperatore;
    codiceAeroportoPartenza?: string | null;
    note?: string | null;
    numeroPax?: number | null;
    versione?: number;
    cookie?: string | null;
    nozze?: boolean;
    templateID?: number | null;
    servizioID?: number | null;
    tipologiaID?: number | null;
    offertaOrigineID?: number | null;
    titoloViaggio?: string | null;
    ritorno?: string | null;
}

export class InviaDocumentiRequest extends TripGetRequest implements IInviaDocumentiRequest {
    recipient?: string | null;
    documentiId?: number[] | null;
    testo?: string | null;
    nomiDocumenti?: { [key in keyof typeof ETipoDocumento]?: string; } | null;

    constructor(data?: IInviaDocumentiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recipient = _data["recipient"] !== undefined ? _data["recipient"] : <any>null;
            if (Array.isArray(_data["documentiId"])) {
                this.documentiId = [] as any;
                for (let item of _data["documentiId"])
                    this.documentiId!.push(item);
            }
            else {
                this.documentiId = <any>null;
            }
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            if (_data["nomiDocumenti"]) {
                this.nomiDocumenti = {} as any;
                for (let key in _data["nomiDocumenti"]) {
                    if (_data["nomiDocumenti"].hasOwnProperty(key))
                        (<any>this.nomiDocumenti)![key] = _data["nomiDocumenti"][key] !== undefined ? _data["nomiDocumenti"][key] : <any>null;
                }
            }
            else {
                this.nomiDocumenti = <any>null;
            }
        }
    }

    static fromJS(data: any): InviaDocumentiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviaDocumentiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient !== undefined ? this.recipient : <any>null;
        if (Array.isArray(this.documentiId)) {
            data["documentiId"] = [];
            for (let item of this.documentiId)
                data["documentiId"].push(item);
        }
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        if (this.nomiDocumenti) {
            data["nomiDocumenti"] = {};
            for (let key in this.nomiDocumenti) {
                if (this.nomiDocumenti.hasOwnProperty(key))
                    (<any>data["nomiDocumenti"])[key] = this.nomiDocumenti[key] !== undefined ? this.nomiDocumenti[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInviaDocumentiRequest extends ITripGetRequest {
    recipient?: string | null;
    documentiId?: number[] | null;
    testo?: string | null;
    nomiDocumenti?: { [key in keyof typeof ETipoDocumento]?: string; } | null;
}

export class InviaDocumentoAgenziaRequest extends TripGetRequest implements IInviaDocumentoAgenziaRequest {
    tipoDocumento?: ETipoDocumento;
    recipient?: string | null;
    cc?: string | null;
    testo?: string | null;
    nomiDocumenti?: { [key in keyof typeof ETipoDocumento]?: string; } | null;

    constructor(data?: IInviaDocumentoAgenziaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tipoDocumento = _data["tipoDocumento"] !== undefined ? _data["tipoDocumento"] : <any>null;
            this.recipient = _data["recipient"] !== undefined ? _data["recipient"] : <any>null;
            this.cc = _data["cc"] !== undefined ? _data["cc"] : <any>null;
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
            if (_data["nomiDocumenti"]) {
                this.nomiDocumenti = {} as any;
                for (let key in _data["nomiDocumenti"]) {
                    if (_data["nomiDocumenti"].hasOwnProperty(key))
                        (<any>this.nomiDocumenti)![key] = _data["nomiDocumenti"][key] !== undefined ? _data["nomiDocumenti"][key] : <any>null;
                }
            }
            else {
                this.nomiDocumenti = <any>null;
            }
        }
    }

    static fromJS(data: any): InviaDocumentoAgenziaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviaDocumentoAgenziaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoDocumento"] = this.tipoDocumento !== undefined ? this.tipoDocumento : <any>null;
        data["recipient"] = this.recipient !== undefined ? this.recipient : <any>null;
        data["cc"] = this.cc !== undefined ? this.cc : <any>null;
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        if (this.nomiDocumenti) {
            data["nomiDocumenti"] = {};
            for (let key in this.nomiDocumenti) {
                if (this.nomiDocumenti.hasOwnProperty(key))
                    (<any>data["nomiDocumenti"])[key] = this.nomiDocumenti[key] !== undefined ? this.nomiDocumenti[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInviaDocumentoAgenziaRequest extends ITripGetRequest {
    tipoDocumento?: ETipoDocumento;
    recipient?: string | null;
    cc?: string | null;
    testo?: string | null;
    nomiDocumenti?: { [key in keyof typeof ETipoDocumento]?: string; } | null;
}

export class InviaQuotationReadyRequest extends SiteRequest implements IInviaQuotationReadyRequest {
    offertaID!: number;
    recipient!: string;
    recipientID!: number;
    quotationLink!: string;
    checkFileExistence?: boolean;

    constructor(data?: IInviaQuotationReadyRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.recipient = _data["recipient"] !== undefined ? _data["recipient"] : <any>null;
            this.recipientID = _data["recipientID"] !== undefined ? _data["recipientID"] : <any>null;
            this.quotationLink = _data["quotationLink"] !== undefined ? _data["quotationLink"] : <any>null;
            this.checkFileExistence = _data["checkFileExistence"] !== undefined ? _data["checkFileExistence"] : <any>null;
        }
    }

    static fromJS(data: any): InviaQuotationReadyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviaQuotationReadyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["recipient"] = this.recipient !== undefined ? this.recipient : <any>null;
        data["recipientID"] = this.recipientID !== undefined ? this.recipientID : <any>null;
        data["quotationLink"] = this.quotationLink !== undefined ? this.quotationLink : <any>null;
        data["checkFileExistence"] = this.checkFileExistence !== undefined ? this.checkFileExistence : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInviaQuotationReadyRequest extends ISiteRequest {
    offertaID: number;
    recipient: string;
    recipientID: number;
    quotationLink: string;
    checkFileExistence?: boolean;
}

export class InviaVoucherRequest extends TripGetRequest implements IInviaVoucherRequest {
    recipient?: string | null;
    voucherIds?: number[] | null;
    testo?: string | null;

    constructor(data?: IInviaVoucherRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recipient = _data["recipient"] !== undefined ? _data["recipient"] : <any>null;
            if (Array.isArray(_data["voucherIds"])) {
                this.voucherIds = [] as any;
                for (let item of _data["voucherIds"])
                    this.voucherIds!.push(item);
            }
            else {
                this.voucherIds = <any>null;
            }
            this.testo = _data["testo"] !== undefined ? _data["testo"] : <any>null;
        }
    }

    static fromJS(data: any): InviaVoucherRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviaVoucherRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient !== undefined ? this.recipient : <any>null;
        if (Array.isArray(this.voucherIds)) {
            data["voucherIds"] = [];
            for (let item of this.voucherIds)
                data["voucherIds"].push(item);
        }
        data["testo"] = this.testo !== undefined ? this.testo : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInviaVoucherRequest extends ITripGetRequest {
    recipient?: string | null;
    voucherIds?: number[] | null;
    testo?: string | null;
}

export class RecalcAnticipoFornitoreResponse extends OkApiResponse implements IRecalcAnticipoFornitoreResponse {
    riga?: OffertaDato;
    stato?: OffertaDatoStato;
    nomeRegola?: string | null;

    constructor(data?: IRecalcAnticipoFornitoreResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : <any>null;
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : <any>null;
            this.nomeRegola = _data["nomeRegola"] !== undefined ? _data["nomeRegola"] : <any>null;
        }
    }

    static fromJS(data: any): RecalcAnticipoFornitoreResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecalcAnticipoFornitoreResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : <any>null;
        data["stato"] = this.stato ? this.stato.toJSON() : <any>null;
        data["nomeRegola"] = this.nomeRegola !== undefined ? this.nomeRegola : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRecalcAnticipoFornitoreResponse extends IOkApiResponse {
    riga?: OffertaDato;
    stato?: OffertaDatoStato;
    nomeRegola?: string | null;
}

export class RecalcAnticipoFornitoreRequest extends SiteRequest implements IRecalcAnticipoFornitoreRequest {
    riga!: OffertaDato;
    stato!: OffertaDatoStato;

    constructor(data?: IRecalcAnticipoFornitoreRequest) {
        super(data);
        if (!data) {
            this.riga = new OffertaDato();
            this.stato = new OffertaDatoStato();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : new OffertaDato();
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : new OffertaDatoStato();
        }
    }

    static fromJS(data: any): RecalcAnticipoFornitoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecalcAnticipoFornitoreRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : <any>null;
        data["stato"] = this.stato ? this.stato.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRecalcAnticipoFornitoreRequest extends ISiteRequest {
    riga: OffertaDato;
    stato: OffertaDatoStato;
}

export class RecalcPricesResponse extends OkApiResponse implements IRecalcPricesResponse {
    riga?: OffertaDato | null;

    constructor(data?: IRecalcPricesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : <any>null;
        }
    }

    static fromJS(data: any): RecalcPricesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecalcPricesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRecalcPricesResponse extends IOkApiResponse {
    riga?: OffertaDato | null;
}

export class RecalcPricesRequest extends SiteRequest implements IRecalcPricesRequest {
    riga?: OffertaDato | null;
    moltiplicaPax?: boolean;

    constructor(data?: IRecalcPricesRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : <any>null;
            this.moltiplicaPax = _data["moltiplicaPax"] !== undefined ? _data["moltiplicaPax"] : <any>null;
        }
    }

    static fromJS(data: any): RecalcPricesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecalcPricesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : <any>null;
        data["moltiplicaPax"] = this.moltiplicaPax !== undefined ? this.moltiplicaPax : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRecalcPricesRequest extends ISiteRequest {
    riga?: OffertaDato | null;
    moltiplicaPax?: boolean;
}

export class ResetVerificaPaxVoloRequest extends TripGetRequest implements IResetVerificaPaxVoloRequest {
    /** ID del volo del quale resettare il flag */
    voloID?: number;

    constructor(data?: IResetVerificaPaxVoloRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voloID = _data["voloID"] !== undefined ? _data["voloID"] : <any>null;
        }
    }

    static fromJS(data: any): ResetVerificaPaxVoloRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetVerificaPaxVoloRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voloID"] = this.voloID !== undefined ? this.voloID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IResetVerificaPaxVoloRequest extends ITripGetRequest {
    /** ID del volo del quale resettare il flag */
    voloID?: number;
}

export class RichiestaSupportoBookingRequest extends TripGetRequest implements IRichiestaSupportoBookingRequest {
    messaggio!: string;
    teamID?: number | null;

    constructor(data?: IRichiestaSupportoBookingRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.messaggio = _data["messaggio"] !== undefined ? _data["messaggio"] : <any>null;
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : <any>null;
        }
    }

    static fromJS(data: any): RichiestaSupportoBookingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RichiestaSupportoBookingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messaggio"] = this.messaggio !== undefined ? this.messaggio : <any>null;
        data["teamID"] = this.teamID !== undefined ? this.teamID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRichiestaSupportoBookingRequest extends ITripGetRequest {
    messaggio: string;
    teamID?: number | null;
}

export class SbloccaConfermaRequest extends TripGetRequest implements ISbloccaConfermaRequest {
    righeDaSbloccareIDs?: number[];

    constructor(data?: ISbloccaConfermaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["righeDaSbloccareIDs"])) {
                this.righeDaSbloccareIDs = [] as any;
                for (let item of _data["righeDaSbloccareIDs"])
                    this.righeDaSbloccareIDs!.push(item);
            }
            else {
                this.righeDaSbloccareIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): SbloccaConfermaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SbloccaConfermaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.righeDaSbloccareIDs)) {
            data["righeDaSbloccareIDs"] = [];
            for (let item of this.righeDaSbloccareIDs)
                data["righeDaSbloccareIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISbloccaConfermaRequest extends ITripGetRequest {
    righeDaSbloccareIDs?: number[];
}

export class SbloccaItinerarioRequest extends TripGetRequest implements ISbloccaItinerarioRequest {

    constructor(data?: ISbloccaItinerarioRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SbloccaItinerarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SbloccaItinerarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISbloccaItinerarioRequest extends ITripGetRequest {
}

export class SetTripDescriptionsResponse extends GetTripDescriptionsResponse implements ISetTripDescriptionsResponse {

    constructor(data?: ISetTripDescriptionsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SetTripDescriptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetTripDescriptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetTripDescriptionsResponse extends IGetTripDescriptionsResponse {
}

export class SetTripDescriptionsRequest extends SiteRequest implements ISetTripDescriptionsRequest {
    offertaID?: number;
    descriptions?: TripDescriptionDay[];

    constructor(data?: ISetTripDescriptionsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            if (Array.isArray(_data["descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["descriptions"])
                    this.descriptions!.push(TripDescriptionDay.fromJS(item));
            }
            else {
                this.descriptions = <any>null;
            }
        }
    }

    static fromJS(data: any): SetTripDescriptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetTripDescriptionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        if (Array.isArray(this.descriptions)) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetTripDescriptionsRequest extends ISiteRequest {
    offertaID?: number;
    descriptions?: TripDescriptionDay[];
}

export class UpdateRequest extends TripGetRequest implements IUpdateRequest {
    offerta?: OffertaBase | null;

    constructor(data?: IUpdateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offerta = _data["offerta"] ? OffertaBase.fromJS(_data["offerta"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerta"] = this.offerta ? this.offerta.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateRequest extends ITripGetRequest {
    offerta?: OffertaBase | null;
}

export class UpdateAgenziaRequest extends TripGetRequest implements IUpdateAgenziaRequest {
    operatore?: EOperatore;
    /** Entit� dell'offerta agenzia */
    offertaAgenzia?: OffertaAgenzia | null;
    /** Elenco degli id dei tag da assegnare */
    tagIds?: number[] | null;

    constructor(data?: IUpdateAgenziaRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.offertaAgenzia = _data["offertaAgenzia"] ? OffertaAgenzia.fromJS(_data["offertaAgenzia"]) : <any>null;
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            else {
                this.tagIds = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateAgenziaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgenziaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["offertaAgenzia"] = this.offertaAgenzia ? this.offertaAgenzia.toJSON() : <any>null;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAgenziaRequest extends ITripGetRequest {
    operatore?: EOperatore;
    /** Entit� dell'offerta agenzia */
    offertaAgenzia?: OffertaAgenzia | null;
    /** Elenco degli id dei tag da assegnare */
    tagIds?: number[] | null;
}

export class UpdateCamereSempliciRequest extends TripGetRequest implements IUpdateCamereSempliciRequest {
    camere?: CameraConClienti[] | null;

    constructor(data?: IUpdateCamereSempliciRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["camere"])) {
                this.camere = [] as any;
                for (let item of _data["camere"])
                    this.camere!.push(CameraConClienti.fromJS(item));
            }
            else {
                this.camere = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateCamereSempliciRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCamereSempliciRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.camere)) {
            data["camere"] = [];
            for (let item of this.camere)
                data["camere"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCamereSempliciRequest extends ITripGetRequest {
    camere?: CameraConClienti[] | null;
}

export class UpdateCamereCompletoRequest extends UpdateCamereSempliciRequest implements IUpdateCamereCompletoRequest {

    constructor(data?: IUpdateCamereCompletoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateCamereCompletoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCamereCompletoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCamereCompletoRequest extends IUpdateCamereSempliciRequest {
}

export class CameraConClienti implements ICameraConClienti {
    abbinamento?: Abbinamento | null;
    clienti?: Cliente[] | null;

    constructor(data?: ICameraConClienti) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abbinamento = _data["abbinamento"] ? Abbinamento.fromJS(_data["abbinamento"]) : <any>null;
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(Cliente.fromJS(item));
            }
            else {
                this.clienti = <any>null;
            }
        }
    }

    static fromJS(data: any): CameraConClienti {
        data = typeof data === 'object' ? data : {};
        let result = new CameraConClienti();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abbinamento"] = this.abbinamento ? this.abbinamento.toJSON() : <any>null;
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICameraConClienti {
    abbinamento?: Abbinamento | null;
    clienti?: Cliente[] | null;
}

export class UpdateClientiRequest extends TripGetRequest implements IUpdateClientiRequest {
    clienti?: ClienteDatoUpdate[] | null;

    constructor(data?: IUpdateClientiRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["clienti"])) {
                this.clienti = [] as any;
                for (let item of _data["clienti"])
                    this.clienti!.push(ClienteDatoUpdate.fromJS(item));
            }
            else {
                this.clienti = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateClientiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clienti)) {
            data["clienti"] = [];
            for (let item of this.clienti)
                data["clienti"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateClientiRequest extends ITripGetRequest {
    clienti?: ClienteDatoUpdate[] | null;
}

export class UpdateConfirmDataRequest extends TripGetRequest implements IUpdateConfirmDataRequest {
    datiConferme!: DatiConfermaRiga[];

    constructor(data?: IUpdateConfirmDataRequest) {
        super(data);
        if (!data) {
            this.datiConferme = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datiConferme"])) {
                this.datiConferme = [] as any;
                for (let item of _data["datiConferme"])
                    this.datiConferme!.push(DatiConfermaRiga.fromJS(item));
            }
            else {
                this.datiConferme = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateConfirmDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfirmDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datiConferme)) {
            data["datiConferme"] = [];
            for (let item of this.datiConferme)
                data["datiConferme"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateConfirmDataRequest extends ITripGetRequest {
    datiConferme: DatiConfermaRiga[];
}

export class UpdateDocumentDataRequest extends TripGetRequest implements IUpdateDocumentDataRequest {
    datiDocumenti!: DatiDocumentoRiga[];

    constructor(data?: IUpdateDocumentDataRequest) {
        super(data);
        if (!data) {
            this.datiDocumenti = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["datiDocumenti"])) {
                this.datiDocumenti = [] as any;
                for (let item of _data["datiDocumenti"])
                    this.datiDocumenti!.push(DatiDocumentoRiga.fromJS(item));
            }
            else {
                this.datiDocumenti = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateDocumentDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datiDocumenti)) {
            data["datiDocumenti"] = [];
            for (let item of this.datiDocumenti)
                data["datiDocumenti"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDocumentDataRequest extends ITripGetRequest {
    datiDocumenti: DatiDocumentoRiga[];
}

export class UpdateFlightsTicketsRequest extends GetFlightsTicketsRequest implements IUpdateFlightsTicketsRequest {
    tickets!: VoloTickets[];

    constructor(data?: IUpdateFlightsTicketsRequest) {
        super(data);
        if (!data) {
            this.tickets = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["tickets"])) {
                this.tickets = [] as any;
                for (let item of _data["tickets"])
                    this.tickets!.push(VoloTickets.fromJS(item));
            }
            else {
                this.tickets = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateFlightsTicketsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFlightsTicketsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tickets)) {
            data["tickets"] = [];
            for (let item of this.tickets)
                data["tickets"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateFlightsTicketsRequest extends IGetFlightsTicketsRequest {
    tickets: VoloTickets[];
}

export class UpdateItinerarioCompletoRequest extends TripGetRequest implements IUpdateItinerarioCompletoRequest {
    partenza?: string;
    itinerario?: OffertaItinerario[] | null;
    eliminaServiziSuCambioLuogo?: boolean;
    aggiustaServizi?: boolean;

    constructor(data?: IUpdateItinerarioCompletoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.partenza = _data["partenza"] !== undefined ? _data["partenza"] : <any>null;
            if (Array.isArray(_data["itinerario"])) {
                this.itinerario = [] as any;
                for (let item of _data["itinerario"])
                    this.itinerario!.push(OffertaItinerario.fromJS(item));
            }
            else {
                this.itinerario = <any>null;
            }
            this.eliminaServiziSuCambioLuogo = _data["eliminaServiziSuCambioLuogo"] !== undefined ? _data["eliminaServiziSuCambioLuogo"] : <any>null;
            this.aggiustaServizi = _data["aggiustaServizi"] !== undefined ? _data["aggiustaServizi"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateItinerarioCompletoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateItinerarioCompletoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partenza"] = this.partenza !== undefined ? this.partenza : <any>null;
        if (Array.isArray(this.itinerario)) {
            data["itinerario"] = [];
            for (let item of this.itinerario)
                data["itinerario"].push(item.toJSON());
        }
        data["eliminaServiziSuCambioLuogo"] = this.eliminaServiziSuCambioLuogo !== undefined ? this.eliminaServiziSuCambioLuogo : <any>null;
        data["aggiustaServizi"] = this.aggiustaServizi !== undefined ? this.aggiustaServizi : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateItinerarioCompletoRequest extends ITripGetRequest {
    partenza?: string;
    itinerario?: OffertaItinerario[] | null;
    eliminaServiziSuCambioLuogo?: boolean;
    aggiustaServizi?: boolean;
}

export class UpdateRigaResponse extends TripGetResponse implements IUpdateRigaResponse {
    /** Entità della riga salvata */
    riga?: OffertaDato | null;
    /** Entità dello status salvato */
    stato?: OffertaDatoStato | null;
    /** Dati Host-2-Host e aggiuntivi */
    datiH2H?: OffertaDatoH2H | null;
    /** Dati del servizio utili alla UI */
    servizio?: TripService | null;

    constructor(data?: IUpdateRigaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : <any>null;
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : <any>null;
            this.datiH2H = _data["datiH2H"] ? OffertaDatoH2H.fromJS(_data["datiH2H"]) : <any>null;
            this.servizio = _data["servizio"] ? TripService.fromJS(_data["servizio"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateRigaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRigaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : <any>null;
        data["stato"] = this.stato ? this.stato.toJSON() : <any>null;
        data["datiH2H"] = this.datiH2H ? this.datiH2H.toJSON() : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateRigaResponse extends ITripGetResponse {
    /** Entità della riga salvata */
    riga?: OffertaDato | null;
    /** Entità dello status salvato */
    stato?: OffertaDatoStato | null;
    /** Dati Host-2-Host e aggiuntivi */
    datiH2H?: OffertaDatoH2H | null;
    /** Dati del servizio utili alla UI */
    servizio?: TripService | null;
}

export class UpdateRigaRequest extends TripGetRequest implements IUpdateRigaRequest {
    riga!: OffertaDato;
    stato?: OffertaDatoStato | null;
    datiH2H?: OffertaDatoH2H | null;

    constructor(data?: IUpdateRigaRequest) {
        super(data);
        if (!data) {
            this.riga = new OffertaDato();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.riga = _data["riga"] ? OffertaDato.fromJS(_data["riga"]) : new OffertaDato();
            this.stato = _data["stato"] ? OffertaDatoStato.fromJS(_data["stato"]) : <any>null;
            this.datiH2H = _data["datiH2H"] ? OffertaDatoH2H.fromJS(_data["datiH2H"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateRigaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRigaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riga"] = this.riga ? this.riga.toJSON() : <any>null;
        data["stato"] = this.stato ? this.stato.toJSON() : <any>null;
        data["datiH2H"] = this.datiH2H ? this.datiH2H.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateRigaRequest extends ITripGetRequest {
    riga: OffertaDato;
    stato?: OffertaDatoStato | null;
    datiH2H?: OffertaDatoH2H | null;
}

export class UpdateStatoRequest extends TripGetRequest implements IUpdateStatoRequest {
    offertaAgenziaStato?: OffertaAgenziaStato | null;

    constructor(data?: IUpdateStatoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaAgenziaStato = _data["offertaAgenziaStato"] ? OffertaAgenziaStato.fromJS(_data["offertaAgenziaStato"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateStatoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaAgenziaStato"] = this.offertaAgenziaStato ? this.offertaAgenziaStato.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateStatoRequest extends ITripGetRequest {
    offertaAgenziaStato?: OffertaAgenziaStato | null;
}

export class UpdateStatoPreventivoRequest extends TripGetRequest implements IUpdateStatoPreventivoRequest {
    statusPreventivo?: EStatusPreventivo;

    constructor(data?: IUpdateStatoPreventivoRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statusPreventivo = _data["statusPreventivo"] !== undefined ? _data["statusPreventivo"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateStatoPreventivoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatoPreventivoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusPreventivo"] = this.statusPreventivo !== undefined ? this.statusPreventivo : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateStatoPreventivoRequest extends ITripGetRequest {
    statusPreventivo?: EStatusPreventivo;
}

export class UpdateItinerarioRequest extends TripGetRequest implements IUpdateItinerarioRequest {
    itinerario?: OffertaItinerario | null;
    eliminaServiziSuCambioLuogo?: boolean;
    aggiustaServizi?: boolean;

    constructor(data?: IUpdateItinerarioRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.itinerario = _data["itinerario"] ? OffertaItinerario.fromJS(_data["itinerario"]) : <any>null;
            this.eliminaServiziSuCambioLuogo = _data["eliminaServiziSuCambioLuogo"] !== undefined ? _data["eliminaServiziSuCambioLuogo"] : <any>null;
            this.aggiustaServizi = _data["aggiustaServizi"] !== undefined ? _data["aggiustaServizi"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateItinerarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateItinerarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerario"] = this.itinerario ? this.itinerario.toJSON() : <any>null;
        data["eliminaServiziSuCambioLuogo"] = this.eliminaServiziSuCambioLuogo !== undefined ? this.eliminaServiziSuCambioLuogo : <any>null;
        data["aggiustaServizi"] = this.aggiustaServizi !== undefined ? this.aggiustaServizi : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateItinerarioRequest extends ITripGetRequest {
    itinerario?: OffertaItinerario | null;
    eliminaServiziSuCambioLuogo?: boolean;
    aggiustaServizi?: boolean;
}

export class UpdateVoucherResponse extends TripGetResponse implements IUpdateVoucherResponse {
    voucher?: Voucher | null;

    constructor(data?: IUpdateVoucherResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voucher = _data["voucher"] ? Voucher.fromJS(_data["voucher"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateVoucherResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVoucherResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucher"] = this.voucher ? this.voucher.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateVoucherResponse extends ITripGetResponse {
    voucher?: Voucher | null;
}

export class UpdateVoucherRequest extends TripGetRequest implements IUpdateVoucherRequest {
    voucher?: Voucher | null;

    constructor(data?: IUpdateVoucherRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voucher = _data["voucher"] ? Voucher.fromJS(_data["voucher"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateVoucherRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVoucherRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucher"] = this.voucher ? this.voucher.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateVoucherRequest extends ITripGetRequest {
    voucher?: Voucher | null;
}

export class ChangePasswordRequest extends ApiRequest implements IChangePasswordRequest {
    /** Password attuale */
    currentPassword!: string;
    /** Nuova password */
    newPassword!: string;

    constructor(data?: IChangePasswordRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.currentPassword = _data["currentPassword"] !== undefined ? _data["currentPassword"] : <any>null;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : <any>null;
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword !== undefined ? this.currentPassword : <any>null;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IChangePasswordRequest extends IApiRequest {
    /** Password attuale */
    currentPassword: string;
    /** Nuova password */
    newPassword: string;
}

export class CreateCrossLoginResponse extends OkApiResponse implements ICreateCrossLoginResponse {
    /** Codice univoco monouso */
    codice?: string;

    constructor(data?: ICreateCrossLoginResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
        }
    }

    static fromJS(data: any): CreateCrossLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCrossLoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateCrossLoginResponse extends IOkApiResponse {
    /** Codice univoco monouso */
    codice?: string;
}

export class CreateCrossLoginRequest extends ApiRequest implements ICreateCrossLoginRequest {
    /** ID dell'utente da impersonare */
    targetUserID!: number;

    constructor(data?: ICreateCrossLoginRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.targetUserID = _data["targetUserID"] !== undefined ? _data["targetUserID"] : <any>null;
        }
    }

    static fromJS(data: any): CreateCrossLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCrossLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUserID"] = this.targetUserID !== undefined ? this.targetUserID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateCrossLoginRequest extends IApiRequest {
    /** ID dell'utente da impersonare */
    targetUserID: number;
}

export class ListTeamsResponse extends OkApiResponse implements IListTeamsResponse {
    teams?: Team[];

    constructor(data?: IListTeamsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(Team.fromJS(item));
            }
            else {
                this.teams = <any>null;
            }
        }
    }

    static fromJS(data: any): ListTeamsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListTeamsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IListTeamsResponse extends IOkApiResponse {
    teams?: Team[];
}

export class UpdateTeamResponse extends ListTeamsResponse implements IUpdateTeamResponse {
    /** Entità Team modificata */
    team?: Team;

    constructor(data?: IUpdateTeamResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.team = _data["team"] ? Team.fromJS(_data["team"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateTeamResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["team"] = this.team ? this.team.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTeamResponse extends IListTeamsResponse {
    /** Entità Team modificata */
    team?: Team;
}

export class UpdateTeamRequest extends ApiRequest implements IUpdateTeamRequest {
    team!: TeamBase;

    constructor(data?: IUpdateTeamRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.team = _data["team"] ? TeamBase.fromJS(_data["team"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateTeamRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["team"] = this.team ? this.team.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTeamRequest extends IApiRequest {
    team: TeamBase;
}

export abstract class TeamBase implements ITeamBase {
    teamID?: string;
    nome?: string;
    email?: string | null;
    visibilita?: EVisibilitaTeam;

    constructor(data?: ITeamBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.visibilita = _data["visibilita"] !== undefined ? _data["visibilita"] : <any>null;
        }
    }

    static fromJS(data: any): TeamBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TeamBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamID"] = this.teamID !== undefined ? this.teamID : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["visibilita"] = this.visibilita !== undefined ? this.visibilita : <any>null;
        return data;
    }
}

export interface ITeamBase {
    teamID?: string;
    nome?: string;
    email?: string | null;
    visibilita?: EVisibilitaTeam;
}

export class UserGetRequest extends LocalizedRequest implements IUserGetRequest {
    /** ID dell'utente di cui chiedere i dati */
    id!: number;

    constructor(data?: IUserGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): UserGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUserGetRequest extends ILocalizedRequest {
    /** ID dell'utente di cui chiedere i dati */
    id: number;
}

export class UserDeleteRequest extends UserGetRequest implements IUserDeleteRequest {

    constructor(data?: IUserDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UserDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUserDeleteRequest extends IUserGetRequest {
}

export class DeleteMultiUserRequest extends ApiRequest implements IDeleteMultiUserRequest {
    /** Lista degli ID da eliminare */
    userIDs!: number[];

    constructor(data?: IDeleteMultiUserRequest) {
        super(data);
        if (!data) {
            this.userIDs = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["userIDs"])) {
                this.userIDs = [] as any;
                for (let item of _data["userIDs"])
                    this.userIDs!.push(item);
            }
            else {
                this.userIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteMultiUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMultiUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIDs)) {
            data["userIDs"] = [];
            for (let item of this.userIDs)
                data["userIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteMultiUserRequest extends IApiRequest {
    /** Lista degli ID da eliminare */
    userIDs: number[];
}

export class EnableFastLoginFromExcelResponse extends OkApiResponse implements IEnableFastLoginFromExcelResponse {

    constructor(data?: IEnableFastLoginFromExcelResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EnableFastLoginFromExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnableFastLoginFromExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEnableFastLoginFromExcelResponse extends IOkApiResponse {
}

export class UserGetResponse extends OkApiResponse implements IUserGetResponse {
    /** Dati dell'utente con l'ID richiesto oppure null */
    row?: UsersListRow | null;

    constructor(data?: IUserGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.row = _data["row"] ? UsersListRow.fromJS(_data["row"]) : <any>null;
        }
    }

    static fromJS(data: any): UserGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["row"] = this.row ? this.row.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUserGetResponse extends IOkApiResponse {
    /** Dati dell'utente con l'ID richiesto oppure null */
    row?: UsersListRow | null;
}

/** Classe di visualizzazione della riga nella lista utenti */
export class UsersListRow implements IUsersListRow {
    /** ID dell'utente */
    id?: number;
    /** Indirizzo email dell'utente */
    email?: string | null;
    /** Nome completo */
    nomeVisualizzato?: string;
    /** Tipo di utente */
    tipoUtente?: ETipoUtente;
    /** Data e ora di creazione dell'utente */
    dataRegistrazione?: string;
    /** Nome dell'eventuale agenzia associata all'utente */
    nomeAgenzia?: string | null;
    /** Entità dell'utente (evita un roundtrip sul server quando si apre l'editor) */
    utente?: Utente;
    fastLoginTokenIsValid?: boolean;
    emailLoginEnabled?: boolean;

    constructor(data?: IUsersListRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.nomeVisualizzato = _data["nomeVisualizzato"] !== undefined ? _data["nomeVisualizzato"] : <any>null;
            this.tipoUtente = _data["tipoUtente"] !== undefined ? _data["tipoUtente"] : <any>null;
            this.dataRegistrazione = _data["dataRegistrazione"] !== undefined ? _data["dataRegistrazione"] : <any>null;
            this.nomeAgenzia = _data["nomeAgenzia"] !== undefined ? _data["nomeAgenzia"] : <any>null;
            this.utente = _data["utente"] ? Utente.fromJS(_data["utente"]) : <any>null;
            this.fastLoginTokenIsValid = _data["fastLoginTokenIsValid"] !== undefined ? _data["fastLoginTokenIsValid"] : <any>null;
            this.emailLoginEnabled = _data["emailLoginEnabled"] !== undefined ? _data["emailLoginEnabled"] : <any>null;
        }
    }

    static fromJS(data: any): UsersListRow {
        data = typeof data === 'object' ? data : {};
        let result = new UsersListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["nomeVisualizzato"] = this.nomeVisualizzato !== undefined ? this.nomeVisualizzato : <any>null;
        data["tipoUtente"] = this.tipoUtente !== undefined ? this.tipoUtente : <any>null;
        data["dataRegistrazione"] = this.dataRegistrazione !== undefined ? this.dataRegistrazione : <any>null;
        data["nomeAgenzia"] = this.nomeAgenzia !== undefined ? this.nomeAgenzia : <any>null;
        data["utente"] = this.utente ? this.utente.toJSON() : <any>null;
        data["fastLoginTokenIsValid"] = this.fastLoginTokenIsValid !== undefined ? this.fastLoginTokenIsValid : <any>null;
        data["emailLoginEnabled"] = this.emailLoginEnabled !== undefined ? this.emailLoginEnabled : <any>null;
        return data;
    }
}

/** Classe di visualizzazione della riga nella lista utenti */
export interface IUsersListRow {
    /** ID dell'utente */
    id?: number;
    /** Indirizzo email dell'utente */
    email?: string | null;
    /** Nome completo */
    nomeVisualizzato?: string;
    /** Tipo di utente */
    tipoUtente?: ETipoUtente;
    /** Data e ora di creazione dell'utente */
    dataRegistrazione?: string;
    /** Nome dell'eventuale agenzia associata all'utente */
    nomeAgenzia?: string | null;
    /** Entità dell'utente (evita un roundtrip sul server quando si apre l'editor) */
    utente?: Utente;
    fastLoginTokenIsValid?: boolean;
    emailLoginEnabled?: boolean;
}

export class GetUserRolesResponse extends OkApiResponse implements IGetUserRolesResponse {
    /** Lista degli ID degli ruoli assegnati a questo utente */
    rolesIds?: number[];

    constructor(data?: IGetUserRolesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rolesIds"])) {
                this.rolesIds = [] as any;
                for (let item of _data["rolesIds"])
                    this.rolesIds!.push(item);
            }
            else {
                this.rolesIds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetUserRolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserRolesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rolesIds)) {
            data["rolesIds"] = [];
            for (let item of this.rolesIds)
                data["rolesIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetUserRolesResponse extends IOkApiResponse {
    /** Lista degli ID degli ruoli assegnati a questo utente */
    rolesIds?: number[];
}

export class NrTableResponseOfUsersListRow extends OkApiResponse implements INrTableResponseOfUsersListRow {
    /** Array delle righe della pagina richiesta */
    rows?: UsersListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfUsersListRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(UsersListRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfUsersListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfUsersListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfUsersListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: UsersListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class UsersListResponse extends NrTableResponseOfUsersListRow implements IUsersListResponse {

    constructor(data?: IUsersListResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UsersListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UsersListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUsersListResponse extends INrTableResponseOfUsersListRow {
}

export class UsersListRequest extends NrTableRequest implements IUsersListRequest {
    /** True show only valid, false show also the deleted users */
    showValid?: boolean;
    /** Termine di ricerca / ID facoltativo */
    term?: string | null;
    /** ID di un'agenzia alla quale restringere la ricerca */
    agencyContactID?: number | null;
    /** Dizionario per tradurre i tipi utente (solo export) */
    nomiTipoUtente?: { [key in keyof typeof ETipoUtente]?: string; } | null;

    constructor(data?: IUsersListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.showValid = _data["showValid"] !== undefined ? _data["showValid"] : <any>null;
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.agencyContactID = _data["agencyContactID"] !== undefined ? _data["agencyContactID"] : <any>null;
            if (_data["nomiTipoUtente"]) {
                this.nomiTipoUtente = {} as any;
                for (let key in _data["nomiTipoUtente"]) {
                    if (_data["nomiTipoUtente"].hasOwnProperty(key))
                        (<any>this.nomiTipoUtente)![key] = _data["nomiTipoUtente"][key] !== undefined ? _data["nomiTipoUtente"][key] : <any>null;
                }
            }
            else {
                this.nomiTipoUtente = <any>null;
            }
        }
    }

    static fromJS(data: any): UsersListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UsersListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showValid"] = this.showValid !== undefined ? this.showValid : <any>null;
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["agencyContactID"] = this.agencyContactID !== undefined ? this.agencyContactID : <any>null;
        if (this.nomiTipoUtente) {
            data["nomiTipoUtente"] = {};
            for (let key in this.nomiTipoUtente) {
                if (this.nomiTipoUtente.hasOwnProperty(key))
                    (<any>data["nomiTipoUtente"])[key] = this.nomiTipoUtente[key] !== undefined ? this.nomiTipoUtente[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUsersListRequest extends INrTableRequest {
    /** True show only valid, false show also the deleted users */
    showValid?: boolean;
    /** Termine di ricerca / ID facoltativo */
    term?: string | null;
    /** ID di un'agenzia alla quale restringere la ricerca */
    agencyContactID?: number | null;
    /** Dizionario per tradurre i tipi utente (solo export) */
    nomiTipoUtente?: { [key in keyof typeof ETipoUtente]?: string; } | null;
}

export class ListRolesResponse extends OkApiResponse implements IListRolesResponse {
    /** Elenco degli ruoli */
    roles?: RoleListData[];

    constructor(data?: IListRolesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleListData.fromJS(item));
            }
            else {
                this.roles = <any>null;
            }
        }
    }

    static fromJS(data: any): ListRolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListRolesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IListRolesResponse extends IOkApiResponse {
    /** Elenco degli ruoli */
    roles?: RoleListData[];
}

export class RoleListData implements IRoleListData {
    /** ID del ruolo */
    id?: number;
    /** Nome del ruolo */
    name?: string;
    /** Entità del ruolo */
    ruolo?: Ruolo;
    /** Lista degli ID dei permessi associati */
    permissionsIDs?: number[];

    constructor(data?: IRoleListData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.ruolo = _data["ruolo"] ? Ruolo.fromJS(_data["ruolo"]) : <any>null;
            if (Array.isArray(_data["permissionsIDs"])) {
                this.permissionsIDs = [] as any;
                for (let item of _data["permissionsIDs"])
                    this.permissionsIDs!.push(item);
            }
            else {
                this.permissionsIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): RoleListData {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["ruolo"] = this.ruolo ? this.ruolo.toJSON() : <any>null;
        if (Array.isArray(this.permissionsIDs)) {
            data["permissionsIDs"] = [];
            for (let item of this.permissionsIDs)
                data["permissionsIDs"].push(item);
        }
        return data;
    }
}

export interface IRoleListData {
    /** ID del ruolo */
    id?: number;
    /** Nome del ruolo */
    name?: string;
    /** Entità del ruolo */
    ruolo?: Ruolo;
    /** Lista degli ID dei permessi associati */
    permissionsIDs?: number[];
}

export class Ruolo implements IRuolo {
    id?: number;
    nome!: string;

    constructor(data?: IRuolo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
        }
    }

    static fromJS(data: any): Ruolo {
        data = typeof data === 'object' ? data : {};
        let result = new Ruolo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        return data;
    }
}

export interface IRuolo {
    id?: number;
    nome: string;
}

export class NrTableResponseOfUsersLoggedListRow extends OkApiResponse implements INrTableResponseOfUsersLoggedListRow {
    /** Array delle righe della pagina richiesta */
    rows?: UsersLoggedListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfUsersLoggedListRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(UsersLoggedListRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfUsersLoggedListRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfUsersLoggedListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfUsersLoggedListRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: UsersLoggedListRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class UsersLoggedListRow extends UsersListRow implements IUsersLoggedListRow {
    /** Data e ora dell'ultima richiesta */
    ultimaRichiesta?: string | null;

    constructor(data?: IUsersLoggedListRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ultimaRichiesta = _data["ultimaRichiesta"] !== undefined ? _data["ultimaRichiesta"] : <any>null;
        }
    }

    static fromJS(data: any): UsersLoggedListRow {
        data = typeof data === 'object' ? data : {};
        let result = new UsersLoggedListRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ultimaRichiesta"] = this.ultimaRichiesta !== undefined ? this.ultimaRichiesta : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUsersLoggedListRow extends IUsersListRow {
    /** Data e ora dell'ultima richiesta */
    ultimaRichiesta?: string | null;
}

export class UsersLoggedListRequest extends NrTableRequest implements IUsersLoggedListRequest {
    /** Termine di ricerca / ID facoltativo */
    term?: string | null;
    /** Minuti di inattività */
    minutes?: number | null;

    constructor(data?: IUsersLoggedListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.term = _data["term"] !== undefined ? _data["term"] : <any>null;
            this.minutes = _data["minutes"] !== undefined ? _data["minutes"] : <any>null;
        }
    }

    static fromJS(data: any): UsersLoggedListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UsersLoggedListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term !== undefined ? this.term : <any>null;
        data["minutes"] = this.minutes !== undefined ? this.minutes : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUsersLoggedListRequest extends INrTableRequest {
    /** Termine di ricerca / ID facoltativo */
    term?: string | null;
    /** Minuti di inattività */
    minutes?: number | null;
}

export class PasswordResetRequest extends ApiRequest implements IPasswordResetRequest {
    /** Codice monouso di cambio password */
    codice!: string;
    /** Nuova password */
    password!: string;

    constructor(data?: IPasswordResetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.codice = _data["codice"] !== undefined ? _data["codice"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): PasswordResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codice"] = this.codice !== undefined ? this.codice : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPasswordResetRequest extends IApiRequest {
    /** Codice monouso di cambio password */
    codice: string;
    /** Nuova password */
    password: string;
}

export class UserRestoreRequest extends UserGetRequest implements IUserRestoreRequest {

    constructor(data?: IUserRestoreRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UserRestoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserRestoreRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUserRestoreRequest extends IUserGetRequest {
}

export class SendPasswordRecoveryRequest extends LocalizedRequest implements ISendPasswordRecoveryRequest {
    /** Email dell'utente che vuole recuperare la password */
    email!: string;
    /** Stringa di formato con la url per il recupero password.
Deve essere nel formato
https://itb2b.naar.com/auth/reset/{0}
dove il segnaposto {0} è il codice univoco monouso */
    passwordResetUrl!: string;

    constructor(data?: ISendPasswordRecoveryRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.passwordResetUrl = _data["passwordResetUrl"] !== undefined ? _data["passwordResetUrl"] : <any>null;
        }
    }

    static fromJS(data: any): SendPasswordRecoveryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordRecoveryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["passwordResetUrl"] = this.passwordResetUrl !== undefined ? this.passwordResetUrl : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISendPasswordRecoveryRequest extends ILocalizedRequest {
    /** Email dell'utente che vuole recuperare la password */
    email: string;
    /** Stringa di formato con la url per il recupero password.
Deve essere nel formato
https://itb2b.naar.com/auth/reset/{0}
dove il segnaposto {0} è il codice univoco monouso */
    passwordResetUrl: string;
}

export class SetRolesRequest extends UserGetRequest implements ISetRolesRequest {
    rolesIds!: number[];

    constructor(data?: ISetRolesRequest) {
        super(data);
        if (!data) {
            this.rolesIds = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rolesIds"])) {
                this.rolesIds = [] as any;
                for (let item of _data["rolesIds"])
                    this.rolesIds!.push(item);
            }
            else {
                this.rolesIds = <any>null;
            }
        }
    }

    static fromJS(data: any): SetRolesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRolesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rolesIds)) {
            data["rolesIds"] = [];
            for (let item of this.rolesIds)
                data["rolesIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISetRolesRequest extends IUserGetRequest {
    rolesIds: number[];
}

export class UpsertUserRequest extends ApiRequest implements IUpsertUserRequest {
    utente!: UtenteBase;

    constructor(data?: IUpsertUserRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.utente = _data["utente"] ? UtenteBase.fromJS(_data["utente"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utente"] = this.utente ? this.utente.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertUserRequest extends IApiRequest {
    utente: UtenteBase;
}

export abstract class UtenteBase implements IUtenteBase {
    id?: number;
    contattoAgenziaID?: number | null;
    contattoUtenteID?: number | null;
    tipoUtente?: ETipoUtente | null;
    registrationDate?: string;
    email?: string | null;
    nome?: string | null;
    cognome?: string | null;
    passwordInChiaro?: string | null;
    passwordCifrata?: string | null;
    abilitato?: boolean;
    eliminato?: boolean;
    deleted?: string | null;
    operatoreID?: number | null;
    abilitazioneCrs?: number | null;
    telefono?: string | null;
    teamID?: string | null;
    npr?: boolean;
    uiOptions?: string | null;
    fuorisede?: boolean;
    emailFuorisede?: string | null;
    categoriaContattoID?: number | null;
    utentePadreID?: number | null;
    fastLoginEnabled?: boolean | null;
    fastLogingEnabledDate?: string | null;
    fastLoginTokenValidityDays?: number | null;
    fastLoginToken?: string | null;
    emailLoginEnabled?: boolean | null;
    basecampRefreshToken?: string | null;

    constructor(data?: IUtenteBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.contattoAgenziaID = _data["contattoAgenziaID"] !== undefined ? _data["contattoAgenziaID"] : <any>null;
            this.contattoUtenteID = _data["contattoUtenteID"] !== undefined ? _data["contattoUtenteID"] : <any>null;
            this.tipoUtente = _data["tipoUtente"] !== undefined ? _data["tipoUtente"] : <any>null;
            this.registrationDate = _data["registrationDate"] !== undefined ? _data["registrationDate"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.cognome = _data["cognome"] !== undefined ? _data["cognome"] : <any>null;
            this.passwordInChiaro = _data["passwordInChiaro"] !== undefined ? _data["passwordInChiaro"] : <any>null;
            this.passwordCifrata = _data["passwordCifrata"] !== undefined ? _data["passwordCifrata"] : <any>null;
            this.abilitato = _data["abilitato"] !== undefined ? _data["abilitato"] : <any>null;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
            this.operatoreID = _data["operatoreID"] !== undefined ? _data["operatoreID"] : <any>null;
            this.abilitazioneCrs = _data["abilitazioneCrs"] !== undefined ? _data["abilitazioneCrs"] : <any>null;
            this.telefono = _data["telefono"] !== undefined ? _data["telefono"] : <any>null;
            this.teamID = _data["teamID"] !== undefined ? _data["teamID"] : <any>null;
            this.npr = _data["npr"] !== undefined ? _data["npr"] : <any>null;
            this.uiOptions = _data["uiOptions"] !== undefined ? _data["uiOptions"] : <any>null;
            this.fuorisede = _data["fuorisede"] !== undefined ? _data["fuorisede"] : <any>null;
            this.emailFuorisede = _data["emailFuorisede"] !== undefined ? _data["emailFuorisede"] : <any>null;
            this.categoriaContattoID = _data["categoriaContattoID"] !== undefined ? _data["categoriaContattoID"] : <any>null;
            this.utentePadreID = _data["utentePadreID"] !== undefined ? _data["utentePadreID"] : <any>null;
            this.fastLoginEnabled = _data["fastLoginEnabled"] !== undefined ? _data["fastLoginEnabled"] : <any>null;
            this.fastLogingEnabledDate = _data["fastLogingEnabledDate"] !== undefined ? _data["fastLogingEnabledDate"] : <any>null;
            this.fastLoginTokenValidityDays = _data["fastLoginTokenValidityDays"] !== undefined ? _data["fastLoginTokenValidityDays"] : <any>null;
            this.fastLoginToken = _data["fastLoginToken"] !== undefined ? _data["fastLoginToken"] : <any>null;
            this.emailLoginEnabled = _data["emailLoginEnabled"] !== undefined ? _data["emailLoginEnabled"] : <any>null;
            this.basecampRefreshToken = _data["basecampRefreshToken"] !== undefined ? _data["basecampRefreshToken"] : <any>null;
        }
    }

    static fromJS(data: any): UtenteBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'UtenteBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["contattoAgenziaID"] = this.contattoAgenziaID !== undefined ? this.contattoAgenziaID : <any>null;
        data["contattoUtenteID"] = this.contattoUtenteID !== undefined ? this.contattoUtenteID : <any>null;
        data["tipoUtente"] = this.tipoUtente !== undefined ? this.tipoUtente : <any>null;
        data["registrationDate"] = this.registrationDate !== undefined ? this.registrationDate : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["cognome"] = this.cognome !== undefined ? this.cognome : <any>null;
        data["passwordInChiaro"] = this.passwordInChiaro !== undefined ? this.passwordInChiaro : <any>null;
        data["passwordCifrata"] = this.passwordCifrata !== undefined ? this.passwordCifrata : <any>null;
        data["abilitato"] = this.abilitato !== undefined ? this.abilitato : <any>null;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        data["operatoreID"] = this.operatoreID !== undefined ? this.operatoreID : <any>null;
        data["abilitazioneCrs"] = this.abilitazioneCrs !== undefined ? this.abilitazioneCrs : <any>null;
        data["telefono"] = this.telefono !== undefined ? this.telefono : <any>null;
        data["teamID"] = this.teamID !== undefined ? this.teamID : <any>null;
        data["npr"] = this.npr !== undefined ? this.npr : <any>null;
        data["uiOptions"] = this.uiOptions !== undefined ? this.uiOptions : <any>null;
        data["fuorisede"] = this.fuorisede !== undefined ? this.fuorisede : <any>null;
        data["emailFuorisede"] = this.emailFuorisede !== undefined ? this.emailFuorisede : <any>null;
        data["categoriaContattoID"] = this.categoriaContattoID !== undefined ? this.categoriaContattoID : <any>null;
        data["utentePadreID"] = this.utentePadreID !== undefined ? this.utentePadreID : <any>null;
        data["fastLoginEnabled"] = this.fastLoginEnabled !== undefined ? this.fastLoginEnabled : <any>null;
        data["fastLogingEnabledDate"] = this.fastLogingEnabledDate !== undefined ? this.fastLogingEnabledDate : <any>null;
        data["fastLoginTokenValidityDays"] = this.fastLoginTokenValidityDays !== undefined ? this.fastLoginTokenValidityDays : <any>null;
        data["fastLoginToken"] = this.fastLoginToken !== undefined ? this.fastLoginToken : <any>null;
        data["emailLoginEnabled"] = this.emailLoginEnabled !== undefined ? this.emailLoginEnabled : <any>null;
        data["basecampRefreshToken"] = this.basecampRefreshToken !== undefined ? this.basecampRefreshToken : <any>null;
        return data;
    }
}

export interface IUtenteBase {
    id?: number;
    contattoAgenziaID?: number | null;
    contattoUtenteID?: number | null;
    tipoUtente?: ETipoUtente | null;
    registrationDate?: string;
    email?: string | null;
    nome?: string | null;
    cognome?: string | null;
    passwordInChiaro?: string | null;
    passwordCifrata?: string | null;
    abilitato?: boolean;
    eliminato?: boolean;
    deleted?: string | null;
    operatoreID?: number | null;
    abilitazioneCrs?: number | null;
    telefono?: string | null;
    teamID?: string | null;
    npr?: boolean;
    uiOptions?: string | null;
    fuorisede?: boolean;
    emailFuorisede?: string | null;
    categoriaContattoID?: number | null;
    utentePadreID?: number | null;
    fastLoginEnabled?: boolean | null;
    fastLogingEnabledDate?: string | null;
    fastLoginTokenValidityDays?: number | null;
    fastLoginToken?: string | null;
    emailLoginEnabled?: boolean | null;
    basecampRefreshToken?: string | null;
}

export class UpsertRoleResponse extends ListRolesResponse implements IUpsertRoleResponse {
    /** Ruolo modificato */
    ruolo?: Ruolo;

    constructor(data?: IUpsertRoleResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ruolo = _data["ruolo"] ? Ruolo.fromJS(_data["ruolo"]) : <any>null;
        }
    }

    static fromJS(data: any): UpsertRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruolo"] = this.ruolo ? this.ruolo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertRoleResponse extends IListRolesResponse {
    /** Ruolo modificato */
    ruolo?: Ruolo;
}

export class UpsertRoleRequest extends LocalizedRequest implements IUpsertRoleRequest {
    /** Entità ruolo */
    ruolo!: Ruolo;
    /** ID dei permessi associati */
    permessiIDs!: number[];

    constructor(data?: IUpsertRoleRequest) {
        super(data);
        if (!data) {
            this.ruolo = new Ruolo();
            this.permessiIDs = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ruolo = _data["ruolo"] ? Ruolo.fromJS(_data["ruolo"]) : new Ruolo();
            if (Array.isArray(_data["permessiIDs"])) {
                this.permessiIDs = [] as any;
                for (let item of _data["permessiIDs"])
                    this.permessiIDs!.push(item);
            }
            else {
                this.permessiIDs = <any>null;
            }
        }
    }

    static fromJS(data: any): UpsertRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruolo"] = this.ruolo ? this.ruolo.toJSON() : <any>null;
        if (Array.isArray(this.permessiIDs)) {
            data["permessiIDs"] = [];
            for (let item of this.permessiIDs)
                data["permessiIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpsertRoleRequest extends ILocalizedRequest {
    /** Entità ruolo */
    ruolo: Ruolo;
    /** ID dei permessi associati */
    permessiIDs: number[];
}

export class ClientAppSettings implements IClientAppSettings {
    applicationName?: string | null;
    naarDomain?: string | null;
    commonPathsSettings?: CommonPathsSettings | null;

    constructor(data?: IClientAppSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"] !== undefined ? _data["applicationName"] : <any>null;
            this.naarDomain = _data["naarDomain"] !== undefined ? _data["naarDomain"] : <any>null;
            this.commonPathsSettings = _data["commonPathsSettings"] ? CommonPathsSettings.fromJS(_data["commonPathsSettings"]) : <any>null;
        }
    }

    static fromJS(data: any): ClientAppSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAppSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName !== undefined ? this.applicationName : <any>null;
        data["naarDomain"] = this.naarDomain !== undefined ? this.naarDomain : <any>null;
        data["commonPathsSettings"] = this.commonPathsSettings ? this.commonPathsSettings.toJSON() : <any>null;
        return data;
    }
}

export interface IClientAppSettings {
    applicationName?: string | null;
    naarDomain?: string | null;
    commonPathsSettings?: CommonPathsSettings | null;
}

export class CommonPathsSettings implements ICommonPathsSettings {
    infoAttachmentsRoot?: string | null;
    infoAttachmentsBaseUrl?: string | null;
    articleAttachmentsRoot?: string | null;
    imagesBaseUrl?: string | null;
    imagesBasePath?: string | null;
    generalVoidImage?: string | null;
    mediaBaseUrl?: string | null;
    articleUrlFormatString?: string | null;

    constructor(data?: ICommonPathsSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.infoAttachmentsRoot = _data["infoAttachmentsRoot"] !== undefined ? _data["infoAttachmentsRoot"] : <any>null;
            this.infoAttachmentsBaseUrl = _data["infoAttachmentsBaseUrl"] !== undefined ? _data["infoAttachmentsBaseUrl"] : <any>null;
            this.articleAttachmentsRoot = _data["articleAttachmentsRoot"] !== undefined ? _data["articleAttachmentsRoot"] : <any>null;
            this.imagesBaseUrl = _data["imagesBaseUrl"] !== undefined ? _data["imagesBaseUrl"] : <any>null;
            this.imagesBasePath = _data["imagesBasePath"] !== undefined ? _data["imagesBasePath"] : <any>null;
            this.generalVoidImage = _data["generalVoidImage"] !== undefined ? _data["generalVoidImage"] : <any>null;
            this.mediaBaseUrl = _data["mediaBaseUrl"] !== undefined ? _data["mediaBaseUrl"] : <any>null;
            this.articleUrlFormatString = _data["articleUrlFormatString"] !== undefined ? _data["articleUrlFormatString"] : <any>null;
        }
    }

    static fromJS(data: any): CommonPathsSettings {
        data = typeof data === 'object' ? data : {};
        let result = new CommonPathsSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["infoAttachmentsRoot"] = this.infoAttachmentsRoot !== undefined ? this.infoAttachmentsRoot : <any>null;
        data["infoAttachmentsBaseUrl"] = this.infoAttachmentsBaseUrl !== undefined ? this.infoAttachmentsBaseUrl : <any>null;
        data["articleAttachmentsRoot"] = this.articleAttachmentsRoot !== undefined ? this.articleAttachmentsRoot : <any>null;
        data["imagesBaseUrl"] = this.imagesBaseUrl !== undefined ? this.imagesBaseUrl : <any>null;
        data["imagesBasePath"] = this.imagesBasePath !== undefined ? this.imagesBasePath : <any>null;
        data["generalVoidImage"] = this.generalVoidImage !== undefined ? this.generalVoidImage : <any>null;
        data["mediaBaseUrl"] = this.mediaBaseUrl !== undefined ? this.mediaBaseUrl : <any>null;
        data["articleUrlFormatString"] = this.articleUrlFormatString !== undefined ? this.articleUrlFormatString : <any>null;
        return data;
    }
}

export interface ICommonPathsSettings {
    infoAttachmentsRoot?: string | null;
    infoAttachmentsBaseUrl?: string | null;
    articleAttachmentsRoot?: string | null;
    imagesBaseUrl?: string | null;
    imagesBasePath?: string | null;
    generalVoidImage?: string | null;
    mediaBaseUrl?: string | null;
    articleUrlFormatString?: string | null;
}

export class SwaggerUrlRequest extends ApiRequest implements ISwaggerUrlRequest {
    /** Url of Swagger API to Generate the Typescript Client */
    url!: string;
    /** The Generated Client ClassName -> {ClassName}{controller}Client */
    clientClassName!: string;

    constructor(data?: ISwaggerUrlRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.clientClassName = _data["clientClassName"] !== undefined ? _data["clientClassName"] : <any>null;
        }
    }

    static fromJS(data: any): SwaggerUrlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SwaggerUrlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["clientClassName"] = this.clientClassName !== undefined ? this.clientClassName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISwaggerUrlRequest extends IApiRequest {
    /** Url of Swagger API to Generate the Typescript Client */
    url: string;
    /** The Generated Client ClassName -> {ClassName}{controller}Client */
    clientClassName: string;
}

export class VoidContainer implements IVoidContainer {
    tripsBatches?: TripsBatches | null;
    priceVerifyStatus?: PriceVerifyStatus | null;
    uiPriceVerifyStatus?: UiPriceVerifyStatus | null;
    autofillStatus?: AutofillStatus | null;
    addAttachmentRequest?: AddAttachmentRequest | null;
    giorniGratis?: GiorniGratis | null;
    scontoPercentuale?: ScontoPercentuale | null;
    scontoValore?: ScontoValore | null;
    abbinamentoSettimana?: AbbinamentoSettimana | null;
    composizioneGruppo?: ComposizioneGruppo | null;
    dataPartenza?: DataPartenza | null;
    dataPrenotazione?: DataPrenotazione | null;
    durataSoggiorno?: DurataSoggiorno | null;
    giorniEntrataUscita?: GiorniEntrataUscita | null;
    presenzaQuoteBambino?: PresenzaQuoteBambino | null;
    partenza?: Partenza | null;
    servizio?: Servizio | null;
    tipologia?: ServizioTipologia | null;
    regolaVendita?: ServizioRegolaVendita | null;
    permesso?: EPermesso;

    constructor(data?: IVoidContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripsBatches = _data["tripsBatches"] ? TripsBatches.fromJS(_data["tripsBatches"]) : <any>null;
            this.priceVerifyStatus = _data["priceVerifyStatus"] ? PriceVerifyStatus.fromJS(_data["priceVerifyStatus"]) : <any>null;
            this.uiPriceVerifyStatus = _data["uiPriceVerifyStatus"] ? UiPriceVerifyStatus.fromJS(_data["uiPriceVerifyStatus"]) : <any>null;
            this.autofillStatus = _data["autofillStatus"] ? AutofillStatus.fromJS(_data["autofillStatus"]) : <any>null;
            this.addAttachmentRequest = _data["addAttachmentRequest"] ? AddAttachmentRequest.fromJS(_data["addAttachmentRequest"]) : <any>null;
            this.giorniGratis = _data["giorniGratis"] ? GiorniGratis.fromJS(_data["giorniGratis"]) : <any>null;
            this.scontoPercentuale = _data["scontoPercentuale"] ? ScontoPercentuale.fromJS(_data["scontoPercentuale"]) : <any>null;
            this.scontoValore = _data["scontoValore"] ? ScontoValore.fromJS(_data["scontoValore"]) : <any>null;
            this.abbinamentoSettimana = _data["abbinamentoSettimana"] ? AbbinamentoSettimana.fromJS(_data["abbinamentoSettimana"]) : <any>null;
            this.composizioneGruppo = _data["composizioneGruppo"] ? ComposizioneGruppo.fromJS(_data["composizioneGruppo"]) : <any>null;
            this.dataPartenza = _data["dataPartenza"] ? DataPartenza.fromJS(_data["dataPartenza"]) : <any>null;
            this.dataPrenotazione = _data["dataPrenotazione"] ? DataPrenotazione.fromJS(_data["dataPrenotazione"]) : <any>null;
            this.durataSoggiorno = _data["durataSoggiorno"] ? DurataSoggiorno.fromJS(_data["durataSoggiorno"]) : <any>null;
            this.giorniEntrataUscita = _data["giorniEntrataUscita"] ? GiorniEntrataUscita.fromJS(_data["giorniEntrataUscita"]) : <any>null;
            this.presenzaQuoteBambino = _data["presenzaQuoteBambino"] ? PresenzaQuoteBambino.fromJS(_data["presenzaQuoteBambino"]) : <any>null;
            this.partenza = _data["partenza"] ? Partenza.fromJS(_data["partenza"]) : <any>null;
            this.servizio = _data["servizio"] ? Servizio.fromJS(_data["servizio"]) : <any>null;
            this.tipologia = _data["tipologia"] ? ServizioTipologia.fromJS(_data["tipologia"]) : <any>null;
            this.regolaVendita = _data["regolaVendita"] ? ServizioRegolaVendita.fromJS(_data["regolaVendita"]) : <any>null;
            this.permesso = _data["permesso"] !== undefined ? _data["permesso"] : <any>null;
        }
    }

    static fromJS(data: any): VoidContainer {
        data = typeof data === 'object' ? data : {};
        let result = new VoidContainer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripsBatches"] = this.tripsBatches ? this.tripsBatches.toJSON() : <any>null;
        data["priceVerifyStatus"] = this.priceVerifyStatus ? this.priceVerifyStatus.toJSON() : <any>null;
        data["uiPriceVerifyStatus"] = this.uiPriceVerifyStatus ? this.uiPriceVerifyStatus.toJSON() : <any>null;
        data["autofillStatus"] = this.autofillStatus ? this.autofillStatus.toJSON() : <any>null;
        data["addAttachmentRequest"] = this.addAttachmentRequest ? this.addAttachmentRequest.toJSON() : <any>null;
        data["giorniGratis"] = this.giorniGratis ? this.giorniGratis.toJSON() : <any>null;
        data["scontoPercentuale"] = this.scontoPercentuale ? this.scontoPercentuale.toJSON() : <any>null;
        data["scontoValore"] = this.scontoValore ? this.scontoValore.toJSON() : <any>null;
        data["abbinamentoSettimana"] = this.abbinamentoSettimana ? this.abbinamentoSettimana.toJSON() : <any>null;
        data["composizioneGruppo"] = this.composizioneGruppo ? this.composizioneGruppo.toJSON() : <any>null;
        data["dataPartenza"] = this.dataPartenza ? this.dataPartenza.toJSON() : <any>null;
        data["dataPrenotazione"] = this.dataPrenotazione ? this.dataPrenotazione.toJSON() : <any>null;
        data["durataSoggiorno"] = this.durataSoggiorno ? this.durataSoggiorno.toJSON() : <any>null;
        data["giorniEntrataUscita"] = this.giorniEntrataUscita ? this.giorniEntrataUscita.toJSON() : <any>null;
        data["presenzaQuoteBambino"] = this.presenzaQuoteBambino ? this.presenzaQuoteBambino.toJSON() : <any>null;
        data["partenza"] = this.partenza ? this.partenza.toJSON() : <any>null;
        data["servizio"] = this.servizio ? this.servizio.toJSON() : <any>null;
        data["tipologia"] = this.tipologia ? this.tipologia.toJSON() : <any>null;
        data["regolaVendita"] = this.regolaVendita ? this.regolaVendita.toJSON() : <any>null;
        data["permesso"] = this.permesso !== undefined ? this.permesso : <any>null;
        return data;
    }
}

export interface IVoidContainer {
    tripsBatches?: TripsBatches | null;
    priceVerifyStatus?: PriceVerifyStatus | null;
    uiPriceVerifyStatus?: UiPriceVerifyStatus | null;
    autofillStatus?: AutofillStatus | null;
    addAttachmentRequest?: AddAttachmentRequest | null;
    giorniGratis?: GiorniGratis | null;
    scontoPercentuale?: ScontoPercentuale | null;
    scontoValore?: ScontoValore | null;
    abbinamentoSettimana?: AbbinamentoSettimana | null;
    composizioneGruppo?: ComposizioneGruppo | null;
    dataPartenza?: DataPartenza | null;
    dataPrenotazione?: DataPrenotazione | null;
    durataSoggiorno?: DurataSoggiorno | null;
    giorniEntrataUscita?: GiorniEntrataUscita | null;
    presenzaQuoteBambino?: PresenzaQuoteBambino | null;
    partenza?: Partenza | null;
    servizio?: Servizio | null;
    tipologia?: ServizioTipologia | null;
    regolaVendita?: ServizioRegolaVendita | null;
    permesso?: EPermesso;
}

export class TripsBatches implements ITripsBatches {
    ok?: boolean;
    batches?: TripBatch[] | null;

    constructor(data?: ITripsBatches) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"] !== undefined ? _data["ok"] : <any>null;
            if (Array.isArray(_data["batches"])) {
                this.batches = [] as any;
                for (let item of _data["batches"])
                    this.batches!.push(TripBatch.fromJS(item));
            }
            else {
                this.batches = <any>null;
            }
        }
    }

    static fromJS(data: any): TripsBatches {
        data = typeof data === 'object' ? data : {};
        let result = new TripsBatches();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok !== undefined ? this.ok : <any>null;
        if (Array.isArray(this.batches)) {
            data["batches"] = [];
            for (let item of this.batches)
                data["batches"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripsBatches {
    ok?: boolean;
    batches?: TripBatch[] | null;
}

export class AddAttachmentRequest extends ApiRequest implements IAddAttachmentRequest {
    articoloID?: number;
    descrizione?: string | null;

    constructor(data?: IAddAttachmentRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.articoloID = _data["articoloID"] !== undefined ? _data["articoloID"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
        }
    }

    static fromJS(data: any): AddAttachmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddAttachmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articoloID"] = this.articoloID !== undefined ? this.articoloID : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddAttachmentRequest extends IApiRequest {
    articoloID?: number;
    descrizione?: string | null;
}

export class GiorniGratis implements IGiorniGratis {
    giorniDaScontare?: number;
    percentualeSconto?: number;
    periodo?: EPeriodoGiorniGratis;
    gruppoApplicazione?: EGruppoApplicazione;
    applicaMulipliPeriodo?: boolean;
    maxQuoteDaTogliere?: number;

    constructor(data?: IGiorniGratis) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorniDaScontare = _data["giorniDaScontare"] !== undefined ? _data["giorniDaScontare"] : <any>null;
            this.percentualeSconto = _data["percentualeSconto"] !== undefined ? _data["percentualeSconto"] : <any>null;
            this.periodo = _data["periodo"] !== undefined ? _data["periodo"] : <any>null;
            this.gruppoApplicazione = _data["gruppoApplicazione"] !== undefined ? _data["gruppoApplicazione"] : <any>null;
            this.applicaMulipliPeriodo = _data["applicaMulipliPeriodo"] !== undefined ? _data["applicaMulipliPeriodo"] : <any>null;
            this.maxQuoteDaTogliere = _data["maxQuoteDaTogliere"] !== undefined ? _data["maxQuoteDaTogliere"] : <any>null;
        }
    }

    static fromJS(data: any): GiorniGratis {
        data = typeof data === 'object' ? data : {};
        let result = new GiorniGratis();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorniDaScontare"] = this.giorniDaScontare !== undefined ? this.giorniDaScontare : <any>null;
        data["percentualeSconto"] = this.percentualeSconto !== undefined ? this.percentualeSconto : <any>null;
        data["periodo"] = this.periodo !== undefined ? this.periodo : <any>null;
        data["gruppoApplicazione"] = this.gruppoApplicazione !== undefined ? this.gruppoApplicazione : <any>null;
        data["applicaMulipliPeriodo"] = this.applicaMulipliPeriodo !== undefined ? this.applicaMulipliPeriodo : <any>null;
        data["maxQuoteDaTogliere"] = this.maxQuoteDaTogliere !== undefined ? this.maxQuoteDaTogliere : <any>null;
        return data;
    }
}

export interface IGiorniGratis {
    giorniDaScontare?: number;
    percentualeSconto?: number;
    periodo?: EPeriodoGiorniGratis;
    gruppoApplicazione?: EGruppoApplicazione;
    applicaMulipliPeriodo?: boolean;
    maxQuoteDaTogliere?: number;
}

export enum EPeriodoGiorniGratis {
    PrimaNotte = "PrimaNotte",
    UltimaNotte = "UltimaNotte",
    GiornoPiuCostoso = "GiornoPiuCostoso",
    GiornoMenoCostoso = "GiornoMenoCostoso",
    PrimaSettimana = "PrimaSettimana",
    SecondaSettimana = "SecondaSettimana",
    SecondaSettimanaESuccessive = "SecondaSettimanaESuccessive",
    SettimanaMenoCostosa = "SettimanaMenoCostosa",
}

export enum EGruppoApplicazione {
    Tutti = "Tutti",
    SottoEta1 = "SottoEta1",
    TraEta1e2 = "TraEta1e2",
    OltreEta2 = "OltreEta2",
}

export class ScontoPercentuale implements IScontoPercentuale {
    percentuale?: number;
    applicaSuMezzaDoppia?: boolean;
    moltiplicaMezzaDoppiaPerPax?: boolean;
    gruppoApplicazione?: EGruppoApplicazione;
    soloQuoteBambino?: boolean;
    maxQuoteDaTogliere?: number;
    applicazioneSuSettimaneAbbinate?: EApplSettAbbinata;

    constructor(data?: IScontoPercentuale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentuale = _data["percentuale"] !== undefined ? _data["percentuale"] : <any>null;
            this.applicaSuMezzaDoppia = _data["applicaSuMezzaDoppia"] !== undefined ? _data["applicaSuMezzaDoppia"] : <any>null;
            this.moltiplicaMezzaDoppiaPerPax = _data["moltiplicaMezzaDoppiaPerPax"] !== undefined ? _data["moltiplicaMezzaDoppiaPerPax"] : <any>null;
            this.gruppoApplicazione = _data["gruppoApplicazione"] !== undefined ? _data["gruppoApplicazione"] : <any>null;
            this.soloQuoteBambino = _data["soloQuoteBambino"] !== undefined ? _data["soloQuoteBambino"] : <any>null;
            this.maxQuoteDaTogliere = _data["maxQuoteDaTogliere"] !== undefined ? _data["maxQuoteDaTogliere"] : <any>null;
            this.applicazioneSuSettimaneAbbinate = _data["applicazioneSuSettimaneAbbinate"] !== undefined ? _data["applicazioneSuSettimaneAbbinate"] : <any>null;
        }
    }

    static fromJS(data: any): ScontoPercentuale {
        data = typeof data === 'object' ? data : {};
        let result = new ScontoPercentuale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentuale"] = this.percentuale !== undefined ? this.percentuale : <any>null;
        data["applicaSuMezzaDoppia"] = this.applicaSuMezzaDoppia !== undefined ? this.applicaSuMezzaDoppia : <any>null;
        data["moltiplicaMezzaDoppiaPerPax"] = this.moltiplicaMezzaDoppiaPerPax !== undefined ? this.moltiplicaMezzaDoppiaPerPax : <any>null;
        data["gruppoApplicazione"] = this.gruppoApplicazione !== undefined ? this.gruppoApplicazione : <any>null;
        data["soloQuoteBambino"] = this.soloQuoteBambino !== undefined ? this.soloQuoteBambino : <any>null;
        data["maxQuoteDaTogliere"] = this.maxQuoteDaTogliere !== undefined ? this.maxQuoteDaTogliere : <any>null;
        data["applicazioneSuSettimaneAbbinate"] = this.applicazioneSuSettimaneAbbinate !== undefined ? this.applicazioneSuSettimaneAbbinate : <any>null;
        return data;
    }
}

export interface IScontoPercentuale {
    percentuale?: number;
    applicaSuMezzaDoppia?: boolean;
    moltiplicaMezzaDoppiaPerPax?: boolean;
    gruppoApplicazione?: EGruppoApplicazione;
    soloQuoteBambino?: boolean;
    maxQuoteDaTogliere?: number;
    applicazioneSuSettimaneAbbinate?: EApplSettAbbinata;
}

export enum EApplSettAbbinata {
    Tutto = "Tutto",
    SettimanaIndicata = "SettimanaIndicata",
    SettimanaAbbinata = "SettimanaAbbinata",
}

export class ScontoValore implements IScontoValore {
    valorePrezzo?: number;
    valoreCosto?: number;
    perGiorno?: boolean;
    perPersona?: boolean;
    quotaBambiniProporzionale?: boolean;
    applicaMulipliPeriodo?: boolean;
    gruppoApplicazione?: EGruppoApplicazione;
    ricostruisciTariffaAdultiSuMezzeDoppie?: boolean;
    maxQuoteDaTogliere?: number;

    constructor(data?: IScontoValore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valorePrezzo = _data["valorePrezzo"] !== undefined ? _data["valorePrezzo"] : <any>null;
            this.valoreCosto = _data["valoreCosto"] !== undefined ? _data["valoreCosto"] : <any>null;
            this.perGiorno = _data["perGiorno"] !== undefined ? _data["perGiorno"] : <any>null;
            this.perPersona = _data["perPersona"] !== undefined ? _data["perPersona"] : <any>null;
            this.quotaBambiniProporzionale = _data["quotaBambiniProporzionale"] !== undefined ? _data["quotaBambiniProporzionale"] : <any>null;
            this.applicaMulipliPeriodo = _data["applicaMulipliPeriodo"] !== undefined ? _data["applicaMulipliPeriodo"] : <any>null;
            this.gruppoApplicazione = _data["gruppoApplicazione"] !== undefined ? _data["gruppoApplicazione"] : <any>null;
            this.ricostruisciTariffaAdultiSuMezzeDoppie = _data["ricostruisciTariffaAdultiSuMezzeDoppie"] !== undefined ? _data["ricostruisciTariffaAdultiSuMezzeDoppie"] : <any>null;
            this.maxQuoteDaTogliere = _data["maxQuoteDaTogliere"] !== undefined ? _data["maxQuoteDaTogliere"] : <any>null;
        }
    }

    static fromJS(data: any): ScontoValore {
        data = typeof data === 'object' ? data : {};
        let result = new ScontoValore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valorePrezzo"] = this.valorePrezzo !== undefined ? this.valorePrezzo : <any>null;
        data["valoreCosto"] = this.valoreCosto !== undefined ? this.valoreCosto : <any>null;
        data["perGiorno"] = this.perGiorno !== undefined ? this.perGiorno : <any>null;
        data["perPersona"] = this.perPersona !== undefined ? this.perPersona : <any>null;
        data["quotaBambiniProporzionale"] = this.quotaBambiniProporzionale !== undefined ? this.quotaBambiniProporzionale : <any>null;
        data["applicaMulipliPeriodo"] = this.applicaMulipliPeriodo !== undefined ? this.applicaMulipliPeriodo : <any>null;
        data["gruppoApplicazione"] = this.gruppoApplicazione !== undefined ? this.gruppoApplicazione : <any>null;
        data["ricostruisciTariffaAdultiSuMezzeDoppie"] = this.ricostruisciTariffaAdultiSuMezzeDoppie !== undefined ? this.ricostruisciTariffaAdultiSuMezzeDoppie : <any>null;
        data["maxQuoteDaTogliere"] = this.maxQuoteDaTogliere !== undefined ? this.maxQuoteDaTogliere : <any>null;
        return data;
    }
}

export interface IScontoValore {
    valorePrezzo?: number;
    valoreCosto?: number;
    perGiorno?: boolean;
    perPersona?: boolean;
    quotaBambiniProporzionale?: boolean;
    applicaMulipliPeriodo?: boolean;
    gruppoApplicazione?: EGruppoApplicazione;
    ricostruisciTariffaAdultiSuMezzeDoppie?: boolean;
    maxQuoteDaTogliere?: number;
}

export class AbbinamentoSettimana implements IAbbinamentoSettimana {
    tipoAbbinamento?: EAbbinamentoSettimana;
    giornoIniziale?: string;

    constructor(data?: IAbbinamentoSettimana) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoAbbinamento = _data["tipoAbbinamento"] !== undefined ? _data["tipoAbbinamento"] : <any>null;
            this.giornoIniziale = _data["giornoIniziale"] !== undefined ? _data["giornoIniziale"] : <any>null;
        }
    }

    static fromJS(data: any): AbbinamentoSettimana {
        data = typeof data === 'object' ? data : {};
        let result = new AbbinamentoSettimana();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoAbbinamento"] = this.tipoAbbinamento !== undefined ? this.tipoAbbinamento : <any>null;
        data["giornoIniziale"] = this.giornoIniziale !== undefined ? this.giornoIniziale : <any>null;
        return data;
    }
}

export interface IAbbinamentoSettimana {
    tipoAbbinamento?: EAbbinamentoSettimana;
    giornoIniziale?: string;
}

export enum EAbbinamentoSettimana {
    SettimanaPrecedente = "SettimanaPrecedente",
    SettimanaSuccessiva = "SettimanaSuccessiva",
    SettimanaPrimaODopo = "SettimanaPrimaODopo",
}

export class ComposizioneGruppo implements IComposizioneGruppo {
    sottoEta1?: number;
    operatoreEta1?: EOperatoreDisuguaglianza;
    eta1?: number;
    traEta1e2?: number;
    operatoreEta1e2?: EOperatoreDisuguaglianza;
    eta2?: number;
    oltreEta2?: number;
    operatoreEta2?: EOperatoreDisuguaglianza;

    constructor(data?: IComposizioneGruppo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sottoEta1 = _data["sottoEta1"] !== undefined ? _data["sottoEta1"] : <any>null;
            this.operatoreEta1 = _data["operatoreEta1"] !== undefined ? _data["operatoreEta1"] : <any>null;
            this.eta1 = _data["eta1"] !== undefined ? _data["eta1"] : <any>null;
            this.traEta1e2 = _data["traEta1e2"] !== undefined ? _data["traEta1e2"] : <any>null;
            this.operatoreEta1e2 = _data["operatoreEta1e2"] !== undefined ? _data["operatoreEta1e2"] : <any>null;
            this.eta2 = _data["eta2"] !== undefined ? _data["eta2"] : <any>null;
            this.oltreEta2 = _data["oltreEta2"] !== undefined ? _data["oltreEta2"] : <any>null;
            this.operatoreEta2 = _data["operatoreEta2"] !== undefined ? _data["operatoreEta2"] : <any>null;
        }
    }

    static fromJS(data: any): ComposizioneGruppo {
        data = typeof data === 'object' ? data : {};
        let result = new ComposizioneGruppo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sottoEta1"] = this.sottoEta1 !== undefined ? this.sottoEta1 : <any>null;
        data["operatoreEta1"] = this.operatoreEta1 !== undefined ? this.operatoreEta1 : <any>null;
        data["eta1"] = this.eta1 !== undefined ? this.eta1 : <any>null;
        data["traEta1e2"] = this.traEta1e2 !== undefined ? this.traEta1e2 : <any>null;
        data["operatoreEta1e2"] = this.operatoreEta1e2 !== undefined ? this.operatoreEta1e2 : <any>null;
        data["eta2"] = this.eta2 !== undefined ? this.eta2 : <any>null;
        data["oltreEta2"] = this.oltreEta2 !== undefined ? this.oltreEta2 : <any>null;
        data["operatoreEta2"] = this.operatoreEta2 !== undefined ? this.operatoreEta2 : <any>null;
        return data;
    }
}

export interface IComposizioneGruppo {
    sottoEta1?: number;
    operatoreEta1?: EOperatoreDisuguaglianza;
    eta1?: number;
    traEta1e2?: number;
    operatoreEta1e2?: EOperatoreDisuguaglianza;
    eta2?: number;
    oltreEta2?: number;
    operatoreEta2?: EOperatoreDisuguaglianza;
}

export enum EOperatoreDisuguaglianza {
    Esattamente = "Esattamente",
    Minimo = "Minimo",
    Massimo = "Massimo",
}

export class DataPartenza implements IDataPartenza {
    dataDal?: string | null;
    dataAl?: string | null;

    constructor(data?: IDataPartenza) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataDal = _data["dataDal"] !== undefined ? _data["dataDal"] : <any>null;
            this.dataAl = _data["dataAl"] !== undefined ? _data["dataAl"] : <any>null;
        }
    }

    static fromJS(data: any): DataPartenza {
        data = typeof data === 'object' ? data : {};
        let result = new DataPartenza();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataDal"] = this.dataDal !== undefined ? this.dataDal : <any>null;
        data["dataAl"] = this.dataAl !== undefined ? this.dataAl : <any>null;
        return data;
    }
}

export interface IDataPartenza {
    dataDal?: string | null;
    dataAl?: string | null;
}

export class DataPrenotazione implements IDataPrenotazione {
    tipoRaffronto?: EPrenotaEntro;
    giorni?: number;
    dataDal?: string | null;
    dataAl?: string | null;

    constructor(data?: IDataPrenotazione) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipoRaffronto = _data["tipoRaffronto"] !== undefined ? _data["tipoRaffronto"] : <any>null;
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : <any>null;
            this.dataDal = _data["dataDal"] !== undefined ? _data["dataDal"] : <any>null;
            this.dataAl = _data["dataAl"] !== undefined ? _data["dataAl"] : <any>null;
        }
    }

    static fromJS(data: any): DataPrenotazione {
        data = typeof data === 'object' ? data : {};
        let result = new DataPrenotazione();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipoRaffronto"] = this.tipoRaffronto !== undefined ? this.tipoRaffronto : <any>null;
        data["giorni"] = this.giorni !== undefined ? this.giorni : <any>null;
        data["dataDal"] = this.dataDal !== undefined ? this.dataDal : <any>null;
        data["dataAl"] = this.dataAl !== undefined ? this.dataAl : <any>null;
        return data;
    }
}

export interface IDataPrenotazione {
    tipoRaffronto?: EPrenotaEntro;
    giorni?: number;
    dataDal?: string | null;
    dataAl?: string | null;
}

export enum EPrenotaEntro {
    Giorni = "Giorni",
    Periodo = "Periodo",
}

export class DurataSoggiorno implements IDurataSoggiorno {
    operatore?: EOperatoreDisuguaglianza;
    valore?: number;
    accettaMultipli?: boolean;
    ignoraEsclusioni?: boolean;

    constructor(data?: IDurataSoggiorno) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.valore = _data["valore"] !== undefined ? _data["valore"] : <any>null;
            this.accettaMultipli = _data["accettaMultipli"] !== undefined ? _data["accettaMultipli"] : <any>null;
            this.ignoraEsclusioni = _data["ignoraEsclusioni"] !== undefined ? _data["ignoraEsclusioni"] : <any>null;
        }
    }

    static fromJS(data: any): DurataSoggiorno {
        data = typeof data === 'object' ? data : {};
        let result = new DurataSoggiorno();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["valore"] = this.valore !== undefined ? this.valore : <any>null;
        data["accettaMultipli"] = this.accettaMultipli !== undefined ? this.accettaMultipli : <any>null;
        data["ignoraEsclusioni"] = this.ignoraEsclusioni !== undefined ? this.ignoraEsclusioni : <any>null;
        return data;
    }
}

export interface IDurataSoggiorno {
    operatore?: EOperatoreDisuguaglianza;
    valore?: number;
    accettaMultipli?: boolean;
    ignoraEsclusioni?: boolean;
}

export class GiorniEntrataUscita implements IGiorniEntrataUscita {
    giorni?: string;
    tipoGiorni?: EEntrataUscita;

    constructor(data?: IGiorniEntrataUscita) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.giorni = _data["giorni"] !== undefined ? _data["giorni"] : <any>null;
            this.tipoGiorni = _data["tipoGiorni"] !== undefined ? _data["tipoGiorni"] : <any>null;
        }
    }

    static fromJS(data: any): GiorniEntrataUscita {
        data = typeof data === 'object' ? data : {};
        let result = new GiorniEntrataUscita();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giorni"] = this.giorni !== undefined ? this.giorni : <any>null;
        data["tipoGiorni"] = this.tipoGiorni !== undefined ? this.tipoGiorni : <any>null;
        return data;
    }
}

export interface IGiorniEntrataUscita {
    giorni?: string;
    tipoGiorni?: EEntrataUscita;
}

export enum EEntrataUscita {
    Entrata = "Entrata",
    Uscita = "Uscita",
    InOut = "InOut",
}

export class PresenzaQuoteBambino implements IPresenzaQuoteBambino {
    operatore?: EOperatoreDisuguaglianza;
    numeroQuoteBambino?: number;

    constructor(data?: IPresenzaQuoteBambino) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            this.numeroQuoteBambino = _data["numeroQuoteBambino"] !== undefined ? _data["numeroQuoteBambino"] : <any>null;
        }
    }

    static fromJS(data: any): PresenzaQuoteBambino {
        data = typeof data === 'object' ? data : {};
        let result = new PresenzaQuoteBambino();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        data["numeroQuoteBambino"] = this.numeroQuoteBambino !== undefined ? this.numeroQuoteBambino : <any>null;
        return data;
    }
}

export interface IPresenzaQuoteBambino {
    operatore?: EOperatoreDisuguaglianza;
    numeroQuoteBambino?: number;
}

export enum EPermesso {
    Dev = "dev",
    Services_advance_payments_read = "services_advance_payments_read",
    Services_advance_payments_readwrite = "services_advance_payments_readwrite",
    Services_advance_payments = "services_advance_payments",
    Contab_fatture = "contab_fatture",
    Contab_fatture_read = "contab_fatture_read",
    Contab_fatture_readwrite = "contab_fatture_readwrite",
    Contab_fatture_creazione = "contab_fatture_creazione",
    Payments = "payments",
    Payments_read = "payments_read",
    Payments_readwrite = "payments_readwrite",
    Contab_ciclopassivo = "contab_ciclopassivo",
    Services_margins = "services_margins",
    Services_margins_read = "services_margins_read",
    Services_margins_readwrite = "services_margins_readwrite",
    Contacts = "contacts",
    Contacts_read = "contacts_read",
    Contacts_readwrite = "contacts_readwrite",
    Contacts_contracts_read = "contacts_contracts_read",
    Contacts_contracts_readwrite = "contacts_contracts_readwrite",
    Contacts_relations_read = "contacts_relations_read",
    Contacts_relations_readwrite = "contacts_relations_readwrite",
    Contacts_data_read = "contacts_data_read",
    Contacts_data_readwrite = "contacts_data_readwrite",
    Contacts_addresses_read = "contacts_addresses_read",
    Contacts_addresses_readwrite = "contacts_addresses_readwrite",
    Contacts_maps_read = "contacts_maps_read",
    Contacts_users_read = "contacts_users_read",
    Contacts_users_readwrite = "contacts_users_readwrite",
    Contacts_maps_readwrite = "contacts_maps_readwrite",
    Places = "places",
    Places_read = "places_read",
    Places_readwrite = "places_readwrite",
    Places_maps_readwrite = "places_maps_readwrite",
    Places_relations_read = "places_relations_read",
    Places_relations_readwrite = "places_relations_readwrite",
    Places_near_read = "places_near_read",
    Places_near_readwrite = "places_near_readwrite",
    H2hsvcs_read = "h2hsvcs_read",
    H2hsvcs_readwrite = "h2hsvcs_readwrite",
    Attacheddocs = "attacheddocs",
    Attacheddocs_read = "attacheddocs_read",
    Attacheddocs_readwrite = "attacheddocs_readwrite",
    Offert_optimize_hotel = "offert_optimize_hotel",
    Currencies_read = "currencies_read",
    Currencies_readwrite = "currencies_readwrite",
    Operators = "operators",
    Operators_read = "operators_read",
    Operators_readwrite = "operators_readwrite",
    Operators_quoteoptions_read = "operators_quoteoptions_read",
    Operators_quoteoptions_readwrite = "operators_quoteoptions_readwrite",
    Agency_users = "agency_users",
    Agency_users_read = "agency_users_read",
    Agency_users_readwrite = "agency_users_readwrite",
    Users = "users",
    Users_read = "users_read",
    Users_readwrite = "users_readwrite",
    Users_impersonate = "users_impersonate",
}

export class ValidateTripExistsResponse extends OkApiResponse implements IValidateTripExistsResponse {
    exists?: boolean;

    constructor(data?: IValidateTripExistsResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.exists = _data["exists"] !== undefined ? _data["exists"] : <any>null;
        }
    }

    static fromJS(data: any): ValidateTripExistsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateTripExistsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists !== undefined ? this.exists : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IValidateTripExistsResponse extends IOkApiResponse {
    exists?: boolean;
}

export class ValidateTripExistsRequest extends ApiRequest implements IValidateTripExistsRequest {
    offertaID?: number;

    constructor(data?: IValidateTripExistsRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
        }
    }

    static fromJS(data: any): ValidateTripExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateTripExistsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IValidateTripExistsRequest extends IApiRequest {
    offertaID?: number;
}

export class NrTableResponseOfVoucherRow extends OkApiResponse implements INrTableResponseOfVoucherRow {
    /** Array delle righe della pagina richiesta */
    rows?: VoucherRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfVoucherRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(VoucherRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfVoucherRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfVoucherRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfVoucherRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: VoucherRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class VoucherRow implements IVoucherRow {
    id?: number;
    luogo?: string;
    abbinamento?: string | null;
    descrizione?: string;
    nomeContatto?: string;
    data?: string;
    tipoEmissione?: string;
    cumulativeVouchers?: VoucherRow[] | null;

    constructor(data?: IVoucherRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.luogo = _data["luogo"] !== undefined ? _data["luogo"] : <any>null;
            this.abbinamento = _data["abbinamento"] !== undefined ? _data["abbinamento"] : <any>null;
            this.descrizione = _data["descrizione"] !== undefined ? _data["descrizione"] : <any>null;
            this.nomeContatto = _data["nomeContatto"] !== undefined ? _data["nomeContatto"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.tipoEmissione = _data["tipoEmissione"] !== undefined ? _data["tipoEmissione"] : <any>null;
            if (Array.isArray(_data["cumulativeVouchers"])) {
                this.cumulativeVouchers = [] as any;
                for (let item of _data["cumulativeVouchers"])
                    this.cumulativeVouchers!.push(VoucherRow.fromJS(item));
            }
            else {
                this.cumulativeVouchers = <any>null;
            }
        }
    }

    static fromJS(data: any): VoucherRow {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["luogo"] = this.luogo !== undefined ? this.luogo : <any>null;
        data["abbinamento"] = this.abbinamento !== undefined ? this.abbinamento : <any>null;
        data["descrizione"] = this.descrizione !== undefined ? this.descrizione : <any>null;
        data["nomeContatto"] = this.nomeContatto !== undefined ? this.nomeContatto : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["tipoEmissione"] = this.tipoEmissione !== undefined ? this.tipoEmissione : <any>null;
        if (Array.isArray(this.cumulativeVouchers)) {
            data["cumulativeVouchers"] = [];
            for (let item of this.cumulativeVouchers)
                data["cumulativeVouchers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVoucherRow {
    id?: number;
    luogo?: string;
    abbinamento?: string | null;
    descrizione?: string;
    nomeContatto?: string;
    data?: string;
    tipoEmissione?: string;
    cumulativeVouchers?: VoucherRow[] | null;
}

export class VouchersCreateRequest extends LocalizedRequest implements IVouchersCreateRequest {
    offertaID?: number;
    quantity?: number;

    constructor(data?: IVouchersCreateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
        }
    }

    static fromJS(data: any): VouchersCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VouchersCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IVouchersCreateRequest extends ILocalizedRequest {
    offertaID?: number;
    quantity?: number;
}

export class VouchersListRequest extends NrTableRequest implements IVouchersListRequest {
    offertaID?: number;

    constructor(data?: IVouchersListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.offertaID = _data["offertaID"] !== undefined ? _data["offertaID"] : <any>null;
        }
    }

    static fromJS(data: any): VouchersListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VouchersListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offertaID"] = this.offertaID !== undefined ? this.offertaID : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IVouchersListRequest extends INrTableRequest {
    offertaID?: number;
}

export class GetPlaceWeatherResponse extends OkApiResponse implements IGetPlaceWeatherResponse {
    weather?: OWWeather | null;

    constructor(data?: IGetPlaceWeatherResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weather = _data["weather"] ? OWWeather.fromJS(_data["weather"]) : <any>null;
        }
    }

    static fromJS(data: any): GetPlaceWeatherResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlaceWeatherResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weather"] = this.weather ? this.weather.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPlaceWeatherResponse extends IOkApiResponse {
    weather?: OWWeather | null;
}

export class OWWeather implements IOWWeather {
    description?: string;
    icon?: string;
    name?: string | null;
    temperature?: string | null;

    constructor(data?: IOWWeather) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.icon = _data["icon"] !== undefined ? _data["icon"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : <any>null;
        }
    }

    static fromJS(data: any): OWWeather {
        data = typeof data === 'object' ? data : {};
        let result = new OWWeather();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["icon"] = this.icon !== undefined ? this.icon : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["temperature"] = this.temperature !== undefined ? this.temperature : <any>null;
        return data;
    }
}

export interface IOWWeather {
    description?: string;
    icon?: string;
    name?: string | null;
    temperature?: string | null;
}

export class GetPlaceWeatherRequest extends LocalizedRequest implements IGetPlaceWeatherRequest {
    latitude?: number;
    longitude?: number;

    constructor(data?: IGetPlaceWeatherRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
        }
    }

    static fromJS(data: any): GetPlaceWeatherRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlaceWeatherRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPlaceWeatherRequest extends ILocalizedRequest {
    latitude?: number;
    longitude?: number;
}

export class WebsiteLabelsGetResponse extends OkApiResponse implements IWebsiteLabelsGetResponse {
    id?: number;
    website?: EWebsite;
    label?: string | null;
    nome?: string | null;
    nomeInglese?: string | null;
    translations?: WebsiteLabelTranslation[] | null;

    constructor(data?: IWebsiteLabelsGetResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : <any>null;
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(WebsiteLabelTranslation.fromJS(item));
            }
            else {
                this.translations = <any>null;
            }
        }
    }

    static fromJS(data: any): WebsiteLabelsGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["website"] = this.website !== undefined ? this.website : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : <any>null;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsGetResponse extends IOkApiResponse {
    id?: number;
    website?: EWebsite;
    label?: string | null;
    nome?: string | null;
    nomeInglese?: string | null;
    translations?: WebsiteLabelTranslation[] | null;
}

export enum EWebsite {
    App = "app",
    B2b = "b2b",
    B2c = "b2c",
    Intranet = "intranet",
    Print = "print",
}

export class WebsiteLabelTranslation implements IWebsiteLabelTranslation {
    id?: number;
    labelID?: number;
    lingua?: ELingua;
    translation?: string | null;
    confirmed?: boolean | null;
    aggiornato?: string | null;
    eliminato?: string | null;

    constructor(data?: IWebsiteLabelTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.labelID = _data["labelID"] !== undefined ? _data["labelID"] : <any>null;
            this.lingua = _data["lingua"] !== undefined ? _data["lingua"] : <any>null;
            this.translation = _data["translation"] !== undefined ? _data["translation"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.aggiornato = _data["aggiornato"] !== undefined ? _data["aggiornato"] : <any>null;
            this.eliminato = _data["eliminato"] !== undefined ? _data["eliminato"] : <any>null;
        }
    }

    static fromJS(data: any): WebsiteLabelTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["labelID"] = this.labelID !== undefined ? this.labelID : <any>null;
        data["lingua"] = this.lingua !== undefined ? this.lingua : <any>null;
        data["translation"] = this.translation !== undefined ? this.translation : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["aggiornato"] = this.aggiornato !== undefined ? this.aggiornato : <any>null;
        data["eliminato"] = this.eliminato !== undefined ? this.eliminato : <any>null;
        return data;
    }
}

export interface IWebsiteLabelTranslation {
    id?: number;
    labelID?: number;
    lingua?: ELingua;
    translation?: string | null;
    confirmed?: boolean | null;
    aggiornato?: string | null;
    eliminato?: string | null;
}

export class WebsiteLabelsGetRequest extends ApiRequest implements IWebsiteLabelsGetRequest {
    id?: number;

    constructor(data?: IWebsiteLabelsGetRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): WebsiteLabelsGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsGetRequest extends IApiRequest {
    id?: number;
}

export class WebsiteLabelsCreateRequest extends WebsiteLabelsGetRequest implements IWebsiteLabelsCreateRequest {
    label?: string | null;
    website?: EWebsite;
    nome?: string | null;
    nomeInglese?: string | null;
    translations?: WebsiteLabelTranslation[] | null;

    constructor(data?: IWebsiteLabelsCreateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
            this.nomeInglese = _data["nomeInglese"] !== undefined ? _data["nomeInglese"] : <any>null;
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(WebsiteLabelTranslation.fromJS(item));
            }
            else {
                this.translations = <any>null;
            }
        }
    }

    static fromJS(data: any): WebsiteLabelsCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["website"] = this.website !== undefined ? this.website : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        data["nomeInglese"] = this.nomeInglese !== undefined ? this.nomeInglese : <any>null;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsCreateRequest extends IWebsiteLabelsGetRequest {
    label?: string | null;
    website?: EWebsite;
    nome?: string | null;
    nomeInglese?: string | null;
    translations?: WebsiteLabelTranslation[] | null;
}

export class WebsiteLabelsDeleteRequest extends ApiRequest implements IWebsiteLabelsDeleteRequest {
    id?: number;

    constructor(data?: IWebsiteLabelsDeleteRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): WebsiteLabelsDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsDeleteRequest extends IApiRequest {
    id?: number;
}

export class NrTableResponseOfWebsiteLabelsRow extends OkApiResponse implements INrTableResponseOfWebsiteLabelsRow {
    /** Array delle righe della pagina richiesta */
    rows?: WebsiteLabelsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;

    constructor(data?: INrTableResponseOfWebsiteLabelsRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(WebsiteLabelsRow.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
        }
    }

    static fromJS(data: any): NrTableResponseOfWebsiteLabelsRow {
        data = typeof data === 'object' ? data : {};
        let result = new NrTableResponseOfWebsiteLabelsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INrTableResponseOfWebsiteLabelsRow extends IOkApiResponse {
    /** Array delle righe della pagina richiesta */
    rows?: WebsiteLabelsRow[] | null;
    /** Numero totale dei record presenti */
    total?: number;
}

export class WebsiteLabelsRow extends TranslationsListRow implements IWebsiteLabelsRow {
    website?: EWebsite | null;

    constructor(data?: IWebsiteLabelsRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
        }
    }

    static fromJS(data: any): WebsiteLabelsRow {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["website"] = this.website !== undefined ? this.website : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsRow extends ITranslationsListRow {
    website?: EWebsite | null;
}

export class WebsiteLabelsListRequest extends TranslationsListRequest implements IWebsiteLabelsListRequest {
    website?: EWebsite | null;

    constructor(data?: IWebsiteLabelsListRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
        }
    }

    static fromJS(data: any): WebsiteLabelsListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["website"] = this.website !== undefined ? this.website : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsListRequest extends ITranslationsListRequest {
    website?: EWebsite | null;
}

export class MissingLabelRequest extends ApiRequest implements IMissingLabelRequest {
    label?: string | null;
    website?: EWebsite;
    langCode?: string | null;
    url?: string | null;

    constructor(data?: IMissingLabelRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
            this.langCode = _data["langCode"] !== undefined ? _data["langCode"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): MissingLabelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MissingLabelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["website"] = this.website !== undefined ? this.website : <any>null;
        data["langCode"] = this.langCode !== undefined ? this.langCode : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMissingLabelRequest extends IApiRequest {
    label?: string | null;
    website?: EWebsite;
    langCode?: string | null;
    url?: string | null;
}

export class WebsiteLabelsUpdateRequest extends WebsiteLabelsCreateRequest implements IWebsiteLabelsUpdateRequest {

    constructor(data?: IWebsiteLabelsUpdateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): WebsiteLabelsUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLabelsUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IWebsiteLabelsUpdateRequest extends IWebsiteLabelsCreateRequest {
}

export class GetWebsitesResponse extends OkApiResponse implements IGetWebsitesResponse {
    websites?: WebsiteDef[] | null;
    siti?: Site[] | null;

    constructor(data?: IGetWebsitesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(WebsiteDef.fromJS(item));
            }
            else {
                this.websites = <any>null;
            }
            if (Array.isArray(_data["siti"])) {
                this.siti = [] as any;
                for (let item of _data["siti"])
                    this.siti!.push(Site.fromJS(item));
            }
            else {
                this.siti = <any>null;
            }
        }
    }

    static fromJS(data: any): GetWebsitesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWebsitesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item.toJSON());
        }
        if (Array.isArray(this.siti)) {
            data["siti"] = [];
            for (let item of this.siti)
                data["siti"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetWebsitesResponse extends IOkApiResponse {
    websites?: WebsiteDef[] | null;
    siti?: Site[] | null;
}

export class WebsiteDef implements IWebsiteDef {
    id?: number;
    host?: string | null;
    defaultLangCode?: string | null;
    operatore?: EOperatore;
    availableLanguages?: WebsiteLanguage[] | null;

    constructor(data?: IWebsiteDef) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.host = _data["host"] !== undefined ? _data["host"] : <any>null;
            this.defaultLangCode = _data["defaultLangCode"] !== undefined ? _data["defaultLangCode"] : <any>null;
            this.operatore = _data["operatore"] !== undefined ? _data["operatore"] : <any>null;
            if (Array.isArray(_data["availableLanguages"])) {
                this.availableLanguages = [] as any;
                for (let item of _data["availableLanguages"])
                    this.availableLanguages!.push(WebsiteLanguage.fromJS(item));
            }
            else {
                this.availableLanguages = <any>null;
            }
        }
    }

    static fromJS(data: any): WebsiteDef {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteDef();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["host"] = this.host !== undefined ? this.host : <any>null;
        data["defaultLangCode"] = this.defaultLangCode !== undefined ? this.defaultLangCode : <any>null;
        data["operatore"] = this.operatore !== undefined ? this.operatore : <any>null;
        if (Array.isArray(this.availableLanguages)) {
            data["availableLanguages"] = [];
            for (let item of this.availableLanguages)
                data["availableLanguages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWebsiteDef {
    id?: number;
    host?: string | null;
    defaultLangCode?: string | null;
    operatore?: EOperatore;
    availableLanguages?: WebsiteLanguage[] | null;
}

export class Site implements ISite {
    id?: number;
    nome?: string | null;

    constructor(data?: ISite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nome = _data["nome"] !== undefined ? _data["nome"] : <any>null;
        }
    }

    static fromJS(data: any): Site {
        data = typeof data === 'object' ? data : {};
        let result = new Site();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nome"] = this.nome !== undefined ? this.nome : <any>null;
        return data;
    }
}

export interface ISite {
    id?: number;
    nome?: string | null;
}

export class Trip implements ITrip {
    tripID?: string;
    tripName!: string;
    tourOperatorID!: string;
    tourOperatorTripID!: string;
    quoteUUID?: string;
    previewUUID?: string;
    desc?: string;
    dateStart!: string;
    dateEnd!: string;
    locale!: string;
    status!: TripStatus2;
    generalContacts?: number[];
    featuredImage?: number;
    agency!: Agency;
    itinerary!: Step2[];
    images?: Image[];
    documents?: Document[];
    contacts!: Contact[];
    services!: Service[];
    paxList!: Pax[];
    mobiles?: MobileTuple[];
    prices?: Price[];
    updatedAt?: string;
    createdAt?: string;

    [key: string]: any;

    constructor(data?: ITrip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.agency = new Agency();
            this.itinerary = [];
            this.contacts = [];
            this.services = [];
            this.paxList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tripID = _data["tripID"] !== undefined ? _data["tripID"] : <any>null;
            this.tripName = _data["tripName"] !== undefined ? _data["tripName"] : <any>null;
            this.tourOperatorID = _data["tourOperatorID"] !== undefined ? _data["tourOperatorID"] : <any>null;
            this.tourOperatorTripID = _data["tourOperatorTripID"] !== undefined ? _data["tourOperatorTripID"] : <any>null;
            this.quoteUUID = _data["quoteUUID"] !== undefined ? _data["quoteUUID"] : <any>null;
            this.previewUUID = _data["previewUUID"] !== undefined ? _data["previewUUID"] : <any>null;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : <any>null;
            this.dateStart = _data["dateStart"] !== undefined ? _data["dateStart"] : <any>null;
            this.dateEnd = _data["dateEnd"] !== undefined ? _data["dateEnd"] : <any>null;
            this.locale = _data["locale"] !== undefined ? _data["locale"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["generalContacts"])) {
                this.generalContacts = [] as any;
                for (let item of _data["generalContacts"])
                    this.generalContacts!.push(item);
            }
            else {
                this.generalContacts = <any>null;
            }
            this.featuredImage = _data["featuredImage"] !== undefined ? _data["featuredImage"] : <any>null;
            this.agency = _data["agency"] ? Agency.fromJS(_data["agency"]) : new Agency();
            if (Array.isArray(_data["itinerary"])) {
                this.itinerary = [] as any;
                for (let item of _data["itinerary"])
                    this.itinerary!.push(Step2.fromJS(item));
            }
            else {
                this.itinerary = <any>null;
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(Image.fromJS(item));
            }
            else {
                this.images = <any>null;
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(Document.fromJS(item));
            }
            else {
                this.documents = <any>null;
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
            else {
                this.contacts = <any>null;
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(Service.fromJS(item));
            }
            else {
                this.services = <any>null;
            }
            if (Array.isArray(_data["paxList"])) {
                this.paxList = [] as any;
                for (let item of _data["paxList"])
                    this.paxList!.push(Pax.fromJS(item));
            }
            else {
                this.paxList = <any>null;
            }
            if (Array.isArray(_data["mobiles"])) {
                this.mobiles = [] as any;
                for (let item of _data["mobiles"])
                    this.mobiles!.push(MobileTuple.fromJS(item));
            }
            else {
                this.mobiles = <any>null;
            }
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(Price.fromJS(item));
            }
            else {
                this.prices = <any>null;
            }
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
            this.createdAt = _data["createdAt"] !== undefined ? _data["createdAt"] : <any>null;
        }
    }

    static fromJS(data: any): Trip {
        data = typeof data === 'object' ? data : {};
        let result = new Trip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tripID"] = this.tripID !== undefined ? this.tripID : <any>null;
        data["tripName"] = this.tripName !== undefined ? this.tripName : <any>null;
        data["tourOperatorID"] = this.tourOperatorID !== undefined ? this.tourOperatorID : <any>null;
        data["tourOperatorTripID"] = this.tourOperatorTripID !== undefined ? this.tourOperatorTripID : <any>null;
        data["quoteUUID"] = this.quoteUUID !== undefined ? this.quoteUUID : <any>null;
        data["previewUUID"] = this.previewUUID !== undefined ? this.previewUUID : <any>null;
        data["desc"] = this.desc !== undefined ? this.desc : <any>null;
        data["dateStart"] = this.dateStart !== undefined ? this.dateStart : <any>null;
        data["dateEnd"] = this.dateEnd !== undefined ? this.dateEnd : <any>null;
        data["locale"] = this.locale !== undefined ? this.locale : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.generalContacts)) {
            data["generalContacts"] = [];
            for (let item of this.generalContacts)
                data["generalContacts"].push(item);
        }
        data["featuredImage"] = this.featuredImage !== undefined ? this.featuredImage : <any>null;
        data["agency"] = this.agency ? this.agency.toJSON() : <any>null;
        if (Array.isArray(this.itinerary)) {
            data["itinerary"] = [];
            for (let item of this.itinerary)
                data["itinerary"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        if (Array.isArray(this.paxList)) {
            data["paxList"] = [];
            for (let item of this.paxList)
                data["paxList"].push(item.toJSON());
        }
        if (Array.isArray(this.mobiles)) {
            data["mobiles"] = [];
            for (let item of this.mobiles)
                data["mobiles"].push(item.toJSON());
        }
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        data["createdAt"] = this.createdAt !== undefined ? this.createdAt : <any>null;
        return data;
    }
}

export interface ITrip {
    tripID?: string;
    tripName: string;
    tourOperatorID: string;
    tourOperatorTripID: string;
    quoteUUID?: string;
    previewUUID?: string;
    desc?: string;
    dateStart: string;
    dateEnd: string;
    locale: string;
    status: TripStatus2;
    generalContacts?: number[];
    featuredImage?: number;
    agency: Agency;
    itinerary: Step2[];
    images?: Image[];
    documents?: Document[];
    contacts: Contact[];
    services: Service[];
    paxList: Pax[];
    mobiles?: MobileTuple[];
    prices?: Price[];
    updatedAt?: string;
    createdAt?: string;

    [key: string]: any;
}

export enum TripStatus2 {
    CONFIRMED = "CONFIRMED",
    PENDING = "PENDING",
    CANCELED = "CANCELED",
    QUOTE = "QUOTE",
}

export class Agency implements IAgency {
    id!: number;
    title!: string;
    desc?: string;
    image?: number;
    contacts?: number[];

    [key: string]: any;

    constructor(data?: IAgency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(item);
            }
            else {
                this.contacts = <any>null;
            }
        }
    }

    static fromJS(data: any): Agency {
        data = typeof data === 'object' ? data : {};
        let result = new Agency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["desc"] = this.desc !== undefined ? this.desc : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item);
        }
        return data;
    }
}

export interface IAgency {
    id: number;
    title: string;
    desc?: string;
    image?: number;
    contacts?: number[];

    [key: string]: any;
}

export class Step2 implements IStep2 {
    stepID!: number;
    type!: StepType;
    cityID?: string;
    cityCode?: string;
    cityName!: string;
    cityDesc?: string;
    dateStart!: string;
    dateEnd!: string;
    autoGuide?: boolean;
    map?: Map;
    images?: number[];
    services?: number[];
    contacts?: number[];
    documents?: number[];
    references?: Reference[];

    [key: string]: any;

    constructor(data?: IStep2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.stepID = _data["stepID"] !== undefined ? _data["stepID"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.cityID = _data["cityID"] !== undefined ? _data["cityID"] : <any>null;
            this.cityCode = _data["cityCode"] !== undefined ? _data["cityCode"] : <any>null;
            this.cityName = _data["cityName"] !== undefined ? _data["cityName"] : <any>null;
            this.cityDesc = _data["cityDesc"] !== undefined ? _data["cityDesc"] : <any>null;
            this.dateStart = _data["dateStart"] !== undefined ? _data["dateStart"] : <any>null;
            this.dateEnd = _data["dateEnd"] !== undefined ? _data["dateEnd"] : <any>null;
            this.autoGuide = _data["autoGuide"] !== undefined ? _data["autoGuide"] : <any>null;
            this.map = _data["map"] ? Map.fromJS(_data["map"]) : <any>null;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            else {
                this.images = <any>null;
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(item);
            }
            else {
                this.services = <any>null;
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(item);
            }
            else {
                this.contacts = <any>null;
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(item);
            }
            else {
                this.documents = <any>null;
            }
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references!.push(Reference.fromJS(item));
            }
            else {
                this.references = <any>null;
            }
        }
    }

    static fromJS(data: any): Step2 {
        data = typeof data === 'object' ? data : {};
        let result = new Step2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["stepID"] = this.stepID !== undefined ? this.stepID : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["cityID"] = this.cityID !== undefined ? this.cityID : <any>null;
        data["cityCode"] = this.cityCode !== undefined ? this.cityCode : <any>null;
        data["cityName"] = this.cityName !== undefined ? this.cityName : <any>null;
        data["cityDesc"] = this.cityDesc !== undefined ? this.cityDesc : <any>null;
        data["dateStart"] = this.dateStart !== undefined ? this.dateStart : <any>null;
        data["dateEnd"] = this.dateEnd !== undefined ? this.dateEnd : <any>null;
        data["autoGuide"] = this.autoGuide !== undefined ? this.autoGuide : <any>null;
        data["map"] = this.map ? this.map.toJSON() : <any>null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item);
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item);
        }
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStep2 {
    stepID: number;
    type: StepType;
    cityID?: string;
    cityCode?: string;
    cityName: string;
    cityDesc?: string;
    dateStart: string;
    dateEnd: string;
    autoGuide?: boolean;
    map?: Map;
    images?: number[];
    services?: number[];
    contacts?: number[];
    documents?: number[];
    references?: Reference[];

    [key: string]: any;
}

export enum StepType {
    START = "START",
    TRANSFERT = "TRANSFERT",
    STEP = "STEP",
    END = "END",
}

export class Map implements IMap {
    lat!: number;
    lng!: number;
    zoom?: number;
    minZoom?: number;
    maxZoom?: number;

    [key: string]: any;

    constructor(data?: IMap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : <any>null;
            this.zoom = _data["zoom"] !== undefined ? _data["zoom"] : <any>null;
            this.minZoom = _data["minZoom"] !== undefined ? _data["minZoom"] : <any>null;
            this.maxZoom = _data["maxZoom"] !== undefined ? _data["maxZoom"] : <any>null;
        }
    }

    static fromJS(data: any): Map {
        data = typeof data === 'object' ? data : {};
        let result = new Map();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lng"] = this.lng !== undefined ? this.lng : <any>null;
        data["zoom"] = this.zoom !== undefined ? this.zoom : <any>null;
        data["minZoom"] = this.minZoom !== undefined ? this.minZoom : <any>null;
        data["maxZoom"] = this.maxZoom !== undefined ? this.maxZoom : <any>null;
        return data;
    }
}

export interface IMap {
    lat: number;
    lng: number;
    zoom?: number;
    minZoom?: number;
    maxZoom?: number;

    [key: string]: any;
}

export class Reference implements IReference {
    id?: number;
    title?: string;
    type?: string;
    languageId?: string;
    url?: string;
    supplier?: string;
    enabled?: boolean;

    [key: string]: any;

    constructor(data?: IReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.languageId = _data["languageId"] !== undefined ? _data["languageId"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : <any>null;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : <any>null;
        }
    }

    static fromJS(data: any): Reference {
        data = typeof data === 'object' ? data : {};
        let result = new Reference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["languageId"] = this.languageId !== undefined ? this.languageId : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["supplier"] = this.supplier !== undefined ? this.supplier : <any>null;
        data["enabled"] = this.enabled !== undefined ? this.enabled : <any>null;
        return data;
    }
}

export interface IReference {
    id?: number;
    title?: string;
    type?: string;
    languageId?: string;
    url?: string;
    supplier?: string;
    enabled?: boolean;

    [key: string]: any;
}

export class Image implements IImage {
    id!: number;
    type!: ImageType;
    isFeatured!: boolean;
    url!: string;
    source!: ImageSource;
    updatedAt?: string;

    [key: string]: any;

    constructor(data?: IImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.isFeatured = _data["isFeatured"] !== undefined ? _data["isFeatured"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.source = _data["source"] !== undefined ? _data["source"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
        }
    }

    static fromJS(data: any): Image {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["isFeatured"] = this.isFeatured !== undefined ? this.isFeatured : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["source"] = this.source !== undefined ? this.source : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        return data;
    }
}

export interface IImage {
    id: number;
    type: ImageType;
    isFeatured: boolean;
    url: string;
    source: ImageSource;
    updatedAt?: string;

    [key: string]: any;
}

export enum ImageType {
    CITY = "CITY",
    SERVICE = "SERVICE",
    AGENCY = "AGENCY",
    OTHER = "OTHER",
}

export enum ImageSource {
    WEELLGODRIVE = "WEELLGODRIVE",
    PUBLIC = "PUBLIC",
}

export class Document implements IDocument {
    id!: number;
    type!: DocumentType2;
    title!: string;
    desc?: string;
    url!: string;
    source!: DocumentSource;
    updatedAt?: string;

    [key: string]: any;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.source = _data["source"] !== undefined ? _data["source"] : <any>null;
            this.updatedAt = _data["updatedAt"] !== undefined ? _data["updatedAt"] : <any>null;
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["desc"] = this.desc !== undefined ? this.desc : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["source"] = this.source !== undefined ? this.source : <any>null;
        data["updatedAt"] = this.updatedAt !== undefined ? this.updatedAt : <any>null;
        return data;
    }
}

export interface IDocument {
    id: number;
    type: DocumentType2;
    title: string;
    desc?: string;
    url: string;
    source: DocumentSource;
    updatedAt?: string;

    [key: string]: any;
}

export enum DocumentType2 {
    VOUCHER = "VOUCHER",
    GUIDE = "GUIDE",
    INFO = "INFO",
    EXTRA = "EXTRA",
    TICKET = "TICKET",
    BOARDING_PASS = "BOARDING_PASS",
    PROGRAM = "PROGRAM",
    INSURANCE = "INSURANCE",
}

export enum DocumentSource {
    WEELLGODRIVE = "WEELLGODRIVE",
    PUBLIC = "PUBLIC",
}

export class Contact implements IContact {
    id!: number;
    type!: ContactType;
    title!: string;
    desc?: string;
    phones?: Phone2[];
    emails?: Email2[];
    address?: string;
    website?: string;

    [key: string]: any;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : <any>null;
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(Phone2.fromJS(item));
            }
            else {
                this.phones = <any>null;
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(Email2.fromJS(item));
            }
            else {
                this.emails = <any>null;
            }
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.website = _data["website"] !== undefined ? _data["website"] : <any>null;
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["desc"] = this.desc !== undefined ? this.desc : <any>null;
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["website"] = this.website !== undefined ? this.website : <any>null;
        return data;
    }
}

export interface IContact {
    id: number;
    type: ContactType;
    title: string;
    desc?: string;
    phones?: Phone2[];
    emails?: Email2[];
    address?: string;
    website?: string;

    [key: string]: any;
}

export enum ContactType {
    AGENCY = "AGENCY",
    TO = "TO",
    HOTEL = "HOTEL",
    POLICE = "POLICE",
    HOSPITAL = "HOSPITAL",
    SERVICE = "SERVICE",
    OTHER = "OTHER",
    INSURANCE = "INSURANCE",
    GUIDE = "GUIDE",
    CORRESPONDING = "CORRESPONDING",
    EMERGENCY = "EMERGENCY",
    CONSULATE_EMBASSY = "CONSULATE_EMBASSY",
}

export class Phone2 implements IPhone2 {
    title!: string;
    phone!: string;
    type?: PhoneType;

    [key: string]: any;

    constructor(data?: IPhone2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): Phone2 {
        data = typeof data === 'object' ? data : {};
        let result = new Phone2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IPhone2 {
    title: string;
    phone: string;
    type?: PhoneType;

    [key: string]: any;
}

export enum PhoneType {
    WHATSAPP = "WHATSAPP",
}

export class Email2 implements IEmail2 {
    title!: string;
    email!: string;

    [key: string]: any;

    constructor(data?: IEmail2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): Email2 {
        data = typeof data === 'object' ? data : {};
        let result = new Email2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface IEmail2 {
    title: string;
    email: string;

    [key: string]: any;
}

export class Service implements IService {
    id!: number;
    type!: ServiceType;
    title!: string;
    desc?: string;
    images?: number[];
    documents?: number[];
    serviceData?: any;
    servicePaxList?: number[];
    markers?: Marker[];
    contacts?: number[];
    date!: string;
    status!: ServiceStatus;
    price?: Price;
    parentID?: number;

    [key: string]: any;

    constructor(data?: IService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.desc = _data["desc"] !== undefined ? _data["desc"] : <any>null;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            else {
                this.images = <any>null;
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(item);
            }
            else {
                this.documents = <any>null;
            }
            this.serviceData = _data["serviceData"] !== undefined ? _data["serviceData"] : <any>null;
            if (Array.isArray(_data["servicePaxList"])) {
                this.servicePaxList = [] as any;
                for (let item of _data["servicePaxList"])
                    this.servicePaxList!.push(item);
            }
            else {
                this.servicePaxList = <any>null;
            }
            if (Array.isArray(_data["markers"])) {
                this.markers = [] as any;
                for (let item of _data["markers"])
                    this.markers!.push(Marker.fromJS(item));
            }
            else {
                this.markers = <any>null;
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(item);
            }
            else {
                this.contacts = <any>null;
            }
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.price = _data["price"] ? Price.fromJS(_data["price"]) : <any>null;
            this.parentID = _data["parentID"] !== undefined ? _data["parentID"] : <any>null;
        }
    }

    static fromJS(data: any): Service {
        data = typeof data === 'object' ? data : {};
        let result = new Service();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["desc"] = this.desc !== undefined ? this.desc : <any>null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item);
        }
        data["serviceData"] = this.serviceData !== undefined ? this.serviceData : <any>null;
        if (Array.isArray(this.servicePaxList)) {
            data["servicePaxList"] = [];
            for (let item of this.servicePaxList)
                data["servicePaxList"].push(item);
        }
        if (Array.isArray(this.markers)) {
            data["markers"] = [];
            for (let item of this.markers)
                data["markers"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item);
        }
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["price"] = this.price ? this.price.toJSON() : <any>null;
        data["parentID"] = this.parentID !== undefined ? this.parentID : <any>null;
        return data;
    }
}

export interface IService {
    id: number;
    type: ServiceType;
    title: string;
    desc?: string;
    images?: number[];
    documents?: number[];
    serviceData?: any;
    servicePaxList?: number[];
    markers?: Marker[];
    contacts?: number[];
    date: string;
    status: ServiceStatus;
    price?: Price;
    parentID?: number;

    [key: string]: any;
}

export enum ServiceType {
    FLIGHT = "FLIGHT",
    TRANSFER = "TRANSFER",
    EXCURSION = "EXCURSION",
    TOUR = "TOUR",
    HOTEL = "HOTEL",
    PARKING = "PARKING",
    CAR_RENT = "CAR_RENT",
    TRAIN = "TRAIN",
    FERRY = "FERRY",
    LUNCH_DINNER = "LUNCH_DINNER",
    OTHER = "OTHER",
}

export class Marker implements IMarker {
    lat!: number;
    lng!: number;
    title?: string;

    [key: string]: any;

    constructor(data?: IMarker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.lat = _data["lat"] !== undefined ? _data["lat"] : <any>null;
            this.lng = _data["lng"] !== undefined ? _data["lng"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): Marker {
        data = typeof data === 'object' ? data : {};
        let result = new Marker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["lat"] = this.lat !== undefined ? this.lat : <any>null;
        data["lng"] = this.lng !== undefined ? this.lng : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data;
    }
}

export interface IMarker {
    lat: number;
    lng: number;
    title?: string;

    [key: string]: any;
}

export enum ServiceStatus {
    CONFIRMED = "CONFIRMED",
    PENDING = "PENDING",
    CANCELED = "CANCELED",
    QUOTE = "QUOTE",
}

export class Price implements IPrice {
    label?: string;
    amount?: number;
    currency?: PriceCurrency;

    [key: string]: any;

    constructor(data?: IPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
        }
    }

    static fromJS(data: any): Price {
        data = typeof data === 'object' ? data : {};
        let result = new Price();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        return data;
    }
}

export interface IPrice {
    label?: string;
    amount?: number;
    currency?: PriceCurrency;

    [key: string]: any;
}

export enum PriceCurrency {
    EUR = "EUR",
    USD = "USD",
    CHF = "CHF",
}

export class Pax implements IPax {
    id!: number;
    lastname!: string;
    firstname!: string;
    type!: PaxType;
    birthday?: string;
    isMainPax?: boolean;
    email?: string;
    phone?: string;

    [key: string]: any;

    constructor(data?: IPax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : <any>null;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.birthday = _data["birthday"] !== undefined ? _data["birthday"] : <any>null;
            this.isMainPax = _data["isMainPax"] !== undefined ? _data["isMainPax"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
        }
    }

    static fromJS(data: any): Pax {
        data = typeof data === 'object' ? data : {};
        let result = new Pax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["lastname"] = this.lastname !== undefined ? this.lastname : <any>null;
        data["firstname"] = this.firstname !== undefined ? this.firstname : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["birthday"] = this.birthday !== undefined ? this.birthday : <any>null;
        data["isMainPax"] = this.isMainPax !== undefined ? this.isMainPax : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        return data;
    }
}

export interface IPax {
    id: number;
    lastname: string;
    firstname: string;
    type: PaxType;
    birthday?: string;
    isMainPax?: boolean;
    email?: string;
    phone?: string;

    [key: string]: any;
}

export enum PaxType {
    ADULT = "ADULT",
    CHILD = "CHILD",
    INFANT = "INFANT",
}

export class MobileTuple implements IMobileTuple {
    id?: string;
    token!: string;
    os!: string;
    identityId?: string;

    [key: string]: any;

    constructor(data?: IMobileTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
            this.os = _data["os"] !== undefined ? _data["os"] : <any>null;
            this.identityId = _data["identityId"] !== undefined ? _data["identityId"] : <any>null;
        }
    }

    static fromJS(data: any): MobileTuple {
        data = typeof data === 'object' ? data : {};
        let result = new MobileTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["os"] = this.os !== undefined ? this.os : <any>null;
        data["identityId"] = this.identityId !== undefined ? this.identityId : <any>null;
        return data;
    }
}

export interface IMobileTuple {
    id?: string;
    token: string;
    os: string;
    identityId?: string;

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}